msgid ""
msgstr ""
"POT-Creation-Date: 2026-05-18 00:00+0000\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: it\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. js-lingui-explicit-id
#: src/features/console/connectors/ConnectionAccessSummary.tsx:61
#: src/features/console/connectors/ConnectionAccessSummary.tsx:71
msgid "Accesso alla connessione"
msgstr "Accesso alla connessione"

#: src/features/sources/components/InboxDetailPane.tsx:1296
msgid ""
"\n"
"\n"
"Il {dateLabel}, {senderLabel} ha scritto:\n"
"{quotedLines}"
msgstr ""
"\n"
"\n"
"Il {dateLabel}, {senderLabel} ha scritto:\n"
"{quotedLines}"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:839
msgid " — org"
msgstr " — org"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:843
msgid " — pronto per il merge AI"
msgstr " — pronto per il merge AI"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:841
msgid " — test"
msgstr " — test"

#. placeholder {0}: flow.total_runs
#: src/routes/_authed/workspace/flows.index.tsx:380
msgid " · {0} esecuzioni"
msgstr " · {0} esecuzioni"

#: src/routes/_authed/workspace/technical.tsx:294
msgid " · <0>{inReview}</0> in elaborazione"
msgstr " · <0>{inReview}</0> in elaborazione"

#: src/routes/_authed/workspace/work.tsx:326
msgid " · <0>{totalActions}</0> proposte AI"
msgstr " · <0>{totalActions}</0> proposte AI"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:411
msgid " · consigliata"
msgstr " · consigliata"

#: src/features/sales/components/BatchSendModal.tsx:263
msgid " · da riconnettere"
msgstr " · da riconnettere"

#: src/features/dashboard/components/AddChartDialog.tsx:563
msgid " · limite superato"
msgstr " · limite superato"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:123
msgid " · salva prima di scegliere le persone"
msgstr " · salva prima di scegliere le persone"

#: src/features/dashboard/components/AddChartDialog.tsx:561
msgid " · si avvicina al limite"
msgstr " · si avvicina al limite"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:389
msgid " · versione {rulesetVersion}"
msgstr " · versione {rulesetVersion}"

#: src/features/dashboard/components/AddChartDialog.tsx:593
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:319
msgid " (predefinita)"
msgstr " (predefinita)"

#: src/features/hive-flows/components/DocTemplatesField.tsx:44
msgid " (tuo)"
msgstr " (tuo)"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:835
msgid " {liveScanCount} file trovati"
msgstr " {liveScanCount} file trovati"

#: src/routes/_authed/workspace/technical.tsx:285
msgid " di <0>{total}</0> disegni"
msgstr " di <0>{total}</0> disegni"

#: src/routes/_authed/workspace/technical.tsx:290
msgid " disegni"
msgstr " disegni"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:207
msgid ""
"- Punto uno\n"
"- Punto due"
msgstr ""
"- Punto uno\n"
"- Punto due"

#: src/features/admin/components/AdminOrgs.tsx:1221
msgid "-1 = illimitato."
msgstr "-1 = illimitato."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:148
msgid "— il contesto di business attuale invece verrà riscritto dall'AI."
msgstr "— il contesto di business attuale invece verrà riscritto dall'AI."

#: src/features/templates/components/CreateTemplateDialog.tsx:173
msgid "— Inizia da capo (default) —"
msgstr "— Inizia da capo (default) —"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:417
msgid "— mostrati i primi {unmatchedShown}"
msgstr "— mostrati i primi {unmatchedShown}"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:327
msgid "— Predefinita —"
msgstr "— Predefinita —"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:440
msgid "— Predefinito —"
msgstr "— Predefinito —"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:231
msgid "— Predefinito azienda —"
msgstr "— Predefinito azienda —"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:202
msgid "— Seleziona —"
msgstr "— Seleziona —"

#: src/features/sources/components/SyncConflictDialog.tsx:86
msgid ", dopo che lo hai aperto. Se sovrascrivi, le sue modifiche andranno perse."
msgstr ", dopo che lo hai aperto. Se sovrascrivi, le sue modifiche andranno perse."

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:286
msgid ": verifica il destinatario prima di inviare."
msgstr ": verifica il destinatario prima di inviare."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:212
msgid ": verifica importo, beneficiario e IBAN prima di confermare."
msgstr ": verifica importo, beneficiario e IBAN prima di confermare."

#. placeholder {0}: partialResult.failed_users.length - 6
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:151
msgid "…e altri {0}"
msgstr "…e altri {0}"

#. placeholder {0}: preview.dictionary_columns
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:370
msgid "· {0} colonne"
msgstr "· {0} colonne"

#: src/features/admin/components/PageEditor.tsx:352
msgid "· modifiche non salvate"
msgstr "· modifiche non salvate"

#. placeholder {0}: p.name
#: src/features/projects/components/ProjectHub.tsx:170
msgid "\"{0}\" — {filename}, {when}"
msgstr "\"{0}\" — {filename}, {when}"

#. placeholder {0}: p.name
#: src/features/projects/components/ProjectHub.tsx:144
msgid "\"{0}\" — automazione {when}"
msgstr "\"{0}\" — automazione {when}"

#. placeholder {0}: p.name
#: src/features/projects/components/ProjectHub.tsx:162
msgid "\"{0}\" — ultima volta: \"{last}\", {when}"
msgstr "\"{0}\" — ultima volta: \"{last}\", {when}"

#. placeholder {0}: doc.title || doc.filename
#: src/routes/_authed/workspace/documents.tsx:585
msgid "\"{0}\" eliminato"
msgstr "\"{0}\" eliminato"

#. placeholder {0}: p.name
#: src/features/projects/components/ProjectHub.tsx:126
msgid "\"{0}\" ha {count} attività in ritardo"
msgstr "\"{0}\" ha {count} attività in ritardo"

#. placeholder {0}: p.name
#: src/features/projects/components/ProjectHub.tsx:125
msgid "\"{0}\" ha 1 attività in ritardo"
msgstr "\"{0}\" ha 1 attività in ritardo"

#. placeholder {0}: deleteTarget.name
#: src/features/sync/components/DocSyncManager.tsx:469
msgid "\"{0}\" rimosso dal tracking"
msgstr "\"{0}\" rimosso dal tracking"

#. placeholder {0}: deleteCandidate.name
#: src/features/agent-modes/components/AgentModesList.tsx:339
msgid "\"{0}\" verrà disattivato. Le conversazioni che lo usavano resteranno invariate."
msgstr "\"{0}\" verrà disattivato. Le conversazioni che lo usavano resteranno invariate."

#. placeholder {0}: deleteCandidate.name
#: src/features/settings/components/PresentationTemplates.tsx:297
msgid "\"{0}\" verrà eliminato. I deck creati con questo template restano invariati."
msgstr "\"{0}\" verrà eliminato. I deck creati con questo template restano invariati."

#. placeholder {0}: target.name
#: src/features/sync/components/DocSyncManager.tsx:1439
msgid "\"{0}\" verrà tolto dal tracking. I documenti già indicizzati restano consultabili."
msgstr "\"{0}\" verrà tolto dal tracking. I documenti già indicizzati restano consultabili."

#: src/routes/_authed/workspace/conversations.tsx:1052
msgid "\"{query}\" non corrisponde a nessun messaggio visibile."
msgstr "\"{query}\" non corrisponde a nessun messaggio visibile."

#: src/features/connectors/wizards/messagingSpec.tsx:79
msgid "\"Cosa abbiamo deciso con il team backend?\" — risposta con citazioni."
msgstr "\"Cosa abbiamo deciso con il team backend?\" — risposta con citazioni."

#: src/features/connectors/wizards/driveSpec.tsx:112
msgid "\"Cosa c'è nella due-diligence Acme?\" → risposta con citazioni."
msgstr "\"Cosa c'è nella due-diligence Acme?\" → risposta con citazioni."

#: src/features/connectors/wizards/emailSpec.tsx:88
msgid "\"Email di Mario su Q2\" — risultati ordinati per rilevanza, non per data."
msgstr "\"Email di Mario su Q2\" — risultati ordinati per rilevanza, non per data."

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:244
msgid "“Mostrami le fatture aperte per cliente”"
msgstr "“Mostrami le fatture aperte per cliente”"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:138
msgid "\"Quali tavole hanno una flangia DN50?\" — risposta con thumbnail."
msgstr "\"Quali tavole hanno una flangia DN50?\" — risposta con thumbnail."

#: src/features/connectors/wizards/spreadsheetSpec.tsx:202
msgid "\"Quante fatture sopra €5k nel Q1?\" risponde leggendo il foglio."
msgstr "\"Quante fatture sopra €5k nel Q1?\" risponde leggendo il foglio."

#: src/features/connectors/wizards/accountingSpec.tsx:121
msgid "\"Quanto fatturato a Maggio?\" — risposta in 2 secondi."
msgstr "\"Quanto fatturato a Maggio?\" — risposta in 2 secondi."

#: src/features/connectors/wizards/calendarSpec.tsx:76
msgid "\"Trovami 30 minuti con Mario settimana prossima\" → tre opzioni."
msgstr "\"Trovami 30 minuti con Mario settimana prossima\" → tre opzioni."

#. placeholder {0}: deleteTarget.name
#: src/features/console/pages/DocumentsPage.tsx:927
msgid "«{0}» e i suoi chunk saranno rimossi dall'indice. L'operazione non è reversibile."
msgstr "«{0}» e i suoi chunk saranno rimossi dall'indice. L'operazione non è reversibile."

#. placeholder {0}: deleteTarget.name
#: src/features/console/pages/FlowsPage.tsx:980
msgid "«{0}» e la sua pianificazione saranno rimossi. L'operazione non è reversibile."
msgstr "«{0}» e la sua pianificazione saranno rimossi. L'operazione non è reversibile."

#. placeholder {0}: deleteTarget.name
#: src/features/console/connectors/ConnectorActionsPanel.tsx:309
msgid "«{0}» non sarà più eseguibile. Le richieste già inviate non vengono toccate."
msgstr "«{0}» non sarà più eseguibile. Le richieste già inviate non vengono toccate."

#. placeholder {0}: disableTarget.name
#: src/features/console/connectors/CustomConnectorsPanel.tsx:377
msgid "«{0}» smetterà di accettare nuovi sync. I contenuti già indicizzati restano interrogabili."
msgstr "«{0}» smetterà di accettare nuovi sync. I contenuti già indicizzati restano interrogabili."

#. placeholder {0}: keyRecord.name
#. placeholder {0}: revokeTarget.name
#: src/features/console/pages/KeyDetailPage.tsx:710
#: src/features/console/pages/KeysPage.tsx:266
msgid "«{0}» smetterà di funzionare immediatamente. L'operazione è irreversibile."
msgstr "«{0}» smetterà di funzionare immediatamente. L'operazione è irreversibile."

#. placeholder {0}: connector.name
#: src/features/console/connectors/CustomConnectorDetail.tsx:1104
msgid "«{0}» smetterà di sincronizzare. I contenuti già indicizzati restano interrogabili e potrai riattivarlo quando vuoi."
msgstr "«{0}» smetterà di sincronizzare. I contenuti già indicizzati restano interrogabili e potrai riattivarlo quando vuoi."

#. placeholder {0}: confirmTarget.config.label
#: src/features/console/pages/ModelsPage.tsx:488
msgid "«{0}» tornerà al modello gestito da Ando. L'account provider rimane collegato."
msgstr "«{0}» tornerà al modello gestito da Ando. L'account provider rimane collegato."

#. placeholder {0}: runTarget.name
#: src/features/console/pages/FlowsPage.tsx:1021
msgid "«{0}» verrà eseguito davvero: i passi con effetti esterni (email, azioni sui sistemi collegati) saranno inviati. Per una prova senza conseguenze usa «Esegui test»."
msgstr "«{0}» verrà eseguito davvero: i passi con effetti esterni (email, azioni sui sistemi collegati) saranno inviati. Per una prova senza conseguenze usa «Esegui test»."

#: src/features/sources/components/InboxDetailPane.tsx:1284
msgid "(data non disponibile)"
msgstr "(data non disponibile)"

#: src/features/settings/components/OrgMembersPanel.tsx:437
msgid "(email mancante)"
msgstr "(email mancante)"

#: src/features/connect/components/CreateSpaceDialog.tsx:150
msgid "(facoltativa)"
msgstr "(facoltativa)"

#: src/features/sales/components/crm/EmailMiniList.tsx:58
msgid "(nessun oggetto)"
msgstr "(nessun oggetto)"

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:168
#: src/features/admin/components/AdminOrgs.tsx:1159
msgid "(opzionale)"
msgstr "(opzionale)"

#: src/features/console/pages/PlaygroundPage.tsx:1361
msgid "(query vuota)"
msgstr "(query vuota)"

#: src/features/automations/components/ScheduleEditor.tsx:200
msgid "(richiede una sorgente reattiva collegata)"
msgstr "(richiede una sorgente reattiva collegata)"

#: src/features/admin/components/AdminCpqAskAndo.tsx:188
msgid "(senza nome)"
msgstr "(senza nome)"

#: src/features/sources/components/InboxDetailPane.tsx:160
#: src/features/sources/components/InboxDetailPane.tsx:315
#: src/features/sources/components/InboxDetailPane.tsx:565
#: src/features/workspace/components/InboxItemRow.tsx:280
#: src/routes/_authed/workspace/conversations.tsx:1148
msgid "(senza oggetto)"
msgstr "(senza oggetto)"

#: src/features/sources/components/CalendarEventPane.tsx:231
#: src/features/sources/components/CalendarEventPane.tsx:326
#: src/features/sources/components/CalendarEventPane.tsx:408
msgid "(senza titolo)"
msgstr "(senza titolo)"

#: src/features/admin/components/orgs/OrgCostTab.tsx:271
msgid "(sistema / background)"
msgstr "(sistema / background)"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:429
msgid "(tutti)"
msgstr "(tutti)"

#. placeholder {0}: generation.engine_version
#: src/features/report/components/AiDisclosureBanner.tsx:196
msgid "(v{0})"
msgstr "(v{0})"

#: src/features/sources/components/AISummaryPanel.tsx:759
msgid "(vuoto)"
msgstr "(vuoto)"

#. placeholder {0}: exposure.attachment_count
#: src/features/share/components/ShareLinkDialog.tsx:462
msgid "{0, plural, one {# allegato} other {# allegati}}"
msgstr "{0, plural, one {# allegato} other {# allegati}}"

#. placeholder {0}: share.view_count
#: src/features/share/components/ShareLinkRow.tsx:154
msgid "{0, plural, one {# apertura} other {# aperture}}"
msgstr "{0, plural, one {# apertura} other {# aperture}}"

#. placeholder {0}: connections.length
#: src/features/workspace/finance/components/ConnectionsPanel.tsx:53
msgid "{0, plural, one {# collegamento} other {# collegamenti}}"
msgstr "{0, plural, one {# collegamento} other {# collegamenti}}"

#. placeholder {0}: table.columns.length
#: src/features/connectors/components/management/SchemaViewer.tsx:309
msgid "{0, plural, one {# colonna} other {# colonne}}"
msgstr "{0, plural, one {# colonna} other {# colonne}}"

#. placeholder {0}: exposure.document_count
#: src/features/share/components/ShareLinkDialog.tsx:469
msgid "{0, plural, one {# documento interno} other {# documenti interni}}"
msgstr "{0, plural, one {# documento interno} other {# documenti interni}}"

#. placeholder {0}: selected.size
#: src/features/sync/components/picker/NotionPickerModal.tsx:174
msgid "{0, plural, one {# elemento selezionato} other {# elementi selezionati}}"
msgstr "{0, plural, one {# elemento selezionato} other {# elementi selezionati}}"

#. placeholder {0}: result.pending_facts
#: src/features/settings/components/SelfProfileMemory.tsx:673
msgid "{0, plural, one {# fatto verrà cancellato a breve.} other {# fatti verranno cancellati a breve.}}"
msgstr "{0, plural, one {# fatto verrà cancellato a breve.} other {# fatti verranno cancellati a breve.}}"

#. placeholder {0}: file.holes_count ?? 0
#: src/features/dxf/components/DxfFileRow.tsx:85
msgid "{0, plural, one {# foro cilindrico rilevato} other {# fori cilindrici rilevati}}"
msgstr "{0, plural, one {# foro cilindrico rilevato} other {# fori cilindrici rilevati}}"

#. placeholder {0}: file.holes_count ?? 0
#: src/features/dxf/components/DxfFileRow.tsx:91
msgid "{0, plural, one {# foro} other {# fori}}"
msgstr "{0, plural, one {# foro} other {# fori}}"

#. placeholder {0}: Math.round(inv.duration_hours / 24)
#: src/features/admin/components/AdminDemoInviti.tsx:258
msgid "{0, plural, one {# giorno} other {# giorni}}"
msgstr "{0, plural, one {# giorno} other {# giorni}}"

#. placeholder {0}: rows.length
#: src/features/admin/components/AdminDemoInviti.tsx:191
msgid "{0, plural, one {# invito} other {# inviti}}"
msgstr "{0, plural, one {# invito} other {# inviti}}"

#. placeholder {0}: issues.length
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:345
msgid "{0, plural, one {# issue identificata} other {# issue identificate}}"
msgstr "{0, plural, one {# issue identificata} other {# issue identificate}}"

#. placeholder {0}: allMembers.length
#: src/features/admin/components/orgs/OrgMembersTab.tsx:258
msgid "{0, plural, one {# membro totali} other {# membri totali}}"
msgstr "{0, plural, one {# membro totali} other {# membri totali}}"

#. placeholder {0}: detail.data.turn_count
#. placeholder {0}: preview.turn_count
#. placeholder {0}: share.turn_count
#: src/features/share/components/ShareLinkDialog.tsx:412
#: src/features/share/components/ShareLinkRow.tsx:142
#: src/routes/_authed/workspace/shares.tsx:276
msgid "{0, plural, one {# messaggio} other {# messaggi}}"
msgstr "{0, plural, one {# messaggio} other {# messaggi}}"

#. placeholder {0}: table.record_count
#: src/features/connectors/components/management/SchemaViewer.tsx:313
msgid "{0, plural, one {# riga} other {# righe}}"
msgstr "{0, plural, one {# riga} other {# righe}}"

#. placeholder {0}: exposure.display_count
#: src/features/share/components/ShareLinkDialog.tsx:477
msgid "{0, plural, one {# risultato dai tuoi dati} other {# risultati dai tuoi dati}}"
msgstr "{0, plural, one {# risultato dai tuoi dati} other {# risultati dai tuoi dati}}"

#. placeholder {0}: selected.length
#: src/features/hive-flows/components/EnterpriseConnectorsField.tsx:82
msgid "{0, plural, one {# selezionata.} other {# selezionate.}}"
msgstr "{0, plural, one {# selezionata.} other {# selezionate.}}"

#. placeholder {0}: selected.size
#: src/features/admin/components/AdminUsers.tsx:348
msgid "{0, plural, one {# selezionato} other {# selezionati}}"
msgstr "{0, plural, one {# selezionato} other {# selezionati}}"

#. placeholder {0}: e.count
#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:188
msgid "{0, plural, one {# settimana senza movimenti} other {# settimane senza movimenti}}"
msgstr "{0, plural, one {# settimana senza movimenti} other {# settimane senza movimenti}}"

#. placeholder {0}: filteredTables.length
#: src/features/connectors/components/management/SchemaViewer.tsx:176
msgid "{0, plural, one {# tabella} other {# tabelle}}"
msgstr "{0, plural, one {# tabella} other {# tabelle}}"

#. placeholder {0}: data.length
#: src/features/dashboard/components/ChartDetailModal.tsx:121
msgid "{0, plural, one {Dati (# riga)} other {Dati (# righe)}}"
msgstr "{0, plural, one {Dati (# riga)} other {Dati (# righe)}}"

#. placeholder {0}: sharesQuery.shares.length
#: src/features/dashboard/components/ShareDashboardSheet.tsx:328
msgid "{0, plural, one {Già condivisa con # persona} other {Già condivisa con # persone}}"
msgstr "{0, plural, one {Già condivisa con # persona} other {Già condivisa con # persone}}"

#. placeholder {0}: chartShares.length
#: src/features/dashboard/components/ShareChartSheet.tsx:341
msgid "{0, plural, one {Già condiviso con # persona} other {Già condiviso con # persone}}"
msgstr "{0, plural, one {Già condiviso con # persona} other {Già condiviso con # persone}}"

#. placeholder {0}: status?.total_tables ?? 0
#: src/features/connectors/components/management/DiscoveryDialog.tsx:125
msgid "{0, plural, one {Interessa # tabella già profilata.} other {Interessa # tabelle già profilate.}}"
msgstr "{0, plural, one {Interessa # tabella già profilata.} other {Interessa # tabelle già profilate.}}"

#. placeholder {0}: selected.size
#: src/features/admin/components/orgs/OrgMembersTab.tsx:619
msgid "{0, plural, one {membro} other {membri}}"
msgstr "{0, plural, one {membro} other {membri}}"

#. placeholder {0}: categories.length - TOP_CATEGORIES_VISIBLE
#: src/features/dxf/components/DxfLeftRail.tsx:118
msgid "{0, plural, one {Mostra l'altra # categoria} other {Mostra le altre # categorie}}"
msgstr "{0, plural, one {Mostra l'altra # categoria} other {Mostra le altre # categorie}}"

#. placeholder {0}: approvals.length
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:65
msgid "{0, plural, one {Un flow in attesa di approvazione} other {# flow in attesa di approvazione}}"
msgstr "{0, plural, one {Un flow in attesa di approvazione} other {# flow in attesa di approvazione}}"

#. placeholder {0}: ex.used_count
#: src/features/connectors/components/management/ChatExamplesManager.tsx:237
msgid "{0, plural, one {Usato # volta} other {Usato # volte}}"
msgstr "{0, plural, one {Usato # volta} other {Usato # volte}}"

#. placeholder {0}: pendingFlow.label
#: src/routes/_authed/_modal/integrations/index.tsx:200
msgid "{0} — errore di sincronizzazione"
msgstr "{0} — errore di sincronizzazione"

#. placeholder {0}: twin.filename
#. placeholder {1}: twin.format.toUpperCase()
#: src/features/structured-data/components/SimilarPartsSection.tsx:339
msgid "{0} — formato {1}: {tooltip}"
msgstr "{0} — formato {1}: {tooltip}"

#. placeholder {0}: entry.filename
#: src/features/structured-data/components/SimilarPartsSection.tsx:438
msgid "{0} — similarità {pct}%: {tooltip}"
msgstr "{0} — similarità {pct}%: {tooltip}"

#. placeholder {0}: pendingFlow.label
#: src/routes/_authed/_modal/integrations/index.tsx:193
msgid "{0} — sincronizzazione più lenta del previsto"
msgstr "{0} — sincronizzazione più lenta del previsto"

#. placeholder {0}: formatUsd(detail.total_cost_usd, 4)
#. placeholder {1}: formatInt(detail.total_call_count)
#: src/features/admin/components/CostTraceDetailSection.tsx:138
msgid "{0} · {1} chiamate"
msgstr "{0} · {1} chiamate"

#. placeholder {0}: org.name
#. placeholder {1}: result.migrated_users.length
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:79
msgid "{0} · {1} membri migrati al Default Tenant."
msgstr "{0} · {1} membri migrati al Default Tenant."

#. placeholder {0}: w.text
#. placeholder {1}: w.value.toLocaleString("it-IT")
#: src/features/report/components/charts.tsx:111
msgid "{0} · {1} menzioni"
msgstr "{0} · {1} menzioni"

#. placeholder {0}: flow.name
#. placeholder {0}: summary.name
#: src/routes/_authed/workspace/flows.index.tsx:140
#: src/routes/_authed/workspace/templates/$kind.tsx:270
msgid "{0} (copia)"
msgstr "{0} (copia)"

#. placeholder {0}: mc.display_name
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:440
msgid "{0} (esteso a tutti i membri)"
msgstr "{0} (esteso a tutti i membri)"

#. placeholder {0}: u.name
#: src/features/hive-flows/run/PresenceStack.tsx:41
msgid "{0} (tu)"
msgstr "{0} (tu)"

#. placeholder {0}: receivables.severely_overdue_count
#: src/routes/_authed/workspace/finance.tsx:1662
msgid "{0} > 60g"
msgstr "{0} > 60g"

#. placeholder {0}: result.accepted
#: src/features/console/connectors/CustomConnectorDetail.tsx:290
msgid "{0} accettati"
msgstr "{0} accettati"

#. placeholder {0}: visible.length
#: src/features/sources/components/EmailThreadMessages.tsx:982
msgid "{0} allegati"
msgstr "{0} allegati"

#. placeholder {0}: d.open_count
#: src/features/clean-control/components/DimensionRadar.tsx:283
msgid "{0} aperti"
msgstr "{0} aperti"

#. placeholder {0}: counts.warning
#: src/routes/_authed/workspace/finance.tsx:765
msgid "{0} attenzione"
msgstr "{0} attenzione"

#. placeholder {0}: row.active_workers
#. placeholder {1}: row.pending_tasks
#: src/features/admin/components/AdminHealth.tsx:97
msgid "{0} attivi · {1} in coda"
msgstr "{0} attivi · {1} in coda"

#. placeholder {0}: chip.count
#: src/features/connect/components/SpaceScopeBanner.tsx:111
msgid "{0} basi di conoscenza"
msgstr "{0} basi di conoscenza"

#. placeholder {0}: slide.runs.length
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:537
msgid "{0} blocchi di testo"
msgstr "{0} blocchi di testo"

#. placeholder {0}: formatInt(r.calls)
#: src/features/admin/components/orgs/OrgCostTab.tsx:152
#: src/features/admin/components/orgs/OrgCostTab.tsx:278
msgid "{0} call"
msgstr "{0} call"

#. placeholder {0}: formatInt(samples)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:162
msgid "{0} campioni"
msgstr "{0} campioni"

#. placeholder {0}: d.chars.toLocaleString()
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2756
msgid "{0} caratteri"
msgstr "{0} caratteri"

#. placeholder {0}: syncProgress.uploaded
#: src/features/connectors/components/FilesystemConnectDialog.tsx:926
msgid "{0} caricati"
msgstr "{0} caricati"

#. placeholder {0}: props.payload.n_categories
#: src/features/chat/components/MessagePreviewEmbed.tsx:207
msgid "{0} categorie · {score}%"
msgstr "{0} categorie · {score}%"

#. placeholder {0}: selectedDataset.n_chunks_estimated
#: src/features/voice_report/components/NewReportDialog.tsx:803
msgid "{0} chunk stimati"
msgstr "{0} chunk stimati"

#. placeholder {0}: localize(spec.title, i18n)
#. placeholder {0}: pendingFlow.label
#: src/routes/_authed/_modal/integrations/$capability.tsx:572
#: src/routes/_authed/_modal/integrations/$capability.tsx:901
#: src/routes/_authed/_modal/integrations/index.tsx:187
msgid "{0} collegata"
msgstr "{0} collegata"

#. placeholder {0}: template.n_components
#: src/features/voice_report/components/TemplatesGallery.tsx:246
msgid "{0} componenti"
msgstr "{0} componenti"

#. placeholder {0}: erroredSummaries.length
#: src/routes/_authed/_modal/integrations/index.tsx:352
msgid "{0} con errore"
msgstr "{0} con errore"

#. placeholder {0}: enabledLicenses.length
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:339
msgid "{0} connector licenziati"
msgstr "{0} connector licenziati"

#. placeholder {0}: row.connectionCount
#: src/routes/_authed/_modal/integrations/index.tsx:499
msgid "{0} connessioni"
msgstr "{0} connessioni"

#. placeholder {0}: formatNumber(i18n.locale, data?.documents ?? 0)
#: src/features/console/pages/OverviewPage.tsx:301
msgid "{0} contenuti nell'indice"
msgstr "{0} contenuti nell'indice"

#. placeholder {0}: saved.share_scope.selected_count
#: src/features/console/pages/ResourceAccessPage.tsx:361
msgid "{0} contenuti selezionati"
msgstr "{0} contenuti selezionati"

#. placeholder {0}: p.credits.toLocaleString()
#: src/features/billing/components/CreditBalanceCard.tsx:139
msgid "{0} crediti"
msgstr "{0} crediti"

#. placeholder {0}: counts.danger
#: src/routes/_authed/workspace/finance.tsx:766
msgid "{0} critici"
msgstr "{0} critici"

#. placeholder {0}: deck.placeholders
#: src/features/admin/components/AdminDecks.tsx:245
msgid "{0} da completare"
msgstr "{0} da completare"

#. placeholder {0}: lowConfidenceIds.length
#: src/features/hive-flows/run/ProposalReview.tsx:454
msgid "{0} da verificare"
msgstr "{0} da verificare"

#. placeholder {0}: data.salesforce_pipeline.deal_count
#. placeholder {0}: pipeline.deal_count
#. placeholder {1}: data.salesforce_pipeline.closing_soon_count
#. placeholder {1}: pipeline.closing_soon_count
#: src/routes/_authed/workspace/finance.tsx:457
#: src/routes/_authed/workspace/finance.tsx:1688
msgid "{0} deal · {1} in chiusura"
msgstr "{0} deal · {1} in chiusura"

#. placeholder {0}: data.salesforce_pipeline.deal_count
#. placeholder {1}: data.salesforce_pipeline.closing_soon_count
#. placeholder {2}: formatCurrencyFromCents( data.salesforce_pipeline.won_this_quarter_eur_cents, currency, )
#. placeholder {3}: Math.floor(new Date().getMonth() / 3) + 1
#: src/routes/_authed/workspace/finance.tsx:451
msgid "{0} deal · {1} in chiusura · {2} vinti Q{3}"
msgstr "{0} deal · {1} in chiusura · {2} vinti Q{3}"

#. placeholder {0}: rows.length
#. placeholder {1}: all.length
#: src/features/admin/components/AdminCpqList.tsx:107
msgid "{0} di {1} preventivi"
msgstr "{0} di {1} preventivi"

#. placeholder {0}: items.length
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:550
msgid "{0} di {total} mostrati (limit {LIMIT})"
msgstr "{0} di {total} mostrati (limit {LIMIT})"

#. placeholder {0}: folders.length
#. placeholder {0}: formatBytes( Math.max(0, usage.storage_limit_bytes - usage.storage_used_bytes), )
#. placeholder {0}: formatEur( Math.max(0, usage.cost_cap_eur - usage.cost_used_eur), )
#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:334
#: src/features/admin/components/orgs/OrgBillingTab.tsx:477
#: src/features/admin/components/orgs/OrgBillingTab.tsx:508
#: src/routes/_authed/workspace/dashboard.tsx:618
msgid "{0} disponibili"
msgstr "{0} disponibili"

#. placeholder {0}: chip.count
#. placeholder {0}: grant.content_item_ids.length
#: src/features/connect/components/GrantManager.tsx:963
#: src/features/connect/components/SpaceScopeBanner.tsx:107
msgid "{0} documenti"
msgstr "{0} documenti"

#. placeholder {0}: form.email.trim()
#. placeholder {1}: org.name
#: src/features/admin/components/orgs/AddMemberDialog.tsx:101
msgid "{0} è di nuovo membro di {1}."
msgstr "{0} è di nuovo membro di {1}."

#. placeholder {0}: member.email ?? member.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:192
msgid "{0} è di nuovo membro."
msgstr "{0} è di nuovo membro."

#. placeholder {0}: org.name
#: src/features/admin/components/AdminOrgs.tsx:447
msgid "{0} è stata creata con successo."
msgstr "{0} è stata creata con successo."

#. placeholder {0}: clips.length
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1217
msgid "{0} elementi copiati: incollali con Cmd+V su una slide libera"
msgstr "{0} elementi copiati: incollali con Cmd+V su una slide libera"

#. placeholder {0}: ids.length
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1248
msgid "{0} elementi selezionati"
msgstr "{0} elementi selezionati"

#. placeholder {0}: resumableProcessed.toLocaleString("it-IT")
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:345
msgid "{0} email già processate."
msgstr "{0} email già processate."

#. placeholder {0}: meta.emails_seen
#: src/features/sales/components/crm/SuggestionsStrip.tsx:135
msgid "{0} email scambiate"
msgstr "{0} email scambiate"

#. placeholder {0}: job.failedItems
#: src/features/sync/components/UniversalSyncToast.tsx:343
msgid "{0} errori"
msgstr "{0} errori"

#. placeholder {0}: flow.total_runs
#: src/features/projects/components/sections/AutomationsSection.tsx:200
msgid "{0} esecuzioni"
msgstr "{0} esecuzioni"

#. placeholder {0}: group.events.length
#. placeholder {0}: request.event_count
#: src/features/console/pages/TracesPage.tsx:584
#: src/features/console/traces/TraceGraph.tsx:238
#: src/features/console/traces/TraceGraph.tsx:325
msgid "{0} eventi"
msgstr "{0} eventi"

#. placeholder {0}: emailBadge.relative
#. placeholder {0}: formatRelativeTime(lastSync)
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:247
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:396
msgid "{0} fa"
msgstr "{0} fa"

#. placeholder {0}: receivables.invoice_count
#: src/routes/_authed/workspace/finance.tsx:1654
msgid "{0} fatture"
msgstr "{0} fatture"

#. placeholder {0}: data.open_receivables.invoice_count
#. placeholder {1}: data.open_receivables.expiring_soon_count
#: src/routes/_authed/workspace/finance.tsx:422
msgid "{0} fatture · {1} in scadenza"
msgstr "{0} fatture · {1} in scadenza"

#. placeholder {0}: data.open_payables.invoice_count
#. placeholder {0}: payables.invoice_count
#: src/routes/_authed/workspace/finance.tsx:436
#: src/routes/_authed/workspace/finance.tsx:1679
msgid "{0} fatture passive"
msgstr "{0} fatture passive"

#. placeholder {0}: b.bucket
#: src/features/admin/components/AdminEngagement.tsx:308
msgid "{0} feature"
msgstr "{0} feature"

#. placeholder {0}: f.extractedCount
#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:98
msgid "{0} file"
msgstr "{0} file"

#. placeholder {0}: filesToDelete.length
#: src/routes/_authed/workspace/documents.tsx:669
msgid "{0} file (inclusi i contenuti delle sotto-cartelle) verranno rimossi dall'indice vettoriale, dal grafo, dal database e dallo storage. Operazione irreversibile."
msgstr "{0} file (inclusi i contenuti delle sotto-cartelle) verranno rimossi dall'indice vettoriale, dal grafo, dal database e dallo storage. Operazione irreversibile."

#. placeholder {0}: scanSummary.matchedFiles.toLocaleString("it-IT")
#: src/features/connectors/components/FilesystemConnectDialog.tsx:840
msgid "{0} file da indicizzare"
msgstr "{0} file da indicizzare"

#. placeholder {0}: filesToDelete.length
#: src/routes/_authed/workspace/documents.tsx:684
msgid "{0} file in coda…"
msgstr "{0} file in coda…"

#. placeholder {0}: files.toLocaleString("it-IT")
#: src/features/connectors/components/ConnectedAccountRow.tsx:177
msgid "{0} file indicizzati · {when}"
msgstr "{0} file indicizzati · {when}"

#. placeholder {0}: summary.failedFiles
#: src/routes/_authed/_modal/integrations/$capability.tsx:1052
msgid "{0} file non caricati · riprova."
msgstr "{0} file non caricati · riprova."

#. placeholder {0}: summary.uploadedFiles
#: src/routes/_authed/_modal/integrations/$capability.tsx:1054
msgid "{0} file sincronizzati"
msgstr "{0} file sincronizzati"

#. placeholder {0}: canvas.source_count
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:255
msgid "{0} fonte"
msgstr "{0} fonte"

#. placeholder {0}: c.source_count
#. placeholder {0}: canvas.source_count
#: src/features/connect/components/GrantManager.tsx:546
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:256
msgid "{0} fonti"
msgstr "{0} fonti"

#. placeholder {0}: formatNumber(i18n.locale, activeSourceCount)
#: src/features/console/pages/OverviewPage.tsx:302
msgid "{0} fonti collegate"
msgstr "{0} fonti collegate"

#. placeholder {0}: chip.count
#: src/features/connect/components/SpaceScopeBanner.tsx:115
msgid "{0} fonti connesse"
msgstr "{0} fonti connesse"

#. placeholder {0}: data.chunk_count
#: src/features/console/components/DocumentAcquiredContent.tsx:52
msgid "{0} frammenti indicizzati. I testi lunghi sono suddivisi in parti per la lettura."
msgstr "{0} frammenti indicizzati. I testi lunghi sono suddivisi in parti per la lettura."

#. placeholder {0}: pk.days
#: src/features/admin/components/AdminCpq.tsx:869
msgid "{0} giornate"
msgstr "{0} giornate"

#. placeholder {0}: dashboard.chart_count
#: src/features/dashboard/components/DashboardListSidebar.tsx:291
msgid "{0} grafici"
msgstr "{0} grafici"

#. placeholder {0}: entries.length
#: src/features/console/traces/TraceGraph.tsx:233
msgid "{0} gruppi"
msgstr "{0} gruppi"

#. placeholder {0}: inv.duration_hours
#: src/features/admin/components/AdminDemoInviti.tsx:264
msgid "{0} h"
msgstr "{0} h"

#. placeholder {0}: scanSummary.skippedFiles.toLocaleString("it-IT")
#: src/features/connectors/components/FilesystemConnectDialog.tsx:845
msgid "{0} ignorati"
msgstr "{0} ignorati"

#. placeholder {0}: Math.max(0, total - profiled)
#: src/features/connectors/components/management/DiscoveryDialog.tsx:259
msgid "{0} in attesa"
msgstr "{0} in attesa"

#. placeholder {0}: provision.tier
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:273
msgid "{0} infrastructure"
msgstr "{0} infrastructure"

#. placeholder {0}: filteredSummaries.length
#: src/routes/_authed/_modal/integrations/index.tsx:427
msgid "{0} integrazioni trovate per \"{searchValue}\"."
msgstr "{0} integrazioni trovate per \"{searchValue}\"."

#. placeholder {0}: list.length
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:94
msgid "{0} issue"
msgstr "{0} issue"

#. placeholder {0}: list.length
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:90
msgid "{0} issue identificati"
msgstr "{0} issue identificati"

#. placeholder {0}: formatInt(job.items_processed)
#: src/features/admin/components/hypermem/HmOverviewTab.tsx:175
msgid "{0} item"
msgstr "{0} item"

#. placeholder {0}: eur(cat?.poc_extra_source_price ?? 0)
#: src/features/admin/components/AdminCpq.tsx:819
msgid "{0} l'una"
msgstr "{0} l'una"

#. placeholder {0}: deck.links
#: src/features/admin/components/AdminDecks.tsx:244
msgid "{0} link attivi"
msgstr "{0} link attivi"

#. placeholder {0}: org.member_count
#: src/features/account/components/OrgSwitcherDialog.tsx:235
msgid "{0} membri"
msgstr "{0} membri"

#. placeholder {0}: result.migrated_users.length
#: src/features/admin/components/AdminOrgs.tsx:496
msgid "{0} membri migrati al Default Tenant."
msgstr "{0} membri migrati al Default Tenant."

#. placeholder {0}: memberCount ?? 0
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:125
msgid "{0} membri nell'organizzazione"
msgstr "{0} membri nell'organizzazione"

#. placeholder {0}: c.mentions.toLocaleString("it-IT")
#: src/features/report/components/QuestionView.tsx:45
msgid "{0} menzioni"
msgstr "{0} menzioni"

#. placeholder {0}: formatNumber(data?.burn_rate?.runway_months, 1)
#. placeholder {0}: formatNumber(runway, 1)
#. placeholder {0}: l.months
#: src/features/admin/components/AdminCpq.tsx:219
#: src/features/admin/components/AdminCpq.tsx:794
#: src/routes/_authed/workspace/finance.tsx:499
#: src/routes/_authed/workspace/finance.tsx:1441
msgid "{0} mesi"
msgstr "{0} mesi"

#. placeholder {0}: archivable.length
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:452
msgid "{0} messaggi archiviati"
msgstr "{0} messaggi archiviati"

#. placeholder {0}: view.totalMessages.toLocaleString(i18n.locale)
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:280
msgid "{0} messaggi importati"
msgstr "{0} messaggi importati"

#. placeholder {0}: messageIds.length
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:483
msgid "{0} messaggi in snooze"
msgstr "{0} messaggi in snooze"

#. placeholder {0}: result.migrated_users.length
#. placeholder {1}: result.failed_users.length
#: src/features/admin/components/AdminOrgs.tsx:502
msgid "{0} migrati, {1} falliti."
msgstr "{0} migrati, {1} falliti."

#. placeholder {0}: counts.modified_count
#: src/features/sync/components/DocSyncManager.tsx:1021
msgid "{0} modificati"
msgstr "{0} modificati"

#. placeholder {0}: (changes as ReadonlyArray<DiffChange>).length
#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:197
msgid "{0} modifiche"
msgstr "{0} modifiche"

#. placeholder {0}: pending.length
#: ../../packages/ui/src/editors/ReviewRail.tsx:169
#: ../../packages/ui/src/editors/ReviewRail.tsx:170
msgid "{0} modifiche in attesa"
msgstr "{0} modifiche in attesa"

#. placeholder {0}: changes.length
#: src/features/admin/components/AdminCpqAskAndo.tsx:300
msgid "{0} modifiche rispetto all'editor"
msgstr "{0} modifiche rispetto all'editor"

#. placeholder {0}: formatCurrency( data?.cash_flow?.reduce((acc, b) => acc + b.net, 0) ?? 0, currency, )
#: src/routes/_authed/workspace/finance.tsx:525
msgid "{0} netto"
msgstr "{0} netto"

#. placeholder {0}: m.email ?? m.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:175
msgid "{0} non è più membro."
msgstr "{0} non è più membro."

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:115
msgid "{0} non potrà più accettare l'invito."
msgstr "{0} non potrà più accettare l'invito."

#. placeholder {0}: formatInt(total)
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:140
msgid "{0} nudge"
msgstr "{0} nudge"

#. placeholder {0}: counts.new_count
#: src/features/sync/components/DocSyncManager.tsx:1016
msgid "{0} nuovi"
msgstr "{0} nuovi"

#. placeholder {0}: formatInt(item.occurrences)
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:271
msgid "{0} occorrenze"
msgstr "{0} occorrenze"

#. placeholder {0}: ids.length
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:133
#: src/features/admin/components/orgs/OrgMembersTab.tsx:228
msgid "{0} operazioni completate."
msgstr "{0} operazioni completate."

#. placeholder {0}: (res.results ?? []).length
#: src/features/console/pages/PlaygroundPage.tsx:1639
msgid "{0} passaggi"
msgstr "{0} passaggi"

#. placeholder {0}: resolveDisplayName(l.connector_key)
#. placeholder {1}: m.email ?? m.user_id
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:485
msgid "{0} per {1}"
msgstr "{0} per {1}"

#. placeholder {0}: l.licensed_seats
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:384
msgid "{0} posti"
msgstr "{0} posti"

#. placeholder {0}: all.length
#: src/features/admin/components/AdminCpqList.tsx:107
msgid "{0} preventivi"
msgstr "{0} preventivi"

#. placeholder {0}: r.rules_count
#. placeholder {0}: rules.data?.length ?? 0
#: src/features/dfm-rules/components/DfmRulesPage.tsx:321
#: src/features/dfm-rules/components/DfmRulesPage.tsx:388
msgid "{0} regole"
msgstr "{0} regole"

#. placeholder {0}: upload.data.rules_extracted
#. placeholder {1}: upload.data.rules_confident
#: src/features/dfm-rules/components/DfmRulesPage.tsx:265
msgid "{0} regole · {1} confident"
msgstr "{0} regole · {1} confident"

#. placeholder {0}: graph.edges.length - relations.edges.length - relations.internalCount
#: src/features/console/traces/TraceGraph.tsx:490
msgid "{0} relazioni escluse dai filtri."
msgstr "{0} relazioni escluse dai filtri."

#. placeholder {0}: canvasRelations.edges.length
#. placeholder {1}: canvasRelations.internalCount
#: src/features/console/traces/TraceGraph.tsx:486
msgid "{0} relazioni originali disegnate; {1} relazioni interne ai nodi raggruppati."
msgstr "{0} relazioni originali disegnate; {1} relazioni interne ai nodi raggruppati."

#. placeholder {0}: form.email.trim()
#: src/features/admin/components/orgs/AddMemberDialog.tsx:108
msgid "{0} riceverà un'email di invito."
msgstr "{0} riceverà un'email di invito."

#. placeholder {0}: result.rejected.length
#: src/features/console/connectors/CustomConnectorDetail.tsx:293
msgid "{0} rifiutati"
msgstr "{0} rifiutati"

#. placeholder {0}: block.rows.length
#. placeholder {0}: preview.rowCount
#. placeholder {0}: previewData.length
#: ../../packages/ui/src/ando/DataPagedTable.tsx:295
#: src/features/dashboard/components/AddChartDialog.tsx:659
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:402
#: src/features/hive-flows/run/ProposalReview.tsx:614
#: src/features/hive-flows/run/ProposalReview.tsx:717
msgid "{0} righe"
msgstr "{0} righe"

#. placeholder {0}: targets.length
#: src/features/admin/components/AdminOrgs.tsx:731
msgid "{0} righe scaricate."
msgstr "{0} righe scaricate."

#. placeholder {0}: p.count
#: src/features/clean-control/components/UndoActionsList.tsx:313
msgid "{0} risorse coinvolte"
msgstr "{0} risorse coinvolte"

#. placeholder {0}: entry.row_count
#: src/features/connect/components/ActivityFeed.tsx:104
msgid "{0} risultati"
msgstr "{0} risultati"

#. placeholder {0}: job.skippedItems
#: src/features/sync/components/UniversalSyncToast.tsx:344
msgid "{0} saltati"
msgstr "{0} saltati"

#. placeholder {0}: counts.success
#: src/routes/_authed/workspace/finance.tsx:764
msgid "{0} sani"
msgstr "{0} sani"

#. placeholder {0}: t.placeholders.length
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:257
msgid "{0} segnaposto"
msgstr "{0} segnaposto"

#. placeholder {0}: selectedIds.size
#: src/features/admin/components/AdminOrgs.tsx:900
msgid "{0} selezionate"
msgstr "{0} selezionate"

#. placeholder {0}: row.missing
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:441
msgid "{0} senza descrizione"
msgstr "{0} senza descrizione"

#. placeholder {0}: data?.cash_flow.length ?? 0
#: src/routes/_authed/workspace/finance.tsx:537
msgid "{0} settimane"
msgstr "{0} settimane"

#. placeholder {0}: overlaysBySlide.size
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:398
msgid "{0} slide con modifiche"
msgstr "{0} slide con modifiche"

#. placeholder {0}: missing[l].size
#: src/features/admin/components/deckEditor/DeckEditor.tsx:353
msgid "{0} slide da tradurre"
msgstr "{0} slide da tradurre"

#. placeholder {0}: ids.length - failed
#: src/features/admin/components/orgs/OrgMembersTab.tsx:233
msgid "{0} successi, {failed} errori."
msgstr "{0} successi, {failed} errori."

#. placeholder {0}: res.accepted
#: src/features/sales/hooks/useCrmQueries.ts:315
msgid "{0} suggerimenti accettati"
msgstr "{0} suggerimenti accettati"

#. placeholder {0}: discoveryEstimate.data.tables_to_profile
#. placeholder {1}: discoveryEstimate.data.columns_to_profile
#. placeholder {2}: discoveryEstimate.data.unchanged_tables
#: src/features/console/pages/ConnectorDetailPage.tsx:534
msgid "{0} tabelle e {1} colonne da analizzare. {2} tabelle invariate."
msgstr "{0} tabelle e {1} colonne da analizzare. {2} tabelle invariate."

#. placeholder {0}: discoveryEstimate.data.baseline_review_tables ?? 0
#: src/features/console/pages/ConnectorDetailPage.tsx:562
msgid "{0} tabelle richiedono una revisione del profiling precedente."
msgstr "{0} tabelle richiedono una revisione del profiling precedente."

#. placeholder {0}: formatInt(total)
#: src/features/admin/components/hypermem/HmTenantsTab.tsx:133
msgid "{0} tenant nel platform · ordinamento per <0>{sortLabel}</0> ({sortDir})"
msgstr "{0} tenant nel platform · ordinamento per <0>{sortLabel}</0> ({sortDir})"

#. placeholder {0}: formatPct(traffic * 100, 0)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:151
msgid "{0} traffic"
msgstr "{0} traffic"

#. placeholder {0}: pairs.length
#. placeholder {1}: finished.length
#: src/features/voice_report/components/RunDiffTimeline.tsx:430
msgid "{0} transizioni · {1} run completati"
msgstr "{0} transizioni · {1} run completati"

#. placeholder {0}: formatInt(b.user_count)
#. placeholder {0}: formatInt(f.wau)
#: src/features/admin/components/AdminEngagement.tsx:275
#: src/features/admin/components/AdminEngagement.tsx:320
msgid "{0} utenti"
msgstr "{0} utenti"

#. placeholder {0}: data?.active_users ?? 0
#. placeholder {1}: data?.active_connections ?? 0
#. placeholder {2}: data?.needs_reauth ?? 0
#. placeholder {3}: data?.sync_errors ?? 0
#: src/features/console/pages/EmbeddedIdentityPage.tsx:512
msgid "{0} utenti · {1} connessioni attive · {2} da ricollegare · {3} errori di sync"
msgstr "{0} utenti · {1} connessioni attive · {2} da ricollegare · {3} errori di sync"

#. placeholder {0}: result.failed_users.length
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:94
msgid "{0} utenti non migrati. Org NON eliminata."
msgstr "{0} utenti non migrati. Org NON eliminata."

#. placeholder {0}: ids.length
#: src/features/admin/components/AdminUsers.tsx:158
msgid "{0} utenti sospesi"
msgstr "{0} utenti sospesi"

#. placeholder {0}: twins.length
#: src/features/structured-data/components/SimilarPartsSection.tsx:316
msgid "{0} varianti trovate"
msgstr "{0} varianti trovate"

#. placeholder {0}: l.items_count
#: src/features/price-lists/components/PriceListsPage.tsx:425
msgid "{0} voci"
msgstr "{0} voci"

#. placeholder {0}: upload.data.items_extracted
#. placeholder {1}: upload.data.items_confident
#: src/features/price-lists/components/PriceListsPage.tsx:246
msgid "{0} voci · {1} confident"
msgstr "{0} voci · {1} confident"

#. placeholder {0}: result.items_extracted
#. placeholder {1}: result.items_confident
#: src/features/price-lists/components/PriceListsPage.tsx:88
#: src/features/price-lists/components/PriceListsPage.tsx:200
msgid "{0} voci estratte ({1} ad alta confidence)"
msgstr "{0} voci estratte ({1} ad alta confidence)"

#. placeholder {0}: tpl.widgets.length
#: src/features/dashboard/components/DashboardTemplatePicker.tsx:196
msgid "{0} widget pre-configurati"
msgstr "{0} widget pre-configurati"

#. placeholder {0}: offset + 1
#: src/features/console/pages/EmbeddedIdentityPage.tsx:616
msgid "{0}–{pageEnd} di {total}"
msgstr "{0}–{pageEnd} di {total}"

#. placeholder {0}: file.name
#: src/features/chat/hooks/useChatAttachments.ts:244
#: src/features/chat/hooks/useChatAttachments.ts:276
msgid "{0}: errore upload"
msgstr "{0}: errore upload"

#. placeholder {0}: file.name
#: src/features/chat/hooks/useChatAttachments.ts:167
msgid "{0}: file oltre i 25 MB"
msgstr "{0}: file oltre i 25 MB"

#. placeholder {0}: file.name
#: src/features/chat/hooks/useChatAttachments.ts:147
msgid "{0}: immagine oltre i 10 MB"
msgstr "{0}: immagine oltre i 10 MB"

#. placeholder {0}: kindLabel(p.kind)
#: src/features/sales/hooks/useProspectingWsBridge.ts:53
msgid "{0}: operazione non riuscita. Riprova."
msgstr "{0}: operazione non riuscita. Riprova."

#. placeholder {0}: file.name
#: src/features/chat/hooks/useChatAttachments.ts:178
msgid "{0}: tipo non supportato"
msgstr "{0}: tipo non supportato"

#. placeholder {0}: data.early_churn.cur_wau - data.early_churn.prev_wau >= 0 ? "+" : ""
#. placeholder {1}: formatInt( data.early_churn.cur_wau - data.early_churn.prev_wau, )
#: src/features/admin/components/AdminEngagement.tsx:193
msgid "{0}{1} sett. su sett."
msgstr "{0}{1} sett. su sett."

#. placeholder {0}: activeIds.length
#. placeholder {1}: connectionOptions.length
#: src/routes/_authed/workspace/conversations.tsx:833
msgid "{0}/{1} account"
msgstr "{0}/{1} account"

#. placeholder {0}: activeIds.length
#. placeholder {1}: connectionOptions.length
#: src/routes/_authed/workspace/calendar.tsx:772
msgid "{0}/{1} calendari"
msgstr "{0}/{1} calendari"

#. placeholder {0}: syncProgress.uploaded
#. placeholder {1}: syncProgress.total
#: src/features/connectors/components/FilesystemConnectDialog.tsx:925
msgid "{0}/{1} caricati"
msgstr "{0}/{1} caricati"

#. placeholder {0}: activeIds.length
#. placeholder {1}: connectionOptions.length
#: src/routes/_authed/workspace/finance.tsx:351
msgid "{0}/{1} collegamenti"
msgstr "{0}/{1} collegamenti"

#. placeholder {0}: rejectReason.trim().length
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:435
msgid "{0}/1000 · richiesto"
msgstr "{0}/1000 · richiesto"

#. placeholder {0}: Math.round(currentRatio)
#. placeholder {1}: Math.round(100 - currentRatio)
#: src/features/chat/components/SplitDragHandle.tsx:145
msgid "{0}% chat, {1}% workspace"
msgstr "{0}% chat, {1}% workspace"

#. placeholder {0}: safeNum(usage.cost_used_pct).toFixed(1)
#. placeholder {0}: safeNum(usage.storage_used_pct).toFixed(1)
#: src/features/admin/components/orgs/OrgBillingTab.tsx:474
#: src/features/admin/components/orgs/OrgBillingTab.tsx:505
msgid "{0}% usato"
msgstr "{0}% usato"

#. placeholder {0}: (deltaPct ?? 0).toFixed(1)
#: src/features/admin/components/AdminRevenue.tsx:192
msgid "{0}% vs periodo precedente"
msgstr "{0}% vs periodo precedente"

#. placeholder {0}: Math.floor(delta / 86_400)
#: src/features/sources/components/AISummaryPanel.tsx:929
msgid "{0}g fa"
msgstr "{0}g fa"

#. placeholder {0}: daysInStage(deal)
#: src/features/sales/components/crm/PipelineBoard.tsx:126
msgid "{0}g fermo"
msgstr "{0}g fermo"

#. placeholder {0}: Math.floor(delta / 3600)
#: src/features/sources/components/AISummaryPanel.tsx:928
msgid "{0}h fa"
msgstr "{0}h fa"

#. placeholder {0}: Math.floor(delta / 60)
#: src/features/sources/components/AISummaryPanel.tsx:927
msgid "{0}m fa"
msgstr "{0}m fa"

#: src/routes/_authed/workspace/finance.tsx:1402
msgid "{accountsCount} conti attivi"
msgstr "{accountsCount} conti attivi"

#: src/features/console/components/KeyMeta.tsx:156
msgid "{actions, plural, one {# connettore in scrittura} other {# connettori in scrittura}}"
msgstr "{actions, plural, one {# connettore in scrittura} other {# connettori in scrittura}}"

#: src/features/projects/components/ProjectDetailPage.tsx:204
msgid "{active} attive"
msgstr "{active} attive"

#: src/features/console/pages/OverviewPage.tsx:193
msgid "{activeSourceCount} fonti collegate"
msgstr "{activeSourceCount} fonti collegate"

#. placeholder {0}: members.length
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:379
msgid "{assignedCount}/{0} assegnati"
msgstr "{assignedCount}/{0} assegnati"

#: src/features/sources/components/EmailThreadMessages.tsx:966
msgid "{attachmentCount} allegati"
msgstr "{attachmentCount} allegati"

#: src/features/sources/components/EmailThreadMessages.tsx:965
msgid "{attachmentCount} allegato"
msgstr "{attachmentCount} allegato"

#: src/features/sync/components/UniversalSyncToast.tsx:296
msgid "{base} · annullamento…"
msgstr "{base} · annullamento…"

#: src/features/sync/components/UniversalSyncToast.tsx:295
msgid "{base} · annullato"
msgstr "{base} · annullato"

#: src/features/sync/components/UniversalSyncToast.tsx:293
msgid "{base} · completato"
msgstr "{base} · completato"

#: src/features/sync/components/UniversalSyncToast.tsx:294
msgid "{base} · errore"
msgstr "{base} · errore"

#: src/routes/_authed/workspace/technical.tsx:512
msgid "{blocksCount} blocchi"
msgstr "{blocksCount} blocchi"

#: src/features/dashboard/components/DashboardListSidebar.tsx:464
msgid "{chartCount, plural, one {1 grafico verrà eliminato.} other {# grafici verranno eliminati.}}"
msgstr "{chartCount, plural, one {1 grafico verrà eliminato.} other {# grafici verranno eliminati.}}"

#. placeholder {0}: plan.display_name
#: src/features/admin/components/AdminPlatformSettings.tsx:347
#: src/features/admin/components/AdminPlatformSettings.tsx:392
msgid "{columnLabel} del piano {0}"
msgstr "{columnLabel} del piano {0}"

#: src/features/sync/components/UniversalSyncToast.tsx:82
msgid "{completed} completate"
msgstr "{completed} completate"

#: src/features/projects/components/ProjectDetailPage.tsx:115
msgid "{conn} connettori"
msgstr "{conn} connettori"

#: src/features/console/components/KeyMeta.tsx:151
msgid "{connections, plural, one {# connessione} other {# connessioni}}"
msgstr "{connections, plural, one {# connessione} other {# connessioni}}"

#: src/features/workspace/documents/components/BulkActionBar.tsx:87
msgid "{count, plural, one {Eliminare # documento?} other {Eliminare # documenti?}}"
msgstr "{count, plural, one {Eliminare # documento?} other {Eliminare # documenti?}}"

#: src/features/integrations/parts/StatusElements.tsx:47
msgid "{count} {nounWord} · riconnessione richiesta"
msgstr "{count} {nounWord} · riconnessione richiesta"

#: src/features/connect/components/SpaceCard.tsx:79
msgid "{count} basi"
msgstr "{count} basi"

#: src/features/admin/components/AdminQuality.tsx:115
msgid "{count} celle ricevute dal BE — render disponibile post-merge chart slice."
msgstr "{count} celle ricevute dal BE — render disponibile post-merge chart slice."

#: src/features/connect/components/SpaceCard.tsx:77
msgid "{count} doc"
msgstr "{count} doc"

#: src/features/workspace/documents/components/RecencyGroupSection.tsx:86
#: src/features/workspace/documents/components/SourceGroupSection.tsx:165
msgid "{count} elementi"
msgstr "{count} elementi"

#: src/features/sync/components/DocSyncManager.tsx:265
msgid "{count} elementi aggiunti al tracking"
msgstr "{count} elementi aggiunti al tracking"

#: src/features/workspace/documents/components/RecencyGroupSection.tsx:86
#: src/features/workspace/documents/components/SourceGroupSection.tsx:165
msgid "{count} elemento"
msgstr "{count} elemento"

#: src/features/sync/components/DocSyncManager.tsx:264
msgid "{count} elemento aggiunto al tracking"
msgstr "{count} elemento aggiunto al tracking"

#: src/features/connect/components/SpaceCard.tsx:81
msgid "{count} fonti"
msgstr "{count} fonti"

#: src/features/capabilities/useActiveConnectorsCount.ts:49
msgid "{count} fonti connesse"
msgstr "{count} fonti connesse"

#: src/features/workspace/components/NotificationPill.tsx:200
msgid "{count} non lette"
msgstr "{count} non lette"

#: src/features/workspace/components/NotificationPill.tsx:166
msgid "{count} notifiche da Ando in attesa"
msgstr "{count} notifiche da Ando in attesa"

#: src/features/admin/components/AdminCanvas.tsx:154
msgid "{count} punti dati pronti dal BE."
msgstr "{count} punti dati pronti dal BE."

#: src/features/projects/components/ProjectDetailPage.tsx:182
msgid "{count} ricordi"
msgstr "{count} ricordi"

#: src/features/chat/hooks/useThinkingHops.ts:78
msgid "{count} risultati"
msgstr "{count} risultati"

#: src/features/chat/hooks/useThinkingHops.ts:77
msgid "{count} risultato"
msgstr "{count} risultato"

#: src/features/admin/components/AdminAutomation.tsx:169
msgid "{count} serie pronte dal BE."
msgstr "{count} serie pronte dal BE."

#: src/features/workspace/finance/components/BankAccountsList.tsx:46
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:53
msgid "{d}g fa"
msgstr "{d}g fa"

#: src/features/automations/components/formatters.ts:32
msgid "{days}d"
msgstr "{days}d"

#: src/features/automations/components/formatters.ts:63
msgid "{days}d fa"
msgstr "{days}d fa"

#: src/features/console/pages/UsagePage.tsx:291
#: src/routes/_authed/workspace/calendar.tsx:163
#: src/routes/_authed/workspace/calendar.tsx:165
msgid "{days}g"
msgstr "{days}g"

#: src/routes/_authed/workspace/calendar.tsx:163
msgid "{days}g {remainderHours}h"
msgstr "{days}g {remainderHours}h"

#: src/features/settings/components/SecuritySettings.tsx:411
msgid "{days}g fa"
msgstr "{days}g fa"

#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:106
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:107
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:108
msgid "{days}g residui"
msgstr "{days}g residui"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:49
msgid "{diffMin}m fa"
msgstr "{diffMin}m fa"

#: src/features/settings/components/OrgMembersPanel.tsx:348
msgid "{displayName} avrà il pieno controllo dell'organizzazione, inclusa la gestione di membri e fatturazione. Puoi cambiare ruolo in seguito."
msgstr "{displayName} avrà il pieno controllo dell'organizzazione, inclusa la gestione di membri e fatturazione. Puoi cambiare ruolo in seguito."

#: src/routes/_authed/route.tsx:1798
msgid "{docCount} file"
msgstr "{docCount} file"

#: src/features/console/pages/SchemaPage.tsx:723
#: src/features/console/pages/SchemaPage.tsx:727
msgid "{documentCount} documenti"
msgstr "{documentCount} documenti"

#: src/routes/_authed/_modal/integrations/$capability.tsx:280
msgid "{done} file CAD caricati. Indicizzazione in corso."
msgstr "{done} file CAD caricati. Indicizzazione in corso."

#: src/features/admin/components/userAdminActions.tsx:427
msgid "{email} otterrà accesso all'area di amministrazione della piattaforma. Puoi revocarlo in qualsiasi momento riportando il ruolo a Utente."
msgstr "{email} otterrà accesso all'area di amministrazione della piattaforma. Puoi revocarlo in qualsiasi momento riportando il ruolo a Utente."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:105
#: src/features/dfm-rules/components/DfmRulesPage.tsx:217
msgid "{extracted} regole estratte ({confident} ad alta confidence)"
msgstr "{extracted} regole estratte ({confident} ad alta confidence)"

#. placeholder {0}: archivable.length
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:444
msgid "{failed} di {0} falliti."
msgstr "{failed} di {0} falliti."

#: src/features/sync/components/UniversalSyncToast.tsx:90
msgid "{failed} errori"
msgstr "{failed} errori"

#. placeholder {0}: first?.error ? `: ${first.error}` : ""
#: src/routes/_authed/_modal/integrations/$capability.tsx:296
msgid "{failed} file CAD non caricati{0}"
msgstr "{failed} file CAD non caricati{0}"

#. placeholder {0}: results.length
#: src/features/console/pages/ConnectorDetailPage.tsx:159
msgid "{failed} sincronizzazioni su {0} non sono partite."
msgstr "{failed} sincronizzazioni su {0} non sono partite."

#. placeholder {0}: messageIds.length
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:386
msgid "{failed} su {0}. Aggiornerò al prossimo refresh."
msgstr "{failed} su {0}. Aggiornerò al prossimo refresh."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:790
msgid "{fileCount} file"
msgstr "{fileCount} file"

#: src/features/workspace/lib/ingestionToast.ts:80
msgid "{fileCount} file caricati"
msgstr "{fileCount} file caricati"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:768
msgid "{fileCount} file inclusi nel sync ricorsivo"
msgstr "{fileCount} file inclusi nel sync ricorsivo"

#: src/routes/_authed/workspace/documents.tsx:951
msgid "{filteredCount} documenti trovati"
msgstr "{filteredCount} documenti trovati"

#. placeholder {0}: selectedIds.size
#: src/routes/_authed/workspace/documents.tsx:950
msgid "{filteredCount} documenti trovati, {0} selezionati"
msgstr "{filteredCount} documenti trovati, {0} selezionati"

#: src/features/projects/components/ProjectDetailPage.tsx:118
msgid "{fold} cartelle"
msgstr "{fold} cartelle"

#: src/routes/_authed/route.tsx:1790
msgid "{folderCount} cartelle"
msgstr "{folderCount} cartelle"

#: src/features/structured-data/components/ExecutionStatsStrip.tsx:44
msgid "{formatted} righe"
msgstr "{formatted} righe"

#: src/features/structured-data/components/ExecutionStatsStrip.tsx:48
msgid "{formatted} token"
msgstr "{formatted} token"

#: src/features/admin/components/orgs/_shared.tsx:194
msgid "{from}–{to} di {total}"
msgstr "{from}–{to} di {total}"

#: src/features/workspace/finance/components/BankAccountsList.tsx:44
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:51
msgid "{h}h fa"
msgstr "{h}h fa"

#: src/features/automations/components/formatters.ts:29
#: src/routes/_authed/workspace/calendar.tsx:158
msgid "{hours}h"
msgstr "{hours}h"

#: src/routes/_authed/workspace/calendar.tsx:158
msgid "{hours}h {minutes} min"
msgstr "{hours}h {minutes} min"

#: src/features/settings/components/SecuritySettings.tsx:409
msgid "{hours}h fa"
msgstr "{hours}h fa"

#: src/features/automations/components/formatters.ts:61
msgid "{hrs}h fa"
msgstr "{hrs}h fa"

#: src/features/sync/components/UniversalSyncToast.tsx:74
msgid "{inProgress} in corso"
msgstr "{inProgress} in corso"

#. placeholder {0}: formatDelta(data.dscr.trend_delta_30d)
#: src/routes/_authed/workspace/finance.tsx:478
msgid "{interp} · Δ30g {0}"
msgstr "{interp} · Δ30g {0}"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:345
msgid "{label} — {visibleActiveCount} di {totalCount} attivi"
msgstr "{label} — {visibleActiveCount} di {totalCount} attivi"

#: src/features/connect/components/MemberManager.tsx:332
msgid "{label} ora ha accesso a questo spazio"
msgstr "{label} ora ha accesso a questo spazio"

#: src/features/admin/components/AdminDemoInviti.tsx:154
msgid "{label}: errore"
msgstr "{label}: errore"

#: src/routes/_authed/workspace/technical.tsx:502
msgid "{layersCount} layer"
msgstr "{layersCount} layer"

#: src/features/connect/components/SpaceCard.tsx:151
#: src/features/connect/components/SpaceCard.tsx:160
msgid "{memberCount} membri"
msgstr "{memberCount} membri"

#: src/features/projects/components/ProjectHub.tsx:680
msgid "{memoryCount} ricordi"
msgstr "{memoryCount} ricordi"

#: src/features/workspace/finance/components/BankAccountsList.tsx:42
msgid "{min}m fa"
msgstr "{min}m fa"

#: src/features/automations/components/formatters.ts:59
msgid "{mins}m fa"
msgstr "{mins}m fa"

#: src/features/automations/components/formatters.ts:26
msgid "{minutes}m"
msgstr "{minutes}m"

#: src/features/settings/components/SecuritySettings.tsx:407
msgid "{minutes}m fa"
msgstr "{minutes}m fa"

#: src/features/sync/components/DocSyncManager.tsx:900
msgid "{modifiedCount} modificati"
msgstr "{modifiedCount} modificati"

#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:111
msgid "{months} mesi"
msgstr "{months} mesi"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:287
msgid "{name} abilitato per tutti i membri."
msgstr "{name} abilitato per tutti i membri."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:199
msgid "{name} abilitato."
msgstr "{name} abilitato."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:288
msgid "{name} disabilitato per tutti i membri."
msgstr "{name} disabilitato per tutti i membri."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:200
msgid "{name} disabilitato."
msgstr "{name} disabilitato."

#: src/features/sync/components/DocSyncManager.tsx:898
msgid "{newCount} nuovi"
msgstr "{newCount} nuovi"

#: src/routes/_authed/workspace/flows.index.tsx:346
msgid "{nodeCount} passi"
msgstr "{nodeCount} passi"

#: src/routes/_authed/workspace/flows.index.tsx:345
msgid "{nodeCount} passo"
msgstr "{nodeCount} passo"

#: src/features/console/pages/SchemaPage.tsx:720
msgid "{objectCount} oggetti"
msgstr "{objectCount} oggetti"

#: src/features/admin/components/AdminOrgs.tsx:776
msgid "{ok} organizzazione/i ora disattivate."
msgstr "{ok} organizzazione/i ora disattivate."

#: src/features/admin/components/AdminOrgs.tsx:683
#: src/features/admin/components/AdminOrgs.tsx:780
msgid "{ok} successi, {fail} errori — dettagli nel pannello."
msgstr "{ok} successi, {fail} errori — dettagli nel pannello."

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:138
msgid "{ok} successi, {failed} errori."
msgstr "{ok} successi, {failed} errori."

#. placeholder {0}: failures.length
#: src/features/admin/components/AdminOrgs.tsx:299
msgid "{okCount} organizzazione/i completate, {0} con errore."
msgstr "{okCount} organizzazione/i completate, {0} con errore."

#: src/features/chat/components/ConversationSidebar.tsx:691
msgid "{overdue} attività in ritardo"
msgstr "{overdue} attività in ritardo"

#: src/features/projects/components/ProjectDetailPage.tsx:150
msgid "{overdue} in ritardo"
msgstr "{overdue} in ritardo"

#: src/features/projects/components/ProjectHub.tsx:672
msgid "{overdueCount} in ritardo"
msgstr "{overdueCount} in ritardo"

#: src/features/canvases/components/SuggestedCanvasCard.tsx:67
msgid "{participants, plural, one {# persona} other {# persone}}"
msgstr "{participants, plural, one {# persona} other {# persone}}"

#: src/features/projects/components/ProjectDetailPage.tsx:159
msgid "{pending} in coda"
msgstr "{pending} in coda"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:605
msgid "{pendingCount} in attesa"
msgstr "{pendingCount} in attesa"

#: ../../packages/ui/src/editors/ReviewRail.tsx:281
msgid "{pendingCount} modifiche proposte"
msgstr "{pendingCount} modifiche proposte"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:193
msgid "{profiled} di {total} profilati"
msgstr "{profiled} di {total} profilati"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:262
msgid "{profiled} profilate"
msgstr "{profiled} profilate"

#: src/features/console/components/ModelPickerModal.tsx:221
msgid "{purposeLabel}: Ando gestisce le credenziali e le richieste."
msgstr "{purposeLabel}: Ando gestisce le credenziali e le richieste."

#. placeholder {0}: formatInt(total)
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:234
msgid "{rangeStart}–{rangeEnd} di {0}"
msgstr "{rangeStart}–{rangeEnd} di {0}"

#: src/features/connectors/components/ConnectedAccountRow.tsx:147
msgid "{relative} fa"
msgstr "{relative} fa"

#: src/features/settings/components/SelfProfileMemory.tsx:508
msgid "{remaining, plural, one {+# altro} other {+# altri}}"
msgstr "{remaining, plural, one {+# altro} other {+# altri}}"

#: src/features/structured-data/components/ExecutionStatsStrip.tsx:51
msgid "{retryCount} retry"
msgstr "{retryCount} retry"

#: src/features/sources/components/AISummaryPanel.tsx:854
msgid "{reviewed} su {total} modifiche revisionate"
msgstr "{reviewed} su {total} modifiche revisionate"

#: src/features/projects/components/ProjectDetailPage.tsx:101
msgid "{role} · tono {tone}"
msgstr "{role} · tono {tone}"

#: src/features/automations/components/AutomationsHub.tsx:265
msgid "{runsThisMonth} esec. questo mese"
msgstr "{runsThisMonth} esec. questo mese"

#: src/features/console/pages/ResourceAccessPage.tsx:373
msgid "{savedActiveGrantCount} persone autorizzate"
msgstr "{savedActiveGrantCount} persone autorizzate"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:123
msgid "{selectedCount} contenuti selezionati"
msgstr "{selectedCount} contenuti selezionati"

#: src/features/workspace/components/NudgeClusterRow.tsx:215
msgid "{size, plural, one {Notifica · # fonte correlata} other {Notifica · # fonti correlate}}"
msgstr "{size, plural, one {Notifica · # fonte correlata} other {Notifica · # fonti correlate}}"

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:456
msgid "{skipped} esclusi (PEC/chat — archivio non disponibile)."
msgstr "{skipped} esclusi (PEC/chat — archivio non disponibile)."

#: src/features/admin/components/AdminDecks.tsx:242
msgid "{slides} slide"
msgstr "{slides} slide"

#: src/features/canvases/components/SuggestedCanvasCard.tsx:50
msgid "{sources, plural, one {# fonte} other {# fonti}}"
msgstr "{sources, plural, one {# fonte} other {# fonti}}"

#: src/features/console/components/KeyMeta.tsx:146
msgid "{sources, plural, one {# sorgente} other {# sorgenti}}"
msgstr "{sources, plural, one {# sorgente} other {# sorgenti}}"

#: src/routes/_authed/workspace/documents.tsx:708
msgid "{succeeded} file rimossi."
msgstr "{succeeded} file rimossi."

#: src/routes/_authed/workspace/documents.tsx:716
msgid "{succeeded} ok · {failed} falliti."
msgstr "{succeeded} ok · {failed} falliti."

#: src/features/sync/components/DocSyncManager.tsx:866
msgid "{syncedCount} file aggiornati. Puoi forzare una ri-sincronizzazione."
msgstr "{syncedCount} file aggiornati. Puoi forzare una ri-sincronizzazione."

#: src/features/sync/components/DocSyncManager.tsx:902
msgid "{syncedCount} già sincronizzati"
msgstr "{syncedCount} già sincronizzati"

#: src/routes/_authed/workspace/technical.tsx:507
msgid "{textsCount} annotazioni"
msgstr "{textsCount} annotazioni"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:84
msgid "{tier} in {region}."
msgstr "{tier} in {region}."

#: src/features/integrations/parts/IntegrationsEmptyState.tsx:39
msgid "{title} richiede un piano superiore"
msgstr "{title} richiede un piano superiore"

#: src/features/chat/components/ChatTopBar.tsx:165
msgid "{total, plural, =0 {Nessun file, immagine o documento} one {# elemento} other {# elementi}}"
msgstr "{total, plural, =0 {Nessun file, immagine o documento} one {# elemento} other {# elementi}}"

#: src/features/automations/components/AutomationsHub.tsx:293
msgid "{total, plural, one {# automazione} other {# automazioni}}"
msgstr "{total, plural, one {# automazione} other {# automazioni}}"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:171
msgid "{total, plural, one {# elemento aggiunto alla sincronizzazione} other {# elementi aggiunti alla sincronizzazione}}"
msgstr "{total, plural, one {# elemento aggiunto alla sincronizzazione} other {# elementi aggiunti alla sincronizzazione}}"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:235
msgid "{total, plural, one {Scoperta completata: # tabella pronta.} other {Scoperta completata: # tabelle pronte.}}"
msgstr "{total, plural, one {Scoperta completata: # tabella pronta.} other {Scoperta completata: # tabelle pronte.}}"

#: src/features/clean-control/components/EventQueue.tsx:193
msgid "{total} aperti · {criticalCount} critici"
msgstr "{total} aperti · {criticalCount} critici"

#: src/features/sales/components/LeadsPanel.tsx:276
msgid "{total} lead"
msgstr "{total} lead"

#: ../../packages/ui/src/editors/ReviewRail.tsx:521
msgid "{total} modifiche processate."
msgstr "{total} modifiche processate."

#: src/features/admin/components/AdminOrgs.tsx:801
msgid "{total} tenant · {activeCount} attivi · {inactiveCount} disattivati"
msgstr "{total} tenant · {activeCount} attivi · {inactiveCount} disattivati"

#: src/features/admin/components/AdminUsers.tsx:205
msgid "{total} utenti totali"
msgstr "{total} utenti totali"

#: src/features/price-lists/components/PriceListsPage.tsx:502
msgid "{total} voci"
msgstr "{total} voci"

#: src/features/automations/components/AutomationsHub.tsx:258
msgid "{totalAutomations} totali"
msgstr "{totalAutomations} totali"

#: src/features/workspace/finance/components/ConnectionsPanel.tsx:61
msgid "{totalConnected} attivi in totale"
msgstr "{totalConnected} attivi in totale"

#: src/features/settings/components/SelfProfileMemory.tsx:428
msgid "{totalFacts, plural, one {# fatto totale} other {# fatti totali}}"
msgstr "{totalFacts, plural, one {# fatto totale} other {# fatti totali}}"

#: src/features/settings/components/SelfProfileMemory.tsx:697
msgid "{totalFacts, plural, one {Cancella memoria (# fatto)} other {Cancella memoria (# fatti)}}"
msgstr "{totalFacts, plural, one {Cancella memoria (# fatto)} other {Cancella memoria (# fatti)}}"

#: src/routes/_authed/workspace/calendar.tsx:154
msgid "{totalMinutes} min"
msgstr "{totalMinutes} min"

#: src/features/sync/components/DocSyncManager.tsx:809
msgid "{totalSelected, plural, one {Sincronizza # elemento} other {Sincronizza # elementi}}"
msgstr "{totalSelected, plural, one {Sincronizza # elemento} other {Sincronizza # elementi}}"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:93
msgid "{totalSheets, plural, one {# foglio rilevato} other {# fogli rilevati}}"
msgstr "{totalSheets, plural, one {# foglio rilevato} other {# fogli rilevati}}"

#: src/features/sources/components/EmailThreadMessages.tsx:565
msgid "{trackerCount} tracker bloccati"
msgstr "{trackerCount} tracker bloccati"

#: src/features/sources/components/EmailThreadMessages.tsx:570
msgid "{trackerCount} tracker bloccati — clicca per i dettagli"
msgstr "{trackerCount} tracker bloccati — clicca per i dettagli"

#: src/features/sources/components/EmailThreadMessages.tsx:564
msgid "{trackerCount} tracker bloccato"
msgstr "{trackerCount} tracker bloccato"

#: src/features/sources/components/EmailThreadMessages.tsx:569
msgid "{trackerCount} tracker bloccato — clicca per i dettagli"
msgstr "{trackerCount} tracker bloccato — clicca per i dettagli"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:128
msgid "{type} attivato."
msgstr "{type} attivato."

#: src/features/console/pages/SchemaPage.tsx:901
msgid "{UKS_FULL} ({UKS}) · motore {TRAMA}"
msgstr "{UKS_FULL} ({UKS}) · motore {TRAMA}"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:280
msgid "{validPct}% validi"
msgstr "{validPct}% validi"

#: src/features/admin/components/AdminGatedLinks.tsx:299
msgid "{views} aperture"
msgstr "{views} aperture"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:420
msgid "{visibleActiveCount} di {totalCount}"
msgstr "{visibleActiveCount} di {totalCount}"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:346
msgid "{visibleActiveCount} di {totalCount} account attivi"
msgstr "{visibleActiveCount} di {totalCount} account attivi"

#: src/routes/_authed/workspace/conversations.tsx:899
msgid "{visibleCount} thread visibili"
msgstr "{visibleCount} thread visibili"

#. placeholder {0}: selectedIds.size
#: src/routes/_authed/workspace/conversations.tsx:898
msgid "{visibleCount} thread visibili, {0} selezionati"
msgstr "{visibleCount} thread visibili, {0} selezionati"

#: src/features/console/components/KeyMeta.tsx:99
#: src/features/console/pages/KeyDetailPage.tsx:461
msgid "/ mese"
msgstr "/ mese"

#: src/features/admin/components/AdminCostTracking.tsx:449
msgid "/mese"
msgstr "/mese"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1174
msgid "/percorso/al/ca.pem"
msgstr "/percorso/al/ca.pem"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:216
msgid "#general / Mario Rossi / +39…"
msgstr "#general / Mario Rossi / +39…"

#: src/features/admin/components/AdminOverview.tsx:127
msgid "% spesa per modello / provider, finestra dell'intervallo"
msgstr "% spesa per modello / provider, finestra dell'intervallo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:408
msgid "← Collegamento app"
msgstr "← Collegamento app"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:436
#: src/features/dashboard/components/wizard/WizardStepData.tsx:406
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:431
msgid "← Indietro"
msgstr "← Indietro"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:329
msgid "← Raccolte"
msgstr "← Raccolte"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:315
msgid "← Siti"
msgstr "← Siti"

#. placeholder {0}: parentCrumb.label
#: src/features/workspace/documents/components/FolderBrowserView.tsx:190
msgid "← Torna a {0}"
msgstr "← Torna a {0}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:302
msgid "← Torna alle fonti"
msgstr "← Torna alle fonti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:608
msgid "← Tutti gli utenti"
msgstr "← Tutti gli utenti"

#: src/routes/_authed/route.tsx:900
msgid "↓ Nuovi messaggi"
msgstr "↓ Nuovi messaggi"

#: src/features/hive-flows/components/ConditionBuilder.tsx:261
#: src/features/hive-flows/components/NodeInspector.tsx:1017
msgid "↪ oppure usa un dato…"
msgstr "↪ oppure usa un dato…"

#. placeholder {0}: teams.data.channels.length - 30
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:443
msgid "+ {0} altri canali — seleziona il team per includerli tutti."
msgstr "+ {0} altri canali — seleziona il team per includerli tutti."

#. placeholder {0}: spaces.data.spaces.length - 30
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:510
msgid "+ {0} altri spazi."
msgstr "+ {0} altri spazi."

#: src/routes/_authed/workspace/finance.tsx:1138
msgid "+ Aggiungi snapshot patrimonio netto"
msgstr "+ Aggiungi snapshot patrimonio netto"

#: src/features/dashboard/components/AddChartDialog.tsx:597
msgid "+ Crea nuova dashboard…"
msgstr "+ Crea nuova dashboard…"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:322
msgid "+ Nuova dashboard…"
msgstr "+ Nuova dashboard…"

#: src/features/settings/components/BrandKitSettings.tsx:785
msgid "+ Nuova voce"
msgstr "+ Nuova voce"

#: src/features/admin/components/AdminCpqPriceBook.tsx:304
msgid "+ per ogni applicazione in più (EUR)"
msgstr "+ per ogni applicazione in più (EUR)"

#. placeholder {0}: categories.length - TOP_CATEGORIES_VISIBLE
#: src/features/dxf/components/DxfLeftRail.tsx:126
msgid "+{0} altre"
msgstr "+{0} altre"

#. placeholder {0}: event.related_ids.length - 20
#. placeholder {0}: selectedDocs.length - 6
#: src/features/clean-control/components/EventDetailSheet.tsx:475
#: src/features/connect/components/GrantManager.tsx:589
msgid "+{0} altri"
msgstr "+{0} altri"

#: src/routes/_authed/workspace/calendar.tsx:1314
msgid "+{overflow} altri"
msgstr "+{overflow} altri"

#. placeholder {0}: CHANGELOG_ENTRIES.length
#: src/routes/_authed/_modal/settings/changelog.tsx:47
msgid "<0>{0} aggiornamenti</0> · le ultime modifiche distribuite ad Ando"
msgstr "<0>{0} aggiornamenti</0> · le ultime modifiche distribuite ad Ando"

#. placeholder {0}: templates.length
#: src/features/settings/components/PresentationTemplates.tsx:205
msgid "<0>{0}</0> · slide design, Word, voice & tone"
msgstr "<0>{0}</0> · slide design, Word, voice & tone"

#. placeholder {0}: flows.length
#: src/features/projects/components/sections/AutomationsSection.tsx:270
msgid "<0>{0}</0> automazioni del progetto."
msgstr "<0>{0}</0> automazioni del progetto."

#. placeholder {0}: connectedSummaries.length
#. placeholder {1}: disconnectedSummaries.length
#: src/routes/_authed/_modal/integrations/index.tsx:343
msgid "<0>{0}</0> collegate · <1>{1}</1> disponibili"
msgstr "<0>{0}</0> collegate · <1>{1}</1> disponibili"

#. placeholder {0}: artifacts.length
#: src/features/projects/components/sections/ArtifactGallerySection.tsx:206
msgid "<0>{0}</0> documenti generati, più recenti per primi."
msgstr "<0>{0}</0> documenti generati, più recenti per primi."

#. placeholder {0}: confirmRemove.email ?? confirmRemove.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:593
msgid "<0>{0}</0> perderà l'accesso a questa organizzazione. Verrà migrato al Default Tenant; i dati personali (TIER 1+2) seguono l'utente."
msgstr "<0>{0}</0> perderà l'accesso a questa organizzazione. Verrà migrato al Default Tenant; i dati personali (TIER 1+2) seguono l'utente."

#. placeholder {0}: entries.length
#: src/features/projects/components/sections/MemorySection.tsx:318
msgid "<0>{0}</0> ricordi del progetto, più recenti per primi."
msgstr "<0>{0}</0> ricordi del progetto, più recenti per primi."

#. placeholder {0}: rows.length
#: src/features/dashboard/components/DashboardChartCard.tsx:692
msgid "<0>{0}</0> righe"
msgstr "<0>{0}</0> righe"

#. placeholder {0}: selected.size
#: src/features/admin/components/orgs/OrgMembersTab.tsx:274
msgid "<0>{0}</0> selezionati"
msgstr "<0>{0}</0> selezionati"

#: src/routes/_authed/workspace/dashboard.tsx:889
msgid "<0>{chartCount}</0> widget"
msgstr "<0>{chartCount}</0> widget"

#: src/features/sales/components/LeadsPanel.tsx:615
msgid "<0>{contactedCount}</0> contattati su <1>{total}</1>"
msgstr "<0>{contactedCount}</0> contattati su <1>{total}</1>"

#: src/features/workspace/components/UploadModal.tsx:393
msgid "<0>{errorCount}</0> falliti"
msgstr "<0>{errorCount}</0> falliti"

#: src/routes/_authed/workspace/documents.tsx:865
msgid "<0>{filteredCount}</0> di {displayTotal} file"
msgstr "<0>{filteredCount}</0> di {displayTotal} file"

#: src/features/admin/components/AdminOrgs.tsx:309
msgid "<0>{okCount}</0> completate con successo."
msgstr "<0>{okCount}</0> completate con successo."

#: src/features/clean-control/components/EventQueue.tsx:264
msgid "<0>{selectionCount}</0> selezionati"
msgstr "<0>{selectionCount}</0> selezionati"

#. placeholder {0}: statusTab === "archived" ? i18n._(msg`archiviati`) : i18n._(msg`canvases`)
#: src/routes/_authed/workspace/canvases.tsx:187
msgid "<0>{total}</0> {0}"
msgstr "<0>{total}</0> {0}"

#: src/routes/_authed/workspace/calendar.tsx:633
msgid "<0>{totalEvents}</0> eventi"
msgstr "<0>{totalEvents}</0> eventi"

#: src/routes/_authed/workspace/work.tsx:321
msgid "<0>{totalPending}</0> in sospeso"
msgstr "<0>{totalPending}</0> in sospeso"

#: src/routes/_authed/workspace/conversations.tsx:735
msgid "<0>{unreadLabel}</0> non lette · <1>{totalLabel}</1> totali"
msgstr "<0>{unreadLabel}</0> non lette · <1>{totalLabel}</1> totali"

#: src/routes/_authed/_modal/settings/shortcuts.tsx:30
msgid "<0>20+</0> scorciatoie · cerca per azione o tasto"
msgstr "<0>20+</0> scorciatoie · cerca per azione o tasto"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:434
msgid "<0>ANDO_BASE_URL</0> è la base del runtime della piattaforma; <1>ANDO_API_KEY</1> è la AppKey del passaggio 1."
msgstr "<0>ANDO_BASE_URL</0> è la base del runtime della piattaforma; <1>ANDO_API_KEY</1> è la AppKey del passaggio 1."

#: src/features/console/connectors/CustomConnectorDetail.tsx:505
msgid "<0>ANDO_BASE_URL</0> è la base del runtime della piattaforma;<1> ANDO_API_KEY</1> è la AppKey con gli scope qui sopra."
msgstr "<0>ANDO_BASE_URL</0> è la base del runtime della piattaforma;<1> ANDO_API_KEY</1> è la AppKey con gli scope qui sopra."

#: src/features/console/connectors/ConnectorActionsPanel.tsx:160
msgid "<0>Azioni:</0> Ando invia una richiesta FUORI, al tuo applicativo, che la esegue (es. crea un ticket)."
msgstr "<0>Azioni:</0> Ando invia una richiesta FUORI, al tuo applicativo, che la esegue (es. crea un ticket)."

#: src/features/clean-control/components/EventQueue.tsx:458
msgid "<0>La tua memoria è in ordine.</0> Ando non ha nulla da segnalarti al momento — nessun duplicato, nessun formato invalido, nessun contenuto obsoleto. Continua a lavorare tranquillamente; ti avviserò appena qualcosa richiederà una revisione."
msgstr "<0>La tua memoria è in ordine.</0> Ando non ha nulla da segnalarti al momento — nessun duplicato, nessun formato invalido, nessun contenuto obsoleto. Continua a lavorare tranquillamente; ti avviserò appena qualcosa richiederà una revisione."

#: src/features/console/connectors/ConnectorActionsPanel.tsx:146
msgid "<0>Letture:</0> la tua app spinge i dati DENTRO Ando per renderli interrogabili."
msgstr "<0>Letture:</0> la tua app spinge i dati DENTRO Ando per renderli interrogabili."

#: src/features/clean-control/components/EventQueue.tsx:506
msgid "<0>Non sono riuscito a caricare la coda.</0> {message}"
msgstr "<0>Non sono riuscito a caricare la coda.</0> {message}"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:231
msgid "<0>Platform Overview</0> — somma cross-tenant di tutti i tenant del sistema (no PII)."
msgstr "<0>Platform Overview</0> — somma cross-tenant di tutti i tenant del sistema (no PII)."

#: src/features/onboarding/DemoBetaBanner.tsx:48
msgid "<0>Stai esplorando la demo di Ando</0> · beta con dati simulati. Qualche piccolo intoppo è possibile — riguarda solo la demo, non il prodotto, che è già solido e stabile."
msgstr "<0>Stai esplorando la demo di Ando</0> · beta con dati simulati. Qualche piccolo intoppo è possibile — riguarda solo la demo, non il prodotto, che è già solido e stabile."

#. placeholder {0}: data.readTime
#: src/features/sources/components/ArtifactPane.tsx:2298
msgid "~{0} min"
msgstr "~{0} min"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:116
msgid "~{m} min"
msgstr "~{m} min"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:782
msgid "~$0.05/deck"
msgstr "~$0.05/deck"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:116
msgid "~1 min"
msgstr "~1 min"

#: src/features/admin/components/AdminPlatformSettings.tsx:391
#: src/features/admin/components/AdminPlatformSettings.tsx:841
msgid "∞ illimitato"
msgstr "∞ illimitato"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:828
msgid "⌘/Ctrl + Invio per inviare · Esc per annullare"
msgstr "⌘/Ctrl + Invio per inviare · Esc per annullare"

#: src/routes/_authed/route.tsx:2000
msgid "⌘⇧E per chiudere · Esc"
msgstr "⌘⇧E per chiudere · Esc"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:342
msgid "🇪🇺 Dati ospitati in EU · Ruolo: aggregato (no PII)"
msgstr "🇪🇺 Dati ospitati in EU · Ruolo: aggregato (no PII)"

#: src/features/admin/components/AdminPlatformSettings.tsx:223
msgid "$ / 1M input"
msgstr "$ / 1M input"

#: src/features/admin/components/AdminPlatformSettings.tsx:226
msgid "$ / 1M output"
msgstr "$ / 1M output"

#: src/features/admin/components/AdminCostTracking.tsx:188
msgid "$ / sorgente · $ / outcome · margine per tenant · top trace costosi"
msgstr "$ / sorgente · $ / outcome · margine per tenant · top trace costosi"

#: src/features/admin/components/AdminAutomation.tsx:241
#: src/features/admin/components/AdminQuality.tsx:201
msgid "$ medio"
msgstr "$ medio"

#: src/features/admin/components/AdminPlatformSettings.tsx:574
#: src/features/admin/components/AdminPlatformSettings.tsx:798
msgid "€ / utente"
msgstr "€ / utente"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:263
msgid "€ / utente / mese"
msgstr "€ / utente / mese"

#: src/features/admin/components/orgs/_shared.tsx:193
msgid "0 risultati"
msgstr "0 risultati"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:248
msgid "0,00"
msgstr "0,00"

#: src/routes/_authed/workspace/conversations.tsx:832
msgid "1 account"
msgstr "1 account"

#: src/features/sources/components/EmailThreadMessages.tsx:981
msgid "1 allegato"
msgstr "1 allegato"

#: src/features/voice_report/components/ShareReportDialog.tsx:89
msgid "1 anno (massimo)"
msgstr "1 anno (massimo)"

#: src/features/projects/components/ProjectDetailPage.tsx:204
msgid "1 attiva"
msgstr "1 attiva"

#: src/features/chat/components/ConversationSidebar.tsx:690
msgid "1 attività in ritardo"
msgstr "1 attività in ritardo"

#: src/features/connect/components/SpaceCard.tsx:79
msgid "1 base"
msgstr "1 base"

#: src/features/connect/components/SpaceScopeBanner.tsx:110
msgid "1 base di conoscenza"
msgstr "1 base di conoscenza"

#: src/routes/_authed/workspace/calendar.tsx:771
msgid "1 calendario"
msgstr "1 calendario"

#: src/features/projects/components/ProjectDetailPage.tsx:118
msgid "1 cartella"
msgstr "1 cartella"

#: src/routes/_authed/workspace/finance.tsx:350
msgid "1 collegamento"
msgstr "1 collegamento"

#: src/features/projects/components/ProjectDetailPage.tsx:115
msgid "1 connettore"
msgstr "1 connettore"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:123
#: src/features/console/pages/ResourceAccessPage.tsx:360
msgid "1 contenuto selezionato"
msgstr "1 contenuto selezionato"

#: src/routes/_authed/workspace/finance.tsx:1401
msgid "1 conto attivo"
msgstr "1 conto attivo"

#: src/features/connect/components/SpaceCard.tsx:77
msgid "1 doc"
msgstr "1 doc"

#: src/features/connect/components/SpaceScopeBanner.tsx:107
#: src/features/console/pages/SchemaPage.tsx:723
#: src/features/console/pages/SchemaPage.tsx:727
msgid "1 documento"
msgstr "1 documento"

#: src/features/connect/components/GrantManager.tsx:546
#: src/features/connect/components/SpaceCard.tsx:81
msgid "1 fonte"
msgstr "1 fonte"

#: src/features/console/pages/OverviewPage.tsx:193
msgid "1 fonte collegata"
msgstr "1 fonte collegata"

#: src/features/capabilities/useActiveConnectorsCount.ts:48
#: src/features/connect/components/SpaceScopeBanner.tsx:114
msgid "1 fonte connessa"
msgstr "1 fonte connessa"

#: src/features/projects/components/ProjectDetailPage.tsx:158
msgid "1 in coda"
msgstr "1 in coda"

#: src/features/projects/components/ProjectDetailPage.tsx:149
msgid "1 in ritardo"
msgstr "1 in ritardo"

#: src/features/admin/components/AdminDecks.tsx:244
msgid "1 link attivo"
msgstr "1 link attivo"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:196
msgid "1 modifica"
msgstr "1 modifica"

#: ../../packages/ui/src/editors/ReviewRail.tsx:520
msgid "1 modifica processata."
msgstr "1 modifica processata."

#: ../../packages/ui/src/editors/ReviewRail.tsx:280
msgid "1 modifica proposta"
msgstr "1 modifica proposta"

#: src/features/console/pages/SchemaPage.tsx:720
msgid "1 oggetto"
msgstr "1 oggetto"

#: src/features/console/pages/ResourceAccessPage.tsx:372
msgid "1 persona autorizzata"
msgstr "1 persona autorizzata"

#: src/features/projects/components/ProjectDetailPage.tsx:182
msgid "1 ricordo"
msgstr "1 ricordo"

#: src/features/connect/components/ActivityFeed.tsx:102
msgid "1 risultato"
msgstr "1 risultato"

#: src/features/admin/components/AdminDecks.tsx:242
msgid "1 slide"
msgstr "1 slide"

#: src/features/console/pages/GetStartedPage.tsx:87
msgid "1. Aggiungi crediti"
msgstr "1. Aggiungi crediti"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:151
msgid "1. Apri WhatsApp Business sul telefono → <0>Impostazioni → Account → Business Platform</0> → tocca <1>Disconnetti</1>. Le tue chat restano sul telefono."
msgstr "1. Apri WhatsApp Business sul telefono → <0>Impostazioni → Account → Business Platform</0> → tocca <1>Disconnetti</1>. Le tue chat restano sul telefono."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1074
msgid "1. Clicca <0>Carica checklist</0> in alto."
msgstr "1. Clicca <0>Carica checklist</0> in alto."

#: src/features/price-lists/components/PriceListsPage.tsx:1040
msgid "1. Clicca <0>Carica listino</0> in alto."
msgstr "1. Clicca <0>Carica listino</0> in alto."

#: src/features/console/components/ProviderAccounts.tsx:67
msgid "1. Collega un provider"
msgstr "1. Collega un provider"

#: src/features/console/pages/ResourceAccessPage.tsx:355
msgid "1. Contenuti"
msgstr "1. Contenuti"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:392
msgid "1. Crea una AppKey con gli scope giusti"
msgstr "1. Crea una AppKey con gli scope giusti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:421
msgid "1. Identità della tua app"
msgstr "1. Identità della tua app"

#: src/features/console/docs/content.ts:84
msgid "1. Ottieni una API key"
msgstr "1. Ottieni una API key"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:84
msgid "1. Scegli i contenuti"
msgstr "1. Scegli i contenuti"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1192
msgid "10"
msgstr "10"

#: src/features/connectors/wizards/legalStorageSpec.tsx:59
msgid "10+ anni"
msgstr "10+ anni"

#: src/features/admin/components/ModelMarkupCard.tsx:114
msgid "100% significa una commissione Ando pari al costo di riferimento del modello. Con BYOK il provider fattura direttamente il cliente e Ando addebita questa commissione separatamente. Con la chiave Ando, Ando addebita costo del provider più commissione. La tariffa viene fissata quando la richiesta è registrata."
msgstr "100% significa una commissione Ando pari al costo di riferimento del modello. Con BYOK il provider fattura direttamente il cliente e Ando addebita questa commissione separatamente. Con la chiave Ando, Ando addebita costo del provider più commissione. La tariffa viene fissata quando la richiesta è registrata."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1309
msgid "10000"
msgstr "10000"

#: src/features/connectors/wizards/sdiSpec.tsx:76
msgid "11 cifre con prefisso IT (es. IT01234567890)."
msgstr "11 cifre con prefisso IT (es. IT01234567890)."

#: src/routes/_authed/workspace/finance.tsx:101
msgid "13 sett."
msgstr "13 sett."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1256
msgid "15"
msgstr "15"

#. placeholder {0}: view.totalMessages.toLocaleString(i18n.locale)
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:96
msgid "180 giorni disponibili · {0} messaggi ricercabili"
msgstr "180 giorni disponibili · {0} messaggi ricercabili"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1079
msgid "2. Attendi qualche secondo — Ando estrae le regole."
msgstr "2. Attendi qualche secondo — Ando estrae le regole."

#: src/features/price-lists/components/PriceListsPage.tsx:1045
msgid "2. Attendi qualche secondo — Ando estrae le voci prezzate."
msgstr "2. Attendi qualche secondo — Ando estrae le voci prezzate."

#: src/features/console/docs/content.ts:112
msgid "2. Configura l'ambiente e verifica la chiave"
msgstr "2. Configura l'ambiente e verifica la chiave"

#: src/features/console/pages/GetStartedPage.tsx:136
msgid "2. Crea la tua AppKey"
msgstr "2. Crea la tua AppKey"

#: src/features/console/pages/ResourceAccessPage.tsx:367
msgid "2. Persone"
msgstr "2. Persone"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:443
msgid "2. Ritorno alla tua app"
msgstr "2. Ritorno alla tua app"

#: src/features/console/pages/ModelsPage.tsx:375
msgid "2. Scegli i modelli per elaborazione"
msgstr "2. Scegli i modelli per elaborazione"

#: src/features/console/pages/ResourceAccessPage.tsx:436
msgid "2. Scegli le persone"
msgstr "2. Scegli le persone"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:423
msgid "2. Spingi i dati dal tuo applicativo"
msgstr "2. Spingi i dati dal tuo applicativo"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:158
msgid "2. Torna qui e clicca di nuovo su <0>Connetti WhatsApp Business</0>."
msgstr "2. Torna qui e clicca di nuovo su <0>Connetti WhatsApp Business</0>."

#: src/features/console/pages/KeyDetailPage.tsx:70
#: src/features/console/webhooks/WebhooksPanel.tsx:115
#: src/features/share/components/ShareLinkDialog.tsx:92
#: src/features/voice_report/components/ShareReportDialog.tsx:86
msgid "24 ore"
msgstr "24 ore"

#: src/routes/_authed/workspace/finance.tsx:102
msgid "26 sett."
msgstr "26 sett."

#: src/features/workspace/config.ts:133
#: src/features/workspace/config.ts:135
msgid "2D/3D Design"
msgstr "2D/3D Design"

#: src/features/console/pages/GetStartedPage.tsx:152
msgid "3. Esegui la prima chiamata"
msgstr "3. Esegui la prima chiamata"

#: src/features/console/docs/content.ts:139
msgid "3. Ingerisci il primo documento"
msgstr "3. Ingerisci il primo documento"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:163
msgid "3. Quando l'app WhatsApp Business ti invia una richiesta di conferma, tocca <0>Conferma</0> entro pochi minuti. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca anche se salti questo passaggio."
msgstr "3. Quando l'app WhatsApp Business ti invia una richiesta di conferma, tocca <0>Conferma</0> entro pochi minuti. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca anche se salti questo passaggio."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1082
msgid "3. Rivedi e approva le regole a bassa confidence."
msgstr "3. Rivedi e approva le regole a bassa confidence."

#: src/features/price-lists/components/PriceListsPage.tsx:1048
msgid "3. Rivedi e approva le voci a bassa confidence."
msgstr "3. Rivedi e approva le voci a bassa confidence."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1359
msgid "30"
msgstr "30"

#: src/features/admin/components/orgs/OrgCostTab.tsx:31
#: src/features/console/pages/KeyDetailPage.tsx:72
#: src/features/share/components/ShareLinkDialog.tsx:94
#: src/features/voice_report/components/ShareReportDialog.tsx:88
msgid "30 giorni"
msgstr "30 giorni"

#: src/routes/_authed/workspace/finance.tsx:100
msgid "4 sett."
msgstr "4 sett."

#: src/features/price-lists/components/PriceListsPage.tsx:1051
msgid "4. Chiedi in chat <0>\"fammi un preventivo per questo disegno\"</0> — Ando userà il listino approvato."
msgstr "4. Chiedi in chat <0>\"fammi un preventivo per questo disegno\"</0> — Ando userà il listino approvato."

#: src/features/console/docs/content.ts:170
msgid "4. Interroga: retrieve e answer"
msgstr "4. Interroga: retrieve e answer"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1085
msgid "4. Le regole vengono applicate automaticamente ai nuovi CAD."
msgstr "4. Le regole vengono applicate automaticamente ai nuovi CAD."

#: src/features/admin/components/AdminEngagement.tsx:306
msgid "4+ feature"
msgstr "4+ feature"

#: src/features/console/docs/content.ts:201
msgid "5. Agentic answer (PREVIEW)"
msgstr "5. Agentic answer (PREVIEW)"

#: src/routes/_authed/workspace/finance.tsx:103
msgid "52 sett."
msgstr "52 sett."

#: src/features/admin/components/orgs/OrgCostTab.tsx:30
#: src/features/console/pages/KeyDetailPage.tsx:71
#: src/features/console/webhooks/WebhooksPanel.tsx:116
#: src/features/share/components/ShareLinkDialog.tsx:93
#: src/features/voice_report/components/ShareReportDialog.tsx:87
msgid "7 giorni"
msgstr "7 giorni"

#: src/features/structured-data/components/SimilarPartsSection.tsx:99
msgid "7 viste 3D aggregate (SOTA Duoduo CLIP)"
msgstr "7 viste 3D aggregate (SOTA Duoduo CLIP)"

#: src/features/admin/components/orgs/OrgCostTab.tsx:32
msgid "90 giorni"
msgstr "90 giorni"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:282
#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:190
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:320
#: src/features/sources/components/InboxDetailPane.tsx:2196
#: src/features/structured-data/components/TemporalQueryControl.tsx:263
msgid "A"
msgstr "A"

#: src/features/clean-control/components/EventRow.tsx:429
msgid "A · candidata da mantenere"
msgstr "A · candidata da mantenere"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:169
msgid "A (PEC):"
msgstr "A (PEC):"

#: src/features/automations/components/CreateAutomationDialog.tsx:209
msgid "A cosa serve questa automazione"
msgstr "A cosa serve questa automazione"

#: src/features/agent-modes/components/AgentModeEditor.tsx:340
msgid "A cosa serve questo modo"
msgstr "A cosa serve questo modo"

#: src/features/connect/components/CreateSpaceDialog.tsx:158
msgid "A cosa serve questo spazio?"
msgstr "A cosa serve questo spazio?"

#: src/features/templates/components/CreateTemplateDialog.tsx:159
msgid "A cosa serve questo template? Quando va usato?"
msgstr "A cosa serve questo template? Quando va usato?"

#: src/features/sales/components/TemplateManager.tsx:32
#: src/features/sales/components/TemplateManager.tsx:38
msgid "A freddo"
msgstr "A freddo"

#: src/routes/_authed/workspace/flows.index.tsx:77
msgid "A intervalli"
msgstr "A intervalli"

#: src/features/console/pages/FlowsPage.tsx:118
msgid "A intervallo"
msgstr "A intervallo"

#: src/features/account/components/UserMenuButton.tsx:281
#: src/features/console/components/ConsoleShell.tsx:474
msgid "A presto"
msgstr "A presto"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:297
msgid "A:"
msgstr "A:"

#: src/features/sources/components/EmailThreadMessages.tsx:284
msgid "A: "
msgstr "A: "

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:306
msgid "A/B esperimenti attivi"
msgstr "A/B esperimenti attivi"

#: src/features/templates/components/TemplateFieldSpecs.ts:129
msgid "A4 orizzontale"
msgstr "A4 orizzontale"

#: src/features/templates/components/TemplateFieldSpecs.ts:128
msgid "A4 verticale"
msgstr "A4 verticale"

#: src/features/settings/components/SecuritySettings.tsx:168
msgid "Abilita un'app di autenticazione (Google Authenticator, 1Password, …) come secondo fattore di accesso."
msgstr "Abilita un'app di autenticazione (Google Authenticator, 1Password, …) come secondo fattore di accesso."

#: src/features/auth/desktop/DesktopLoginForm.tsx:781
msgid "Accedi"
msgstr "Accedi"

#: src/routes/login.tsx:164
msgid "Accedi al tuo workspace Ando"
msgstr "Accedi al tuo workspace Ando"

#: src/features/settings/components/BrandKitSettings.tsx:78
msgid "Accento"
msgstr "Accento"

#: src/features/settings/components/BrandKitSettings.tsx:79
msgid "Accento scuro"
msgstr "Accento scuro"

#: src/features/settings/components/BrandKitSettings.tsx:80
msgid "Accento tenue"
msgstr "Accento tenue"

#: src/features/admin/components/AdminDemoInviti.tsx:235
#: src/features/console/pages/AccessOverviewPage.tsx:127
msgid "Accessi"
msgstr "Accessi"

#. js-lingui-explicit-id
#: src/features/console/components/ConsoleShell.tsx:215
msgid "console.resourceAccessNav"
msgstr "Accessi"

#: src/features/admin/components/AdminOrgs.tsx:1400
#: src/features/admin/components/AdminOrgs.tsx:1408
#: src/features/admin/components/orgs/AddMemberDialog.tsx:221
#: src/features/admin/components/orgs/AddMemberDialog.tsx:232
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:252
#: src/features/console/pages/AccessOverviewPage.tsx:303
#: src/features/console/pages/DocumentsPage.tsx:774
#: src/features/console/pages/DocumentsPage.tsx:848
msgid "Accesso"
msgstr "Accesso"

#. placeholder {0}: mc.display_name
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:439
msgid "Accesso a {0}"
msgstr "Accesso a {0}"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:242
msgid "Accesso a Workspace, Console e API. Il ruolo gestisce i permessi, non i prodotti disponibili."
msgstr "Accesso a Workspace, Console e API. Il ruolo gestisce i permessi, non i prodotti disponibili."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:288
#: src/features/console/pages/ResourceAccessPage.tsx:938
msgid "Accesso aggiornato"
msgstr "Accesso aggiornato"

#: src/features/console/pages/ResourceAccessPage.tsx:230
msgid "Accesso al documento"
msgstr "Accesso al documento"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:36
msgid "Accesso al progetto"
msgstr "Accesso al progetto"

#: src/features/console/pages/ConnectorsPage.tsx:451
#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Accesso al servizio"
msgstr "Accesso al servizio"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:246
msgid "Accesso all'app Ando per il lavoro quotidiano."
msgstr "Accesso all'app Ando per il lavoro quotidiano."

#: src/features/console/connectors/ConnectionAccessSummary.tsx:76
#: src/features/console/pages/ResourceAccessPage.tsx:231
msgid "Accesso alla connessione"
msgstr "Accesso alla connessione"

#: src/features/console/pages/KeyDetailPage.tsx:361
msgid "Accesso alle risorse"
msgstr "Accesso alle risorse"

#: src/features/console/pages/ResourceAccessPage.tsx:333
msgid "Accesso attuale"
msgstr "Accesso attuale"

#. placeholder {0}: credential.email
#: src/routes/connect.space.$spaceId.tsx:131
msgid "Accesso come {0}"
msgstr "Accesso come {0}"

#: src/features/console/pages/PlaygroundPage.tsx:466
msgid "Accesso completo a tutte le risorse"
msgstr "Accesso completo a tutte le risorse"

#: src/features/console/pages/KeyDetailPage.tsx:380
msgid "Accesso completo: la chiave può leggere tutte le risorse dell'organizzazione."
msgstr "Accesso completo: la chiave può leggere tutte le risorse dell'organizzazione."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:216
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:233
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:278
msgid "Accesso connector"
msgstr "Accesso connector"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:406
msgid "Accesso connector per membro"
msgstr "Accesso connector per membro"

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:135
msgid "Accesso console"
msgstr "Accesso console"

#: src/features/connectors/wizards/filesystemSpec.tsx:127
#: src/features/connectors/wizards/legalStorageSpec.tsx:69
msgid "Accesso controllato"
msgstr "Accesso controllato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:355
msgid "Accesso degli utenti"
msgstr "Accesso degli utenti"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:29
msgid "Accesso delegato al cassetto fiscale Agenzia delle Entrate"
msgstr "Accesso delegato al cassetto fiscale Agenzia delle Entrate"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:398
msgid "Accesso gestito da Ando"
msgstr "Accesso gestito da Ando"

#: src/features/connect/components/ConnectPublicShell.tsx:143
#: src/features/connect/components/SpaceScopeBanner.tsx:164
#: src/routes/_authed/workspace/connect.$spaceId.tsx:420
msgid "Accesso in sola lettura"
msgstr "Accesso in sola lettura"

#: src/routes/connect.invite.$token.tsx:170
msgid "Accesso in sola lettura · solo le fonti condivise"
msgstr "Accesso in sola lettura · solo le fonti condivise"

#: src/features/console/connectors/meta.ts:51
msgid "Accesso in sola lettura: nessuna modifica ai contenuti originali"
msgstr "Accesso in sola lettura: nessuna modifica ai contenuti originali"

#: src/routes/public.voice-report.$token.tsx:311
msgid "Accesso non autorizzato"
msgstr "Accesso non autorizzato"

#: src/features/console/pages/ResourceAccessPage.tsx:697
msgid "Accesso non più attivo"
msgstr "Accesso non più attivo"

#: src/routes/connect.space.$spaceId.tsx:153
msgid "Accesso ospite in sola lettura · solo le fonti condivise con te"
msgstr "Accesso ospite in sola lettura · solo le fonti condivise con te"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:413
msgid "Accesso per membro"
msgstr "Accesso per membro"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:38
#: src/features/console/pages/AccessOverviewPage.tsx:328
#: src/features/console/pages/DocumentsPage.tsx:831
#: src/features/console/pages/ResourceAccessPage.tsx:223
msgid "Accesso precedente"
msgstr "Accesso precedente"

#: src/features/connect/components/MemberManager.tsx:80
msgid "Accesso revocato"
msgstr "Accesso revocato"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:245
msgid "Accesso tecnico alla Console di configurazione e alle API."
msgstr "Accesso tecnico alla Console di configurazione e alle API."

#: ../../packages/ui/src/editors/AiCellPopover.tsx:159
#: ../../packages/ui/src/editors/AiTextPopover.tsx:384
#: ../../packages/ui/src/editors/ReviewRail.tsx:303
#: src/features/admin/components/deckEditor/DeckEditor.tsx:513
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2714
#: src/features/sources/components/AISummaryPanel.tsx:634
msgid "Accetta"
msgstr "Accetta"

#: src/routes/connect.invite.$token.tsx:163
msgid "Accetta e apri lo spazio"
msgstr "Accetta e apri lo spazio"

#: ../../packages/ui/src/ando/actions/InlineDiffPreview.tsx:247
#: ../../packages/ui/src/editors/ReviewRail.tsx:412
#: src/features/sources/components/AISummaryPanel.tsx:790
msgid "Accetta modifica"
msgstr "Accetta modifica"

#: src/features/sales/components/crm/SuggestionsStrip.tsx:144
msgid "Accetta suggerimento"
msgstr "Accetta suggerimento"

#: ../../packages/ui/src/editors/ReviewRail.tsx:292
#: ../../packages/ui/src/editors/ReviewRail.tsx:293
#: src/features/sources/components/AISummaryPanel.tsx:551
msgid "Accetta tutte"
msgstr "Accetta tutte"

#: src/features/sales/components/crm/SuggestionsStrip.tsx:99
msgid "Accetta tutti"
msgstr "Accetta tutti"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2734
msgid "Accetta tutto"
msgstr "Accetta tutto"

#: src/routes/connect.invite.$token.tsx:131
msgid "Accettando potrai fare domande allo spazio. Ando risponde solo dalle fonti condivise con te — niente di più."
msgstr "Accettando potrai fare domande allo spazio. Ando risponde solo dalle fonti condivise con te — niente di più."

#: src/features/sources/components/AISummaryPanel.tsx:608
msgid "Accettare tutte le {count} modifiche?"
msgstr "Accettare tutte le {count} modifiche?"

#: ../../packages/ui/src/editors/ReviewRail.tsx:388
msgid "Accettata"
msgstr "Accettata"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:97
msgid "acciaio, inox, …"
msgstr "acciaio, inox, …"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:66
msgid "Accorcia mantenendo le informazioni essenziali."
msgstr "Accorcia mantenendo le informazioni essenziali."

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:341
#: src/features/account/components/UserMenuButton.tsx:374
#: src/features/chat/components/ConversationMiniRail.tsx:306
#: src/features/connectors/wizards/emailSpec.tsx:118
msgid "Account"
msgstr "Account"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:125
msgid "Account {providerLabel}"
msgstr "Account {providerLabel}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Account autorizzato"
msgstr "Account autorizzato"

#: src/features/console/connectors/meta.ts:273
msgid "Account aziendale"
msgstr "Account aziendale"

#: src/features/console/pages/ModelsPage.tsx:78
msgid "Account cliente attivo"
msgstr "Account cliente attivo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:306
#: src/features/console/pages/EmbeddedIdentityPage.tsx:307
msgid "Account collegati"
msgstr "Account collegati"

#: src/features/console/pages/PlaygroundPage.tsx:1993
msgid "Account collegato"
msgstr "Account collegato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Account da ricollegare"
msgstr "Account da ricollegare"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
msgid "Account da ricollegare o con errori di sincronizzazione"
msgstr "Account da ricollegare o con errori di sincronizzazione"

#: src/features/sales/components/BatchSendModal.tsx:232
#: src/features/sales/components/BatchSendModal.tsx:256
msgid "Account di invio"
msgstr "Account di invio"

#: src/features/console/components/ModelPickerModal.tsx:375
#: src/features/console/components/ProviderAccounts.tsx:214
msgid "Account di servizio delegato"
msgstr "Account di servizio delegato"

#: src/routes/_authed/_modal/integrations/$capability.tsx:630
msgid "Account disconnesso"
msgstr "Account disconnesso"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:279
msgid "Account email"
msgstr "Account email"

#: src/routes/_authed/_modal/integrations/$capability.tsx:982
msgid "Account email senza indirizzo — riconnetti l'account."
msgstr "Account email senza indirizzo — riconnetti l'account."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:312
msgid "Account non identificato"
msgstr "Account non identificato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:308
msgid "Account non trovato o non più disponibile."
msgstr "Account non trovato o non più disponibile."

#: src/features/console/connectors/meta.ts:278
msgid "Account operations"
msgstr "Account operations"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:53
msgid "Account: {connectionKey}"
msgstr "Account: {connectionKey}"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:425
msgid "Accredito in pochi secondi (SCT Inst)"
msgstr "Accredito in pochi secondi (SCT Inst)"

#: src/features/clean-control/utils/labels.ts:88
msgid "Accur."
msgstr "Accur."

#: src/features/clean-control/utils/labels.ts:74
msgid "Accuratezza"
msgstr "Accuratezza"

#: src/features/chat/components/ChatEmptyState.tsx:281
msgid "Achievement settimana"
msgstr "Achievement settimana"

#: src/features/connectors/wizards/legalStorageSpec.tsx:70
msgid "ACL granulari, audit log esportabile."
msgstr "ACL granulari, audit log esportabile."

#: src/features/console/connectors/SourceHealthSummary.tsx:19
msgid "Acquisizione"
msgstr "Acquisizione"

#: src/features/billing/components/CreditBalanceCard.tsx:162
msgid "Acquista crediti"
msgstr "Acquista crediti"

#. placeholder {0}: balanceQ.data.lifetime_purchased.toLocaleString()
#. placeholder {1}: balanceQ.data.lifetime_used.toLocaleString()
#: src/features/billing/components/CreditBalanceCard.tsx:99
msgid "Acquistati totali: {0} · usati: {1}"
msgstr "Acquistati totali: {0} · usati: {1}"

#: src/features/sources/components/ArtifactPane.tsx:2353
msgid "Action items"
msgstr "Action items"

#: src/features/console/docs/content.ts:1045
msgid "Actions (system of action)"
msgstr "Actions (system of action)"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:594
msgid "Active Directory"
msgstr "Active Directory"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:409
msgid "Adatta"
msgstr "Adatta"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:132
#: ../../packages/ui/src/editors/ImageViewerInline.tsx:133
#: src/features/admin/components/deckEditor/DeckEditor.tsx:410
msgid "Adatta alla finestra"
msgstr "Adatta alla finestra"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:356
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:357
msgid "Adatta alla larghezza"
msgstr "Adatta alla larghezza"

#: src/features/help/components/ShortcutsList.tsx:152
msgid "Adatta larghezza nel viewer PDF"
msgstr "Adatta larghezza nel viewer PDF"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:304
#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:305
#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:309
#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:310
msgid "Adatta vista"
msgstr "Adatta vista"

#: src/features/console/pages/BillingPage.tsx:396
msgid "Addebito automatico sulla carta"
msgstr "Addebito automatico sulla carta"

#: src/routes/_authed/workspace/finance.tsx:554
msgid "Adeguati Assetti · Codice Crisi"
msgstr "Adeguati Assetti · Codice Crisi"

#: src/features/automations/components/formatters.ts:58
msgid "Adesso"
msgstr "Adesso"

#: src/features/account/components/UserMenuButton.tsx:478
#: src/features/admin/components/AdminOrgs.tsx:1393
#: src/features/admin/components/orgs/AddMemberDialog.tsx:211
#: src/features/admin/components/orgs/OrgMembersTab.tsx:457
#: src/features/admin/components/userAdminActions.tsx:83
#: src/routes/_authed/_modal/admin/route.tsx:208
msgid "Admin"
msgstr "Admin"

#: src/features/settings/components/OrgMembersPanel.tsx:555
msgid "Admin — gestisce membri e branding"
msgstr "Admin — gestisce membri e branding"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:301
msgid "Admin · Organizzazione"
msgstr "Admin · Organizzazione"

#: src/features/account/components/UserMenuButton.tsx:479
msgid "Admin · panel"
msgstr "Admin · panel"

#: src/features/admin/components/AdminEngagement.tsx:94
msgid "Admin engagement dashboard"
msgstr "Admin engagement dashboard"

#: src/features/admin/components/AdminOverview.tsx:68
msgid "Admin overview con KPI principali"
msgstr "Admin overview con KPI principali"

#: src/features/admin/components/AdminEngagement.tsx:260
msgid "Adozione feature (% utenti attivi)"
msgstr "Adozione feature (% utenti attivi)"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1382
#: ../../packages/ui/src/ando/SqlConfidenceBadge.tsx:49
msgid "Affidabilità alta"
msgstr "Affidabilità alta"

#: ../../packages/ui/src/ando/EditableTable.tsx:348
#: ../../packages/ui/src/ando/EditableTable.tsx:349
#: ../../packages/ui/src/ando/SqlConfidenceBadge.tsx:51
msgid "Affidabilità bassa"
msgstr "Affidabilità bassa"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1384
msgid "Affidabilità da verificare"
msgstr "Affidabilità da verificare"

#: ../../packages/ui/src/ando/SqlConfidenceBadge.tsx:50
msgid "Affidabilità media"
msgstr "Affidabilità media"

#: src/features/admin/components/AdminCpqAskAndo.tsx:364
msgid "Affina"
msgstr "Affina"

#: src/features/sales/components/LeadDetailDrawer.tsx:161
#: src/features/sales/components/LeadsPanel.tsx:395
msgid "Affinità"
msgstr "Affinità"

#. placeholder {0}: Math.round(n)
#: src/features/sales/components/ScorePill.tsx:82
msgid "Affinità {0} su 100"
msgstr "Affinità {0} su 100"

#: src/features/chat/hooks/useThinkingHops.ts:57
msgid "Affino la ricerca"
msgstr "Affino la ricerca"

#: src/features/chat/wsHandlers.ts:488
msgid "Affino la ricerca…"
msgstr "Affino la ricerca…"

#: src/features/console/pages/ModelsPage.tsx:229
msgid "Agente Engine"
msgstr "Agente Engine"

#: src/features/admin/components/AdminPlatformSettings.tsx:915
msgid "Agente principale"
msgstr "Agente principale"

#: src/features/workspace/config.ts:416
msgid "Agenti AI"
msgstr "Agenti AI"

#: src/features/console/docs/content.ts:382
msgid "Agentic answer"
msgstr "Agentic answer"

#: src/features/console/docs/content.ts:202
msgid "agentic_answer esegue l'intero loop Ando/TRAMA: escalation T1→T2→T3 e, sulle sources strutturate pubblicate, text-to-SQL. Read-only per costruzione. Restringere a un connettore rende la corsa più affidabile (profondità invece di ampiezza)."
msgstr "agentic_answer esegue l'intero loop Ando/TRAMA: escalation T1→T2→T3 e, sulle sources strutturate pubblicate, text-to-SQL. Read-only per costruzione. Restringere a un connettore rende la corsa più affidabile (profondità invece di ampiezza)."

#: src/features/console/pages/PlaygroundPage.tsx:1850
msgid "Agentico · TRAMA attuale"
msgstr "Agentico · TRAMA attuale"

#: src/features/console/pages/PlaygroundPage.tsx:1851
msgid "Agentico · TRAMA Lakehouse"
msgstr "Agentico · TRAMA Lakehouse"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:349
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:463
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:208
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:390
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:648
#: src/features/admin/components/orgs/OrgBillingTab.tsx:383
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:182
#: src/features/automations/components/AutomationsHub.tsx:170
#: src/features/console/pages/EmbeddedIdentityPage.tsx:601
#: src/features/console/pages/TracesPage.tsx:323
#: src/features/dashboard/components/DashboardChartCard.tsx:774
#: src/features/sales/components/LeadsPanel.tsx:331
#: src/features/structured-data/components/TemporalQueryControl.tsx:344
#: src/features/sync/components/DocSyncManager.tsx:781
#: src/features/updates/components/UpdateBanner.tsx:186
#: src/routes/_authed/workspace/finance.tsx:368
msgid "Aggiorna"
msgstr "Aggiorna"

#: src/features/console/docs/content.ts:659
msgid "Aggiorna / riattiva / ruota il secret"
msgstr "Aggiorna / riattiva / ruota il secret"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:622
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:581
msgid "Aggiorna anteprima"
msgstr "Aggiorna anteprima"

#: src/features/briefing/BriefAggregate.tsx:185
msgid "Aggiorna briefing"
msgstr "Aggiorna briefing"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:100
msgid "Aggiorna cella"
msgstr "Aggiorna cella"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:346
msgid "Aggiorna coda"
msgstr "Aggiorna coda"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:108
msgid "Aggiorna contenuto slide"
msgstr "Aggiorna contenuto slide"

#: src/features/console/components/ProviderAccounts.tsx:143
msgid "Aggiorna credenziale"
msgstr "Aggiorna credenziale"

#: src/routes/_authed/workspace/finance.tsx:361
msgid "Aggiorna dati"
msgstr "Aggiorna dati"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:298
msgid "Aggiorna deck"
msgstr "Aggiorna deck"

#: src/features/console/pages/TracesPage.tsx:501
msgid "Aggiorna elenco"
msgstr "Aggiorna elenco"

#: src/features/dashboard/components/DashboardChartCard.tsx:773
msgid "Aggiorna grafico"
msgstr "Aggiorna grafico"

#: src/features/agent-modes/components/AgentModeEditor.tsx:305
msgid "Aggiorna identità, scope e capacità. Le modifiche al prompt creano una nuova versione."
msgstr "Aggiorna identità, scope e capacità. Le modifiche al prompt creano una nuova versione."

#: src/features/console/pages/MembersPage.tsx:335
msgid "Aggiorna il ruolo di «{label}»."
msgstr "Aggiorna il ruolo di «{label}»."

#: src/features/automations/components/AutomationsHub.tsx:163
msgid "Aggiorna la lista"
msgstr "Aggiorna la lista"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:645
msgid "Aggiorna lista"
msgstr "Aggiorna lista"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:460
msgid "Aggiorna log"
msgstr "Aggiorna log"

#: src/features/settings/components/SecuritySettings.tsx:129
msgid "Aggiorna password"
msgstr "Aggiorna password"

#: src/features/console/components/TopupReturnStatus.tsx:104
msgid "Aggiorna saldo"
msgstr "Aggiorna saldo"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:78
#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:80
msgid "Aggiorna stato"
msgstr "Aggiorna stato"

#: src/features/console/connectors/ConnectionCard.tsx:384
msgid "Aggiorna struttura"
msgstr "Aggiorna struttura"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:285
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:286
msgid "Aggiorna struttura cartelle"
msgstr "Aggiorna struttura cartelle"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:107
msgid "Aggiorna titolo slide"
msgstr "Aggiorna titolo slide"

#: src/features/dashboard/components/DashboardToolbar.tsx:133
msgid "Aggiorna tutti i widget"
msgstr "Aggiorna tutti i widget"

#: src/features/dashboard/components/DashboardToolbar.tsx:134
msgid "Aggiorna tutto"
msgstr "Aggiorna tutto"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:376
msgid "Aggiorna utilizzo e fatture"
msgstr "Aggiorna utilizzo e fatture"

#: src/features/clean-control/utils/signalCatalog.ts:139
msgid "Aggiorna versione"
msgstr "Aggiorna versione"

#: src/features/canvases/components/CanvasStatusChip.tsx:31
msgid "Aggiornabile"
msgstr "Aggiornabile"

#: src/features/connectors/wizards/databaseSpec.tsx:257
msgid "Aggiornamenti incrementali"
msgstr "Aggiornamenti incrementali"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:196
msgid "Aggiornamenti via Drive sync"
msgstr "Aggiornamenti via Drive sync"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:350
msgid "Aggiornamento automatico"
msgstr "Aggiornamento automatico"

#: src/features/updates/components/UpdateBanner.tsx:114
msgid "Aggiornamento disponibile"
msgstr "Aggiornamento disponibile"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:197
msgid "Aggiornamento fallito"
msgstr "Aggiornamento fallito"

#: src/features/admin/components/AdminDemoInviti.tsx:143
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:95
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:196
#: src/features/sales/components/AssigneePicker.tsx:59
#: src/features/sales/components/CampaignSharing.tsx:159
#: src/features/sales/components/CampaignSharing.tsx:265
#: src/features/sales/components/FollowUpControl.tsx:59
#: src/features/sales/components/LeadInlineControls.tsx:66
#: src/features/sales/components/LeadInlineControls.tsx:124
msgid "Aggiornamento non riuscito"
msgstr "Aggiornamento non riuscito"

#: src/features/admin/components/AdminPlatformSettings.tsx:449
msgid "Aggiornamento piano fallito"
msgstr "Aggiornamento piano fallito"

#: src/features/updates/components/UpdateBanner.tsx:164
msgid "Aggiornamento pronto — riavvia per applicarlo"
msgstr "Aggiornamento pronto — riavvia per applicarlo"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:161
#: src/features/settings/components/OrgMembersPanel.tsx:234
msgid "Aggiornamento ruolo fallito"
msgstr "Aggiornamento ruolo fallito"

#: src/features/admin/components/AdminUsers.tsx:204
msgid "aggiornamento…"
msgstr "aggiornamento…"

#: src/features/sync/components/DocSyncManager.tsx:781
msgid "Aggiornamento…"
msgstr "Aggiornamento…"

#: src/features/templates/components/TemplatePreview.tsx:85
msgid "Aggiornando…"
msgstr "Aggiornando…"

#: src/routes/_authed/workspace/dashboard.tsx:896
msgid "aggiornata {updated}"
msgstr "aggiornata {updated}"

#: src/features/skills/components/SkillsList.tsx:397
msgid "Aggiornata {updatedLabel}"
msgstr "Aggiornata {updatedLabel}"

#: src/features/console/pages/FlowDetailPage.tsx:219
msgid "Aggiornato"
msgstr "Aggiornato"

#. placeholder {0}: formatRelative(generatedAt)
#: src/features/briefing/BriefAggregate.tsx:178
msgid "Aggiornato {0}"
msgstr "Aggiornato {0}"

#. placeholder {0}: formatAsOf(data?.as_of)
#. placeholder {1}: Math.round((completeness?.coverage_pct ?? 0) * 100)
#: src/routes/_authed/workspace/finance.tsx:292
msgid "Aggiornato {0} · copertura {1}%"
msgstr "Aggiornato {0} · copertura {1}%"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:288
msgid "Aggiornato {lastSync} · prossima sync automatica entro 4 ore."
msgstr "Aggiornato {lastSync} · prossima sync automatica entro 4 ore."

#: src/features/workspace/finance/components/BankAccountsList.tsx:132
msgid "Aggiornato {lastSynced}"
msgstr "Aggiornato {lastSynced}"

#: src/features/admin/components/MaintenanceControl.tsx:227
msgid "Aggiorniamo Ando per renderlo più veloce…"
msgstr "Aggiorniamo Ando per renderlo più veloce…"

#: src/features/console/pages/DevelopersPage.tsx:128
msgid "Aggiunge Ando come server MCP alla CLI di Claude Code."
msgstr "Aggiunge Ando come server MCP alla CLI di Claude Code."

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:789
msgid "Aggiunge illustrazioni AI brand-coerenti al deck. Aumenta il tempo di compilazione di ~30s e il costo di ~$0.05."
msgstr "Aggiunge illustrazioni AI brand-coerenti al deck. Aumenta il tempo di compilazione di ~30s e il costo di ~$0.05."

#: src/features/projects/components/sections/KnowledgeSection.tsx:221
msgid "Aggiungere nuove fonti? Apri una chat del progetto e usa il picker del composer: il progetto promuoverà le scelte come default nella prossima conversazione."
msgstr "Aggiungere nuove fonti? Apri una chat del progetto e usa il picker del composer: il progetto promuoverà le scelte come default nella prossima conversazione."

#: src/features/admin/components/AdminCpq.tsx:648
#: src/features/admin/components/AdminOrgs.tsx:1434
#: src/features/admin/components/AdminPlatformSettings.tsx:197
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1028
#: src/features/admin/components/orgs/AddMemberDialog.tsx:264
#: src/features/console/pages/ResourceAccessPage.tsx:754
#: src/features/console/pages/ResourceAccessPage.tsx:887
#: src/features/projects/components/sections/TasksSection.tsx:251
#: src/features/sales/components/CampaignSharing.tsx:178
#: src/features/sales/components/SuppressionPanel.tsx:90
#: src/features/sync/components/DocSyncManager.tsx:601
#: src/features/sync/components/DocSyncManager.tsx:1487
#: src/features/workspace/components/QuickAddMenu/QuickAddMenu.tsx:226
#: src/features/workspace/components/TaskComposer.tsx:270
#: src/features/workspace/finance/components/ConnectionsPanel.tsx:74
msgid "Aggiungi"
msgstr "Aggiungi"

#. placeholder {0}: block.label
#. placeholder {0}: selected.size
#. placeholder {0}: table.label
#: src/features/hive-flows/run/ProposalReview.tsx:589
#: src/features/hive-flows/run/ProposalReview.tsx:716
#: src/features/sync/components/picker/NotionPickerModal.tsx:197
msgid "Aggiungi {0}"
msgstr "Aggiungi {0}"

#. placeholder {0}: selected.size
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:415
msgid "Aggiungi {0} · ~{selectedFileCount} file"
msgstr "Aggiungi {0} · ~{selectedFileCount} file"

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:411
msgid "Aggiungi {trimmedDraft}"
msgstr "Aggiungi {trimmedDraft}"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:446
msgid "Aggiungi <0>{trimmedDraft}</0>"
msgstr "Aggiungi <0>{trimmedDraft}</0>"

#: src/features/settings/components/OtpEmailPanel.tsx:247
msgid "Aggiungi 2FA via email"
msgstr "Aggiungi 2FA via email"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:416
msgid "Aggiungi al grafico"
msgstr "Aggiungi al grafico"

#: src/features/dashboard/components/ShareChartSheet.tsx:333
#: src/features/dashboard/components/ShareDashboardSheet.tsx:320
msgid "Aggiungi al team"
msgstr "Aggiungi al team"

#: src/features/hive-flows/components/FlowFormPublish.tsx:81
msgid "Aggiungi almeno un campo"
msgstr "Aggiungi almeno un campo"

#: src/features/admin/components/AdminCpq.tsx:406
msgid "Aggiungi almeno un indirizzo email autorizzato"
msgstr "Aggiungi almeno un indirizzo email autorizzato"

#: src/features/dashboard/components/DashboardToolbar.tsx:117
msgid "Aggiungi almeno un widget per condividere"
msgstr "Aggiungi almeno un widget per condividere"

#: src/features/connect/components/GuestPreviewDialog.tsx:72
msgid "Aggiungi almeno una fonte: senza condivisioni l'ospite non può interrogare nulla."
msgstr "Aggiungi almeno una fonte: senza condivisioni l'ospite non può interrogare nulla."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
msgid "Aggiungi altro"
msgstr "Aggiungi altro"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:421
msgid "Aggiungi CAD (DXF/STEP)"
msgstr "Aggiungi CAD (DXF/STEP)"

#: src/features/hive-flows/components/FlowFormPublish.tsx:198
msgid "Aggiungi campo"
msgstr "Aggiungi campo"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:231
msgid "Aggiungi cartelle da Google Drive"
msgstr "Aggiungi cartelle da Google Drive"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:223
msgid "Aggiungi cartelle da OneDrive"
msgstr "Aggiungi cartelle da OneDrive"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:227
msgid "Aggiungi cartelle da SharePoint"
msgstr "Aggiungi cartelle da SharePoint"

#: src/features/sync/components/DocSyncManager.tsx:1474
msgid "Aggiungi cartelle o file dal tuo drive per iniziare a sincronizzare."
msgstr "Aggiungi cartelle o file dal tuo drive per iniziare a sincronizzare."

#: src/features/sales/components/CampaignSharing.tsx:182
msgid "Aggiungi collaboratore"
msgstr "Aggiungi collaboratore"

#: src/features/connect/components/MemberManager.tsx:489
msgid "Aggiungi collega"
msgstr "Aggiungi collega"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1104
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1194
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2345
msgid "Aggiungi colonna"
msgstr "Aggiungi colonna"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:231
msgid "Aggiungi colonne derivate dai dati del grafico. Le formule sono applicate al volo prima del rendering."
msgstr "Aggiungi colonne derivate dai dati del grafico. Le formule sono applicate al volo prima del rendering."

#: src/features/console/pages/ConnectorDetailPage.tsx:243
msgid "Aggiungi connessione"
msgstr "Aggiungi connessione"

#: src/features/console/pages/EngineSignupPage.tsx:189
msgid "Aggiungi crediti"
msgstr "Aggiungi crediti"

#: src/features/console/pages/GetStartedPage.tsx:62
msgid "Aggiungi crediti, crea una AppKey e verifica la prima chiamata."
msgstr "Aggiungi crediti, crea una AppKey e verifica la prima chiamata."

#. placeholder {0}: label.name
#. placeholder {0}: vendorLabel(conn.vendor)
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:263
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:184
msgid "Aggiungi da {0}"
msgstr "Aggiungi da {0}"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:205
msgid "Aggiungi da {label}"
msgstr "Aggiungi da {label}"

#: src/features/sync/components/picker/NotionPickerModal.tsx:101
msgid "Aggiungi da Notion"
msgstr "Aggiungi da Notion"

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:206
msgid "Aggiungi destinatari"
msgstr "Aggiungi destinatari"

#: src/routes/_authed/workspace/documents.tsx:934
msgid "Aggiungi documenti"
msgstr "Aggiungi documenti"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:847
msgid "Aggiungi e premi Invio"
msgstr "Aggiungi e premi Invio"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:136
msgid "Aggiungi esempio"
msgstr "Aggiungi esempio"

#: src/features/sales/components/BatchSendModal.tsx:355
#: src/features/sales/components/BatchSendModal.tsx:389
#: src/features/sales/components/TemplateManager.tsx:298
#: src/features/sales/components/TemplateManager.tsx:301
msgid "Aggiungi firma"
msgstr "Aggiungi firma"

#: src/features/admin/components/AdminCpq.tsx:982
#: src/features/admin/components/AdminCpqPriceBook.tsx:364
#: src/features/projects/components/sections/KnowledgeSection.tsx:237
msgid "Aggiungi fonte"
msgstr "Aggiungi fonte"

#: src/features/projects/components/sections/KnowledgeSection.tsx:235
msgid "Aggiungi fonte (in arrivo)"
msgstr "Aggiungi fonte (in arrivo)"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:110
msgid "Aggiungi forma slide"
msgstr "Aggiungi forma slide"

#: src/features/skills/components/SkillEditor.tsx:404
msgid "Aggiungi frase"
msgstr "Aggiungi frase"

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:127
msgid "Aggiungi gli utenti del cliente"
msgstr "Aggiungi gli utenti del cliente"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:111
msgid "Aggiungi grafico slide"
msgstr "Aggiungi grafico slide"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:809
msgid "Aggiungi il template e i CSV anche in più passaggi. Il flow partirà solo quando premi “Controlla e avvia”."
msgstr "Aggiungi il template e i CSV anche in più passaggi. Il flow partirà solo quando premi “Controlla e avvia”."

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:96
msgid "Aggiungi immagine"
msgstr "Aggiungi immagine"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:103
msgid "Aggiungi immagine al foglio"
msgstr "Aggiungi immagine al foglio"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:109
msgid "Aggiungi immagine slide"
msgstr "Aggiungi immagine slide"

#: src/features/sales/components/CreateLeadDialog.tsx:231
msgid "Aggiungi lead"
msgstr "Aggiungi lead"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:349
msgid "Aggiungi luogo o link"
msgstr "Aggiungi luogo o link"

#: src/features/sales/components/CreateLeadDialog.tsx:96
msgid "Aggiungi manualmente un'azienda a una campagna."
msgstr "Aggiungi manualmente un'azienda a una campagna."

#: src/features/admin/components/AdminOrgs.tsx:911
#: src/features/admin/components/AdminOrgs.tsx:1353
msgid "Aggiungi member"
msgstr "Aggiungi member"

#: src/features/admin/components/AdminOrgs.tsx:1349
msgid "Aggiungi member alle org selezionate"
msgstr "Aggiungi member alle org selezionate"

#: src/features/console/pages/ResourceAccessPage.tsx:530
msgid "Aggiungi membri del team o utenti delle tue app."
msgstr "Aggiungi membri del team o utenti delle tue app."

#: src/features/console/pages/ResourceAccessPage.tsx:526
msgid "Aggiungi membri del team."
msgstr "Aggiungi membri del team."

#: src/features/admin/components/orgs/AddMemberDialog.tsx:150
#: src/features/admin/components/orgs/OrgDetailShell.tsx:338
msgid "Aggiungi membro"
msgstr "Aggiungi membro"

#: src/features/console/pages/BillingPage.tsx:364
msgid "Aggiungi metodo"
msgstr "Aggiungi metodo"

#: src/features/sales/components/ActivityTimeline.tsx:85
msgid "Aggiungi nota"
msgstr "Aggiungi nota"

#: src/features/sync/components/picker/NotionPickerModal.tsx:91
msgid "Aggiungi pagine da Notion"
msgstr "Aggiungi pagine da Notion"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:93
msgid "Aggiungi paragrafo"
msgstr "Aggiungi paragrafo"

#: src/features/admin/components/AdminCpqPriceBook.tsx:287
msgid "Aggiungi PoC"
msgstr "Aggiungi PoC"

#: src/features/hive-flows/components/ConditionBuilder.tsx:317
msgid "Aggiungi regola"
msgstr "Aggiungi regola"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:99
#: ../../packages/ui/src/ando/EditableTable.tsx:160
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1097
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1189
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2240
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2340
msgid "Aggiungi riga"
msgstr "Aggiungi riga"

#: src/features/connect/components/GrantManager.tsx:165
#: src/features/connect/components/GrantManager.tsx:314
msgid "Aggiungi risorsa"
msgstr "Aggiungi risorsa"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2241
msgid "Aggiungi serie"
msgstr "Aggiungi serie"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:142
msgid "Aggiungi sezione"
msgstr "Aggiungi sezione"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:105
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:457
#: src/features/admin/components/deckEditor/DeckEditor.tsx:656
msgid "Aggiungi slide"
msgstr "Aggiungi slide"

#: src/features/workspace/components/InboxItemRow.tsx:218
msgid "Aggiungi stella"
msgstr "Aggiungi stella"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:95
msgid "Aggiungi tabella"
msgstr "Aggiungi tabella"

#: src/features/admin/components/AdminCpqPriceBook.tsx:256
msgid "Aggiungi taglio"
msgstr "Aggiungi taglio"

#: src/routes/_authed/_modal/integrations/$capability.tsx:782
msgid "Aggiungi un altro account"
msgstr "Aggiungi un altro account"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:246
msgid "Aggiungi un altro provider"
msgstr "Aggiungi un altro provider"

#: src/features/connect/components/MemberManager.tsx:349
msgid "Aggiungi un collega della tua organizzazione: accede subito, in sola lettura, senza link da condividere."
msgstr "Aggiungi un collega della tua organizzazione: accede subito, in sola lettura, senza link da condividere."

#: src/features/settings/components/AccountDeletion.tsx:156
msgid "Aggiungi un commento per aiutarci a migliorare (max 500 caratteri)."
msgstr "Aggiungi un commento per aiutarci a migliorare (max 500 caratteri)."

#: src/features/chat/components/ChatEmptyState.tsx:307
msgid "Aggiungi un grafico"
msgstr "Aggiungi un grafico"

#: src/features/console/pages/ResourceAccessPage.tsx:719
msgid "Aggiungi un membro del team"
msgstr "Aggiungi un membro del team"

#: src/features/sources/components/InboxDetailPane.tsx:2204
msgid "Aggiungi un messaggio (opzionale)…"
msgstr "Aggiungi un messaggio (opzionale)…"

#: src/features/hive-flows/components/FlowActivateControl.tsx:218
msgid "Aggiungi un trigger non manuale (Pianificato, Webhook, o un evento) per poter attivare questo flow"
msgstr "Aggiungi un trigger non manuale (Pianificato, Webhook, o un evento) per poter attivare questo flow"

#. placeholder {0}: org.name
#: src/features/admin/components/orgs/AddMemberDialog.tsx:154
msgid "Aggiungi un utente a {0}. Se l'email non esiste viene inviato un invito."
msgstr "Aggiungi un utente a {0}. Se l'email non esiste viene inviato un invito."

#. placeholder {0}: selectedIds.size
#: src/features/admin/components/AdminOrgs.tsx:1356
msgid "Aggiungi un utente alle {0} organizzazioni selezionate. Le org dove l'utente esiste in un altro tenant richiederanno conferma manuale."
msgstr "Aggiungi un utente alle {0} organizzazioni selezionate. Le org dove l'utente esiste in un altro tenant richiederanno conferma manuale."

#: src/features/console/pages/ResourceAccessPage.tsx:768
msgid "Aggiungi un utente della tua app"
msgstr "Aggiungi un utente della tua app"

#: src/features/sales/components/SuppressionPanel.tsx:73
msgid "Aggiungi un'esclusione"
msgstr "Aggiungi un'esclusione"

#: src/features/sales/components/crm/CreateDealDialog.tsx:109
msgid "Aggiungi un'opportunità alla pipeline."
msgstr "Aggiungi un'opportunità alla pipeline."

#: src/features/console/pages/ConnectorDetailPage.tsx:425
msgid "Aggiungi una connessione per iniziare a indicizzare."
msgstr "Aggiungi una connessione per iniziare a indicizzare."

#: src/features/sales/components/ActivityTimeline.tsx:299
msgid "Aggiungi una nota o aggiorna il lead per iniziare la cronologia."
msgstr "Aggiungi una nota o aggiorna il lead per iniziare la cronologia."

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:177
msgid "Aggiungi una nota personale…"
msgstr "Aggiungi una nota personale…"

#: src/features/sales/components/ActivityTimeline.tsx:66
msgid "Aggiungi una nota su questo lead…"
msgstr "Aggiungi una nota su questo lead…"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:143
msgid "Aggiungi una nota…"
msgstr "Aggiungi una nota…"

#: src/features/dashboard/components/ShareChartSheet.tsx:281
#: src/features/dashboard/components/ShareDashboardSheet.tsx:268
msgid "Aggiungi una persona"
msgstr "Aggiungi una persona"

#: src/features/console/pages/ResourceAccessPage.tsx:528
msgid "Aggiungi utenti delle tue app."
msgstr "Aggiungi utenti delle tue app."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:378
msgid "Aggiungi videochiamata"
msgstr "Aggiungi videochiamata"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:97
msgid "Aggiungi voce lista"
msgstr "Aggiungi voce lista"

#: src/features/dashboard/components/AddChartDialog.tsx:420
#: src/features/dashboard/components/AddChartDialog.tsx:425
#: src/features/dashboard/components/AddWidgetWizard.tsx:286
#: src/features/dashboard/components/AddWidgetWizard.tsx:293
msgid "Aggiungi widget"
msgstr "Aggiungi widget"

#: src/features/dashboard/components/DashboardToolbar.tsx:149
msgid "Aggiungi widget alla dashboard"
msgstr "Aggiungi widget alla dashboard"

#: src/features/dashboard/components/ShareChartSheet.tsx:333
#: src/features/dashboard/components/ShareDashboardSheet.tsx:320
msgid "Aggiungo…"
msgstr "Aggiungo…"

#: src/features/admin/components/AdminOrgs.tsx:685
msgid "Aggiunta membro"
msgstr "Aggiunta membro"

#: src/features/sales/components/CampaignSharing.tsx:131
#: src/features/sales/components/SuppressionPanel.tsx:47
msgid "Aggiunta non riuscita"
msgstr "Aggiunta non riuscita"

#: src/features/sales/components/SuppressionPanel.tsx:90
msgid "Aggiunta…"
msgstr "Aggiunta…"

#: src/features/admin/components/AdminOrgs.tsx:679
msgid "Aggiunto a {ok} organizzazione/i."
msgstr "Aggiunto a {ok} organizzazione/i."

#: src/features/sales/components/SuppressionPanel.tsx:45
msgid "Aggiunto alla lista di esclusione"
msgstr "Aggiunto alla lista di esclusione"

#: src/features/projects/components/sections/MembersSection.tsx:201
msgid "Aggiunto il"
msgstr "Aggiunto il"

#: src/features/clean-control/components/SignalHealthCard.tsx:116
msgid "Aggiustamento confidenza"
msgstr "Aggiustamento confidenza"

#: src/features/admin/components/AdminRevenue.tsx:55
msgid "Aggregati locali dal subscription store. La Stripe API import è deferita — i valori sono allineati alla cadenza di facturation interna."
msgstr "Aggregati locali dal subscription store. La Stripe API import è deferita — i valori sono allineati alla cadenza di facturation interna."

#: src/features/admin/components/AdminCostTracking.tsx:227
msgid "Aggregati sull'intervallo selezionato vs periodo precedente"
msgstr "Aggregati sull'intervallo selezionato vs periodo precedente"

#: src/features/dashboard/utils/calculatedFields.ts:111
msgid "Aggregato"
msgstr "Aggregato"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:521
msgid "Aggregato (no PII) · Registro globale dei prompt · Ordine cronologico decrescente."
msgstr "Aggregato (no PII) · Registro globale dei prompt · Ordine cronologico decrescente."

#: src/features/hive-flows/components/nodeVisuals.tsx:48
msgid "AI"
msgstr "AI"

#: src/features/sources/components/AISummaryPanel.tsx:678
msgid "AI · Eliminazione"
msgstr "AI · Eliminazione"

#: src/features/sources/components/AISummaryPanel.tsx:677
msgid "AI · Inserimento"
msgstr "AI · Inserimento"

#: src/features/sources/components/AISummaryPanel.tsx:679
msgid "AI · Modifica"
msgstr "AI · Modifica"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:259
#: src/features/connectors/components/management/BusinessContextEditor.tsx:140
msgid "AI generato"
msgstr "AI generato"

#: src/routes/_authed/workspace/dashboard.tsx:463
msgid "AI-generated"
msgstr "AI-generated"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:920
msgid "AI-ready"
msgstr "AI-ready"

#: src/features/chat/components/ChatEmptyState.tsx:374
msgid "Aiutami a creare un flow visuale che automatizzi un processo ricorrente."
msgstr "Aiutami a creare un flow visuale che automatizzi un processo ricorrente."

#: src/features/chat/components/ChatEmptyState.tsx:354
msgid "Aiutami a creare un nuovo workflow di automazione."
msgstr "Aiutami a creare un nuovo workflow di automazione."

#. js-lingui-explicit-id
#: src/features/hive-flows/run/ScopedChatPanel.tsx:65
msgid "flow.run.chat.seed"
msgstr "Aiutami a rivedere questa proposta del flow."

#: src/features/chat/components/ChatEmptyState.tsx:308
msgid "Aiutami ad aggiungere un grafico a una dashboard esistente."
msgstr "Aiutami ad aggiungere un grafico a una dashboard esistente."

#: src/routes/_authed/_modal/settings/changelog.tsx:43
#: src/routes/_authed/_modal/settings/help.tsx:35
#: src/routes/_authed/_modal/settings/shortcuts.tsx:26
msgid "Aiuto"
msgstr "Aiuto"

#: src/features/onboarding/OnboardingSettings.tsx:27
msgid "Aiuto e onboarding"
msgstr "Aiuto e onboarding"

#: src/features/console/connectors/PersonalConnectionSync.tsx:234
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:351
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:448
msgid "Al"
msgstr "Al"

#: src/features/connect/components/ChatbotPanel.tsx:250
msgid "Al giorno"
msgstr "Al giorno"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2584
#: src/features/admin/components/PageEditor.tsx:123
msgid "Al massimo {MAX_SOURCES} documenti per volta"
msgstr "Al massimo {MAX_SOURCES} documenti per volta"

#: src/features/connect/components/ChatbotPanel.tsx:257
msgid "Al mese"
msgstr "Al mese"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:514
msgid "al mount."
msgstr "al mount."

#: src/features/dashboard/components/AxisConfigurator.tsx:355
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:241
msgid "Alcune colonne salvate non contengono valori numerici nei dati attuali. Puoi deselezionarle e scegliere una misura numerica."
msgstr "Alcune colonne salvate non contengono valori numerici nei dati attuali. Puoi deselezionarle e scegliere una misura numerica."

#: src/features/console/pages/ConnectorDetailPage.tsx:366
msgid "Alcuni dettagli non sono disponibili in questo momento: la vista è parziale."
msgstr "Alcuni dettagli non sono disponibili in questo momento: la vista è parziale."

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:384
msgid "Alcuni messaggi non sono stati aggiornati"
msgstr "Alcuni messaggi non sono stati aggiornati"

#: src/features/admin/components/PageEditor.tsx:222
#: src/features/admin/components/PageEditor.tsx:230
msgid "Allega documenti"
msgstr "Allega documenti"

#: src/features/admin/components/AdminDecks.tsx:416
#: src/features/admin/components/AdminDecks.tsx:433
msgid "Allega documento"
msgstr "Allega documento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2803
msgid "Allega un documento"
msgstr "Allega un documento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2804
msgid "Allega un documento (PDF, Word, PowerPoint, Excel, testo): Ando lo usa come fonte"
msgstr "Allega un documento (PDF, Word, PowerPoint, Excel, testo): Ando lo usa come fonte"

#: ../../packages/ui/src/ando/sources/email/EmailActions.tsx:39
#: src/features/chat/components/ChatTopBar.tsx:184
#: src/features/sources/components/EmailThreadMessages.tsx:974
msgid "Allegati"
msgstr "Allegati"

#: src/features/workspace/config.ts:380
msgid "Allegati email"
msgstr "Allegati email"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:126
msgid "Allegato in questa conversazione"
msgstr "Allegato in questa conversazione"

#: src/features/clean-control/utils/signalCatalog.ts:198
msgid "Allegato orfano (email senza file)"
msgstr "Allegato orfano (email senza file)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1240
msgid "Allinea a destra"
msgstr "Allinea a destra"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1238
msgid "Allinea a sinistra"
msgstr "Allinea a sinistra"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1953
msgid "Allinea alla slide"
msgstr "Allinea alla slide"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1241
msgid "Allinea in alto"
msgstr "Allinea in alto"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1243
msgid "Allinea in basso"
msgstr "Allinea in basso"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1259
msgid "Allinea tra loro"
msgstr "Allinea tra loro"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:993
msgid "alluminio, EN_46100, zama"
msgstr "alluminio, EN_46100, zama"

#: src/features/agent-modes/components/AgentModeEditor.tsx:489
msgid "Almeno {PROMPT_MIN_CHARS} caratteri."
msgstr "Almeno {PROMPT_MIN_CHARS} caratteri."

#: src/features/settings/marp/CssUploadPanel.tsx:49
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:44
msgid "Almeno {SLUG_MIN} caratteri"
msgstr "Almeno {SLUG_MIN} caratteri"

#: src/features/settings/components/SecuritySettings.tsx:115
msgid "Almeno 12 caratteri"
msgstr "Almeno 12 caratteri"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:811
msgid "Alone"
msgstr "Alone"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1626
msgid "Alt. %"
msgstr "Alt. %"

#: src/features/admin/components/AdminCpq.tsx:811
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:94
#: src/features/clean-control/components/EventQueue.tsx:86
#: src/features/report/components/ConfidenceMeter.tsx:129
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:40
#: src/features/workspace/components/TaskComposer.tsx:41
msgid "Alta"
msgstr "Alta"

#: src/features/clean-control/utils/labels.ts:47
msgid "ALTA"
msgstr "ALTA"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:402
#: src/features/price-lists/components/PriceListsPage.tsx:522
msgid "Alta confidence"
msgstr "Alta confidence"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1346
msgid "Alternativa al SID; opzionale."
msgstr "Alternativa al SID; opzionale."

#: src/features/admin/components/AdminCostTracking.tsx:374
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1947
#: src/features/console/lib/connectorActions.ts:30
msgid "Alto"
msgstr "Alto"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:347
#: src/features/connectors/components/ConnectedAccountRow.tsx:454
#: src/features/connectors/components/management/BusinessContextBanner.tsx:275
#: src/features/dashboard/components/ChartActionsMenu.tsx:144
#: src/features/workspace/components/TaskSimpleRow.tsx:292
msgid "Altre azioni"
msgstr "Altre azioni"

#: src/features/admin/components/AdminOrgs.tsx:929
msgid "Altre azioni di gruppo"
msgstr "Altre azioni di gruppo"

#. placeholder {0}: skill.name
#: src/features/skills/components/SkillsList.tsx:418
msgid "Altre azioni per «{0}»"
msgstr "Altre azioni per «{0}»"

#. placeholder {0}: flow.name
#: src/features/console/pages/FlowsPage.tsx:584
msgid "Altre azioni per {0}"
msgstr "Altre azioni per {0}"

#: src/features/clean-control/components/policies/PolicyRow.tsx:155
msgid "Altre azioni policy"
msgstr "Altre azioni policy"

#: ../../packages/ui/src/ando/email/SendControl.tsx:146
msgid "Altre opzioni di invio"
msgstr "Altre opzioni di invio"

#: src/features/console/pages/AccessOverviewPage.tsx:90
msgid "Altri servizi"
msgstr "Altri servizi"

#: src/features/console/pages/AccessOverviewPage.tsx:262
msgid "Altri servizi o account potrebbero trovarsi nelle pagine successive."
msgstr "Altri servizi o account potrebbero trovarsi nelle pagine successive."

#: ../../packages/ui/src/ando/RecipientsInput.tsx:518
#: src/features/settings/components/AccountDeletion.tsx:44
#: src/features/settings/components/SelfProfileMemory.tsx:84
#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:74
msgid "Altro"
msgstr "Altro"

#: src/features/admin/components/AdminCpqPriceBook.tsx:307
msgid "Ambiente aggiuntivo (EUR)"
msgstr "Ambiente aggiuntivo (EUR)"

#: src/features/admin/components/AdminCpqAskAndo.tsx:171
msgid "Ambienti"
msgstr "Ambienti"

#: src/features/admin/components/AdminCpq.tsx:744
msgid "Ambienti del cliente"
msgstr "Ambienti del cliente"

#: src/features/console/pages/ResourceAccessPage.tsx:570
msgid "Ambito"
msgstr "Ambito"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:74
msgid "Ambito attivo"
msgstr "Ambito attivo"

#: src/features/console/connectors/ConnectionCard.tsx:303
msgid "Ambito autorizzato"
msgstr "Ambito autorizzato"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:983
msgid "Ambito di applicazione"
msgstr "Ambito di applicazione"

#: src/features/connect/components/ConnectPublicShell.tsx:125
msgid "Ambito di condivisione"
msgstr "Ambito di condivisione"

#: src/features/connect/components/SpaceScopeBanner.tsx:141
msgid "Ambito di condivisione dello spazio"
msgstr "Ambito di condivisione dello spazio"

#: src/routes/_authed/workspace/sales.tsx:107
msgid "Ambito pipeline"
msgstr "Ambito pipeline"

#: src/features/console/pages/PlaygroundPage.tsx:615
msgid "Ambito predefinito: documenti e dati strutturati, senza restrizioni."
msgstr "Ambito predefinito: documenti e dati strutturati, senza restrizioni."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:557
msgid "Ambito:"
msgstr "Ambito:"

#: src/lib/roles.ts:17
msgid "Amministratore"
msgstr "Amministratore"

#: src/features/connectors/catalog.ts:229
#: src/features/workspace/config.ts:113
#: src/features/workspace/config.ts:115
msgid "Amministrazione"
msgstr "Amministrazione"

#: src/features/onboarding/ConnectorsIntro.tsx:52
msgid "Amministrazione & Finance"
msgstr "Amministrazione & Finance"

#: src/features/onboarding/demoTourSteps.ts:93
msgid "Amministrazione e dati strutturati"
msgstr "Amministrazione e dati strutturati"

#: src/features/admin/components/AdminEngagement.tsx:289
msgid "Ampiezza d'uso — feature per utente"
msgstr "Ampiezza d'uso — feature per utente"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:60
msgid "Anagrafica completa"
msgstr "Anagrafica completa"

#: src/features/connectors/wizards/erpSpec.tsx:183
msgid "Anagrafiche, ordini, scadenze e magazzino disponibili ad Ando in lettura."
msgstr "Anagrafiche, ordini, scadenze e magazzino disponibili ad Ando in lettura."

#: src/features/chat/hooks/useThinkingHops.ts:47
#: src/features/chat/hooks/useThinkingHops.ts:48
#: src/features/chat/hooks/useThinkingHops.ts:68
#: src/features/dashboard/components/DashboardViewControls.tsx:34
#: src/features/projects/components/ProjectIcon.tsx:68
#: src/features/workspace/config.ts:185
#: src/features/workspace/config.ts:187
msgid "Analisi"
msgstr "Analisi"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:234
#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:233
msgid "Analisi CAD"
msgstr "Analisi CAD"

#: src/features/sales/components/crm/RecordDrawer.tsx:347
msgid "Analisi di Ando"
msgstr "Analisi di Ando"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:108
#: src/features/dfm-rules/components/DfmRulesPage.tsx:223
#: src/features/price-lists/components/PriceListsPage.tsx:92
#: src/features/price-lists/components/PriceListsPage.tsx:204
msgid "Analisi fallita"
msgstr "Analisi fallita"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1495
msgid "Analisi in corso"
msgstr "Analisi in corso"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:834
msgid "Analisi in corso…"
msgstr "Analisi in corso…"

#: src/features/console/docs/content.ts:967
msgid "Analisi STEP/DXF"
msgstr "Analisi STEP/DXF"

#: src/features/console/docs/content.ts:959
msgid "Analisi STEP/DXF, check DFM e conversione profilo→solido. Tutte asincrone → 202 con job_id e result_id."
msgstr "Analisi STEP/DXF, check DFM e conversione profilo→solido. Tutte asincrone → 202 con job_id e result_id."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:225
msgid "Analisi tabelle in corso…"
msgstr "Analisi tabelle in corso…"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:261
#: src/features/price-lists/components/PriceListsPage.tsx:242
msgid "Analisi…"
msgstr "Analisi…"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:409
msgid "Analizza area"
msgstr "Analizza area"

#: src/features/console/pages/ConnectorsPage.tsx:525
msgid "Analizza modelli con le API CAD"
msgstr "Analizza modelli con le API CAD"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:183
msgid "Analizziamo le tabelle disponibili e generiamo descrizioni AI per ciascuna. Puoi chiudere questa finestra: il lavoro continua in background."
msgstr "Analizziamo le tabelle disponibili e generiamo descrizioni AI per ciascuna. Puoi chiudere questa finestra: il lavoro continua in background."

#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:96
msgid "Analizzo il foglio…"
msgstr "Analizzo il foglio…"

#: src/routes/_authed/workspace/canvases.tsx:346
msgid "Ancora nessun canvas"
msgstr "Ancora nessun canvas"

#: src/routes/_authed/workspace/shares.tsx:161
msgid "Ancora nessuna condivisione"
msgstr "Ancora nessuna condivisione"

#: src/features/connect/components/SpaceScopeBanner.tsx:175
msgid "Ancora nessuna fonte condivisa. Finché non aggiungi qualcosa, gli ospiti non possono interrogare nulla."
msgstr "Ancora nessuna fonte condivisa. Finché non aggiungi qualcosa, gli ospiti non possono interrogare nulla."

#: src/routes/_authed/workspace/connect.index.tsx:182
msgid "Ancora nessuno spazio"
msgstr "Ancora nessuno spazio"

#: src/routes/_authed/workspace/work.tsx:531
msgid "Ancora niente di fatto"
msgstr "Ancora niente di fatto"

#. placeholder {0}: chi.toFixed(2)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:122
msgid "ancora non significativo (χ² {0})"
msgstr "ancora non significativo (χ² {0})"

#: src/features/console/pages/UsagePage.tsx:509
msgid "Andamento giornaliero dello spazio indicizzato."
msgstr "Andamento giornaliero dello spazio indicizzato."

#: src/features/dashboard/components/AxisConfigurator.tsx:253
#: src/features/dashboard/components/AxisConfigurator.tsx:254
msgid "Andamento nel tempo"
msgstr "Andamento nel tempo"

#. placeholder {0}: series.length
#: src/features/dashboard/components/KpiCard.tsx:223
msgid "Andamento storico: {0} osservazioni"
msgstr "Andamento storico: {0} osservazioni"

#: src/features/console/pages/UsagePage.tsx:382
msgid "Andamento utilizzo"
msgstr "Andamento utilizzo"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:526
msgid "Ando"
msgstr "Ando"

#: src/routes/_authed/_modal/settings/help.tsx:149
msgid "Ando — bug critico (URGENTE)"
msgstr "Ando — bug critico (URGENTE)"

#: src/routes/_authed/_modal/settings/help.tsx:146
msgid "Ando — richiesta supporto"
msgstr "Ando — richiesta supporto"

#. placeholder {0}: m.name
#: src/routes/_authed/route.tsx:1522
msgid "Ando · {0}"
msgstr "Ando · {0}"

#: src/features/projects/components/ProjectHub.tsx:279
msgid "Ando · progetti"
msgstr "Ando · progetti"

#: src/routes/_authed/route.tsx:1247
msgid "Ando · Standard"
msgstr "Ando · Standard"

#. placeholder {0}: feedbackSuccess.confidence_adjust >= 0 ? "+" : ""
#. placeholder {1}: feedbackSuccess.confidence_adjust.toFixed(2)
#: src/features/clean-control/components/EventRow.tsx:547
msgid "Ando aggiornerà il livello di fiducia (Δ = <0>{0}{1}</0>)"
msgstr "Ando aggiornerà il livello di fiducia (Δ = <0>{0}{1}</0>)"

#: src/features/workspace/documents/components/SmartSourceChips.tsx:59
msgid "Ando AI"
msgstr "Ando AI"

#: src/features/clean-control/components/policies/PolicyForm.tsx:314
msgid "Ando applica la policy solo se il rilevatore è sicuro almeno a questo livello."
msgstr "Ando applica la policy solo se il rilevatore è sicuro almeno a questo livello."

#: src/features/console/webhooks/WebhooksPanel.tsx:91
msgid "Ando chiede al TUO applicativo di eseguire un'azione (write-loop)"
msgstr "Ando chiede al TUO applicativo di eseguire un'azione (write-loop)"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:354
msgid "Ando crea automaticamente una cartella “Ando Generated”."
msgstr "Ando crea automaticamente una cartella “Ando Generated”."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:400
msgid "Ando crea un client OIDC pubblico per questa app. Usa Authorization Code con PKCE; non serve un client secret. È il callback di accesso della tua app. Gli URL per collegare Gmail, Drive e Teams si configurano separatamente."
msgstr "Ando crea un client OIDC pubblico per questa app. Usa Authorization Code con PKCE; non serve un client secret. È il callback di accesso della tua app. Gli URL per collegare Gmail, Drive e Teams si configurano separatamente."

#: src/features/onboarding/demoTourSteps.ts:39
msgid "Ando è il tuo Company Brain: unisce email, documenti, gestionale e calendario in un'unica mente che ricorda, capisce e agisce. Ti mostro dove trovi cosa, in meno di un minuto. Puoi saltare quando vuoi."
msgstr "Ando è il tuo Company Brain: unisce email, documenti, gestionale e calendario in un'unica mente che ricorda, capisce e agisce. Ti mostro dove trovi cosa, in meno di un minuto. Puoi saltare quando vuoi."

#: src/features/clean-control/components/policies/enforcement.ts:42
msgid "Ando esegue l'azione senza intervento. Sempre annullabile entro 24 ore."
msgstr "Ando esegue l'azione senza intervento. Sempre annullabile entro 24 ore."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:191
msgid "Ando estrae le regole DFM dal tuo Excel / PDF / Word e le applica ai file CAD in ingresso."
msgstr "Ando estrae le regole DFM dal tuo Excel / PDF / Word e le applica ai file CAD in ingresso."

#: src/features/price-lists/components/PriceListsPage.tsx:283
msgid "Ando fa NL-to-SQL sulle tue tabelle prezzo"
msgstr "Ando fa NL-to-SQL sulle tue tabelle prezzo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:355
msgid "Ando gestisce il login tramite Zitadel. I permessi sui dati restano specifici di questa app."
msgstr "Ando gestisce il login tramite Zitadel. I permessi sui dati restano specifici di questa app."

#: src/features/console/pages/ModelsPage.tsx:347
msgid "Ando gestisce la pipeline. Per le elaborazioni disponibili puoi collegare un tuo account AI e controllare la copertura e i costi."
msgstr "Ando gestisce la pipeline. Per le elaborazioni disponibili puoi collegare un tuo account AI e controllare la copertura e i costi."

#: src/features/clean-control/components/UndoActionsList.tsx:112
msgid "Ando ha applicato queste azioni automaticamente. Puoi annullarle entro 24 ore dall'esecuzione."
msgstr "Ando ha applicato queste azioni automaticamente. Puoi annullarle entro 24 ore dall'esecuzione."

#. placeholder {0}: Math.round(aiState.confidence * 100)
#: src/features/dashboard/components/wizard/WizardStepData.tsx:309
msgid "Ando ha generato una query a <0>{0}%</0> di confidenza — controlla l'anteprima e ritocca la query in <1>Scrivi SQL</1> se serve."
msgstr "Ando ha generato una query a <0>{0}%</0> di confidenza — controlla l'anteprima e ritocca la query in <1>Scrivi SQL</1> se serve."

#: src/features/sources/components/InboxDetailPane.tsx:929
msgid "Ando ha pre-compilato"
msgstr "Ando ha pre-compilato"

#: src/features/sales/hooks/useCrmQueries.ts:283
msgid "Ando ha trovato {found} nuovi suggerimenti"
msgstr "Ando ha trovato {found} nuovi suggerimenti"

#: src/features/sources/components/InboxDetailPane.tsx:935
msgid "Ando ha una proposta — clicca per rivederla."
msgstr "Ando ha una proposta — clicca per rivederla."

#: src/features/connectors/wizards/messagingSpec.tsx:70
msgid "Ando indicizza i canali, i thread e le trascrizioni delle riunioni (Teams · Google Meet) a cui l'utente ha accesso."
msgstr "Ando indicizza i canali, i thread e le trascrizioni delle riunioni (Teams · Google Meet) a cui l'utente ha accesso."

#: src/features/skills/components/SkillCardParts.tsx:54
msgid "Ando la esegue con uno script già collaudato"
msgstr "Ando la esegue con uno script già collaudato"

#: src/features/price-lists/components/PriceListsPage.tsx:269
msgid "Ando legge il listino live dal file su Drive / SharePoint"
msgstr "Ando legge il listino live dal file su Drive / SharePoint"

#: src/features/connectors/wizards/emailSpec.tsx:57
msgid "Ando legge solo gli ultimi 12 mesi per default; configurabile."
msgstr "Ando legge solo gli ultimi 12 mesi per default; configurabile."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:191
msgid "Ando li proporrà quando rileverà pattern ricorrenti nelle tue azioni (≥3 occorrenze in finestra 30 giorni)."
msgstr "Ando li proporrà quando rileverà pattern ricorrenti nelle tue azioni (≥3 occorrenze in finestra 30 giorni)."

#: src/features/chat/components/ConversationMiniRail.tsx:261
msgid "Ando Modes"
msgstr "Ando Modes"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:160
msgid "Ando non è riuscito a generare la query. Prova a riformulare il prompt o passa alla scheda Scrivi SQL."
msgstr "Ando non è riuscito a generare la query. Prova a riformulare il prompt o passa alla scheda Scrivi SQL."

#: src/features/clean-control/components/UndoActionsList.tsx:137
msgid "Ando non ha ancora applicato azioni automatiche. Attiva le policy che ti servono nella scheda Policy."
msgstr "Ando non ha ancora applicato azioni automatiche. Attiva le policy che ti servono nella scheda Policy."

#: src/features/settings/components/SelfProfileMemory.tsx:463
msgid "Ando non ha ancora appreso nulla di te. Continua a chattare per costruire il tuo profilo — i fatti compariranno qui non appena l'estrattore li identifica."
msgstr "Ando non ha ancora appreso nulla di te. Continua a chattare per costruire il tuo profilo — i fatti compariranno qui non appena l'estrattore li identifica."

#: src/features/projects/components/ProjectDetailPage.tsx:179
msgid "Ando non ha ancora memorizzato nulla"
msgstr "Ando non ha ancora memorizzato nulla"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2623
#: src/features/admin/components/PageEditor.tsx:155
msgid "Ando non ha risposto, riprova."
msgstr "Ando non ha risposto, riprova."

#: src/features/skills/components/SkillsList.tsx:313
msgid "Ando non la userà più."
msgstr "Ando non la userà più."

#: src/features/onboarding/demoTourSteps.ts:102
msgid "Ando non solo risponde: propone azioni (inviare un'email, emettere una fattura, creare un evento). Ogni azione è una proposta che vedi, modifichi e approvi — in demo l'esecuzione è simulata."
msgstr "Ando non solo risponde: propone azioni (inviare un'email, emettere una fattura, creare un evento). Ogni azione è una proposta che vedi, modifichi e approvi — in demo l'esecuzione è simulata."

#: src/features/connectors/wizards/sdiSpec.tsx:109
msgid "Ando notifica scarti, accettazioni, mancate consegne."
msgstr "Ando notifica scarti, accettazioni, mancate consegne."

#: src/features/clean-control/components/CleanControlHub.tsx:86
msgid "Ando osserva ciò che entra nella tua memoria per segnalarti <0>duplicati, conflitti e derive del dato</0>. Puoi lavorare a mano o lasciare che Ando applichi le tue policy — sempre con un audit trail e 24 ore per annullare ogni decisione."
msgstr "Ando osserva ciò che entra nella tua memoria per segnalarti <0>duplicati, conflitti e derive del dato</0>. Puoi lavorare a mano o lasciare che Ando applichi le tue policy — sempre con un audit trail e 24 ore per annullare ogni decisione."

#: src/features/price-lists/components/PriceListsPage.tsx:174
msgid "Ando pesca i prezzi da ovunque stiano — file caricati, Drive, ERP, database aziendale — e li applica al BOM del disegno per preventivare in automatico."
msgstr "Ando pesca i prezzi da ovunque stiano — file caricati, Drive, ERP, database aziendale — e li applica al BOM del disegno per preventivare in automatico."

#: src/features/console/components/ConsoleShell.tsx:612
msgid "Ando Platform"
msgstr "Ando Platform"

#: src/features/connectors/wizards/calendarSpec.tsx:62
msgid "Ando potrà leggere/creare eventi e suggerire slot liberi."
msgstr "Ando potrà leggere/creare eventi e suggerire slot liberi."

#: src/features/connectors/wizards/databaseSpec.tsx:248
msgid "Ando profila tabelle, colonne e relazioni al primo collegamento."
msgstr "Ando profila tabelle, colonne e relazioni al primo collegamento."

#: src/features/connectors/wizards/openBankingSpec.tsx:198
msgid "Ando proietta entrate e uscite usando lo storico."
msgstr "Ando proietta entrate e uscite usando lo storico."

#: src/features/clean-control/components/policies/enforcement.ts:35
msgid "Ando propone l'azione in coda per la tua approvazione manuale prima di eseguirla."
msgstr "Ando propone l'azione in coda per la tua approvazione manuale prima di eseguirla."

#: src/features/settings/components/SelfProfileMemory.tsx:301
msgid "Ando può imparare da te preferenze, ruolo, obiettivi e progetti SOLO se acconsenti esplicitamente. Puoi revocare in ogni momento; la revoca fa scattare la cancellazione automatica dei fatti appresi."
msgstr "Ando può imparare da te preferenze, ruolo, obiettivi e progetti SOLO se acconsenti esplicitamente. Puoi revocare in ogni momento; la revoca fa scattare la cancellazione automatica dei fatti appresi."

#: src/features/settings/components/SelfProfileMemory.tsx:218
msgid "Ando può personalizzare le sue risposte imparando ruolo, obiettivi e preferenze dalle vostre conversazioni — solo se lo autorizzi esplicitamente. Qui vedi cosa ha imparato e puoi revocare tutto in un click."
msgstr "Ando può personalizzare le sue risposte imparando ruolo, obiettivi e preferenze dalle vostre conversazioni — solo se lo autorizzi esplicitamente. Qui vedi cosa ha imparato e puoi revocare tutto in un click."

#: src/features/settings/components/MemoryConsentBanner.tsx:103
msgid "Ando può ricordare il tuo ruolo, i progetti attivi e le preferenze di comunicazione per rendere briefing e suggerimenti davvero utili per te. I dati restano nel tuo tenant, non vengono mai condivisi, e puoi disattivare in qualsiasi momento in <0>Impostazioni → Memoria personale</0>."
msgstr "Ando può ricordare il tuo ruolo, i progetti attivi e le preferenze di comunicazione per rendere briefing e suggerimenti davvero utili per te. I dati restano nel tuo tenant, non vengono mai condivisi, e puoi disattivare in qualsiasi momento in <0>Impostazioni → Memoria personale</0>."

#: src/features/clean-control/components/policies/enforcement.ts:28
msgid "Ando registra l'esito in un'anteprima. Nessuna modifica reale — il modo più prudente per calibrare la policy."
msgstr "Ando registra l'esito in un'anteprima. Nessuna modifica reale — il modo più prudente per calibrare la policy."

#: src/features/admin/components/AdminDecksAskAndo.tsx:83
msgid "Ando riscrive il deck secondo la tua istruzione e ti mostra le slide cambiate. Niente viene salvato finché non applichi e salvi una nuova versione. I numeri mancanti restano segnaposto [[...]]."
msgstr "Ando riscrive il deck secondo la tua istruzione e ti mostra le slide cambiate. Niente viene salvato finché non applichi e salvi una nuova versione. I numeri mancanti restano segnaposto [[...]]."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:343
msgid "Ando scrive ed esegue la query sui tuoi dati reali — riceverai SQL + anteprima in un unico passaggio."
msgstr "Ando scrive ed esegue la query sui tuoi dati reali — riceverai SQL + anteprima in un unico passaggio."

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:100
msgid "Ando si connette direttamente al database. Consigliato per database pubblici o raggiungibili via internet."
msgstr "Ando si connette direttamente al database. Consigliato per database pubblici o raggiungibili via internet."

#: src/features/sources/components/InboxDetailPane.tsx:882
msgid "Ando sta analizzando…"
msgstr "Ando sta analizzando…"

#: src/features/sales/components/LeadsPanel.tsx:662
msgid "Ando sta cercando aziende che combaciano con il tuo profilo cliente. I risultati compaiono qui appena pronti."
msgstr "Ando sta cercando aziende che combaciano con il tuo profilo cliente. I risultati compaiono qui appena pronti."

#: src/features/sales/components/LeadsPanel.tsx:641
msgid "Ando sta cercando le aziende migliori…"
msgstr "Ando sta cercando le aziende migliori…"

#: src/features/clean-control/components/EventQueue.tsx:466
msgid "Ando sta osservando la memoria in tempo reale. Non appena spunta qualcosa da rivedere — un duplicato, un IBAN storto, un dato scaduto — comparirà qui con una proposta di azione chiara."
msgstr "Ando sta osservando la memoria in tempo reale. Non appena spunta qualcosa da rivedere — un duplicato, un IBAN storto, un dato scaduto — comparirà qui con una proposta di azione chiara."

#: src/features/admin/components/AdminCpqAskAndo.tsx:290
msgid "Ando sta preparando la proposta…"
msgstr "Ando sta preparando la proposta…"

#: src/features/share/components/ShareLinkDialog.tsx:369
msgid "Ando sta preparando la scheda…"
msgstr "Ando sta preparando la scheda…"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:287
msgid "Ando sta ragionando…"
msgstr "Ando sta ragionando…"

#: src/routes/_authed/route.tsx:2220
msgid "Ando sta rispondendo… premi Stop per interrompere"
msgstr "Ando sta rispondendo… premi Stop per interrompere"

#. placeholder {0}: context.provider
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:100
msgid "Ando sta scaricando i file da {0}. Tra qualche istante li vedrai apparire qui."
msgstr "Ando sta scaricando i file da {0}. Tra qualche istante li vedrai apparire qui."

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:101
msgid "Ando sta scaricando i file dai tuoi drive. Tra qualche istante li vedrai apparire qui."
msgstr "Ando sta scaricando i file dai tuoi drive. Tra qualche istante li vedrai apparire qui."

#: src/features/admin/components/PageEditor.tsx:237
msgid "Ando sta scrivendo la pagina, può volerci un minuto…"
msgstr "Ando sta scrivendo la pagina, può volerci un minuto…"

#: src/features/admin/components/AdminDecksAskAndo.tsx:125
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2848
msgid "Ando sta scrivendo…"
msgstr "Ando sta scrivendo…"

#: src/features/workspace/components/NotificationPill.tsx:216
msgid "Ando ti avviserà qui quando avrà qualcosa di nuovo per te."
msgstr "Ando ti avviserà qui quando avrà qualcosa di nuovo per te."

#: src/routes/_authed/workspace/work.tsx:594
msgid "Ando ti suggerirà azioni qui quando trova qualcosa da fare."
msgstr "Ando ti suggerirà azioni qui quando trova qualcosa da fare."

#: src/features/connectors/wizards/driveSpec.tsx:117
msgid "Ando vede solo ciò che l'utente vede sul provider."
msgstr "Ando vede solo ciò che l'utente vede sul provider."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:399
msgid "Ando verifica il token OIDC a ogni richiesta. Il provider e l'audience devono identificare questa app."
msgstr "Ando verifica il token OIDC a ogni richiesta. Il provider e l'audience devono identificare questa app."

#: src/features/console/docs/content.ts:1849
msgid "AndoConnector — Push API"
msgstr "AndoConnector — Push API"

#: src/features/console/docs/content.ts:1669
msgid "AndoPlatform — il client"
msgstr "AndoPlatform — il client"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:455
msgid "andrea@example.com"
msgstr "andrea@example.com"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1862
msgid "Angoli"
msgstr "Angoli"

#: src/features/templates/components/TemplateFieldSpecs.ts:106
msgid "Animazioni alle transizioni"
msgstr "Animazioni alle transizioni"

#: src/features/voice_report/components/ShareReportDialog.tsx:260
msgid "anna@example.com, luca@example.com"
msgstr "anna@example.com, luca@example.com"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:235
msgid "anni"
msgstr "anni"

#: src/features/dashboard/utils/calculatedFields.ts:90
#: src/features/structured-data/components/TemporalQueryControl.tsx:216
msgid "Anno"
msgstr "Anno"

#: src/features/structured-data/components/TemporalQueryControl.tsx:205
msgid "Anno da analizzare"
msgstr "Anno da analizzare"

#: src/features/structured-data/components/TemporalQueryControl.tsx:166
msgid "Anno precedente"
msgstr "Anno precedente"

#: src/features/structured-data/components/TemporalQueryControl.tsx:289
msgid "Anno successivo"
msgstr "Anno successivo"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:111
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:137
#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:239
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:838
#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:394
#: ../../packages/ui/src/ando/dialog/AndoDialogProvider.tsx:61
#: ../../packages/ui/src/ando/ShareEmailForm.tsx:215
#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:505
#: ../../packages/ui/src/ando/UndoChip.tsx:79
#: ../../packages/ui/src/editors/AiTextPopover.tsx:344
#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:574
#: src/features/admin/components/AdminCpq.tsx:1227
#: src/features/admin/components/AdminDecks.tsx:454
#: src/features/admin/components/AdminDemoInviti.tsx:398
#: src/features/admin/components/AdminDemoInviti.tsx:439
#: src/features/admin/components/AdminOrgs.tsx:1260
#: src/features/admin/components/AdminOrgs.tsx:1320
#: src/features/admin/components/AdminOrgs.tsx:1424
#: src/features/admin/components/AdminPlatformSettings.tsx:888
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:214
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:454
#: src/features/admin/components/MaintenanceControl.tsx:255
#: src/features/admin/components/MaintenanceControl.tsx:284
#: src/features/admin/components/orgs/_shared.tsx:280
#: src/features/admin/components/orgs/AddMemberDialog.tsx:258
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:112
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:192
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:463
#: src/features/admin/components/orgs/MigrateUserDialog.tsx:219
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:546
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:205
#: src/features/admin/components/orgs/OrgMembersTab.tsx:154
#: src/features/admin/components/PageEditor.tsx:412
#: src/features/admin/components/userAdminActions.tsx:387
#: src/features/admin/components/userAdminActions.tsx:435
#: src/features/admin/components/ZitadelPasswordActions.tsx:282
#: src/features/agent-modes/components/AgentModeEditor.tsx:527
#: src/features/agent-modes/components/AgentModesList.tsx:358
#: src/features/automations/components/CreateAutomationDialog.tsx:252
#: src/features/clean-control/components/policies/PolicyForm.tsx:378
#: src/features/clean-control/components/UndoActionsList.tsx:256
#: src/features/connect/components/ChatbotPanel.tsx:178
#: src/features/connect/components/CreateSpaceDialog.tsx:218
#: src/features/connect/components/GrantManager.tsx:110
#: src/features/connect/components/GrantManager.tsx:195
#: src/features/connect/components/MemberManager.tsx:82
#: src/features/connect/components/MemberManager.tsx:163
#: src/features/connect/components/MemberManager.tsx:474
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:302
#: src/features/connectors/components/ConnectAccountDialog.tsx:491
#: src/features/connectors/components/ConnectAccountDialog.tsx:525
#: src/features/connectors/components/management/BusinessContextBanner.tsx:396
#: src/features/connectors/components/management/BusinessContextEditor.tsx:177
#: src/features/connectors/components/management/BusinessContextEditor.tsx:207
#: src/features/connectors/components/management/ChatExamplesManager.tsx:201
#: src/features/connectors/components/management/ChatExamplesManager.tsx:266
#: src/features/connectors/components/management/DiscoveryDialog.tsx:158
#: src/features/connectors/components/management/EditConnectorDialog.tsx:363
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:264
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:360
#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:129
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:897
#: src/features/console/components/ByokModal.tsx:105
#: src/features/console/components/CreateKeyWizard.tsx:728
#: src/features/console/components/ModelPickerModal.tsx:232
#: src/features/console/components/OverlapRotationModal.tsx:105
#: src/features/console/components/ProviderAccounts.tsx:243
#: src/features/console/connectors/ConnectorActionsPanel.tsx:318
#: src/features/console/connectors/CustomConnectorDetail.tsx:749
#: src/features/console/connectors/CustomConnectorDetail.tsx:802
#: src/features/console/connectors/CustomConnectorDetail.tsx:864
#: src/features/console/connectors/CustomConnectorDetail.tsx:1109
#: src/features/console/connectors/CustomConnectorsPanel.tsx:386
#: src/features/console/connectors/DeclareConnectorActionModal.tsx:225
#: src/features/console/connectors/InvokeConnectorActionModal.tsx:137
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:659
#: src/features/console/connectors/TestConnectorActionModal.tsx:176
#: src/features/console/pages/ConnectorDetailPage.tsx:505
#: src/features/console/pages/ConnectorDetailPage.tsx:595
#: src/features/console/pages/DocumentsPage.tsx:940
#: src/features/console/pages/EmbeddedIdentityPage.tsx:391
#: src/features/console/pages/EmbeddedIdentityPage.tsx:403
#: src/features/console/pages/FlowsPage.tsx:993
#: src/features/console/pages/FlowsPage.tsx:1035
#: src/features/console/pages/KeyDetailPage.tsx:158
#: src/features/console/pages/KeyDetailPage.tsx:279
#: src/features/console/pages/KeyDetailPage.tsx:719
#: src/features/console/pages/KeysPage.tsx:275
#: src/features/console/pages/MembersPage.tsx:222
#: src/features/console/pages/MembersPage.tsx:339
#: src/features/console/pages/MembersPage.tsx:698
#: src/features/console/pages/MembersPage.tsx:730
#: src/features/console/pages/ModelsPage.tsx:497
#: src/features/console/pages/PlaygroundPage.tsx:2049
#: src/features/console/pages/ResourceAccessPage.tsx:297
#: src/features/console/pages/SchemaPage.tsx:305
#: src/features/console/webhooks/WebhooksPanel.tsx:296
#: src/features/console/webhooks/WebhooksPanel.tsx:742
#: src/features/dashboard/components/AddChartDialog.tsx:723
#: src/features/dashboard/components/AxisConfigurator.tsx:483
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:434
#: src/features/dashboard/components/ChartActionsMenu.tsx:288
#: src/features/dashboard/components/ChartSqlEditor.tsx:145
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:435
#: src/features/dashboard/components/DashboardListSidebar.tsx:480
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:254
#: src/features/dfm-rules/components/DfmRulesPage.tsx:823
#: src/features/dfm-rules/components/DfmRulesPage.tsx:1024
#: src/features/dxf/components/DxfActionsMenu.tsx:122
#: src/features/hive-flows/components/FlowActivateControl.tsx:249
#: src/features/hive-flows/components/FlowFormPublish.tsx:212
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:168
#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:99
#: src/features/price-lists/components/PriceListsPage.tsx:869
#: src/features/price-lists/components/PriceListsPage.tsx:993
#: src/features/projects/components/NewProjectDialog.tsx:192
#: src/features/projects/components/sections/PersonaSection.tsx:381
#: src/features/projects/components/TemplatesBrowserDialog.tsx:228
#: src/features/sales/components/ActivityTimeline.tsx:221
#: src/features/sales/components/ActivityTimeline.tsx:242
#: src/features/sales/components/BatchSendModal.tsx:427
#: src/features/sales/components/CampaignsPanel.tsx:140
#: src/features/sales/components/CreateCampaignDialog.tsx:119
#: src/features/sales/components/CreateLeadDialog.tsx:225
#: src/features/sales/components/crm/CompaniesPanel.tsx:146
#: src/features/sales/components/crm/ContactsPanel.tsx:155
#: src/features/sales/components/crm/CreateDealDialog.tsx:229
#: src/features/sales/components/LeadsPanel.tsx:228
#: src/features/sales/components/SignaturesManager.tsx:277
#: src/features/sales/components/TemplateManager.tsx:357
#: src/features/settings/components/OrgMembersPanel.tsx:357
#: src/features/settings/components/OrgMembersPanel.tsx:577
#: src/features/settings/components/OrgMembersPanel.tsx:678
#: src/features/settings/components/OtpEmailPanel.tsx:342
#: src/features/settings/components/PresentationTemplates.tsx:317
#: src/features/settings/components/PresentationTemplates.tsx:875
#: src/features/share/components/ShareLinkDialog.tsx:597
#: src/features/skills/components/SkillEditor.tsx:439
#: src/features/skills/components/SkillsList.tsx:318
#: src/features/sources/components/AISummaryPanel.tsx:619
#: src/features/sources/components/ArtifactPane.tsx:1628
#: src/features/sources/components/ArtifactPane.tsx:2112
#: src/features/sources/components/CalendarEventPane.tsx:735
#: src/features/sources/components/GoogleChatMessageEditor.tsx:43
#: src/features/sources/components/InboxDetailPane.tsx:523
#: src/features/sources/components/InboxDetailPane.tsx:1170
#: src/features/sources/components/InboxDetailPane.tsx:2218
#: src/features/sources/components/SyncConflictDialog.tsx:90
#: src/features/sources/hooks/useUndoableSend.tsx:91
#: src/features/structured-data/components/TemporalQueryControl.tsx:341
#: src/features/sync/components/DocSyncManager.tsx:1449
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:400
#: src/features/sync/components/picker/NotionPickerModal.tsx:186
#: src/features/sync/components/UniversalSyncToast.tsx:215
#: src/features/templates/components/CreateTemplateDialog.tsx:196
#: src/features/templates/components/TemplateEditor.tsx:431
#: src/features/templates/components/TemplateEditor.tsx:462
#: src/features/voice_report/components/NewReportDialog.tsx:1079
#: src/features/voice_report/components/RunsTab.tsx:120
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:291
#: src/features/workspace/components/TaskComposer.tsx:259
#: src/features/workspace/components/UploadModal.tsx:408
#: src/features/workspace/documents/components/BulkActionBar.tsx:102
#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:185
#: src/routes/_authed/workspace/documents.tsx:625
#: src/routes/_authed/workspace/documents.tsx:672
#: src/routes/_authed/workspace/finance.tsx:1175
#: src/routes/_authed/workspace/templates/$kind.tsx:412
msgid "Annulla"
msgstr "Annulla"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:371
msgid "Annulla (Cmd+Z)"
msgstr "Annulla (Cmd+Z)"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:392
msgid "Annulla (Esc)"
msgstr "Annulla (Esc)"

#: src/features/billing/components/CurrentPlanCard.tsx:168
#: src/features/settings/components/BillingSettings.tsx:74
msgid "Annulla abbonamento"
msgstr "Annulla abbonamento"

#: src/features/clean-control/components/UndoActionsList.tsx:253
msgid "Annulla azione"
msgstr "Annulla azione"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:134
msgid "Annulla invio"
msgstr "Annulla invio"

#: src/features/settings/components/OrgMembersPanel.tsx:460
msgid "Annulla invito"
msgstr "Annulla invito"

#: src/features/settings/components/OrgMembersPanel.tsx:458
msgid "Annulla invito a {inviteRecipient}"
msgstr "Annulla invito a {inviteRecipient}"

#: src/features/sources/components/ArtifactPane.tsx:1594
msgid "Annulla la proposta in corso su questo documento"
msgstr "Annulla la proposta in corso su questo documento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:370
msgid "Annulla modifica"
msgstr "Annulla modifica"

#: src/features/admin/components/AdminCpqPriceBook.tsx:183
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:715
msgid "Annulla modifiche"
msgstr "Annulla modifiche"

#: src/features/sources/components/InboxDetailPane.tsx:1974
#: src/features/sources/components/InboxDetailPane.tsx:1978
msgid "Annulla programmazione"
msgstr "Annulla programmazione"

#: src/features/sources/components/InboxDetailPane.tsx:1195
msgid "Annulla programmazione · invia subito"
msgstr "Annulla programmazione · invia subito"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:296
msgid "Annulla selezione"
msgstr "Annulla selezione"

#: src/features/connectors/components/CancelSyncButton.tsx:70
msgid "Annulla sincronizzazione"
msgstr "Annulla sincronizzazione"

#. placeholder {0}: connection.connection_key
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:284
msgid "Annulla sincronizzazione {0}"
msgstr "Annulla sincronizzazione {0}"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:209
msgid "Annulla sync"
msgstr "Annulla sync"

#. placeholder {0}: countdown.hoursLeft
#: src/features/clean-control/components/UndoActionsList.tsx:227
msgid "Annullabile per <0>{0}h</0>"
msgstr "Annullabile per <0>{0}h</0>"

#. placeholder {0}: countdown.minutesLeft
#: src/features/clean-control/components/UndoActionsList.tsx:234
msgid "Annullabile per <0>{0}m</0>"
msgstr "Annullabile per <0>{0}m</0>"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:170
msgid "Annullamento in corso…"
msgstr "Annullamento in corso…"

#: src/features/sync/components/DocSyncManager.tsx:436
msgid "Annullamento più lento del previsto — riprova fra qualche istante."
msgstr "Annullamento più lento del previsto — riprova fra qualche istante."

#: src/features/sync/components/SyncStatusPill.tsx:80
msgid "Annullamento sincronizzazione in corso"
msgstr "Annullamento sincronizzazione in corso"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:209
#: src/features/billing/components/CurrentPlanCard.tsx:168
msgid "Annullamento…"
msgstr "Annullamento…"

#: src/features/sync/components/SyncStatusPill.tsx:107
#: src/features/sync/components/UniversalSyncToast.tsx:213
msgid "Annullando…"
msgstr "Annullando…"

#: src/features/settings/components/BillingSettings.tsx:70
msgid "Annullare l'abbonamento?"
msgstr "Annullare l'abbonamento?"

#: src/features/billing/components/InvoicesTable.tsx:34
#: src/features/clean-control/components/UndoActionsList.tsx:218
#: src/features/console/components/StatusBadges.tsx:168
#: src/features/console/components/StatusBadges.tsx:259
msgid "Annullata"
msgstr "Annullata"

#: src/features/billing/components/CurrentPlanCard.tsx:53
#: src/features/voice_report/components/RunStatusBadge.tsx:65
msgid "Annullato"
msgstr "Annullato"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:278
msgid "anteprima"
msgstr "anteprima"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:103
#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:522
#: src/features/admin/components/AdminCpq.tsx:569
#: src/features/admin/components/deckEditor/DeckEditor.tsx:440
#: src/features/admin/components/PageEditor.tsx:366
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:276
#: src/features/console/connectors/TestConnectorActionModal.tsx:307
#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
#: src/features/dashboard/components/AddChartDialog.tsx:655
#: src/features/dashboard/components/AddChartDialog.tsx:668
#: src/features/dashboard/components/AddChartDialog.tsx:701
#: src/features/dashboard/components/wizard/WizardStepData.tsx:387
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:399
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:408
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:416
#: src/features/dxf/components/DxfPreviewStage.tsx:346
#: src/features/hive-flows/run/ProposalReview.tsx:774
#: src/features/settings/components/BrandKitSettings.tsx:582
#: src/features/sources/components/EmailAttachmentChip.tsx:179
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:616
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:575
msgid "Anteprima"
msgstr "Anteprima"

#: src/routes/_authed/workspace/finance.tsx:288
msgid "Anteprima — collega un connettore"
msgstr "Anteprima — collega un connettore"

#: src/features/sources/components/ArtifactPane.tsx:1879
msgid "Anteprima — scarica il file originale per modificare in PowerPoint/Keynote."
msgstr "Anteprima — scarica il file originale per modificare in PowerPoint/Keynote."

#. placeholder {0}: firstSelected.original_name
#. placeholder {1}: firstSelected.preview_rows.length
#. placeholder {2}: firstSelected.preview_rows.length === 1 ? t`riga` : t`righe`
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:192
msgid "Anteprima · {0} · prime {1} {2}"
msgstr "Anteprima · {0} · prime {1} {2}"

#. placeholder {0}: preview.rowCount
#. placeholder {1}: rows.length
#: src/features/dashboard/components/wizard/WizardStepData.tsx:476
msgid "Anteprima · <0>{0}</0> righe totali · prime {1} mostrate"
msgstr "Anteprima · <0>{0}</0> righe totali · prime {1} mostrate"

#. placeholder {0}: preview.length
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:382
msgid "Anteprima · prime {0} righe"
msgstr "Anteprima · prime {0} righe"

#: src/features/connectors/components/management/SchemaViewer.tsx:727
msgid "Anteprima · prime 20 righe"
msgstr "Anteprima · prime 20 righe"

#: src/features/hive-flows/components/DryRunPanel.tsx:88
msgid "Anteprima (nessuna azione reale)"
msgstr "Anteprima (nessuna azione reale)"

#. placeholder {0}: attachment.filename
#. placeholder {0}: file.filename
#. placeholder {0}: template.name
#: src/features/dxf/components/DxfPreview.tsx:54
#: src/features/dxf/components/DxfPreviewStage.tsx:273
#: src/features/settings/components/PresentationTemplates.tsx:492
#: src/features/sources/components/EmailAttachmentChip.tsx:175
msgid "Anteprima {0}"
msgstr "Anteprima {0}"

#. placeholder {0}: file.filename
#: src/features/dxf/components/DxfPreviewStage.tsx:230
msgid "Anteprima a tutto schermo: {0}"
msgstr "Anteprima a tutto schermo: {0}"

#: src/features/console/connectors/TestConnectorActionModal.tsx:311
msgid "Anteprima azione"
msgstr "Anteprima azione"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:276
msgid "Anteprima chatbot"
msgstr "Anteprima chatbot"

#: src/features/voice_report/components/DatasetTab.tsx:87
msgid "Anteprima chunks"
msgstr "Anteprima chunks"

#: src/features/connect/components/GuestPreviewDialog.tsx:49
msgid "Anteprima come ospite"
msgstr "Anteprima come ospite"

#. placeholder {0}: new Date(data.expires_at).toLocaleString(i18n.locale || "it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", })
#: src/routes/public.voice-report.$token.tsx:118
msgid "Anteprima condivisa — scade {0}"
msgstr "Anteprima condivisa — scade {0}"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:356
msgid "Anteprima copertura"
msgstr "Anteprima copertura"

#: src/features/settings/marp/PptxExtractPanel.tsx:201
msgid "Anteprima CSS"
msgstr "Anteprima CSS"

#: src/features/connectors/components/management/SchemaViewer.tsx:332
msgid "Anteprima dati"
msgstr "Anteprima dati"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:597
msgid "Anteprima deck"
msgstr "Anteprima deck"

#: src/features/console/connectors/ManifestConfigForm.tsx:336
msgid "Anteprima del config generato"
msgstr "Anteprima del config generato"

#. placeholder {0}: firstSelected.original_name
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:200
msgid "Anteprima del foglio {0}"
msgstr "Anteprima del foglio {0}"

#: src/features/templates/components/TemplatePreview.tsx:63
msgid "Anteprima del template {name}"
msgstr "Anteprima del template {name}"

#: src/features/admin/components/AdminCpqCanvas.tsx:292
msgid "Anteprima della proposta"
msgstr "Anteprima della proposta"

#: ../../packages/ui/src/ando/actions/InlineDiffPreview.tsx:150
msgid "Anteprima delle modifiche"
msgstr "Anteprima delle modifiche"

#: src/features/console/docs/content.ts:1415
msgid "Anteprima di un account"
msgstr "Anteprima di un account"

#: src/features/dashboard/components/AddChartDialog.tsx:702
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:417
msgid "Anteprima grafico {chartType}"
msgstr "Anteprima grafico {chartType}"

#: src/features/dxf/components/DxfPreviewStage.tsx:490
msgid "Anteprima in generazione…"
msgstr "Anteprima in generazione…"

#: src/features/sources/components/ArtifactPane.tsx:1525
msgid "Anteprima in linea non disponibile — rivedi e applica le modifiche dalla scheda della proposta."
msgstr "Anteprima in linea non disponibile — rivedi e applica le modifiche dalla scheda della proposta."

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:559
msgid "Anteprima modifiche — conferma per applicare"
msgstr "Anteprima modifiche — conferma per applicare"

#: src/features/templates/components/TemplatePreview.tsx:73
msgid "Anteprima non ancora generata"
msgstr "Anteprima non ancora generata"

#: src/features/admin/components/AdminDecks.tsx:552
#: src/features/dxf/components/DxfPreviewStage.tsx:492
#: src/features/share/components/ShareLinkDialog.tsx:222
#: src/features/sources/components/ArtifactPane.tsx:1966
msgid "Anteprima non disponibile"
msgstr "Anteprima non disponibile"

#. placeholder {0}: file.filename
#: src/features/dxf/components/DxfPreview.tsx:71
msgid "Anteprima non disponibile · {0}"
msgstr "Anteprima non disponibile · {0}"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:337
msgid "Anteprima non disponibile per questo disegno."
msgstr "Anteprima non disponibile per questo disegno."

#: src/features/console/pages/DocumentsPage.tsx:452
msgid "Anteprima non disponibile per questo formato."
msgstr "Anteprima non disponibile per questo formato."

#: src/routes/public.voice-report.$token.tsx:267
msgid "Anteprima non disponibile per questo report."
msgstr "Anteprima non disponibile per questo report."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:230
msgid "Anteprima non disponibile."
msgstr "Anteprima non disponibile."

#: src/features/dxf/components/DxfPreviewStage.tsx:491
msgid "Anteprima non generata"
msgstr "Anteprima non generata"

#: src/features/console/flows/ConsoleFlowEditor.tsx:160
#: src/routes/_authed/workspace/flows.$flowId.tsx:339
msgid "Anteprima non riuscita"
msgstr "Anteprima non riuscita"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:338
msgid "Anteprima non riuscita."
msgstr "Anteprima non riuscita."

#: src/features/connect/components/GrantManager.tsx:144
#: src/features/connect/components/GuestPreviewDialog.tsx:64
#: src/routes/_authed/workspace/connect.$spaceId.tsx:276
msgid "Anteprima ospite"
msgstr "Anteprima ospite"

#: src/features/projects/components/NewProjectDialog.tsx:173
msgid "Anteprima progetto"
msgstr "Anteprima progetto"

#: src/features/admin/components/AdminDecks.tsx:549
msgid "Anteprima pronta"
msgstr "Anteprima pronta"

#: src/features/console/connectors/CustomConnectorDetail.tsx:329
msgid "Anteprima record accettati"
msgstr "Anteprima record accettati"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:161
msgid "Anteprima slide"
msgstr "Anteprima slide"

#. placeholder {0}: i + 1
#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:283
msgid "Anteprima slide {0}"
msgstr "Anteprima slide {0}"

#: src/features/voice_report/components/TemplatesGallery.tsx:279
msgid "Anteprima template"
msgstr "Anteprima template"

#. placeholder {0}: template.name
#: src/features/voice_report/components/TemplatesGallery.tsx:207
msgid "Anteprima template {0}"
msgstr "Anteprima template {0}"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:275
msgid "Anteprima troncata server-side (PII protetta)"
msgstr "Anteprima troncata server-side (PII protetta)"

#: ../../packages/ui/src/ando/sources/web/WebPreview.tsx:198
msgid "Anteprima web {title}"
msgstr "Anteprima web {title}"

#: src/features/console/pages/DocumentsPage.tsx:353
msgid "Anteprima, metadati e stato di indicizzazione."
msgstr "Anteprima, metadati e stato di indicizzazione."

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:432
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:549
msgid "Anteprime slide"
msgstr "Anteprime slide"

#: src/features/settings/components/NotificationPreferences.tsx:451
msgid "Anti-fatigue: oltre il soft cap Ando avvisa, oltre l'hard cap blocca fino al giorno successivo."
msgstr "Anti-fatigue: oltre il soft cap Ando avvisa, oltre l'hard cap blocca fino al giorno successivo."

#: src/features/sales/components/crm/PipelineBoard.tsx:308
msgid "aperta"
msgstr "aperta"

#: src/features/billing/components/InvoicesTable.tsx:33
#: src/features/console/connectors/ConnectionCard.tsx:180
msgid "Aperta"
msgstr "Aperta"

#: src/features/clean-control/components/QualityScoreStat.tsx:215
msgid "Aperti"
msgstr "Aperti"

#: src/routes/_authed/route.tsx:1036
msgid "Aperto {tabName}"
msgstr "Aperto {tabName}"

#: src/features/workspace/components/WorkspaceTabs.tsx:584
msgid "Aperto da Ando"
msgstr "Aperto da Ando"

#. placeholder {0}: KIND_LABEL[kind]
#: src/features/sources/components/ArtifactToolbar.tsx:74
msgid "Aperto in {0}"
msgstr "Aperto in {0}"

#: src/features/sources/components/ArtifactToolbar.tsx:75
msgid "Aperto in applicazione esterna"
msgstr "Aperto in applicazione esterna"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:503
msgid "Aperto nel browser"
msgstr "Aperto nel browser"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:121
msgid "Aperto nella sidebar dei documenti"
msgstr "Aperto nella sidebar dei documenti"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:551
msgid "Apertura browser…"
msgstr "Apertura browser…"

#. placeholder {0}: cta.action_type
#: src/features/sources/components/InboxDetailPane.tsx:981
msgid "Apertura card HITL ({0})"
msgstr "Apertura card HITL ({0})"

#: src/features/billing/components/CreditBalanceCard.tsx:162
msgid "Apertura checkout…"
msgstr "Apertura checkout…"

#: src/routes/login.tsx:147
msgid "Apertura del browser…"
msgstr "Apertura del browser…"

#: src/features/sources/marp/ManualDeckEditMount.tsx:123
msgid "Apertura editor…"
msgstr "Apertura editor…"

#: src/features/sources/components/ArtifactPane.tsx:1803
msgid "Apertura sessione di editing"
msgstr "Apertura sessione di editing"

#: src/features/help/data/changelog.ts:66
msgid "Apertura source drawer ottimizzata sui click di citazione: il viewer si posiziona sul passaggio esatto, metadata canvas sempre leggibili anche su viewport stretti."
msgstr "Apertura source drawer ottimizzata sui click di citazione: il viewer si posiziona sul passaggio esatto, metadata canvas sempre leggibili anche su viewport stretti."

#: src/features/billing/components/CurrentPlanCard.tsx:158
#: src/features/console/pages/EmbeddedIdentityPage.tsx:287
#: src/routes/connect.invite.$token.tsx:160
msgid "Apertura…"
msgstr "Apertura…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:363
msgid "API audience scope"
msgstr "API audience scope"

#: src/features/console/components/ProviderAccounts.tsx:107
msgid "API key"
msgstr "API key"

#: src/features/console/components/ByokModal.tsx:129
msgid "API key del provider"
msgstr "API key del provider"

#: src/features/console/components/ConsoleShell.tsx:231
#: src/features/console/components/CreateKeyWizard.tsx:327
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
#: src/features/console/pages/EmbeddedIdentityPage.tsx:346
msgid "App"
msgstr "App"

#: src/features/console/pages/PlaygroundPage.tsx:1974
msgid "App · Prova"
msgstr "App · Prova"

#: src/features/console/pages/ResourceAccessPage.tsx:787
msgid "App dell'utente"
msgstr "App dell'utente"

#: src/features/connectors/wizards/filesystemSpec.tsx:132
msgid "App desktop"
msgstr "App desktop"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:140
msgid "App disattivata. Le sue AppKey e gli accessi degli utenti non sono più utilizzabili."
msgstr "App disattivata. Le sue AppKey e gli accessi degli utenti non sono più utilizzabili."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:345
msgid "App non trovata"
msgstr "App non trovata"

#: src/features/connectors/wizards/emailSpec.tsx:76
#: src/features/connectors/wizards/pecSpec.tsx:124
#: src/features/connectors/wizards/pecSpec.tsx:157
msgid "App password"
msgstr "App password"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:341
msgid "App selezionata"
msgstr "App selezionata"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:600
msgid "App: {appLabel}. "
msgstr "App: {appLabel}. "

#. placeholder {0}: row.run_id
#: src/features/report/components/CategoryEmergenceTimeline.tsx:80
msgid "Apparsa il {d} nel run {0}"
msgstr "Apparsa il {d} nel run {0}"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:165
msgid "appartiene già a"
msgstr "appartiene già a"

#: src/features/workspace/finance/components/BankAccountsList.tsx:39
#: src/features/workspace/finance/components/BankAccountsList.tsx:41
msgid "appena"
msgstr "appena"

#: src/features/console/connectors/CustomConnectorDetail.tsx:123
msgid "Appena la tua app apre un sync e spinge dei record, le run compaiono qui con i loro contatori."
msgstr "Appena la tua app apre un sync e spinge dei record, le run compaiono qui con i loro contatori."

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:48
msgid "appena ora"
msgstr "appena ora"

#: src/features/console/pages/GetStartedPage.tsx:55
#: src/features/console/pages/KeyDetailPage.tsx:589
#: src/features/console/pages/KeyDetailPage.tsx:593
msgid "AppKey"
msgstr "AppKey"

#: src/features/console/components/CreateKeyWizard.tsx:667
msgid "AppKey creata"
msgstr "AppKey creata"

#: src/features/console/connectors/CustomConnectorDetail.tsx:585
msgid "AppKey per il sync"
msgstr "AppKey per il sync"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:479
msgid "AppKey server attiva presente. Il primo tentativo di sync parte entro 15 minuti."
msgstr "AppKey server attiva presente. Il primo tentativo di sync parte entro 15 minuti."

#: src/features/console/components/ConsoleShell.tsx:233
#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
#: src/features/console/pages/KeyDetailPage.tsx:588
#: src/features/console/pages/KeysPage.tsx:71
#: src/features/console/pages/KeysPage.tsx:85
msgid "AppKeys"
msgstr "AppKeys"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:251
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:945
#: src/features/admin/components/AdminCpqAskAndo.tsx:343
#: src/features/admin/components/MaintenanceControl.tsx:262
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:447
#: src/features/sources/components/AISummaryPanel.tsx:633
msgid "Applica"
msgstr "Applica"

#: src/features/admin/components/AdminDecksAskAndo.tsx:217
msgid "Applica alla bozza"
msgstr "Applica alla bozza"

#: src/features/clean-control/components/policies/enforcement.ts:41
msgid "Applica automaticamente"
msgstr "Applica automaticamente"

#: src/features/clean-control/components/policies/enforcement.ts:34
msgid "Applica con approvazione"
msgstr "Applica con approvazione"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:424
msgid "Applica filtro"
msgstr "Applica filtro"

#: src/features/sources/components/ArtifactPane.tsx:1556
msgid "Applica le modifiche proposte a questo documento"
msgstr "Applica le modifiche proposte a questo documento"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:338
msgid "Applica modifica AI alla slide"
msgstr "Applica modifica AI alla slide"

#: src/features/sources/components/AISummaryPanel.tsx:550
#: src/features/sources/components/ArtifactPane.tsx:1583
#: src/features/sources/components/ArtifactPane.tsx:2128
#: src/features/sources/components/ArtifactPane.tsx:2137
msgid "Applica modifiche"
msgstr "Applica modifiche"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:367
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:368
msgid "Applica periodo"
msgstr "Applica periodo"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:381
msgid "Applica riscrittura"
msgstr "Applica riscrittura"

#: src/features/sources/components/ArtifactPane.tsx:2114
msgid "Applica tutto"
msgstr "Applica tutto"

#: src/features/sources/components/AISummaryPanel.tsx:607
#: src/features/sources/components/ArtifactPane.tsx:2109
#: src/features/sources/components/ArtifactPane.tsx:2110
msgid "Applicare tutte le modifiche al documento?"
msgstr "Applicare tutte le modifiche al documento?"

#: src/features/clean-control/components/UndoActionsList.tsx:211
msgid "applicata {applied}"
msgstr "applicata {applied}"

#: src/features/console/components/ConsoleShell.tsx:229
msgid "Applications"
msgstr "Applications"

#: src/features/admin/components/AdminCpqAskAndo.tsx:170
#: src/features/admin/components/AdminCpqCanvas.tsx:151
#: src/features/admin/components/AdminCpqProposalCopy.tsx:38
msgid "Applicazioni"
msgstr "Applicazioni"

#: src/features/console/pages/ConnectorsPage.tsx:162
msgid "Applicazioni aziendali"
msgstr "Applicazioni aziendali"

#: src/features/admin/components/AdminCpq.tsx:635
msgid "Applicazioni in produzione"
msgstr "Applicazioni in produzione"

#: src/features/sources/components/ArtifactPane.tsx:1658
msgid "Applico le modifiche…"
msgstr "Applico le modifiche…"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:422
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:274
#: src/features/hive-flows/run/ProposalReview.tsx:342
msgid "Approva"
msgstr "Approva"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:143
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:150
msgid "Approva DRAFT"
msgstr "Approva DRAFT"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:497
msgid "Approva e crea"
msgstr "Approva e crea"

#: src/features/hive-flows/run/ProposalReview.tsx:343
msgid "Approva la proposta"
msgstr "Approva la proposta"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:573
#: src/features/dfm-rules/components/DfmRulesPage.tsx:574
msgid "Approva regola"
msgstr "Approva regola"

#: src/features/price-lists/components/PriceListsPage.tsx:715
#: src/features/price-lists/components/PriceListsPage.tsx:716
msgid "Approva voce"
msgstr "Approva voce"

#: src/features/admin/components/AdminHypermem.tsx:90
msgid "Approval Queue"
msgstr "Approval Queue"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:526
#: src/features/price-lists/components/PriceListsPage.tsx:656
msgid "Approvata"
msgstr "Approvata"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:70
msgid "Approvati"
msgstr "Approvati"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:145
msgid "Approvato"
msgstr "Approvato"

#: src/features/console/flows/ConsoleFlowApprovals.tsx:38
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:46
msgid "Approvato, il flow riprende"
msgstr "Approvato, il flow riprende"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1509
msgid "Approvazione"
msgstr "Approvazione"

#. placeholder {0}: err.message
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:568
msgid "Approvazione fallita: {0}"
msgstr "Approvazione fallita: {0}"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:569
msgid "Approvazione fallita."
msgstr "Approvazione fallita."

#: src/features/console/flows/ConsoleFlowApprovals.tsx:39
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:47
#: src/features/hive-flows/run/ProposalReview.tsx:251
msgid "Approvazione non riuscita"
msgstr "Approvazione non riuscita"

#: src/features/automations/components/AutomationDetailSection.tsx:169
#: src/features/console/pages/FlowDetailPage.tsx:222
msgid "Approvazione richiesta"
msgstr "Approvazione richiesta"

#: src/features/console/flows/ConsoleFlowApprovals.tsx:52
#: src/features/console/pages/FlowsPage.tsx:765
#: src/features/console/pages/FlowsPage.tsx:766
#: src/features/console/pages/FlowsPage.tsx:775
msgid "Approvazioni"
msgstr "Approvazioni"

#: src/features/admin/components/ZitadelPasswordActions.tsx:107
msgid "Appunti non disponibili in questo contesto"
msgstr "Appunti non disponibili in questo contesto"

#: src/features/dashboard/components/ShareDashboardSheet.tsx:292
msgid "Apre e legge i grafici"
msgstr "Apre e legge i grafici"

#: src/features/dashboard/components/ShareChartSheet.tsx:305
msgid "Apre e legge il grafico"
msgstr "Apre e legge il grafico"

#: src/features/console/docs/content.ts:1776
msgid "Apre un thread di memoria per gli agentic turn (scope query:read)."
msgstr "Apre un thread di memoria per gli agentic turn (scope query:read)."

#: src/features/console/docs/content.ts:1885
msgid "Apre una run e restituisce la SyncSession (context manager: complete su uscita pulita, abort su eccezione)."
msgstr "Apre una run e restituisce la SyncSession (context manager: complete su uscita pulita, abort su eccezione)."

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:422
#: src/features/admin/components/AdminDecks.tsx:256
#: src/features/admin/components/AdminDecks.tsx:549
#: src/features/admin/components/AdminDecks.tsx:646
#: src/features/billing/components/InvoicesTable.tsx:184
#: src/features/connect/components/connectShared.tsx:316
#: src/features/console/pages/AccessOverviewPage.tsx:306
#: src/features/console/pages/AccessOverviewPage.tsx:366
#: src/features/console/pages/ConnectorsPage.tsx:408
#: src/features/console/pages/OverviewPage.tsx:414
#: src/features/share/components/ShareLinkDialog.tsx:913
#: src/features/structured-data/components/OpenResultButton.tsx:103
#: src/features/voice_report/components/RunsTab.tsx:104
#: src/features/voice_report/components/ShareReportDialog.tsx:350
#: src/routes/_authed/workspace/flows.index.tsx:411
msgid "Apri"
msgstr "Apri"

#. placeholder {0}: primaryCtaProject.name
#: src/features/projects/components/ProjectHub.tsx:336
#: src/features/projects/components/ProjectHub.tsx:346
msgid "Apri \"{0}\""
msgstr "Apri \"{0}\""

#. placeholder {0}: flow.name
#: src/routes/_authed/workspace/flows.index.tsx:505
msgid "Apri {0}"
msgstr "Apri {0}"

#. placeholder {0}: d.date
#. placeholder {0}: d.day
#. placeholder {1}: MONTHS_IT[new Date(d.iso).getMonth()] ?? ""
#. placeholder {1}: d.date
#: src/routes/_authed/workspace/calendar.tsx:1048
#: src/routes/_authed/workspace/calendar.tsx:1270
msgid "Apri {0} {1}"
msgstr "Apri {0} {1}"

#: src/features/structured-data/components/DisplayResultChips.tsx:163
msgid "Apri {resolvedLabel} nella work-area"
msgstr "Apri {resolvedLabel} nella work-area"

#: src/features/actions/components/MessageActionChips.tsx:140
msgid "Apri anteprima"
msgstr "Apri anteprima"

#. placeholder {0}: doc.name
#: src/features/console/pages/DocumentsPage.tsx:853
msgid "Apri anteprima di {0}"
msgstr "Apri anteprima di {0}"

#: src/features/console/connectors/CustomConnectorDetail.tsx:578
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:494
#: src/features/console/pages/EmbeddedIdentityPage.tsx:411
msgid "Apri AppKeys"
msgstr "Apri AppKeys"

#. placeholder {0}: flow.name
#: src/features/projects/components/sections/AutomationsSection.tsx:136
msgid "Apri automazione: {0}"
msgstr "Apri automazione: {0}"

#. placeholder {0}: sub.name
#. placeholder {1}: sub.cumulative_count
#: src/features/workspace/documents/components/FolderBrowserView.tsx:237
msgid "Apri cartella {0} ({1} file)"
msgstr "Apri cartella {0} ({1} file)"

#: src/features/projects/components/ProjectDetailPage.tsx:612
#: src/features/structured-data/components/CadDataPanel.tsx:155
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:196
msgid "Apri chat"
msgstr "Apri chat"

#: src/routes/_authed/workspace/finance.tsx:604
msgid "Apri chat — scadenze fiscali"
msgstr "Apri chat — scadenze fiscali"

#. placeholder {0}: citation.respondent_id
#: src/features/report/components/CitationLink.tsx:62
#: src/features/report/components/CitationViewer.tsx:131
msgid "Apri citazione {index} (respondent {0})"
msgstr "Apri citazione {index} (respondent {0})"

#: ../../packages/ui/src/ando/SourceDrawer.tsx:350
msgid "Apri contesto completo"
msgstr "Apri contesto completo"

#: src/features/projects/components/sections/MemorySection.tsx:124
msgid "Apri conversazione"
msgstr "Apri conversazione"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:150
msgid "Apri conversazione che ha generato {displayName}"
msgstr "Apri conversazione che ha generato {displayName}"

#: src/features/chat/components/ConversationSidebar.tsx:1017
msgid "Apri conversazione: {display}"
msgstr "Apri conversazione: {display}"

#: src/features/hive-flows/run/RunHistoryRail.tsx:198
msgid "Apri cronologia"
msgstr "Apri cronologia"

#. placeholder {0}: dashboard.name
#: src/features/dashboard/components/DashboardListSidebar.tsx:257
msgid "Apri dashboard {0}"
msgstr "Apri dashboard {0}"

#. placeholder {0}: d.name
#: src/features/dashboard/components/ReceivedDashboardsList.tsx:61
msgid "Apri dashboard condivisa {0}"
msgstr "Apri dashboard condivisa {0}"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:634
msgid "Apri dati"
msgstr "Apri dati"

#: src/features/actions/components/MessageActionChips.tsx:138
msgid "Apri dettagli"
msgstr "Apri dettagli"

#. placeholder {0}: m.email ?? m.user_id
#. placeholder {0}: org.name
#: src/features/admin/components/AdminOrgs.tsx:1508
#: src/features/admin/components/orgs/OrgMembersTab.tsx:422
#: src/features/admin/components/orgs/OrgMembersTab.tsx:534
msgid "Apri dettagli di {0}"
msgstr "Apri dettagli di {0}"

#. placeholder {0}: it.suggested_workflow_name
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:680
msgid "Apri dettagli per {0}"
msgstr "Apri dettagli per {0}"

#: src/features/admin/components/AdminOrgs.tsx:1571
#: src/features/admin/components/userAdminActions.tsx:171
msgid "Apri dettaglio"
msgstr "Apri dettaglio"

#: src/features/clean-control/components/EventRow.tsx:313
msgid "Apri dettaglio completo"
msgstr "Apri dettaglio completo"

#. placeholder {0}: user.email
#: src/features/admin/components/AdminUsers.tsx:495
msgid "Apri dettaglio utente {0}"
msgstr "Apri dettaglio utente {0}"

#: src/features/actions/components/MessageActionChips.tsx:137
msgid "Apri documento"
msgstr "Apri documento"

#: src/features/studio/components/StudioDrawerContent.tsx:533
msgid "Apri editor template"
msgstr "Apri editor template"

#: src/features/sources/components/ArtifactToolbar.tsx:116
msgid "Apri esternamente"
msgstr "Apri esternamente"

#: src/features/console/pages/BillingPage.tsx:628
msgid "Apri fattura"
msgstr "Apri fattura"

#: src/features/billing/components/InvoicesTable.tsx:176
msgid "Apri fattura {invoiceRef} su Stripe"
msgstr "Apri fattura {invoiceRef} su Stripe"

#: src/routes/_authed/route.tsx:2519
msgid "Apri Focus chat"
msgstr "Apri Focus chat"

#. placeholder {0}: row.provenance.label
#: ../../packages/ui/src/ando/EditableTable.tsx:477
msgid "Apri fonte: {0}"
msgstr "Apri fonte: {0}"

#: src/features/console/pages/OverviewPage.tsx:375
msgid "Apri Fonti"
msgstr "Apri Fonti"

#: src/features/console/pages/OverviewPage.tsx:195
msgid "Apri Fonti per iniziare"
msgstr "Apri Fonti per iniziare"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:199
msgid "Apri Google Picker"
msgstr "Apri Google Picker"

#: src/features/console/traces/TraceGraph.tsx:269
msgid "Apri gruppi #{ordinal}–{lastOrdinal}"
msgstr "Apri gruppi #{ordinal}–{lastOrdinal}"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:621
msgid "Apri i dati certificati oppure scegli un grafico qui sopra per esplorare il risultato visivamente."
msgstr "Apri i dati certificati oppure scegli un grafico qui sopra per esplorare il risultato visivamente."

#: src/features/console/lib/onboarding.ts:74
msgid "Apri i documenti"
msgstr "Apri i documenti"

#: src/features/console/pages/PlaygroundPage.tsx:770
msgid "Apri i passaggi citati e confrontali con la risposta. I passaggi mostrati non misurano la completezza della ricerca."
msgstr "Apri i passaggi citati e confrontali con la risposta. I passaggi mostrati non misurano la completezza della ricerca."

#: src/features/console/pages/PlaygroundPage.tsx:770
msgid "Apri i riferimenti e confronta la risposta con i contenuti originali. I riferimenti mostrati non misurano la completezza della ricerca."
msgstr "Apri i riferimenti e confronta la risposta con i contenuti originali. I riferimenti mostrati non misurano la completezza della ricerca."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1171
#: src/features/studio/components/StudioDrawerContent.tsx:163
#: src/features/studio/components/StudioDrawerContent.tsx:164
#: src/features/studio/components/StudioDrawerContent.tsx:165
#: src/features/studio/components/StudioDrawerContent.tsx:489
msgid "Apri il Brand Kit"
msgstr "Apri il Brand Kit"

#: src/features/chat/components/ChatEmptyState.tsx:698
msgid "Apri il briefing completo"
msgstr "Apri il briefing completo"

#: src/features/admin/components/AdminCpqCanvas.tsx:269
msgid "Apri il campo"
msgstr "Apri il campo"

#: src/features/help/components/ShortcutsList.tsx:61
msgid "Apri il command palette"
msgstr "Apri il command palette"

#: src/features/help/components/ShortcutsList.tsx:98
msgid "Apri il composer in modalità schermo intero"
msgstr "Apri il composer in modalità schermo intero"

#: src/routes/_authed/route.tsx:1113
msgid "Apri il drawer delle fonti"
msgstr "Apri il drawer delle fonti"

#. placeholder {0}: result.title
#: src/features/chat/components/MessagePreviewEmbed.tsx:147
msgid "Apri il grafico: {0}"
msgstr "Apri il grafico: {0}"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:189
msgid "Apri il picker per scegliere un foglio da {providerLabel}."
msgstr "Apri il picker per scegliere un foglio da {providerLabel}."

#: src/features/console/pages/UsagePage.tsx:373
msgid "Apri il Playground"
msgstr "Apri il Playground"

#: src/features/console/pages/GetStartedPage.tsx:155
msgid "Apri il Playground per provare una richiesta reale. Il consumo comparirà qui automaticamente."
msgstr "Apri il Playground per provare una richiesta reale. Il consumo comparirà qui automaticamente."

#. placeholder {0}: props.payload.title
#: src/features/chat/components/MessagePreviewEmbed.tsx:188
msgid "Apri il report Voice of X: {0}"
msgstr "Apri il report Voice of X: {0}"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:167
msgid "Apri il risultato"
msgstr "Apri il risultato"

#: src/routes/connect.space.$spaceId.tsx:76
msgid "Apri il tuo link di invito"
msgstr "Apri il tuo link di invito"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1236
msgid "Apri impostazioni"
msgstr "Apri impostazioni"

#. placeholder {0}: KIND_LABEL[kind]
#. placeholder {0}: chatProviderLabel(providerId)
#. placeholder {0}: emailProviderLabel(providerId)
#: src/features/sources/components/ArtifactToolbar.tsx:103
#: src/features/sources/components/ArtifactToolbar.tsx:116
#: src/features/sources/components/InboxDetailPane.tsx:706
#: src/features/sources/components/InboxDetailPane.tsx:777
msgid "Apri in {0}"
msgstr "Apri in {0}"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:167
msgid "Apri in {label}"
msgstr "Apri in {label}"

#: src/features/sources/components/ArtifactToolbar.tsx:104
msgid "Apri in applicazione esterna"
msgstr "Apri in applicazione esterna"

#: src/features/hive-flows/run/ScopedChatPanel.tsx:82
#: src/routes/_authed/workspace/connect.$spaceId.tsx:236
#: src/routes/_authed/workspace/connect.$spaceId.tsx:482
msgid "Apri in chat"
msgstr "Apri in chat"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:468
msgid "Apri integrazioni"
msgstr "Apri integrazioni"

#: src/features/console/components/CommandCenter.tsx:34
msgid "Apri l'assistente AI"
msgstr "Apri l'assistente AI"

#: src/features/workspace/components/ProjectPill.tsx:82
msgid "Apri l'hub progetti"
msgstr "Apri l'hub progetti"

#: src/features/chat/components/MessagePreviewEmbed.tsx:252
msgid "Apri l'illustrazione: {title}"
msgstr "Apri l'illustrazione: {title}"

#: src/features/chat/components/MessagePreviewEmbed.tsx:228
msgid "Apri l'immagine: {title}"
msgstr "Apri l'immagine: {title}"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:223
msgid "Apri la chat, esegui la query e usa “Salva in dashboard” per pinnare il risultato."
msgstr "Apri la chat, esegui la query e usa “Salva in dashboard” per pinnare il risultato."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:553
msgid "Apri la configurazione di WhatsApp nel browser"
msgstr "Apri la configurazione di WhatsApp nel browser"

#: src/features/projects/components/sections/MemorySection.tsx:123
msgid "Apri la conversazione che ha generato questo ricordo"
msgstr "Apri la conversazione che ha generato questo ricordo"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:213
msgid "Apri la finestra del picker per scegliere cartelle o file."
msgstr "Apri la finestra del picker per scegliere cartelle o file."

#: src/features/maintenance/MaintenanceScreen.tsx:231
msgid "Apri la pagina di stato"
msgstr "Apri la pagina di stato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:345
msgid "Apri la prima app"
msgstr "Apri la prima app"

#: src/features/sources/components/InboxDetailPane.tsx:2186
msgid "Apri la risposta e fai scrivere una bozza a Ando"
msgstr "Apri la risposta e fai scrivere una bozza a Ando"

#: src/features/chat/components/MessagePreviewEmbed.tsx:294
msgid "Apri la tabella: {title}"
msgstr "Apri la tabella: {title}"

#: src/features/console/pages/ResourceAccessPage.tsx:781
msgid "Apri le app"
msgstr "Apri le app"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:534
msgid "Apri lo storico sync"
msgstr "Apri lo storico sync"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:477
msgid "Apri membri"
msgstr "Apri membri"

#: src/features/help/components/ShortcutsList.tsx:103
msgid "Apri menu comandi nel composer"
msgstr "Apri menu comandi nel composer"

#: ../../packages/ui/src/ando/UserMenu.tsx:67
msgid "Apri menu di {name}"
msgstr "Apri menu di {name}"

#: ../../packages/ui/src/ando/UserMenu.tsx:67
msgid "Apri menu utente"
msgstr "Apri menu utente"

#: src/features/share/components/ShareLinkRow.tsx:190
msgid "Apri nel browser"
msgstr "Apri nel browser"

#: src/features/sources/components/CalendarEventPane.tsx:507
msgid "Apri nel calendario"
msgstr "Apri nel calendario"

#: src/features/console/pages/DocumentsPage.tsx:462
msgid "Apri o scarica il file"
msgstr "Apri o scarica il file"

#: src/features/help/components/KeyboardShortcutsOverlay.tsx:57
msgid "Apri pagina completa"
msgstr "Apri pagina completa"

#: ../../packages/ui/src/editors/ReviewRail.tsx:161
msgid "Apri pannello revisione modifiche"
msgstr "Apri pannello revisione modifiche"

#: src/features/chat/components/MessagePreviewEmbed.tsx:108
#: src/features/chat/components/MessagePreviewEmbed.tsx:167
msgid "Apri per esplorare →"
msgstr "Apri per esplorare →"

#: src/features/console/pages/ConnectorDetailPage.tsx:410
#: src/features/console/pages/GetStartedPage.tsx:165
msgid "Apri Playground"
msgstr "Apri Playground"

#: src/features/billing/components/CurrentPlanCard.tsx:158
msgid "Apri portale Stripe"
msgstr "Apri portale Stripe"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:391
msgid "Apri portale Stripe in una nuova scheda"
msgstr "Apri portale Stripe in una nuova scheda"

#: src/features/chat/components/ConversationSidebar.tsx:815
msgid "Apri progetto"
msgstr "Apri progetto"

#. placeholder {0}: current.name
#: src/features/workspace/components/ProjectPill.tsx:81
msgid "Apri progetto · {0}"
msgstr "Apri progetto · {0}"

#. placeholder {0}: project.name
#: src/features/chat/components/ConversationSidebar.tsx:751
#: src/features/projects/components/ProjectHub.tsx:644
msgid "Apri progetto: {0}"
msgstr "Apri progetto: {0}"

#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:163
msgid "Apri revisione completa"
msgstr "Apri revisione completa"

#: src/features/studio/components/StudioPillTrigger.tsx:73
msgid "Apri Studio"
msgstr "Apri Studio"

#: src/features/studio/components/StudioPillTrigger.tsx:50
msgid "Apri Studio (Modes, Brand, Voice, Templates)"
msgstr "Apri Studio (Modes, Brand, Voice, Templates)"

#: ../../packages/ui/src/ando/sources/web/WebPreview.tsx:294
msgid "Apri su {host}"
msgstr "Apri su {host}"

#: src/routes/_authed/_modal/integrations/$capability.tsx:282
msgid "Apri Tecnico"
msgstr "Apri Tecnico"

#: ../../packages/ui/src/ando/sources/email/EmailActions.tsx:32
msgid "Apri thread"
msgstr "Apri thread"

#: src/features/studio/components/StudioDrawerContent.tsx:161
msgid "Apri tutti i Modes"
msgstr "Apri tutti i Modes"

#: src/features/console/traces/TracePayloadReader.tsx:201
msgid "Apri un campo per leggere il contenuto originale. Le pagine dichiarano elementi e caratteri; il download conserva il payload completo."
msgstr "Apri un campo per leggere il contenuto originale. Le pagine dichiarano elementi e caratteri; il download conserva il payload completo."

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:64
msgid "Apri un caso dallo storico a sinistra per vedere email, risposta e soluzione individuata."
msgstr "Apri un caso dallo storico a sinistra per vedere email, risposta e soluzione individuata."

#: ../../packages/ui/src/editors/ReviewRail.tsx:498
msgid "Apri un documento per vedere le modifiche proposte."
msgstr "Apri un documento per vedere le modifiche proposte."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:426
msgid "Apri un sync, invia i record a batch (max 500), poi completa. Ando fa chunking, embedding, ACL e versioning: i dati diventano interrogabili da /query e /agentic."
msgstr "Apri un sync, invia i record a batch (max 500), poi completa. Ando fa chunking, embedding, ACL e versioning: i dati diventano interrogabili da /query e /agentic."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:455
msgid "Apri una chat Ando — stessa esperienza di sempre — che risponde solo dalle fonti che {ownerOrg} ha condiviso qui, in sola lettura."
msgstr "Apri una chat Ando — stessa esperienza di sempre — che risponde solo dalle fonti che {ownerOrg} ha condiviso qui, in sola lettura."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:460
msgid "Apri una chat Ando — stessa esperienza di sempre — che risponde solo dalle fonti condivise in quest'area, in sola lettura."
msgstr "Apri una chat Ando — stessa esperienza di sempre — che risponde solo dalle fonti condivise in quest'area, in sola lettura."

#: src/features/console/pages/TracesPage.tsx:430
msgid "Apri una chiamata o un evento"
msgstr "Apri una chiamata o un evento"

#: src/features/console/docs/content.ts:517
msgid "Apri una conversazione"
msgstr "Apri una conversazione"

#: src/features/onboarding/sectionGuides.ts:69
msgid "Apri una delle Canvas di esempio per vedere come si combinano fonti e analisi in un unico spazio."
msgstr "Apri una delle Canvas di esempio per vedere come si combinano fonti e analisi in un unico spazio."

#: src/features/console/pages/ConnectorsPage.tsx:576
msgid "Apri una fonte in errore per ripristinare autorizzazione o sincronizzazione."
msgstr "Apri una fonte in errore per ripristinare autorizzazione o sincronizzazione."

#: src/features/console/pages/ConnectorsPage.tsx:353
msgid "Apri una fonte per sincronizzarla. Da Accessi scegli chi può leggere i dati indicizzati; la connessione originale resta privata."
msgstr "Apri una fonte per sincronizzarla. Da Accessi scegli chi può leggere i dati indicizzati; la connessione originale resta privata."

#: src/features/console/docs/content.ts:723
msgid "Apri una run (mode full o incremental), spingi batch (≤500 record, Idempotency-Key per batch) su .../records, poi .../complete. L'SDK AndoConnector fa batching, retry con backoff e abort-on-exception."
msgstr "Apri una run (mode full o incremental), spingi batch (≤500 record, Idempotency-Key per batch) su .../records, poi .../complete. L'SDK AndoConnector fa batching, retry con backoff e abort-on-exception."

#: src/features/dxf/components/DxfPreviewStage.tsx:572
msgid "Apri viewer navigabile"
msgstr "Apri viewer navigabile"

#: src/features/share/components/ShareLinkDialog.tsx:687
msgid "Apri WhatsApp"
msgstr "Apri WhatsApp"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:826
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1602
msgid "Arancio"
msgstr "Arancio"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1677
msgid "Arancio Lab"
msgstr "Arancio Lab"

#: src/features/projects/components/ProjectIcon.tsx:110
msgid "Arancione"
msgstr "Arancione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:668
#: src/features/projects/components/TemplatesBrowserDialog.tsx:85
msgid "Architettura"
msgstr "Architettura"

#: src/features/admin/components/AdminDecks.tsx:267
#: src/features/chat/components/ConversationSidebar.tsx:630
#: src/features/chat/components/ConversationSidebar.tsx:827
#: src/features/clean-control/utils/signalCatalog.ts:137
#: src/features/projects/components/ProjectHub.tsx:232
#: src/features/sources/components/InboxDetailPane.tsx:2174
#: src/features/workspace/components/InboxItemRow.tsx:257
#: src/features/workspace/inbox/components/InboxBulkActionBar.tsx:75
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:323
msgid "Archivia"
msgstr "Archivia"

#: src/features/clean-control/utils/labels.ts:117
msgid "Archivia automaticamente"
msgstr "Archivia automaticamente"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:314
msgid "Archivia canvas"
msgstr "Archivia canvas"

#: src/features/sources/components/InboxDetailPane.tsx:2166
msgid "Archivia email"
msgstr "Archivia email"

#. placeholder {0}: project.name
#: src/features/projects/components/ProjectHub.tsx:688
msgid "Archivia progetto {0}"
msgstr "Archivia progetto {0}"

#: src/features/clean-control/components/EventQueue.tsx:280
msgid "Archivia tutti"
msgstr "Archivia tutti"

#. placeholder {0}: project.name
#: src/features/chat/components/ConversationSidebar.tsx:626
#: src/features/projects/components/ProjectHub.tsx:228
msgid "Archiviare \"{0}\"?"
msgstr "Archiviare \"{0}\"?"

#. placeholder {0}: deck.title
#: src/features/admin/components/AdminDecks.tsx:263
msgid "Archiviare «{0}»? Resta recuperabile da Archiviate; i link già inviati continuano a funzionare."
msgstr "Archiviare «{0}»? Resta recuperabile da Archiviate; i link già inviati continuano a funzionare."

#: src/features/sales/components/CampaignsPanel.tsx:222
msgid "Archiviata"
msgstr "Archiviata"

#: src/features/admin/components/AdminDecks.tsx:184
msgid "Archiviate"
msgstr "Archiviate"

#: src/routes/_authed/workspace/canvases.tsx:189
msgid "archiviati"
msgstr "archiviati"

#: src/routes/_authed/workspace/canvases.tsx:204
msgid "Archiviati"
msgstr "Archiviati"

#: src/features/automations/components/AutomationStatusChip.tsx:37
#: src/features/canvases/components/CanvasStatusChip.tsx:35
#: src/features/console/components/StatusBadges.tsx:186
#: src/features/hive-flows/components/FlowActivateControl.tsx:53
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:320
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:451
#: src/routes/_authed/workspace/connect.$spaceId.tsx:252
#: src/routes/_authed/workspace/connect.$spaceId.tsx:427
#: src/routes/_authed/workspace/flows.index.tsx:71
msgid "Archiviato"
msgstr "Archiviato"

#: src/features/briefing/briefingActions.ts:83
msgid "Archiviazione bulk in arrivo"
msgstr "Archiviazione bulk in arrivo"

#: src/features/connectors/wizards/legalStorageSpec.tsx:23
msgid "Archiviazione decennale conforme CAD (Codice Amministrazione Digitale)"
msgstr "Archiviazione decennale conforme CAD (Codice Amministrazione Digitale)"

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:300
msgid "Archiviazione non disponibile per questo canale."
msgstr "Archiviazione non disponibile per questo canale."

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:326
msgid "Archiviazione non riuscita"
msgstr "Archiviazione non riuscita"

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:442
msgid "Archiviazione parzialmente non riuscita"
msgstr "Archiviazione parzialmente non riuscita"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:115
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:101
msgid "Archivio Ando"
msgstr "Archivio Ando"

#. placeholder {0}: item.channel
#: src/features/sources/components/InboxDetailPane.tsx:295
msgid "Archivio non supportato per il canale {0}."
msgstr "Archivio non supportato per il canale {0}."

#: src/features/settings/components/DataExport.tsx:235
msgid "Archivio pronto"
msgstr "Archivio pronto"

#: src/features/sources/components/InboxDetailPane.tsx:2174
msgid "Archivio…"
msgstr "Archivio…"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2063
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:57
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:41
msgid "Area"
msgstr "Area"

#: src/routes/_authed/route.tsx:1818
msgid "Area · {areaName}"
msgstr "Area · {areaName}"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:257
msgid "Area 2D"
msgstr "Area 2D"

#: src/routes/_authed/_modal/admin/route.tsx:187
msgid "Area amministrativa"
msgstr "Area amministrativa"

#: src/routes/_authed/_modal/route.tsx:170
msgid "Area amministrativa a schermo intero"
msgstr "Area amministrativa a schermo intero"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:482
msgid "Area archiviata"
msgstr "Area archiviata"

#: src/routes/_authed/route.tsx:1479
msgid "Area condivisa"
msgstr "Area condivisa"

#: src/routes/_authed/route.tsx:958
msgid "Area di lavoro"
msgstr "Area di lavoro"

#: src/features/structured-data/components/CadDataPanel.tsx:285
msgid "Area selezionata"
msgstr "Area selezionata"

#: src/features/workspace/components/UploadModal.tsx:332
msgid "Area trascinamento file — clicca per scegliere"
msgstr "Area trascinamento file — clicca per scegliere"

#. placeholder {0}: spatial.min_x.toFixed(0)
#. placeholder {1}: spatial.max_x.toFixed(0)
#. placeholder {2}: spatial.min_y.toFixed(0)
#. placeholder {3}: spatial.max_y.toFixed(0)
#: src/features/structured-data/components/CadDataPanel.tsx:280
msgid "Area: X {0}–{1}, Y {2}–{3}"
msgstr "Area: X {0}–{1}, Y {2}–{3}"

#. placeholder {0}: idx + 1
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:338
msgid "Argomento {0}"
msgstr "Argomento {0}"

#. placeholder {0}: i + 1
#: src/features/dashboard/utils/calculatedFields.ts:326
msgid "Argomento {0} mancante"
msgstr "Argomento {0} mancante"

#: src/features/admin/components/AdminRevenue.tsx:89
msgid "ARR · Annual"
msgstr "ARR · Annual"

#: src/features/sales/hooks/useCrmQueries.ts:371
msgid "Arricchimento non riuscito"
msgstr "Arricchimento non riuscito"

#: src/features/sales/components/crm/RecordDrawer.tsx:183
msgid "Arricchisci con AI"
msgstr "Arricchisci con AI"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:26
msgid "Arricchita con AI"
msgstr "Arricchita con AI"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:29
msgid "Arricchito con AI"
msgstr "Arricchito con AI"

#: src/features/dashboard/utils/calculatedFields.ts:72
msgid "Arrotonda"
msgstr "Arrotonda"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1980
msgid "Arrotondato"
msgstr "Arrotondato"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:104
msgid "Asola"
msgstr "Asola"

#: src/features/sources/components/CalendarEventPane.tsx:320
msgid "Aspetta che l'AI finisca di prepararlo."
msgstr "Aspetta che l'AI finisca di prepararlo."

#: ../../packages/ui/src/editors/DraftActionBar.tsx:187
msgid "Aspetto"
msgstr "Aspetto"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1325
msgid "Aspetto del documento"
msgstr "Aspetto del documento"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:195
msgid "Aspetto del documento (attuale: {aspettoLabel})"
msgstr "Aspetto del documento (attuale: {aspettoLabel})"

#: src/features/structured-data/components/SimilarPartsSection.tsx:212
msgid "Asse di similarità"
msgstr "Asse di similarità"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:220
msgid "Asse X"
msgstr "Asse X"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:227
msgid "Asse Y"
msgstr "Asse Y"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:295
msgid "Assegna"
msgstr "Assegna"

#: src/features/sales/components/AssigneePicker.tsx:95
msgid "Assegna a"
msgstr "Assegna a"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:276
msgid "Assegna credito (USD)"
msgstr "Assegna credito (USD)"

#: src/features/admin/components/AdminPlatformSettings.tsx:985
msgid "Assegna il modello per ogni slot del sistema. Un override prende effetto alla prossima risoluzione modello; slot vuoto = default da configurazione."
msgstr "Assegna il modello per ogni slot del sistema. Un override prende effetto alla prossima risoluzione modello; slot vuoto = default da configurazione."

#: src/features/sales/components/AssigneePicker.tsx:69
msgid "Assegna lead"
msgstr "Assegna lead"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:27
msgid "Assegnata"
msgstr "Assegnata"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:258
#: src/features/sales/components/crm/ActivityNotesPane.tsx:32
msgid "Assegnato"
msgstr "Assegnato"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:207
msgid "Assegnazione credito fallita"
msgstr "Assegnazione credito fallita"

#: src/features/sales/components/AssigneePicker.tsx:58
msgid "Assegnazione rimossa"
msgstr "Assegnazione rimossa"

#: src/features/price-lists/utils/formatItem.ts:36
msgid "Assemblaggio"
msgstr "Assemblaggio"

#: src/features/settings/components/BrandKitSettings.tsx:470
msgid "Asset visivi del Brand Kit usati su copertine e generazione documenti."
msgstr "Asset visivi del Brand Kit usati su copertine e generazione documenti."

#: src/features/console/components/AssistPanel.tsx:227
#: src/routes/connect.chatbot.$publicToken.tsx:124
msgid "Assistente"
msgstr "Assistente"

#: src/routes/connect.chatbot.$publicToken.tsx:184
#: src/routes/connect.chatbot.$publicToken.tsx:192
msgid "Assistente {name}"
msgstr "Assistente {name}"

#: src/routes/connect.chatbot.$publicToken.tsx:132
msgid "Assistente Ando"
msgstr "Assistente Ando"

#: src/features/console/components/AssistPanel.tsx:216
msgid "Assistente della console"
msgstr "Assistente della console"

#: src/routes/connect.chatbot.$publicToken.tsx:107
msgid "Assistente non disponibile"
msgstr "Assistente non disponibile"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:54
msgid "Assistenza email"
msgstr "Assistenza email"

#: src/features/console/connectors/CustomConnectorDetail.tsx:599
msgid "Associa AppKey"
msgstr "Associa AppKey"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:485
msgid "Associa utente"
msgstr "Associa utente"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:372
msgid "Assunzioni"
msgstr "Assunzioni"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:175
msgid "Attendi qualche secondo, poi riprova."
msgstr "Attendi qualche secondo, poi riprova."

#: src/features/chat/wsHandlers.ts:325
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:290
#: src/features/sources/components/CalendarEventPane.tsx:157
msgid "Attenzione"
msgstr "Attenzione"

#: src/features/console/pages/PlaygroundPage.tsx:2088
msgid "Attesa interrotta"
msgstr "Attesa interrotta"

#: src/features/admin/components/AdminCpqPriceBook.tsx:348
msgid "Atteso (USD)"
msgstr "Atteso (USD)"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:83
msgid "Atti, repertorio, antiriciclaggio"
msgstr "Atti, repertorio, antiriciclaggio"

#: src/features/admin/components/AdminDecks.tsx:640
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:698
msgid "attiva"
msgstr "attiva"

#: src/features/account/components/OrgSwitcherDialog.tsx:242
#: src/features/admin/components/AdminOrgs.tsx:1544
#: src/features/admin/components/orgs/OrgDetailShell.tsx:323
#: src/features/chat/components/ConversationCommandPalette.tsx:263
#: src/features/console/components/KeyMeta.tsx:34
#: src/features/console/connectors/ConnectionCard.tsx:45
#: src/features/console/pages/EmbeddedIdentityPage.tsx:359
#: src/features/console/pages/FlowDetailPage.tsx:107
#: src/features/console/pages/FlowsPage.tsx:619
#: src/features/console/webhooks/WebhooksPanel.tsx:600
#: src/features/hive-flows/components/FlowActivateControl.tsx:253
#: src/features/sales/components/CampaignsPanel.tsx:226
#: src/features/skills/components/SkillsList.tsx:406
msgid "Attiva"
msgstr "Attiva"

#. placeholder {0}: skill.name
#: src/features/skills/components/SkillsList.tsx:409
msgid "Attiva «{0}»"
msgstr "Attiva «{0}»"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:413
msgid "Attiva abbonamento"
msgstr "Attiva abbonamento"

#: src/features/console/pages/EngineSignupPage.tsx:115
msgid "Attiva Ando Engine"
msgstr "Attiva Ando Engine"

#: src/features/console/pages/EngineSignupPage.tsx:164
msgid "Attiva Engine"
msgstr "Attiva Engine"

#: src/features/console/pages/EngineSignupPage.tsx:125
msgid "Attiva Engine per la tua organizzazione"
msgstr "Attiva Engine per la tua organizzazione"

#: src/features/settings/components/SelfProfileMemory.tsx:452
msgid "Attiva il consenso qui sopra per iniziare a personalizzare le risposte di Ando. Nessun fatto verrà salvato prima del tuo esplicito assenso."
msgstr "Attiva il consenso qui sopra per iniziare a personalizzare le risposte di Ando. Nessun fatto verrà salvato prima del tuo esplicito assenso."

#: src/features/hive-flows/components/FlowActivateControl.tsx:231
msgid "Attiva il flow"
msgstr "Attiva il flow"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:269
msgid "Attiva il motore di retrieval sperimentale TERRA"
msgstr "Attiva il motore di retrieval sperimentale TERRA"

#. placeholder {0}: webhook.url
#: src/features/console/webhooks/WebhooksPanel.tsx:589
msgid "Attiva il webhook {0}"
msgstr "Attiva il webhook {0}"

#: src/features/admin/components/orgs/OrgCostTab.tsx:249
msgid "Attiva Inspect (15m)"
msgstr "Attiva Inspect (15m)"

#: src/features/admin/components/UserDetailContent.tsx:892
msgid "Attiva Inspect Mode (5m)"
msgstr "Attiva Inspect Mode (5m)"

#. placeholder {0}: entry.specialist_name ?? t`questo specialist`
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:154
msgid "Attiva la nuova versione del prompt. La versione ATTIVA corrente per {0} verrà DEPRECATA."
msgstr "Attiva la nuova versione del prompt. La versione ATTIVA corrente per {0} verrà DEPRECATA."

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:349
msgid "Attiva la selezione e trascina per scegliere un'area"
msgstr "Attiva la selezione e trascina per scegliere un'area"

#: src/features/admin/components/MaintenanceControl.tsx:292
msgid "Attiva manutenzione"
msgstr "Attiva manutenzione"

#: src/features/help/components/ShortcutsList.tsx:120
msgid "Attiva o disattiva la modalità Focus"
msgstr "Attiva o disattiva la modalità Focus"

#: src/features/clean-control/components/policies/PolicyRow.tsx:140
msgid "Attiva o disattiva la policy"
msgstr "Attiva o disattiva la policy"

#: src/features/settings/components/NotificationPreferences.tsx:357
msgid "Attiva o disattiva singolarmente le sei categorie del Proactive Layer."
msgstr "Attiva o disattiva singolarmente le sei categorie del Proactive Layer."

#: src/features/skills/components/SkillsList.tsx:381
msgid "Attiva per tutto il team"
msgstr "Attiva per tutto il team"

#: src/features/console/pages/ModelsPage.tsx:248
msgid "Attiva profilo"
msgstr "Attiva profilo"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:207
msgid "Attiva ricerca web"
msgstr "Attiva ricerca web"

#: src/routes/_authed/workspace/finance.tsx:1091
msgid "Attiva tutto"
msgstr "Attiva tutto"

#. placeholder {0}: resolveDisplayName( l.connector_key, )
#. placeholder {1}: members.length
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:452
msgid "Attiva/disattiva {0} per tutti (attualmente {assigned}/{1})"
msgstr "Attiva/disattiva {0} per tutti (attualmente {assigned}/{1})"

#: src/features/admin/components/MaintenanceControl.tsx:272
msgid "Attivare la manutenzione adesso?"
msgstr "Attivare la manutenzione adesso?"

#: src/features/admin/components/AdminDemoInviti.tsx:229
msgid "Attivato"
msgstr "Attivato"

#: src/features/hive-flows/components/FlowActivateControl.tsx:158
msgid "Attivazione non riuscita"
msgstr "Attivazione non riuscita"

#: src/features/admin/components/orgs/OrgCostTab.tsx:254
msgid "Attivazione non riuscita. Riprova."
msgstr "Attivazione non riuscita. Riprova."

#: src/features/settings/components/OtpEmailPanel.tsx:246
msgid "Attivazione…"
msgstr "Attivazione…"

#: src/features/admin/components/AdminDecks.tsx:184
#: src/features/admin/components/AdminOrgs.tsx:834
#: src/features/admin/components/AdminOrgs.tsx:887
#: src/features/workspace/config.ts:433
msgid "Attive"
msgstr "Attive"

#: src/features/admin/components/AdminUsers.tsx:263
#: src/features/workspace/config.ts:440
#: src/routes/_authed/workspace/canvases.tsx:203
msgid "Attivi"
msgstr "Attivi"

#: src/features/admin/components/AdminEngagement.tsx:146
msgid "attivi mese"
msgstr "attivi mese"

#: src/features/admin/components/AdminEngagement.tsx:141
msgid "attivi settimana"
msgstr "attivi settimana"

#: src/features/projects/components/ProjectDetailPage.tsx:248
#: src/features/sales/components/crm/ActivityNotesPane.tsx:75
#: src/routes/_authed/workspace/connect.$spaceId.tsx:327
msgid "Attività"
msgstr "Attività"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:31
msgid "Attività collegata"
msgstr "Attività collegata"

#: ../../packages/ui/src/ando/chat/ThinkingChain.tsx:202
#: ../../packages/ui/src/ando/chat/ThinkingChain.tsx:203
#: ../../packages/ui/src/ando/chat/ThinkingChain.tsx:223
#: ../../packages/ui/src/ando/chat/ThinkingChain.tsx:266
msgid "Attività della richiesta"
msgstr "Attività della richiesta"

#: src/features/sales/components/LeadDetailDrawer.tsx:287
msgid "Attività e note"
msgstr "Attività e note"

#: src/features/sales/components/SalesOverview.tsx:374
msgid "Attività recente"
msgstr "Attività recente"

#: src/features/console/pages/OverviewPage.tsx:262
#: src/features/console/pages/OverviewPage.tsx:316
msgid "Attività recenti"
msgstr "Attività recenti"

#: src/features/connectors/wizards/projectManagementSpec.tsx:70
msgid "Attività sempre a portata"
msgstr "Attività sempre a portata"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:302
msgid "Attività ultima giornata"
msgstr "Attività ultima giornata"

#: src/features/admin/components/AdminEngagement.tsx:115
msgid "Attività utenti — DAU/WAU/MAU + stickiness"
msgstr "Attività utenti — DAU/WAU/MAU + stickiness"

#: src/features/projects/components/sections/AutomationsSection.tsx:176
#: src/routes/_authed/workspace/flows.$flowId.tsx:222
msgid "attivo"
msgstr "attivo"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:665
#: src/features/admin/components/AdminDemoInviti.tsx:43
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:57
#: src/features/admin/components/orgs/OrgMembersTab.tsx:503
#: src/features/admin/components/UserDetailContent.tsx:508
#: src/features/automations/components/AutomationStatusChip.tsx:34
#: src/features/billing/components/CurrentPlanCard.tsx:47
#: src/features/connect/components/ChatbotPanel.tsx:97
#: src/features/connect/components/MemberManager.tsx:216
#: src/features/connectors/components/ConnectedAccountRow.tsx:385
#: src/features/connectors/components/ConnectorStatus.tsx:113
#: src/features/connectors/components/ConnectorStatus.tsx:233
#: src/features/console/components/StatusBadges.tsx:184
#: src/features/console/components/StatusBadges.tsx:239
#: src/features/console/connectors/CustomConnectorsPanel.tsx:310
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/ResourceAccessPage.tsx:698
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:362
#: src/features/hive-flows/components/FlowActivateControl.tsx:51
#: src/features/settings/components/OtpEmailPanel.tsx:280
#: src/features/settings/components/SelfProfileMemory.tsx:321
#: src/routes/_authed/workspace/flows.index.tsx:69
msgid "Attivo"
msgstr "Attivo"

#: src/features/settings/components/SelfProfileMemory.tsx:330
msgid "Attivo dal {consentAtFormatted}"
msgstr "Attivo dal {consentAtFormatted}"

#: src/features/projects/components/sections/PersonaSection.tsx:242
msgid "Attivo: {activeModeName}."
msgstr "Attivo: {activeModeName}."

#: src/features/hive-flows/components/FlowActivateControl.tsx:253
msgid "Attivo…"
msgstr "Attivo…"

#: src/features/admin/components/orgs/AuditLogList.tsx:139
msgid "Attore"
msgstr "Attore"

#: src/features/console/pages/BillingPage.tsx:150
msgid "Attribuzione dei crediti"
msgstr "Attribuzione dei crediti"

#: src/features/hive-flows/components/FlowVersionMenu.tsx:123
#: src/features/settings/components/OrgMembersPanel.tsx:319
#: src/features/settings/components/SecuritySettings.tsx:338
msgid "attuale"
msgstr "attuale"

#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:126
msgid "Attuale"
msgstr "Attuale"

#. placeholder {0}: i18n._(defaultLabel)
#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:217
msgid "Attualmente: {0}"
msgstr "Attualmente: {0}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:401
msgid "Audience di questa app"
msgstr "Audience di questa app"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:183
#: src/features/automations/components/AutomationDetailSection.tsx:77
msgid "Audit"
msgstr "Audit"

#: src/features/admin/components/UserDetailContent.tsx:234
msgid "Audit log Inspect Mode"
msgstr "Audit log Inspect Mode"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:80
#: src/features/console/pages/KeyDetailPage.tsx:487
msgid "Audit trail"
msgstr "Audit trail"

#: src/features/admin/components/AdminHypermem.tsx:95
msgid "Audit Trail"
msgstr "Audit Trail"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:178
msgid "Audit trail eventi agent"
msgstr "Audit trail eventi agent"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:125
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:349
msgid "Aumenta zoom"
msgstr "Aumenta zoom"

#: src/features/help/components/ShortcutsList.tsx:142
msgid "Aumenta zoom nel viewer PDF"
msgstr "Aumenta zoom nel viewer PDF"

#. placeholder {0}: Math.abs(computedDelta)
#. placeholder {1}: r.suffix ?? ""
#: src/features/report/components/ComparisonGrid.tsx:146
msgid "Aumento di {0}{1}"
msgstr "Aumento di {0}{1}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Autentica un utente nella tua app e assegnagli un ID stabile."
msgstr "Autentica un utente nella tua app e assegnagli un ID stabile."

#: src/features/admin/components/UserDetailContent.tsx:586
#: src/features/console/components/ProviderAccounts.tsx:88
#: src/features/console/connectors/CustomConnectorDetail.tsx:630
#: src/features/console/connectors/ManifestConfigForm.tsx:109
msgid "Autenticazione"
msgstr "Autenticazione"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:759
msgid "Autenticazione Active Directory (Kerberos, chiavi AES). Le credenziali restano nel tuo computer (vault cifrato), mai sul cloud."
msgstr "Autenticazione Active Directory (Kerberos, chiavi AES). Le credenziali restano nel tuo computer (vault cifrato), mai sul cloud."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1693
msgid "Auto"
msgstr "Auto"

#: src/features/billing/components/CreditBalanceCard.tsx:80
msgid "Auto-ricarica"
msgstr "Auto-ricarica"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:398
msgid "Autocomplete contatti non attivo"
msgstr "Autocomplete contatti non attivo"

#: src/features/clean-control/components/ModeToggle.tsx:65
msgid "Automatica"
msgstr "Automatica"

#: src/features/dashboard/components/AxisConfigurator.tsx:337
msgid "Automatico"
msgstr "Automatico"

#: src/routes/_authed/_modal/admin/route.tsx:139
msgid "Automation"
msgstr "Automation"

#: src/features/admin/components/AdminAutomation.tsx:79
msgid "Automation dashboard"
msgstr "Automation dashboard"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:282
msgid "Automation:"
msgstr "Automation:"

#: src/features/admin/components/AdminAutomation.tsx:226
msgid "Automazione"
msgstr "Automazione"

#: src/features/automations/components/AutomationsHub.tsx:132
msgid "Automazione non trovata"
msgstr "Automazione non trovata"

#: src/features/automations/components/AutomationDetailSection.tsx:49
#: src/features/automations/components/AutomationsHub.tsx:149
#: src/features/projects/components/ProjectDetailPage.tsx:266
#: src/features/workspace/config.ts:196
#: src/features/workspace/config.ts:198
msgid "Automazioni"
msgstr "Automazioni"

#: src/features/automations/components/AutomationsHub.tsx:214
msgid "Automazioni — anteprima"
msgstr "Automazioni — anteprima"

#: src/features/chat/components/ChatEmptyState.tsx:347
msgid "Automazioni attive"
msgstr "Automazioni attive"

#: src/features/onboarding/sectionGuides.ts:62
msgid "Automazioni che Ando esegue per te su base ricorrente."
msgstr "Automazioni che Ando esegue per te su base ricorrente."

#: src/routes/_authed/workspace/flows.index.tsx:226
msgid "Automazioni visuali, a concetti — niente codice."
msgstr "Automazioni visuali, a concetti — niente codice."

#: src/features/connectors/components/ConnectAccountDialog.tsx:542
#: src/features/connectors/wizards/accountingSpec.tsx:113
#: src/features/connectors/wizards/calendarSpec.tsx:61
#: src/features/connectors/wizards/crmSpec.tsx:90
#: src/features/connectors/wizards/driveSpec.tsx:97
#: src/features/connectors/wizards/emailSpec.tsx:56
#: src/features/connectors/wizards/messagingSpec.tsx:69
#: src/features/connectors/wizards/messagingSpec.tsx:71
#: src/features/connectors/wizards/projectManagementSpec.tsx:56
msgid "Autorizza"
msgstr "Autorizza"

#: src/features/connectors/components/ConnectAccountDialog.tsx:533
msgid "Autorizza {vendorLabel}"
msgstr "Autorizza {vendorLabel}"

#: src/features/connectors/wizards/driveSpec.tsx:99
msgid "Autorizza accesso"
msgstr "Autorizza accesso"

#: src/features/connectors/wizards/calendarSpec.tsx:63
msgid "Autorizza calendario"
msgstr "Autorizza calendario"

#: src/features/connectors/wizards/crmSpec.tsx:92
msgid "Autorizza con CRM"
msgstr "Autorizza con CRM"

#: src/features/connectors/wizards/emailSpec.tsx:58
msgid "Autorizza email"
msgstr "Autorizza email"

#: src/features/connectors/wizards/accountingSpec.tsx:111
msgid "Autorizza Fatture in Cloud"
msgstr "Autorizza Fatture in Cloud"

#: src/features/connectors/wizards/projectManagementSpec.tsx:58
msgid "Autorizza il project management"
msgstr "Autorizza il project management"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Autorizzato"
msgstr "Autorizzato"

#: src/features/console/connectors/ConnectionCard.tsx:226
msgid "Autorizzazione scaduta: riconnetti per riprendere la sincronizzazione."
msgstr "Autorizzazione scaduta: riconnetti per riprendere la sincronizzazione."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:211
msgid "Autorizzerai il tuo account in entrambi i casi. Scegli la destinazione dei dati."
msgstr "Autorizzerai il tuo account in entrambi i casi. Scegli la destinazione dei dati."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:785
#: src/features/connectors/components/FilesystemConnectDialog.tsx:882
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:904
#: src/features/onboarding/DemoTour.tsx:289
msgid "Avanti"
msgstr "Avanti"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:416
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:264
msgid "Avanti →"
msgstr "Avanti →"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:236
msgid "Avanzamento importazione cronologia"
msgstr "Avanzamento importazione cronologia"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:203
msgid "Avanzamento profilazione"
msgstr "Avanzamento profilazione"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:534
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:510
#: src/features/voice_report/components/NewReportDialog.tsx:1026
msgid "Avanzate"
msgstr "Avanzate"

#: src/features/admin/components/AdminBilling.tsx:259
#: src/features/console/flows/ConsoleFlowEditor.tsx:55
#: src/routes/_authed/workspace/flows.$flowId.tsx:68
msgid "Avanzato"
msgstr "Avanzato"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:88
msgid "Avanzato · modifica la query che alimenta il grafico"
msgstr "Avanzato · modifica la query che alimenta il grafico"

#: src/features/admin/components/AdminRevenue.tsx:135
msgid "Average Revenue Per User"
msgstr "Average Revenue Per User"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:406
msgid "Avvia checkout Stripe in una nuova scheda"
msgstr "Avvia checkout Stripe in una nuova scheda"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1476
msgid "Avvia esecuzione"
msgstr "Avvia esecuzione"

#: src/features/settings/components/DataExport.tsx:145
msgid "Avvia esportazione"
msgstr "Avvia esportazione"

#: src/features/console/docs/content.ts:1385
msgid "Avvia il collegamento personale"
msgstr "Avvia il collegamento personale"

#: src/features/voice_report/components/RunsTab.tsx:171
msgid "Avvia il primo run dalla tab \"Impostazioni\" del report o dalla pagina principale per popolare la cronologia."
msgstr "Avvia il primo run dalla tab \"Impostazioni\" del report o dalla pagina principale per popolare la cronologia."

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:254
msgid "Avvia la prima sincronizzazione per pullare i movimenti dal provider open-banking."
msgstr "Avvia la prima sincronizzazione per pullare i movimenti dal provider open-banking."

#: src/features/connectors/components/management/SchemaViewer.tsx:883
msgid "Avvia la scoperta dal pulsante in alto per analizzare le tabelle disponibili."
msgstr "Avvia la scoperta dal pulsante in alto per analizzare le tabelle disponibili."

#: src/features/console/docs/content.ts:1512
msgid "Avvia OAuth personale"
msgstr "Avvia OAuth personale"

#: src/features/sales/components/LeadsPanel.tsx:227
msgid "Avvia ricerca"
msgstr "Avvia ricerca"

#: src/features/connectors/components/management/SchemaViewer.tsx:887
#: src/features/integrations/parts/ConnectorDetailSection.tsx:186
msgid "Avvia scoperta schema"
msgstr "Avvia scoperta schema"

#: src/features/settings/components/DataExport.tsx:317
msgid "Avvia una nuova esportazione"
msgstr "Avvia una nuova esportazione"

#: src/features/console/docs/content.ts:1472
#: src/features/console/docs/content.ts:1597
msgid "Avvia una pagina manualmente"
msgstr "Avvia una pagina manualmente"

#: src/features/sales/components/LeadsPanel.tsx:225
msgid "Avviare la ricerca approfondita?"
msgstr "Avviare la ricerca approfondita?"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:176
msgid "avviata {startedAgo}"
msgstr "avviata {startedAgo}"

#: src/features/console/connectors/CustomConnectorDetail.tsx:154
msgid "Avvio"
msgstr "Avvio"

#: src/features/connectors/components/ConnectAccountDialog.tsx:276
msgid "Avvio del flusso non riuscito."
msgstr "Avvio del flusso non riuscito."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:227
msgid "Avvio del job di scoperta…"
msgstr "Avvio del job di scoperta…"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:127
msgid "Avvio esperimento"
msgstr "Avvio esperimento"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:734
msgid "Avvio non riuscito"
msgstr "Avvio non riuscito"

#: src/features/sales/components/CampaignsPanel.tsx:149
msgid "Avvio ricerca…"
msgstr "Avvio ricerca…"

#: src/features/connectors/components/ConnectAccountDialog.tsx:538
#: src/features/console/pages/ConnectorDetailPage.tsx:518
#: src/features/settings/components/DataExport.tsx:144
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:299
msgid "Avvio…"
msgstr "Avvio…"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:121
msgid "Avvisi"
msgstr "Avvisi"

#: src/features/connect/components/ConnectPublicShell.tsx:186
msgid "Avviso"
msgstr "Avviso"

#: src/features/report/components/AiDisclosureBanner.tsx:180
msgid "Avviso AI"
msgstr "Avviso AI"

#: src/features/connectors/wizards/accountingSpec.tsx:143
#: src/features/connectors/wizards/sdiSpec.tsx:66
#: src/features/connectors/wizards/sdiSpec.tsx:123
#: src/features/onboarding/DemoBookCallModal.tsx:412
#: src/features/sales/components/CreateLeadDialog.tsx:151
#: src/features/sales/components/CreateLeadDialog.tsx:158
#: src/features/sales/components/crm/ContactsPanel.tsx:131
#: src/features/sales/components/crm/ContactsPanel.tsx:136
#: src/features/sales/components/crm/ContactsPanel.tsx:242
#: src/features/sales/components/crm/CreateDealDialog.tsx:170
#: src/features/sales/components/crm/CreateDealDialog.tsx:175
#: src/features/sales/components/crm/DealDetailDrawer.tsx:189
#: src/features/sales/components/crm/RecordDrawer.tsx:208
#: src/features/sales/components/LeadsPanel.tsx:389
msgid "Azienda"
msgstr "Azienda"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:199
#: src/features/sales/components/crm/RecordDrawer.tsx:218
msgid "Azienda collegata"
msgstr "Azienda collegata"

#: src/features/sales/hooks/useCrmQueries.ts:164
msgid "Azienda creata"
msgstr "Azienda creata"

#: src/features/sales/components/CreateLeadDialog.tsx:211
#: src/features/sales/components/crm/CompaniesPanel.tsx:108
msgid "azienda.it"
msgstr "azienda.it"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:341
msgid "azienda@pec.example.it"
msgstr "azienda@pec.example.it"

#: src/features/console/pages/BillingPage.tsx:168
msgid "Aziendale condiviso"
msgstr "Aziendale condiviso"

#: src/features/sales/components/crm/CompaniesPanel.tsx:177
msgid "aziende"
msgstr "aziende"

#: src/features/workspace/config.ts:365
msgid "Aziende"
msgstr "Aziende"

#: src/features/admin/components/AdminCostTracking.tsx:401
#: src/features/admin/components/orgs/AuditLogList.tsx:148
#: src/features/clean-control/components/policies/PolicyForm.tsx:257
#: src/features/clean-control/components/UndoActionsList.tsx:171
#: src/features/console/connectors/ConnectorActionsPanel.tsx:191
#: src/features/console/pages/ResourceAccessPage.tsx:576
#: src/features/hive-flows/components/nodeVisuals.tsx:46
msgid "Azione"
msgstr "Azione"

#: src/features/hive-flows/components/FlowNodeCard.tsx:64
msgid "Azione che modifica dati — richiede conferma"
msgstr "Azione che modifica dati — richiede conferma"

#: src/features/actions/components/MessageActionChips.tsx:132
msgid "Azione completata"
msgstr "Azione completata"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1512
msgid "Azione del connettore"
msgstr "Azione del connettore"

#: src/features/actions/components/FocusedActionView.tsx:881
#: src/features/actions/components/ScalarActionProposalMount.tsx:214
msgid "Azione eseguita"
msgstr "Azione eseguita"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:70
msgid "Azione eseguita."
msgstr "Azione eseguita."

#: src/features/console/connectors/TestConnectorActionModal.tsx:359
msgid "Azione inviata al tuo applicativo. Ora è in attesa che la tua app la riceva dal webhook, la esegua e ne riporti l'esito."
msgstr "Azione inviata al tuo applicativo. Ora è in attesa che la tua app la riceva dal webhook, la esegua e ne riporti l'esito."

#: src/features/briefing/briefingActions.ts:106
msgid "Azione non riconosciuta"
msgstr "Azione non riconosciuta"

#: src/features/admin/components/AdminCpqList.tsx:177
#: src/features/admin/components/AdminDemoInviti.tsx:238
#: src/features/admin/components/AdminOrgs.tsx:1053
#: src/features/admin/components/AdminUsers.tsx:394
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:387
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:270
#: src/features/admin/components/orgs/OrgMembersTab.tsx:373
#: src/features/billing/components/InvoicesTable.tsx:119
#: src/features/console/components/CommandPalette.tsx:197
#: src/features/console/components/ConsoleShell.tsx:224
#: src/features/console/connectors/CustomConnectorDetail.tsx:1039
#: src/features/console/connectors/CustomConnectorsPanel.tsx:275
#: src/features/console/pages/ActionsPage.tsx:42
#: src/features/console/pages/ActionsPage.tsx:56
#: src/features/console/pages/BillingPage.tsx:606
#: src/features/console/pages/DocumentsPage.tsx:784
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/FlowsPage.tsx:827
#: src/features/console/pages/KeysPage.tsx:143
#: src/features/console/pages/MembersPage.tsx:511
#: src/features/console/pages/MembersPage.tsx:619
#: src/features/sales/components/LeadsPanel.tsx:403
#: src/features/sources/components/AISummaryPanel.tsx:494
#: src/features/sources/components/ArtifactPane.tsx:2124
#: src/features/sources/components/ArtifactPane.tsx:2124
#: src/features/sources/components/ArtifactPane.tsx:2130
#: src/features/sources/components/CalendarEventPane.tsx:641
msgid "Azioni"
msgstr "Azioni"

#. placeholder {0}: connector.name
#: src/features/console/connectors/ConnectorActionsPanel.tsx:113
msgid "Azioni · {0}"
msgstr "Azioni · {0}"

#: src/features/clean-control/components/CleanControlHub.tsx:195
#: src/features/clean-control/components/UndoActionsList.tsx:109
msgid "Azioni applicate"
msgstr "Azioni applicate"

#: src/features/admin/components/AdminUsers.tsx:344
msgid "Azioni bulk"
msgstr "Azioni bulk"

#: src/features/chat/components/ConversationSidebar.tsx:1080
msgid "Azioni conversazione"
msgstr "Azioni conversazione"

#: src/features/admin/components/AdminOrgs.tsx:896
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:190
#: src/features/admin/components/orgs/OrgMembersTab.tsx:271
msgid "Azioni di gruppo"
msgstr "Azioni di gruppo"

#: src/features/clean-control/components/EventQueue.tsx:255
msgid "Azioni di massa"
msgstr "Azioni di massa"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:171
msgid "Azioni dichiarate"
msgstr "Azioni dichiarate"

#. placeholder {0}: connector.name
#: src/features/console/connectors/ConnectorActionsPanel.tsx:187
msgid "Azioni dichiarate per {0}"
msgstr "Azioni dichiarate per {0}"

#: src/features/onboarding/demoTourSteps.ts:101
msgid "Azioni e attività"
msgstr "Azioni e attività"

#: src/features/dashboard/components/ChartActionsMenu.tsx:143
msgid "Azioni grafico"
msgstr "Azioni grafico"

#: src/features/chat/components/ConversationSidebar.tsx:773
msgid "Azioni gruppo {label}"
msgstr "Azioni gruppo {label}"

#: src/features/workspace/documents/components/BulkActionBar.tsx:62
msgid "Azioni in blocco"
msgstr "Azioni in blocco"

#: src/features/workspace/inbox/components/InboxBulkActionBar.tsx:49
msgid "Azioni in blocco — Conversazioni"
msgstr "Azioni in blocco — Conversazioni"

#: src/features/projects/components/sections/MembersSection.tsx:218
msgid "Azioni membro"
msgstr "Azioni membro"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:101
msgid "Azioni messaggio"
msgstr "Azioni messaggio"

#. placeholder {0}: dashboard.name
#. placeholder {0}: flow.name
#. placeholder {0}: org.name
#: src/features/admin/components/AdminOrgs.tsx:1557
#: src/features/admin/components/userAdminActions.tsx:161
#: src/features/dashboard/components/DashboardListSidebar.tsx:306
#: src/routes/_authed/workspace/flows.index.tsx:397
msgid "Azioni per {0}"
msgstr "Azioni per {0}"

#: src/features/settings/components/OrgMembersPanel.tsx:280
msgid "Azioni per {displayName}"
msgstr "Azioni per {displayName}"

#: src/features/chat/components/ConversationCommandPalette.tsx:311
msgid "Azioni rapide"
msgstr "Azioni rapide"

#: ../../packages/ui/src/ando/EditableTable.tsx:242
msgid "Azioni riga"
msgstr "Azioni riga"

#: src/features/console/components/CreateKeyWizard.tsx:515
msgid "Azioni sui connettori (opzionale)"
msgstr "Azioni sui connettori (opzionale)"

#: src/features/dxf/components/DxfActionsMenu.tsx:81
msgid "Azioni sul disegno"
msgstr "Azioni sul disegno"

#: ../../packages/ui/src/ando/SourceDrawer.tsx:297
msgid "Azioni sulla fonte"
msgstr "Azioni sulla fonte"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:606
#: src/features/report/components/ReportDateFilter.tsx:192
msgid "Azzera"
msgstr "Azzera"

#: src/features/console/pages/ConnectorsPage.tsx:334
#: src/features/console/pages/DocumentsPage.tsx:739
msgid "Azzera filtri"
msgstr "Azzera filtri"

#: src/features/console/pages/DocsPage.tsx:565
msgid "Azzera la ricerca"
msgstr "Azzera la ricerca"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:318
#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:319
msgid "Azzera selezione"
msgstr "Azzera selezione"

#: src/features/clean-control/components/EventRow.tsx:433
msgid "B · candidata da archiviare"
msgstr "B · candidata da archiviare"

#: src/features/console/connectors/meta.ts:88
msgid "Bacheche, liste e schede dei workspace autorizzati"
msgstr "Bacheche, liste e schede dei workspace autorizzati"

#: src/features/admin/components/AdminBilling.tsx:94
msgid "Backend avanzato — Metronome (opzionale, dark)"
msgstr "Backend avanzato — Metronome (opzionale, dark)"

#: src/features/admin/components/AdminBilling.tsx:260
msgid "Backend di rating"
msgstr "Backend di rating"

#: src/features/connectors/wizards/openBankingSpec.tsx:176
#: src/features/connectors/wizards/openBankingSpec.tsx:218
#: src/features/workspace/config.ts:353
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:61
#: src/routes/_authed/workspace/finance.tsx:252
#: src/routes/_authed/workspace/finance.tsx:1209
msgid "Banca"
msgstr "Banca"

#: src/routes/_authed/workspace/finance.tsx:678
msgid "Banca, fatture, CRM e cassetto fiscale popoleranno i grafici sopra una volta collegati."
msgstr "Banca, fatture, CRM e cassetto fiscale popoleranno i grafici sopra una volta collegati."

#: src/features/chat/components/ConversationMiniRail.tsx:166
msgid "Barra conversazioni"
msgstr "Barra conversazioni"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:729
msgid "Barrato"
msgstr "Barrato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2061
#: src/features/dashboard/components/AddChartDialog.tsx:107
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:55
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:40
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:120
msgid "Barre"
msgstr "Barre"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:253
msgid "Base"
msgstr "Base"

#: src/features/admin/components/AdminCpq.tsx:961
#: src/features/admin/components/AdminCpqAskAndo.tsx:182
#: src/features/admin/components/AdminCpqCanvas.tsx:154
#: src/features/admin/components/AdminCpqProposalCopy.tsx:40
#: src/features/connect/components/GrantManager.tsx:360
#: src/features/connect/components/GrantManager.tsx:537
#: src/features/connect/components/GrantManager.tsx:961
#: src/features/connect/components/GrantManager.tsx:964
msgid "Base di conoscenza"
msgstr "Base di conoscenza"

#: src/features/admin/components/AdminCpq.tsx:226
msgid "Base di conoscenza, in crediti di usage"
msgstr "Base di conoscenza, in crediti di usage"

#: src/features/console/connectors/ManifestConfigForm.tsx:88
msgid "Base URL"
msgstr "Base URL"

#: src/features/admin/components/AdminCpq.tsx:811
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:96
#: src/features/clean-control/components/EventQueue.tsx:88
#: src/features/report/components/ConfidenceMeter.tsx:125
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:38
#: src/features/workspace/components/TaskComposer.tsx:43
msgid "Bassa"
msgstr "Bassa"

#: src/features/clean-control/utils/labels.ts:49
msgid "BASSA"
msgstr "BASSA"

#: src/features/clean-control/utils/labels.ts:38
msgid "Bassi"
msgstr "Bassi"

#: src/features/admin/components/AdminCostTracking.tsx:381
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1949
#: src/features/console/lib/connectorActions.ts:28
msgid "Basso"
msgstr "Basso"

#: src/features/admin/components/orgs/_shared.tsx:318
msgid "BE gap"
msgstr "BE gap"

#: src/features/admin/components/AdminUsers.tsx:554
msgid "BE in arrivo"
msgstr "BE in arrivo"

#: src/features/console/connectors/ManifestConfigForm.tsx:80
msgid "Bearer token"
msgstr "Bearer token"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:169
msgid "Beneficiario"
msgstr "Beneficiario"

#: src/routes/login.tsx:161
msgid "Bentornato"
msgstr "Bentornato"

#: src/features/auth/desktop/DesktopLoginForm.tsx:693
#: src/features/auth/desktop/DesktopLoginForm.tsx:800
msgid "Bentornato,"
msgstr "Bentornato,"

#: src/features/onboarding/demoTourSteps.ts:37
msgid "Benvenuto in Ando"
msgstr "Benvenuto in Ando"

#: src/features/chat/components/ChatEmptyState.tsx:546
msgid "Benvenuto nella demo"
msgstr "Benvenuto nella demo"

#: src/features/chat/components/ChatEmptyState.tsx:557
#: src/features/onboarding/DemoWelcomeModal.tsx:165
msgid "Benvenuto nella demo di Ando"
msgstr "Benvenuto nella demo di Ando"

#: src/features/onboarding/DemoBetaBanner.tsx:44
#: src/features/onboarding/DemoWelcomeModal.tsx:158
msgid "Beta"
msgstr "Beta"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1683
msgid "Bianco"
msgstr "Bianco"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:221
#: src/features/settings/MarpTemplateSettings.tsx:232
msgid "Bianco e nero"
msgstr "Bianco e nero"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:65
msgid "Biforca conversazione"
msgstr "Biforca conversazione"

#: src/features/chat/hooks/useMessageActions.ts:164
msgid "Biforcazione in arrivo"
msgstr "Biforcazione in arrivo"

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:27
msgid "Bilanciamento velocità / qualità"
msgstr "Bilanciamento velocità / qualità"

#: src/features/chat/components/LayoutSwitcher.tsx:63
msgid "Bilanciato"
msgstr "Bilanciato"

#: src/features/billing/components/CreditBalanceCard.tsx:107
msgid "Bilancio non disponibile."
msgstr "Bilancio non disponibile."

#: src/features/admin/components/AdminBilling.tsx:195
#: src/features/admin/components/orgs/OrgBillingTab.tsx:328
#: src/features/admin/components/orgs/OrgBillingTab.tsx:342
#: src/features/admin/components/orgs/OrgDetailShell.tsx:172
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:143
#: src/routes/_authed/_modal/admin/route.tsx:152
msgid "Billing"
msgstr "Billing"

#: src/features/console/docs/content.ts:1237
msgid "Billing (portale, fatture, crediti)"
msgstr "Billing (portale, fatture, crediti)"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:360
msgid "Binding HTTP (opzionale)"
msgstr "Binding HTTP (opzionale)"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:76
msgid "Bloccante"
msgstr "Bloccante"

#: src/features/dxf/components/DxfEmptyHero.tsx:61
msgid "Blocchi, quote, fori, geometria 3D"
msgstr "Blocchi, quote, fori, geometria 3D"

#: src/features/chat/components/ChatEmptyState.tsx:287
msgid "Blockers attuali"
msgstr "Blockers attuali"

#: src/features/projects/components/ProjectIcon.tsx:112
msgid "Blu"
msgstr "Blu"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:348
msgid "Blueprint preview"
msgstr "Blueprint preview"

#: src/features/connectors/wizards/projectManagementSpec.tsx:34
msgid "Board e attività di progetto, disponibili in chat"
msgstr "Board e attività di progetto, disponibili in chat"

#: src/features/connectors/wizards/projectManagementSpec.tsx:43
msgid "Board, liste e card sincronizzate via OAuth gestito"
msgstr "Board, liste e card sincronizzate via OAuth gestito"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:420
msgid "Body template (JSON, opzionale)"
msgstr "Body template (JSON, opzionale)"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:154
msgid "Body template non valido: inserisci un oggetto JSON."
msgstr "Body template non valido: inserisci un oggetto JSON."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:160
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:218
msgid "Bonifico SEPA"
msgstr "Bonifico SEPA"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1837
msgid "Bordo"
msgstr "Bordo"

#: src/features/projects/components/sections/AutomationsSection.tsx:180
msgid "bozza"
msgstr "bozza"

#: src/features/admin/components/AdminCpq.tsx:467
#: src/features/admin/components/AdminCpqList.tsx:69
#: src/features/billing/components/InvoicesTable.tsx:36
#: src/features/console/components/StatusBadges.tsx:183
#: src/features/console/components/StatusBadges.tsx:258
#: src/features/hive-flows/components/FlowActivateControl.tsx:50
#: src/features/report/lib/useReportLifecycle.ts:73
#: src/features/sales/components/leadMeta.ts:28
#: src/routes/_authed/workspace/flows.index.tsx:68
msgid "Bozza"
msgstr "Bozza"

#: src/features/console/pages/ModelsPage.tsx:82
msgid "Bozza · non attiva"
msgstr "Bozza · non attiva"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:171
msgid "Bozza AI"
msgstr "Bozza AI"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:160
msgid "Bozza AI da confermare"
msgstr "Bozza AI da confermare"

#: src/features/sources/components/ArtifactPane.tsx:1220
msgid "Bozza confermata"
msgstr "Bozza confermata"

#: src/features/admin/components/AdminCpq.tsx:377
#: src/features/console/pages/FlowsPage.tsx:443
msgid "Bozza creata"
msgstr "Bozza creata"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:287
#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:512
msgid "Bozza email"
msgstr "Bozza email"

#: src/features/sources/components/InboxDetailPane.tsx:1675
msgid "Bozza generata da Ando"
msgstr "Bozza generata da Ando"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:157
msgid "Bozza preventivo cliente"
msgstr "Bozza preventivo cliente"

#: src/features/skills/components/SkillEditor.tsx:169
msgid "Bozza pronta — rivedila e salva"
msgstr "Bozza pronta — rivedila e salva"

#: src/features/sources/components/ArtifactPane.tsx:1234
msgid "Bozza rifiutata"
msgstr "Bozza rifiutata"

#. placeholder {0}: item.subject
#: src/features/sources/components/InboxDetailPane.tsx:360
msgid "Bozza risposta professionale a \"{0}\""
msgstr "Bozza risposta professionale a \"{0}\""

#: src/features/actions/components/FocusedActionView.tsx:788
#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:257
#: src/features/admin/components/AdminCpq.tsx:381
msgid "Bozza salvata"
msgstr "Bozza salvata"

#: src/features/workspace/config.ts:435
#: src/features/workspace/config.ts:441
msgid "Bozze"
msgstr "Bozze"

#: src/features/connectors/wizards/sdiSpec.tsx:114
msgid "Bozze proposte, mai inviate in autonomia (HITL)."
msgstr "Bozze proposte, mai inviate in autonomia (HITL)."

#: src/features/connectors/wizards/emailSpec.tsx:103
msgid "Bozze proposte, mai inviate in autonomia."
msgstr "Bozze proposte, mai inviate in autonomia."

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:765
#: src/features/settings/components/OrganizationSettings.tsx:219
#: src/features/studio/components/StudioDrawerContent.tsx:71
msgid "Brand"
msgstr "Brand"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:117
#: src/features/account/components/UserMenuButton.tsx:439
#: src/features/sales/components/SignatureRichEditor.tsx:180
#: src/features/settings/components/BrandKitSettings.tsx:247
msgid "Brand Kit"
msgstr "Brand Kit"

#. placeholder {0}: brandKit.name
#. placeholder {1}: formatLabel ? ` — ${formatLabel}` : ""
#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:984
msgid "Brand Kit {0} — predefinito{1}"
msgstr "Brand Kit {0} — predefinito{1}"

#: src/features/settings/components/BrandKitSettings.tsx:169
msgid "Brand Kit creato"
msgstr "Brand Kit creato"

#: src/features/settings/components/BrandKitSettings.tsx:182
msgid "Brand Kit salvato"
msgstr "Brand Kit salvato"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:138
#: src/features/admin/components/orgs/OrgDetailShell.tsx:162
#: src/features/settings/components/OrganizationSettings.tsx:112
msgid "Branding"
msgstr "Branding"

#: src/features/settings/components/OrganizationSettings.tsx:90
msgid "branding · membri · SSO"
msgstr "branding · membri · SSO"

#: src/features/settings/components/OrganizationSettings.tsx:303
msgid "Branding aggiornato."
msgstr "Branding aggiornato."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:149
msgid "Branding resettato"
msgstr "Branding resettato"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:134
msgid "Branding salvato"
msgstr "Branding salvato"

#: src/features/integrations/parts/CapabilityHeader.tsx:43
msgid "Breadcrumb"
msgstr "Breadcrumb"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:288
#: src/features/admin/components/UserDetailShell.tsx:115
msgid "Briciole di pane"
msgstr "Briciole di pane"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:167
#: src/features/voice_report/components/NewReportDialog.tsx:863
msgid "Brief"
msgstr "Brief"

#: src/features/voice_report/components/SettingsTab.tsx:144
msgid "Brief (cosa vuoi sapere?)"
msgstr "Brief (cosa vuoi sapere?)"

#: src/routes/_authed/workspace/calendar.tsx:1441
msgid "Brief automatici prima dei meeting"
msgstr "Brief automatici prima dei meeting"

#: src/features/sources/components/CalendarEventPane.tsx:369
msgid "Brief copiato negli appunti"
msgstr "Brief copiato negli appunti"

#: src/features/sources/components/CalendarEventPane.tsx:319
msgid "Brief non disponibile"
msgstr "Brief non disponibile"

#: src/features/chat/components/ChatEmptyState.tsx:157
msgid "Brief per prossimo meeting"
msgstr "Brief per prossimo meeting"

#: src/features/connectors/wizards/calendarSpec.tsx:70
msgid "Brief pre-meeting"
msgstr "Brief pre-meeting"

#: src/features/briefing/BriefCard.tsx:185
#: src/features/sources/components/CalendarEventPane.tsx:556
msgid "Briefing"
msgstr "Briefing"

#: src/features/briefing/BriefAggregate.tsx:93
#: src/features/briefing/BriefAggregate.tsx:149
msgid "Briefing del giorno"
msgstr "Briefing del giorno"

#: src/features/chat/components/ChatEmptyState.tsx:243
msgid "Bug aperti"
msgstr "Bug aperti"

#: src/features/console/components/ConsoleShell.tsx:220
msgid "Build"
msgstr "Build"

#: src/features/settings/components/PresentationTemplates.tsx:92
#: src/features/settings/components/PresentationTemplates.tsx:440
msgid "Built-in"
msgstr "Built-in"

#: src/features/templates/components/TemplateCard.tsx:25
#: src/features/templates/components/TemplatesList.tsx:50
msgid "BUILT-IN"
msgstr "BUILT-IN"

#: src/features/chat/components/ChatEmptyState.tsx:86
#: src/features/projects/components/ProjectHub.tsx:81
msgid "Buon pomeriggio"
msgstr "Buon pomeriggio"

#: src/features/chat/components/ChatEmptyState.tsx:87
#: src/features/projects/components/ProjectHub.tsx:82
msgid "Buonasera"
msgstr "Buonasera"

#: src/features/chat/components/ChatEmptyState.tsx:85
#: src/features/projects/components/ProjectHub.tsx:80
msgid "Buongiorno"
msgstr "Buongiorno"

#: src/routes/_authed/workspace/finance.tsx:485
#: src/routes/_authed/workspace/finance.tsx:1419
msgid "Burn mensile"
msgstr "Burn mensile"

#: src/features/admin/components/AdminOrgs.tsx:110
msgid "Business"
msgstr "Business"

#: src/features/settings/MarpTemplateSettings.tsx:135
msgid "Business · curato"
msgstr "Business · curato"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:369
msgid "Business selection…"
msgstr "Business selection…"

#: src/features/admin/components/AdminOrgs.tsx:111
msgid "Business+"
msgstr "Business+"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:84
msgid "C.F. {buyerCf}"
msgstr "C.F. {buyerCf}"

#: src/features/projects/components/ProjectDetailPage.tsx:334
msgid "C'è <0>1 attività in ritardo</0>: vale la pena darle un'occhiata."
msgstr "C'è <0>1 attività in ritardo</0>: vale la pena darle un'occhiata."

#: src/features/connectors/wizards/vatVerifierSpec.tsx:71
msgid "Cache + retry trasparenti, niente blocchi sul portale AdE."
msgstr "Cache + retry trasparenti, niente blocchi sul portale AdE."

#: src/features/admin/components/CostTraceDetailSection.tsx:161
msgid "Cache hit"
msgstr "Cache hit"

#: src/features/admin/components/AdminCostTracking.tsx:264
#: src/features/admin/components/CostTraceDetailSection.tsx:175
msgid "Cached"
msgstr "Cached"

#: src/features/admin/components/AdminCostTracking.tsx:385
msgid "Caching"
msgstr "Caching"

#: src/features/chat/hooks/useThinkingHops.ts:49
#: src/features/chat/hooks/useThinkingHops.ts:50
msgid "CAD"
msgstr "CAD"

#: src/routes/_authed/route.tsx:1806
msgid "CAD · {cadFile}"
msgstr "CAD · {cadFile}"

#: src/features/console/docs/content.ts:958
msgid "CAD (add-on manifatturiero)"
msgstr "CAD (add-on manifatturiero)"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:84
msgid "CAD, tavole tecniche"
msgstr "CAD, tavole tecniche"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:278
msgid "Cadence:"
msgstr "Cadence:"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:100
msgid "Calcolo"
msgstr "Calcolo"

#: src/features/admin/components/AdminCpq.tsx:420
msgid "Calcolo congelato con il listino corrente."
msgstr "Calcolo congelato con il listino corrente."

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:152
msgid "Calcolo l'embedding del file e cerco i pezzi simili…"
msgstr "Calcolo l'embedding del file e cerco i pezzi simili…"

#: src/features/admin/components/AdminCpq.tsx:1155
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:600
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:559
msgid "Calcolo…"
msgstr "Calcolo…"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:219
#: src/features/settings/MarpTemplateSettings.tsx:228
msgid "Caldi"
msgstr "Caldi"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:164
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
msgid "Calendari"
msgstr "Calendari"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:96
msgid "Calendari da sincronizzare"
msgstr "Calendari da sincronizzare"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:198
msgid "calendari selezionati"
msgstr "calendari selezionati"

#: src/routes/_authed/workspace/work.tsx:611
msgid "calendario"
msgstr "calendario"

#: src/features/briefing/BriefCard.tsx:120
#: src/features/connectors/wizards/calendarSpec.tsx:32
#: src/features/connectors/wizards/calendarSpec.tsx:93
#: src/features/console/connectors/meta.ts:102
#: src/features/console/pages/DocumentsPage.tsx:84
#: src/features/console/pages/PlaygroundPage.tsx:1989
#: src/features/onboarding/demoTourSteps.ts:77
#: src/features/workspace/config.ts:89
#: src/features/workspace/config.ts:91
#: src/routes/_authed/workspace/calendar.tsx:1532
#: src/routes/_authed/workspace/calendar.tsx:1561
#: src/routes/_authed/workspace/calendar.tsx:1584
msgid "Calendario"
msgstr "Calendario"

#: src/features/auth/desktop/useDesktopOAuth.ts:194
msgid "Callback OAuth privo di code/state. Riprova."
msgstr "Callback OAuth privo di code/state. Riprova."

#: src/features/auth/desktop/DesktopLoginForm.tsx:683
msgid "Cambia account"
msgstr "Cambia account"

#. placeholder {0}: control.value
#: src/features/structured-data/components/TemporalQueryControl.tsx:185
msgid "Cambia anno, anno selezionato {0}"
msgstr "Cambia anno, anno selezionato {0}"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:569
msgid "Cambia cartella"
msgstr "Cambia cartella"

#: ../../packages/ui/src/ando/sources/banking-tx/BankingActions.tsx:17
#: src/features/dxf/components/DxfActionsMenu.tsx:130
msgid "Cambia categoria"
msgstr "Cambia categoria"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:182
msgid "Cambia file"
msgstr "Cambia file"

#: src/features/structured-data/components/TemporalQueryControl.tsx:186
msgid "Cambia intervallo temporale"
msgstr "Cambia intervallo temporale"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:83
msgid "Cambia la rappresentazione dei dati"
msgstr "Cambia la rappresentazione dei dati"

#: src/features/admin/components/AdminCpqList.tsx:133
msgid "Cambia la ricerca o lo stato."
msgstr "Cambia la ricerca o lo stato."

#: src/features/help/components/ShortcutsList.tsx:115
msgid "Cambia layout (Split / Workspace / Focus)"
msgstr "Cambia layout (Split / Workspace / Focus)"

#: src/features/console/pages/ModelsPage.tsx:162
msgid "Cambia modello"
msgstr "Cambia modello"

#. placeholder {0}: config.label
#: src/features/console/pages/ModelsPage.tsx:159
msgid "Cambia modello per {0}"
msgstr "Cambia modello per {0}"

#: src/features/account/components/OrgSwitcherDialog.tsx:161
#: src/features/account/components/OrgSwitcherDialog.tsx:165
msgid "Cambia organizzazione"
msgstr "Cambia organizzazione"

#: src/features/chat/components/ConversationSidebar.tsx:1149
msgid "Cambia progetto"
msgstr "Cambia progetto"

#: src/features/admin/components/UserDetailContent.tsx:434
#: src/features/console/pages/MembersPage.tsx:334
#: src/features/console/pages/MembersPage.tsx:576
#: src/features/sales/components/CampaignSharing.tsx:283
#: src/features/settings/components/OrgMembersPanel.tsx:289
msgid "Cambia ruolo"
msgstr "Cambia ruolo"

#. placeholder {0}: user.email
#: src/features/admin/components/userAdminActions.tsx:113
msgid "Cambia ruolo di {0}"
msgstr "Cambia ruolo di {0}"

#. placeholder {0}: connector.slug
#: src/features/console/connectors/CustomConnectorDetail.tsx:744
msgid "Cambia solo il nome mostrato: lo slug «{0}» resta invariato."
msgstr "Cambia solo il nome mostrato: lo slug «{0}» resta invariato."

#: src/features/admin/components/UserDetailContent.tsx:393
#: src/features/sales/components/LeadInlineControls.tsx:76
msgid "Cambia stato"
msgstr "Cambia stato"

#: src/routes/_authed/workspace/conversations.tsx:1066
msgid "Cambia vista per vedere altri messaggi."
msgstr "Cambia vista per vedere altri messaggi."

#: src/features/admin/components/AdminDecksAskAndo.tsx:197
msgid "Cambiano anche elenchi, colonne o note."
msgstr "Cambiano anche elenchi, colonne o note."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:53
msgid "Cambio abitudini"
msgstr "Cambio abitudini"

#: src/features/settings/components/AccountDeletion.tsx:43
msgid "Cambio servizio"
msgstr "Cambio servizio"

#: src/features/admin/components/AdminCpqPriceBook.tsx:218
msgid "Cambio USD/EUR"
msgstr "Cambio USD/EUR"

#: src/features/sales/components/CreateLeadDialog.tsx:130
#: src/features/sales/components/CreateLeadDialog.tsx:135
msgid "Campagna"
msgstr "Campagna"

#: src/features/sales/components/LeadsPanel.tsx:265
msgid "Campagna attiva"
msgstr "Campagna attiva"

#: src/features/sales/components/CreateCampaignDialog.tsx:52
msgid "Campagna creata"
msgstr "Campagna creata"

#: src/features/sales/components/CreateCampaignDialog.tsx:55
msgid "Campagna non creata"
msgstr "Campagna non creata"

#: src/features/sales/components/LeadsPanel.tsx:256
#: src/features/workspace/config.ts:366
msgid "Campagne"
msgstr "Campagne"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:27
msgid "Campi aggiornati"
msgstr "Campi aggiornati"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:228
#: src/features/dashboard/components/ChartConfigurationMenu.tsx:75
msgid "Campi calcolati"
msgstr "Campi calcolati"

#: src/features/actions/components/ActionAiFillBar.tsx:56
msgid "Campi compilati con l'AI — controllali prima di confermare"
msgstr "Campi compilati con l'AI — controllali prima di confermare"

#: src/features/sales/components/BatchSendModal.tsx:319
msgid "Campi compilati per destinatario:"
msgstr "Campi compilati per destinatario:"

#: src/features/hive-flows/components/NodeInspector.tsx:514
msgid "Campi del record"
msgstr "Campi del record"

#: src/features/console/connectors/CustomConnectorDetail.tsx:383
msgid "Campi del Record contract"
msgstr "Campi del Record contract"

#: src/features/console/docs/content.ts:304
msgid "Campi display-safe (mai l'hash); paginato con ?limit=&cursor=."
msgstr "Campi display-safe (mai l'hash); paginato con ?limit=&cursor=."

#: src/features/sales/components/TemplateManager.tsx:337
msgid "Campi rilevati:"
msgstr "Campi rilevati:"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:199
msgid "Campiona i valori distinti delle colonne codice/flag. Nessuna AI: descrizioni e contesto restano intatti."
msgstr "Campiona i valori distinti delle colonne codice/flag. Nessuna AI: descrizioni e contesto restano intatti."

#: src/features/dashboard/components/AddChartDialog.tsx:660
msgid "campione vuoto"
msgstr "campione vuoto"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:97
#: src/features/console/connectors/CustomConnectorDetail.tsx:303
#: src/features/console/connectors/CustomConnectorDetail.tsx:387
msgid "Campo"
msgstr "Campo"

#: src/features/console/connectors/ManifestConfigForm.tsx:188
msgid "Campo elenco record (opzionale)"
msgstr "Campo elenco record (opzionale)"

#: src/features/console/connectors/ManifestConfigForm.tsx:300
msgid "Campo nella risposta"
msgstr "Campo nella risposta"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:330
msgid "Campo obbligatorio"
msgstr "Campo obbligatorio"

#. placeholder {0}: localize(f.label, i18n)
#: ../../packages/ui/src/connectors/FieldRenderer.tsx:173
msgid "Campo obbligatorio: {0}"
msgstr "Campo obbligatorio: {0}"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:200
#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:217
msgid "Canale / destinatario"
msgstr "Canale / destinatario"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:390
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:426
msgid "Canali"
msgstr "Canali"

#: src/features/settings/components/NotificationPreferences.tsx:392
msgid "Canali di consegna"
msgstr "Canali di consegna"

#: ../../packages/ui/src/ando/sources/calendar/EventActions.tsx:39
#: src/features/console/docs/content.ts:555
msgid "Cancella"
msgstr "Cancella"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:167
msgid "Cancella intervallo"
msgstr "Cancella intervallo"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:578
#: src/features/console/pages/DocsPage.tsx:537
msgid "Cancella la ricerca"
msgstr "Cancella la ricerca"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:108
msgid "Cancella materiale"
msgstr "Cancella materiale"

#: src/features/settings/components/SelfProfileMemory.tsx:695
msgid "Cancella memoria"
msgstr "Cancella memoria"

#: src/features/settings/components/SelfProfileMemory.tsx:570
#: src/features/settings/components/SelfProfileMemory.tsx:689
msgid "Cancella memoria personalizzata"
msgstr "Cancella memoria personalizzata"

#: src/routes/_authed/_modal/integrations/index.tsx:381
msgid "Cancella ricerca"
msgstr "Cancella ricerca"

#: src/features/dashboard/components/CrossFilterBar.tsx:94
msgid "Cancella tutto"
msgstr "Cancella tutto"

#: src/features/admin/components/AdminUsers.tsx:265
msgid "Cancellati"
msgstr "Cancellati"

#: src/features/settings/components/AccountDeletion.tsx:100
msgid "Cancellazione account"
msgstr "Cancellazione account"

#: src/features/connectors/wizards/driveSpec.tsx:121
msgid "Cancellazione GDPR"
msgstr "Cancellazione GDPR"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:85
msgid "Cantiere, direzione lavori"
msgstr "Cantiere, direzione lavori"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:41
msgid "canvas"
msgstr "canvas"

#: src/features/connect/components/GrantManager.tsx:515
#: src/features/workspace/config.ts:166
#: src/features/workspace/config.ts:168
#: src/routes/_authed/_modal/admin/route.tsx:138
msgid "Canvas"
msgstr "Canvas"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:389
msgid "Canvas ancora vuoto"
msgstr "Canvas ancora vuoto"

#: src/features/admin/components/AdminCanvas.tsx:76
msgid "Canvas dashboard"
msgstr "Canvas dashboard"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:155
msgid "Canvas non trovato"
msgstr "Canvas non trovato"

#: src/features/chat/components/ChatEmptyState.tsx:321
msgid "Canvas recenti"
msgstr "Canvas recenti"

#: src/routes/_authed/workspace/canvases.tsx:189
msgid "canvases"
msgstr "canvases"

#: src/routes/_authed/workspace/canvases.tsx:366
msgid "Canvases"
msgstr "Canvases"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:140
#: src/routes/_authed/workspace/canvases.tsx:173
msgid "Canvases non attivi sul tuo piano"
msgstr "Canvases non attivi sul tuo piano"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:462
msgid "Capability suggerite:"
msgstr "Capability suggerite:"

#: src/features/agent-modes/components/AgentModeEditor.tsx:375
#: src/features/console/pages/PlaygroundPage.tsx:886
msgid "Capacità"
msgstr "Capacità"

#. placeholder {0}: selected.size === 1 ? t`cartella selezionata` : t`cartelle selezionate`
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:386
msgid "Capisco che Ando sincronizzerà ~{selectedFileCount} file di tutte le sotto-cartelle delle {0}."
msgstr "Capisco che Ando sincronizzerà ~{selectedFileCount} file di tutte le sotto-cartelle delle {0}."

#: src/features/dxf/utils.ts:123
msgid "Capo 3D"
msgstr "Capo 3D"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:740
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:741
msgid "Carattere"
msgstr "Carattere"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:168
msgid "caratteri"
msgstr "caratteri"

#. placeholder {0}: citation.offset_start
#. placeholder {1}: citation.offset_end
#: src/features/report/components/CitationDetail.tsx:142
msgid "Caratteri {0}–{1}"
msgstr "Caratteri {0}–{1}"

#. placeholder {0}: offset + (data.payload ? 1 : 0)
#. placeholder {0}: part.text_offset + (Array.from(part.text).length ? 1 : 0)
#. placeholder {1}: offset + Array.from(data.payload).length
#. placeholder {1}: part.text_offset + Array.from(part.text).length
#. placeholder {2}: page?.total_chars ?? "—"
#. placeholder {2}: part.text_length
#: src/features/console/components/DocumentAcquiredContent.tsx:65
#: src/features/console/traces/TracePayloadReader.tsx:137
msgid "Caratteri {0}–{1} di {2}"
msgstr "Caratteri {0}–{1} di {2}"

#. placeholder {0}: start + 1
#. placeholder {1}: chars.length
#: src/features/console/traces/TraceJsonTree.tsx:20
msgid "Caratteri {0}–{end} di {1}. Le altre parti restano disponibili."
msgstr "Caratteri {0}–{end} di {1}. Le altre parti restano disponibili."

#: src/features/dxf/components/DxfEmptyHero.tsx:54
#: src/features/settings/components/BrandKitSettings.tsx:339
#: src/features/settings/components/BrandKitSettings.tsx:697
#: src/features/workspace/components/UploadModal.tsx:313
msgid "Carica"
msgstr "Carica"

#: src/features/workspace/components/UploadModal.tsx:312
msgid "Carica {acceptableCount} file"
msgstr "Carica {acceptableCount} file"

#: src/features/console/pages/TracesPage.tsx:605
msgid "Carica altre richieste"
msgstr "Carica altre richieste"

#: src/features/clean-control/components/EventQueue.tsx:351
msgid "Carica altri 50 →"
msgstr "Carica altri 50 →"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:261
msgid "Carica checklist"
msgstr "Carica checklist"

#: src/features/settings/marp/CssUploadPanel.tsx:145
msgid "Carica CSS"
msgstr "Carica CSS"

#: src/features/console/pages/ConnectorsPage.tsx:523
msgid "Carica e gestisci documenti"
msgstr "Carica e gestisci documenti"

#: src/features/console/pages/ConnectorDetailPage.tsx:240
msgid "Carica Excel o CSV"
msgstr "Carica Excel o CSV"

#: src/features/connectors/components/_spreadsheet/types.tsx:82
#: src/features/connectors/wizards/cadLibrarySpec.tsx:83
#: src/features/connectors/wizards/spreadsheetSpec.tsx:143
msgid "Carica file"
msgstr "Carica file"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:161
msgid "Carica file da computer"
msgstr "Carica file da computer"

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:414
msgid "Carica file dal dispositivo"
msgstr "Carica file dal dispositivo"

#: src/features/admin/components/AdminDecks.tsx:359
#: src/features/admin/components/AdminDecks.tsx:375
msgid "Carica file HTML"
msgstr "Carica file HTML"

#: src/features/admin/components/PageEditor.tsx:357
#: src/features/admin/components/PageEditor.tsx:373
msgid "Carica HTML"
msgstr "Carica HTML"

#: src/features/workspace/components/UploadModal.tsx:320
msgid "Carica i tuoi file"
msgstr "Carica i tuoi file"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:233
msgid "Carica il dizionario dati del fornitore (Excel) e completa lo schema in automatico."
msgstr "Carica il dizionario dati del fornitore (Excel) e completa lo schema in automatico."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:156
msgid "Carica il dizionario dati del fornitore in formato Excel: le descrizioni di tabelle e colonne vengono importate senza AI, poi il completamento automatico si occupa del resto."
msgstr "Carica il dizionario dati del fornitore in formato Excel: le descrizioni di tabelle e colonne vengono importate senza AI, poi il completamento automatico si occupa del resto."

#: src/features/price-lists/components/PriceListsPage.tsx:1031
msgid "Carica il file Excel, PDF o Word del tuo listino cliente. Ando estrae codici, descrizioni e prezzi voce per voce; poi in chat può preventivare automaticamente un disegno CAD contro questi prezzi."
msgstr "Carica il file Excel, PDF o Word del tuo listino cliente. Ando estrae codici, descrizioni e prezzi voce per voce; poi in chat può preventivare automaticamente un disegno CAD contro questi prezzi."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1065
msgid "Carica il file Excel, PDF o Word della tua checklist DFM. Ando estrae le regole atomiche (spessore parete, sformo, raccordi, tolleranze, materiali) e le applica ai CAD in ingresso."
msgstr "Carica il file Excel, PDF o Word della tua checklist DFM. Ando estrae le regole atomiche (spessore parete, sformo, raccordi, tolleranze, materiali) e le applica ai CAD in ingresso."

#: src/features/console/pages/OverviewPage.tsx:301
msgid "Carica il primo file"
msgstr "Carica il primo file"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1408
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2503
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2504
msgid "Carica immagine"
msgstr "Carica immagine"

#: src/features/price-lists/components/PriceListsPage.tsx:242
msgid "Carica listino"
msgstr "Carica listino"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:170
msgid "Carica spreadsheet"
msgstr "Carica spreadsheet"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:239
msgid "Carica template"
msgstr "Carica template"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:137
msgid "Carica template grafico (compilabile)"
msgstr "Carica template grafico (compilabile)"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:139
msgid "Carica un .docx / .xlsx / .pptx brandizzato con segnaposto <0>{{nome}}</0>. L'AI lo riempirà preservando il tuo layout e i tuoi colori."
msgstr "Carica un .docx / .xlsx / .pptx brandizzato con segnaposto <0>{{nome}}</0>. L'AI lo riempirà preservando il tuo layout e i tuoi colori."

#: src/features/settings/marp/PptxExtractPanel.tsx:130
msgid "Carica un .pptx (max 20 MB) — l'AI ne estrae palette e tipografia."
msgstr "Carica un .pptx (max 20 MB) — l'AI ne estrae palette e tipografia."

#: src/features/hive-flows/run/ProposalReview.tsx:880
msgid "Carica un altro"
msgstr "Carica un altro"

#: src/features/dxf/components/DxfEmptyHero.tsx:156
msgid "Carica un disegno"
msgstr "Carica un disegno"

#: src/features/console/docs/content.ts:438
#: src/features/hive-flows/run/PdfDropzone.tsx:197
msgid "Carica un documento"
msgstr "Carica un documento"

#: src/features/billing/components/UsageInsightsCard.tsx:266
msgid "Carica un documento o connetti una sorgente per iniziare a costruire la knowledge base."
msgstr "Carica un documento o connetti una sorgente per iniziare a costruire la knowledge base."

#: src/features/console/lib/onboarding.ts:75
msgid "Carica un documento oppure controlla quelli acquisiti dalle tue fonti. Apri l'originale e il contenuto acquisito per confrontarli."
msgstr "Carica un documento oppure controlla quelli acquisiti dalle tue fonti. Apri l'originale e il contenuto acquisito per confrontarli."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:814
msgid "Carica un documento per avviare una nuova esecuzione di questo flow."
msgstr "Carica un documento per avviare una nuova esecuzione di questo flow."

#: src/features/dxf/components/DxfLeftRail.tsx:186
msgid "Carica un DXF dalla chat per iniziare"
msgstr "Carica un DXF dalla chat per iniziare"

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:64
msgid "Carica un file"
msgstr "Carica un file"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:77
msgid "Carica un file Excel (.xlsx / .xls) o CSV dal tuo computer. Il file viene cifrato a riposo; revoca disponibile dalla pagina Integrazioni."
msgstr "Carica un file Excel (.xlsx / .xls) o CSV dal tuo computer. Il file viene cifrato a riposo; revoca disponibile dalla pagina Integrazioni."

#: src/features/connectors/wizards/spreadsheetSpec.tsx:187
msgid "Carica un file locale o pesca da Drive / OneDrive senza esportare."
msgstr "Carica un file locale o pesca da Drive / OneDrive senza esportare."

#: src/features/console/flows/ConsoleFlowEditor.tsx:204
#: src/features/hive-flows/run/PdfDropzone.tsx:134
msgid "Carica un file PDF"
msgstr "Carica un file PDF"

#: src/features/console/docs/content.ts:968
msgid "Carica un file STEP/DXF → 202. /cad/dfm-check per il DFM, /cad/convert (cad:write) per profilo DXF → solido STEP."
msgstr "Carica un file STEP/DXF → 202. /cad/dfm-check per il DFM, /cad/convert (cad:write) per profilo DXF → solido STEP."

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:58
msgid "Carica un file, collega Google Drive / OneDrive / SharePoint, oppure aggiungi una cartella locale o NAS per portare qui i tuoi file."
msgstr "Carica un file, collega Google Drive / OneDrive / SharePoint, oppure aggiungi una cartella locale o NAS per portare qui i tuoi file."

#: src/features/settings/MarpTemplateSettings.tsx:65
msgid "Carica un foglio di stile CSS oppure estrai automaticamente la palette da un file PowerPoint."
msgstr "Carica un foglio di stile CSS oppure estrai automaticamente la palette da un file PowerPoint."

#: src/features/settings/components/BrandKitSettings.tsx:336
msgid "Carica un font per i titoli"
msgstr "Carica un font per i titoli"

#: src/features/settings/components/BrandKitSettings.tsx:336
msgid "Carica un font per il corpo"
msgstr "Carica un font per il corpo"

#: src/features/hive-flows/run/PdfDropzone.tsx:197
msgid "Carica un PDF"
msgstr "Carica un PDF"

#: src/features/console/flows/ConsoleFlowEditor.tsx:276
msgid "Carica un PDF come documento di innesco: il flow parte con quel documento"
msgstr "Carica un PDF come documento di innesco: il flow parte con quel documento"

#: src/features/console/flows/ConsoleFlowEditor.tsx:291
msgid "Carica un PDF per avviare il flow"
msgstr "Carica un PDF per avviare il flow"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:759
msgid "Carica un riferimento"
msgstr "Carica un riferimento"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1113
msgid "Carica un template"
msgstr "Carica un template"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1227
msgid "Carica un template brandizzato dalle impostazioni per riusarlo qui."
msgstr "Carica un template brandizzato dalle impostazioni per riusarlo qui."

#: src/features/console/pages/OverviewPage.tsx:273
msgid "Caricamenti e relative elaborazioni. Per il sync, consulta Stato delle sincronizzazioni."
msgstr "Caricamenti e relative elaborazioni. Per il sync, consulta Stato delle sincronizzazioni."

#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:102
#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:298
#: src/features/connect/components/ConnectPublicShell.tsx:94
#: src/features/console/components/ProviderAccounts.tsx:113
#: src/features/console/pages/DocumentsPage.tsx:80
#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1495
msgid "Caricamento"
msgstr "Caricamento"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:28
msgid "Caricamento accesso…"
msgstr "Caricamento accesso…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:323
#: src/features/sales/components/BatchSendModal.tsx:236
msgid "Caricamento account…"
msgstr "Caricamento account…"

#: src/features/workspace/documents/components/VirtualizedDocList.tsx:214
msgid "Caricamento altri documenti…"
msgstr "Caricamento altri documenti…"

#: src/features/workspace/hooks/useFileUpload.ts:151
msgid "Caricamento annullato"
msgstr "Caricamento annullato"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:443
msgid "Caricamento anteprima"
msgstr "Caricamento anteprima"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:343
msgid "Caricamento app…"
msgstr "Caricamento app…"

#: src/features/projects/components/sections/TasksSection.tsx:258
msgid "Caricamento attività…"
msgstr "Caricamento attività…"

#: src/features/chat/components/AudioPlayer.tsx:139
msgid "Caricamento audio…"
msgstr "Caricamento audio…"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:246
msgid "Caricamento audit trail…"
msgstr "Caricamento audit trail…"

#: src/features/projects/components/sections/AutomationsSection.tsx:226
msgid "Caricamento automazioni"
msgstr "Caricamento automazioni"

#: src/routes/_authed/_modal/integrations/$capability.tsx:879
msgid "Caricamento avviato — il connettore sarà pronto fra pochi minuti."
msgstr "Caricamento avviato — il connettore sarà pronto fra pochi minuti."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:502
msgid "Caricamento avviato. Il foglio apparirà appena l'analisi è completata."
msgstr "Caricamento avviato. Il foglio apparirà appena l'analisi è completata."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:163
#: src/features/settings/components/OrganizationSettings.tsx:205
msgid "Caricamento branding…"
msgstr "Caricamento branding…"

#: src/features/briefing/BriefAggregate.tsx:198
#: src/features/briefing/BriefCard.tsx:427
msgid "Caricamento briefing"
msgstr "Caricamento briefing"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:107
msgid "Caricamento calendari…"
msgstr "Caricamento calendari…"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:190
msgid "Caricamento canvas…"
msgstr "Caricamento canvas…"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:64
msgid "Caricamento casi…"
msgstr "Caricamento casi…"

#: src/features/clean-control/components/EventQueue.tsx:534
msgid "Caricamento coda"
msgstr "Caricamento coda"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:355
msgid "Caricamento coda…"
msgstr "Caricamento coda…"

#: src/features/connect/components/MemberManager.tsx:643
msgid "Caricamento colleghi…"
msgstr "Caricamento colleghi…"

#: src/features/workspace/components/UploadModal.tsx:385
msgid "Caricamento completato: <0>{doneCount}</0> riusciti"
msgstr "Caricamento completato: <0>{doneCount}</0> riusciti"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:108
msgid "Caricamento configurazione"
msgstr "Caricamento configurazione"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:164
msgid "Caricamento configurazione SSO…"
msgstr "Caricamento configurazione SSO…"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:391
msgid "Caricamento connector"
msgstr "Caricamento connector"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:315
msgid "Caricamento connector…"
msgstr "Caricamento connector…"

#: ../../packages/ui/src/primitives/skeleton.tsx:92
msgid "Caricamento contenuti"
msgstr "Caricamento contenuti"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:92
msgid "Caricamento contenuti indicizzati…"
msgstr "Caricamento contenuti indicizzati…"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:128
#: src/features/sources/components/InboxDetailPane.tsx:746
msgid "Caricamento conversazione…"
msgstr "Caricamento conversazione…"

#: src/routes/_authed/workspace/conversations.tsx:896
msgid "Caricamento conversazioni in corso"
msgstr "Caricamento conversazioni in corso"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:507
msgid "Caricamento copertura…"
msgstr "Caricamento copertura…"

#: src/features/admin/components/AdminCostTracking.tsx:211
#: src/features/admin/components/orgs/OrgCostTab.tsx:326
msgid "Caricamento costi…"
msgstr "Caricamento costi…"

#: src/routes/_authed/workspace/dashboard.tsx:1257
msgid "Caricamento dashboard"
msgstr "Caricamento dashboard"

#: src/features/voice_report/components/NewReportDialog.tsx:635
msgid "Caricamento dataset…"
msgstr "Caricamento dataset…"

#: src/features/structured-data/components/SimilarPartsSection.tsx:277
msgid "Caricamento dei pezzi simili in corso…"
msgstr "Caricamento dei pezzi simili in corso…"

#: src/routes/public.voice-report.$token.tsx:216
msgid "Caricamento del contenuto del report…"
msgstr "Caricamento del contenuto del report…"

#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:137
msgid "Caricamento del file non riuscito. Riprova."
msgstr "Caricamento del file non riuscito. Riprova."

#: src/features/admin/components/CostTraceDetailSection.tsx:192
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:172
msgid "Caricamento dettagli…"
msgstr "Caricamento dettagli…"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:298
msgid "Caricamento dettaglio…"
msgstr "Caricamento dettaglio…"

#: src/features/dxf/components/DxfLeftRail.tsx:166
msgid "Caricamento disegni"
msgstr "Caricamento disegni"

#: src/routes/_authed/workspace/documents.tsx:1083
msgid "Caricamento documenti"
msgstr "Caricamento documenti"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:174
msgid "Caricamento documenti generati"
msgstr "Caricamento documenti generati"

#: src/routes/_authed/workspace/documents.tsx:948
msgid "Caricamento documenti in corso"
msgstr "Caricamento documenti in corso"

#: src/features/sync/components/UniversalSyncToast.tsx:291
msgid "Caricamento documento"
msgstr "Caricamento documento"

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:609
msgid "Caricamento documento…"
msgstr "Caricamento documento…"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:275
msgid "Caricamento DXF…"
msgstr "Caricamento DXF…"

#: src/features/connectors/wizards/openBankingSpec.tsx:47
msgid "Caricamento elenco banche {country}…"
msgstr "Caricamento elenco banche {country}…"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:318
msgid "Caricamento esperimenti…"
msgstr "Caricamento esperimenti…"

#: src/routes/_authed/workspace/calendar.tsx:1562
msgid "Caricamento evento…"
msgstr "Caricamento evento…"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:190
msgid "Caricamento fact…"
msgstr "Caricamento fact…"

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:241
msgid "Caricamento fallito"
msgstr "Caricamento fallito"

#: src/routes/_authed/_modal/integrations/index.tsx:559
msgid "Caricamento fallito — clicca per riprovare"
msgstr "Caricamento fallito — clicca per riprovare"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:588
msgid "Caricamento fatture…"
msgstr "Caricamento fatture…"

#. placeholder {0}: uploadProgress.percent.toLocaleString("it-IT", { maximumFractionDigits: 1 })
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:288
msgid "Caricamento file · {0}%"
msgstr "Caricamento file · {0}%"

#: src/features/admin/components/widgets/EmptyChartState.tsx:45
msgid "Caricamento grafico…"
msgstr "Caricamento grafico…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:444
#: src/features/console/pages/EmbeddedIdentityPage.tsx:477
msgid "Caricamento identità dell'app…"
msgstr "Caricamento identità dell'app…"

#: src/features/sales/components/SignatureRichEditor.tsx:132
msgid "Caricamento immagine non riuscito"
msgstr "Caricamento immagine non riuscito"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:164
msgid "Caricamento immagine…"
msgstr "Caricamento immagine…"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:142
msgid "Caricamento infrastruttura…"
msgstr "Caricamento infrastruttura…"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:279
msgid "Caricamento inviti…"
msgstr "Caricamento inviti…"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:316
msgid "Caricamento job…"
msgstr "Caricamento job…"

#: src/features/admin/components/AdminOverview.tsx:74
#: src/features/admin/components/UserDetailContent.tsx:475
msgid "Caricamento KPI…"
msgstr "Caricamento KPI…"

#: src/features/price-lists/components/PriceListsPage.tsx:135
msgid "Caricamento listini…"
msgstr "Caricamento listini…"

#: src/features/projects/components/sections/MembersSection.tsx:618
#: src/features/settings/components/OrgMembersPanel.tsx:701
msgid "Caricamento membri"
msgstr "Caricamento membri"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:382
msgid "Caricamento membri…"
msgstr "Caricamento membri…"

#: src/features/projects/components/sections/MemorySection.tsx:278
msgid "Caricamento memoria"
msgstr "Caricamento memoria"

#: src/routes/_authed/workspace/conversations.tsx:1173
msgid "Caricamento messaggio…"
msgstr "Caricamento messaggio…"

#: src/features/admin/components/AdminPlatformSettings.tsx:1007
msgid "Caricamento modelli…"
msgstr "Caricamento modelli…"

#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:303
msgid "Caricamento modello…"
msgstr "Caricamento modello…"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:561
#: src/features/settings/components/BrandKitSettings.tsx:200
#: src/features/settings/components/BrandKitSettings.tsx:240
msgid "Caricamento non riuscito"
msgstr "Caricamento non riuscito"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:395
msgid "Caricamento nudge…"
msgstr "Caricamento nudge…"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:245
msgid "Caricamento organizzazione…"
msgstr "Caricamento organizzazione…"

#: src/features/admin/components/AdminOrgs.tsx:963
msgid "Caricamento organizzazioni…"
msgstr "Caricamento organizzazioni…"

#: src/features/billing/components/CreditBalanceCard.tsx:117
msgid "Caricamento pacchetti…"
msgstr "Caricamento pacchetti…"

#: src/features/console/flows/ConsoleFlowEditor.tsx:313
#: src/routes/_authed/workspace/flows.$flowId.tsx:574
msgid "Caricamento palette…"
msgstr "Caricamento palette…"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:395
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:428
msgid "Caricamento PDF…"
msgstr "Caricamento PDF…"

#: src/features/structured-data/components/SimilarPartsSection.tsx:262
msgid "Caricamento pezzi simili"
msgstr "Caricamento pezzi simili"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:102
msgid "Caricamento policy…"
msgstr "Caricamento policy…"

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:427
msgid "Caricamento presentazione…"
msgstr "Caricamento presentazione…"

#: src/features/projects/components/ProjectDetailPage.tsx:407
msgid "Caricamento progetto…"
msgstr "Caricamento progetto…"

#: src/features/auth/desktop/DesktopLoginForm.tsx:614
msgid "Caricamento provider di accesso…"
msgstr "Caricamento provider di accesso…"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:153
msgid "Caricamento regole…"
msgstr "Caricamento regole…"

#: src/routes/_authed/workspace/dashboard.tsx:689
msgid "Caricamento report"
msgstr "Caricamento report"

#: src/features/clean-control/components/SignalHealthCard.tsx:60
msgid "Caricamento salute segnale"
msgstr "Caricamento salute segnale"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:192
msgid "Caricamento slide"
msgstr "Caricamento slide"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:193
msgid "Caricamento slide…"
msgstr "Caricamento slide…"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:477
msgid "Caricamento slides…"
msgstr "Caricamento slides…"

#: src/features/sources/marp/MarpDeckEditorMount.tsx:365
msgid "Caricamento sorgente Marp"
msgstr "Caricamento sorgente Marp"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:213
msgid "Caricamento statistiche…"
msgstr "Caricamento statistiche…"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:209
msgid "Caricamento stato HyperMem…"
msgstr "Caricamento stato HyperMem…"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:132
msgid "Caricamento stato WhatsApp…"
msgstr "Caricamento stato WhatsApp…"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:657
msgid "Caricamento suggerimenti…"
msgstr "Caricamento suggerimenti…"

#: src/features/automations/components/AutomationsHub.tsx:436
#: src/features/settings/components/PresentationTemplates.tsx:745
#: src/features/templates/components/TemplatesList.tsx:164
#: src/routes/_authed/workspace/templates/$kind.tsx:283
#: src/routes/_authed/workspace/templates/edit.$slug.tsx:53
msgid "Caricamento template…"
msgstr "Caricamento template…"

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:141
msgid "Caricamento tenant…"
msgstr "Caricamento tenant…"

#: src/features/admin/components/UserDetailContent.tsx:745
msgid "Caricamento trace…"
msgstr "Caricamento trace…"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:531
msgid "Caricamento traces…"
msgstr "Caricamento traces…"

#: src/features/admin/components/UserDetailShell.tsx:78
msgid "Caricamento utente…"
msgstr "Caricamento utente…"

#: src/features/admin/components/AdminUsers.tsx:288
#: src/features/console/pages/EmbeddedIdentityPage.tsx:611
msgid "Caricamento utenti…"
msgstr "Caricamento utenti…"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:358
msgid "Caricamento utilizzo…"
msgstr "Caricamento utilizzo…"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:346
msgid "Caricamento viewer"
msgstr "Caricamento viewer"

#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:105
#: src/features/actions/components/EmailTemplatePicker.tsx:74
#: src/features/admin/components/AdminAutomation.tsx:84
#: src/features/admin/components/AdminCanvas.tsx:81
#: src/features/admin/components/AdminCpq.tsx:455
#: src/features/admin/components/AdminCpqList.tsx:115
#: src/features/admin/components/AdminCpqPriceBook.tsx:115
#: src/features/admin/components/AdminDecks.tsx:199
#: src/features/admin/components/AdminDecks.tsx:561
#: src/features/admin/components/AdminDemoInviti.tsx:200
#: src/features/admin/components/AdminEngagement.tsx:99
#: src/features/admin/components/AdminHealth.tsx:65
#: src/features/admin/components/AdminQuality.tsx:76
#: src/features/admin/components/AdminRevenue.tsx:69
#: src/features/admin/components/ModelMarkupCard.tsx:66
#: src/features/admin/components/orgs/_shared.tsx:338
#: src/features/admin/components/orgs/MigrateUserDialog.tsx:174
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:145
#: src/features/admin/components/UserDetailContent.tsx:593
#: src/features/auth/desktop/DesktopLoginForm.tsx:581
#: src/features/auth/desktop/DesktopLoginForm.tsx:776
#: src/features/automations/components/AutomationDetailSection.tsx:105
#: src/features/automations/components/AutomationDetailSection.tsx:217
#: src/features/automations/components/AutomationsHub.tsx:127
#: src/features/automations/components/AutomationsHub.tsx:331
#: src/features/billing/components/CreditBalanceCard.tsx:88
#: src/features/chat/components/ChatTopBar.tsx:163
#: src/features/connect/components/ConnectPublicShell.tsx:101
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:331
#: src/features/console/pages/DocumentsPage.tsx:196
#: src/features/hive-flows/components/FlowShareControl.tsx:156
#: src/features/hive-flows/run/PdfDropzone.tsx:210
#: src/features/sales/components/BatchSendModal.tsx:307
#: src/features/settings/components/BillingSettings.tsx:104
#: src/features/settings/components/BrandKitSettings.tsx:678
#: src/features/settings/components/BrandKitSettings.tsx:697
#: src/features/settings/components/ProfileSettings.tsx:85
#: src/features/settings/components/SecuritySettings.tsx:316
#: src/features/settings/components/SelfProfileMemory.tsx:397
#: src/features/settings/marp/CssUploadPanel.tsx:252
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:238
#: src/features/sources/components/CalendarEventPane.tsx:678
#: src/features/workspace/components/NotificationPill.tsx:208
#: src/features/workspace/components/ProjectPill.tsx:79
#: src/features/workspace/components/UploadModal.tsx:310
#: src/routes/_authed/workspace/calendar.tsx:628
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:124
#: src/routes/_authed/workspace/canvases.tsx:157
#: src/routes/_authed/workspace/canvases.tsx:184
#: src/routes/_authed/workspace/connect.index.tsx:97
#: src/routes/_authed/workspace/dashboard.tsx:880
#: src/routes/_authed/workspace/dashboard.tsx:923
#: src/routes/_authed/workspace/dashboard.tsx:1179
#: src/routes/_authed/workspace/documents.tsx:860
#: src/routes/_authed/workspace/finance.tsx:280
#: src/routes/_authed/workspace/flows.index.tsx:248
#: src/routes/_authed/workspace/flows.index.tsx:558
#: src/routes/_authed/workspace/shares.tsx:97
#: src/routes/_authed/workspace/technical.tsx:278
#: src/routes/_authed/workspace/technical.tsx:643
#: src/routes/_authed/workspace/work.tsx:316
#: src/routes/forms.$flowId.tsx:48
msgid "Caricamento…"
msgstr "Caricamento…"

#: src/features/workspace/config.ts:381
#: src/features/workspace/documents/components/FolderBrowserView.tsx:53
msgid "Caricati"
msgstr "Caricati"

#: src/features/console/pages/DocumentsPage.tsx:221
msgid "Caricati {uploadedCount} file. L'indicizzazione è in corso."
msgstr "Caricati {uploadedCount} file. L'indicizzazione è in corso."

#: src/features/workspace/hooks/useDocuments.ts:322
msgid "Caricati manualmente"
msgstr "Caricati manualmente"

#: src/routes/_authed/workspace/conversations.tsx:1263
msgid "Carico altri messaggi…"
msgstr "Carico altri messaggi…"

#: ../../packages/ui/src/ando/OrganizationMemberPicker.tsx:282
msgid "Carico colleghi…"
msgstr "Carico colleghi…"

#: src/features/sync/components/DocSyncManager.tsx:1043
#: src/features/sync/components/picker/NotionPickerModal.tsx:127
msgid "Carico contenuti…"
msgstr "Carico contenuti…"

#: src/features/connect/components/GrantManager.tsx:694
msgid "Carico i connettori…"
msgstr "Carico i connettori…"

#: src/features/hive-flows/components/DocumentPickerField.tsx:72
msgid "Carico i documenti…"
msgstr "Carico i documenti…"

#: src/features/hive-flows/components/DocTemplatesField.tsx:31
msgid "Carico i template…"
msgstr "Carico i template…"

#: src/features/sync/components/DocSyncManager.tsx:616
msgid "Carico i tuoi file…"
msgstr "Carico i tuoi file…"

#: src/features/hive-flows/run/RunDocumentViewer.tsx:114
#: src/features/hive-flows/run/RunDocumentViewer.tsx:137
msgid "Carico il documento…"
msgstr "Carico il documento…"

#: src/routes/_authed/workspace/conversations.tsx:1181
msgid "Carico il messaggio…"
msgstr "Carico il messaggio…"

#: src/routes/_authed/workspace/calendar.tsx:1569
msgid "Carico l'evento…"
msgstr "Carico l'evento…"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:509
msgid "Carico la slide…"
msgstr "Carico la slide…"

#: src/features/dxf/components/PdfDrawingSheet.tsx:54
#: src/features/dxf/components/PdfDrawingSheet.tsx:79
msgid "Carico la tavola…"
msgstr "Carico la tavola…"

#: src/features/hive-flows/components/EnterpriseConnectorsField.tsx:37
msgid "Carico le banche dati…"
msgstr "Carico le banche dati…"

#: src/features/sales/components/LeadsPanel.tsx:242
msgid "Carico le campagne…"
msgstr "Carico le campagne…"

#: src/routes/_authed/workspace/conversations.tsx:874
msgid "Carico le conversazioni…"
msgstr "Carico le conversazioni…"

#: src/features/console/pages/PlaygroundPage.tsx:575
msgid "Carico le sorgenti interrogabili…"
msgstr "Carico le sorgenti interrogabili…"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:562
msgid "Carico raccolte…"
msgstr "Carico raccolte…"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:412
msgid "Carico regole…"
msgstr "Carico regole…"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:501
msgid "Carico siti SharePoint…"
msgstr "Carico siti SharePoint…"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:650
msgid "Carico struttura cartelle…"
msgstr "Carico struttura cartelle…"

#: src/features/price-lists/components/PriceListsPage.tsx:532
msgid "Carico voci…"
msgstr "Carico voci…"

#: src/features/clean-control/components/EventQueue.tsx:349
#: src/features/connect/components/GrantManager.tsx:881
#: src/features/sync/components/DocSyncManager.tsx:1288
msgid "Carico…"
msgstr "Carico…"

#: src/features/report/components/RespondentQuotesCarousel.tsx:124
msgid "carosello"
msgstr "carosello"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:55
msgid "Carta salvata"
msgstr "Carta salvata"

#: src/features/dxf/utils.ts:125
msgid "Cartamodello"
msgstr "Cartamodello"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:363
msgid "cartella"
msgstr "cartella"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:107
#: src/features/connectors/components/ConnectedAccountRow.tsx:144
#: src/features/connectors/components/FilesystemConnectDialog.tsx:816
#: src/features/connectors/wizards/cadLibrarySpec.tsx:129
#: src/features/connectors/wizards/filesystemSpec.tsx:150
#: src/features/projects/components/ProjectIcon.tsx:65
msgid "Cartella"
msgstr "Cartella"

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:707
msgid "Cartella \"{0}\" eliminata"
msgstr "Cartella \"{0}\" eliminata"

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:715
msgid "Cartella \"{0}\" eliminata parzialmente"
msgstr "Cartella \"{0}\" eliminata parzialmente"

#. placeholder {0}: providerLabel.toLowerCase()
#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:330
msgid "Cartella {0}"
msgstr "Cartella {0}"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:385
msgid "Cartella collegata"
msgstr "Cartella collegata"

#. placeholder {0}: summary.uploadedFiles
#: src/features/connectors/components/FilesystemConnectDialog.tsx:363
msgid "Cartella collegata · {0} file in caricamento"
msgstr "Cartella collegata · {0} file in caricamento"

#. placeholder {0}: summary.failedFiles
#: src/features/connectors/components/FilesystemConnectDialog.tsx:358
msgid "Cartella collegata, ma {0} file non caricati. Riprova la sincronizzazione."
msgstr "Cartella collegata, ma {0} file non caricati. Riprova la sincronizzazione."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:376
msgid "Cartella collegata, ma è vuota."
msgstr "Cartella collegata, ma è vuota."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:380
msgid "Cartella collegata, ma nessun file compatibile trovato (pdf, docx, xlsx, txt…)."
msgstr "Cartella collegata, ma nessun file compatibile trovato (pdf, docx, xlsx, txt…)."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:347
msgid "Cartella di destinazione ({providerLabel})"
msgstr "Cartella di destinazione ({providerLabel})"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:510
msgid "Cartella di rete"
msgstr "Cartella di rete"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:509
msgid "Cartella locale"
msgstr "Cartella locale"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:101
msgid "Cartella locale / NAS"
msgstr "Cartella locale / NAS"

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:332
msgid "Cartella non trovata: {first} — è stata spostata o eliminata. Rimuovi la cartella e ricollegala dal percorso attuale."
msgstr "Cartella non trovata: {first} — è stata spostata o eliminata. Rimuovi la cartella e ricollegala dal percorso attuale."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:351
msgid "Cartella radice"
msgstr "Cartella radice"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:389
msgid "cartella selezionata"
msgstr "cartella selezionata"

#: src/features/sync/components/DocSyncManager.tsx:1310
msgid "Cartella vuota."
msgstr "Cartella vuota."

#. placeholder {0}: folderCrumbs.join(" / ")
#: src/features/workspace/documents/components/DocumentCardV2.tsx:203
msgid "Cartella: {0}"
msgstr "Cartella: {0}"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:363
msgid "cartelle"
msgstr "cartelle"

#: src/features/projects/components/sections/KnowledgeSection.tsx:181
#: src/features/workspace/documents/components/FolderBrowserView.tsx:136
#: src/features/workspace/documents/components/FolderBrowserView.tsx:226
msgid "Cartelle"
msgstr "Cartelle"

#: src/features/connectors/wizards/filesystemSpec.tsx:33
#: src/features/workspace/config.ts:379
msgid "Cartelle e NAS"
msgstr "Cartelle e NAS"

#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:150
msgid "Cartelle esistenti"
msgstr "Cartelle esistenti"

#: src/features/connectors/wizards/filesystemSpec.tsx:117
msgid "Cartelle locali e NAS"
msgstr "Cartelle locali e NAS"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:389
msgid "cartelle selezionate"
msgstr "cartelle selezionate"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:325
#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:342
msgid "Casella PEC mittente"
msgstr "Casella PEC mittente"

#: src/routes/_authed/_modal/integrations/$capability.tsx:992
#: src/routes/_authed/_modal/integrations/$capability.tsx:999
msgid "Casella PEC senza indirizzo — riconnetti l'account."
msgstr "Casella PEC senza indirizzo — riconnetti l'account."

#: src/features/workspace/config.ts:356
#: src/routes/_authed/workspace/finance.tsx:265
msgid "Cash flow"
msgstr "Cash flow"

#: src/features/connectors/wizards/openBankingSpec.tsx:197
msgid "Cash flow forecast"
msgstr "Cash flow forecast"

#: src/routes/_authed/workspace/finance.tsx:879
msgid "Cash flow netto settimanale"
msgstr "Cash flow netto settimanale"

#: src/routes/_authed/workspace/finance.tsx:1575
msgid "Cash flow settimanale"
msgstr "Cash flow settimanale"

#: src/features/connectors/wizards/openBankingSpec.tsx:193
msgid "Cash position aggiornata su tutti i conti collegati."
msgstr "Cash position aggiornata su tutti i conti collegati."

#. placeholder {0}: i18n._(PERIOD_LABELS[period])
#: src/routes/_authed/workspace/finance.tsx:522
msgid "Cash-flow {0}"
msgstr "Cash-flow {0}"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:81
msgid "Cash, controllo, finance"
msgstr "Cash, controllo, finance"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:90
msgid "Cassetto"
msgstr "Cassetto"

#: src/features/console/connectors/meta.ts:156
msgid "Cassetto fiscale"
msgstr "Cassetto fiscale"

#: src/features/connectors/components/vendorIcons.tsx:169
#: src/features/connectors/components/vendorIcons.tsx:486
#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:28
#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:36
#: src/routes/_authed/workspace/finance.tsx:1213
msgid "Cassetto Fiscale"
msgstr "Cassetto Fiscale"

#: src/routes/_authed/workspace/finance.tsx:599
msgid "Cassetto Fiscale collegato — chiedi ad Ando di interrogare l'archivio AdE."
msgstr "Cassetto Fiscale collegato — chiedi ad Ando di interrogare l'archivio AdE."

#: src/routes/_authed/workspace/finance.tsx:1746
msgid "Cassetto fiscale e SDI"
msgstr "Cassetto fiscale e SDI"

#: src/features/templates/components/TemplateFieldSpecs.ts:170
msgid "Casual"
msgstr "Casual"

#: src/features/console/pages/ConnectorsPage.tsx:63
msgid "Catalogo"
msgstr "Catalogo"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:555
msgid "Catalogo del corpus — esempio: M6, M8, H7."
msgstr "Catalogo del corpus — esempio: M6, M8, H7."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:845
#: src/features/dxf/components/DxfActionsMenu.tsx:93
#: src/features/price-lists/components/PriceListsPage.tsx:941
msgid "Categoria"
msgstr "Categoria"

#: src/features/dashboard/components/AxisConfigurator.tsx:121
#: src/features/dashboard/components/DashboardChartCard.tsx:753
msgid "Categoria, valore e colori"
msgstr "Categoria, valore e colori"

#: src/features/connectors/components/management/SchemaViewer.tsx:446
msgid "categorico"
msgstr "categorico"

#: src/features/dxf/components/DxfCategorySidebar.tsx:28
#: src/features/dxf/components/DxfLeftRail.tsx:95
#: src/features/voice_report/components/RunDiffTimeline.tsx:230
msgid "Categorie"
msgstr "Categorie"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:528
msgid "Categorie geometriche estratte dall'analizzatore SOTA."
msgstr "Categorie geometriche estratte dall'analizzatore SOTA."

#: src/features/console/traces/TraceGraph.tsx:41
msgid "Cattura mancante"
msgstr "Cattura mancante"

#: src/features/console/traces/TraceGraph.tsx:46
msgid "Cattura non determinata"
msgstr "Cattura non determinata"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:181
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:387
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:399
msgid "Causale"
msgstr "Causale"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:398
msgid "Causale del bonifico (es. Fattura 2026/123)"
msgstr "Causale del bonifico (es. Fattura 2026/123)"

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:202
#: src/features/sources/components/InboxDetailPane.tsx:1859
msgid "Cc"
msgstr "Cc"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:301
#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:175
msgid "Cc:"
msgstr "Cc:"

#: src/features/sources/components/EmailThreadMessages.tsx:290
msgid "Cc: "
msgstr "Cc: "

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:214
#: src/features/sources/components/InboxDetailPane.tsx:1868
msgid "Ccn"
msgstr "Ccn"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:307
msgid "Ccn:"
msgstr "Ccn:"

#: src/features/settings/components/NotificationPreferences.tsx:96
msgid "Celebrazione dei tuoi successi settimanali."
msgstr "Celebrazione dei tuoi successi settimanali."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1239
msgid "Centra in orizzontale"
msgstr "Centra in orizzontale"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1242
msgid "Centra in verticale"
msgstr "Centra in verticale"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1587
msgid "Centro"
msgstr "Centro"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1945
msgid "Centro orizz."
msgstr "Centro orizz."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1948
msgid "Centro vert."
msgstr "Centro vert."

#: src/features/chat/components/ConversationMiniRail.tsx:226
#: src/features/connect/components/GrantManager.tsx:869
#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:90
#: src/features/console/pages/EmbeddedIdentityPage.tsx:330
#: src/features/console/pages/EmbeddedIdentityPage.tsx:605
#: src/features/console/pages/ResourceAccessPage.tsx:852
msgid "Cerca"
msgstr "Cerca"

#. placeholder {0}: spec.referenceTo
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:977
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1009
msgid "Cerca {0}…"
msgstr "Cerca {0}…"

#: src/features/agent-modes/components/AgentModeEditor.tsx:424
msgid "Cerca a fondo"
msgstr "Cerca a fondo"

#: src/features/clean-control/utils/signalCatalog.ts:202
msgid "Cerca allegato"
msgstr "Cerca allegato"

#: src/routes/_authed/workspace/sales.tsx:59
msgid "Cerca aziende…"
msgstr "Cerca aziende…"

#: src/routes/_authed/workspace/calendar.tsx:737
msgid "Cerca calendario"
msgstr "Cerca calendario"

#: src/features/connect/components/MemberManager.tsx:628
msgid "Cerca collega"
msgstr "Cerca collega"

#: src/features/console/pages/ConnectorsPage.tsx:281
msgid "Cerca connettori"
msgstr "Cerca connettori"

#: src/routes/_authed/workspace/sales.tsx:58
msgid "Cerca contatti…"
msgstr "Cerca contatti…"

#: src/routes/_authed/workspace/conversations.tsx:638
msgid "Cerca conversazioni"
msgstr "Cerca conversazioni"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:164
msgid "Cerca dataset…"
msgstr "Cerca dataset…"

#: src/routes/_authed/workspace/technical.tsx:305
msgid "Cerca disegni CAD"
msgstr "Cerca disegni CAD"

#: src/routes/_authed/workspace/technical.tsx:304
msgid "Cerca disegno…"
msgstr "Cerca disegno…"

#: src/features/console/pages/DocumentsPage.tsx:691
#: src/routes/_authed/workspace/documents.tsx:478
#: src/routes/_authed/workspace/documents.tsx:886
msgid "Cerca documenti"
msgstr "Cerca documenti"

#: src/features/chat/components/ChatEmptyState.tsx:236
msgid "Cerca documenti recenti per un cliente specifico."
msgstr "Cerca documenti recenti per un cliente specifico."

#: src/routes/_authed/workspace/documents.tsx:885
msgid "Cerca documenti, allegati, drive…"
msgstr "Cerca documenti, allegati, drive…"

#: src/features/chat/components/ConversationCommandPalette.tsx:343
msgid "Cerca documenti, chat, azioni…"
msgstr "Cerca documenti, chat, azioni…"

#: src/routes/_authed/workspace/conversations.tsx:797
msgid "Cerca email, chat, PEC…"
msgstr "Cerca email, chat, PEC…"

#: src/features/console/pages/DocsPage.tsx:530
msgid "Cerca endpoint, metodi SDK, scope…"
msgstr "Cerca endpoint, metodi SDK, scope…"

#: src/routes/_authed/workspace/calendar.tsx:736
msgid "Cerca eventi, riunioni…"
msgstr "Cerca eventi, riunioni…"

#: src/features/admin/components/orgs/AuditLogList.tsx:116
msgid "Cerca evento di audit"
msgstr "Cerca evento di audit"

#: src/routes/_authed/workspace/finance.tsx:301
msgid "Cerca fatture, banking, F24…"
msgstr "Cerca fatture, banking, F24…"

#: src/routes/_authed/workspace/finance.tsx:302
msgid "Cerca finanza"
msgstr "Cerca finanza"

#: src/features/console/docs/content.ts:1622
msgid "Cerca i chunk email, Drive e chat Teams indicizzati per l'utente autenticato della tua app. Ogni risultato viene ricontrollato contro proprietario, credenziale e app attivi. Non legge le connessioni Workspace."
msgstr "Cerca i chunk email, Drive e chat Teams indicizzati per l'utente autenticato della tua app. Ogni risultato viene ricontrollato contro proprietario, credenziale e app attivi. Non legge le connessioni Workspace."

#: src/features/console/docs/content.ts:1621
msgid "Cerca i dati dell'utente in TRAMA"
msgstr "Cerca i dati dell'utente in TRAMA"

#: src/features/console/pages/DevelopersPage.tsx:35
msgid "Cerca i passaggi più rilevanti nella knowledge base del progetto."
msgstr "Cerca i passaggi più rilevanti nella knowledge base del progetto."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2027
msgid "Cerca icona (in inglese: rocket, chart, user…)"
msgstr "Cerca icona (in inglese: rocket, chart, user…)"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:329
msgid "Cerca in tutti i miei account"
msgstr "Cerca in tutti i miei account"

#: src/routes/_authed/_modal/integrations/index.tsx:370
msgid "Cerca integrazioni"
msgstr "Cerca integrazioni"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:167
msgid "Cerca invito"
msgstr "Cerca invito"

#: src/routes/_authed/workspace/work.tsx:337
msgid "Cerca lavoro"
msgstr "Cerca lavoro"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:253
msgid "Cerca membro"
msgstr "Cerca membro"

#: src/features/agent-modes/components/AgentModesList.tsx:216
msgid "Cerca modo"
msgstr "Cerca modo"

#: src/features/agent-modes/components/AgentModesList.tsx:215
msgid "Cerca modo…"
msgstr "Cerca modo…"

#: src/features/console/docs/content.ts:1741
msgid "Cerca nei documenti del project (scope query:read). I narrowing restringono solo; la resource policy vince."
msgstr "Cerca nei documenti del project (scope query:read). I narrowing restringono solo; la resource policy vince."

#: src/features/console/docs/content.ts:1486
msgid "Cerca nei miei account"
msgstr "Cerca nei miei account"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:328
msgid "Cerca nei tuoi dati"
msgstr "Cerca nei tuoi dati"

#: src/routes/_authed/workspace/sales.tsx:98
msgid "Cerca nel CRM"
msgstr "Cerca nel CRM"

#: src/features/console/pages/DocsPage.tsx:529
msgid "Cerca nella documentazione"
msgstr "Cerca nella documentazione"

#: src/features/console/pages/AccessOverviewPage.tsx:279
msgid "Cerca nella pagina"
msgstr "Cerca nella pagina"

#: src/features/console/pages/AccessOverviewPage.tsx:278
msgid "Cerca nella pagina corrente"
msgstr "Cerca nella pagina corrente"

#: src/features/help/components/ShortcutsList.tsx:125
msgid "Cerca nella tab workspace corrente"
msgstr "Cerca nella tab workspace corrente"

#: src/features/console/pages/PlaygroundPage.tsx:1973
msgid "Cerca nelle fonti accessibili al progetto o prova i permessi di una AppKey."
msgstr "Cerca nelle fonti accessibili al progetto o prova i permessi di una AppKey."

#: src/features/console/pages/TracesPage.tsx:541
msgid "Cerca nelle richieste caricate"
msgstr "Cerca nelle richieste caricate"

#: ../../packages/ui/src/workspace/WorkspaceSearchBar.tsx:148
msgid "Cerca nello spazio di lavoro"
msgstr "Cerca nello spazio di lavoro"

#: src/features/sales/components/crm/SuggestionsStrip.tsx:79
msgid "Cerca nuovi suggerimenti"
msgstr "Cerca nuovi suggerimenti"

#: src/features/sales/components/crm/SuggestionsStrip.tsx:55
msgid "Cerca nuovi suggerimenti dalle email"
msgstr "Cerca nuovi suggerimenti dalle email"

#: src/routes/_authed/workspace/sales.tsx:57
msgid "Cerca opportunità…"
msgstr "Cerca opportunità…"

#: src/features/account/components/OrgSwitcherDialog.tsx:183
msgid "Cerca organizzazione"
msgstr "Cerca organizzazione"

#: src/features/admin/components/AdminOrgs.tsx:861
msgid "Cerca organizzazioni"
msgstr "Cerca organizzazioni"

#: src/features/sync/components/picker/NotionPickerModal.tsx:118
msgid "Cerca pagine, database…"
msgstr "Cerca pagine, database…"

#: src/features/console/pages/PlaygroundPage.tsx:2017
msgid "Cerca passaggi"
msgstr "Cerca passaggi"

#: src/features/admin/components/orgs/AuditLogList.tsx:117
msgid "Cerca per azione, attore o target…"
msgstr "Cerca per azione, attore o target…"

#: src/features/chat/components/ChatEmptyState.tsx:235
msgid "Cerca per cliente"
msgstr "Cerca per cliente"

#: src/features/admin/components/AdminUsers.tsx:240
msgid "Cerca per email o nome…"
msgstr "Cerca per email o nome…"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:168
msgid "Cerca per email…"
msgstr "Cerca per email…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:604
msgid "Cerca per ID utente nella tua app"
msgstr "Cerca per ID utente nella tua app"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:93
msgid "Cerca per materiale"
msgstr "Cerca per materiale"

#: src/features/console/pages/DocumentsPage.tsx:692
msgid "Cerca per nome"
msgstr "Cerca per nome"

#: src/features/hive-flows/components/DocumentPickerField.tsx:66
msgid "Cerca per nome file…"
msgstr "Cerca per nome file…"

#: src/features/dashboard/components/ShareChartSheet.tsx:292
#: src/features/dashboard/components/ShareDashboardSheet.tsx:279
#: src/features/share/components/ShareLinkDialog.tsx:745
msgid "Cerca per nome o email"
msgstr "Cerca per nome o email"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:254
#: src/features/connect/components/MemberManager.tsx:627
#: src/features/projects/components/sections/MembersSection.tsx:425
msgid "Cerca per nome o email…"
msgstr "Cerca per nome o email…"

#: src/features/admin/components/AdminOrgs.tsx:860
msgid "Cerca per nome o slug…"
msgstr "Cerca per nome o slug…"

#: src/features/console/pages/ConnectorsPage.tsx:282
msgid "Cerca per nome o tipo"
msgstr "Cerca per nome o tipo"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:176
msgid "Cerca persone, documenti, cartelle…"
msgstr "Cerca persone, documenti, cartelle…"

#: src/features/admin/components/AdminCpqList.tsx:88
msgid "Cerca preventivi"
msgstr "Cerca preventivi"

#: src/features/projects/components/ProjectHub.tsx:383
msgid "Cerca progetti"
msgstr "Cerca progetti"

#: src/routes/_authed/workspace/dashboard.tsx:624
msgid "Cerca report"
msgstr "Cerca report"

#: src/routes/_authed/workspace/dashboard.tsx:623
msgid "Cerca report per nome o azienda…"
msgstr "Cerca report per nome o azienda…"

#: src/features/admin/components/AdminCpqList.tsx:87
msgid "Cerca riferimento, cliente, software house"
msgstr "Cerca riferimento, cliente, software house"

#: src/features/console/components/CommandPalette.tsx:162
msgid "Cerca sezioni e azioni"
msgstr "Cerca sezioni e azioni"

#: src/features/console/components/CommandPalette.tsx:161
msgid "Cerca sezioni e azioni…"
msgstr "Cerca sezioni e azioni…"

#: src/features/connectors/components/management/SchemaViewer.tsx:171
msgid "Cerca tabella"
msgstr "Cerca tabella"

#: src/features/connectors/components/management/SchemaViewer.tsx:170
msgid "Cerca tabella…"
msgstr "Cerca tabella…"

#: src/routes/_authed/workspace/work.tsx:336
msgid "Cerca task, attività…"
msgstr "Cerca task, attività…"

#: src/features/help/components/ShortcutsList.tsx:254
msgid "Cerca tasto o azione…"
msgstr "Cerca tasto o azione…"

#: src/features/projects/components/sections/MembersSection.tsx:573
msgid "Cerca tra i membri della tua organizzazione oppure digita un'email diretta. Il ruolo Owner non è assegnabile (uno per progetto)."
msgstr "Cerca tra i membri della tua organizzazione oppure digita un'email diretta. Il ruolo Owner non è assegnabile (uno per progetto)."

#: ../../packages/ui/src/ando/OrganizationMemberPicker.tsx:93
msgid "Cerca un collega…"
msgstr "Cerca un collega…"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:233
msgid "Cerca un contatto o digita un'email…"
msgstr "Cerca un contatto o digita un'email…"

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:429
msgid "Cerca un documento Ando…"
msgstr "Cerca un documento Ando…"

#: src/features/settings/components/BrandKitSettings.tsx:368
msgid "Cerca un font Google per i titoli"
msgstr "Cerca un font Google per i titoli"

#: src/features/settings/components/BrandKitSettings.tsx:368
msgid "Cerca un font Google per il corpo"
msgstr "Cerca un font Google per il corpo"

#: src/features/projects/components/sections/MembersSection.tsx:426
msgid "Cerca un membro da invitare"
msgstr "Cerca un membro da invitare"

#: ../../packages/ui/src/ando/OrganizationMemberPicker.tsx:95
msgid "Cerca un membro dell'organizzazione"
msgstr "Cerca un membro dell'organizzazione"

#: src/features/hive-flows/components/NodePalette.tsx:63
msgid "Cerca un nodo"
msgstr "Cerca un nodo"

#: src/features/hive-flows/components/NodePalette.tsx:62
msgid "Cerca un nodo…"
msgstr "Cerca un nodo…"

#: src/features/console/docs/content.ts:1127
msgid "Cerca un tentativo HTTP tramite ?idempotency_key=, senza esporre parametri o risposta. Gli stati started e unknown hanno esito incerto: verifica il sistema esterno prima di creare una nuova intenzione. La lettura non ritenta né risolve il tentativo."
msgstr "Cerca un tentativo HTTP tramite ?idempotency_key=, senza esporre parametri o risposta. Gli stati started e unknown hanno esito incerto: verifica il sistema esterno prima di creare una nuova intenzione. La lettura non ritenta né risolve il tentativo."

#: src/features/console/pages/SchemaPage.tsx:939
msgid "Cerca una sorgente"
msgstr "Cerca una sorgente"

#: src/features/console/pages/SchemaPage.tsx:938
msgid "Cerca una sorgente…"
msgstr "Cerca una sorgente…"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:566
msgid "Cerca uno stile per nome o categoria"
msgstr "Cerca uno stile per nome o categoria"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:565
msgid "Cerca uno stile…"
msgstr "Cerca uno stile…"

#: src/features/admin/components/AdminUsers.tsx:241
msgid "Cerca utente"
msgstr "Cerca utente"

#: src/features/console/pages/ResourceAccessPage.tsx:845
msgid "Cerca utente per ID"
msgstr "Cerca utente per ID"

#: src/routes/_authed/_modal/integrations/index.tsx:368
msgid "Cerca: Gmail, fatturazione, banca…"
msgstr "Cerca: Gmail, fatturazione, banca…"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1009
#: ../../packages/ui/src/command-palette/CommandPalette.tsx:162
#: ../../packages/ui/src/workspace/WorkspaceSearchBar.tsx:147
#: src/features/account/components/OrgSwitcherDialog.tsx:182
#: src/features/admin/components/orgs/_shared.tsx:151
#: src/features/connect/components/GrantManager.tsx:868
#: src/features/projects/components/ProjectHub.tsx:382
#: src/routes/_authed/workspace/sales.tsx:97
msgid "Cerca…"
msgstr "Cerca…"

#: src/routes/_authed/workspace/conversations.tsx:873
msgid "Cerco in tutti gli account…"
msgstr "Cerco in tutti gli account…"

#: src/features/sales/hooks/useSalesQueries.ts:206
msgid "Cerco le email mancanti… compaiono man mano."
msgstr "Cerco le email mancanti… compaiono man mano."

#: src/features/chat/hooks/useThinkingHops.ts:55
msgid "Cerco le informazioni iniziali"
msgstr "Cerco le informazioni iniziali"

#: src/features/chat/wsHandlers.ts:486
msgid "Cerco le informazioni iniziali…"
msgstr "Cerco le informazioni iniziali…"

#: src/features/chat/wsHandlers.ts:474
msgid "Cerco nei documenti…"
msgstr "Cerco nei documenti…"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:174
msgid "Cerco persone, documenti, cartelle…"
msgstr "Cerco persone, documenti, cartelle…"

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:417
msgid "Cerco tra i contatti…"
msgstr "Cerco tra i contatti…"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:455
msgid "Cerco tra i tuoi contatti…"
msgstr "Cerco tra i tuoi contatti…"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1168
msgid "Certificato root SSL"
msgstr "Certificato root SSL"

#: src/routes/_authed/workspace/work.tsx:618
msgid "chat"
msgstr "chat"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:125
#: src/features/admin/components/orgs/OrgCostTab.tsx:53
#: src/features/chat/hooks/useThinkingHops.ts:44
#: src/features/clean-control/components/EventQueue.tsx:99
#: src/features/console/components/KeyMeta.tsx:60
#: src/features/console/pages/DocumentsPage.tsx:83
#: src/features/console/pages/EmbeddedIdentityPage.tsx:163
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
#: src/features/console/pages/PlaygroundPage.tsx:1988
#: src/features/help/components/ShortcutsList.tsx:44
msgid "Chat"
msgstr "Chat"

#: src/features/billing/components/UsageMeter.tsx:176
msgid "Chat — mese corrente"
msgstr "Chat — mese corrente"

#: src/features/connect/components/ConnectChat.tsx:220
msgid "Chat dello spazio"
msgstr "Chat dello spazio"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:476
msgid "Chat di gruppo"
msgstr "Chat di gruppo"

#: src/features/chat/components/LayoutSwitcher.tsx:64
msgid "Chat e area di lavoro affiancate"
msgstr "Chat e area di lavoro affiancate"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:382
msgid "Chat private e di gruppo"
msgstr "Chat private e di gruppo"

#: src/features/chat/components/ConversationCommandPalette.tsx:315
#: src/features/chat/components/ConversationSidebar.tsx:487
msgid "Chat recenti"
msgstr "Chat recenti"

#: src/features/chat/components/LayoutSwitcher.tsx:71
msgid "Chat ridotta a barra, area di lavoro grande"
msgstr "Chat ridotta a barra, area di lavoro grande"

#: src/features/connect/components/CreateSpaceDialog.tsx:100
#: src/features/connect/components/SpaceCard.tsx:72
#: src/features/connect/components/SpaceCard.tsx:210
#: src/routes/_authed/workspace/connect.$spaceId.tsx:248
msgid "Chatbot"
msgstr "Chatbot"

#: src/features/connect/components/ChatbotPanel.tsx:83
msgid "Chatbot disattivato"
msgstr "Chatbot disattivato"

#: src/features/connect/components/ChatbotPanel.tsx:72
msgid "Chatbot pubblicato"
msgstr "Chatbot pubblicato"

#: src/features/connect/components/ChatbotPanel.tsx:92
msgid "Chatbot pubblico"
msgstr "Chatbot pubblico"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:104
#: src/features/dfm-rules/components/DfmRulesPage.tsx:216
msgid "Checklist analizzata"
msgstr "Checklist analizzata"

#: src/features/sales/components/SuppressionPanel.tsx:63
msgid "Chi è in questa lista non verrà <0>mai</0> contattato. Ando blocca l'invio sia alla scrittura della bozza sia alla spedizione."
msgstr "Chi è in questa lista non verrà <0>mai</0> contattato. Ando blocca l'invio sia alla scrittura della bozza sia alla spedizione."

#: src/features/console/pages/ResourceAccessPage.tsx:438
msgid "Chi può leggere"
msgstr "Chi può leggere"

#: src/features/share/components/ShareLinkDialog.tsx:236
msgid "Chi riceve vede la conversazione così com'è ora, senza accesso al tuo workspace."
msgstr "Chi riceve vede la conversazione così com'è ora, senza accesso al tuo workspace."

#: src/features/share/components/ShareLinkDialog.tsx:238
msgid "Chi riceve vede solo questa risposta, senza accesso al tuo workspace."
msgstr "Chi riceve vede solo questa risposta, senza accesso al tuo workspace."

#: src/features/chat/components/ChatEmptyState.tsx:145
msgid "Chi vedo questa settimana"
msgstr "Chi vedo questa settimana"

#: src/features/chat/components/ChatEmptyState.tsx:146
msgid "Chi vedo questa settimana? Raggruppa per cliente / azienda."
msgstr "Chi vedo questa settimana? Raggruppa per cliente / azienda."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:163
msgid "Chiamata sincrona: Ando invoca direttamente l'endpoint HTTP che «{connectorName}» ha dichiarato per questa azione e ti mostra subito la risposta."
msgstr "Chiamata sincrona: Ando invoca direttamente l'endpoint HTTP che «{connectorName}» ha dichiarato per questa azione e ti mostra subito la risposta."

#: src/features/admin/components/AdminQuality.tsx:183
#: src/features/console/pages/TracesPage.tsx:287
#: src/features/settings/components/PlatformUsageCard.tsx:63
msgid "Chiamate"
msgstr "Chiamate"

#: src/features/admin/components/CostTraceDetailSection.tsx:154
#: src/features/admin/components/orgs/OrgCostTab.tsx:368
msgid "Chiamate LLM"
msgstr "Chiamate LLM"

#: src/features/settings/components/PlatformUsageCard.tsx:56
msgid "Chiamate, token e costo del tuo utilizzo LLM/API."
msgstr "Chiamate, token e costo del tuo utilizzo LLM/API."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:218
#: src/features/settings/MarpTemplateSettings.tsx:229
msgid "Chiari"
msgstr "Chiari"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:811
#: src/features/settings/components/ProfileSettings.tsx:144
#: src/features/settings/MarpTemplateSettings.tsx:297
msgid "Chiaro"
msgstr "Chiaro"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:80
msgid "Chiave"
msgstr "Chiave"

#: src/features/console/pages/KeyDetailPage.tsx:135
#: src/features/console/pages/KeyDetailPage.tsx:259
msgid "Chiave aggiornata"
msgstr "Chiave aggiornata"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:42
msgid "Chiave API"
msgstr "Chiave API"

#: src/features/console/docs/content.ts:1990
msgid "Chiave assente, malformata o sconosciuta."
msgstr "Chiave assente, malformata o sconosciuta."

#: src/features/console/components/CreateKeyWizard.tsx:119
#: src/features/console/components/CreateKeyWizard.tsx:722
msgid "Chiave creata"
msgstr "Chiave creata"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:252
msgid "Chiave di test: endpoint non chiamato"
msgstr "Chiave di test: endpoint non chiamato"

#. placeholder {0}: column.foreign_key
#: src/features/connectors/components/management/SchemaViewer.tsx:438
msgid "Chiave esterna verso {0}"
msgstr "Chiave esterna verso {0}"

#: src/features/console/components/CreateKeyWizard.tsx:308
msgid "Chiave live (produzione)"
msgstr "Chiave live (produzione)"

#: src/features/console/pages/KeyDetailPage.tsx:629
msgid "Chiave non trovata"
msgstr "Chiave non trovata"

#: src/features/connectors/components/management/SchemaViewer.tsx:432
msgid "Chiave primaria"
msgstr "Chiave primaria"

#: src/features/console/pages/KeyDetailPage.tsx:574
#: src/features/console/pages/KeysPage.tsx:59
msgid "Chiave revocata"
msgstr "Chiave revocata"

#: src/features/console/docs/content.ts:1992
msgid "Chiave revocata."
msgstr "Chiave revocata."

#: src/features/console/pages/KeyDetailPage.tsx:560
msgid "Chiave ruotata"
msgstr "Chiave ruotata"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:428
msgid "Chiavi pubbliche con cui Ando verifica la firma dei token."
msgstr "Chiavi pubbliche con cui Ando verifica la firma dei token."

#: src/features/console/pages/KeysPage.tsx:73
msgid "Chiavi server per chiamare Ando Engine. Scegli l'app e i permessi durante la creazione; qui puoi controllare uso, scadenza e revoca."
msgstr "Chiavi server per chiamare Ando Engine. Scegli l'app e i permessi durante la creazione; qui puoi controllare uso, scadenza e revoca."

#: ../../packages/ui/src/editors/RegionEditPill.tsx:240
#: src/features/admin/components/PageEditor.tsx:250
#: src/features/console/components/AssistPanel.tsx:300
msgid "Chiedi"
msgstr "Chiedi"

#: ../../packages/ui/src/editors/RegionEditPill.tsx:176
#: src/features/admin/components/AdminCpq.tsx:517
#: src/features/admin/components/AdminCpqAskAndo.tsx:237
#: src/features/admin/components/AdminCpqAskAndo.tsx:244
#: src/features/admin/components/PageEditor.tsx:163
#: src/features/dashboard/components/DashboardEmptyState.tsx:71
#: src/features/dashboard/components/wizard/WizardStepData.tsx:245
#: src/features/sources/components/CalendarEventPane.tsx:759
#: src/features/sources/components/InboxDetailPane.tsx:594
#: src/features/workspace/finance/components/AskAndoCard.tsx:154
msgid "Chiedi ad Ando"
msgstr "Chiedi ad Ando"

#: src/routes/_authed/workspace/finance.tsx:1583
msgid "Chiedi ad Ando · Banca"
msgstr "Chiedi ad Ando · Banca"

#: src/routes/_authed/workspace/finance.tsx:1699
msgid "Chiedi ad Ando · Fatture"
msgstr "Chiedi ad Ando · Fatture"

#: src/routes/_authed/workspace/finance.tsx:1783
msgid "Chiedi ad Ando · Fisco"
msgstr "Chiedi ad Ando · Fisco"

#: src/features/connectors/wizards/databaseSpec.tsx:243
msgid "Chiedi ad Ando di interrogare i tuoi dati senza scrivere SQL."
msgstr "Chiedi ad Ando di interrogare i tuoi dati senza scrivere SQL."

#: src/features/connectors/wizards/erpSpec.tsx:193
msgid "Chiedi ad Ando di interrogare il tuo ERP in linguaggio naturale."
msgstr "Chiedi ad Ando di interrogare il tuo ERP in linguaggio naturale."

#: src/features/admin/components/AdminDecksAskAndo.tsx:80
msgid "Chiedi ad Ando di modificare"
msgstr "Chiedi ad Ando di modificare"

#: ../../packages/ui/src/editors/RegionEditPill.tsx:162
msgid "Chiedi ad Ando di modificare la selezione"
msgstr "Chiedi ad Ando di modificare la selezione"

#: src/features/connectors/wizards/crmSpec.tsx:100
msgid "Chiedi ad Ando di trovare account, deal e opportunità in linguaggio naturale."
msgstr "Chiedi ad Ando di trovare account, deal e opportunità in linguaggio naturale."

#: src/features/connectors/wizards/projectManagementSpec.tsx:66
msgid "Chiedi ad Ando di trovare board, liste e card in linguaggio naturale."
msgstr "Chiedi ad Ando di trovare board, liste e card in linguaggio naturale."

#: src/features/clean-control/utils/signalCatalog.ts:204
msgid "Chiedi al mittente"
msgstr "Chiedi al mittente"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:330
msgid "Chiedi all'AI di modificare questa slide… (es. rendi più formale, aggiungi un'immagine)"
msgstr "Chiedi all'AI di modificare questa slide… (es. rendi più formale, aggiungi un'immagine)"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:289
msgid "Chiedi all'AI…"
msgstr "Chiedi all'AI…"

#: src/features/console/components/AssistPanel.tsx:231
msgid "Chiedi con parole tue"
msgstr "Chiedi con parole tue"

#: src/features/onboarding/demoTourSteps.ts:45
msgid "Chiedi in linguaggio naturale"
msgstr "Chiedi in linguaggio naturale"

#: src/features/console/components/AssistPanel.tsx:282
msgid "Chiedi qualcosa su {contextLabel}…"
msgstr "Chiedi qualcosa su {contextLabel}…"

#: src/features/console/components/AssistPanel.tsx:258
msgid "Chiedi qualcosa sui tuoi dati o su come integrare Ando. Rispondo con lo stesso motore agentico del runtime, in sola lettura."
msgstr "Chiedi qualcosa sui tuoi dati o su come integrare Ando. Rispondo con lo stesso motore agentico del runtime, in sola lettura."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2672
msgid "Chiedi una modifica alla slide selezionata o a tutto il deck. Ando propone, tu vedi prima e dopo sulla tela e accetti o rifiuti slide per slide. Puoi allegare un documento (brief, report, vecchio deck) da usare come fonte. I numeri mancanti restano [[segnaposto]]."
msgstr "Chiedi una modifica alla slide selezionata o a tutto il deck. Ando propone, tu vedi prima e dopo sulla tela e accetti o rifiuti slide per slide. Puoi allegare un documento (brief, report, vecchio deck) da usare come fonte. I numeri mancanti restano [[segnaposto]]."

#: src/features/admin/components/AdminCpqAskAndo.tsx:252
msgid "Chiedi una modifica: la vedi qui prima di applicarla."
msgstr "Chiedi una modifica: la vedi qui prima di applicarla."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:997
#: src/features/skills/components/SkillEditor.tsx:469
msgid "Chiudere senza salvare?"
msgstr "Chiudere senza salvare?"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:247
#: ../../packages/ui/src/editors/RegionEditPill.tsx:200
#: ../../packages/ui/src/primitives/dialog.tsx:83
#: ../../packages/ui/src/primitives/drawer.tsx:107
#: src/features/admin/components/AdminOrgs.tsx:350
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:290
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:233
#: src/features/chat/components/InterruptedQueryNotice.tsx:49
#: src/features/clean-control/components/EventDetailSheet.tsx:228
#: src/features/connect/components/MemberManager.tsx:474
#: src/features/connectors/components/ConnectorDialogShell.tsx:81
#: src/features/connectors/components/management/DiscoveryDialog.tsx:270
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:316
#: src/features/console/connectors/ConnectorActionsPanel.tsx:130
#: src/features/console/connectors/CustomConnectorDetail.tsx:1027
#: src/features/console/connectors/InvokeConnectorActionModal.tsx:131
#: src/features/console/connectors/TestConnectorActionModal.tsx:155
#: src/features/console/pages/DocumentsPage.tsx:365
#: src/features/dashboard/components/ShareChartSheet.tsx:407
#: src/features/dashboard/components/ShareDashboardSheet.tsx:394
#: src/features/hive-flows/components/FlowFormPublish.tsx:207
#: src/features/hive-flows/components/FlowShareControl.tsx:144
#: src/features/hive-flows/components/FlowVersionMenu.tsx:88
#: src/features/hive-flows/run/WorkbenchSurface.tsx:183
#: src/features/onboarding/DemoBookCallBanner.tsx:63
#: src/features/onboarding/DemoBookCallModal.tsx:337
#: src/features/onboarding/DemoWelcomeModal.tsx:139
#: src/features/sales/components/CampaignsPanel.tsx:98
#: src/features/settings/components/BrandKitSettings.tsx:785
#: src/features/share/components/ShareLinkDialog.tsx:334
#: src/features/sources/components/InboxDetailPane.tsx:1876
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:466
#: src/features/sync/components/UniversalSyncToast.tsx:173
#: src/features/voice_report/components/ShareReportDialog.tsx:429
#: src/features/workspace/components/TaskComposer.tsx:121
msgid "Chiudi"
msgstr "Chiudi"

#: src/features/admin/components/AdminCpqAskAndo.tsx:256
msgid "Chiudi Ando"
msgstr "Chiudi Ando"

#: src/features/hive-flows/components/DryRunPanel.tsx:100
msgid "Chiudi anteprima"
msgstr "Chiudi anteprima"

#: src/features/hive-flows/components/AiCopilotBar.tsx:127
msgid "Chiudi assistente"
msgstr "Chiudi assistente"

#: src/features/billing/components/UsageAlertBanner.tsx:117
#: src/features/console/components/ConsoleShell.tsx:830
#: src/features/updates/components/UpdateBanner.tsx:230
msgid "Chiudi avviso"
msgstr "Chiudi avviso"

#: src/features/report/components/AiDisclosureBanner.tsx:211
msgid "Chiudi avviso AI"
msgstr "Chiudi avviso AI"

#: src/features/briefing/BriefCard.tsx:334
msgid "Chiudi briefing"
msgstr "Chiudi briefing"

#: src/routes/_authed/route.tsx:1988
msgid "Chiudi composer espanso"
msgstr "Chiudi composer espanso"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1021
msgid "Chiudi comunque"
msgstr "Chiudi comunque"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:516
msgid "Chiudi confronto"
msgstr "Chiudi confronto"

#. placeholder {0}: it.suggested_workflow_name
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:679
msgid "Chiudi dettagli per {0}"
msgstr "Chiudi dettagli per {0}"

#: src/features/clean-control/components/EventDetailSheet.tsx:104
msgid "Chiudi dettaglio"
msgstr "Chiudi dettaglio"

#: src/features/report/components/CitationViewer.tsx:237
msgid "Chiudi dettaglio citazione"
msgstr "Chiudi dettaglio citazione"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:183
msgid "Chiudi diff"
msgstr "Chiudi diff"

#: src/features/hive-flows/run/WorkbenchSurface.tsx:156
msgid "Chiudi disegno"
msgstr "Chiudi disegno"

#: src/features/dashboard/components/AddWidgetWizard.tsx:391
msgid "Chiudi e perdi modifiche"
msgstr "Chiudi e perdi modifiche"

#: src/features/clean-control/components/policies/PolicyForm.tsx:181
msgid "Chiudi editor policy"
msgstr "Chiudi editor policy"

#: src/features/voice_report/components/TemplatesGallery.tsx:384
msgid "Chiudi gallery"
msgstr "Chiudi gallery"

#: src/features/console/traces/TraceGraph.tsx:265
msgid "Chiudi gruppi #{ordinal}–{lastOrdinal}"
msgstr "Chiudi gruppi #{ordinal}–{lastOrdinal}"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1023
msgid "Chiudi il dettaglio"
msgstr "Chiudi il dettaglio"

#: src/features/console/pages/FlowsPage.tsx:476
msgid "Chiudi il pannello nuovo flow"
msgstr "Chiudi il pannello nuovo flow"

#: src/features/console/components/AssistPanel.tsx:237
msgid "Chiudi l'assistente"
msgstr "Chiudi l'assistente"

#: src/features/console/components/ConToaster.tsx:91
msgid "Chiudi la notifica"
msgstr "Chiudi la notifica"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:126
msgid "Chiudi le azioni"
msgstr "Chiudi le azioni"

#: src/features/hive-flows/components/FlowCanvas.tsx:147
msgid "Chiudi menu"
msgstr "Chiudi menu"

#: src/features/help/components/ShortcutsList.tsx:76
msgid "Chiudi modale, drawer o overlay attivo"
msgstr "Chiudi modale, drawer o overlay attivo"

#: ../../packages/ui/src/editors/ReviewRail.tsx:327
#: src/features/structured-data/components/InlineChartPanel.tsx:92
msgid "Chiudi pannello"
msgstr "Chiudi pannello"

#: src/features/sources/components/AISummaryPanel.tsx:501
msgid "Chiudi pannello revisione"
msgstr "Chiudi pannello revisione"

#: src/features/sources/components/InboxDetailPane.tsx:1875
msgid "Chiudi risposta"
msgstr "Chiudi risposta"

#: src/features/structured-data/components/CadDataPanel.tsx:131
#: src/features/structured-data/components/CadDataPanel.tsx:294
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:172
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:448
msgid "Chiudi risultato"
msgstr "Chiudi risultato"

#: src/features/skills/components/SkillEditor.tsx:487
msgid "Chiudi senza salvare"
msgstr "Chiudi senza salvare"

#: src/features/chat/components/ConversationSidebar.tsx:284
#: src/routes/_authed/route.tsx:785
msgid "Chiudi sidebar"
msgstr "Chiudi sidebar"

#: src/features/chat/components/SmartLayoutHint.tsx:158
msgid "Chiudi suggerimento"
msgstr "Chiudi suggerimento"

#: src/features/share/components/ShareLinkDialog.tsx:640
msgid "Chiunque abbia il link può aprirlo. Puoi revocarlo in qualsiasi momento da Condivisioni."
msgstr ""

#: src/features/admin/components/deckEditor/DeckEditor.tsx:687
msgid "Chiusura"
msgstr "Chiusura"

#: src/features/sales/components/crm/CreateDealDialog.tsx:209
#: src/features/sales/components/crm/CreateDealDialog.tsx:215
#: src/features/sales/components/crm/DealDetailDrawer.tsx:166
#: src/features/sales/components/crm/DealDetailDrawer.tsx:177
msgid "Chiusura prevista"
msgstr "Chiusura prevista"

#: src/features/templates/components/TemplatesList.tsx:41
#: src/features/templates/components/TemplatesList.tsx:57
msgid "Chrome"
msgstr "Chrome"

#: src/features/studio/components/StudioDrawerContent.tsx:539
#: src/features/templates/components/CreateTemplateDialog.tsx:51
#: src/features/templates/components/TemplateEditor.tsx:58
msgid "Chrome · slide deck"
msgstr "Chrome · slide deck"

#: src/features/console/connectors/ConnectionCard.tsx:265
#: src/features/console/pages/DocumentsPage.tsx:324
#: src/features/console/pages/DocumentsPage.tsx:761
#: src/features/console/pages/OverviewPage.tsx:213
msgid "Chunk"
msgstr "Chunk"

#: src/features/console/pages/PlaygroundPage.tsx:1905
msgid "Chunk (k)"
msgstr "Chunk (k)"

#: src/features/admin/components/AdminRevenue.tsx:90
msgid "Churn rate"
msgstr "Churn rate"

#: src/features/projects/components/ProjectDetailPage.tsx:338
msgid "Ci sono <0>{overdue} attività in ritardo</0>: vale la pena guardarle."
msgstr "Ci sono <0>{overdue} attività in ritardo</0>: vale la pena guardarle."

#: src/features/admin/components/AdminDecks.tsx:484
#: src/features/admin/components/deckEditor/DeckEditor.tsx:230
msgid "Ci sono modifiche non salvate alla presentazione. Uscire e perderle?"
msgstr "Ci sono modifiche non salvate alla presentazione. Uscire e perderle?"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2065
msgid "Ciambella"
msgstr "Ciambella"

#: src/features/sales/components/TemplateManager.tsx:327
msgid "Ciao {{nome}}, …"
msgstr "Ciao {{nome}}, …"

#: src/routes/connect.chatbot.$publicToken.tsx:176
msgid "Ciao! Come posso aiutarti? Scrivi qui la tua domanda."
msgstr "Ciao! Come posso aiutarti? Scrivi qui la tua domanda."

#: src/features/console/docs/content.ts:722
msgid "Ciclo di sync"
msgstr "Ciclo di sync"

#: src/features/console/docs/content.ts:1276
msgid "Ciclo di vita chiave dalla console (create/list/revoke sono le stesse di Core, ma in sessione). POST /keys/<id>/roll conia un successore con grace window: eredita nome, scope, resource_policy e tier, e la vecchia scade a now + grace_hours (grace_hours=0 la revoca subito). PATCH /keys/<id> edita scope e/o resource_policy (spend-cap incluso) in-place, senza nuovo segreto; una chiave revocata → conflict."
msgstr "Ciclo di vita chiave dalla console (create/list/revoke sono le stesse di Core, ma in sessione). POST /keys/<id>/roll conia un successore con grace window: eredita nome, scope, resource_policy e tier, e la vecchia scade a now + grace_hours (grace_hours=0 la revoca subito). PATCH /keys/<id> edita scope e/o resource_policy (spend-cap incluso) in-place, senza nuovo segreto; una chiave revocata → conflict."

#: src/features/console/connectors/ManifestConfigForm.tsx:160
msgid "Cifrato a riposo e mai più mostrato dopo la creazione: dalla console potrai solo ruotarlo."
msgstr "Cifrato a riposo e mai più mostrato dopo la creazione: dalla console potrai solo ruotarlo."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1230
msgid "Cifratura"
msgstr "Cifratura"

#: ../../packages/ui/src/ando/sources/pdf/PDFActions.tsx:57
msgid "Cita anche [n]"
msgstr "Cita anche [n]"

#: src/features/help/data/changelog.ts:65
msgid "Citation targets e visibilità metadata canvas"
msgstr "Citation targets e visibilità metadata canvas"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:40
msgid "citazione"
msgstr "citazione"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:876
#: src/features/admin/components/deckEditor/DeckEditor.tsx:715
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1320
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1350
msgid "Citazione"
msgstr "Citazione"

#: src/features/report/components/CitationDetail.tsx:104
msgid "Citazione {index}"
msgstr "Citazione {index}"

#: src/features/report/components/CitationDetail.tsx:51
msgid "Citazione esatta, fedeltà incerta"
msgstr "Citazione esatta, fedeltà incerta"

#: src/features/connectors/wizards/emailSpec.tsx:97
#: src/features/console/pages/PlaygroundPage.tsx:809
#: src/features/console/pages/PlaygroundPage.tsx:1123
msgid "Citazioni"
msgstr "Citazioni"

#: src/features/report/components/CitationViewer.tsx:189
msgid "Citazioni non ancorate"
msgstr "Citazioni non ancorate"

#: src/features/sales/components/crm/CompaniesPanel.tsx:128
#: src/features/sales/components/crm/CompaniesPanel.tsx:134
#: src/features/sales/components/crm/RecordDrawer.tsx:66
msgid "Città"
msgstr "Città"

#: src/features/console/docs/content.ts:1971
msgid "Classe base di ogni errore dell'SDK."
msgstr "Classe base di ogni errore dell'SDK."

#: src/features/account/components/UserMenuButton.tsx:451
msgid "Clean & Control"
msgstr "Clean & Control"

#: src/features/clean-control/components/CleanControlHub.tsx:94
msgid "Clean & Control cockpit"
msgstr "Clean & Control cockpit"

#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:133
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:195
msgid "Clicca per cambiare file"
msgstr "Clicca per cambiare file"

#. placeholder {0}: SOURCE_PROVIDER_LABEL[cloudProvider]
#: src/features/connectors/components/SpreadsheetConnectDialog.tsx:197
msgid "Clicca qui per aprire la pagina Documenti e collegare un account {0}."
msgstr "Clicca qui per aprire la pagina Documenti e collegare un account {0}."

#: src/features/admin/components/AdminCpqCanvas.tsx:243
msgid "Clicca su un testo per modificarlo; su prezzi e servizi per vedere dove si cambiano."
msgstr "Clicca su un testo per modificarlo; su prezzi e servizi per vedere dove si cambiano."

#: src/features/admin/components/AdminCostTracking.tsx:309
msgid "Clicca una riga per ispezionare le singole chiamate LLM"
msgstr "Clicca una riga per ispezionare le singole chiamate LLM"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:283
msgid "Client ID"
msgstr "Client ID"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:34
msgid "Client ID obbligatorio."
msgstr "Client ID obbligatorio."

#: src/features/admin/components/orgs/OrgSSOTab.tsx:35
msgid "Client ID troppo corto."
msgstr "Client ID troppo corto."

#: src/features/admin/components/orgs/OrgSSOTab.tsx:302
msgid "Client secret"
msgstr "Client secret"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:101
msgid "Client secret obbligatorio."
msgstr "Client secret obbligatorio."

#: src/features/console/docs/content.ts:1670
msgid "Client sincrono, sottile su httpx (>=0.24). Context manager; ogni errore dell'envelope diventa ApiError (code, message, status, retry_after)."
msgstr "Client sincrono, sottile su httpx (>=0.24). Context manager; ogni errore dell'envelope diventa ApiError (code, message, status, retry_after)."

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:167
#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:65
#: src/features/admin/components/AdminCpq.tsx:589
#: src/features/admin/components/AdminCpq.tsx:1131
#: src/features/admin/components/AdminCpqAskAndo.tsx:166
#: src/features/admin/components/AdminCpqCanvas.tsx:196
#: src/features/admin/components/AdminCpqList.tsx:144
msgid "Cliente"
msgstr "Cliente"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:172
msgid "Cliente da definire"
msgstr "Cliente da definire"

#: src/features/admin/components/AdminCpq.tsx:591
#: src/features/admin/components/AdminCpq.tsx:1075
#: src/features/admin/components/AdminCpq.tsx:1097
msgid "Cliente finale"
msgstr "Cliente finale"

#: src/features/sales/components/CampaignsPanel.tsx:188
#: src/features/sales/components/CreateCampaignDialog.tsx:103
msgid "Cliente ideale"
msgstr "Cliente ideale"

#: src/features/sales/components/CampaignsPanel.tsx:118
#: src/features/sales/components/CreateCampaignDialog.tsx:96
msgid "Cliente ideale (ICP)"
msgstr "Cliente ideale (ICP)"

#: src/features/console/pages/BillingPage.tsx:452
msgid "Cliente Stripe dal"
msgstr "Cliente Stripe dal"

#: src/routes/_authed/workspace/finance.tsx:1704
msgid "Clienti con fatture scadute da oltre 30 giorni"
msgstr "Clienti con fatture scadute da oltre 30 giorni"

#: src/features/dxf/components/DxfPreviewStage.tsx:421
msgid "CLO/Marvelous"
msgstr "CLO/Marvelous"

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:98
msgid "Cloud"
msgstr "Cloud"

#: src/features/console/connectors/meta.ts:120
msgid "Cloud storage"
msgstr "Cloud storage"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:263
msgid "Cmd/Ctrl + Invio per eseguire"
msgstr "Cmd/Ctrl + Invio per eseguire"

#: src/features/admin/components/AdminCpqAskAndo.tsx:376
msgid "Cmd/Ctrl + Invio per inviare"
msgstr "Cmd/Ctrl + Invio per inviare"

#: src/features/dashboard/components/ChartSqlEditor.tsx:135
msgid "Cmd+Invio per eseguire"
msgstr "Cmd+Invio per eseguire"

#: src/features/clean-control/components/CleanControlHub.tsx:76
msgid "Cockpit qualità dato"
msgstr "Cockpit qualità dato"

#: src/features/clean-control/components/CleanControlHub.tsx:191
msgid "Coda"
msgstr "Coda"

#: src/features/admin/components/AdminAutomation.tsx:153
msgid "Coda nella sezione Proactive (Hypermem) o via API admin."
msgstr "Coda nella sezione Proactive (Hypermem) o via API admin."

#: src/features/clean-control/components/EventQueue.tsx:186
#: src/features/clean-control/components/EventQueue.tsx:190
msgid "Coda revisione"
msgstr "Coda revisione"

#: src/features/console/pages/PlaygroundPage.tsx:1260
#: src/features/console/pages/PlaygroundPage.tsx:2077
msgid "Codice"
msgstr "Codice"

#: src/features/price-lists/components/PriceListsPage.tsx:891
msgid "Codice (SKU)"
msgstr "Codice (SKU)"

#: src/features/settings/components/SecuritySettings.tsx:277
msgid "Codice 6 cifre"
msgstr "Codice 6 cifre"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:93
msgid "Codice destinatario"
msgstr "Codice destinatario"

#: src/features/connectors/wizards/sdiSpec.tsx:80
msgid "Codice destinatario (7 char)"
msgstr "Codice destinatario (7 char)"

#: src/features/connect/components/ChatbotPanel.tsx:143
#: src/features/connect/components/ChatbotPanel.tsx:146
msgid "Codice di incorporamento"
msgstr "Codice di incorporamento"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:50
msgid "Codice fiscale"
msgstr "Codice fiscale"

#: src/features/clean-control/utils/signalCatalog.ts:160
msgid "Codice fiscale con checksum errato."
msgstr "Codice fiscale con checksum errato."

#: src/features/clean-control/utils/signalCatalog.ts:159
msgid "Codice fiscale non valido"
msgstr "Codice fiscale non valido"

#: src/features/settings/components/SecuritySettings.tsx:292
msgid "Codice non valido o scaduto"
msgstr "Codice non valido o scaduto"

#: src/features/connectors/wizards/legalStorageSpec.tsx:43
msgid "Codice tenant"
msgstr "Codice tenant"

#: src/features/connectors/wizards/legalStorageSpec.tsx:41
msgid "Codice tenant e credenziali rilasciate dal conservatore."
msgstr "Codice tenant e credenziali rilasciate dal conservatore."

#: src/features/settings/components/OtpEmailPanel.tsx:120
msgid "Codice via email (2FA)"
msgstr "Codice via email (2FA)"

#: src/features/clean-control/utils/labels.ts:90
msgid "Coer."
msgstr "Coer."

#: src/features/clean-control/utils/labels.ts:76
msgid "Coerenza"
msgstr "Coerenza"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:214
msgid "Coesistenza attiva"
msgstr "Coesistenza attiva"

#: src/routes/connect.invite.$token.tsx:96
msgid "Collaboratore"
msgstr "Collaboratore"

#: src/features/connect/components/CreateSpaceDialog.tsx:94
#: src/features/connect/components/SpaceCard.tsx:72
#: src/features/connect/components/SpaceCard.tsx:210
#: src/routes/_authed/workspace/connect.$spaceId.tsx:248
msgid "Collaborazione"
msgstr "Collaborazione"

#: src/features/sources/components/EmailThreadMessages.tsx:152
msgid "Collassa tutti"
msgstr "Collassa tutti"

#: src/features/connect/components/MemberManager.tsx:331
#: src/features/connect/components/MemberManager.tsx:372
#: src/features/connect/components/MemberManager.tsx:660
#: src/features/connectors/components/ConnectAccountDialog.tsx:506
#: src/features/connectors/components/FilesystemConnectDialog.tsx:959
#: src/features/workspace/finance/components/ConnectionsPanel.tsx:74
#: src/routes/_authed/_modal/integrations/index.tsx:606
msgid "Collega"
msgstr "Collega"

#: src/features/console/components/ByokModal.tsx:97
msgid "Collega «{providerLabel}» una volta per la tua organizzazione. Poi scegli i modelli. La credenziale viene salvata cifrata e non viene restituita dalla Console."
msgstr "Collega «{providerLabel}» una volta per la tua organizzazione. Poi scegli i modelli. La credenziale viene salvata cifrata e non viene restituita dalla Console."

#: src/features/connectors/components/ConnectAccountDialog.tsx:374
#: src/features/connectors/components/ConnectAccountDialog.tsx:383
msgid "Collega {vendorLabel}"
msgstr "Collega {vendorLabel}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:287
msgid "Collega →"
msgstr "Collega →"

#: src/features/console/pages/DevelopersPage.tsx:185
msgid "Collega Ando al tuo agente via MCP: interroga il tuo {UKS} (documenti + sistemi strutturati) dai tuoi strumenti di sviluppo."
msgstr "Collega Ando al tuo agente via MCP: interroga il tuo {UKS} (documenti + sistemi strutturati) dai tuoi strumenti di sviluppo."

#: src/routes/_authed/workspace/calendar.tsx:1427
msgid "Collega calendario"
msgstr "Collega calendario"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:487
msgid "Collega cartella · Accessi"
msgstr "Collega cartella · Accessi"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:485
msgid "Collega cartella · Anteprima"
msgstr "Collega cartella · Anteprima"

#: src/features/connect/components/MemberManager.tsx:612
msgid "Collega da invitare"
msgstr "Collega da invitare"

#: src/features/console/pages/ConnectorDetailPage.tsx:242
msgid "Collega database"
msgstr "Collega database"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:473
msgid "Collega e gestisci WhatsApp tramite Meta Embedded Signup."
msgstr "Collega e gestisci WhatsApp tramite Meta Embedded Signup."

#: src/features/console/pages/ConnectorsPage.tsx:241
msgid "Collega email, file e sistemi. Ogni servizio autorizzato compare come fonte distinta."
msgstr "Collega email, file e sistemi. Ogni servizio autorizzato compare come fonte distinta."

#: src/features/console/lib/onboarding.ts:61
msgid "Collega email, file o sistemi aziendali. Per un sistema personalizzato, usa il connettore dedicato."
msgstr "Collega email, file o sistemi aziendali. Per un sistema personalizzato, usa il connettore dedicato."

#: src/routes/_authed/workspace/finance.tsx:1638
msgid "Collega Fatture in Cloud per crediti/debiti, SDI per le e-fatture e Salesforce per la pipeline commerciale."
msgstr "Collega Fatture in Cloud per crediti/debiti, SDI per le e-fatture e Salesforce per la pipeline commerciale."

#: src/features/console/docs/content.ts:1503
msgid "Collega gli utenti della tua app"
msgstr "Collega gli utenti della tua app"

#: src/features/connectors/components/GmailAccessModeDialog.tsx:19
msgid "Collega Gmail"
msgstr "Collega Gmail"

#: src/routes/_authed/workspace/calendar.tsx:1420
msgid "Collega Google Calendar o Outlook per vedere meeting e brief preparati da Ando."
msgstr "Collega Google Calendar o Outlook per vedere meeting e brief preparati da Ando."

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:82
msgid "Collega Google Drive, OneDrive o SharePoint per vedere i tuoi file qui. Ando li indicizza in autonomia in background."
msgstr "Collega Google Drive, OneDrive o SharePoint per vedere i tuoi file qui. Ando li indicizza in autonomia in background."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:224
msgid "Collega i tuoi account a Engine, sincronizza e cerca nei dati privati. Non serve Workspace."
msgstr "Collega i tuoi account a Engine, sincronizza e cerca nei dati privati. Non serve Workspace."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:294
msgid "Collega i tuoi account per usarne i dati in Engine."
msgstr "Collega i tuoi account per usarne i dati in Engine."

#: src/routes/_authed/workspace/finance.tsx:1750
msgid "Collega il Cassetto Fiscale (delega AdE) per interrogare F24, IVA e fatture elettroniche via chat."
msgstr "Collega il Cassetto Fiscale (delega AdE) per interrogare F24, IVA e fatture elettroniche via chat."

#: src/routes/_authed/workspace/finance.tsx:608
#: src/routes/_authed/workspace/finance.tsx:1774
msgid "Collega il Cassetto Fiscale per visualizzare F24, LIPE e conservazione in arrivo."
msgstr "Collega il Cassetto Fiscale per visualizzare F24, LIPE e conservazione in arrivo."

#: src/features/console/components/ProviderAccounts.tsx:188
msgid "Collega il progetto e l'account di servizio autorizzato per la tua organizzazione."
msgstr "Collega il progetto e l'account di servizio autorizzato per la tua organizzazione."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:648
msgid "Collega il tuo applicativo per rendere i suoi dati interrogabili da Ando: scegli COME i dati arrivano (li spingi tu, o descrivi la tua API e la piattaforma la interroga da sola)."
msgstr "Collega il tuo applicativo per rendere i suoi dati interrogabili da Ando: scegli COME i dati arrivano (li spingi tu, o descrivi la tua API e la piattaforma la interroga da sola)."

#: src/routes/_authed/workspace/finance.tsx:1362
msgid "Collega il tuo open banking (PSD2) per vedere saldi, movimenti e categorie aggiornati ogni poche ore."
msgstr "Collega il tuo open banking (PSD2) per vedere saldi, movimenti e categorie aggiornati ogni poche ore."

#: src/features/integrations/parts/IntegrationsEmptyState.tsx:38
msgid "Collega il tuo primo account {title}"
msgstr "Collega il tuo primo account {title}"

#: src/features/console/pages/OverviewPage.tsx:177
msgid "Collega la prima fonte."
msgstr "Collega la prima fonte."

#: src/features/console/components/FirstRunTimeline.tsx:200
msgid "Collega le fonti, controlla i contenuti e prova una domanda."
msgstr "Collega le fonti, controlla i contenuti e prova una domanda."

#: src/features/console/components/ProviderAccounts.tsx:145
msgid "Collega provider"
msgstr "Collega provider"

#: src/features/admin/components/AdminBilling.tsx:115
msgid "Collega Stripe"
msgstr "Collega Stripe"

#: src/features/console/pages/ConnectorsPage.tsx:356
#: src/features/console/pages/EmbeddedIdentityPage.tsx:285
#: src/features/sales/components/BatchSendModal.tsx:247
msgid "Collega un account"
msgstr "Collega un account"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:202
msgid "Collega un account personale"
msgstr "Collega un account personale"

#: src/features/console/components/CommandCenter.tsx:36
#: src/routes/_authed/workspace/finance.tsx:1059
msgid "Collega un connettore"
msgstr "Collega un connettore"

#: src/routes/_authed/workspace/finance.tsx:1052
msgid "Collega un connettore finanziario"
msgstr "Collega un connettore finanziario"

#: src/features/console/pages/DocumentsPage.tsx:731
msgid "Collega un connettore o carica un documento per popolare l'indice."
msgstr "Collega un connettore o carica un documento per popolare l'indice."

#: src/features/console/docs/content.ts:798
msgid "Collega un database"
msgstr "Collega un database"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:656
msgid "Collega un database on-prem"
msgstr "Collega un database on-prem"

#: src/features/console/pages/SchemaPage.tsx:918
msgid "Collega un database, un foglio di calcolo o una fonte di documenti per vederla qui."
msgstr "Collega un database, un foglio di calcolo o una fonte di documenti per vederla qui."

#. placeholder {0}: field.label
#: src/features/hive-flows/components/NodeInspector.tsx:1014
msgid "Collega un dato a {0}"
msgstr "Collega un dato a {0}"

#: src/features/hive-flows/components/ConditionBuilder.tsx:258
msgid "Collega un dato al valore"
msgstr "Collega un dato al valore"

#: src/features/dxf/components/DxfEmptyHero.tsx:165
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:70
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:87
msgid "Collega un drive"
msgstr "Collega un drive"

#: src/features/console/pages/ModelsPage.tsx:199
msgid "Collega un provider sopra, poi scegli un modello e attiva il profilo."
msgstr "Collega un provider sopra, poi scegli un modello e attiva il profilo."

#: src/features/console/pages/OverviewPage.tsx:302
msgid "Collega un servizio"
msgstr "Collega un servizio"

#: src/features/console/pages/ConnectorsPage.tsx:521
msgid "Collega un servizio al tuo profilo"
msgstr "Collega un servizio al tuo profilo"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:581
msgid "Collega una cartella condivisa in rete (SMB/NAS). Ando legge i file direttamente dalla rete — non serve montarla sul computer."
msgstr "Collega una cartella condivisa in rete (SMB/NAS). Ando legge i file direttamente dalla rete — non serve montarla sul computer."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:489
msgid "Collega una cartella di rete"
msgstr "Collega una cartella di rete"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:475
#: src/features/connectors/components/FilesystemConnectDialog.tsx:490
msgid "Collega una cartella locale"
msgstr "Collega una cartella locale"

#: src/features/console/pages/ModelsPage.tsx:218
msgid "Collega una credenziale prima di attivare il profilo."
msgstr "Collega una credenziale prima di attivare il profilo."

#: src/features/console/lib/onboarding.ts:59
#: src/features/console/lib/onboarding.ts:60
#: src/features/console/pages/ConnectorsPage.tsx:474
#: src/features/console/pages/OverviewPage.tsx:375
msgid "Collega una fonte"
msgstr "Collega una fonte"

#: src/routes/_authed/workspace/dashboard.tsx:945
msgid "Collega una fonte dati per iniziare"
msgstr "Collega una fonte dati per iniziare"

#: src/features/console/pages/OverviewPage.tsx:296
msgid "Collega una fonte o carica un file. Qui vedrai le nuove importazioni."
msgstr "Collega una fonte o carica un file. Qui vedrai le nuove importazioni."

#: src/features/console/pages/OverviewPage.tsx:371
msgid "Collega una fonte per avviare la prima sincronizzazione."
msgstr "Collega una fonte per avviare la prima sincronizzazione."

#: src/features/console/pages/MembersPage.tsx:245
msgid "collega@azienda.com"
msgstr "collega@azienda.com"

#: src/routes/_authed/workspace/finance.tsx:1022
#: src/routes/_authed/workspace/finance.tsx:1023
msgid "collegabile via Fatture in Cloud"
msgstr "collegabile via Fatture in Cloud"

#: src/routes/_authed/workspace/finance.tsx:1024
msgid "collegabile via Salesforce"
msgstr "collegabile via Salesforce"

#: src/routes/_authed/workspace/finance.tsx:674
msgid "Collegamenti attivi"
msgstr "Collegamenti attivi"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:102
msgid "Collegamento"
msgstr "Collegamento"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:373
msgid "Collegamento account: registra dove tornare dopo che un utente autorizza Gmail, Drive, Teams o un altro servizio. Questo URL è distinto dal callback di login."
msgstr "Collegamento account: registra dove tornare dopo che un utente autorizza Gmail, Drive, Teams o un altro servizio. Questo URL è distinto dal callback di login."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:955
msgid "Collegamento in corso…"
msgstr "Collegamento in corso…"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:276
#: src/features/console/pages/ConnectorsPage.tsx:529
msgid "Collegamento in preparazione per Console"
msgstr "Collegamento in preparazione per Console"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:452
msgid "Collegamento non riuscito."
msgstr "Collegamento non riuscito."

#: src/features/console/connectors/SourceHealthSummary.tsx:42
msgid "Collegata"
msgstr "Collegata"

#: src/features/console/connectors/ConnectionCard.tsx:296
msgid "Collegata il"
msgstr "Collegata il"

#: src/routes/_authed/_modal/integrations/index.tsx:471
msgid "Collegate"
msgstr "Collegate"

#: src/routes/_authed/_modal/integrations/index.tsx:500
msgid "collegato"
msgstr "collegato"

#: src/features/console/pages/BillingPage.tsx:350
#: src/routes/_authed/workspace/finance.tsx:912
msgid "Collegato"
msgstr "Collegato"

#: src/features/console/pages/MembersPage.tsx:462
msgid "Colleghi che gestiscono questa organizzazione nella Console. Gli utenti finali delle tue app sono separati; l’accesso ai dati privati richiede permessi dedicati."
msgstr "Colleghi che gestiscono questa organizzazione nella Console. Gli utenti finali delle tue app sono separati; l’accesso ai dati privati richiede permessi dedicati."

#: src/features/connect/components/MemberManager.tsx:637
msgid "Colleghi della tua organizzazione"
msgstr "Colleghi della tua organizzazione"

#: src/features/console/docs/content.ts:790
msgid "Colleghi un database read-only, curi il K-Schema proposto dall'AI e pubblichi: la source entra in /query e negli agentic turn. Una source non partecipa finché non è published."
msgstr "Colleghi un database read-only, curi il K-Schema proposto dall'AI e pubblichi: la source entra in /query e negli agentic turn. Una source non partecipa finché non è published."

#: src/features/projects/components/sections/PersonaSection.tsx:355
msgid "Colloquiale"
msgstr "Colloquiale"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:176
msgid "colonna"
msgstr "colonna"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2349
#: src/features/console/pages/SchemaPage.tsx:320
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:395
msgid "Colonna"
msgstr "Colonna"

#: src/features/dashboard/utils/calculatedFields.ts:328
msgid "Colonna \"{ref}\" non disponibile"
msgstr "Colonna \"{ref}\" non disponibile"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:285
msgid "Colonna aggiornata"
msgstr "Colonna aggiornata"

#: src/features/dashboard/components/AxisConfigurator.tsx:324
#: src/features/dashboard/components/AxisConfigurator.tsx:327
msgid "Colonna asse X"
msgstr "Colonna asse X"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:388
msgid "Colonna data"
msgstr "Colonna data"

#: src/features/dashboard/components/AxisConfigurator.tsx:237
#: src/features/dashboard/components/AxisConfigurator.tsx:240
msgid "Colonna del valore KPI"
msgstr "Colonna del valore KPI"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:176
msgid "colonne"
msgstr "colonne"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1039
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2060
#: src/features/connectors/components/management/SchemaViewer.tsx:377
msgid "Colonne"
msgstr "Colonne"

#: src/features/dashboard/components/AxisConfigurator.tsx:321
msgid "Colonne del grafico"
msgstr "Colonne del grafico"

#: src/features/dashboard/components/AxisConfigurator.tsx:119
#: src/features/dashboard/components/DashboardChartCard.tsx:751
msgid "Colonne della tabella"
msgstr "Colonne della tabella"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:403
msgid "Colonne descritte"
msgstr "Colonne descritte"

#. placeholder {0}: object.object
#: src/features/console/pages/SchemaPage.tsx:316
msgid "Colonne di {0}"
msgstr "Colonne di {0}"

#: src/features/dashboard/components/AxisConfigurator.tsx:348
msgid "Colonne valori (Y)"
msgstr "Colonne valori (Y)"

#: src/features/dashboard/components/AxisConfigurator.tsx:269
msgid "Colonne visibili e ordine"
msgstr "Colonne visibili e ordine"

#: src/features/dashboard/components/AxisConfigurator.tsx:122
#: src/features/dashboard/components/ChartConfigurationMenu.tsx:68
msgid "Colonne, assi e colori"
msgstr "Colonne, assi e colori"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1844
msgid "Colore"
msgstr "Colore"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:267
#: src/features/settings/components/OrganizationSettings.tsx:246
msgid "Colore accent"
msgstr "Colore accent"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1844
msgid "Colore del testo"
msgstr "Colore del testo"

#: src/features/dashboard/components/AxisConfigurator.tsx:453
msgid "Colore per {series}"
msgstr "Colore per {series}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1714
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1721
msgid "Colore personalizzato"
msgstr "Colore personalizzato"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:860
msgid "Colore predefinito"
msgstr "Colore predefinito"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:239
#: src/features/settings/components/OrganizationSettings.tsx:234
#: src/features/templates/components/TemplateFieldSpecs.ts:55
msgid "Colore primario"
msgstr "Colore primario"

#: src/features/settings/components/OrganizationSettings.tsx:239
#: src/features/templates/components/TemplateFieldSpecs.ts:63
msgid "Colore secondario"
msgstr "Colore secondario"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:823
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:824
msgid "Colore testo"
msgstr "Colore testo"

#: src/features/settings/components/BrandKitSettings.tsx:292
msgid "Colori"
msgstr "Colori"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:978
msgid "Colori e font del tuo Brand Kit"
msgstr "Colori e font del tuo Brand Kit"

#: src/features/dashboard/components/AxisConfigurator.tsx:432
msgid "Colori serie"
msgstr "Colori serie"

#: src/features/studio/components/StudioDrawerContent.tsx:497
msgid "Colori, font, logo e template del brand — applicati a documenti, deck e fogli generati. Gestiscili nel Brand Kit."
msgstr "Colori, font, logo e template del brand — applicati a documenti, deck e fogli generati. Gestiscili nel Brand Kit."

#: src/routes/_authed/route.tsx:1130
msgid "Comandi disponibili"
msgstr "Comandi disponibili"

#: ../../packages/ui/src/ando/composer-parts/SlashCommandMenu.tsx:104
#: ../../packages/ui/src/command-palette/CommandPalette.tsx:164
#: src/features/chat/components/ConversationCommandPalette.tsx:346
#: src/features/console/components/CommandPalette.tsx:104
msgid "Comandi rapidi"
msgstr "Comandi rapidi"

#: src/features/structured-data/components/SimilarPartsSection.tsx:113
msgid "Combinato"
msgstr "Combinato"

#: src/features/chat/hooks/useThinkingHops.ts:59
msgid "Combino più ricerche"
msgstr "Combino più ricerche"

#: src/features/chat/wsHandlers.ts:490
msgid "Combino più ricerche…"
msgstr "Combino più ricerche…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:395
msgid "Come accedono gli utenti?"
msgstr "Come accedono gli utenti?"

#: src/routes/_authed/_modal/settings/help.tsx:65
msgid "Come collego un connettore?"
msgstr "Come collego un connettore?"

#: src/features/chat/components/MessageBusinessDefinition.tsx:83
msgid "Come definite questo dato nella vostra azienda?"
msgstr "Come definite questo dato nella vostra azienda?"

#: src/features/console/pages/PlaygroundPage.tsx:1104
msgid "Come è stata istradata la corsa (per gli umani, non per il parsing)."
msgstr "Come è stata istradata la corsa (per gli umani, non per il parsing)."

#: src/routes/_authed/_modal/settings/help.tsx:81
msgid "Come elimino i miei dati?"
msgstr "Come elimino i miei dati?"

#: src/features/console/pages/ActionsPage.tsx:47
#: src/features/console/pages/DevelopersPage.tsx:199
#: src/features/dxf/components/DxfEmptyHero.tsx:187
msgid "Come funziona"
msgstr "Come funziona"

#: src/routes/_authed/_modal/settings/help.tsx:69
msgid "Come funziona la fatturazione?"
msgstr "Come funziona la fatturazione?"

#: src/features/onboarding/ConnectorsIntro.tsx:88
msgid "Come funzionano"
msgstr "Come funzionano"

#: src/features/console/docs/content.ts:1334
msgid "Come il runtime ma in sessione, con as_key_id? per simulare la resource policy di una chiave specifica."
msgstr "Come il runtime ma in sessione, con as_key_id? per simulare la resource policy di una chiave specifica."

#: src/features/admin/components/AdminBilling.tsx:255
msgid "Come incassi"
msgstr "Come incassi"

#: src/features/projects/components/ProjectDetailPage.tsx:104
msgid "Come l'agente deve comportarsi su questo progetto"
msgstr "Come l'agente deve comportarsi su questo progetto"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:195
msgid "Come paga"
msgstr "Come paga"

#: src/features/connectors/components/GmailAccessModeDialog.tsx:20
msgid "Come vuoi usare Gmail?"
msgstr "Come vuoi usare Gmail?"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:204
msgid "Come vuoi usare i dati?"
msgstr "Come vuoi usare i dati?"

#: src/features/auth/desktop/DesktopLoginForm.tsx:806
msgid "Come vuoi verificare la tua identità?"
msgstr "Come vuoi verificare la tua identità?"

#: src/features/sources/components/ArtifactPane.tsx:2356
msgid "Commenta"
msgstr "Commenta"

#: src/features/sources/components/ArtifactPane.tsx:2036
msgid "Commenta \"{filename}\": "
msgstr "Commenta \"{filename}\": "

#: src/features/admin/components/AdminDecks.tsx:159
msgid "Commerciale"
msgstr "Commerciale"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:80
msgid "Commercialista"
msgstr "Commercialista"

#: src/features/admin/components/ModelMarkupCard.tsx:76
msgid "Commissione Ando sui modelli"
msgstr "Commissione Ando sui modelli"

#. placeholder {0}: config.tariff.markup_pct
#: src/features/console/pages/ModelsPage.tsx:203
msgid "Commissione Ando sul profilo cliente: {0}% del consumo a listino di riferimento."
msgstr "Commissione Ando sul profilo cliente: {0}% del consumo a listino di riferimento."

#: src/features/admin/components/AdminPricingMarkup.tsx:30
msgid "Commissione Console e markup Engine"
msgstr "Commissione Console e markup Engine"

#: src/features/admin/components/AdminBilling.tsx:233
msgid "Commissione modelli"
msgstr "Commissione modelli"

#: src/features/admin/components/AdminPricingMarkup.tsx:49
#: src/features/admin/components/orgs/OrgBillingTab.tsx:421
msgid "Commissione modelli Console"
msgstr "Commissione modelli Console"

#: src/features/dashboard/components/DashboardViewControls.tsx:47
msgid "Comoda"
msgstr "Comoda"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:600
msgid "Compaiono alla prima richiesta autenticata, anche senza account collegati."
msgstr "Compaiono alla prima richiesta autenticata, anche senza account collegati."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:460
msgid "Compatibilità con membri Ando esistenti"
msgstr "Compatibilità con membri Ando esistenti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:476
msgid "Compatibilità: mappatura membri Ando"
msgstr "Compatibilità: mappatura membri Ando"

#: src/features/dashboard/components/DashboardViewControls.tsx:48
msgid "Compatta"
msgstr "Compatta"

#: src/features/settings/components/SelfProfileMemory.tsx:105
msgid "Competenze"
msgstr "Competenze"

#: src/features/actions/components/ActionAiFillBar.tsx:106
#: src/features/skills/components/SkillEditor.tsx:278
#: src/features/voice_report/components/NewReportDialog.tsx:617
#: src/features/workspace/components/TaskComposer.tsx:247
msgid "Compila con AI"
msgstr "Compila con AI"

#: src/features/actions/components/ActionAiFillBar.tsx:85
msgid "Compila con l'AI: descrivi cosa vuoi…"
msgstr "Compila con l'AI: descrivi cosa vuoi…"

#: src/features/actions/components/EmailTemplatePicker.tsx:71
msgid "Compila da un modello email"
msgstr "Compila da un modello email"

#: src/features/actions/components/EmailTemplatePicker.tsx:74
msgid "Compila da un modello…"
msgstr "Compila da un modello…"

#: src/features/skills/components/SkillEditor.tsx:308
msgid "Compila i campi"
msgstr "Compila i campi"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:540
#: src/features/hive-flows/run/FlowRunWorkspace.tsx:624
msgid "Compila i campi richiesti"
msgstr "Compila i campi richiesti"

#: src/features/actions/components/ActionAiFillBar.tsx:84
msgid "Compila il modulo con l'AI: descrivi cosa vuoi"
msgstr "Compila il modulo con l'AI: descrivi cosa vuoi"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:820
msgid "Compilando PPTX…"
msgstr "Compilando PPTX…"

#: src/features/voice_report/components/NewReportDialog.tsx:432
msgid "Compilato con AI — controlla e personalizza prima di creare"
msgstr "Compilato con AI — controlla e personalizza prima di creare"

#: src/features/canvases/components/CanvasStatusChip.tsx:28
msgid "Compilazione"
msgstr "Compilazione"

#: src/features/admin/components/AdminCanvas.tsx:63
msgid "compile · entità · costi · latenza"
msgstr "compile · entità · costi · latenza"

#: src/features/sources/components/GeneratingState.tsx:33
msgid "Compilo i campi e rivedo il risultato. Ci vuole qualche secondo."
msgstr "Compilo i campi e rivedo il risultato. Ci vuole qualche secondo."

#: src/features/actions/components/ActionAiFillBar.tsx:106
msgid "Compilo…"
msgstr "Compilo…"

#: src/features/clean-control/utils/labels.ts:89
msgid "Compl."
msgstr "Compl."

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:103
msgid "Complessità"
msgstr "Complessità"

#: src/features/admin/components/AdminCpq.tsx:801
msgid "Complessità dei contenuti"
msgstr "Complessità dei contenuti"

#: src/features/admin/components/AdminCpqAskAndo.tsx:173
msgid "Complessità PoC"
msgstr "Complessità PoC"

#. placeholder {0}: task.title
#: src/features/workspace/components/TaskSimpleRow.tsx:217
msgid "Completa {0}"
msgstr "Completa {0}"

#: src/features/console/docs/content.ts:1154
msgid "Completa & poll"
msgstr "Completa & poll"

#. placeholder {0}: task.title
#: src/features/projects/components/sections/TasksSection.tsx:124
msgid "Completa attività: {0}"
msgstr "Completa attività: {0}"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:588
msgid "Completa i file richiesti prima di avviare"
msgstr "Completa i file richiesti prima di avviare"

#: src/routes/login.tsx:151
msgid "Completa l'accesso nel browser. Tornerai qui automaticamente."
msgstr "Completa l'accesso nel browser. Tornerai qui automaticamente."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:505
msgid "Completa la configurazione di WhatsApp nella scheda del browser. Questa finestra si aggiornerà automaticamente al tuo ritorno."
msgstr "Completa la configurazione di WhatsApp nella scheda del browser. Questa finestra si aggiornerà automaticamente al tuo ritorno."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:227
msgid "Completa la configurazione nelle opzioni avanzate prima di applicare."
msgstr "Completa la configurazione nelle opzioni avanzate prima di applicare."

#: src/features/console/components/StatusBadges.tsx:166
#: src/features/hive-flows/run/RunHistoryRail.tsx:55
msgid "Completata"
msgstr "Completata"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:149
msgid "Completata con errori"
msgstr "Completata con errori"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:103
msgid "Completata il {completedDate} alle {completedTime}"
msgstr "Completata il {completedDate} alle {completedTime}"

#: src/features/console/connectors/SourceHealthSummary.tsx:7
msgid "Completata in passato"
msgstr "Completata in passato"

#: src/features/projects/components/sections/TasksSection.tsx:289
msgid "Completate"
msgstr "Completate"

#: src/routes/_authed/workspace/work.tsx:516
msgid "Completate oggi"
msgstr "Completate oggi"

#: src/features/console/pages/DocumentsPage.tsx:93
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:34
msgid "Completati"
msgstr "Completati"

#: src/features/console/components/StatusBadges.tsx:82
#: src/features/console/components/StatusBadges.tsx:83
#: src/features/console/components/StatusBadges.tsx:84
#: src/features/console/components/StatusBadges.tsx:203
#: src/features/voice_report/components/RunStatusBadge.tsx:55
#: src/features/workspace/components/TaskSimpleRow.tsx:76
msgid "Completato"
msgstr "Completato"

#: src/features/workspace/components/TaskSimpleRow.tsx:75
msgid "Completato da Ando"
msgstr "Completato da Ando"

#: src/features/clean-control/utils/labels.ts:75
msgid "Completezza"
msgstr "Completezza"

#: src/features/onboarding/ConnectorsIntro.tsx:58
msgid "Compliance (Italia)"
msgstr "Compliance (Italia)"

#: src/features/connectors/wizards/accountingSpec.tsx:135
msgid "Compliance GDPR"
msgstr "Compliance GDPR"

#: src/features/connectors/catalog.ts:231
msgid "Compliance italiana"
msgstr "Compliance italiana"

#: src/features/price-lists/utils/formatItem.ts:33
msgid "Componente su misura"
msgstr "Componente su misura"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:170
msgid "Componenti prezzati"
msgstr "Componenti prezzati"

#: src/features/skills/components/SkillEditor.tsx:308
msgid "Compongo…"
msgstr "Compongo…"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:231
msgid "Componi email"
msgstr "Componi email"

#: src/features/dashboard/components/AddWidgetWizard.tsx:279
msgid "Componi la query o usa l'AI per generarla."
msgstr "Componi la query o usa l'AI per generarla."

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:255
msgid "Componi messaggio"
msgstr "Componi messaggio"

#: src/features/connectors/components/GmailAccessModeDialog.tsx:28
msgid "Componi nuove email con destinatari inseriti a mano. Nessuna lettura, sincronizzazione o accesso ai contatti."
msgstr "Componi nuove email con destinatari inseriti a mano. Nessuna lettura, sincronizzazione o accesso ai contatti."

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:243
msgid "Componi PEC"
msgstr "Componi PEC"

#: src/routes/_authed/route.tsx:1997
msgid "Composer esteso"
msgstr "Composer esteso"

#: src/features/admin/components/AdminCostTracking.tsx:242
#: src/features/admin/components/AdminOverview.tsx:125
#: src/features/sales/components/SalesOverview.tsx:180
msgid "Composizione"
msgstr "Composizione"

#: src/features/admin/components/AdminCostTracking.tsx:297
msgid "Composizione costo per modello, finestra dell'intervallo"
msgstr "Composizione costo per modello, finestra dell'intervallo"

#. placeholder {0}: formatUsd(split.chat)
#. placeholder {1}: formatUsd(split.ingestion)
#. placeholder {2}: formatUsd(split.profiling)
#: src/features/admin/components/orgs/OrgCostTab.tsx:86
msgid "Composizione costo: chat {0}, ingestione {1}, profiling {2}"
msgstr "Composizione costo: chat {0}, ingestione {1}, profiling {2}"

#: src/features/admin/components/orgs/OrgCostTab.tsx:345
msgid "Composizione del costo"
msgstr "Composizione del costo"

#: src/features/hive-flows/run/RunHistoryRail.tsx:239
#: src/features/sync/components/DocSyncManager.tsx:998
#: src/features/sync/components/DocSyncManager.tsx:1262
msgid "Comprimi"
msgstr "Comprimi"

#. placeholder {0}: node.name
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:746
msgid "Comprimi {0}"
msgstr "Comprimi {0}"

#: src/features/chat/components/ConversationSidebar.tsx:662
#: src/features/chat/components/ConversationSidebar.tsx:733
msgid "Comprimi {label}"
msgstr "Comprimi {label}"

#: src/features/briefing/BriefCard.tsx:320
msgid "Comprimi briefing"
msgstr "Comprimi briefing"

#: src/features/hive-flows/run/RunHistoryRail.tsx:238
msgid "Comprimi cronologia"
msgstr "Comprimi cronologia"

#: src/features/onboarding/GuideBoxHeader.tsx:41
msgid "Comprimi la guida"
msgstr "Comprimi la guida"

#: src/features/chat/components/ConversationMiniRail.tsx:219
#: src/features/console/components/ConsoleShell.tsx:417
msgid "Comprimi la sidebar"
msgstr "Comprimi la sidebar"

#: src/features/console/flows/ConsoleFlowEditor.tsx:54
#: src/routes/_authed/workspace/flows.$flowId.tsx:67
msgid "Comune"
msgstr "Comune"

#: src/features/projects/components/ProjectIcon.tsx:69
msgid "Comunicazione"
msgstr "Comunicazione"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:283
msgid "Comunicazione con valore legale."
msgstr "Comunicazione con valore legale."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:485
#: src/features/workspace/components/InboxItemRow.tsx:201
msgid "Con allegati"
msgstr "Con allegati"

#: src/features/workspace/inbox/utils/inboxSmartViews.ts:67
msgid "Con allegato"
msgstr "Con allegato"

#: src/features/console/pages/ModelsPage.tsx:361
msgid "Con Ando paghi il consumo del provider e il servizio Ando. Con un tuo account paghi il provider direttamente; la tariffa Ando resta separata e si calcola sul listino di riferimento, non sulla tua fattura. I prezzi mostrati sono in USD per 1M di token."
msgstr "Con Ando paghi il consumo del provider e il servizio Ando. Con un tuo account paghi il provider direttamente; la tariffa Ando resta separata e si calcola sul listino di riferimento, non sulla tua fattura. I prezzi mostrati sono in USD per 1M di token."

#: src/features/sales/components/SalesOverview.tsx:173
msgid "Con email"
msgstr "Con email"

#: src/features/console/connectors/ManifestConfigForm.tsx:275
msgid "Con il cursore il sync è INCREMENTALE (riparte da dove era arrivato). Senza, ogni run è FULL con mark-and-sweep: i record non più restituiti vengono rimossi dall'indice."
msgstr "Con il cursore il sync è INCREMENTALE (riparte da dove era arrivato). Senza, ogni run è FULL con mark-and-sweep: i record non più restituiti vengono rimossi dall'indice."

#: src/features/console/pages/ModelsPage.tsx:184
msgid "Con un account personale, un errore interrompe la chiamata: nessun passaggio automatico al conto Ando."
msgstr "Con un account personale, un errore interrompe la chiamata: nessun passaggio automatico al conto Ando."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:364
msgid "Con un binding, Ando chiama direttamente un endpoint HTTP del tuo sistema quando l'azione viene invocata (risposta sincrona). Senza, l'azione viaggia via webhook con il flusso «proponi e poi esegui». Per configurarlo servono sia metodo sia percorso."
msgstr "Con un binding, Ando chiama direttamente un endpoint HTTP del tuo sistema quando l'azione viene invocata (risposta sincrona). Senza, l'azione viaggia via webhook con il flusso «proponi e poi esegui». Per configurarlo servono sia metodo sia percorso."

#: src/features/dashboard/components/AxisConfigurator.tsx:259
msgid "Con una colonna data e più periodi, mostra l'ultimo valore e lo storico. Totali e rapporti restano calcolati dalla query."
msgstr "Con una colonna data e più periodi, mostra l'ultimo valore e lo storico. Totali e rapporti restano calcolati dalla query."

#: src/features/dashboard/utils/calculatedFields.ts:82
msgid "Concatena"
msgstr "Concatena"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:67
#: src/features/chat/components/ChatTopBar.tsx:83
#: src/features/chat/components/ConversationSidebar.tsx:1169
#: src/features/connect/components/GrantManager.tsx:441
#: src/features/dashboard/components/ChartActionsMenu.tsx:241
#: src/features/dashboard/components/DashboardToolbar.tsx:124
#: src/features/sales/components/LeadsPanel.tsx:314
#: src/features/share/components/ShareLinkDialog.tsx:725
#: src/features/voice_report/components/VoiceReportDetailPage.tsx:174
#: src/features/workspace/documents/components/BulkActionBar.tsx:72
msgid "Condividi"
msgstr "Condividi"

#: src/features/sales/components/LeadsPanel.tsx:319
msgid "Condividi campagna"
msgstr "Condividi campagna"

#: src/features/skills/components/SkillsList.tsx:438
#: src/routes/_authed/workspace/flows.index.tsx:447
msgid "Condividi col team"
msgstr "Condividi col team"

#. placeholder {0}: recipients[0]?.name ?? ""
#: src/features/share/components/ShareLinkDialog.tsx:727
msgid "Condividi con {0}"
msgstr "Condividi con {0}"

#. placeholder {0}: recipients.length
#: src/features/share/components/ShareLinkDialog.tsx:728
msgid "Condividi con {0} colleghi"
msgstr "Condividi con {0} colleghi"

#: src/features/sales/components/CampaignSharing.tsx:143
#: src/features/sales/components/CampaignSharing.tsx:156
msgid "Condividi con tutta l'organizzazione"
msgstr "Condividi con tutta l'organizzazione"

#: src/features/share/components/ShareLinkDialog.tsx:733
msgid "Condividi con uno o più colleghi"
msgstr "Condividi con uno o più colleghi"

#: src/features/share/components/ShareLinkDialog.tsx:232
msgid "Condividi conversazione"
msgstr "Condividi conversazione"

#. placeholder {0}: dashboard.name
#: src/features/dashboard/components/ShareDashboardSheet.tsx:90
msgid "Condividi dashboard “{0}”"
msgstr "Condividi dashboard “{0}”"

#: src/features/dashboard/components/DashboardToolbar.tsx:114
msgid "Condividi dashboard via email"
msgstr "Condividi dashboard via email"

#. placeholder {0}: chart.title
#: src/features/dashboard/components/ShareChartSheet.tsx:94
msgid "Condividi grafico “{0}”"
msgstr "Condividi grafico “{0}”"

#: src/features/share/components/ShareLinkDialog.tsx:320
msgid "Condividi in un altro modo"
msgstr "Condividi in un altro modo"

#: src/features/sales/components/LeadsPanel.tsx:312
msgid "Condividi la campagna con il team"
msgstr "Condividi la campagna con il team"

#: src/features/connect/components/MemberManager.tsx:421
msgid "Condividi questo link con l'ospite."
msgstr "Condividi questo link con l'ospite."

#: src/features/voice_report/components/ShareReportDialog.tsx:210
msgid "Condividi report"
msgstr "Condividi report"

#: src/features/share/components/ShareLinkDialog.tsx:232
msgid "Condividi risposta"
msgstr "Condividi risposta"

#: src/routes/_authed/workspace/connect.index.tsx:111
msgid "Condividi una porzione del tuo workspace con ospiti esterni · tu decidi esattamente cosa possono interrogare"
msgstr "Condividi una porzione del tuo workspace con ospiti esterni · tu decidi esattamente cosa possono interrogare"

#: src/features/dashboard/components/DashboardToolbar.tsx:118
msgid "Condividi via email"
msgstr "Condividi via email"

#: src/features/share/components/ShareLinkDialog.tsx:784
msgid "Condivido…"
msgstr "Condivido…"

#: src/features/console/pages/AccessOverviewPage.tsx:323
msgid "Condivisa"
msgstr "Condivisa"

#: src/features/sales/components/CampaignsPanel.tsx:266
msgid "Condivisa con {collaboratorCount}"
msgstr "Condivisa con {collaboratorCount}"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:34
msgid "Condivisa con {sharedCount} persone"
msgstr "Condivisa con {sharedCount} persone"

#: src/features/sales/components/CampaignSharing.tsx:103
msgid "Condivisa con tutta l'organizzazione"
msgstr "Condivisa con tutta l'organizzazione"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:32
msgid "Condivisa con una persona"
msgstr "Condivisa con una persona"

#. placeholder {0}: owner.name?.trim() || owner.email || t`un membro del team`
#. placeholder {0}: skill.shared_by_name
#: src/features/sales/components/CampaignSharing.tsx:95
#: src/features/skills/components/TeamSkillsCatalog.tsx:145
msgid "Condivisa da {0}"
msgstr "Condivisa da {0}"

#: src/features/chat/components/ChatEmptyState.tsx:313
#: src/features/dashboard/components/ReceivedDashboardsList.tsx:46
msgid "Condivise con me"
msgstr "Condivise con me"

#: src/features/workspace/config.ts:421
#: src/features/workspace/config.ts:430
msgid "Condivisi"
msgstr "Condivisi"

#: src/features/chat/components/ChatEmptyState.tsx:419
msgid "Condivisi col team"
msgstr "Condivisi col team"

#: src/features/sales/components/TemplateManager.tsx:170
msgid "Condivisi col team o solo tuoi — usati nelle email a freddo e standard."
msgstr "Condivisi col team o solo tuoi — usati nelle email a freddo e standard."

#: src/features/chat/components/ChatEmptyState.tsx:333
#: src/routes/_authed/workspace/connect.index.tsx:103
#: src/routes/_authed/workspace/connect.index.tsx:141
msgid "Condivisi con me"
msgstr "Condivisi con me"

#: src/features/chat/components/ChatEmptyState.tsx:407
msgid "Condivisi recenti"
msgstr "Condivisi recenti"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:641
#: src/features/connectors/components/FilesystemConnectDialog.tsx:813
#: src/features/sales/components/CampaignsPanel.tsx:194
#: src/routes/_authed/workspace/shares.tsx:232
#: src/routes/_authed/workspace/shares.tsx:271
msgid "Condivisione"
msgstr "Condivisione"

#. placeholder {0}: r.name
#: src/features/share/components/ShareLinkDialog.tsx:203
msgid "Condivisione con {0} non riuscita"
msgstr "Condivisione con {0} non riuscita"

#: src/features/projects/components/sections/MemorySection.tsx:196
msgid "Condivisione con altri progetti"
msgstr "Condivisione con altri progetti"

#: src/features/share/components/ShareLinkDialog.tsx:179
msgid "Condivisione non riuscita"
msgstr "Condivisione non riuscita"

#: src/features/workspace/config.ts:240
#: src/features/workspace/config.ts:242
msgid "Condivisioni"
msgstr ""

#: src/routes/_authed/workspace/shares.tsx:104
msgid "condivisioni inviate · puoi revocarle in qualsiasi momento"
msgstr ""

#: src/routes/_authed/workspace/shares.tsx:106
msgid "condivisioni ricevute · aprile e continua la conversazione nel tuo workspace"
msgstr "condivisioni ricevute · aprile e continua la conversazione nel tuo workspace"

#: src/features/projects/components/sections/MemorySection.tsx:234
msgid "Condiviso"
msgstr "Condiviso"

#: src/features/hive-flows/components/FlowShareControl.tsx:59
#: src/features/hive-flows/components/FlowShareControl.tsx:86
msgid "Condiviso col progetto"
msgstr "Condiviso col progetto"

#: src/features/hive-flows/components/FlowShareControl.tsx:58
#: src/routes/_authed/workspace/flows.index.tsx:188
msgid "Condiviso col team"
msgstr "Condiviso col team"

#. placeholder {0}: doc.access_grant_count
#. placeholder {0}: done[0]
#. placeholder {0}: recipientNames.join(", ")
#: src/features/console/pages/DocumentsPage.tsx:829
#: src/features/share/components/ShareLinkDialog.tsx:212
#: src/features/share/components/ShareLinkDialog.tsx:882
#: src/features/share/components/ShareLinkDialog.tsx:884
msgid "Condiviso con {0}"
msgstr "Condiviso con {0}"

#. placeholder {0}: done.length
#: src/features/share/components/ShareLinkDialog.tsx:212
msgid "Condiviso con {0} colleghi"
msgstr "Condiviso con {0} colleghi"

#: src/features/console/pages/ResourceAccessPage.tsx:218
msgid "Condiviso con {savedActiveGrantCount} persone"
msgstr "Condiviso con {savedActiveGrantCount} persone"

#: src/routes/_authed/workspace/flows.index.tsx:624
#: src/routes/_authed/workspace/shares.tsx:271
msgid "Condiviso da {sharedBy}"
msgstr "Condiviso da {sharedBy}"

#: src/routes/_authed/workspace/flows.index.tsx:624
msgid "Condiviso dal team"
msgstr "Condiviso dal team"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:879
msgid "Condizione di verifica"
msgstr "Condizione di verifica"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:41
msgid "Condizioni"
msgstr "Condizioni"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:213
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:419
msgid "Conf."
msgstr "Conf."

#. placeholder {0}: formatPct(actRate, 0)
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:155
msgid "Conf. {0}"
msgstr "Conf. {0}"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:130
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:73
#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:167
#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:126
#: ../../packages/ui/src/ando/dialog/AndoDialogProvider.tsx:60
#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:526
#: ../../packages/ui/src/editors/DraftActionBar.tsx:308
#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:584
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:228
#: src/features/admin/components/orgs/_shared.tsx:291
#: src/features/admin/components/userAdminActions.tsx:394
#: src/features/connectors/wizards/filesystemSpec.tsx:111
#: src/features/connectors/wizards/legalStorageSpec.tsx:48
#: src/features/connectors/wizards/sdiSpec.tsx:90
#: src/features/connectors/wizards/vatVerifierSpec.tsx:49
#: src/features/dashboard/components/ChartActionsMenu.tsx:298
#: src/features/settings/components/AccountDeletion.tsx:164
#: src/features/sources/components/CalendarEventPane.tsx:655
#: src/features/sources/components/InboxDetailPane.tsx:1182
#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:192
msgid "Conferma"
msgstr "Conferma"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:391
msgid "Conferma disattivazione"
msgstr "Conferma disattivazione"

#: src/features/console/pages/ConnectorDetailPage.tsx:520
msgid "Conferma e avvia"
msgstr "Conferma e avvia"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:178
msgid "Conferma e crea"
msgstr "Conferma e crea"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:201
msgid "Conferma e genera il deck"
msgstr "Conferma e genera il deck"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:335
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:338
msgid "Conferma e procedi"
msgstr "Conferma e procedi"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:298
msgid "Conferma e salva la bozza"
msgstr "Conferma e salva la bozza"

#: src/features/agent-modes/components/AgentModesList.tsx:332
#: src/features/settings/components/PresentationTemplates.tsx:289
msgid "Conferma eliminazione"
msgstr "Conferma eliminazione"

#: src/features/sources/components/ArtifactPane.tsx:1223
msgid "Conferma fallita: {reason}"
msgstr "Conferma fallita: {reason}"

#: src/features/source-confirmation/components/SourceConfirmationSurface.tsx:134
msgid "Conferma fallita."
msgstr "Conferma fallita."

#: src/features/console/docs/content.ts:1551
msgid "Conferma il callback"
msgstr "Conferma il callback"

#: src/features/console/docs/content.ts:1395
msgid "Conferma il callback OAuth"
msgstr "Conferma il callback OAuth"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:253
msgid "Conferma in corso per {selectedFilename}."
msgstr "Conferma in corso per {selectedFilename}."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:254
msgid "Conferma in corso."
msgstr "Conferma in corso."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:646
msgid "Conferma la connessione"
msgstr "Conferma la connessione"

#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:168
msgid "Conferma la proposta"
msgstr "Conferma la proposta"

#: src/features/settings/components/SecuritySettings.tsx:118
msgid "Conferma nuova password"
msgstr "Conferma nuova password"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:467
msgid "Conferma rifiuto"
msgstr "Conferma rifiuto"

#: src/features/settings/components/OrgMembersPanel.tsx:665
#: src/features/settings/components/OtpEmailPanel.tsx:353
msgid "Conferma rimozione"
msgstr "Conferma rimozione"

#: src/features/clean-control/utils/signalCatalog.ts:217
msgid "Confermare accesso"
msgstr "Confermare accesso"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:66
msgid "Confermati"
msgstr "Confermati"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:75
msgid "Confermato"
msgstr "Confermato"

#. placeholder {0}: confirmDelete.display_name
#: src/features/admin/components/AdminPlatformSettings.tsx:710
msgid "Confermi l'eliminazione del piano <0>{0}</0>? Gli utenti su questo tier passeranno al fallback (free)."
msgstr "Confermi l'eliminazione del piano <0>{0}</0>? Gli utenti su questo tier passeranno al fallback (free)."

#: src/features/admin/components/userAdminActions.tsx:382
msgid "Confermi questa azione amministrativa?"
msgstr "Confermi questa azione amministrativa?"

#: src/features/console/connectors/TestConnectorActionModal.tsx:327
msgid "Confermo di voler eseguire questa azione a rischio «{risk}». Ando invierà la richiesta al tuo applicativo."
msgstr "Confermo di voler eseguire questa azione a rischio «{risk}». Ando invierà la richiesta al tuo applicativo."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:522
msgid "Confermo…"
msgstr "Confermo…"

#. placeholder {0}: Math.round((item.extraction_confidence ?? 0) * 100)
#. placeholder {0}: Math.round((rule.extraction_confidence ?? 0) * 100)
#: src/features/dfm-rules/components/DfmRulesPage.tsx:531
#: src/features/dfm-rules/components/DfmRulesPage.tsx:535
#: src/features/price-lists/components/PriceListsPage.tsx:671
msgid "Confidence {0}%"
msgstr "Confidence {0}%"

#. placeholder {0}: Math.round((item.extraction_confidence ?? 0) * 100)
#: src/features/price-lists/components/PriceListsPage.tsx:661
msgid "Confidence <0>{0}</0>%"
msgstr "Confidence <0>{0}</0>%"

#: src/features/report/components/ConfidenceMeter.tsx:73
msgid "Confidence di classificazione"
msgstr "Confidence di classificazione"

#: src/features/admin/components/AdminCanvas.tsx:224
#: src/features/clean-control/components/EventDetailSheet.tsx:270
msgid "Confidenza"
msgstr "Confidenza"

#. placeholder {0}: policy.confidence_min.toFixed(2)
#: src/features/clean-control/components/policies/PolicyRow.tsx:115
msgid "confidenza ≥ <0>{0}</0>"
msgstr "confidenza ≥ <0>{0}</0>"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:157
msgid "Confidenza media"
msgstr "Confidenza media"

#: src/features/clean-control/components/policies/PolicyForm.tsx:289
msgid "Confidenza minima"
msgstr "Confidenza minima"

#: src/features/clean-control/components/EventRow.tsx:529
msgid "Confidenza:"
msgstr "Confidenza:"

#: src/features/console/connectors/CustomConnectorDetail.tsx:707
#: src/features/console/connectors/ManifestConfigForm.tsx:337
msgid "config"
msgstr "config"

#: src/features/console/connectors/CustomConnectorDetail.tsx:706
msgid "Config (come lo vede il server — secret mai incluso)"
msgstr "Config (come lo vede il server — secret mai incluso)"

#: src/features/console/connectors/CustomConnectorDetail.tsx:550
msgid "Config manifest non leggibile: modifica il manifest per ripristinarlo."
msgstr "Config manifest non leggibile: modifica il manifest per ripristinarlo."

#: src/features/console/connectors/CustomConnectorDetail.tsx:889
#: src/features/console/connectors/CustomConnectorDetail.tsx:944
msgid "Config manifest non leggibile."
msgstr "Config manifest non leggibile."

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:146
#: src/features/connectors/components/ConnectedAccountRow.tsx:439
#: src/features/dashboard/components/ChartConfigurationMenu.tsx:59
#: src/features/hive-flows/components/FlowCanvas.tsx:162
msgid "Configura"
msgstr "Configura"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:341
msgid "Configura app →"
msgstr "Configura app →"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:205
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:282
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:439
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:459
#: src/routes/_authed/workspace/calendar.tsx:783
#: src/routes/_authed/workspace/finance.tsx:376
#: src/routes/_authed/workspace/sales.tsx:137
msgid "Configura connettori"
msgstr "Configura connettori"

#: src/features/console/components/CreateKeyWizard.tsx:342
msgid "Configura e abilita un issuer in Identità utenti prima di creare questa chiave."
msgstr "Configura e abilita un issuer in Identità utenti prima di creare questa chiave."

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:111
msgid "Configura e attiva questo cliente. I default sono già validi — personalizza solo ciò che serve."
msgstr "Configura e attiva questo cliente. I default sono già validi — personalizza solo ciò che serve."

#: src/features/console/pages/ConnectorsPage.tsx:532
msgid "Configura e verifica"
msgstr "Configura e verifica"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:54
#: src/features/dashboard/components/ChartConfigurationMenu.tsx:55
msgid "Configura grafico"
msgstr "Configura grafico"

#: src/features/agent-modes/components/AgentModeEditor.tsx:306
msgid "Configura identità, scope e capacità. Le modifiche al prompt creano una nuova versione."
msgstr "Configura identità, scope e capacità. Le modifiche al prompt creano una nuova versione."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Configura il collegamento degli account"
msgstr "Configura il collegamento degli account"

#: src/features/dashboard/components/AddWidgetWizard.tsx:280
msgid "Configura il grafico e scegli dove salvarlo."
msgstr "Configura il grafico e scegli dove salvarlo."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Configura il login Ando nella tua app con Authorization Code e PKCE."
msgstr "Configura il login Ando nella tua app con Authorization Code e PKCE."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:296
msgid "Configura il login, il ritorno OAuth e le chiavi della tua integrazione."
msgstr "Configura il login, il ritorno OAuth e le chiavi della tua integrazione."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Configura il tuo provider OIDC e fai accedere un utente alla tua app."
msgstr "Configura il tuo provider OIDC e fai accedere un utente alla tua app."

#: src/features/admin/components/AdminPricingMarkup.tsx:34
msgid "Configura la commissione dei modelli Console. Il markup Engine legacy è separato; le eccezioni per organizzazione si gestiscono nella sua scheda Billing."
msgstr "Configura la commissione dei modelli Console. Il markup Engine legacy è separato; le eccezioni per organizzazione si gestiscono nella sua scheda Billing."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:347
msgid "Configura la prima app →"
msgstr "Configura la prima app →"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:188
msgid "Configura OIDC, SAML, Azure AD o Google SSO per questa org."
msgstr "Configura OIDC, SAML, Azure AD o Google SSO per questa org."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:375
msgid "Configura questi parametri nel WHERE della query, prima di GROUP BY."
msgstr "Configura questi parametri nel WHERE della query, prima di GROUP BY."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:373
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:379
msgid "Configura SQL"
msgstr "Configura SQL"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:354
msgid "Configura SSO"
msgstr "Configura SSO"

#: src/features/admin/components/AdminCpq.tsx:1263
msgid "Configura tagli, deploy e base di conoscenza, vedi costi e margine (solo superadmin) e pubblica link a codice email per software house e cliente finale. I prezzi arrivano dal listino versionato."
msgstr "Configura tagli, deploy e base di conoscenza, vedi costi e margine (solo superadmin) e pubblica link a codice email per software house e cliente finale. I prezzi arrivano dal listino versionato."

#: src/features/settings/components/SecuritySettings.tsx:183
msgid "Configura TOTP"
msgstr "Configura TOTP"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:393
msgid "Configura un account"
msgstr "Configura un account"

#: src/features/automations/components/AutomationDetailSection.tsx:74
#: src/features/console/pages/EmbeddedIdentityPage.tsx:349
#: src/routes/_authed/_modal/integrations/route.tsx:78
msgid "Configurazione"
msgstr "Configurazione"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:324
msgid "Configurazione (opzionale)"
msgstr "Configurazione (opzionale)"

#: src/features/admin/components/AdminBilling.tsx:204
msgid "Configurazione di fatturazione a livello piattaforma. Il markup e l'incasso per singolo tenant si gestiscono dentro l'organizzazione."
msgstr "Configurazione di fatturazione a livello piattaforma. Il markup e l'incasso per singolo tenant si gestiscono dentro l'organizzazione."

#: src/features/admin/components/AdminPlatformSettings.tsx:1132
msgid "Configurazione globale piattaforma. Modifiche ai prezzi modello impattano il calcolo costi LLM in real-time; modifiche ai piani tier prendono effetto al prossimo billing cycle."
msgstr "Configurazione globale piattaforma. Modifiche ai prezzi modello impattano il calcolo costi LLM in real-time; modifiche ai piani tier prendono effetto al prossimo billing cycle."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:358
msgid "Configurazione non riuscita"
msgstr "Configurazione non riuscita"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:96
msgid "Configurazione non valida: inserisci un oggetto JSON."
msgstr "Configurazione non valida: inserisci un oggetto JSON."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:382
msgid "Configurazione OIDC avanzata →"
msgstr "Configurazione OIDC avanzata →"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:151
msgid "Configurazione SSO rimossa."
msgstr "Configurazione SSO rimossa."

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:373
msgid "Confirm permissions…"
msgstr "Confirm permissions…"

#: src/features/connectors/wizards/pecSpec.tsx:66
msgid "Conformità"
msgstr "Conformità"

#: src/features/connectors/wizards/legalStorageSpec.tsx:54
msgid "Conformità CAD"
msgstr "Conformità CAD"

#: src/features/hive-flows/components/ConditionBuilder.tsx:290
#: src/features/hive-flows/components/ConditionBuilder.tsx:291
msgid "Confronta con"
msgstr "Confronta con"

#: src/features/console/pages/UsagePage.tsx:440
msgid "Confronta traffico, token e impronta della knowledge prima di intervenire su limiti o modelli."
msgstr "Confronta traffico, token e impronta della knowledge prima di intervenire su limiti o modelli."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:683
msgid "Confronto"
msgstr "Confronto"

#: src/features/console/pages/TracesPage.tsx:201
msgid "Confronto degli hash e dei campi della pagina indice caricata. Differenze di struttura non dimostrano una perdita di informazioni tra agenti."
msgstr "Confronto degli hash e dei campi della pagina indice caricata. Differenze di struttura non dimostrano una perdita di informazioni tra agenti."

#: src/features/chat/wsHandlers.ts:478
msgid "Confronto le fonti…"
msgstr "Confronto le fonti…"

#: src/features/dxf/components/DxfEmptyHero.tsx:73
msgid "Confronto v→v automatico"
msgstr "Confronto v→v automatico"

#: src/features/console/docs/content.ts:274
msgid "Conia una AppKey; il segreto è nella risposta una sola volta. live=false conia una chiave ando_sk_test_. principal_mode=service è il default. Per gli utenti di una nuova app usa app_user_server o app_user_oidc con app_id; app_user_oidc richiede anche end_user_issuer. La chiave rimane sul backend dell'app, condivisa dai suoi utenti autenticati. resource_policy (opzionale) restringe la chiave: sources, connector_ids, action_connectors, cad_visibility e monthly_spend_limit_cents — lo SPEND-CAP mensile per-chiave in centesimi USD (superata la soglia, la chiave riceve spend_limit_exceeded)."
msgstr "Conia una AppKey; il segreto è nella risposta una sola volta. live=false conia una chiave ando_sk_test_. principal_mode=service è il default. Per gli utenti di una nuova app usa app_user_server o app_user_oidc con app_id; app_user_oidc richiede anche end_user_issuer. La chiave rimane sul backend dell'app, condivisa dai suoi utenti autenticati. resource_policy (opzionale) restringe la chiave: sources, connector_ids, action_connectors, cad_visibility e monthly_spend_limit_cents — lo SPEND-CAP mensile per-chiave in centesimi USD (superata la soglia, la chiave riceve spend_limit_exceeded)."

#: src/features/console/docs/content.ts:1822
msgid "Conia una nuova API key (scope keys:manage). La chiave piena è solo in questa risposta."
msgstr "Conia una nuova API key (scope keys:manage). La chiave piena è solo in questa risposta."

#: src/features/workspace/config.ts:226
#: src/features/workspace/config.ts:228
msgid "Connect"
msgstr "Connect"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:379
msgid "Connect WhatsApp Business"
msgstr "Connect WhatsApp Business"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:363
#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:375
msgid "Connecting…"
msgstr "Connecting…"

#: src/features/dashboard/hooks/useCreateChart.ts:109
msgid "connectionId mancante — seleziona una sorgente dati prima di salvare il widget."
msgstr "connectionId mancante — seleziona una sorgente dati prima di salvare il widget."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:254
#: src/features/admin/components/orgs/OrgDetailShell.tsx:171
#: src/features/admin/components/orgs/OrgDetailShell.tsx:401
msgid "Connector"
msgstr "Connector"

#: src/features/console/docs/content.ts:585
msgid "Connectors (Push API)"
msgstr "Connectors (Push API)"

#: src/features/console/pages/ConnectorsPage.tsx:74
msgid "Connessi"
msgstr "Connessi"

#: src/features/connectors/wizards/crmSpec.tsx:130
#: src/features/connectors/wizards/filesystemSpec.tsx:59
#: src/features/connectors/wizards/projectManagementSpec.tsx:93
#: src/features/console/components/accessResourceLabels.ts:80
#: src/features/console/connectors/SourceHealthSummary.tsx:18
#: src/features/dashboard/components/AddChartDialog.tsx:628
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:232
#: src/features/workspace/hooks/useFinance.ts:122
msgid "Connessione"
msgstr "Connessione"

#: src/features/chat/hooks/useStopQuery.ts:28
msgid "Connessione assente: riconnettiti e riprova a interrompere."
msgstr "Connessione assente: riconnettiti e riprova a interrompere."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:399
msgid "Connessione collegata"
msgstr "Connessione collegata"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:295
msgid "Connessione in modalità Solo cloud"
msgstr "Connessione in modalità Solo cloud"

#: src/features/chat/hooks/useSendQuery.ts:515
msgid "Connessione interrotta. Controlla la rete o ricarica l'app."
msgstr "Connessione interrotta. Controlla la rete o ricarica l'app."

#: src/features/sync/components/UniversalSyncToast.tsx:226
msgid "Connessione live persa — fallback a polling"
msgstr "Connessione live persa — fallback a polling"

#: src/features/dashboard/components/AddWidgetWizard.tsx:200
msgid "Connessione mancante. Torna al passo Sorgente e seleziona la connessione di destinazione."
msgstr "Connessione mancante. Torna al passo Sorgente e seleziona la connessione di destinazione."

#: src/features/connectors/wizards/databaseSpec.tsx:201
msgid "Connessione MySQL"
msgstr "Connessione MySQL"

#: src/features/console/pages/ConnectorDetailPage.tsx:474
msgid "Connessione non trovata"
msgstr "Connessione non trovata"

#: src/features/connectors/wizards/databaseSpec.tsx:233
msgid "Connessione ODBC"
msgstr "Connessione ODBC"

#. placeholder {0}: data.latency_ms
#. placeholder {0}: testResult.latency_ms
#: src/features/connectors/components/management/EditConnectorDialog.tsx:242
#: src/routes/_authed/_modal/integrations/$capability.tsx:180
msgid "Connessione OK · {0}ms"
msgstr "Connessione OK · {0}ms"

#. placeholder {0}: data.latency_ms
#. placeholder {1}: data.server_version
#: src/routes/_authed/_modal/integrations/$capability.tsx:179
msgid "Connessione OK · {0}ms · {1}"
msgstr "Connessione OK · {0}ms · {1}"

#: src/features/connectors/wizards/databaseSpec.tsx:217
msgid "Connessione Oracle"
msgstr "Connessione Oracle"

#: src/features/connectors/wizards/databaseSpec.tsx:193
msgid "Connessione PostgreSQL"
msgstr "Connessione PostgreSQL"

#: src/features/connectors/wizards/accountingSpec.tsx:103
msgid "Connessione SAP Business One"
msgstr "Connessione SAP Business One"

#: src/features/connectors/wizards/erpSpec.tsx:157
msgid "Connessione SAP OData"
msgstr "Connessione SAP OData"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:260
msgid "Connessione scaduta"
msgstr "Connessione scaduta"

#: src/features/connectors/wizards/databaseSpec.tsx:209
msgid "Connessione SQL Server"
msgstr "Connessione SQL Server"

#: src/features/connectors/wizards/erpSpec.tsx:173
msgid "Connessione TeamSystem"
msgstr "Connessione TeamSystem"

#: src/features/console/pages/ConnectorDetailPage.tsx:179
msgid "Connessione verificata"
msgstr "Connessione verificata"

#. placeholder {0}: DIALECT_LABELS[dialect]
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:858
msgid "Connessione verificata — {0} raggiungibile da questa macchina."
msgstr "Connessione verificata — {0} raggiungibile da questa macchina."

#. placeholder {0}: result.latency_ms
#: src/features/console/pages/ConnectorDetailPage.tsx:178
msgid "Connessione verificata in {0} ms"
msgstr "Connessione verificata in {0} ms"

#: src/features/onboarding/ConnectorsIntro.tsx:188
msgid "Connessione via OAuth sicuro, token cifrati e revocabili in qualsiasi momento: Ando accede solo a ciò che autorizzi."
msgstr "Connessione via OAuth sicuro, token cifrati e revocabili in qualsiasi momento: Ando accede solo a ciò che autorizzi."

#: src/features/console/pages/OverviewPage.tsx:399
msgid "Connessione Workspace"
msgstr "Connessione Workspace"

#: src/features/connectors/wizards/erpSpec.tsx:165
msgid "Connessione Zucchetti"
msgstr "Connessione Zucchetti"

#: src/features/console/pages/AccessOverviewPage.tsx:211
#: src/features/console/pages/ConnectorDetailPage.tsx:418
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/KeyDetailPage.tsx:403
msgid "Connessioni"
msgstr "Connessioni"

#: src/features/console/pages/ConnectorDetailPage.tsx:98
msgid "connessioni attive"
msgstr "connessioni attive"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:469
msgid "Connessioni attive"
msgstr "Connessioni attive"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:322
msgid "Connessioni disponibili"
msgstr "Connessioni disponibili"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
msgid "Connessioni personali"
msgstr "Connessioni personali"

#: src/features/console/components/CreateKeyWizard.tsx:472
msgid "Connessioni specifiche"
msgstr "Connessioni specifiche"

#. placeholder {0}: connector.connections
#. placeholder {1}: connector.active_connections
#: src/features/console/pages/ConnectorsPage.tsx:382
msgid "Connessioni: {0} · attive: {1}"
msgstr "Connessioni: {0} · attive: {1}"

#: src/features/console/components/StatusBadges.tsx:127
#: src/features/console/components/StatusBadges.tsx:128
msgid "Connesso"
msgstr "Connesso"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:247
msgid "Connesso il"
msgstr "Connesso il"

#: src/features/settings/components/OrganizationSettings.tsx:146
msgid "Connetterai il tuo identity provider (Azure AD, Okta, Google Workspace, JumpCloud o qualsiasi OIDC/SAML 2.0) per gestire l'accesso centralmente."
msgstr "Connetterai il tuo identity provider (Azure AD, Okta, Google Workspace, JumpCloud o qualsiasi OIDC/SAML 2.0) per gestire l'accesso centralmente."

#: src/features/connectors/components/ConnectAccountDialog.tsx:392
msgid "Connetterai questo account a Ando. La conservazione delle credenziali avviene cifrata; revoca disponibile in qualsiasi momento dalla pagina Integrazioni."
msgstr "Connetterai questo account a Ando. La conservazione delle credenziali avviene cifrata; revoca disponibile in qualsiasi momento dalla pagina Integrazioni."

#: src/features/dashboard/components/ChartNeedsConnectorState.tsx:86
msgid "Connetti {providerLabel}"
msgstr "Connetti {providerLabel}"

#: src/features/dashboard/components/ChartNeedsConnectorState.tsx:68
msgid "Connetti {providerLabel} per vedere questo grafico"
msgstr "Connetti {providerLabel} per vedere questo grafico"

#: src/routes/_authed/workspace/finance.tsx:1029
msgid "Connetti Fatture in Cloud, la tua banca o Salesforce per vedere il tuo flusso di cassa in tempo reale."
msgstr "Connetti Fatture in Cloud, la tua banca o Salesforce per vedere il tuo flusso di cassa in tempo reale."

#: src/routes/_authed/workspace/calendar.tsx:1412
msgid "Connetti il tuo calendario"
msgstr "Connetti il tuo calendario"

#: src/routes/_authed/_modal/integrations/route.tsx:83
msgid "connetti le sorgenti che alimentano Ando"
msgstr "connetti le sorgenti che alimentano Ando"

#: src/features/console/pages/DevelopersPage.tsx:230
msgid "Connetti un client"
msgstr "Connetti un client"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:108
#: src/features/connect/components/GrantManager.tsx:709
#: src/features/console/connectors/meta.ts:227
#: src/features/console/pages/ConnectorDetailPage.tsx:262
#: src/features/console/pages/ConnectorDetailPage.tsx:278
msgid "Connettore"
msgstr "Connettore"

#. placeholder {0}: created.name
#. placeholder {1}: created.slug
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:366
msgid "Connettore «{0}» registrato con slug <0>{1}</0>."
msgstr "Connettore «{0}» registrato con slug <0>{1}</0>."

#: src/features/connect/components/GrantManager.tsx:689
msgid "Connettore a dati strutturati"
msgstr "Connettore a dati strutturati"

#: src/features/connectors/hooks/useStructuredDataConnectors.ts:79
msgid "Connettore non raggiungibile"
msgstr "Connettore non raggiungibile"

#: src/features/console/lib/onboarding.ts:65
msgid "Connettore personalizzato"
msgstr "Connettore personalizzato"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:637
msgid "Connettore registrato"
msgstr "Connettore registrato"

#: src/features/account/components/UserMenuButton.tsx:394
#: src/features/console/pages/ConnectorDetailPage.tsx:261
#: src/features/console/pages/ConnectorsPage.tsx:313
#: src/features/integrations/parts/ConnectorDetailSection.tsx:145
#: src/features/projects/components/sections/KnowledgeSection.tsx:149
msgid "Connettori"
msgstr "Connettori"

#: src/features/console/pages/OverviewPage.tsx:227
msgid "Connettori attivi"
msgstr "Connettori attivi"

#: src/features/console/pages/ActionsPage.tsx:85
msgid "Connettori con azioni"
msgstr "Connettori con azioni"

#: src/features/connectors/catalog.ts:224
#: src/features/onboarding/ConnectorsIntro.tsx:46
#: src/features/projects/components/ProjectDetailPage.tsx:230
#: src/features/projects/components/sections/MemorySection.tsx:54
msgid "Conoscenza"
msgstr "Conoscenza"

#. placeholder {0}: formatPct(deliverRate, 0)
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:152
msgid "Cons. {0}"
msgstr "Cons. {0}"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1511
msgid "Consegna"
msgstr "Consegna"

#: src/features/console/docs/content.ts:895
msgid "Consegna di prova"
msgstr "Consegna di prova"

#: src/features/console/webhooks/WebhooksPanel.tsx:131
msgid "Consegna rimessa in coda"
msgstr "Consegna rimessa in coda"

#: src/features/console/docs/content.ts:896
msgid "Consegna un evento test.ping all'endpoint registrato."
msgstr "Consegna un evento test.ping all'endpoint registrato."

#: src/features/console/webhooks/WebhooksPanel.tsx:97
msgid "Consegnata"
msgstr "Consegnata"

#. placeholder {0}: formatDateTime(i18n.locale, delivery.delivered_at)
#: src/features/console/webhooks/WebhooksPanel.tsx:179
msgid "Consegnata il {0}"
msgstr "Consegnata il {0}"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:64
msgid "Consegnati"
msgstr "Consegnati"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:73
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:431
#: src/features/console/webhooks/WebhooksPanel.tsx:658
msgid "Consegnato"
msgstr "Consegnato"

#: src/features/console/webhooks/WebhooksPanel.tsx:610
msgid "Consegne"
msgstr "Consegne"

#: src/features/connectors/wizards/openBankingSpec.tsx:221
msgid "consenso"
msgstr "consenso"

#. placeholder {0}: consent.label
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:184
msgid "Consenso · {0}"
msgstr "Consenso · {0}"

#: src/features/settings/components/SelfProfileMemory.tsx:211
msgid "consenso · fatti appresi · cancellazione"
msgstr "consenso · fatti appresi · cancellazione"

#: src/features/settings/components/SelfProfileMemory.tsx:582
msgid "Consenso disattivo: non ci sono fatti da cancellare. Riattiva la memoria dal pannello in alto per iniziare a costruire il profilo."
msgstr "Consenso disattivo: non ci sono fatti da cancellare. Riattiva la memoria dal pannello in alto per iniziare a costruire il profilo."

#: src/features/connectors/components/ConnectorStatus.tsx:119
#: src/features/connectors/components/ConnectorStatus.tsx:239
msgid "Consenso in scadenza"
msgstr "Consenso in scadenza"

#: src/features/settings/components/MemoryConsentBanner.tsx:87
msgid "Consenso memoria personale"
msgstr "Consenso memoria personale"

#: src/features/settings/components/SelfProfileMemory.tsx:299
#: src/features/settings/components/SelfProfileMemory.tsx:344
msgid "Consenso memoria personalizzata"
msgstr "Consenso memoria personalizzata"

#: src/features/connectors/wizards/openBankingSpec.tsx:183
msgid "Consenso PSD2"
msgstr "Consenso PSD2"

#: src/features/templates/components/TemplateFieldSpecs.ts:194
msgid "Consenti emoji"
msgstr "Consenti emoji"

#: src/features/settings/components/SecuritySettings.tsx:236
msgid "Conserva al sicuro il codice di recupero ed esegui un test al prossimo accesso."
msgstr "Conserva al sicuro il codice di recupero ed esegui un test al prossimo accesso."

#: src/features/connectors/components/vendorIcons.tsx:170
#: src/features/connectors/components/vendorIcons.tsx:495
#: src/features/connectors/wizards/legalStorageSpec.tsx:22
#: src/features/connectors/wizards/legalStorageSpec.tsx:30
msgid "Conservazione a norma"
msgstr "Conservazione a norma"

#: src/features/connectors/wizards/accountingSpec.tsx:136
msgid "Conservazione e cancellazione conformi al regolamento UE."
msgstr "Conservazione e cancellazione conformi al regolamento UE."

#: src/routes/_authed/workspace/finance.tsx:1800
msgid "Conservazione e LIPE nei prossimi 60 giorni"
msgstr "Conservazione e LIPE nei prossimi 60 giorni"

#: src/features/connectors/wizards/sdiSpec.tsx:103
msgid "Conservazione integrata"
msgstr "Conservazione integrata"

#: src/routes/_authed/workspace/canvases.tsx:253
msgid "Consigliati da Ando"
msgstr "Consigliati da Ando"

#: src/features/voice_report/components/NewReportDialog.tsx:682
msgid "Consigliato"
msgstr "Consigliato"

#: src/features/console/components/CommandCenter.tsx:38
#: src/features/console/components/ConsoleShell.tsx:687
#: src/features/console/pages/ConnectorDetailPage.tsx:260
#: src/features/console/pages/FlowDetailPage.tsx:115
#: src/features/console/pages/KeyDetailPage.tsx:587
msgid "Console"
msgstr "Console"

#: src/features/console/docs/content.ts:1171
msgid "Console · /platform/console/v1 · cookie di sessione (ruolo platform-dev)"
msgstr "Console · /platform/console/v1 · cookie di sessione (ruolo platform-dev)"

#: src/features/console/docs/content.ts:1381
msgid "Console · /platform/console/v1 · cookie di sessione; nessun accesso Workspace richiesto."
msgstr "Console · /platform/console/v1 · cookie di sessione; nessun accesso Workspace richiesto."

#: src/features/admin/components/AdminUsers.tsx:252
#: src/features/admin/components/userAdminActions.tsx:82
msgid "Console (dev)"
msgstr "Console (dev)"

#: src/features/console/docs/content.ts:1169
msgid "Console (management, session)"
msgstr "Console (management, session)"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:304
msgid "Consolidation jobs (24h)"
msgstr "Consolidation jobs (24h)"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:310
msgid "Consolidation jobs recenti"
msgstr "Consolidation jobs recenti"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:264
#: src/features/console/pages/BillingPage.tsx:256
msgid "Consumato"
msgstr "Consumato"

#: src/features/admin/components/AdminBilling.tsx:167
#: src/features/admin/components/AdminBilling.tsx:269
msgid "Consumi & ricavi"
msgstr "Consumi & ricavi"

#: src/features/console/pages/UsagePage.tsx:320
msgid "Consumi Engine attribuiti degli ultimi {windowDays} giorni: richieste, token e ripartizione per modello. I dati precedenti al nuovo tracciamento restano nei report storici."
msgstr "Consumi Engine attribuiti degli ultimi {windowDays} giorni: richieste, token e ripartizione per modello. I dati precedenti al nuovo tracciamento restano nei report storici."

#: src/features/settings/components/PlatformUsageCard.tsx:55
msgid "Consumo LLM (30 giorni)"
msgstr "Consumo LLM (30 giorni)"

#: src/features/console/pages/UsagePage.tsx:481
msgid "Consumo per modello"
msgstr "Consumo per modello"

#: src/features/console/pages/UsagePage.tsx:491
msgid "Consumo per tipo di richiesta"
msgstr "Consumo per tipo di richiesta"

#: src/features/admin/components/AdminCpq.tsx:1030
msgid "Conta il refresh dello schema"
msgstr "Conta il refresh dello schema"

#: src/features/connectors/wizards/accountingSpec.tsx:71
#: src/features/console/connectors/meta.ts:93
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:62
msgid "Contabilità"
msgstr "Contabilità"

#: src/features/console/docs/content.ts:1193
msgid "Contatori: documenti, chunk indicizzati, storage, connettori attivi, job recenti."
msgstr "Contatori: documenti, chunk indicizzati, storage, connettori attivi, job recenti."

#: src/routes/_authed/_modal/settings/help.tsx:156
msgid "Contatta il supporto"
msgstr "Contatta il supporto"

#: src/features/sales/components/LeadsPanel.tsx:90
msgid "Contattati"
msgstr "Contattati"

#: src/features/sales/components/leadMeta.ts:29
msgid "Contattato"
msgstr "Contattato"

#: src/features/sales/components/crm/ContactsPanel.tsx:186
msgid "contatti"
msgstr "contatti"

#: src/features/sales/components/crm/CompaniesPanel.tsx:233
#: src/features/sales/components/crm/RecordDrawer.tsx:283
#: src/features/sales/components/SalesOverview.tsx:184
#: src/features/workspace/config.ts:364
msgid "Contatti"
msgstr "Contatti"

#: src/features/sales/components/LeadsPanel.tsx:540
msgid "contatti selezionati"
msgstr "contatti selezionati"

#: src/features/console/connectors/meta.ts:79
msgid "Contatti, aziende, trattative e note del CRM"
msgstr "Contatti, aziende, trattative e note del CRM"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:716
#: src/features/sales/components/crm/CreateDealDialog.tsx:190
#: src/features/sales/components/crm/CreateDealDialog.tsx:195
#: src/features/sales/components/crm/DealDetailDrawer.tsx:213
#: src/features/sales/components/LeadDetailDrawer.tsx:177
#: src/features/sales/components/LeadsPanel.tsx:401
msgid "Contatto"
msgstr "Contatto"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:223
msgid "Contatto collegato"
msgstr "Contatto collegato"

#: src/features/sales/hooks/useCrmQueries.ts:202
msgid "Contatto creato"
msgstr "Contatto creato"

#: src/features/sales/components/LeadsPanel.tsx:538
msgid "contatto selezionato"
msgstr "contatto selezionato"

#: src/features/dashboard/utils/calculatedFields.ts:113
msgid "Conteggio"
msgstr "Conteggio"

#: src/features/console/connectors/meta.ts:231
msgid "Contenuti autorizzati dalla sorgente collegata"
msgstr "Contenuti autorizzati dalla sorgente collegata"

#: src/features/clean-control/utils/signalCatalog.ts:108
msgid "Contenuti con similarità semantica ≥ 95%."
msgstr "Contenuti con similarità semantica ≥ 95%."

#: src/features/chat/components/ChatTopBar.tsx:66
#: src/features/chat/components/ChatTopBar.tsx:74
#: src/features/chat/components/ChatTopBar.tsx:154
#: src/features/chat/components/ChatTopBar.tsx:159
msgid "Contenuti della chat"
msgstr "Contenuti della chat"

#: src/features/console/pages/OverviewPage.tsx:291
msgid "Contenuti già disponibili"
msgstr "Contenuti già disponibili"

#: src/features/console/lib/onboarding.ts:82
msgid "Contenuti indicizzati"
msgstr "Contenuti indicizzati"

#: src/features/console/pages/PlaygroundPage.tsx:571
msgid "Contenuti indicizzati e connessioni"
msgstr "Contenuti indicizzati e connessioni"

#: src/features/console/pages/SchemaPage.tsx:767
msgid "Contenuti non strutturati"
msgstr "Contenuti non strutturati"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:111
msgid "Contenuti selezionati"
msgstr "Contenuti selezionati"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:102
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:200
#: src/features/console/pages/DocumentsPage.tsx:373
#: src/features/sales/components/BatchSendModal.tsx:289
msgid "Contenuto"
msgstr "Contenuto"

#: src/features/console/components/DocumentAcquiredContent.tsx:23
#: src/features/console/pages/DocumentsPage.tsx:382
msgid "Contenuto acquisito"
msgstr "Contenuto acquisito"

#: src/features/console/pages/SchemaPage.tsx:487
#: src/features/console/pages/SchemaPage.tsx:666
msgid "Contenuto indicizzato"
msgstr "Contenuto indicizzato"

#: src/features/clean-control/utils/signalCatalog.ts:134
msgid "Contenuto non modificato da oltre 180 giorni."
msgstr "Contenuto non modificato da oltre 180 giorni."

#: src/features/console/traces/TracePayloadReader.tsx:143
msgid "Contenuto originale paginato"
msgstr "Contenuto originale paginato"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:567
msgid "Contenuto proposto"
msgstr "Contenuto proposto"

#: src/features/clean-control/utils/signalCatalog.ts:212
msgid "Contenuto senza utenti autorizzati residui."
msgstr "Contenuto senza utenti autorizzati residui."

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:152
msgid "Contenuto slide"
msgstr "Contenuto slide"

#: src/features/admin/components/AdminCostTracking.tsx:388
#: src/features/integrations/parts/ConnectorDetailSection.tsx:122
#: src/features/sources/components/CalendarEventPane.tsx:153
msgid "Contesto"
msgstr "Contesto"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:201
#: src/features/connectors/components/management/BusinessContextBanner.tsx:207
#: src/features/connectors/components/management/BusinessContextBanner.tsx:247
#: src/features/connectors/components/management/BusinessContextBanner.tsx:253
#: src/features/connectors/components/management/BusinessContextEditor.tsx:133
msgid "Contesto di business"
msgstr "Contesto di business"

#: src/features/projects/components/sections/PersonaSection.tsx:285
msgid "Contesto specifico del progetto. Si aggiunge al Modo, non lo sostituisce."
msgstr "Contesto specifico del progetto. Si aggiunge al Modo, non lo sostituisce."

#: src/routes/_authed/workspace/finance.tsx:1475
msgid "Conti"
msgstr "Conti"

#: src/features/connectors/wizards/openBankingSpec.tsx:136
#: src/features/workspace/finance/components/BankAccountsList.tsx:76
msgid "Conti bancari"
msgstr "Conti bancari"

#: src/routes/_authed/workspace/finance.tsx:1358
msgid "Conti bancari collegati"
msgstr "Conti bancari collegati"

#: src/routes/_authed/workspace/finance.tsx:1456
msgid "Conti collegati ma nessun movimento ancora. Il provider potrebbe essere in sandbox o la prima sync deve ancora completare — forza un aggiornamento sul conto qui sotto."
msgstr "Conti collegati ma nessun movimento ancora. Il provider potrebbe essere in sandbox o la prima sync deve ancora completare — forza un aggiornamento sul conto qui sotto."

#: src/features/console/connectors/meta.ts:151
msgid "Conti, saldi e movimenti dei rapporti autorizzati"
msgstr "Conti, saldi e movimenti dei rapporti autorizzati"

#: src/features/hive-flows/components/ConditionBuilder.tsx:102
msgid "contiene"
msgstr "contiene"

#: src/features/admin/components/ZitadelPasswordActions.tsx:115
msgid "Contiene un segreto — incollala subito e svuota gli appunti."
msgstr "Contiene un segreto — incollala subito e svuota gli appunti."

#: src/features/auth/desktop/DesktopLoginForm.tsx:586
#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:132
#: src/features/console/components/CreateKeyWizard.tsx:731
#: src/features/console/connectors/StructuredConnectorSetup.tsx:244
msgid "Continua"
msgstr "Continua"

#: src/routes/_authed/workspace/canvases.tsx:354
msgid "Continua a chattare con Ando: appena emerge un'entità ricorrente, ti propone un canvas qui sopra."
msgstr "Continua a chattare con Ando: appena emerge un'entità ricorrente, ti propone un canvas qui sopra."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1008
msgid "Continua a compilare"
msgstr "Continua a compilare"

#: src/features/dashboard/components/AddWidgetWizard.tsx:385
#: src/features/skills/components/SkillEditor.tsx:477
msgid "Continua a modificare"
msgstr "Continua a modificare"

#: src/features/admin/components/AdminCpqAskAndo.tsx:248
msgid "Continua a scrivere per affinare, poi applica o scarta."
msgstr "Continua a scrivere per affinare, poi applica o scarta."

#. placeholder {0}: idp.display_name
#. placeholder {0}: idp.name || idp.type
#: src/features/auth/desktop/DesktopLoginForm.tsx:640
#: src/features/auth/desktop/DesktopLoginForm.tsx:714
msgid "Continua con {0}"
msgstr "Continua con {0}"

#: src/features/auth/desktop/DesktopLoginForm.tsx:630
#: src/features/connectors/components/GmailAccessModeDialog.tsx:31
msgid "Continua con Google"
msgstr "Continua con Google"

#: src/features/auth/desktop/DesktopLoginForm.tsx:635
msgid "Continua con Microsoft"
msgstr "Continua con Microsoft"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:260
msgid "Continua con Workspace"
msgstr "Continua con Workspace"

#: src/routes/_authed/workspace/shares.tsx:317
msgid "Continua da qui"
msgstr "Continua da qui"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:521
msgid "Continua la configurazione nel browser"
msgstr "Continua la configurazione nel browser"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:160
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:220
#: src/features/workspace/finance/components/BankAccountsList.tsx:99
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:204
msgid "Conto"
msgstr "Conto"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:229
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:247
#: src/features/workspace/finance/components/BankAccountsList.tsx:93
#: src/features/workspace/finance/components/BankAccountsList.tsx:110
msgid "Conto bancario"
msgstr "Conto bancario"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:355
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:372
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:373
msgid "Conto di addebito"
msgstr "Conto di addebito"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:258
msgid "Conto su cui è arrivato l'incasso (vuoto = predefinito azienda)."
msgstr "Conto su cui è arrivato l'incasso (vuoto = predefinito azienda)."

#: src/features/console/connectors/CustomConnectorDetail.tsx:1042
msgid "Contract"
msgstr "Contract"

#: src/features/chat/components/ChatEmptyState.tsx:223
msgid "Contratti firmati"
msgstr "Contratti firmati"

#: src/features/settings/components/NotificationPreferences.tsx:72
msgid "Contratti, abbonamenti e scadenze auto-rilevati nei tuoi documenti ed email."
msgstr "Contratti, abbonamenti e scadenze auto-rilevati nei tuoi documenti ed email."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:68
msgid "Contratto ando-platform: mai fatturato a consumo. La fattura la emette la SRL."
msgstr "Contratto ando-platform: mai fatturato a consumo. La fattura la emette la SRL."

#: src/features/console/pages/BillingPage.tsx:400
msgid "Contratto gestito esternamente"
msgstr "Contratto gestito esternamente"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:241
msgid "Control"
msgstr "Control"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:368
msgid "Controlla configurazione"
msgstr "Controlla configurazione"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Controlla configurazione login"
msgstr "Controlla configurazione login"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:870
msgid "Controlla e avvia"
msgstr "Controlla e avvia"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:264
msgid "Controlla i campi"
msgstr "Controlla i campi"

#: src/features/console/lib/onboarding.ts:73
msgid "Controlla i contenuti"
msgstr "Controlla i contenuti"

#: src/features/console/pages/PlaygroundPage.tsx:768
msgid "Controlla il risultato"
msgstr "Controlla il risultato"

#: src/features/integrations/parts/StatusElements.tsx:134
msgid "Controlla la connessione e riprova."
msgstr "Controlla la connessione e riprova."

#: src/features/auth/desktop/DesktopLoginForm.tsx:909
msgid "Controlla la tua email"
msgstr "Controlla la tua email"

#: src/features/console/docs/content.ts:1529
msgid "Controlla lo stato OAuth"
msgstr "Controlla lo stato OAuth"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:80
msgid "Controlla lo stato prima di riprovare."
msgstr "Controlla lo stato prima di riprovare."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:272
msgid "Controlla stato"
msgstr "Controlla stato"

#: src/features/admin/components/AdminBilling.tsx:213
msgid "Controllo billing di piattaforma"
msgstr "Controllo billing di piattaforma"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:64
msgid "Controllo delle importazioni precedenti…"
msgstr "Controllo delle importazioni precedenti…"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:109
msgid "Conversazione"
msgstr "Conversazione"

#: src/features/admin/components/AdminCpqAskAndo.tsx:269
msgid "Conversazione con Ando"
msgstr "Conversazione con Ando"

#: src/routes/_authed/workspace/shares.tsx:245
msgid "Conversazione copiata nel tuo workspace"
msgstr "Conversazione copiata nel tuo workspace"

#: src/features/sources/components/EmailThreadMessages.tsx:144
msgid "Conversazione email"
msgstr "Conversazione email"

#: src/features/console/pages/PlaygroundPage.tsx:1940
msgid "Conversazione multi-turno"
msgstr "Conversazione multi-turno"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:608
msgid "conversazioni"
msgstr "conversazioni"

#: src/features/onboarding/demoTourSteps.ts:68
#: src/features/workspace/config.ts:79
#: src/features/workspace/config.ts:81
#: src/routes/_authed/workspace/conversations.tsx:1146
#: src/routes/_authed/workspace/conversations.tsx:1172
#: src/routes/_authed/workspace/conversations.tsx:1196
msgid "Conversazioni"
msgstr "Conversazioni"

#: src/features/console/docs/content.ts:508
msgid "Conversazioni (multi-turn)"
msgstr "Conversazioni (multi-turn)"

#: src/routes/_authed/workspace/shares.tsx:120
msgid "Conversazioni e risposte"
msgstr ""

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:205
msgid "Conversazioni, memoria, documenti, automazioni e OAuth seguono l'utente. Le connessioni legacy potrebbero richiedere un re-OAuth. Disattiva per lasciare i dati nell'org sorgente."
msgstr "Conversazioni, memoria, documenti, automazioni e OAuth seguono l'utente. Le connessioni legacy potrebbero richiedere un re-OAuth. Disattiva per lasciare i dati nell'org sorgente."

#: src/features/sales/hooks/useCrmQueries.ts:401
msgid "Conversione non riuscita"
msgstr "Conversione non riuscita"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:25
msgid "Convertita da lead"
msgstr "Convertita da lead"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:28
msgid "Convertito da lead"
msgstr "Convertito da lead"

#: src/features/admin/components/AdminEngagement.tsx:567
msgid "Coorte"
msgstr "Coorte"

#: src/features/admin/components/AdminEngagement.tsx:560
msgid "Coorti di retention — % attivi rispetto alla settimana di iscrizione"
msgstr "Coorti di retention — % attivi rispetto alla settimana di iscrizione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:679
#: src/features/settings/components/BrandKitSettings.tsx:419
#: src/features/settings/components/BrandKitSettings.tsx:596
msgid "Copertina"
msgstr "Copertina"

#. placeholder {0}: Math.round((completeness?.coverage_pct ?? 0) * 100)
#: src/routes/_authed/workspace/finance.tsx:690
msgid "Copertura {0}%"
msgstr "Copertura {0}%"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:511
msgid "Copertura app"
msgstr "Copertura app"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:463
msgid "Copertura connessioni legacy"
msgstr "Copertura connessioni legacy"

#: src/features/admin/components/AdminCostTracking.tsx:122
msgid "Copertura input token"
msgstr "Copertura input token"

#: src/features/admin/components/AdminCostTracking.tsx:128
msgid "Copertura output token"
msgstr "Copertura output token"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:66
#: src/features/connect/components/connectShared.tsx:309
#: src/features/console/components/atoms.tsx:509
#: src/features/console/components/atoms.tsx:510
#: src/features/console/components/CreateKeyWizard.tsx:632
#: src/features/console/components/OverlapRotationModal.tsx:139
#: src/features/console/pages/EngineSignupPage.tsx:247
#: src/features/console/pages/PlaygroundPage.tsx:1275
#: src/features/console/webhooks/WebhooksPanel.tsx:331
#: src/features/dashboard/components/AddChartDialog.tsx:224
#: src/features/hive-flows/components/FlowFormPublish.tsx:136
#: src/features/share/components/ShareLinkDialog.tsx:909
#: src/features/voice_report/components/ShareReportDialog.tsx:335
msgid "Copia"
msgstr "Copia"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1486
msgid "Copia (Cmd+C), poi incolla in un'altra slide"
msgstr "Copia (Cmd+C), poi incolla in un'altra slide"

#: src/features/sales/components/LeadDetailDrawer.tsx:336
msgid "Copia {email}"
msgstr "Copia {email}"

#: src/features/sources/components/CalendarEventPane.tsx:578
msgid "Copia briefing negli appunti"
msgstr "Copia briefing negli appunti"

#: src/features/admin/components/AdminDecks.tsx:397
msgid "Copia di una esistente"
msgstr "Copia di una esistente"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:155
msgid "Copia fallita"
msgstr "Copia fallita"

#: src/features/console/docs/CodeBlock.tsx:58
msgid "Copia il codice"
msgstr "Copia il codice"

#: src/features/console/pages/PlaygroundPage.tsx:1164
msgid "Copia il JSON"
msgstr "Copia il JSON"

#: src/features/voice_report/components/ShareReportDialog.tsx:320
#: src/features/voice_report/components/ShareReportDialog.tsx:388
msgid "Copia il link condivisione"
msgstr "Copia il link condivisione"

#: src/features/admin/components/AdminDemoInviti.tsx:126
msgid "Copia il link per condividerlo."
msgstr "Copia il link per condividerlo."

#: src/features/console/pages/DocsPage.tsx:116
msgid "Copia il path"
msgstr "Copia il path"

#. placeholder {0}: key.key_prefix
#. placeholder {0}: keyRecord.key_prefix
#: src/features/console/pages/KeyDetailPage.tsx:670
#: src/features/console/pages/KeysPage.tsx:182
msgid "Copia il prefisso {0}"
msgstr "Copia il prefisso {0}"

#: src/features/console/components/OverlapRotationModal.tsx:138
msgid "Copia il secret"
msgstr "Copia il secret"

#: src/features/console/webhooks/WebhooksPanel.tsx:330
msgid "Copia il signing secret"
msgstr "Copia il signing secret"

#: src/features/console/pages/PlaygroundPage.tsx:708
msgid "Copia l'id del documento"
msgstr "Copia l'id del documento"

#: src/features/console/pages/KeyDetailPage.tsx:599
msgid "Copia l'id della chiave"
msgstr "Copia l'id della chiave"

#: src/features/console/connectors/ConnectionCard.tsx:190
#: src/features/console/pages/ConnectorDetailPage.tsx:286
msgid "Copia l'id della connessione"
msgstr "Copia l'id della connessione"

#: src/features/console/pages/ModelsPage.tsx:120
msgid "Copia l'identificatore del modello"
msgstr "Copia l'identificatore del modello"

#: src/features/console/components/CreateKeyWizard.tsx:629
msgid "Copia la chiave"
msgstr "Copia la chiave"

#: src/features/console/components/ByokModal.tsx:164
msgid "Copia la chiave inserita"
msgstr "Copia la chiave inserita"

#: src/features/console/pages/DocsPage.tsx:204
msgid "Copia la firma"
msgstr "Copia la firma"

#: src/features/console/pages/PlaygroundPage.tsx:995
msgid "Copia la query SQL"
msgstr "Copia la query SQL"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1252
msgid "Copia la selezione (Cmd+C)"
msgstr "Copia la selezione (Cmd+C)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2252
msgid "Copia le celle da Excel o Google Sheets (prima riga: intestazioni) e incollale qui"
msgstr "Copia le celle da Excel o Google Sheets (prima riga: intestazioni) e incollale qui"

#: src/features/admin/components/AdminDemoInviti.tsx:277
#: src/features/admin/components/AdminGatedLinks.tsx:304
#: src/features/share/components/ShareLinkRow.tsx:182
#: src/features/sources/components/CalendarEventPane.tsx:488
msgid "Copia link"
msgstr "Copia link"

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:351
msgid "Copia link invito a {0}"
msgstr "Copia link invito a {0}"

#: src/features/sources/components/CalendarEventPane.tsx:487
msgid "Copia link videochiamata"
msgstr "Copia link videochiamata"

#. placeholder {0}: connector.slug
#. placeholder {0}: created.slug
#: src/features/console/connectors/CustomConnectorsPanel.tsx:298
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:373
msgid "Copia lo slug {0}"
msgstr "Copia lo slug {0}"

#: src/features/console/pages/PlaygroundPage.tsx:1274
msgid "Copia lo snippet"
msgstr "Copia lo snippet"

#: src/features/sources/components/CalendarEventPane.tsx:579
msgid "Copia negli appunti"
msgstr "Copia negli appunti"

#: src/features/admin/components/ZitadelPasswordActions.tsx:117
msgid "Copia negli appunti fallita"
msgstr "Copia negli appunti fallita"

#: src/features/admin/components/AdminGatedLinks.tsx:170
#: src/features/sales/components/LeadDetailDrawer.tsx:328
msgid "Copia non riuscita"
msgstr "Copia non riuscita"

#: src/features/connect/components/connectShared.tsx:276
msgid "Copia non riuscita. Copia manualmente."
msgstr "Copia non riuscita. Copia manualmente."

#: src/features/admin/components/ZitadelPasswordActions.tsx:250
msgid "Copia password"
msgstr "Copia password"

#: src/features/templates/components/TemplatesList.tsx:114
msgid "Copia personalizzabile del template built-in."
msgstr "Copia personalizzabile del template built-in."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1394
msgid "Copia prima un elemento (Cmd+C o il pulsante Copia)"
msgstr "Copia prima un elemento (Cmd+C o il pulsante Copia)"

#: src/features/sources/components/ArtifactPane.tsx:654
msgid "Copia salvata e aperta"
msgstr "Copia salvata e aperta"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:211
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:223
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:289
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:300
#: src/features/dashboard/components/AddChartDialog.tsx:221
msgid "Copia SQL"
msgstr "Copia SQL"

#: src/features/console/components/CreateKeyWizard.tsx:668
msgid "Copia subito il segreto: non sarà più mostrato."
msgstr "Copia subito il segreto: non sarà più mostrato."

#: ../../packages/ui/src/connectors/FieldRenderer.tsx:80
msgid "Copia URL"
msgstr "Copia URL"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:218
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:295
#: src/features/connect/components/connectShared.tsx:305
#: src/features/share/components/ShareLinkDialog.tsx:909
#: src/features/voice_report/components/ShareReportDialog.tsx:330
msgid "Copiato"
msgstr "Copiato"

#: src/features/share/components/ShareLinkRow.tsx:182
msgid "Copiato!"
msgstr "Copiato!"

#: src/routes/_authed/workspace/shares.tsx:317
msgid "Copio…"
msgstr "Copio…"

#: src/features/console/docs/content.ts:226
msgid "Core — identità & chiavi"
msgstr "Core — identità & chiavi"

#: src/features/console/docs/content.ts:595
msgid "Corpo con slug, name e kind push. Il connettore appare in console accanto a quelli nativi."
msgstr "Corpo con slug, name e kind push. Il connettore appare in console accanto a quelli nativi."

#: src/features/sales/components/BatchSendModal.tsx:346
msgid "Corpo dell'email. Usa {{campo}} per i placeholder."
msgstr "Corpo dell'email. Usa {{campo}} per i placeholder."

#: src/features/sales/components/SignaturesManager.tsx:261
msgid "Corpo della firma"
msgstr "Corpo della firma"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:346
msgid "Corpo della risposta"
msgstr "Corpo della risposta"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:317
msgid "Corpo email vuoto."
msgstr "Corpo email vuoto."

#: src/features/console/docs/content.ts:518
msgid "Corpo opzionale con un title. Senza titolo, il primo turno la intitola con la tua prima riga verbatim."
msgstr "Corpo opzionale con un title. Senza titolo, il primo turno la intitola con la tua prima riga verbatim."

#: src/features/clean-control/utils/signalCatalog.ts:150
#: src/features/clean-control/utils/signalCatalog.ts:163
#: src/features/clean-control/utils/signalCatalog.ts:176
msgid "Correggi"
msgstr "Correggi"

#: src/features/admin/components/AdminCpq.tsx:402
msgid "Correggi gli indirizzi email non validi"
msgstr "Correggi gli indirizzi email non validi"

#: src/features/actions/components/ScalarActionProposalMount.tsx:192
#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:219
msgid "Correggi i campi evidenziati prima di confermare"
msgstr "Correggi i campi evidenziati prima di confermare"

#: src/features/admin/components/AdminGatedLinks.tsx:142
msgid "Correggi o rimuovi gli indirizzi in rosso."
msgstr "Correggi o rimuovi gli indirizzi in rosso."

#: src/features/connectors/wizards/crmSpec.tsx:105
msgid "Correla email, calendario e CRM in un'unica vista temporale."
msgstr "Correla email, calendario e CRM in un'unica vista temporale."

#: src/features/connectors/wizards/projectManagementSpec.tsx:76
msgid "Correla email, calendario e progetti in un'unica vista temporale."
msgstr "Correla email, calendario e progetti in un'unica vista temporale."

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:165
msgid "Corrente"
msgstr "Corrente"

#: src/features/hive-flows/components/ConditionBuilder.tsx:105
msgid "corrisponde a (regex)"
msgstr "corrisponde a (regex)"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:723
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1928
#: src/features/sales/components/SignatureRichEditor.tsx:204
msgid "Corsivo"
msgstr "Corsivo"

#: src/features/settings/components/SelfProfileMemory.tsx:386
msgid "Cosa Ando ha imparato di te"
msgstr "Cosa Ando ha imparato di te"

#: src/features/sources/components/CalendarEventPane.tsx:154
msgid "Cosa aspettarti"
msgstr "Cosa aspettarti"

#: src/features/workspace/components/TaskComposer.tsx:140
msgid "Cosa c'è da fare?"
msgstr "Cosa c'è da fare?"

#: src/features/chat/components/ChatEmptyState.tsx:139
#: src/routes/_authed/route.tsx:1068
msgid "Cosa devo fare oggi"
msgstr "Cosa devo fare oggi"

#: src/features/chat/components/ChatEmptyState.tsx:140
#: src/routes/_authed/route.tsx:1069
msgid "Cosa devo fare oggi? Mostrami priorità, scadenze e meeting."
msgstr "Cosa devo fare oggi? Mostrami priorità, scadenze e meeting."

#: src/features/sources/components/CalendarEventPane.tsx:414
msgid "Cosa devo sapere prima del meeting \"{titleLabel}\"?"
msgstr "Cosa devo sapere prima del meeting \"{titleLabel}\"?"

#: src/features/agent-modes/components/AgentModeEditor.tsx:503
msgid "Cosa è cambiato (verrà mostrato nella history)"
msgstr "Cosa è cambiato (verrà mostrato nella history)"

#: src/features/chat/components/ChatEmptyState.tsx:408
msgid "Cosa è stato condiviso con me di recente?"
msgstr "Cosa è stato condiviso con me di recente?"

#: src/features/sales/components/LeadDetailDrawer.tsx:145
#: src/features/skills/components/SkillEditor.tsx:417
msgid "Cosa fa"
msgstr "Cosa fa"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:276
msgid "Cosa fa questa azione nel tuo applicativo"
msgstr "Cosa fa questa azione nel tuo applicativo"

#: src/features/hive-flows/components/AiCopilotBar.tsx:116
msgid "Cosa fa:"
msgstr "Cosa fa:"

#: src/features/chat/components/ChatEmptyState.tsx:275
msgid "Cosa farò domani"
msgstr "Cosa farò domani"

#: src/features/console/pages/PlaygroundPage.tsx:1017
msgid "Cosa ha fatto l'agente, in ordine — senza mai esporre il fornitore."
msgstr "Cosa ha fatto l'agente, in ordine — senza mai esporre il fornitore."

#: src/features/chat/components/ChatEmptyState.tsx:420
msgid "Cosa hanno condiviso le persone del mio team?"
msgstr "Cosa hanno condiviso le persone del mio team?"

#: src/features/chat/components/ChatEmptyState.tsx:399
#: src/features/chat/components/ChatEmptyState.tsx:413
msgid "Cosa ho condiviso"
msgstr "Cosa ho condiviso"

#: src/features/chat/components/ChatEmptyState.tsx:414
msgid "Cosa ho condiviso negli ultimi 30 giorni?"
msgstr "Cosa ho condiviso negli ultimi 30 giorni?"

#: src/features/chat/components/ChatEmptyState.tsx:249
msgid "Cosa ho da fare oggi"
msgstr "Cosa ho da fare oggi"

#: src/features/chat/components/ChatEmptyState.tsx:250
msgid "Cosa ho da fare oggi sui task tecnici?"
msgstr "Cosa ho da fare oggi sui task tecnici?"

#: src/features/chat/components/ChatEmptyState.tsx:282
msgid "Cosa ho portato a casa questa settimana?"
msgstr "Cosa ho portato a casa questa settimana?"

#: src/features/chat/components/ChatEmptyState.tsx:385
msgid "Cosa posso automatizzare"
msgstr "Cosa posso automatizzare"

#. placeholder {0}: item.subject
#. placeholder {1}: item.sender_display
#: src/features/sources/components/InboxDetailPane.tsx:457
msgid "Cosa posso fare con questa email? Oggetto: \"{0}\" da {1}. "
msgstr "Cosa posso fare con questa email? Oggetto: \"{0}\" da {1}. "

#: src/features/integrations/parts/IntegrationsEmptyState.tsx:57
#: src/routes/_authed/workspace/calendar.tsx:1432
msgid "Cosa potrai fare"
msgstr "Cosa potrai fare"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:96
msgid "Cosa può provare il cliente"
msgstr "Cosa può provare il cliente"

#: src/features/clean-control/components/EventDetailSheet.tsx:326
msgid "Cosa significa"
msgstr "Cosa significa"

#: src/routes/_authed/_modal/settings/help.tsx:73
msgid "Cosa sono i Modi agente?"
msgstr "Cosa sono i Modi agente?"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:443
msgid "Cosa viene applicato"
msgstr "Cosa viene applicato"

#: src/features/onboarding/DemoBookCallModal.tsx:439
msgid "Cosa vorresti vedere?"
msgstr "Cosa vorresti vedere?"

#: ../../packages/ui/src/editors/RegionEditPill.tsx:221
msgid "Cosa vuoi cambiare? (es. tono più formale, accorcia…)"
msgstr "Cosa vuoi cambiare? (es. tono più formale, accorcia…)"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:168
msgid "Cosa vuoi capire da questo report?"
msgstr "Cosa vuoi capire da questo report?"

#: src/features/connect/components/GuestPreviewDialog.tsx:52
msgid "Così appare «{spaceName}» a chi inviti. Le risposte sono limitate alle sole fonti condivise qui sotto."
msgstr "Così appare «{spaceName}» a chi inviti. Le risposte sono limitate alle sole fonti condivise qui sotto."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:344
msgid "Cost (USD)"
msgstr "Cost (USD)"

#: src/features/admin/components/AdminPlatformSettings.tsx:577
msgid "Cost cap (€)"
msgstr "Cost cap (€)"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:337
msgid "Cost cap (€/mese)"
msgstr "Cost cap (€/mese)"

#: src/features/admin/components/AdminPlatformSettings.tsx:815
msgid "Cost cap chat (€)"
msgstr "Cost cap chat (€)"

#: src/features/settings/components/BillingSettings.tsx:146
msgid "Cost cap giornaliero / settimanale / mensile, storage e mix delle modalità usate."
msgstr "Cost cap giornaliero / settimanale / mensile, storage e mix delle modalità usate."

#: src/features/admin/components/AdminPlatformSettings.tsx:638
msgid "Cost cap mensile"
msgstr "Cost cap mensile"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:351
msgid "Cost cap override"
msgstr "Cost cap override"

#: src/routes/_authed/_modal/admin/route.tsx:128
msgid "Cost tracking"
msgstr "Cost tracking"

#: src/features/admin/components/AdminCostTracking.tsx:201
msgid "Cost tracking — costi LLM granulari"
msgstr "Cost tracking — costi LLM granulari"

#: src/features/admin/components/CostTraceDetailSection.tsx:132
#: src/features/admin/components/orgs/OrgDetailShell.tsx:173
msgid "Costi"
msgstr "Costi"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:530
msgid "Costi per membro"
msgstr "Costi per membro"

#: src/features/admin/components/AdminCpqPriceBook.tsx:322
msgid "Costi unitari in USD (minimo, atteso, massimo). Tipo \"items\": costo per elemento. Tipo \"refresh\": costo per refresh di una fonte, più la profilazione iniziale."
msgstr "Costi unitari in USD (minimo, atteso, massimo). Tipo \"items\": costo per elemento. Tipo \"refresh\": costo per refresh di una fonte, più la profilazione iniziale."

#: src/features/admin/components/AdminBilling.tsx:170
msgid "Costi, margine e consumo per tenant nel tempo."
msgstr "Costi, margine e consumo per tenant nel tempo."

#: src/features/automations/components/AutomationDetailSection.tsx:148
msgid "costo"
msgstr "costo"

#: src/features/admin/components/CostTraceDetailSection.tsx:232
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:330
#: src/features/admin/components/orgs/OrgBillingTab.tsx:459
#: src/features/admin/components/orgs/OrgBillingTab.tsx:544
#: src/features/settings/components/PlatformUsageCard.tsx:65
msgid "Costo"
msgstr "Costo"

#: src/features/billing/components/UsageMeter.tsx:222
msgid "Costo · giornaliero"
msgstr "Costo · giornaliero"

#: src/features/billing/components/UsageMeter.tsx:230
msgid "Costo · settimanale"
msgstr "Costo · settimanale"

#: src/features/admin/components/AdminCanvas.tsx:135
msgid "Costo compile nel tempo"
msgstr "Costo compile nel tempo"

#: src/features/admin/components/AdminCpq.tsx:257
msgid "Costo infrastruttura"
msgstr "Costo infrastruttura"

#. placeholder {0}: row.name || idx + 1
#: src/features/admin/components/AdminPlatformSettings.tsx:263
msgid "Costo input modello {0}"
msgstr "Costo input modello {0}"

#: src/features/admin/components/AdminCpqPriceBook.tsx:226
msgid "Costo medio chat (USD), solo stima query"
msgstr "Costo medio chat (USD), solo stima query"

#: src/features/admin/components/AdminCpqPriceBook.tsx:220
msgid "Costo orario supporto (EUR)"
msgstr "Costo orario supporto (EUR)"

#: src/features/admin/components/AdminCpq.tsx:258
msgid "Costo ore di supporto"
msgstr "Costo ore di supporto"

#. placeholder {0}: row.name || idx + 1
#: src/features/admin/components/AdminPlatformSettings.tsx:277
msgid "Costo output modello {0}"
msgstr "Costo output modello {0}"

#: src/features/admin/components/AdminPlatformSettings.tsx:180
msgid "Costo per 1M token (input/output) per modello. Validato lato BE."
msgstr "Costo per 1M token (input/output) per modello. Validato lato BE."

#: src/features/admin/components/AdminCostTracking.tsx:243
msgid "Costo per sorgente"
msgstr "Costo per sorgente"

#: src/features/admin/components/orgs/OrgCostTab.tsx:202
msgid "Costo per utente"
msgstr "Costo per utente"

#: src/features/console/pages/FlowsPage.tsx:216
msgid "Costo stimato"
msgstr "Costo stimato"

#: src/features/console/pages/UsagePage.tsx:413
msgid "Costo stimato ({windowDays}g)"
msgstr "Costo stimato ({windowDays}g)"

#: src/features/admin/components/CostTraceDetailSection.tsx:150
msgid "Costo totale"
msgstr "Costo totale"

#: src/features/admin/components/AdminCpq.tsx:256
msgid "Costo usage"
msgstr "Costo usage"

#: src/features/admin/components/AdminCostTracking.tsx:255
msgid "Costo USD"
msgstr "Costo USD"

#: src/features/console/docs/content.ts:1675
msgid "Costruisce il client. api_key inviata come Authorization: Bearer."
msgstr "Costruisce il client. api_key inviata come Authorization: Bearer."

#: src/features/console/docs/content.ts:1856
msgid "Costruisce l'helper (o usa ando.connector(slug)). batch_size 1..500."
msgstr "Costruisce l'helper (o usa ando.connector(slug)). batch_size 1..500."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2602
msgid "Costruisci dai documenti allegati una presentazione completa di 8-12 slide: copertina, problema, soluzione, come funziona, piano e tempi, metriche di successo, dati e sicurezza, prossimi passi. Riscrivi le slide esistenti che servono e aggiungi le mancanti, con i numeri e i casi dei documenti; non togliere slide."
msgstr "Costruisci dai documenti allegati una presentazione completa di 8-12 slide: copertina, problema, soluzione, come funziona, piano e tempi, metriche di successo, dati e sicurezza, prossimi passi. Riscrivi le slide esistenti che servono e aggiungi le mancanti, con i numeri e i casi dei documenti; non togliere slide."

#: src/routes/_authed/workspace/flows.index.tsx:674
msgid "Costruisci flussi visuali tra tutti i tuoi strumenti — a concetti, non a logiche tecniche."
msgstr "Costruisci flussi visuali tra tutti i tuoi strumenti — a concetti, non a logiche tecniche."

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:131
msgid "Costruisci la tua prima dashboard"
msgstr "Costruisci la tua prima dashboard"

#: src/features/admin/components/AdminCpq.tsx:242
msgid "Costruzione iniziale (a carico del cliente)"
msgstr "Costruzione iniziale (a carico del cliente)"

#: src/features/admin/components/AdminDecks.tsx:458
#: src/features/admin/components/AdminOrgs.tsx:1266
#: src/features/admin/components/AdminPlatformSettings.tsx:892
#: src/features/canvases/components/SuggestedCanvasCard.tsx:160
#: src/features/projects/components/NewProjectDialog.tsx:195
#: src/features/voice_report/components/NewReportDialog.tsx:1096
msgid "Crea"
msgstr "Crea"

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:227
msgid "Crea + nomina"
msgstr "Crea + nomina"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:347
#: src/features/console/pages/EmbeddedIdentityPage.tsx:403
msgid "Crea app"
msgstr "Crea app"

#: src/features/automations/components/AutomationsHub.tsx:353
#: src/features/automations/components/CreateAutomationDialog.tsx:261
#: src/features/projects/components/sections/AutomationsSection.tsx:258
msgid "Crea automazione"
msgstr "Crea automazione"

#: src/features/sales/components/crm/CompaniesPanel.tsx:152
msgid "Crea azienda"
msgstr "Crea azienda"

#: src/features/settings/components/BrandKitSettings.tsx:268
msgid "Crea Brand Kit"
msgstr "Crea Brand Kit"

#: src/features/sales/components/CreateCampaignDialog.tsx:125
msgid "Crea campagna"
msgstr "Crea campagna"

#. placeholder {0}: suggestion.entity_name
#: src/features/canvases/components/SuggestedCanvasCard.tsx:144
msgid "Crea canvas per {0}"
msgstr "Crea canvas per {0}"

#: src/features/chat/components/ChatEmptyState.tsx:327
msgid "Crea canvas per progetto"
msgstr "Crea canvas per progetto"

#: src/features/console/components/CreateKeyWizard.tsx:740
msgid "Crea chiave"
msgstr "Crea chiave"

#: src/features/sales/components/crm/ContactsPanel.tsx:161
msgid "Crea contatto"
msgstr "Crea contatto"

#: src/features/console/pages/FlowsPage.tsx:263
msgid "Crea da questo template"
msgstr "Crea da questo template"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:147
msgid "Crea dashboard e pinna widget"
msgstr "Crea dashboard e pinna widget"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:297
msgid "Crea deck"
msgstr "Crea deck"

#: src/features/sales/components/CampaignsPanel.tsx:149
msgid "Crea e cerca"
msgstr "Crea e cerca"

#: src/features/console/pages/EngineSignupPage.tsx:164
msgid "Crea e continua"
msgstr "Crea e continua"

#: src/routes/_authed/workspace/flows.index.tsx:240
#: src/routes/_authed/workspace/flows.index.tsx:684
msgid "Crea flow"
msgstr "Crea flow"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:76
msgid "Crea formule usando le colonne disponibili"
msgstr "Crea formule usando le colonne disponibili"

#: src/features/admin/components/AdminDemoInviti.tsx:212
msgid "Crea il primo invito per far provare Ando a un cliente."
msgstr "Crea il primo invito per far provare Ando a un cliente."

#: src/features/agent-modes/components/AgentModesList.tsx:266
msgid "Crea il primo modo"
msgstr "Crea il primo modo"

#: src/features/agent-modes/components/AgentModesList.tsx:260
msgid "Crea il primo modo personalizzato per la tua attività."
msgstr "Crea il primo modo personalizzato per la tua attività."

#: src/features/admin/components/AdminCpqList.tsx:127
msgid "Crea il primo preventivo per una software house o un cliente."
msgstr "Crea il primo preventivo per una software house o un cliente."

#: src/features/templates/components/TemplatesList.tsx:178
msgid "Crea il primo template personalizzato dalla scheda Studio."
msgstr "Crea il primo template personalizzato dalla scheda Studio."

#: src/routes/_authed/workspace/templates/$kind.tsx:136
msgid "Crea il primo template personalizzato per iniziare."
msgstr "Crea il primo template personalizzato per iniziare."

#: src/features/settings/components/BrandKitSettings.tsx:265
msgid "Crea il tuo Brand Kit: colori, font, logo, template e tono di voce useranno questa identità in tutti i documenti, deck e fogli generati. Finché non lo crei, usiamo lo stile Ando."
msgstr "Crea il tuo Brand Kit: colori, font, logo, template e tono di voce useranno questa identità in tutti i documenti, deck e fogli generati. Finché non lo crei, usiamo lo stile Ando."

#: src/routes/_authed/workspace/connect.index.tsx:184
msgid "Crea il tuo primo spazio Connect per condividere documenti, basi di conoscenza o fonti connesse con ospiti esterni — in totale controllo."
msgstr "Crea il tuo primo spazio Connect per condividere documenti, basi di conoscenza o fonti connesse con ospiti esterni — in totale controllo."

#: src/features/settings/components/PresentationTemplates.tsx:399
msgid "Crea il tuo primo template personalizzato per questa categoria."
msgstr "Crea il tuo primo template personalizzato per questa categoria."

#: src/features/voice_report/components/VoiceReportsList.tsx:155
msgid "Crea il tuo primo Voice of X report"
msgstr "Crea il tuo primo Voice of X report"

#: src/features/automations/components/AutomationsHub.tsx:350
msgid "Crea il tuo primo worker o parti da un template per vedere Ando lavorare in autonomia."
msgstr "Crea il tuo primo worker o parti da un template per vedere Ando lavorare in autonomia."

#: src/features/admin/components/AdminDemoInviti.tsx:404
#: src/features/connect/components/MemberManager.tsx:504
msgid "Crea invito"
msgstr "Crea invito"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2774
msgid "Crea la presentazione dal documento"
msgstr "Crea la presentazione dal documento"

#: src/features/console/pages/GetStartedPage.tsx:146
msgid "Crea la prima AppKey"
msgstr "Crea la prima AppKey"

#: src/features/sales/components/CampaignsPanel.tsx:174
msgid "Crea la prima campagna"
msgstr "Crea la prima campagna"

#: src/features/console/pages/KeysPage.tsx:94
msgid "Crea la prima chiave per interrogare il runtime via API — potrai limitarla a sorgenti e connessioni specifiche."
msgstr "Crea la prima chiave per interrogare il runtime via API — potrai limitarla a sorgenti e connessioni specifiche."

#: src/features/sales/components/SalesOverview.tsx:296
msgid "Crea la prima con \"+ Nuovo\"."
msgstr "Crea la prima con \"+ Nuovo\"."

#: src/features/admin/components/AdminOrgs.tsx:986
msgid "Crea la prima organizzazione con il pulsante in alto."
msgstr "Crea la prima organizzazione con il pulsante in alto."

#: src/features/skills/components/SkillsList.tsx:250
msgid "Crea la prima skill"
msgstr "Crea la prima skill"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:347
msgid "Crea la tua prima app"
msgstr "Crea la tua prima app"

#: src/routes/_authed/workspace/flows.index.tsx:672
msgid "Crea la tua prima automazione"
msgstr "Crea la tua prima automazione"

#: src/features/dashboard/components/DashboardListSidebar.tsx:575
#: src/features/dashboard/components/DashboardListSidebar.tsx:578
#: src/features/dashboard/components/DashboardTemplatePicker.tsx:120
msgid "Crea la tua prima dashboard"
msgstr "Crea la tua prima dashboard"

#: src/features/admin/components/AdminDecks.tsx:766
msgid "Crea link"
msgstr "Crea link"

#: src/features/agent-modes/components/AgentModeEditor.tsx:537
msgid "Crea modo"
msgstr "Crea modo"

#: src/features/chat/components/ChatEmptyState.tsx:301
msgid "Crea nuova dashboard"
msgstr "Crea nuova dashboard"

#: src/features/studio/components/StudioDrawerContent.tsx:306
msgid "Crea nuovo Mode"
msgstr "Crea nuovo Mode"

#: src/features/projects/components/ProjectHub.tsx:504
msgid "Crea nuovo progetto"
msgstr "Crea nuovo progetto"

#: src/features/voice_report/components/NewReportDialog.tsx:591
msgid "Crea nuovo Voice of X report"
msgstr "Crea nuovo Voice of X report"

#: src/features/hive-flows/components/AiCopilotBar.tsx:111
msgid "Crea o modifica il flow"
msgstr "Crea o modifica il flow"

#: src/features/sales/components/crm/CreateDealDialog.tsx:235
msgid "Crea opportunità"
msgstr "Crea opportunità"

#: src/features/clean-control/components/policies/PolicyForm.tsx:389
msgid "Crea policy"
msgstr "Crea policy"

#: src/features/admin/components/AdminBilling.tsx:131
msgid "Crea pricing di base"
msgstr "Crea pricing di base"

#: src/features/console/components/CreateKeyWizard.tsx:333
msgid "Crea prima un'app con questa modalità di accesso nella sezione App."
msgstr "Crea prima un'app con questa modalità di accesso nella sezione App."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:242
msgid "Crea progetto"
msgstr "Crea progetto"

#: src/routes/_authed/workspace/dashboard.tsx:533
msgid "Crea report {titleStr}"
msgstr "Crea report {titleStr}"

#: src/features/skills/components/SkillEditor.tsx:457
msgid "Crea skill"
msgstr "Crea skill"

#: src/features/connect/components/CreateSpaceDialog.tsx:222
msgid "Crea spazio"
msgstr "Crea spazio"

#: src/features/report/components/tables.tsx:190
#: src/features/report/components/tables.tsx:219
#: src/features/sources/components/InboxDetailPane.tsx:2182
msgid "Crea task"
msgstr "Crea task"

#: src/features/report/components/tables.tsx:189
msgid "Crea task da questa attività"
msgstr "Crea task da questa attività"

#: src/routes/_authed/workspace/work.tsx:170
msgid "Crea task: "
msgstr "Crea task: "

#: src/features/settings/components/PresentationTemplates.tsx:404
#: src/features/settings/components/PresentationTemplates.tsx:886
#: src/features/templates/components/CreateTemplateDialog.tsx:199
#: src/routes/_authed/workspace/templates/$kind.tsx:139
msgid "Crea template"
msgstr "Crea template"

#: src/features/chat/components/ChatEmptyState.tsx:328
msgid "Crea un canvas per un nuovo progetto."
msgstr "Crea un canvas per un nuovo progetto."

#: src/features/chat/components/ChatEmptyState.tsx:373
msgid "Crea un flow"
msgstr "Crea un flow"

#: src/features/projects/components/sections/AutomationsSection.tsx:249
msgid "Crea un flusso che si attiva su un calendario o un evento e fissalo al progetto: le esecuzioni resteranno scoped qui dentro."
msgstr "Crea un flusso che si attiva su un calendario o un evento e fissalo al progetto: le esecuzioni resteranno scoped qui dentro."

#: src/features/admin/components/AdminOrgs.tsx:1127
msgid "Crea un nuovo tenant B2B. Lo slug è opzionale (verrà generato dal nome se omesso)."
msgstr "Crea un nuovo tenant B2B. Lo slug è opzionale (verrà generato dal nome se omesso)."

#: src/routes/_authed/workspace/work.tsx:445
msgid "Crea un task"
msgstr "Crea un task"

#. placeholder {0}: i18n._(KIND_LABEL[kind])
#: src/features/templates/components/CreateTemplateDialog.tsx:125
msgid "Crea un template {0} personalizzato. La descrizione deve contenere almeno 10 caratteri."
msgstr "Crea un template {0} personalizzato. La descrizione deve contenere almeno 10 caratteri."

#: src/features/console/pages/GetStartedPage.tsx:146
msgid "Crea un’altra AppKey"
msgstr "Crea un’altra AppKey"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:392
msgid "Crea un'app"
msgstr "Crea un'app"

#: src/features/console/components/CommandCenter.tsx:35
msgid "Crea una AppKey"
msgstr "Crea una AppKey"

#: src/features/console/pages/LimitsPage.tsx:134
msgid "Crea una AppKey per vedere i suoi limiti."
msgstr "Crea una AppKey per vedere i suoi limiti."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Crea una AppKey server per questa app e invia una prima richiesta autenticata."
msgstr "Crea una AppKey server per questa app e invia una prima richiesta autenticata."

#: src/features/sales/components/CampaignsPanel.tsx:65
msgid "Crea una campagna con il profilo cliente ideale: Ando trova le aziende, le valuta e prepara le email a freddo."
msgstr "Crea una campagna con il profilo cliente ideale: Ando trova le aziende, le valuta e prepara le email a freddo."

#: src/features/sales/components/CampaignsPanel.tsx:170
msgid "Crea una campagna con il profilo del tuo cliente ideale: Ando cerca le aziende che combaciano, le valuta e prepara le email a freddo."
msgstr "Crea una campagna con il profilo del tuo cliente ideale: Ando cerca le aziende che combaciano, le valuta e prepara le email a freddo."

#: src/features/console/docs/content.ts:273
msgid "Crea una chiave"
msgstr "Crea una chiave"

#: src/features/console/docs/content.ts:85
msgid "Crea una chiave da AppKeys (o via API con scope keys:manage). Il segreto è mostrato una sola volta: salvalo subito in un secret manager. La chiave È il project — nessun parametro project negli endpoint."
msgstr "Crea una chiave da AppKeys (o via API con scope keys:manage). Il segreto è mostrato una sola volta: salvalo subito in un secret manager. La chiave È il project — nessun parametro project negli endpoint."

#: src/features/chat/components/ChatEmptyState.tsx:302
msgid "Crea una nuova dashboard."
msgstr "Crea una nuova dashboard."

#: src/features/connect/components/CreateSpaceDialog.tsx:114
msgid "Crea uno spazio per condividere una porzione del tuo workspace con ospiti esterni. Sceglierai cosa condividere subito dopo."
msgstr "Crea uno spazio per condividere una porzione del tuo workspace con ospiti esterni. Sceglierai cosa condividere subito dopo."

#: src/routes/_authed/workspace/connect.index.tsx:116
msgid "Crea uno spazio per far interrogare ai tuoi ospiti SOLO le fonti che scegli — in sola lettura, senza accedere al resto"
msgstr "Crea uno spazio per far interrogare ai tuoi ospiti SOLO le fonti che scegli — in sola lettura, senza accedere al resto"

#: src/features/settings/components/BrandKitSettings.tsx:846
msgid "Crea voce"
msgstr "Crea voce"

#: src/features/chat/components/ChatEmptyState.tsx:353
msgid "Crea workflow"
msgstr "Crea workflow"

#: src/features/skills/components/SkillsList.tsx:242
msgid "Creane una qui (a mano o con l'AI) — oppure spiega una skill ad Ando in chat e lui la ricorderà per te."
msgstr "Creane una qui (a mano o con l'AI) — oppure spiega una skill ad Ando in chat e lui la ricorderà per te."

#: src/features/admin/components/AdminDecks.tsx:631
#: src/features/admin/components/AdminOrgs.tsx:1045
#: src/features/admin/components/orgs/OrgDetailShell.tsx:411
#: src/features/console/components/KeyMeta.tsx:173
#: src/features/console/pages/KeyDetailPage.tsx:683
msgid "Creata"
msgstr "Creata"

#. placeholder {0}: q.reference
#: src/features/admin/components/AdminCpqList.tsx:29
msgid "Creata la bozza {0}"
msgstr "Creata la bozza {0}"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:384
msgid "Created"
msgstr "Created"

#: src/features/projects/components/ProjectIcon.tsx:72
msgid "Creativo"
msgstr "Creativo"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:130
msgid "creato"
msgstr "creato"

#: src/features/admin/components/AdminCpqList.tsx:167
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:219
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:428
#: src/features/console/pages/FlowDetailPage.tsx:216
#: src/features/console/webhooks/WebhooksPanel.tsx:529
#: src/features/sales/components/crm/ActivityNotesPane.tsx:24
msgid "Creato"
msgstr "Creato"

#: src/features/voice_report/components/NewReportDialog.tsx:791
msgid "Creato dalla tua knowledge"
msgstr "Creato dalla tua knowledge"

#: src/features/admin/components/UserDetailContent.tsx:384
msgid "Creato il"
msgstr "Creato il"

#. placeholder {0}: formatTimestamp(exp.created_at)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:285
msgid "Creato il {0}"
msgstr "Creato il {0}"

#: src/routes/_authed/workspace/flows.index.tsx:168
msgid "Creazione dal modello non riuscita"
msgstr "Creazione dal modello non riuscita"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:90
msgid "Creazione esempio non riuscita."
msgstr "Creazione esempio non riuscita."

#: src/features/admin/components/AdminOrgs.tsx:461
msgid "Creazione fallita"
msgstr "Creazione fallita"

#: src/features/voice_report/components/NewReportDialog.tsx:517
msgid "Creazione fallita. Riprova."
msgstr "Creazione fallita. Riprova."

#: src/features/actions/hooks/useCreateManualAction.ts:87
msgid "Creazione manuale non disponibile: il backend non espone ancora questa azione (riavvia/ricostruisci il backend)."
msgstr "Creazione manuale non disponibile: il backend non espone ancora questa azione (riavvia/ricostruisci il backend)."

#: src/features/admin/components/AdminDecks.tsx:315
#: src/features/admin/components/AdminDecks.tsx:753
#: src/features/admin/components/AdminDemoInviti.tsx:130
#: src/features/console/pages/FlowsPage.tsx:299
#: src/features/console/pages/FlowsPage.tsx:426
#: src/features/sales/hooks/useCrmQueries.ts:120
#: src/features/sales/hooks/useCrmQueries.ts:167
#: src/features/sales/hooks/useCrmQueries.ts:205
#: src/features/settings/components/BrandKitSettings.tsx:171
#: src/routes/_authed/workspace/flows.index.tsx:156
msgid "Creazione non riuscita"
msgstr "Creazione non riuscita"

#: src/features/skills/components/SkillEditor.tsx:213
msgid "Creazione non riuscita. Riprova."
msgstr "Creazione non riuscita. Riprova."

#: src/features/admin/components/AdminPlatformSettings.tsx:462
msgid "Creazione piano fallita"
msgstr "Creazione piano fallita"

#: src/features/settings/components/BrandKitSettings.tsx:766
msgid "Creazione voce non riuscita"
msgstr "Creazione voce non riuscita"

#: src/features/projects/components/NewProjectDialog.tsx:195
msgid "Creazione..."
msgstr "Creazione..."

#: src/features/admin/components/AdminPlatformSettings.tsx:892
#: src/features/automations/components/CreateAutomationDialog.tsx:258
#: src/features/settings/components/BrandKitSettings.tsx:268
#: src/features/settings/components/BrandKitSettings.tsx:846
#: src/features/skills/components/SkillEditor.tsx:454
#: src/features/sources/components/InboxDetailPane.tsx:2182
#: src/features/templates/components/CreateTemplateDialog.tsx:199
#: src/features/voice_report/components/NewReportDialog.tsx:1093
msgid "Creazione…"
msgstr "Creazione…"

#: src/features/console/components/ProviderAccounts.tsx:116
msgid "Credenziale precedente · per elaborazione"
msgstr "Credenziale precedente · per elaborazione"

#: src/features/console/components/ProviderAccounts.tsx:118
msgid "Credenziale salvata"
msgstr "Credenziale salvata"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:247
msgid "Credenziali"
msgstr "Credenziali"

#: src/features/connectors/wizards/crmSpec.tsx:66
msgid "Credenziali (opzionale)"
msgstr "Credenziali (opzionale)"

#: src/features/connectors/wizards/emailSpec.tsx:64
msgid "Credenziali Aruba"
msgstr "Credenziali Aruba"

#: src/features/connectors/wizards/pecSpec.tsx:112
msgid "Credenziali Aruba PEC"
msgstr "Credenziali Aruba PEC"

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:223
msgid "Credenziali della cartella di rete mancanti. Riconnetti la cartella."
msgstr "Credenziali della cartella di rete mancanti. Riconnetti la cartella."

#: src/features/connectors/wizards/pecSpec.tsx:145
msgid "Credenziali InfoCert PEC"
msgstr "Credenziali InfoCert PEC"

#: src/features/console/docs/content.ts:799
msgid "Credenziali read-only; avvia il profiling."
msgstr "Credenziali read-only; avvia il profiling."

#: src/features/billing/components/CreditBalanceCard.tsx:95
msgid "crediti"
msgstr "crediti"

#: src/features/console/pages/BillingPage.tsx:504
#: src/features/console/pages/BillingPage.tsx:507
msgid "Crediti"
msgstr "Crediti"

#: src/routes/_authed/workspace/finance.tsx:413
#: src/routes/_authed/workspace/finance.tsx:1022
#: src/routes/_authed/workspace/finance.tsx:1652
msgid "Crediti aperti"
msgstr "Crediti aperti"

#: src/features/settings/components/BillingSettings.tsx:161
msgid "Crediti e ricariche"
msgstr "Crediti e ricariche"

#: src/features/console/components/ConsoleShell.tsx:816
msgid "Crediti esauriti. Ricarica il wallet per riprendere le chiamate Engine."
msgstr "Crediti esauriti. Ricarica il wallet per riprendere le chiamate Engine."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:205
msgid "Credito assegnato"
msgstr "Credito assegnato"

#: src/features/billing/components/CreditBalanceCard.tsx:75
msgid "Credito disponibile"
msgstr "Credito disponibile"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:262
msgid "Credito esaurito"
msgstr "Credito esaurito"

#. placeholder {0}: tpl.name
#: src/features/hive-flows/components/TemplatesGallery.tsx:52
msgid "Creo \"{0}\"…"
msgstr "Creo \"{0}\"…"

#: src/features/voice_report/components/NewReportDialog.tsx:688
msgid "Creo uno scope sui tuoi documenti, email, chat e memoria."
msgstr "Creo uno scope sui tuoi documenti, email, chat e memoria."

#: src/features/chat/components/MessageBusinessDefinition.tsx:62
msgid "Criterio inviato:"
msgstr "Criterio inviato:"

#: src/features/clean-control/components/EventQueue.tsx:85
msgid "Critica"
msgstr "Critica"

#: src/features/clean-control/utils/labels.ts:46
msgid "CRITICA"
msgstr "CRITICA"

#: src/features/clean-control/utils/labels.ts:35
msgid "Critici"
msgstr "Critici"

#: src/features/console/lib/connectorActions.ts:31
msgid "Critico"
msgstr "Critico"

#: src/features/briefing/BriefCard.tsx:124
#: src/features/chat/components/ConversationCommandPalette.tsx:313
#: src/features/console/connectors/meta.ts:75
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:63
#: src/routes/_authed/workspace/finance.tsx:1211
#: src/routes/_authed/workspace/work.tsx:613
msgid "CRM"
msgstr "CRM"

#: src/features/console/pages/PlaygroundPage.tsx:1312
#: src/features/hive-flows/components/FlowVersionMenu.tsx:81
#: src/features/hive-flows/run/RunHistoryRail.tsx:199
#: src/features/hive-flows/run/RunHistoryRail.tsx:230
msgid "Cronologia"
msgstr "Cronologia"

#: src/features/chat/components/ConversationSidebar.tsx:237
#: src/routes/_authed/route.tsx:796
msgid "Cronologia conversazioni"
msgstr "Cronologia conversazioni"

#. placeholder {0}: mode.name
#: src/features/agent-modes/components/AgentModesList.tsx:401
#: src/features/agent-modes/components/AgentModesList.tsx:416
msgid "Cronologia di {0}"
msgstr "Cronologia di {0}"

#: src/features/hive-flows/run/RunHistoryRail.tsx:192
#: src/features/hive-flows/run/RunHistoryRail.tsx:225
msgid "Cronologia esecuzioni"
msgstr "Cronologia esecuzioni"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:181
msgid "Cronologia immutabile di intent → proposal → action → outcome → policy_change. Ogni evento è linkato a chi ha fatto cosa, quando, per chi. user_id mascherato per default."
msgstr "Cronologia immutabile di intent → proposal → action → outcome → policy_change. Ogni evento è linkato a chi ha fatto cosa, quando, per chi. user_id mascherato per default."

#: src/features/console/pages/DocumentsPage.tsx:503
msgid "Cronologia job"
msgstr "Cronologia job"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:93
msgid "Cronologia messaggi importata"
msgstr "Cronologia messaggi importata"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:200
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:201
msgid "Cronologia messaggi non condivisa"
msgstr "Cronologia messaggi non condivisa"

#: src/features/voice_report/components/RunDiffTimeline.tsx:401
msgid "Cronologia non disponibile"
msgstr "Cronologia non disponibile"

#: src/routes/_authed/workspace/technical.tsx:635
#: src/routes/_authed/workspace/technical.tsx:638
msgid "Cronologia revisioni"
msgstr "Cronologia revisioni"

#: src/features/voice_report/components/RunDiffTimeline.tsx:426
msgid "Cronologia semantica"
msgstr "Cronologia semantica"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:102
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:108
msgid "Cronologia versioni"
msgstr "Cronologia versioni"

#: src/features/sources/components/ArtifactPane.tsx:2032
msgid "Cronologia versioni in arrivo — disponibile a breve."
msgstr "Cronologia versioni in arrivo — disponibile a breve."

#: src/features/dashboard/components/CrossFilterBar.tsx:59
msgid "Cross-filter attivi"
msgstr "Cross-filter attivi"

#: src/features/connectors/wizards/crmSpec.tsx:104
#: src/features/connectors/wizards/projectManagementSpec.tsx:75
msgid "Cross-referencing"
msgstr "Cross-referencing"

#: src/features/connectors/wizards/erpSpec.tsx:197
msgid "Cross-vendor unified"
msgstr "Cross-vendor unified"

#: src/features/admin/components/AdminPlatformSettings.tsx:545
msgid "CRUD piani. <0>Multiplier</0> controlla quanto consumo è incluso, <1>Cost cap</1> il budget chat mensile, <2>Ingestion cap</2> il budget ingestion (clicca <3/> o svuota per illimitato), <4>Storage</4> i GB di knowledge base, <5>Prezzo</5> è per utente."
msgstr "CRUD piani. <0>Multiplier</0> controlla quanto consumo è incluso, <1>Cost cap</1> il budget chat mensile, <2>Ingestion cap</2> il budget ingestion (clicca <3/> o svuota per illimitato), <4>Storage</4> i GB di knowledge base, <5>Prezzo</5> è per utente."

#: src/features/settings/marp/PptxExtractPanel.tsx:197
msgid "CSS generato (anteprima)"
msgstr "CSS generato (anteprima)"

#: src/features/settings/marp/CssUploadPanel.tsx:217
msgid "CSS Marp"
msgstr "CSS Marp"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:91
#: src/routes/_authed/workspace/documents.tsx:1122
msgid "CSV"
msgstr "CSV"

#: src/features/settings/components/DataExport.tsx:115
msgid "CSV (tabellare)"
msgstr "CSV (tabellare)"

#: src/features/admin/components/AdminOrgs.tsx:730
msgid "CSV esportato"
msgstr "CSV esportato"

#: src/features/studio/components/StudioDrawerContent.tsx:355
msgid "Curati da Ando"
msgstr "Curati da Ando"

#: src/features/console/connectors/CustomConnectorDetail.tsx:502
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:431
msgid "cURL"
msgstr "cURL"

#. placeholder {0}: form.cursorParam
#. placeholder {1}: form.cursorResponseField
#: src/features/console/connectors/CustomConnectorDetail.tsx:665
msgid "cursore «{0}» → «{1}»"
msgstr "cursore «{0}» → «{1}»"

#: src/features/admin/components/AdminOrgs.tsx:121
msgid "Custom"
msgstr "Custom"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:89
msgid "Customer Success"
msgstr "Customer Success"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:431
#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:318
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:320
#: src/features/structured-data/components/TemporalQueryControl.tsx:255
msgid "Da"
msgstr "Da"

#. placeholder {0}: source.label
#: src/routes/_authed/workspace/work.tsx:567
msgid "Da {0}"
msgstr "Da {0}"

#. placeholder {0}: p.min_customers
#: src/features/admin/components/AdminCpq.tsx:888
msgid "da {0} clienti"
msgstr "da {0} clienti"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:503
msgid "Da 1 a 60 secondi; vuoto usa il default della piattaforma."
msgstr "Da 1 a 60 secondi; vuoto usa il default della piattaforma."

#: src/features/console/components/ProviderAccounts.tsx:121
msgid "Da aggiornare"
msgstr "Da aggiornare"

#: src/routes/_authed/workspace/work.tsx:288
msgid "Da Ando"
msgstr "Da Ando"

#: src/features/admin/components/AdminAutomation.tsx:147
#: src/features/dfm-rules/components/DfmRulesPage.tsx:396
#: src/features/hive-flows/run/RunHistoryRail.tsx:51
#: src/features/price-lists/components/PriceListsPage.tsx:516
msgid "Da approvare"
msgstr "Da approvare"

#: src/features/admin/components/AdminDemoInviti.tsx:42
msgid "Da attivare"
msgstr "Da attivare"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:102
msgid "Da classificare"
msgstr "Da classificare"

#: src/features/console/pages/ConnectorsPage.tsx:75
msgid "Da collegare"
msgstr "Da collegare"

#: src/features/billing/components/CurrentPlanCard.tsx:56
msgid "Da completare"
msgstr "Da completare"

#: src/features/console/pages/BillingPage.tsx:412
msgid "Da completare su Stripe"
msgstr "Da completare su Stripe"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:19
msgid "Da confermare"
msgstr "Da confermare"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:268
msgid "Da confermare con la fonte"
msgstr "Da confermare con la fonte"

#: src/features/connectors/components/StatusChip.tsx:34
msgid "Da connettere"
msgstr "Da connettere"

#: src/features/workspace/components/QuickAddMenu/types.ts:91
msgid "Da connettori attivi"
msgstr "Da connettori attivi"

#: src/features/sales/components/LeadsPanel.tsx:89
#: src/features/sales/components/SalesOverview.tsx:113
msgid "Da contattare"
msgstr "Da contattare"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:180
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:343
msgid "Da conto"
msgstr "Da conto"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
msgid "da controllare"
msgstr "da controllare"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:68
msgid "Da correggere prima di pubblicare"
msgstr "Da correggere prima di pubblicare"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:171
msgid "Da dove arrivano i dati?"
msgstr "Da dove arrivano i dati?"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:89
#: src/features/connectors/wizards/spreadsheetSpec.tsx:149
msgid "Da Google Drive"
msgstr "Da Google Drive"

#: src/routes/_authed/_modal/settings/help.tsx:82
msgid "Da Impostazioni → Privacy & dati puoi esportare l'archivio completo o richiedere l'eliminazione dell'account. L'eliminazione è irreversibile e propaga su ingestion, embeddings e backup entro 30 giorni."
msgstr "Da Impostazioni → Privacy & dati puoi esportare l'archivio completo o richiedere l'eliminazione dell'account. L'eliminazione è irreversibile e propaga su ingestion, embeddings e backup entro 30 giorni."

#: src/features/sales/components/crm/DealDetailDrawer.tsx:118
msgid "da lead"
msgstr "da lead"

#: src/features/workspace/inbox/utils/inboxSmartViews.ts:65
msgid "Da leggere"
msgstr "Da leggere"

#: src/features/admin/components/AdminEngagement.tsx:135
msgid "Da migliorare"
msgstr "Da migliorare"

#: src/routes/_authed/workspace/finance.tsx:475
msgid "Da monitorare"
msgstr "Da monitorare"

#: src/features/sources/components/CalendarEventPane.tsx:156
msgid "Da non dimenticare"
msgstr "Da non dimenticare"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:95
#: src/features/connectors/wizards/spreadsheetSpec.tsx:155
msgid "Da OneDrive"
msgstr "Da OneDrive"

#: src/features/hive-flows/components/DryRunPanel.tsx:73
msgid "Da ora questo passaggio esegue sempre questa query, senza AI. Salva il flow per confermare."
msgstr "Da ora questo passaggio esegue sempre questa query, senza AI. Salva il flow per confermare."

#: src/features/console/components/StatusBadges.tsx:257
msgid "Da pagare"
msgstr "Da pagare"

#: src/features/sales/components/leadMeta.ts:57
#: src/features/sales/components/SalesOverview.tsx:170
msgid "Da qualificare"
msgstr "Da qualificare"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:645
msgid "Da qui in poi ci pensa la piattaforma: ecco cosa succede adesso."
msgstr "Da qui in poi ci pensa la piattaforma: ecco cosa succede adesso."

#: src/features/onboarding/demoTourSteps.ts:46
msgid "Da qui parli con Ando come a un collega. \"Focus\" sceglie se cercare nei documenti, nei dati strutturati o in entrambi; \"Strumenti\" e \"Ambito\" affinano la ricerca. Prova: «Quali fatture sono scadute?»"
msgstr "Da qui parli con Ando come a un collega. \"Focus\" sceglie se cercare nei documenti, nei dati strutturati o in entrambi; \"Strumenti\" e \"Ambito\" affinano la ricerca. Prova: «Quali fatture sono scadute?»"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:148
#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:178
msgid "Da quotare manualmente"
msgstr "Da quotare manualmente"

#: src/features/report/hooks/useRecommendationActions.ts:72
msgid "Da report Voice-of-X."
msgstr "Da report Voice-of-X."

#: src/features/console/connectors/ConnectionCard.tsx:46
#: src/features/console/pages/EmbeddedIdentityPage.tsx:470
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:193
msgid "Da riautorizzare"
msgstr "Da riautorizzare"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Da ricollegare"
msgstr "Da ricollegare"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:116
msgid "Da rimuovere"
msgstr "Da rimuovere"

#: src/features/clean-control/components/QualityScoreStat.tsx:170
msgid "da rivedere"
msgstr "da rivedere"

#: src/features/actions/components/MessageActionChips.tsx:128
msgid "Da rivedere"
msgstr "Da rivedere"

#: src/features/workspace/components/TaskSimpleRow.tsx:83
msgid "Da scadenza"
msgstr "Da scadenza"

#: src/features/workspace/components/TaskSimpleRow.tsx:82
msgid "Da scadenza · urgente"
msgstr "Da scadenza · urgente"

#: src/features/projects/components/ProjectHub.tsx:525
msgid "Da template"
msgstr "Da template"

#: src/features/admin/components/AdminCpq.tsx:168
msgid "Da validare con il cliente"
msgstr "Da validare con il cliente"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:74
#: src/features/console/connectors/SourceHealthSummary.tsx:8
#: src/features/dfm-rules/components/DfmRulesPage.tsx:77
#: src/features/hive-flows/run/RunHistoryRail.tsx:319
msgid "Da verificare"
msgstr "Da verificare"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:293
msgid "Da:"
msgstr "Da:"

#: src/features/sources/components/EmailThreadMessages.tsx:278
msgid "Da: "
msgstr "Da: "

#: src/features/sales/components/SignaturesManager.tsx:80
msgid "Dai un nome alla firma"
msgstr "Dai un nome alla firma"

#: src/features/console/connectors/PersonalConnectionSync.tsx:222
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:346
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:447
msgid "Dal"
msgstr "Dal"

#. placeholder {0}: fmt(from)
#: src/features/report/components/ReportDateFilter.tsx:94
msgid "Dal {0}"
msgstr "Dal {0}"

#. placeholder {0}: formatItDate(oldest)
#. placeholder {1}: formatItDate(newest)
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:231
msgid "dal {0} al {1}"
msgstr "dal {0} al {1}"

#: src/features/console/pages/DocumentsPage.tsx:827
msgid "Dal connettore"
msgstr "Dal connettore"

#: src/features/console/pages/DocsPage.tsx:588
msgid "Dal get-a-key alla prima risposta agentica."
msgstr "Dal get-a-key alla prima risposta agentica."

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:604
msgid "Dal più alto"
msgstr "Dal più alto"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:607
msgid "Dal più basso"
msgstr "Dal più basso"

#: src/features/console/docs/content.ts:1513
msgid "Dal server della tua app invia provider e return_url HTTPS registrato. Apri authorization_url nel browser dell'utente. Conserva l'id della sessione sul server. L'account resta inattivo fino alla conferma del callback con lo stesso ID utente autenticato."
msgstr "Dal server della tua app invia provider e return_url HTTPS registrato. Apri authorization_url nel browser dell'utente. Conserva l'id della sessione sul server. L'account resta inattivo fino alla conferma del callback con lo stesso ID utente autenticato."

#: src/features/console/docs/content.ts:1505
msgid "Dal server: Bearer AppKey app_user_server e X-Ando-App-User-Id con ID stabile dell'utente autenticato. Non fidarti di un ID fornito dal browser senza verificarne la sessione. Per una nuova app OIDC usa una AppKey app_user_oidc vincolata all'app e X-Ando-End-User-Token; end_user_only resta per integrazioni legacy basate solo sull'issuer. Non inviare la AppKey al browser."
msgstr "Dal server: Bearer AppKey app_user_server e X-Ando-App-User-Id con ID stabile dell'utente autenticato. Non fidarti di un ID fornito dal browser senza verificarne la sessione. Per una nuova app OIDC usa una AppKey app_user_oidc vincolata all'app e X-Ando-End-User-Token; end_user_only resta per integrazioni legacy basate solo sull'issuer. Non inviare la AppKey al browser."

#: src/features/console/docs/content.ts:1380
msgid "Dalla Console collega più account Gmail, Outlook, Google Drive, OneDrive, Teams o Google Chat senza Workspace. Per le chat scegli esplicitamente quali conversazioni indicizzare: senza selezione non parte alcuna sincronizzazione. Ogni account resta privato finché non concedi accesso ai contenuti indicizzati. Puoi testare l'accesso, gestire la sincronizzazione e scollegare l'account. Gli utenti della tua app usano invece un'app registrata e una AppKey server. Aruba/PEC, SharePoint, Notion e Slack non sono disponibili come connessioni private Engine."
msgstr "Dalla Console collega più account Gmail, Outlook, Google Drive, OneDrive, Teams o Google Chat senza Workspace. Per le chat scegli esplicitamente quali conversazioni indicizzare: senza selezione non parte alcuna sincronizzazione. Ogni account resta privato finché non concedi accesso ai contenuti indicizzati. Puoi testare l'accesso, gestire la sincronizzazione e scollegare l'account. Gli utenti della tua app usano invece un'app registrata e una AppKey server. Aruba/PEC, SharePoint, Notion e Slack non sono disponibili come connessioni private Engine."

#: src/routes/_authed/_modal/settings/help.tsx:66
msgid "Dalla spalla utente apri Connettori (o vai su /workspace/integrations). Scegli il vendor, autorizza l'accesso e attendi la prima sincronizzazione. I dati compaiono nelle tab Workspace e diventano citabili in chat."
msgstr "Dalla spalla utente apri Connettori (o vai su /workspace/integrations). Scegli il vendor, autorizza l'accesso e attendi la prima sincronizzazione. I dati compaiono nelle tab Workspace e diventano citabili in chat."

#: src/features/dashboard/components/AddChartDialog.tsx:336
#: src/features/dashboard/components/AddWidgetWizard.tsx:239
msgid "dashboard"
msgstr "dashboard"

#: src/features/dashboard/components/DashboardListSidebar.tsx:388
#: src/routes/_authed/workspace/dashboard.tsx:123
#: src/routes/_authed/workspace/dashboard.tsx:921
#: src/routes/_authed/workspace/dashboard.tsx:922
#: src/routes/_authed/workspace/dashboard.tsx:938
#: src/routes/_authed/workspace/dashboard.tsx:939
#: src/routes/_authed/workspace/dashboard.tsx:966
#: src/routes/_authed/workspace/dashboard.tsx:996
#: src/routes/_authed/workspace/dashboard.tsx:1182
msgid "Dashboard"
msgstr "Dashboard"

#: src/features/connectors/wizards/databaseSpec.tsx:252
msgid "Dashboard automatica"
msgstr "Dashboard automatica"

#: src/features/dashboard/components/ShareDashboardSheet.tsx:250
msgid "Dashboard condivisa con {who}"
msgstr "Dashboard condivisa con {who}"

#: src/features/dashboard/components/AddChartDialog.tsx:573
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:301
msgid "Dashboard di destinazione"
msgstr "Dashboard di destinazione"

#: src/features/admin/components/AdminOverview.tsx:59
msgid "Dashboard di pilotaggio: stickiness, costi, qualità, salute del sistema. I dati sono aggregati per design — apri Inspect Mode per drill-down a livello utente."
msgstr "Dashboard di pilotaggio: stickiness, costi, qualità, salute del sistema. I dati sono aggregati per design — apri Inspect Mode per drill-down a livello utente."

#: src/features/onboarding/sectionGuides.ts:57
msgid "Dashboard e grafici sui tuoi dati strutturati (banca, gestionale, database). Le query sui dati strutturati si lanciano dal pulsante dedicato «Crea un grafico»: scegli la fonte e la query SQL parte da lì, non dalla chat."
msgstr "Dashboard e grafici sui tuoi dati strutturati (banca, gestionale, database). Le query sui dati strutturati si lanciano dal pulsante dedicato «Crea un grafico»: scegli la fonte e la query SQL parte da lì, non dalla chat."

#. placeholder {0}: input.recipient_email
#: src/features/dashboard/components/ShareDashboardSheet.tsx:434
msgid "Dashboard inviata a {0}"
msgstr "Dashboard inviata a {0}"

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:220
msgid "Dashboard vuota"
msgstr "Dashboard vuota"

#: src/features/help/data/changelog.ts:53
msgid "Dashboard: empty state e template picker"
msgstr "Dashboard: empty state e template picker"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:194
#: src/features/admin/components/orgs/OrgBillingTab.tsx:600
#: src/features/projects/components/sections/MemorySection.tsx:60
msgid "Data"
msgstr "Data"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:202
msgid "Data del pagamento"
msgstr "Data del pagamento"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:359
msgid "Data di fine"
msgstr "Data di fine"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:347
msgid "Data di invito (membro non ancora attivo)"
msgstr "Data di invito (membro non ancora attivo)"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:263
msgid "Data di riferimento"
msgstr "Data di riferimento"

#: src/routes/_authed/workspace/finance.tsx:1166
msgid "Data di riferimento dello snapshot"
msgstr "Data di riferimento dello snapshot"

#: src/features/sources/components/InboxDetailPane.tsx:1162
msgid "Data e ora di invio programmato"
msgstr "Data e ora di invio programmato"

#: src/features/sources/components/InboxDetailPane.tsx:1142
msgid "Data e ora…"
msgstr "Data e ora…"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:211
msgid "Data effettiva dell'incasso."
msgstr "Data effettiva dell'incasso."

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:191
#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:66
#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:102
msgid "Data emissione"
msgstr "Data emissione"

#: src/features/admin/components/AdminRangePicker.tsx:190
#: src/features/admin/components/AdminRangePicker.tsx:211
msgid "Data fine"
msgstr "Data fine"

#: src/features/sales/components/FollowUpControl.tsx:90
msgid "Data follow-up"
msgstr "Data follow-up"

#: src/features/admin/components/AdminRangePicker.tsx:186
#: src/features/admin/components/AdminRangePicker.tsx:211
msgid "Data inizio"
msgstr "Data inizio"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:153
msgid "Data pagamento"
msgstr "Data pagamento"

#: src/routes/_authed/workspace/finance.tsx:1161
msgid "Data riferimento"
msgstr "Data riferimento"

#: src/features/chat/hooks/useThinkingHops.ts:51
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:752
#: src/features/connectors/wizards/databaseSpec.tsx:269
#: src/features/console/connectors/meta.ts:174
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:43
msgid "Database"
msgstr "Database"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:509
msgid "Database collegato"
msgstr "Database collegato"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:381
msgid "Database collegato. Analisi dello schema avviata."
msgstr "Database collegato. Analisi dello schema avviata."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:376
msgid "Database creato, ma il test di accesso non è riuscito."
msgstr "Database creato, ma il test di accesso non è riuscito."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:384
msgid "Database creato. Verifica e analisi dello schema vanno completate."
msgstr "Database creato. Verifica e analisi dello schema vanno completate."

#: src/features/console/pages/ConnectorsPage.tsx:160
msgid "Database e sistemi"
msgstr "Database e sistemi"

#: src/features/connectors/wizards/databaseSpec.tsx:149
msgid "Database open-source standard de-facto"
msgstr "Database open-source standard de-facto"

#: src/features/connectors/wizards/databaseSpec.tsx:139
msgid "Database SQL"
msgstr "Database SQL"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:163
#: src/features/voice_report/components/NewReportDialog.tsx:627
#: src/features/voice_report/components/VoiceReportDetailPage.tsx:211
msgid "Dataset"
msgstr "Dataset"

#: src/features/dashboard/utils/calculatedFields.ts:88
msgid "Date"
msgstr "Date"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:307
msgid "Date precise"
msgstr "Date precise"

#: src/features/connectors/components/management/SchemaViewer.tsx:511
#: src/features/dashboard/components/AddWidgetWizard.tsx:73
#: src/features/hive-flows/components/nodeVisuals.tsx:45
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:483
msgid "Dati"
msgstr "Dati"

#: ../../packages/ui/src/ando/chat/ConflictNote.tsx:82
msgid "Dati a confronto"
msgstr "Dati a confronto"

#: src/features/connectors/wizards/sdiSpec.tsx:67
msgid "Dati anagrafici necessari per la trasmissione al SDI."
msgstr "Dati anagrafici necessari per la trasmissione al SDI."

#: src/features/voice_report/components/TemplatesGallery.tsx:313
msgid "Dati di esempio"
msgstr "Dati di esempio"

#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:56
msgid "Dati di test per il trigger"
msgstr "Dati di test per il trigger"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:102
msgid "Dati e accessi spostati nella nuova organizzazione."
msgstr "Dati e accessi spostati nella nuova organizzazione."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Dati in Ando"
msgstr "Dati in Ando"

#: src/routes/_authed/workspace/finance.tsx:481
msgid "dati insufficienti"
msgstr "dati insufficienti"

#: src/features/admin/components/AdminEngagement.tsx:130
msgid "Dati insufficienti"
msgstr "Dati insufficienti"

#: src/routes/_authed/workspace/finance.tsx:863
msgid "Dati insufficienti per il grafico"
msgstr "Dati insufficienti per il grafico"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:116
msgid "Dati personali (PII) — accesso registrato"
msgstr "Dati personali (PII) — accesso registrato"

#: src/features/clean-control/utils/signalCatalog.ts:186
msgid "Dati personali rilevati in un contenuto pubblico."
msgstr "Dati personali rilevati in un contenuto pubblico."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:492
msgid "Dati sensibili (PII medio) — accesso registrato"
msgstr "Dati sensibili (PII medio) — accesso registrato"

#: src/features/console/pages/BillingPage.tsx:422
msgid "Dati sincronizzati dal cliente Stripe dell’organizzazione."
msgstr "Dati sincronizzati dal cliente Stripe dell’organizzazione."

#: src/features/console/pages/ConnectorDetailPage.tsx:64
#: src/features/console/pages/PlaygroundPage.tsx:549
#: src/features/console/pages/PlaygroundPage.tsx:873
msgid "Dati strutturati"
msgstr "Dati strutturati"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:669
msgid "Dati unificati"
msgstr "Dati unificati"

#: src/features/structured-data/components/StructuredDataCard.tsx:71
msgid "Dati verificati"
msgstr "Dati verificati"

#: src/features/admin/components/AdminEngagement.tsx:137
msgid "DAU · oggi"
msgstr "DAU · oggi"

#: src/features/sync/components/picker/NotionPickerModal.tsx:162
msgid "DB"
msgstr "DB"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:728
msgid "db.azienda.local"
msgstr "db.azienda.local"

#: src/routes/_authed/workspace/finance.tsx:1716
msgid "Deal Salesforce in chiusura nei prossimi 30 giorni"
msgstr "Deal Salesforce in chiusura nei prossimi 30 giorni"

#: src/routes/_authed/workspace/finance.tsx:428
#: src/routes/_authed/workspace/finance.tsx:1023
#: src/routes/_authed/workspace/finance.tsx:1677
msgid "Debiti aperti"
msgstr "Debiti aperti"

#: src/features/connectors/wizards/messagingSpec.tsx:94
msgid "Decidi quali canali sincronizzare (privacy granulare)."
msgstr "Decidi quali canali sincronizzare (privacy granulare)."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:375
msgid "Decision"
msgstr "Decision"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:165
#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1510
#: src/features/projects/components/sections/MemorySection.tsx:58
msgid "Decisione"
msgstr "Decisione"

#: src/features/sources/marp/ManualDeckEditMount.tsx:107
#: src/features/sources/marp/SlideDeckProposalMount.tsx:240
msgid "Deck aggiornato"
msgstr "Deck aggiornato"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:237
msgid "Deck creato"
msgstr "Deck creato"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:189
msgid "Dedicato (namespace K8s)"
msgstr "Dedicato (namespace K8s)"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:635
#: src/features/settings/components/PresentationTemplates.tsx:518
#: src/routes/_authed/workspace/dashboard.tsx:1231
msgid "Default"
msgstr "Default"

#: src/features/templates/components/TemplatesList.tsx:262
msgid "DEFAULT"
msgstr "DEFAULT"

#: src/features/admin/components/AdminBilling.tsx:234
msgid "Default globale per i modelli Console, personalizzabile per organizzazione."
msgstr "Default globale per i modelli Console, personalizzabile per organizzazione."

#: src/features/admin/components/AdminPricingMarkup.tsx:50
msgid "Default globale, con eventuale tariffa specifica per organizzazione."
msgstr "Default globale, con eventuale tariffa specifica per organizzazione."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:150
msgid "Default ripristinati."
msgstr "Default ripristinati."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:392
msgid "Definisci come Ando riconosce gli utenti della tua app. Potrai collegare i loro account e gestire gli accessi dopo la creazione."
msgstr "Definisci come Ando riconosce gli utenti della tua app. Potrai collegare i loro account e gestire gli accessi dopo la creazione."

#: src/features/sales/components/CreateCampaignDialog.tsx:69
msgid "Definisci il cliente ideale: Ando potrà poi trovare le aziende che combaciano."
msgstr "Definisci il cliente ideale: Ando potrà poi trovare le aziende che combaciano."

#: src/features/chat/components/MessageBusinessDefinition.tsx:56
msgid "Definisci il criterio"
msgstr "Definisci il criterio"

#: src/features/settings/components/BrandKitSettings.tsx:293
msgid "Definisci la palette del Brand Kit usata su documenti, deck e fogli."
msgstr "Definisci la palette del Brand Kit usata su documenti, deck e fogli."

#. placeholder {0}: i18n._(KIND_LABELS[form.kind])
#: src/features/settings/components/PresentationTemplates.tsx:735
msgid "Definisci nome, descrizione e specifica JSON. Il backend valida lo schema in base al tipo ({0})."
msgstr "Definisci nome, descrizione e specifica JSON. Il backend valida lo schema in base al tipo ({0})."

#: src/features/console/docs/content.ts:1055
msgid "Definisci un'azione che un connettore supporta (name, params_schema JSON, risk). GET /connectors/<slug>/actions elenca; DELETE /connectors/<slug>/actions/<name> rimuove."
msgstr "Definisci un'azione che un connettore supporta (name, params_schema JSON, risk). GET /connectors/<slug>/actions elenca; DELETE /connectors/<slug>/actions/<name> rimuove."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:46
msgid "Delega"
msgstr "Delega"

#: src/features/admin/components/AdminDemoInviti.tsx:186
msgid "Demo invites"
msgstr "Demo invites"

#: src/routes/_authed/_modal/admin/route.tsx:154
msgid "Demo Inviti"
msgstr "Demo Inviti"

#: src/features/dashboard/components/DashboardViewControls.tsx:39
msgid "Densità"
msgstr "Densità"

#: src/features/dashboard/components/DashboardViewControls.tsx:41
msgid "Densità dashboard"
msgstr "Densità dashboard"

#: src/features/hive-flows/run/ProposalReview.tsx:544
#: src/features/hive-flows/run/ProposalReview.tsx:545
msgid "Densità righe"
msgstr "Densità righe"

#: src/features/admin/components/AdminCpqAskAndo.tsx:169
#: src/features/admin/components/AdminCpqCanvas.tsx:152
#: src/features/admin/components/AdminCpqList.tsx:150
#: src/features/admin/components/AdminCpqProposalCopy.tsx:39
msgid "Deploy"
msgstr "Deploy"

#: src/features/admin/components/AdminCpq.tsx:725
msgid "Deploy a regime"
msgstr "Deploy a regime"

#: src/features/admin/components/AdminCpqAskAndo.tsx:181
msgid "Deploy alternativi"
msgstr "Deploy alternativi"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:101
msgid "Deploy infrastruttura partito."
msgstr "Deploy infrastruttura partito."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:159
msgid "Deprecazione del draft. La motivazione sarà registrata nell'audit trail."
msgstr "Deprecazione del draft. La motivazione sarà registrata nell'audit trail."

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:134
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:401
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:446
msgid "Deprovision"
msgstr "Deprovision"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:439
msgid "Deprovision infrastruttura?"
msgstr "Deprovision infrastruttura?"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:445
msgid "Deprovision…"
msgstr "Deprovision…"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:128
msgid "Deprovisionata"
msgstr "Deprovisionata"

#. placeholder {0}: col.name
#: src/features/console/pages/SchemaPage.tsx:348
msgid "Descrivi {0}"
msgstr "Descrivi {0}"

#: src/features/automations/components/CreateAutomationDialog.tsx:163
msgid "Descrivi cosa deve fare Ando e quando — il prompt è l'istruzione naturale che l'agente eseguirà ad ogni run."
msgstr "Descrivi cosa deve fare Ando e quando — il prompt è l'istruzione naturale che l'agente eseguirà ad ogni run."

#: src/features/console/pages/FlowsPage.tsx:491
msgid "Descrivi cosa deve fare il flow"
msgstr "Descrivi cosa deve fare il flow"

#: src/features/connectors/components/management/SchemaViewer.tsx:367
msgid "Descrivi cosa rappresenta questa tabella…"
msgstr "Descrivi cosa rappresenta questa tabella…"

#: src/features/voice_report/components/NewReportDialog.tsx:895
msgid "Descrivi cosa vuoi capire dai dati: domande chiave, segmenti da confrontare, decisioni che il report deve abilitare."
msgstr "Descrivi cosa vuoi capire dai dati: domande chiave, segmenti da confrontare, decisioni che il report deve abilitare."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:258
msgid "Descrivi cosa vuoi vedere"
msgstr "Descrivi cosa vuoi vedere"

#: src/features/connectors/components/management/BusinessContextEditor.tsx:157
msgid "Descrivi i processi di business, il significato delle entità principali e i KPI usati per interrogare i dati…"
msgstr "Descrivi i processi di business, il significato delle entità principali e i KPI usati per interrogare i dati…"

#: src/features/settings/components/PresentationTemplates.tsx:774
msgid "Descrivi il template — viene mostrato nel picker."
msgstr "Descrivi il template — viene mostrato nel picker."

#: src/features/voice_report/components/SettingsTab.tsx:152
msgid "Descrivi in 2-3 frasi cosa il report deve analizzare. Es: \"Quali sono i principali motivi di churn citati dai clienti enterprise nell'ultimo trimestre?\""
msgstr "Descrivi in 2-3 frasi cosa il report deve analizzare. Es: \"Quali sono i principali motivi di churn citati dai clienti enterprise nell'ultimo trimestre?\""

#: src/features/skills/components/SkillEditor.tsx:353
msgid "Descrivi in che situazione Ando deve usarla"
msgstr "Descrivi in che situazione Ando deve usarla"

#: src/features/admin/components/AdminCpqAskAndo.tsx:250
msgid "Descrivi l'offerta: Ando la configura dal listino attivo."
msgstr "Descrivi l'offerta: Ando la configura dal listino attivo."

#: src/features/automations/components/ScheduleEditor.tsx:136
msgid "Descrivi quando far partire il flow"
msgstr "Descrivi quando far partire il flow"

#: src/features/connectors/components/management/SchemaViewer.tsx:464
msgid "Descrivi questa colonna…"
msgstr "Descrivi questa colonna…"

#: src/features/skills/components/SkillEditor.tsx:282
msgid "Descrivila a parole tue e Ando riempie i campi qui sotto."
msgstr "Descrivila a parole tue e Ando riempie i campi qui sotto."

#: src/features/console/pages/FlowsPage.tsx:470
msgid "Descrivilo all'AI: una bozza pronta comparirà nell'elenco."
msgstr "Descrivilo all'AI: una bozza pronta comparirà nell'elenco."

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:269
#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:208
#: src/features/agent-modes/components/AgentModeEditor.tsx:332
#: src/features/automations/components/AutomationDetailSection.tsx:166
#: src/features/connect/components/CreateSpaceDialog.tsx:148
#: src/features/console/connectors/ConnectorActionsPanel.tsx:197
#: src/features/console/connectors/CustomConnectorDetail.tsx:396
#: src/features/console/pages/SchemaPage.tsx:326
#: src/features/price-lists/components/PriceListsPage.tsx:878
#: src/features/sales/components/LeadsPanel.tsx:392
#: src/features/settings/components/PresentationTemplates.tsx:764
#: src/features/settings/marp/CssUploadPanel.tsx:182
#: src/features/templates/components/CreateTemplateDialog.tsx:150
#: src/features/templates/components/TemplateEditor.tsx:230
#: src/routes/_authed/workspace/technical.tsx:602
msgid "Descrizione"
msgstr "Descrizione"

#: src/features/hive-flows/components/FlowFormPublish.tsx:151
msgid "Descrizione (facoltativa)"
msgstr "Descrizione (facoltativa)"

#: src/features/automations/components/CreateAutomationDialog.tsx:200
#: src/features/console/connectors/DeclareConnectorActionModal.tsx:270
msgid "Descrizione (opzionale)"
msgstr "Descrizione (opzionale)"

#: src/features/dashboard/components/AddChartDialog.tsx:524
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:279
msgid "Descrizione <0>(opzionale)</0>"
msgstr "Descrizione <0>(opzionale)</0>"

#: src/features/console/pages/SchemaPage.tsx:224
msgid "Descrizione aggiornata"
msgstr "Descrizione aggiornata"

#. placeholder {0}: column.name
#: src/features/connectors/components/management/SchemaViewer.tsx:457
msgid "Descrizione colonna {0}"
msgstr "Descrizione colonna {0}"

#: src/features/templates/components/TemplateEditor.tsx:239
#: src/routes/_authed/workspace/templates/$kind.tsx:327
msgid "Descrizione del template"
msgstr "Descrizione del template"

#. placeholder {0}: col.name
#. placeholder {0}: object.object
#: src/features/console/pages/SchemaPage.tsx:290
#: src/features/console/pages/SchemaPage.tsx:347
msgid "Descrizione di {0}"
msgstr "Descrizione di {0}"

#: src/features/connectors/components/management/SchemaViewer.tsx:360
msgid "Descrizione tabella"
msgstr "Descrizione tabella"

#: src/features/structured-data/components/SimilarPartsSection.tsx:109
msgid "Descrizione testuale"
msgstr "Descrizione testuale"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:118
msgid "descrizioni AI di tabelle e colonne"
msgstr "descrizioni AI di tabelle e colonne"

#: src/features/console/pages/SchemaPage.tsx:895
msgid "Descrizioni più chiare = risposte più precise. {TRAMA} legge queste descrizioni per capire quali tabelle e colonne interrogare — così l'agente risponde dai tuoi dati invece di approssimarli. Le sorgenti sono interrogabili appena scoperte; qui le rendi più accurate."
msgstr "Descrizioni più chiare = risposte più precise. {TRAMA} legge queste descrizioni per capire quali tabelle e colonne interrogare — così l'agente risponde dai tuoi dati invece di approssimarli. Le sorgenti sono interrogabili appena scoperte; qui le rendi più accurate."

#: src/features/admin/components/AdminCpqCanvas.tsx:274
#: src/features/clean-control/components/EventQueue.tsx:301
#: src/features/sales/components/LeadsPanel.tsx:546
msgid "Deseleziona"
msgstr "Deseleziona"

#. placeholder {0}: node.name
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:723
msgid "Deseleziona {0}"
msgstr "Deseleziona {0}"

#: src/features/admin/components/AdminUsers.tsx:363
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:144
msgid "Deseleziona tutti"
msgstr "Deseleziona tutti"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:160
#: src/features/share/components/ShareLinkDialog.tsx:750
msgid "Destinatari"
msgstr "Destinatari"

#: src/features/sales/components/BatchSendModal.tsx:399
msgid "Destinatari ({count})"
msgstr "Destinatari ({count})"

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:218
msgid "Destinatari nascosti"
msgstr "Destinatari nascosti"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:69
#: src/features/admin/components/AdminCpqCanvas.tsx:192
#: src/features/admin/components/AdminDecks.tsx:713
#: src/features/admin/components/AdminDemoInviti.tsx:220
msgid "Destinatario"
msgstr "Destinatario"

#: src/features/admin/components/AdminDecks.tsx:709
msgid "Destinatario (es. Fondo X, Azienda Y)"
msgstr "Destinatario (es. Fondo X, Azienda Y)"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:523
#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:194
#: src/features/sources/components/InboxDetailPane.tsx:2199
msgid "destinatario@dominio.it"
msgstr "destinatario@dominio.it"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:373
msgid "destinatario@pec.example.it"
msgstr "destinatario@pec.example.it"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:259
msgid "Destinazione di salvataggio"
msgstr "Destinazione di salvataggio"

#. placeholder {0}: selected?.label ?? "—"
#: ../../packages/ui/src/editors/DraftActionBar.tsx:228
msgid "Destinazione di salvataggio (attuale: {0})"
msgstr "Destinazione di salvataggio (attuale: {0})"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:244
msgid "Destinazioni disponibili"
msgstr "Destinazioni disponibili"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1587
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1946
msgid "Destra"
msgstr "Destra"

#: src/features/report/components/NpsPromoterDetractorGrid.tsx:61
msgid "Detrattori"
msgstr "Detrattori"

#: src/features/clean-control/components/EventRow.tsx:320
#: src/features/console/components/CreateKeyWizard.tsx:117
#: src/features/console/connectors/ConnectionCard.tsx:357
#: src/features/console/pages/KeysPage.tsx:230
msgid "Dettagli"
msgstr "Dettagli"

#: src/features/settings/components/AccountDeletion.tsx:147
msgid "Dettagli (opzionale)"
msgstr "Dettagli (opzionale)"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:53
msgid "Dettagli accesso"
msgstr "Dettagli accesso"

#: src/features/clean-control/components/EventRow.tsx:640
msgid "Dettagli caricabili nella side sheet."
msgstr "Dettagli caricabili nella side sheet."

#: src/features/console/connectors/ConnectionCard.tsx:286
msgid "Dettagli della connessione"
msgstr "Dettagli della connessione"

#: src/routes/_authed/workspace/technical.tsx:480
msgid "Dettagli disegno"
msgstr "Dettagli disegno"

#. placeholder {0}: model.contextFields.length
#: src/features/hive-flows/run/ProposalReview.tsx:506
msgid "Dettagli estratti ({0})"
msgstr "Dettagli estratti ({0})"

#: src/features/workspace/components/TaskComposer.tsx:228
msgid "Dettagli opzionali…"
msgstr "Dettagli opzionali…"

#: src/features/projects/components/ProjectDetailPage.tsx:412
msgid "Dettagli progetto in caricamento"
msgstr "Dettagli progetto in caricamento"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:297
#: src/features/clean-control/components/TechnicalDetails.tsx:57
msgid "Dettagli tecnici"
msgstr "Dettagli tecnici"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
msgid "Dettagli utente"
msgstr "Dettagli utente"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:249
msgid "Dettagli widget"
msgstr "Dettagli widget"

#: src/routes/_authed/workspace/technical.tsx:492
msgid "Dettagli, layer, revisioni"
msgstr "Dettagli, layer, revisioni"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:979
#: src/features/sales/components/crm/RecordDrawer.tsx:141
msgid "Dettaglio"
msgstr "Dettaglio"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:306
msgid "Dettaglio account"
msgstr "Dettaglio account"

#: src/features/console/pages/KeyDetailPage.tsx:642
msgid "Dettaglio chiave"
msgstr "Dettaglio chiave"

#: src/features/report/components/CitationViewer.tsx:226
#: src/features/report/components/CitationViewer.tsx:232
msgid "Dettaglio citazione"
msgstr "Dettaglio citazione"

#: src/routes/_authed/workspace/shares.tsx:260
msgid "Dettaglio condivisione"
msgstr "Dettaglio condivisione"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1048
#: src/features/console/pages/ConnectorDetailPage.tsx:354
msgid "Dettaglio connettore"
msgstr "Dettaglio connettore"

#: src/features/console/pages/UsagePage.tsx:521
msgid "Dettaglio consumi giornaliero"
msgstr "Dettaglio consumi giornaliero"

#: src/features/console/pages/TracesPage.tsx:611
msgid "Dettaglio della richiesta"
msgstr "Dettaglio della richiesta"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:193
msgid "Dettaglio distinta"
msgstr "Dettaglio distinta"

#: src/features/clean-control/components/EventDetailSheet.tsx:113
#: src/features/clean-control/components/EventRow.tsx:411
msgid "Dettaglio evento"
msgstr "Dettaglio evento"

#: src/features/clean-control/components/EventDetailSheet.tsx:97
msgid "Dettaglio evento qualità"
msgstr "Dettaglio evento qualità"

#: src/features/console/pages/FlowDetailPage.tsx:172
msgid "Dettaglio flow"
msgstr "Dettaglio flow"

#: src/features/console/pages/UsagePage.tsx:518
msgid "Dettaglio giornaliero"
msgstr "Dettaglio giornaliero"

#: src/features/sales/components/LeadDetailDrawer.tsx:88
msgid "Dettaglio lead"
msgstr "Dettaglio lead"

#: src/features/sources/components/InboxDetailPane.tsx:373
msgid "Dettaglio messaggio"
msgstr "Dettaglio messaggio"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:81
msgid "Dettaglio opportunità"
msgstr "Dettaglio opportunità"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:277
msgid "Dettaglio organizzazione"
msgstr "Dettaglio organizzazione"

#: src/routes/_authed/workspace/finance.tsx:662
msgid "Dettaglio settimanale"
msgstr "Dettaglio settimanale"

#: src/features/admin/components/CostTraceDetailSection.tsx:133
msgid "Dettaglio trace"
msgstr "Dettaglio trace"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:164
msgid "Dettaglio turn"
msgstr "Dettaglio turn"

#: src/features/admin/components/UserDetailDrawer.tsx:80
#: src/features/admin/components/UserDetailDrawer.tsx:86
#: src/features/admin/components/UserDetailShell.tsx:110
#: src/features/admin/components/UserDetailShell.tsx:126
msgid "Dettaglio utente"
msgstr "Dettaglio utente"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:401
msgid "Deve comparire nel campo aud dei token emessi per questa app."
msgstr "Deve comparire nel campo aud dei token emessi per questa app."

#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:81
msgid "Deve essere un indirizzo email vero: è a chi risponderà il flow."
msgstr "Deve essere un indirizzo email vero: è a chi risponderà il flow."

#: src/features/console/connectors/ManifestConfigForm.tsx:183
msgid "Deve iniziare con «/»; viene accodato alla base URL."
msgstr "Deve iniziare con «/»; viene accodato alla base URL."

#: src/features/account/components/UserMenuButton.tsx:411
msgid "Developer Console"
msgstr "Developer Console"

#. placeholder {0}: SOURCE_PROVIDER_LABEL[cloudProvider]
#: src/features/connectors/components/SpreadsheetConnectDialog.tsx:194
msgid "Devi prima collegare {0}"
msgstr "Devi prima collegare {0}"

#. placeholder {0}: formatBytes(usage.storage_limit_bytes)
#. placeholder {0}: formatEur(usage.cost_cap_eur)
#: src/features/admin/components/orgs/OrgBillingTab.tsx:465
#: src/features/admin/components/orgs/OrgBillingTab.tsx:496
msgid "di {0}"
msgstr "di {0}"

#: src/features/sales/components/CampaignsPanel.tsx:271
#: src/features/sales/components/SalesOverview.tsx:358
msgid "di {ownerName}"
msgstr "di {ownerName}"

#: src/routes/connect.chatbot.$publicToken.tsx:132
msgid "di {ownerOrgName}"
msgstr "di {ownerOrgName}"

#: src/features/console/pages/PlaygroundPage.tsx:1102
msgid "Diagnostica"
msgstr "Diagnostica"

#: src/features/console/pages/PlaygroundPage.tsx:1924
msgid "Diagnostica dettagliata"
msgstr "Diagnostica dettagliata"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:572
msgid "Diametro (mm)"
msgstr "Diametro (mm)"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:55
msgid "Diametro foro"
msgstr "Diametro foro"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:594
msgid "Diametro massimo in millimetri"
msgstr "Diametro massimo in millimetri"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:583
msgid "Diametro minimo in millimetri"
msgstr "Diametro minimo in millimetri"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:96
#: src/features/console/connectors/DeclareConnectorActionModal.tsx:218
#: src/features/console/connectors/DeclareConnectorActionModal.tsx:228
msgid "Dichiara azione"
msgstr "Dichiara azione"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:179
msgid "Dichiara la prima azione che il tuo applicativo sa eseguire: nome, schema dei parametri e livello di rischio."
msgstr "Dichiara la prima azione che il tuo applicativo sa eseguire: nome, schema dei parametri e livello di rischio."

#: src/features/console/pages/ActionsPage.tsx:44
msgid "Dichiara le azioni che il tuo applicativo sa eseguire. Ando prepara una proposta e, dopo la conferma richiesta, la invia tramite webhook firmato."
msgstr "Dichiara le azioni che il tuo applicativo sa eseguire. Ando prepara una proposta e, dopo la conferma richiesta, la invia tramite webhook firmato."

#: src/features/console/docs/content.ts:1054
msgid "Dichiara un'azione"
msgstr "Dichiara un'azione"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:71
msgid "Dichiarazioni, registri, comunicazioni — un solo posto."
msgstr "Dichiarazioni, registri, comunicazioni — un solo posto."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1318
msgid "Didascalia"
msgstr "Didascalia"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:187
msgid "Diff"
msgstr "Diff"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:183
msgid "Diff vs corrente"
msgstr "Diff vs corrente"

#: src/features/console/pages/TracesPage.tsx:198
msgid "Differenze di payload"
msgstr "Differenze di payload"

#: src/features/settings/components/OrgMembersPanel.tsx:652
msgid "Digita <0>{REMOVE_CONFIRM_TOKEN}</0> per confermare"
msgstr "Digita <0>{REMOVE_CONFIRM_TOKEN}</0> per confermare"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:405
msgid "Digita email libere e premi Invio per aggiungerle."
msgstr "Digita email libere e premi Invio per aggiungerle."

#: src/features/settings/components/SelfProfileMemory.tsx:623
msgid "Digita la frase esatta per confermare"
msgstr "Digita la frase esatta per confermare"

#: src/features/admin/components/AdminOrgs.tsx:1296
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:168
msgid "Digita lo slug"
msgstr "Digita lo slug"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:234
msgid "Digita una password di esempio per validare la policy attiva prima di comunicarla agli utenti. Nulla viene inviato al server."
msgstr "Digita una password di esempio per validare la policy attiva prima di comunicarla agli utenti. Nulla viene inviato al server."

#: src/features/clean-control/components/EventDetailSheet.tsx:267
#: src/features/console/pages/DocumentsPage.tsx:329
#: src/features/console/pages/DocumentsPage.tsx:765
msgid "Dimensione"
msgstr "Dimensione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1880
msgid "Dimensione %"
msgstr "Dimensione %"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:217
msgid "Dimensione campione"
msgstr "Dimensione campione"

#: src/features/admin/components/AdminUsers.tsx:275
msgid "Dimensione pagina"
msgstr "Dimensione pagina"

#. placeholder {0}: i18n._(DIMENSION_LABEL[dimension])
#: src/features/clean-control/components/policies/PolicyForm.tsx:241
msgid "Dimensione: <0>{0}</0>"
msgstr "Dimensione: <0>{0}</0>"

#: src/features/clean-control/components/DimensionRadar.tsx:171
#: src/features/clean-control/components/DimensionRadar.tsx:174
msgid "Dimensioni DAMA"
msgstr "Dimensioni DAMA"

#: src/features/console/docs/content.ts:1801
msgid "Dimentica il thread e la sua storia (irreversibile)."
msgstr "Dimentica il thread e la sua storia (irreversibile)."

#. placeholder {0}: Math.abs(computedDelta)
#. placeholder {1}: r.suffix ?? ""
#: src/features/report/components/ComparisonGrid.tsx:150
msgid "Diminuzione di {0}{1}"
msgstr "Diminuzione di {0}{1}"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:597
#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:63
msgid "Direzione"
msgstr "Direzione"

#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:65
msgid "Direzione email"
msgstr "Direzione email"

#: src/routes/_authed/_modal/settings/privacy.tsx:37
msgid "diritto d'accesso · diritto all'oblio"
msgstr "diritto d'accesso · diritto all'oblio"

#: src/features/settings/components/SelfProfileMemory.tsx:260
msgid "Diritto separato dall'eliminazione account (GDPR Art. 17): qui cancelli solo i fatti appresi, l'account e le conversazioni restano. Per rimuovere tutto vai su Privacy & dati."
msgstr "Diritto separato dall'eliminazione account (GDPR Art. 17): qui cancelli solo i fatti appresi, l'account e le conversazioni restano. Per rimuovere tutto vai su Privacy & dati."

#: src/features/console/connectors/CustomConnectorsPanel.tsx:350
#: src/features/console/docs/content.ts:780
msgid "Disabilita"
msgstr "Disabilita"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:395
msgid "Disabilita connettore"
msgstr "Disabilita connettore"

#: src/features/console/docs/content.ts:1903
msgid "Disabilita il connettore (non distruttivo)."
msgstr "Disabilita il connettore (non distruttivo)."

#: src/features/templates/components/TemplateFieldSpecs.ts:108
msgid "Disabilita per ridurre dimensioni file PPTX."
msgstr "Disabilita per ridurre dimensioni file PPTX."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:554
msgid "Disabilita per tutti"
msgstr "Disabilita per tutti"

#: src/features/settings/components/SecuritySettings.tsx:187
msgid "Disabilita TOTP"
msgstr "Disabilita TOTP"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:374
msgid "Disabilitare il connettore?"
msgstr "Disabilitare il connettore?"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:537
msgid "Disabilitare in blocco?"
msgstr "Disabilitare in blocco?"

#: src/features/console/connectors/CustomConnectorDetail.tsx:973
#: src/features/console/connectors/CustomConnectorsPanel.tsx:314
#: src/features/console/connectors/CustomConnectorsPanel.tsx:354
msgid "Disabilitato"
msgstr "Disabilitato"

#: src/features/admin/components/AdminOrgs.tsx:1579
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:131
#: src/features/admin/components/orgs/OrgDetailShell.tsx:361
#: src/features/clean-control/components/policies/PolicyRow.tsx:182
#: src/features/connect/components/ChatbotPanel.tsx:177
#: src/features/console/connectors/CustomConnectorDetail.tsx:1007
#: src/features/console/pages/EmbeddedIdentityPage.tsx:435
#: src/features/console/pages/EmbeddedIdentityPage.tsx:454
#: src/features/console/pages/FlowDetailPage.tsx:107
#: src/features/console/pages/FlowsPage.tsx:619
#: src/features/console/webhooks/WebhooksPanel.tsx:600
msgid "Disattiva"
msgstr "Disattiva"

#. placeholder {0}: skill.name
#: src/features/skills/components/SkillsList.tsx:409
msgid "Disattiva «{0}»"
msgstr "Disattiva «{0}»"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:369
msgid "Disattiva app"
msgstr "Disattiva app"

#: src/features/connect/components/ChatbotPanel.tsx:161
msgid "Disattiva chatbot"
msgstr "Disattiva chatbot"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1116
msgid "Disattiva connettore"
msgstr "Disattiva connettore"

#. placeholder {0}: webhook.url
#: src/features/console/webhooks/WebhooksPanel.tsx:588
msgid "Disattiva il webhook {0}"
msgstr "Disattiva il webhook {0}"

#: src/features/console/pages/ModelsPage.tsx:246
msgid "Disattiva profilo"
msgstr "Disattiva profilo"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:608
#: src/features/dfm-rules/components/DfmRulesPage.tsx:609
msgid "Disattiva regola"
msgstr "Disattiva regola"

#: src/features/admin/components/AdminOrgs.tsx:941
msgid "Disattiva selezionate"
msgstr "Disattiva selezionate"

#: src/features/price-lists/components/PriceListsPage.tsx:753
#: src/features/price-lists/components/PriceListsPage.tsx:754
msgid "Disattiva voce"
msgstr "Disattiva voce"

#. placeholder {0}: org.name
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:97
msgid "Disattivare «{0}»?"
msgstr "Disattivare «{0}»?"

#. placeholder {0}: selectedApp.name
#: src/features/console/pages/EmbeddedIdentityPage.tsx:391
msgid "Disattivare {0}?"
msgstr "Disattivare {0}?"

#: src/features/connect/components/ChatbotPanel.tsx:170
msgid "Disattivare il chatbot?"
msgstr "Disattivare il chatbot?"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1102
msgid "Disattivare il connettore?"
msgstr "Disattivare il connettore?"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:369
msgid "Disattivare questa app blocca le sue AppKey e l'accesso dei suoi utenti. Puoi ripetere l'operazione se il provider di login era temporaneamente indisponibile."
msgstr "Disattivare questa app blocca le sue AppKey e l'accesso dei suoi utenti. Puoi ripetere l'operazione se il provider di login era temporaneamente indisponibile."

#: src/features/admin/components/AdminOrgs.tsx:1544
#: src/features/admin/components/orgs/OrgDetailShell.tsx:324
#: src/features/console/pages/EmbeddedIdentityPage.tsx:359
#: src/features/skills/components/SkillsList.tsx:407
msgid "Disattivata"
msgstr "Disattivata"

#: src/features/admin/components/AdminOrgs.tsx:840
#: src/features/admin/components/AdminOrgs.tsx:888
msgid "Disattivate"
msgstr "Disattivate"

#: src/features/settings/components/NotificationPreferences.tsx:474
msgid "Disattivato — abilita il canale Email per impostare il limite."
msgstr "Disattivato — abilita il canale Email per impostare il limite."

#: src/features/admin/components/AdminOrgs.tsx:473
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:76
msgid "Disattivazione fallita"
msgstr "Disattivazione fallita"

#: src/features/admin/components/AdminOrgs.tsx:782
msgid "Disattivazione organizzazioni"
msgstr "Disattivazione organizzazioni"

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:329
msgid "Disco esterno non montato ({first}). Collega il disco e riprova."
msgstr "Disco esterno non montato ({first}). Collega il disco e riprova."

#. placeholder {0}: err instanceof Error ? err.message : i18n._(msg`errore sconosciuto`)
#: src/routes/_authed/_modal/integrations/$capability.tsx:635
msgid "Disconnessione fallita: {0}"
msgstr "Disconnessione fallita: {0}"

#: src/features/account/components/UserMenuButton.tsx:280
#: src/features/console/components/ConsoleShell.tsx:473
msgid "Disconnessione in corso…"
msgstr "Disconnessione in corso…"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:118
msgid "Disconnessione non riuscita"
msgstr "Disconnessione non riuscita"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:329
msgid "Disconnessione…"
msgstr "Disconnessione…"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:339
msgid "Disconnettere WhatsApp Business?"
msgstr "Disconnettere WhatsApp Business?"

#: src/features/connectors/components/ConnectedAccountRow.tsx:504
#: src/features/connectors/components/ConnectedAccountRow.tsx:531
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:332
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:366
msgid "Disconnetti"
msgstr "Disconnetti"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:322
#: src/routes/_authed/workspace/connect.$spaceId.tsx:501
#: src/routes/connect.space.$spaceId.tsx:143
msgid "Discussione"
msgstr "Discussione"

#: src/features/connect/components/ConnectMessageThread.tsx:121
msgid "Discussione dello spazio"
msgstr "Discussione dello spazio"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:288
msgid "Disegna un'area da analizzare"
msgstr "Disegna un'area da analizzare"

#: src/features/workspace/config.ts:398
#: src/routes/_authed/workspace/technical.tsx:241
msgid "Disegni 2D"
msgstr "Disegni 2D"

#: src/features/onboarding/sectionGuides.ts:72
msgid "Disegni 2D/3D, distinte base (BOM) e revisioni tecniche. I dati strutturati dei file CAD si interrogano dal pulsante dedicato del pannello, non dalla chat."
msgstr "Disegni 2D/3D, distinte base (BOM) e revisioni tecniche. I dati strutturati dei file CAD si interrogano dal pulsante dedicato del pannello, non dalla chat."

#: src/features/dxf/components/DxfLeftRail.tsx:191
msgid "Disegni CAD"
msgstr "Disegni CAD"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:293
msgid "Disegni DXF"
msgstr "Disegni DXF"

#: src/features/dxf/components/DxfLeftRail.tsx:80
msgid "Disegni e categorie"
msgstr "Disegni e categorie"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:356
msgid "disegno"
msgstr "disegno"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:39
msgid "Disegno"
msgstr "Disegno"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:487
msgid "Disegno (opzionale)"
msgstr "Disegno (opzionale)"

#. placeholder {0}: selected.filename
#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:360
msgid "Disegno {0}"
msgstr "Disegno {0}"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:117
msgid "Disegno CAD"
msgstr "Disegno CAD"

#: src/features/hive-flows/run/WorkbenchSurface.tsx:168
#: src/features/hive-flows/run/WorkbenchSurface.tsx:174
#: src/features/structured-data/components/CadDataPanel.tsx:259
msgid "Disegno tecnico"
msgstr "Disegno tecnico"

#: src/features/console/docs/content.ts:1136
msgid "Dispaccia l'azione alla tua app via webhook firmato. high/critical richiedono confirm_risk=true; serve un webhook action.requested registrato. La verifica automatica contro la fonte è ancora in preview e non produce oggi un verdetto per questa API."
msgstr "Dispaccia l'azione alla tua app via webhook firmato. high/critical richiedono confirm_risk=true; serve un webhook action.requested registrato. La verifica automatica contro la fonte è ancora in preview e non produce oggi un verdetto per questa API."

#: src/features/dashboard/components/AddChartDialog.tsx:110
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:43
msgid "Dispersione"
msgstr "Dispersione"

#: src/features/admin/components/AdminPlatformSettings.tsx:568
msgid "Display"
msgstr "Display"

#: src/features/admin/components/AdminPlatformSettings.tsx:768
msgid "Display name"
msgstr "Display name"

#. placeholder {0}: plan.display_name
#: src/features/admin/components/AdminPlatformSettings.tsx:615
msgid "Display name del piano {0}"
msgstr "Display name del piano {0}"

#: src/features/admin/components/AdminPlatformSettings.tsx:505
msgid "Display name obbligatorio."
msgstr "Display name obbligatorio."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:122
msgid "Disponibile"
msgstr "Disponibile"

#: src/features/connectors/hooks/useStructuredDataConnectors.ts:80
msgid "Disponibile con TRAMA attuale"
msgstr "Disponibile con TRAMA attuale"

#: src/features/console/pages/ResourceAccessPage.tsx:376
msgid "Disponibile dopo il salvataggio dei contenuti"
msgstr "Disponibile dopo il salvataggio dei contenuti"

#: src/features/onboarding/sectionGuides.ts:79
msgid "Disponibile nella versione completa di Ando. Qui puoi esplorare l'interfaccia per capire come si costruisce un flusso."
msgstr "Disponibile nella versione completa di Ando. Qui puoi esplorare l'interfaccia per capire come si costruisce un flusso."

#: src/features/connectors/wizards/cadLibrarySpec.tsx:103
msgid "Disponibile solo da Ando Desktop"
msgstr "Disponibile solo da Ando Desktop"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:498
msgid "Disponibile solo nell'app desktop."
msgstr "Disponibile solo nell'app desktop."

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:66
msgid "Disponibile sui piani Pro+"
msgstr "Disponibile sui piani Pro+"

#: src/features/dxf/components/DxfEmptyHero.tsx:66
msgid "Distinta"
msgstr "Distinta"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:41
msgid "Distinta (BOM)"
msgstr "Distinta (BOM)"

#: src/features/console/docs/content.ts:1030
msgid "Distinta base (BOM)"
msgstr "Distinta base (BOM)"

#: src/features/console/docs/content.ts:1031
msgid "Distinta base strutturata di un modello CAD ingerito (DXF/STEP/PDF-table federati)."
msgstr "Distinta base strutturata di un modello CAD ingerito (DXF/STEP/PDF-table federati)."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1267
msgid "Distribuisci"
msgstr "Distribuisci"

#: src/features/report/components/charts.tsx:69
msgid "Distribuzione"
msgstr "Distribuzione"

#: src/features/admin/components/AdminRevenue.tsx:100
msgid "Distribuzione clienti"
msgstr "Distribuzione clienti"

#: src/features/clean-control/components/SignalHealthCard.tsx:131
msgid "Distribuzione feedback"
msgstr "Distribuzione feedback"

#: src/features/admin/components/widgets/LatencyHistogram.tsx:106
msgid "Distribuzione latenza per bucket (asse Y log10)"
msgstr "Distribuzione latenza per bucket (asse Y log10)"

#: src/features/report/components/NpsPromoterDetractorGrid.tsx:101
msgid "Distribuzione NPS per bucket"
msgstr "Distribuzione NPS per bucket"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:227
msgid "Distribuzione per tipologia"
msgstr "Distribuzione per tipologia"

#. placeholder {0}: Math.round(pctQuick)
#. placeholder {1}: Math.round(pctStandard)
#. placeholder {2}: Math.round(pctExpert)
#: src/features/billing/components/UsageInsightsCard.tsx:156
msgid "Distribuzione query: {0}% rapide, {1}% standard, {2}% expert"
msgstr "Distribuzione query: {0}% rapide, {1}% standard, {2}% expert"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:441
msgid "Distrugge l'infrastruttura dedicata e riporta l'org alla modalità condivisa. I dati nel database condiviso restano intatti."
msgstr "Distrugge l'infrastruttura dedicata e riporta l'org alla modalità condivisa. I dati nel database condiviso restano intatti."

#: src/features/dashboard/utils/calculatedFields.ts:70
msgid "Divisione (÷)"
msgstr "Divisione (÷)"

#: src/features/templates/components/TemplateFieldSpecs.ts:101
msgid "Diviso (50/50)"
msgstr "Diviso (50/50)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1307
msgid "Divisore"
msgstr "Divisore"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:237
msgid "Dizionario"
msgstr "Dizionario"

#: src/features/console/components/ConsoleShell.tsx:235
msgid "Docs"
msgstr "Docs"

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:353
msgid "Document editing is disabled"
msgstr "Document editing is disabled"

#: src/features/console/docs/content.ts:910
msgid "Document generation"
msgstr "Document generation"

#: src/features/console/pages/DocsPage.tsx:507
msgid "Documentazione"
msgstr "Documentazione"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:411
msgid "Documentazione API"
msgstr "Documentazione API"

#: src/routes/_authed/workspace/work.tsx:617
msgid "documenti"
msgstr "documenti"

#: src/features/briefing/BriefCard.tsx:121
#: src/features/chat/components/ConversationCommandPalette.tsx:314
#: src/features/chat/hooks/useThinkingHops.ts:43
#: src/features/connect/components/GrantManager.tsx:516
#: src/features/connect/components/GrantManager.tsx:556
#: src/features/console/components/ConsoleShell.tsx:214
#: src/features/console/pages/AccessOverviewPage.tsx:211
#: src/features/console/pages/DocumentsPage.tsx:650
#: src/features/console/pages/DocumentsPage.tsx:663
#: src/features/console/pages/OverviewPage.tsx:206
#: src/features/console/pages/PlaygroundPage.tsx:548
#: src/features/console/pages/SchemaPage.tsx:468
#: src/features/console/pages/SchemaPage.tsx:622
#: src/features/onboarding/demoTourSteps.ts:85
#: src/features/workspace/config.ts:99
#: src/features/workspace/config.ts:101
#: src/routes/_authed/workspace/documents.tsx:845
#: src/routes/_authed/workspace/documents.tsx:1199
#: src/routes/_authed/workspace/documents.tsx:1248
msgid "Documenti"
msgstr "Documenti"

#: src/features/console/docs/content.ts:429
msgid "Documenti & ingestion"
msgstr "Documenti & ingestion"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2742
msgid "Documenti allegati"
msgstr "Documenti allegati"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:434
msgid "Documenti candidati"
msgstr "Documenti candidati"

#: src/features/chat/components/ChatTopBar.tsx:227
msgid "Documenti citati"
msgstr "Documenti citati"

#: src/features/connectors/wizards/driveSpec.tsx:49
msgid "Documenti cloud"
msgstr "Documenti cloud"

#: src/features/connectors/wizards/accountingSpec.tsx:130
msgid "Documenti collegati"
msgstr "Documenti collegati"

#: src/features/sources/components/CalendarEventPane.tsx:910
msgid "Documenti correlati"
msgstr "Documenti correlati"

#: src/features/sources/components/CalendarEventPane.tsx:914
msgid "Documenti correlati al meeting"
msgstr "Documenti correlati al meeting"

#: src/features/chat/components/ChatEmptyState.tsx:229
msgid "Documenti da revisionare"
msgstr "Documenti da revisionare"

#: src/features/console/connectors/meta.ts:160
msgid "Documenti e comunicazioni del cassetto fiscale"
msgstr "Documenti e comunicazioni del cassetto fiscale"

#: src/features/projects/components/ProjectDetailPage.tsx:238
msgid "Documenti generati"
msgstr "Documenti generati"

#. placeholder {0}: formatBytes(storage)
#: src/features/billing/components/UsageInsightsCard.tsx:260
msgid "documenti indicizzati · <0>{0}</0> nel cervello"
msgstr "documenti indicizzati · <0>{0}</0> nel cervello"

#. js-lingui-explicit-id
#: src/features/hive-flows/run/ScopedChatPanel.tsx:44
msgid "flow.run.document"
msgstr "documento"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:38
msgid "documento"
msgstr "documento"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:951
#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:105
#: src/features/connect/components/GrantManager.tsx:377
#: src/features/connect/components/GrantManager.tsx:793
#: src/features/connect/components/GrantManager.tsx:972
#: src/features/console/components/accessResourceLabels.ts:49
#: src/features/console/pages/AccessOverviewPage.tsx:297
#: src/features/hive-flows/run/RunDocumentViewer.tsx:95
#: src/features/settings/components/BrandKitSettings.tsx:389
#: src/routes/_authed/workspace/documents.tsx:1224
msgid "Documento"
msgstr "Documento"

#: src/features/console/flows/ConsoleFlowEditor.tsx:215
msgid "Documento caricato, esecuzione avviata"
msgstr "Documento caricato, esecuzione avviata"

#: src/features/source-confirmation/components/SourceConfirmationSurface.tsx:149
msgid "Documento confermato"
msgstr "Documento confermato"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:257
msgid "Documento confermato: {selectedFilename}."
msgstr "Documento confermato: {selectedFilename}."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:258
msgid "Documento confermato."
msgstr "Documento confermato."

#: src/features/actions/components/MessageActionChips.tsx:125
msgid "Documento da rivedere"
msgstr "Documento da rivedere"

#: src/features/sources/components/ArtifactPane.tsx:373
#: src/features/sources/components/ArtifactPane.tsx:374
msgid "Documento modificato altrove — riapri per editare."
msgstr "Documento modificato altrove — riapri per editare."

#: src/features/sources/components/ArtifactPane.tsx:1834
msgid "Documento non disponibile"
msgstr "Documento non disponibile"

#: src/features/clean-control/utils/signalCatalog.ts:133
msgid "Documento obsoleto"
msgstr "Documento obsoleto"

#: src/features/actions/hooks/useActionRouter.ts:170
msgid "Documento pronto"
msgstr "Documento pronto"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1502
msgid "Documento ricevuto"
msgstr "Documento ricevuto"

#: src/features/hive-flows/run/ProposalReview.tsx:273
msgid "Documento rifiutato"
msgstr "Documento rifiutato"

#: src/features/actions/components/MessageActionChips.tsx:132
msgid "Documento salvato"
msgstr "Documento salvato"

#. placeholder {0}: selected.slice(0, 12)
#: src/features/hive-flows/components/DocumentPickerField.tsx:114
msgid "Documento selezionato non nella lista corrente (id: {0}…)."
msgstr "Documento selezionato non nella lista corrente (id: {0}…)."

#: src/features/clean-control/utils/signalCatalog.ts:211
msgid "Documento senza accessi assegnati"
msgstr "Documento senza accessi assegnati"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:87
msgid "Documento senza nome"
msgstr "Documento senza nome"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:88
msgid "Documento Word"
msgstr "Documento Word"

#: src/features/admin/components/AdminEngagement.tsx:37
msgid "Dom"
msgstr "Dom"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:151
msgid "Domanda"
msgstr "Domanda"

#: src/features/report/components/QuestionView.tsx:79
msgid "Domanda {questionNumber}"
msgstr "Domanda {questionNumber}"

#: src/features/admin/components/AdminGatedLinks.tsx:333
msgid "Domanda ad Ando"
msgstr "Domanda ad Ando"

#: src/features/connect/components/ConnectChat.tsx:334
msgid "Domanda allo spazio"
msgstr "Domanda allo spazio"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:71
msgid "Domanda e SQL sono entrambi obbligatori."
msgstr "Domanda e SQL sono entrambi obbligatori."

#: src/features/console/pages/TracesPage.tsx:542
msgid "Domanda o query ID"
msgstr "Domanda o query ID"

#: src/features/report/components/ReportViewer.tsx:124
msgid "Domande"
msgstr "Domande"

#: src/features/admin/components/AdminDecks.tsx:803
msgid "Domande dei lettori"
msgstr "Domande dei lettori"

#: src/features/admin/components/AdminCpq.tsx:1093
msgid "Domande e messaggi dei destinatari"
msgstr "Domande e messaggi dei destinatari"

#: src/routes/_authed/_modal/settings/help.tsx:100
msgid "Domande frequenti"
msgstr "Domande frequenti"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:130
msgid "Domande tipiche con la SQL corretta — usate per guidare il text-to-SQL."
msgstr "Domande tipiche con la SQL corretta — usate per guidare il text-to-SQL."

#: src/features/chat/components/ChatEmptyState.tsx:717
#: src/features/chat/components/ChatEmptyState.tsx:721
msgid "Domande veloci su {tabLabel}"
msgstr "Domande veloci su {tabLabel}"

#: src/features/projects/utils/relativeDate.ts:158
msgid "domani"
msgstr "domani"

#: src/features/workspace/components/NudgeClusterRow.tsx:101
#: src/features/workspace/components/TaskSimpleRow.tsx:254
#: src/routes/_authed/workspace/calendar.tsx:1516
#: src/routes/_authed/workspace/work.tsx:475
#: src/routes/_authed/workspace/work.tsx:477
msgid "Domani"
msgstr "Domani"

#: src/features/workspace/inbox/hooks/useSnoozeStore.ts:191
msgid "Domani (9:00)"
msgstr "Domani (9:00)"

#: src/features/sources/components/InboxDetailPane.tsx:1010
msgid "domani {hh}:{mm}"
msgstr "domani {hh}:{mm}"

#: src/features/sources/components/InboxDetailPane.tsx:1064
msgid "Domani alle 14:00"
msgstr "Domani alle 14:00"

#: src/features/sources/components/InboxDetailPane.tsx:1059
msgid "Domani alle 9:00"
msgstr "Domani alle 9:00"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:82
msgid "domenica"
msgstr "domenica"

#: src/features/sales/components/crm/CompaniesPanel.tsx:103
#: src/features/sales/components/crm/CompaniesPanel.tsx:109
#: src/features/sales/components/crm/CompaniesPanel.tsx:227
#: src/features/sales/components/crm/RecordDrawer.tsx:64
msgid "Dominio"
msgstr "Dominio"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:692
msgid "Dominio (opzionale)"
msgstr "Dominio (opzionale)"

#: src/features/settings/components/OrganizationSettings.tsx:228
msgid "Dominio custom"
msgstr "Dominio custom"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:370
#: ../../packages/ui/src/editors/ReviewRail.tsx:451
msgid "Dopo"
msgstr "Dopo"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:156
msgid "Dopo la sezione"
msgstr "Dopo la sezione"

#: src/features/connect/components/GrantManager.tsx:610
msgid "Dopo questa data l'accesso a questa risorsa si chiude da solo."
msgstr "Dopo questa data l'accesso a questa risorsa si chiude da solo."

#: src/features/admin/components/AdminEngagement.tsx:184
msgid "dormienti → attivi"
msgstr "dormienti → attivi"

#: src/features/sources/components/CalendarEventPane.tsx:513
msgid "Dove"
msgstr "Dove"

#: src/features/console/pages/PlaygroundPage.tsx:1966
#: src/features/console/pages/PlaygroundPage.tsx:1968
msgid "Dove cercare"
msgstr "Dove cercare"

#: src/routes/_authed/workspace/finance.tsx:1551
msgid "Dove hai speso (mese corrente)"
msgstr "Dove hai speso (mese corrente)"

#: src/features/console/pages/UsagePage.tsx:473
msgid "Dove viene usato Engine"
msgstr "Dove viene usato Engine"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:680
msgid "Download del deck"
msgstr "Download del deck"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:114
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:100
msgid "Download diretto"
msgstr "Download diretto"

#: src/features/settings/components/BrandKitSettings.tsx:221
msgid "Download non riuscito"
msgstr "Download non riuscito"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:331
msgid "DRAFT prompt versions in attesa di approvazione"
msgstr "DRAFT prompt versions in attesa di approvazione"

#: src/features/help/data/changelog.ts:42
msgid "Drag handle invisibile tra chat e workspace con snap a preset (30/38/50/62/70%) e memoria per-tab. Switcher visivo in alto a destra per Split / Workspace-led / Focus."
msgstr "Drag handle invisibile tra chat e workspace con snap a preset (30/38/50/62/70%) e memoria per-tab. Switcher visivo in alto a destra per Split / Workspace-led / Focus."

#: src/features/help/data/changelog.ts:36
msgid "Drawer avatar a sinistra, sezione Aiuto con tasti rapidi (⌘/), changelog e help center. Punti d'ingresso unificati per profilo, organizzazione, fatturazione e modi agente."
msgstr "Drawer avatar a sinistra, sezione Aiuto con tasti rapidi (⌘/), changelog e help center. Punti d'ingresso unificati per profilo, organizzazione, fatturazione e modi agente."

#: src/features/admin/components/AdminCostTracking.tsx:307
msgid "Drill-down"
msgstr "Drill-down"

#: src/features/clean-control/components/EventQueue.tsx:97
#: src/features/connectors/wizards/driveSpec.tsx:131
#: src/features/console/components/KeyMeta.tsx:58
#: src/features/console/pages/DocumentsPage.tsx:82
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
#: src/features/console/pages/PlaygroundPage.tsx:1987
#: src/features/workspace/documents/components/SmartSourceChips.tsx:58
msgid "Drive"
msgstr "Drive"

#: src/features/connectors/wizards/driveSpec.tsx:50
msgid "Drive, OneDrive, SharePoint, Notion — file indicizzati e citati"
msgstr "Drive, OneDrive, SharePoint, Notion — file indicizzati e citati"

#: src/routes/_authed/workspace/finance.tsx:466
msgid "DSCR 12 mesi"
msgstr "DSCR 12 mesi"

#: src/features/connectors/wizards/databaseSpec.tsx:234
msgid "DSN o stringa di connessione ODBC completa."
msgstr "DSN o stringa di connessione ODBC completa."

#: src/features/clean-control/utils/signalCatalog.ts:95
msgid "Due o più contenuti con lo stesso hash SHA-256."
msgstr "Due o più contenuti con lo stesso hash SHA-256."

#: src/features/share/components/ShareLinkDialog.tsx:407
msgid "Due righe su cosa contiene"
msgstr "Due righe su cosa contiene"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:667
msgid "Due strade"
msgstr "Due strade"

#: src/features/admin/components/AdminCpq.tsx:507
#: src/features/admin/components/AdminCpqList.tsx:231
#: src/features/admin/components/deckEditor/DeckEditor.tsx:742
#: src/features/automations/components/AutomationsHub.tsx:403
#: src/features/dashboard/components/ChartActionsMenu.tsx:232
#: src/routes/_authed/workspace/flows.index.tsx:436
msgid "Duplica"
msgstr "Duplica"

#. placeholder {0}: automation.name
#. placeholder {0}: q.reference
#: src/features/admin/components/AdminCpqList.tsx:224
#: src/features/automations/components/AutomationsHub.tsx:401
msgid "Duplica {0}"
msgstr "Duplica {0}"

#: src/routes/_authed/workspace/templates/$kind.tsx:342
msgid "Duplica come custom"
msgstr "Duplica come custom"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1479
msgid "Duplica elemento"
msgstr "Duplica elemento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1249
msgid "Duplica la selezione"
msgstr "Duplica la selezione"

#: src/features/hive-flows/components/FlowCanvas.tsx:165
msgid "Duplica nodo"
msgstr "Duplica nodo"

#: src/features/clean-control/utils/signalCatalog.ts:94
msgid "Duplicato esatto (hash identico)"
msgstr "Duplicato esatto (hash identico)"

#: src/features/clean-control/utils/signalCatalog.ts:107
msgid "Duplicato semantico (similarità elevata)"
msgstr "Duplicato semantico (similarità elevata)"

#: src/features/admin/components/AdminCpqList.tsx:32
#: src/routes/_authed/workspace/flows.index.tsx:143
#: src/routes/_authed/workspace/flows.index.tsx:213
msgid "Duplicazione non riuscita"
msgstr "Duplicazione non riuscita"

#: src/features/dashboard/components/DashboardChartCard.tsx:331
msgid "Duplicazione non riuscita."
msgstr "Duplicazione non riuscita."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:239
#: src/features/admin/components/AdminDemoInviti.tsx:226
#: src/features/admin/components/CostTraceDetailSection.tsx:226
#: src/features/console/connectors/CustomConnectorDetail.tsx:151
msgid "Durata"
msgstr "Durata"

#: src/features/admin/components/AdminDemoInviti.tsx:377
msgid "Durata (giorni dall'attivazione)"
msgstr "Durata (giorni dall'attivazione)"

#: src/features/admin/components/AdminDemoInviti.tsx:425
msgid "Durata (giorni)"
msgstr "Durata (giorni)"

#: src/features/admin/components/AdminDemoInviti.tsx:141
msgid "Durata aggiornata"
msgstr "Durata aggiornata"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:270
msgid "Durata della prima fase (mesi)"
msgstr "Durata della prima fase (mesi)"

#: src/features/console/pages/FlowsPage.tsx:212
#: src/features/hive-flows/components/FlowVersionMenu.tsx:100
msgid "Durata media"
msgstr "Durata media"

#: src/features/automations/components/AutomationDetailSection.tsx:146
msgid "Durata:"
msgstr "Durata:"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:66
msgid "DXF, DWG, STEP, IGES indicizzati per ricerca geometrica"
msgstr "DXF, DWG, STEP, IGES indicizzati per ricerca geometrica"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:143
msgid "DXF, DWG, STEP, IGES, STL — tutti accessibili in un'unica chat."
msgstr "DXF, DWG, STEP, IGES, STL — tutti accessibili in un'unica chat."

#: src/features/connectors/wizards/cadLibrarySpec.tsx:85
msgid "DXF, DWG, STEP, IGES, STL dal computer"
msgstr "DXF, DWG, STEP, IGES, STL dal computer"

#: src/features/hive-flows/components/ConditionBuilder.tsx:217
msgid "E"
msgstr "E"

#. placeholder {0}: formatNumber(locale, schemas.object_count - schemas.objects.length)
#: src/features/console/connectors/ConnectionCard.tsx:342
msgid "e altri {0} oggetti"
msgstr "e altri {0} oggetti"

#: src/features/hive-flows/components/ConditionBuilder.tsx:97
msgid "è diverso da"
msgstr "è diverso da"

#: src/features/projects/components/sections/MembersSection.tsx:495
msgid "È già membro del progetto."
msgstr "È già membro del progetto."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:143
msgid "e il contesto di business, che è protetto."
msgstr "e il contesto di business, che è protetto."

#: src/features/hive-flows/components/ConditionBuilder.tsx:98
msgid "è maggiore di"
msgstr "è maggiore di"

#: src/features/hive-flows/components/ConditionBuilder.tsx:99
msgid "è maggiore o uguale a"
msgstr "è maggiore o uguale a"

#: src/features/hive-flows/components/ConditionBuilder.tsx:100
msgid "è minore di"
msgstr "è minore di"

#: src/features/hive-flows/components/ConditionBuilder.tsx:101
msgid "è minore o uguale a"
msgstr "è minore o uguale a"

#: src/features/clean-control/utils/explainEvent.ts:97
msgid "È stata rilevata una partita IVA con formato non valido: controlla che sia corretta."
msgstr "È stata rilevata una partita IVA con formato non valido: controlla che sia corretta."

#: src/features/clean-control/utils/explainEvent.ts:94
msgid "È stato rilevato un codice fiscale con formato non valido: controlla che sia corretto."
msgstr "È stato rilevato un codice fiscale con formato non valido: controlla che sia corretto."

#: src/features/clean-control/utils/explainEvent.ts:100
msgid "È stato rilevato un dato con formato non valido: controlla che sia corretto."
msgstr "È stato rilevato un dato con formato non valido: controlla che sia corretto."

#: src/features/clean-control/utils/explainEvent.ts:91
msgid "È stato rilevato un IBAN con formato non valido: controlla che sia corretto."
msgstr "È stato rilevato un IBAN con formato non valido: controlla che sia corretto."

#: src/features/hive-flows/components/ConditionBuilder.tsx:104
msgid "è tra"
msgstr "è tra"

#: src/features/hive-flows/components/ConditionBuilder.tsx:96
msgid "è uguale a"
msgstr "è uguale a"

#: src/features/sales/components/LeadsPanel.tsx:226
msgid "È un'operazione più lenta e costosa: cerca aziende difficili da trovare con contatti di alto livello. I risultati arrivano fra qualche minuto."
msgstr "È un'operazione più lenta e costosa: cerca aziende difficili da trovare con contatti di alto livello. I risultati arrivano fra qualche minuto."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:88
msgid "E-commerce"
msgstr "E-commerce"

#: src/features/console/pages/DocsPage.tsx:689
msgid "Eccezioni"
msgstr "Eccezioni"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:646
msgid "Ecco i prossimi passi per iniziare a spingere i dati dal tuo applicativo."
msgstr "Ecco i prossimi passi per iniziare a spingere i dati dal tuo applicativo."

#: src/features/admin/components/AdminCostTracking.tsx:322
msgid "Economics"
msgstr "Economics"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:720
msgid "Editabile in PowerPoint, design semplificato"
msgstr "Editabile in PowerPoint, design semplificato"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:528
#: src/features/connect/components/connectShared.tsx:67
#: src/features/projects/components/sections/MembersSection.tsx:70
#: src/features/projects/components/sections/MembersSection.tsx:562
msgid "Editor"
msgstr "Editor"

#: src/features/templates/components/TemplateEditor.tsx:334
msgid "Editor a basso livello: utile per chiavi annidate (es.<0>decorations</0>,<1>slide_layout_overrides</1>) non coperte dal form guidato."
msgstr "Editor a basso livello: utile per chiavi annidate (es.<0>decorations</0>,<1>slide_layout_overrides</1>) non coperte dal form guidato."

#: src/features/projects/components/sections/KnowledgeSection.tsx:234
msgid "Editor completo in arrivo nella Phase 1.5"
msgstr "Editor completo in arrivo nella Phase 1.5"

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:368
msgid "Editor container not ready"
msgstr "Editor container not ready"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:638
msgid "Editor deck"
msgstr "Editor deck"

#: src/features/console/flows/ConsoleFlowEditor.tsx:233
#: src/routes/_authed/workspace/flows.$flowId.tsx:382
msgid "Editor del flow"
msgstr "Editor del flow"

#: src/features/admin/components/PageEditor.tsx:306
msgid "Editor pagina"
msgstr "Editor pagina"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:367
msgid "Editor query SQL"
msgstr "Editor query SQL"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:248
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:680
msgid "Editor SQL"
msgstr "Editor SQL"

#: src/features/dashboard/components/ChartSqlEditor.tsx:107
#: src/features/dashboard/components/ChartSqlEditor.tsx:121
msgid "Editor SQL del grafico"
msgstr "Editor SQL del grafico"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:87
msgid "Editoriale, lead nurturing"
msgstr "Editoriale, lead nurturing"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:259
msgid "Effect size"
msgstr "Effect size"

#. placeholder {0}: member?.effective_storage_gb ?? "—"
#. placeholder {1}: member?.effective_cost_cap_eur ?? "—"
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:328
msgid "Effettivo: storage {0} GB · cost cap €{1}/mese."
msgstr "Effettivo: storage {0} GB · cost cap €{1}/mese."

#: src/features/console/pages/ResourceAccessPage.tsx:467
msgid "Effetto"
msgstr "Effetto"

#: src/features/dxf/utils.ts:189
#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1508
msgid "Elaborazione"
msgstr "Elaborazione"

#: src/features/console/traces/TraceGraph.tsx:53
msgid "Elaborazione (main)"
msgstr "Elaborazione (main)"

#: src/features/console/pages/ModelsPage.tsx:232
msgid "Elaborazione Engine"
msgstr "Elaborazione Engine"

#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:55
msgid "Elaborazione…"
msgstr "Elaborazione…"

#: src/features/console/pages/ModelsPage.tsx:231
msgid "Elaborazioni di supporto dell’agente Engine"
msgstr "Elaborazioni di supporto dell’agente Engine"

#: src/features/console/connectors/ConnectionCard.tsx:262
msgid "Elementi"
msgstr "Elementi"

#. placeholder {0}: offset + (children.length ? 1 : 0)
#. placeholder {1}: offset + children.length
#. placeholder {2}: page?.total_children ?? "—"
#: src/features/console/traces/TracePayloadReader.tsx:113
msgid "Elementi {0}–{1} di {2}"
msgstr "Elementi {0}–{1} di {2}"

#. placeholder {0}: offset + 1
#. placeholder {1}: entries.length
#: src/features/console/traces/TraceJsonTree.tsx:103
msgid "Elementi {0}–{end} di {1}"
msgstr "Elementi {0}–{end} di {1}"

#: src/features/hive-flows/run/SimilarItemsStrip.tsx:106
msgid "Elementi simili"
msgstr "Elementi simili"

#: src/features/hive-flows/run/SimilarItemsStrip.tsx:101
msgid "Elementi simili trovati"
msgstr "Elementi simili trovati"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:61
msgid "elemento"
msgstr "elemento"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:332
#: src/features/hive-flows/run/ReferencePane.tsx:162
msgid "Elemento"
msgstr "Elemento"

#: src/features/active-context/components/AmbientContextChips.tsx:77
msgid "Elemento aperto"
msgstr "Elemento aperto"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1219
msgid "Elemento copiato: incollalo con Cmd+V su una slide libera"
msgstr "Elemento copiato: incollalo con Cmd+V su una slide libera"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:890
msgid "Elemento selezionato"
msgstr "Elemento selezionato"

#: src/features/console/docs/content.ts:707
msgid "Elenca / dettaglio"
msgstr "Elenca / dettaglio"

#: src/features/console/docs/content.ts:880
msgid "Elenca / rimuovi"
msgstr "Elenca / rimuovi"

#: src/features/console/docs/content.ts:1453
msgid "Elenca chat personali e di gruppo accessibili con Chat.Read, non i canali. Richiede un account Microsoft aziendale o scolastico."
msgstr "Elenca chat personali e di gruppo accessibili con Chat.Read, non i canali. Richiede un account Microsoft aziendale o scolastico."

#: src/features/console/pages/DevelopersPage.tsx:60
msgid "Elenca cosa può cercare il progetto: origini indicizzate, connettori attivi e permessi della chiave."
msgstr "Elenca cosa può cercare il progetto: origini indicizzate, connettori attivi e permessi della chiave."

#: src/features/console/docs/content.ts:1434
msgid "Elenca file e cartelle accessibili, con paginazione. Passa folder_id per entrare in una cartella."
msgstr "Elenca file e cartelle accessibili, con paginazione. Passa folder_id per entrare in una cartella."

#: src/features/console/docs/content.ts:1538
msgid "Elenca i grant personali"
msgstr "Elenca i grant personali"

#: src/features/console/docs/content.ts:1405
msgid "Elenca i miei account"
msgstr "Elenca i miei account"

#: src/features/console/pages/DevelopersPage.tsx:70
msgid "Elenca le azioni consentite dai connettori, con i parametri richiesti e il livello di rischio (scope actions:read)."
msgstr "Elenca le azioni consentite dai connettori, con i parametri richiesti e il livello di rischio (scope actions:read)."

#: src/features/console/docs/content.ts:1453
msgid "Elenca le chat Teams"
msgstr "Elenca le chat Teams"

#: src/features/console/docs/content.ts:303
msgid "Elenca le chiavi"
msgstr "Elenca le chiavi"

#: src/features/console/docs/content.ts:531
msgid "Elenca le conversazioni"
msgstr "Elenca le conversazioni"

#: src/routes/_authed/route.tsx:1132
msgid "elenca le fonti correlate all'ultima risposta"
msgstr "elenca le fonti correlate all'ultima risposta"

#: src/features/console/docs/content.ts:1405
msgid "Elenca solo gli account collegati dal membro Console autenticato."
msgstr "Elenca solo gli account collegati dal membro Console autenticato."

#: src/features/console/pages/PlaygroundPage.tsx:2006
msgid "Elenco account non disponibile. Puoi ancora cercare per tipo di fonte."
msgstr "Elenco account non disponibile. Puoi ancora cercare per tipo di fonte."

#: src/features/console/pages/KeysPage.tsx:107
msgid "Elenco AppKeys"
msgstr "Elenco AppKeys"

#: src/features/console/pages/TracesPage.tsx:387
msgid "Elenco completo degli eventi"
msgstr "Elenco completo degli eventi"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:252
msgid "Elenco connettori personalizzati"
msgstr "Elenco connettori personalizzati"

#: src/features/dashboard/components/DashboardListSidebar.tsx:379
#: src/features/dashboard/components/DashboardViewControls.tsx:59
#: src/features/dashboard/components/DashboardViewControls.tsx:60
#: src/features/dashboard/components/DashboardViewControls.tsx:70
msgid "Elenco dashboard"
msgstr "Elenco dashboard"

#: src/features/console/pages/FlowsPage.tsx:807
msgid "Elenco dei flow"
msgstr "Elenco dei flow"

#: src/features/skills/components/SkillsList.tsx:188
msgid "Elenco delle skill salvate"
msgstr "Elenco delle skill salvate"

#: src/features/console/pages/DocumentsPage.tsx:745
msgid "Elenco documenti"
msgstr "Elenco documenti"

#: src/features/console/pages/MembersPage.tsx:605
msgid "Elenco inviti in sospeso"
msgstr "Elenco inviti in sospeso"

#: src/features/console/pages/MembersPage.tsx:494
msgid "Elenco membri"
msgstr "Elenco membri"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:873
msgid "Elenco numerato"
msgstr "Elenco numerato"

#: src/features/console/docs/content.ts:1353
msgid "Elenco paginato delle identità già attive in Ando per questa app, con stato e salute aggregata delle connessioni. Non restituisce contenuti né account provider. Gli utenti della app non sono membri del Team Console."
msgstr "Elenco paginato delle identità già attive in Ando per questa app, con stato e salute aggregata delle connessioni. Non restituisce contenuti né account provider. Gli utenti della app non sono membri del Team Console."

#: src/features/console/docs/content.ts:1371
msgid "Elenco paginato delle identità per un issuer OIDC registrato, isolato dagli altri issuer. La Console offre anche la revoca per ciascun utente."
msgstr "Elenco paginato delle identità per un issuer OIDC registrato, isolato dagli altri issuer. La Console offre anche la revoca per ciascun utente."

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:870
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1898
msgid "Elenco puntato"
msgstr "Elenco puntato"

#: src/features/console/connectors/CustomConnectorDetail.tsx:651
msgid "Elenco record"
msgstr "Elenco record"

#: src/features/console/webhooks/WebhooksPanel.tsx:519
msgid "Elenco webhook"
msgstr "Elenco webhook"

#: src/features/price-lists/utils/formatItem.ts:37
msgid "Elettronica"
msgstr "Elettronica"

#: src/features/clean-control/utils/labels.ts:36
msgid "Elevati"
msgstr "Elevati"

#: src/features/admin/components/UserDetailContent.tsx:145
msgid "Elevation requested · reason: {reason}"
msgstr "Elevation requested · reason: {reason}"

#: src/features/admin/components/UserDetailContent.tsx:857
msgid "Elevation richiesta"
msgstr "Elevation richiesta"

#: src/features/admin/components/AdminPlatformSettings.tsx:718
#: src/features/admin/components/orgs/OrgMembersTab.tsx:293
#: src/features/admin/components/orgs/OrgMembersTab.tsx:628
#: src/features/agent-modes/components/AgentModesList.tsx:369
#: src/features/automations/components/AutomationsHub.tsx:413
#: src/features/automations/components/AutomationsHub.tsx:421
#: src/features/chat/components/ConversationSidebar.tsx:1183
#: src/features/connectors/components/management/ChatExamplesManager.tsx:268
#: src/features/console/connectors/ConnectorActionsPanel.tsx:258
#: src/features/console/pages/DocumentsPage.tsx:950
#: src/features/console/pages/FlowsPage.tsx:631
#: src/features/console/pages/FlowsPage.tsx:1003
#: src/features/console/webhooks/WebhooksPanel.tsx:641
#: src/features/dashboard/components/ChartActionsMenu.tsx:265
#: src/features/dashboard/components/DashboardListSidebar.tsx:353
#: src/features/dxf/components/DxfActionsMenu.tsx:55
#: src/features/dxf/components/DxfActionsMenu.tsx:142
#: src/features/projects/components/sections/TasksSection.tsx:161
#: src/features/sales/components/ActivityTimeline.tsx:220
#: src/features/sales/components/ActivityTimeline.tsx:284
#: src/features/sales/components/SignaturesManager.tsx:222
#: src/features/settings/components/BrandKitSettings.tsx:803
#: src/features/settings/components/PresentationTemplates.tsx:332
#: src/features/skills/components/SkillsList.tsx:333
#: src/features/skills/components/SkillsList.tsx:465
#: src/features/sources/components/CalendarEventPane.tsx:747
#: src/features/templates/components/TemplateEditor.tsx:471
#: src/features/workspace/documents/components/BulkActionBar.tsx:77
#: src/features/workspace/documents/components/BulkActionBar.tsx:110
#: src/features/workspace/documents/components/DocumentCardV2.tsx:323
#: src/routes/_authed/workspace/documents.tsx:624
#: src/routes/_authed/workspace/flows.index.tsx:457
#: src/routes/_authed/workspace/templates/$kind.tsx:353
#: src/routes/_authed/workspace/templates/$kind.tsx:420
msgid "Elimina"
msgstr "Elimina"

#. placeholder {0}: hardDeleteTarget?.name
#. placeholder {0}: org.name
#: src/features/admin/components/AdminOrgs.tsx:1285
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:118
msgid "Elimina «{0}»?"
msgstr "Elimina «{0}»?"

#. placeholder {0}: automation.name
#. placeholder {0}: doc.name
#. placeholder {0}: mode.name
#: src/features/agent-modes/components/AgentModesList.tsx:428
#: src/features/automations/components/AutomationsHub.tsx:419
#: src/features/console/pages/DocumentsPage.tsx:861
#: src/features/sales/components/SignaturesManager.tsx:221
#: src/features/sales/components/TemplateManager.tsx:216
#: src/features/settings/components/PresentationTemplates.tsx:554
msgid "Elimina {0}"
msgstr "Elimina {0}"

#. placeholder {0}: filesToDelete.length
#: src/routes/_authed/workspace/documents.tsx:671
msgid "Elimina {0} file"
msgstr "Elimina {0} file"

#. placeholder {0}: task.title
#: src/features/projects/components/sections/TasksSection.tsx:160
msgid "Elimina attività: {0}"
msgstr "Elimina attività: {0}"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:327
msgid "Elimina azione"
msgstr "Elimina azione"

#. placeholder {0}: sub.name
#. placeholder {1}: sub.cumulative_count
#: src/features/workspace/documents/components/FolderBrowserView.tsx:274
msgid "Elimina cartella {0} ({1} file)"
msgstr "Elimina cartella {0} ({1} file)"

#: src/features/dashboard/components/DashboardListSidebar.tsx:455
#: src/features/dashboard/components/DashboardListSidebar.tsx:458
#: src/features/dashboard/components/DashboardListSidebar.tsx:490
msgid "Elimina dashboard"
msgstr "Elimina dashboard"

#: src/features/admin/components/AdminOrgs.tsx:1339
#: src/features/admin/components/AdminOrgs.tsx:1595
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:203
#: src/features/admin/components/orgs/OrgDetailShell.tsx:376
#: src/features/settings/components/AccountDeletion.tsx:217
#: src/features/sources/components/CalendarEventPane.tsx:722
msgid "Elimina definitivamente"
msgstr "Elimina definitivamente"

#: src/features/settings/components/AccountDeletion.tsx:213
msgid "Elimina definitivamente il mio account"
msgstr "Elimina definitivamente il mio account"

#: src/features/sources/components/CalendarEventPane.tsx:714
msgid "Elimina definitivamente l'evento"
msgstr "Elimina definitivamente l'evento"

#: src/features/console/pages/DocumentsPage.tsx:362
msgid "Elimina documento"
msgstr "Elimina documento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1491
msgid "Elimina elemento"
msgstr "Elimina elemento"

#. placeholder {0}: ex.question
#: src/features/connectors/components/management/ChatExamplesManager.tsx:252
msgid "Elimina esempio: {0}"
msgstr "Elimina esempio: {0}"

#: src/features/sources/components/CalendarEventPane.tsx:742
msgid "Elimina evento"
msgstr "Elimina evento"

#: src/features/dashboard/components/ChartActionsMenu.tsx:277
msgid "Elimina grafico"
msgstr "Elimina grafico"

#: src/features/console/docs/content.ts:481
msgid "Elimina il documento"
msgstr "Elimina il documento"

#. placeholder {0}: webhook.url
#: src/features/console/webhooks/WebhooksPanel.tsx:632
msgid "Elimina il webhook {0}"
msgstr "Elimina il webhook {0}"

#. placeholder {0}: action.name
#: src/features/console/connectors/ConnectorActionsPanel.tsx:249
msgid "Elimina l'azione {0}"
msgstr "Elimina l'azione {0}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1255
msgid "Elimina la selezione"
msgstr "Elimina la selezione"

#: src/features/hive-flows/components/FlowCanvas.tsx:167
msgid "Elimina nodo"
msgstr "Elimina nodo"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:115
msgid "Elimina nota"
msgstr "Elimina nota"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:259
msgid "Elimina opportunità"
msgstr "Elimina opportunità"

#: src/features/admin/components/AdminOrgs.tsx:1282
msgid "Elimina organizzazione"
msgstr "Elimina organizzazione"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:94
msgid "Elimina paragrafo"
msgstr "Elimina paragrafo"

#: src/features/admin/components/AdminPlatformSettings.tsx:707
msgid "Elimina piano"
msgstr "Elimina piano"

#. placeholder {0}: plan.display_name
#: src/features/admin/components/AdminPlatformSettings.tsx:662
msgid "Elimina piano {0}"
msgstr "Elimina piano {0}"

#. placeholder {0}: p.preset_name
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:401
msgid "Elimina preset {0}"
msgstr "Elimina preset {0}"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:603
msgid ""
"Elimina questa regola?\n"
"\n"
"\"{excerpt}\""
msgstr ""
"Elimina questa regola?\n"
"\n"
"\"{excerpt}\""

#: src/features/price-lists/components/PriceListsPage.tsx:746
msgid ""
"Elimina questa voce?\n"
"\n"
"\"{preview}\""
msgstr ""
"Elimina questa voce?\n"
"\n"
"\"{preview}\""

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:101
msgid "Elimina riga"
msgstr "Elimina riga"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:106
#: src/features/admin/components/deckEditor/DeckEditor.tsx:748
msgid "Elimina slide"
msgstr "Elimina slide"

#: src/features/templates/components/TemplateEditor.tsx:394
msgid "Elimina template"
msgstr "Elimina template"

#. placeholder {0}: row.slug
#: src/features/settings/marp/CssUploadPanel.tsx:294
msgid "Elimina template {0}"
msgstr "Elimina template {0}"

#: src/features/chat/components/ConversationSidebar.tsx:589
msgid "Elimina tutte"
msgstr "Elimina tutte"

#: src/features/chat/components/ConversationSidebar.tsx:848
msgid "Elimina tutte ({count})"
msgstr "Elimina tutte ({count})"

#: src/features/chat/components/ConversationSidebar.tsx:837
msgid "Elimina tutte le chat ({count})"
msgstr "Elimina tutte le chat ({count})"

#: src/features/settings/components/SelfProfileMemory.tsx:572
msgid "Elimina tutti i fatti appresi da Ando. È distinto dalla cancellazione account (che elimina tutto). L'operazione non è reversibile."
msgstr "Elimina tutti i fatti appresi da Ando. È distinto dalla cancellazione account (che elimina tutto). L'operazione non è reversibile."

#: src/features/console/webhooks/WebhooksPanel.tsx:751
msgid "Elimina webhook"
msgstr "Elimina webhook"

#. placeholder {0}: automation.name
#. placeholder {0}: doc.title || doc.filename
#: src/features/automations/components/AutomationsHub.tsx:411
#: src/routes/_authed/workspace/documents.tsx:620
msgid "Eliminare \"{0}\"?"
msgstr "Eliminare \"{0}\"?"

#. placeholder {0}: deleteCandidate.name
#: src/features/skills/components/SkillsList.tsx:309
msgid "Eliminare «{0}»?"
msgstr "Eliminare «{0}»?"

#. placeholder {0}: file.filename
#: src/features/dxf/components/DxfActionsMenu.tsx:53
msgid "Eliminare {0}?"
msgstr "Eliminare {0}?"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:613
msgid "Eliminare i membri selezionati?"
msgstr "Eliminare i membri selezionati?"

#: src/features/console/pages/DocumentsPage.tsx:924
msgid "Eliminare il documento?"
msgstr "Eliminare il documento?"

#. placeholder {0}: flow.name
#: src/routes/_authed/workspace/flows.index.tsx:110
msgid "Eliminare il flow «{0}»? L'azione non è reversibile."
msgstr "Eliminare il flow «{0}»? L'azione non è reversibile."

#: src/features/console/pages/FlowsPage.tsx:977
msgid "Eliminare il flow?"
msgstr "Eliminare il flow?"

#: src/features/agent-modes/components/AgentModesList.tsx:335
msgid "Eliminare il modo?"
msgstr "Eliminare il modo?"

#: src/features/settings/components/PresentationTemplates.tsx:292
#: src/features/templates/components/TemplateEditor.tsx:449
#: src/routes/_authed/workspace/templates/$kind.tsx:398
msgid "Eliminare il template?"
msgstr "Eliminare il template?"

#: src/features/console/webhooks/WebhooksPanel.tsx:731
msgid "Eliminare il webhook?"
msgstr "Eliminare il webhook?"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:306
msgid "Eliminare l'azione?"
msgstr "Eliminare l'azione?"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:260
msgid "Eliminare l'esempio?"
msgstr "Eliminare l'esempio?"

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:667
msgid "Eliminare la cartella \"{0}\"?"
msgstr "Eliminare la cartella \"{0}\"?"

#: src/features/sales/components/ActivityTimeline.tsx:218
msgid "Eliminare la nota?"
msgstr "Eliminare la nota?"

#: src/features/skills/components/SkillsList.tsx:310
msgid "Eliminare la skill?"
msgstr "Eliminare la skill?"

#: src/features/chat/components/ConversationSidebar.tsx:585
msgid "Eliminare tutte le chat?"
msgstr "Eliminare tutte le chat?"

#: src/features/sources/components/AISummaryPanel.tsx:681
msgid "Eliminazione"
msgstr "Eliminazione"

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:683
msgid "Eliminazione cartella \"{0}\""
msgstr "Eliminazione cartella \"{0}\""

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:711
msgid "Eliminazione cartella \"{0}\" fallita"
msgstr "Eliminazione cartella \"{0}\" fallita"

#: src/features/admin/components/AdminOrgs.tsx:518
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:102
msgid "Eliminazione fallita"
msgstr "Eliminazione fallita"

#: src/features/settings/components/AccountDeletion.tsx:216
msgid "Eliminazione in corso…"
msgstr "Eliminazione in corso…"

#: src/features/sales/components/ActivityTimeline.tsx:225
#: src/features/sales/components/SignaturesManager.tsx:110
#: src/features/sales/components/TemplateManager.tsx:159
#: src/features/sales/hooks/useCrmQueries.ts:145
#: src/features/sales/hooks/useCrmQueries.ts:259
#: src/features/settings/components/BrandKitSettings.tsx:775
#: src/routes/_authed/workspace/flows.index.tsx:115
msgid "Eliminazione non riuscita"
msgstr "Eliminazione non riuscita"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:105
#: src/features/dashboard/components/DashboardChartCard.tsx:340
msgid "Eliminazione non riuscita."
msgstr "Eliminazione non riuscita."

#: src/features/skills/components/SkillsList.tsx:148
msgid "Eliminazione non riuscita. Riprova."
msgstr "Eliminazione non riuscita. Riprova."

#: src/features/admin/components/AdminPlatformSettings.tsx:475
msgid "Eliminazione piano fallita"
msgstr "Eliminazione piano fallita"

#: src/features/agent-modes/components/AgentModesList.tsx:369
#: src/features/console/pages/DocumentsPage.tsx:950
#: src/features/console/pages/FlowsPage.tsx:1003
#: src/features/settings/components/PresentationTemplates.tsx:331
#: src/features/skills/components/SkillsList.tsx:333
#: src/features/workspace/documents/components/DocumentCardV2.tsx:256
#: src/routes/_authed/workspace/templates/$kind.tsx:420
msgid "Eliminazione…"
msgstr "Eliminazione…"

#: src/features/sources/components/CalendarEventPane.tsx:720
msgid "Elimino…"
msgstr "Elimino…"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1981
msgid "Ellisse"
msgstr "Ellisse"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:39
#: src/routes/_authed/workspace/work.tsx:609
msgid "email"
msgstr "email"

#: src/features/admin/components/AdminOrgs.tsx:1368
#: src/features/admin/components/orgs/AddMemberDialog.tsx:181
#: src/features/admin/components/orgs/OrgBillingTab.tsx:541
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:234
#: src/features/admin/components/UserDetailContent.tsx:380
#: src/features/admin/components/UserDetailContent.tsx:821
#: src/features/auth/desktop/DesktopLoginForm.tsx:564
#: src/features/chat/hooks/useThinkingHops.ts:42
#: src/features/clean-control/components/EventQueue.tsx:98
#: src/features/console/components/KeyMeta.tsx:59
#: src/features/console/connectors/meta.ts:129
#: src/features/console/pages/DocumentsPage.tsx:81
#: src/features/console/pages/EmbeddedIdentityPage.tsx:161
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
#: src/features/console/pages/MembersPage.tsx:237
#: src/features/console/pages/MembersPage.tsx:609
#: src/features/console/pages/PlaygroundPage.tsx:1986
#: src/features/dashboard/components/ShareChartSheet.tsx:119
#: src/features/dashboard/components/ShareDashboardSheet.tsx:112
#: src/features/sales/components/CreateLeadDialog.tsx:192
#: src/features/sales/components/CreateLeadDialog.tsx:199
#: src/features/sales/components/crm/ContactsPanel.tsx:105
#: src/features/sales/components/crm/ContactsPanel.tsx:112
#: src/features/sales/components/crm/ContactsPanel.tsx:236
#: src/features/sales/components/crm/EmailMiniList.tsx:51
#: src/features/sales/components/crm/RecordDrawer.tsx:58
#: src/features/settings/components/NotificationPreferences.tsx:419
#: src/features/settings/components/OrgMembersPanel.tsx:531
#: src/features/settings/components/ProfileSettings.tsx:114
#: src/features/share/components/ShareLinkDialog.tsx:284
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:238
#: src/features/workspace/config.ts:334
#: src/routes/_authed/workspace/conversations.tsx:574
#: src/routes/_authed/workspace/conversations.tsx:1117
msgid "Email"
msgstr "Email"

#. placeholder {0}: item.recommendation
#: src/features/report/hooks/useRecommendationActions.ts:113
msgid "Email — {0}"
msgstr "Email — {0}"

#: src/features/sales/components/EmailLibrarySettings.tsx:22
msgid "Email — template e firma"
msgstr "Email — template e firma"

#: src/features/settings/components/NotificationPreferences.tsx:469
msgid "Email al giorno"
msgstr "Email al giorno"

#: src/features/admin/components/AdminDecks.tsx:718
#: src/features/admin/components/AdminDecks.tsx:719
msgid "Email autorizzate"
msgstr "Email autorizzate"

#: src/features/voice_report/components/ShareReportDialog.tsx:252
msgid "Email autorizzate (opzionale)"
msgstr "Email autorizzate (opzionale)"

#: src/features/onboarding/DemoBookCallModal.tsx:372
msgid "Email aziendale"
msgstr "Email aziendale"

#: src/features/clean-control/utils/signalCatalog.ts:199
msgid "Email cita un allegato che non è stato ricevuto."
msgstr "Email cita un allegato che non è stato ricevuto."

#: src/features/sales/components/crm/ActivityNotesPane.tsx:30
msgid "Email collegata"
msgstr "Email collegata"

#: src/features/sales/components/LeadDetailDrawer.tsx:325
msgid "Email copiata"
msgstr "Email copiata"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:567
msgid "email corrispondenti"
msgstr "email corrispondenti"

#: src/features/chat/components/ChatEmptyState.tsx:131
msgid "Email da archiviare"
msgstr "Email da archiviare"

#: src/features/admin/components/AdminCpqPriceBook.tsx:193
msgid "Email dei preventivi"
msgstr "Email dei preventivi"

#: src/features/admin/components/AdminCpq.tsx:1198
#: src/features/admin/components/AdminCpq.tsx:1202
msgid "Email del cliente finale"
msgstr "Email del cliente finale"

#: src/features/connect/components/MemberManager.tsx:431
msgid "Email dell'ospite"
msgstr "Email dell'ospite"

#: src/features/admin/components/AdminCpq.tsx:1190
#: src/features/admin/components/AdminCpq.tsx:1194
msgid "Email della software house"
msgstr "Email della software house"

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:132
msgid "Email destinatario"
msgstr "Email destinatario"

#: src/features/admin/components/AdminDemoInviti.tsx:351
msgid "Email destinatario (opzionale)"
msgstr "Email destinatario (opzionale)"

#: src/features/console/pages/BillingPage.tsx:408
msgid "Email di fatturazione"
msgstr "Email di fatturazione"

#: src/features/admin/components/ZitadelPasswordActions.tsx:86
msgid "Email di reset inviata"
msgstr "Email di reset inviata"

#: src/features/console/pages/ConnectorsPage.tsx:158
msgid "Email e messaggi"
msgstr "Email e messaggi"

#: src/features/admin/components/AdminOrgs.tsx:1232
msgid "Email fatturazione"
msgstr "Email fatturazione"

#: src/features/sources/components/InboxDetailPane.tsx:280
msgid "Email inoltrata."
msgstr "Email inoltrata."

#. placeholder {0}: share.recipient_email
#: src/features/share/components/ShareLinkDialog.tsx:887
msgid "Email inviata a {0}"
msgstr "Email inviata a {0}"

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:99
msgid "Email inviata a {0}."
msgstr "Email inviata a {0}."

#: src/features/sources/components/InboxDetailPane.tsx:539
msgid "Email inviata."
msgstr "Email inviata."

#. placeholder {0}: r.failed.join(", ")
#: src/features/admin/components/AdminGatedLinks.tsx:180
msgid "Email non inviata a {0}"
msgstr "Email non inviata a {0}"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:342
#: src/features/admin/components/AdminOrgs.tsx:623
#: src/features/admin/components/orgs/AddMemberDialog.tsx:135
msgid "Email non valida"
msgstr "Email non valida"

#: src/features/admin/components/AdminOrgs.tsx:216
#: src/features/onboarding/DemoBookCallModal.tsx:174
msgid "Email non valida."
msgstr "Email non valida."

#: src/features/sales/components/SuppressionPanel.tsx:80
msgid "email o dominio — es. mario@acme.it oppure acme.it"
msgstr "email o dominio — es. mario@acme.it oppure acme.it"

#: src/features/admin/components/AdminOrgs.tsx:215
msgid "Email obbligatoria."
msgstr "Email obbligatoria."

#. placeholder {0}: formatScheduledLabel(resp.scheduled_for)
#: src/features/sources/components/InboxDetailPane.tsx:518
msgid "Email programmata per {0}."
msgstr "Email programmata per {0}."

#: src/features/admin/components/AdminDemoInviti.tsx:299
msgid "Email reinviata"
msgstr "Email reinviata"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:914
#: src/features/connectors/wizards/filesystemSpec.tsx:107
msgid "Email separate da virgola — vuoto = solo te."
msgstr "Email separate da virgola — vuoto = solo te."

#: src/features/report/components/tables.tsx:236
msgid "Email stakeholder"
msgstr "Email stakeholder"

#: src/features/sales/components/SignatureRichEditor.tsx:192
msgid "Email-safe"
msgstr "Email-safe"

#: src/features/connectors/wizards/calendarSpec.tsx:71
msgid "Email, deal correlati, note: tutto pronto 5 minuti prima."
msgstr "Email, deal correlati, note: tutto pronto 5 minuti prima."

#: src/features/onboarding/sectionGuides.ts:32
msgid "Email, PEC e chat di tutti gli account collegati in un'unica casella. Chiedi ad Ando di riassumere, dare priorità o scrivere una risposta — in demo gli invii sono simulati."
msgstr "Email, PEC e chat di tutti gli account collegati in un'unica casella. Chiedi ad Ando di riassumere, dare priorità o scrivere una risposta — in demo gli invii sono simulati."

#: src/features/onboarding/demoTourSteps.ts:69
msgid "Email, PEC e chat di tutti gli account in un'unica casella. Chiedi ad Ando di riassumere o di scrivere una risposta — gli invii in demo sono simulati, niente parte davvero."
msgstr "Email, PEC e chat di tutti gli account in un'unica casella. Chiedi ad Ando di riassumere o di scrivere una risposta — gli invii in demo sono simulati, niente parte davvero."

#: src/features/onboarding/demoTourSteps.ts:70
msgid "Email, PEC e chat di tutti i tuoi account in un'unica casella. Chiedi ad Ando di riassumere, dare priorità o scrivere una risposta."
msgstr "Email, PEC e chat di tutti i tuoi account in un'unica casella. Chiedi ad Ando di riassumere, dare priorità o scrivere una risposta."

#: ../../packages/ui/src/ando/RecipientsInput.tsx:232
msgid "email@example.com — Invio per aggiungere"
msgstr "email@example.com — Invio per aggiungere"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:219
msgid "Embedded Signup config_id is not configured"
msgstr "Embedded Signup config_id is not configured"

#: src/features/console/pages/ModelsPage.tsx:330
msgid "Embedding"
msgstr "Embedding"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:120
msgid "embedding dello schema (ricalcolati da zero)"
msgstr "embedding dello schema (ricalcolati da zero)"

#: src/features/settings/components/BrandKitSettings.tsx:828
msgid "Emoji"
msgstr "Emoji"

#: src/features/agent-modes/components/AgentModeEditor.tsx:352
msgid "emoji o glifo"
msgstr "emoji o glifo"

#: src/features/admin/components/orgs/OrgAuditTab.tsx:42
#: src/features/connectors/wizards/erpSpec.tsx:94
#: src/features/console/connectors/CustomConnectorDetail.tsx:624
#: src/features/console/webhooks/WebhooksPanel.tsx:523
msgid "Endpoint"
msgstr "Endpoint"

#. placeholder {0}: created.url
#: src/features/console/webhooks/WebhooksPanel.tsx:336
msgid "Endpoint <0>{0}</0> registrato: usa «Invia test.ping» per verificare che riceva e verifichi la firma."
msgstr "Endpoint <0>{0}</0> registrato: usa «Invia test.ping» per verificare che riceva e verifichi la firma."

#: src/features/connectors/wizards/erpSpec.tsx:98
msgid "Endpoint API del vendor — fornito dal partner."
msgstr "Endpoint API del vendor — fornito dal partner."

#: src/features/connectors/wizards/erpSpec.tsx:174
msgid "Endpoint API TeamSystem — disponibile dopo la firma del contratto partner."
msgstr "Endpoint API TeamSystem — disponibile dopo la firma del contratto partner."

#: src/features/connectors/wizards/erpSpec.tsx:166
msgid "Endpoint API Zucchetti — disponibile dopo la firma del contratto partner."
msgstr "Endpoint API Zucchetti — disponibile dopo la firma del contratto partner."

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:418
msgid "Endpoint infrastruttura"
msgstr "Endpoint infrastruttura"

#: src/features/connectors/wizards/erpSpec.tsx:56
msgid "Endpoint OData v4"
msgstr "Endpoint OData v4"

#: src/features/connectors/wizards/erpSpec.tsx:126
msgid "Endpoint OData v4 (Business Suite, S/4HANA)"
msgstr "Endpoint OData v4 (Business Suite, S/4HANA)"

#: src/features/connectors/wizards/erpSpec.tsx:158
msgid "Endpoint OData v4, credenziali tecniche e namespace del servizio SAP."
msgstr "Endpoint OData v4, credenziali tecniche e namespace del servizio SAP."

#: src/features/connectors/wizards/accountingSpec.tsx:44
msgid "Endpoint Service Layer della tua installazione SAP B1 (tipicamente porta 50000 HTTPS). Il path /b1s/v2/ viene aggiunto automaticamente."
msgstr "Endpoint Service Layer della tua installazione SAP B1 (tipicamente porta 50000 HTTPS). Il path /b1s/v2/ viene aggiunto automaticamente."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:817
msgid "Enfasi"
msgstr "Enfasi"

#: src/routes/_authed/_modal/admin/route.tsx:130
msgid "Engagement"
msgstr "Engagement"

#: src/features/console/pages/EngineSignupPage.tsx:228
msgid "Engine pronto"
msgstr "Engine pronto"

#: src/features/templates/components/TemplateFieldSpecs.ts:182
msgid "English"
msgstr "English"

#: src/features/admin/components/AdminOrgs.tsx:112
msgid "Enterprise"
msgstr "Enterprise"

#: src/features/connectors/wizards/databaseSpec.tsx:167
msgid "Enterprise legacy"
msgstr "Enterprise legacy"

#: src/features/connectors/wizards/databaseSpec.tsx:161
msgid "Enterprise Microsoft"
msgstr "Enterprise Microsoft"

#: src/features/admin/components/AdminPlatformSettings.tsx:919
msgid "Enterprise SQL"
msgstr "Enterprise SQL"

#: src/features/admin/components/AdminOrgs.tsx:113
msgid "Enterprise+"
msgstr "Enterprise+"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:96
msgid "Entità"
msgstr "Entità"

#: src/features/clean-control/utils/signalCatalog.ts:120
msgid "Entità duplicata (contatti / aziende)"
msgstr "Entità duplicata (contatti / aziende)"

#: src/features/sales/components/TemplateManager.tsx:34
#: src/features/sales/components/TemplateManager.tsx:40
msgid "Entrambi"
msgstr "Entrambi"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:95
msgid "Entrata"
msgstr "Entrata"

#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:174
msgid "Entrate"
msgstr "Entrate"

#: src/routes/_authed/workspace/finance.tsx:1409
msgid "Entrate mese"
msgstr "Entrate mese"

#: src/routes/_authed/workspace/finance.tsx:1600
msgid "Entrate più grandi delle ultime 4 settimane"
msgstr "Entrate più grandi delle ultime 4 settimane"

#: src/features/console/pages/DocsPage.tsx:631
msgid "Envelope degli errori"
msgstr "Envelope degli errori"

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:40
msgid "Episodic"
msgstr "Episodic"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:272
msgid "Episodic facts"
msgstr "Episodic facts"

#. placeholder {0}: task.title
#: src/features/workspace/components/TaskSimpleRow.tsx:215
msgid "Era sbagliato? Riapri {0}"
msgstr "Era sbagliato? Riapri {0}"

#: src/features/templates/components/CreateTemplateDialog.tsx:166
msgid "Eredita da (opzionale)"
msgstr "Eredita da (opzionale)"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:218
msgid "Eredita l'impostazione globale."
msgstr "Eredita l'impostazione globale."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:490
msgid "Ereditato dal tier dell'organizzazione"
msgstr "Ereditato dal tier dell'organizzazione"

#: src/features/console/connectors/meta.ts:191
msgid "ERP"
msgstr "ERP"

#: src/features/connectors/wizards/erpSpec.tsx:116
msgid "ERP Italiano"
msgstr "ERP Italiano"

#: src/features/connectors/wizards/erpSpec.tsx:182
msgid "ERP italiano sincronizzato"
msgstr "ERP italiano sincronizzato"

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:360
#: src/features/hive-flows/components/DryRunPanel.tsx:78
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:239
#: src/features/sync/components/DocSyncManager.tsx:269
#: src/features/sync/components/DocSyncManager.tsx:326
#: src/features/sync/components/DocSyncManager.tsx:385
#: src/features/sync/components/DocSyncManager.tsx:473
#: src/features/sync/components/DocSyncManager.tsx:556
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:246
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:263
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:282
#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:181
#: src/routes/_authed/_modal/integrations/$capability.tsx:191
#: src/routes/_authed/workspace/documents.tsx:603
msgid "errore"
msgstr "errore"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:22
#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:57
#: src/features/actions/hooks/useActionRouter.ts:317
#: src/features/admin/components/AdminOrgs.tsx:329
#: src/features/admin/components/AdminOrgs.tsx:656
#: src/features/admin/components/AdminOrgs.tsx:672
#: src/features/admin/components/AdminOrgs.tsx:753
#: src/features/admin/components/AdminOrgs.tsx:769
#: src/features/admin/components/userAdminActions.tsx:253
#: src/features/admin/components/userAdminActions.tsx:293
#: src/features/automations/components/AutomationStatusChip.tsx:36
#: src/features/canvases/components/CanvasStatusChip.tsx:34
#: src/features/chat/hooks/useChatStream.ts:90
#: src/features/chat/wsHandlers.ts:306
#: src/features/console/components/StatusBadges.tsx:111
#: src/features/console/components/StatusBadges.tsx:112
#: src/features/console/components/StatusBadges.tsx:131
#: src/features/console/pages/ConnectorsPage.tsx:76
#: src/features/console/pages/PlaygroundPage.tsx:1587
#: src/features/console/pages/PlaygroundPage.tsx:1644
#: src/features/dxf/components/DxfBomButton.tsx:73
#: src/features/dxf/utils.ts:197
#: src/features/hive-flows/run/RunHistoryRail.tsx:57
#: src/features/sources/components/ArtifactPane.tsx:1222
#: src/features/sources/components/ArtifactPane.tsx:1241
#: src/features/sources/components/ArtifactToolbar.tsx:83
#: src/routes/_authed/workspace/templates/$kind.tsx:290
msgid "Errore"
msgstr "Errore"

#: src/features/chat/wsHandlers.ts:324
msgid "Errore (auto-recovery attivo)"
msgstr "Errore (auto-recovery attivo)"

#. placeholder {0}: provision.retry_count
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:347
msgid "Errore (retry {0}/3)"
msgstr "Errore (retry {0}/3)"

#: src/features/updates/components/UpdateBanner.tsx:171
msgid "Errore aggiornamento"
msgstr "Errore aggiornamento"

#: src/features/admin/components/AdminUsers.tsx:162
msgid "Errore bulk"
msgstr "Errore bulk"

#: src/features/voice_report/components/RunDiffTimeline.tsx:187
msgid "Errore caricamento diff"
msgstr "Errore caricamento diff"

#: src/features/console/docs/content.ts:1974
msgid "Errore dell'envelope: code (stabile), message, status, retry_after (sui 429)."
msgstr "Errore dell'envelope: code (stabile), message, status, retry_after (sui 429)."

#: src/features/report/components/CitationDetail.tsx:93
msgid "Errore di caricamento"
msgstr "Errore di caricamento"

#: src/features/dxf/components/DxfPreviewStage.tsx:489
msgid "Errore di caricamento anteprima"
msgstr "Errore di caricamento anteprima"

#: src/features/connectors/components/ConnectorStatus.tsx:121
#: src/features/connectors/components/ConnectorStatus.tsx:241
msgid "Errore di connessione"
msgstr "Errore di connessione"

#: src/features/dashboard/components/DashboardChartCard.tsx:583
msgid "Errore di esecuzione"
msgstr "Errore di esecuzione"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:407
#: src/features/sources/marp/DeckOutlineEditorMount.tsx:134
#: src/features/sources/marp/DeckOutlineEditorMount.tsx:181
#: src/features/sources/marp/MarpDeckEditorMount.tsx:174
#: src/features/sources/marp/MarpDeckEditorMount.tsx:214
#: src/features/sources/marp/SlideDeckProposalMount.tsx:144
msgid "Errore di rete"
msgstr "Errore di rete"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:183
msgid "Errore di rete durante la generazione della query."
msgstr "Errore di rete durante la generazione della query."

#: ../../packages/ui/src/ando/actions/InlineAIRefiner.tsx:331
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:604
msgid "Errore di rete."
msgstr "Errore di rete."

#: src/features/workspace/documents/components/SmartSourceChips.tsx:73
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:296
msgid "Errore di sincronizzazione"
msgstr "Errore di sincronizzazione"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:94
msgid "Errore durante il rollback."
msgstr "Errore durante il rollback."

#: src/features/agent-modes/components/AgentModeEditor.tsx:286
#: src/features/settings/components/OrganizationSettings.tsx:299
msgid "Errore durante il salvataggio."
msgstr "Errore durante il salvataggio."

#: src/features/settings/components/SecuritySettings.tsx:134
msgid "Errore durante l'aggiornamento."
msgstr "Errore durante l'aggiornamento."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:205
msgid "Errore durante l'esecuzione della query."
msgstr "Errore durante l'esecuzione della query."

#: src/features/settings/components/OrgMembersPanel.tsx:566
msgid "Errore durante l'invito. Riprova."
msgstr "Errore durante l'invito. Riprova."

#: src/features/dashboard/components/ShareChartSheet.tsx:268
#: src/features/dashboard/components/ShareDashboardSheet.tsx:255
msgid "Errore durante la condivisione."
msgstr "Errore durante la condivisione."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:262
msgid "Errore durante la conferma."
msgstr "Errore durante la conferma."

#: src/features/settings/components/OrgMembersPanel.tsx:672
msgid "Errore durante la rimozione. Riprova."
msgstr "Errore durante la rimozione. Riprova."

#: src/features/admin/components/AdminPlatformSettings.tsx:140
#: src/features/admin/components/AdminPlatformSettings.tsx:165
#: src/features/admin/components/AdminPlatformSettings.tsx:450
#: src/features/admin/components/AdminPlatformSettings.tsx:463
#: src/features/admin/components/AdminPlatformSettings.tsx:476
#: src/features/admin/components/AdminPlatformSettings.tsx:514
#: src/features/admin/components/AdminPlatformSettings.tsx:526
msgid "Errore generico"
msgstr "Errore generico"

#: src/features/clean-control/components/EventDetailSheet.tsx:141
msgid "Errore imprevisto."
msgstr "Errore imprevisto."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:198
#: ../../packages/ui/src/editors/RegionEditPill.tsx:144
msgid "Errore inaspettato."
msgstr "Errore inaspettato."

#: src/features/admin/components/AdminOrgs.tsx:462
#: src/features/admin/components/AdminOrgs.tsx:474
#: src/features/admin/components/AdminOrgs.tsx:486
#: src/features/admin/components/AdminOrgs.tsx:519
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:190
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:217
#: src/features/admin/components/orgs/OrgBrandingTab.tsx:140
#: src/features/admin/components/orgs/OrgBrandingTab.tsx:157
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:205
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:234
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:279
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:91
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:106
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:120
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:136
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:104
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:122
#: src/features/admin/components/orgs/OrgMembersTab.tsx:162
#: src/features/admin/components/orgs/OrgMembersTab.tsx:182
#: src/features/admin/components/orgs/OrgMembersTab.tsx:203
#: src/features/admin/components/orgs/OrgSecurityTab.tsx:83
#: src/features/admin/components/orgs/OrgSecurityTab.tsx:96
#: src/features/admin/components/orgs/OrgSSOTab.tsx:139
#: src/features/admin/components/orgs/OrgSSOTab.tsx:158
#: src/features/admin/components/ZitadelPasswordActions.tsx:91
#: src/features/admin/components/ZitadelPasswordActions.tsx:145
msgid "Errore inatteso"
msgstr "Errore inatteso"

#: src/features/admin/components/AdminOrgs.tsx:972
#: src/features/admin/components/orgs/AddMemberDialog.tsx:126
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:80
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:104
#: src/features/admin/components/orgs/MigrateUserDialog.tsx:113
msgid "Errore inatteso."
msgstr "Errore inatteso."

#: src/features/workspace/documents/components/DocumentCardV2.tsx:273
msgid "Errore indicizzazione"
msgstr "Errore indicizzazione"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:397
msgid "Errore nel caricamento dei connector."
msgstr "Errore nel caricamento dei connector."

#: src/features/agent-modes/components/AgentModesList.tsx:233
msgid "Errore nel caricamento dei modi."
msgstr "Errore nel caricamento dei modi."

#: src/routes/_authed/workspace/finance.tsx:1532
msgid "Errore nel caricamento dei movimenti."
msgstr "Errore nel caricamento dei movimenti."

#: src/features/settings/components/PresentationTemplates.tsx:375
#: src/features/studio/components/StudioDrawerContent.tsx:424
#: src/features/templates/components/TemplatesList.tsx:155
#: src/routes/_authed/workspace/templates/$kind.tsx:122
msgid "Errore nel caricamento dei template."
msgstr "Errore nel caricamento dei template."

#: src/routes/_authed/workspace/finance.tsx:1558
msgid "Errore nel caricamento delle categorie."
msgstr "Errore nel caricamento delle categorie."

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:187
msgid "Errore nel caricamento delle organizzazioni."
msgstr "Errore nel caricamento delle organizzazioni."

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:136
msgid "Errore nel caricamento."
msgstr "Errore nel caricamento."

#: src/routes/_authed/workspace/finance.tsx:284
msgid "Errore nel recupero dati"
msgstr "Errore nel recupero dati"

#: src/features/settings/components/OrgMembersPanel.tsx:111
msgid "Errore nel recupero dei membri. Riprova fra qualche istante."
msgstr "Errore nel recupero dei membri. Riprova fra qualche istante."

#: src/features/settings/components/OrganizationSettings.tsx:213
msgid "Errore nel recupero del branding. Riprova fra qualche istante."
msgstr "Errore nel recupero del branding. Riprova fra qualche istante."

#: src/features/settings/components/SecuritySettings.tsx:320
msgid "Errore nel recupero delle sessioni."
msgstr "Errore nel recupero delle sessioni."

#: src/features/sources/components/ArtifactPane.tsx:663
msgid "Errore nell'applicare le modifiche"
msgstr "Errore nell'applicare le modifiche"

#: src/features/projects/components/NewProjectDialog.tsx:181
msgid "Errore nella creazione del progetto."
msgstr "Errore nella creazione del progetto."

#: src/features/console/docs/content.ts:2001
msgid "Errore nostro; riprovabile."
msgstr "Errore nostro; riprovabile."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:791
#: src/features/price-lists/components/PriceListsPage.tsx:842
msgid "Errore salvataggio"
msgstr "Errore salvataggio"

#: src/features/sources/components/ArtifactPane.tsx:2027
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:220
#: src/routes/_authed/_modal/integrations/$capability.tsx:184
#: src/routes/_authed/_modal/integrations/$capability.tsx:635
msgid "errore sconosciuto"
msgstr "errore sconosciuto"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:62
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:397
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:660
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:719
#: src/features/settings/marp/CssUploadPanel.tsx:107
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:121
#: src/features/settings/marp/PptxExtractPanel.tsx:67
#: src/features/source-confirmation/components/SourceConfirmationSurface.tsx:165
#: src/features/voice_report/components/RunsTab.tsx:150
#: src/features/voice_report/components/VoiceReportsList.tsx:224
msgid "Errore sconosciuto"
msgstr "Errore sconosciuto"

#: src/features/workspace/hooks/useFileUpload.ts:154
msgid "Errore sconosciuto durante il caricamento"
msgstr "Errore sconosciuto durante il caricamento"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:462
msgid "Errore sconosciuto durante il caricamento. Verifica la connessione o riconnetti l'account."
msgstr "Errore sconosciuto durante il caricamento. Verifica la connessione o riconnetti l'account."

#: src/features/admin/components/AdminOrgs.tsx:338
msgid "Errore sconosciuto."
msgstr "Errore sconosciuto."

#: src/features/sync/components/SyncStatusPill.tsx:105
#: src/features/workspace/finance/components/BankAccountsList.tsx:139
msgid "Errore sync"
msgstr "Errore sync"

#. placeholder {0}: humanizeError(uploadErr)
#: src/routes/_authed/_modal/integrations/$capability.tsx:300
msgid "Errore upload CAD: {0}"
msgstr "Errore upload CAD: {0}"

#. placeholder {0}: err.message
#: src/features/sources/components/CalendarEventPane.tsx:275
#: src/features/sources/components/CalendarEventPane.tsx:288
#: src/features/sources/components/CalendarEventPane.tsx:301
msgid "Errore: {0}"
msgstr "Errore: {0}"

#: src/features/admin/components/CostTraceDetailSection.tsx:198
msgid "Errore: {error}"
msgstr "Errore: {error}"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:261
msgid "Errore: {errorMessage}"
msgstr "Errore: {errorMessage}"

#: src/features/automations/components/AutomationsHub.tsx:270
msgid "Errori"
msgstr "Errori"

#: src/features/admin/components/AdminHealth.tsx:145
msgid "Errori %"
msgstr "Errori %"

#: src/routes/_authed/_modal/integrations/index.tsx:545
msgid "Errori di caricamento"
msgstr "Errori di caricamento"

#: src/features/admin/components/AdminOrgs.tsx:319
msgid "Errori per organizzazione"
msgstr "Errori per organizzazione"

#: src/features/chat/components/ChatEmptyState.tsx:359
msgid "Errori workflow"
msgstr "Errori workflow"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:426
msgid "Es: il pattern è coincidente, non rappresenta un workflow ricorrente"
msgstr "Es: il pattern è coincidente, non rappresenta un workflow ricorrente"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:161
msgid "Es: Mostra il fatturato per cliente nel 2026."
msgstr "Es: Mostra il fatturato per cliente nel 2026."

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:372
msgid "es. -"
msgstr "es. -"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:295
msgid "Es. 'rendi più formale', 'accorcia a 2 righe', 'in inglese'"
msgstr "Es. 'rendi più formale', 'accorcia a 2 righe', 'in inglese'"

#: src/features/automations/components/ScheduleEditor.tsx:154
msgid "es. \"ogni lunedì alle 9\", \"ogni 2 ore\""
msgstr "es. \"ogni lunedì alle 9\", \"ogni 2 ore\""

#: src/features/projects/components/sections/PersonaSection.tsx:265
msgid "Es. \"Sei un commercialista esperto in IVA trimestrale. Quando produci un F24, escludi sempre i documenti extra-UE.\""
msgstr "Es. \"Sei un commercialista esperto in IVA trimestrale. Quando produci un F24, escludi sempre i documenti extra-UE.\""

#: src/features/admin/components/PageEditor.tsx:183
msgid "Es. «Crea una pagina sul modello di pricing con un simulatore» o «Aggiungi una sezione sul team con schede espandibili»"
msgstr "Es. «Crea una pagina sul modello di pricing con un simulatore» o «Aggiungi una sezione sul team con schede espandibili»"

#: src/features/console/pages/FlowsPage.tsx:500
msgid "Es. «Ogni mattina alle 8 prepara un riepilogo delle email e mandamelo»."
msgstr "Es. «Ogni mattina alle 8 prepara un riepilogo delle email e mandamelo»."

#: src/features/sales/components/crm/CreateDealDialog.tsx:143
msgid "Es. 12.500"
msgstr "Es. 12.500"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:372
msgid "es. 2"
msgstr "es. 2"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:350
msgid "es. 25"
msgstr "es. 25"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:374
msgid "es. 50"
msgstr "es. 50"

#: src/features/console/components/CreateKeyWizard.tsx:575
#: src/features/console/pages/KeyDetailPage.tsx:321
msgid "Es. 50"
msgstr "Es. 50"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2786
msgid "Es. accorcia il titolo, rendi i punti più concreti, aggiungi una slide sul verticale CAD"
msgstr "Es. accorcia il titolo, rendi i punti più concreti, aggiungi una slide sul verticale CAD"

#: src/features/admin/components/AdminDecksAskAndo.tsx:96
msgid "Es. accorcia la slide del problema, aggiungi una slide sul verticale CAD dopo i casi d'uso, allinea l'inglese"
msgstr "Es. accorcia la slide del problema, aggiungi una slide sul verticale CAD dopo i casi d'uso, allinea l'inglese"

#: src/features/templates/components/CreateTemplateDialog.tsx:143
msgid "Es. ACME · Pitch deck"
msgstr "Es. ACME · Pitch deck"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:275
msgid "Es. Acme CRM"
msgstr "Es. Acme CRM"

#: src/features/settings/components/BrandKitSettings.tsx:408
msgid "es. Acme S.r.l. — 2026"
msgstr "es. Acme S.r.l. — 2026"

#: src/features/settings/components/BrandKitSettings.tsx:399
msgid "es. Acme S.r.l. — Confidenziale"
msgstr "es. Acme S.r.l. — Confidenziale"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:254
msgid "Es. Acme!2026-EarlyAccess"
msgstr "Es. Acme!2026-EarlyAccess"

#: src/features/admin/components/AdminCpqAskAndo.tsx:233
msgid "Es. aggiungi una sezione sui rischi, passa a private cloud, accorcia il titolo"
msgstr "Es. aggiungi una sezione sui rischi, passa a private cloud, accorcia il titolo"

#: src/features/agent-modes/components/AgentModeEditor.tsx:328
msgid "es. Analista Finanziario"
msgstr "es. Analista Finanziario"

#: src/features/settings/components/PresentationTemplates.tsx:759
msgid "Es. ando_brand_2026"
msgstr "Es. ando_brand_2026"

#: src/features/hive-flows/components/ConditionBuilder.tsx:290
msgid "es. attivo, sospeso, chiuso"
msgstr "es. attivo, sospeso, chiuso"

#: src/features/settings/marp/CssUploadPanel.tsx:159
msgid "es. blue-pitch-2026"
msgstr "es. blue-pitch-2026"

#: src/features/automations/components/CreateAutomationDialog.tsx:189
msgid "es. Brief vendite settimanale"
msgstr "es. Brief vendite settimanale"

#: src/features/dxf/components/DxfActionsMenu.tsx:101
msgid "es. Cancelli, Tornelli…"
msgstr "es. Cancelli, Tornelli…"

#: src/features/projects/components/sections/PersonaSection.tsx:319
msgid "Es. Commercialista, PM tecnico…"
msgstr "Es. Commercialista, PM tecnico…"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:68
msgid "Es. Da tanti Excel a un unico file, pulito e sempre aggiornato."
msgstr "Es. Da tanti Excel a un unico file, pulito e sempre aggiornato."

#: src/features/sales/components/CreateLeadDialog.tsx:183
#: src/features/sales/components/crm/ContactsPanel.tsx:123
msgid "Es. Direttrice acquisti"
msgstr "Es. Direttrice acquisti"

#: src/features/connect/components/CreateSpaceDialog.tsx:138
msgid "Es. Due diligence — Acme S.p.A."
msgstr "Es. Due diligence — Acme S.p.A."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:329
msgid "Es. Email sul progetto Alfa"
msgstr "Es. Email sul progetto Alfa"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:604
msgid "Es. employee-123"
msgstr "Es. employee-123"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:874
msgid "Es. ERP produzione"
msgstr "Es. ERP produzione"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:262
msgid "Es. Fatture aperte per cliente"
msgstr "Es. Fatture aperte per cliente"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:265
msgid "Es. Fatture aperte per cliente nel quarto trimestre"
msgstr "Es. Fatture aperte per cliente nel quarto trimestre"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:265
msgid "Es. Fatture Q1 2026"
msgstr "Es. Fatture Q1 2026"

#: src/features/sales/components/SignaturesManager.tsx:249
msgid "Es. Firma commerciale"
msgstr "Es. Firma commerciale"

#: src/features/sales/components/crm/CreateDealDialog.tsx:128
msgid "Es. Fornitura arredi uffici Rossi"
msgstr "Es. Fornitura arredi uffici Rossi"

#: src/features/admin/components/AdminPlatformSettings.tsx:247
msgid "es. google/gemini-2.5-pro"
msgstr "es. google/gemini-2.5-pro"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:283
msgid "es. imponibile"
msgstr "es. imponibile"

#: src/features/console/components/CreateKeyWizard.tsx:284
msgid "Es. Integrazione sito docs"
msgstr "Es. Integrazione sito docs"

#: src/features/connect/components/GrantManager.tsx:727
msgid "es. invoices, customers"
msgstr "es. invoices, customers"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:423
msgid "Es. IVA Q2 2026 — Rossi SRL"
msgstr "Es. IVA Q2 2026 — Rossi SRL"

#: src/features/sales/components/crm/CompaniesPanel.tsx:120
msgid "Es. Manifattura"
msgstr "Es. Manifattura"

#: src/features/sales/components/CampaignsPanel.tsx:112
#: src/features/sales/components/CreateCampaignDialog.tsx:88
msgid "Es. Manifatturiero Nord Italia Q3"
msgstr "Es. Manifatturiero Nord Italia Q3"

#: src/features/sales/components/CreateLeadDialog.tsx:171
#: src/features/sales/components/crm/ContactsPanel.tsx:97
msgid "Es. Maria Rossi"
msgstr "Es. Maria Rossi"

#: src/features/sales/components/SuppressionPanel.tsx:38
msgid "Es. mario@acme.it oppure acme.it"
msgstr "Es. mario@acme.it oppure acme.it"

#: src/features/dashboard/components/AxisConfigurator.tsx:393
msgid "es. Mese"
msgstr "es. Mese"

#: src/features/sales/components/crm/CompaniesPanel.tsx:133
msgid "Es. Milano"
msgstr "Es. Milano"

#: src/features/admin/components/AdminCpq.tsx:664
msgid "Es. Mission 1, Company brain"
msgstr "Es. Mission 1, Company brain"

#: src/features/admin/components/AdminDecks.tsx:331
msgid "Es. Pilota Ceramiche Vela, Round seed, Fiera MECSPE"
msgstr "Es. Pilota Ceramiche Vela, Round seed, Fiera MECSPE"

#: src/features/sales/components/CampaignsPanel.tsx:123
#: src/features/sales/components/CreateCampaignDialog.tsx:101
msgid "Es. PMI manifatturiere in Lombardia, 10-50 dipendenti, che esportano"
msgstr "Es. PMI manifatturiere in Lombardia, 10-50 dipendenti, che esportano"

#: src/features/admin/components/AdminCpqAskAndo.tsx:232
msgid "Es. PoC piccolo per Luxottica: consolidare tanti Excel in un unico Excel pulito, SaaS, supporto standard, R&D light"
msgstr "Es. PoC piccolo per Luxottica: consolidare tanti Excel in un unico Excel pulito, SaaS, supporto standard, R&D light"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:256
msgid "Es. PoC-Pilota 2026 · Mission 1–3"
msgstr "Es. PoC-Pilota 2026 · Mission 1–3"

#: src/features/sales/components/TemplateManager.tsx:258
msgid "Es. Primo contatto SaaS"
msgstr "Es. Primo contatto SaaS"

#: src/features/console/pages/PlaygroundPage.tsx:1881
msgid "Es. Quali clienti hanno l'esposizione più critica e per quale importo?"
msgstr "Es. Quali clienti hanno l'esposizione più critica e per quale importo?"

#: src/features/skills/components/SkillEditor.tsx:291
msgid "es. Quando arriva una fattura da un fornitore, registrala e avvisami"
msgstr "es. Quando arriva una fattura da un fornitore, registrala e avvisami"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:805
msgid "Es. Rendi più formale, aggiungi una clausola di riservatezza, abbrevia…"
msgstr "Es. Rendi più formale, aggiungi una clausola di riservatezza, abbrevia…"

#: src/features/dashboard/components/AxisConfigurator.tsx:410
msgid "es. Ricavi (€)"
msgstr "es. Ricavi (€)"

#: src/features/admin/components/UserDetailContent.tsx:877
msgid "Es. richiesta DSAR ticket #4598 — verifica identità utente"
msgstr "Es. richiesta DSAR ticket #4598 — verifica identità utente"

#: src/features/sales/components/CreateLeadDialog.tsx:157
#: src/features/sales/components/crm/CompaniesPanel.tsx:95
msgid "Es. Rossi Manifatture S.r.l."
msgstr "Es. Rossi Manifatture S.r.l."

#: src/features/skills/components/SkillEditor.tsx:336
msgid "es. Smistamento fatture fornitori"
msgstr "es. Smistamento fatture fornitori"

#: src/features/admin/components/AdminCpqAskAndo.tsx:230
msgid "Es. titolo più corto, togli l'R&D, aggiungi un secondo PoC"
msgstr "Es. titolo più corto, togli l'R&D, aggiungi un secondo PoC"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:906
msgid "es. undercut"
msgstr "es. undercut"

#: src/features/clean-control/components/policies/PolicyForm.tsx:204
msgid "Es. Unifica duplicati preventivi"
msgstr "Es. Unifica duplicati preventivi"

#: src/features/admin/components/userAdminActions.tsx:374
msgid "Es. utente segnalato per attività sospetta (#ticket-1234)"
msgstr "Es. utente segnalato per attività sospetta (#ticket-1234)"

#: src/features/price-lists/components/PriceListsPage.tsx:896
msgid "es. V-M6X20-ZN"
msgstr "es. V-M6X20-ZN"

#: src/features/dashboard/components/AddChartDialog.tsx:459
msgid "Es. Vendite per regione"
msgstr "Es. Vendite per regione"

#: src/features/projects/components/NewProjectDialog.tsx:125
msgid "es. Vendite Q2"
msgstr "es. Vendite Q2"

#: src/features/admin/components/orgs/OrgCostTab.tsx:234
msgid "Es. verifica anomalia costo ticket #4598"
msgstr "Es. verifica anomalia costo ticket #4598"

#: src/features/voice_report/components/SettingsTab.tsx:132
msgid "es. Voce dei clienti Q3"
msgstr "es. Voce dei clienti Q3"

#: src/features/voice_report/components/NewReportDialog.tsx:836
msgid "es. Voice of Customer Q2 — Italia"
msgstr "es. Voice of Customer Q2 — Italia"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:918
msgid "es. wall_thickness_mm"
msgstr "es. wall_thickness_mm"

#: src/features/price-lists/components/PriceListsPage.tsx:962
msgid "es. ZAMA, acciaio inox"
msgstr "es. ZAMA, acciaio inox"

#: src/features/console/pages/TracesPage.tsx:495
msgid "Esamina le chiamate registrate e riapri i payload originali in sola lettura."
msgstr "Esamina le chiamate registrate e riapri i payload originali in sola lettura."

#: src/features/account/components/UserMenuButton.tsx:487
#: src/features/console/components/ConsoleShell.tsx:523
msgid "Esci"
msgstr "Esci"

#: src/routes/_authed/route.tsx:2535
msgid "Esci da Focus"
msgstr "Esci da Focus"

#: src/routes/_authed/route.tsx:2519
msgid "Esci da Focus chat"
msgstr "Esci da Focus chat"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:428
#: src/features/admin/components/deckEditor/DeckEditor.tsx:432
msgid "Esci da schermo intero"
msgstr "Esci da schermo intero"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:429
msgid "Esci da schermo intero (Esc)"
msgstr "Esci da schermo intero (Esc)"

#: src/features/projects/components/sections/MembersSection.tsx:147
#: src/features/projects/components/sections/MembersSection.tsx:270
msgid "Esci dal progetto"
msgstr "Esci dal progetto"

#: src/features/help/components/ShortcutsList.tsx:130
msgid "Esci dalla modalità Focus"
msgstr "Esci dalla modalità Focus"

#: src/features/clean-control/utils/signalCatalog.ts:191
msgid "Escludere dal RAG"
msgstr "Escludere dal RAG"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:563
msgid "Esclusione spazi inattivi"
msgstr "Esclusione spazi inattivi"

#: src/features/workspace/config.ts:368
msgid "Esclusioni"
msgstr "Esclusioni"

#: src/features/admin/components/AdminCpqCanvas.tsx:157
msgid "Esclusioni e condizioni"
msgstr "Esclusioni e condizioni"

#: src/features/automations/components/AutomationCard.tsx:74
msgid "esec."
msgstr "esec."

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:110
#: src/features/hive-flows/components/DryRunPanel.tsx:88
#: src/features/hive-flows/run/RunHistoryRail.tsx:116
msgid "Esecuzione"
msgstr "Esecuzione"

#: src/features/actions/components/FocusedActionView.tsx:903
#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:237
msgid "Esecuzione azione fallita. Riprova."
msgstr "Esecuzione azione fallita. Riprova."

#: src/features/console/flows/hooks.ts:65
#: src/features/console/pages/FlowsPage.tsx:690
#: src/features/hive-flows/run/ProposalReview.tsx:847
msgid "Esecuzione completata"
msgstr "Esecuzione completata"

#: src/features/console/flows/ConsoleFlowEditor.tsx:220
msgid "Esecuzione con documento non riuscita"
msgstr "Esecuzione con documento non riuscita"

#: src/features/hive-flows/run/RunHistoryRail.tsx:76
msgid "Esecuzione da webhook"
msgstr "Esecuzione da webhook"

#: src/features/console/flows/hooks.ts:60
#: src/features/console/pages/FlowsPage.tsx:685
#: src/routes/_authed/workspace/flows.$flowId.tsx:334
msgid "Esecuzione fallita"
msgstr "Esecuzione fallita"

#: src/features/console/flows/hooks.ts:52
#: src/features/console/pages/FlowsPage.tsx:681
msgid "Esecuzione in attesa di approvazione"
msgstr "Esecuzione in attesa di approvazione"

#: src/features/hive-flows/run/RunHistoryRail.tsx:71
msgid "Esecuzione manuale"
msgstr "Esecuzione manuale"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:271
#: src/features/console/flows/ConsoleFlowEditor.tsx:161
#: src/features/hive-flows/run/ProposalReview.tsx:844
#: src/routes/_authed/workspace/flows.$flowId.tsx:340
#: src/routes/_authed/workspace/flows.index.tsx:131
msgid "Esecuzione non riuscita"
msgstr "Esecuzione non riuscita"

#: src/features/hive-flows/run/RunHistoryRail.tsx:74
msgid "Esecuzione pianificata"
msgstr "Esecuzione pianificata"

#: src/features/admin/components/userAdminActions.tsx:394
#: src/features/console/pages/PlaygroundPage.tsx:2053
msgid "Esecuzione…"
msgstr "Esecuzione…"

#: src/features/automations/components/AutomationDetailSection.tsx:70
#: src/features/console/pages/FlowsPage.tsx:823
#: src/features/hive-flows/components/FlowVersionMenu.tsx:95
#: src/features/workspace/config.ts:436
msgid "Esecuzioni"
msgstr "Esecuzioni"

#: src/features/admin/components/AdminAutomation.tsx:70
msgid "Esecuzioni automation + workflow suggestions. Picchi di failed spesso precedono un endpoint vendor in down — verifica health prima di chiamare on-call."
msgstr "Esecuzioni automation + workflow suggestions. Picchi di failed spesso precedono un endpoint vendor in down — verifica health prima di chiamare on-call."

#: src/features/console/flows/ConsoleFlowApprovals.tsx:76
msgid "Esecuzioni in attesa di approvazione"
msgstr "Esecuzioni in attesa di approvazione"

#: src/features/console/flows/ConsoleFlowApprovals.tsx:54
msgid "Esecuzioni in pausa su un passaggio di approvazione: rivedi il contenuto proposto, correggilo se serve e approva per far riprendere il flow — oppure rifiuta per chiuderla senza eseguire nulla a valle."
msgstr "Esecuzioni in pausa su un passaggio di approvazione: rivedi il contenuto proposto, correggilo se serve e approva per far riprendere il flow — oppure rifiuta per chiuderla senza eseguire nulla a valle."

#: src/features/console/pages/FlowsPage.tsx:196
msgid "Esecuzioni reali"
msgstr "Esecuzioni reali"

#: src/features/console/pages/FlowDetailPage.tsx:248
msgid "Esecuzioni reali del flow (i test non contano)."
msgstr "Esecuzioni reali del flow (i test non contano)."

#: src/features/console/flows/ConsoleFlowEditor.tsx:261
msgid "Esegue il flow per davvero (le azioni vengono eseguite)"
msgstr "Esegue il flow per davvero (le azioni vengono eseguite)"

#: src/features/console/docs/content.ts:1108
msgid "Esegue subito una capability con binding HTTP. Richiede permesso sul connettore e conferma esplicita per rischio alto o critico. Per scritture live invia un Idempotency-Key stabile (massimo 255 caratteri): un esito incerto non viene ritentato automaticamente. Con una AppKey test valida i parametri senza chiamare il sistema esterno e restituisce test: true."
msgstr "Esegue subito una capability con binding HTTP. Richiede permesso sul connettore e conferma esplicita per rischio alto o critico. Per scritture live invia un Idempotency-Key stabile (massimo 255 caratteri): un esito incerto non viene ritentato automaticamente. Con una AppKey test valida i parametri senza chiamare il sistema esterno e restituisce test: true."

#: src/features/console/pages/DevelopersPage.tsx:80
msgid "Esegue un'azione dichiarata da un connettore del progetto (scope actions:write). Le azioni a rischio alto o critico non partono mai da qui: richiedono la conferma esplicita del flusso proponi → esegui."
msgstr "Esegue un'azione dichiarata da un connettore del progetto (scope actions:write). Le azioni a rischio alto o critico non partono mai da qui: richiedono la conferma esplicita del flusso proponi → esegui."

#: src/features/console/docs/content.ts:1874
msgid "Esegue un'intera sync: apre, spinge tutto in batch, completa. L'iterabile è consumato pigramente (streaming di milioni di record)."
msgstr "Esegue un'intera sync: apre, spinge tutto in batch, completa. L'iterabile è consumato pigramente (streaming di milioni di record)."

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:314
#: src/features/automations/components/AutomationsHub.tsx:373
#: src/features/console/connectors/TestConnectorActionModal.tsx:168
#: src/features/console/flows/ConsoleFlowEditor.tsx:268
#: src/features/console/pages/FlowsPage.tsx:611
#: src/features/console/pages/FlowsPage.tsx:1044
#: src/features/console/pages/PlaygroundPage.tsx:2053
#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:102
msgid "Esegui"
msgstr "Esegui"

#. placeholder {0}: automation.name
#: src/features/automations/components/AutomationsHub.tsx:371
msgid "Esegui {0} ora"
msgstr "Esegui {0} ora"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:380
msgid "Esegui anteprima query"
msgstr "Esegui anteprima query"

#: src/features/console/pages/PlaygroundPage.tsx:1798
msgid "Esegui come AppKey"
msgstr "Esegui come AppKey"

#: src/features/console/flows/ConsoleFlowEditor.tsx:284
msgid "Esegui con documento"
msgstr "Esegui con documento"

#: src/features/console/pages/DevelopersPage.tsx:232
msgid "Esegui il comando nel tuo strumento: Ando compare tra i server MCP."
msgstr "Esegui il comando nel tuo strumento: Ando compare tra i server MCP."

#: src/features/automations/components/CreateAutomationDialog.tsx:228
msgid "Esegui il riassunto settimanale delle vendite e invialo via email il lunedì alle 9."
msgstr "Esegui il riassunto settimanale delle vendite e invialo via email il lunedì alle 9."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:451
msgid "Esegui l'anteprima per vedere il campione dei risultati."
msgstr "Esegui l'anteprima per vedere il campione dei risultati."

#: src/features/console/docs/content.ts:1135
msgid "Esegui l'azione"
msgstr "Esegui l'azione"

#: src/features/agent-modes/components/AgentModesList.tsx:112
msgid "Esegui l'upgrade del piano per creare profili AI personalizzati con prompt e capacità dedicate."
msgstr "Esegui l'upgrade del piano per creare profili AI personalizzati con prompt e capacità dedicate."

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:127
#: src/routes/_authed/workspace/flows.index.tsx:419
msgid "Esegui ora"
msgstr "Esegui ora"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:372
msgid "Esegui provisioning"
msgstr "Esegui provisioning"

#: src/features/help/components/ShortcutsList.tsx:137
msgid "Esegui query SQL nell'editor"
msgstr "Esegui query SQL nell'editor"

#: src/features/console/pages/FlowsPage.tsx:896
msgid "Esegui test"
msgstr "Esegui test"

#: src/features/skills/components/SkillCardParts.tsx:57
msgid "Eseguibile"
msgstr "Eseguibile"

#: src/features/console/pages/FlowsPage.tsx:1018
msgid "Eseguire il flow?"
msgstr "Eseguire il flow?"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:21
#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:250
msgid "Eseguita"
msgstr "Eseguita"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:67
msgid "Eseguito (umano)"
msgstr "Eseguito (umano)"

#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:102
msgid "Eseguo…"
msgstr "Eseguo…"

#: src/features/console/pages/DocsPage.tsx:149
#: src/features/integrations/parts/ConnectorDetailSection.tsx:128
msgid "Esempi"
msgstr "Esempi"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:121
msgid "esempi e affinamenti maturati con le query precedenti"
msgstr "esempi e affinamenti maturati con le query precedenti"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:128
msgid "Esempi few-shot"
msgstr "Esempi few-shot"

#: src/features/console/pages/BillingPage.tsx:461
msgid "Esente"
msgstr "Esente"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:266
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:268
msgid "Esercizio chiuso"
msgstr "Esercizio chiuso"

#: src/features/hive-flows/components/ConditionBuilder.tsx:106
msgid "esiste"
msgstr "esiste"

#: src/features/console/connectors/TestConnectorActionModal.tsx:368
msgid "Esito riportato dalla tua app"
msgstr "Esito riportato dalla tua app"

#. placeholder {0}: entry.outcome_notes
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:333
msgid "Esito: {0}"
msgstr "Esito: {0}"

#: src/features/dashboard/components/ChartActionsMenu.tsx:161
#: src/features/sync/components/DocSyncManager.tsx:998
#: src/features/sync/components/DocSyncManager.tsx:1262
msgid "Espandi"
msgstr "Espandi"

#. placeholder {0}: node.name
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:746
msgid "Espandi {0}"
msgstr "Espandi {0}"

#: src/features/chat/components/ConversationSidebar.tsx:662
#: src/features/chat/components/ConversationSidebar.tsx:733
msgid "Espandi {label}"
msgstr "Espandi {label}"

#: src/features/briefing/BriefCard.tsx:169
msgid "Espandi briefing"
msgstr "Espandi briefing"

#: src/routes/_authed/route.tsx:2504
msgid "Espandi composer · ⌘⇧E"
msgstr "Espandi composer · ⌘⇧E"

#: src/routes/_authed/route.tsx:2503
msgid "Espandi composer (⌘⇧E)"
msgstr "Espandi composer (⌘⇧E)"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:71
msgid "Espandi con dettagli pertinenti senza inventare fatti."
msgstr "Espandi con dettagli pertinenti senza inventare fatti."

#: src/features/onboarding/GuideBoxHeader.tsx:41
msgid "Espandi la guida"
msgstr "Espandi la guida"

#: src/features/chat/components/ConversationMiniRail.tsx:219
#: src/features/console/components/ConsoleShell.tsx:417
msgid "Espandi la sidebar"
msgstr "Espandi la sidebar"

#: src/features/sources/components/EmailThreadMessages.tsx:152
msgid "Espandi tutti"
msgstr "Espandi tutti"

#: src/features/chat/hooks/useThinkingHops.ts:56
msgid "Espando il contesto"
msgstr "Espando il contesto"

#: src/features/chat/wsHandlers.ts:487
msgid "Espando il contesto…"
msgstr "Espando il contesto…"

#: src/features/account/components/UserMenuButton.tsx:416
msgid "Esperienza"
msgstr "Esperienza"

#: src/features/admin/components/AdminHypermem.tsx:92
msgid "Esperimenti A/B"
msgstr "Esperimenti A/B"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:262
msgid "Esperimenti A/B attivi"
msgstr "Esperimenti A/B attivi"

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:28
msgid "Esperto"
msgstr "Esperto"

#: src/features/structured-data/components/CadDataPanel.tsx:377
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:747
msgid "Esplora connessione"
msgstr "Esplora connessione"

#: src/features/console/docs/content.ts:1434
msgid "Esplora Drive"
msgstr "Esplora Drive"

#: src/features/console/pages/OverviewPage.tsx:301
msgid "Esplora i contenuti"
msgstr "Esplora i contenuti"

#: src/features/console/pages/FlowsPage.tsx:802
msgid "Esplora i template"
msgstr "Esplora i template"

#: ../../packages/ui/src/ando/sources/banking-tx/BankingActions.tsx:32
#: ../../packages/ui/src/ando/sources/pdf/PDFActions.tsx:43
#: src/features/chat/components/ConversationSidebar.tsx:1172
#: src/features/sources/components/ArtifactPane.tsx:2354
msgid "Esporta"
msgstr "Esporta"

#: src/features/console/docs/content.ts:113
msgid "Esporta base URL e chiave, poi chiama GET /me: risponde con l'identità del project (tenant, scope, tier). Se la chiave è valida, sei pronto."
msgstr "Esporta base URL e chiave, poi chiama GET /me: risponde con l'identità del project (tenant, scope, tier). Se la chiave è valida, sei pronto."

#: src/features/dxf/components/DxfBomButton.tsx:76
#: src/features/structured-data/components/CadDataPanel.tsx:387
#: src/features/structured-data/components/CadQueryCard.tsx:160
msgid "Esporta BOM"
msgstr "Esporta BOM"

#: src/features/chat/components/ConversationCommandPalette.tsx:190
msgid "Esporta conversazione corrente"
msgstr "Esporta conversazione corrente"

#: ../../packages/ui/src/ando/sources/db-row/DBActions.tsx:32
#: src/features/admin/components/AdminOrgs.tsx:921
msgid "Esporta CSV"
msgstr "Esporta CSV"

#. placeholder {0}: file.filename
#: src/features/dxf/components/DxfBomButton.tsx:92
msgid "Esporta distinta base per {0}"
msgstr "Esporta distinta base per {0}"

#: src/features/settings/components/DataExport.tsx:89
msgid "Esporta i miei dati"
msgstr "Esporta i miei dati"

#: src/routes/_authed/route.tsx:1119
msgid "Esporta la chat come Markdown"
msgstr "Esporta la chat come Markdown"

#: src/routes/_authed/route.tsx:1133
msgid "esporta la conversazione in Markdown"
msgstr "esporta la conversazione in Markdown"

#: src/features/dxf/components/DxfBomButton.tsx:98
msgid "Esporta la distinta base in Excel"
msgstr "Esporta la distinta base in Excel"

#: src/features/structured-data/components/CadDataPanel.tsx:231
#: src/features/structured-data/components/CadQueryCard.tsx:90
msgid "Esportazione BOM in arrivo con il visualizzatore CAD (PR-A7)."
msgstr "Esportazione BOM in arrivo con il visualizzatore CAD (PR-A7)."

#: src/features/hive-flows/run/ProposalReview.tsx:834
msgid "Esportazione Excel non riuscita"
msgstr "Esportazione Excel non riuscita"

#: src/features/settings/components/DataExport.tsx:231
msgid "Esportazione fallita"
msgstr "Esportazione fallita"

#: src/features/sources/components/ArtifactPane.tsx:2028
msgid "Esportazione fallita: {reason}"
msgstr "Esportazione fallita: {reason}"

#: src/features/automations/components/ScheduleEditor.tsx:241
msgid "Espressione cron (UTC)"
msgstr "Espressione cron (UTC)"

#: src/features/voice_report/components/NewReportDialog.tsx:162
msgid "Espressione cron non valida (5 campi)"
msgstr "Espressione cron non valida (5 campi)"

#: src/features/console/flows/ConsoleFlowEditor.tsx:53
#: src/routes/_authed/workspace/flows.$flowId.tsx:66
msgid "Essenziale"
msgstr "Essenziale"

#: src/features/connect/components/MemberManager.tsx:375
msgid "Esterno"
msgstr "Esterno"

#: ../../packages/ui/src/ando/sources/pdf/PDFActions.tsx:28
msgid "Estrai action items"
msgstr "Estrai action items"

#: src/features/settings/marp/PptxExtractPanel.tsx:183
msgid "Estrai CSS"
msgstr "Estrai CSS"

#: src/features/sources/components/ArtifactPane.tsx:2009
msgid "Estrai gli action items da \"{filename}\" con scadenze e responsabili."
msgstr "Estrai gli action items da \"{filename}\" con scadenze e responsabili."

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1425
msgid "Estratto da fonte — clicca per aprire"
msgstr "Estratto da fonte — clicca per aprire"

#: src/features/dxf/components/DxfEmptyHero.tsx:60
msgid "Estrazione"
msgstr "Estrazione"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1506
msgid "Estrazione dei dati"
msgstr "Estrazione dei dati"

#: src/features/settings/marp/PptxExtractPanel.tsx:68
msgid "Estrazione fallita: {reason}"
msgstr "Estrazione fallita: {reason}"

#: src/features/settings/marp/PptxExtractPanel.tsx:182
msgid "Estrazione…"
msgstr "Estrazione…"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:974
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1304
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1525
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2170
#: src/features/connectors/wizards/vatVerifierSpec.tsx:45
msgid "Etichetta"
msgstr "Etichetta"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:169
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1060
msgid "Etichetta (facoltativa)"
msgstr "Etichetta (facoltativa)"

#. placeholder {0}: i + 1
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2206
msgid "Etichetta {0}"
msgstr "Etichetta {0}"

#: src/features/dashboard/components/AxisConfigurator.tsx:386
msgid "Etichetta asse X"
msgstr "Etichetta asse X"

#: src/features/dashboard/components/AxisConfigurator.tsx:403
msgid "Etichetta asse Y"
msgstr "Etichetta asse Y"

#: src/features/hive-flows/components/FlowFormPublish.tsx:161
msgid "Etichetta campo"
msgstr "Etichetta campo"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:752
msgid "Etichette"
msgstr "Etichette"

#. placeholder {0}: userLabels.length
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:774
msgid "Etichette personali ({0})"
msgstr "Etichette personali ({0})"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:57
msgid "Europe West 1 (Belgium)"
msgstr "Europe West 1 (Belgium)"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:58
msgid "Europe West 3 (Frankfurt)"
msgstr "Europe West 3 (Frankfurt)"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:59
msgid "Europe West 4 (Netherlands)"
msgstr "Europe West 4 (Netherlands)"

#: src/features/admin/components/orgs/AuditLogList.tsx:121
#: src/features/console/pages/OverviewPage.tsx:277
msgid "eventi"
msgstr "eventi"

#: src/features/console/pages/TracesPage.tsx:295
#: src/features/console/webhooks/WebhooksPanel.tsx:526
msgid "Eventi"
msgstr "Eventi"

#: src/features/console/webhooks/WebhooksPanel.tsx:369
msgid "Eventi da ricevere"
msgstr "Eventi da ricevere"

#: src/features/console/connectors/meta.ts:106
msgid "Eventi e disponibilità dei calendari autorizzati"
msgstr "Eventi e disponibilità dei calendari autorizzati"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:274
msgid "Eventi grezzi catturati nelle ultime sessioni"
msgstr "Eventi grezzi catturati nelle ultime sessioni"

#: src/features/console/pages/KeyDetailPage.tsx:488
msgid "Eventi più recenti per primi."
msgstr "Eventi più recenti per primi."

#: src/features/console/pages/TracesPage.tsx:389
msgid "Eventi registrati"
msgstr "Eventi registrati"

#: src/features/connectors/wizards/calendarSpec.tsx:33
msgid "Eventi, brief pre-meeting, finestre di disponibilità"
msgstr "Eventi, brief pre-meeting, finestre di disponibilità"

#: src/features/admin/components/orgs/AuditLogList.tsx:121
msgid "evento"
msgstr "evento"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:37
msgid "evento calendario"
msgstr "evento calendario"

#: src/features/sources/components/CalendarEventPane.tsx:284
msgid "Evento eliminato"
msgstr "Evento eliminato"

#: src/routes/_authed/workspace/calendar.tsx:1585
msgid "Evento non trovato"
msgstr "Evento non trovato"

#: src/features/sources/components/CalendarEventPane.tsx:298
msgid "Evento riprogrammato"
msgstr "Evento riprogrammato"

#: src/features/connectors/components/management/BusinessContextEditor.tsx:200
msgid "Eventuali modifiche manuali verranno sovrascritte dal testo generato dall'AI. L'operazione richiede 10-30 secondi."
msgstr "Eventuali modifiche manuali verranno sovrascritte dal testo generato dall'AI. L'operazione richiede 10-30 secondi."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:311
msgid "Evidence"
msgstr "Evidence"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:424
msgid "Evidenza certificata"
msgstr "Evidenza certificata"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:407
msgid "Evolution log"
msgstr "Evolution log"

#: src/features/admin/components/AdminHypermem.tsx:93
msgid "Evolution Log"
msgstr "Evolution Log"

#: src/routes/_authed/workspace/documents.tsx:1120
#: src/routes/_authed/workspace/documents.tsx:1121
msgid "Excel"
msgstr "Excel"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:50
msgid "Excel / Google Sheets caricati"
msgstr "Excel / Google Sheets caricati"

#: src/features/dxf/components/DxfEmptyHero.tsx:67
msgid "Excel pronta in 1 click"
msgstr "Excel pronta in 1 click"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:186
msgid "Excel, CSV e Google Sheets in 1 click"
msgstr "Excel, CSV e Google Sheets in 1 click"

#: src/features/billing/components/UsageInsightsCard.tsx:180
msgid "expert"
msgstr "expert"

#: src/features/console/docs/content.ts:1991
msgid "expires_at superato."
msgstr "expires_at superato."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:65
msgid "F24 + cartelle"
msgstr "F24 + cartelle"

#: src/routes/_authed/workspace/finance.tsx:1788
msgid "F24 in scadenza nei prossimi 30 giorni"
msgstr "F24 in scadenza nei prossimi 30 giorni"

#: src/features/console/docs/content.ts:1733
msgid "Fa il polling fino a uno stato terminale; ritenta i transienti (429/5xx/rete)."
msgstr "Fa il polling fino a uno stato terminale; ritenta i transienti (429/5xx/rete)."

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:215
msgid "Facebook SDK not ready"
msgstr "Facebook SDK not ready"

#: src/features/sales/components/CreateCampaignDialog.tsx:107
msgid "Facoltativo. Più è preciso il profilo, migliori sono i lead trovati."
msgstr "Facoltativo. Più è preciso il profilo, migliori sono i lead trovati."

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:210
msgid "Fact text"
msgstr "Fact text"

#: src/features/admin/components/AdminHypermem.tsx:94
msgid "Facts Browser"
msgstr "Facts Browser"

#: src/routes/connect.space.$spaceId.tsx:133
msgid "Fai una domanda. Ando risponde solo dalle fonti condivise con te in questo spazio."
msgstr "Fai una domanda. Ando risponde solo dalle fonti condivise con te in questo spazio."

#: src/features/connect/components/ConnectChat.tsx:264
msgid "Fai una domanda. Ando risponde solo dalle fonti condivise in questo spazio."
msgstr "Fai una domanda. Ando risponde solo dalle fonti condivise in questo spazio."

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:497
msgid "Failed to initialise OnlyOffice editor"
msgstr "Failed to initialise OnlyOffice editor"

#: src/features/connectors/hooks/useFacebookSDK.ts:116
msgid "Failed to load Facebook SDK"
msgstr "Failed to load Facebook SDK"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:99
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:188
msgid "Fallimento"
msgstr "Fallimento"

#: src/features/console/docs/content.ts:1976
msgid "Fallimento di trasporto (DNS/connect/TLS/timeout)."
msgstr "Fallimento di trasporto (DNS/connect/TLS/timeout)."

#: src/features/console/components/StatusBadges.tsx:167
#: src/features/console/webhooks/WebhooksPanel.tsx:98
msgid "Fallita"
msgstr "Fallita"

#: src/features/console/pages/FlowsPage.tsx:204
msgid "Fallite"
msgstr "Fallite"

#: src/features/console/pages/DocumentsPage.tsx:96
msgid "Falliti"
msgstr "Falliti"

#: src/features/console/components/StatusBadges.tsx:85
#: src/features/console/components/StatusBadges.tsx:86
#: src/features/console/components/StatusBadges.tsx:204
#: src/features/voice_report/components/RunStatusBadge.tsx:60
msgid "Fallito"
msgstr "Fallito"

#: ../../packages/ui/src/editors/AiCellPopover.tsx:69
msgid "FALSO"
msgstr "FALSO"

#: src/features/clean-control/components/EventDetailSheet.tsx:217
#: src/features/clean-control/components/EventRow.tsx:588
#: src/features/clean-control/components/SignalHealthCard.tsx:140
msgid "Falso positivo"
msgstr "Falso positivo"

#: src/routes/_authed/_modal/settings/help.tsx:37
msgid "FAQ · contatti supporto"
msgstr "FAQ · contatti supporto"

#: src/features/sales/components/crm/CreateDealDialog.tsx:150
#: src/features/sales/components/crm/CreateDealDialog.tsx:155
#: src/features/sales/components/crm/DealDetailDrawer.tsx:145
#: src/features/sales/components/crm/DealDetailDrawer.tsx:152
msgid "Fase"
msgstr "Fase"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:349
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:355
msgid "Fase 1 di 3 · più recenti (24h)"
msgstr "Fase 1 di 3 · più recenti (24h)"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:351
msgid "Fase 2 di 3 · ultimi 3 mesi"
msgstr "Fase 2 di 3 · ultimi 3 mesi"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:353
msgid "Fase 3 di 3 · ultimi 6 mesi"
msgstr "Fase 3 di 3 · ultimi 6 mesi"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:25
msgid "Fase aggiornata"
msgstr "Fase aggiornata"

#: src/features/admin/components/AdminCpqCanvas.tsx:150
msgid "Fasi del percorso"
msgstr "Fasi del percorso"

#: src/routes/_authed/workspace/work.tsx:283
msgid "Fatte"
msgstr "Fatte"

#: src/features/settings/components/SelfProfileMemory.tsx:82
msgid "Fatti errati o obsoleti"
msgstr "Fatti errati o obsoleti"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:392
#: src/features/console/components/FirstRunTimeline.tsx:93
#: src/features/report/components/ReportDateFilter.tsx:199
msgid "Fatto"
msgstr "Fatto"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:68
msgid "Fattura di riferimento"
msgstr "Fattura di riferimento"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:154
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:123
msgid "Fattura n. {invoiceNumber}"
msgstr "Fattura n. {invoiceNumber}"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:53
msgid "Fattura SDI"
msgstr "Fattura SDI"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:61
msgid "Fattura Stripe"
msgstr "Fattura Stripe"

#: src/features/console/pages/BillingPage.tsx:398
msgid "Fattura Stripe con pagamento manuale"
msgstr "Fattura Stripe con pagamento manuale"

#. placeholder {0}: number ? ` n. ${number}` : ""
#. placeholder {1}: docType ? ` · ${docType}` : ""
#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:52
msgid "Fattura{0}{1}"
msgstr "Fattura{0}{1}"

#: src/features/connectors/wizards/accountingSpec.tsx:120
msgid "Fatturato in linguaggio naturale"
msgstr "Fatturato in linguaggio naturale"

#: src/features/account/components/UserMenuButton.tsx:404
#: src/features/console/components/ConsoleShell.tsx:250
#: src/features/console/pages/BillingPage.tsx:104
#: src/features/settings/components/BillingSettings.tsx:85
msgid "Fatturazione"
msgstr "Fatturazione"

#: src/features/admin/components/AdminBilling.tsx:49
msgid "Fatturazione a consumo (Stripe)"
msgstr "Fatturazione a consumo (Stripe)"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:156
msgid "Fatturazione attiva"
msgstr "Fatturazione attiva"

#: src/routes/_authed/workspace/finance.tsx:1634
msgid "Fatturazione e CRM collegati"
msgstr "Fatturazione e CRM collegati"

#: src/routes/_authed/workspace/finance.tsx:1212
msgid "Fatturazione elettronica"
msgstr "Fatturazione elettronica"

#: src/features/billing/components/CurrentPlanCard.tsx:147
msgid "Fatturazione non abilitata su questo ambiente."
msgstr "Fatturazione non abilitata su questo ambiente."

#: src/features/connectors/wizards/sdiSpec.tsx:42
msgid "Fatturazione SDI"
msgstr "Fatturazione SDI"

#: src/routes/_authed/workspace/work.tsx:615
msgid "fatture"
msgstr "fatture"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:584
#: src/features/console/pages/BillingPage.tsx:569
#: src/features/console/pages/BillingPage.tsx:572
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:41
#: src/features/workspace/config.ts:354
#: src/routes/_authed/workspace/finance.tsx:261
#: src/routes/_authed/workspace/finance.tsx:1210
msgid "Fatture"
msgstr "Fatture"

#: src/routes/_authed/workspace/finance.tsx:1710
msgid "Fatture attive in scadenza nei prossimi 7 giorni"
msgstr "Fatture attive in scadenza nei prossimi 7 giorni"

#: src/features/chat/components/ChatEmptyState.tsx:125
msgid "Fatture in arrivo"
msgstr "Fatture in arrivo"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:157
#: src/features/clean-control/components/EventQueue.tsx:101
msgid "Fatture in Cloud"
msgstr "Fatture in Cloud"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:131
msgid "Fatture piattaforma"
msgstr "Fatture piattaforma"

#: src/features/chat/components/ChatEmptyState.tsx:171
msgid "Fatture scadute"
msgstr "Fatture scadute"

#: src/features/console/connectors/meta.ts:97
msgid "Fatture, documenti contabili e anagrafiche"
msgstr "Fatture, documenti contabili e anagrafiche"

#: src/features/connectors/wizards/accountingSpec.tsx:72
msgid "Fatture, prima nota, scadenziario — Fatture in Cloud o SAP Business One"
msgstr "Fatture, prima nota, scadenziario — Fatture in Cloud o SAP Business One"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:325
#: src/features/settings/components/OrganizationSettings.tsx:274
msgid "Favicon"
msgstr "Favicon"

#: src/features/settings/components/OrganizationSettings.tsx:251
msgid "Favicon URL"
msgstr "Favicon URL"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:901
msgid "Feature"
msgstr "Feature"

#: src/features/structured-data/components/SimilarPartsSection.tsx:118
msgid "Features"
msgstr "Features"

#: src/features/projects/components/sections/MemorySection.tsx:61
msgid "Feedback"
msgstr "Feedback"

#: src/features/chat/hooks/useMessageActions.ts:110
msgid "Feedback non salvato"
msgstr "Feedback non salvato"

#: src/features/clean-control/components/EventDetailSheet.tsx:170
msgid "Feedback su questo evento"
msgstr "Feedback su questo evento"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:360
msgid "Feedback utente"
msgstr "Feedback utente"

#: src/routes/_authed/workspace/sales.tsx:113
msgid "Ferme"
msgstr "Ferme"

#: src/features/price-lists/utils/formatItem.ts:34
msgid "Ferramenta"
msgstr "Ferramenta"

#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:32
msgid "Festività"
msgstr "Festività"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1226
msgid "Fidati del certificato del server"
msgstr "Fidati del certificato del server"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1306
msgid "Figura Lab"
msgstr "Figura Lab"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:164
msgid "file"
msgstr "file"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:253
msgid "File"
msgstr "File"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:368
msgid "file (sync ricorsivo)"
msgstr "file (sync ricorsivo)"

#: src/routes/_authed/workspace/documents.tsx:1014
msgid "File aziendali recenti"
msgstr "File aziendali recenti"

#: src/features/price-lists/components/PriceListsPage.tsx:265
msgid "File caricati manualmente (Excel · PDF · Word)"
msgstr "File caricati manualmente (Excel · PDF · Word)"

#: src/features/workspace/lib/ingestionToast.ts:79
msgid "File caricato"
msgstr "File caricato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:162
msgid "File cloud"
msgstr "File cloud"

#: src/features/sync/components/DocSyncManager.tsx:894
msgid "file da sincronizzare"
msgstr "file da sincronizzare"

#: src/features/sync/components/DocSyncManager.tsx:656
msgid "File e cartelle tracciati"
msgstr "File e cartelle tracciati"

#: src/features/sync/components/DocSyncManager.tsx:581
msgid "File e cartelle tracciati. Seleziona cosa sincronizzare o aggiungine altri."
msgstr "File e cartelle tracciati. Seleziona cosa sincronizzare o aggiungine altri."

#: src/features/console/pages/ConnectorsPage.tsx:156
msgid "File e knowledge"
msgstr "File e knowledge"

#: src/features/connectors/wizards/databaseSpec.tsx:173
msgid "File embedded"
msgstr "File embedded"

#: src/features/workspace/documents/components/FolderBrowserView.tsx:298
msgid "File nella cartella"
msgstr "File nella cartella"

#: src/features/sync/components/DocSyncManager.tsx:712
msgid "File singoli"
msgstr "File singoli"

#: src/features/connectors/wizards/databaseSpec.tsx:225
msgid "File SQLite"
msgstr "File SQLite"

#: src/features/connectors/wizards/filesystemSpec.tsx:50
#: src/features/console/components/KeyMeta.tsx:57
msgid "File system"
msgstr "File system"

#. placeholder {0}: formatSize(file.size)
#. placeholder {1}: formatSize(MAX_BYTES)
#: src/features/workspace/components/UploadModal.tsx:144
msgid "File troppo grande ({0}, max {1})"
msgstr "File troppo grande ({0}, max {1})"

#: src/features/settings/marp/PptxExtractPanel.tsx:83
msgid "File troppo grande ({sizeMb} MB · max 20 MB)"
msgstr "File troppo grande ({sizeMb} MB · max 20 MB)"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:74
msgid "File troppo grande ({sizeMb} MB · max 25 MB)"
msgstr "File troppo grande ({sizeMb} MB · max 25 MB)"

#. placeholder {0}: started.max_parts
#: src/features/connectors/hooks/useChunkedSpreadsheetUpload.ts:144
msgid "File troppo grande per il chunking ({totalParts} > {0} parti)."
msgstr "File troppo grande per il chunking ({totalParts} > {0} parti)."

#: src/features/console/connectors/meta.ts:124
msgid "File, cartelle e drive condivisi a cui l'account ha accesso"
msgstr "File, cartelle e drive condivisi a cui l'account ha accesso"

#: src/features/connectors/components/vendorIcons.tsx:174
#: src/features/connectors/components/vendorIcons.tsx:531
msgid "Filesystem locale"
msgstr "Filesystem locale"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:102
msgid "Filetto"
msgstr "Filetto"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:230
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:174
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:509
msgid "Filtra"
msgstr "Filtra"

#: src/features/connectors/wizards/messagingSpec.tsx:93
msgid "Filtra canali"
msgstr "Filtra canali"

#: src/features/console/pages/TracesPage.tsx:318
msgid "Filtra componenti, call ID o eventi"
msgstr "Filtra componenti, call ID o eventi"

#: src/features/console/pages/TracesPage.tsx:319
msgid "Filtra eventi"
msgstr "Filtra eventi"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:72
msgid "Filtra i dati per intervallo di tempo"
msgstr "Filtra i dati per intervallo di tempo"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:240
msgid "Filtra il corpus per feature, materiale e diametro — la risposta arriva da dati strutturati."
msgstr "Filtra il corpus per feature, materiale e diametro — la risposta arriva da dati strutturati."

#: src/routes/_authed/_modal/integrations/index.tsx:399
msgid "Filtra per categoria"
msgstr "Filtra per categoria"

#: src/features/clean-control/components/EventQueue.tsx:203
msgid "Filtra per dimensione"
msgstr "Filtra per dimensione"

#: src/features/admin/components/AdminUsers.tsx:248
msgid "Filtra per ruolo"
msgstr "Filtra per ruolo"

#: src/features/agent-modes/components/AgentModesList.tsx:224
msgid "Filtra per scope"
msgstr "Filtra per scope"

#: src/features/clean-control/components/EventQueue.tsx:215
msgid "Filtra per severità"
msgstr "Filtra per severità"

#: src/features/clean-control/components/EventQueue.tsx:227
msgid "Filtra per sorgente"
msgstr "Filtra per sorgente"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:421
msgid "Filtra per specialist"
msgstr "Filtra per specialist"

#: src/features/admin/components/AdminCpqList.tsx:94
#: src/features/admin/components/AdminOrgs.tsx:884
#: src/features/admin/components/AdminUsers.tsx:260
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:434
#: src/features/console/pages/ConnectorsPage.tsx:292
#: src/features/console/pages/DocumentsPage.tsx:699
msgid "Filtra per stato"
msgstr "Filtra per stato"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:618
msgid "Filtra per status"
msgstr "Filtra per status"

#: src/features/admin/components/AdminOrgs.tsx:868
msgid "Filtra per tier"
msgstr "Filtra per tier"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:154
msgid "Filtra per User ID"
msgstr "Filtra per User ID"

#: src/features/console/pages/TracesPage.tsx:331
msgid "Filtra registri tecnici"
msgstr "Filtra registri tecnici"

#: src/routes/_authed/workspace/canvases.tsx:267
msgid "Filtra suggerimenti per tipo"
msgstr "Filtra suggerimenti per tipo"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:234
msgid "Filtra una porzione del disegno"
msgstr "Filtra una porzione del disegno"

#: src/features/clean-control/components/EventQueue.tsx:200
#: src/features/dashboard/components/CrossFilterBar.tsx:73
#: src/features/workspace/components/SubTabBar.tsx:96
#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:57
#: src/routes/_authed/workspace/calendar.tsx:745
#: src/routes/_authed/workspace/documents.tsx:903
#: src/routes/_authed/workspace/documents.tsx:915
#: src/routes/_authed/workspace/finance.tsx:311
#: src/routes/_authed/workspace/work.tsx:346
msgid "Filtri"
msgstr "Filtri"

#: src/routes/_authed/workspace/finance.tsx:310
msgid "Filtri amministrazione"
msgstr "Filtri amministrazione"

#: src/routes/_authed/workspace/calendar.tsx:744
msgid "Filtri calendario"
msgstr "Filtri calendario"

#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:56
msgid "Filtri conversazioni"
msgstr "Filtri conversazioni"

#: ../../packages/ui/src/workspace/WorkspaceSearchBar.tsx:273
msgid "Filtri di ricerca"
msgstr "Filtri di ricerca"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:275
msgid "Filtri di sincronizzazione chat"
msgstr "Filtri di sincronizzazione chat"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:299
msgid "Filtri di sincronizzazione email"
msgstr "Filtri di sincronizzazione email"

#: src/routes/_authed/workspace/documents.tsx:902
msgid "Filtri documenti"
msgstr "Filtri documenti"

#: src/routes/_authed/workspace/work.tsx:345
msgid "Filtri lavoro"
msgstr "Filtri lavoro"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:478
msgid "Filtri rapidi"
msgstr "Filtri rapidi"

#: src/features/dashboard/components/DashboardChartCard.tsx:706
msgid "filtro"
msgstr "filtro"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:101
msgid "Filtro"
msgstr "Filtro"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:170
msgid "Filtro dataset (avanzato)"
msgstr "Filtro dataset (avanzato)"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:258
msgid "Filtro feature"
msgstr "Filtro feature"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:109
msgid "Filtro importo"
msgstr "Filtro importo"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:74
msgid "Filtro materiale"
msgstr "Filtro materiale"

#: src/features/report/components/ReportDateFilter.tsx:120
msgid "Filtro per data"
msgstr "Filtro per data"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:385
msgid "Filtro pronto"
msgstr "Filtro pronto"

#: src/routes/_authed/workspace/canvases.tsx:199
msgid "Filtro stato canvases"
msgstr "Filtro stato canvases"

#: src/features/console/pages/TracesPage.tsx:546
msgid "Filtro sulle richieste caricate. Carica altre richieste per estendere la ricerca."
msgstr "Filtro sulle richieste caricate. Carica altre richieste per estendere la ricerca."

#: src/features/dashboard/components/DashboardChartCard.tsx:703
#: src/features/dashboard/components/DashboardChartCard.tsx:715
#: src/features/dashboard/components/DashboardChartCard.tsx:716
msgid "Filtro temporale attivo"
msgstr "Filtro temporale attivo"

#: src/features/report/lib/useReportLifecycle.ts:85
msgid "Finale"
msgstr "Finale"

#: src/features/briefing/BriefCard.tsx:122
msgid "Finanze"
msgstr "Finanze"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:179
msgid "Finché questa data è vuota o futura l'organizzazione non paga nulla: nessuna fattura a consumo e nessun addebito per le licenze."
msgstr "Finché questa data è vuota o futura l'organizzazione non paga nulla: nessuna fattura a consumo e nessun addebito per le licenze."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:316
#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:333
#: src/features/console/components/OverlapRotationModal.tsx:100
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:654
#: src/features/console/webhooks/WebhooksPanel.tsx:291
msgid "Fine"
msgstr "Fine"

#: src/features/admin/components/MaintenanceControl.tsx:236
msgid "Fine (stima)"
msgstr "Fine (stima)"

#: src/routes/_authed/workspace/conversations.tsx:931
msgid "Fine elenco · {visibleCount} thread"
msgstr "Fine elenco · {visibleCount} thread"

#: ../../packages/ui/src/primitives/dialog.tsx:77
msgid "Finestra"
msgstr "Finestra"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:135
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:136
msgid "Finestra di importazione cronologia messaggi scaduta"
msgstr "Finestra di importazione cronologia messaggi scaduta"

#: src/features/clean-control/components/UndoActionsList.tsx:222
msgid "Finestra scaduta"
msgstr "Finestra scaduta"

#: src/features/console/pages/UsagePage.tsx:269
msgid "Finestra temporale"
msgstr "Finestra temporale"

#: src/features/price-lists/utils/formatItem.ts:35
msgid "Finitura"
msgstr "Finitura"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:60
msgid "Finitura superficiale"
msgstr "Finitura superficiale"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:362
msgid "Fino a {MAX_CUSTOM_RANGE_DAYS} giorni."
msgstr "Fino a {MAX_CUSTOM_RANGE_DAYS} giorni."

#. placeholder {0}: fmt(to as Date)
#: src/features/report/components/ReportDateFilter.tsx:95
msgid "Fino al {0}"
msgstr "Fino al {0}"

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:86
#: src/features/sales/components/BatchSendModal.tsx:366
#: src/features/sales/components/SignaturesManager.tsx:255
#: src/features/templates/components/TemplateFieldSpecs.ts:199
msgid "Firma"
msgstr "Firma"

#: src/features/sources/components/InboxDetailPane.tsx:1581
msgid "Firma aziendale"
msgstr "Firma aziendale"

#: src/features/sales/components/BatchSendModal.tsx:359
msgid "Firma da usare"
msgstr "Firma da usare"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:56
msgid "Firma delega"
msgstr "Firma delega"

#: src/features/sales/components/SignaturesManager.tsx:305
msgid "Firma della casella aggiornata"
msgstr "Firma della casella aggiornata"

#: src/features/connectors/wizards/pecSpec.tsx:57
msgid "Firma digitale e marca temporale preservate dall'archivio."
msgstr "Firma digitale e marca temporale preservate dall'archivio."

#: src/features/sales/components/SignaturesManager.tsx:107
msgid "Firma eliminata"
msgstr "Firma eliminata"

#: src/features/sales/components/SignatureSettings.tsx:107
msgid "Firma email"
msgstr "Firma email"

#: src/features/sales/components/SignatureSettings.tsx:74
msgid "Firma organizzazione"
msgstr "Firma organizzazione"

#. placeholder {0}: acc.email
#: src/features/sales/components/SignaturesManager.tsx:353
msgid "Firma per {0}"
msgstr "Firma per {0}"

#: src/features/sales/components/SignaturesManager.tsx:315
msgid "Firma per casella"
msgstr "Firma per casella"

#: src/features/sales/components/SignaturesManager.tsx:119
msgid "Firma predefinita aggiornata"
msgstr "Firma predefinita aggiornata"

#: src/features/sales/components/SignatureSettings.tsx:75
msgid "Firma predefinita impostata dall'organizzazione. È in sola lettura."
msgstr "Firma predefinita impostata dall'organizzazione. È in sola lettura."

#: src/features/sales/components/SignatureSettings.tsx:51
#: src/features/sales/components/SignaturesManager.tsx:95
msgid "Firma salvata"
msgstr "Firma salvata"

#: src/features/workspace/config.ts:355
#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:65
#: src/routes/_authed/workspace/finance.tsx:264
msgid "Fisco"
msgstr "Fisco"

#: src/features/structured-data/components/SimilarPartsSection.tsx:93
msgid "Fisica"
msgstr "Fisica"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:68
#: src/features/chat/components/ConversationSidebar.tsx:1166
msgid "Fissa"
msgstr "Fissa"

#: src/features/chat/components/ConversationSidebar.tsx:456
msgid "Fissate"
msgstr "Fissate"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:123
msgid "Fit"
msgstr "Fit"

#: src/routes/_authed/_modal/settings/changelog.tsx:93
msgid "Fix"
msgstr "Fix"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:43
msgid "flow"
msgstr "flow"

#: src/features/console/pages/FlowDetailPage.tsx:117
#: src/features/console/pages/FlowDetailPage.tsx:123
#: src/features/hive-flows/run/FlowRunSurface.tsx:54
#: src/routes/_authed/workspace/flows.index.tsx:274
msgid "Flow"
msgstr "Flow"

#: src/features/hive-flows/components/FlowActivateControl.tsx:150
msgid "Flow attivato — partirà in automatico"
msgstr "Flow attivato — partirà in automatico"

#: src/features/chat/components/ChatEmptyState.tsx:379
msgid "Flow attivi"
msgstr "Flow attivi"

#: src/routes/_authed/workspace/flows.index.tsx:584
msgid "Flow condivisi dal team"
msgstr "Flow condivisi dal team"

#: src/features/console/pages/FlowsPage.tsx:294
#: src/features/console/pages/FlowsPage.tsx:420
msgid "Flow creato"
msgstr "Flow creato"

#: src/routes/_authed/workspace/flows.index.tsx:142
msgid "Flow duplicato"
msgstr "Flow duplicato"

#: src/routes/_authed/workspace/flows.index.tsx:205
msgid "Flow duplicato: verifica gli account collegati"
msgstr "Flow duplicato: verifica gli account collegati"

#: src/features/console/pages/FlowsPage.tsx:730
#: src/routes/_authed/workspace/flows.index.tsx:114
msgid "Flow eliminato"
msgstr "Flow eliminato"

#: src/routes/_authed/workspace/flows.$flowId.tsx:330
msgid "Flow eseguito"
msgstr "Flow eseguito"

#: src/features/hive-flows/components/FlowActivateControl.tsx:167
msgid "Flow in pausa"
msgstr "Flow in pausa"

#: src/features/console/pages/FlowDetailPage.tsx:159
msgid "Flow non trovato"
msgstr "Flow non trovato"

#: src/features/console/flows/ConsoleFlowEditor.tsx:127
#: src/routes/_authed/workspace/flows.$flowId.tsx:309
msgid "Flow salvato"
msgstr "Flow salvato"

#: src/routes/_authed/workspace/flows.index.tsx:343
msgid "Flow vuoto"
msgstr "Flow vuoto"

#: src/features/console/components/ConsoleShell.tsx:223
#: src/features/console/pages/FlowDetailPage.tsx:116
#: src/features/console/pages/FlowsPage.tsx:739
#: src/features/console/pages/FlowsPage.tsx:760
#: src/features/console/pages/FlowsPage.tsx:779
#: src/features/workspace/config.ts:210
msgid "Flows"
msgstr "Flows"

#: src/features/onboarding/sectionGuides.ts:77
msgid "Flussi visuali per orchestrare processi ricorrenti su più sistemi."
msgstr "Flussi visuali per orchestrare processi ricorrenti su più sistemi."

#: src/features/console/docs/content.ts:566
msgid "Flusso multi-turn"
msgstr "Flusso multi-turn"

#: src/features/console/pages/PlaygroundPage.tsx:881
msgid "Focus"
msgstr "Focus"

#: src/routes/_authed/route.tsx:2521
#: src/routes/_authed/route.tsx:2535
msgid "Focus chat"
msgstr "Focus chat"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:220
msgid "fogli"
msgstr "fogli"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:178
msgid "Fogli"
msgstr "Fogli"

#: src/features/console/connectors/meta.ts:208
msgid "Fogli di calcolo"
msgstr "Fogli di calcolo"

#: src/features/console/connectors/meta.ts:213
msgid "Fogli e intervalli di dati caricati"
msgstr "Fogli e intervalli di dati caricati"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:136
msgid "Fogli rilevati"
msgstr "Fogli rilevati"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:220
msgid "foglio"
msgstr "foglio"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:91
#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:222
#: src/features/connectors/wizards/spreadsheetSpec.tsx:208
#: src/features/dashboard/components/wizard/WizardStepSource.tsx:49
msgid "Foglio"
msgstr "Foglio"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:952
#: src/features/console/components/accessResourceLabels.ts:64
msgid "Foglio di calcolo"
msgstr "Foglio di calcolo"

#: src/features/connectors/components/vendorIcons.tsx:161
#: src/features/connectors/wizards/spreadsheetSpec.tsx:126
msgid "Foglio di Calcolo"
msgstr "Foglio di Calcolo"

#: src/features/connectors/components/vendorIcons.tsx:160
msgid "Foglio di Calcolo (locale)"
msgstr "Foglio di Calcolo (locale)"

#: src/features/connectors/components/vendorIcons.tsx:442
msgid "Foglio di Calcolo (upload locale)"
msgstr "Foglio di Calcolo (upload locale)"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:89
msgid "Foglio Excel"
msgstr "Foglio Excel"

#: src/features/sales/components/FollowUpControl.tsx:78
msgid "Follow-up"
msgstr "Follow-up"

#: src/features/sales/components/FollowUpControl.tsx:58
msgid "Follow-up impostato"
msgstr "Follow-up impostato"

#: src/features/chat/components/ChatEmptyState.tsx:203
msgid "Follow-up opportunità"
msgstr "Follow-up opportunità"

#: src/features/sales/components/FollowUpControl.tsx:58
msgid "Follow-up rimosso"
msgstr "Follow-up rimosso"

#. placeholder {0}: item.subject || i18n._(msg`(senza oggetto)`)
#: src/features/sources/components/InboxDetailPane.tsx:315
#: src/features/sources/components/InboxDetailPane.tsx:565
msgid "Follow-up: {0}"
msgstr "Follow-up: {0}"

#: src/features/sales/components/SignatureRichEditor.tsx:177
msgid "Font"
msgstr "Font"

#: src/features/templates/components/TemplateFieldSpecs.ts:83
msgid "Font · corpo"
msgstr "Font · corpo"

#: src/features/templates/components/TemplateFieldSpecs.ts:70
msgid "Font · intestazioni"
msgstr "Font · intestazioni"

#: src/features/settings/components/BrandKitSettings.tsx:238
msgid "Font caricato"
msgstr "Font caricato"

#: src/features/settings/components/BrandKitSettings.tsx:311
msgid "Font corpo"
msgstr "Font corpo"

#: src/features/sales/components/SignatureRichEditor.tsx:169
msgid "Font della firma"
msgstr "Font della firma"

#: src/features/settings/components/BrandKitSettings.tsx:353
msgid "Font personalizzato caricato"
msgstr "Font personalizzato caricato"

#: src/features/settings/components/BrandKitSettings.tsx:219
msgid "Font scaricato da Google Fonts"
msgstr "Font scaricato da Google Fonts"

#: src/features/settings/components/BrandKitSettings.tsx:310
msgid "Font titoli"
msgstr "Font titoli"

#: src/features/settings/components/BrandKitSettings.tsx:307
msgid "Font usato per titoli e corpo del testo."
msgstr "Font usato per titoli e corpo del testo."

#: ../../packages/ui/src/ando/SourceDrawer.tsx:217
#: src/features/console/pages/PlaygroundPage.tsx:817
msgid "Fonte"
msgstr "Fonte"

#: src/features/console/pages/AccessOverviewPage.tsx:297
msgid "Fonte collegata"
msgstr "Fonte collegata"

#: src/features/connect/components/GrantManager.tsx:366
#: src/features/connect/components/GrantManager.tsx:969
msgid "Fonte connessa"
msgstr "Fonte connessa"

#. placeholder {0}: tables.join(", ")
#: src/features/connect/components/GrantManager.tsx:968
msgid "Fonte connessa · {0}"
msgstr "Fonte connessa · {0}"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:227
msgid "Fonte del prezzo"
msgstr "Fonte del prezzo"

#: src/features/console/pages/ConnectorsPage.tsx:531
msgid "Fonte Engine · accesso iniziale privato"
msgstr "Fonte Engine · accesso iniziale privato"

#: src/features/price-lists/components/PriceListsPage.tsx:320
msgid "Fonte prezzo"
msgstr "Fonte prezzo"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:133
msgid "fonti"
msgstr "fonti"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerReasoning.tsx:66
#: src/features/admin/components/AdminCpq.tsx:575
#: src/features/admin/components/AdminCpqCanvas.tsx:165
#: src/features/canvases/components/CanvasReader.tsx:149
#: src/features/console/components/ConsoleShell.tsx:213
#: src/features/console/pages/ConnectorsPage.tsx:240
#: src/features/sales/components/LeadDetailDrawer.tsx:202
#: src/features/sources/SourceRailSurface.tsx:209
#: src/features/sources/SourceRailSurface.tsx:234
msgid "Fonti"
msgstr "Fonti"

#: src/features/admin/components/AdminCpq.tsx:818
msgid "Fonti aggiuntive"
msgstr "Fonti aggiuntive"

#: src/features/console/pages/ConnectorsPage.tsx:350
#: src/features/console/pages/OverviewPage.tsx:189
#: src/features/price-lists/components/PriceListsPage.tsx:297
msgid "Fonti collegate"
msgstr "Fonti collegate"

#: src/features/connect/components/GrantManager.tsx:134
msgid "Fonti condivise"
msgstr "Fonti condivise"

#. placeholder {0}: primary.title
#: src/features/workspace/components/NudgeClusterRow.tsx:306
msgid "Fonti correlate per {0}"
msgstr "Fonti correlate per {0}"

#: src/features/console/pages/PlaygroundPage.tsx:1971
msgid "Fonti del progetto"
msgstr "Fonti del progetto"

#: src/routes/_authed/route.tsx:1207
msgid "Fonti dell'ultima risposta"
msgstr "Fonti dell'ultima risposta"

#: src/features/admin/components/AdminCpqPriceBook.tsx:319
msgid "Fonti della base di conoscenza (UKS)"
msgstr "Fonti della base di conoscenza (UKS)"

#: src/features/dashboard/components/DashboardChartCard.tsx:728
msgid "Fonti e calcolo"
msgstr "Fonti e calcolo"

#: src/features/admin/components/AdminCpqPriceBook.tsx:246
#: src/features/admin/components/AdminCpqPriceBook.tsx:278
msgid "Fonti incluse"
msgstr "Fonti incluse"

#: src/features/admin/components/AdminCpqAskAndo.tsx:174
msgid "Fonti PoC extra"
msgstr "Fonti PoC extra"

#: src/features/price-lists/components/PriceListsPage.tsx:171
#: src/features/workspace/config.ts:410
#: src/routes/_authed/workspace/technical.tsx:256
msgid "Fonti prezzi"
msgstr "Fonti prezzi"

#: src/features/console/pages/PlaygroundPage.tsx:1225
msgid "Fonti usate"
msgstr "Fonti usate"

#: src/features/console/pages/OverviewPage.tsx:181
msgid "Fonti, contenuti e attività recenti nello stesso spazio operativo."
msgstr "Fonti, contenuti e attività recenti nello stesso spazio operativo."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1309
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1988
#: src/features/structured-data/components/SimilarPartsSection.tsx:88
msgid "Forma"
msgstr "Forma"

#: src/features/projects/components/sections/PersonaSection.tsx:353
#: src/features/templates/components/TemplateFieldSpecs.ts:169
msgid "Formale"
msgstr "Formale"

#. placeholder {0}: Math.round(SPREADSHEET_MAX_UPLOAD_BYTES / 1024 / 1024)
#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:160
msgid "Formati supportati: .xlsx, .xls, .csv · max {0} MB"
msgstr "Formati supportati: .xlsx, .xls, .csv · max {0} MB"

#: src/features/admin/components/AdminDecks.tsx:349
#: src/features/console/pages/DocumentsPage.tsx:311
#: src/features/console/pages/DocumentsPage.tsx:755
#: src/features/settings/components/DataExport.tsx:103
#: src/features/templates/components/TemplateFieldSpecs.ts:122
msgid "Formato"
msgstr "Formato"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:82
msgid "Formato non supportato — carica .docx / .xlsx / .pptx"
msgstr "Formato non supportato — carica .docx / .xlsx / .pptx"

#: src/features/settings/marp/PptxExtractPanel.tsx:93
msgid "Formato non supportato — carica un file .pptx"
msgstr "Formato non supportato — carica un file .pptx"

#: src/features/console/pages/DocumentsPage.tsx:138
msgid "Formato non supportato: sono ammessi PDF, DOCX, TXT e MD."
msgstr "Formato non supportato: sono ammessi PDF, DOCX, TXT e MD."

#: src/features/connectors/components/_spreadsheet/types.tsx:119
msgid "Formato non supportato. Usa .xlsx, .xls o .csv."
msgstr "Formato non supportato. Usa .xlsx, .xls o .csv."

#: src/features/settings/components/BrandKitSettings.tsx:425
msgid "Formato pagina"
msgstr "Formato pagina"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:204
msgid "Formato supportato: .xlsx"
msgstr "Formato supportato: .xlsx"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:674
msgid "Formattazione"
msgstr "Formattazione"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:99
msgid "Foro"
msgstr "Foro"

#: src/features/admin/components/userAdminActions.tsx:190
#: src/features/admin/components/UserDetailContent.tsx:660
msgid "Forza enrolment MFA"
msgstr "Forza enrolment MFA"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:128
msgid "Forza MFA"
msgstr "Forza MFA"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:138
msgid "Forza MFA per i membri"
msgstr "Forza MFA per i membri"

#: src/features/admin/components/UserDetailContent.tsx:728
msgid "Forza reset MFA"
msgstr "Forza reset MFA"

#: src/features/console/pages/SchemaPage.tsx:476
#: src/features/console/pages/SchemaPage.tsx:630
msgid "Frammenti"
msgstr "Frammenti"

#: src/features/console/connectors/SourceHealthSummary.tsx:10
msgid "Frammenti segnalati"
msgstr "Frammenti segnalati"

#: src/features/console/components/DocumentAcquiredContent.tsx:62
msgid "Frammento acquisito"
msgstr "Frammento acquisito"

#: src/features/connectors/wizards/openBankingSpec.tsx:166
msgid "Francia"
msgstr "Francia"

#: src/features/templates/components/TemplateFieldSpecs.ts:202
msgid "Frase di chiusura ricorrente (vuoto = nessuna firma)."
msgstr "Frase di chiusura ricorrente (vuoto = nessuna firma)."

#: src/features/settings/components/BrandKitSettings.tsx:825
msgid "frasi {l}"
msgstr "frasi {l}"

#: src/features/skills/components/SkillEditor.tsx:363
msgid "Frasi che attivano la skill"
msgstr "Frasi che attivano la skill"

#: src/features/skills/components/SkillEditor.tsx:360
msgid "Frasi che la attivano"
msgstr "Frasi che la attivano"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1985
msgid "Freccia"
msgstr "Freccia"

#: src/features/admin/components/AdminRevenue.tsx:115
msgid "Free"
msgstr "Free"

#: src/features/hive-flows/components/DryRunPanel.tsx:144
msgid "Freeza questa query"
msgstr "Freeza questa query"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:296
msgid "Frequenza"
msgstr "Frequenza"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:38
msgid "Full"
msgstr "Full"

#: src/features/console/connectors/CustomConnectorDetail.tsx:673
msgid "Full + mark-and-sweep"
msgstr "Full + mark-and-sweep"

#: src/features/admin/components/AdminEngagement.tsx:213
msgid "Funnel di attivazione"
msgstr "Funnel di attivazione"

#: src/features/studio/components/StudioDrawerContent.tsx:416
msgid "Funzionalità Brand Templates non disponibile sul tuo piano."
msgstr "Funzionalità Brand Templates non disponibile sul tuo piano."

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:307
#: src/features/structured-data/components/SimilarPartsSection.tsx:108
msgid "Funzione"
msgstr "Funzione"

#: src/features/dashboard/utils/calculatedFields.ts:322
msgid "Funzione non riconosciuta"
msgstr "Funzione non riconosciuta"

#: src/features/console/pages/FlowDetailPage.tsx:212
msgid "Fuso orario"
msgstr "Fuso orario"

#. placeholder {0}: control.timezone
#: src/features/structured-data/components/TemporalQueryControl.tsx:275
msgid "Fuso orario: {0}"
msgstr "Fuso orario: {0}"

#: src/features/console/pages/FlowsPage.tsx:344
msgid "Galleria dei template"
msgstr "Galleria dei template"

#: src/features/voice_report/components/NewReportDialog.tsx:1000
#: src/features/voice_report/components/TemplatesGallery.tsx:371
msgid "Gallery dei template"
msgstr "Gallery dei template"

#: src/features/settings/components/DataExport.tsx:91
msgid "GDPR Art. 15 — diritto di accesso. Generiamo un archivio con il tuo profilo, lo storico conversazioni, i metadati dei documenti indicizzati, le connessioni OAuth e i log di consenso. Il link è disponibile per 7 giorni dopo la generazione."
msgstr "GDPR Art. 15 — diritto di accesso. Generiamo un archivio con il tuo profilo, lo storico conversazioni, i metadati dei documenti indicizzati, le connessioni OAuth e i log di consenso. Il link è disponibile per 7 giorni dopo la generazione."

#: src/features/settings/components/AccountDeletion.tsx:102
msgid "GDPR Art. 17 — diritto all'oblio. L'azione è irreversibile: conversazioni, documenti caricati, embedding, connessioni OAuth e preferenze saranno rimossi. I log d'audit anonimizzati restano per 12 mesi e i backup si rigenerano entro 30 giorni (obbligo legale)."
msgstr "GDPR Art. 17 — diritto all'oblio. L'azione è irreversibile: conversazioni, documenti caricati, embedding, connessioni OAuth e preferenze saranno rimossi. I log d'audit anonimizzati restano per 12 mesi e i backup si rigenerano entro 30 giorni (obbligo legale)."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:360
#: src/features/admin/components/ZitadelPasswordActions.tsx:242
msgid "Genera"
msgstr "Genera"

#: src/features/connectors/wizards/sdiSpec.tsx:99
msgid "Genera + trasmetti + ricevuta SDI senza usare il portale AdE."
msgstr "Genera + trasmetti + ricevuta SDI senza usare il portale AdE."

#: src/features/clean-control/components/EventDetailSheet.tsx:426
#: src/features/clean-control/components/EventRow.tsx:469
msgid "Genera anteprima"
msgstr "Genera anteprima"

#: src/features/sources/components/InboxDetailPane.tsx:952
msgid "Genera azione"
msgstr "Genera azione"

#: src/features/console/pages/FlowsPage.tsx:529
msgid "Genera bozza"
msgstr "Genera bozza"

#: ../../packages/ui/src/ando/sources/calendar/EventActions.tsx:17
msgid "Genera brief"
msgstr "Genera brief"

#: ../../packages/ui/src/ando/sources/db-row/DBActions.tsx:39
msgid "Genera chart"
msgstr "Genera chart"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:231
#: src/features/dashboard/components/wizard/WizardStepData.tsx:287
msgid "Genera con AI"
msgstr "Genera con AI"

#: src/features/sources/components/InboxDetailPane.tsx:1849
msgid "Genera con Ando"
msgstr "Genera con Ando"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:758
msgid "Genera con illustrazioni AI"
msgstr "Genera con illustrazioni AI"

#: src/features/share/components/ShareLinkDialog.tsx:650
#: src/features/voice_report/components/ShareReportDialog.tsx:442
msgid "Genera link"
msgstr "Genera link"

#: src/features/admin/components/ZitadelPasswordActions.tsx:239
msgid "Genera password forte"
msgstr "Genera password forte"

#: src/features/dashboard/components/AddWidgetWizard.tsx:214
msgid "Genera prima la query con il pulsante “Genera SQL” (passo Dati), poi salva il widget."
msgstr "Genera prima la query con il pulsante “Genera SQL” (passo Dati), poi salva il widget."

#: src/routes/_authed/workspace/dashboard.tsx:470
msgid "Genera report Voice of Customer, Employee, Citizen, Reviewer o Support dalla tua knowledge Ando — pipeline AI a 7 stage con citation grounding e aggiornamenti on-demand."
msgstr "Genera report Voice of Customer, Employee, Citizen, Reviewer o Support dalla tua knowledge Ando — pipeline AI a 7 stage con citation grounding e aggiornamenti on-demand."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:353
msgid "Genera riscrittura"
msgstr "Genera riscrittura"

#: src/features/console/pages/PlaygroundPage.tsx:2017
msgid "Genera risposta"
msgstr "Genera risposta"

#: src/features/console/docs/content.ts:919
msgid "Genera un documento"
msgstr "Genera un documento"

#: src/features/console/docs/content.ts:911
msgid "Genera un documento dal contenuto del project → 202 + generation_id, poi polling e download."
msgstr "Genera un documento dal contenuto del project → 202 + generation_id, poi polling e download."

#: src/features/share/components/ShareLinkDialog.tsx:670
msgid "Genera un link e apre WhatsApp con la scheda già scritta: scegli tu il contatto. Il link resta revocabile da Condivisioni."
msgstr ""

#: src/features/voice_report/components/ShareReportDialog.tsx:213
msgid "Genera un link pubblico al report. Il destinatario vedrà solo la versione di sola lettura — nessun accesso al tuo workspace."
msgstr "Genera un link pubblico al report. Il destinatario vedrà solo la versione di sola lettura — nessun accesso al tuo workspace."

#. placeholder {0}: rotateTarget.url
#: src/features/console/webhooks/WebhooksPanel.tsx:766
msgid "Genera un nuovo signing secret per {0}. Aggiorna il tuo endpoint prima del prossimo evento: il secret precedente smette subito di verificare."
msgstr "Genera un nuovo signing secret per {0}. Aggiorna il tuo endpoint prima del prossimo evento: il secret precedente smette subito di verificare."

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:301
msgid "Genera un Voice of X report"
msgstr "Genera un Voice of X report"

#: src/features/connectors/wizards/emailSpec.tsx:65
#: src/features/connectors/wizards/pecSpec.tsx:113
msgid "Genera una app password dal pannello cliente Aruba e usala qui — Ando non vede mai la tua password principale."
msgstr "Genera una app password dal pannello cliente Aruba e usala qui — Ando non vede mai la tua password principale."

#: src/features/connectors/wizards/pecSpec.tsx:146
msgid "Genera una app password dal pannello Legalmail e usala qui — Ando non vede mai la tua password principale."
msgstr "Genera una app password dal pannello Legalmail e usala qui — Ando non vede mai la tua password principale."

#: src/features/console/pages/KeyDetailPage.tsx:737
msgid "Genera una nuova chiave che eredita nome, scope e limiti. Scegli per quanto la chiave attuale resta valida in parallelo, così puoi aggiornare le integrazioni senza downtime."
msgstr "Genera una nuova chiave che eredita nome, scope e limiti. Scegli per quanto la chiave attuale resta valida in parallelo, così puoi aggiornare le integrazioni senza downtime."

#: src/features/settings/components/BrandKitSettings.tsx:419
msgid "Genera una pagina di copertina"
msgstr "Genera una pagina di copertina"

#: src/features/console/pages/PlaygroundPage.tsx:2023
msgid "Genera una risposta sintetica con citazioni."
msgstr "Genera una risposta sintetica con citazioni."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:62
#: src/features/price-lists/utils/formatItem.ts:40
msgid "Generale"
msgstr "Generale"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:816
msgid "Generando illustrazioni AI…{counter}"
msgstr "Generando illustrazioni AI…{counter}"

#. placeholder {0}: generation.model
#: src/features/report/components/AiDisclosureBanner.tsx:192
msgid "Generato con Ando — modello: {0}"
msgstr "Generato con Ando — modello: {0}"

#: src/routes/public.voice-report.$token.tsx:150
msgid "Generato da Ando · accesso in sola lettura"
msgstr "Generato da Ando · accesso in sola lettura"

#: src/features/report/lib/useReportLifecycle.ts:74
msgid "Generato dall'AI, in attesa di revisione umana."
msgstr "Generato dall'AI, in attesa di revisione umana."

#: src/routes/_authed/workspace/documents.tsx:846
msgid "Generazione"
msgstr "Generazione"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:245
msgid "Generazione del deck fallita. Riprova."
msgstr "Generazione del deck fallita. Riprova."

#: src/features/connectors/components/management/BusinessContextEditor.tsx:164
msgid "Generazione in corso, attendi…"
msgstr "Generazione in corso, attendi…"

#: src/features/settings/components/DataExport.tsx:238
msgid "Generazione in corso…"
msgstr "Generazione in corso…"

#: src/features/console/pages/FlowsPage.tsx:438
#: src/features/console/pages/FlowsPage.tsx:456
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:365
msgid "Generazione non riuscita"
msgstr "Generazione non riuscita"

#: src/features/dxf/components/DxfBomButton.tsx:67
#: src/features/settings/components/SecuritySettings.tsx:182
#: src/features/share/components/ShareLinkDialog.tsx:650
#: src/features/share/components/ShareLinkDialog.tsx:687
#: src/features/sources/components/InboxDetailPane.tsx:1847
#: src/features/voice_report/components/ShareReportDialog.tsx:442
msgid "Generazione…"
msgstr "Generazione…"

#: src/features/actions/components/FocusedActionView.tsx:1085
msgid "Genero contenuti, layout e — per i deck — le illustrazioni su misura. Può volerci qualche decina di secondi; l'anteprima si apre da sola appena è pronta."
msgstr "Genero contenuti, layout e — per i deck — le illustrazioni su misura. Può volerci qualche decina di secondi; l'anteprima si apre da sola appena è pronta."

#: src/features/source-confirmation/components/SourceConfirmationSurface.tsx:96
#: src/features/sources/components/ArtifactPane.tsx:1495
#: src/features/sources/components/GeneratingState.tsx:30
msgid "Genero la versione modificata…"
msgstr "Genero la versione modificata…"

#: src/features/clean-control/components/EventDetailSheet.tsx:424
#: src/features/clean-control/components/EventRow.tsx:467
msgid "Genero…"
msgstr "Genero…"

#: src/features/structured-data/components/SimilarPartsSection.tsx:89
msgid "Geometria 3D mesh (Shape DNA)"
msgstr "Geometria 3D mesh (Shape DNA)"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:147
msgid "Gerarchia preservata"
msgstr "Gerarchia preservata"

#: src/features/connectors/wizards/openBankingSpec.tsx:165
msgid "Germania"
msgstr "Germania"

#: src/features/onboarding/sectionGuides.ts:44
msgid "Gestionale, banca e fatturazione: scadenziario, cash flow, clienti per fatturato. I dati strutturati (gestionale e banca) si interrogano dal pulsante dedicato «Crea un grafico» nel pannello Dashboard — è da lì che lanci le query SQL su questi dati; la chat non li estrae da sola."
msgstr "Gestionale, banca e fatturazione: scadenziario, cash flow, clienti per fatturato. I dati strutturati (gestionale e banca) si interrogano dal pulsante dedicato «Crea un grafico» nel pannello Dashboard — è da lì che lanci le query SQL su questi dati; la chat non li estrae da sola."

#: src/features/onboarding/demoTourSteps.ts:94
msgid "Gestionale, banca e fatturazione. Qui Ando interroga i dati strutturati: scadenziario, cash flow, clienti per fatturato. Prova «Mostrami i 5 clienti con più fatturato»."
msgstr "Gestionale, banca e fatturazione. Qui Ando interroga i dati strutturati: scadenziario, cash flow, clienti per fatturato. Prova «Mostrami i 5 clienti con più fatturato»."

#: src/features/onboarding/ConnectorsIntro.tsx:53
msgid "Gestionale/ERP, fatturazione elettronica, open banking"
msgstr "Gestionale/ERP, fatturazione elettronica, open banking"

#: src/features/console/components/ProviderAccounts.tsx:94
msgid "Gestione"
msgstr "Gestione"

#: src/features/console/docs/content.ts:1300
msgid "Gestione dalla console degli endpoint webhook (registrazione/test rispecchiano l'area Webhooks). PATCH /webhooks/<id> abilita/disabilita le consegne (l'unico campo mutabile), reversibile. POST /webhooks/<id>/rotate-secret conia un nuovo whsec_ mostrato UNA volta — immediate replace: il vecchio segreto smette di verificare subito (nessun overlap window), aggiorna il ricevitore prima del prossimo evento."
msgstr "Gestione dalla console degli endpoint webhook (registrazione/test rispecchiano l'area Webhooks). PATCH /webhooks/<id> abilita/disabilita le consegne (l'unico campo mutabile), reversibile. POST /webhooks/<id>/rotate-secret conia un nuovo whsec_ mostrato UNA volta — immediate replace: il vecchio segreto smette di verificare subito (nessun overlap window), aggiorna il ricevitore prima del prossimo evento."

#: src/features/settings/components/SecuritySettings.tsx:51
msgid "Gestione nativa: password, secondo fattore TOTP, e revoca dei dispositivi attivi."
msgstr "Gestione nativa: password, secondo fattore TOTP, e revoca dei dispositivi attivi."

#: src/features/console/docs/content.ts:1299
msgid "Gestione webhook (session)"
msgstr "Gestione webhook (session)"

#: src/features/console/pages/ResourceAccessPage.tsx:443
msgid "Gestire la Console non dà accesso ai contenuti. I destinatari scelti potranno usare il documento nelle proprie query."
msgstr "Gestire la Console non dà accesso ai contenuti. I destinatari scelti potranno usare il documento nelle proprie query."

#: src/features/console/pages/ResourceAccessPage.tsx:453
msgid "Gestire la Console non dà accesso ai contenuti. Solo le persone autorizzate potranno usare questa connessione nelle proprie query."
msgstr "Gestire la Console non dà accesso ai contenuti. Solo le persone autorizzate potranno usare questa connessione nelle proprie query."

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:130
#: src/features/console/connectors/CustomConnectorsPanel.tsx:336
#: src/features/console/pages/BillingPage.tsx:306
#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
#: src/routes/_authed/_modal/integrations/index.tsx:530
msgid "Gestisci"
msgstr "Gestisci"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:398
msgid "Gestisci abbonamento"
msgstr "Gestisci abbonamento"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:51
#: src/features/console/pages/AccessOverviewPage.tsx:363
#: src/features/console/pages/DocumentsPage.tsx:358
msgid "Gestisci accesso"
msgstr "Gestisci accesso"

#: src/features/console/lib/onboarding.ts:92
msgid "Gestisci AppKey"
msgstr "Gestisci AppKey"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:374
msgid "Gestisci AppKeys"
msgstr "Gestisci AppKeys"

#: src/features/console/pages/AccessOverviewPage.tsx:128
msgid "Gestisci chi può leggere i dati indicizzati di ogni fonte o documento."
msgstr "Gestisci chi può leggere i dati indicizzati di ogni fonte o documento."

#: src/features/sync/components/DocSyncManager.tsx:578
msgid "Gestisci file"
msgstr "Gestisci file"

#: src/features/sync/components/DocSyncManager.tsx:568
msgid "Gestisci file da sincronizzare"
msgstr "Gestisci file da sincronizzare"

#: src/features/console/pages/ConnectorsPage.tsx:457
msgid "Gestisci fonte"
msgstr "Gestisci fonte"

#: src/features/onboarding/SectionGuide.tsx:158
msgid "Gestisci i connettori"
msgstr "Gestisci i connettori"

#: src/features/share/components/ShareLinkDialog.tsx:331
msgid "Gestisci in Condivisioni"
msgstr ""

#: src/features/settings/components/OrganizationSettings.tsx:97
msgid "Gestisci l'identità visiva, i membri e l'accesso single sign-on della tua organizzazione. Le modifiche sono visibili a tutti i membri."
msgstr "Gestisci l'identità visiva, i membri e l'accesso single sign-on della tua organizzazione. Le modifiche sono visibili a tutti i membri."

#: src/features/console/components/CommandCenter.tsx:37
msgid "Gestisci le azioni dei connettori"
msgstr "Gestisci le azioni dei connettori"

#: src/features/console/pages/OverviewPage.tsx:302
msgid "Gestisci le fonti"
msgstr "Gestisci le fonti"

#: src/features/console/pages/ResourceAccessPage.tsx:725
msgid "Gestisci membri"
msgstr "Gestisci membri"

#: src/features/console/pages/BillingPage.tsx:114
msgid "Gestisci su Stripe"
msgstr "Gestisci su Stripe"

#: src/features/console/components/ModelPickerModal.tsx:293
msgid "gestito da Ando"
msgstr "gestito da Ando"

#: src/features/console/pages/ModelsPage.tsx:86
msgid "Gestito da Ando"
msgstr "Gestito da Ando"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:293
#: src/features/console/components/StatusBadges.tsx:223
msgid "Gestore"
msgstr "Gestore"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:299
msgid "Gestore PEC"
msgstr "Gestore PEC"

#: src/features/console/docs/content.ts:992
msgid "GET /cad/jobs/<job_id> per il polling; /cad/results/<result_id> per il download."
msgstr "GET /cad/jobs/<job_id> per il polling; /cad/results/<result_id> per il download."

#: src/features/console/docs/content.ts:944
msgid "GET /generate/<id> per lo stato; /generate/<id>/download per il file."
msgstr "GET /generate/<id> per lo stato; /generate/<id>/download per il file."

#: src/features/console/docs/content.ts:1315
msgid "GET /models = modello corrente per purpose + catalogo. PUT /models/<purpose> sceglie; DELETE torna al default; POST /models/<purpose>/byok salva/ruota la provider key del project."
msgstr "GET /models = modello corrente per purpose + catalogo. PUT /models/<purpose> sceglie; DELETE torna al default; POST /models/<purpose>/byok salva/ruota la provider key del project."

#: src/features/console/docs/content.ts:881
msgid "GET elenca gli endpoint; DELETE /webhooks/<id> li rimuove."
msgstr "GET elenca gli endpoint; DELETE /webhooks/<id> li rimuove."

#: src/routes/_authed/_modal/integrations/$capability.tsx:1071
msgid "Già aggiornata · nessuna modifica"
msgstr "Già aggiornata · nessuna modifica"

#: src/features/dashboard/components/ChartNeedsConnectorState.tsx:98
msgid "Già connesso? Aggiorna"
msgstr "Già connesso? Aggiorna"

#: src/features/sales/components/LeadDetailDrawer.tsx:252
msgid "Già in pipeline — apri"
msgstr "Già in pipeline — apri"

#: src/features/console/pages/SchemaPage.tsx:668
msgid "Già interrogabile in linguaggio naturale. Questa cartella non ha sotto-cartelle indicizzate."
msgstr "Già interrogabile in linguaggio naturale. Questa cartella non ha sotto-cartelle indicizzate."

#: src/features/connect/components/MemberManager.tsx:697
msgid "Già invitato"
msgstr "Già invitato"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:123
msgid "Già nell'org target"
msgstr "Già nell'org target"

#: src/features/projects/components/ProjectIcon.tsx:117
msgid "Giallo"
msgstr "Giallo"

#: src/features/admin/components/AdminEngagement.tsx:34
msgid "Gio"
msgstr "Gio"

#: src/features/briefing/BriefCard.tsx:129
msgid "Giornata"
msgstr "Giornata"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:229
#: src/features/admin/components/AdminDecks.tsx:733
msgid "giorni"
msgstr "giorni"

#: src/features/admin/components/AdminDecks.tsx:731
msgid "Giorni di validità"
msgstr "Giorni di validità"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:154
msgid "Giorni futuri"
msgstr "Giorni futuri"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:141
msgid "Giorni passati"
msgstr "Giorni passati"

#: src/features/console/pages/UsagePage.tsx:525
#: src/features/dashboard/utils/calculatedFields.ts:92
#: src/routes/_authed/workspace/calendar.tsx:408
msgid "Giorno"
msgstr "Giorno"

#: src/routes/_authed/workspace/calendar.tsx:845
msgid "Giorno precedente"
msgstr "Giorno precedente"

#: src/features/dashboard/utils/calculatedFields.ts:93
msgid "Giorno settimana"
msgstr "Giorno settimana"

#: src/routes/_authed/workspace/calendar.tsx:851
msgid "Giorno successivo"
msgstr "Giorno successivo"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:79
msgid "giovedì"
msgstr "giovedì"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Gli account Gmail, Drive e Teams si collegano separatamente, dopo la registrazione dell’utente."
msgstr "Gli account Gmail, Drive e Teams si collegano separatamente, dopo la registrazione dell’utente."

#: src/features/console/pages/ModelsPage.tsx:177
msgid "Gli account personali non sono attivi per questa elaborazione. Le chiamate restano gestite da Ando."
msgstr "Gli account personali non sono attivi per questa elaborazione. Le chiamate restano gestite da Ando."

#: src/routes/_authed/workspace/canvases.tsx:350
msgid "Gli archiviati appariranno qui — puoi sempre riattivarli."
msgstr "Gli archiviati appariranno qui — puoi sempre riattivarli."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:161
msgid "Gli header devono essere un oggetto JSON di stringhe, es. { \"X-Api-Version\": \"2\" }."
msgstr "Gli header devono essere un oggetto JSON di stringhe, es. { \"X-Api-Version\": \"2\" }."

#: src/features/connect/components/SpaceScopeBanner.tsx:156
msgid "Gli ospiti interrogano SOLO:"
msgstr "Gli ospiti interrogano SOLO:"

#: src/features/connect/components/GrantManager.tsx:190
msgid "Gli ospiti non potranno più interrogare questa fonte. Puoi annullare subito dopo."
msgstr "Gli ospiti non potranno più interrogare questa fonte. Puoi annullare subito dopo."

#: src/features/console/docs/content.ts:1790
msgid "Gli scambi del thread, dal più vecchio (cursor-paginati)."
msgstr "Gli scambi del thread, dal più vecchio (cursor-paginati)."

#: src/features/onboarding/demoTourSteps.ts:108
msgid "Gli Spazi"
msgstr "Gli Spazi"

#: src/routes/_authed/workspace/connect.index.tsx:237
msgid "Gli spazi a cui ti invitano appariranno qui. Apri l'invito che ricevi via email per accedere."
msgstr "Gli spazi a cui ti invitano appariranno qui. Apri l'invito che ricevi via email per accedere."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:399
msgid "Gli utenti accedono tramite Zitadel nella Organization collegata al tuo tenant Ando. La stessa persona può usare Workspace e Console, ma i permessi di questa app restano separati."
msgstr "Gli utenti accedono tramite Zitadel nella Organization collegata al tuo tenant Ando. La stessa persona può usare Workspace e Console, ma i permessi di questa app restano separati."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Gli utenti compaiono alla prima richiesta autenticata della tua app, anche prima di collegare un account."
msgstr "Gli utenti compaiono alla prima richiesta autenticata della tua app, anche prima di collegare un account."

#: src/features/admin/components/orgs/OrgSSOTab.tsx:366
msgid "Gli utenti dell'organizzazione torneranno al login con email/password. Le sessioni attive non vengono interrotte."
msgstr "Gli utenti dell'organizzazione torneranno al login con email/password. Le sessioni attive non vengono interrotte."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:394
msgid "Gli utenti finali saranno associati a questa app, separati dai membri della Console."
msgstr "Gli utenti finali saranno associati a questa app, separati dai membri della Console."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:391
msgid "Gli utenti non potranno più accedere a Engine tramite questa app. La disattivazione può essere ripetuta se il provider di login non risponde."
msgstr "Gli utenti non potranno più accedere a Engine tramite questa app. La disattivazione può essere ripetuta se il provider di login non risponde."

#: src/features/admin/components/MaintenanceControl.tsx:204
msgid "Gli utenti vedono il banner di preavviso"
msgstr "Gli utenti vedono il banner di preavviso"

#: src/features/admin/components/MaintenanceControl.tsx:202
msgid "Gli utenti vedono la schermata di manutenzione"
msgstr "Gli utenti vedono la schermata di manutenzione"

#: src/features/console/pages/KeyDetailPage.tsx:500
msgid "Gli utilizzi e le modifiche della chiave compariranno qui."
msgstr "Gli utilizzi e le modifiche della chiave compariranno qui."

#: src/features/agent-modes/components/AgentModeEditor.tsx:366
#: src/features/agent-modes/components/AgentModeEditor.tsx:629
msgid "Globale"
msgstr "Globale"

#: src/features/agent-modes/components/AgentModesList.tsx:61
msgid "Globali"
msgstr "Globali"

#: src/features/onboarding/ConnectorsIntro.tsx:41
msgid "Gmail, Outlook, Google Calendar, Slack, Teams"
msgstr "Gmail, Outlook, Google Calendar, Slack, Teams"

#: src/routes/_authed/workspace/conversations.tsx:586
#: src/routes/_authed/workspace/conversations.tsx:1120
msgid "Google Chat"
msgstr "Google Chat"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:111
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:97
#: src/features/workspace/config.ts:376
#: src/features/workspace/documents/components/FolderBrowserView.tsx:49
msgid "Google Drive"
msgstr "Google Drive"

#: src/features/onboarding/ConnectorsIntro.tsx:47
msgid "Google Drive, OneDrive, SharePoint, file locali/NAS"
msgstr "Google Drive, OneDrive, SharePoint, file locali/NAS"

#: src/features/console/components/ModelPickerModal.tsx:330
msgid "Google Vertex AI · il tuo progetto"
msgstr "Google Vertex AI · il tuo progetto"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:259
msgid "Google Workspace"
msgstr "Google Workspace"

#: src/features/clean-control/utils/labels.ts:94
msgid "Gover."
msgstr "Gover."

#: src/features/clean-control/utils/labels.ts:80
#: src/routes/_authed/_modal/admin/route.tsx:144
msgid "Governance"
msgstr "Governance"

#: src/features/admin/components/AdminHypermem.tsx:173
msgid "Governance del sottosistema di memoria cognitiva: consolidamento, esperimenti A/B sui prompt, suggerimenti di automazione e nudge proattivi — con audit completo e isolamento per tenant."
msgstr "Governance del sottosistema di memoria cognitiva: consolidamento, esperimenti A/B sui prompt, suggerimenti di automazione e nudge proattivi — con audit completo e isolamento per tenant."

#: src/features/connectors/wizards/databaseSpec.tsx:253
msgid "Grafici e KPI generati dai tuoi dati, pronti per la condivisione."
msgstr "Grafici e KPI generati dai tuoi dati, pronti per la condivisione."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:688
#: src/features/admin/components/deckEditor/DeckEditor.tsx:775
msgid "Grafico"
msgstr "Grafico"

#: ../../packages/ui/src/charts/Chart.tsx:209
msgid "Grafico {type}"
msgstr "Grafico {type}"

#: ../../packages/ui/src/charts/Chart.tsx:209
msgid "Grafico {type}: {title}"
msgstr "Grafico {type}: {title}"

#: src/features/console/components/UsageCharts.tsx:150
msgid "Grafico a barre dello storage giornaliero"
msgstr "Grafico a barre dello storage giornaliero"

#: src/features/dashboard/components/AddChartDialog.tsx:363
msgid "Grafico aggiunto a {targetDashboardName}"
msgstr "Grafico aggiunto a {targetDashboardName}"

#: src/features/dashboard/components/ShareChartSheet.tsx:263
msgid "Grafico condiviso con {who}"
msgstr "Grafico condiviso con {who}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1310
msgid "Grafico dati"
msgstr "Grafico dati"

#: src/features/console/pages/UsagePage.tsx:467
msgid "Grafico dell'andamento dei token giornalieri"
msgstr "Grafico dell'andamento dei token giornalieri"

#: src/features/console/pages/UsagePage.tsx:392
msgid "Grafico dell'andamento delle richieste giornaliere"
msgstr "Grafico dell'andamento delle richieste giornaliere"

#: src/features/chat/components/MessagePreviewEmbed.tsx:153
#: src/features/structured-data/components/InlineChartPanel.tsx:69
msgid "Grafico generato"
msgstr "Grafico generato"

#: src/features/admin/components/AdminAutomation.tsx:166
#: src/features/admin/components/AdminCanvas.tsx:151
#: src/features/admin/components/AdminQuality.tsx:112
msgid "Grafico in arrivo (chart slice round 3)."
msgstr "Grafico in arrivo (chart slice round 3)."

#. placeholder {0}: input.recipient_email
#: src/features/dashboard/components/ShareChartSheet.tsx:440
msgid "Grafico inviato a {0}"
msgstr "Grafico inviato a {0}"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:913
msgid "Grandezza"
msgstr "Grandezza"

#: src/features/admin/components/AdminCostTracking.tsx:192
msgid "Granularità admin v2.6 (May 2026 — Cost Tracking SOTA): ogni chiamata LLM è marcata per source/model/tipo-token con drill-down per trace."
msgstr "Granularità admin v2.6 (May 2026 — Cost Tracking SOTA): ogni chiamata LLM è marcata per source/model/tipo-token con drill-down per trace."

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:720
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1920
#: src/features/sales/components/SignatureRichEditor.tsx:201
msgid "Grassetto"
msgstr "Grassetto"

#: src/features/settings/MarpTemplateSettings.tsx:121
msgid "Gratis · attribuzione richiesta"
msgstr "Gratis · attribuzione richiesta"

#: src/features/settings/MarpTemplateSettings.tsx:142
msgid "Gratis · curato"
msgstr "Gratis · curato"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:861
msgid "Gravità"
msgstr "Gravità"

#. placeholder {0}: submitFeedback.data.confidence_adjust >= 0 ? "+" : ""
#. placeholder {1}: submitFeedback.data.confidence_adjust.toFixed(2)
#: src/features/clean-control/components/EventDetailSheet.tsx:178
msgid "Grazie — Ando aggiornerà la fiducia (Δ = <0>{0}{1}</0>)."
msgstr "Grazie — Ando aggiornerà la fiducia (Δ = <0>{0}{1}</0>)."

#: src/features/onboarding/DemoBookCallModal.tsx:535
msgid "Grazie!"
msgstr "Grazie!"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1679
msgid "Grigio"
msgstr "Grigio"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1680
msgid "Grigio chiaro"
msgstr "Grigio chiaro"

#: src/features/templates/components/TemplateFieldSpecs.ts:99
msgid "Griglia (multi-colonna)"
msgstr "Griglia (multi-colonna)"

#: src/features/admin/components/AdminQuality.tsx:57
msgid "grounding · feedback · tool-use telemetry"
msgstr "grounding · feedback · tool-use telemetry"

#: src/features/admin/components/AdminQuality.tsx:61
msgid "Grounding rate è il segnale che correla meglio con churn nel 2026. Tool × esito è la vista debug più potente per un agent product — oggi rendered come tabella, heatmap in arrivo con la chart slice."
msgstr "Grounding rate è il segnale che correla meglio con churn nel 2026. Tool × esito è la vista debug più potente per un agent product — oggi rendered come tabella, heatmap in arrivo con la chart slice."

#: src/features/onboarding/SectionGuide.tsx:85
msgid "Guida alla sezione {label}"
msgstr "Guida alla sezione {label}"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Guida API"
msgstr "Guida API"

#: src/features/console/pages/DevelopersPage.tsx:237
msgid "Guida MCP"
msgstr "Guida MCP"

#: src/features/sales/components/activitySentences.tsx:80
msgid "ha aggiornato i dati del lead"
msgstr "ha aggiornato i dati del lead"

#: src/features/sales/components/activitySentences.tsx:82
msgid "ha aggiornato il lead"
msgstr "ha aggiornato il lead"

#: src/features/sales/components/SalesOverview.tsx:423
msgid "ha aggiunto una nota"
msgstr "ha aggiunto una nota"

#. placeholder {0}: teamName(p.to)
#: src/features/sales/components/activitySentences.tsx:68
msgid "ha assegnato il lead a {0}"
msgstr "ha assegnato il lead a {0}"

#. placeholder {0}: i18n._(label)
#: src/features/sales/components/activitySentences.tsx:64
msgid "ha cambiato la qualifica in {0}"
msgstr "ha cambiato la qualifica in {0}"

#: src/features/sales/components/activitySentences.tsx:76
msgid "ha condiviso la campagna"
msgstr "ha condiviso la campagna"

#: src/features/sales/components/activitySentences.tsx:53
msgid "ha creato il lead"
msgstr "ha creato il lead"

#. placeholder {0}: shortDate(when)
#: src/features/sales/components/activitySentences.tsx:73
msgid "ha impostato un follow-up per il {0}"
msgstr "ha impostato un follow-up per il {0}"

#: src/features/sales/components/activitySentences.tsx:78
msgid "ha inviato un'email a freddo"
msgstr "ha inviato un'email a freddo"

#: src/features/sources/components/SyncConflictDialog.tsx:84
msgid "ha modificato questo file il"
msgstr "ha modificato questo file il"

#: src/features/sales/components/activitySentences.tsx:72
msgid "ha rimosso il follow-up"
msgstr "ha rimosso il follow-up"

#: src/features/sales/components/activitySentences.tsx:67
msgid "ha rimosso l'assegnazione del lead"
msgstr "ha rimosso l'assegnazione del lead"

#. placeholder {0}: statusLabel(p.from)
#. placeholder {1}: statusLabel(p.to)
#: src/features/sales/components/activitySentences.tsx:56
msgid "ha spostato lo stato da {0} a {1}"
msgstr "ha spostato lo stato da {0} a {1}"

#: src/features/projects/components/ProjectHub.tsx:468
msgid "Hai {projectCount} progetti attivi. Tutto sotto controllo."
msgstr "Hai {projectCount} progetti attivi. Tutto sotto controllo."

#: src/features/dxf/components/DxfEmptyHero.tsx:106
msgid "Hai <0>{totalCount}</0> disegni indicizzati in totale. Allarga la ricerca o rimuovi i filtri per vederli tutti."
msgstr "Hai <0>{totalCount}</0> disegni indicizzati in totale. Allarga la ricerca o rimuovi i filtri per vederli tutti."

#: src/features/projects/components/ProjectHub.tsx:466
msgid "Hai 1 progetto attivo. Tutto sotto controllo."
msgstr "Hai 1 progetto attivo. Tutto sotto controllo."

#: src/features/dashboard/components/DashboardToolbar.tsx:73
#: src/features/dashboard/components/DashboardToolbar.tsx:74
msgid "Hai accesso in sola visualizzazione"
msgstr "Hai accesso in sola visualizzazione"

#: src/features/projects/components/ProjectDetailPage.tsx:324
msgid "Hai aperto questo progetto <0>{lastAt}</0>."
msgstr "Hai aperto questo progetto <0>{lastAt}</0>."

#: src/routes/_authed/workspace/finance.tsx:1087
msgid "Hai disattivato tutte le fonti dati. Riattivane almeno una per vedere i pannelli Banking, SDI / Fatture e CRM."
msgstr "Hai disattivato tutte le fonti dati. Riattivane almeno una per vedere i pannelli Banking, SDI / Fatture e CRM."

#: src/routes/public.voice-report.$token.tsx:327
msgid "Hai effettuato troppe richieste. Attendi qualche istante e riprova."
msgstr "Hai effettuato troppe richieste. Attendi qualche istante e riprova."

#: src/routes/connect.invite.$token.tsx:212
msgid "Hai fatto troppe richieste. Attendi qualche istante e riprova."
msgstr "Hai fatto troppe richieste. Attendi qualche istante e riprova."

#: src/features/sources/components/AISummaryPanel.tsx:902
msgid "Hai gestito {total} proposte dell'AI."
msgstr "Hai gestito {total} proposte dell'AI."

#: src/features/sources/components/AISummaryPanel.tsx:901
msgid "Hai gestito 1 proposta dell'AI."
msgstr "Hai gestito 1 proposta dell'AI."

#: src/features/billing/components/UsageInsightsCard.tsx:216
msgid "Hai già una base di conoscenza pronta. Fai la prima domanda alla chat per iniziare a vedere il valore generato."
msgstr "Hai già una base di conoscenza pronta. Fai la prima domanda alla chat per iniziare a vedere il valore generato."

#: src/features/console/pages/PlaygroundPage.tsx:1750
msgid "Hai interrotto l’attesa della risposta."
msgstr "Hai interrotto l’attesa della risposta."

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:282
msgid "Hai modificato {editedFieldCount} campo rispetto alla proposta dell'AI"
msgstr "Hai modificato {editedFieldCount} campo rispetto alla proposta dell'AI"

#: src/features/skills/components/SkillEditor.tsx:472
msgid "Hai modifiche non salvate. Se chiudi ora vanno perse."
msgstr "Hai modifiche non salvate. Se chiudi ora vanno perse."

#: src/features/templates/components/TemplateEditor.tsx:420
msgid "Hai modifiche pendenti. Tornando indietro andranno perse. Procedi?"
msgstr "Hai modifiche pendenti. Tornando indietro andranno perse. Procedi?"

#: src/features/dashboard/components/AddWidgetWizard.tsx:377
msgid "Hai una bozza widget in compilazione. Chiudendo perderai i dati inseriti. Continuare a modificare oppure chiudere?"
msgstr "Hai una bozza widget in compilazione. Chiudendo perderai i dati inseriti. Continuare a modificare oppure chiudere?"

#: src/features/dxf/components/DxfEmptyHero.tsx:178
msgid "Hai una checklist DFM? Carica le regole di progettazione →"
msgstr "Hai una checklist DFM? Carica le regole di progettazione →"

#: src/routes/_authed/_modal/settings/help.tsx:43
msgid "Hai una domanda veloce? Inizia dalle FAQ. Per casi specifici scrivi al supporto — risponde una persona, non un bot."
msgstr "Hai una domanda veloce? Inizia dalle FAQ. Per casi specifici scrivi al supporto — risponde una persona, non un bot."

#: src/features/connectors/wizards/legalStorageSpec.tsx:65
msgid "Hash check periodico, alert se un file è alterato."
msgstr "Hash check periodico, alert se un file è alterato."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:451
msgid "Header (JSON, opzionale)"
msgstr "Header (JSON, opzionale)"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:474
msgid "Header aggiuntivi inviati con ogni chiamata al tuo endpoint."
msgstr "Header aggiuntivi inviati con ogni chiamata al tuo endpoint."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:160
msgid "Header non validi: inserisci un oggetto JSON."
msgstr "Header non validi: inserisci un oggetto JSON."

#: src/features/console/connectors/ManifestConfigForm.tsx:81
msgid "Header personalizzato"
msgstr "Header personalizzato"

#: src/features/account/components/UserMenuButton.tsx:469
#: src/routes/_authed/_modal/settings/help.tsx:36
msgid "Help center"
msgstr "Help center"

#: src/features/console/docs/content.ts:1850
msgid "Helper legato a uno slug: batching, retry con backoff, Idempotency-Key per batch e una forma context-manager che ABORTISCE la run se il producer solleva (niente sweep parziale). La chiave deve avere sources:manage + ingest:write."
msgstr "Helper legato a uno slug: batching, retry con backoff, Idempotency-Key per batch e una forma context-manager che ABORTISCE la run se il producer solleva (niente sweep parziale). La chiave deve avere sources:manage + ingest:write."

#: src/features/templates/components/TemplateFieldSpecs.ts:59
msgid "Hex del colore brand principale (header, CTA, accenti)."
msgstr "Hex del colore brand principale (header, CTA, accenti)."

#: src/features/templates/components/TemplateFieldSpecs.ts:66
msgid "Hex usato per decorazioni e bordi."
msgstr "Hex usato per decorazioni e bordi."

#: src/features/workspace/config.ts:212
msgid "Hive Flows"
msgstr "Hive Flows"

#. placeholder {0}: bullets.length
#: src/features/chat/components/ChatEmptyState.tsx:651
msgid "Ho {0} cose interessanti per te."
msgstr "Ho {0} cose interessanti per te."

#: src/features/sales/components/CreateLeadDialog.tsx:116
msgid "Ho capito"
msgstr "Ho capito"

#: src/features/sources/components/InboxDetailPane.tsx:573
msgid "Ho creato un promemoria in Attività."
msgstr "Ho creato un promemoria in Attività."

#: src/features/projects/components/ProjectDetailPage.tsx:351
msgid "Ho memorizzato <0>{memCount} ricordi</0> su questo progetto."
msgstr "Ho memorizzato <0>{memCount} ricordi</0> su questo progetto."

#: src/features/projects/components/ProjectDetailPage.tsx:347
msgid "Ho memorizzato <0>1 ricordo</0> su questo progetto."
msgstr "Ho memorizzato <0>1 ricordo</0> su questo progetto."

#. placeholder {0}: insights.length
#: src/features/projects/components/ProjectHub.tsx:478
msgid "Ho notato {0} cose che valgono la pena."
msgstr "Ho notato {0} cose che valgono la pena."

#: src/features/projects/components/ProjectHub.tsx:476
msgid "Ho notato una cosa che vale la pena guardare."
msgstr "Ho notato una cosa che vale la pena guardare."

#: src/features/console/components/CreateKeyWizard.tsx:745
msgid "Ho salvato la chiave"
msgstr "Ho salvato la chiave"

#: src/features/chat/components/ChatEmptyState.tsx:649
msgid "Ho una cosa interessante per te."
msgstr "Ho una cosa interessante per te."

#: src/features/console/components/ConsoleShell.tsx:204
msgid "Home"
msgstr "Home"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:721
msgid "Host"
msgstr "Host"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:626
msgid "Host / indirizzo"
msgstr "Host / indirizzo"

#: src/features/connectors/wizards/databaseSpec.tsx:202
msgid "Host, database e credenziali del tuo server MySQL."
msgstr "Host, database e credenziali del tuo server MySQL."

#: src/features/connectors/wizards/databaseSpec.tsx:194
msgid "Host, database e credenziali del tuo server PostgreSQL."
msgstr "Host, database e credenziali del tuo server PostgreSQL."

#: src/features/connectors/wizards/databaseSpec.tsx:210
msgid "Host, database e credenziali del tuo server SQL Server."
msgstr "Host, database e credenziali del tuo server SQL Server."

#: src/features/connectors/wizards/databaseSpec.tsx:218
msgid "Host, service name e credenziali del tuo server Oracle."
msgstr "Host, service name e credenziali del tuo server Oracle."

#: src/features/connectors/wizards/filesystemSpec.tsx:60
msgid "Host, share e credenziali della tua rete locale."
msgstr "Host, share e credenziali della tua rete locale."

#: src/features/clean-control/components/EventRow.tsx:538
msgid "hot-path"
msgstr "hot-path"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1004
msgid "HPDC, LPDC"
msgstr "HPDC, LPDC"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:90
msgid "HR / People"
msgstr "HR / People"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:93
msgid "HTML"
msgstr "HTML"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:919
msgid "https://…"
msgstr "https://…"

#: src/routes/_authed/_modal/admin/route.tsx:137
msgid "HyperMem"
msgstr "HyperMem"

#: src/features/admin/components/AdminHypermem.tsx:202
msgid "HyperMem — governance memoria cognitiva"
msgstr "HyperMem — governance memoria cognitiva"

#: src/features/settings/components/OtpEmailPanel.tsx:227
msgid "I codici verranno inviati a <0>{masked}</0>."
msgstr "I codici verranno inviati a <0>{masked}</0>."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:450
msgid "I connector con licenza “tutti i membri” non sono toggleabili singolarmente."
msgstr "I connector con licenza “tutti i membri” non sono toggleabili singolarmente."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:343
msgid "I connector disattivati restano visibili nel catalogo e non sono utilizzabili dagli utenti finché non li abiliti."
msgstr "I connector disattivati restano visibili nel catalogo e non sono utilizzabili dagli utenti finché non li abiliti."

#: src/features/onboarding/ConnectorsIntro.tsx:145
msgid "I connettori collegano i tuoi strumenti ad Ando. Una volta connessi, Ando indicizza e tiene aggiornata la conoscenza aziendale in un unico Company Brain: puoi interrogare in linguaggio naturale tra tutti i sistemi, ricevere briefing e far eseguire azioni — sempre con la tua approvazione."
msgstr "I connettori collegano i tuoi strumenti ad Ando. Una volta connessi, Ando indicizza e tiene aggiornata la conoscenza aziendale in un unico Company Brain: puoi interrogare in linguaggio naturale tra tutti i sistemi, ricevere briefing e far eseguire azioni — sempre con la tua approvazione."

#: src/features/console/pages/ConnectorDetailPage.tsx:587
msgid "I contenuti già indicizzati verranno rimossi dall'indice al prossimo ciclo di pulizia. L'operazione non tocca i dati nella sorgente."
msgstr "I contenuti già indicizzati verranno rimossi dall'indice al prossimo ciclo di pulizia. L'operazione non tocca i dati nella sorgente."

#: src/features/console/pages/SchemaPage.tsx:489
msgid "I contenuti non strutturati sono già interrogabili in linguaggio naturale: non c'è uno schema da curare qui."
msgstr "I contenuti non strutturati sono già interrogabili in linguaggio naturale: non c'è uno schema da curare qui."

#: src/features/console/pages/MembersPage.tsx:278
msgid "I contenuti privati richiedono permessi separati. L’invito non cambia gli accessi Workspace esistenti."
msgstr "I contenuti privati richiedono permessi separati. L’invito non cambia gli accessi Workspace esistenti."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:254
msgid "I dati autorizzati entrano nelle risorse condivise secondo i permessi Workspace."
msgstr "I dati autorizzati entrano nelle risorse condivise secondo i permessi Workspace."

#: src/features/console/pages/PlaygroundPage.tsx:1974
msgid "I dati degli altri utenti non sono visibili nella Console."
msgstr "I dati degli altri utenti non sono visibili nella Console."

#: src/features/console/components/ConsoleSectionBoundary.tsx:71
msgid "I dati ricevuti non sono nel formato atteso. Il resto della pagina continua a funzionare."
msgstr "I dati ricevuti non sono nel formato atteso. Il resto della pagina continua a funzionare."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:209
msgid "I dati saranno privati e accessibili solo a te in Engine."
msgstr "I dati saranno privati e accessibili solo a te in Engine."

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:119
msgid "I fact contengono dati estratti dalle conversazioni utente. Il testo è redatto e mascherato lato server salvo modalità Inspect (audit log accessibile all'utente, Art. 15 GDPR)."
msgstr "I fact contengono dati estratti dalle conversazioni utente. Il testo è redatto e mascherato lato server salvo modalità Inspect (audit log accessibile all'utente, Art. 15 GDPR)."

#: src/features/connectors/wizards/spreadsheetSpec.tsx:197
msgid "I file cloud restano sincronizzati: re-importi senza ricaricare."
msgstr "I file cloud restano sincronizzati: re-importi senza ricaricare."

#: src/features/console/pages/FlowsPage.tsx:741
msgid "I flow di automazione del progetto: creali da un template o descrivendoli all'AI, esegui un test senza effetti collaterali o lancia un'esecuzione reale."
msgstr "I flow di automazione del progetto: creali da un template o descrivendoli all'AI, esegui un test senza effetti collaterali o lancia un'esecuzione reale."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:141
#: src/routes/_authed/workspace/canvases.tsx:175
msgid "I Knowledge Canvases sono inclusi nei piani Knowledge e superiori. Contatta il tuo amministratore per attivarli."
msgstr "I Knowledge Canvases sono inclusi nei piani Knowledge e superiori. Contatta il tuo amministratore per attivarli."

#: src/features/console/pages/LimitsPage.tsx:122
msgid "I limiti crescono con il tier della chiave."
msgstr "I limiti crescono con il tier della chiave."

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:413
msgid "I link diventano invalidi immediatamente."
msgstr "I link diventano invalidi immediatamente."

#: src/features/console/pages/UsagePage.tsx:342
msgid "I membri e le nuove AppKey condividono il saldo dell’organizzazione."
msgstr "I membri e le nuove AppKey condividono il saldo dell’organizzazione."

#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:103
msgid "I membri non potranno più accedere finché l'organizzazione resta disattivata. L'operazione è reversibile — i dati restano intatti."
msgstr "I membri non potranno più accedere finché l'organizzazione resta disattivata. L'operazione è reversibile — i dati restano intatti."

#: src/features/admin/components/AdminOrgs.tsx:1288
msgid "I membri saranno migrati al Default Tenant (TIER 1+2 personali seguono, TIER 3 org-owned sono droppati). L'operazione è irreversibile."
msgstr "I membri saranno migrati al Default Tenant (TIER 1+2 personali seguono, TIER 3 org-owned sono droppati). L'operazione è irreversibile."

#: src/features/console/pages/PlaygroundPage.tsx:1971
msgid "I miei account"
msgstr "I miei account"

#: src/features/console/docs/content.ts:1379
msgid "I miei account in Engine"
msgstr "I miei account in Engine"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:226
msgid "I miei connettori"
msgstr "I miei connettori"

#: src/routes/_authed/_modal/settings/help.tsx:89
msgid "I miei dati allenano modelli esterni?"
msgstr "I miei dati allenano modelli esterni?"

#: src/features/sales/components/SalesOverview.tsx:120
msgid "I miei lead"
msgstr "I miei lead"

#: src/routes/_authed/workspace/connect.index.tsx:140
msgid "I miei spazi"
msgstr "I miei spazi"

#: src/features/agent-modes/components/AgentModesList.tsx:194
msgid "I modi personalizzano il prompt e le capacità di Ando per attività specifiche. Ogni modifica del prompt crea una nuova versione: puoi tornare a quella precedente in qualsiasi momento."
msgstr "I modi personalizzano il prompt e le capacità di Ando per attività specifiche. Ogni modifica del prompt crea una nuova versione: puoi tornare a quella precedente in qualsiasi momento."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:495
msgid "I nudge contengono testo generato da contenuti utente (titoli email, frammenti chat, scadenze documento). Title e body sono troncati server-side e non sono espandibili da questa vista. Ogni query è registrata nell'audit trail (GDPR Art. 5(2))."
msgstr "I nudge contengono testo generato da contenuti utente (titoli email, frammenti chat, scadenze documento). Title e body sono troncati server-side e non sono espandibili da questa vista. Ogni query è registrata nell'audit trail (GDPR Art. 5(2))."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:113
#: src/features/console/connectors/TestConnectorActionModal.tsx:136
msgid "I parametri devono essere un oggetto JSON valido."
msgstr "I parametri devono essere un oggetto JSON valido."

#: src/features/sources/components/CalendarEventPane.tsx:409
msgid "i partecipanti"
msgstr "i partecipanti"

#: src/features/skills/components/SkillEditor.tsx:426
msgid "I passi che Ando deve seguire"
msgstr "I passi che Ando deve seguire"

#: src/features/console/components/ProviderAccounts.tsx:235
msgid "I profili cliente saranno disattivati e le elaborazioni torneranno ad Ando fino alla tua riattivazione."
msgstr "I profili cliente saranno disattivati e le elaborazioni torneranno ad Ando fino alla tua riattivazione."

#: src/features/projects/components/ProjectHub.tsx:573
msgid "I progetti raggruppano conversazioni, conoscenza e automazioni per cliente o area di lavoro. Posso ricordare cosa hai fatto la volta scorsa e ripartire da lì."
msgstr "I progetti raggruppano conversazioni, conoscenza e automazioni per cliente o area di lavoro. Posso ricordare cosa hai fatto la volta scorsa e ripartire da lì."

#: src/features/console/connectors/CustomConnectorDetail.tsx:676
msgid "i record non più restituiti vengono rimossi"
msgstr "i record non più restituiti vengono rimossi"

#: src/features/report/components/ReportList.tsx:103
msgid "I report di analisi appariranno qui non appena verranno generati. Ogni report resta consultabile nel tempo."
msgstr "I report di analisi appariranno qui non appena verranno generati. Ogni report resta consultabile nel tempo."

#: src/features/projects/components/sections/MemorySection.tsx:237
msgid "I ricordi entrano nel pool dei progetti \"condivisi\" dello stesso utente. Utile per famiglie di progetti correlati. NON usare per dati separati per cliente."
msgstr "I ricordi entrano nel pool dei progetti \"condivisi\" dello stesso utente. Utile per famiglie di progetti correlati. NON usare per dati separati per cliente."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:404
msgid "I sample facts possono contenere PII (es. email destinatari). L'accesso è loggato in audit trail."
msgstr "I sample facts possono contenere PII (es. email destinatari). L'accesso è loggato in audit trail."

#: src/routes/_authed/workspace/work.tsx:532
msgid "I task che completi oggi compaiono qui."
msgstr "I task che completi oggi compaiono qui."

#: src/routes/_authed/workspace/templates/$kind.tsx:382
msgid "I template built-in sono sola lettura. Usa \"Duplica come custom\" per creare una versione modificabile."
msgstr "I template built-in sono sola lettura. Usa \"Duplica come custom\" per creare una versione modificabile."

#: src/features/settings/MarpTemplateSettings.tsx:75
msgid "I template personalizzati appaiono nel picker del deck Marp accanto ai 4 built-in (Editoriale, McKinsey, Sequoia, Keynote). Lo scope \"Organizzazione\" li condivide con tutti i colleghi dello stesso tenant."
msgstr "I template personalizzati appaiono nel picker del deck Marp accanto ai 4 built-in (Editoriale, McKinsey, Sequoia, Keynote). Lo scope \"Organizzazione\" li condivide con tutti i colleghi dello stesso tenant."

#: src/features/voice_report/components/NewReportDialog.tsx:976
msgid "I template predefiniti (Voice of Customer, Employee, Citizen) determinano la struttura iniziale del report."
msgstr "I template predefiniti (Voice of Customer, Employee, Citizen) determinano la struttura iniziale del report."

#: src/features/voice_report/components/TemplatesGallery.tsx:435
msgid "I template predefiniti saranno disponibili a breve."
msgstr "I template predefiniti saranno disponibili a breve."

#: src/features/console/docs/content.ts:1783
msgid "I thread della chiave, più recenti prima (cursor-paginati)."
msgstr "I thread della chiave, più recenti prima (cursor-paginati)."

#: src/routes/_authed/workspace/flows.index.tsx:223
#: src/routes/_authed/workspace/flows.index.tsx:280
msgid "I tuoi flow"
msgstr "I tuoi flow"

#: src/features/console/pages/LimitsPage.tsx:117
msgid "I tuoi limiti per chiave: tier, richieste al minuto e tetto di spesa."
msgstr "I tuoi limiti per chiave: tier, richieste al minuto e tetto di spesa."

#: src/features/studio/components/StudioDrawerContent.tsx:309
msgid "I tuoi modes"
msgstr "I tuoi modes"

#: src/features/projects/components/ProjectHub.tsx:266
#: src/features/projects/components/ProjectHub.tsx:408
msgid "I tuoi progetti"
msgstr "I tuoi progetti"

#: src/features/projects/components/ProjectHub.tsx:370
msgid "I tuoi spazi"
msgstr "I tuoi spazi"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:655
#: src/features/settings/MarpTemplateSettings.tsx:350
msgid "I tuoi stili"
msgstr "I tuoi stili"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1200
msgid "I tuoi template"
msgstr "I tuoi template"

#: src/features/automations/components/AutomationsHub.tsx:290
msgid "I tuoi worker"
msgstr "I tuoi worker"

#: src/features/console/docs/content.ts:541
msgid "I turni dal più vecchio (cronologico), paginati. role = user | assistant, query_id lega le due metà."
msgstr "I turni dal più vecchio (cronologico), paginati. role = user | assistant, query_id lega le due metà."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2260
msgid "I valori sono uguali in tutte le lingue; etichette e nomi delle serie si traducono per lingua."
msgstr "I valori sono uguali in tutte le lingue; etichette e nomi delle serie si traducono per lingua."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:174
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:311
msgid "IBAN"
msgstr "IBAN"

#: src/features/clean-control/utils/signalCatalog.ts:147
msgid "IBAN con checksum errato."
msgstr "IBAN con checksum errato."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:329
msgid "IBAN del beneficiario"
msgstr "IBAN del beneficiario"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:361
#: src/features/clean-control/utils/signalCatalog.ts:146
msgid "IBAN non valido"
msgstr "IBAN non valido"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:980
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1311
#: src/features/agent-modes/components/AgentModeEditor.tsx:344
#: src/features/projects/components/NewProjectDialog.tsx:137
msgid "Icona"
msgstr "Icona"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:246
msgid "ID conto (vuoto = predefinito)"
msgstr "ID conto (vuoto = predefinito)"

#: src/features/clean-control/components/EventDetailSheet.tsx:465
msgid "ID correlati"
msgstr "ID correlati"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:597
msgid "ID della tua app"
msgstr "ID della tua app"

#: src/features/console/components/ModelPickerModal.tsx:349
#: src/features/console/components/ProviderAccounts.tsx:210
msgid "ID progetto Google Cloud"
msgstr "ID progetto Google Cloud"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/EmbeddedIdentityPage.tsx:619
#: src/features/console/pages/ResourceAccessPage.tsx:848
msgid "ID utente nella tua app"
msgstr "ID utente nella tua app"

#: src/features/connectors/wizards/accountingSpec.tsx:85
msgid "Ideale per PMI italiane — OAuth + API v2"
msgstr "Ideale per PMI italiane — OAuth + API v2"

#: src/features/projects/components/ProjectIcon.tsx:67
msgid "Idee"
msgstr "Idee"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:88
msgid "Identico"
msgstr "Identico"

#: src/features/console/pages/TracesPage.tsx:335
msgid "Identificativi registrati per questa richiesta"
msgstr "Identificativi registrati per questa richiesta"

#: src/features/console/components/DocumentAcquiredContent.tsx:76
msgid "Identificativo del frammento"
msgstr "Identificativo del frammento"

#: src/features/console/traces/TraceGraph.tsx:443
msgid "Identificativo del registro"
msgstr "Identificativo del registro"

#. placeholder {0}: created.key_prefix
#: src/features/console/components/CreateKeyWizard.tsx:636
msgid "Identificatore pubblico: <0>{0}…</0>"
msgstr "Identificatore pubblico: <0>{0}…</0>"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:306
msgid "Identificatore stabile del connettore: è ciò che ogni chiamata di sync indirizza."
msgstr "Identificatore stabile del connettore: è ciò che ogni chiamata di sync indirizza."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:262
msgid "Identificatore stabile dell'azione, unico per questo connettore (es. create.ticket)."
msgstr "Identificatore stabile dell'azione, unico per questo connettore (es. create.ticket)."

#: src/features/admin/components/orgs/OrgDetailShell.tsx:159
msgid "Identità"
msgstr "Identità"

#: src/features/console/docs/content.ts:251
msgid "Identità del project"
msgstr "Identità del project"

#: src/features/console/docs/content.ts:1693
msgid "Identità del project della chiave corrente."
msgstr "Identità del project della chiave corrente."

#: src/features/console/components/ProviderAccounts.tsx:107
msgid "Identità delegata"
msgstr "Identità delegata"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:729
msgid "Identità dell'app"
msgstr "Identità dell'app"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:223
msgid "Identità di brand"
msgstr "Identità di brand"

#: src/features/console/components/CreateKeyWizard.tsx:275
msgid "Identità e ambiente"
msgstr "Identità e ambiente"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:297
msgid "Identità e connessioni degli utenti finali delle tue app."
msgstr "Identità e connessioni degli utenti finali delle tue app."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:409
msgid "Identità OIDC avanzata"
msgstr "Identità OIDC avanzata"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:471
msgid "Identità per la sincronizzazione"
msgstr "Identità per la sincronizzazione"

#: src/features/admin/components/orgs/OrgCostTab.tsx:206
msgid "identità visibili"
msgstr "identità visibili"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:184
msgid "Identity Provider (SSO)"
msgstr "Identity Provider (SSO)"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:137
#: src/features/admin/components/orgs/OrgSSOTab.tsx:156
msgid "IdP"
msgstr "IdP"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:127
msgid "IdP configurato"
msgstr "IdP configurato"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:150
msgid "IdP rimosso"
msgstr "IdP rimosso"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:522
msgid "Idratazione della matrice in corso… una richiesta per membro"
msgstr "Idratazione della matrice in corso… una richiesta per membro"

#: src/features/projects/utils/relativeDate.ts:157
#: src/features/workspace/hooks/formatRelativeTime.ts:34
msgid "ieri"
msgstr "ieri"

#: src/features/clean-control/utils/signalCatalog.ts:228
msgid "Ignora"
msgstr "Ignora"

#: src/features/sales/components/crm/SuggestionsStrip.tsx:153
msgid "Ignora suggerimento"
msgstr "Ignora suggerimento"

#. placeholder {0}: suggestion.entity_name
#: src/features/canvases/components/SuggestedCanvasCard.tsx:167
msgid "Ignora suggerimento per {0}"
msgstr "Ignora suggerimento per {0}"

#: src/features/clean-control/components/EventQueue.tsx:291
msgid "Ignora tutti"
msgstr "Ignora tutti"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:352
msgid "Il"
msgstr "Il"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:78
msgid "Il {kindLabel} aperto <0>“{title}”</0> non guiderà questa risposta."
msgstr "Il {kindLabel} aperto <0>“{title}”</0> non guiderà questa risposta."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:99
msgid "Il 1° di ogni mese alle 09:00"
msgstr "Il 1° di ogni mese alle 09:00"

#: src/features/admin/components/orgs/OrgAuditTab.tsx:55
msgid "Il backend non ha ancora esposto l'endpoint dedicato — l'UI è pronta per la prima release."
msgstr "Il backend non ha ancora esposto l'endpoint dedicato — l'UI è pronta per la prima release."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:155
msgid "Il body template deve essere un oggetto JSON (i valori possono usare segnaposto {{parametro}})."
msgstr "Il body template deve essere un oggetto JSON (i valori possono usare segnaposto {{parametro}})."

#: src/features/briefing/briefingActions.ts:68
msgid "Il briefing non ha specificato un percorso di destinazione."
msgstr "Il briefing non ha specificato un percorso di destinazione."

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:166
msgid "Il browser ha bloccato l'accesso agli appunti."
msgstr "Il browser ha bloccato l'accesso agli appunti."

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:156
#: src/features/sources/components/CalendarEventPane.tsx:372
msgid "Il browser ha negato l'accesso agli appunti."
msgstr "Il browser ha negato l'accesso agli appunti."

#: src/features/console/docs/content.ts:1396
msgid "Il browser riceve ando_session e ando_proof nell'URL di ritorno. Conferma una sola volta con la stessa sessione Console; non conservare né riutilizzare il proof."
msgstr "Il browser riceve ando_session e ando_proof nell'URL di ritorno. Conferma una sola volta con la stessa sessione Console; non conservare né riutilizzare il proof."

#: src/features/admin/components/AdminCpq.tsx:1176
msgid "Il calcolo viene congelato con il listino corrente. Chi apre il link inserisce la propria email e riceve un codice monouso: entrano solo gli indirizzi elencati."
msgstr "Il calcolo viene congelato con il listino corrente. Chi apre il link inserisce la propria email e riceve un codice monouso: entrano solo gli indirizzi elencati."

#. placeholder {0}: dependent.name
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:187
msgid "Il campo {0} usa {name}. Rimuovi prima il campo dipendente."
msgstr "Il campo {0} usa {name}. Rimuovi prima il campo dipendente."

#: src/features/console/pages/ConnectorsPage.tsx:326
msgid "Il catalogo dei connettori non è disponibile al momento."
msgstr "Il catalogo dei connettori non è disponibile al momento."

#: src/features/console/pages/ModelsPage.tsx:430
msgid "Il catalogo dei modelli non è disponibile per questa organizzazione. Riprova più tardi."
msgstr "Il catalogo dei modelli non è disponibile per questa organizzazione. Riprova più tardi."

#: src/features/dashboard/components/ShareChartSheet.tsx:262
#: src/features/dashboard/components/ShareDashboardSheet.tsx:249
msgid "il collega"
msgstr "il collega"

#: src/features/console/pages/MembersPage.tsx:214
msgid "Il collega potrà entrare nella Console di questa organizzazione con il ruolo scelto. L’invito scade tra 7 giorni."
msgstr "Il collega potrà entrare nella Console di questa organizzazione con il ruolo scelto. L’invito scade tra 7 giorni."

#: src/features/clean-control/utils/explainEvent.ts:82
msgid "Il collegamento {provider} non si sincronizza da un po': i dati potrebbero non essere aggiornati."
msgstr "Il collegamento {provider} non si sincronizza da un po': i dati potrebbero non essere aggiornati."

#: src/features/console/connectors/CustomConnectorDetail.tsx:859
msgid "Il config viene sostituito per intero e ri-validato; lo stato del cursore si azzera (la prossima run è un full sync). Lascia il secret vuoto per mantenere quello sigillato."
msgstr "Il config viene sostituito per intero e ri-validato; lo stato del cursore si azzera (la prossima run è un full sync). Lascia il secret vuoto per mantenere quello sigillato."

#: src/features/console/connectors/CustomConnectorDetail.tsx:618
msgid "Il connettore è disabilitato: le run sono in pausa."
msgstr "Il connettore è disabilitato: le run sono in pausa."

#: src/features/console/lib/onboarding.ts:84
msgid "Il contatore segnala contenuti nell'indice. Prova una domanda e controlla i riferimenti: non certifica la completezza della ricerca."
msgstr "Il contatore segnala contenuti nell'indice. Prova una domanda e controlla i riferimenti: non certifica la completezza della ricerca."

#: src/features/console/connectors/CustomConnectorDetail.tsx:655
msgid "il corpo della risposta è l'array"
msgstr "il corpo della risposta è l'array"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:416
msgid "Il database parte privato. Dopo il collegamento puoi scegliere quali utenti della tua app possono interrogarlo dalla pagina Accesso della connessione."
msgstr "Il database parte privato. Dopo il collegamento puoi scegliere quali utenti della tua app possono interrogarlo dalla pagina Accesso della connessione."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:226
msgid "Il database ricalcola gli indicatori nel periodo selezionato."
msgstr "Il database ricalcola gli indicatori nel periodo selezionato."

#: src/features/admin/components/AdminDecks.tsx:701
msgid "Il destinatario apre il link e riceve un codice monouso sulla sua email. Il link mostra la versione attiva al momento della creazione."
msgstr "Il destinatario apre il link e riceve un codice monouso sulla sua email. Il link mostra la versione attiva al momento della creazione."

#: src/features/structured-data/components/StructuredDataCard.tsx:108
msgid "Il dettaglio certificato è aperto nell’area dati"
msgstr "Il dettaglio certificato è aperto nell’area dati"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:304
msgid "Il dizionario è stato accettato e viene applicato in background."
msgstr "Il dizionario è stato accettato e viene applicato in background."

#: src/features/sources/components/ArtifactPane.tsx:2004
msgid "il documento"
msgstr "il documento"

#: src/features/sources/components/SyncConflictDialog.tsx:82
msgid "Il documento è cambiato altrove"
msgstr "Il documento è cambiato altrove"

#: src/features/clean-control/components/UndoActionsList.tsx:277
msgid "Il documento è ripristinato. La ricerca semantica sarà disponibile dopo la re-indicizzazione (circa 1 minuto)."
msgstr "Il documento è ripristinato. La ricerca semantica sarà disponibile dopo la re-indicizzazione (circa 1 minuto)."

#: src/features/sources/components/ArtifactPane.tsx:417
msgid "Il documento su Drive/OneDrive/SharePoint NON è stato aggiornato per evitare di sovrascrivere le modifiche dell'altro editor."
msgstr "Il documento su Drive/OneDrive/SharePoint NON è stato aggiornato per evitare di sovrascrivere le modifiche dell'altro editor."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:109
msgid "Il file deve essere un Excel .xlsx."
msgstr "Il file deve essere un Excel .xlsx."

#: src/features/dxf/components/DxfPreviewStage.tsx:515
msgid "Il file è indicizzato ma non è stata generata un'anteprima PNG (entità non supportate o dimensione oltre soglia)."
msgstr "Il file è indicizzato ma non è stata generata un'anteprima PNG (entità non supportate o dimensione oltre soglia)."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:460
msgid "Il file resta nella cartella radice se confermi."
msgstr "Il file resta nella cartella radice se confermi."

#: src/features/connectors/components/_spreadsheet/types.tsx:116
msgid "Il file supera i {maxMb} MB. Riduci le righe o suddividilo."
msgstr "Il file supera i {maxMb} MB. Riduci le righe o suddividilo."

#: src/routes/_authed/workspace/documents.tsx:622
msgid "Il file verrà rimosso dall'indice vettoriale, dal grafo della conoscenza, dal database e dallo storage. Operazione irreversibile."
msgstr "Il file verrà rimosso dall'indice vettoriale, dal grafo della conoscenza, dal database e dallo storage. Operazione irreversibile."

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:102
msgid "Il file viene risincronizzato circa ogni 60 minuti"
msgstr "Il file viene risincronizzato circa ogni 60 minuti"

#: src/features/hive-flows/run/PdfDropzone.tsx:220
msgid "Il flow analizza il documento e prepara una proposta da approvare."
msgstr "Il flow analizza il documento e prepara una proposta da approvare."

#: src/features/console/pages/FlowDetailPage.tsx:161
msgid "Il flow potrebbe essere stato eliminato o l'indirizzo non è corretto."
msgstr "Il flow potrebbe essere stato eliminato o l'indirizzo non è corretto."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1582
msgid "Il flow sta analizzando il documento."
msgstr "Il flow sta analizzando il documento."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:132
msgid "Il foglio parte privato. Dopo l'importazione puoi scegliere quali utenti della tua app possono interrogarlo dalla pagina Accesso della connessione."
msgstr "Il foglio parte privato. Dopo l'importazione puoi scegliere quali utenti della tua app possono interrogarlo dalla pagina Accesso della connessione."

#: src/features/console/pages/TracesPage.tsx:621
msgid "Il grafo conserva root, chiamate e singoli eventi. Nessuna ricerca o replay parte da questa vista."
msgstr "Il grafo conserva root, chiamate e singoli eventi. Nessuna ricerca o replay parte da questa vista."

#: src/features/console/pages/TracesPage.tsx:361
msgid "Il grafo conserva tutti i gruppi visibili dopo i filtri. L’ordine di registrazione non prova una causa o un passaggio di dati; le relazioni esplicite mantengono la provenienza registrata. Una cattura assente non prova che il modello non abbia ricevuto i dati."
msgstr "Il grafo conserva tutti i gruppi visibili dopo i filtri. L’ordine di registrazione non prova una causa o un passaggio di dati; le relazioni esplicite mantengono la provenienza registrata. Una cattura assente non prova che il modello non abbia ricevuto i dati."

#: src/features/connect/components/ChatbotPanel.tsx:172
msgid "Il link pubblico e il codice di incorporamento smetteranno di funzionare immediatamente. Potrai ripubblicare in seguito con un nuovo link."
msgstr "Il link pubblico e il codice di incorporamento smetteranno di funzionare immediatamente. Potrai ripubblicare in seguito con un nuovo link."

#: src/features/share/components/ShareLinkDialog.tsx:612
msgid "Il link scade fra"
msgstr "Il link scade fra"

#: src/features/admin/components/AdminCpqPriceBook.tsx:122
msgid "Il listino è modificabile solo dai superadmin."
msgstr "Il listino è modificabile solo dai superadmin."

#: src/features/console/docs/content.ts:1765
msgid "Il loop agentico completo (PREVIEW): escalation TRAMA + text-to-SQL. Read-only. Passa conversation_id per il multi-turn."
msgstr "Il loop agentico completo (PREVIEW): escalation TRAMA + text-to-SQL. Read-only. Passa conversation_id per il multi-turn."

#: src/features/console/docs/content.ts:383
msgid "Il loop agentico read-only: escalation TRAMA + text-to-SQL sulle sources pubblicate. sources accetta bucket (documents/structured/web) e id concreti mescolati. Passa conversation_id per il multi-turn. Latenza in decine di secondi (timeout dedicato 120s)."
msgstr "Il loop agentico read-only: escalation TRAMA + text-to-SQL sulle sources pubblicate. sources accetta bucket (documents/structured/web) e id concreti mescolati. Passa conversation_id per il multi-turn. Latenza in decine di secondi (timeout dedicato 120s)."

#: src/features/admin/components/GlobalMarkupCard.tsx:116
msgid "Il markup deve essere tra {min}% e {max}%."
msgstr "Il markup deve essere tra {min}% e {max}%."

#: src/features/structured-data/components/CadDataPanel.tsx:141
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:182
msgid "Il messaggio collegato a questo risultato non è più nella cache della chat. Apri la conversazione di origine per rieseguire la query."
msgstr "Il messaggio collegato a questo risultato non è più nella cache della chat. Apri la conversazione di origine per rieseguire la query."

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:309
msgid "Il MetaPrompt agent confronta le versioni dei prompt via chi-square test (α=0.05, effect ≥5%). Il job EXPERIMENT_MONITOR auto-promuove il vincitore se statisticamente significativo. χ² calcolato lato client come anteprima; il backend è l'unico autorizzato a promuovere."
msgstr "Il MetaPrompt agent confronta le versioni dei prompt via chi-square test (α=0.05, effect ≥5%). Il job EXPERIMENT_MONITOR auto-promuove il vincitore se statisticamente significativo. χ² calcolato lato client come anteprima; il backend è l'unico autorizzato a promuovere."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:334
msgid "Il MetaPrompt agent genera proposte basate sui feedback degli utenti. Approva per attivare la nuova versione (1 sola attiva per specialist), rigetta per deprecare il draft."
msgstr "Il MetaPrompt agent genera proposte basate sui feedback degli utenti. Approva per attivare la nuova versione (1 sola attiva per specialist), rigetta per deprecare il draft."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:699
msgid "Il mio utente di prova"
msgstr "Il mio utente di prova"

#: src/features/projects/components/sections/PersonaSection.tsx:233
msgid "Il Modo definisce chi è l'agente (riusabile su più progetti). Le istruzioni qui sotto si AGGIUNGONO al Modo solo per questo progetto."
msgstr "Il Modo definisce chi è l'agente (riusabile su più progetti). Le istruzioni qui sotto si AGGIUNGONO al Modo solo per questo progetto."

#: src/features/console/pages/PlaygroundPage.tsx:2091
msgid "Il modulo è stato modificato. Esegui di nuovo per aggiornare il risultato."
msgstr "Il modulo è stato modificato. Esegui di nuovo per aggiornare il risultato."

#: src/features/console/pages/EngineSignupPage.tsx:147
msgid "Il nome deve essere univoco. Se è già in uso, scegli un nome diverso."
msgstr "Il nome deve essere univoco. Se è già in uso, scegli un nome diverso."

#: src/features/admin/components/AdminOrgs.tsx:195
msgid "Il nome è obbligatorio."
msgstr "Il nome è obbligatorio."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:37
msgid "Il percorso"
msgstr "Il percorso"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:226
msgid "Il periodo filtra i dati visualizzati."
msgstr "Il periodo filtra i dati visualizzati."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:251
msgid "Il periodo non è ricavabile dai dati disponibili. Scegli le date oppure cambia la colonna data."
msgstr "Il periodo non è ricavabile dai dati disponibili. Scegli le date oppure cambia la colonna data."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:632
msgid "Il periodo non è valido"
msgstr "Il periodo non è valido"

#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:279
msgid "Il picker ha restituito una cartella. Seleziona un file foglio (.xlsx/.xls/.csv)."
msgstr "Il picker ha restituito una cartella. Seleziona un file foglio (.xlsx/.xls/.csv)."

#: src/features/admin/components/AdminCpq.tsx:727
msgid "Il PoC è sempre in SaaS. La fee di servizio è per ambiente."
msgstr "Il PoC è sempre in SaaS. La fee di servizio è per ambiente."

#: src/features/admin/components/AdminCpq.tsx:774
msgid "Il prezzo cresce con la complessità dei contenuti e con le fonti oltre quelle del pacchetto."
msgstr "Il prezzo cresce con la complessità dei contenuti e con le fonti oltre quelle del pacchetto."

#: src/features/console/components/ModelPickerModal.tsx:388
msgid "Il progetto deve autorizzare l'identità Ando a usare questo account. Il salvataggio non verifica i permessi e non attiva le chiamate."
msgstr "Il progetto deve autorizzare l'identità Ando a usare questo account. Il salvataggio non verifica i permessi e non attiva le chiamate."

#: src/features/console/webhooks/WebhooksPanel.tsx:90
msgid "Il progetto ha raggiunto una soglia di utilizzo"
msgstr "Il progetto ha raggiunto una soglia di utilizzo"

#: src/features/projects/components/ProjectDetailPage.tsx:452
msgid "Il progetto non esiste più"
msgstr "Il progetto non esiste più"

#: src/features/console/pages/FlowsPage.tsx:794
msgid "Il progetto non ha ancora flow di automazione. Parti da un template: la galleria qui sotto mostra i punti di partenza pronti."
msgstr "Il progetto non ha ancora flow di automazione. Parti da un template: la galleria qui sotto mostra i punti di partenza pronti."

#: src/features/chat/components/ConversationSidebar.tsx:628
#: src/features/projects/components/ProjectHub.tsx:230
msgid "Il progetto verrà spostato in archivio. Le conversazioni resteranno nella cronologia, senza progetto associato."
msgstr "Il progetto verrà spostato in archivio. Le conversazioni resteranno nella cronologia, senza progetto associato."

#: src/features/console/pages/ResourceAccessPage.tsx:551
msgid "Il proprietario mantiene sempre l'accesso. Rimuovere una persona blocca le nuove query appena salvi."
msgstr "Il proprietario mantiene sempre l'accesso. Rimuovere una persona blocca le nuove query appena salvi."

#: src/features/console/components/ByokModal.tsx:178
msgid "Il provider «{providerLabel}» fattura i consumi delle chiamate coperte. La tariffa del servizio Ando resta separata. Una credenziale salvata non dimostra che una chiamata sia riuscita; in caso di errore non viene usato automaticamente il conto Ando."
msgstr "Il provider «{providerLabel}» fattura i consumi delle chiamate coperte. La tariffa del servizio Ando resta separata. Una credenziale salvata non dimostra che una chiamata sia riuscita; in caso di errore non viene usato automaticamente il conto Ando."

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:162
msgid "Il provider (A-Cube) ha confermato la sincronizzazione ma non ha restituito alcun movimento per i conti collegati. Il<0> sandbox di test </0>tipicamente espone solo metadati (saldo, IBAN) e non transazioni — passa a produzione o richiedi a A-Cube un VAT di test con dataset di mock-transazioni."
msgstr "Il provider (A-Cube) ha confermato la sincronizzazione ma non ha restituito alcun movimento per i conti collegati. Il<0> sandbox di test </0>tipicamente espone solo metadati (saldo, IBAN) e non transazioni — passa a produzione o richiedi a A-Cube un VAT di test con dataset di mock-transazioni."

#: src/features/console/docs/content.ts:1552
msgid "Il provider torna alla tua app con ando_session, ando_status=awaiting_confirmation e ando_proof. Il backend della tua app deve verificare la sessione login del browser e inviare ando_proof insieme allo stesso ID utente verificato dal tuo server. La prova dura dieci minuti e si usa una sola volta; un utente diverso non può attivare l'account. Non registrare la prova nei log."
msgstr "Il provider torna alla tua app con ando_session, ando_status=awaiting_confirmation e ando_proof. Il backend della tua app deve verificare la sessione login del browser e inviare ando_proof insieme allo stesso ID utente verificato dal tuo server. La prova dura dieci minuti e si usa una sola volta; un utente diverso non può attivare l'account. Non registrare la prova nei log."

#: src/features/dxf/components/DxfPreviewStage.tsx:509
msgid "Il render automatico non è riuscito per questo file. Usa il viewer 3D per visualizzarlo o scaricalo per aprirlo in CAD."
msgstr "Il render automatico non è riuscito per questo file. Usa il viewer 3D per visualizzarlo o scaricalo per aprirlo in CAD."

#: src/features/voice_report/components/ReportTab.tsx:77
msgid "Il report appare qui non appena un run completato lo produce."
msgstr "Il report appare qui non appena un run completato lo produce."

#. placeholder {0}: connector.name
#: src/features/console/connectors/CustomConnectorDetail.tsx:797
msgid "Il resto del manifest di «{0}» resta com'è: viene sostituito solo il secret, che non sarà più visibile."
msgstr "Il resto del manifest di «{0}» resta com'è: viene sostituito solo il secret, che non sarà più visibile."

#. placeholder {0}: formatUsdCents(i18n.locale, credits.data?.balance_cents)
#: src/features/console/pages/BillingPage.tsx:153
msgid "Il saldo corrente è {0}."
msgstr "Il saldo corrente è {0}."

#: src/features/console/components/TopupReturnStatus.tsx:87
msgid "Il saldo è stato aggiornato."
msgstr "Il saldo è stato aggiornato."

#: src/features/console/pages/GetStartedPage.tsx:90
msgid "Il saldo viene scalato solo quando l’Engine lavora."
msgstr "Il saldo viene scalato solo quando l’Engine lavora."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:503
msgid "Il secret è sigillato"
msgstr "Il secret è sigillato"

#: src/features/console/webhooks/WebhooksPanel.tsx:778
msgid "Il secret precedente smette di verificare ora."
msgstr "Il secret precedente smette di verificare ora."

#: src/features/console/pages/GetStartedPage.tsx:139
msgid "Il segreto completo viene mostrato una volta sola. Puoi limitarne scope, risorse e spesa."
msgstr "Il segreto completo viene mostrato una volta sola. Puoi limitarne scope, risorse e spesa."

#: src/features/console/pages/PlaygroundPage.tsx:1563
msgid "Il server non ha confermato TRAMA Lakehouse."
msgstr "Il server non ha confermato TRAMA Lakehouse."

#: src/features/console/docs/content.ts:857
msgid "Il signing secret è nella risposta una sola volta."
msgstr "Il signing secret è nella risposta una sola volta."

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:63
msgid "Il sistema firmerà l'XML con il certificato Agenzia delle Entrate e lo trasmetterà allo SDI. Ricevute (NS/MC/EC) torneranno nei prossimi minuti."
msgstr "Il sistema firmerà l'XML con il certificato Agenzia delle Entrate e lo trasmetterà allo SDI. Ricevute (NS/MC/EC) torneranno nei prossimi minuti."

#: src/features/settings/components/BrandKitSettings.tsx:500
msgid "Il sistema genera SOPRA il tuo template {fmt}, preservandone il design."
msgstr "Il sistema genera SOPRA il tuo template {fmt}, preservandone il design."

#: src/features/console/webhooks/WebhooksPanel.tsx:89
msgid "Il sync di una sorgente è terminato"
msgstr "Il sync di una sorgente è terminato"

#: src/routes/_authed/workspace/templates/edit.$slug.tsx:63
msgid "Il template richiesto non esiste oppure non hai i permessi per visualizzarlo."
msgstr "Il template richiesto non esiste oppure non hai i permessi per visualizzarlo."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:770
msgid "Il tipo vale per tutte le lingue; i testi e i punti vengono riadattati al nuovo layout."
msgstr "Il tipo vale per tutte le lingue; i testi e i punti vengono riadattati al nuovo layout."

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:204
msgid "Il titolare dell'attività ha rifiutato di condividere la cronologia chat dall'app WhatsApp Business. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca."
msgstr "Il titolare dell'attività ha rifiutato di condividere la cronologia chat dall'app WhatsApp Business. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca."

#: src/features/studio/components/StudioDrawerContent.tsx:508
msgid "Il tono di voce dell'AI (registro, persona, parole da evitare) vive nel Brand Kit. La lingua resta sempre quella della conversazione."
msgstr "Il tono di voce dell'AI (registro, persona, parole da evitare) vive nel Brand Kit. La lingua resta sempre quella della conversazione."

#: src/features/settings/components/BrandKitSettings.tsx:457
msgid "Il tono guida registro, persona e parole vietate nelle risposte e nei testi generati."
msgstr "Il tono guida registro, persona e parole vietate nelle risposte e nei testi generati."

#: src/features/console/pages/SchemaPage.tsx:880
msgid "Il tuo {UKS_FULL} ({UKS}): la mappa di tutto ciò che l'agente può interrogare. Correggi le descrizioni proposte dall'AI per risposte più precise."
msgstr "Il tuo {UKS_FULL} ({UKS}): la mappa di tutto ciò che l'agente può interrogare. Correggi le descrizioni proposte dall'AI per risposte più precise."

#: src/features/console/pages/ConnectorsPage.tsx:443
msgid "Il tuo account"
msgstr "Il tuo account"

#: src/features/auth/desktop/DesktopLoginForm.tsx:450
msgid "Il tuo account è in coda di attivazione manuale. Ti scriviamo appena sei dentro."
msgstr "Il tuo account è in coda di attivazione manuale. Ti scriviamo appena sei dentro."

#: src/features/console/components/ConsoleShell.tsx:234
#: src/features/console/pages/DevelopersPage.tsx:183
msgid "Il tuo agente"
msgstr "Il tuo agente"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:399
msgid "Il tuo backend passa a Ando un ID utente stabile in ogni richiesta. La AppKey resta sul server."
msgstr "Il tuo backend passa a Ando un ID utente stabile in ogni richiesta. La AppKey resta sul server."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1132
msgid "Il tuo Brand Kit"
msgstr "Il tuo Brand Kit"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:618
msgid "Il tuo Brand Kit · ottimizzato dall'AI"
msgstr "Il tuo Brand Kit · ottimizzato dall'AI"

#: src/routes/public.voice-report.$token.tsx:313
msgid "Il tuo indirizzo email non è autorizzato ad aprire questo link. Chiedi a chi te l'ha inviato di aggiungerti."
msgstr "Il tuo indirizzo email non è autorizzato ad aprire questo link. Chiedi a chi te l'ha inviato di aggiungerti."

#: src/features/billing/components/InvoiceBilledBanner.tsx:52
msgid "Il tuo piano è governato dall'organizzazione tramite contratto enterprise."
msgstr "Il tuo piano è governato dall'organizzazione tramite contratto enterprise."

#: src/features/projects/components/ProjectHub.tsx:570
msgid "Il tuo primo spazio di lavoro"
msgstr "Il tuo primo spazio di lavoro"

#: src/features/console/components/ModelPickerModal.tsx:345
msgid "Il tuo progetto Vertex AI"
msgstr "Il tuo progetto Vertex AI"

#: src/features/settings/components/BillingSettings.tsx:121
msgid "Il valore di Ando questo mese"
msgstr "Il valore di Ando questo mese"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:264
msgid "Il workflow Temporal sta pullando i movimenti dal provider. I dati compariranno entro pochi minuti."
msgstr "Il workflow Temporal sta pullando i movimenti dal provider. I dati compariranno entro pochi minuti."

#: src/features/console/docs/content.ts:1046
msgid "Il write-loop: proponi un'azione su un sistema connesso, ottieni un'anteprima, poi eseguila. Parametri, permessi e rischio vengono verificati; la verifica automatica dei valori contro una fonte autorevole è ancora in preview e non va considerata una protezione attiva."
msgstr "Il write-loop: proponi un'azione su un sistema connesso, ottieni un'anteprima, poi eseguila. Parametri, permessi e rischio vengono verificati; la verifica automatica dei valori contro una fonte autorevole è ancora in preview e non va considerata una protezione attiva."

#: src/features/billing/components/UsageMeter.tsx:207
#: src/features/console/pages/KeyDetailPage.tsx:455
msgid "Illimitato"
msgstr "Illimitato"

#: src/features/chat/components/MessagePreviewEmbed.tsx:249
msgid "Illustrazione generata"
msgstr "Illustrazione generata"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:775
msgid "Illustrazioni AI"
msgstr "Illustrazioni AI"

#: src/features/price-lists/utils/formatItem.ts:38
msgid "Imballaggio"
msgstr "Imballaggio"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:169
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1302
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2446
#: src/features/share/components/ShareLinkDialog.tsx:498
msgid "Immagine"
msgstr "Immagine"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:247
msgid "Immagine AI"
msgstr "Immagine AI"

#: src/features/chat/components/MessagePreviewEmbed.tsx:225
#: src/features/chat/components/MessagePreviewEmbed.tsx:230
msgid "Immagine generata"
msgstr "Immagine generata"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1339
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2440
msgid "Immagine non valida"
msgstr "Immagine non valida"

#: src/features/sources/marp/MarpDeckEditorMount.tsx:171
msgid "Immagine rigenerata"
msgstr "Immagine rigenerata"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1336
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2437
msgid "Immagine troppo grande anche dopo la riduzione"
msgstr "Immagine troppo grande anche dopo la riduzione"

#: src/features/chat/components/ChatTopBar.tsx:210
msgid "Immagini"
msgstr "Immagini"

#: src/features/sync/components/DocSyncManager.tsx:1369
msgid "Impatto storage"
msgstr "Impatto storage"

#: src/features/admin/components/AdminCpqAskAndo.tsx:179
#: src/features/admin/components/AdminCpqProposalCopy.tsx:48
msgid "Impegno a 3 anni"
msgstr "Impegno a 3 anni"

#: src/features/admin/components/AdminCpq.tsx:937
msgid "Impegno a 3 anni (sconto su licenze e fee)"
msgstr "Impegno a 3 anni (sconto su licenze e fee)"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:122
msgid "Impone TOTP o passkey a tutti i membri."
msgstr "Impone TOTP o passkey a tutti i membri."

#. placeholder {0}: b.rate
#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:268
msgid "Imponibile · IVA {0}%"
msgstr "Imponibile · IVA {0}%"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:301
msgid "Import avviato"
msgstr "Import avviato"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:147
msgid "Import avviato. Il foglio apparirà dopo l'analisi."
msgstr "Import avviato. Il foglio apparirà dopo l'analisi."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:309
msgid "Import avviato. Lo schema si aggiorna in background; segui l'avanzamento nella scheda Schema."
msgstr "Import avviato. Lo schema si aggiorna in background; segui l'avanzamento nella scheda Schema."

#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:440
msgid "Import non riuscito."
msgstr "Import non riuscito."

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:335
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:467
msgid "Importa"
msgstr "Importa"

#: src/features/settings/marp/PptxExtractPanel.tsx:126
msgid "Importa da PowerPoint"
msgstr "Importa da PowerPoint"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:142
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:153
#: src/features/integrations/parts/ConnectorDetailSection.tsx:231
msgid "Importa dizionario dati"
msgstr "Importa dizionario dati"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:188
msgid "Importa foglio"
msgstr "Importa foglio"

#: src/features/connectors/components/SpreadsheetConnectDialog.tsx:170
msgid "Importa foglio · Anteprima"
msgstr "Importa foglio · Anteprima"

#. placeholder {0}: SOURCE_LABELS[sourceMode]
#: src/features/connectors/components/SpreadsheetConnectDialog.tsx:171
msgid "Importa foglio di calcolo · {0}"
msgstr "Importa foglio di calcolo · {0}"

#. placeholder {0}: SOURCE_LABELS[sourceMode]
#: src/features/connectors/components/SpreadsheetConnectDialog.tsx:160
msgid "Importa foglio: {0}"
msgstr "Importa foglio: {0}"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:54
msgid "Importa le trascrizioni disponibili per questo account. Il lavoro continua quando chiudi questa finestra; riaprendola puoi controllarne lo stato."
msgstr "Importa le trascrizioni disponibili per questo account. Il lavoro continua quando chiudi questa finestra; riaprendola puoi controllarne lo stato."

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:61
msgid "Importa trascrizioni"
msgstr "Importa trascrizioni"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:130
msgid "Importa un foglio in Engine"
msgstr "Importa un foglio in Engine"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:68
msgid "Importazione completata."
msgstr "Importazione completata."

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:228
msgid "Importazione cronologia messaggi"
msgstr "Importazione cronologia messaggi"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:92
msgid "Importazione cronologia messaggi completata"
msgstr "Importazione cronologia messaggi completata"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:227
msgid "Importazione cronologia messaggi in corso"
msgstr "Importazione cronologia messaggi in corso"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:181
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:182
msgid "Importazione cronologia messaggi non riuscita"
msgstr "Importazione cronologia messaggi non riuscita"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:66
msgid "Importazione in coda."
msgstr "Importazione in coda."

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:331
#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:61
msgid "Importazione in corso…"
msgstr "Importazione in corso…"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:71
msgid "Importazione interrotta."
msgstr "Importazione interrotta."

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:70
msgid "Importazione non riuscita. I documenti già importati restano disponibili."
msgstr "Importazione non riuscita. I documenti già importati restano disponibili."

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:69
msgid "Importazione parziale: alcune trascrizioni non sono state importate."
msgstr "Importazione parziale: alcune trascrizioni non sono state importate."

#: src/features/console/pages/OverviewPage.tsx:270
msgid "Importazioni recenti"
msgstr "Importazioni recenti"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:220
#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:57
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:135
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:163
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:223
#: src/features/admin/components/orgs/OrgBillingTab.tsx:606
#: src/features/billing/components/InvoicesTable.tsx:116
#: src/features/console/pages/BillingPage.tsx:602
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:54
msgid "Importo"
msgstr "Importo"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:65
msgid "Importo · {lo}–{hi}€"
msgstr "Importo · {lo}–{hi}€"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:61
msgid "Importo · ≤ {hi}€"
msgstr "Importo · ≤ {hi}€"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:57
msgid "Importo · ≥ {lo}€"
msgstr "Importo · ≥ {lo}€"

#: src/features/console/pages/BillingPage.tsx:514
msgid "Importo (USD)"
msgstr "Importo (USD)"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:223
msgid "Importo *"
msgstr "Importo *"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:285
msgid "Importo credito in USD"
msgstr "Importo credito in USD"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:249
msgid "Importo del bonifico in euro"
msgstr "Importo del bonifico in euro"

#: src/features/console/components/CustomTopup.tsx:23
msgid "Importo personalizzato (USD)"
msgstr "Importo personalizzato (USD)"

#: src/features/console/pages/BillingPage.tsx:524
msgid "Importo ricarica in USD"
msgstr "Importo ricarica in USD"

#: src/features/connect/components/ChatbotPanel.tsx:237
msgid "Impossibile aggiornare i limiti"
msgstr "Impossibile aggiornare i limiti"

#: src/features/settings/components/SelfProfileMemory.tsx:355
msgid "Impossibile aggiornare il consenso. Riprova fra qualche minuto."
msgstr "Impossibile aggiornare il consenso. Riprova fra qualche minuto."

#: src/features/dashboard/components/ShareChartSheet.tsx:372
#: src/features/dashboard/components/ShareDashboardSheet.tsx:359
msgid "Impossibile aggiornare il permesso."
msgstr "Impossibile aggiornare il permesso."

#: src/features/projects/components/sections/MembersSection.tsx:124
msgid "Impossibile aggiornare il ruolo"
msgstr "Impossibile aggiornare il ruolo"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/MembersSection.tsx:123
msgid "Impossibile aggiornare il ruolo: {0}"
msgstr "Impossibile aggiornare il ruolo: {0}"

#: src/features/projects/components/sections/TasksSection.tsx:90
msgid "Impossibile aggiornare l'attività"
msgstr "Impossibile aggiornare l'attività"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/TasksSection.tsx:89
msgid "Impossibile aggiornare l'attività: {0}"
msgstr "Impossibile aggiornare l'attività: {0}"

#: src/features/projects/components/sections/MemorySection.tsx:174
msgid "Impossibile aggiornare la policy"
msgstr "Impossibile aggiornare la policy"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/MemorySection.tsx:173
msgid "Impossibile aggiornare la policy: {0}"
msgstr "Impossibile aggiornare la policy: {0}"

#: src/features/sources/components/InboxDetailPane.tsx:530
msgid "Impossibile annullare"
msgstr "Impossibile annullare"

#: src/features/connectors/components/CancelSyncButton.tsx:64
msgid "Impossibile annullare la sincronizzazione."
msgstr "Impossibile annullare la sincronizzazione."

#. placeholder {0}: err.message
#: src/features/connectors/components/CancelSyncButton.tsx:63
msgid "Impossibile annullare: {0}"
msgstr "Impossibile annullare: {0}"

#: src/features/sync/components/DocSyncManager.tsx:386
msgid "Impossibile annullare: {reason}"
msgstr "Impossibile annullare: {reason}"

#. placeholder {0}: file.filename
#: src/features/chat/components/ChatTopBar.tsx:136
msgid "Impossibile aprire {0}"
msgstr "Impossibile aprire {0}"

#: src/features/sources/components/ArtifactToolbar.tsx:84
msgid "Impossibile aprire esternamente: {errMsg}"
msgstr "Impossibile aprire esternamente: {errMsg}"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:509
msgid "Impossibile aprire il browser"
msgstr "Impossibile aprire il browser"

#: src/features/auth/desktop/useDesktopOAuth.ts:197
msgid "Impossibile aprire il browser."
msgstr "Impossibile aprire il browser."

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:129
msgid "Impossibile aprire il caso."
msgstr "Impossibile aprire il caso."

#. placeholder {0}: err instanceof Error ? err.message : t`errore`
#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:180
msgid "Impossibile aprire il picker: {0}"
msgstr "Impossibile aprire il picker: {0}"

#: src/features/sync/components/DocSyncManager.tsx:270
msgid "Impossibile aprire il picker: {reason}"
msgstr "Impossibile aprire il picker: {reason}"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:329
msgid "Impossibile aprire il portale Stripe."
msgstr "Impossibile aprire il portale Stripe."

#: src/features/voice_report/components/VoiceReportDetailPage.tsx:97
msgid "Impossibile aprire il report"
msgstr "Impossibile aprire il report"

#: src/features/actions/hooks/useCreateManualAction.ts:76
msgid "Impossibile aprire l'azione: area non trovata."
msgstr "Impossibile aprire l'azione: area non trovata."

#: src/features/sources/marp/ManualDeckEditMount.tsx:130
msgid "Impossibile aprire l'editor di questo deck."
msgstr "Impossibile aprire l'editor di questo deck."

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:423
msgid "Impossibile aprire la presentazione."
msgstr "Impossibile aprire la presentazione."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:162
msgid "Impossibile aprire questo canvas"
msgstr "Impossibile aprire questo canvas"

#: src/features/sources/components/InboxDetailPane.tsx:305
msgid "Impossibile archiviare l'email"
msgstr "Impossibile archiviare l'email"

#: src/features/hive-flows/components/FlowShareControl.tsx:97
msgid "Impossibile assegnare il progetto"
msgstr "Impossibile assegnare il progetto"

#: src/features/settings/components/OtpEmailPanel.tsx:47
msgid "Impossibile attivare il codice via email. Verifica che la tua email sia confermata."
msgstr "Impossibile attivare il codice via email. Verifica che la tua email sia confermata."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:343
msgid "Impossibile avviare il checkout Stripe."
msgstr "Impossibile avviare il checkout Stripe."

#: src/features/settings/components/DataExport.tsx:130
msgid "Impossibile avviare l'esportazione. Riprova fra qualche minuto."
msgstr "Impossibile avviare l'esportazione. Riprova fra qualche minuto."

#: src/features/sync/components/DocSyncManager.tsx:557
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:264
msgid "Impossibile avviare la ri-sincronizzazione: {reason}"
msgstr "Impossibile avviare la ri-sincronizzazione: {reason}"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:241
#: src/features/sync/components/DocSyncManager.tsx:327
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:221
msgid "Impossibile avviare la sincronizzazione: {reason}"
msgstr "Impossibile avviare la sincronizzazione: {reason}"

#: src/features/clean-control/components/EventRow.tsx:508
msgid "Impossibile calcolare l'anteprima."
msgstr "Impossibile calcolare l'anteprima."

#: src/features/integrations/parts/StatusElements.tsx:131
msgid "Impossibile caricare gli account"
msgstr "Impossibile caricare gli account"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:322
msgid "Impossibile caricare gli esperimenti."
msgstr "Impossibile caricare gli esperimenti."

#: src/features/admin/components/AdminDemoInviti.tsx:205
msgid "Impossibile caricare gli inviti"
msgstr "Impossibile caricare gli inviti"

#: src/routes/_authed/workspace/connect.index.tsx:154
#: src/routes/_authed/workspace/connect.index.tsx:208
msgid "Impossibile caricare gli spazi"
msgstr "Impossibile caricare gli spazi"

#: src/features/settings/MarpTemplateSettings.tsx:378
msgid "Impossibile caricare gli stili — riprova fra un istante."
msgstr "Impossibile caricare gli stili — riprova fra un istante."

#: src/features/admin/components/AdminUsers.tsx:293
msgid "Impossibile caricare gli utenti"
msgstr "Impossibile caricare gli utenti"

#: src/routes/_authed/workspace/canvases.tsx:215
msgid "Impossibile caricare i canvases"
msgstr "Impossibile caricare i canvases"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:64
msgid "Impossibile caricare i casi."
msgstr "Impossibile caricare i casi."

#: src/features/connect/components/MemberManager.tsx:647
msgid "Impossibile caricare i colleghi."
msgstr "Impossibile caricare i colleghi."

#: src/features/connect/components/GrantManager.tsx:698
msgid "Impossibile caricare i connettori condivisibili. Riprova."
msgstr "Impossibile caricare i connettori condivisibili. Riprova."

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:323
msgid "Impossibile caricare i consolidation jobs."
msgstr "Impossibile caricare i consolidation jobs."

#: src/features/chat/components/ChatTopBar.tsx:179
msgid "Impossibile caricare i contenuti."
msgstr "Impossibile caricare i contenuti."

#: src/routes/_authed/workspace/finance.tsx:1494
msgid "Impossibile caricare i conti dal provider banking."
msgstr "Impossibile caricare i conti dal provider banking."

#: src/features/admin/components/orgs/OrgCostTab.tsx:332
msgid "Impossibile caricare i costi dell'organizzazione."
msgstr "Impossibile caricare i costi dell'organizzazione."

#: src/routes/_authed/workspace/technical.tsx:358
msgid "Impossibile caricare i disegni"
msgstr "Impossibile caricare i disegni"

#: src/routes/_authed/workspace/documents.tsx:957
msgid "Impossibile caricare i documenti"
msgstr "Impossibile caricare i documenti"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:182
msgid "Impossibile caricare i documenti generati. Riprova fra poco."
msgstr "Impossibile caricare i documenti generati. Riprova fra poco."

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:193
msgid "Impossibile caricare i fact."
msgstr "Impossibile caricare i fact."

#: src/features/settings/components/SelfProfileMemory.tsx:406
msgid "Impossibile caricare i fatti."
msgstr "Impossibile caricare i fatti."

#: src/features/projects/components/sections/MembersSection.tsx:453
msgid "Impossibile caricare i membri dell'organizzazione."
msgstr "Impossibile caricare i membri dell'organizzazione."

#: src/features/projects/components/sections/MembersSection.tsx:626
msgid "Impossibile caricare i membri. Riprova fra poco."
msgstr "Impossibile caricare i membri. Riprova fra poco."

#: src/features/console/pages/ModelsPage.tsx:383
msgid "Impossibile caricare i modelli"
msgstr "Impossibile caricare i modelli"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:397
msgid "Impossibile caricare i nudge."
msgstr "Impossibile caricare i nudge."

#: src/features/admin/components/AdminPlatformSettings.tsx:522
msgid "Impossibile caricare i piani"
msgstr "Impossibile caricare i piani"

#: src/features/admin/components/AdminCpqList.tsx:120
msgid "Impossibile caricare i preventivi"
msgstr "Impossibile caricare i preventivi"

#: src/features/admin/components/AdminPlatformSettings.tsx:161
msgid "Impossibile caricare i prezzi"
msgstr "Impossibile caricare i prezzi"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:535
msgid "Impossibile caricare i reasoning traces."
msgstr "Impossibile caricare i reasoning traces."

#: src/features/voice_report/components/VoiceReportsList.tsx:195
msgid "Impossibile caricare i report"
msgstr "Impossibile caricare i report"

#: src/features/admin/components/AdminRevenue.tsx:74
msgid "Impossibile caricare i ricavi"
msgstr "Impossibile caricare i ricavi"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:495
msgid "Impossibile caricare i siti SharePoint"
msgstr "Impossibile caricare i siti SharePoint"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:308
msgid "Impossibile caricare i template. Riprova fra poco."
msgstr "Impossibile caricare i template. Riprova fra poco."

#: src/features/voice_report/components/TemplatesGallery.tsx:417
msgid "Impossibile caricare i template. Riprova più tardi."
msgstr "Impossibile caricare i template. Riprova più tardi."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:207
msgid "Impossibile caricare i workflow suggestions"
msgstr "Impossibile caricare i workflow suggestions"

#: src/routes/_authed/workspace/calendar.tsx:1411
msgid "Impossibile caricare il calendario"
msgstr "Impossibile caricare il calendario"

#: src/routes/public.voice-report.$token.tsx:201
msgid "Impossibile caricare il contenuto del report. Il link al payload è scaduto: aggiorna la pagina per richiedere un nuovo URL firmato."
msgstr "Impossibile caricare il contenuto del report. Il link al payload è scaduto: aggiorna la pagina per richiedere un nuovo URL firmato."

#: src/features/admin/components/AdminCanvas.tsx:86
msgid "Impossibile caricare il dashboard canvas"
msgstr "Impossibile caricare il dashboard canvas"

#: src/features/admin/components/AdminCostTracking.tsx:216
msgid "Impossibile caricare il dashboard costi"
msgstr "Impossibile caricare il dashboard costi"

#: src/features/admin/components/AdminDecks.tsx:568
msgid "Impossibile caricare il deck."
msgstr "Impossibile caricare il deck."

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:533
#: src/features/hive-flows/run/RunDocumentViewer.tsx:122
msgid "Impossibile caricare il documento."
msgstr "Impossibile caricare il documento."

#: src/features/sources/components/ArtifactPane.tsx:1934
msgid "Impossibile caricare il documento. Scaricalo qui sotto."
msgstr "Impossibile caricare il documento. Scaricalo qui sotto."

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:480
msgid "Impossibile caricare il file."
msgstr "Impossibile caricare il file."

#: src/features/admin/components/widgets/EmptyChartState.tsx:60
msgid "Impossibile caricare il grafico."
msgstr "Impossibile caricare il grafico."

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:392
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:432
msgid "Impossibile caricare il PDF."
msgstr "Impossibile caricare il PDF."

#: src/features/settings/components/ProfileSettings.tsx:90
msgid "Impossibile caricare il profilo"
msgstr "Impossibile caricare il profilo"

#: src/features/admin/components/AdminPlatformSettings.tsx:1013
msgid "Impossibile caricare il registry modelli."
msgstr "Impossibile caricare il registry modelli."

#: src/features/voice_report/components/ReportTab.tsx:56
msgid "Impossibile caricare il report."
msgstr "Impossibile caricare il report."

#: src/routes/_authed/workspace/templates/$kind.tsx:291
msgid "Impossibile caricare il template selezionato."
msgstr "Impossibile caricare il template selezionato."

#: src/features/sources/components/InboxDetailPane.tsx:764
msgid "Impossibile caricare il thread. Mostro l'anteprima salvata."
msgstr "Impossibile caricare il thread. Mostro l'anteprima salvata."

#: src/features/settings/components/BillingSettings.tsx:109
msgid "Impossibile caricare l'abbonamento"
msgstr "Impossibile caricare l'abbonamento"

#: src/features/connectors/components/management/SchemaViewer.tsx:734
msgid "Impossibile caricare l'anteprima dei dati."
msgstr "Impossibile caricare l'anteprima dei dati."

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:250
msgid "Impossibile caricare l'audit trail."
msgstr "Impossibile caricare l'audit trail."

#: src/features/admin/components/AdminAutomation.tsx:89
msgid "Impossibile caricare l'automation dashboard"
msgstr "Impossibile caricare l'automation dashboard"

#: src/routes/_authed/workspace/dashboard.tsx:1065
msgid "Impossibile caricare l'elenco dashboard"
msgstr "Impossibile caricare l'elenco dashboard"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:310
msgid "Impossibile caricare l'elenco delle connessioni. Riprova fra qualche secondo."
msgstr "Impossibile caricare l'elenco delle connessioni. Riprova fra qualche secondo."

#: src/features/admin/components/AdminEngagement.tsx:104
msgid "Impossibile caricare l'engagement"
msgstr "Impossibile caricare l'engagement"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1650
msgid "Impossibile caricare l'esecuzione."
msgstr "Impossibile caricare l'esecuzione."

#: src/features/clean-control/components/EventDetailSheet.tsx:125
msgid "Impossibile caricare l’evento."
msgstr "Impossibile caricare l’evento."

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:472
msgid "Impossibile caricare l'evolution log"
msgstr "Impossibile caricare l'evolution log"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:159
msgid "Impossibile caricare l'immagine."
msgstr "Impossibile caricare l'immagine."

#: src/routes/_authed/workspace/conversations.tsx:855
msgid "Impossibile caricare l'inbox"
msgstr "Impossibile caricare l'inbox"

#: src/features/voice_report/components/OutlineTab.tsx:124
msgid "Impossibile caricare l'outline."
msgstr "Impossibile caricare l'outline."

#: src/features/admin/components/AdminOverview.tsx:79
msgid "Impossibile caricare l'overview"
msgstr "Impossibile caricare l'overview"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:358
msgid "Impossibile caricare la coda di approvazione"
msgstr "Impossibile caricare la coda di approvazione"

#: src/routes/_authed/workspace/technical.tsx:647
msgid "Impossibile caricare la cronologia."
msgstr "Impossibile caricare la cronologia."

#: src/features/settings/marp/CssUploadPanel.tsx:310
msgid "Impossibile caricare la lista dei template — riprova fra un istante."
msgstr "Impossibile caricare la lista dei template — riprova fra un istante."

#: src/features/admin/components/AdminOrgs.tsx:968
msgid "Impossibile caricare la lista organizzazioni"
msgstr "Impossibile caricare la lista organizzazioni"

#: src/features/projects/components/sections/MemorySection.tsx:290
msgid "Impossibile caricare la memoria del progetto. Riprova fra poco."
msgstr "Impossibile caricare la memoria del progetto. Riprova fra poco."

#: src/features/admin/components/AdminQuality.tsx:81
msgid "Impossibile caricare la qualità"
msgstr "Impossibile caricare la qualità"

#: src/features/clean-control/components/SignalHealthCard.tsx:85
msgid "Impossibile caricare la salute del segnale."
msgstr "Impossibile caricare la salute del segnale."

#: src/features/admin/components/AdminHealth.tsx:70
msgid "Impossibile caricare la salute del sistema"
msgstr "Impossibile caricare la salute del sistema"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:616
msgid "Impossibile caricare la struttura cartelle"
msgstr "Impossibile caricare la struttura cartelle"

#: src/features/admin/components/ModelMarkupCard.tsx:70
msgid "Impossibile caricare la tariffa modelli."
msgstr "Impossibile caricare la tariffa modelli."

#: src/features/dxf/components/PdfDrawingSheet.tsx:62
msgid "Impossibile caricare la tavola."
msgstr "Impossibile caricare la tavola."

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:145
msgid "Impossibile caricare la vista comparativa dei tenant."
msgstr "Impossibile caricare la vista comparativa dei tenant."

#: src/features/console/flows/ConsoleFlowApprovals.tsx:65
msgid "Impossibile caricare le approvazioni. Riprova."
msgstr "Impossibile caricare le approvazioni. Riprova."

#: src/features/automations/components/AutomationsHub.tsx:336
msgid "Impossibile caricare le automazioni"
msgstr "Impossibile caricare le automazioni"

#: src/features/projects/components/sections/AutomationsSection.tsx:234
msgid "Impossibile caricare le automazioni. Riprova fra poco."
msgstr "Impossibile caricare le automazioni. Riprova fra poco."

#: src/features/clean-control/components/UndoActionsList.tsx:132
msgid "Impossibile caricare le azioni applicate."
msgstr "Impossibile caricare le azioni applicate."

#: src/features/sales/components/SignaturesManager.tsx:324
msgid "Impossibile caricare le caselle."
msgstr "Impossibile caricare le caselle."

#: src/routes/_authed/workspace/shares.tsx:144
msgid "Impossibile caricare le condivisioni"
msgstr "Impossibile caricare le condivisioni"

#: src/features/sales/components/SignaturesManager.tsx:151
msgid "Impossibile caricare le firme."
msgstr "Impossibile caricare le firme."

#: src/features/clean-control/components/policies/PoliciesEditor.tsx:106
msgid "Impossibile caricare le policy."
msgstr "Impossibile caricare le policy."

#: src/features/settings/components/NotificationPreferences.tsx:283
msgid "Impossibile caricare le preferenze"
msgstr "Impossibile caricare le preferenze"

#: src/features/admin/components/AdminDecks.tsx:203
msgid "Impossibile caricare le presentazioni."
msgstr "Impossibile caricare le presentazioni."

#: src/routes/_authed/workspace/work.tsx:542
msgid "Impossibile caricare le proposte"
msgstr "Impossibile caricare le proposte"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:559
msgid "Impossibile caricare le raccolte"
msgstr "Impossibile caricare le raccolte"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:201
msgid "Impossibile caricare le slide del deck."
msgstr "Impossibile caricare le slide del deck."

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:462
msgid "Impossibile caricare le slide."
msgstr "Impossibile caricare le slide."

#: src/features/console/pages/PlaygroundPage.tsx:579
msgid "Impossibile caricare le sorgenti. Le sorgenti collegate non sono selezionabili."
msgstr "Impossibile caricare le sorgenti. Le sorgenti collegate non sono selezionabili."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:216
msgid "Impossibile caricare le statistiche dei nudge."
msgstr "Impossibile caricare le statistiche dei nudge."

#: src/features/connectors/components/management/SchemaViewer.tsx:134
msgid "Impossibile caricare lo schema. Controlla la connessione e riprova."
msgstr "Impossibile caricare lo schema. Controlla la connessione e riprova."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:140
msgid "Impossibile caricare lo stato di WhatsApp."
msgstr "Impossibile caricare lo stato di WhatsApp."

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:213
msgid "Impossibile caricare lo stato HyperMem."
msgstr "Impossibile caricare lo stato HyperMem."

#: src/routes/_authed/workspace/dashboard.tsx:1103
msgid "Impossibile caricare questa dashboard"
msgstr "Impossibile caricare questa dashboard"

#: src/features/actions/components/ActionAiFillBar.tsx:59
#: src/features/voice_report/components/NewReportDialog.tsx:437
msgid "Impossibile compilare con l'AI. Riprova."
msgstr "Impossibile compilare con l'AI. Riprova."

#: src/features/sources/components/EmailAttachmentChip.tsx:121
msgid "Impossibile completare l'operazione"
msgstr "Impossibile completare l'operazione"

#: src/features/connect/components/GrantManager.tsx:302
msgid "Impossibile condividere la risorsa"
msgstr "Impossibile condividere la risorsa"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:146
msgid "Impossibile confermare il completamento. Controlla lo stato aggiornato e riprova: l'operazione può essere ripetuta."
msgstr "Impossibile confermare il completamento. Controlla lo stato aggiornato e riprova: l'operazione può essere ripetuta."

#: src/routes/_authed/workspace/shares.tsx:249
msgid "Impossibile continuare la conversazione"
msgstr "Impossibile continuare la conversazione"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:165
#: src/features/dashboard/components/AddChartDialog.tsx:197
#: src/features/sources/components/CalendarEventPane.tsx:371
msgid "Impossibile copiare"
msgstr "Impossibile copiare"

#: src/features/sources/components/CalendarEventPane.tsx:219
msgid "Impossibile copiare il link"
msgstr "Impossibile copiare il link"

#: src/features/voice_report/components/NewReportDialog.tsx:764
msgid "Impossibile creare il dataset dalla tua knowledge. Tocca di nuovo per riprovare."
msgstr "Impossibile creare il dataset dalla tua knowledge. Tocca di nuovo per riprovare."

#: src/features/voice_report/components/ShareReportDialog.tsx:166
msgid "Impossibile creare il link"
msgstr "Impossibile creare il link"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:143
msgid "Impossibile creare il progetto"
msgstr "Impossibile creare il progetto"

#. placeholder {0}: err.message
#: src/features/projects/components/TemplatesBrowserDialog.tsx:142
msgid "Impossibile creare il progetto: {0}"
msgstr "Impossibile creare il progetto: {0}"

#: src/features/sources/components/InboxDetailPane.tsx:577
msgid "Impossibile creare il promemoria"
msgstr "Impossibile creare il promemoria"

#: src/features/sources/components/InboxDetailPane.tsx:324
msgid "Impossibile creare il task"
msgstr "Impossibile creare il task"

#: src/features/workspace/components/TaskComposer.tsx:92
msgid "Impossibile creare il task. Riprova."
msgstr "Impossibile creare il task. Riprova."

#: src/features/projects/components/sections/TasksSection.tsx:202
msgid "Impossibile creare l'attività"
msgstr "Impossibile creare l'attività"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/TasksSection.tsx:201
msgid "Impossibile creare l'attività: {0}"
msgstr "Impossibile creare l'attività: {0}"

#: src/features/actions/hooks/useCreateManualAction.ts:92
msgid "Impossibile creare l'azione. Riprova."
msgstr "Impossibile creare l'azione. Riprova."

#: src/features/connect/components/MemberManager.tsx:315
msgid "Impossibile creare l'invito"
msgstr "Impossibile creare l'invito"

#: src/features/dashboard/components/DashboardListSidebar.tsx:153
msgid "Impossibile creare la dashboard."
msgstr "Impossibile creare la dashboard."

#: src/features/connect/components/CreateSpaceDialog.tsx:81
msgid "Impossibile creare lo spazio. Riprova."
msgstr "Impossibile creare lo spazio. Riprova."

#: src/features/connect/components/ChatbotPanel.tsx:85
msgid "Impossibile disattivare il chatbot"
msgstr "Impossibile disattivare il chatbot"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:121
msgid "Impossibile disconnettere WhatsApp Business"
msgstr "Impossibile disconnettere WhatsApp Business"

#. placeholder {0}: doc.title || doc.filename
#. placeholder {1}: err instanceof Error ? err.message : i18n._(msg`errore`)
#: src/routes/_authed/workspace/documents.tsx:603
msgid "Impossibile eliminare \"{0}\": {1}"
msgstr "Impossibile eliminare \"{0}\": {1}"

#: src/features/settings/components/AccountDeletion.tsx:89
msgid "Impossibile eliminare l'account. Riprova tra qualche minuto."
msgstr "Impossibile eliminare l'account. Riprova tra qualche minuto."

#: src/features/projects/components/sections/TasksSection.tsx:103
msgid "Impossibile eliminare l'attività"
msgstr "Impossibile eliminare l'attività"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/TasksSection.tsx:102
msgid "Impossibile eliminare l'attività: {0}"
msgstr "Impossibile eliminare l'attività: {0}"

#: src/features/dashboard/components/DashboardListSidebar.tsx:228
msgid "Impossibile eliminare la dashboard."
msgstr "Impossibile eliminare la dashboard."

#: src/features/dashboard/components/ChartSqlEditor.tsx:93
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:692
msgid "Impossibile eseguire la query."
msgstr "Impossibile eseguire la query."

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:408
msgid "Impossibile generare l'anteprima: {detail}"
msgstr "Impossibile generare l'anteprima: {detail}"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:145
msgid "Impossibile generare l'anteprima: {errMsg}"
msgstr "Impossibile generare l'anteprima: {errMsg}"

#: src/features/sources/components/InboxDetailPane.tsx:1680
msgid "Impossibile generare la bozza"
msgstr "Impossibile generare la bozza"

#. placeholder {0}: err.message
#: src/routes/_authed/workspace/work.tsx:245
msgid "Impossibile ignorare: {0}"
msgstr "Impossibile ignorare: {0}"

#: ../../packages/ui/src/editors/XlsxEditorInline.tsx:1003
msgid "Impossibile inizializzare il foglio."
msgstr "Impossibile inizializzare il foglio."

#: src/features/sources/components/InboxDetailPane.tsx:284
msgid "Impossibile inoltrare l'email"
msgstr "Impossibile inoltrare l'email"

#: src/features/dashboard/components/ShareChartSheet.tsx:444
msgid "Impossibile inviare il grafico."
msgstr "Impossibile inviare il grafico."

#: src/features/sources/components/InboxDetailPane.tsx:544
msgid "Impossibile inviare l'email"
msgstr "Impossibile inviare l'email"

#: src/features/dashboard/components/ShareDashboardSheet.tsx:438
msgid "Impossibile inviare la dashboard."
msgstr "Impossibile inviare la dashboard."

#: src/features/settings/components/SelfProfileMemory.tsx:655
msgid "Impossibile inviare la richiesta. Riprova fra qualche minuto."
msgstr "Impossibile inviare la richiesta. Riprova fra qualche minuto."

#: src/features/projects/components/sections/MembersSection.tsx:354
#: src/features/projects/components/sections/MembersSection.tsx:377
msgid "Impossibile invitare"
msgstr "Impossibile invitare"

#: src/features/connect/components/MemberManager.tsx:335
msgid "Impossibile invitare il collega"
msgstr "Impossibile invitare il collega"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/MembersSection.tsx:353
#: src/features/projects/components/sections/MembersSection.tsx:376
msgid "Impossibile invitare: {0}"
msgstr "Impossibile invitare: {0}"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:82
msgid "Impossibile leggere lo stato di scoperta."
msgstr "Impossibile leggere lo stato di scoperta."

#. placeholder {0}: err.message
#: src/features/workspace/components/NotificationPill.tsx:111
#: src/features/workspace/components/NotificationPill.tsx:129
#: src/routes/_authed/workspace/work.tsx:237
msgid "Impossibile leggere: {0}"
msgstr "Impossibile leggere: {0}"

#. placeholder {0}: this.props.name
#: src/features/console/components/ConsoleSectionBoundary.tsx:64
msgid "Impossibile mostrare la sezione «{0}»"
msgstr "Impossibile mostrare la sezione «{0}»"

#: src/features/console/components/ConsoleSectionBoundary.tsx:66
msgid "Impossibile mostrare questa sezione"
msgstr "Impossibile mostrare questa sezione"

#: src/features/connect/components/ChatbotPanel.tsx:74
msgid "Impossibile pubblicare il chatbot"
msgstr "Impossibile pubblicare il chatbot"

#: src/features/connectors/wizards/openBankingSpec.tsx:57
msgid "Impossibile recuperare le banche disponibili. Riprova fra qualche secondo."
msgstr "Impossibile recuperare le banche disponibili. Riprova fra qualche secondo."

#: src/features/chat/hooks/useAudioRecorder.ts:82
msgid "Impossibile registrare audio."
msgstr "Impossibile registrare audio."

#: src/features/clean-control/components/EventDetailSheet.tsx:238
#: src/features/clean-control/components/EventRow.tsx:601
msgid "Impossibile registrare la segnalazione."
msgstr "Impossibile registrare la segnalazione."

#: src/features/voice_report/components/ShareReportDialog.tsx:178
msgid "Impossibile revocare il link"
msgstr "Impossibile revocare il link"

#: src/features/connect/components/MemberManager.tsx:102
msgid "Impossibile revocare l'accesso"
msgstr "Impossibile revocare l'accesso"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:98
msgid "Impossibile ricontrollare la modalità WhatsApp"
msgstr "Impossibile ricontrollare la modalità WhatsApp"

#: src/features/sources/marp/MarpDeckEditorMount.tsx:175
msgid "Impossibile rigenerare l'immagine: {errMsg}"
msgstr "Impossibile rigenerare l'immagine: {errMsg}"

#: ../../packages/ui/src/ando/actions/InlineAIRefiner.tsx:314
#: src/features/actions/components/FocusedActionView.tsx:700
#: src/features/actions/components/ScalarActionProposalMount.tsx:174
msgid "Impossibile rigenerare la selezione."
msgstr "Impossibile rigenerare la selezione."

#: src/features/actions/components/FocusedActionView.tsx:1133
msgid "Impossibile rigenerare la sezione"
msgstr "Impossibile rigenerare la sezione"

#: src/features/actions/components/FocusedActionView.tsx:1135
msgid "Impossibile rigenerare: {detail}"
msgstr "Impossibile rigenerare: {detail}"

#: src/features/projects/components/sections/MembersSection.tsx:157
msgid "Impossibile rimuovere il membro"
msgstr "Impossibile rimuovere il membro"

#. placeholder {0}: err.message
#: src/features/projects/components/sections/MembersSection.tsx:156
msgid "Impossibile rimuovere il membro: {0}"
msgstr "Impossibile rimuovere il membro: {0}"

#: src/features/dashboard/components/ShareChartSheet.tsx:389
#: src/features/dashboard/components/ShareDashboardSheet.tsx:376
msgid "Impossibile rimuovere la condivisione."
msgstr "Impossibile rimuovere la condivisione."

#: src/features/connect/components/GrantManager.tsx:124
msgid "Impossibile rimuovere la risorsa"
msgstr "Impossibile rimuovere la risorsa"

#. placeholder {0}: err.message
#: src/features/workspace/components/NotificationPill.tsx:120
msgid "Impossibile rimuovere: {0}"
msgstr "Impossibile rimuovere: {0}"

#: src/features/dashboard/components/DashboardListSidebar.tsx:206
msgid "Impossibile rinominare la dashboard."
msgstr "Impossibile rinominare la dashboard."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:247
msgid "Impossibile riprendere la sincronizzazione: {reason}"
msgstr "Impossibile riprendere la sincronizzazione: {reason}"

#: src/features/connect/components/MemberManager.tsx:95
msgid "Impossibile ripristinare l'invito"
msgstr "Impossibile ripristinare l'invito"

#: src/features/connect/components/GrantManager.tsx:117
msgid "Impossibile ripristinare la risorsa"
msgstr "Impossibile ripristinare la risorsa"

#: src/features/admin/components/ModelMarkupCard.tsx:55
msgid "Impossibile ripristinare la tariffa globale"
msgstr "Impossibile ripristinare la tariffa globale"

#: src/features/chat/components/AudioPlayer.tsx:145
msgid "Impossibile riprodurre."
msgstr "Impossibile riprodurre."

#: src/features/dashboard/components/AddChartDialog.tsx:370
msgid "Impossibile salvare il grafico."
msgstr "Impossibile salvare il grafico."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:283
msgid "Impossibile salvare il preset: {reason}"
msgstr "Impossibile salvare il preset: {reason}"

#: src/features/dashboard/components/DashboardChartCard.tsx:319
msgid "Impossibile salvare il tipo di grafico."
msgstr "Impossibile salvare il tipo di grafico."

#: src/features/dashboard/components/AddWidgetWizard.tsx:250
msgid "Impossibile salvare il widget."
msgstr "Impossibile salvare il widget."

#: src/features/sources/marp/MarpDeckEditorMount.tsx:215
msgid "Impossibile salvare la bozza Marp: {errMsg}"
msgstr "Impossibile salvare la bozza Marp: {errMsg}"

#: src/features/admin/components/ModelMarkupCard.tsx:43
msgid "Impossibile salvare la tariffa modelli"
msgstr "Impossibile salvare la tariffa modelli"

#: src/features/projects/components/sections/PersonaSection.tsx:161
msgid "Impossibile salvare le modifiche"
msgstr "Impossibile salvare le modifiche"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:135
msgid "Impossibile salvare le slide: {errMsg}"
msgstr "Impossibile salvare le slide: {errMsg}"

#: src/routes/_authed/workspace/finance.tsx:1187
msgid "Impossibile salvare lo snapshot. Riprova fra qualche istante."
msgstr "Impossibile salvare lo snapshot. Riprova fra qualche istante."

#. placeholder {0}: err.message
#: src/features/projects/components/sections/PersonaSection.tsx:160
msgid "Impossibile salvare: {0}"
msgstr "Impossibile salvare: {0}"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:77
msgid "Impossibile verificare lo stato dell’importazione. Nessuna nuova importazione è stata avviata automaticamente."
msgstr "Impossibile verificare lo stato dell’importazione. Nessuna nuova importazione è stata avviata automaticamente."

#. placeholder {0}: sig.name
#: src/features/sales/components/SignaturesManager.tsx:199
msgid "Imposta {0} come predefinita"
msgstr "Imposta {0} come predefinita"

#: src/features/admin/components/AdminPlatformSettings.tsx:416
msgid "Imposta {columnLabel} a illimitato"
msgstr "Imposta {columnLabel} a illimitato"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:492
msgid "Imposta ANDO_APP_URL nell'env del container per abilitare questo flusso."
msgstr "Imposta ANDO_APP_URL nell'env del container per abilitare questo flusso."

#: src/features/automations/components/AutomationsHub.tsx:187
msgid "Imposta automazioni che lavorano per te — Ando le esegue secondo la programmazione e ti notifica i risultati."
msgstr "Imposta automazioni che lavorano per te — Ando le esegue secondo la programmazione e ti notifica i risultati."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:285
#: src/features/admin/components/orgs/OrgMembersTab.tsx:630
msgid "Imposta come Membro"
msgstr "Imposta come Membro"

#: src/features/sales/components/SignaturesManager.tsx:200
msgid "Imposta come predefinita"
msgstr "Imposta come predefinita"

#: src/features/projects/components/sections/MembersSection.tsx:241
msgid "Imposta editor"
msgstr "Imposta editor"

#: src/features/sales/components/FollowUpControl.tsx:70
msgid "Imposta follow-up"
msgstr "Imposta follow-up"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:102
msgid "Imposta formula"
msgstr "Imposta formula"

#: src/features/console/docs/content.ts:1425
msgid "Imposta il periodo email o chat"
msgstr "Imposta il periodo email o chat"

#: src/features/admin/components/AdminPlatformSettings.tsx:417
#: src/features/admin/components/AdminPlatformSettings.tsx:860
msgid "Imposta illimitato"
msgstr "Imposta illimitato"

#: src/features/admin/components/AdminPlatformSettings.tsx:859
msgid "Imposta ingestion cap illimitato"
msgstr "Imposta ingestion cap illimitato"

#: src/features/dashboard/components/ChartActionsMenu.tsx:177
msgid "Imposta intervallo"
msgstr "Imposta intervallo"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:424
msgid "Imposta l'App ID di Meta e il config_id di Embedded Signup nell'env runtime della SPA, poi ricarica. In Docker: passa <0>ANDO_META_APP_ID</0> e <1>ANDO_META_WHATSAPP_CONFIG_ID</1>. In Vite dev: aggiungi <2>VITE_META_APP_ID</2> e <3>VITE_WA_EMBEDDED_SIGNUP_CONFIG_ID</3> in <4>apps/client/.env</4> (vedi <5>.env.example</5>)."
msgstr "Imposta l'App ID di Meta e il config_id di Embedded Signup nell'env runtime della SPA, poi ricarica. In Docker: passa <0>ANDO_META_APP_ID</0> e <1>ANDO_META_WHATSAPP_CONFIG_ID</1>. In Vite dev: aggiungi <2>VITE_META_APP_ID</2> e <3>VITE_WA_EMBEDDED_SIGNUP_CONFIG_ID</3> in <4>apps/client/.env</4> (vedi <5>.env.example</5>)."

#: src/features/admin/components/ZitadelPasswordActions.tsx:176
#: src/features/admin/components/ZitadelPasswordActions.tsx:189
msgid "Imposta nuova password"
msgstr "Imposta nuova password"

#: src/features/admin/components/ZitadelPasswordActions.tsx:294
msgid "Imposta password"
msgstr "Imposta password"

#: src/features/dashboard/components/AddChartDialog.tsx:433
msgid "Imposta titolo, tipo di grafico e dashboard di destinazione."
msgstr "Imposta titolo, tipo di grafico e dashboard di destinazione."

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:137
msgid "Imposta un membro come \"Console (dev)\" negli Utenti"
msgstr "Imposta un membro come \"Console (dev)\" negli Utenti"

#: src/features/projects/components/sections/MembersSection.tsx:253
msgid "Imposta viewer"
msgstr "Imposta viewer"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:614
msgid "Impostare come Membro i selezionati?"
msgstr "Impostare come Membro i selezionati?"

#: src/features/admin/components/ZitadelPasswordActions.tsx:144
msgid "Impostazione password fallita"
msgstr "Impostazione password fallita"

#: src/features/account/components/UserMenuButton.tsx:365
#: src/features/clean-control/components/CleanControlHub.tsx:75
#: src/features/settings/components/BillingSettings.tsx:84
#: src/features/settings/components/NotificationPreferences.tsx:228
#: src/features/settings/components/OrganizationSettings.tsx:86
#: src/features/settings/components/ProfileSettings.tsx:65
#: src/features/settings/components/SecuritySettings.tsx:40
#: src/features/settings/components/SelfProfileMemory.tsx:207
#: src/features/voice_report/components/VoiceReportDetailPage.tsx:229
#: src/routes/_authed/_modal/settings/privacy.tsx:35
msgid "Impostazioni"
msgstr "Impostazioni"

#: src/features/dashboard/components/ChartActionsMenu.tsx:212
msgid "Impostazioni intervallo persistenti"
msgstr "Impostazioni intervallo persistenti"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:240
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:242
#: src/features/admin/components/orgs/OrgMembersTab.tsx:520
msgid "Impostazioni membro"
msgstr "Impostazioni membro"

#. placeholder {0}: m.email ?? m.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:519
msgid "Impostazioni per {0}"
msgstr "Impostazioni per {0}"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:183
msgid "Impostazioni salvate"
msgstr "Impostazioni salvate"

#: src/features/admin/components/ZitadelPasswordActions.tsx:192
msgid "Imposti direttamente una password per l'utente. Zitadel applica comunque la policy di complessità dell'organizzazione."
msgstr "Imposti direttamente una password per l'utente. Zitadel applica comunque la policy di complessità dell'organizzazione."

#: src/features/console/pages/UsagePage.tsx:423
msgid "Impronta della knowledge"
msgstr "Impronta della knowledge"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:128
#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:192
msgid "In"
msgstr "In"

#: src/routes/_authed/workspace/finance.tsx:951
msgid "in {days}g"
msgstr "in {days}g"

#: src/routes/_authed/workspace/finance.tsx:932
msgid "in arrivo"
msgstr "in arrivo"

#: src/features/admin/components/userAdminActions.tsx:181
#: src/features/admin/components/UserDetailContent.tsx:641
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:32
#: src/features/workspace/config.ts:414
msgid "In arrivo"
msgstr "In arrivo"

#: src/features/connectors/wizards/erpSpec.tsx:132
#: src/features/connectors/wizards/erpSpec.tsx:140
msgid "In arrivo · partner-gated"
msgstr "In arrivo · partner-gated"

#: src/features/hive-flows/components/DryRunPanel.tsx:78
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:395
msgid "in attesa"
msgstr "in attesa"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:63
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:72
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:69
#: src/features/admin/components/orgs/OrgMembersTab.tsx:507
#: src/features/connect/components/MemberManager.tsx:212
#: src/features/console/components/StatusBadges.tsx:107
#: src/features/settings/components/OrgMembersPanel.tsx:220
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:49
msgid "In attesa"
msgstr "In attesa"

#: src/routes/_authed/workspace/flows.$flowId.tsx:333
msgid "In attesa (nodo «Attendi»)"
msgstr "In attesa (nodo «Attendi»)"

#: src/features/hive-flows/run/RunHistoryRail.tsx:317
msgid "In attesa del cliente"
msgstr "In attesa del cliente"

#: src/features/settings/components/SelfProfileMemory.tsx:323
msgid "In attesa del tuo consenso"
msgstr "In attesa del tuo consenso"

#: src/features/console/pages/SchemaPage.tsx:179
msgid "In attesa della prima sincronizzazione della sorgente."
msgstr "In attesa della prima sincronizzazione della sorgente."

#: src/features/console/components/StatusBadges.tsx:205
#: src/routes/_authed/workspace/flows.$flowId.tsx:332
msgid "In attesa di approvazione"
msgstr "In attesa di approvazione"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:91
msgid "in attesa di campioni"
msgstr "in attesa di campioni"

#: src/features/chat/components/ChatEmptyState.tsx:425
msgid "In attesa di revisione"
msgstr "In attesa di revisione"

#: src/features/connectors/components/ConnectedAccountRow.tsx:154
msgid "In attesa di sincronizzazione"
msgstr "In attesa di sincronizzazione"

#: src/features/hive-flows/run/ProposalReview.tsx:846
msgid "In attesa…"
msgstr "In attesa…"

#: src/features/billing/components/UsageMeter.tsx:192
msgid "In avvicinamento"
msgstr "In avvicinamento"

#: src/features/chat/components/ChatEmptyState.tsx:209
msgid "In chiusura questo mese"
msgstr "In chiusura questo mese"

#: src/features/hive-flows/run/FlowRunSurface.tsx:57
msgid "in coda"
msgstr "in coda"

#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:54
#: src/features/canvases/components/CanvasStatusChip.tsx:27
#: src/features/console/components/StatusBadges.tsx:78
#: src/features/console/components/StatusBadges.tsx:79
#: src/features/console/components/StatusBadges.tsx:201
#: src/features/console/pages/DocumentsPage.tsx:95
#: src/features/console/webhooks/WebhooksPanel.tsx:96
#: src/features/dxf/utils.ts:185
#: src/features/settings/components/DataExport.tsx:239
#: src/features/voice_report/components/RunStatusBadge.tsx:43
msgid "In coda"
msgstr "In coda"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:270
msgid "In conflitto con i tuoi dati"
msgstr "In conflitto con i tuoi dati"

#: src/features/admin/components/AdminCpqPriceBook.tsx:207
msgid "In copia (separati da virgola)"
msgstr "In copia (separati da virgola)"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:401
#: ../../packages/ui/src/editors/AiTextPopover.tsx:403
#: ../../packages/ui/src/editors/DraftActionBar.tsx:338
#: ../../packages/ui/src/editors/DraftActionBar.tsx:340
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:100
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:193
#: src/features/console/components/StatusBadges.tsx:80
#: src/features/console/components/StatusBadges.tsx:81
#: src/features/console/components/StatusBadges.tsx:104
#: src/features/console/components/StatusBadges.tsx:105
#: src/features/console/components/StatusBadges.tsx:106
#: src/features/console/components/StatusBadges.tsx:202
#: src/features/console/connectors/SourceHealthSummary.tsx:9
#: src/features/console/pages/DocumentsPage.tsx:94
#: src/features/hive-flows/run/RunHistoryRail.tsx:63
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:147
msgid "In corso"
msgstr "In corso"

#: src/features/chat/hooks/useThinkingHops.ts:84
#: src/features/sync/components/UniversalSyncToast.tsx:354
msgid "in corso…"
msgstr "in corso…"

#: src/features/sales/components/SuppressionPanel.tsx:112
msgid "In esclusione"
msgstr "In esclusione"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:20
#: src/features/automations/components/AutomationStatusChip.tsx:38
#: src/features/console/pages/PlaygroundPage.tsx:2088
#: src/features/voice_report/components/RunStatusBadge.tsx:50
msgid "In esecuzione"
msgstr "In esecuzione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1076
msgid "In evidenza"
msgstr "In evidenza"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:242
msgid "In fase da"
msgstr "In fase da"

#: src/features/admin/components/MaintenanceControl.tsx:62
msgid "In manutenzione"
msgstr "In manutenzione"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:18
msgid "In modifica"
msgstr "In modifica"

#. placeholder {0}: cellLock.name
#. placeholder {0}: lock.name
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1444
#: ../../packages/ui/src/ando/EditableTable.tsx:395
msgid "In modifica da {0}"
msgstr "In modifica da {0}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1271
msgid "In orizzontale"
msgstr "In orizzontale"

#: src/features/projects/components/sections/AutomationsSection.tsx:178
msgid "in pausa"
msgstr "in pausa"

#: src/features/automations/components/AutomationsHub.tsx:277
#: src/features/automations/components/AutomationStatusChip.tsx:35
#: src/features/console/components/StatusBadges.tsx:110
#: src/features/console/components/StatusBadges.tsx:185
#: src/features/hive-flows/components/FlowActivateControl.tsx:52
#: src/features/hive-flows/run/RunHistoryRail.tsx:61
#: src/features/workspace/config.ts:434
#: src/features/workspace/finance/components/BankAccountsList.tsx:138
#: src/routes/_authed/workspace/flows.index.tsx:70
msgid "In pausa"
msgstr "In pausa"

#: src/features/console/connectors/CustomConnectorDetail.tsx:696
msgid "in pausa: AppKey associata non attiva"
msgstr "in pausa: AppKey associata non attiva"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:358
msgid "In preparazione"
msgstr "In preparazione"

#: src/features/console/pages/ConnectorsPage.tsx:527
msgid "In preparazione: nessun provider ERP attivabile in Console"
msgstr "In preparazione: nessun provider ERP attivabile in Console"

#: src/features/billing/components/CurrentPlanCard.tsx:49
msgid "In prova"
msgstr "In prova"

#: src/features/onboarding/sectionGuides.ts:64
msgid "In questa demo è già attiva un'automazione \"Riassunto mail giornaliero\": la trovi qui nell'elenco, con stato ed esecuzioni."
msgstr "In questa demo è già attiva un'automazione \"Riassunto mail giornaliero\": la trovi qui nell'elenco, con stato ed esecuzioni."

#: src/features/console/pages/UsagePage.tsx:366
msgid "In questa finestra non risultano richieste Engine attribuite. Esegui una query dal Playground o collega un connettore per vedere i nuovi consumi."
msgstr "In questa finestra non risultano richieste Engine attribuite. Esegui una query dal Playground o collega un connettore per vedere i nuovi consumi."

#: src/features/console/pages/DocsPage.tsx:356
#: src/features/console/pages/DocsPage.tsx:361
msgid "In questa pagina"
msgstr "In questa pagina"

#: src/features/report/components/ReportViewer.tsx:208
msgid "In questa sezione"
msgstr "In questa sezione"

#: src/features/console/pages/BillingPage.tsx:425
msgid "In regola"
msgstr "In regola"

#: src/features/sources/components/InboxDetailPane.tsx:1798
msgid "In risposta a"
msgstr "In risposta a"

#: src/features/automations/components/formatters.ts:74
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:33
#: src/features/workspace/config.ts:415
msgid "In ritardo"
msgstr "In ritardo"

#. placeholder {0}: Math.abs(days)
#: src/routes/_authed/workspace/finance.tsx:948
msgid "in ritardo {0}g"
msgstr "in ritardo {0}g"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:115
msgid "In roadmap"
msgstr "In roadmap"

#: src/features/sales/components/SalesOverview.tsx:116
msgid "In scadenza"
msgstr "In scadenza"

#: src/routes/_authed/workspace/finance.tsx:1658
msgid "In scadenza 30g"
msgstr "In scadenza 30g"

#: src/routes/_authed/workspace/finance.tsx:933
msgid "in scadenza oggi"
msgstr "in scadenza oggi"

#: src/features/console/pages/SchemaPage.tsx:162
#: src/features/console/pages/SchemaPage.tsx:458
#: src/features/console/pages/SchemaPage.tsx:607
#: src/features/console/pages/SchemaPage.tsx:967
msgid "In scoperta"
msgstr "In scoperta"

#: src/features/console/pages/SchemaPage.tsx:717
msgid "in scoperta…"
msgstr "in scoperta…"

#: src/features/sources/components/CalendarEventPane.tsx:155
msgid "In sospeso"
msgstr "In sospeso"

#. placeholder {0}: formatDateTime(i18n.locale, rollResult.old_key_expires_at)
#: src/features/console/pages/KeyDetailPage.tsx:655
msgid "In sovrapposizione · scade {0}"
msgstr "In sovrapposizione · scade {0}"

#: src/features/share/components/ShareLinkRow.tsx:43
msgid "In team"
msgstr "In team"

#: src/features/admin/components/AdminRevenue.tsx:110
msgid "In trial"
msgstr "In trial"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:152
msgid "in un'altra organizzazione. È l'unico modo sicuro: dati e connessioni seguono l'utente atomicamente, l'azione viene loggata."
msgstr "in un'altra organizzazione. È l'unico modo sicuro: dati e connessioni seguono l'utente atomicamente, l'azione viene loggata."

#: src/features/skills/components/TeamSkillsCatalog.tsx:154
msgid "In uso"
msgstr "In uso"

#: src/features/console/pages/ModelsPage.tsx:95
msgid "In uso ora: profilo Ando"
msgstr "In uso ora: profilo Ando"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1276
msgid "In verticale"
msgstr "In verticale"

#: src/features/settings/components/NotificationPreferences.tsx:403
msgid "In-app"
msgstr "In-app"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:79
msgid "Inattivi 30+ giorni esclusi"
msgstr "Inattivi 30+ giorni esclusi"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:78
msgid "Inattivi 7+ giorni esclusi"
msgstr "Inattivi 7+ giorni esclusi"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:80
msgid "Inattivi 90+ giorni esclusi"
msgstr "Inattivi 90+ giorni esclusi"

#: src/routes/_authed/workspace/flows.$flowId.tsx:222
msgid "inattivo"
msgstr "inattivo"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:61
#: src/features/console/webhooks/WebhooksPanel.tsx:561
msgid "Inattivo"
msgstr "Inattivo"

#: src/features/briefing/BriefCard.tsx:119
msgid "Inbox"
msgstr "Inbox"

#: src/features/help/data/changelog.ts:59
msgid "Inbox + connettori chat live"
msgstr "Inbox + connettori chat live"

#: src/features/help/data/changelog.ts:60
msgid "Inbox passa alla pipeline live query con risultati incrementali. Supporto per i provider chat (Slack / Teams) nel pannello connettori."
msgstr "Inbox passa alla pipeline live query con risultati incrementali. Supporto per i provider chat (Slack / Teams) nel pannello connettori."

#: src/routes/_authed/workspace/conversations.tsx:1097
msgid "Inbox zero!"
msgstr "Inbox zero!"

#: src/features/admin/components/AdminBilling.tsx:223
#: src/features/admin/components/AdminBilling.tsx:255
msgid "Incasso"
msgstr "Incasso"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:101
msgid "Incasso (entrata)"
msgstr "Incasso (entrata)"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:91
msgid "Incident, runbook, SRE"
msgstr "Incident, runbook, SRE"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:203
msgid "Include risultati pubblici da internet"
msgstr "Include risultati pubblici da internet"

#: src/features/console/pages/PlaygroundPage.tsx:1934
msgid "Include un campione di righe nei passaggi SQL (risposta più grande)."
msgstr "Include un campione di righe nei passaggi SQL (risposta più grande)."

#. placeholder {0}: file.name
#. placeholder {0}: folder.name
#: src/features/sync/components/DocSyncManager.tsx:1180
#: src/features/sync/components/DocSyncManager.tsx:1257
msgid "Includi {0}"
msgstr "Includi {0}"

#: src/features/console/pages/PlaygroundPage.tsx:1932
msgid "Includi le righe"
msgstr "Includi le righe"

#: src/features/admin/components/AdminCpq.tsx:193
msgid "inclusa"
msgstr "inclusa"

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:142
msgid "Inclusa"
msgstr "Inclusa"

#: src/features/admin/components/AdminCpq.tsx:195
#: src/features/admin/components/AdminCpq.tsx:855
msgid "incluso"
msgstr "incluso"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1399
msgid "Incolla"
msgstr "Incolla"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2243
msgid "Incolla da Excel"
msgstr "Incolla da Excel"

#: src/features/settings/marp/CssUploadPanel.tsx:148
msgid "Incolla il CSS Marp pronto e dagli un nome."
msgstr "Incolla il CSS Marp pronto e dagli un nome."

#: src/features/connectors/wizards/vatVerifierSpec.tsx:43
msgid "Incolla la chiave API ottenuta dal provider (o lascia vuoto per usare il piano gestito)."
msgstr "Incolla la chiave API ottenuta dal provider (o lascia vuoto per usare il piano gestito)."

#: src/features/sales/components/SignatureRichEditor.tsx:230
msgid "Incolla o trascina un'immagine direttamente qui"
msgstr "Incolla o trascina un'immagine direttamente qui"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2105
msgid "Incolla una tabella con intestazione e almeno una riga"
msgstr "Incolla una tabella con intestazione e almeno una riga"

#: src/features/console/connectors/CustomConnectorDetail.tsx:259
msgid "Incolla uno o più record (JSON) per verificarli contro il Record contract<0> senza scrivere nulla</0>: vedi cosa verrebbe indicizzato o perché un record sarebbe rifiutato."
msgstr "Incolla uno o più record (JSON) per verificarli contro il Record contract<0> senza scrivere nulla</0>: vedi cosa verrebbe indicizzato o perché un record sarebbe rifiutato."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:55
msgid "Incoraggiamenti"
msgstr "Incoraggiamenti"

#: src/features/console/connectors/CustomConnectorDetail.tsx:662
msgid "Incrementale"
msgstr "Incrementale"

#: src/features/chat/hooks/useThinkingHops.ts:60
msgid "Incrocio le fonti"
msgstr "Incrocio le fonti"

#: src/features/chat/wsHandlers.ts:491
msgid "Incrocio le fonti…"
msgstr "Incrocio le fonti…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:443
msgid "Indica l'URL HTTPS esatto a cui tornare dopo l'autorizzazione Google o Microsoft. Appartiene alla tua app, non al provider Drive; Ando aggiungerà i parametri di stato."
msgstr "Indica l'URL HTTPS esatto a cui tornare dopo l'autorizzazione Google o Microsoft. Appartiene alla tua app, non al provider Drive; Ando aggiungerà i parametri di stato."

#: src/features/console/pages/OverviewPage.tsx:165
msgid "Indicatori"
msgstr "Indicatori"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:386
msgid "Indicatori organizzazione"
msgstr "Indicatori organizzazione"

#: src/features/report/components/RespondentQuotesCarousel.tsx:212
msgid "Indicatori slide"
msgstr "Indicatori slide"

#: src/routes/_authed/workspace/finance.tsx:1646
msgid "Indicatori vendite"
msgstr "Indicatori vendite"

#: src/features/console/pages/TracesPage.tsx:226
msgid "Indice completo:"
msgstr "Indice completo:"

#: src/features/connectors/wizards/driveSpec.tsx:107
msgid "Indicizza solo le cartelle che scegli — il resto resta privato."
msgstr "Indicizza solo le cartelle che scegli — il resto resta privato."

#: src/features/connectors/wizards/filesystemSpec.tsx:40
msgid "Indicizza una cartella del tuo computer o un'unità di rete (app desktop)"
msgstr "Indicizza una cartella del tuo computer o un'unità di rete (app desktop)"

#: src/features/workspace/components/InboxItemRow.tsx:206
msgid "Indicizzata"
msgstr "Indicizzata"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:228
msgid "Indicizzate"
msgstr "Indicizzate"

#: src/features/console/connectors/CustomConnectorDetail.tsx:142
msgid "Indicizzati"
msgstr "Indicizzati"

#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:56
#: src/features/dxf/utils.ts:193
msgid "Indicizzato"
msgstr "Indicizzato"

#: src/features/console/connectors/SourceHealthSummary.tsx:20
msgid "Indicizzazione"
msgstr "Indicizzazione"

#: src/features/workspace/documents/components/DocumentCardV2.tsx:268
msgid "Indicizzazione…"
msgstr "Indicizzazione…"

#: src/features/chat/components/MessageBusinessDefinition.tsx:77
msgid "Indico un altro criterio"
msgstr "Indico un altro criterio"

#: src/features/auth/desktop/DesktopLoginForm.tsx:791
#: src/features/auth/desktop/DesktopLoginForm.tsx:853
#: src/features/auth/desktop/DesktopLoginForm.tsx:900
#: src/features/auth/desktop/DesktopLoginForm.tsx:960
#: src/features/chat/components/ConversationSidebar.tsx:1115
#: src/features/connect/components/GrantManager.tsx:431
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:320
#: src/features/connectors/components/FilesystemConnectDialog.tsx:870
#: src/features/connectors/components/FilesystemConnectDialog.tsx:943
#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:463
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:921
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:957
#: src/features/console/components/CreateKeyWizard.tsx:737
#: src/features/console/pages/AccessOverviewPage.tsx:157
#: src/features/onboarding/DemoTour.tsx:280
msgid "Indietro"
msgstr "Indietro"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:907
msgid "Indirizzo del link"
msgstr "Indirizzo del link"

#: src/features/connectors/wizards/emailSpec.tsx:69
#: src/features/share/components/ShareLinkDialog.tsx:816
msgid "Indirizzo email"
msgstr "Indirizzo email"

#: src/features/console/pages/BillingPage.tsx:411
msgid "Indirizzo fiscale"
msgstr "Indirizzo fiscale"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:375
msgid "Indirizzo HTTPS della tua app a cui tornare dopo l'autorizzazione."
msgstr "Indirizzo HTTPS della tua app a cui tornare dopo l'autorizzazione."

#: src/features/admin/components/AdminGatedLinks.tsx:81
msgid "Indirizzo non valido"
msgstr "Indirizzo non valido"

#: src/features/connectors/wizards/pecSpec.tsx:117
#: src/features/connectors/wizards/pecSpec.tsx:150
msgid "Indirizzo PEC"
msgstr "Indirizzo PEC"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:225
msgid "Indirizzo PEC del destinatario — verifica con attenzione."
msgstr "Indirizzo PEC del destinatario — verifica con attenzione."

#: src/features/console/pages/MembersPage.tsx:251
msgid "Indirizzo valido"
msgstr "Indirizzo valido"

#: src/features/settings/components/PresentationTemplates.tsx:820
msgid "Inferenza…"
msgstr "Inferenza…"

#: src/features/settings/components/PresentationTemplates.tsx:821
msgid "Inferisci da corpus"
msgstr "Inferisci da corpus"

#: src/features/clean-control/utils/signalCatalog.ts:185
msgid "Informazione personale non mascherata"
msgstr "Informazione personale non mascherata"

#. placeholder {0}: chart.title
#: src/features/dashboard/components/DashboardChartCard.tsx:727
msgid "Informazioni su {0}"
msgstr "Informazioni su {0}"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:174
#: src/features/connectors/catalog.ts:233
msgid "Infrastruttura"
msgstr "Infrastruttura"

#: src/features/admin/components/AdminCpqPriceBook.tsx:221
msgid "Infrastruttura cluster (EUR/mese)"
msgstr "Infrastruttura cluster (EUR/mese)"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:162
msgid "Infrastruttura condivisa"
msgstr "Infrastruttura condivisa"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:245
msgid "Infrastruttura di ricerca"
msgstr "Infrastruttura di ricerca"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:129
msgid "Infrastruttura rilasciata."
msgstr "Infrastruttura rilasciata."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:84
msgid "Ingegneria"
msgstr "Ingegneria"

#: src/features/console/pages/DocumentsPage.tsx:339
#: src/features/console/pages/DocumentsPage.tsx:777
msgid "Ingerito"
msgstr "Ingerito"

#: src/features/clean-control/components/EventQueue.tsx:103
msgid "Ingestion"
msgstr "Ingestion"

#: src/features/admin/components/AdminPlatformSettings.tsx:580
msgid "Ingestion cap (€)"
msgstr "Ingestion cap (€)"

#: src/features/admin/components/AdminPlatformSettings.tsx:832
msgid "Ingestion cap (€) <0>— vuoto = illimitato</0>"
msgstr "Ingestion cap (€) <0>— vuoto = illimitato</0>"

#: src/features/admin/components/AdminPlatformSettings.tsx:645
msgid "Ingestion cap mensile"
msgstr "Ingestion cap mensile"

#: src/features/admin/components/orgs/OrgCostTab.tsx:59
msgid "Ingestione"
msgstr "Ingestione"

#: src/features/connectors/components/ConnectedAccountRow.tsx:381
msgid "Ingestione fallita"
msgstr "Ingestione fallita"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:401
msgid "Ingrandisci"
msgstr "Ingrandisci"

#: src/features/console/pages/ModelsPage.tsx:136
msgid "Ingresso {inputPrice} / 1M token"
msgstr "Ingresso {inputPrice} / 1M token"

#: src/features/console/components/ModelPickerModal.tsx:302
msgid "Ingresso {price} / 1M token"
msgstr "Ingresso {price} / 1M token"

#: src/features/console/components/ConsoleShell.tsx:207
#: src/features/onboarding/DemoTour.tsx:289
msgid "Inizia"
msgstr "Inizia"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:462
msgid "Inizia a digitare il nome o l'email di una persona"
msgstr "Inizia a digitare il nome o l'email di una persona"

#: src/features/onboarding/DemoWelcomeModal.tsx:180
msgid "Inizia a esplorare"
msgstr "Inizia a esplorare"

#: src/features/billing/components/UsageInsightsCard.tsx:221
msgid "Inizia a usare Ando per vedere il valore generato."
msgstr "Inizia a usare Ando per vedere il valore generato."

#: src/features/console/pages/GetStartedPage.tsx:61
msgid "Inizia con Ando Engine"
msgstr "Inizia con Ando Engine"

#: src/features/hive-flows/components/FlowCanvas.tsx:98
msgid "Inizia con un nodo «Quando…»"
msgstr "Inizia con un nodo «Quando…»"

#: src/routes/_authed/workspace/dashboard.tsx:498
msgid "Inizia da un caso d'uso"
msgstr "Inizia da un caso d'uso"

#: src/features/hive-flows/components/TemplatesGallery.tsx:40
msgid "Inizia da un modello"
msgstr "Inizia da un modello"

#: src/features/console/pages/OverviewPage.tsx:291
msgid "Inizia dalla tua prima fonte"
msgstr "Inizia dalla tua prima fonte"

#: src/features/dashboard/components/DashboardListSidebar.tsx:568
msgid "Inizia raggruppando i tuoi grafici."
msgstr "Inizia raggruppando i tuoi grafici."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:280
#: src/features/admin/components/MaintenanceControl.tsx:233
msgid "Inizio"
msgstr "Inizio"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:167
msgid "Inizio fatturazione"
msgstr "Inizio fatturazione"

#: ../../packages/ui/src/ando/sources/email/EmailActions.tsx:25
#: src/features/sources/components/InboxDetailPane.tsx:2160
#: src/features/sources/components/InboxDetailPane.tsx:2237
msgid "Inoltra"
msgstr "Inoltra"

#. placeholder {0}: item.channel
#: src/features/sources/components/InboxDetailPane.tsx:265
msgid "Inoltro non supportato per il canale {0}."
msgstr "Inoltro non supportato per il canale {0}."

#: src/features/sources/components/InboxDetailPane.tsx:2160
#: src/features/sources/components/InboxDetailPane.tsx:2232
msgid "Inoltro…"
msgstr "Inoltro…"

#: src/features/admin/components/CostTraceDetailSection.tsx:174
msgid "Input"
msgstr "Input"

#: src/features/admin/components/AdminCostTracking.tsx:258
msgid "Input tokens"
msgstr "Input tokens"

#: src/features/skills/components/SkillEditor.tsx:254
msgid "Insegna ad Ando una skill riutilizzabile — scrivila a mano o falla comporre con l'AI, poi salvala."
msgstr "Insegna ad Ando una skill riutilizzabile — scrivila a mano o falla comporre con l'AI, poi salvala."

#: src/features/sources/components/AISummaryPanel.tsx:680
msgid "Inserimento"
msgstr "Inserimento"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1198
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1262
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1315
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1365
msgid "Inserire un numero intero positivo."
msgstr "Inserire un numero intero positivo."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1375
msgid "Inserisci"
msgstr "Inserisci"

#: src/features/voice_report/components/NewReportDialog.tsx:154
msgid "Inserisci almeno 20 caratteri"
msgstr "Inserisci almeno 20 caratteri"

#: src/features/voice_report/components/NewReportDialog.tsx:150
msgid "Inserisci almeno 3 caratteri"
msgstr "Inserisci almeno 3 caratteri"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:291
msgid "Inserisci host e nome della condivisione."
msgstr "Inserisci host e nome della condivisione."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:421
msgid "Inserisci i valori del provider con cui gli utenti accedono alla tua app. L'issuer deve essere HTTPS pubblico senza slash finale; JWKS deve stare sullo stesso host. Ogni issuer deve appartenere a una sola app."
msgstr "Inserisci i valori del provider con cui gli utenti accedono alla tua app. L'issuer deve essere HTTPS pubblico senza slash finale; JWKS deve stare sullo stesso host. Ogni issuer deve appartenere a una sola app."

#: src/features/auth/desktop/DesktopLoginForm.tsx:862
msgid "Inserisci il codice a 6 cifre dall'app di autenticazione."
msgstr "Inserisci il codice a 6 cifre dall'app di autenticazione."

#: src/features/sales/components/SignatureRichEditor.tsx:211
msgid "Inserisci immagine (o incollala direttamente)"
msgstr "Inserisci immagine (o incollala direttamente)"

#: src/features/connectors/wizards/accountingSpec.tsx:104
msgid "Inserisci l'endpoint Service Layer + Company DB + credenziali. Ando ottiene un session cookie e si re-loggherà al primo 401."
msgstr "Inserisci l'endpoint Service Layer + Company DB + credenziali. Ando ottiene un session cookie e si re-loggherà al primo 401."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:645
msgid "Inserisci le credenziali"
msgstr "Inserisci le credenziali"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:892
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:893
msgid "Inserisci link"
msgstr "Inserisci link"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:47
msgid "Inserisci P.IVA e codice fiscale del soggetto delegante."
msgstr "Inserisci P.IVA e codice fiscale del soggetto delegante."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:42
msgid "Inserisci un colore esadecimale valido."
msgstr "Inserisci un colore esadecimale valido."

#: src/features/console/components/CustomTopup.tsx:48
msgid "Inserisci un importo intero tra $5 e $1000."
msgstr "Inserisci un importo intero tra $5 e $1000."

#: src/features/console/pages/BillingPage.tsx:530
msgid "Inserisci un importo intero tra 5 e 1000 USD."
msgstr "Inserisci un importo intero tra 5 e 1000 USD."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:137
msgid "Inserisci un importo maggiore o uguale a zero."
msgstr "Inserisci un importo maggiore o uguale a zero."

#: src/features/console/components/CreateKeyWizard.tsx:593
msgid "Inserisci un importo positivo (es. 50) oppure lascia il campo vuoto."
msgstr "Inserisci un importo positivo (es. 50) oppure lascia il campo vuoto."

#: src/features/console/pages/KeyDetailPage.tsx:332
msgid "Inserisci un importo positivo (es. 50)."
msgstr "Inserisci un importo positivo (es. 50)."

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:157
#: src/features/connect/components/MemberManager.tsx:453
#: src/features/console/pages/MembersPage.tsx:253
#: src/features/share/components/ShareLinkDialog.tsx:836
msgid "Inserisci un indirizzo email valido."
msgstr "Inserisci un indirizzo email valido."

#: src/features/admin/components/AdminOrgs.tsx:226
msgid "Inserisci un intero ≥ 0 (oppure -1 per illimitato)."
msgstr "Inserisci un intero ≥ 0 (oppure -1 per illimitato)."

#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:376
msgid "Inserisci un nome per il connettore."
msgstr "Inserisci un nome per il connettore."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:505
msgid "Inserisci un numero intero tra 1 e 60."
msgstr "Inserisci un numero intero tra 1 e 60."

#: src/features/sales/components/SuppressionPanel.tsx:37
msgid "Inserisci un'email o un dominio valido"
msgstr "Inserisci un'email o un dominio valido"

#: src/features/admin/components/AdminOrgs.tsx:624
msgid "Inserisci un'email valida prima di procedere."
msgstr "Inserisci un'email valida prima di procedere."

#: src/features/admin/components/orgs/AddMemberDialog.tsx:136
msgid "Inserisci un'email valida."
msgstr "Inserisci un'email valida."

#: src/features/onboarding/DemoBookCallModal.tsx:173
msgid "Inserisci un'email."
msgstr "Inserisci un'email."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:153
msgid "Inserisci un'istruzione (es. 'rendi più formale')."
msgstr "Inserisci un'istruzione (es. 'rendi più formale')."

#: src/features/voice_report/components/ShareReportDialog.tsx:270
msgid "Inserisci una o più email separate da virgola o newline. Lascia vuoto per condividere con chiunque abbia il link."
msgstr "Inserisci una o più email separate da virgola o newline. Lascia vuoto per condividere con chiunque abbia il link."

#: src/features/admin/components/ModelMarkupCard.tsx:111
msgid "Inserisci una percentuale tra {min}% e {max}%."
msgstr "Inserisci una percentuale tra {min}% e {max}%."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:54
#: src/features/settings/components/NotificationPreferences.tsx:89
msgid "Insight"
msgstr "Insight"

#: src/features/admin/components/UserDetailContent.tsx:153
msgid "Inspect Mode revocata manualmente"
msgstr "Inspect Mode revocata manualmente"

#: src/features/admin/components/UserDetailContent.tsx:138
msgid "Inspect Mode scaduta automaticamente (TTL 5 minuti)"
msgstr "Inspect Mode scaduta automaticamente (TTL 5 minuti)"

#: src/features/console/lib/onboarding.ts:91
msgid "Integra il tuo applicativo"
msgstr "Integra il tuo applicativo"

#: src/features/console/components/FirstRunTimeline.tsx:253
msgid "Integra via API"
msgstr "Integra via API"

#: src/routes/_authed/_modal/integrations/route.tsx:79
msgid "Integrazioni"
msgstr "Integrazioni"

#: src/features/console/pages/TracesPage.tsx:130
msgid "Integrità registrata"
msgstr "Integrità registrata"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:211
msgid "intent"
msgstr "intent"

#. placeholder {0}: event.intent_id
#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:100
msgid "intent: {0}"
msgstr "intent: {0}"

#: src/features/briefing/briefingActions.ts:107
msgid "Intent: {unknownIntent}"
msgstr "Intent: {unknownIntent}"

#: src/features/templates/components/TemplateFieldSpecs.ts:75
#: src/features/templates/components/TemplateFieldSpecs.ts:87
msgid "Inter"
msgstr "Inter"

#: src/features/console/pages/ResourceAccessPage.tsx:642
msgid "Intera connessione"
msgstr "Intera connessione"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:54
msgid "Interasse fori"
msgstr "Interasse fori"

#: src/features/settings/components/SelfProfileMemory.tsx:106
msgid "Interessi"
msgstr "Interessi"

#: src/features/admin/components/AdminCpq.tsx:1129
msgid "Interno"
msgstr "Interno"

#: src/features/console/pages/ResourceAccessPage.tsx:692
msgid "Intero contenuto"
msgstr "Intero contenuto"

#: src/features/automations/components/ScheduleEditor.tsx:164
msgid "Interpreta"
msgstr "Interpreta"

#: src/features/automations/components/ScheduleEditor.tsx:164
msgid "Interpreto…"
msgstr "Interpreto…"

#: src/features/onboarding/demoTourSteps.ts:52
msgid "Interroga i dati strutturati"
msgstr "Interroga i dati strutturati"

#: src/features/console/docs/content.ts:1530
msgid "Interroga la sessione con la stessa AppKey e lo stesso ID utente. awaiting_confirmation richiede la conferma monouso del passaggio successivo; connected indica che il grant è attivo, non che i dati siano stati sincronizzati."
msgstr "Interroga la sessione con la stessa AppKey e lo stesso ID utente. awaiting_confirmation richiede la conferma monouso del passaggio successivo; connected indica che il grant è attivo, non che i dati siano stati sincronizzati."

#: src/features/console/pages/PlaygroundPage.tsx:1862
msgid "Interroga le fonti documentali selezionate."
msgstr "Interroga le fonti documentali selezionate."

#: src/features/console/pages/PlaygroundPage.tsx:1861
msgid "Interroga le fonti selezionate con la sessione corrente."
msgstr "Interroga le fonti selezionate con la sessione corrente."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:451
msgid "Interroga quest'area in chat"
msgstr "Interroga quest'area in chat"

#: src/features/console/pages/SchemaPage.tsx:158
#: src/features/console/pages/SchemaPage.tsx:454
#: src/features/console/pages/SchemaPage.tsx:603
msgid "Interrogabile"
msgstr "Interrogabile"

#: src/features/console/pages/PlaygroundPage.tsx:872
msgid "Interrogazione dati"
msgstr "Interrogazione dati"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1505
msgid "Interrogazione dei dati"
msgstr "Interrogazione dei dati"

#: src/features/admin/components/AdminCostTracking.tsx:108
msgid "Interrogazione Google Cloud Monitoring…"
msgstr "Interrogazione Google Cloud Monitoring…"

#: src/features/connect/components/ConnectPublicShell.tsx:139
msgid "Interroghi solo le fonti condivise — niente di più."
msgstr "Interroghi solo le fonti condivise — niente di più."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:490
#: src/routes/connect.space.$spaceId.tsx:122
msgid "Interroghi solo le fonti condivise con te"
msgstr "Interroghi solo le fonti condivise con te"

#: src/features/workspace/components/UploadModal.tsx:408
msgid "Interrompi"
msgstr "Interrompi"

#: src/features/chat/hooks/useStopQuery.ts:24
msgid "Interruzione non disponibile: attendo l’identificativo della richiesta."
msgstr "Interruzione non disponibile: attendo l’identificativo della richiesta."

#: src/features/chat/hooks/useStopQuery.ts:36
msgid "Interruzione non inviata: riprova."
msgstr "Interruzione non inviata: riprova."

#: src/features/chat/hooks/useStopQuery.ts:34
msgid "Interruzione richiesta…"
msgstr "Interruzione richiesta…"

#: src/features/structured-data/components/TemporalQueryControl.tsx:226
msgid "Intervalli rapidi"
msgstr "Intervalli rapidi"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:290
#: src/features/automations/components/formatters.ts:25
#: src/features/automations/components/formatters.ts:88
#: src/features/automations/components/ScheduleEditor.tsx:213
#: src/features/dfm-rules/components/DfmRulesPage.tsx:659
#: src/features/report/components/ReportDateFilter.tsx:143
msgid "Intervallo"
msgstr "Intervallo"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:128
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:103
msgid "Intervallo date non valido (fine deve essere dopo l'inizio)."
msgstr "Intervallo date non valido (fine deve essere dopo l'inizio)."

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:573
msgid "Intervallo di diametro applicato alle feature estratte."
msgstr "Intervallo di diametro applicato alle feature estratte."

#: src/features/console/connectors/ManifestConfigForm.tsx:318
msgid "Intervallo di polling (minuti)"
msgstr "Intervallo di polling (minuti)"

#: src/features/structured-data/components/TemporalQueryControl.tsx:251
msgid "Intervallo personalizzato"
msgstr "Intervallo personalizzato"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:181
#: src/features/admin/components/orgs/OrgCostTab.tsx:303
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:221
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:314
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:416
msgid "Intervallo temporale"
msgstr "Intervallo temporale"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:216
msgid "Intervallo temporale del grafico"
msgstr "Intervallo temporale del grafico"

#: src/features/admin/components/AdminRangePicker.tsx:140
msgid "Intervallo temporale globale"
msgstr "Intervallo temporale globale"

#: src/features/console/pages/BillingPage.tsx:407
msgid "Intestatario"
msgstr "Intestatario"

#: src/features/admin/components/AdminCpqCanvas.tsx:148
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1830
msgid "Intestazione"
msgstr "Intestazione"

#: src/features/settings/components/BrandKitSettings.tsx:396
msgid "Intestazione (header)"
msgstr "Intestazione (header)"

#: src/features/settings/components/BrandKitSettings.tsx:389
msgid "Intestazione, piè di pagina, copertina e formato pagina."
msgstr "Intestazione, piè di pagina, copertina e formato pagina."

#: src/features/structured-data/components/SimilarPartsSection.tsx:94
msgid "Invariante convex hull (formato-invariante)"
msgstr "Invariante convex hull (formato-invariante)"

#: src/features/console/pages/AccessOverviewPage.tsx:134
msgid "Inventario accessi"
msgstr "Inventario accessi"

#: src/features/admin/components/AdminDecks.tsx:159
msgid "Investitori"
msgstr "Investitori"

#: ../../packages/ui/src/ando/email/SendControl.tsx:109
#: ../../packages/ui/src/ando/ShareEmailForm.tsx:223
#: ../../packages/ui/src/ando/ShareEmailForm.tsx:230
#: src/features/share/components/ShareLinkDialog.tsx:849
#: src/routes/forms.$flowId.tsx:118
msgid "Invia"
msgstr "Invia"

#: src/features/sales/components/crm/RecordDrawer.tsx:315
#: src/features/sales/components/crm/RecordDrawer.tsx:323
msgid "Invia a CRM esterno"
msgstr "Invia a CRM esterno"

#. placeholder {0}: selectedRecipients.length
#: src/features/sales/components/LeadsPanel.tsx:550
msgid "Invia a freddo a {0}"
msgstr "Invia a freddo a {0}"

#: src/features/sales/components/BatchSendModal.tsx:217
msgid "Invia a freddo a {count} contatti"
msgstr "Invia a freddo a {count} contatti"

#: src/features/sales/components/BatchSendModal.tsx:215
msgid "Invia a freddo a {count} contatto"
msgstr "Invia a freddo a {count} contatto"

#: src/features/sales/components/BatchSendModal.tsx:436
msgid "Invia a tutti"
msgstr "Invia a tutti"

#: src/features/auth/desktop/DesktopLoginForm.tsx:843
msgid "Invia codice via email"
msgstr "Invia codice via email"

#: ../../packages/ui/src/ando/email/SendControl.tsx:174
msgid "Invia e archivia"
msgstr "Invia e archivia"

#: ../../packages/ui/src/ando/email/SendControl.tsx:118
#: src/features/admin/components/AdminGatedLinks.tsx:257
msgid "Invia email"
msgstr "Invia email"

#: src/features/sales/components/BatchSendModal.tsx:208
msgid "Invia email a freddo"
msgstr "Invia email a freddo"

#: src/features/admin/components/ZitadelPasswordActions.tsx:166
msgid "Invia email di reset"
msgstr "Invia email di reset"

#: src/features/console/docs/content.ts:1386
msgid "Invia il provider e apri authorization_url. Il grant resta inattivo finché la stessa sessione Console non conferma il callback OAuth."
msgstr "Invia il provider e apri authorization_url. Il grant resta inattivo finché la stessa sessione Console non conferma il callback OAuth."

#: src/features/console/pages/MembersPage.tsx:229
#: src/features/settings/components/OrgMembersPanel.tsx:584
msgid "Invia invito"
msgstr "Invia invito"

#: src/features/help/components/ShortcutsList.tsx:88
msgid "Invia messaggio (alternativa, anche con Shift attivo)"
msgstr "Invia messaggio (alternativa, anche con Shift attivo)"

#: src/features/help/components/ShortcutsList.tsx:83
msgid "Invia messaggio dal composer"
msgstr "Invia messaggio dal composer"

#: ../../packages/ui/src/ando/email/SendControl.tsx:162
msgid "Invia ora"
msgstr "Invia ora"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:248
msgid "Invia PEC"
msgstr "Invia PEC"

#: src/features/share/components/ShareLinkDialog.tsx:919
#: src/features/share/components/ShareLinkDialog.tsx:920
msgid "Invia su WhatsApp"
msgstr "Invia su WhatsApp"

#: src/features/admin/components/AdminCpq.tsx:1221
msgid "Invia subito il link via email agli indirizzi autorizzati"
msgstr "Invia subito il link via email agli indirizzi autorizzati"

#: src/features/admin/components/AdminDemoInviti.tsx:392
msgid "Invia subito l'email di invito"
msgstr "Invia subito l'email di invito"

#: src/features/console/webhooks/WebhooksPanel.tsx:619
msgid "Invia test.ping"
msgstr "Invia test.ping"

#: src/features/console/docs/content.ts:1701
msgid "Invia un documento per l'ingestion asincrona (scope ingest:write). Accetta un path o bytes (filename obbligatorio con i bytes)."
msgstr "Invia un documento per l'ingestion asincrona (scope ingest:write). Accetta un path o bytes (filename obbligatorio con i bytes)."

#: src/features/console/components/StatusBadges.tsx:165
#: src/features/sources/hooks/useUndoableSend.tsx:85
msgid "Inviata"
msgstr "Inviata"

#. placeholder {0}: r.sent.join(", ")
#: src/features/admin/components/AdminGatedLinks.tsx:181
msgid "Inviata a {0}"
msgstr "Inviata a {0}"

#: src/routes/_authed/workspace/shares.tsx:111
msgid "inviate"
msgstr ""

#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:70
#: src/routes/_authed/workspace/shares.tsx:125
#: src/routes/_authed/workspace/shares.tsx:175
msgid "Inviate"
msgstr "Inviate"

#: src/features/sales/hooks/useProspectingWsBridge.ts:88
msgid "Inviate {sent} email a freddo."
msgstr "Inviate {sent} email a freddo."

#: src/features/sales/hooks/useProspectingWsBridge.ts:86
msgid "Inviate {sent} email, {failed} non riuscite."
msgstr "Inviate {sent} email, {failed} non riuscite."

#: src/routes/_authed/workspace/shares.tsx:136
msgid "Inviate o ricevute"
msgstr ""

#. placeholder {0}: email.trim()
#: src/features/share/components/ShareLinkDialog.tsx:811
msgid "Inviato a {0}"
msgstr "Inviato a {0}"

#: src/routes/forms.$flowId.tsx:56
msgid "Inviato, grazie!"
msgstr "Inviato, grazie!"

#: src/features/actions/components/FocusedActionView.tsx:1065
#: src/features/actions/components/ScalarActionProposalMount.tsx:300
msgid "Invio"
msgstr "Invio"

#: src/features/admin/components/AdminDemoInviti.tsx:172
msgid "invio · durata da attivazione · utilizzi · privacy-safe"
msgstr "invio · durata da attivazione · utilizzi · privacy-safe"

#: src/features/sales/hooks/useProspectingWsBridge.ts:40
msgid "Invio a freddo"
msgstr "Invio a freddo"

#: src/features/actions/components/FocusedActionView.tsx:850
#: src/features/actions/components/ScalarActionProposalMount.tsx:211
#: src/features/sources/hooks/useUndoableSend.tsx:74
msgid "Invio annullato"
msgstr "Invio annullato"

#: src/features/connectors/wizards/sdiSpec.tsx:98
msgid "Invio automatico"
msgstr "Invio automatico"

#: src/features/auth/desktop/DesktopLoginForm.tsx:915
msgid "Invio codice in corso…"
msgstr "Invio codice in corso…"

#: src/features/auth/desktop/DesktopLoginForm.tsx:306
msgid "Invio del codice fallito"
msgstr "Invio del codice fallito"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1580
msgid "Invio del documento in corso…"
msgstr "Invio del documento in corso…"

#: src/features/connectors/components/ConnectAccountDialog.tsx:299
msgid "Invio delle credenziali non riuscito."
msgstr "Invio delle credenziali non riuscito."

#: src/features/admin/components/ZitadelPasswordActions.tsx:90
msgid "Invio email fallito"
msgstr "Invio email fallito"

#: src/features/sales/components/BatchSendModal.tsx:222
msgid "Invio in background, con throttling per proteggere la reputazione del dominio."
msgstr "Invio in background, con throttling per proteggere la reputazione del dominio."

#. placeholder {0}: res.count
#: src/features/sales/components/BatchSendModal.tsx:194
msgid "Invio in coda: {0} email"
msgstr "Invio in coda: {0} email"

#: src/features/settings/components/SelfProfileMemory.tsx:693
msgid "Invio in corso…"
msgstr "Invio in corso…"

#: src/features/admin/components/AdminCpq.tsx:394
#: src/features/admin/components/AdminGatedLinks.tsx:244
#: src/features/sales/components/BatchSendModal.tsx:200
msgid "Invio non riuscito"
msgstr "Invio non riuscito"

#: src/routes/forms.$flowId.tsx:106
msgid "Invio non riuscito, riprova."
msgstr "Invio non riuscito, riprova."

#: src/features/chat/components/MessageBusinessDefinition.tsx:104
msgid "Invio non riuscito. Riprova."
msgstr "Invio non riuscito. Riprova."

#. placeholder {0}: item.channel
#: src/features/sources/components/InboxDetailPane.tsx:490
msgid "Invio non supportato per il canale {0}."
msgstr "Invio non supportato per il canale {0}."

#: src/features/console/pages/PlaygroundPage.tsx:2042
msgid "Invio o ⌘/Ctrl+Invio per eseguire"
msgstr "Invio o ⌘/Ctrl+Invio per eseguire"

#: src/features/console/pages/PlaygroundPage.tsx:1887
msgid "Invio per eseguire · Maiusc+Invio per andare a capo"
msgstr "Invio per eseguire · Maiusc+Invio per andare a capo"

#: src/features/sales/components/BatchSendModal.tsx:418
msgid "Invio progressivo in background"
msgstr "Invio progressivo in background"

#: src/features/admin/components/AdminGatedLinks.tsx:137
msgid "Invio, virgola o spazio per aggiungere; puoi incollare un elenco."
msgstr "Invio, virgola o spazio per aggiungere; puoi incollare un elenco."

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:230
#: ../../packages/ui/src/editors/RegionEditPill.tsx:240
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:228
#: src/features/connectors/components/ConnectAccountDialog.tsx:502
#: src/features/onboarding/DemoBookCallModal.tsx:473
#: src/features/sales/components/BatchSendModal.tsx:436
#: src/features/share/components/ShareLinkDialog.tsx:849
#: src/routes/forms.$flowId.tsx:118
msgid "Invio…"
msgstr "Invio…"

#: src/features/settings/components/OrgMembersPanel.tsx:138
msgid "Invita"
msgstr "Invita"

#: src/features/projects/components/sections/MembersSection.tsx:483
msgid "Invita {trimmedQuery}"
msgstr "Invita {trimmedQuery}"

#: src/features/connect/components/MemberManager.tsx:345
msgid "Invita allo spazio"
msgstr "Invita allo spazio"

#: src/features/admin/components/AdminDemoInviti.tsx:176
msgid "Invita clienti alla demo via email o link. La scadenza parte dal <0>primo accesso</0>, non dall'invio. Modifica durata, riattiva o revoca in qualsiasi momento."
msgstr "Invita clienti alla demo via email o link. La scadenza parte dal <0>primo accesso</0>, non dall'invio. Modifica durata, riattiva o revoca in qualsiasi momento."

#: src/features/console/pages/MembersPage.tsx:454
msgid "Invita collega"
msgstr "Invita collega"

#: src/features/settings/components/OrgMembersPanel.tsx:147
msgid "Invita il primo collega per condividere agenti, connettori e workspace."
msgstr "Invita il primo collega per condividere agenti, connettori e workspace."

#: src/features/connect/components/MemberManager.tsx:139
msgid "Invita ospite"
msgstr "Invita ospite"

#: src/features/console/pages/MembersPage.tsx:212
msgid "Invita un collega"
msgstr "Invita un collega"

#: src/features/console/pages/MembersPage.tsx:486
msgid "Invita un collega per gestire insieme la Console. Gli utenti delle tue app si gestiscono nella sezione Utenti delle app."
msgstr "Invita un collega per gestire insieme la Console. Gli utenti delle tue app si gestiscono nella sezione Utenti delle app."

#: src/features/dashboard/components/ShareChartSheet.tsx:98
#: src/features/dashboard/components/ShareDashboardSheet.tsx:93
msgid "Invita un collega su Ando oppure invia un riepilogo via email."
msgstr "Invita un collega su Ando oppure invia un riepilogo via email."

#: src/features/projects/components/sections/MembersSection.tsx:407
#: src/features/settings/components/OrgMembersPanel.tsx:155
#: src/features/settings/components/OrgMembersPanel.tsx:512
#: src/features/settings/components/OrgMembersPanel.tsx:517
msgid "Invita un membro"
msgstr "Invita un membro"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:367
msgid "Invitati — cerca contatti…"
msgstr "Invitati — cerca contatti…"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:261
#: src/features/admin/components/orgs/OrgMembersTab.tsx:350
#: src/features/console/components/StatusBadges.tsx:240
msgid "Invitato"
msgstr "Invitato"

#. placeholder {0}: inv.invited_at ? new Intl.DateTimeFormat(i18n.locale, { day: "2-digit", month: "short", year: "numeric", }).format(new Date(inv.invited_at)) : "—"
#: src/features/settings/components/OrgMembersPanel.tsx:440
msgid "Invitato il {0}"
msgstr "Invitato il {0}"

#. placeholder {0}: member.name ?? member.email ?? i18n._(msg`utente`)
#: src/features/projects/components/sections/MembersSection.tsx:345
msgid "Invitato: {0}"
msgstr "Invitato: {0}"

#: src/features/projects/components/sections/MembersSection.tsx:370
msgid "Invitato: {email}"
msgstr "Invitato: {email}"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:412
msgid "inviti"
msgstr "inviti"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:164
msgid "Inviti"
msgstr "Inviti"

#: src/features/console/pages/MembersPage.tsx:471
#: src/features/console/pages/MembersPage.tsx:599
#: src/features/console/pages/MembersPage.tsx:602
#: src/features/settings/components/OrgMembersPanel.tsx:420
msgid "Inviti in sospeso"
msgstr "Inviti in sospeso"

#: src/features/connect/components/CreateSpaceDialog.tsx:95
msgid "Inviti membri nominali che interrogano le fonti condivise."
msgstr "Inviti membri nominali che interrogano le fonti condivise."

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:132
msgid "Inviti revocati"
msgstr "Inviti revocati"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:193
msgid "inviti selezionati"
msgstr "inviti selezionati"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:412
msgid "invito"
msgstr "invito"

#: src/routes/connect.invite.$token.tsx:102
msgid "Invito a uno spazio Ando Connect"
msgstr "Invito a uno spazio Ando Connect"

#: src/features/admin/components/AdminDemoInviti.tsx:126
#: src/features/connect/components/MemberManager.tsx:313
msgid "Invito creato"
msgstr "Invito creato"

#: src/features/admin/components/AdminDemoInviti.tsx:124
msgid "Invito creato e inviato"
msgstr "Invito creato e inviato"

#: src/features/settings/components/OrgMembersPanel.tsx:584
msgid "Invito in corso…"
msgstr "Invito in corso…"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:107
#: src/features/console/pages/MembersPage.tsx:196
msgid "Invito inviato"
msgstr "Invito inviato"

#: src/routes/connect.invite.$token.tsx:197
msgid "Invito non più valido"
msgstr "Invito non più valido"

#: src/routes/connect.invite.$token.tsx:85
#: src/routes/connect.invite.$token.tsx:221
msgid "Invito non trovato"
msgstr "Invito non trovato"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:98
#: src/features/console/pages/MembersPage.tsx:430
msgid "Invito reinviato"
msgstr "Invito reinviato"

#: src/features/admin/components/AdminDemoInviti.tsx:323
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:114
#: src/features/console/pages/MembersPage.tsx:417
msgid "Invito revocato"
msgstr "Invito revocato"

#: src/features/admin/components/AdminDemoInviti.tsx:310
msgid "Invito riattivato"
msgstr "Invito riattivato"

#: src/features/connect/components/MemberManager.tsx:221
msgid "Invito scade"
msgstr "Invito scade"

#: src/routes/connect.invite.$token.tsx:184
msgid "Invito scaduto"
msgstr "Invito scaduto"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:239
#: src/features/console/connectors/InvokeConnectorActionModal.tsx:141
msgid "Invoca"
msgstr "Invoca"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:156
msgid "Invoca azione"
msgstr "Invoca azione"

#: src/features/console/docs/content.ts:1107
msgid "Invoca una capability HTTP"
msgstr "Invoca una capability HTTP"

#. placeholder {0}: s.ip_address
#. placeholder {1}: formatRelative(s.last_active_at, i18n)
#: src/features/settings/components/SecuritySettings.tsx:343
msgid "IP {0} · ultima attività {1}"
msgstr "IP {0} · ultima attività {1}"

#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:121
msgid "irreversibile"
msgstr "irreversibile"

#: src/features/console/docs/content.ts:556
msgid "Irreversibile: i turni sono rimossi e l'id è ritirato (poi not_found)."
msgstr "Irreversibile: i turni sono rimossi e l'id è ritirato (poi not_found)."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:333
msgid "Iscritto"
msgstr "Iscritto"

#: src/features/projects/components/sections/MemorySection.tsx:210
msgid "Isolato"
msgstr "Isolato"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:192
msgid "Isolato (progetto GCP)"
msgstr "Isolato (progetto GCP)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:525
msgid "Ispettore"
msgstr "Ispettore"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:361
msgid "Issuer"
msgstr "Issuer"

#: src/features/console/components/CreateKeyWizard.tsx:336
msgid "Issuer dell’applicazione"
msgstr "Issuer dell’applicazione"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:324
msgid "Issuer URL"
msgstr "Issuer URL"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:40
msgid "Issuer URL obbligatorio."
msgstr "Issuer URL obbligatorio."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:381
msgid "Issues"
msgstr "Issues"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:101
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:104
msgid "Issues identificati"
msgstr "Issues identificati"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:413
msgid "Istantaneo"
msgstr "Istantaneo"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:185
msgid "Istantaneo (SCT Inst)"
msgstr "Istantaneo (SCT Inst)"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:218
msgid "Istanza"
msgstr "Istanza"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:278
msgid "Istruzione"
msgstr "Istruzione"

#. placeholder {0}: index + 1
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:331
msgid "Istruzione AI per la slide {0}"
msgstr "Istruzione AI per la slide {0}"

#: src/features/admin/components/AdminDecksAskAndo.tsx:93
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2787
#: src/features/admin/components/PageEditor.tsx:184
msgid "Istruzione per Ando"
msgstr "Istruzione per Ando"

#: src/features/settings/components/BrandKitSettings.tsx:837
msgid "Istruzioni aggiuntive (opzionale)"
msgstr "Istruzioni aggiuntive (opzionale)"

#: src/features/projects/components/sections/PersonaSection.tsx:255
msgid "Istruzioni per l'agente"
msgstr "Istruzioni per l'agente"

#: src/features/projects/components/sections/PersonaSection.tsx:267
msgid "Istruzioni per l'agente nel progetto"
msgstr "Istruzioni per l'agente nel progetto"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:91
msgid "IT / DevOps"
msgstr "IT / DevOps"

#: src/features/admin/components/AdminDecksAskAndo.tsx:70
msgid "IT + EN"
msgstr "IT + EN"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:328
msgid "IT60 X054 2811 1010 0000 0123 456"
msgstr "IT60 X054 2811 1010 0000 0123 456"

#: src/features/connectors/wizards/openBankingSpec.tsx:164
msgid "Italia"
msgstr "Italia"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:66
msgid "Italia, EU, UK in un'unica API."
msgstr "Italia, EU, UK in un'unica API."

#: src/features/templates/components/TemplateFieldSpecs.ts:181
msgid "Italiano"
msgstr "Italiano"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:217
#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:80
#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:104
msgid "IVA"
msgstr "IVA"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:276
msgid "IVA totale"
msgstr "IVA totale"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:80
msgid "IVA, bilancio, contabilità"
msgstr "IVA, bilancio, contabilità"

#: src/features/console/docs/content.ts:991
msgid "Job & risultati"
msgstr "Job & risultati"

#: src/features/settings/components/DataExport.tsx:108
msgid "JSON (consigliato)"
msgstr "JSON (consigliato)"

#: src/features/console/pages/PlaygroundPage.tsx:1162
msgid "JSON grezzo"
msgstr "JSON grezzo"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:374
#: src/features/settings/components/PresentationTemplates.tsx:649
#: src/features/templates/components/TemplateEditor.tsx:148
msgid "JSON non valido"
msgstr "JSON non valido"

#: src/features/console/connectors/CustomConnectorDetail.tsx:226
msgid "JSON non valido: incolla un record o un array di record."
msgstr "JSON non valido: incolla un record o un array di record."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:341
msgid "JSON Schema (Draft 2020-12) con cui Ando valida i parametri. Lascia vuoto per non imporre vincoli."
msgstr "JSON Schema (Draft 2020-12) con cui Ando valida i parametri. Lascia vuoto per non imporre vincoli."

#: src/features/console/docs/content.ts:817
msgid "K-Schema proposto"
msgstr "K-Schema proposto"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:741
msgid "KDC (domain controller)"
msgstr "KDC (domain controller)"

#: src/features/clean-control/components/ModeToggle.tsx:91
msgid "Kill switch"
msgstr "Kill switch"

#: src/features/console/docs/content.ts:610
msgid "kind manifest: descrivi la tua API REST come JSON. Il sync periodico si lega alla AppKey di servizio live scelta alla registrazione e si ferma se la chiave scade o viene revocata; puoi ricollegarne esplicitamente una dello stesso utente di servizio. Controlla AppKeys e lo storico sync prima di attendere dati. Regole: base_url e token_url OAuth solo https pubblico; auth.secret è WRITE-ONLY (le letture mostrano secret_set: true); fields.external_id obbligatorio; cursor presente → sync incrementale, assente → full con mark-and-sweep; interval_minutes intero ≥ 15, default 60."
msgstr "kind manifest: descrivi la tua API REST come JSON. Il sync periodico si lega alla AppKey di servizio live scelta alla registrazione e si ferma se la chiave scade o viene revocata; puoi ricollegarne esplicitamente una dello stesso utente di servizio. Controlla AppKeys e lo storico sync prima di attendere dati. Regole: base_url e token_url OAuth solo https pubblico; auth.secret è WRITE-ONLY (le letture mostrano secret_set: true); fields.external_id obbligatorio; cursor presente → sync incrementale, assente → full con mark-and-sweep; interval_minutes intero ≥ 15, default 60."

#: src/features/console/components/ConsoleShell.tsx:211
msgid "Knowledge"
msgstr "Knowledge"

#: src/features/billing/components/UsageInsightsCard.tsx:256
msgid "Knowledge base"
msgstr "Knowledge base"

#: src/features/dashboard/components/AddChartDialog.tsx:113
#: src/features/voice_report/components/RunDiffTimeline.tsx:300
msgid "KPI"
msgstr "KPI"

#. placeholder {0}: chart.title
#: src/features/dashboard/components/KpiCard.tsx:169
msgid "KPI {0}"
msgstr "KPI {0}"

#: src/features/admin/components/AdminCostTracking.tsx:226
msgid "KPI costi"
msgstr "KPI costi"

#: src/features/admin/components/AdminOverview.tsx:55
msgid "KPI esecutivi · ultime 24h vs periodo precedente"
msgstr "KPI esecutivi · ultime 24h vs periodo precedente"

#: src/features/admin/components/UserDetailContent.tsx:471
msgid "KPI periodo"
msgstr "KPI periodo"

#: src/features/admin/components/AdminOverview.tsx:96
msgid "KPI principali"
msgstr "KPI principali"

#: src/features/billing/components/CurrentPlanCard.tsx:135
msgid "L'abbonamento NON sarà rinnovato alla scadenza."
msgstr "L'abbonamento NON sarà rinnovato alla scadenza."

#: src/features/settings/components/BillingSettings.tsx:72
msgid "L'abbonamento resterà attivo fino alla fine del periodo corrente, poi non sarà rinnovato."
msgstr "L'abbonamento resterà attivo fino alla fine del periodo corrente, poi non sarà rinnovato."

#: src/features/console/pages/ResourceAccessPage.tsx:410
msgid "L'accesso a questa connessione è gestito dal proprietario."
msgstr "L'accesso a questa connessione è gestito dal proprietario."

#: src/features/structured-data/components/InlineChartPanel.tsx:103
msgid "L'agente non ha allegato dati visualizzabili a questa risposta."
msgstr "L'agente non ha allegato dati visualizzabili a questa risposta."

#: src/features/projects/components/sections/MemorySection.tsx:308
msgid "L'agente non ha ancora memorizzato nulla in questo progetto. Inizia una conversazione: al termine, i fatti rilevanti vengono riassunti qui automaticamente."
msgstr "L'agente non ha ancora memorizzato nulla in questo progetto. Inizia una conversazione: al termine, i fatti rilevanti vengono riassunti qui automaticamente."

#: src/features/console/pages/DevelopersPage.tsx:200
msgid "L'agente parla con <0>{mcpUrl}</0> usando la tua AppKey come Bearer token. Le richieste usano l'identità della AppKey di servizio, non quella dei singoli utenti della tua app. Ogni strumento rispetta la resource policy e gli scope della chiave: i tool di knowledge richiedono query:read, list_capabilities richiede actions:read e run_capability richiede actions:write."
msgstr "L'agente parla con <0>{mcpUrl}</0> usando la tua AppKey come Bearer token. Le richieste usano l'identità della AppKey di servizio, non quella dei singoli utenti della tua app. Ogni strumento rispetta la resource policy e gli scope della chiave: i tool di knowledge richiedono query:read, list_capabilities richiede actions:read e run_capability richiede actions:write."

#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:98
msgid "L'agente sta preparando i dettagli — la card si popolerà appena la proposta è completa."
msgstr "L'agente sta preparando i dettagli — la card si popolerà appena la proposta è completa."

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:309
msgid "L'AI propone di generare un Voice of X report"
msgstr "L'AI propone di generare un Voice of X report"

#: src/features/clean-control/utils/explainEvent.ts:67
msgid "L'anagrafica {name} compare con {count} schede diverse: potresti unificarle."
msgstr "L'anagrafica {name} compare con {count} schede diverse: potresti unificarle."

#: src/features/voice_report/components/DatasetTab.tsx:90
msgid "L'anteprima dei chunk diventa disponibile dopo il primo run andato a buon fine. Apri la tab \"Runs\" per avviarne uno."
msgstr "L'anteprima dei chunk diventa disponibile dopo il primo run andato a buon fine. Apri la tab \"Runs\" per avviarne uno."

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:166
msgid "L'anteprima mostra l'ultima versione generata. Premi «{resolvedConfirmLabel}» per applicare le tue modifiche."
msgstr "L'anteprima mostra l'ultima versione generata. Premi «{resolvedConfirmLabel}» per applicare le tue modifiche."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:438
msgid "L'anteprima mostra l'ultima versione salvata"
msgstr "L'anteprima mostra l'ultima versione salvata"

#: src/features/templates/components/TemplateEditor.tsx:369
msgid "L'anteprima si aggiorna dopo il salvataggio (rigenerata server-side)."
msgstr "L'anteprima si aggiorna dopo il salvataggio (rigenerata server-side)."

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:421
msgid "L'anteprima usa il campione caricato. Dopo il salvataggio Ando ri-esegue la query sulla connessione."
msgstr "L'anteprima usa il campione caricato. Dopo il salvataggio Ando ri-esegue la query sulla connessione."

#: src/features/dashboard/components/AddChartDialog.tsx:707
msgid "L'anteprima usa il campione dei dati. Dopo il salvataggio il grafico ri-esegue la query sulla connessione."
msgstr "L'anteprima usa il campione dei dati. Dopo il salvataggio il grafico ri-esegue la query sulla connessione."

#. placeholder {0}: String(p.index)
#: src/features/admin/components/AdminCpqPublishChecks.tsx:41
msgid "L'applicazione {0} non ha un nome."
msgstr "L'applicazione {0} non ha un nome."

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:413
msgid "L'archiviazione è disponibile solo per Gmail e Outlook."
msgstr "L'archiviazione è disponibile solo per Gmail e Outlook."

#: src/routes/connect.chatbot.$publicToken.tsx:94
msgid "L'assistente è momentaneamente occupato. Attendi qualche istante e riprova."
msgstr "L'assistente è momentaneamente occupato. Attendi qualche istante e riprova."

#: src/features/automations/components/AutomationsHub.tsx:133
msgid "L'automazione richiesta non esiste più o non è accessibile."
msgstr "L'automazione richiesta non esiste più o non è accessibile."

#: src/features/automations/components/ScheduleEditor.tsx:290
msgid "L'automazione verrà eseguita una sola volta alla creazione. Per esecuzioni ripetute scegli intervallo o cron."
msgstr "L'automazione verrà eseguita una sola volta alla creazione. Per esecuzioni ripetute scegli intervallo o cron."

#: src/features/automations/components/AutomationsHub.tsx:412
msgid "L'automazione verrà rimossa definitivamente. L'azione non è reversibile."
msgstr "L'automazione verrà rimossa definitivamente. L'azione non è reversibile."

#: src/features/dashboard/components/DashboardListSidebar.tsx:469
#: src/features/dxf/components/DxfActionsMenu.tsx:54
msgid "L'azione è irreversibile."
msgstr "L'azione è irreversibile."

#. placeholder {0}: detail.name
#. placeholder {0}: summary.name
#: src/features/templates/components/TemplateEditor.tsx:451
#: src/routes/_authed/workspace/templates/$kind.tsx:401
msgid "L'azione è irreversibile. Il template \"{0}\" verrà rimosso e non sarà più disponibile nei drawer Studio."
msgstr "L'azione è irreversibile. Il template \"{0}\" verrà rimosso e non sarà più disponibile nei drawer Studio."

#: src/features/settings/marp/CssUploadPanel.tsx:296
msgid "L'eliminazione arriverà in una prossima release"
msgstr "L'eliminazione arriverà in una prossima release"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:268
msgid "L'endpoint non ha restituito un corpo JSON."
msgstr "L'endpoint non ha restituito un corpo JSON."

#: src/features/chat/hooks/useMessageActions.ts:165
msgid "L'endpoint server è ancora in lavorazione — questa azione sarà disponibile a breve."
msgstr "L'endpoint server è ancora in lavorazione — questa azione sarà disponibile a breve."

#: src/features/connectors/components/management/ChatExamplesManager.tsx:262
msgid "L'esempio non sarà più usato per guidare il text-to-SQL."
msgstr "L'esempio non sarà più usato per guidare il text-to-SQL."

#: src/features/console/docs/content.ts:140
msgid "L'ingestion è sempre asincrona: l'upload risponde 202 con un job_id. wait_for_job fa il polling fino a completed (o solleva JobFailed con l'error_code stabile)."
msgstr "L'ingestion è sempre asincrona: l'upload risponde 202 con un job_id. wait_for_job fa il polling fino a completed (o solleva JobFailed con l'error_code stabile)."

#: src/features/console/pages/TracesPage.tsx:432
msgid "L’inspector carica input, output, tool, contesti e receipt solo quando li apri."
msgstr "L’inspector carica input, output, tool, contesti e receipt solo quando li apri."

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:133
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:107
msgid "L'intervallo personalizzato non può superare {MAX_CUSTOM_RANGE_DAYS} giorni."
msgstr "L'intervallo personalizzato non può superare {MAX_CUSTOM_RANGE_DAYS} giorni."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:454
msgid "L'intervallo personalizzato può durare fino a {MAX_CUSTOM_RANGE_DAYS} giorni."
msgstr "L'intervallo personalizzato può durare fino a {MAX_CUSTOM_RANGE_DAYS} giorni."

#: src/features/sales/components/BatchSendModal.tsx:195
msgid "L'invio avviene in background, con un ritmo controllato."
msgstr "L'invio avviene in background, con un ritmo controllato."

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:392
msgid "L'invito a"
msgstr "L'invito a"

#: src/features/admin/components/AdminDemoInviti.tsx:419
msgid "L'invito è già attivo: la nuova scadenza viene ricalcolata dall'attivazione."
msgstr "L'invito è già attivo: la nuova scadenza viene ricalcolata dall'attivazione."

#: src/features/admin/components/orgs/OrgSSOTab.tsx:43
msgid "L'issuer deve usare HTTPS."
msgstr "L'issuer deve usare HTTPS."

#: src/features/workspace/documents/components/BulkActionBar.tsx:94
msgid "L'operazione non è recuperabile. I file vengono rimossi dall'indice di Ando; gli originali su Drive non verranno toccati."
msgstr "L'operazione non è recuperabile. I file vengono rimossi dall'indice di Ando; gli originali su Drive non verranno toccati."

#: src/features/sales/components/ActivityTimeline.tsx:219
msgid "L'operazione non può essere annullata."
msgstr "L'operazione non può essere annullata."

#. placeholder {0}: sessionEmail || "—"
#: src/features/settings/components/AccountDeletion.tsx:220
msgid "L'operazione richiede alcuni minuti. Riceverai una conferma via email a <0>{0}</0>."
msgstr "L'operazione richiede alcuni minuti. Riceverai una conferma via email a <0>{0}</0>."

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:189
msgid "L'operazione verrà registrata su Fatture in Cloud con audit; al cliente può essere inviata un'email di conferma opzionale."
msgstr "L'operazione verrà registrata su Fatture in Cloud con audit; al cliente può essere inviata un'email di conferma opzionale."

#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:157
msgid "L'org NON è stata eliminata. Risolvi i conflitti e riprova."
msgstr "L'org NON è stata eliminata. Risolvi i conflitti e riprova."

#: src/features/console/pages/MembersPage.tsx:524
msgid "L'organizzazione deve mantenere almeno un proprietario."
msgstr "L'organizzazione deve mantenere almeno un proprietario."

#: src/features/sales/components/SignatureSettings.tsx:88
msgid "L'organizzazione non ha impostato una firma predefinita."
msgstr "L'organizzazione non ha impostato una firma predefinita."

#: src/features/connect/components/GrantManager.tsx:682
msgid "L'ospite può interrogare questa fonte, ma non può modificare nulla."
msgstr "L'ospite può interrogare questa fonte, ma non può modificare nulla."

#: src/features/connect/components/MemberManager.tsx:354
msgid "L'ospite riceve un link magico per accedere a questo spazio in sola lettura. Nessun account Ando richiesto."
msgstr "L'ospite riceve un link magico per accedere a questo spazio in sola lettura. Nessun account Ando richiesto."

#: src/features/voice_report/components/OutlineTab.tsx:55
msgid "L'outline non contiene sezioni."
msgstr "L'outline non contiene sezioni."

#: src/features/projects/components/ProjectDetailPage.tsx:317
msgid "L'ultima volta ci hai lavorato <0>{when}</0>, stavamo guardando \"<1>{lastConvTitle}</1>\"."
msgstr "L'ultima volta ci hai lavorato <0>{when}</0>, stavamo guardando \"<1>{lastConvTitle}</1>\"."

#: src/features/voice_report/components/ReportTab.tsx:87
msgid "L'ultimo run non è leggibile con lo schema corrente del report."
msgstr "L'ultimo run non è leggibile con lo schema corrente del report."

#: src/features/automations/components/ScheduleEditor.tsx:272
msgid "L'URL del webhook sarà generato dopo la creazione. Apri il menu contestuale dell'automazione per copiare URL + secret + esempio curl."
msgstr "L'URL del webhook sarà generato dopo la creazione. Apri il menu contestuale dell'automazione per copiare URL + secret + esempio curl."

#: src/features/dxf/components/DxfPreviewStage.tsx:497
msgid "L'URL dell'anteprima è stato emesso dal server ma il browser non è riuscito a scaricarla (rete, CORS o file rimosso). Puoi riprovare oppure passare al viewer 3D."
msgstr "L'URL dell'anteprima è stato emesso dal server ma il browser non è riuscito a scaricarla (rete, CORS o file rimosso). Puoi riprovare oppure passare al viewer 3D."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:50
msgid "L'URL deve usare HTTPS."
msgstr "L'URL deve usare HTTPS."

#: src/features/admin/components/ZitadelPasswordActions.tsx:137
msgid "L'utente dovrà cambiarla al prossimo accesso."
msgstr "L'utente dovrà cambiarla al prossimo accesso."

#: src/features/admin/components/AdminOrgs.tsx:643
msgid "L'utente è già in un'altra org — usare il flusso singolo."
msgstr "L'utente è già in un'altra org — usare il flusso singolo."

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:124
msgid "L'utente è già membro dell'organizzazione scelta."
msgstr "L'utente è già membro dell'organizzazione scelta."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:202
msgid "L'utente è ora in un'altra organizzazione. Usa \"Migra\" per spostarlo."
msgstr "L'utente è ora in un'altra organizzazione. Usa \"Migra\" per spostarlo."

#: src/features/projects/components/sections/MembersSection.tsx:144
msgid "L'utente perderà l'accesso al progetto immediatamente. Potrai re-invitarlo in seguito."
msgstr "L'utente perderà l'accesso al progetto immediatamente. Potrai re-invitarlo in seguito."

#: src/features/admin/components/ZitadelPasswordActions.tsx:87
msgid "L'utente riceverà un link per impostare una nuova password."
msgstr "L'utente riceverà un link per impostare una nuova password."

#: src/features/console/docs/content.ts:818
msgid "La bozza K-Schema da curare; PATCH per descrizioni/join/entità."
msgstr "La bozza K-Schema da curare; PATCH per descrizioni/join/entità."

#: src/features/console/pages/ModelsPage.tsx:103
msgid "La bozza qui sotto non serve ancora richieste."
msgstr "La bozza qui sotto non serve ancora richieste."

#: src/features/console/pages/FlowsPage.tsx:506
msgid "La bozza si apre subito nell'editor visuale della console."
msgstr "La bozza si apre subito nell'editor visuale della console."

#. placeholder {0}: ref.name
#: src/routes/_authed/workspace/documents.tsx:662
msgid "La cartella \"{0}\" è già vuota."
msgstr "La cartella \"{0}\" è già vuota."

#: src/routes/_authed/_modal/integrations/$capability.tsx:1066
msgid "La cartella è vuota."
msgstr "La cartella è vuota."

#: src/features/console/traces/TracePayloadReader.tsx:29
msgid "La cattura di questo payload è incompleta. Non significa che il modello non abbia ricevuto il contesto."
msgstr "La cattura di questo payload è incompleta. Non significa che il modello non abbia ricevuto il contesto."

#: src/features/console/components/CreateKeyWizard.tsx:436
msgid "La chiave accede alle fonti del progetto consentite da policy e ACL. Gli account personali richiedono l'identità del proprietario."
msgstr "La chiave accede alle fonti del progetto consentite da policy e ACL. Gli account personali richiedono l'identità del proprietario."

#: src/features/console/components/ByokModal.tsx:79
msgid "La chiave deve avere almeno {BYOK_MIN_LENGTH} caratteri e nessuno spazio."
msgstr "La chiave deve avere almeno {BYOK_MIN_LENGTH} caratteri e nessuno spazio."

#: src/features/console/pages/KeyDetailPage.tsx:631
msgid "La chiave potrebbe essere stata eliminata o l'indirizzo non è corretto."
msgstr "La chiave potrebbe essere stata eliminata o l'indirizzo non è corretto."

#: src/features/console/pages/KeyDetailPage.tsx:749
msgid "La chiave precedente è stata revocata subito."
msgstr "La chiave precedente è stata revocata subito."

#. placeholder {0}: formatDateTime(i18n.locale, rollResult.old_key_expires_at)
#: src/features/console/pages/KeyDetailPage.tsx:751
msgid "La chiave precedente resta valida fino al {0}."
msgstr "La chiave precedente resta valida fino al {0}."

#: src/features/console/pages/KeyDetailPage.tsx:366
msgid "La chiave può leggere solo le risorse elencate."
msgstr "La chiave può leggere solo le risorse elencate."

#. placeholder {0}: draft.name
#: src/features/dashboard/utils/calculatedFields.ts:317
msgid "La colonna \"{0}\" esiste già"
msgstr "La colonna \"{0}\" esiste già"

#: src/features/dashboard/components/AxisConfigurator.tsx:258
msgid "La colonna salvata non contiene date valide nei dati attuali. Scegli una colonna data oppure mostra solo il valore."
msgstr "La colonna salvata non contiene date valide nei dati attuali. Scegli una colonna data oppure mostra solo il valore."

#: src/features/console/connectors/ConnectionAccessSummary.tsx:87
msgid "La condivisione di questa connessione non è disponibile."
msgstr "La condivisione di questa connessione non è disponibile."

#: src/features/console/pages/ModelsPage.tsx:387
msgid "La configurazione dei modelli non è disponibile in questo momento."
msgstr "La configurazione dei modelli non è disponibile in questo momento."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:678
msgid "La configurazione del bridge è disponibile solo dall'app desktop Ando. Apri l'app sul computer che ha accesso al database."
msgstr "La configurazione del bridge è disponibile solo dall'app desktop Ando. Apri l'app sul computer che ha accesso al database."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:97
msgid "La configurazione deve essere un oggetto JSON, es. { \"chiave\": \"valore\" }."
msgstr "La configurazione deve essere un oggetto JSON, es. { \"chiave\": \"valore\" }."

#: src/routes/_authed/_modal/integrations/index.tsx:188
msgid "La connessione è attiva — Ando può iniziare a leggere."
msgstr "La connessione è attiva — Ando può iniziare a leggere."

#: src/features/console/pages/ConnectorDetailPage.tsx:404
msgid "La connessione e l’ultima acquisizione sono distinte. I frammenti segnalati dalla sincronizzazione non confermano che i contenuti siano recuperabili con i tuoi accessi. Verifica le fonti nel Playground."
msgstr "La connessione e l’ultima acquisizione sono distinte. I frammenti segnalati dalla sincronizzazione non confermano che i contenuti siano recuperabili con i tuoi accessi. Verifica le fonti nel Playground."

#: src/features/console/pages/ConnectorDetailPage.tsx:476
msgid "La connessione potrebbe essere stata scollegata o l'indirizzo non è corretto."
msgstr "La connessione potrebbe essere stata scollegata o l'indirizzo non è corretto."

#: src/features/onboarding/sectionGuides.ts:40
msgid "La conoscenza aziendale — HR, policy, manuali tecnici, troubleshooting — indicizzata e interrogabile in linguaggio naturale, con citazione della fonte."
msgstr "La conoscenza aziendale — HR, policy, manuali tecnici, troubleshooting — indicizzata e interrogabile in linguaggio naturale, con citazione della fonte."

#: src/features/onboarding/demoTourSteps.ts:86
msgid "La conoscenza aziendale — HR, policy, manuali tecnici, troubleshooting — indicizzata e interrogabile. Chiedi «Qual è la policy ferie?» e Ando risponde citando il documento."
msgstr "La conoscenza aziendale — HR, policy, manuali tecnici, troubleshooting — indicizzata e interrogabile. Chiedi «Qual è la policy ferie?» e Ando risponde citando il documento."

#: src/features/console/pages/PlaygroundPage.tsx:1282
msgid "La Console simula la chiave selezionata. Nel codice usa il segreto di quella AppKey come ANDO_API_KEY; l'ID della chiave non va nel corpo della richiesta."
msgstr "La Console simula la chiave selezionata. Nel codice usa il segreto di quella AppKey come ANDO_API_KEY; l'ID della chiave non va nel corpo della richiesta."

#: src/features/chat/wsHandlers.ts:300
msgid "La conversazione non è disponibile per questo account. Apri una nuova chat."
msgstr "La conversazione non è disponibile per questo account. Apri una nuova chat."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:377
msgid "La data di riferimento è inclusa. Il limite SQL esclusivo viene impostato al giorno successivo."
msgstr "La data di riferimento è inclusa. Il limite SQL esclusivo viene impostato al giorno successivo."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:375
msgid "La data di riferimento viene passata alla query come parametro."
msgstr "La data di riferimento viene passata alla query come parametro."

#. placeholder {0}: String(p.value)
#: src/features/admin/components/AdminCpqPublishChecks.tsx:39
msgid "La data di validità è già passata: {0}."
msgstr "La data di validità è già passata: {0}."

#. placeholder {0}: String(p.value)
#: src/features/admin/components/AdminCpqPublishChecks.tsx:37
msgid "La data di validità non è leggibile: {0}."
msgstr "La data di validità non è leggibile: {0}."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:377
msgid "La data finale è inclusa. Sono necessarie entrambe le date. Il nome della colonna è un esempio: usa la data della tua sorgente."
msgstr "La data finale è inclusa. Sono necessarie entrambe le date. Il nome della colonna è un esempio: usa la data della tua sorgente."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:233
msgid "La data iniziale deve precedere o coincidere con la data finale."
msgstr "La data iniziale deve precedere o coincidere con la data finale."

#: src/features/console/pages/ModelsPage.tsx:216
msgid "La delega Vertex richiede approvazione per questa organizzazione."
msgstr "La delega Vertex richiede approvazione per questa organizzazione."

#: src/features/price-lists/components/PriceListsPage.tsx:821
msgid "La descrizione è obbligatoria"
msgstr "La descrizione è obbligatoria"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:343
msgid "La disconnessione in modalità Coesistenza rilascia il numero all'app WhatsApp Business sul tuo telefono. Per riconnetterti in seguito dovrai ripetere Embedded Signup."
msgstr "La disconnessione in modalità Coesistenza rilascia il numero all'app WhatsApp Business sul tuo telefono. Per riconnetterti in seguito dovrai ripetere Embedded Signup."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:349
msgid "La disconnessione interrompe immediatamente la consegna dei messaggi ad Ando. Per riabilitare la Coesistenza in seguito dovrai installare l'app WhatsApp Business su un telefono e utilizzarla per ≥7 giorni prima di un nuovo tentativo di Embedded Signup."
msgstr "La disconnessione interrompe immediatamente la consegna dei messaggi ad Ando. Per riabilitare la Coesistenza in seguito dovrai installare l'app WhatsApp Business su un telefono e utilizzarla per ≥7 giorni prima di un nuovo tentativo di Embedded Signup."

#: src/features/admin/components/AdminDemoInviti.tsx:420
msgid "La durata partirà dal primo accesso del destinatario."
msgstr "La durata partirà dal primo accesso del destinatario."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:184
msgid "La fatturazione è attiva da questa data."
msgstr "La fatturazione è attiva da questa data."

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:134
msgid "La firma non verrà aggiunta"
msgstr "La firma non verrà aggiunta"

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:133
msgid "La firma verrà aggiunta all'invio"
msgstr "La firma verrà aggiunta all'invio"

#: src/features/settings/components/SelfProfileMemory.tsx:633
msgid "La frase distingue maiuscole e minuscole."
msgstr "La frase distingue maiuscole e minuscole."

#: src/features/console/pages/DocsPage.tsx:690
msgid "La gerarchia di errori dell'SDK."
msgstr "La gerarchia di errori dell'SDK."

#: src/features/account/components/OrgSwitcherDialog.tsx:195
msgid "La lista completa delle organizzazioni arriverà a breve. Per ora vedi solo l'organizzazione attiva."
msgstr "La lista completa delle organizzazioni arriverà a breve. Per ora vedi solo l'organizzazione attiva."

#: src/features/projects/components/sections/MemorySection.tsx:216
msgid "La memoria di questo progetto non viene mai mostrata in altri progetti. Consigliato per clienti con dati separati per privacy (GDPR)."
msgstr "La memoria di questo progetto non viene mai mostrata in altri progetti. Consigliato per clienti con dati separati per privacy (GDPR)."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:396
msgid "La mia app autentica gli utenti"
msgstr "La mia app autentica gli utenti"

#: src/features/sales/components/SignatureSettings.tsx:94
#: src/features/sources/components/InboxDetailPane.tsx:1578
msgid "La mia firma"
msgstr "La mia firma"

#: src/features/voice_report/components/NewReportDialog.tsx:391
msgid "La mia knowledge Ando"
msgstr "La mia knowledge Ando"

#: src/features/automations/components/ScheduleEditor.tsx:281
msgid "La modalità reattiva richiede di selezionare una sorgente reattiva (email/chat) — anteprima in arrivo."
msgstr "La modalità reattiva richiede di selezionare una sorgente reattiva (email/chat) — anteprima in arrivo."

#: ../../packages/ui/src/editors/RegionEditPill.tsx:229
msgid "La modifica appare nel pannello a destra"
msgstr "La modifica appare nel pannello a destra"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:62
msgid "La nota di credito sarà registrata su Fatture in Cloud e potrà essere inviata via SDI."
msgstr "La nota di credito sarà registrata su Fatture in Cloud e potrà essere inviata via SDI."

#: src/features/admin/components/ZitadelPasswordActions.tsx:138
msgid "La nuova password è attiva."
msgstr "La nuova password è attiva."

#: src/features/admin/components/PageEditor.tsx:403
msgid "La pagina di Ando è nell'anteprima: salvala se ti piace."
msgstr "La pagina di Ando è nell'anteprima: salvala se ti piace."

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:284
msgid "La PEC viene firmata e archiviata 10 anni e"
msgstr "La PEC viene firmata e archiviata 10 anni e"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:462
msgid "La piattaforma interroga da sola la tua API ogni {interval} minuti. Non servono chiamate di push dal tuo applicativo."
msgstr "La piattaforma interroga da sola la tua API ogni {interval} minuti. Non servono chiamate di push dal tuo applicativo."

#. placeholder {0}: eur(Number(p.margin))
#: src/features/admin/components/AdminCpqPublishChecks.tsx:55
msgid "La prima fase è in perdita: {0}."
msgstr "La prima fase è in perdita: {0}."

#: src/features/connectors/components/management/ChatExamplesManager.tsx:75
msgid "La query deve iniziare con SELECT."
msgstr "La query deve iniziare con SELECT."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:229
msgid "La query ricalcola scadenze e rate rispetto alla data di riferimento selezionata."
msgstr "La query ricalcola scadenze e rate rispetto alla data di riferimento selezionata."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:378
msgid "La query salvata non contiene entrambi i parametri. Configurali nell’editor SQL prima di applicare."
msgstr "La query salvata non contiene entrambi i parametri. Configurali nell’editor SQL prima di applicare."

#: src/features/dashboard/components/ChartSqlEditor.tsx:82
msgid "La query SQL non può essere vuota."
msgstr "La query SQL non può essere vuota."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:373
msgid "La query usa parametri temporali: seleziona Nella query SQL oppure rimuovili dall’editor SQL."
msgstr "La query usa parametri temporali: seleziona Nella query SQL oppure rimuovili dall’editor SQL."

#: src/features/console/pages/GetStartedPage.tsx:98
msgid "La raccolta crediti non è attiva per questa organizzazione. Un gestore può abilitarla dalla fatturazione."
msgstr "La raccolta crediti non è attiva per questa organizzazione. Un gestore può abilitarla dalla fatturazione."

#: src/features/console/pages/PlaygroundPage.tsx:481
msgid "La ricerca è limitata a queste risorse"
msgstr "La ricerca è limitata a queste risorse"

#: src/features/console/pages/PlaygroundPage.tsx:1193
msgid "La ricerca ha incontrato una limitazione."
msgstr "La ricerca ha incontrato una limitazione."

#: src/features/chat/components/InterruptedQueryNotice.tsx:32
msgid "La richiesta si è interrotta prima della risposta."
msgstr "La richiesta si è interrotta prima della risposta."

#: src/features/console/components/ByokModal.tsx:119
msgid "La rotazione disattiva i profili cliente: le elaborazioni tornano ad Ando fino alla riattivazione."
msgstr "La rotazione disattiva i profili cliente: le elaborazioni tornano ad Ando fino alla riattivazione."

#: src/features/connectors/wizards/filesystemSpec.tsx:133
msgid "La scansione gira sul tuo computer — nessun agente da installare."
msgstr "La scansione gira sul tuo computer — nessun agente da installare."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:275
msgid "La scelta è indipendente dal ruolo. Engine comprende Console e API; Workspace mantiene il proprio stato di attivazione."
msgstr "La scelta è indipendente dal ruolo. Engine comprende Console e API; Workspace mantiene il proprio stato di attivazione."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:102
msgid "La scoperta rilegge la struttura dal database e rilancia la profilazione AI su tutte le tabelle. Non si può annullare a metà e non si può tornare indietro."
msgstr "La scoperta rilegge la struttura dal database e rilancia la profilazione AI su tutte le tabelle. Non si può annullare a metà e non si può tornare indietro."

#. placeholder {0}: String(p.index)
#: src/features/admin/components/AdminCpqPublishChecks.tsx:59
msgid "La sezione aggiuntiva {0} non ha testo."
msgstr "La sezione aggiuntiva {0} non ha testo."

#. placeholder {0}: String(p.index)
#: src/features/admin/components/AdminCpqPublishChecks.tsx:57
msgid "La sezione aggiuntiva {0} non ha un titolo."
msgstr "La sezione aggiuntiva {0} non ha un titolo."

#: src/features/console/pages/ResourceAccessPage.tsx:340
msgid "La sincronizzazione resta privata. Solo i contenuti scelti qui sotto possono essere condivisi, senza dare accesso all'account originale."
msgstr "La sincronizzazione resta privata. Solo i contenuti scelti qui sotto possono essere condivisi, senza dare accesso all'account originale."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:317
msgid "La sincronizzazione richiede attenzione."
msgstr "La sincronizzazione richiede attenzione."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:394
msgid "La sorgente selezionata porta con sé il proprio set di dati: non serve scrivere SQL. Vai avanti per impostare la visualizzazione."
msgstr "La sorgente selezionata porta con sé il proprio set di dati: non serve scrivere SQL. Vai avanti per impostare la visualizzazione."

#: src/features/voice_report/components/OutlineTab.tsx:144
msgid "La struttura dell'ultimo report appare qui non appena un run completato la produce."
msgstr "La struttura dell'ultimo report appare qui non appena un run completato la produce."

#: src/features/voice_report/components/OutlineTab.tsx:45
msgid "La struttura dell'ultimo run non è leggibile con lo schema corrente."
msgstr "La struttura dell'ultimo run non è leggibile con lo schema corrente."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:130
msgid "La struttura della proposta resta quella standard: ogni sezione extra si inserisce dopo una sezione fissa."
msgstr "La struttura della proposta resta quella standard: ogni sezione extra si inserisce dopo una sezione fissa."

#: src/features/console/connectors/ConnectionCard.tsx:273
msgid "La struttura mostra tabelle e righe disponibili; non indica un'indicizzazione dei dati."
msgstr "La struttura mostra tabelle e righe disponibili; non indica un'indicizzazione dei dati."

#: src/features/console/docs/content.ts:1170
msgid "La superficie di GOVERNO (questa console) — auth di sessione (cookie BFF), NON API-key. Overview, usage (anche per-chiave), quota, billing, team e Modelli. La API-key resta l'auth del runtime."
msgstr "La superficie di GOVERNO (questa console) — auth di sessione (cookie BFF), NON API-key. Overview, usage (anche per-chiave), quota, billing, team e Modelli. La API-key resta l'auth del runtime."

#: src/features/connectors/components/management/SchemaViewer.tsx:845
msgid "La tabella non contiene righe da mostrare."
msgstr "La tabella non contiene righe da mostrare."

#: src/features/share/components/ShareLinkDialog.tsx:896
msgid "La trovano in Condivisioni, nel loro workspace. Nessun link pubblico."
msgstr ""

#: src/features/console/pages/EmbeddedIdentityPage.tsx:355
msgid "La tua app autentica gli utenti. Il tuo server passa a Ando un ID stabile per ogni richiesta."
msgstr "La tua app autentica gli utenti. Il tuo server passa a Ando un ID stabile per ogni richiesta."

#: src/features/console/docs/content.ts:1155
msgid "La tua app riporta l'esito (completed/failed) dell'azione dispacciata. GET /actions elenca (filtro ?connector=), GET /actions/<id> per il polling."
msgstr "La tua app riporta l'esito (completed/failed) dell'azione dispacciata. GET /actions elenca (filtro ?connector=), GET /actions/<id> per il polling."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:355
msgid "La tua app usa un provider OIDC esistente. Ando verifica il token dell'utente per ogni richiesta."
msgstr "La tua app usa un provider OIDC esistente. Ando verifica il token dell'utente per ogni richiesta."

#: src/features/onboarding/DemoBookCallModal.tsx:419
msgid "La tua azienda S.r.l."
msgstr "La tua azienda S.r.l."

#: src/features/dashboard/components/DashboardEmptyState.tsx:57
msgid "La tua dashboard è vuota. Chiedi ad Ando di analizzare un dataset e il grafico viene salvato qui in automatico — oppure costruisci tu un widget da zero."
msgstr "La tua dashboard è vuota. Chiedi ad Ando di analizzare un dataset e il grafico viene salvato qui in automatico — oppure costruisci tu un widget da zero."

#: src/features/settings/components/OtpEmailPanel.tsx:271
#: src/features/settings/components/OtpEmailPanel.tsx:316
msgid "la tua email"
msgstr "la tua email"

#: src/features/account/components/OrgSwitcherDialog.tsx:99
msgid "La tua organizzazione"
msgstr "La tua organizzazione"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:341
msgid "La tua prima app"
msgstr "La tua prima app"

#: src/routes/forms.$flowId.tsx:58
msgid "La tua richiesta è stata registrata."
msgstr "La tua richiesta è stata registrata."

#: src/features/console/pages/ConnectorDetailPage.tsx:182
msgid "La verifica della connessione non è riuscita."
msgstr "La verifica della connessione non è riuscita."

#: src/routes/_authed/workspace/finance.tsx:1054
msgid "La vista cash flow si abilita appena colleghi Fatture in Cloud (fatture), l'open banking (movimenti bancari) o Salesforce (pipeline)."
msgstr "La vista cash flow si abilita appena colleghi Fatture in Cloud (fatture), l'open banking (movimenti bancari) o Salesforce (pipeline)."

#: src/features/dashboard/components/DashboardViewControls.tsx:54
msgid "La vista è salvata solo per te."
msgstr "La vista è salvata solo per te."

#: src/features/admin/components/AdminCpq.tsx:1159
msgid "La vista Interno non finisce mai sui link: le altre due mostrano ciò che vedrà il destinatario."
msgstr "La vista Interno non finisce mai sui link: le altre due mostrano ciò che vedrà il destinatario."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:811
msgid "Lab"
msgstr "Lab"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:243
#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:249
msgid "Lakehouse in preparazione"
msgstr "Lakehouse in preparazione"

#: src/features/console/pages/PlaygroundPage.tsx:1856
msgid "Lakehouse in preparazione."
msgstr "Lakehouse in preparazione."

#: src/features/console/pages/PlaygroundPage.tsx:1858
msgid "Lakehouse supporta documenti e dati strutturati."
msgstr "Lakehouse supporta documenti e dati strutturati."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1626
msgid "Larg. %"
msgstr "Larg. %"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:433
msgid "Lascia il nome del template oppure personalizzalo per il singolo cliente / commessa."
msgstr "Lascia il nome del template oppure personalizzalo per il singolo cliente / commessa."

#: src/features/admin/components/AdminDemoInviti.tsx:345
msgid "Lascia l'email vuota per generare solo un link condivisibile."
msgstr "Lascia l'email vuota per generare solo un link condivisibile."

#: src/features/connectors/wizards/erpSpec.tsx:82
msgid "Lascia vuoto per auto-discovery dal $metadata."
msgstr "Lascia vuoto per auto-discovery dal $metadata."

#: src/features/connect/components/GrantManager.tsx:732
msgid "Lascia vuoto per consentire l'intera connessione in sola lettura, oppure aggiungi le tabelle una alla volta (Invio o virgola per confermare)."
msgstr "Lascia vuoto per consentire l'intera connessione in sola lettura, oppure aggiungi le tabelle una alla volta (Invio o virgola per confermare)."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:380
msgid "Lascia vuoto per ereditare dal tier. I valori sono salvati in byte sul backend."
msgstr "Lascia vuoto per ereditare dal tier. I valori sono salvati in byte sul backend."

#: src/features/voice_report/components/NewReportDialog.tsx:1062
msgid "Lascia vuoto per esecuzione manuale."
msgstr "Lascia vuoto per esecuzione manuale."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:243
msgid "Lascia vuoto per i prezzi di listino. Per un budget concordato: prezzo e durata della prima fase (PoC, o PoC e pilota) e licenza annua."
msgstr "Lascia vuoto per i prezzi di listino. Per un budget concordato: prezzo e durata della prima fase (PoC, o PoC e pilota) e licenza annua."

#: src/features/console/connectors/ManifestConfigForm.tsx:155
msgid "Lascia vuoto per mantenere il secret attuale (sigillato). Inserirne uno nuovo lo RUOTA: dopo il salvataggio non sarà più visibile."
msgstr "Lascia vuoto per mantenere il secret attuale (sigillato). Inserirne uno nuovo lo RUOTA: dopo il salvataggio non sarà più visibile."

#: src/features/connect/components/ChatbotPanel.tsx:264
msgid "Lascia vuoto per nessun limite."
msgstr "Lascia vuoto per nessun limite."

#: src/features/connectors/components/management/EditConnectorDialog.tsx:295
msgid "Lascia vuoto per non aggiornare"
msgstr "Lascia vuoto per non aggiornare"

#: src/features/voice_report/components/SettingsTab.tsx:184
msgid "Lascia vuoto per un report on-demand. Sintassi cron a 5 campi."
msgstr "Lascia vuoto per un report on-demand. Sintassi cron a 5 campi."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:392
msgid "Lascia vuoto per usare il prompt del blueprint"
msgstr "Lascia vuoto per usare il prompt del blueprint"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:60
msgid "Lascia vuoto per usare il testo del listino."
msgstr "Lascia vuoto per usare il testo del listino."

#: src/features/connectors/wizards/crmSpec.tsx:67
msgid "Lascia vuoto per usare l'app gestita da Ando. Compila per BYOA."
msgstr "Lascia vuoto per usare l'app gestita da Ando. Compila per BYOA."

#: src/features/templates/components/TemplateFieldSpecs.ts:150
msgid "Lasciare vuoto per nessun footer."
msgstr "Lasciare vuoto per nessun footer."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:229
msgid "Lasciare vuoto per rilevarlo automaticamente."
msgstr "Lasciare vuoto per rilevarlo automaticamente."

#: src/features/admin/components/AdminHealth.tsx:129
msgid "Latenza per route"
msgstr "Latenza per route"

#: src/features/projects/components/ProjectIcon.tsx:66
msgid "Lavoro"
msgstr "Lavoro"

#: src/routes/_authed/workspace/technical.tsx:557
msgid "Layer"
msgstr "Layer"

#. placeholder {0}: layer.name
#: ../../packages/ui/src/cad/CadLayerList.tsx:83
msgid "Layer {0}: nascosto"
msgstr "Layer {0}: nascosto"

#. placeholder {0}: layer.name
#: ../../packages/ui/src/cad/CadLayerList.tsx:82
msgid "Layer {0}: visibile"
msgstr "Layer {0}: visibile"

#: src/routes/_authed/workspace/technical.tsx:553
msgid "Layer del disegno"
msgstr "Layer del disegno"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:219
msgid "Layout"
msgstr "Layout"

#: src/features/help/data/changelog.ts:41
msgid "Layout chat resizable + smart hint"
msgstr "Layout chat resizable + smart hint"

#: src/features/templates/components/TemplateFieldSpecs.ts:95
msgid "Layout slide"
msgstr "Layout slide"

#: src/features/console/pages/ActionsPage.tsx:48
msgid "Le <0>letture</0> spingono dati DENTRO Ando; le <1>azioni</1> mandano una richiesta FUORI, al tuo applicativo, che la esegue. Se una proposta contiene una verifica della fonte, Ando blocca i valori contraddetti e richiede conferma per quelli non attestati."
msgstr "Le <0>letture</0> spingono dati DENTRO Ando; le <1>azioni</1> mandano una richiesta FUORI, al tuo applicativo, che la esegue. Se una proposta contiene una verifica della fonte, Ando blocca i valori contraddetti e richiede conferma per quelli non attestati."

#: src/features/automations/components/AutomationsHub.tsx:215
msgid "Le automazioni si abilitano sui piani Pro e superiori. Vai in Integrazioni per controllare il tuo piano attivo."
msgstr "Le automazioni si abilitano sui piani Pro e superiori. Vai in Integrazioni per controllare il tuo piano attivo."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:306
msgid "Le azioni ad alto rischio richiedono una conferma esplicita al momento dell'esecuzione."
msgstr "Le azioni ad alto rischio richiedono una conferma esplicita al momento dell'esecuzione."

#: src/features/console/pages/ActionsPage.tsx:69
msgid "Le azioni vivono su un connettore Push. Registra il primo connettore personalizzato, poi dichiara le azioni che il tuo applicativo sa eseguire."
msgstr "Le azioni vivono su un connettore Push. Registra il primo connettore personalizzato, poi dichiara le azioni che il tuo applicativo sa eseguire."

#: src/features/onboarding/sectionGuides.ts:67
msgid "Le Canvas sono spazi di conoscenza verticali — un cervello dedicato per cliente, progetto o tema, che combina documenti, dati e ragionamento."
msgstr "Le Canvas sono spazi di conoscenza verticali — un cervello dedicato per cliente, progetto o tema, che combina documenti, dati e ragionamento."

#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:116
msgid "Le cartelle vengono create automaticamente al primo file spostato. Lascia vuoto per riportare in Root."
msgstr "Le cartelle vengono create automaticamente al primo file spostato. Lascia vuoto per riportare in Root."

#: src/features/console/connectors/CustomConnectorDetail.tsx:490
msgid "Le chiamate di push si autenticano con una AppKey che abbia entrambi questi scope. Apri un sync, invia i record a batch (max 500), poi completa."
msgstr "Le chiamate di push si autenticano con una AppKey che abbia entrambi questi scope. Apri un sync, invia i record a batch (max 500), poi completa."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:395
msgid "Le chiamate di push si autenticano con una AppKey della piattaforma, che deve avere entrambi questi scope:"
msgstr "Le chiamate di push si autenticano con una AppKey della piattaforma, che deve avere entrambi questi scope:"

#: src/features/console/docs/content.ts:1833
msgid "Le chiavi del project, hash mai inclusi (scope keys:manage)."
msgstr "Le chiavi del project, hash mai inclusi (scope keys:manage)."

#. placeholder {0}: deleteTarget.url
#: src/features/console/webhooks/WebhooksPanel.tsx:735
msgid "Le consegne verso {0} si fermano subito. Gli eventi non consegnati non vengono recuperati."
msgstr "Le consegne verso {0} si fermano subito. Gli eventi non consegnati non vengono recuperati."

#: src/features/skills/components/SkillsList.tsx:160
msgid "Le cose che hai insegnato ad Ando — si attivano da sole quando servono"
msgstr "Le cose che hai insegnato ad Ando — si attivano da sole quando servono"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:506
msgid "Le credenziali della tua API sono cifrate a riposo e non verranno più mostrate. Per cambiarle usa «Ruota secret» nel dettaglio del connettore."
msgstr "Le credenziali della tua API sono cifrate a riposo e non verranno più mostrate. Per cambiarle usa «Ruota secret» nel dettaglio del connettore."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1000
msgid "Le credenziali inserite andranno perse. Nessuna informazione è stata inviata al cloud Ando."
msgstr "Le credenziali inserite andranno perse. Nessuna informazione è stata inviata al cloud Ando."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:764
msgid "Le credenziali restano nel tuo computer (vault cifrato), mai sul cloud."
msgstr "Le credenziali restano nel tuo computer (vault cifrato), mai sul cloud."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:666
msgid "Le credenziali restano sul tuo dispositivo, nel portachiavi di sistema (Keychain). Il cloud Ando riceve solo un identificativo opaco per inoltrare le query."
msgstr "Le credenziali restano sul tuo dispositivo, nel portachiavi di sistema (Keychain). Il cloud Ando riceve solo un identificativo opaco per inoltrare le query."

#: src/routes/_authed/workspace/dashboard.tsx:946
msgid "Le dashboard di Ando si compongono da query strutturate sui tuoi database o fogli. Aggiungi un connettore enterprise dal pannello Integrazioni per attivare la funzionalità."
msgstr "Le dashboard di Ando si compongono da query strutturate sui tuoi database o fogli. Aggiungi un connettore enterprise dal pannello Integrazioni per attivare la funzionalità."

#: src/features/console/pages/SchemaPage.tsx:177
msgid "Le descrizioni curate qui migliorano la precisione delle risposte di TRAMA."
msgstr "Le descrizioni curate qui migliorano la precisione delle risposte di TRAMA."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:452
msgid "Le descrizioni importate vengono marcate come modificate a mano: la profilazione AI non le sovrascrive."
msgstr "Le descrizioni importate vengono marcate come modificate a mano: la profilazione AI non le sovrascrive."

#: src/features/connectors/components/management/SchemaViewer.tsx:152
msgid "Le descrizioni sono condivise con tutto il team: una modifica vale per tutti gli utenti della tua organizzazione."
msgstr "Le descrizioni sono condivise con tutto il team: una modifica vale per tutti gli utenti della tua organizzazione."

#: src/features/chat/components/ChatEmptyState.tsx:610
msgid "Le domande con questo segno interrogano il gestionale. Apri «Ambito» per chiedere sui tuoi dati — fatture, clienti, fatturato."
msgstr "Le domande con questo segno interrogano il gestionale. Apri «Ambito» per chiedere sui tuoi dati — fatture, clienti, fatturato."

#: src/features/connect/components/ActivityFeed.tsx:51
msgid "Le domande dei tuoi ospiti e le azioni sullo spazio appariranno qui."
msgstr "Le domande dei tuoi ospiti e le azioni sullo spazio appariranno qui."

#: src/features/sales/components/SuppressionPanel.tsx:105
msgid "Le email e i domini che aggiungi qui vengono esclusi da ogni campagna. Aggiungine uno qui sopra."
msgstr "Le email e i domini che aggiungi qui vengono esclusi da ogni campagna. Aggiungine uno qui sopra."

#: src/features/admin/components/orgs/OrgCostTab.tsx:227
msgid "Le email sono dati personali dei dipendenti del cliente (GDPR). Per rivelarle indica una motivazione (≥ 10 caratteri): l'accesso è registrato in audit log e scade dopo 15 minuti."
msgstr "Le email sono dati personali dei dipendenti del cliente (GDPR). Per rivelarle indica una motivazione (≥ 10 caratteri): l'accesso è registrato in audit log e scade dopo 15 minuti."

#: src/features/console/pages/PlaygroundPage.tsx:1328
msgid "Le esecuzioni compaiono qui, la più recente in alto."
msgstr "Le esecuzioni compaiono qui, la più recente in alto."

#: src/features/console/pages/BillingPage.tsx:586
msgid "Le fatture compariranno qui dopo la prima chiusura del periodo di consumo."
msgstr "Le fatture compariranno qui dopo la prima chiusura del periodo di consumo."

#: src/features/console/pages/OverviewPage.tsx:370
msgid "Le fonti sono collegate. Apri Fonti per controllare lo stato e avviare una sincronizzazione, se disponibile."
msgstr "Le fonti sono collegate. Apri Fonti per controllare lo stato e avviare una sincronizzazione, se disponibile."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2520
msgid "Le immagini caricate vengono ridotte a 1600 px e salvate nel deck."
msgstr "Le immagini caricate vengono ridotte a 1600 px e salvate nel deck."

#: src/features/console/pages/OverviewPage.tsx:284
msgid "Le importazioni recenti non sono disponibili."
msgstr "Le importazioni recenti non sono disponibili."

#: src/features/settings/components/ProfileSettings.tsx:76
msgid "Le informazioni di identità (nome, email) sono gestite tramite il provider di identità — modifica tema e preferenze qui."
msgstr "Le informazioni di identità (nome, email) sono gestite tramite il provider di identità — modifica tema e preferenze qui."

#: src/features/skills/components/SkillsList.tsx:198
msgid "Le mie"
msgstr "Le mie"

#: src/features/sales/components/SalesOverview.tsx:278
msgid "Le mie campagne"
msgstr "Le mie campagne"

#: src/features/chat/components/ChatEmptyState.tsx:295
msgid "Le mie dashboard"
msgstr "Le mie dashboard"

#: src/features/sales/components/SignaturesManager.tsx:134
msgid "Le mie firme"
msgstr "Le mie firme"

#: src/features/automations/components/AutomationDetailSection.tsx:177
msgid "Le modifiche avanzate (canali di output, approvazioni multi-step, filtri reattivi) torneranno in arrivo nel detail editor."
msgstr "Le modifiche avanzate (canali di output, approvazioni multi-step, filtri reattivi) torneranno in arrivo nel detail editor."

#: src/features/sources/components/ArtifactToolbar.tsx:78
msgid "Le modifiche fatte fuori da Ando non torneranno indietro come tracked-changes."
msgstr "Le modifiche fatte fuori da Ando non torneranno indietro come tracked-changes."

#: src/features/sources/components/AISummaryPanel.tsx:523
msgid "Le modifiche vengono salvate insieme."
msgstr "Le modifiche vengono salvate insieme."

#: src/features/settings/components/NotificationPreferences.tsx:394
msgid "Le notifiche in-app sono sempre attive. L'email è opzionale e disattivata di default."
msgstr "Le notifiche in-app sono sempre attive. L'email è opzionale e disattivata di default."

#: src/features/console/pages/BillingPage.tsx:170
msgid "Le nuove AppKey e le ricariche usano un unico saldo dell’organizzazione."
msgstr "Le nuove AppKey e le ricariche usano un unico saldo dell’organizzazione."

#: src/features/console/pages/BillingPage.tsx:177
msgid "Le nuove AppKey e ogni ricarica usano il saldo personale del membro corrente."
msgstr "Le nuove AppKey e ogni ricarica usano il saldo personale del membro corrente."

#: src/features/settings/components/SecuritySettings.tsx:123
msgid "Le password non coincidono"
msgstr "Le password non coincidono"

#: src/features/connectors/wizards/pecSpec.tsx:62
msgid "Le PEC restano consultabili come prova in caso di contenzioso."
msgstr "Le PEC restano consultabili come prova in caso di contenzioso."

#: src/features/console/pages/ResourceAccessPage.tsx:448
msgid "Le persone scelte potranno cercare solo i contenuti indicizzati selezionati nella knowledge Ando, senza accesso all'account originale."
msgstr "Le persone scelte potranno cercare solo i contenuti indicizzati selezionati nella knowledge Ando, senza accesso all'account originale."

#: src/features/admin/components/AdminDecks.tsx:140
msgid "Le presentazioni di Ando Lab, ognuna con le sue versioni e i suoi link. Creane una vuota, copiane una esistente o partendo da un documento; modifica le slide o chiedi ad Ando, salva una nuova versione e condividi con link a codice email."
msgstr "Le presentazioni di Ando Lab, ognuna con le sue versioni e i suoi link. Creane una vuota, copiane una esistente o partendo da un documento; modifica le slide o chiedi ad Ando, salva una nuova versione e condividi con link a codice email."

#: src/features/sources/components/AISummaryPanel.tsx:833
msgid "Le proposte AI di {hint} appariranno qui quando l'agente le suggerisce."
msgstr "Le proposte AI di {hint} appariranno qui quando l'agente le suggerisce."

#: src/features/console/traces/TraceGraph.tsx:494
msgid "Le relazioni originali complete restano in «Metadati e relazioni del trace»."
msgstr "Le relazioni originali complete restano in «Metadati e relazioni del trace»."

#: src/features/connectors/wizards/sdiSpec.tsx:104
msgid "Le ricevute restano nel Cassetto Fiscale (capability separata)."
msgstr "Le ricevute restano nel Cassetto Fiscale (capability separata)."

#: src/routes/_authed/workspace/conversations.tsx:1080
msgid "Le ricevute SDI e i messaggi certificati arriveranno qui."
msgstr "Le ricevute SDI e i messaggi certificati arriveranno qui."

#: src/features/console/pages/PlaygroundPage.tsx:1315
msgid "Le richieste di questa sessione. Clicca per rieseguire."
msgstr "Le richieste di questa sessione. Clicca per rieseguire."

#: src/features/console/pages/KeyDetailPage.tsx:466
msgid "Le risposte del runtime riportano il consumo negli header <0>X-Spend-Limit</0>, <1>X-Spend-Used</1> e <2>X-Spend-Remaining</2> (USD); oltre il tetto la chiave riceve un errore 402."
msgstr "Le risposte del runtime riportano il consumo negli header <0>X-Spend-Limit</0>, <1>X-Spend-Used</1> e <2>X-Spend-Remaining</2> (USD); oltre il tetto la chiave riceve un errore 402."

#: src/routes/_authed/workspace/shares.tsx:168
msgid "Le risposte e le chat che i tuoi colleghi ti inoltreranno appariranno qui."
msgstr "Le risposte e le chat che i tuoi colleghi ti inoltreranno appariranno qui."

#: src/features/connectors/wizards/messagingSpec.tsx:89
msgid "Le riunioni Teams e Google Meet vengono trascritte e indicizzate: chiedi \"cosa è stato deciso?\" con citazioni."
msgstr "Le riunioni Teams e Google Meet vengono trascritte e indicizzate: chiedi \"cosa è stato deciso?\" con citazioni."

#: src/features/dashboard/components/AddWidgetWizard.tsx:197
msgid "Le saved-query non sono ancora supportate dal salvataggio diretto — usa Database / Spreadsheet."
msgstr "Le saved-query non sono ancora supportate dal salvataggio diretto — usa Database / Spreadsheet."

#: src/features/connect/components/GuestPreviewDialog.tsx:66
msgid "Le stesse risposte che vedono i tuoi ospiti, limitate alle fonti condivise."
msgstr "Le stesse risposte che vedono i tuoi ospiti, limitate alle fonti condivise."

#: src/features/console/pages/ConnectorDetailPage.tsx:497
msgid "Le tabelle invariate riusano il profiling. Una tabella modificata viene analizzata con tutte le sue colonne."
msgstr "Le tabelle invariate riusano il profiling. Una tabella modificata viene analizzata con tutte le sue colonne."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:339
msgid "Le tue app"
msgstr "Le tue app"

#: src/features/onboarding/demoTourSteps.ts:60
msgid "Le tue aree di lavoro"
msgstr "Le tue aree di lavoro"

#: src/features/console/pages/OverviewPage.tsx:175
msgid "Le tue fonti sono collegate."
msgstr "Le tue fonti sono collegate."

#: src/features/skills/components/SkillsList.tsx:157
msgid "Le tue Skill"
msgstr "Le tue Skill"

#: src/features/workspace/config.ts:367
msgid "Lead"
msgstr "Lead"

#: src/features/sales/components/CreateLeadDialog.tsx:79
msgid "Lead aggiunto"
msgstr "Lead aggiunto"

#: src/features/sales/components/AssigneePicker.tsx:58
msgid "Lead assegnato"
msgstr "Lead assegnato"

#: src/features/sales/hooks/useCrmQueries.ts:388
msgid "Lead convertito in opportunità"
msgstr "Lead convertito in opportunità"

#: src/features/chat/components/ChatEmptyState.tsx:197
msgid "Lead da contattare"
msgstr "Lead da contattare"

#: src/features/sales/hooks/useCrmQueries.ts:400
msgid "Lead già convertito"
msgstr "Lead già convertito"

#: src/features/sales/components/CreateLeadDialog.tsx:82
msgid "Lead non aggiunto"
msgstr "Lead non aggiunto"

#: src/features/sales/components/LeadInlineControls.tsx:119
msgid "Lead qualificato"
msgstr "Lead qualificato"

#: src/features/sales/components/LeadInlineControls.tsx:121
msgid "Lead squalificato"
msgstr "Lead squalificato"

#: src/routes/_authed/workspace/dashboard.tsx:614
msgid "Legacy"
msgstr "Legacy"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2152
msgid "Legenda"
msgstr "Legenda"

#: src/features/clean-control/components/DimensionRadar.tsx:258
msgid "Legenda dimensioni"
msgstr "Legenda dimensioni"

#: src/features/connectors/components/management/SchemaViewer.tsx:482
msgid "Legenda valori"
msgstr "Legenda valori"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:498
msgid "Legenda:"
msgstr "Legenda:"

#: src/features/connectors/components/GmailAccessModeDialog.tsx:24
msgid "Leggi e gestisci email e contatti, cerca e invia da Ando."
msgstr "Leggi e gestisci email e contatti, cerca e invia da Ando."

#: src/features/console/docs/content.ts:1420
msgid "Leggi il periodo email o chat"
msgstr "Leggi il periodo email o chat"

#: src/features/console/docs/content.ts:1458
msgid "Leggi la selezione chat"
msgstr "Leggi la selezione chat"

#: src/features/console/docs/content.ts:1439
msgid "Leggi la selezione Drive"
msgstr "Leggi la selezione Drive"

#: src/features/console/docs/content.ts:1588
msgid "Leggi una piccola anteprima"
msgstr "Leggi una piccola anteprima"

#. placeholder {0}: d.text.length.toLocaleString()
#. placeholder {1}: d.chars.toLocaleString()
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2755
msgid "Letti i primi {0} caratteri su {1}"
msgstr "Letti i primi {0} caratteri su {1}"

#: src/features/console/pages/DevelopersPage.tsx:103
msgid "Lettura"
msgstr "Lettura"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1503
msgid "Lettura del documento"
msgstr "Lettura del documento"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:223
msgid "Lettura dello schema dal connettore…"
msgstr "Lettura dello schema dal connettore…"

#: src/features/console/pages/UsagePage.tsx:437
msgid "Lettura operativa"
msgstr "Lettura operativa"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:689
msgid "Libera"
msgstr "Libera"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:162
msgid "Libreria"
msgstr "Libreria"

#: src/features/connectors/components/vendorIcons.tsx:168
#: src/features/connectors/components/vendorIcons.tsx:477
#: src/features/connectors/wizards/cadLibrarySpec.tsx:65
#: src/features/console/connectors/meta.ts:165
msgid "Libreria CAD"
msgstr "Libreria CAD"

#: src/features/sales/components/TemplateManager.tsx:290
msgid "Libreria organizzazione"
msgstr "Libreria organizzazione"

#: src/features/settings/MarpTemplateSettings.tsx:127
msgid "Libreria premium illimitata, uso commerciale"
msgstr "Libreria premium illimitata, uso commerciale"

#. placeholder {0}: resolveDisplayName(l.connector_key)
#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:392
msgid "Licenza {0}"
msgstr "Licenza {0}"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:197
msgid "Licenza aggiornata"
msgstr "Licenza aggiornata"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:281
msgid "Licenza annua concordata (€)"
msgstr "Licenza annua concordata (€)"

#. placeholder {0}: eur(Number(p.agreed))
#. placeholder {1}: eur(Number(p.list))
#: src/features/admin/components/AdminCpqPublishChecks.tsx:49
msgid "Licenza concordata ({0}) sopra il listino ({1})."
msgstr "Licenza concordata ({0}) sopra il listino ({1})."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:204
msgid "Licenza connector"
msgstr "Licenza connector"

#: src/features/admin/components/AdminCpq.tsx:637
msgid "Licenza per applicazione. Il pacchetto di crediti dice quanto viene usata."
msgstr "Licenza per applicazione. Il pacchetto di crediti dice quanto viene usata."

#. placeholder {0}: recipient.apps.length
#: src/features/admin/components/AdminCpq.tsx:190
msgid "Licenze ({0} applicazioni)"
msgstr "Licenze ({0} applicazioni)"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:336
msgid "Licenze connector"
msgstr "Licenze connector"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:67
msgid "Licenze e utenti"
msgstr "Licenze e utenti"

#: src/features/help/data/changelog.ts:72
msgid "Lifecycle dell'auto-updater per il client desktop con UI di notifica nativa, firma del binario e ripristino sessione dopo restart."
msgstr "Lifecycle dell'auto-updater per il client desktop con UI di notifica nativa, firma del binario e ripristino sessione dopo restart."

#: src/features/connectors/wizards/filesystemSpec.tsx:95
msgid "Limita l'accesso a un sotto-percorso e a utenti specifici."
msgstr "Limita l'accesso a un sotto-percorso e a utenti specifici."

#: src/features/console/components/CreateKeyWizard.tsx:443
msgid "Limita la chiave a sorgenti e connessioni specifiche."
msgstr "Limita la chiave a sorgenti e connessioni specifiche."

#: src/features/console/components/CreateKeyWizard.tsx:518
msgid "Limita su quali dei tuoi connettori questa chiave può eseguire azioni (il write-loop). Lascia vuoto per consentirli tutti."
msgstr "Limita su quali dei tuoi connettori questa chiave può eseguire azioni (il write-loop). Lascia vuoto per consentirli tutti."

#: src/features/chat/wsHandlers.ts:322
msgid "Limite del piano raggiunto"
msgstr "Limite del piano raggiunto"

#: src/features/console/pages/KeyDetailPage.tsx:436
msgid "Limite di spesa"
msgstr "Limite di spesa"

#: src/features/console/pages/KeyDetailPage.tsx:305
msgid "Limite di spesa mensile"
msgstr "Limite di spesa mensile"

#: src/features/console/components/CreateKeyWizard.tsx:559
msgid "Limite di spesa mensile (opzionale)"
msgstr "Limite di spesa mensile (opzionale)"

#: src/features/automations/components/AutomationDetailSection.tsx:173
msgid "Limite esecuzioni"
msgstr "Limite esecuzioni"

#: src/features/console/docs/content.ts:1997
msgid "Limite per-chiave superato (header Retry-After)."
msgstr "Limite per-chiave superato (header Retry-After)."

#: src/features/console/components/LimitBar.tsx:81
msgid "Limite quasi raggiunto"
msgstr "Limite quasi raggiunto"

#: src/features/admin/components/AdminGatedLinks.tsx:108
#: src/features/billing/components/UsageMeter.tsx:186
#: src/features/chat/wsHandlers.ts:318
msgid "Limite raggiunto"
msgstr "Limite raggiunto"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:253
#: src/features/console/components/ConsoleShell.tsx:249
#: src/features/console/pages/LimitsPage.tsx:115
msgid "Limiti"
msgstr "Limiti"

#: src/features/connect/components/ChatbotPanel.tsx:236
msgid "Limiti aggiornati"
msgstr "Limiti aggiornati"

#: src/features/connect/components/ChatbotPanel.tsx:245
msgid "Limiti di domande"
msgstr "Limiti di domande"

#: src/features/settings/components/NotificationPreferences.tsx:449
msgid "Limiti giornalieri"
msgstr "Limiti giornalieri"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1681
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1984
#: src/features/dashboard/components/AddChartDialog.tsx:108
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:39
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:121
msgid "Linea"
msgstr "Linea"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2062
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:56
msgid "Linee"
msgstr "Linee"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:343
#: src/features/admin/components/PageEditor.tsx:308
#: src/features/settings/components/ProfileSettings.tsx:123
#: src/features/templates/components/TemplateFieldSpecs.ts:177
msgid "Lingua"
msgstr "Lingua"

#: src/features/admin/components/AdminGatedLinks.tsx:202
msgid "Lingua dell'email"
msgstr "Lingua dell'email"

#: src/features/admin/components/AdminCpqCanvas.tsx:213
msgid "Lingua della proposta"
msgstr "Lingua della proposta"

#: src/features/voice_report/components/NewReportDialog.tsx:813
msgid "Lingua: {languageLabel}"
msgstr "Lingua: {languageLabel}"

#: src/features/console/pages/PlaygroundPage.tsx:1265
msgid "Linguaggio dello snippet"
msgstr "Linguaggio dello snippet"

#: src/features/admin/components/AdminDecksAskAndo.tsx:103
msgid "Lingue"
msgstr "Lingue"

#: src/features/admin/components/AdminDecks.tsx:805
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1794
#: src/features/share/components/ShareLinkDialog.tsx:272
msgid "Link"
msgstr "Link"

#: src/features/voice_report/components/ShareReportDialog.tsx:367
msgid "Link attivi"
msgstr "Link attivi"

#: src/features/admin/components/AdminGatedLinks.tsx:168
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:150
#: src/features/hive-flows/components/FlowFormPublish.tsx:131
#: src/features/voice_report/components/ShareReportDialog.tsx:195
msgid "Link copiato"
msgstr "Link copiato"

#: src/features/sources/components/CalendarEventPane.tsx:217
msgid "Link copiato negli appunti"
msgstr "Link copiato negli appunti"

#: src/features/share/components/ShareLinkDialog.tsx:904
msgid "Link di condivisione"
msgstr "Link di condivisione"

#: src/features/connect/components/MemberManager.tsx:415
#: src/features/connect/components/MemberManager.tsx:418
msgid "Link di invito"
msgstr "Link di invito"

#: src/features/admin/components/AdminCpq.tsx:582
msgid "Link e messaggi"
msgstr "Link e messaggi"

#: src/features/voice_report/components/ShareReportDialog.tsx:163
msgid "Link generato"
msgstr "Link generato"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:381
msgid "link generato automaticamente"
msgstr "link generato automaticamente"

#. placeholder {0}: formatExpiresAt(lastGenerated.expires_at, locale)
#: src/features/voice_report/components/ShareReportDialog.tsx:299
msgid "Link generato. Scade il <0>{0}</0>"
msgstr "Link generato. Scade il <0>{0}</0>"

#: src/features/admin/components/AdminDemoInviti.tsx:246
msgid "Link generico"
msgstr "Link generico"

#: src/features/admin/components/AdminGatedLinks.tsx:184
msgid "Link inviato via email"
msgstr "Link inviato via email"

#: src/features/briefing/briefingActions.ts:66
msgid "Link non disponibile"
msgstr "Link non disponibile"

#: src/routes/public.voice-report.$token.tsx:91
#: src/routes/public.voice-report.$token.tsx:339
msgid "Link non trovato"
msgstr "Link non trovato"

#: src/features/share/components/ShareLinkDialog.tsx:889
msgid "Link pronto"
msgstr "Link pronto"

#: src/features/admin/components/AdminCpq.tsx:1071
msgid "Link pubblicati"
msgstr "Link pubblicati"

#: src/features/connect/components/ChatbotPanel.tsx:136
#: src/features/connect/components/ChatbotPanel.tsx:139
#: src/features/share/components/ShareLinkRow.tsx:45
msgid "Link pubblico"
msgstr "Link pubblico"

#: src/features/admin/components/AdminCpq.tsx:445
msgid "Link revocati"
msgstr "Link revocati"

#: src/features/voice_report/components/ShareReportDialog.tsx:175
#: src/routes/public.voice-report.$token.tsx:297
msgid "Link revocato"
msgstr "Link revocato"

#: src/features/admin/components/AdminDecks.tsx:698
msgid "Link riservati"
msgstr "Link riservati"

#: src/features/settings/components/DataExport.tsx:234
#: src/routes/public.voice-report.$token.tsx:283
msgid "Link scaduto"
msgstr "Link scaduto"

#: src/routes/_authed/workspace/finance.tsx:1794
msgid "Liquidazione IVA del trimestre"
msgstr "Liquidazione IVA del trimestre"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:516
msgid "Lista"
msgstr "Lista"

#: src/features/automations/components/AutomationsHub.tsx:194
msgid "Lista automazioni con KPI e dettagli"
msgstr "Lista automazioni con KPI e dettagli"

#: src/routes/_authed/_modal/integrations/route.tsx:89
msgid "Lista integrazioni e wizard di configurazione"
msgstr "Lista integrazioni e wizard di configurazione"

#: src/features/admin/components/AdminOrgs.tsx:822
msgid "Lista organizzazioni"
msgstr "Lista organizzazioni"

#: src/features/admin/components/UserDetailContent.tsx:676
msgid "Lista sessioni attive"
msgstr "Lista sessioni attive"

#: src/features/admin/components/AdminUsers.tsx:217
#: src/features/admin/components/AdminUsers.tsx:309
msgid "Lista utenti piattaforma"
msgstr "Lista utenti piattaforma"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:127
msgid "Lista versioni"
msgstr "Lista versioni"

#: src/features/price-lists/components/PriceListsPage.tsx:394
msgid "Listini caricati"
msgstr "Listini caricati"

#: src/features/admin/components/AdminBilling.tsx:249
#: src/features/admin/components/AdminCpq.tsx:1280
msgid "Listino"
msgstr "Listino"

#. placeholder {0}: data.price_book_version ?? ""
#: src/features/admin/components/AdminCpq.tsx:494
msgid "listino {0}"
msgstr "listino {0}"

#: src/features/price-lists/components/PriceListsPage.tsx:86
#: src/features/price-lists/components/PriceListsPage.tsx:198
msgid "Listino analizzato"
msgstr "Listino analizzato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1422
msgid "Livelli"
msgstr "Livelli"

#: src/features/console/flows/ConsoleFlowEditor.tsx:246
msgid "Livello di dettaglio"
msgstr "Livello di dettaglio"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:282
msgid "Livello di rischio"
msgstr "Livello di rischio"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:45
msgid "Livello di supporto"
msgstr "Livello di supporto"

#: src/features/admin/components/AdminCpq.tsx:844
msgid "Livello di supporto e SLA"
msgstr "Livello di supporto e SLA"

#: src/features/admin/components/AdminCpq.tsx:879
#: src/features/admin/components/AdminCpqAskAndo.tsx:177
msgid "Livello partner"
msgstr "Livello partner"

#: src/features/console/docs/content.ts:235
msgid "Liveness pubblica"
msgstr "Liveness pubblica"

#: src/features/console/docs/content.ts:227
msgid "Liveness, identità del project e gestione delle AppKey. Ogni chiave ha scope espliciti e appartiene a un project isolato."
msgstr "Liveness, identità del project e gestione delle AppKey. Ogni chiave ha scope espliciti e appartiene a un project isolato."

#: src/features/admin/components/AdminCpqPriceBook.tsx:310
msgid "LLM a carico nostro"
msgstr "LLM a carico nostro"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:334
msgid "LLM calls"
msgstr "LLM calls"

#. placeholder {0}: i18n._(KIND_LABELS[form.kind]).toLowerCase()
#: src/features/settings/components/PresentationTemplates.tsx:844
msgid "Lo schema {0} viene validato dal backend al salvataggio."
msgstr "Lo schema {0} viene validato dal backend al salvataggio."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:72
msgid "Lo schema deve essere un oggetto JSON Schema, es. { \"type\": \"object\", \"properties\": { … } }."
msgstr "Lo schema deve essere un oggetto JSON Schema, es. { \"type\": \"object\", \"properties\": { … } }."

#: src/features/console/pages/SchemaPage.tsx:423
msgid "Lo schema non è ancora stato scoperto: attendi la prima sincronizzazione della sorgente."
msgstr "Lo schema non è ancora stato scoperto: attendi la prima sincronizzazione della sorgente."

#: src/features/settings/components/PresentationTemplates.tsx:642
msgid "Lo spec deve essere un oggetto JSON"
msgstr "Lo spec deve essere un oggetto JSON"

#: src/features/templates/components/TemplateEditor.tsx:143
msgid "Lo spec deve essere un oggetto JSON."
msgstr "Lo spec deve essere un oggetto JSON."

#: src/features/templates/components/TemplateEditor.tsx:300
msgid "Lo spec JSON non è valido; correggi il blocco JSON sotto per riattivare l'editor."
msgstr "Lo spec JSON non è valido; correggi il blocco JSON sotto per riattivare l'editor."

#: src/features/admin/components/orgs/AddMemberDialog.tsx:169
msgid "Lo spostamento tra organizzazioni è una migrazione dedicata — usa il flusso di migrazione utente."
msgstr "Lo spostamento tra organizzazioni è una migrazione dedicata — usa il flusso di migrazione utente."

#: src/features/console/pages/DevelopersPage.tsx:50
msgid "Lo stack agentico completo: retrieval sul corpus + query sui sistemi collegati, in un'unica risposta."
msgstr "Lo stack agentico completo: retrieval sul corpus + query sui sistemi collegati, in un'unica risposta."

#: src/features/console/pages/PlaygroundPage.tsx:1864
msgid "Lo stack completo per le fonti del progetto, con traccia di esecuzione. Per gli account personali scegli Ricerca → I miei account."
msgstr "Lo stack completo per le fonti del progetto, con traccia di esecuzione. Per gli account personali scegli Ricerca → I miei account."

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:531
msgid "Loading editor…"
msgstr "Loading editor…"

#: src/features/dashboard/utils/calculatedFields.ts:98
#: src/features/hive-flows/components/nodeVisuals.tsx:47
msgid "Logica"
msgstr "Logica"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
msgid "Login"
msgstr "Login"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:597
msgid "Login Ando"
msgstr "Login Ando"

#: src/features/auth/desktop/DesktopLoginForm.tsx:425
#: src/features/auth/desktop/DesktopLoginForm.tsx:456
#: src/features/auth/desktop/DesktopLoginForm.tsx:459
msgid "Login fallito"
msgstr "Login fallito"

#: src/features/auth/desktop/useDesktopOAuth.ts:196
msgid "Login fallito durante l'exchange."
msgstr "Login fallito durante l'exchange."

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:367
msgid "Login verification…"
msgstr "Login verification…"

#: src/features/settings/components/BrandKitSettings.tsx:474
msgid "Logo"
msgstr "Logo"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:310
#: src/features/settings/components/OrganizationSettings.tsx:267
msgid "Logo (dark)"
msgstr "Logo (dark)"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:296
#: src/features/settings/components/OrganizationSettings.tsx:260
msgid "Logo (light)"
msgstr "Logo (light)"

#: src/features/settings/components/BrandKitSettings.tsx:470
msgid "Logo & Template"
msgstr "Logo & Template"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1305
msgid "Logo Ando"
msgstr "Logo Ando"

#: src/features/settings/components/BrandKitSettings.tsx:198
msgid "Logo caricato"
msgstr "Logo caricato"

#: src/features/settings/components/BrandKitSettings.tsx:475
msgid "Logo caricato — la generazione lo usa su copertine e header."
msgstr "Logo caricato — la generazione lo usa su copertine e header."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:183
msgid "Logo, colori e favicon appaiono solo agli utenti di questa organizzazione."
msgstr "Logo, colori e favicon appaiono solo agli utenti di questa organizzazione."

#: src/features/settings/MarpTemplateSettings.tsx:319
msgid "Look pronti che l'AI applica a documenti, fogli e presentazioni. Sceglili al momento della creazione."
msgstr "Look pronti che l'AI applica a documenti, fogli e presentazioni. Sceglili al momento della creazione."

#: src/features/settings/marp/CssUploadPanel.tsx:175
msgid "Lowercase + trattini. Verrà mostrato nel picker del deck."
msgstr "Lowercase + trattini. Verrà mostrato nel picker del deck."

#: src/features/admin/components/AdminRevenue.tsx:91
msgid "LTV · Lifetime value"
msgstr "LTV · Lifetime value"

#: src/features/admin/components/AdminEngagement.tsx:31
msgid "Lun"
msgstr "Lun"

#: src/features/automations/components/ScheduleEditor.tsx:55
msgid "Lun-Ven alle 9:00"
msgstr "Lun-Ven alle 9:00"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:76
msgid "lunedì"
msgstr "lunedì"

#: src/features/workspace/inbox/hooks/useSnoozeStore.ts:196
msgid "Lunedì (9:00)"
msgstr "Lunedì (9:00)"

#: src/features/connectors/wizards/emailSpec.tsx:93
msgid "Lunghe catene → summary 3-bullet + action items pronti."
msgstr "Lunghe catene → summary 3-bullet + action items pronti."

#: src/features/templates/components/TemplateFieldSpecs.ts:187
msgid "Lunghezza massima frase"
msgstr "Lunghezza massima frase"

#. placeholder {0}: pwd.min_length
#: src/features/admin/components/orgs/OrgSecurityTab.tsx:92
msgid "Lunghezza minima {0} caratteri."
msgstr "Lunghezza minima {0} caratteri."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:166
msgid "Lunghezza minima:"
msgstr "Lunghezza minima:"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:70
msgid "Lunghezza tra 8 e 128 caratteri."
msgstr "Lunghezza tra 8 e 128 caratteri."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:241
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:350
msgid "Luogo"
msgstr "Luogo"

#: src/features/price-lists/components/PriceListsPage.tsx:975
msgid "M6x20, vite esagonale, hex bolt"
msgstr "M6x20, vite esagonale, hex bolt"

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:157
msgid "macOS sta bloccando l'accesso di Ando a questa cartella. Apri Impostazioni di Sistema → Privacy e Sicurezza → File e Cartelle → Ando e abilita la cartella (o sposta la cartella fuori da Download/Documenti/Scrivania)."
msgstr "macOS sta bloccando l'accesso di Ando a questa cartella. Apri Impostazioni di Sistema → Privacy e Sicurezza → File e Cartelle → Ando e abilita la cartella (o sposta la cartella fuori da Download/Documenti/Scrivania)."

#: src/features/admin/components/orgs/OrgDetailShell.tsx:429
msgid "Macro-sezioni"
msgstr "Macro-sezioni"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:44
msgid "mai"
msgstr "mai"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:342
#: src/features/admin/components/hypermem/HmOverviewTab.tsx:257
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
msgid "Mai"
msgstr "Mai"

#: src/features/connectors/components/management/BusinessContextEditor.tsx:136
msgid "Mai aggiornato"
msgstr "Mai aggiornato"

#: src/features/connectors/wizards/messagingSpec.tsx:99
msgid "Mai esposti al modello; minimo scope OAuth richiesto."
msgstr "Mai esposti al modello; minimo scope OAuth richiesto."

#: src/features/connectors/wizards/emailSpec.tsx:102
msgid "Mai inviato senza consenso"
msgstr "Mai inviato senza consenso"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:218
msgid "mai sincronizzato"
msgstr "mai sincronizzato"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:155
msgid "Mai sincronizzato"
msgstr "Mai sincronizzato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1281
msgid "Maiusc+clic aggiunge o toglie, trascina su un'area vuota per selezionare, Cmd+A seleziona tutto, Esc torna a uno. Trascina o usa le frecce per spostare il gruppo."
msgstr "Maiusc+clic aggiunge o toglie, trascina su un'area vuota per selezionare, Cmd+A seleziona tutto, Esc torna a uno. Trascina o usa le frecce per spostare il gruppo."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:38
msgid "Maiuscole (A-Z)"
msgstr "Maiuscole (A-Z)"

#: src/features/dashboard/utils/calculatedFields.ts:80
msgid "MAIUSCOLO"
msgstr "MAIUSCOLO"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:31
msgid "Manca il cliente finale."
msgstr "Manca il cliente finale."

#: src/features/admin/components/AdminCpqPublishChecks.tsx:33
msgid "Manca il titolo interno."
msgstr "Manca il titolo interno."

#: src/features/templates/components/TemplateFieldSpecs.ts:76
#: src/features/templates/components/TemplateFieldSpecs.ts:88
msgid "Manrope"
msgstr "Manrope"

#: src/features/admin/components/AdminCpq.tsx:246
msgid "Mantenimento annuo stimato"
msgstr "Mantenimento annuo stimato"

#: src/features/console/pages/PlaygroundPage.tsx:1942
msgid "Mantiene il contesto tra i turni della conversazione."
msgstr "Mantiene il contesto tra i turni della conversazione."

#: src/features/clean-control/utils/signalCatalog.ts:126
msgid "Mantieni separati"
msgstr "Mantieni separati"

#: src/features/projects/components/sections/AutomationsSection.tsx:93
msgid "manuale"
msgstr "manuale"

#: src/features/clean-control/components/ModeToggle.tsx:57
#: src/features/console/pages/FlowsPage.tsx:116
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:56
#: src/routes/_authed/workspace/flows.index.tsx:75
msgid "Manuale"
msgstr "Manuale"

#: src/features/clean-control/components/CleanControlHub.tsx:79
msgid "Manuale · Automatica · Governance"
msgstr "Manuale · Automatica · Governance"

#: src/features/maintenance/MaintenanceScreen.tsx:197
msgid "Manutenzione"
msgstr "Manutenzione"

#: src/features/admin/components/AdminCpqPriceBook.tsx:302
msgid "Manutenzione % sulle licenze"
msgstr "Manutenzione % sulle licenze"

#: src/features/admin/components/MaintenanceControl.tsx:102
msgid "Manutenzione attiva"
msgstr "Manutenzione attiva"

#: src/features/maintenance/MaintenanceGate.tsx:45
msgid "Manutenzione attiva per gli utenti — tu stai vedendo la piattaforma reale"
msgstr "Manutenzione attiva per gli utenti — tu stai vedendo la piattaforma reale"

#: src/features/admin/components/AdminCpq.tsx:192
msgid "Manutenzione e servizio gestito"
msgstr "Manutenzione e servizio gestito"

#: src/features/admin/components/AdminCpqPriceBook.tsx:303
msgid "Manutenzione minima per ambiente, 1 applicazione (EUR)"
msgstr "Manutenzione minima per ambiente, 1 applicazione (EUR)"

#: src/features/admin/components/AdminHealth.tsx:58
msgid "Manutenzione piattaforma"
msgstr "Manutenzione piattaforma"

#: src/features/admin/components/MaintenanceControl.tsx:104
#: src/features/maintenance/MaintenanceBanner.tsx:99
msgid "Manutenzione programmata"
msgstr "Manutenzione programmata"

#: src/features/console/connectors/CustomConnectorDetail.tsx:681
msgid "Mappa dei campi"
msgstr "Mappa dei campi"

#: src/features/console/connectors/ManifestConfigForm.tsx:207
msgid "Mappa dei campi (nome del campo nella TUA risposta)"
msgstr "Mappa dei campi (nome del campo nella TUA risposta)"

#: src/features/console/pages/SchemaPage.tsx:889
msgid "Mappa della conoscenza non disponibile: mostro l'elenco delle sorgenti. Riprova più tardi."
msgstr "Mappa della conoscenza non disponibile: mostro l'elenco delle sorgenti. Riprova più tardi."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:666
msgid "Mappa della rete"
msgstr "Mappa della rete"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:215
msgid "Mappatura colonne"
msgstr "Mappatura colonne"

#: src/features/admin/components/AdminEngagement.tsx:32
msgid "Mar"
msgstr "Mar"

#: ../../packages/ui/src/ando/sources/banking-tx/BankingActions.tsx:39
msgid "Marca ricorrente"
msgstr "Marca ricorrente"

#: src/features/connectors/wizards/legalStorageSpec.tsx:55
msgid "Marche temporali, firme, indici secondo normativa AgID."
msgstr "Marche temporali, firme, indici secondo normativa AgID."

#: src/features/admin/components/AdminBilling.tsx:239
#: src/features/admin/components/AdminPricingMarkup.tsx:55
msgid "Margine"
msgstr "Margine"

#: src/features/admin/components/AdminCpq.tsx:176
msgid "Margine lordo"
msgstr "Margine lordo"

#: src/features/admin/components/AdminCostTracking.tsx:323
msgid "Margine lordo per tenant"
msgstr "Margine lordo per tenant"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:52
msgid "Margine sotto l'obiettivo del listino: {pct}%."
msgstr "Margine sotto l'obiettivo del listino: {pct}%."

#: src/features/admin/components/AdminCpqPriceBook.tsx:223
msgid "Margine target %"
msgstr "Margine target %"

#: src/features/templates/components/TemplateFieldSpecs.ts:134
msgid "Margini"
msgstr "Margini"

#: src/features/onboarding/DemoBookCallModal.tsx:407
msgid "Mario Rossi"
msgstr "Mario Rossi"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:87
msgid "Marketing"
msgstr "Marketing"

#: src/features/connectors/wizards/crmSpec.tsx:53
msgid "Marketing + CRM hub"
msgstr "Marketing + CRM hub"

#: src/features/admin/components/AdminBilling.tsx:240
#: src/features/admin/components/AdminPricingMarkup.tsx:56
#: src/features/admin/components/orgs/OrgBillingTab.tsx:431
msgid "Markup Engine legacy"
msgstr "Markup Engine legacy"

#. placeholder {0}: res.markup_pct
#: src/features/admin/components/GlobalMarkupCard.tsx:69
msgid "Markup salvato: {0}%"
msgstr "Markup salvato: {0}%"

#: src/features/admin/components/GlobalMarkupCard.tsx:85
msgid "Markup sul costo LLM"
msgstr "Markup sul costo LLM"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:77
msgid "martedì"
msgstr "martedì"

#: src/features/clean-control/utils/signalCatalog.ts:189
msgid "Mascherare"
msgstr "Mascherare"

#: src/features/dxf/components/DxfPreviewStage.tsx:365
msgid "Massimizza anteprima"
msgstr "Massimizza anteprima"

#: src/features/dashboard/utils/calculatedFields.ts:117
#: src/features/dfm-rules/components/DfmRulesPage.tsx:954
msgid "Massimo"
msgstr "Massimo"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:658
msgid "Massimo (≤)"
msgstr "Massimo (≤)"

#: src/features/chat/hooks/useChatAttachments.ts:173
msgid "Massimo {MAX_FILE_COUNT} file per messaggio"
msgstr "Massimo {MAX_FILE_COUNT} file per messaggio"

#: src/features/chat/hooks/useChatAttachments.ts:153
msgid "Massimo {MAX_IMAGE_COUNT} immagini per messaggio"
msgstr "Massimo {MAX_IMAGE_COUNT} immagini per messaggio"

#: src/features/settings/marp/CssUploadPanel.tsx:51
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:46
msgid "Massimo {SLUG_MAX} caratteri"
msgstr "Massimo {SLUG_MAX} caratteri"

#: src/features/admin/components/AdminOrgs.tsx:196
msgid "Massimo 120 caratteri."
msgstr "Massimo 120 caratteri."

#: src/features/voice_report/components/NewReportDialog.tsx:151
msgid "Massimo 200 caratteri"
msgstr "Massimo 200 caratteri"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:750
msgid "Massimo non valido"
msgstr "Massimo non valido"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:202
msgid "Match {pct} percento"
msgstr "Match {pct} percento"

#: src/features/dashboard/utils/calculatedFields.ts:65
msgid "Matematica"
msgstr "Matematica"

#: src/features/price-lists/utils/formatItem.ts:32
msgid "Materia prima"
msgstr "Materia prima"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:603
#: src/features/dfm-rules/components/DfmRulesPage.tsx:59
#: src/features/price-lists/components/PriceListsPage.tsx:957
#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:46
msgid "Materiale"
msgstr "Materiale"

#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:46
msgid "Materiale · {value}"
msgstr "Materiale · {value}"

#: src/features/price-lists/components/PriceListsPage.tsx:690
msgid "Materiale:"
msgstr "Materiale:"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:988
msgid "Materiali (separati da virgola)"
msgstr "Materiali (separati da virgola)"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:604
msgid "Materiali estratti dal title block 2D / XCAFDoc 3D."
msgstr "Materiali estratti dal title block 2D / XCAFDoc 3D."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:508
msgid "Matrice idratata dal BE: lo stato iniziale di ogni cella viene caricato da"
msgstr "Matrice idratata dal BE: lo stato iniziale di ogni cella viene caricato da"

#: src/features/briefing/BriefCard.tsx:128
msgid "Mattina"
msgstr "Mattina"

#: src/features/admin/components/AdminEngagement.tsx:144
msgid "MAU · 30gg"
msgstr "MAU · 30gg"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:145
msgid "Max (€)"
msgstr "Max (€)"

#: src/features/admin/components/AdminCpqPriceBook.tsx:349
msgid "Max (USD)"
msgstr "Max (USD)"

#. placeholder {0}: spec.max
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:383
msgid "Max {0}"
msgstr "Max {0}"

#. placeholder {0}: c.max_metadata_keys
#: src/features/console/connectors/CustomConnectorDetail.tsx:439
msgid "Max {0} chiavi metadata"
msgstr "Max {0} chiavi metadata"

#. placeholder {0}: formatNumber(i18n.locale, c.max_records_per_batch)
#: src/features/console/connectors/CustomConnectorDetail.tsx:436
msgid "Max {0} record/batch"
msgstr "Max {0} record/batch"

#: src/features/admin/components/AdminOrgs.tsx:1205
msgid "Max membri"
msgstr "Max membri"

#: src/features/clean-control/utils/labels.ts:37
msgid "Medi"
msgstr "Medi"

#: src/features/admin/components/AdminCpq.tsx:811
#: src/features/clean-control/components/EventQueue.tsx:87
#: src/features/dashboard/utils/calculatedFields.ts:115
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:39
#: src/features/workspace/components/TaskComposer.tsx:42
msgid "Media"
msgstr "Media"

#: src/features/clean-control/utils/labels.ts:48
msgid "MEDIA"
msgstr "MEDIA"

#: src/features/admin/components/AdminCostTracking.tsx:378
#: src/features/console/lib/connectorActions.ts:29
msgid "Medio"
msgstr "Medio"

#: src/features/admin/components/AdminOrgs.tsx:1392
#: src/features/admin/components/orgs/AddMemberDialog.tsx:210
#: src/features/admin/components/orgs/OrgMembersTab.tsx:458
msgid "Member"
msgstr "Member"

#: src/features/settings/components/OrgMembersPanel.tsx:553
msgid "Member — accesso standard"
msgstr "Member — accesso standard"

#: src/features/admin/components/AdminOrgs.tsx:1026
#: src/features/admin/components/orgs/OrgDetailShell.tsx:163
#: src/features/admin/components/orgs/OrgDetailShell.tsx:390
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:121
#: src/features/console/pages/MembersPage.tsx:477
#: src/features/projects/components/ProjectDetailPage.tsx:276
#: src/features/settings/components/OrganizationSettings.tsx:115
#: src/features/settings/components/OrgMembersPanel.tsx:125
#: src/routes/_authed/workspace/connect.$spaceId.tsx:315
msgid "Membri"
msgstr "Membri"

#: src/features/console/pages/MembersPage.tsx:470
msgid "Membri attivi"
msgstr "Membri attivi"

#: src/features/settings/components/OrgMembersPanel.tsx:162
msgid "Membri dell'organizzazione"
msgstr "Membri dell'organizzazione"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:226
msgid "Membri rimossi"
msgstr "Membri rimossi"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:542
msgid "membri. Vuoi continuare?"
msgstr "membri. Vuoi continuare?"

#: src/features/dashboard/components/ShareChartSheet.tsx:352
#: src/features/dashboard/components/ShareDashboardSheet.tsx:339
#: src/features/settings/components/OrgMembersPanel.tsx:429
msgid "membro"
msgstr "membro"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:438
#: src/features/admin/components/orgs/OrgMembersTab.tsx:315
#: src/features/console/pages/MembersPage.tsx:498
#: src/lib/roles.ts:18
msgid "Membro"
msgstr "Membro"

#: src/features/admin/components/AdminOrgs.tsx:678
#: src/features/admin/components/orgs/AddMemberDialog.tsx:92
msgid "Membro aggiunto"
msgstr "Membro aggiunto"

#: src/features/console/pages/ResourceAccessPage.tsx:732
msgid "Membro da autorizzare"
msgstr "Membro da autorizzare"

#: src/features/console/pages/ResourceAccessPage.tsx:621
msgid "Membro del team"
msgstr "Membro del team"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:100
#: src/features/admin/components/orgs/OrgMembersTab.tsx:191
msgid "Membro riattivato"
msgstr "Membro riattivato"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:174
#: src/features/console/pages/MembersPage.tsx:403
msgid "Membro rimosso"
msgstr "Membro rimosso"

#: src/features/console/pages/MembersPage.tsx:526
msgid "Membro senza nome"
msgstr "Membro senza nome"

#: src/features/admin/components/AdminPlatformSettings.tsx:921
#: src/features/admin/components/hypermem/HmOverviewTab.tsx:269
msgid "Memoria"
msgstr "Memoria"

#: src/features/admin/components/AdminHypermem.tsx:166
msgid "Memoria cognitiva · fatti episodici/semantici · esperimenti · governance proattiva"
msgstr "Memoria cognitiva · fatti episodici/semantici · esperimenti · governance proattiva"

#: src/features/console/pages/PlaygroundPage.tsx:868
msgid "Memoria conversazionale"
msgstr "Memoria conversazionale"

#: src/features/projects/components/ProjectDetailPage.tsx:256
msgid "Memoria del progetto"
msgstr "Memoria del progetto"

#: src/features/projects/components/sections/MemorySection.tsx:166
msgid "Memoria del progetto ora condivisa"
msgstr "Memoria del progetto ora condivisa"

#: src/features/projects/components/sections/MemorySection.tsx:167
msgid "Memoria del progetto ora isolata"
msgstr "Memoria del progetto ora isolata"

#: src/features/account/components/UserMenuButton.tsx:434
#: src/features/settings/components/SelfProfileMemory.tsx:208
msgid "Memoria personale"
msgstr "Memoria personale"

#: src/features/account/components/UserMenuButton.tsx:287
#: src/features/account/components/UserMenuButton.tsx:310
#: src/features/console/components/ConsoleShell.tsx:480
msgid "Menu utente"
msgstr "Menu utente"

#: src/features/help/components/ShortcutsList.tsx:108
msgid "Menziona un file, una persona o un connettore"
msgstr "Menziona un file, una persona o un connettore"

#. placeholder {0}: entry.mention_count
#: src/features/projects/components/sections/MemorySection.tsx:113
msgid "menzionato {0}×"
msgstr "menzionato {0}×"

#: src/features/admin/components/AdminCanvas.tsx:218
msgid "Menzioni"
msgstr "Menzioni"

#: src/features/admin/components/AdminEngagement.tsx:33
msgid "Mer"
msgstr "Mer"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:78
msgid "mercoledì"
msgstr "mercoledì"

#: src/features/templates/components/TemplateFieldSpecs.ts:90
msgid "Merriweather"
msgstr "Merriweather"

#: src/features/dashboard/utils/calculatedFields.ts:91
#: src/features/workspace/config.ts:342
#: src/routes/_authed/workspace/calendar.tsx:410
msgid "Mese"
msgstr "Mese"

#: src/routes/_authed/workspace/calendar.tsx:848
msgid "Mese precedente"
msgstr "Mese precedente"

#: src/routes/_authed/workspace/calendar.tsx:854
msgid "Mese successivo"
msgstr "Mese successivo"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:233
msgid "mesi"
msgstr "mesi"

#: src/features/admin/components/AdminCpqPriceBook.tsx:276
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:298
msgid "Mesi"
msgstr "Mesi"

#: src/features/console/connectors/meta.ts:142
msgid "Messaggi certificati e ricevute delle caselle PEC"
msgstr "Messaggi certificati e ricevute delle caselle PEC"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:486
msgid "Messaggi diretti"
msgstr "Messaggi diretti"

#: src/features/console/connectors/meta.ts:133
msgid "Messaggi e allegati delle caselle autorizzate"
msgstr "Messaggi e allegati delle caselle autorizzate"

#: src/features/console/connectors/meta.ts:115
msgid "Messaggi e canali dei workspace autorizzati"
msgstr "Messaggi e canali dei workspace autorizzati"

#: src/features/workspace/components/InboxItemRow.tsx:292
msgid "messaggio"
msgstr "messaggio"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:123
#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:173
#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:181
#: ../../packages/ui/src/ando/ShareEmailForm.tsx:167
#: src/features/admin/components/AdminGatedLinks.tsx:333
#: src/features/admin/components/deckEditor/DeckEditor.tsx:680
#: src/features/console/pages/DocumentsPage.tsx:314
#: src/features/console/pages/DocumentsPage.tsx:809
msgid "Messaggio"
msgstr "Messaggio"

#: src/features/onboarding/DemoBookCallModal.tsx:435
msgid "Messaggio (opzionale)"
msgstr "Messaggio (opzionale)"

#: src/features/connect/components/ConnectMessageThread.tsx:197
msgid "Messaggio alla discussione"
msgstr "Messaggio alla discussione"

#: ../../packages/ui/src/ando/composer-parts/RichTextEditor.tsx:394
msgid "Messaggio della chat"
msgstr "Messaggio della chat"

#: src/features/connect/components/ConnectMessageThread.tsx:94
msgid "Messaggio non inviato. Riprova."
msgstr "Messaggio non inviato. Riprova."

#: src/routes/_authed/workspace/conversations.tsx:1197
msgid "Messaggio non trovato"
msgstr "Messaggio non trovato"

#: src/features/admin/components/MaintenanceControl.tsx:221
msgid "Messaggio per gli utenti"
msgstr "Messaggio per gli utenti"

#: src/features/chat/components/AudioPlayer.tsx:109
msgid "Messaggio vocale"
msgstr "Messaggio vocale"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:135
msgid "Messaggio vuoto."
msgstr "Messaggio vuoto."

#: src/features/connectors/wizards/messagingSpec.tsx:39
#: src/features/console/connectors/meta.ts:111
msgid "Messaggistica"
msgstr "Messaggistica"

#: src/features/connectors/hooks/useFacebookSDK.ts:77
msgid "Meta App ID is not configured"
msgstr "Meta App ID is not configured"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:296
msgid "Meta confirmed authorization but no setup code arrived. Click the button again — Meta will remember your previous steps, the second flow is faster."
msgstr "Meta confirmed authorization but no setup code arrived. Click the button again — Meta will remember your previous steps, the second flow is faster."

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:139
msgid "Meta consente l'importazione dei 180 giorni di cronologia solo entro 24 ore dalla primissima connessione. Quella finestra si è chiusa per questo numero, quindi non è stato possibile recuperare le chat passate."
msgstr "Meta consente l'importazione dei 180 giorni di cronologia solo entro 24 ore dalla primissima connessione. Quella finestra si è chiusa per questo numero, quindi non è stato possibile recuperare le chat passate."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:524
msgid "Meta Embedded Signup richiede una connessione HTTPS sicura. Le app desktop aprono la pagina di configurazione sicura nel tuo browser predefinito; al termine, torna qui — la tua connessione comparirà automaticamente."
msgstr "Meta Embedded Signup richiede una connessione HTTPS sicura. Le app desktop aprono la pagina di configurazione sicura nel tuo browser predefinito; al termine, torna qui — la tua connessione comparirà automaticamente."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:298
msgid "Meta ha registrato questo numero come Cloud API classica: il numero è stato rimosso dall'app WhatsApp Business sul telefono. La Coesistenza non può essere abilitata in un secondo momento — per usarla, disconnetti, installa l'app WhatsApp Business e utilizzala per almeno 7 giorni, poi riconnetti tramite Embedded Signup."
msgstr "Meta ha registrato questo numero come Cloud API classica: il numero è stato rimosso dall'app WhatsApp Business sul telefono. La Coesistenza non può essere abilitata in un secondo momento — per usarla, disconnetti, installa l'app WhatsApp Business e utilizzala per almeno 7 giorni, poi riconnetti tramite Embedded Signup."

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:62
msgid "Meta sta preparando gli ultimi 180 giorni della tua cronologia chat. I primi messaggi arrivano di solito entro pochi minuti. Tieni aperta l'app WhatsApp Business sul telefono per velocizzare l'operazione."
msgstr "Meta sta preparando gli ultimi 180 giorni della tua cronologia chat. I primi messaggi arrivano di solito entro pochi minuti. Tieni aperta l'app WhatsApp Business sul telefono per velocizzare l'operazione."

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:128
msgid "Metadata"
msgstr "Metadata"

#: src/features/console/connectors/CustomConnectorDetail.tsx:337
msgid "Metadata filtrabili"
msgstr "Metadata filtrabili"

#: src/features/console/pages/TracesPage.tsx:104
msgid "metadati"
msgstr "metadati"

#: src/features/console/pages/TracesPage.tsx:442
msgid "Metadati e relazioni del trace"
msgstr "Metadati e relazioni del trace"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:487
msgid "Metodo"
msgstr "Metodo"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:591
msgid "Metodo di autenticazione"
msgstr "Metodo di autenticazione"

#: src/features/console/pages/BillingPage.tsx:295
#: src/features/console/pages/BillingPage.tsx:298
msgid "Metodo di pagamento"
msgstr "Metodo di pagamento"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:374
msgid "Metodo HTTP"
msgstr "Metodo HTTP"

#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:45
#: src/features/report/components/ComparisonGrid.tsx:86
msgid "Metrica"
msgstr "Metrica"

#: src/routes/_authed/_modal/admin/route.tsx:125
msgid "Metriche"
msgstr "Metriche"

#. placeholder {0}: automation.name
#: src/features/automations/components/AutomationsHub.tsx:381
msgid "Metti in pausa {0}"
msgstr "Metti in pausa {0}"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:82
msgid "MFA"
msgstr "MFA"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:131
msgid "MFA è obbligatorio per i nuovi login."
msgstr "MFA è obbligatorio per i nuovi login."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:132
msgid "MFA è opzionale per i membri."
msgstr "MFA è opzionale per i membri."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:79
msgid "MFA non più obbligatorio."
msgstr "MFA non più obbligatorio."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:78
msgid "MFA obbligatorio per i membri."
msgstr "MFA obbligatorio per i membri."

#: src/features/chat/hooks/useAudioRecorder.ts:76
msgid "Microfono occupato da un'altra app."
msgstr "Microfono occupato da un'altra app."

#: src/routes/_authed/workspace/sales.tsx:112
msgid "Mie"
msgstr "Mie"

#: src/features/workspace/config.ts:420
#: src/features/workspace/config.ts:429
#: src/routes/_authed/workspace/flows.index.tsx:255
msgid "Miei"
msgstr "Miei"

#: src/features/settings/MarpTemplateSettings.tsx:120
msgid "Migliaia di pitch deck business, gratis"
msgstr "Migliaia di pitch deck business, gratis"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:55
msgid "Migliora"
msgstr "Migliora"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:960
msgid "Migliora con l'AI"
msgstr "Migliora con l'AI"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:56
msgid "Migliora la scrittura mantenendo il significato."
msgstr "Migliora la scrittura mantenendo il significato."

#: src/routes/_authed/_modal/settings/changelog.tsx:89
msgid "Miglioramento"
msgstr "Miglioramento"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:225
msgid "Migra"
msgstr "Migra"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:201
msgid "Migra anche i dati"
msgstr "Migra anche i dati"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:147
msgid "Migra utente"
msgstr "Migra utente"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:127
msgid "Migrazione fallita"
msgstr "Migrazione fallita"

#: src/features/admin/components/AdminOrgs.tsx:500
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:92
msgid "Migrazione parziale"
msgstr "Migrazione parziale"

#. placeholder {0}: partialResult.failed_users.length
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:137
msgid "Migrazione parziale ({0} errore)"
msgstr "Migrazione parziale ({0} errore)"

#. placeholder {0}: partialResult.failed_users.length
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:140
msgid "Migrazione parziale ({0} errori)"
msgstr "Migrazione parziale ({0} errori)"

#: src/features/admin/components/AdminEngagement.tsx:163
msgid "milestone valore profondo"
msgstr "milestone valore profondo"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:129
msgid "Min (€)"
msgstr "Min (€)"

#: src/features/admin/components/AdminCpqPriceBook.tsx:347
msgid "Min (USD)"
msgstr "Min (USD)"

#. placeholder {0}: spec.min
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:382
msgid "Min {0}"
msgstr "Min {0}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:491
msgid "Miniature delle slide"
msgstr "Miniature delle slide"

#: src/features/dashboard/utils/calculatedFields.ts:116
#: src/features/dfm-rules/components/DfmRulesPage.tsx:940
msgid "Minimo"
msgstr "Minimo"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:657
msgid "Minimo (≥)"
msgstr "Minimo (≥)"

#: src/features/console/connectors/ManifestConfigForm.tsx:330
msgid "Minimo {MANIFEST_MIN_INTERVAL_MINUTES} minuti; default 60."
msgstr "Minimo {MANIFEST_MIN_INTERVAL_MINUTES} minuti; default 60."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:741
msgid "Minimo non valido"
msgstr "Minimo non valido"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:39
msgid "Minuscole (a-z)"
msgstr "Minuscole (a-z)"

#: src/features/dashboard/utils/calculatedFields.ts:81
msgid "minuscolo"
msgstr "minuscolo"

#: src/features/actions/components/EmailTemplatePicker.tsx:78
#: src/features/sales/components/BatchSendModal.tsx:312
msgid "Mio · "
msgstr "Mio · "

#: src/features/console/pages/OverviewPage.tsx:399
msgid "Mio account"
msgstr "Mio account"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:222
#: src/features/settings/MarpTemplateSettings.tsx:233
msgid "Misti"
msgstr "Misti"

#: src/features/console/pages/ConnectorDetailPage.tsx:65
msgid "Misto"
msgstr "Misto"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:227
msgid "Misura"
msgstr "Misura"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:438
#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:456
msgid "Mittente"
msgstr "Mittente"

#: src/features/admin/components/AdminCpq.tsx:913
msgid "Mittente delle email"
msgstr "Mittente delle email"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:441
msgid "Mittente non disponibile"
msgstr "Mittente non disponibile"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:337
msgid "Mittente non disponibile. Seleziona un account."
msgstr "Mittente non disponibile. Seleziona un account."

#: src/features/sources/components/InboxDetailPane.tsx:1289
msgid "Mittente sconosciuto"
msgstr "Mittente sconosciuto"

#: src/features/admin/components/AdminCpqPriceBook.tsx:200
msgid "Mittenti (uno per riga: Nome <indirizzo>)"
msgstr "Mittenti (uno per riga: Nome <indirizzo>)"

#: src/features/admin/components/AdminCpq.tsx:731
#: src/features/clean-control/components/policies/PolicyForm.tsx:324
#: src/features/connect/components/CreateSpaceDialog.tsx:168
#: src/features/console/pages/PlaygroundPage.tsx:2012
#: src/features/console/pages/PlaygroundPage.tsx:2014
msgid "Modalità"
msgstr "Modalità"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:254
msgid "Modalità Analisi CAD"
msgstr "Modalità Analisi CAD"

#: src/features/clean-control/components/ModeToggle.tsx:47
msgid "Modalità Clean & Control"
msgstr "Modalità Clean & Control"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:189
msgid "Modalità deck"
msgstr "Modalità deck"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:515
msgid "Modalità deck Marp"
msgstr "Modalità deck Marp"

#: src/features/agent-modes/components/AgentModeEditor.tsx:391
msgid "Modalità default"
msgstr "Modalità default"

#: src/features/console/pages/FlowDetailPage.tsx:192
#: src/routes/_authed/workspace/flows.$flowId.tsx:399
msgid "Modalità del flow"
msgstr "Modalità del flow"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:305
msgid "Modalità demo: le connessioni e i test sono simulati."
msgstr "Modalità demo: le connessioni e i test sono simulati."

#: src/features/dashboard/components/ShareChartSheet.tsx:106
#: src/features/dashboard/components/ShareDashboardSheet.tsx:99
#: src/features/share/components/ShareLinkDialog.tsx:265
msgid "Modalità di condivisione"
msgstr "Modalità di condivisione"

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:84
msgid "Modalità di connessione"
msgstr "Modalità di connessione"

#: src/features/admin/components/AdminCpqPriceBook.tsx:294
msgid "Modalità di deploy"
msgstr "Modalità di deploy"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:153
msgid "Modalità di fatturazione"
msgstr "Modalità di fatturazione"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:65
msgid "Modalità di focus"
msgstr "Modalità di focus"

#: src/features/workspace/documents/components/GroupingModeToggle.tsx:60
msgid "Modalità di raggruppamento"
msgstr "Modalità di raggruppamento"

#: src/features/workspace/inbox/components/InboxGroupingToggle.tsx:56
msgid "Modalità di raggruppamento conversazioni"
msgstr "Modalità di raggruppamento conversazioni"

#: src/features/admin/components/UserDetailContent.tsx:841
msgid "Modalità Ispezione attiva"
msgstr "Modalità Ispezione attiva"

#. placeholder {0}: String(s).padStart(2, "0")
#: src/features/admin/components/UserDetailContent.tsx:210
msgid "Modalità Ispezione PII attiva · scade tra <0>{m}m {0}s</0>"
msgstr "Modalità Ispezione PII attiva · scade tra <0>{m}m {0}s</0>"

#: src/features/chat/components/LayoutSwitcher.tsx:90
msgid "Modalità layout"
msgstr "Modalità layout"

#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:164
msgid "Modalità proposta"
msgstr "Modalità proposta"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:287
msgid "Modalità selezione attiva"
msgstr "Modalità selezione attiva"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1151
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1283
msgid "Modalità SSL"
msgstr "Modalità SSL"

#: src/features/dxf/components/DxfPreviewStage.tsx:327
msgid "Modalità visualizzazione"
msgstr "Modalità visualizzazione"

#: src/features/console/pages/BillingPage.tsx:139
msgid "Modalità wallet aggiornata"
msgstr "Modalità wallet aggiornata"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:92
msgid "Modalità WhatsApp aggiornata"
msgstr "Modalità WhatsApp aggiornata"

#: src/features/clean-control/components/EventRow.tsx:535
msgid "Modalità:"
msgstr "Modalità:"

#: src/features/console/docs/content.ts:331
msgid "mode=retrieve → chunk con score + citazioni; mode=answer → risposta sintetizzata. k 1..50 (default 10). filters, include_web e verify restringono/arricchiscono; la resource policy della chiave vince sempre."
msgstr "mode=retrieve → chunk con score + citazioni; mode=answer → risposta sintetizzata. k 1..50 (default 10). filters, include_web e verify restringono/arricchiscono; la resource policy della chiave vince sempre."

#: src/features/console/docs/content.ts:171
msgid "mode=retrieve restituisce i chunk rilevanti con score e citazioni (fai tu la generazione). mode=answer sintetizza una risposta ancorata, rispecchiando la lingua della domanda; se non trova nulla, answer è null e no_results è true."
msgstr "mode=retrieve restituisce i chunk rilevanti con score e citazioni (fai tu la generazione). mode=answer sintetizza una risposta ancorata, rispecchiando la lingua della domanda; se non trova nulla, answer è null e no_results è true."

#: src/features/admin/components/AdminCostTracking.tsx:296
#: src/features/admin/components/AdminOverview.tsx:126
msgid "Model mix nel tempo"
msgstr "Model mix nel tempo"

#: src/features/admin/components/AdminPlatformSettings.tsx:1151
#: src/features/admin/components/CostTraceDetailSection.tsx:155
#: src/features/console/components/ConsoleShell.tsx:225
#: src/features/console/pages/ModelsPage.tsx:377
msgid "Modelli"
msgstr "Modelli"

#: src/features/console/docs/content.ts:1314
msgid "Modelli (per-purpose, BYOK)"
msgstr "Modelli (per-purpose, BYOK)"

#: src/features/admin/components/AdminBilling.tsx:148
#: src/features/admin/components/AdminBilling.tsx:249
msgid "Modelli & Piani"
msgstr "Modelli & Piani"

#: src/features/workspace/config.ts:399
#: src/routes/_authed/workspace/technical.tsx:246
msgid "Modelli 3D"
msgstr "Modelli 3D"

#: src/features/console/connectors/meta.ts:169
msgid "Modelli CAD e risultati di analisi"
msgstr "Modelli CAD e risultati di analisi"

#: src/features/console/pages/ModelsPage.tsx:345
msgid "Modelli e account AI"
msgstr "Modelli e account AI"

#: src/features/console/pages/UsagePage.tsx:476
msgid "Modelli e scopi nella finestra selezionata."
msgstr "Modelli e scopi nella finestra selezionata."

#: src/features/sales/components/TemplateManager.tsx:169
msgid "Modelli email"
msgstr "Modelli email"

#: src/features/sales/components/EmailLibrarySettings.tsx:23
msgid "Modelli email (org + personali) e firma usati nelle email a freddo e standard."
msgstr "Modelli email (org + personali) e firma usati nelle email a freddo e standard."

#: src/features/admin/components/AdminPlatformSettings.tsx:1128
msgid "Modelli LLM · tier piani usage"
msgstr "Modelli LLM · tier piani usage"

#: src/features/console/components/ModelPickerModal.tsx:247
msgid "Modelli per {purposeLabel}"
msgstr "Modelli per {purposeLabel}"

#: src/features/admin/components/AdminPlatformSettings.tsx:960
msgid "Modelli salvati"
msgstr "Modelli salvati"

#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:330
msgid "modello"
msgstr "modello"

#: src/features/actions/components/EmailTemplatePicker.tsx:65
#: src/features/admin/components/AdminPlatformSettings.tsx:220
msgid "Modello"
msgstr "Modello"

#: src/features/sales/components/BatchSendModal.tsx:293
msgid "Modello (a freddo)"
msgstr "Modello (a freddo)"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:195
msgid "Modello di fatturazione aggiornato"
msgstr "Modello di fatturazione aggiornato"

#: src/features/sales/components/TemplateManager.tsx:156
msgid "Modello eliminato"
msgstr "Modello eliminato"

#. placeholder {0}: slot.label
#: src/features/admin/components/AdminPlatformSettings.tsx:1090
msgid "Modello per {0}"
msgstr "Modello per {0}"

#: src/features/sales/components/TemplateManager.tsx:144
msgid "Modello salvato"
msgstr "Modello salvato"

#: src/features/admin/components/AdminBilling.tsx:232
#: src/features/admin/components/AdminPricingMarkup.tsx:48
msgid "Models"
msgstr "Models"

#: src/features/studio/components/StudioDrawerContent.tsx:70
msgid "Modes"
msgstr "Modes"

#: src/features/studio/components/StudioDrawerContent.tsx:331
msgid "Modes del team"
msgstr "Modes del team"

#: src/features/studio/components/StudioDrawerContent.tsx:377
msgid "Modes non disponibili sul tuo piano."
msgstr "Modes non disponibili sul tuo piano."

#: src/features/account/components/UserMenuButton.tsx:419
#: src/features/agent-modes/components/AgentModesList.tsx:98
#: src/features/agent-modes/components/AgentModesList.tsx:178
msgid "Modi agente"
msgstr "Modi agente"

#: src/features/agent-modes/components/AgentModesList.tsx:110
msgid "Modi agente non disponibili sul tuo piano"
msgstr "Modi agente non disponibili sul tuo piano"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:233
#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:414
#: src/features/sources/components/AISummaryPanel.tsx:296
msgid "modifica"
msgstr "modifica"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:786
#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:114
#: ../../packages/ui/src/ando/MessageToolbar.tsx:63
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:407
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:412
#: src/features/admin/components/orgs/OrgDetailShell.tsx:355
#: src/features/clean-control/components/policies/PolicyRow.tsx:168
#: src/features/console/pages/FlowDetailPage.tsx:186
#: src/features/console/pages/KeyDetailPage.tsx:372
#: src/features/console/pages/KeyDetailPage.tsx:447
#: src/features/console/pages/SchemaPage.tsx:280
#: src/features/dashboard/components/ReceivedDashboardsList.tsx:97
#: src/features/dashboard/components/ShareChartSheet.tsx:312
#: src/features/dashboard/components/ShareChartSheet.tsx:379
#: src/features/dashboard/components/ShareDashboardSheet.tsx:299
#: src/features/dashboard/components/ShareDashboardSheet.tsx:366
#: src/features/help/components/ShortcutsList.tsx:46
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:173
#: src/features/hive-flows/run/ProposalReview.tsx:779
#: src/features/sales/components/ActivityTimeline.tsx:275
#: src/features/sales/components/SignaturesManager.tsx:212
#: src/features/skills/components/SkillsList.tsx:427
#: src/features/templates/components/TemplatesList.tsx:281
#: src/routes/_authed/workspace/flows.$flowId.tsx:393
msgid "Modifica"
msgstr "Modifica"

#. placeholder {0}: column.label
#. placeholder {0}: mode.name
#. placeholder {0}: sig.name
#: ../../packages/ui/src/ando/EditableTable.tsx:443
#: src/features/agent-modes/components/AgentModesList.tsx:401
#: src/features/agent-modes/components/AgentModesList.tsx:423
#: src/features/sales/components/SignaturesManager.tsx:211
#: src/features/sales/components/TemplateManager.tsx:207
#: src/features/settings/components/PresentationTemplates.tsx:543
#: src/features/templates/components/TemplatesList.tsx:233
msgid "Modifica {0}"
msgstr "Modifica {0}"

#. placeholder {0}: d.filename
#: src/features/chat/components/ConversationCommandPalette.tsx:243
msgid "modifica {0}: "
msgstr "modifica {0}: "

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:302
msgid "Modifica {display}"
msgstr "Modifica {display}"

#: ../../packages/ui/src/editors/AiCellPopover.tsx:99
msgid "Modifica AI"
msgstr "Modifica AI"

#: ../../packages/ui/src/editors/RegionEditPill.tsx:184
msgid "Modifica AI della selezione"
msgstr "Modifica AI della selezione"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:182
msgid "Modifica AI fallita: {errMsg}"
msgstr "Modifica AI fallita: {errMsg}"

#: ../../packages/ui/src/editors/AiCellPopover.tsx:83
msgid "Modifica AI proposta"
msgstr "Modifica AI proposta"

#: ../../packages/ui/src/editors/AiCellPopover.tsx:82
msgid "Modifica AI proposta sulla cella {cellLabel}"
msgstr "Modifica AI proposta sulla cella {cellLabel}"

#: src/features/dashboard/components/ChartActionsMenu.tsx:201
msgid "Modifica assi"
msgstr "Modifica assi"

#: src/routes/_authed/workspace/dashboard.tsx:906
msgid "Modifica attiva"
msgstr "Modifica attiva"

#: src/features/automations/components/CreateAutomationDialog.tsx:157
msgid "Modifica automazione"
msgstr "Modifica automazione"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:222
#: src/features/dashboard/components/ChartActionsMenu.tsx:190
msgid "Modifica calcoli"
msgstr "Modifica calcoli"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:420
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:421
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:425
msgid "Modifica con AI"
msgstr "Modifica con AI"

#: src/features/sources/components/ArtifactPane.tsx:258
msgid "Modifica con AI il deck \"{name}\": "
msgstr "Modifica con AI il deck \"{name}\": "

#: ../../packages/ui/src/editors/RegionEditPill.tsx:196
msgid "Modifica con Ando"
msgstr "Modifica con Ando"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:797
msgid "Modifica con Ando — {heading}"
msgstr "Modifica con Ando — {heading}"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:774
msgid "Modifica con Ando la sezione: {heading}"
msgstr "Modifica con Ando la sezione: {heading}"

#: src/features/connectors/components/management/EditConnectorDialog.tsx:219
#: src/features/connectors/components/management/EditConnectorDialog.tsx:230
msgid "Modifica connessione"
msgstr "Modifica connessione"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:266
msgid "Modifica contesto"
msgstr "Modifica contesto"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:244
msgid "Modifica credenziali"
msgstr "Modifica credenziali"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:227
msgid "Modifica documento"
msgstr "Modifica documento"

#: src/features/admin/components/AdminDemoInviti.tsx:285
#: src/features/admin/components/AdminDemoInviti.tsx:415
msgid "Modifica durata"
msgstr "Modifica durata"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:331
msgid "Modifica e salva come bozza"
msgstr "Modifica e salva come bozza"

#: src/features/sales/components/SignaturesManager.tsx:238
msgid "Modifica firma"
msgstr "Modifica firma"

#: src/features/console/pages/KeyDetailPage.tsx:151
msgid "Modifica gli scope"
msgstr "Modifica gli scope"

#: src/features/admin/components/AdminOrgs.tsx:985
msgid "Modifica i filtri per vedere più risultati."
msgstr "Modifica i filtri per vedere più risultati."

#: src/features/console/pages/TracesPage.tsx:382
msgid "Modifica i filtri. Un elenco vuoto non dimostra una perdita di contesto."
msgstr "Modifica i filtri. Un elenco vuoto non dimostra una perdita di contesto."

#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:186
msgid "Modifica il contenuto proposto"
msgstr "Modifica il contenuto proposto"

#: src/features/dashboard/components/ShareChartSheet.tsx:313
msgid "Modifica il grafico"
msgstr "Modifica il grafico"

#: src/features/console/pages/KeyDetailPage.tsx:274
msgid "Modifica il limite di spesa"
msgstr "Modifica il limite di spesa"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:245
msgid "Modifica in-place: il file originale verrà aggiornato. Per creare una copia, chiedi a Ando di farti una \"versione\" del documento."
msgstr "Modifica in-place: il file originale verrà aggiornato. Per creare una copia, chiedi a Ando di farti una \"versione\" del documento."

#: src/features/dashboard/components/DashboardToolbar.tsx:104
msgid "Modifica layout"
msgstr "Modifica layout"

#: src/features/dashboard/components/DashboardToolbar.tsx:88
msgid "Modifica layout dashboard"
msgstr "Modifica layout dashboard"

#: src/features/dashboard/components/ShareDashboardSheet.tsx:300
msgid "Modifica layout e grafici"
msgstr "Modifica layout e grafici"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:892
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:893
msgid "Modifica link"
msgstr "Modifica link"

#: src/features/console/connectors/CustomConnectorDetail.tsx:857
#: src/features/console/connectors/CustomConnectorDetail.tsx:991
msgid "Modifica manifest"
msgstr "Modifica manifest"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:408
msgid "Modifica manuale (blocchi)"
msgstr "Modifica manuale (blocchi)"

#: src/features/sources/marp/ManualDeckEditMount.tsx:148
msgid "Modifica manuale del deck"
msgstr "Modifica manuale del deck"

#: src/features/sources/components/GoogleChatMessageEditor.tsx:33
msgid "Modifica messaggio"
msgstr "Modifica messaggio"

#: src/features/sales/components/TemplateManager.tsx:245
msgid "Modifica modello"
msgstr "Modifica modello"

#: src/features/agent-modes/components/AgentModeEditor.tsx:299
#: src/features/agent-modes/components/AgentModeEditor.tsx:302
msgid "Modifica modo"
msgstr "Modifica modo"

#: src/features/settings/marp/PptxExtractPanel.tsx:212
msgid "Modifica nome e salva"
msgstr "Modifica nome e salva"

#: src/features/sales/components/ActivityTimeline.tsx:211
#: src/features/sales/hooks/useCrmQueries.ts:254
msgid "Modifica non riuscita"
msgstr "Modifica non riuscita"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:96
msgid "Modifica non salvata"
msgstr "Modifica non salvata"

#: src/features/console/connectors/TestConnectorActionModal.tsx:164
msgid "Modifica parametri"
msgstr "Modifica parametri"

#: src/features/clean-control/components/policies/PolicyForm.tsx:165
#: src/features/clean-control/components/policies/PolicyForm.tsx:173
msgid "Modifica policy"
msgstr "Modifica policy"

#: src/features/hive-flows/run/ProposalReview.tsx:789
msgid "Modifica proposta"
msgstr "Modifica proposta"

#: src/features/sources/components/ArtifactPane.tsx:244
msgid "Modifica proposta — rivedila nel pannello a destra"
msgstr "Modifica proposta — rivedila nel pannello a destra"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:588
#: src/features/dfm-rules/components/DfmRulesPage.tsx:589
#: src/features/dfm-rules/components/DfmRulesPage.tsx:817
msgid "Modifica regola"
msgstr "Modifica regola"

#: src/features/skills/components/SkillEditor.tsx:246
#: src/features/skills/components/SkillEditor.tsx:250
msgid "Modifica skill"
msgstr "Modifica skill"

#: ../../packages/ui/src/ando/sources/db-row/DBActions.tsx:25
#: src/features/dashboard/components/ChartActionsMenu.tsx:171
msgid "Modifica SQL"
msgstr "Modifica SQL"

#: src/features/settings/components/PresentationTemplates.tsx:721
#: src/features/settings/components/PresentationTemplates.tsx:729
msgid "Modifica template"
msgstr "Modifica template"

#: src/features/admin/components/AdminCpqCanvas.tsx:299
msgid "Modifica tutti i testi nella scheda Proposta"
msgstr "Modifica tutti i testi nella scheda Proposta"

#: src/features/price-lists/components/PriceListsPage.tsx:730
#: src/features/price-lists/components/PriceListsPage.tsx:731
#: src/features/price-lists/components/PriceListsPage.tsx:863
msgid "Modifica voce"
msgstr "Modifica voce"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1328
msgid "Modifica: da {beforeText} a {afterText}"
msgstr "Modifica: da {beforeText} a {afterText}"

#: src/features/admin/components/AdminDecksAskAndo.tsx:192
msgid "Modificata"
msgstr "Modificata"

#. placeholder {0}: fmtDateTime(deck.changed_at)
#: src/features/admin/components/AdminDecks.tsx:246
msgid "modificata {0}"
msgstr "modificata {0}"

#: src/features/chat/components/ChatEmptyState.tsx:217
msgid "Modificati questa settimana"
msgstr "Modificati questa settimana"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:130
msgid "modificato"
msgstr "modificato"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:92
#: src/features/console/pages/SchemaPage.tsx:269
#: src/features/sync/components/DocSyncManager.tsx:1193
#: src/features/sync/components/DocSyncManager.tsx:1276
msgid "Modificato"
msgstr "Modificato"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:234
#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:415
msgid "modifiche"
msgstr "modifiche"

#: src/features/sources/components/AISummaryPanel.tsx:479
msgid "Modifiche"
msgstr "Modifiche"

#: src/features/sources/components/ArtifactPane.tsx:657
msgid "Modifiche applicate"
msgstr "Modifiche applicate"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:184
msgid "Modifiche applicate al membro."
msgstr "Modifiche applicate al membro."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:135
msgid "Modifiche applicate."
msgstr "Modifiche applicate."

#: src/features/actions/components/MessageActionChips.tsx:127
msgid "Modifiche da rivedere"
msgstr "Modifiche da rivedere"

#: src/features/admin/components/AdminCpqCanvas.tsx:230
msgid "Modifiche di Ando evidenziate"
msgstr "Modifiche di Ando evidenziate"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:86
msgid "Modifiche locali in attesa di conferma."
msgstr "Modifiche locali in attesa di conferma."

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:566
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:401
#: ../../packages/ui/src/editors/XlsxEditorInline.tsx:984
#: src/features/admin/components/deckEditor/DeckEditor.tsx:450
#: src/features/admin/components/GlobalMarkupCard.tsx:142
#: src/features/console/pages/ResourceAccessPage.tsx:936
#: src/features/dashboard/components/AddWidgetWizard.tsx:374
#: src/features/templates/components/TemplateEditor.tsx:418
msgid "Modifiche non salvate"
msgstr "Modifiche non salvate"

#: src/features/admin/components/AdminCpqAskAndo.tsx:304
#: src/features/admin/components/AdminDecksAskAndo.tsx:171
msgid "Modifiche proposte"
msgstr "Modifiche proposte"

#: src/features/admin/components/AdminPlatformSettings.tsx:682
msgid "Modifiche salvate automaticamente al blur del campo. Per cambi massivi usa l'API admin direttamente."
msgstr "Modifiche salvate automaticamente al blur del campo. Per cambi massivi usa l'API admin direttamente."

#: src/features/sources/components/ArtifactPane.tsx:416
msgid "Modifiche salvate solo localmente"
msgstr "Modifiche salvate solo localmente"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:459
msgid "Modifiche scartate. Cmd+Z per recuperarle."
msgstr "Modifiche scartate. Cmd+Z per recuperarle."

#: src/features/console/connectors/CustomConnectorDetail.tsx:139
msgid "Modo"
msgstr "Modo"

#: src/features/projects/components/sections/PersonaSection.tsx:196
msgid "Modo agente"
msgstr "Modo agente"

#: src/features/projects/components/sections/PersonaSection.tsx:207
msgid "Modo agente per il progetto"
msgstr "Modo agente per il progetto"

#: src/routes/forms.$flowId.tsx:71
msgid "Modulo"
msgstr "Modulo"

#: src/features/hive-flows/components/FlowFormPublish.tsx:88
msgid "Modulo pubblicato"
msgstr "Modulo pubblicato"

#: src/features/hive-flows/components/FlowFormPublish.tsx:121
msgid "Modulo pubblicato! Condividi questo link — ogni invio avvia il flow:"
msgstr "Modulo pubblicato! Condividi questo link — ogni invio avvia il flow:"

#: src/features/dashboard/utils/calculatedFields.ts:69
msgid "Moltiplicazione (×)"
msgstr "Moltiplicazione (×)"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:517
#: src/features/console/pages/FlowsPage.tsx:328
msgid "Mostra"
msgstr "Mostra"

#. placeholder {0}: pieRemainder.length
#: ../../packages/ui/src/charts/Chart.tsx:264
msgid "Mostra {0} categorie raggruppate in “Altri”"
msgstr "Mostra {0} categorie raggruppate in “Altri”"

#: src/features/dashboard/components/AxisConfigurator.tsx:277
msgid "Mostra {column}"
msgstr "Mostra {column}"

#: src/features/hive-flows/components/NodeInspector.tsx:535
msgid "Mostra {hiddenAdvancedCount} impostazioni avanzate"
msgstr "Mostra {hiddenAdvancedCount} impostazioni avanzate"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:120
msgid "Mostra {hiddenCount} righe identiche"
msgstr "Mostra {hiddenCount} righe identiche"

#. placeholder {0}: remaining.toLocaleString("it-IT")
#: ../../packages/ui/src/cad/CadLayerList.tsx:121
msgid "Mostra altri {0}"
msgstr "Mostra altri {0}"

#: src/routes/_authed/workspace/canvases.tsx:329
msgid "Mostra altri {hiddenCount} →"
msgstr "Mostra altri {hiddenCount} →"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:91
msgid "Mostra anche i deploy alternativi"
msgstr "Mostra anche i deploy alternativi"

#: src/features/sources/components/EmailThreadMessages.tsx:713
msgid "Mostra contenuto citato ({lineCount} riga)"
msgstr "Mostra contenuto citato ({lineCount} riga)"

#: src/features/sources/components/EmailThreadMessages.tsx:714
msgid "Mostra contenuto citato ({lineCount} righe)"
msgstr "Mostra contenuto citato ({lineCount} righe)"

#: src/features/sources/components/ArtifactPane.tsx:2118
#: src/features/sources/components/ArtifactPane.tsx:2119
msgid "Mostra dettagli"
msgstr "Mostra dettagli"

#: src/features/report/components/ConfidenceMeter.tsx:86
msgid "Mostra dettagli sul calcolo"
msgstr "Mostra dettagli sul calcolo"

#: src/features/voice_report/components/RunDiffTimeline.tsx:170
msgid "Mostra differenze"
msgstr "Mostra differenze"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:217
msgid "Mostra disabilitati"
msgstr "Mostra disabilitati"

#: src/features/sources/components/EmailThreadMessages.tsx:637
msgid "Mostra firma"
msgstr "Mostra firma"

#: src/routes/_authed/route.tsx:1101
msgid "Mostra i comandi disponibili"
msgstr "Mostra i comandi disponibili"

#: src/features/console/pages/PlaygroundPage.tsx:1926
msgid "Mostra i dettagli della scelta delle fonti e della ricerca."
msgstr "Mostra i dettagli della scelta delle fonti e della ricerca."

#: src/features/admin/components/orgs/OrgCostTab.tsx:217
msgid "Mostra identità"
msgstr "Mostra identità"

#: src/features/settings/components/BrandKitSettings.tsx:413
msgid "Mostra il numero nel footer"
msgstr "Mostra il numero nel footer"

#: src/features/sources/components/EmailThreadMessages.tsx:549
msgid "Mostra immagini esterne"
msgstr "Mostra immagini esterne"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2470
msgid "Mostra intera (senza ritaglio)"
msgstr "Mostra intera (senza ritaglio)"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:352
msgid "Mostra JSON"
msgstr "Mostra JSON"

#: src/features/console/docs/content.ts:1481
msgid "Mostra l'ultima riuscita, la prossima esecuzione e l'eventuale errore."
msgstr "Mostra l'ultima riuscita, la prossima esecuzione e l'eventuale errore."

#: src/features/console/components/ByokModal.tsx:146
msgid "Mostra la chiave"
msgstr "Mostra la chiave"

#: src/features/console/pages/DevelopersPage.tsx:142
msgid "Mostra la configurazione MCP da aggiungere a Claude Desktop."
msgstr "Mostra la configurazione MCP da aggiungere a Claude Desktop."

#: src/features/console/docs/content.ts:1439
msgid "Mostra le cartelle e i file scelti per questo account. Una nuova connessione parte senza selezione."
msgstr "Mostra le cartelle e i file scelti per questo account. Una nuova connessione parte senza selezione."

#: src/features/dashboard/components/AxisConfigurator.tsx:420
#: src/features/dashboard/components/AxisConfigurator.tsx:425
msgid "Mostra legenda"
msgstr "Mostra legenda"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:328
#: src/features/connectors/components/management/BusinessContextBanner.tsx:352
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:89
#: src/routes/_authed/workspace/canvases.tsx:328
msgid "Mostra meno"
msgstr "Mostra meno"

#: src/features/admin/components/ZitadelPasswordActions.tsx:226
#: src/features/auth/desktop/DesktopLoginForm.tsx:748
#: src/features/connectors/components/management/EditConnectorDialog.tsx:331
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:806
msgid "Mostra password"
msgstr "Mostra password"

#: src/features/help/components/ShortcutsList.tsx:66
msgid "Mostra questi tasti rapidi"
msgstr "Mostra questi tasti rapidi"

#: src/features/help/components/ShortcutsList.tsx:71
msgid "Mostra questi tasti rapidi (alternativa)"
msgstr "Mostra questi tasti rapidi (alternativa)"

#: src/routes/_authed/route.tsx:1134
msgid "mostra questo elenco"
msgstr "mostra questo elenco"

#: src/features/clean-control/components/policies/PolicyRow.tsx:216
msgid "Mostra salute segnale"
msgstr "Mostra salute segnale"

#: src/features/console/docs/content.ts:1613
msgid "Mostra se l'account attende, indicizza, riconcilia, riprova dopo un errore o è aggiornato. Include l'ultimo completamento e il prossimo tentativo; non espone i cursori del provider."
msgstr "Mostra se l'account attende, indicizza, riconcilia, riprova dopo un errore o è aggiornato. Include l'ultimo completamento e il prossimo tentativo; non espone i cursori del provider."

#. placeholder {0}: approvals.length
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:89
msgid "Mostra tutte ({0})"
msgstr "Mostra tutte ({0})"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:286
#: src/routes/_authed/workspace/conversations.tsx:1069
msgid "Mostra tutti"
msgstr "Mostra tutti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:613
msgid "Mostra tutti gli utenti"
msgstr "Mostra tutti gli utenti"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:333
#: src/features/connectors/components/management/BusinessContextBanner.tsx:352
msgid "Mostra tutto"
msgstr "Mostra tutto"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2145
msgid "Mostra valori"
msgstr "Mostra valori"

#: src/routes/_authed/workspace/finance.tsx:1790
msgid "Mostrami gli F24 in scadenza nei prossimi 30 giorni dal Cassetto Fiscale con tributo, importo e data."
msgstr "Mostrami gli F24 in scadenza nei prossimi 30 giorni dal Cassetto Fiscale con tributo, importo e data."

#: src/features/chat/components/ChatEmptyState.tsx:494
msgid "Mostrami i 5 clienti con più fatturato"
msgstr "Mostrami i 5 clienti con più fatturato"

#: src/features/chat/components/ChatEmptyState.tsx:322
msgid "Mostrami i canvas su cui ho lavorato di recente."
msgstr "Mostrami i canvas su cui ho lavorato di recente."

#: src/routes/_authed/workspace/finance.tsx:1590
msgid "Mostrami i pagamenti ricorrenti degli ultimi 3 mesi raggruppati per fornitore."
msgstr "Mostrami i pagamenti ricorrenti degli ultimi 3 mesi raggruppati per fornitore."

#: src/features/chat/components/ChatEmptyState.tsx:340
msgid "Mostrami i template canvas disponibili."
msgstr "Mostrami i template canvas disponibili."

#: src/routes/_authed/workspace/finance.tsx:1602
msgid "Mostrami le entrate più grandi delle ultime 4 settimane raggruppate per cliente."
msgstr "Mostrami le entrate più grandi delle ultime 4 settimane raggruppate per cliente."

#: src/routes/_authed/workspace/finance.tsx:1712
msgid "Mostrami le fatture attive in scadenza nei prossimi 7 giorni con importo e cliente."
msgstr "Mostrami le fatture attive in scadenza nei prossimi 7 giorni con importo e cliente."

#: src/features/chat/components/ChatEmptyState.tsx:172
msgid "Mostrami le fatture scadute da incassare."
msgstr "Mostrami le fatture scadute da incassare."

#: src/routes/_authed/workspace/finance.tsx:1718
msgid "Mostrami le opportunità Salesforce in chiusura nei prossimi 30 giorni con importo, stage e probabilità."
msgstr "Mostrami le opportunità Salesforce in chiusura nei prossimi 30 giorni con importo, stage e probabilità."

#: src/routes/_authed/workspace/finance.tsx:602
msgid "Mostrami le scadenze fiscali (F24, LIPE, IVA) dei prossimi 30 giorni dal Cassetto Fiscale."
msgstr "Mostrami le scadenze fiscali (F24, LIPE, IVA) dei prossimi 30 giorni dal Cassetto Fiscale."

#: src/features/chat/components/ChatEmptyState.tsx:192
msgid "Mostrami lo stato della pipeline: opportunità per fase e valore."
msgstr "Mostrami lo stato della pipeline: opportunità per fase e valore."

#: src/features/chat/components/ChatEmptyState.tsx:296
msgid "Mostrami tutte le mie dashboard."
msgstr "Mostrami tutte le mie dashboard."

#: src/features/clean-control/components/EventQueue.tsx:325
msgid "Mostrati <0>{shown}</0> di <1>{total}</1> eventi aperti"
msgstr "Mostrati <0>{shown}</0> di <1>{total}</1> eventi aperti"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:167
msgid "Motivazione"
msgstr "Motivazione"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:81
#: src/features/console/connectors/CustomConnectorDetail.tsx:306
#: src/features/console/pages/PlaygroundPage.tsx:889
#: src/features/settings/components/AccountDeletion.tsx:117
msgid "Motivo"
msgstr "Motivo"

#: src/features/admin/components/userAdminActions.tsx:365
msgid "Motivo (≥ 10 caratteri, log audit)"
msgstr "Motivo (≥ 10 caratteri, log audit)"

#: src/features/settings/components/SelfProfileMemory.tsx:592
msgid "Motivo (obbligatorio)"
msgstr "Motivo (obbligatorio)"

#: src/features/admin/components/userAdminActions.tsx:372
msgid "Motivo azione amministrativa"
msgstr "Motivo azione amministrativa"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:199
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:414
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:431
msgid "Motivo del rifiuto"
msgstr "Motivo del rifiuto"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:195
msgid "Motivo del rifiuto (richiesto)"
msgstr "Motivo del rifiuto (richiesto)"

#: src/features/admin/components/UserDetailContent.tsx:868
#: src/features/admin/components/UserDetailContent.tsx:876
msgid "Motivo elevation PII"
msgstr "Motivo elevation PII"

#: src/features/admin/components/UserDetailContent.tsx:898
msgid "Motivo obbligatorio (≥ 10 caratteri)"
msgstr "Motivo obbligatorio (≥ 10 caratteri)"

#: src/features/admin/components/orgs/OrgCostTab.tsx:235
msgid "Motivo rivelazione identità"
msgstr "Motivo rivelazione identità"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:968
msgid "Motivo verifica manuale"
msgstr "Motivo verifica manuale"

#: src/features/console/pages/PlaygroundPage.tsx:1830
msgid "Motore"
msgstr "Motore"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:265
msgid "Motore di retrieval sperimentale (solo admin)"
msgstr "Motore di retrieval sperimentale (solo admin)"

#: src/features/connectors/wizards/openBankingSpec.tsx:203
msgid "Movimenti ↔ fatture, suggerimenti pronti per la conferma."
msgstr "Movimenti ↔ fatture, suggerimenti pronti per la conferma."

#: src/features/structured-data/components/DisplayResultChips.tsx:99
msgid "Movimenti banca"
msgstr "Movimenti banca"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:72
#: src/routes/_authed/workspace/finance.tsx:1518
msgid "Movimenti recenti"
msgstr "Movimenti recenti"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:79
msgid "Movimento"
msgstr "Movimento"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:57
msgid "Mozzetto"
msgstr "Mozzetto"

#: src/features/admin/components/AdminRevenue.tsx:51
msgid "MRR · ARR · churn · LTV · breakdown per tier"
msgstr "MRR · ARR · churn · LTV · breakdown per tier"

#: src/features/admin/components/AdminCostTracking.tsx:324
msgid "MRR · costo inferenza · margine % per i primi 15"
msgstr "MRR · costo inferenza · margine % per i primi 15"

#: src/features/admin/components/AdminRevenue.tsx:84
msgid "MRR · Monthly Recurring Revenue"
msgstr "MRR · Monthly Recurring Revenue"

#. placeholder {0}: formatUsd(row.mrr_usd, 2)
#. placeholder {1}: formatUsd(row.inference_cost_usd, 2)
#: src/features/admin/components/AdminCostTracking.tsx:336
msgid "MRR {0} · costo {1}"
msgstr "MRR {0} · costo {1}"

#: src/features/admin/components/AdminRevenue.tsx:141
msgid "MRR diviso paganti totali."
msgstr "MRR diviso paganti totali."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:75
msgid "Multi-azienda"
msgstr "Multi-azienda"

#: src/features/connectors/wizards/calendarSpec.tsx:80
msgid "Multi-calendario"
msgstr "Multi-calendario"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:119
msgid "Multi-Factor Authentication"
msgstr "Multi-Factor Authentication"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:142
msgid "Multi-formato"
msgstr "Multi-formato"

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:28
msgid "Multi-hop reasoning + Byzantine consensus"
msgstr "Multi-hop reasoning + Byzantine consensus"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:65
msgid "Multi-paese"
msgstr "Multi-paese"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:191
msgid "Multi-sheet selection"
msgstr "Multi-sheet selection"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:165
msgid "Multi-tenant con row-level security."
msgstr "Multi-tenant con row-level security."

#: src/features/console/docs/content.ts:439
msgid "multipart (parte file) oppure un JSON con source_url. metadata (oggetto piatto, max 32 chiavi) e partition sono propagati a ogni chunk e filtrabili in /query. Formati: PDF, DOCX, XLSX, PPTX, HTML, TXT, MD, PNG, JPEG, WEBP (max 25 MB). Idempotency-Key opt-in."
msgstr "multipart (parte file) oppure un JSON con source_url. metadata (oggetto piatto, max 32 chiavi) e partition sono propagati a ogni chunk e filtrabili in /query. Formati: PDF, DOCX, XLSX, PPTX, HTML, TXT, MD, PNG, JPEG, WEBP (max 25 MB). Idempotency-Key opt-in."

#: src/features/admin/components/AdminPlatformSettings.tsx:571
#: src/features/admin/components/AdminPlatformSettings.tsx:624
#: src/features/admin/components/AdminPlatformSettings.tsx:781
msgid "Multiplier"
msgstr "Multiplier"

#: src/features/structured-data/components/SimilarPartsSection.tsx:98
msgid "MultiView"
msgstr "MultiView"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:72
msgid "n. {refInvoice}"
msgstr "n. {refInvoice}"

#: src/features/connectors/wizards/openBankingSpec.tsx:221
msgid "n/d"
msgstr "n/d"

#: src/features/admin/components/UserDetailContent.tsx:704
#: src/features/admin/components/UserDetailContent.tsx:713
#: src/features/admin/components/UserDetailContent.tsx:722
msgid "n/d (BE)"
msgstr "n/d (BE)"

#: src/features/connectors/wizards/erpSpec.tsx:78
msgid "Namespace servizio (opzionale)"
msgstr "Namespace servizio (opzionale)"

#. placeholder {0}: provision.namespace
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:277
msgid "Namespace: {0}"
msgstr "Namespace: {0}"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:517
#: src/features/console/pages/FlowsPage.tsx:328
#: src/features/voice_report/components/RunDiffTimeline.tsx:168
msgid "Nascondi"
msgstr "Nascondi"

#: src/features/maintenance/MaintenanceBanner.tsx:127
msgid "Nascondi avviso di manutenzione"
msgstr "Nascondi avviso di manutenzione"

#: src/features/sources/components/EmailThreadMessages.tsx:711
msgid "Nascondi contenuto citato"
msgstr "Nascondi contenuto citato"

#: src/features/sources/components/ArtifactPane.tsx:2118
#: src/features/sources/components/ArtifactPane.tsx:2119
msgid "Nascondi dettagli"
msgstr "Nascondi dettagli"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:297
msgid "Nascondi dettagli tecnici"
msgstr "Nascondi dettagli tecnici"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:187
msgid "Nascondi diff"
msgstr "Nascondi diff"

#: src/features/admin/components/AdminCpqCanvas.tsx:234
msgid "Nascondi evidenziazione"
msgstr "Nascondi evidenziazione"

#: src/features/sources/components/EmailThreadMessages.tsx:637
msgid "Nascondi firma"
msgstr "Nascondi firma"

#: src/features/console/components/FirstRunTimeline.tsx:211
msgid "Nascondi i primi passi"
msgstr "Nascondi i primi passi"

#: src/features/console/components/ByokModal.tsx:146
msgid "Nascondi la chiave"
msgstr "Nascondi la chiave"

#: src/features/admin/components/ZitadelPasswordActions.tsx:226
#: src/features/auth/desktop/DesktopLoginForm.tsx:748
#: src/features/connectors/components/management/EditConnectorDialog.tsx:331
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:806
msgid "Nascondi password"
msgstr "Nascondi password"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:119
msgid "Nascondi righe identiche"
msgstr "Nascondi righe identiche"

#: src/features/clean-control/components/policies/PolicyRow.tsx:214
msgid "Nascondi salute segnale"
msgstr "Nascondi salute segnale"

#: src/routes/_authed/workspace/dashboard.tsx:430
msgid "Nascondi suggerimento"
msgstr "Nascondi suggerimento"

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:149
msgid "Nascosta"
msgstr "Nascosta"

#: src/features/dxf/components/DxfPreviewStage.tsx:340
msgid "Naviga"
msgstr "Naviga"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:713
msgid "Naviga slide"
msgstr "Naviga slide"

#: src/features/help/components/ShortcutsList.tsx:157
msgid "Naviga voci di menu o liste"
msgstr "Naviga voci di menu o liste"

#: src/features/help/components/ShortcutsList.tsx:43
msgid "Navigazione"
msgstr "Navigazione"

#: src/routes/_authed/workspace/shares.tsx:304
msgid "Ne ricevi una copia privata: il thread originale non cambia."
msgstr "Ne ricevi una copia privata: il thread originale non cambia."

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:110
msgid "Negli ultimi 2 giorni non ti sono arrivati nuovi documenti via chat o email. Torna fra un po'."
msgstr "Negli ultimi 2 giorni non ti sono arrivati nuovi documenti via chat o email. Torna fra un po'."

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:179
msgid "Nei tuoi dati «{term}» può voler dire più di una cosa. Scegli quale intendi e rifaccio il calcolo."
msgstr "Nei tuoi dati «{term}» può voler dire più di una cosa. Scegli quale intendi e rifaccio il calcolo."

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:361
msgid "Nei tuoi dati ufficiali"
msgstr "Nei tuoi dati ufficiali"

#: src/features/skills/components/SkillsList.tsx:382
msgid "Nel catalogo del team"
msgstr "Nel catalogo del team"

#: src/features/clean-control/utils/explainEvent.ts:56
msgid "Nel documento sono stati trovati {count} dati personali ({kind}): valuta se vanno protetti o rimossi."
msgstr "Nel documento sono stati trovati {count} dati personali ({kind}): valuta se vanno protetti o rimossi."

#: src/features/clean-control/utils/explainEvent.ts:57
msgid "Nel documento sono stati trovati {count} dati personali: valuta se vanno protetti o rimossi."
msgstr "Nel documento sono stati trovati {count} dati personali: valuta se vanno protetti o rimossi."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:365
msgid "Nel login Authorization Code con PKCE richiedi entrambi gli scope. Il server della tua app invia a Engine l'access token Zitadel nell'header X-Ando-End-User-Token insieme alla AppKey. Non usare l'ID token come token API."
msgstr "Nel login Authorization Code con PKCE richiedi entrambi gli scope. Il server della tua app invia a Engine l'access token Zitadel nell'header X-Ando-End-User-Token insieme alla AppKey. Non usare l'ID token come token API."

#: src/features/skills/components/SkillsList.tsx:389
msgid "Nel team"
msgstr "Nel team"

#: src/features/console/pages/OverviewPage.tsx:209
msgid "Nell'indice documentale"
msgstr "Nell'indice documentale"

#: src/features/onboarding/demoTourSteps.ts:109
msgid "Nella barra a sinistra trovi gli «Spazi», le aree più avanzate: Canvas (cervelli verticali per cliente o progetto), Analisi, Automazioni, Flows e Connect. Sono sempre a un clic, senza affollare la barra in alto."
msgstr "Nella barra a sinistra trovi gli «Spazi», le aree più avanzate: Canvas (cervelli verticali per cliente o progetto), Analisi, Automazioni, Flows e Connect. Sono sempre a un clic, senza affollare la barra in alto."

#: src/features/onboarding/demoTourSteps.ts:110
msgid "Nella barra a sinistra trovi gli «Spazi»: Canvas (cervelli verticali per cliente o progetto), Analisi, Automazioni, Flows e Connect. Sono le aree più avanzate, sempre a portata di clic."
msgstr "Nella barra a sinistra trovi gli «Spazi»: Canvas (cervelli verticali per cliente o progetto), Analisi, Automazioni, Flows e Connect. Sono le aree più avanzate, sempre a portata di clic."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:369
msgid "Nella query SQL"
msgstr "Nella query SQL"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1684
msgid "Nero"
msgstr "Nero"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:58
msgid "Nervatura"
msgstr "Nervatura"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:371
msgid "Nessun account"
msgstr "Nessun account"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:322
msgid "Nessun account collegato. Scegli un provider qui sotto per iniziare."
msgstr "Nessun account collegato. Scegli un provider qui sotto per iniziare."

#: src/features/sales/components/BatchSendModal.tsx:240
msgid "Nessun account email collegato."
msgstr "Nessun account email collegato."

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:349
msgid "Nessun account email o PEC connesso."
msgstr "Nessun account email o PEC connesso."

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:304
msgid "Nessun allegato — clicca per aggiungere."
msgstr "Nessun allegato — clicca per aggiungere."

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:303
msgid "Nessun allegato."
msgstr "Nessun allegato."

#: src/features/console/pages/MembersPage.tsx:484
msgid "Nessun altro collega"
msgstr "Nessun altro collega"

#: src/features/console/pages/ResourceAccessPage.tsx:496
msgid "Nessun altro può cercare o leggere questo documento."
msgstr "Nessun altro può cercare o leggere questo documento."

#: src/features/console/pages/ResourceAccessPage.tsx:498
msgid "Nessun altro può usare questa connessione."
msgstr "Nessun altro può usare questa connessione."

#: src/features/admin/components/MaintenanceControl.tsx:206
msgid "Nessun avviso mostrato agli utenti"
msgstr "Nessun avviso mostrato agli utenti"

#: src/features/dxf/components/DxfBomButton.tsx:71
msgid "Nessun blocco"
msgstr "Nessun blocco"

#: ../../packages/ui/src/cad/CadBlockAccordion.tsx:56
msgid "Nessun blocco rilevato"
msgstr "Nessun blocco rilevato"

#: src/features/settings/components/BrandKitSettings.tsx:264
msgid "Nessun Brand Kit"
msgstr "Nessun Brand Kit"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:133
msgid "Nessun calendario disponibile per questo account."
msgstr "Nessun calendario disponibile per questo account."

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:265
msgid "Nessun campo calcolato. Compila il modulo per aggiungerne uno."
msgstr "Nessun campo calcolato. Compila il modulo per aggiungerne uno."

#: src/routes/_authed/workspace/canvases.tsx:345
msgid "Nessun canvas archiviato"
msgstr "Nessun canvas archiviato"

#: src/routes/_authed/workspace/canvases.tsx:360
msgid "Nessun canvas creato — approva un suggerimento qui sopra per iniziare."
msgstr "Nessun canvas creato — approva un suggerimento qui sopra per iniziare."

#: src/features/connect/components/GrantManager.tsx:541
msgid "Nessun Canvas disponibile"
msgstr "Nessun Canvas disponibile"

#: src/features/admin/components/AdminCanvas.tsx:106
msgid "Nessun canvas nel periodo."
msgstr "Nessun canvas nel periodo."

#: src/features/console/connectors/CustomConnectorDetail.tsx:614
msgid "Nessun codice dal tuo lato: la piattaforma interroga la tua API ogni {interval} minuti."
msgstr "Nessun codice dal tuo lato: la piattaforma interroga la tua API ogni {interval} minuti."

#: src/features/sales/components/CampaignSharing.tsx:235
msgid "Nessun collaboratore. Aggiungi qualcuno dal pulsante “Aggiungi”."
msgstr "Nessun collaboratore. Aggiungi qualcuno dal pulsante “Aggiungi”."

#: src/features/connect/components/MemberManager.tsx:654
msgid "Nessun collega nella tua organizzazione."
msgstr "Nessun collega nella tua organizzazione."

#: ../../packages/ui/src/ando/OrganizationMemberPicker.tsx:94
#: src/features/connect/components/MemberManager.tsx:652
msgid "Nessun collega trovato."
msgstr "Nessun collega trovato."

#: src/features/workspace/finance/components/ConnectionsPanel.tsx:51
msgid "Nessun collegamento"
msgstr "Nessun collegamento"

#: src/routes/_authed/workspace/finance.tsx:1085
msgid "Nessun collegamento attivo"
msgstr "Nessun collegamento attivo"

#: src/routes/_authed/workspace/finance.tsx:676
msgid "Nessun collegamento configurato"
msgstr "Nessun collegamento configurato"

#: ../../packages/ui/src/ando/composer-parts/SlashCommandMenu.tsx:114
msgid "Nessun comando corrisponde."
msgstr "Nessun comando corrisponde."

#: src/features/console/pages/UsagePage.tsx:106
msgid "nessun confronto"
msgstr "nessun confronto"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:401
msgid "Nessun connector abilitato per l'org."
msgstr "Nessun connector abilitato per l'org."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:423
msgid "Nessun connector con assegnazione «Per utente» abilitato."
msgstr "Nessun connector con assegnazione «Per utente» abilitato."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:351
msgid "Nessun connector configurato per questa organizzazione."
msgstr "Nessun connector configurato per questa organizzazione."

#: src/features/connect/components/GrantManager.tsx:702
msgid "Nessun connettore a dati strutturati collegato."
msgstr "Nessun connettore a dati strutturati collegato."

#: src/features/console/pages/ConnectorsPage.tsx:325
msgid "Nessun connettore corrisponde ai filtri"
msgstr "Nessun connettore corrisponde ai filtri"

#: src/features/console/pages/ConnectorsPage.tsx:325
msgid "Nessun connettore disponibile"
msgstr "Nessun connettore disponibile"

#: src/routes/_authed/workspace/finance.tsx:1748
msgid "Nessun connettore fiscale collegato"
msgstr "Nessun connettore fiscale collegato"

#: src/features/projects/components/ProjectDetailPage.tsx:111
msgid "Nessun connettore né cartella allegata"
msgstr "Nessun connettore né cartella allegata"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:233
#: src/features/console/pages/ActionsPage.tsx:67
msgid "Nessun connettore personalizzato"
msgstr "Nessun connettore personalizzato"

#: src/features/console/components/CreateKeyWizard.tsx:530
msgid "Nessun connettore personalizzato: registrane uno per limitarne le azioni qui."
msgstr "Nessun connettore personalizzato: registrane uno per limitarne le azioni qui."

#: src/features/console/pages/ActionsPage.tsx:100
msgid "Nessun connettore selezionato"
msgstr "Nessun connettore selezionato"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:328
msgid "Nessun consolidation job registrato."
msgstr "Nessun consolidation job registrato."

#: src/features/console/pages/UsagePage.tsx:364
msgid "Nessun consumo registrato"
msgstr "Nessun consumo registrato"

#: src/features/sales/components/crm/ContactsPanel.tsx:223
msgid "Nessun contatto ancora — creane uno o converti un lead dalla sezione Lead."
msgstr "Nessun contatto ancora — creane uno o converti un lead dalla sezione Lead."

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:453
msgid "Nessun contatto trovato"
msgstr "Nessun contatto trovato"

#. placeholder {0}: draft.trim()
#: ../../packages/ui/src/ando/RecipientsInput.tsx:461
msgid "Nessun contatto trovato per \"{0}\""
msgstr "Nessun contatto trovato per \"{0}\""

#: src/features/sales/components/crm/ContactsPanel.tsx:221
msgid "Nessun contatto trovato per la ricerca."
msgstr "Nessun contatto trovato per la ricerca."

#: src/features/sources/components/EmailThreadMessages.tsx:377
msgid "Nessun contenuto disponibile per questo messaggio."
msgstr "Nessun contenuto disponibile per questo messaggio."

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:107
msgid "Nessun contenuto già indicizzato corrisponde alla ricerca. Sincronizza l'account o cambia ricerca."
msgstr "Nessun contenuto già indicizzato corrisponde alla ricerca. Sincronizza l'account o cambia ricerca."

#: src/features/sources/components/ArtifactPane.tsx:2307
msgid "Nessun contenuto rilevante da sintetizzare."
msgstr "Nessun contenuto rilevante da sintetizzare."

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:118
msgid "Nessun contenuto selezionato."
msgstr "Nessun contenuto selezionato."

#: src/features/sync/components/DocSyncManager.tsx:1068
msgid "Nessun contenuto."
msgstr "Nessun contenuto."

#: src/routes/_authed/workspace/finance.tsx:1499
msgid "Nessun conto ancora attivo. Il provider potrebbe non aver completato la prima sync."
msgstr "Nessun conto ancora attivo. Il provider potrebbe non aver completato la prima sync."

#: src/routes/_authed/workspace/finance.tsx:1399
msgid "Nessun conto attivo"
msgstr "Nessun conto attivo"

#: src/routes/_authed/workspace/finance.tsx:1360
msgid "Nessun conto bancario collegato"
msgstr "Nessun conto bancario collegato"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:244
msgid "Nessun database collegato. Aggiungi un connettore dalla pagina Integrazioni."
msgstr "Nessun database collegato. Aggiungi un connettore dalla pagina Integrazioni."

#: ../../packages/ui/src/charts/Chart.tsx:100
msgid "Nessun dato"
msgstr "Nessun dato"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:853
msgid "Nessun dato di anteprima."
msgstr "Nessun dato di anteprima."

#: src/features/hive-flows/run/ReferencePane.tsx:228
msgid "Nessun dato di riferimento."
msgstr "Nessun dato di riferimento."

#: src/features/admin/components/AdminQuality.tsx:164
msgid "Nessun dato disponibile nel periodo."
msgstr "Nessun dato disponibile nel periodo."

#: src/features/admin/components/widgets/EmptyChartState.tsx:52
msgid "Nessun dato nel periodo selezionato."
msgstr "Nessun dato nel periodo selezionato."

#: src/features/console/pages/UsagePage.tsx:581
msgid "Nessun dato per questa finestra."
msgstr "Nessun dato per questa finestra."

#: src/features/hive-flows/run/ProposalReview.tsx:498
msgid "Nessun dato strutturato da rivedere."
msgstr "Nessun dato strutturato da rivedere."

#: src/features/dxf/components/DxfEmptyHero.tsx:103
msgid "Nessun disegno corrisponde ai filtri"
msgstr "Nessun disegno corrisponde ai filtri"

#: src/features/dxf/components/DxfLeftRail.tsx:180
msgid "Nessun disegno corrisponde<0/>ai filtri attivi"
msgstr "Nessun disegno corrisponde<0/>ai filtri attivi"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:303
msgid "Nessun disegno DXF trovato"
msgstr "Nessun disegno DXF trovato"

#: src/features/console/pages/DocumentsPage.tsx:724
msgid "Nessun documento"
msgstr "Nessun documento"

#: src/features/hive-flows/run/RunDocumentViewer.tsx:106
msgid "Nessun documento allegato."
msgstr "Nessun documento allegato."

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:57
msgid "Nessun documento ancora"
msgstr "Nessun documento ancora"

#. placeholder {0}: context.query
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:120
msgid "Nessun documento corrisponde a “{0}”. Prova con un altro termine o rimuovi i filtri."
msgstr "Nessun documento corrisponde a “{0}”. Prova con un altro termine o rimuovi i filtri."

#: src/features/console/pages/DocumentsPage.tsx:722
msgid "Nessun documento corrisponde ai filtri"
msgstr "Nessun documento corrisponde ai filtri"

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:121
msgid "Nessun documento corrisponde ai filtri attivi. Prova ad ampliare la ricerca."
msgstr "Nessun documento corrisponde ai filtri attivi. Prova ad ampliare la ricerca."

#: src/features/connect/components/GrantManager.tsx:941
msgid "Nessun documento disponibile"
msgstr "Nessun documento disponibile"

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:441
#: src/features/hive-flows/components/DocumentPickerField.tsx:75
msgid "Nessun documento disponibile."
msgstr "Nessun documento disponibile."

#: src/features/projects/components/ProjectDetailPage.tsx:135
msgid "Nessun documento generato ancora"
msgstr "Nessun documento generato ancora"

#: src/features/projects/components/sections/ArtifactGallerySection.tsx:194
msgid "Nessun documento generato per ora. Chiedi all'agente di produrre un file (deck, F24, bozza email) nelle chat del progetto e lo troverai qui."
msgstr "Nessun documento generato per ora. Chiedi all'agente di produrre un file (deck, F24, bozza email) nelle chat del progetto e lo troverai qui."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:804
msgid "Nessun documento in coda"
msgstr "Nessun documento in coda"

#: src/features/share/components/ShareLinkDialog.tsx:453
msgid "Nessun documento interno citato."
msgstr "Nessun documento interno citato."

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:440
#: src/features/hive-flows/components/DocumentPickerField.tsx:75
msgid "Nessun documento trovato."
msgstr "Nessun documento trovato."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:364
msgid "Nessun DRAFT in attesa di approvazione"
msgstr "Nessun DRAFT in attesa di approvazione"

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:81
msgid "Nessun Drive collegato"
msgstr "Nessun Drive collegato"

#: src/features/workspace/documents/components/SmartSourceChips.tsx:74
msgid "Nessun drive connesso"
msgstr "Nessun drive connesso"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:320
msgid "Nessun elemento disponibile."
msgstr "Nessun elemento disponibile."

#: src/features/console/traces/TracePayloadReader.tsx:130
msgid "Nessun elemento in questa sezione."
msgstr "Nessun elemento in questa sezione."

#: src/features/connectors/components/management/ChatExamplesManager.tsx:217
msgid "Nessun esempio configurato. Aggiungi domande tipiche con la SQL corretta per migliorare il text-to-SQL."
msgstr "Nessun esempio configurato. Aggiungi domande tipiche con la SQL corretta per migliorare il text-to-SQL."

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:330
msgid "Nessun esperimento attivo"
msgstr "Nessun esperimento attivo"

#: src/routes/_authed/workspace/calendar.tsx:733
msgid "Nessun evento"
msgstr "Nessun evento"

#: src/features/admin/components/orgs/AuditLogList.tsx:179
msgid "Nessun evento corrisponde alla ricerca"
msgstr "Nessun evento corrisponde alla ricerca"

#: src/features/admin/components/orgs/AuditLogList.tsx:180
msgid "Nessun evento da mostrare"
msgstr "Nessun evento da mostrare"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:258
msgid "Nessun evento per questi filtri."
msgstr "Nessun evento per questi filtri."

#: src/features/console/pages/KeyDetailPage.tsx:499
msgid "Nessun evento registrato"
msgstr "Nessun evento registrato"

#: src/features/console/pages/TracesPage.tsx:380
msgid "Nessun evento visibile"
msgstr "Nessun evento visibile"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:199
msgid "Nessun fact per questi filtri."
msgstr "Nessun fact per questi filtri."

#: src/features/auth/desktop/DesktopLoginForm.tsx:381
msgid "Nessun fattore MFA disponibile"
msgstr "Nessun fattore MFA disponibile"

#: src/features/clean-control/components/SignalHealthCard.tsx:246
msgid "Nessun feedback ancora su questo segnale."
msgstr "Nessun feedback ancora su questo segnale."

#: src/routes/_authed/_modal/integrations/$capability.tsx:1068
msgid "Nessun file compatibile trovato (pdf, docx, xlsx…)."
msgstr "Nessun file compatibile trovato (pdf, docx, xlsx…)."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:802
msgid "Nessun file in coda"
msgstr "Nessun file in coda"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:103
msgid "Nessun file selezionato"
msgstr "Nessun file selezionato"

#: src/features/sync/components/DocSyncManager.tsx:1471
msgid "Nessun file tracciato ancora"
msgstr "Nessun file tracciato ancora"

#: src/features/connectors/components/ConnectedAccountRow.tsx:170
msgid "Nessun file trovato · {when}"
msgstr "Nessun file trovato · {when}"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:386
msgid "Nessun filtro attivo"
msgstr "Nessun filtro attivo"

#: src/features/voice_report/components/DatasetTab.tsx:28
msgid "Nessun filtro attivo — il report spazia su tutta la knowledge collegata."
msgstr "Nessun filtro attivo — il report spazia su tutta la knowledge collegata."

#: src/features/console/pages/FlowsPage.tsx:792
msgid "Nessun flow"
msgstr "Nessun flow"

#: src/routes/_authed/workspace/flows.index.tsx:570
msgid "Nessun flow condiviso, per ora"
msgstr "Nessun flow condiviso, per ora"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:245
msgid "Nessun foglio collegato. Carica un file XLSX dalla pagina Integrazioni."
msgstr "Nessun foglio collegato. Carica un file XLSX dalla pagina Integrazioni."

#: src/routes/_authed/workspace/finance.tsx:1636
msgid "Nessun gestionale o CRM collegato"
msgstr "Nessun gestionale o CRM collegato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:613
msgid "Nessun ID utente contiene “{subjectFilter}” in questa app."
msgstr "Nessun ID utente contiene “{subjectFilter}” in questa app."

#: src/routes/_authed/workspace/finance.tsx:767
msgid "Nessun indicatore"
msgstr "Nessun indicatore"

#: src/features/admin/components/AdminDemoInviti.tsx:211
msgid "Nessun invito demo"
msgstr "Nessun invito demo"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:286
msgid "Nessun invito in sospeso"
msgstr "Nessun invito in sospeso"

#: src/features/console/pages/DocumentsPage.tsx:514
msgid "Nessun job registrato per questo documento."
msgstr "Nessun job registrato per questo documento."

#: src/features/admin/components/UserDetailContent.tsx:479
msgid "Nessun KPI per il periodo."
msgstr "Nessun KPI per il periodo."

#: ../../packages/ui/src/cad/CadLayerList.tsx:45
msgid "Nessun layer rilevato"
msgstr "Nessun layer rilevato"

#: src/features/sales/components/LeadsPanel.tsx:659
msgid "Nessun lead ancora"
msgstr "Nessun lead ancora"

#: src/features/sales/components/LeadsPanel.tsx:370
msgid "Nessun lead ancora contattato."
msgstr "Nessun lead ancora contattato."

#: src/features/sales/components/LeadsPanel.tsx:368
msgid "Nessun lead ancora da contattare."
msgstr "Nessun lead ancora da contattare."

#. placeholder {0}: citation.label
#: src/features/sources/components/CalendarEventPane.tsx:385
msgid "Nessun link disponibile per \"{0}\"."
msgstr "Nessun link disponibile per \"{0}\"."

#: src/features/price-lists/components/PriceListsPage.tsx:1028
msgid "Nessun listino ancora caricato"
msgstr "Nessun listino ancora caricato"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:388
#: src/features/connect/components/SpaceCard.tsx:166
#: src/features/settings/components/OrgMembersPanel.tsx:146
msgid "Nessun membro"
msgstr "Nessun membro"

#: src/features/sales/components/AssigneePicker.tsx:99
msgid "Nessun membro del team"
msgstr "Nessun membro del team"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:427
msgid "Nessun membro nell'organizzazione."
msgstr "Nessun membro nell'organizzazione."

#: src/routes/_authed/workspace/conversations.tsx:1105
msgid "Nessun messaggio"
msgstr "Nessun messaggio"

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:411
msgid "Nessun messaggio archiviabile"
msgstr "Nessun messaggio archiviabile"

#: src/routes/_authed/workspace/conversations.tsx:1065
msgid "Nessun messaggio in questa vista"
msgstr "Nessun messaggio in questa vista"

#: src/routes/_authed/workspace/conversations.tsx:1098
msgid "Nessun messaggio non letto. Goditi il momento."
msgstr "Nessun messaggio non letto. Goditi il momento."

#: src/features/connect/components/ConnectMessageThread.tsx:152
msgid "Nessun messaggio. Scrivi il primo."
msgstr "Nessun messaggio. Scrivi il primo."

#: src/features/console/pages/BillingPage.tsx:357
msgid "Nessun metodo di pagamento"
msgstr "Nessun metodo di pagamento"

#: src/features/chat/hooks/useAudioRecorder.ts:73
msgid "Nessun microfono rilevato."
msgstr "Nessun microfono rilevato."

#: src/features/studio/components/StudioDrawerContent.tsx:313
msgid "Nessun Mode personale ancora. Creane uno qui sopra."
msgstr "Nessun Mode personale ancora. Creane uno qui sopra."

#: src/features/sales/components/BatchSendModal.tsx:308
msgid "Nessun modello — scrivi oggetto e testo"
msgstr "Nessun modello — scrivi oggetto e testo"

#: src/features/sales/components/TemplateManager.tsx:183
msgid "Nessun modello ancora. Creane uno per le email che scrivi spesso."
msgstr "Nessun modello ancora. Creane uno per le email che scrivi spesso."

#: src/features/admin/components/AdminPlatformSettings.tsx:297
msgid "Nessun modello configurato — clicca <0>Aggiungi</0>."
msgstr "Nessun modello configurato — clicca <0>Aggiungi</0>."

#: src/features/admin/components/orgs/OrgCostTab.tsx:385
msgid "Nessun modello nel periodo."
msgstr "Nessun modello nel periodo."

#: src/features/projects/components/sections/PersonaSection.tsx:215
msgid "Nessun modo (predefinito)"
msgstr "Nessun modo (predefinito)"

#: src/features/agent-modes/components/AgentModesList.tsx:256
msgid "Nessun modo ancora"
msgstr "Nessun modo ancora"

#: src/features/agent-modes/components/AgentModesList.tsx:256
msgid "Nessun modo corrisponde ai filtri"
msgstr "Nessun modo corrisponde ai filtri"

#: src/routes/_authed/workspace/finance.tsx:1536
msgid "Nessun movimento nel periodo. Il provider potrebbe essere in sandbox o la sincronizzazione è in corso."
msgstr "Nessun movimento nel periodo. Il provider potrebbe essere in sandbox o la sincronizzazione è in corso."

#: src/features/hive-flows/components/NodePalette.tsx:118
msgid "Nessun nodo per «{query}»."
msgstr "Nessun nodo per «{query}»."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:222
msgid "Nessun nudge nel periodo selezionato"
msgstr "Nessun nudge nel periodo selezionato"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:401
msgid "Nessun nudge per i filtri selezionati"
msgstr "Nessun nudge per i filtri selezionati"

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:109
msgid "Nessun nuovo allegato"
msgstr "Nessun nuovo allegato"

#: src/features/sales/hooks/useCrmQueries.ts:285
msgid "Nessun nuovo suggerimento — tutto già in ordine"
msgstr "Nessun nuovo suggerimento — tutto già in ordine"

#: src/features/console/pages/SchemaPage.tsx:421
msgid "Nessun oggetto profilato"
msgstr "Nessun oggetto profilato"

#: src/features/voice_report/components/OutlineTab.tsx:141
msgid "Nessun outline ancora"
msgstr "Nessun outline ancora"

#: src/features/console/pages/PlaygroundPage.tsx:1028
msgid "Nessun passaggio"
msgstr "Nessun passaggio"

#: src/features/console/pages/PlaygroundPage.tsx:853
msgid "Nessun passaggio trovato"
msgstr "Nessun passaggio trovato"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:438
msgid "Nessun PDF da mostrare."
msgstr "Nessun PDF da mostrare."

#: src/routes/_authed/_modal/integrations/$capability.tsx:1040
msgid "Nessun percorso configurato per questa cartella."
msgstr "Nessun percorso configurato per questa cartella."

#: src/features/structured-data/components/SimilarPartsSection.tsx:283
msgid "Nessun pezzo simile"
msgstr "Nessun pezzo simile"

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:172
msgid "Nessun pezzo simile trovato nell'archivio."
msgstr "Nessun pezzo simile trovato nell'archivio."

#: src/features/admin/components/AdminPlatformSettings.tsx:672
msgid "Nessun piano configurato — clicca <0>Nuovo piano</0>."
msgstr "Nessun piano configurato — clicca <0>Nuovo piano</0>."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:301
msgid "Nessun pilota separato (il setup è incluso nella prima fase)"
msgstr "Nessun pilota separato (il setup è incluso nella prima fase)"

#: src/features/admin/components/AdminCpqList.tsx:126
msgid "Nessun preventivo"
msgstr "Nessun preventivo"

#: src/features/admin/components/AdminCpqList.tsx:132
msgid "Nessun preventivo corrisponde ai filtri"
msgstr "Nessun preventivo corrisponde ai filtri"

#: src/features/chat/components/ConversationSidebar.tsx:1121
msgid "Nessun progetto"
msgstr "Nessun progetto"

#: src/features/projects/components/ProjectHub.tsx:405
msgid "Nessun progetto corrisponde alla ricerca. Prova con un altro termine."
msgstr "Nessun progetto corrisponde alla ricerca. Prova con un altro termine."

#: src/features/chat/components/ConversationSidebar.tsx:382
msgid "Nessun progetto. Un progetto tiene insieme istruzioni, dati e memoria di un lavoro."
msgstr "Nessun progetto. Un progetto tiene insieme istruzioni, dati e memoria di un lavoro."

#: src/features/admin/components/orgs/OrgCostTab.tsx:390
msgid "Nessun provider nel periodo."
msgstr "Nessun provider nel periodo."

#: src/features/report/components/ReportList.tsx:96
#: src/features/voice_report/components/ReportTab.tsx:74
msgid "Nessun report ancora"
msgstr "Nessun report ancora"

#: src/features/report/components/ReportList.tsx:94
msgid "Nessun report corrisponde"
msgstr "Nessun report corrisponde"

#: src/features/report/components/NpsPromoterDetractorGrid.tsx:133
msgid "Nessun rispondente in questo bucket."
msgstr "Nessun rispondente in questo bucket."

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1036
#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:177
#: ../../packages/ui/src/command-palette/CommandPalette.tsx:163
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:286
#: src/features/admin/components/orgs/OrgMembersTab.tsx:388
#: src/features/chat/components/ConversationCommandPalette.tsx:344
#: src/features/console/components/CommandPalette.tsx:168
#: src/features/console/pages/DocsPage.tsx:557
#: src/features/console/pages/PlaygroundPage.tsx:1214
#: src/features/console/pages/PlaygroundPage.tsx:1577
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:117
msgid "Nessun risultato"
msgstr "Nessun risultato"

#: src/routes/_authed/workspace/conversations.tsx:1051
msgid "Nessun risultato per la ricerca"
msgstr "Nessun risultato per la ricerca"

#: src/features/console/components/AssistPanel.tsx:69
msgid "Nessun risultato su cui fondare una risposta."
msgstr "Nessun risultato su cui fondare una risposta."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:332
#: src/features/dashboard/components/wizard/WizardStepData.tsx:468
#: src/features/projects/components/sections/MembersSection.tsx:499
msgid "Nessun risultato."
msgstr "Nessun risultato."

#: src/features/voice_report/components/RunsTab.tsx:168
msgid "Nessun run finora"
msgstr "Nessun run finora"

#: src/features/admin/components/AdminAutomation.tsx:122
msgid "Nessun run nel periodo."
msgstr "Nessun run nel periodo."

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:317
msgid "Nessun sample fact associato."
msgstr "Nessun sample fact associato."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:513
msgid "Nessun sito accessibile"
msgstr "Nessun sito accessibile"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:187
msgid "Nessun suggerimento di workflow al momento"
msgstr "Nessun suggerimento di workflow al momento"

#: src/routes/_authed/workspace/work.tsx:508
msgid "Nessun task nei prossimi giorni."
msgstr "Nessun task nei prossimi giorni."

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:405
msgid "Nessun team trovato per questo account."
msgstr "Nessun team trovato per questo account."

#: src/features/templates/components/TemplatesList.tsx:177
#: src/routes/_authed/workspace/templates/$kind.tsx:135
msgid "Nessun template"
msgstr "Nessun template"

#: src/features/automations/components/AutomationsHub.tsx:441
#: src/features/voice_report/components/TemplatesGallery.tsx:432
msgid "Nessun template disponibile"
msgstr "Nessun template disponibile"

#: src/features/console/pages/FlowsPage.tsx:340
#: src/features/studio/components/StudioDrawerContent.tsx:450
msgid "Nessun template disponibile."
msgstr "Nessun template disponibile."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1162
msgid "Nessun template nel Brand Kit — caricane uno."
msgstr "Nessun template nel Brand Kit — caricane uno."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:314
msgid "Nessun template per questa categoria. Prova con un'altra o crea un progetto vuoto."
msgstr "Nessun template per questa categoria. Prova con un'altra o crea un progetto vuoto."

#: src/features/settings/components/PresentationTemplates.tsx:397
msgid "Nessun template per questo tipo"
msgstr "Nessun template per questo tipo"

#: src/features/voice_report/components/TemplatesGallery.tsx:465
msgid "Nessun template selezionato"
msgstr "Nessun template selezionato"

#: src/features/voice_report/components/NewReportDialog.tsx:938
msgid "Nessun template selezionato — struttura default."
msgstr "Nessun template selezionato — struttura default."

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:151
msgid "Nessun tenant trovato."
msgstr "Nessun tenant trovato."

#: src/features/console/components/DocumentAcquiredContent.tsx:44
msgid "Nessun testo acquisito disponibile per il tuo accesso. Controlla lo stato di indicizzazione del documento."
msgstr "Nessun testo acquisito disponibile per il tuo accesso. Controlla lo stato di indicizzazione del documento."

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:543
msgid "Nessun testo modificabile in questa slide. Per inserire nuove forme o immagini, chiedi ad Ando."
msgstr "Nessun testo modificabile in questa slide. Per inserire nuove forme o immagini, chiedi ad Ando."

#: src/features/console/pages/KeyDetailPage.tsx:300
msgid "Nessun tetto"
msgstr "Nessun tetto"

#: src/features/console/pages/LimitsPage.tsx:74
msgid "Nessun tetto di spesa"
msgstr "Nessun tetto di spesa"

#: src/features/console/pages/KeyDetailPage.tsx:439
msgid "Nessun tetto: la chiave non è limitata nei consumi mensili."
msgstr "Nessun tetto: la chiave non è limitata nei consumi mensili."

#: src/features/settings/marp/shared.tsx:88
msgid "Nessun token rilevato — il file potrebbe non avere uno schema brand chiaro."
msgstr "Nessun token rilevato — il file potrebbe non avere uno schema brand chiaro."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:237
msgid "Nessun tool firing per questo turn."
msgstr "Nessun tool firing per questo turn."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:543
msgid "Nessun trace per questi filtri."
msgstr "Nessun trace per questi filtri."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:376
msgid "Nessun URL di ritorno attivo."
msgstr "Nessun URL di ritorno attivo."

#: src/features/admin/components/AdminUsers.tsx:304
msgid "Nessun utente corrisponde ai filtri"
msgstr "Nessun utente corrisponde ai filtri"

#: src/features/console/pages/ResourceAccessPage.tsx:860
msgid "Nessun utente corrisponde alla ricerca."
msgstr "Nessun utente corrisponde alla ricerca."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:614
msgid "Nessun utente registrato"
msgstr "Nessun utente registrato"

#: src/features/console/pages/ResourceAccessPage.tsx:862
msgid "Nessun utente registrato in questa app. L'utente apparirà dopo il primo collegamento."
msgstr "Nessun utente registrato in questa app. L'utente apparirà dopo il primo collegamento."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:613
msgid "Nessun utente trovato"
msgstr "Nessun utente trovato"

#: ../../packages/ui/src/ando/chat/ConflictNote.tsx:100
msgid "Nessun valore confermato"
msgstr "Nessun valore confermato"

#: src/features/connectors/components/management/SchemaViewer.tsx:587
msgid "Nessun valore disponibile per questa colonna."
msgstr "Nessun valore disponibile per questa colonna."

#: src/features/console/webhooks/WebhooksPanel.tsx:509
msgid "Nessun webhook registrato"
msgstr "Nessun webhook registrato"

#: src/features/dashboard/components/DashboardEmptyState.tsx:54
msgid "Nessun widget per ora"
msgstr "Nessun widget per ora"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:245
#: src/features/sales/components/crm/ContactsPanel.tsx:139
#: src/features/sales/components/crm/DealDetailDrawer.tsx:202
#: src/features/sales/components/crm/RecordDrawer.tsx:221
msgid "Nessuna"
msgstr "Nessuna"

#: src/features/sales/components/crm/CreateDealDialog.tsx:178
msgid "Nessuna (collega dopo)"
msgstr "Nessuna (collega dopo)"

#: src/features/console/connectors/ManifestConfigForm.tsx:79
msgid "Nessuna (endpoint pubblico)"
msgstr "Nessuna (endpoint pubblico)"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:315
msgid "Nessuna (salva senza pin)"
msgstr "Nessuna (salva senza pin)"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:601
#: src/features/clean-control/components/EventDetailSheet.tsx:414
msgid "Nessuna anteprima disponibile."
msgstr "Nessuna anteprima disponibile."

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:262
msgid "Nessuna anteprima disponibile. Modifica le slide e aggiorna."
msgstr "Nessuna anteprima disponibile. Modifica le slide e aggiorna."

#: src/features/clean-control/components/EventRow.tsx:512
msgid "Nessuna anteprima disponibile. Puoi generarla su richiesta."
msgstr "Nessuna anteprima disponibile. Puoi generarla su richiesta."

#: src/features/console/pages/KeysPage.tsx:92
msgid "Nessuna AppKey"
msgstr "Nessuna AppKey"

#: src/features/console/connectors/CustomConnectorDetail.tsx:602
msgid "Nessuna AppKey associata"
msgstr "Nessuna AppKey associata"

#: src/features/console/flows/ConsoleFlowApprovals.tsx:69
msgid "Nessuna approvazione in sospeso"
msgstr "Nessuna approvazione in sospeso"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:381
msgid "Nessuna area selezionata"
msgstr "Nessuna area selezionata"

#: src/features/connect/components/ActivityFeed.tsx:50
msgid "Nessuna attività"
msgstr "Nessuna attività"

#: src/features/sales/components/ActivityTimeline.tsx:296
#: src/features/sales/components/crm/ActivityNotesPane.tsx:87
msgid "Nessuna attività ancora"
msgstr "Nessuna attività ancora"

#: src/features/projects/components/sections/TasksSection.tsx:264
msgid "Nessuna attività ancora. Annota qui le cose da fare relative al progetto: l'agente può aggiungerne dalle chat e tu puoi crearne di tue."
msgstr "Nessuna attività ancora. Annota qui le cose da fare relative al progetto: l'agente può aggiungerne dalle chat e tu puoi crearne di tue."

#: src/features/projects/components/ProjectDetailPage.tsx:142
msgid "Nessuna attività in corso"
msgstr "Nessuna attività in corso"

#: src/features/admin/components/orgs/OrgCostTab.tsx:261
#: src/features/admin/components/UserDetailContent.tsx:752
msgid "Nessuna attività nel periodo."
msgstr "Nessuna attività nel periodo."

#: src/features/sales/components/SalesOverview.tsx:378
msgid "Nessuna attività recente."
msgstr "Nessuna attività recente."

#: src/features/automations/components/AutomationsHub.tsx:349
msgid "Nessuna automazione ancora"
msgstr "Nessuna automazione ancora"

#: src/features/projects/components/ProjectDetailPage.tsx:201
msgid "Nessuna automazione attiva"
msgstr "Nessuna automazione attiva"

#: src/features/admin/components/AdminAutomation.tsx:219
msgid "Nessuna automazione attiva nel periodo."
msgstr "Nessuna automazione attiva nel periodo."

#: src/features/projects/components/sections/AutomationsSection.tsx:247
msgid "Nessuna automazione per questo progetto"
msgstr "Nessuna automazione per questo progetto"

#: src/features/sales/components/crm/CompaniesPanel.tsx:214
msgid "Nessuna azienda ancora — creane una o converti un lead dalla sezione Lead."
msgstr "Nessuna azienda ancora — creane una o converti un lead dalla sezione Lead."

#: src/features/sales/hooks/useProspectingWsBridge.ts:70
msgid "Nessuna azienda nuova per questo profilo (già tutte trovate)."
msgstr "Nessuna azienda nuova per questo profilo (già tutte trovate)."

#: src/features/sales/components/crm/CompaniesPanel.tsx:212
msgid "Nessuna azienda trovata per la ricerca."
msgstr "Nessuna azienda trovata per la ricerca."

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:139
msgid "Nessuna azione"
msgstr "Nessuna azione"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:177
msgid "Nessuna azione dichiarata"
msgstr "Nessuna azione dichiarata"

#: src/features/admin/components/AdminCostTracking.tsx:406
msgid "Nessuna azione evidente: costi già ottimizzati sull'intervallo."
msgstr "Nessuna azione evidente: costi già ottimizzati sull'intervallo."

#: src/features/hive-flows/components/EnterpriseConnectorsField.tsx:42
msgid "Nessuna banca dati collegata. Collegane una da Amministrazione → Connettori."
msgstr "Nessuna banca dati collegata. Collegane una da Amministrazione → Connettori."

#: src/features/sales/components/SalesOverview.tsx:295
msgid "Nessuna campagna"
msgstr "Nessuna campagna"

#: src/features/sales/components/CampaignsPanel.tsx:169
msgid "Nessuna campagna ancora"
msgstr "Nessuna campagna ancora"

#: src/features/sales/components/LeadsPanel.tsx:240
msgid "Nessuna campagna ancora — creane una con \"+ Nuovo → Nuova campagna\"."
msgstr "Nessuna campagna ancora — creane una con \"+ Nuovo → Nuova campagna\"."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:457
msgid "Nessuna cartella {providerLabel} tracciata."
msgstr "Nessuna cartella {providerLabel} tracciata."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:375
msgid "Nessuna cartella selezionata"
msgstr "Nessuna cartella selezionata"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:657
msgid "Nessuna cartella trovata in questa posizione."
msgstr "Nessuna cartella trovata in questa posizione."

#: src/features/sales/components/SignaturesManager.tsx:331
msgid "Nessuna casella email collegata."
msgstr "Nessuna casella email collegata."

#: src/features/dxf/components/DxfCategorySidebar.tsx:39
msgid "Nessuna categoria"
msgstr "Nessuna categoria"

#: src/features/admin/components/CostTraceDetailSection.tsx:204
msgid "Nessuna chiamata trovata per questo trace."
msgstr "Nessuna chiamata trovata per questo trace."

#: src/features/console/pages/LimitsPage.tsx:133
msgid "Nessuna chiave"
msgstr "Nessuna chiave"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:259
msgid "Nessuna colonna data rilevata in questo grafico."
msgstr "Nessuna colonna data rilevata in questo grafico."

#: src/routes/_authed/workspace/connect.index.tsx:235
#: src/routes/_authed/workspace/shares.tsx:162
msgid "Nessuna condivisione ricevuta"
msgstr "Nessuna condivisione ricevuta"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:48
msgid "nessuna conferma"
msgstr "nessuna conferma"

#: src/features/console/pages/ConnectorDetailPage.tsx:424
msgid "Nessuna connessione attiva"
msgstr "Nessuna connessione attiva"

#: src/features/console/components/CreateKeyWizard.tsx:481
msgid "Nessuna connessione attiva: collega un connettore per limitarla qui."
msgstr "Nessuna connessione attiva: collega un connettore per limitarla qui."

#: src/features/console/webhooks/WebhooksPanel.tsx:149
msgid "Nessuna consegna ancora: appariranno qui al primo evento sottoscritto."
msgstr "Nessuna consegna ancora: appariranno qui al primo evento sottoscritto."

#: src/features/chat/components/ConversationSidebar.tsx:481
msgid "Nessuna conversazione ancora"
msgstr "Nessuna conversazione ancora"

#: src/routes/_authed/workspace/conversations.tsx:1089
msgid "Nessuna conversazione attiva in questo canale."
msgstr "Nessuna conversazione attiva in questo canale."

#: src/features/console/pages/SchemaPage.tsx:973
msgid "Nessuna corrispondenza"
msgstr "Nessuna corrispondenza"

#: src/features/dashboard/components/DashboardListSidebar.tsx:565
msgid "Nessuna dashboard"
msgstr "Nessuna dashboard"

#: src/features/dashboard/components/AddChartDialog.tsx:587
msgid "Nessuna dashboard disponibile"
msgstr "Nessuna dashboard disponibile"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:175
msgid "Nessuna data — org gratuita"
msgstr "Nessuna data — org gratuita"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:35
msgid "Nessuna data di validità."
msgstr "Nessuna data di validità."

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:478
msgid "Nessuna decisione registrata"
msgstr "Nessuna decisione registrata"

#: src/routes/_authed/workspace/technical.tsx:591
msgid "Nessuna descrizione registrata · Ando genera automaticamente la descrizione e i blocchi rilevati quando processa il file."
msgstr "Nessuna descrizione registrata · Ando genera automaticamente la descrizione e i blocchi rilevati quando processa il file."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:200
msgid "Nessuna destinazione configurata. Il file resterà nell'archivio interno di Ando."
msgstr "Nessuna destinazione configurata. Il file resterà nell'archivio interno di Ando."

#: src/features/voice_report/components/RunDiffTimeline.tsx:218
msgid "Nessuna differenza semantica fra i due run."
msgstr "Nessuna differenza semantica fra i due run."

#: src/features/clean-control/components/DimensionRadar.tsx:291
msgid "Nessuna dimensione rilevata."
msgstr "Nessuna dimensione rilevata."

#: src/features/sales/components/LeadDetailDrawer.tsx:189
msgid "Nessuna email disponibile"
msgstr "Nessuna email disponibile"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:64
msgid "Nessuna email elaborata."
msgstr "Nessuna email elaborata."

#: src/features/admin/components/AdminCanvas.tsx:205
msgid "Nessuna entità nel periodo."
msgstr "Nessuna entità nel periodo."

#: src/features/sales/components/SuppressionPanel.tsx:104
msgid "Nessuna esclusione"
msgstr "Nessuna esclusione"

#: src/features/console/pages/PlaygroundPage.tsx:1785
msgid "Nessuna esecuzione"
msgstr "Nessuna esecuzione"

#: src/features/hive-flows/run/RunHistoryRail.tsx:280
msgid "Nessuna esecuzione ancora."
msgstr "Nessuna esecuzione ancora."

#: src/features/automations/components/AutomationDetailSection.tsx:113
msgid "Nessuna esecuzione finora."
msgstr "Nessuna esecuzione finora."

#: src/features/settings/components/SelfProfileMemory.tsx:334
msgid "Nessuna estrazione in corso. Nessun fatto viene salvato."
msgstr "Nessuna estrazione in corso. Nessun fatto viene salvato."

#: src/features/console/pages/BillingPage.tsx:584
msgid "Nessuna fattura ancora"
msgstr "Nessuna fattura ancora"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:137
msgid "Nessuna fattura di consumo per questa organizzazione."
msgstr "Nessuna fattura di consumo per questa organizzazione."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:591
msgid "Nessuna fattura emessa per questa organizzazione."
msgstr "Nessuna fattura emessa per questa organizzazione."

#: src/features/billing/components/InvoicesTable.tsx:92
msgid "Nessuna fattura emessa."
msgstr "Nessuna fattura emessa."

#: src/features/sales/components/SignaturesManager.tsx:159
msgid "Nessuna firma ancora. Creane una per le tue email."
msgstr "Nessuna firma ancora. Creane una per le tue email."

#: src/features/sales/components/BatchSendModal.tsx:382
msgid "Nessuna firma configurata."
msgstr "Nessuna firma configurata."

#: src/routes/_authed/route.tsx:1204
msgid "Nessuna fonte associata all'ultima risposta."
msgstr "Nessuna fonte associata all'ultima risposta."

#: src/features/console/pages/OverviewPage.tsx:189
msgid "Nessuna fonte collegata"
msgstr "Nessuna fonte collegata"

#: src/features/connect/components/SpaceCard.tsx:139
msgid "Nessuna fonte condivisa ancora"
msgstr "Nessuna fonte condivisa ancora"

#: src/features/capabilities/useActiveConnectorsCount.ts:47
msgid "Nessuna fonte connessa"
msgstr "Nessuna fonte connessa"

#: src/features/projects/components/sections/KnowledgeSection.tsx:138
msgid "Nessuna fonte fissata sul progetto. Aggiungi connettori o cartelle dalla chat: la prossima conversazione del progetto le erediterà automaticamente."
msgstr "Nessuna fonte fissata sul progetto. Aggiungi connettori o cartelle dalla chat: la prossima conversazione del progetto le erediterà automaticamente."

#: src/features/admin/components/orgs/OrgCostTab.tsx:380
msgid "Nessuna fonte nel periodo."
msgstr "Nessuna fonte nel periodo."

#: src/features/admin/components/AdminCpq.tsx:988
msgid "Nessuna fonte: aggiungi email, documenti, CAD, immagini, messaggistica o fonti strutturate."
msgstr "Nessuna fonte: aggiungi email, documenti, CAD, immagini, messaggistica o fonti strutturate."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:472
msgid "Nessuna identità dell'app configurata. La copertura comparirà dopo la registrazione."
msgstr "Nessuna identità dell'app configurata. La copertura comparirà dopo la registrazione."

#: src/routes/_authed/_modal/integrations/index.tsx:628
msgid "Nessuna integrazione trovata per \"{searchValue}\"."
msgstr "Nessuna integrazione trovata per \"{searchValue}\"."

#: src/features/admin/components/AdminEngagement.tsx:218
msgid "Nessuna iscrizione nel periodo."
msgstr "Nessuna iscrizione nel periodo."

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:399
#: ../../packages/ui/src/editors/ReviewRail.tsx:277
msgid "Nessuna modifica"
msgstr "Nessuna modifica"

#: src/features/console/pages/ResourceAccessPage.tsx:940
msgid "Nessuna modifica da salvare"
msgstr "Nessuna modifica da salvare"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:359
msgid "Nessuna modifica è stata ancora scritta. File: {fileName}"
msgstr "Nessuna modifica è stata ancora scritta. File: {fileName}"

#: src/features/sources/components/AISummaryPanel.tsx:830
msgid "Nessuna modifica in attesa"
msgstr "Nessuna modifica in attesa"

#: src/features/admin/components/AdminDecksAskAndo.tsx:168
msgid "Nessuna modifica proposta."
msgstr "Nessuna modifica proposta."

#: ../../packages/ui/src/editors/ReviewRail.tsx:500
msgid "Nessuna modifica proposta. Le suggestioni di Ando appariranno qui."
msgstr "Nessuna modifica proposta. Le suggestioni di Ando appariranno qui."

#: src/features/admin/components/AdminCpqAskAndo.tsx:298
msgid "Nessuna modifica rispetto all'editor"
msgstr "Nessuna modifica rispetto all'editor"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:216
msgid "Nessuna modifica specificata."
msgstr "Nessuna modifica specificata."

#: src/features/sales/hooks/useProspectingWsBridge.ts:78
msgid "Nessuna nuova email trovata per i lead senza contatto."
msgstr "Nessuna nuova email trovata per i lead senza contatto."

#: src/features/sales/components/crm/RecordDrawer.tsx:273
msgid "Nessuna opportunità collegata."
msgstr "Nessuna opportunità collegata."

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:176
msgid "Nessuna org disponibile"
msgstr "Nessuna org disponibile"

#: src/features/admin/components/AdminOrgs.tsx:981
msgid "Nessuna organizzazione attiva nel periodo"
msgstr "Nessuna organizzazione attiva nel periodo"

#: src/features/admin/components/AdminOrgs.tsx:980
msgid "Nessuna organizzazione corrisponde ai filtri"
msgstr "Nessuna organizzazione corrisponde ai filtri"

#: src/features/account/components/OrgSwitcherDialog.tsx:205
msgid "Nessuna organizzazione corrisponde."
msgstr "Nessuna organizzazione corrisponde."

#: src/features/sync/components/picker/NotionPickerModal.tsx:133
msgid "Nessuna pagina accessibile in questo workspace."
msgstr "Nessuna pagina accessibile in questo workspace."

#: src/features/sync/components/picker/NotionPickerModal.tsx:132
msgid "Nessuna pagina corrisponde alla ricerca."
msgstr "Nessuna pagina corrisponde alla ricerca."

#: src/routes/_authed/workspace/conversations.tsx:1079
msgid "Nessuna PEC oggi"
msgstr "Nessuna PEC oggi"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:43
msgid "Nessuna PoC e nessun pilota: manca la prima fase."
msgstr "Nessuna PoC e nessun pilota: manca la prima fase."

#: src/features/clean-control/components/policies/PoliciesEditor.tsx:111
msgid "Nessuna policy configurata. Ando resta in Modalità Manuale."
msgstr "Nessuna policy configurata. Ando resta in Modalità Manuale."

#: src/features/console/pages/MembersPage.tsx:473
msgid "Nessuna postazione libera"
msgstr "Nessuna postazione libera"

#: src/features/admin/components/AdminDecks.tsx:206
msgid "Nessuna presentazione archiviata."
msgstr "Nessuna presentazione archiviata."

#: src/features/admin/components/AdminDecks.tsx:206
msgid "Nessuna presentazione."
msgstr "Nessuna presentazione."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:481
msgid "Nessuna preview disponibile"
msgstr "Nessuna preview disponibile"

#: src/routes/_authed/workspace/work.tsx:593
msgid "Nessuna proposta"
msgstr "Nessuna proposta"

#: src/features/billing/components/UsageInsightsCard.tsx:143
#: src/features/billing/components/UsageInsightsCard.tsx:250
msgid "Nessuna query ancora questo mese."
msgstr "Nessuna query ancora questo mese."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:566
msgid "Nessuna raccolta disponibile."
msgstr "Nessuna raccolta disponibile."

#: src/features/connectors/wizards/pecSpec.tsx:67
msgid "Nessuna re-inoltro automatico — Ando legge, l'utente decide."
msgstr "Nessuna re-inoltro automatico — Ando legge, l'utente decide."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:1062
msgid "Nessuna regola di progettazione ancora caricata"
msgstr "Nessuna regola di progettazione ancora caricata"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:417
msgid "Nessuna regola in questo set."
msgstr "Nessuna regola in questo set."

#: src/features/console/pages/KeyDetailPage.tsx:364
msgid "Nessuna restrizione applicata."
msgstr "Nessuna restrizione applicata."

#: src/routes/_authed/workspace/technical.tsx:651
msgid "Nessuna revisione · il disegno è nello stato originale."
msgstr "Nessuna revisione · il disegno è nello stato originale."

#: src/features/console/pages/PlaygroundPage.tsx:1327
msgid "Nessuna richiesta"
msgstr "Nessuna richiesta"

#: src/features/console/pages/TracesPage.tsx:592
msgid "Nessuna richiesta disponibile"
msgstr "Nessuna richiesta disponibile"

#: ../../packages/ui/src/ando/EditableTable.tsx:251
msgid "Nessuna riga"
msgstr "Nessuna riga"

#: ../../packages/ui/src/ando/DataPagedTable.tsx:188
msgid "Nessuna riga restituita"
msgstr "Nessuna riga restituita"

#: src/features/console/pages/AccessOverviewPage.tsx:289
msgid "Nessuna risorsa corrisponde alla ricerca."
msgstr "Nessuna risorsa corrisponde alla ricerca."

#: src/features/console/pages/AccessOverviewPage.tsx:234
msgid "Nessuna risorsa in questa categoria."
msgstr "Nessuna risorsa in questa categoria."

#: src/features/console/pages/AccessOverviewPage.tsx:288
msgid "Nessuna risorsa in questa pagina. Controlla anche le pagine successive."
msgstr "Nessuna risorsa in questa pagina. Controlla anche le pagine successive."

#: src/features/connect/components/ConnectChat.tsx:173
msgid "Nessuna risposta disponibile."
msgstr "Nessuna risposta disponibile."

#: src/features/workspace/components/TaskComposer.tsx:195
msgid "Nessuna scadenza"
msgstr "Nessuna scadenza"

#: src/routes/_authed/workspace/finance.tsx:1767
msgid "Nessuna scadenza nei prossimi 30 giorni. Interroga il Cassetto via chat per uno storico completo."
msgstr "Nessuna scadenza nei prossimi 30 giorni. Interroga il Cassetto via chat per uno storico completo."

#: src/routes/_authed/workspace/work.tsx:441
msgid "Nessuna scadenza o task per oggi."
msgstr "Nessuna scadenza o task per oggi."

#: src/features/help/components/ShortcutsList.tsx:306
msgid "Nessuna scorciatoia corrisponde a “{query}”."
msgstr "Nessuna scorciatoia corrisponde a “{query}”."

#: src/features/hive-flows/components/EnterpriseConnectorsField.tsx:80
msgid "Nessuna selezione = cerca su tutte le banche dati attive."
msgstr "Nessuna selezione = cerca su tutte le banche dati attive."

#: src/features/dashboard/components/AxisConfigurator.tsx:351
msgid "Nessuna selezione: rilevamento automatico."
msgstr "Nessuna selezione: rilevamento automatico."

#: src/features/dashboard/components/AxisConfigurator.tsx:436
msgid "Nessuna serie rilevata. Esegui prima il grafico per configurare i colori."
msgstr "Nessuna serie rilevata. Esegui prima il grafico per configurare i colori."

#: src/features/settings/components/SecuritySettings.tsx:324
msgid "Nessuna sessione attiva."
msgstr "Nessuna sessione attiva."

#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:125
msgid "Nessuna settimana nel periodo selezionato."
msgstr "Nessuna settimana nel periodo selezionato."

#: src/features/console/pages/DocsPage.tsx:559
msgid "Nessuna sezione corrisponde alla ricerca. Prova un termine più generico."
msgstr "Nessuna sezione corrisponde alla ricerca. Prova un termine più generico."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:149
msgid "Nessuna sezione extra."
msgstr "Nessuna sezione extra."

#: src/features/console/connectors/CustomConnectorDetail.tsx:121
msgid "Nessuna sincronizzazione"
msgstr "Nessuna sincronizzazione"

#: src/features/console/pages/OverviewPage.tsx:367
msgid "Nessuna sincronizzazione recente"
msgstr "Nessuna sincronizzazione recente"

#: src/features/skills/components/TeamSkillsCatalog.tsx:87
msgid "Nessuna skill condivisa dal team"
msgstr "Nessuna skill condivisa dal team"

#: src/features/sources/marp/SlideDeckProposalMount.tsx:201
msgid "Nessuna slide da confermare"
msgstr "Nessuna slide da confermare"

#: src/features/sources/marp/ManualDeckEditMount.tsx:98
msgid "Nessuna slide da salvare"
msgstr "Nessuna slide da salvare"

#: src/features/console/pages/SchemaPage.tsx:916
msgid "Nessuna sorgente collegata"
msgstr "Nessuna sorgente collegata"

#: src/features/console/pages/PlaygroundPage.tsx:585
msgid "Nessuna sorgente collegata pubblicata per questo progetto."
msgstr "Nessuna sorgente collegata pubblicata per questo progetto."

#: src/features/console/pages/SchemaPage.tsx:974
msgid "Nessuna sorgente per questi filtri."
msgstr "Nessuna sorgente per questi filtri."

#: src/features/console/pages/KeyDetailPage.tsx:73
msgid "Nessuna sovrapposizione (revoca subito)"
msgstr "Nessuna sovrapposizione (revoca subito)"

#: src/routes/_authed/workspace/finance.tsx:1562
msgid "Nessuna spesa nel mese. Le categorie compaiono quando arrivano i primi movimenti di uscita."
msgstr "Nessuna spesa nel mese. Le categorie compaiono quando arrivano i primi movimenti di uscita."

#: src/features/workspace/finance/components/CategorySpendBreakdown.tsx:74
msgid "Nessuna spesa nel periodo. Le categorie compaiono quando arrivano i primi movimenti di uscita."
msgstr "Nessuna spesa nel periodo. Le categorie compaiono quando arrivano i primi movimenti di uscita."

#: src/features/clean-control/components/EventDetailSheet.tsx:335
msgid "Nessuna spiegazione automatica per questo segnale. Consulta i dettagli tecnici qui sotto."
msgstr "Nessuna spiegazione automatica per questo segnale. Consulta i dettagli tecnici qui sotto."

#: src/features/connectors/components/management/SchemaViewer.tsx:189
msgid "Nessuna tabella corrisponde a \"{debouncedSearch}\"."
msgstr "Nessuna tabella corrisponde a \"{debouncedSearch}\"."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:246
msgid "Nessuna tabella trovata. Verifica permessi e schema del connettore."
msgstr "Nessuna tabella trovata. Verifica permessi e schema del connettore."

#: src/features/report/components/ComparisonGrid.tsx:152
msgid "Nessuna variazione"
msgstr "Nessuna variazione"

#: src/features/clean-control/components/QualityScoreStat.tsx:151
msgid "Nessuna variazione registrata"
msgstr "Nessuna variazione registrata"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:139
msgid "Nessuna versione disponibile."
msgstr "Nessuna versione disponibile."

#: src/features/hive-flows/components/FlowVersionMenu.tsx:110
msgid "Nessuna versione salvata ancora."
msgstr "Nessuna versione salvata ancora."

#: src/features/automations/components/AutomationDetailSection.tsx:225
msgid "Nessuna voce di audit."
msgstr "Nessuna voce di audit."

#: src/features/price-lists/components/PriceListsPage.tsx:537
msgid "Nessuna voce in questo listino."
msgstr "Nessuna voce in questo listino."

#: src/features/settings/components/BrandKitSettings.tsx:790
msgid "Nessuna voce personalizzata. Le voci predefinite sono sempre disponibili nel selettore sopra."
msgstr "Nessuna voce personalizzata. Le voci predefinite sono sempre disponibili nel selettore sopra."

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:145
msgid "Nessuna voce prezzata"
msgstr "Nessuna voce prezzata"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:297
#: src/features/admin/components/AdminCpq.tsx:866
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1685
#: src/features/connect/components/GrantManager.tsx:711
#: src/features/sales/components/crm/CreateDealDialog.tsx:199
#: src/features/sales/components/crm/DealDetailDrawer.tsx:226
msgid "Nessuno"
msgstr "Nessuno"

#: src/features/settings/components/BrandKitSettings.tsx:451
msgid "Nessuno (predefinito)"
msgstr "Nessuno (predefinito)"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:381
msgid "Nessuno (solo webhook)"
msgstr "Nessuno (solo webhook)"

#: src/features/admin/components/AdminCpq.tsx:885
msgid "Nessuno (vendita diretta o sconto manuale)"
msgstr "Nessuno (vendita diretta o sconto manuale)"

#: src/routes/_authed/workspace/documents.tsx:712
msgid "Nessuno dei {failed} file rimosso. Riprova."
msgstr "Nessuno dei {failed} file rimosso. Riprova."

#: src/features/connectors/components/management/SchemaViewer.tsx:880
msgid "Nessuno schema scoperto."
msgstr "Nessuno schema scoperto."

#: src/features/console/pages/ModelsPage.tsx:428
msgid "Nessuno scopo configurabile"
msgstr "Nessuno scopo configurabile"

#: src/features/sources/components/CalendarEventPane.tsx:697
msgid "Nessuno slot libero nei prossimi 5 giorni."
msgstr "Nessuno slot libero nei prossimi 5 giorni."

#. placeholder {0}: debouncedQuery.trim()
#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:647
msgid "Nessuno stile corrisponde a “{0}”."
msgstr "Nessuno stile corrisponde a “{0}”."

#: src/features/settings/MarpTemplateSettings.tsx:343
msgid "Nessuno stile disponibile al momento."
msgstr "Nessuno stile disponibile al momento."

#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:176
msgid "Netto"
msgstr "Netto"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:826
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1602
msgid "Neutra"
msgstr "Neutra"

#: src/features/projects/components/sections/PersonaSection.tsx:354
msgid "Neutro"
msgstr "Neutro"

#: src/features/chat/components/ChatTopBar.tsx:247
msgid "Niente da mostrare: allega un file o fai una domanda sui tuoi documenti."
msgstr "Niente da mostrare: allega un file o fai una domanda sui tuoi documenti."

#: src/routes/_authed/workspace/work.tsx:507
msgid "Niente in programma"
msgstr "Niente in programma"

#: src/features/connectors/wizards/calendarSpec.tsx:86
msgid "Niente lettura di partecipanti esterni o eventi privati senza consenso."
msgstr "Niente lettura di partecipanti esterni o eventi privati senza consenso."

#: src/features/voice_report/components/NewReportDialog.tsx:690
msgid "Niente upload: Ando analizza la base dati che hai già — documenti, email, chat e memoria."
msgstr "Niente upload: Ando analizza la base dati che hai già — documenti, email, chat e memoria."

#: src/features/admin/components/AdminCpqAskAndo.tsx:264
msgid "Niente viene salvato finché non applichi la proposta e salvi la bozza."
msgstr "Niente viene salvato finché non applichi la proposta e salvi la bozza."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:159
msgid "NIST SP 800-63B — lunghezza prima di complessità."
msgstr "NIST SP 800-63B — lunghezza prima di complessità."

#: ../../packages/ui/src/ando/DataPagedTable.tsx:103
#: ../../packages/ui/src/cad/CadBlockAccordion.tsx:58
#: src/features/console/pages/PlaygroundPage.tsx:948
#: src/features/dashboard/components/wizard/WizardStepData.tsx:529
msgid "no"
msgstr "no"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:21
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1246
#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:45
#: src/features/admin/components/AdminCpqAskAndo.tsx:190
#: src/features/automations/components/AutomationDetailSection.tsx:170
#: src/features/connectors/components/_spreadsheet/types.tsx:151
#: src/features/console/pages/FlowDetailPage.tsx:223
#: src/features/hive-flows/components/FlowNodeCard.tsx:89
msgid "No"
msgstr "No"

#: src/routes/_authed/_modal/settings/help.tsx:90
msgid "No. Le conversazioni e i dati dei tuoi connettori non vengono usati per addestrare modelli di terze parti. Maggiori dettagli su privacy, retention e log access trail in Impostazioni → Privacy & dati."
msgstr "No. Le conversazioni e i dati dei tuoi connettori non vengono usati per addestrare modelli di terze parti. Maggiori dettagli su privacy, retention e log access trail in Impostazioni → Privacy & dati."

#: src/features/admin/components/AdminCpq.tsx:660
#: src/features/admin/components/AdminCpqPriceBook.tsx:243
#: src/features/admin/components/AdminCpqPriceBook.tsx:274
#: src/features/admin/components/AdminCpqPriceBook.tsx:300
#: src/features/admin/components/AdminCpqPriceBook.tsx:338
#: src/features/admin/components/AdminDecks.tsx:326
#: src/features/admin/components/AdminOrgs.tsx:1138
#: src/features/admin/components/deckEditor/DeckEditor.tsx:977
#: src/features/admin/components/orgs/OrgBillingTab.tsx:538
#: src/features/agent-modes/components/AgentModeEditor.tsx:319
#: src/features/automations/components/CreateAutomationDialog.tsx:182
#: src/features/connect/components/CreateSpaceDialog.tsx:130
#: src/features/console/components/CreateKeyWizard.tsx:279
#: src/features/console/connectors/CustomConnectorDetail.tsx:761
#: src/features/console/connectors/CustomConnectorsPanel.tsx:256
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:270
#: src/features/console/pages/DocumentsPage.tsx:749
#: src/features/console/pages/FlowsPage.tsx:811
#: src/features/console/pages/KeysPage.tsx:116
#: src/features/hive-flows/components/FlowFormPublish.tsx:65
#: src/features/sales/components/CampaignsPanel.tsx:185
#: src/features/sales/components/crm/CompaniesPanel.tsx:89
#: src/features/sales/components/crm/CompaniesPanel.tsx:224
#: src/features/sales/components/crm/ContactsPanel.tsx:233
#: src/features/sales/components/crm/CreateDealDialog.tsx:122
#: src/features/sales/components/crm/RecordDrawer.tsx:57
#: src/features/sales/components/crm/RecordDrawer.tsx:63
#: src/features/sales/components/SignaturesManager.tsx:242
#: src/features/sales/components/TemplateManager.tsx:251
#: src/features/settings/components/PresentationTemplates.tsx:750
#: src/features/settings/components/ProfileSettings.tsx:105
#: src/features/skills/components/SkillEditor.tsx:325
#: src/features/templates/components/CreateTemplateDialog.tsx:135
#: src/features/templates/components/TemplateEditor.tsx:216
msgid "Nome"
msgstr "Nome"

#: src/features/settings/components/ProfileSettings.tsx:69
msgid "nome · email · lingua · notifiche"
msgstr "nome · email · lingua · notifiche"

#: src/features/admin/components/AdminDemoInviti.tsx:364
msgid "Nome (opzionale)"
msgstr "Nome (opzionale)"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:188
msgid "Nome (slug)"
msgstr "Nome (slug)"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:372
msgid "Nome automation"
msgstr "Nome automation"

#: src/features/sales/components/crm/CompaniesPanel.tsx:96
msgid "Nome azienda"
msgstr "Nome azienda"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:226
msgid "Nome brand"
msgstr "Nome brand"

#: src/features/sales/components/CampaignsPanel.tsx:107
#: src/features/sales/components/CreateCampaignDialog.tsx:82
#: src/features/sales/components/CreateCampaignDialog.tsx:89
msgid "Nome campagna"
msgstr "Nome campagna"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:276
msgid "Nome colonna"
msgstr "Nome colonna"

#: src/features/admin/components/UserDetailContent.tsx:825
#: src/features/sales/components/crm/ContactsPanel.tsx:91
#: src/features/sales/components/crm/ContactsPanel.tsx:98
msgid "Nome completo"
msgstr "Nome completo"

#: src/features/console/pages/ResourceAccessPage.tsx:278
msgid "Nome connessione"
msgstr "Nome connessione"

#: src/features/dashboard/hooks/useCreateChart.ts:140
msgid "Nome dashboard mancante."
msgstr "Nome dashboard mancante."

#: src/features/dashboard/components/DashboardListSidebar.tsx:413
msgid "Nome dashboard…"
msgstr "Nome dashboard…"

#: src/features/connectors/wizards/databaseSpec.tsx:72
msgid "Nome database"
msgstr "Nome database"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:296
#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:297
msgid "Nome del beneficiario"
msgstr "Nome del beneficiario"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:254
msgid "Nome del connettore"
msgstr "Nome del connettore"

#: src/features/connectors/wizards/accountingSpec.tsx:52
msgid "Nome del database aziendale SAP B1 (selettore società nel client SAP)."
msgstr "Nome del database aziendale SAP B1 (selettore società nel client SAP)."

#: src/features/admin/components/AdminCpqPriceBook.tsx:285
msgid "Nome del nuovo PoC"
msgstr "Nome del nuovo PoC"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:424
msgid "Nome del nuovo progetto"
msgstr "Nome del nuovo progetto"

#: src/features/admin/components/AdminCpqPriceBook.tsx:254
msgid "Nome del nuovo taglio"
msgstr "Nome del nuovo taglio"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:645
msgid "Nome del preset"
msgstr "Nome del preset"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:415
msgid "Nome del progetto"
msgstr "Nome del progetto"

#: src/features/templates/components/TemplateEditor.tsx:224
#: src/routes/_authed/workspace/templates/$kind.tsx:318
msgid "Nome del template"
msgstr "Nome del template"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:394
msgid "Nome dell'app"
msgstr "Nome dell'app"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:237
msgid "Nome dell'azione"
msgstr "Nome dell'azione"

#: src/features/admin/components/AdminCpqPriceBook.tsx:362
msgid "Nome della nuova fonte (es. Ticket, Wiki, Modelli 3D)"
msgstr "Nome della nuova fonte (es. Ticket, Wiki, Modelli 3D)"

#: src/features/admin/components/AdminDecks.tsx:493
msgid "Nome della presentazione"
msgstr "Nome della presentazione"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:250
msgid "Nome della prima fase"
msgstr "Nome della prima fase"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:855
msgid "Nome della slide (non visibile)"
msgstr "Nome della slide (non visibile)"

#: src/features/console/pages/SchemaPage.tsx:127
msgid "Nome della sorgente"
msgstr "Nome della sorgente"

#: src/features/connectors/wizards/databaseSpec.tsx:113
msgid "Nome DSN registrato sull'agente — opzionale se compili la stringa sotto."
msgstr "Nome DSN registrato sull'agente — opzionale se compili la stringa sotto."

#: src/features/onboarding/DemoBookCallModal.tsx:400
msgid "Nome e cognome"
msgstr "Nome e cognome"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:518
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:521
#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:193
#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:194
msgid "Nome file"
msgstr "Nome file"

#: src/features/console/connectors/ManifestConfigForm.tsx:127
msgid "Nome header"
msgstr "Nome header"

#. placeholder {0}: idx + 1
#: src/features/admin/components/AdminPlatformSettings.tsx:249
msgid "Nome modello riga {0}"
msgstr "Nome modello riga {0}"

#: src/features/dashboard/components/AddChartDialog.tsx:612
#: src/features/dashboard/components/AddChartDialog.tsx:613
#: src/features/dashboard/components/DashboardListSidebar.tsx:412
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:336
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:337
msgid "Nome nuova dashboard"
msgstr "Nome nuova dashboard"

#: src/features/dashboard/utils/calculatedFields.ts:315
msgid "Nome obbligatorio"
msgstr "Nome obbligatorio"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:97
msgid "Nome obbligatorio."
msgstr "Nome obbligatorio."

#: src/features/sales/components/crm/CreateDealDialog.tsx:129
#: src/features/sales/components/crm/DealDetailDrawer.tsx:99
msgid "Nome opportunità"
msgstr "Nome opportunità"

#: src/features/console/pages/EngineSignupPage.tsx:137
#: src/features/settings/components/OrganizationSettings.tsx:223
msgid "Nome organizzazione"
msgstr "Nome organizzazione"

#: src/features/clean-control/components/policies/PolicyForm.tsx:194
msgid "Nome policy"
msgstr "Nome policy"

#: src/features/projects/components/NewProjectDialog.tsx:116
msgid "Nome progetto"
msgstr "Nome progetto"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:250
msgid "Nome provider"
msgstr "Nome provider"

#. placeholder {0}: k + 1
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2177
msgid "Nome serie {0}"
msgstr "Nome serie {0}"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:866
msgid "Nome visualizzato"
msgstr "Nome visualizzato"

#: src/features/settings/components/BrandKitSettings.tsx:814
msgid "Nome voce (es. Formale Acme)"
msgstr "Nome voce (es. Formale Acme)"

#: src/features/sales/components/TemplateManager.tsx:117
msgid "Nome, oggetto e testo sono obbligatori"
msgstr "Nome, oggetto e testo sono obbligatori"

#: src/features/settings/components/OrgMembersPanel.tsx:539
msgid "nome.cognome@azienda.it"
msgstr "nome.cognome@azienda.it"

#: src/features/admin/components/AdminCpq.tsx:1195
#: src/features/admin/components/AdminCpq.tsx:1203
#: src/features/connect/components/MemberManager.tsx:442
#: src/features/sales/components/CreateLeadDialog.tsx:198
#: src/features/sales/components/crm/ContactsPanel.tsx:111
msgid "nome@azienda.it"
msgstr "nome@azienda.it"

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:139
msgid "nome@esempio.com"
msgstr "nome@esempio.com"

#: src/features/admin/components/orgs/OrgAuditTab.tsx:47
msgid "non ancora esposto. La tabella è pronta e si popola automaticamente quando il BE espone il rotolo eventi."
msgstr "non ancora esposto. La tabella è pronta e si popola automaticamente quando il BE espone il rotolo eventi."

#: src/features/sales/components/AssigneePicker.tsx:85
msgid "Non assegnato"
msgstr "Non assegnato"

#: src/features/console/components/StatusBadges.tsx:109
msgid "Non avviata"
msgstr "Non avviata"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:459
msgid "Non c'è codice da eseguire"
msgstr "Non c'è codice da eseguire"

#: src/features/console/pages/ResourceAccessPage.tsx:723
msgid "Non ci sono altri membri attivi da aggiungere."
msgstr "Non ci sono altri membri attivi da aggiungere."

#: src/features/sales/hooks/useCrmQueries.ts:370
msgid "Non ci sono ancora abbastanza dati per arricchire questo record"
msgstr "Non ci sono ancora abbastanza dati per arricchire questo record"

#: src/features/console/pages/PlaygroundPage.tsx:1215
msgid "Non ci sono contenuti sufficienti per questa risposta. Controlla le fonti selezionate, il loro aggiornamento e i permessi di accesso."
msgstr "Non ci sono contenuti sufficienti per questa risposta. Controlla le fonti selezionate, il loro aggiornamento e i permessi di accesso."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:477
msgid "Non ci sono membri attivi da associare. Aggiungi o riattiva un membro, poi torna qui."
msgstr "Non ci sono membri attivi da associare. Aggiungi o riattiva un membro, poi torna qui."

#: src/features/console/pages/OverviewPage.tsx:295
msgid "Non ci sono nuovi caricamenti da mostrare. Puoi esplorare i contenuti indicizzati o provarli nel Playground."
msgstr "Non ci sono nuovi caricamenti da mostrare. Puoi esplorare i contenuti indicizzati o provarli nel Playground."

#: src/features/console/pages/TracesPage.tsx:594
msgid "Non ci sono trace visibili con questo filtro e il tuo accesso."
msgstr "Non ci sono trace visibili con questo filtro e il tuo accesso."

#: src/features/workspace/finance/components/CategorySpendBreakdown.tsx:88
msgid "Non classificato"
msgstr "Non classificato"

#: src/features/console/components/ProviderAccounts.tsx:123
#: src/routes/_authed/workspace/finance.tsx:912
msgid "Non collegato"
msgstr "Non collegato"

#: src/features/sales/components/CampaignSharing.tsx:121
msgid "Non condivisa con altri membri."
msgstr "Non condivisa con altri membri."

#: src/features/admin/components/AdminBilling.tsx:105
msgid "Non configurato — imposta METRONOME_API_KEY sul backend per abilitarlo."
msgstr "Non configurato — imposta METRONOME_API_KEY sul backend per abilitarlo."

#: src/features/console/components/StatusBadges.tsx:129
#: src/features/console/components/StatusBadges.tsx:130
msgid "Non connesso"
msgstr "Non connesso"

#: src/features/console/webhooks/WebhooksPanel.tsx:660
msgid "Non consegnato"
msgstr "Non consegnato"

#: src/features/hive-flows/components/ConditionBuilder.tsx:103
msgid "non contiene"
msgstr "non contiene"

#: src/features/console/pages/ConnectorDetailPage.tsx:549
msgid "Non disponibile"
msgstr "Non disponibile"

#: src/features/console/docs/content.ts:781
msgid "Non distruttivo: il contenuto già indicizzato resta ricercabile."
msgstr "Non distruttivo: il contenuto già indicizzato resta ricercabile."

#: src/features/connectors/components/management/SchemaViewer.tsx:538
msgid "non documentato"
msgstr "non documentato"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:211
msgid "non è reversibile"
msgstr "non è reversibile"

#: src/features/sources/components/ArtifactPane.tsx:2276
msgid "Non è stato possibile generare la sintesi di questo documento."
msgstr "Non è stato possibile generare la sintesi di questo documento."

#: src/features/console/pages/ConnectorDetailPage.tsx:569
msgid "Non è stato possibile leggere la struttura attuale. Riprova prima di avviare."
msgstr "Non è stato possibile leggere la struttura attuale. Riprova prima di avviare."

#: src/features/chat/hooks/useMessageActions.ts:111
msgid "Non è stato possibile registrare il tuo feedback. Riprova tra poco."
msgstr "Non è stato possibile registrare il tuo feedback. Riprova tra poco."

#: src/features/settings/components/MemoryConsentBanner.tsx:153
msgid "Non è stato possibile registrare la tua scelta. Riprova."
msgstr "Non è stato possibile registrare la tua scelta. Riprova."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:156
msgid "Non fatturata"
msgstr "Non fatturata"

#: src/features/settings/marp/CssUploadPanel.tsx:256
msgid "Non hai ancora caricato nessun template personalizzato."
msgstr "Non hai ancora caricato nessun template personalizzato."

#: src/features/hive-flows/components/FlowShareControl.tsx:160
msgid "Non hai ancora nessun progetto."
msgstr "Non hai ancora nessun progetto."

#: src/features/projects/components/ProjectHub.tsx:458
msgid "Non hai ancora progetti. Partiamo da un template, oppure uno vuoto."
msgstr "Non hai ancora progetti. Partiamo da un template, oppure uno vuoto."

#: src/features/console/pages/ResourceAccessPage.tsx:588
msgid "Non hai ancora scelto nessuno. Il documento resta accessibile solo al proprietario."
msgstr "Non hai ancora scelto nessuno. Il documento resta accessibile solo al proprietario."

#: src/features/console/pages/ResourceAccessPage.tsx:593
msgid "Non hai ancora scelto nessuno. La connessione resta accessibile solo al proprietario."
msgstr "Non hai ancora scelto nessuno. La connessione resta accessibile solo al proprietario."

#: src/features/skills/components/SkillsList.tsx:240
msgid "Non hai ancora skill salvate"
msgstr "Non hai ancora skill salvate"

#: src/features/console/pages/ResourceAccessPage.tsx:772
msgid "Non hai ancora un'app. Creala nella sezione Utenti della tua app prima di assegnare accessi."
msgstr "Non hai ancora un'app. Creala nella sezione Utenti della tua app prima di assegnare accessi."

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:184
msgid "Non ho abbastanza dettagli per rispondere con certezza. Scegli un'opzione e riprovo."
msgstr "Non ho abbastanza dettagli per rispondere con certezza. Scegli un'opzione e riprovo."

#: src/features/skills/components/TeamSkillsCatalog.tsx:155
msgid "Non in uso"
msgstr "Non in uso"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:450
msgid "Non inserire ando_session, ando_status o ando_proof: sono riservati al callback."
msgstr "Non inserire ando_session, ando_status o ando_proof: sono riservati al callback."

#: src/features/sources/components/EmailThreadMessages.tsx:258
#: src/features/workspace/components/InboxItemRow.tsx:174
msgid "Non letto"
msgstr "Non letto"

#: src/features/settings/components/AccountDeletion.tsx:41
msgid "Non lo uso più"
msgstr "Non lo uso più"

#: src/features/clean-control/components/SignalHealthCard.tsx:146
msgid "Non mostrare"
msgstr "Non mostrare"

#: src/features/onboarding/SectionGuide.tsx:169
msgid "Non mostrare più questi aiuti"
msgstr "Non mostrare più questi aiuti"

#: src/features/settings/components/MemoryConsentBanner.tsx:144
msgid "Non ora"
msgstr "Non ora"

#: src/features/billing/components/CurrentPlanCard.tsx:58
msgid "Non pagato"
msgstr "Non pagato"

#: src/features/settings/components/SelfProfileMemory.tsx:83
msgid "Non più utile"
msgstr "Non più utile"

#: src/features/projects/components/sections/MembersSection.tsx:141
msgid "Non potrai più vedere conversazioni, attività e memoria di questo progetto fino a un nuovo invito."
msgstr "Non potrai più vedere conversazioni, attività e memoria di questo progetto fino a un nuovo invito."

#: src/features/connect/components/ChatbotPanel.tsx:101
msgid "Non pubblicato"
msgstr "Non pubblicato"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:285
msgid "non può essere annullata"
msgstr "non può essere annullata"

#: src/features/console/pages/MembersPage.tsx:522
msgid "Non puoi modificare la tua stessa iscrizione."
msgstr "Non puoi modificare la tua stessa iscrizione."

#. placeholder {0}: f.name
#. placeholder {0}: file.name
#: src/features/admin/components/AdminDecks.tsx:383
#: src/features/admin/components/AdminDecks.tsx:442
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2595
#: src/features/admin/components/PageEditor.tsx:132
#: src/features/admin/components/PageEditor.tsx:381
msgid "Non riesco a leggere {0}"
msgstr "Non riesco a leggere {0}"

#: src/features/clean-control/components/EventQueue.tsx:498
msgid "Non riesco a raggiungere il ledger degli eventi qualità."
msgstr "Non riesco a raggiungere il ledger degli eventi qualità."

#: src/features/console/pages/EngineSignupPage.tsx:172
msgid "Non riesco a verificare la tua organizzazione. Riprova prima di continuare."
msgstr "Non riesco a verificare la tua organizzazione. Riprova prima di continuare."

#: src/features/console/components/TopupReturnStatus.tsx:95
msgid "Non riesco ancora a verificare il pagamento. Non ripetere la ricarica; riprova la verifica."
msgstr "Non riesco ancora a verificare il pagamento. Non ripetere la ricarica; riprova la verifica."

#: src/features/billing/components/InvoicesTable.tsx:35
#: src/features/console/components/StatusBadges.tsx:260
msgid "Non riscuotibile"
msgstr "Non riscuotibile"

#: src/features/connect/components/ConnectMessageThread.tsx:140
msgid "Non riusciamo a caricare la discussione. Riprova più tardi."
msgstr "Non riusciamo a caricare la discussione. Riprova più tardi."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:160
msgid "Non riusciamo a caricare questo spazio. Potrebbe essere stato archiviato o l'accesso è stato revocato."
msgstr "Non riusciamo a caricare questo spazio. Potrebbe essere stato archiviato o l'accesso è stato revocato."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:477
msgid "Non riusciamo a verificare le AppKey. Controllale prima di attendere il sync."
msgstr "Non riusciamo a verificare le AppKey. Controllale prima di attendere il sync."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:243
msgid "Non riuscita"
msgstr "Non riuscita"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:394
msgid "non sarà più valido. Per re-invitare l'utente bisogna inviare un nuovo invito."
msgstr "non sarà più valido. Per re-invitare l'utente bisogna inviare un nuovo invito."

#: src/features/share/components/ShareLinkDialog.tsx:95
#: src/features/share/components/ShareLinkRow.tsx:89
msgid "Non scade"
msgstr "Non scade"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:88
msgid "Non si ripete"
msgstr "Non si ripete"

#: src/routes/connect.invite.$token.tsx:230
msgid "Non siamo riusciti a caricare l'invito. Riprova tra poco."
msgstr "Non siamo riusciti a caricare l'invito. Riprova tra poco."

#: src/features/onboarding/DemoBookCallModal.tsx:251
msgid "Non siamo riusciti a inviare la richiesta. Riprova tra un attimo."
msgstr "Non siamo riusciti a inviare la richiesta. Riprova tra un attimo."

#: src/routes/connect.invite.$token.tsx:144
msgid "Non siamo riusciti ad accettare l'invito. Riprova."
msgstr "Non siamo riusciti ad accettare l'invito. Riprova."

#: src/routes/public.voice-report.$token.tsx:354
msgid "Non siamo riusciti ad aprire il report. Riprova tra poco."
msgstr "Non siamo riusciti ad aprire il report. Riprova tra poco."

#: src/routes/connect.chatbot.$publicToken.tsx:116
msgid "Non siamo riusciti ad avviare l'assistente. Riprova tra poco."
msgstr "Non siamo riusciti ad avviare l'assistente. Riprova tra poco."

#: src/features/automations/components/ScheduleEditor.tsx:103
#: src/features/automations/components/ScheduleEditor.tsx:122
msgid "Non sono riuscito a capire la frase."
msgstr "Non sono riuscito a capire la frase."

#: src/features/skills/components/TeamSkillsCatalog.tsx:61
msgid "Non sono riuscito a caricare le skill del team."
msgstr "Non sono riuscito a caricare le skill del team."

#: src/features/skills/components/SkillsList.tsx:216
msgid "Non sono riuscito a caricare le skill."
msgstr "Non sono riuscito a caricare le skill."

#: src/features/skills/components/SkillEditor.tsx:174
msgid "Non sono riuscito a comporre la bozza. Riprova."
msgstr "Non sono riuscito a comporre la bozza. Riprova."

#: src/features/skills/components/SkillsList.tsx:116
msgid "Non sono riuscito a condividere. Riprova."
msgstr "Non sono riuscito a condividere. Riprova."

#: src/features/chat/components/InterruptedQueryNotice.tsx:36
msgid "Non sono riuscito a riprovare. Puoi ripetere l’operazione."
msgstr "Non sono riuscito a riprovare. Puoi ripetere l’operazione."

#: src/features/skills/components/SkillsList.tsx:134
#: src/features/skills/components/TeamSkillsCatalog.tsx:47
msgid "Non sono riuscito ad aggiornare. Riprova."
msgstr "Non sono riuscito ad aggiornare. Riprova."

#. placeholder {0}: skippedPorts.map((p) => p.label).join(", ")
#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:89
msgid "Non testabili da qui (richiedono dati strutturati, non testo): {0}."
msgstr "Non testabili da qui (richiedono dati strutturati, non testo): {0}."

#. placeholder {0}: formatInt(r.untracked_output_tokens)
#. placeholder {1}: formatInt(r.untracked_input_tokens)
#: src/features/admin/components/AdminCostTracking.tsx:136
msgid "Non tracciati: {0} output · {1} input token fatturati da Google ma non registrati nel periodo."
msgstr "Non tracciati: {0} output · {1} input token fatturati da Google ma non registrati nel periodo."

#: src/features/active-context/components/AmbientContextChips.tsx:79
msgid "Non usare \"{title}\" in questa risposta"
msgstr "Non usare \"{title}\" in questa risposta"

#. placeholder {0}: skill.name
#: src/features/skills/components/TeamSkillsCatalog.tsx:156
msgid "Non usare «{0}»"
msgstr "Non usare «{0}»"

#: src/features/onboarding/sectionGuides.ts:74
msgid "Non utilizzabile nella demo. Con Ando puoi gestire, interrogare e generare file 2D/3D nei formati standard (DXF, DWG, STEP, IGES, STL). Puoi comunque esplorare l'interfaccia."
msgstr "Non utilizzabile nella demo. Con Ando puoi gestire, interrogare e generare file 2D/3D nei formati standard (DXF, DWG, STEP, IGES, STL). Puoi comunque esplorare l'interfaccia."

#: src/features/console/connectors/SourceHealthSummary.tsx:11
msgid "Non verificata"
msgstr "Non verificata"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:690
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:697
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:95
msgid "Normale"
msgstr "Normale"

#: src/features/admin/components/AdminDecks.tsx:628
#: src/features/dfm-rules/components/DfmRulesPage.tsx:78
msgid "Nota"
msgstr "Nota"

#: src/features/admin/components/AdminCpqPriceBook.tsx:357
msgid "Nota / origine del dato"
msgstr "Nota / origine del dato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:470
msgid "Nota della versione"
msgstr "Nota della versione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:469
#: src/features/admin/components/PageEditor.tsx:446
msgid "Nota della versione (facoltativa)"
msgstr "Nota della versione (facoltativa)"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:53
msgid "Nota di credito"
msgstr "Nota di credito"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:52
msgid "Nota di credito n. {number}"
msgstr "Nota di credito n. {number}"

#: src/features/sales/components/ActivityTimeline.tsx:55
msgid "Nota non aggiunta"
msgstr "Nota non aggiunta"

#: src/features/sales/hooks/useCrmQueries.ts:248
msgid "Nota non salvata"
msgstr "Nota non salvata"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:976
msgid "Nota o fonte"
msgstr "Nota o fonte"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:186
msgid "Nota opzionale (per audit)"
msgstr "Nota opzionale (per audit)"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:188
msgid "Nota opzionale per audit"
msgstr "Nota opzionale per audit"

#: src/features/admin/components/AdminBilling.tsx:59
msgid "Nota: è un documento di incasso, non la fattura elettronica SDI (quella resta separata)."
msgstr "Nota: è un documento di incasso, non la fattura elettronica SDI (quella resta separata)."

#: src/features/console/connectors/CustomConnectorDetail.tsx:824
msgid "Nota: lo stato del cursore si azzera e la prossima run sarà un full sync pulito."
msgstr "Nota: lo stato del cursore si azzera e la prossima run sarà un full sync pulito."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:248
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:400
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:165
#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:268
#: src/features/sources/components/CalendarEventPane.tsx:536
#: src/features/workspace/components/TaskComposer.tsx:221
msgid "Note"
msgstr "Note"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:399
msgid "Note (opzionale)"
msgstr "Note (opzionale)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:911
msgid "Note del relatore"
msgstr "Note del relatore"

#: src/features/workspace/components/TaskComposer.tsx:230
msgid "Note del task"
msgstr "Note del task"

#: src/features/chat/components/ChatEmptyState.tsx:261
msgid "Note dello standup"
msgstr "Note dello standup"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:278
msgid "Note interne (opzionale)"
msgstr "Note interne (opzionale)"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:527
msgid "Note relatore"
msgstr "Note relatore"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:279
msgid "Note sull'incasso"
msgstr "Note sull'incasso"

#: src/features/workspace/components/NudgeClusterRow.tsx:221
msgid "Notifica"
msgstr "Notifica"

#: src/features/clean-control/utils/labels.ts:118
msgid "Notifica automaticamente"
msgstr "Notifica automaticamente"

#: src/features/account/components/UserMenuButton.tsx:429
#: src/features/chat/components/ConversationMiniRail.tsx:298
#: src/features/settings/components/NotificationPreferences.tsx:229
#: src/features/workspace/components/NotificationPill.tsx:196
msgid "Notifiche"
msgstr "Notifiche"

#: src/features/workspace/components/NotificationPill.tsx:166
msgid "Notifiche da Ando"
msgstr "Notifiche da Ando"

#: src/features/console/components/ConToaster.tsx:118
msgid "Notifiche della console"
msgstr "Notifiche della console"

#: src/features/settings/components/NotificationPreferences.tsx:458
msgid "Notifiche in-app al giorno"
msgstr "Notifiche in-app al giorno"

#: src/features/connectors/wizards/accountingSpec.tsx:126
msgid "Notifiche su fatture in scadenza e DSO anomali."
msgstr "Notifiche su fatture in scadenza e DSO anomali."

#: src/routes/_authed/workspace/calendar.tsx:1459
msgid "Notifiche sugli slot liberi"
msgstr "Notifiche sugli slot liberi"

#: src/features/workspace/documents/components/FolderBrowserView.tsx:52
msgid "Notion"
msgstr "Notion"

#: src/features/chat/components/ChatEmptyState.tsx:88
#: src/features/projects/components/ProjectHub.tsx:83
msgid "Notte bianca?"
msgstr "Notte bianca?"

#: src/routes/_authed/_modal/settings/changelog.tsx:44
msgid "Novità"
msgstr "Novità"

#: src/features/report/components/ReportList.tsx:46
#: src/features/report/components/ReportViewer.tsx:125
msgid "NPS"
msgstr "NPS"

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:64
msgid "Nudge attivi"
msgstr "Nudge attivi"

#: src/features/settings/components/NotificationPreferences.tsx:232
msgid "nudge proattivi · canali · limiti giornalieri"
msgstr "nudge proattivi · canali · limiti giornalieri"

#: src/features/admin/components/AdminHypermem.tsx:97
msgid "Nudges"
msgstr "Nudges"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:684
#: src/features/admin/components/deckEditor/DeckEditor.tsx:991
msgid "Numeri"
msgstr "Numeri"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:40
msgid "Numeri (0-9)"
msgstr "Numeri (0-9)"

#: src/features/templates/components/TemplateFieldSpecs.ts:142
msgid "Numeri di pagina"
msgstr "Numeri di pagina"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:183
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1303
#: src/features/admin/components/orgs/OrgBillingTab.tsx:603
#: src/features/billing/components/InvoicesTable.tsx:107
msgid "Numero"
msgstr "Numero"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:380
msgid "Numero di occorrenze"
msgstr "Numero di occorrenze"

#: src/features/settings/components/BrandKitSettings.tsx:413
msgid "Numero di pagina"
msgstr "Numero di pagina"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:347
msgid "Numero di telefono non valido"
msgstr "Numero di telefono non valido"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:447
msgid "Numero di voci"
msgstr "Numero di voci"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:541
msgid "Numero massimo di conversazioni"
msgstr "Numero massimo di conversazioni"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:533
msgid "Numero massimo di email"
msgstr "Numero massimo di email"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:381
msgid "Numero non valido"
msgstr "Numero non valido"

#: src/features/admin/components/AdminDecksAskAndo.tsx:186
#: src/features/projects/components/sections/AutomationsSection.tsx:278
msgid "Nuova"
msgstr "Nuova"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:341
msgid "Nuova app"
msgstr "Nuova app"

#: src/features/console/components/CreateKeyWizard.tsx:722
msgid "Nuova AppKey"
msgstr "Nuova AppKey"

#: src/features/projects/components/sections/TasksSection.tsx:231
msgid "Nuova attività…"
msgstr "Nuova attività…"

#: src/features/automations/components/AutomationsHub.tsx:177
#: src/features/automations/components/CreateAutomationDialog.tsx:159
msgid "Nuova automazione"
msgstr "Nuova automazione"

#: src/features/sales/components/crm/CompaniesPanel.tsx:70
#: src/features/sales/components/crm/CompaniesPanel.tsx:74
#: src/features/sales/components/crm/CompaniesPanel.tsx:195
msgid "Nuova azienda"
msgstr "Nuova azienda"

#: src/features/actions/components/NewActionMenu.tsx:70
#: src/features/chat/components/ConversationCommandPalette.tsx:312
msgid "Nuova azione"
msgstr "Nuova azione"

#: src/features/sales/components/CampaignsPanel.tsx:73
#: src/features/sales/components/CampaignsPanel.tsx:91
#: src/features/sales/components/CreateCampaignDialog.tsx:62
#: src/features/sales/components/CreateCampaignDialog.tsx:66
#: src/routes/_authed/workspace/sales.tsx:125
msgid "Nuova campagna"
msgstr "Nuova campagna"

#: src/features/chat/components/ConversationCommandPalette.tsx:156
#: src/features/chat/components/ConversationMiniRail.tsx:194
#: src/features/chat/components/ConversationSidebar.tsx:252
#: src/features/chat/components/ConversationSidebar.tsx:253
#: src/features/chat/components/ConversationSidebar.tsx:274
#: src/features/chat/components/ConversationSidebar.tsx:809
msgid "Nuova chat"
msgstr "Nuova chat"

#: src/features/console/pages/KeysPage.tsx:78
#: src/features/console/pages/KeysPage.tsx:102
msgid "Nuova chiave"
msgstr "Nuova chiave"

#: src/features/console/pages/PlaygroundPage.tsx:1956
msgid "Nuova conversazione"
msgstr "Nuova conversazione"

#: src/routes/_authed/workspace/conversations.tsx:841
msgid "Nuova conversazione o azione"
msgstr "Nuova conversazione o azione"

#: src/features/dashboard/components/AddChartDialog.tsx:334
msgid "nuova dashboard"
msgstr "nuova dashboard"

#: src/features/dashboard/components/DashboardListSidebar.tsx:392
#: src/features/dashboard/components/DashboardListSidebar.tsx:393
msgid "Nuova dashboard"
msgstr "Nuova dashboard"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:236
msgid "Nuova email"
msgstr "Nuova email"

#: src/features/hive-flows/run/RunHistoryRail.tsx:207
#: src/features/hive-flows/run/RunHistoryRail.tsx:208
#: src/features/hive-flows/run/RunHistoryRail.tsx:262
msgid "Nuova esecuzione"
msgstr "Nuova esecuzione"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:155
msgid "Nuova fattura"
msgstr "Nuova fattura"

#: src/features/sales/components/SignaturesManager.tsx:140
#: src/features/sales/components/SignaturesManager.tsx:238
msgid "Nuova firma"
msgstr "Nuova firma"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:128
msgid "Nuova invocazione"
msgstr "Nuova invocazione"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:144
msgid "Nuova nota"
msgstr "Nuova nota"

#: src/features/sales/components/crm/CreateDealDialog.tsx:102
#: src/features/sales/components/crm/CreateDealDialog.tsx:106
#: src/features/sales/components/crm/RecordDrawer.tsx:248
msgid "Nuova opportunità"
msgstr "Nuova opportunità"

#. placeholder {0}: stage.name
#: src/features/sales/components/crm/PipelineBoard.tsx:203
msgid "Nuova opportunità in {0}"
msgstr "Nuova opportunità in {0}"

#: src/features/admin/components/AdminOrgs.tsx:817
#: src/features/admin/components/AdminOrgs.tsx:1121
#: src/features/admin/components/AdminOrgs.tsx:1124
msgid "Nuova organizzazione"
msgstr "Nuova organizzazione"

#: src/features/admin/components/ZitadelPasswordActions.tsx:205
msgid "Nuova password"
msgstr "Nuova password"

#: src/features/settings/components/SecuritySettings.tsx:110
msgid "Nuova password (min 12 caratteri)"
msgstr "Nuova password (min 12 caratteri)"

#: src/features/clean-control/components/policies/PoliciesEditor.tsx:81
#: src/features/clean-control/components/policies/PolicyForm.tsx:164
#: src/features/clean-control/components/policies/PolicyForm.tsx:171
msgid "Nuova policy"
msgstr "Nuova policy"

#: src/features/admin/components/AdminDecks.tsx:190
#: src/features/admin/components/AdminDecks.tsx:323
msgid "Nuova presentazione"
msgstr "Nuova presentazione"

#: src/features/console/connectors/TestConnectorActionModal.tsx:152
msgid "Nuova prova"
msgstr "Nuova prova"

#: src/features/admin/components/AdminCpq.tsx:534
msgid "Nuova revisione"
msgstr "Nuova revisione"

#: src/features/admin/components/AdminCpq.tsx:432
msgid "Nuova revisione creata"
msgstr "Nuova revisione creata"

#: src/features/help/components/ShortcutsList.tsx:93
msgid "Nuova riga nel composer"
msgstr "Nuova riga nel composer"

#: src/features/skills/components/SkillEditor.tsx:246
#: src/features/skills/components/SkillEditor.tsx:250
#: src/features/skills/components/SkillsList.tsx:173
msgid "Nuova skill"
msgstr "Nuova skill"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:121
msgid "Nuova versione"
msgstr "Nuova versione"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:226
msgid "Nuova versione del documento"
msgstr "Nuova versione del documento"

#: src/features/admin/components/AdminCpqPriceBook.tsx:137
msgid "Nuova versione del listino attiva"
msgstr "Nuova versione del listino attiva"

#: src/features/connectors/wizards/filesystemSpec.tsx:123
msgid "Nuovi file e modifiche vengono indicizzati in automatico."
msgstr "Nuovi file e modifiche vengono indicizzati in automatico."

#: src/features/console/pages/UsagePage.tsx:99
#: src/features/voice_report/components/RunDiffTimeline.tsx:315
msgid "nuovo"
msgstr "nuovo"

#: src/features/admin/components/AdminCpq.tsx:471
#: src/features/projects/components/ProjectHub.tsx:508
#: src/features/sales/components/leadMeta.ts:27
#: src/features/sync/components/DocSyncManager.tsx:1197
#: src/features/sync/components/DocSyncManager.tsx:1280
#: src/features/workspace/components/QuickAddMenu/QuickAddMenu.tsx:226
#: src/routes/_authed/_modal/settings/changelog.tsx:85
#: src/routes/_authed/workspace/calendar.tsx:779
#: src/routes/_authed/workspace/conversations.tsx:840
#: src/routes/_authed/workspace/documents.tsx:933
#: src/routes/_authed/workspace/finance.tsx:372
#: src/routes/_authed/workspace/sales.tsx:121
#: src/routes/_authed/workspace/technical.tsx:314
#: src/routes/_authed/workspace/work.tsx:366
msgid "Nuovo"
msgstr "Nuovo"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:152
msgid "Nuovo connettore"
msgstr "Nuovo connettore"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:639
msgid "Nuovo connettore personalizzato"
msgstr "Nuovo connettore personalizzato"

#: src/features/sales/components/crm/ContactsPanel.tsx:72
#: src/features/sales/components/crm/ContactsPanel.tsx:76
#: src/features/sales/components/crm/ContactsPanel.tsx:204
msgid "Nuovo contatto"
msgstr "Nuovo contatto"

#: src/routes/_authed/workspace/documents.tsx:847
msgid "Nuovo documento"
msgstr "Nuovo documento"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:231
msgid "Nuovo evento in calendario"
msgstr "Nuovo evento in calendario"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:258
msgid "Nuovo file"
msgstr "Nuovo file"

#: src/features/console/pages/FlowsPage.tsx:415
#: src/features/console/pages/FlowsPage.tsx:469
#: src/features/console/pages/FlowsPage.tsx:750
#: src/routes/_authed/workspace/flows.index.tsx:152
msgid "Nuovo flow"
msgstr "Nuovo flow"

#: src/features/admin/components/AdminDemoInviti.tsx:194
msgid "Nuovo invito"
msgstr "Nuovo invito"

#: src/features/admin/components/AdminDemoInviti.tsx:342
msgid "Nuovo invito demo"
msgstr "Nuovo invito demo"

#: src/features/sales/components/CreateLeadDialog.tsx:89
#: src/features/sales/components/CreateLeadDialog.tsx:93
#: src/routes/_authed/workspace/sales.tsx:131
msgid "Nuovo lead"
msgstr "Nuovo lead"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:260
msgid "Nuovo messaggio"
msgstr "Nuovo messaggio"

#: src/features/sales/components/TemplateManager.tsx:175
#: src/features/sales/components/TemplateManager.tsx:245
msgid "Nuovo modello"
msgstr "Nuovo modello"

#: src/features/agent-modes/components/AgentModeEditor.tsx:299
#: src/features/agent-modes/components/AgentModeEditor.tsx:302
#: src/features/agent-modes/components/AgentModesList.tsx:187
msgid "Nuovo modo"
msgstr "Nuovo modo"

#: src/features/chat/components/ConversationSidebar.tsx:609
msgid "Nuovo nome"
msgstr "Nuovo nome"

#: src/features/admin/components/AdminPlatformSettings.tsx:557
msgid "Nuovo piano"
msgstr "Nuovo piano"

#: src/features/admin/components/AdminPlatformSettings.tsx:759
#: src/features/admin/components/AdminPlatformSettings.tsx:762
msgid "Nuovo piano usage tier"
msgstr "Nuovo piano usage tier"

#: src/features/admin/components/AdminCpq.tsx:487
#: src/features/admin/components/AdminCpqList.tsx:110
msgid "Nuovo preventivo"
msgstr "Nuovo preventivo"

#: src/features/chat/components/ConversationSidebar.tsx:365
#: src/features/projects/components/NewProjectDialog.tsx:104
msgid "Nuovo progetto"
msgstr "Nuovo progetto"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:160
#: src/features/projects/components/TemplatesBrowserDialog.tsx:181
msgid "Nuovo progetto da template"
msgstr "Nuovo progetto da template"

#: src/features/voice_report/components/VoiceReportsList.tsx:175
#: src/routes/_authed/workspace/reports/index.tsx:76
msgid "Nuovo report"
msgstr "Nuovo report"

#: src/features/console/connectors/CustomConnectorDetail.tsx:815
msgid "Nuovo secret"
msgstr "Nuovo secret"

#: src/features/console/webhooks/WebhooksPanel.tsx:777
msgid "Nuovo signing secret — mostrato UNA SOLA VOLTA."
msgstr "Nuovo signing secret — mostrato UNA SOLA VOLTA."

#: src/routes/_authed/workspace/connect.index.tsx:127
#: src/routes/_authed/workspace/connect.index.tsx:189
msgid "Nuovo spazio"
msgstr "Nuovo spazio"

#: src/features/connect/components/CreateSpaceDialog.tsx:111
msgid "Nuovo spazio Connect"
msgstr "Nuovo spazio Connect"

#: src/features/projects/components/ProjectHub.tsx:632
msgid "nuovo spazio, nessuna attività ancora"
msgstr "nuovo spazio, nessuna attività ancora"

#: src/features/workspace/components/TaskComposer.tsx:106
#: src/features/workspace/components/TaskComposer.tsx:115
#: src/routes/_authed/workspace/work.tsx:370
msgid "Nuovo task"
msgstr "Nuovo task"

#: src/features/settings/components/PresentationTemplates.tsx:219
#: src/features/settings/components/PresentationTemplates.tsx:722
#: src/features/settings/components/PresentationTemplates.tsx:731
#: src/features/templates/components/CreateTemplateDialog.tsx:123
#: src/routes/_authed/workspace/templates/$kind.tsx:108
msgid "Nuovo template"
msgstr "Nuovo template"

#: src/features/chat/components/ConversationCommandPalette.tsx:178
#: src/features/chat/components/ConversationSidebar.tsx:933
msgid "Nuovo titolo"
msgstr "Nuovo titolo"

#: src/routes/_authed/workspace/dashboard.tsx:395
#: src/routes/_authed/workspace/dashboard.tsx:513
msgid "Nuovo Voice of X"
msgstr "Nuovo Voice of X"

#: src/routes/_authed/workspace/dashboard.tsx:391
msgid "Nuovo Voice of X report"
msgstr "Nuovo Voice of X report"

#: src/features/console/webhooks/WebhooksPanel.tsx:280
#: src/features/console/webhooks/WebhooksPanel.tsx:476
msgid "Nuovo webhook"
msgstr "Nuovo webhook"

#: src/features/dashboard/components/DashboardEmptyState.tsx:79
#: src/features/dashboard/components/DashboardToolbar.tsx:153
msgid "Nuovo widget"
msgstr "Nuovo widget"

#: src/features/report/components/QuestionView.tsx:102
msgid "Nuvola di parole"
msgstr "Nuvola di parole"

#: src/features/hive-flows/components/ConditionBuilder.tsx:217
msgid "O"
msgstr "O"

#: src/features/connectors/wizards/accountingSpec.tsx:112
msgid "OAuth 2.0 con il tuo account Fatture in Cloud (API v2)."
msgstr "OAuth 2.0 con il tuo account Fatture in Cloud (API v2)."

#: src/features/hive-flows/components/FlowFormPublish.tsx:180
msgid "obbl."
msgstr "obbl."

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1418
msgid "obbligatorio"
msgstr "obbligatorio"

#: src/features/console/connectors/CustomConnectorDetail.tsx:393
#: src/features/dfm-rules/components/DfmRulesPage.tsx:663
msgid "Obbligatorio"
msgstr "Obbligatorio"

#: src/features/console/connectors/ManifestConfigForm.tsx:225
msgid "Obbligatorio: l'id stabile del record nel tuo sistema."
msgstr "Obbligatorio: l'id stabile del record nel tuo sistema."

#: src/features/sources/components/ArtifactPane.tsx:2325
msgid "Obblighi"
msgstr "Obblighi"

#: src/features/settings/components/SelfProfileMemory.tsx:102
msgid "Obiettivi"
msgstr "Obiettivi"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:100
msgid "Occasionalmente"
msgstr "Occasionalmente"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:382
msgid "occorrenze"
msgstr "occorrenze"

#: src/features/admin/components/AdminCpq.tsx:560
#: src/features/admin/components/AdminCpqCanvas.tsx:162
msgid "Offerta"
msgstr "Offerta"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:195
msgid "offerta-commerciale"
msgstr "offerta-commerciale"

#: src/features/report/components/CitationDetail.tsx:59
msgid "Offset divergente"
msgstr "Offset divergente"

#: src/features/console/connectors/ConnectionCard.tsx:253
msgid "Oggetti"
msgstr "Oggetti"

#: src/features/console/connectors/meta.ts:196
msgid "Oggetti e moduli dell'ERP autorizzati"
msgstr "Oggetti e moduli dell'ERP autorizzati"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:414
msgid "Oggetti non coperti ({unmatchedCount})"
msgstr "Oggetti non coperti ({unmatchedCount})"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:375
msgid "Oggetti trovati nel database"
msgstr "Oggetti trovati nel database"

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:232
#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:233
#: src/features/sales/components/BatchSendModal.tsx:328
#: src/features/sales/components/TemplateManager.tsx:308
msgid "Oggetto"
msgstr "Oggetto"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:540
#: src/features/sales/components/BatchSendModal.tsx:335
#: src/features/sales/components/TemplateManager.tsx:315
msgid "Oggetto dell'email"
msgstr "Oggetto dell'email"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:383
msgid "Oggetto della PEC"
msgstr "Oggetto della PEC"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:344
msgid "Oggetto JSON con metadati del connettore. Non inserire mai credenziali."
msgstr "Oggetto JSON con metadati del connettore. Non inserire mai credenziali."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:441
msgid "Oggetto JSON inviato al tuo endpoint; i segnaposto {{parametro}} vengono sostituiti con i parametri dell'azione."
msgstr "Oggetto JSON inviato al tuo endpoint; i segnaposto {{parametro}} vengono sostituiti con i parametri dell'azione."

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:311
#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:179
msgid "Oggetto:"
msgstr "Oggetto:"

#: src/features/projects/utils/relativeDate.ts:156
#: src/routes/_authed/workspace/finance.tsx:950
msgid "oggi"
msgstr "oggi"

#: src/features/report/components/ReportDateFilter.tsx:53
#: src/features/workspace/components/NudgeClusterRow.tsx:100
#: src/features/workspace/components/searchFilters/types.ts:28
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:31
#: src/features/workspace/config.ts:340
#: src/features/workspace/config.ts:413
#: src/features/workspace/inbox/utils/inboxSmartViews.ts:69
#: src/routes/_authed/workspace/calendar.tsx:883
#: src/routes/_authed/workspace/work.tsx:273
#: src/routes/_authed/workspace/work.tsx:409
msgid "Oggi"
msgstr "Oggi"

#: src/features/sources/components/InboxDetailPane.tsx:1009
msgid "oggi {hh}:{mm}"
msgstr "oggi {hh}:{mm}"

#: src/features/sources/components/InboxDetailPane.tsx:1052
msgid "Oggi alle 18:00"
msgstr "Oggi alle 18:00"

#. placeholder {0}: i18n._(it)
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:104
msgid "Ogni {0} alle 09:00"
msgstr "Ogni {0} alle 09:00"

#. placeholder {0}: flow.interval_minutes
#: src/features/console/pages/FlowDetailPage.tsx:209
msgid "Ogni {0} minuti"
msgstr "Ogni {0} minuti"

#: src/features/projects/components/sections/AutomationsSection.tsx:74
msgid "ogni {h} ora"
msgstr "ogni {h} ora"

#: src/features/projects/components/sections/AutomationsSection.tsx:75
msgid "ogni {h} ore"
msgstr "ogni {h} ore"

#: src/features/projects/components/sections/AutomationsSection.tsx:77
msgid "ogni {intervalMinutes} min"
msgstr "ogni {intervalMinutes} min"

#: src/features/automations/components/ScheduleEditor.tsx:45
msgid "Ogni 15 minuti"
msgstr "Ogni 15 minuti"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:60
msgid "Ogni 24 ore"
msgstr "Ogni 24 ore"

#: src/features/automations/components/ScheduleEditor.tsx:46
msgid "Ogni 30 minuti"
msgstr "Ogni 30 minuti"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:58
msgid "Ogni 5 minuti"
msgstr "Ogni 5 minuti"

#: src/features/automations/components/ScheduleEditor.tsx:48
msgid "Ogni 6 ore"
msgstr "Ogni 6 ore"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:81
msgid "Ogni accesso loggato + esportabile per il commercialista."
msgstr "Ogni accesso loggato + esportabile per il commercialista."

#: src/features/console/pages/ConnectorDetailPage.tsx:419
msgid "Ogni account o sorgente collegata a questo connettore."
msgstr "Ogni account o sorgente collegata a questo connettore."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:182
msgid "Ogni anno"
msgstr "Ogni anno"

#. placeholder {0}: anchor.getDate()
#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:98
msgid "Ogni anno il {0} {monthLong}"
msgstr "Ogni anno il {0} {monthLong}"

#: src/features/console/docs/content.ts:660
msgid "Ogni campo è opzionale: name rinomina; enabled: true riattiva un connettore disabilitato (il ledger sopravvive, l'incrementale riparte); config sostituisce la configurazione PER INTERO. Manifest: un nuovo manifest.auth.secret RUOTA il secret sigillato, ometterlo lo mantiene; lo stato del cursore si azzera (la run successiva è un full pulito)."
msgstr "Ogni campo è opzionale: name rinomina; enabled: true riattiva un connettore disabilitato (il ledger sopravvive, l'incrementale riparte); config sostituisce la configurazione PER INTERO. Manifest: un nuovo manifest.auth.secret RUOTA il secret sigillato, ometterlo lo mantiene; lo stato del cursore si azzera (la run successiva è un full pulito)."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:176
#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:90
msgid "Ogni giorno"
msgstr "Ogni giorno"

#: src/features/automations/components/ScheduleEditor.tsx:49
msgid "Ogni giorno (24h)"
msgstr "Ogni giorno (24h)"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:98
msgid "Ogni giorno alle 09:00"
msgstr "Ogni giorno alle 09:00"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:94
msgid "Ogni giorno feriale (lun–ven)"
msgstr "Ogni giorno feriale (lun–ven)"

#: src/features/automations/components/ScheduleEditor.tsx:56
msgid "Ogni lunedì alle 9:00"
msgstr "Ogni lunedì alle 9:00"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:180
msgid "Ogni mese"
msgstr "Ogni mese"

#: src/features/admin/components/AdminBilling.tsx:52
msgid "Ogni mese Ando emette una fattura Stripe one-off per tenant con il costo LLM maggiorato del markup. Auto-addebito + solleciti (dunning) inclusi, fee minime (nessun sovrapprezzo di piattaforma). Parte in osservazione (dry-run) finché non la attivi lato backend."
msgstr "Ogni mese Ando emette una fattura Stripe one-off per tenant con il costo LLM maggiorato del markup. Auto-addebito + solleciti (dunning) inclusi, fee minime (nessun sovrapprezzo di piattaforma). Parte in osservazione (dry-run) finché non la attivi lato backend."

#. placeholder {0}: anchor.getDate()
#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:96
msgid "Ogni mese il {0}"
msgstr "Ogni mese il {0}"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:57
msgid "Ogni minuto"
msgstr "Ogni minuto"

#: src/features/admin/components/AdminCpqPriceBook.tsx:196
msgid "Ogni mittente deve essere un indirizzo \"Invia come\" verificato della casella che invia, altrimenti Gmail lo sostituisce. Il primo è il predefinito."
msgstr "Ogni mittente deve essere un indirizzo \"Invia come\" verificato della casella che invia, altrimenti Gmail lo sostituisce. Il primo è il predefinito."

#: src/features/automations/components/ScheduleEditor.tsx:47
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:59
msgid "Ogni ora"
msgstr "Ogni ora"

#: src/features/connectors/wizards/emailSpec.tsx:98
msgid "Ogni risposta linka all'email originale."
msgstr "Ogni risposta linka all'email originale."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:519
msgid "Ogni run compare nello Storico sync del connettore con i contatori indicizzati/rimossi/rifiutati e la durata."
msgstr "Ogni run compare nello Storico sync del connettore con i contatori indicizzati/rimossi/rifiutati e la durata."

#: src/features/admin/components/AdminCpqPriceBook.tsx:177
msgid "Ogni salvataggio crea una nuova versione. I preventivi pubblicati restano congelati; bozze e anteprime usano la versione attiva."
msgstr "Ogni salvataggio crea una nuova versione. I preventivi pubblicati restano congelati; bozze e anteprime usano la versione attiva."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:304
msgid "Ogni servizio è una fonte distinta. Le credenziali restano tue; i contenuti sincronizzati sono privati finché non li condividi da Accessi."
msgstr "Ogni servizio è una fonte distinta. Le credenziali restano tue; i contenuti sincronizzati sono privati finché non li condividi da Accessi."

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:178
msgid "Ogni settimana"
msgstr "Ogni settimana"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:92
msgid "Ogni settimana il {weekdayLong}"
msgstr "Ogni settimana il {weekdayLong}"

#: src/features/connectors/wizards/accountingSpec.tsx:131
msgid "Ogni voce è linkata al documento originario, citato in chat."
msgstr "Ogni voce è linkata al documento originario, citato in chat."

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:166
msgid "Ogni voce mostra la fonte del prezzo — Manuale, SAP, Salesforce, HubSpot o Database. Rifiuta la bozza se una fonte non è aggiornata; approvala per salvarla in Preventivi. Nessuna email al cliente viene inviata."
msgstr "Ogni voce mostra la fonte del prezzo — Manuale, SAP, Salesforce, HubSpot o Database. Rifiuta la bozza se una fonte non è aggiornata; approvala per salvarla in Preventivi. Nessuna email al cliente viene inviata."

#: src/routes/_authed/workspace/dashboard.tsx:422
msgid "Ogni Voice of X esegue 7 stage di AI con citation grounding obbligatoria. Apri il dettaglio di un run per leggere il report scientifico passo per passo."
msgstr "Ogni Voice of X esegue 7 stage di AI con citation grounding obbligatoria. Apri il dettaglio di un run per leggere il report scientifico passo per passo."

#: src/features/hive-flows/components/DryRunPanel.tsx:78
msgid "ok"
msgstr "ok"

#: ../../packages/ui/src/ando/dialog/AndoDialogProvider.tsx:60
#: src/features/console/components/StatusBadges.tsx:101
#: src/features/console/components/StatusBadges.tsx:102
#: src/features/console/components/StatusBadges.tsx:103
msgid "OK"
msgstr "OK"

#: src/features/settings/components/MemoryConsentBanner.tsx:136
msgid "Ok, attiva"
msgstr "Ok, attiva"

#: src/routes/_authed/workspace/finance.tsx:1446
msgid "oltre l'anno"
msgstr "oltre l'anno"

#: src/routes/_authed/workspace/finance.tsx:505
msgid "Oltre l'anno"
msgstr "Oltre l'anno"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1908
msgid "Ombra"
msgstr "Ombra"

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:111
msgid "On-prem Bridge"
msgstr "On-prem Bridge"

#: src/features/admin/components/AdminEngagement.tsx:158
msgid "onboarding chat"
msgstr "onboarding chat"

#: src/features/help/data/changelog.ts:54
msgid "Onboarding pulito per nuove dashboard con scelta da template. Modale Aggiungi Widget allargata per editor SQL più leggibile."
msgstr "Onboarding pulito per nuove dashboard con scelta da template. Modale Aggiungi Widget allargata per editor SQL più leggibile."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:90
msgid "Onboarding, recruiting, policy"
msgstr "Onboarding, recruiting, policy"

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:112
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:98
#: src/features/workspace/config.ts:377
#: src/features/workspace/documents/components/FolderBrowserView.tsx:50
msgid "OneDrive"
msgstr "OneDrive"

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:364
msgid "OnlyOffice DocEditor unavailable"
msgstr "OnlyOffice DocEditor unavailable"

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:481
msgid "OnlyOffice editor error"
msgstr "OnlyOffice editor error"

#: ../../packages/ui/src/editors/OnlyOfficeEditor.tsx:357
msgid "OnlyOffice editor URL missing"
msgstr "OnlyOffice editor URL missing"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1871
msgid "Opacità %"
msgstr "Opacità %"

#: src/features/console/connectors/meta.ts:147
msgid "Open banking"
msgstr "Open banking"

#: src/features/connectors/components/vendorIcons.tsx:173
#: src/features/connectors/components/vendorIcons.tsx:522
msgid "Open Banking"
msgstr "Open Banking"

#: src/routes/_authed/workspace/finance.tsx:700
msgid "Open banking (PSD2)"
msgstr "Open banking (PSD2)"

#: src/features/connectors/wizards/databaseSpec.tsx:155
msgid "Open-source, ampia adozione"
msgstr "Open-source, ampia adozione"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:378
msgid "Opening…"
msgstr "Opening…"

#: src/features/console/components/ConsoleShell.tsx:245
msgid "Operate"
msgstr "Operate"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:169
msgid "Operatività"
msgstr "Operatività"

#: src/features/admin/components/MaintenanceControl.tsx:60
msgid "Operativo"
msgstr "Operativo"

#: src/features/hive-flows/components/ConditionBuilder.tsx:274
msgid "Operatore"
msgstr "Operatore"

#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:121
msgid "Operazione"
msgstr "Operazione"

#: src/features/admin/components/orgs/AddMemberDialog.tsx:125
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:291
msgid "Operazione fallita"
msgstr "Operazione fallita"

#: src/features/actions/components/MessageActionChips.tsx:130
#: src/features/actions/components/MessageActionChips.tsx:131
msgid "Operazione in corso"
msgstr "Operazione in corso"

#: src/features/actions/components/MessageActionChips.tsx:133
msgid "Operazione non completata"
msgstr "Operazione non completata"

#: src/features/hive-flows/components/FlowActivateControl.tsx:168
#: src/features/hive-flows/components/FlowShareControl.tsx:62
#: src/features/hive-flows/run/ProposalReview.tsx:276
#: src/features/sales/components/SignaturesManager.tsx:121
#: src/features/sales/components/SignaturesManager.tsx:307
#: src/features/sales/hooks/useCrmQueries.ts:304
#: src/features/sales/hooks/useCrmQueries.ts:310
#: src/features/sales/hooks/useCrmQueries.ts:318
#: src/routes/_authed/workspace/flows.index.tsx:190
msgid "Operazione non riuscita"
msgstr "Operazione non riuscita"

#: src/features/admin/components/AdminOrgs.tsx:682
#: src/features/admin/components/AdminOrgs.tsx:779
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:137
#: src/features/admin/components/orgs/OrgMembersTab.tsx:232
msgid "Operazione parziale"
msgstr "Operazione parziale"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:201
#: src/features/console/webhooks/WebhooksPanel.tsx:533
msgid "Operazioni"
msgstr "Operazioni"

#: src/features/sales/components/crm/CompaniesPanel.tsx:236
#: src/features/sales/components/crm/RecordDrawer.tsx:237
msgid "Opportunità"
msgstr "Opportunità"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:24
#: src/features/sales/hooks/useCrmQueries.ts:115
msgid "Opportunità creata"
msgstr "Opportunità creata"

#: src/features/admin/components/AdminCostTracking.tsx:402
msgid "Opportunità di risparmio"
msgstr "Opportunità di risparmio"

#: src/features/sales/hooks/useCrmQueries.ts:142
msgid "Opportunità eliminata"
msgstr "Opportunità eliminata"

#: src/features/auth/desktop/DesktopLoginForm.tsx:597
msgid "Oppure"
msgstr "Oppure"

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:237
msgid "Oppure chiedi ad Ando"
msgstr "Oppure chiedi ad Ando"

#: src/features/automations/components/ScheduleEditor.tsx:173
msgid "Oppure imposta i campi manualmente qui sotto."
msgstr "Oppure imposta i campi manualmente qui sotto."

#: src/features/settings/components/BrandKitSettings.tsx:359
msgid "Oppure scarica da Google Fonts (es. Inter, Poppins)"
msgstr "Oppure scarica da Google Fonts (es. Inter, Poppins)"

#: src/features/auth/desktop/DesktopLoginForm.tsx:723
msgid "Oppure usa password"
msgstr "Oppure usa password"

#: src/features/settings/marp/CssUploadPanel.tsx:189
msgid "Opzionale, max 140 caratteri"
msgstr "Opzionale, max 140 caratteri"

#: src/features/console/docs/content.ts:1598
msgid "Opzionale: elabora fino a 100 elementi con la credenziale dell'utente verificato. La scansione ordinaria è automatica: usa sync-status per seguirla. Se avvii una scansione manuale, ripeti con next_page_token fino a null; il cursore scade dopo 24 ore. I chunk restano isolati per utente e connessione, salvo accesso esplicitamente concesso al contenuto indicizzato."
msgstr "Opzionale: elabora fino a 100 elementi con la credenziale dell'utente verificato. La scansione ordinaria è automatica: usa sync-status per seguirla. Se avvii una scansione manuale, ripeti con next_page_token fino a null; il cursore scade dopo 24 ore. I chunk restano isolati per utente e connessione, salvo accesso esplicitamente concesso al contenuto indicizzato."

#: src/features/console/docs/content.ts:1472
msgid "Opzionale: elabora una pagina nel perimetro privato del proprietario. La sincronizzazione ordinaria prosegue automaticamente; controlla sync-status. Solo se gestisci tu una scansione manuale, continua con next_page_token come page_token finché è nullo."
msgstr "Opzionale: elabora una pagina nel perimetro privato del proprietario. La sincronizzazione ordinaria prosegue automaticamente; controlla sync-status. Solo se gestisci tu una scansione manuale, continua con next_page_token come page_token finché è nullo."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1107
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:362
msgid "Opzioni avanzate"
msgstr "Opzioni avanzate"

#: src/features/admin/components/AdminCpqCanvas.tsx:158
msgid "Opzioni del destinatario"
msgstr "Opzioni del destinatario"

#: src/features/workspace/components/TaskSimpleRow.tsx:306
msgid "Opzioni task"
msgstr "Opzioni task"

#: src/features/settings/components/SecuritySettings.tsx:406
#: src/features/sources/components/AISummaryPanel.tsx:926
#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:242
#: src/features/workspace/hooks/formatRelativeTime.ts:30
#: src/features/workspace/hooks/formatRelativeTime.ts:31
#: src/routes/_authed/workspace/calendar.tsx:153
msgid "ora"
msgstr "ora"

#: src/features/admin/components/CostTraceDetailSection.tsx:214
#: src/routes/_authed/workspace/calendar.tsx:1513
msgid "Ora"
msgstr "Ora"

#: src/features/sources/components/SyncConflictDialog.tsx:76
msgid "ora ignota"
msgstr "ora ignota"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:671
msgid "Orbita del Lab"
msgstr "Orbita del Lab"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1342
msgid "ORCLPDB1"
msgstr "ORCLPDB1"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:88
msgid "Order ops, customer care"
msgstr "Order ops, customer care"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:561
msgid "Ordina grafico"
msgstr "Ordina grafico"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:580
msgid "Ordina grafico per"
msgstr "Ordina grafico per"

#: src/features/console/pages/ModelsPage.tsx:327
msgid "Ordina i passaggi recuperati per rilevanza."
msgstr "Ordina i passaggi recuperati per rilevanza."

#. placeholder {0}: metaByColumn.get(col)?.label ?? col
#: ../../packages/ui/src/ando/DataPagedTable.tsx:239
msgid "Ordina per {0}"
msgstr "Ordina per {0}"

#: src/features/connectors/components/management/SchemaViewer.tsx:763
msgid "Ordina per {c}"
msgstr "Ordina per {c}"

#: src/features/console/pages/BillingPage.tsx:461
msgid "Ordinario"
msgstr "Ordinario"

#: src/features/console/pages/PlaygroundPage.tsx:849
msgid "Ordinati per rilevanza."
msgstr "Ordinati per rilevanza."

#: src/features/console/traces/TraceGraph.tsx:374
msgid "ordine"
msgstr "ordine"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:567
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:587
msgid "Ordine automatico"
msgstr "Ordine automatico"

#: src/features/admin/components/AdminDecksAskAndo.tsx:181
msgid "ordine cambiato"
msgstr "ordine cambiato"

#: src/features/console/traces/TraceGraph.tsx:478
msgid "Ordine di registrazione dei gruppi visibili (non causale)"
msgstr "Ordine di registrazione dei gruppi visibili (non causale)"

#: src/features/console/traces/TraceGraph.tsx:276
msgid "Ordine di registrazione; posizione non temporale."
msgstr "Ordine di registrazione; posizione non temporale."

#: src/features/console/traces/TraceGraph.tsx:481
msgid "Ordine registrato, non causale. Apri un segmento per le singole chiamate e gli eventi."
msgstr "Ordine registrato, non causale. Apri un segmento per le singole chiamate e gli eventi."

#: src/features/admin/components/AdminCpqPriceBook.tsx:248
#: src/features/admin/components/AdminCpqPriceBook.tsx:280
msgid "Ore supporto/mese"
msgstr "Ore supporto/mese"

#: src/features/admin/components/AdminCpqPriceBook.tsx:306
msgid "Ore supporto/mese (vuoto = per taglio)"
msgstr "Ore supporto/mese (vuoto = per taglio)"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:907
#: src/features/admin/components/orgs/OrgSSOTab.tsx:217
#: src/features/agent-modes/components/AgentModeEditor.tsx:629
#: src/features/sales/components/CampaignsPanel.tsx:261
#: src/features/sales/components/SalesOverview.tsx:348
#: src/features/settings/marp/CssUploadPanel.tsx:286
msgid "Org"
msgstr "Org"

#: src/features/templates/components/TemplateCard.tsx:33
#: src/features/templates/components/TemplatesList.tsx:52
msgid "ORG"
msgstr "ORG"

#: src/features/actions/components/EmailTemplatePicker.tsx:78
#: src/features/sales/components/BatchSendModal.tsx:312
msgid "Org · "
msgstr "Org · "

#. placeholder {0}: orgQuery.data?.usage_multiplier ?? "—"
#: src/features/admin/components/orgs/OrgMembersTab.tsx:492
msgid "org ×{0}"
msgstr "org ×{0}"

#: src/features/console/components/ConsoleShell.tsx:239
msgid "Organization"
msgstr "Organization"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:364
msgid "Organization scope"
msgstr "Organization scope"

#: src/features/account/components/UserMenuButton.tsx:210
#: src/features/account/components/UserMenuButton.tsx:399
#: src/features/admin/components/AdminOrgs.tsx:326
#: src/features/admin/components/AdminOrgs.tsx:1008
#: src/features/agent-modes/components/AgentModeEditor.tsx:366
#: src/features/agent-modes/components/AgentModesList.tsx:60
#: src/features/sales/components/BatchSendModal.tsx:367
#: src/features/sales/components/SignaturesManager.tsx:183
#: src/features/settings/components/OrganizationSettings.tsx:87
#: src/features/settings/components/PresentationTemplates.tsx:94
msgid "Organizzazione"
msgstr "Organizzazione"

#: src/features/admin/components/AdminOrgs.tsx:446
msgid "Organizzazione creata"
msgstr "Organizzazione creata"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:163
msgid "Organizzazione destinazione"
msgstr "Organizzazione destinazione"

#: src/features/admin/components/AdminOrgs.tsx:469
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:66
msgid "Organizzazione disattivata"
msgstr "Organizzazione disattivata"

#: src/features/admin/components/AdminOrgs.tsx:494
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:77
msgid "Organizzazione eliminata"
msgstr "Organizzazione eliminata"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:255
msgid "Organizzazione non trovata"
msgstr "Organizzazione non trovata"

#: src/features/admin/components/AdminOrgs.tsx:481
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:67
msgid "Organizzazione riattivata"
msgstr "Organizzazione riattivata"

#: src/features/account/components/OrgSwitcherDialog.tsx:202
#: src/features/admin/components/AdminOrgs.tsx:796
#: src/features/admin/components/orgs/OrgDetailShell.tsx:292
#: src/routes/_authed/_modal/admin/route.tsx:146
msgid "Organizzazioni"
msgstr "Organizzazioni"

#: src/features/admin/components/AdminOrgs.tsx:775
msgid "Organizzazioni disattivate"
msgstr "Organizzazioni disattivate"

#: src/features/console/pages/DocumentsPage.tsx:381
msgid "Originale"
msgstr "Originale"

#: src/features/console/pages/ResourceAccessPage.tsx:567
msgid "Origine"
msgstr "Origine"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:600
msgid "Origine identità: {identityLabel}."
msgstr "Origine identità: {identityLabel}."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:670
msgid "Orizzonti"
msgstr "Orizzonti"

#: src/features/connect/components/ActivityFeed.tsx:91
#: src/features/connect/components/connectShared.tsx:71
#: src/features/connect/components/MemberManager.tsx:190
msgid "Ospite"
msgstr "Ospite"

#: src/features/connect/components/MemberManager.tsx:117
msgid "Ospiti"
msgstr "Ospiti"

#: src/features/admin/components/UserDetailContent.tsx:710
msgid "OTP via email"
msgstr "OTP via email"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:188
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:471
msgid "Outcome"
msgstr "Outcome"

#: src/features/voice_report/components/VoiceReportDetailPage.tsx:217
msgid "Outline"
msgstr "Outline"

#: src/features/admin/components/CostTraceDetailSection.tsx:177
#: src/features/hive-flows/components/nodeVisuals.tsx:49
msgid "Output"
msgstr "Output"

#: src/features/admin/components/AdminCostTracking.tsx:261
msgid "Output tokens"
msgstr "Output tokens"

#: src/features/admin/components/AdminPlatformSettings.tsx:1079
msgid "override"
msgstr "override"

#. placeholder {0}: m.usage_multiplier_override
#: src/features/admin/components/orgs/OrgMembersTab.tsx:485
msgid "override ×{0}"
msgstr "override ×{0}"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:483
msgid "Override impostato sul singolo membro"
msgstr "Override impostato sul singolo membro"

#: src/features/admin/components/GlobalMarkupCard.tsx:98
msgid "Override markup del tenant"
msgstr "Override markup del tenant"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:339
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:363
msgid "override opzionale"
msgstr "override opzionale"

#: src/features/admin/components/GlobalMarkupCard.tsx:123
msgid "Override per questo tenant — sostituisce il markup globale."
msgstr "Override per questo tenant — sostituisce il markup globale."

#: src/features/admin/components/orgs/OrgDetailShell.tsx:161
#: src/features/admin/components/UserDetailContent.tsx:265
#: src/features/console/components/ConsoleShell.tsx:206
#: src/features/console/docs/content.ts:1192
#: src/routes/_authed/_modal/admin/route.tsx:127
msgid "Overview"
msgstr "Overview"

#: src/features/admin/components/AdminOrgs.tsx:1394
#: src/features/admin/components/orgs/AddMemberDialog.tsx:212
#: src/features/admin/components/orgs/OrgMembersTab.tsx:456
#: src/features/projects/components/sections/MembersSection.tsx:68
#: src/features/projects/components/sections/MembersSection.tsx:196
msgid "Owner"
msgstr "Owner"

#: src/features/settings/components/OrgMembersPanel.tsx:558
msgid "Owner — controllo completo, può cambiare i ruoli"
msgstr "Owner — controllo completo, può cambiare i ruoli"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:117
msgid "Owner non migrabile"
msgstr "Owner non migrabile"

#. placeholder {0}: opts.owner
#: src/features/report/hooks/useRecommendationActions.ts:73
msgid "Owner suggerito: {0}."
msgstr "Owner suggerito: {0}."

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:79
msgid "P.IVA {buyerVat}"
msgstr "P.IVA {buyerVat}"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:176
msgid "P.IVA {customerVat}"
msgstr "P.IVA {customerVat}"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:366
msgid "P.IVA non valida (11 cifre)"
msgstr "P.IVA non valida (11 cifre)"

#: src/features/billing/components/CreditBalanceCard.tsx:113
msgid "Pacchetti"
msgstr "Pacchetti"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:47
msgid "Pacchetti di crediti"
msgstr "Pacchetti di crediti"

#: src/features/billing/components/CreditBalanceCard.tsx:150
msgid "Pacchetti non disponibili in questo ambiente."
msgstr "Pacchetti non disponibili in questo ambiente."

#: src/features/admin/components/AdminCpqPriceBook.tsx:263
msgid "Pacchetti PoC (sempre SaaS)"
msgstr "Pacchetti PoC (sempre SaaS)"

#: src/features/admin/components/AdminCpq.tsx:682
#: src/features/admin/components/AdminCpq.tsx:689
msgid "Pacchetto crediti"
msgstr "Pacchetto crediti"

#: src/features/admin/components/AdminCpqAskAndo.tsx:176
#: src/features/admin/components/AdminCpqCanvas.tsx:155
#: src/features/admin/components/AdminCpqProposalCopy.tsx:46
msgid "Pacchetto R&D"
msgstr "Pacchetto R&D"

#: src/features/connectors/wizards/openBankingSpec.tsx:155
#: src/features/connectors/wizards/openBankingSpec.tsx:160
msgid "Paese"
msgstr "Paese"

#: src/features/connectors/wizards/openBankingSpec.tsx:168
msgid "Paesi Bassi"
msgstr "Paesi Bassi"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:44
msgid "Pagamenti"
msgstr "Pagamenti"

#: src/features/settings/components/BillingSettings.tsx:95
msgid "Pagamenti gestiti tramite Stripe. Per la fatturazione a fattura, contatta il tuo account manager."
msgstr "Pagamenti gestiti tramite Stripe. Per la fatturazione a fattura, contatta il tuo account manager."

#: src/routes/_authed/workspace/finance.tsx:1588
msgid "Pagamenti ricorrenti degli ultimi 3 mesi"
msgstr "Pagamenti ricorrenti degli ultimi 3 mesi"

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:100
msgid "Pagamento (uscita)"
msgstr "Pagamento (uscita)"

#: src/features/billing/components/CurrentPlanCard.tsx:51
msgid "Pagamento in ritardo"
msgstr "Pagamento in ritardo"

#: src/features/console/pages/BillingPage.tsx:425
msgid "Pagamento richiesto"
msgstr "Pagamento richiesto"

#: src/features/console/pages/BillingPage.tsx:534
msgid "Pagamento sicuro tramite Stripe."
msgstr "Pagamento sicuro tramite Stripe."

#: src/features/console/components/TopupReturnStatus.tsx:82
msgid "Pagamento verificato. Il saldo è stato aggiornato."
msgstr "Pagamento verificato. Il saldo è stato aggiornato."

#: src/features/admin/components/AdminRevenue.tsx:105
msgid "Paganti"
msgstr "Paganti"

#: src/features/billing/components/InvoicesTable.tsx:32
#: src/features/console/components/StatusBadges.tsx:256
msgid "Pagata"
msgstr "Pagata"

#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:48
msgid "Pagato"
msgstr "Pagato"

#: src/features/sync/components/picker/NotionPickerModal.tsx:162
msgid "pagina"
msgstr "pagina"

#: src/features/admin/components/AdminDecks.tsx:231
#: src/features/console/pages/EmbeddedIdentityPage.tsx:616
msgid "Pagina"
msgstr "Pagina"

#. placeholder {0}: page + 1
#. placeholder {1}: formatInt(items.length)
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:445
msgid "Pagina {0} · {1} righe"
msgstr "Pagina {0} · {1} righe"

#. placeholder {0}: page + 1
#: ../../packages/ui/src/ando/DataPagedTable.tsx:313
msgid "Pagina {0} di {totalPages}"
msgstr "Pagina {0} di {totalPages}"

#. placeholder {0}: data.page
#. placeholder {1}: formatNumber(i18n.locale, data.total)
#: src/features/console/pages/DocumentsPage.tsx:878
msgid "Pagina {0} di {totalPages} — {1} documenti"
msgstr "Pagina {0} di {totalPages} — {1} documenti"

#. placeholder {0}: formatNumber(i18n.locale, total)
#: src/features/console/pages/FlowsPage.tsx:935
msgid "Pagina {page} di {totalPages} — {0} flow"
msgstr "Pagina {page} di {totalPages} — {0} flow"

#: src/features/admin/components/AdminOrgs.tsx:1087
msgid "Pagina {page} di {totalPages} · {total} totali"
msgstr "Pagina {page} di {totalPages} · {total} totali"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:484
msgid "Pagina {pageNumber}…"
msgstr "Pagina {pageNumber}…"

#: src/features/admin/components/AdminUsers.tsx:422
msgid "Pagina <0>{page}</0> di <1>{pages}</1>"
msgstr "Pagina <0>{page}</0> di <1>{pages}</1>"

#: src/features/admin/components/PageEditor.tsx:299
msgid "Pagina aggiornata"
msgstr "Pagina aggiornata"

#: src/features/console/pages/AccessOverviewPage.tsx:230
msgid "pagina corrente"
msgstr "pagina corrente"

#: src/features/admin/components/AdminDecks.tsx:242
msgid "Pagina interattiva"
msgstr "Pagina interattiva"

#: src/features/admin/components/AdminDecks.tsx:352
msgid "Pagina interattiva (HTML)"
msgstr "Pagina interattiva (HTML)"

#: src/features/settings/components/BrandKitSettings.tsx:627
msgid "Pagina interna"
msgstr "Pagina interna"

#: ../../packages/ui/src/ando/DataPagedTable.tsx:302
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:325
#: src/features/admin/components/AdminOrgs.tsx:1098
#: src/features/admin/components/AdminUsers.tsx:433
#: src/features/admin/components/orgs/_shared.tsx:220
#: src/features/console/pages/DocumentsPage.tsx:889
#: src/features/console/pages/FlowsPage.tsx:945
msgid "Pagina precedente"
msgstr "Pagina precedente"

#: src/features/admin/components/PageEditor.tsx:149
msgid "Pagina pronta."
msgstr "Pagina pronta."

#: ../../packages/ui/src/ando/DataPagedTable.tsx:319
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:337
#: src/features/admin/components/AdminOrgs.tsx:1109
#: src/features/admin/components/AdminUsers.tsx:442
#: src/features/admin/components/orgs/_shared.tsx:234
#: src/features/console/pages/DocumentsPage.tsx:899
#: src/features/console/pages/FlowsPage.tsx:955
msgid "Pagina successiva"
msgstr "Pagina successiva"

#: src/features/console/connectors/ManifestConfigForm.tsx:272
msgid "Paginazione a cursore"
msgstr "Paginazione a cursore"

#: src/features/console/pages/UsagePage.tsx:426
msgid "Pagine ingerite ({windowDays}g)"
msgstr "Pagine ingerite ({windowDays}g)"

#: src/features/console/pages/AccessOverviewPage.tsx:384
msgid "Pagine risorse"
msgstr "Pagine risorse"

#: ../../packages/ui/src/primitives/drawer.tsx:100
#: src/features/console/pages/PlaygroundPage.tsx:2066
msgid "Pannello"
msgstr "Pannello"

#: src/routes/_authed/route.tsx:772
msgid "Pannello conversazione Ando"
msgstr "Pannello conversazione Ando"

#: src/features/structured-data/components/InlineChartPanel.tsx:60
msgid "Pannello grafico"
msgstr "Pannello grafico"

#: src/features/sources/components/AISummaryPanel.tsx:311
msgid "Pannello revisione documento"
msgstr "Pannello revisione documento"

#: ../../packages/ui/src/editors/ReviewRail.tsx:210
msgid "Pannello revisione modifiche"
msgstr "Pannello revisione modifiche"

#: ../../packages/ui/src/editors/ReviewRail.tsx:156
msgid "Pannello revisione modifiche (chiuso)"
msgstr "Pannello revisione modifiche (chiuso)"

#: src/features/admin/components/AdminBilling.tsx:226
#: src/features/admin/components/AdminBilling.tsx:268
#: src/features/admin/components/AdminHypermem.tsx:89
#: src/features/clean-control/components/EventDetailSheet.tsx:264
#: src/features/console/pages/OverviewPage.tsx:155
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:478
#: src/features/workspace/config.ts:352
#: src/features/workspace/config.ts:359
#: src/routes/_authed/workspace/finance.tsx:249
msgid "Panoramica"
msgstr "Panoramica"

#: src/features/templates/components/TemplatesList.tsx:42
#: src/features/templates/components/TemplatesList.tsx:58
msgid "Paper"
msgstr "Paper"

#: src/features/studio/components/StudioDrawerContent.tsx:545
msgid "Paper · documenti"
msgstr "Paper · documenti"

#: src/features/templates/components/CreateTemplateDialog.tsx:52
#: src/features/templates/components/TemplateEditor.tsx:59
msgid "Paper · documento"
msgstr "Paper · documento"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:257
msgid "parallel"
msgstr "parallel"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:177
#: src/features/console/connectors/TestConnectorActionModal.tsx:240
msgid "Parametri (JSON)"
msgstr "Parametri (JSON)"

#: src/features/admin/components/AdminCpqPriceBook.tsx:215
msgid "Parametri generali"
msgstr "Parametri generali"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1608
msgid "Parametri richiesti al momento dell'esecuzione: controllali con attenzione prima di confermare."
msgstr "Parametri richiesti al momento dell'esecuzione: controllali con attenzione prima di confermare."

#: src/features/console/connectors/ManifestConfigForm.tsx:287
msgid "Parametro query"
msgstr "Parametro query"

#: src/features/admin/components/CostTraceDetailSection.tsx:223
msgid "Parent"
msgstr "Parent"

#: src/features/templates/components/TemplateFieldSpecs.ts:190
msgid "Parole · range consigliato 12 – 28."
msgstr "Parole · range consigliato 12 – 28."

#: src/features/settings/components/BrandKitSettings.tsx:832
msgid "Parole da evitare (separate da virgola)"
msgstr "Parole da evitare (separate da virgola)"

#: src/features/console/pages/ModelsPage.tsx:170
msgid "Parte della pipeline gestita da Ando. Collegare un account AI non cambia questa elaborazione."
msgstr "Parte della pipeline gestita da Ando. Collegare un account AI non cambia questa elaborazione."

#: src/features/sources/components/CalendarEventPane.tsx:476
msgid "Partecipa"
msgstr "Partecipa"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:514
msgid "Partecipante"
msgstr "Partecipante"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:242
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:368
#: src/features/sources/components/CalendarEventPane.tsx:520
#: src/features/sources/components/InboxDetailPane.tsx:786
#: src/routes/_authed/workspace/connect.$spaceId.tsx:510
msgid "Partecipanti"
msgstr "Partecipanti"

#: src/features/sources/components/CalendarEventPane.tsx:274
msgid "Partecipazione confermata"
msgstr "Partecipazione confermata"

#. placeholder {0}: data.offset + 1
#. placeholder {1}: Math.min(data.offset + data.parts.length, data.total)
#. placeholder {2}: data.total
#: src/features/console/components/DocumentAcquiredContent.tsx:85
msgid "Parti {0}–{1} di {2}"
msgstr "Parti {0}–{1} di {2}"

#: src/features/admin/components/AdminDecks.tsx:394
msgid "Parti da"
msgstr "Parti da"

#: src/features/projects/components/ProjectHub.tsx:582
msgid "Parti da template"
msgstr "Parti da template"

#: src/features/voice_report/components/TemplatesGallery.tsx:374
msgid "Parti da una struttura predefinita curata da Ando. Personalizzala dopo aver creato il report."
msgstr "Parti da una struttura predefinita curata da Ando. Personalizzala dopo aver creato il report."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:191
msgid "Parti da uno starter pack curato per ruolo. Ogni template imposta una persona dell'agente, le capability necessarie e i primi suggerimenti operativi."
msgstr "Parti da uno starter pack curato per ruolo. Ogni template imposta una persona dell'agente, le capability necessarie e i primi suggerimenti operativi."

#: src/features/projects/components/ProjectHub.tsx:547
msgid "Parti da zero — solo nome, icona e colore."
msgstr "Parti da zero — solo nome, icona e colore."

#: src/features/console/pages/FlowsPage.tsx:521
msgid "Parti da zero (canvas)"
msgstr "Parti da zero (canvas)"

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:223
msgid "Parti da zero e aggiungi widget uno alla volta."
msgstr "Parti da zero e aggiungi widget uno alla volta."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:49
#: src/features/connectors/wizards/sdiSpec.tsx:72
msgid "Partita IVA"
msgstr "Partita IVA"

#: src/features/clean-control/utils/signalCatalog.ts:173
msgid "Partita IVA con Luhn errato."
msgstr "Partita IVA con Luhn errato."

#: src/features/clean-control/utils/signalCatalog.ts:172
msgid "Partita IVA non valida"
msgstr "Partita IVA non valida"

#: src/features/admin/components/AdminCpqAskAndo.tsx:167
msgid "Partner"
msgstr "Partner"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:174
msgid "Passa a infrastruttura dedicata per database, vector store e cache isolati per questa org."
msgstr "Passa a infrastruttura dedicata per database, vector store e cache isolati per questa org."

#: src/features/chat/components/SmartLayoutHint.tsx:150
msgid "Passa a schermo intero"
msgstr "Passa a schermo intero"

#: src/features/console/docs/content.ts:567
msgid "Passa lo stesso conversation_id a più agentic_answer: il follow-up è reso autonomo con le entità della conversazione (\"e il primo di quella lista?\")."
msgstr "Passa lo stesso conversation_id a più agentic_answer: il follow-up è reso autonomo con le entità della conversazione (\"e il primo di quella lista?\")."

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:575
msgid "Passa sopra a una sezione per modificarla"
msgstr "Passa sopra a una sezione per modificarla"

#: src/features/console/pages/ResourceAccessPage.tsx:350
msgid "Passaggi per condividere"
msgstr "Passaggi per condividere"

#: src/features/console/pages/OverviewPage.tsx:242
msgid "Passaggi per fonte"
msgstr "Passaggi per fonte"

#: src/features/console/pages/PlaygroundPage.tsx:848
msgid "Passaggi recuperati"
msgstr "Passaggi recuperati"

#: src/features/console/pages/OverviewPage.tsx:216
msgid "Passaggi ricercabili"
msgstr "Passaggi ricercabili"

#. placeholder {0}: i18n._(STEP_TITLES[step])
#: src/features/console/components/CreateKeyWizard.tsx:138
msgid "Passaggio {step} di 3 — {0}"
msgstr "Passaggio {step} di 3 — {0}"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1055
msgid "Passaggio {step} di 3 — {label}"
msgstr "Passaggio {step} di 3 — {label}"

#: src/features/console/pages/PlaygroundPage.tsx:667
msgid "Passaggio senza titolo"
msgstr "Passaggio senza titolo"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:682
#: src/features/admin/components/deckEditor/DeckEditor.tsx:995
msgid "Passi"
msgstr "Passi"

#: src/features/console/pages/PlaygroundPage.tsx:1913
msgid "Passi max"
msgstr "Passi max"

#: src/features/report/components/NpsPromoterDetractorGrid.tsx:70
msgid "Passivi"
msgstr "Passivi"

#. placeholder {0}: stepIndex + 1
#. placeholder {1}: STEP_ORDER.length
#. placeholder {2}: i18n._(STEP_LABELS[state.step])
#: src/features/dashboard/components/AddWidgetWizard.tsx:362
msgid "Passo {0} di {1}: {2}"
msgstr "Passo {0} di {1}: {2}"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1517
msgid "Passo del flow"
msgstr "Passo del flow"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:419
#: src/features/auth/desktop/DesktopLoginForm.tsx:732
#: src/features/connectors/components/FilesystemConnectDialog.tsx:593
#: src/features/connectors/components/FilesystemConnectDialog.tsx:677
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:784
#: src/features/settings/components/SecuritySettings.tsx:98
msgid "Password"
msgstr "Password"

#: src/features/settings/components/SecuritySettings.tsx:44
msgid "password · MFA · sessioni attive"
msgstr "password · MFA · sessioni attive"

#: src/features/admin/components/ZitadelPasswordActions.tsx:135
msgid "Password aggiornata"
msgstr "Password aggiornata"

#: src/features/settings/components/SecuritySettings.tsx:138
msgid "Password aggiornata."
msgstr "Password aggiornata."

#: src/features/settings/components/SecuritySettings.tsx:103
msgid "Password attuale"
msgstr "Password attuale"

#: src/features/settings/components/SecuritySettings.tsx:201
msgid "Password attuale (richiesta per la rimozione)"
msgstr "Password attuale (richiesta per la rimozione)"

#: src/features/admin/components/ZitadelPasswordActions.tsx:114
msgid "Password copiata"
msgstr "Password copiata"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:421
msgid "Password del PDF"
msgstr "Password del PDF"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:245
msgid "Password di prova"
msgstr "Password di prova"

#: src/features/auth/desktop/DesktopLoginForm.tsx:767
msgid "Password dimenticata?"
msgstr "Password dimenticata?"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:417
msgid "Password errata. Riprova."
msgstr "Password errata. Riprova."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:95
#: src/features/admin/components/orgs/OrgSecurityTab.tsx:156
msgid "Password policy"
msgstr "Password policy"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:91
msgid "Password policy salvata"
msgstr "Password policy salvata"

#: src/routes/_authed/workspace/finance.tsx:1149
msgid "Patrimonio netto (€)"
msgstr "Patrimonio netto (€)"

#: src/features/settings/components/NotificationPreferences.tsx:83
msgid "Pattern break"
msgstr "Pattern break"

#: src/features/settings/components/NotificationPreferences.tsx:90
msgid "Pattern delle tue azioni che si potrebbero automatizzare."
msgstr "Pattern delle tue azioni che si potrebbero automatizzare."

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:296
msgid "Pattern di azioni ricorrenti rilevati ma non ancora salvati come workflow"
msgstr "Pattern di azioni ricorrenti rilevati ma non ancora salvati come workflow"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:610
msgid "Pattern di azioni ripetute rilevati da Process Codification. Approva per creare un Operatore automatizzato Temporal, rigetta per archiviare con motivazione (audit trail)."
msgstr "Pattern di azioni ripetute rilevati da Process Codification. Approva per creare un Operatore automatizzato Temporal, rigetta per archiviare con motivazione (audit trail)."

#: src/features/structured-data/components/SimilarPartsSection.tsx:119
msgid "Pattern fori/feature (legacy)"
msgstr "Pattern fori/feature (legacy)"

#: src/features/automations/components/AutomationsHub.tsx:383
#: src/features/hive-flows/components/FlowActivateControl.tsx:208
msgid "Pausa"
msgstr "Pausa"

#: src/features/chat/components/AudioPlayer.tsx:95
msgid "Pausa audio"
msgstr "Pausa audio"

#: src/features/console/pages/TracesPage.tsx:106
msgid "payload"
msgstr "payload"

#: src/features/console/webhooks/WebhooksPanel.tsx:209
msgid "Payload JSON"
msgstr "Payload JSON"

#: src/features/console/docs/content.ts:1999
msgid "Payload non valido (dettaglio nel message)."
msgstr "Payload non valido (dettaglio nel message)."

#: src/features/price-lists/components/PriceListsPage.tsx:931
msgid "pcs / kg / m"
msgstr "pcs / kg / m"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:92
#: src/routes/_authed/workspace/documents.tsx:1117
msgid "PDF"
msgstr "PDF"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:415
msgid "PDF protetto da password"
msgstr "PDF protetto da password"

#: src/features/console/pages/DocumentsPage.tsx:202
msgid "PDF, DOCX, TXT o MD — massimo 25 MB per file"
msgstr "PDF, DOCX, TXT o MD — massimo 25 MB per file"

#: src/features/workspace/components/UploadModal.tsx:352
msgid "PDF, immagini, Office, CSV, JSON, ZIP, CAD"
msgstr "PDF, immagini, Office, CSV, JSON, ZIP, CAD"

#: src/features/admin/components/AdminDecks.tsx:448
msgid "PDF, Word, PowerPoint, Excel o testo. All'apertura Ando costruisce le slide dal documento: le rivedi e le accetti una per una."
msgstr "PDF, Word, PowerPoint, Excel o testo. All'apertura Ando costruisce le slide dal documento: le rivedi e le accetti una per una."

#: src/features/console/connectors/meta.ts:138
#: src/features/workspace/config.ts:337
#: src/routes/_authed/workspace/conversations.tsx:575
msgid "PEC"
msgstr "PEC"

#: src/routes/_authed/workspace/conversations.tsx:1121
msgid "PEC · SDI"
msgstr "PEC · SDI"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:165
#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:359
msgid "PEC certificata"
msgstr "PEC certificata"

#: src/features/connectors/wizards/pecSpec.tsx:51
msgid "PEC in chat"
msgstr "PEC in chat"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:98
msgid "PEC SDI"
msgstr "PEC SDI"

#: src/features/onboarding/ConnectorsIntro.tsx:59
msgid "PEC, SDI, cassetto fiscale, conservazione a norma"
msgstr "PEC, SDI, cassetto fiscale, conservazione a norma"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:541
msgid "per"
msgstr "per"

#: ../../packages/ui/src/ando/actions/FicCreditNotePreview.tsx:55
msgid "Per {customer}"
msgstr "Per {customer}"

#: src/routes/connect.space.$spaceId.tsx:78
msgid "Per accedere a questo spazio usa il link di invito che hai ricevuto via email. Da lì potrai entrare e fare domande."
msgstr "Per accedere a questo spazio usa il link di invito che hai ricevuto via email. Da lì potrai entrare e fare domande."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:297
msgid "Per Active Directory servono realm, KDC e utente."
msgstr "Per Active Directory servono realm, KDC e utente."

#: src/features/onboarding/sectionGuides.ts:46
msgid "Per analisi su gestionale e banca usa il pulsante «Crea un grafico» nel pannello Dashboard: scegli la fonte e la query parte sui dati strutturati."
msgstr "Per analisi su gestionale e banca usa il pulsante «Crea un grafico» nel pannello Dashboard: scegli la fonte e la query parte sui dati strutturati."

#: src/features/console/components/CommandPalette.tsx:220
msgid "per aprire"
msgstr "per aprire"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:481
msgid "Per avviare il sync serve una AppKey server attiva nel progetto: fornisce l'identità proprietaria dei dati indicizzati."
msgstr "Per avviare il sync serve una AppKey server attiva nel progetto: fornisce l'identità proprietaria dei dati indicizzati."

#: src/features/workspace/documents/utils/sourceGroup.ts:246
msgid "Per cartella"
msgstr "Per cartella"

#: src/features/onboarding/demoTourSteps.ts:53
msgid "Per chiedere di gestionale, banca o fatturato apri «Ambito» e seleziona la fonte dati — ad esempio il connettore Gestionale. Così Ando sa dove cercare. Prova: «Quali fatture sono scadute?» oppure «5 clienti per fatturato»."
msgstr "Per chiedere di gestionale, banca o fatturato apri «Ambito» e seleziona la fonte dati — ad esempio il connettore Gestionale. Così Ando sa dove cercare. Prova: «Quali fatture sono scadute?» oppure «5 clienti per fatturato»."

#: src/features/account/components/OrgSwitcherDialog.tsx:255
msgid "per chiudere"
msgstr "per chiudere"

#: src/features/settings/components/SecuritySettings.tsx:357
msgid "Per chiudere la sessione corrente usa Logout"
msgstr "Per chiudere la sessione corrente usa Logout"

#: src/features/onboarding/ConnectorsIntro.tsx:200
msgid "Per collegare: scegli un connettore qui sotto, premi Collega e autorizza nella finestra del provider. Stato e ultimo aggiornamento sono mostrati su ogni riga."
msgstr "Per collegare: scegli un connettore qui sotto, premi Collega e autorizza nella finestra del provider. Stato e ultimo aggiornamento sono mostrati su ogni riga."

#: src/features/console/connectors/ConnectionAccessSummary.tsx:82
msgid "Per condividere, seleziona prima i contenuti già indicizzati in Ando. L'account originale resta privato."
msgstr "Per condividere, seleziona prima i contenuti già indicizzati in Ando. L'account originale resta privato."

#: src/features/admin/components/AdminOrgs.tsx:1298
#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:172
msgid "per confermare:"
msgstr "per confermare:"

#: src/features/workspace/documents/utils/sourceGroup.ts:245
msgid "Per data"
msgstr "Per data"

#: src/features/admin/components/orgs/OrgCostTab.tsx:378
#: src/features/workspace/documents/utils/sourceGroup.ts:244
msgid "Per fonte"
msgstr "Per fonte"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:412
msgid "Per il binding indica un metodo HTTP e un percorso che inizi con «/»."
msgstr "Per il binding indica un metodo HTTP e un percorso che inizi con «/»."

#: src/features/console/components/CreateKeyWizard.tsx:322
msgid "Per il server della tua app: ogni richiesta deve identificare un suo utente. La chiave non concede accesso ai dati degli altri utenti o alle fonti del progetto."
msgstr "Per il server della tua app: ogni richiesta deve identificare un suo utente. La chiave non concede accesso ai dati degli altri utenti o alle fonti del progetto."

#: src/features/connectors/wizards/openBankingSpec.tsx:74
msgid "Per il tuo paese la selezione della banca avviene direttamente sul portale dell'aggregatore PSD2."
msgstr "Per il tuo paese la selezione della banca avviene direttamente sul portale dell'aggregatore PSD2."

#: src/features/console/components/CreateKeyWizard.tsx:321
msgid "Per il tuo server: interroga le fonti del progetto. Gli account privati del proprietario richiedono la query personale dedicata."
msgstr "Per il tuo server: interroga le fonti del progetto. Gli account privati del proprietario richiedono la query personale dedicata."

#: src/features/console/components/FirstRunTimeline.tsx:257
msgid "Per integrare Ando nel tuo applicativo, usa una AppKey con i permessi necessari. Esporta base URL e chiave, poi verifica l'accesso con <0>/me</0>."
msgstr "Per integrare Ando nel tuo applicativo, usa una AppKey con i permessi necessari. Esporta base URL e chiave, poi verifica l'accesso con <0>/me</0>."

#: src/features/onboarding/demoTourSteps.ts:54
msgid "Per interrogare i tuoi dati strutturati (gestionale, banca, fatturato) apri «Ambito» e seleziona la fonte dati, ad esempio il tuo connettore Gestionale. Così Ando sa dove cercare. Prova: «Quali fatture sono scadute?»."
msgstr "Per interrogare i tuoi dati strutturati (gestionale, banca, fatturato) apri «Ambito» e seleziona la fonte dati, ad esempio il tuo connettore Gestionale. Così Ando sa dove cercare. Prova: «Quali fatture sono scadute?»."

#: src/features/console/components/AssistPanel.tsx:292
msgid "per inviare"
msgstr "per inviare"

#: src/features/console/components/CreateKeyWizard.tsx:323
msgid "Per la tua app con login OIDC: Ando verifica il token dell'utente a ogni richiesta. La chiave non concede accesso ai dati degli altri utenti o alle fonti del progetto."
msgstr "Per la tua app con login OIDC: Ando verifica il token dell'utente a ogni richiesta. La chiave non concede accesso ai dati degli altri utenti o alle fonti del progetto."

#: src/features/console/pages/PlaygroundPage.tsx:1859
msgid "Per Lakehouse scegli solo fonti documentali."
msgstr "Per Lakehouse scegli solo fonti documentali."

#: src/features/console/pages/PlaygroundPage.tsx:1857
msgid "Per Lakehouse usa la sessione corrente."
msgstr "Per Lakehouse usa la sessione corrente."

#: src/features/workspace/inbox/utils/threadGroup.ts:52
msgid "Per messaggio"
msgstr "Per messaggio"

#: src/features/admin/components/orgs/OrgCostTab.tsx:383
msgid "Per modello"
msgstr "Per modello"

#: src/features/billing/components/InvoiceBilledBanner.tsx:55
msgid "Per modifiche al piano o crediti aggiuntivi contatta l'amministratore della tua azienda o il referente commerciale."
msgstr "Per modifiche al piano o crediti aggiuntivi contatta l'amministratore della tua azienda o il referente commerciale."

#: src/features/account/components/OrgSwitcherDialog.tsx:253
#: src/features/console/components/CommandPalette.tsx:225
msgid "per navigare"
msgstr "per navigare"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:366
msgid "Per ora il login gestito ammette solo utenti della Organization Zitadel collegata al tuo tenant Ando. L'accesso tra organizzazioni diverse non è ancora disponibile."
msgstr "Per ora il login gestito ammette solo utenti della Organization Zitadel collegata al tuo tenant Ando. L'accesso tra organizzazioni diverse non è ancora disponibile."

#: src/features/admin/components/AdminUsers.tsx:270
#: src/features/admin/components/orgs/_shared.tsx:198
msgid "Per pagina"
msgstr "Per pagina"

#: src/features/settings/components/AccountDeletion.tsx:167
msgid "Per procedere, digita <0>{CONFIRM_PHRASE}</0> in stampatello. La parola distingue maiuscole e minuscole."
msgstr "Per procedere, digita <0>{CONFIRM_PHRASE}</0> in stampatello. La parola distingue maiuscole e minuscole."

#: src/features/console/pages/PlaygroundPage.tsx:1974
msgid "Per provare gli account di un utente della tua app usa l'identità di prova nella pagina"
msgstr "Per provare gli account di un utente della tua app usa l'identità di prova nella pagina"

#: src/features/admin/components/orgs/OrgCostTab.tsx:388
msgid "Per provider"
msgstr "Per provider"

#: src/features/structured-data/components/SimilarPartsSection.tsx:285
msgid "Per questa metrica non c'è nessun candidato. Prova un'altra metrica nella barra di sopra."
msgstr "Per questa metrica non c'è nessun candidato. Prova un'altra metrica nella barra di sopra."

#: src/features/hive-flows/run/PdfDropzone.tsx:232
msgid "per scegliere un file"
msgstr "per scegliere un file"

#. placeholder {0}: hint.provider
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:116
msgid "Per segnare le email come lette su {0}, riconnetti l'account."
msgstr "Per segnare le email come lette su {0}, riconnetti l'account."

#: src/features/account/components/OrgSwitcherDialog.tsx:254
msgid "per selezionare"
msgstr "per selezionare"

#: src/features/admin/components/AdminHypermem.tsx:98
msgid "Per Tenant"
msgstr "Per Tenant"

#: src/features/workspace/inbox/utils/threadGroup.ts:51
msgid "Per thread"
msgstr "Per thread"

#: src/features/console/lib/onboarding.ts:93
msgid "Per usare Ando via API, crea una chiave con i permessi necessari. Puoi già provare le fonti dal Playground con la tua sessione."
msgstr "Per usare Ando via API, crea una chiave con i permessi necessari. Puoi già provare le fonti dal Playground con la tua sessione."

#: src/features/dashboard/components/wizard/WizardStepData.tsx:143
msgid "Per usare l'AI serve una sorgente database connessa (torna al passo Sorgente)."
msgstr "Per usare l'AI serve una sorgente database connessa (torna al passo Sorgente)."

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:375
msgid "Per utente"
msgstr "Per utente"

#: src/features/admin/components/UserDetailContent.tsx:860
msgid "Per visualizzare email, nome e telefono in chiaro, fornisci una giustificazione (≥ 10 caratteri). L'azione è registrata in audit log e la modalità scade automaticamente dopo 5 minuti."
msgstr "Per visualizzare email, nome e telefono in chiaro, fornisci una giustificazione (≥ 10 caratteri). L'azione è registrata in audit log e la modalità scade automaticamente dopo 5 minuti."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:471
msgid "Percentuale costo utilizzato"
msgstr "Percentuale costo utilizzato"

#: src/features/admin/components/GlobalMarkupCard.tsx:99
msgid "Percentuale di markup globale"
msgstr "Percentuale di markup globale"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:502
msgid "Percentuale storage utilizzato"
msgstr "Percentuale storage utilizzato"

#: src/features/console/components/FirstRunTimeline.tsx:256
#: src/features/console/pages/SchemaPage.tsx:894
msgid "Perché"
msgstr "Perché"

#: src/routes/_authed/_modal/settings/help.tsx:85
msgid "Perché alcuni messaggi sono più lenti di altri?"
msgstr "Perché alcuni messaggi sono più lenti di altri?"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerReasoning.tsx:44
msgid "Perché Ando propone questi valori"
msgstr "Perché Ando propone questi valori"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:973
msgid "Perché non è verificabile automaticamente"
msgstr "Perché non è verificabile automaticamente"

#: src/features/sales/components/LeadDetailDrawer.tsx:153
msgid "Perché ora"
msgstr "Perché ora"

#: src/features/sales/components/LeadDetailDrawer.tsx:168
msgid "Perché questo punteggio"
msgstr "Perché questo punteggio"

#: src/features/clean-control/components/EventRow.tsx:338
msgid "Perché?"
msgstr "Perché?"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:82
msgid "Percorsi di integrazione disponibili"
msgstr "Percorsi di integrazione disponibili"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:390
#: src/features/console/pages/PlaygroundPage.tsx:884
#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:134
msgid "Percorso"
msgstr "Percorso"

#: src/features/connectors/wizards/filesystemSpec.tsx:99
msgid "Percorso (prefisso)"
msgstr "Percorso (prefisso)"

#: src/features/connectors/wizards/databaseSpec.tsx:226
msgid "Percorso al file SQLite raggiungibile dall'agente."
msgstr "Percorso al file SQLite raggiungibile dall'agente."

#: src/features/connectors/wizards/databaseSpec.tsx:101
msgid "Percorso assoluto al file .sqlite/.db nel filesystem dell'agente."
msgstr "Percorso assoluto al file .sqlite/.db nel filesystem dell'agente."

#: src/features/onboarding/sectionGuides.ts:59
msgid "Percorso consigliato: collega una fonte dati, poi premi «Crea un grafico», scegli la fonte e descrivi cosa vuoi vedere (es. «fatturato per mese»). Fissa il grafico sulla dashboard."
msgstr "Percorso consigliato: collega una fonte dati, poi premi «Crea un grafico», scegli la fonte e descrivi cosa vuoi vedere (es. «fatturato per mese»). Fissa il grafico sulla dashboard."

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1178
msgid "Percorso del CA o contenuto PEM."
msgstr "Percorso del CA o contenuto PEM."

#: src/features/console/components/atoms.tsx:745
msgid "Percorso di navigazione"
msgstr "Percorso di navigazione"

#: src/features/connectors/wizards/databaseSpec.tsx:97
msgid "Percorso file"
msgstr "Percorso file"

#: src/features/console/connectors/ManifestConfigForm.tsx:172
msgid "Percorso risorsa"
msgstr "Percorso risorsa"

#: src/features/admin/components/AdminCpqPriceBook.tsx:249
msgid "Perimetro"
msgstr "Perimetro"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:99
#: src/features/billing/components/InvoicesTable.tsx:110
#: src/features/console/pages/BillingPage.tsx:596
#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:69
#: src/features/workspace/components/searchFilters/ConversationsSearchFilters.tsx:66
#: src/features/workspace/components/searchFilters/DocumentsSearchFilters.tsx:53
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:97
#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:115
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:68
msgid "Periodo"
msgstr "Periodo"

#: src/features/dashboard/components/ChartSqlEditor.tsx:112
msgid "Periodo applicato nella query SQL"
msgstr "Periodo applicato nella query SQL"

#: src/features/dashboard/components/ChartTimeRangeSettings.tsx:34
#: src/features/dashboard/components/ChartTimeRangeSettings.tsx:38
msgid "Periodo del grafico"
msgstr "Periodo del grafico"

#: src/features/structured-data/components/TemporalQueryControl.tsx:158
msgid "Periodo del risultato"
msgstr "Periodo del risultato"

#: src/features/dashboard/components/DashboardChartCard.tsx:684
#: src/features/dashboard/components/DashboardChartCard.tsx:699
msgid "Periodo della query"
msgstr "Periodo della query"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:55
msgid "Periodo delle riunioni"
msgstr "Periodo delle riunioni"

#: src/routes/_authed/workspace/finance.tsx:337
msgid "Periodo di previsione"
msgstr "Periodo di previsione"

#: src/features/console/components/OverlapRotationModal.tsx:151
msgid "Periodo di sovrapposizione"
msgstr "Periodo di sovrapposizione"

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:72
msgid "Periodo e date"
msgstr "Periodo e date"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:463
msgid "Periodo non aggiornato. I dati precedenti restano visibili."
msgstr "Periodo non aggiornato. I dati precedenti restano visibili."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:244
msgid "Periodo visualizzato"
msgstr "Periodo visualizzato"

#: src/features/console/components/CreateKeyWizard.tsx:348
msgid "Permessi"
msgstr "Permessi"

#: src/features/connectors/wizards/driveSpec.tsx:116
msgid "Permessi rispettati"
msgstr "Permessi rispettati"

#: src/features/dashboard/components/ShareChartSheet.tsx:298
#: src/features/dashboard/components/ShareDashboardSheet.tsx:285
msgid "Permesso"
msgstr "Permesso"

#: src/features/chat/hooks/useAudioRecorder.ts:70
msgid "Permesso microfono negato."
msgstr "Permesso microfono negato."

#: src/features/dashboard/components/ShareChartSheet.tsx:362
#: src/features/dashboard/components/ShareDashboardSheet.tsx:349
msgid "Permesso per {memberName}"
msgstr "Permesso per {memberName}"

#: src/features/sales/components/crm/DealDetailDrawer.tsx:111
#: src/features/sales/components/crm/RecordDrawer.tsx:260
msgid "Persa"
msgstr "Persa"

#: src/features/admin/components/AdminEngagement.tsx:175
msgid "Persi · 7gg"
msgstr "Persi · 7gg"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:106
#: src/features/console/pages/ResourceAccessPage.tsx:564
#: src/features/projects/components/ProjectDetailPage.tsx:222
msgid "Persona"
msgstr "Persona"

#: src/features/projects/components/sections/PersonaSection.tsx:155
msgid "Persona del progetto aggiornata"
msgstr "Persona del progetto aggiornata"

#: src/features/projects/components/ProjectHub.tsx:528
msgid "Persona, capability e prima impostazione già pronti per ruolo."
msgstr "Persona, capability e prima impostazione già pronti per ruolo."

#: src/features/agent-modes/components/AgentModeEditor.tsx:366
#: src/features/agent-modes/components/AgentModeEditor.tsx:629
#: src/features/sales/components/TemplateManager.tsx:197
#: src/features/settings/components/PresentationTemplates.tsx:93
#: src/features/settings/marp/CssUploadPanel.tsx:287
msgid "Personale"
msgstr "Personale"

#: src/features/console/pages/BillingPage.tsx:175
msgid "Personale per membro"
msgstr "Personale per membro"

#: src/features/connectors/wizards/calendarSpec.tsx:81
msgid "Personale, team, condivisi — un'unica timeline."
msgstr "Personale, team, condivisi — un'unica timeline."

#: src/features/agent-modes/components/AgentModesList.tsx:59
#: src/features/settings/components/PresentationTemplates.tsx:419
msgid "Personali"
msgstr "Personali"

#. placeholder {0}: template.name
#: src/features/templates/components/TemplatesList.tsx:233
msgid "Personalizza {0}"
msgstr "Personalizza {0}"

#: src/features/settings/components/MemoryConsentBanner.tsx:100
msgid "Personalizza Ando con la memoria"
msgstr "Personalizza Ando con la memoria"

#: src/features/studio/components/StudioDrawerContent.tsx:103
msgid "Personalizza come Ando lavora e si presenta."
msgstr "Personalizza come Ando lavora e si presenta."

#: src/features/settings/components/PresentationTemplates.tsx:226
msgid "Personalizza il modo in cui Ando genera slide, documenti Word e il tono di voce dell'AI. Il default si applica a ogni nuova creazione; puoi sovrascriverlo per singolo deck."
msgstr "Personalizza il modo in cui Ando genera slide, documenti Word e il tono di voce dell'AI. Il default si applica a ogni nuova creazione; puoi sovrascriverlo per singolo deck."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:186
msgid "Personalizza il nome del progetto prima di crearlo. Persona, istruzioni e capability richieste verranno copiate dal template."
msgstr "Personalizza il nome del progetto prima di crearlo. Persona, istruzioni e capability richieste verranno copiate dal template."

#: src/features/templates/components/TemplatesList.tsx:286
msgid "Personalizza per modificare"
msgstr "Personalizza per modificare"

#: src/features/dashboard/components/DashboardViewControls.tsx:35
msgid "Personalizzata"
msgstr "Personalizzata"

#: src/features/console/pages/ConnectorsPage.tsx:64
msgid "Personalizzati"
msgstr "Personalizzati"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:106
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:339
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:441
msgid "Personalizzato"
msgstr "Personalizzato"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:100
msgid "Personalizzato…"
msgstr "Personalizzato…"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:179
msgid "Personalizzazione pagina di login per i membri di {orgName}."
msgstr "Personalizzazione pagina di login per i membri di {orgName}."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:993
#: src/features/dashboard/components/ShareChartSheet.tsx:113
#: src/features/dashboard/components/ShareDashboardSheet.tsx:106
msgid "Persone"
msgstr "Persone"

#: src/features/console/pages/ResourceAccessPage.tsx:548
#: src/features/console/pages/ResourceAccessPage.tsx:558
msgid "Persone autorizzate"
msgstr "Persone autorizzate"

#: src/features/sales/components/CampaignSharing.tsx:169
msgid "Persone con accesso"
msgstr "Persone con accesso"

#: src/features/projects/components/ProjectDetailPage.tsx:278
msgid "Persone con accesso a questo progetto"
msgstr "Persone con accesso a questo progetto"

#: src/features/console/pages/MembersPage.tsx:603
msgid "Persone invitate che non hanno ancora accettato."
msgstr "Persone invitate che non hanno ancora accettato."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:600
msgid "Persone registrate"
msgstr "Persone registrate"

#: src/features/console/pages/ResourceAccessPage.tsx:521
msgid "Persone scelte da te"
msgstr "Persone scelte da te"

#: src/features/templates/components/TemplateFieldSpecs.ts:171
msgid "Persuasivo"
msgstr "Persuasivo"

#: src/features/admin/components/AdminCpqPriceBook.tsx:247
#: src/features/admin/components/AdminCpqPriceBook.tsx:279
msgid "Peso infra"
msgstr "Peso infra"

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:48
#: src/features/structured-data/components/SimilarPartsSection.tsx:168
#: src/features/structured-data/components/SimilarPartsSection.tsx:185
msgid "Pezzi simili"
msgstr "Pezzi simili"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:371
msgid "Phone number selection…"
msgstr "Phone number selection…"

#: src/features/admin/components/AdminPlatformSettings.tsx:543
#: src/features/admin/components/AdminPlatformSettings.tsx:1154
msgid "Piani Usage Tier"
msgstr "Piani Usage Tier"

#: src/features/chat/components/ChatEmptyState.tsx:276
msgid "Pianifica cosa farò domani in base alle priorità correnti."
msgstr "Pianifica cosa farò domani in base alle priorità correnti."

#: src/features/console/pages/FlowsPage.tsx:117
#: src/routes/_authed/workspace/flows.index.tsx:76
msgid "Pianificato"
msgstr "Pianificato"

#: src/features/console/pages/FlowDetailPage.tsx:201
#: src/features/console/pages/FlowDetailPage.tsx:208
#: src/features/console/pages/PlaygroundPage.tsx:869
msgid "Pianificazione"
msgstr "Pianificazione"

#: src/features/voice_report/components/SettingsTab.tsx:166
msgid "Pianificazione (cron, opzionale)"
msgstr "Pianificazione (cron, opzionale)"

#: src/features/voice_report/components/NewReportDialog.tsx:1036
msgid "Pianificazione (cron)"
msgstr "Pianificazione (cron)"

#: src/features/admin/components/AdminOrgs.tsx:1017
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:220
#: src/features/console/pages/BillingPage.tsx:259
#: src/features/console/pages/BillingPage.tsx:276
msgid "Piano"
msgstr "Piano"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:218
msgid "Piano & crediti"
msgstr "Piano & crediti"

#: src/features/billing/components/CurrentPlanCard.tsx:143
msgid "Piano a fattura — modifiche tramite il tuo account manager."
msgstr "Piano a fattura — modifiche tramite il tuo account manager."

#: src/features/admin/components/AdminPlatformSettings.tsx:446
msgid "Piano aggiornato"
msgstr "Piano aggiornato"

#: src/features/settings/components/BillingSettings.tsx:130
msgid "Piano corrente"
msgstr "Piano corrente"

#: src/features/admin/components/AdminPlatformSettings.tsx:459
msgid "Piano creato"
msgstr "Piano creato"

#: src/features/admin/components/AdminPlatformSettings.tsx:472
msgid "Piano eliminato"
msgstr "Piano eliminato"

#: src/features/billing/components/InvoiceBilledBanner.tsx:49
msgid "Piano gestito a fattura"
msgstr "Piano gestito a fattura"

#: src/features/connectors/components/StatusChip.tsx:32
msgid "Piano superiore"
msgstr "Piano superiore"

#: src/features/integrations/parts/CapabilityHeader.tsx:80
msgid "Piano superiore richiesto"
msgstr "Piano superiore richiesto"

#: src/features/admin/components/MaintenanceControl.tsx:105
msgid "Piattaforma operativa"
msgstr "Piattaforma operativa"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:224
msgid "Picker in attesa…"
msgstr "Picker in attesa…"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:204
msgid "Picker non disponibile in questo contesto."
msgstr "Picker non disponibile in questo contesto."

#: src/features/settings/components/BrandKitSettings.tsx:405
msgid "Piè di pagina (footer)"
msgstr "Piè di pagina (footer)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:811
msgid "Pieno"
msgstr "Pieno"

#: src/features/admin/components/UserDetailContent.tsx:278
msgid "PII Inspect"
msgstr "PII Inspect"

#: src/features/admin/components/AdminUsers.tsx:208
msgid "PII mascherate di default. Apri il dettaglio utente per drill-down, sessioni, MFA, trace e (capability-gated) PII Inspect Mode con revoca automatica dopo 5 minuti."
msgstr "PII mascherate di default. Apri il dettaglio utente per drill-down, sessioni, MFA, trace e (capability-gated) PII Inspect Mode con revoca automatica dopo 5 minuti."

#: src/features/admin/components/UserDetailContent.tsx:817
msgid "PII utente"
msgstr "PII utente"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:130
msgid "Pillar"
msgstr "Pillar"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:250
msgid "Pillar attivi"
msgstr "Pillar attivi"

#. placeholder {0}: recipient.pilot_months ?? 6
#: src/features/admin/components/AdminCpq.tsx:204
msgid "Pilota ({0} mesi)"
msgstr "Pilota ({0} mesi)"

#: src/features/admin/components/AdminCostTracking.tsx:225
#: src/features/admin/components/AdminOverview.tsx:95
msgid "Pilotaggio"
msgstr "Pilotaggio"

#: src/features/workspace/documents/components/BulkActionBar.tsx:67
#: src/features/workspace/documents/components/DocumentCardV2.tsx:298
msgid "Pinna"
msgstr "Pinna"

#: src/features/dashboard/components/DashboardTemplatePicker.tsx:134
msgid "Pinna i grafici che Ando genera o creane manualmente partendo dai dati che hai già caricato. Inizia da un template o da una dashboard vuota."
msgstr "Pinna i grafici che Ando genera o creane manualmente partendo dai dati che hai già caricato. Inizia da un template o da una dashboard vuota."

#: src/routes/_authed/workspace/dashboard.tsx:970
msgid "Pinna il grafico per salvarlo nella dashboard."
msgstr "Pinna il grafico per salvarlo nella dashboard."

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:148
msgid "Pinna in dashboard"
msgstr "Pinna in dashboard"

#: src/features/workspace/documents/components/SmartSourceChips.tsx:60
msgid "Pinnati"
msgstr "Pinnati"

#: src/features/workspace/documents/components/DocumentCardV2.tsx:233
msgid "Pinnato"
msgstr "Pinnato"

#: src/features/workspace/config.ts:363
#: src/routes/_authed/workspace/finance.tsx:1024
msgid "Pipeline"
msgstr "Pipeline"

#: src/features/sales/components/crm/CompaniesPanel.tsx:239
#: src/routes/_authed/workspace/finance.tsx:1685
msgid "Pipeline aperta"
msgstr "Pipeline aperta"

#: src/routes/_authed/workspace/finance.tsx:441
msgid "Pipeline SF"
msgstr "Pipeline SF"

#: src/features/connectors/wizards/crmSpec.tsx:110
msgid "Pipeline summary, conversion rate, top accounts — pronti per la riunione."
msgstr "Pipeline summary, conversion rate, top accounts — pronti per la riunione."

#: src/features/onboarding/sectionGuides.ts:49
msgid "Pipeline, lead e opportunità dal CRM. Interroga lo stato delle trattative e prepara follow-up; le scritture sul CRM sono proposte che approvi tu."
msgstr "Pipeline, lead e opportunità dal CRM. Interroga lo stato delle trattative e prepara follow-up; le scritture sul CRM sono proposte che approvi tu."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:86
msgid "Pipeline, prospect, CRM"
msgstr "Pipeline, prospect, CRM"

#: src/features/settings/MarpTemplateSettings.tsx:141
msgid "Pitch deck design da agenzie premiate"
msgstr "Pitch deck design da agenzie premiate"

#: src/features/settings/MarpTemplateSettings.tsx:134
msgid "Pitch deck VC, dashboard, SWOT, Gantt"
msgstr "Pitch deck VC, dashboard, SWOT, Gantt"

#: src/routes/_authed/workspace/work.tsx:493
#: src/routes/_authed/workspace/work.tsx:495
msgid "Più avanti"
msgstr "Più avanti"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:65
msgid "Più breve"
msgstr "Più breve"

#: src/features/sales/components/CampaignsPanel.tsx:128
msgid "Più è preciso il profilo, migliori sono i lead trovati."
msgstr "Più è preciso il profilo, migliori sono i lead trovati."

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:60
msgid "Più formale"
msgstr "Più formale"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:70
msgid "Più lungo"
msgstr "Più lungo"

#: src/features/console/docs/content.ts:532
msgid "Più recenti prima; cursore opaco ?limit=&cursor=."
msgstr "Più recenti prima; cursore opaco ?limit=&cursor=."

#: src/features/chat/components/SmartLayoutHint.tsx:144
msgid "Più spazio per leggere?"
msgstr "Più spazio per leggere?"

#: src/features/updates/components/UpdateBanner.tsx:193
msgid "Più tardi"
msgstr "Più tardi"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:703
msgid "Pixel-perfect, non editabile in PowerPoint"
msgstr "Pixel-perfect, non editabile in PowerPoint"

#: src/features/templates/components/TemplateFieldSpecs.ts:78
msgid "Playfair Display"
msgstr "Playfair Display"

#: src/features/console/components/ConsoleShell.tsx:222
#: src/features/console/docs/content.ts:1333
#: src/features/console/pages/PlaygroundPage.tsx:1818
msgid "Playground"
msgstr "Playground"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:81
msgid "PMI"
msgstr "PMI"

#: src/features/settings/components/BrandKitSettings.tsx:475
msgid "PNG/JPEG/WebP/SVG. Usato sulle copertine."
msgstr "PNG/JPEG/WebP/SVG. Usato sulle copertine."

#: src/features/admin/components/AdminCpqAskAndo.tsx:172
msgid "PoC"
msgstr "PoC"

#: src/features/admin/components/AdminCpq.tsx:215
msgid "PoC, sempre in SaaS"
msgstr "PoC, sempre in SaaS"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:123
msgid "pochi istanti fa"
msgstr "pochi istanti fa"

#: src/features/projects/components/ProjectDetailPage.tsx:315
msgid "poco fa"
msgstr "poco fa"

#: src/features/clean-control/components/CleanControlHub.tsx:193
msgid "Policy"
msgstr "Policy"

#: src/features/clean-control/components/policies/PoliciesEditor.tsx:60
msgid "Policy attive"
msgstr "Policy attive"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:76
msgid "Policy MFA aggiornata"
msgstr "Policy MFA aggiornata"

#. placeholder {0}: event.policy_change_id
#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:110
msgid "policy: {0}"
msgstr "policy: {0}"

#: src/features/templates/components/TemplateFieldSpecs.ts:138
msgid "Pollici · range 0.25 – 2.0."
msgstr "Pollici · range 0.25 – 2.0."

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:354
msgid "Popup blocked by browser — enable popups for this site and retry"
msgstr "Popup blocked by browser — enable popups for this site and retry"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:736
#: src/features/connectors/wizards/databaseSpec.tsx:65
#: src/features/connectors/wizards/filesystemSpec.tsx:69
msgid "Porta"
msgstr "Porta"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1465
msgid "Porta avanti"
msgstr "Porta avanti"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1415
msgid "Porta di default {defaultPort}"
msgstr "Porta di default {defaultPort}"

#: src/features/dxf/components/DxfEmptyHero.tsx:134
msgid "Porta i disegni meccanici in Ando"
msgstr "Porta i disegni meccanici in Ando"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1472
msgid "Porta indietro"
msgstr "Porta indietro"

#: src/features/console/components/ByokModal.tsx:94
msgid "Porta la tua API key"
msgstr "Porta la tua API key"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:729
msgid "Posizione"
msgstr "Posizione"

#: src/features/chat/components/AudioPlayer.tsx:123
msgid "Posizione audio"
msgstr "Posizione audio"

#: src/routes/_authed/_modal/settings/help.tsx:77
msgid "Posso invitare colleghi?"
msgstr "Posso invitare colleghi?"

#: src/features/admin/components/UserDetailContent.tsx:729
msgid "POST /admin/users/{id}/force-mfa — endpoint non ancora esposto."
msgstr "POST /admin/users/{id}/force-mfa — endpoint non ancora esposto."

#: src/features/console/docs/content.ts:1238
msgid "POST /billing/portal apre il Stripe Customer Portal (metodi di pagamento, storico, PDF). GET /billing/summary è lo snapshot header (stima MTD marked-up — mai il costo raw né il markup %). GET /invoices elenca le fatture platform-usage, /invoices/<id>/pdf reindirizza al PDF Stripe. GET /credits mostra il saldo prepagato; POST /credits/checkout apre un top-up."
msgstr "POST /billing/portal apre il Stripe Customer Portal (metodi di pagamento, storico, PDF). GET /billing/summary è lo snapshot header (stima MTD marked-up — mai il costo raw né il markup %). GET /invoices elenca le fatture platform-usage, /invoices/<id>/pdf reindirizza al PDF Stripe. GET /credits mostra il saldo prepagato; POST /credits/checkout apre un top-up."

#: src/features/console/docs/content.ts:833
msgid "POST /sources/<id>/validate prova una query NL → SQL preview; /publish porta la source in /query."
msgstr "POST /sources/<id>/validate prova una query NL → SQL preview; /publish porta la source in /query."

#: src/features/connectors/wizards/pecSpec.tsx:107
#: src/features/connectors/wizards/pecSpec.tsx:140
msgid "Posta Elettronica Certificata via IMAP/SMTP (app password)"
msgstr "Posta Elettronica Certificata via IMAP/SMTP (app password)"

#: src/features/console/pages/MembersPage.tsx:472
msgid "Postazioni"
msgstr "Postazioni"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:44
msgid "Postgres, MySQL, BigQuery, Snowflake…"
msgstr "Postgres, MySQL, BigQuery, Snowflake…"

#: src/features/console/pages/BillingPage.tsx:276
msgid "Posticipato"
msgstr "Posticipato"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:234
msgid "Postpagato"
msgstr "Postpagato"

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:102
msgid "Postpagato (default) · eredita il markup globale"
msgstr "Postpagato (default) · eredita il markup globale"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:221
msgid "Postpagato = fattura mensile. Prepagato = consuma crediti, bloccato a saldo zero."
msgstr "Postpagato = fattura mensile. Prepagato = consuma crediti, bloccato a saldo zero."

#: src/routes/_authed/workspace/conversations.tsx:1208
msgid "Potrebbe essere stato archiviato o cancellato. Torna all'inbox per cercarlo."
msgstr "Potrebbe essere stato archiviato o cancellato. Torna all'inbox per cercarlo."

#: src/features/projects/components/ProjectDetailPage.tsx:454
msgid "Potrebbe essere stato archiviato. Apri l'elenco dei progetti per vederli tutti."
msgstr "Potrebbe essere stato archiviato. Apri l'elenco dei progetti per vederli tutti."

#: src/routes/_authed/workspace/calendar.tsx:1595
msgid "Potrebbe essere stato cancellato o spostato fuori dalla finestra visibile. Torna al calendario per cercarlo."
msgstr "Potrebbe essere stato cancellato o spostato fuori dalla finestra visibile. Torna al calendario per cercarlo."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:163
msgid "Potrebbe essere stato eliminato o non hai più accesso. Torna alla lista o riprova."
msgstr "Potrebbe essere stato eliminato o non hai più accesso. Torna alla lista o riprova."

#: src/features/sources/components/ArtifactPane.tsx:1837
msgid "Potrebbe essere stato rimosso oppure non hai i permessi per aprirlo."
msgstr "Potrebbe essere stato rimosso oppure non hai i permessi per aprirlo."

#: src/routes/_authed/workspace/documents.tsx:1123
#: src/routes/_authed/workspace/documents.tsx:1124
msgid "PowerPoint"
msgstr "PowerPoint"

#: src/features/chat/components/ChatEmptyState.tsx:255
msgid "PR da revisionare"
msgstr "PR da revisionare"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:82
msgid "Pratiche forensi, PEC"
msgstr "Pratiche forensi, PEC"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:246
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:457
#: src/features/console/components/DocumentAcquiredContent.tsx:98
#: src/features/console/pages/AccessOverviewPage.tsx:401
#: src/features/console/pages/DocumentsPage.tsx:892
#: src/features/console/pages/FlowsPage.tsx:948
#: src/features/console/traces/TraceJsonTree.tsx:30
#: src/features/console/traces/TraceJsonTree.tsx:113
#: src/features/console/traces/TracePayloadReader.tsx:167
msgid "Precedente"
msgstr "Precedente"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:108
#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:119
#: src/features/console/pages/EmbeddedIdentityPage.tsx:616
#: src/features/console/pages/ResourceAccessPage.tsx:898
msgid "Precedenti"
msgstr "Precedenti"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:104
msgid "Precisazione"
msgstr "Precisazione"

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:197
msgid "Precompilato dallo schema dell'azione. Ando valida questi parametri prima di chiamare il tuo endpoint."
msgstr "Precompilato dallo schema dell'azione. Ando valida questi parametri prima di chiamare il tuo endpoint."

#: src/features/console/connectors/TestConnectorActionModal.tsx:259
msgid "Precompilato dallo schema dell'azione. Ando valida questi parametri prima di proporre l'azione."
msgstr "Precompilato dallo schema dell'azione. Ando valida questi parametri prima di proporre l'azione."

#: src/features/sales/components/SignaturesManager.tsx:178
msgid "Predefinita"
msgstr "Predefinita"

#: src/features/skills/components/TeamSkillsCatalog.tsx:138
msgid "Predefinita del team"
msgstr "Predefinita del team"

#: src/features/sales/components/SignaturesManager.tsx:355
msgid "Predefinita globale"
msgstr "Predefinita globale"

#: src/features/skills/components/SkillsList.tsx:387
msgid "Predefinita team"
msgstr "Predefinita team"

#: src/features/projects/components/sections/MemorySection.tsx:212
msgid "predefinito"
msgstr "predefinito"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1032
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:859
#: src/features/console/pages/BillingPage.tsx:348
#: src/features/projects/components/sections/PersonaSection.tsx:350
msgid "Predefinito"
msgstr "Predefinito"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:213
#: src/features/console/pages/BillingPage.tsx:401
msgid "Predefinito della piattaforma"
msgstr "Predefinito della piattaforma"

#: src/features/projects/components/sections/MemorySection.tsx:55
msgid "Preferenza"
msgstr "Preferenza"

#: src/features/settings/components/SelfProfileMemory.tsx:103
msgid "Preferenze"
msgstr "Preferenze"

#: src/features/settings/components/NotificationPreferences.tsx:334
#: src/features/settings/components/ProfileSettings.tsx:168
msgid "Preferenze aggiornate."
msgstr "Preferenze aggiornate."

#: src/features/workspace/inbox/utils/inboxSmartViews.ts:68
msgid "Preferiti"
msgstr "Preferiti"

#: src/features/console/pages/KeyDetailPage.tsx:663
#: src/features/console/pages/KeysPage.tsx:119
msgid "Prefisso"
msgstr "Prefisso"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:214
msgid "Prefisso azienda"
msgstr "Prefisso azienda"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:382
msgid "Prefisso rilevato"
msgstr "Prefisso rilevato"

#. placeholder {0}: c.reserved_metadata_prefix
#: src/features/console/connectors/CustomConnectorDetail.tsx:442
msgid "Prefisso riservato {0}"
msgstr "Prefisso riservato {0}"

#: src/features/connectors/wizards/openBankingSpec.tsx:80
msgid "Premi <0>\"Procedi al consenso\"</0> per aprire il selettore ufficiale e completare il flusso PSD2 (consenso valido 90 giorni)."
msgstr "Premi <0>\"Procedi al consenso\"</0> per aprire il selettore ufficiale e completare il flusso PSD2 (consenso valido 90 giorni)."

#: src/routes/_authed/_modal/settings/shortcuts.tsx:39
msgid "Premi <0>⌘ /</0> in qualsiasi punto dell'app per aprire questa lista in un overlay senza lasciare il flusso."
msgstr "Premi <0>⌘ /</0> in qualsiasi punto dell'app per aprire questa lista in un overlay senza lasciare il flusso."

#: src/features/help/components/KeyboardShortcutsOverlay.tsx:48
msgid "Premi <0>Esc</0> o <1>?</1> per chiudere."
msgstr "Premi <0>Esc</0> o <1>?</1> per chiudere."

#: ../../packages/ui/src/ando/RecipientsInput.tsx:466
msgid "Premi <0>Invio</0> per aggiungerla come email libera."
msgstr "Premi <0>Invio</0> per aggiungerla come email libera."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:453
msgid "Premi il pulsante qui sotto per avviare Meta Embedded Signup. Si aprirà un popup; autorizza Ando e scegli il numero di telefono WhatsApp Business da connettere."
msgstr "Premi il pulsante qui sotto per avviare Meta Embedded Signup. Si aprirà un popup; autorizza Ando e scegli il numero di telefono WhatsApp Business da connettere."

#: src/features/skills/components/SkillEditor.tsx:410
msgid "Premi Invio per aggiungere ogni frase."
msgstr "Premi Invio per aggiungere ogni frase."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:390
msgid "Premi Rigenera per ricomporre il contenuto a partire dalle ultime fonti disponibili."
msgstr "Premi Rigenera per ricomporre il contenuto a partire dalle ultime fonti disponibili."

#: src/features/settings/MarpTemplateSettings.tsx:128
msgid "Premium · €15/mese"
msgstr "Premium · €15/mese"

#: src/features/sales/components/LeadDetailDrawer.tsx:277
msgid "Prendi in gestione"
msgstr "Prendi in gestione"

#: src/features/onboarding/DemoBookCallModal.tsx:479
msgid "Prenota"
msgstr "Prenota"

#: src/features/onboarding/DemoBookCallModal.tsx:362
msgid "Prenota 15 min col team"
msgstr "Prenota 15 min col team"

#: src/features/onboarding/DemoBetaBanner.tsx:73
#: src/features/onboarding/DemoBookCallBanner.tsx:57
msgid "Prenota demo"
msgstr "Prenota demo"

#: src/features/onboarding/DemoBookCallModal.tsx:551
msgid "Prenota subito"
msgstr "Prenota subito"

#: src/features/onboarding/DemoBookCallBanner.tsx:35
msgid "Prenota una demo con il team Ando"
msgstr "Prenota una demo con il team Ando"

#: src/features/settings/components/SelfProfileMemory.tsx:81
msgid "Preoccupazione privacy"
msgstr "Preoccupazione privacy"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:242
#: src/features/console/pages/BillingPage.tsx:259
msgid "Prepagato"
msgstr "Prepagato"

#. placeholder {0}: (balance / 100).toFixed(2)
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:101
msgid "Prepagato · saldo {0} USD"
msgstr "Prepagato · saldo {0} USD"

#: src/features/admin/components/AdminCpqAskAndo.tsx:364
msgid "Prepara"
msgstr "Prepara"

#: src/features/chat/components/ChatEmptyState.tsx:158
msgid "Prepara un brief per il prossimo meeting in agenda."
msgstr "Prepara un brief per il prossimo meeting in agenda."

#: src/features/sources/components/CalendarEventPane.tsx:416
msgid "Prepara una scaletta per \"{titleLabel}\""
msgstr "Prepara una scaletta per \"{titleLabel}\""

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1113
msgid "Preparazione AI…"
msgstr "Preparazione AI…"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:58
#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:59
msgid "Preparazione importazione cronologia messaggi"
msgstr "Preparazione importazione cronologia messaggi"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:467
msgid "Preparazione slide…"
msgstr "Preparazione slide…"

#: src/features/sources/components/ArtifactPane.tsx:1530
msgid "Preparo l’anteprima delle modifiche proposte…"
msgstr "Preparo l’anteprima delle modifiche proposte…"

#: src/features/admin/components/AdminCpqCanvas.tsx:286
msgid "Preparo l'anteprima…"
msgstr "Preparo l'anteprima…"

#: src/features/voice_report/components/NewReportDialog.tsx:675
msgid "Preparo la tua knowledge…"
msgstr "Preparo la tua knowledge…"

#: src/features/sources/components/ArtifactPane.tsx:257
msgid "presentazione"
msgstr "presentazione"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:953
#: src/routes/_authed/workspace/documents.tsx:1125
msgid "Presentazione"
msgstr "Presentazione"

#: src/features/templates/components/TemplateFieldSpecs.ts:126
msgid "Presentazione 16:9"
msgstr "Presentazione 16:9"

#: src/features/templates/components/TemplateFieldSpecs.ts:127
msgid "Presentazione 4:3"
msgstr "Presentazione 4:3"

#: src/features/dashboard/components/DashboardViewControls.tsx:19
msgid "Presentazione dashboard"
msgstr "Presentazione dashboard"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:90
msgid "Presentazione PowerPoint"
msgstr "Presentazione PowerPoint"

#: src/features/admin/components/AdminDecks.tsx:149
#: src/features/admin/components/AdminDecks.tsx:174
#: src/routes/_authed/_modal/admin/route.tsx:158
msgid "Presentazioni"
msgstr "Presentazioni"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:277
msgid "Preset"
msgstr "Preset"

#. placeholder {0}: p.preset_name
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:390
msgid "Preset \"{0}\" caricato"
msgstr "Preset \"{0}\" caricato"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:278
msgid "Preset \"{name}\" salvato"
msgstr "Preset \"{name}\" salvato"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:381
msgid "Preset salvati"
msgstr "Preset salvati"

#. placeholder {0}: chi.toFixed(2)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:116
msgid "presto significativo (χ² {0})"
msgstr "presto significativo (χ² {0})"

#: src/features/admin/components/AdminCpq.tsx:1260
#: src/features/admin/components/AdminCpq.tsx:1272
#: src/features/admin/components/AdminCpq.tsx:1279
#: src/routes/_authed/_modal/admin/route.tsx:156
msgid "Preventivi"
msgstr "Preventivi"

#: src/features/admin/components/AdminCpq.tsx:419
msgid "Preventivo pubblicato"
msgstr "Preventivo pubblicato"

#: src/features/admin/components/AdminCpqCanvas.tsx:247
msgid "Preventivo pubblicato: anteprima in sola lettura."
msgstr "Preventivo pubblicato: anteprima in sola lettura."

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:126
msgid "Preview"
msgstr "Preview"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:152
msgid "Preview leggera"
msgstr "Preview leggera"

#: src/features/admin/components/AdminCpqCanvas.tsx:149
msgid "Prezzi"
msgstr "Prezzi"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:241
msgid "Prezzi concordati"
msgstr "Prezzi concordati"

#: src/features/admin/components/AdminPlatformSettings.tsx:1148
msgid "Prezzi modelli"
msgstr "Prezzi modelli"

#: src/features/admin/components/AdminPlatformSettings.tsx:179
msgid "Prezzi modelli LLM"
msgstr "Prezzi modelli LLM"

#: src/features/admin/components/AdminBilling.tsx:151
msgid "Prezzi per modello e piani a tier di utilizzo."
msgstr "Prezzi per modello e piani a tier di utilizzo."

#: src/features/admin/components/AdminPlatformSettings.tsx:136
msgid "Prezzi salvati"
msgstr "Prezzi salvati"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:214
msgid "Prezzo"
msgstr "Prezzo"

#: src/features/admin/components/AdminCpqPriceBook.tsx:275
msgid "Prezzo (EUR)"
msgstr "Prezzo (EUR)"

#: src/features/admin/components/AdminCpqPriceBook.tsx:244
msgid "Prezzo annuo (EUR)"
msgstr "Prezzo annuo (EUR)"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:45
msgid "Prezzo concordato della prima fase senza PoC: viene ignorato."
msgstr "Prezzo concordato della prima fase senza PoC: viene ignorato."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:260
msgid "Prezzo della prima fase (€)"
msgstr "Prezzo della prima fase (€)"

#: src/features/admin/components/AdminCpq.tsx:160
msgid "Prezzo di acquisto della software house, anno a regime"
msgstr "Prezzo di acquisto della software house, anno a regime"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:258
msgid "Prezzo di listino del tier"
msgstr "Prezzo di listino del tier"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:136
msgid "Prezzo non valido"
msgstr "Prezzo non valido"

#: src/features/admin/components/AdminPlatformSettings.tsx:631
msgid "Prezzo per utente"
msgstr "Prezzo per utente"

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:245
msgid "Prezzo per utente negoziato"
msgstr "Prezzo per utente negoziato"

#: src/features/price-lists/components/PriceListsPage.tsx:902
msgid "Prezzo unitario"
msgstr "Prezzo unitario"

#: src/features/price-lists/components/PriceListsPage.tsx:816
msgid "Prezzo unitario non valido"
msgstr "Prezzo unitario non valido"

#: src/features/admin/components/AdminBilling.tsx:220
msgid "Pricing"
msgstr "Pricing"

#: src/features/admin/components/AdminPlatformSettings.tsx:1123
msgid "Pricing & Plans"
msgstr "Pricing & Plans"

#: src/features/admin/components/AdminBilling.tsx:82
msgid "Pricing di base creato su Metronome"
msgstr "Pricing di base creato su Metronome"

#: src/features/admin/components/AdminBilling.tsx:129
msgid "Pricing già creato"
msgstr "Pricing già creato"

#: src/features/admin/components/AdminPlatformSettings.tsx:1142
msgid "Pricing modelli e piani usage tier"
msgstr "Pricing modelli e piani usage tier"

#: src/features/admin/components/AdminBilling.tsx:200
msgid "Pricing, incasso e consumi — globale"
msgstr "Pricing, incasso e consumi — globale"

#: ../../packages/ui/src/editors/ReviewRail.tsx:450
msgid "Prima"
msgstr "Prima"

#: src/features/console/pages/GetStartedPage.tsx:56
msgid "Prima chiamata"
msgstr "Prima chiamata"

#: src/features/console/pages/ModelsPage.tsx:197
msgid "Prima dell'attivazione completa i requisiti seguenti."
msgstr "Prima dell'attivazione completa i requisiti seguenti."

#: src/features/console/pages/ConnectorDetailPage.tsx:495
msgid "Prima di aggiornare la struttura"
msgstr "Prima di aggiornare la struttura"

#: src/features/sales/components/crm/CreateDealDialog.tsx:158
msgid "Prima fase"
msgstr "Prima fase"

#: src/features/console/traces/TraceGraph.tsx:416
msgid "Prima registrazione"
msgstr "Prima registrazione"

#. placeholder {0}: data?.data.length
#: src/features/dashboard/components/KpiCard.tsx:215
msgid "Prima riga di {0} risultati"
msgstr "Prima riga di {0} risultati"

#: src/features/sources/components/AISummaryPanel.tsx:765
msgid "prima:"
msgstr "prima:"

#. placeholder {0}: Math.min(10, data.top_orgs_by_cost.length)
#: src/features/admin/components/AdminOverview.tsx:139
msgid "Prime {0} per spesa inferenziale"
msgstr "Prime {0} per spesa inferenziale"

#: src/features/console/components/FirstRunTimeline.tsx:197
msgid "Primi passi"
msgstr "Primi passi"

#: src/features/admin/components/AdminCpq.tsx:189
msgid "Primo anno"
msgstr "Primo anno"

#: src/features/automations/components/ScheduleEditor.tsx:57
msgid "Primo del mese alle 9:00"
msgstr "Primo del mese alle 9:00"

#: src/features/console/connectors/CustomConnectorDetail.tsx:700
msgid "primo sync entro 15 minuti dalla registrazione"
msgstr "primo sync entro 15 minuti dalla registrazione"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:126
msgid "Principale"
msgstr "Principale"

#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:62
#: src/features/workspace/components/TaskComposer.tsx:148
#: src/features/workspace/components/TaskComposer.tsx:152
msgid "Priorità"
msgstr "Priorità"

#: src/features/admin/components/AdminEngagement.tsx:178
msgid "priorità outreach"
msgstr "priorità outreach"

#: src/features/settings/components/AccountDeletion.tsx:42
#: src/routes/_authed/_modal/settings/privacy.tsx:36
msgid "Privacy"
msgstr "Privacy"

#: src/features/account/components/UserMenuButton.tsx:387
msgid "Privacy & dati"
msgstr "Privacy & dati"

#: src/features/console/pages/AccessOverviewPage.tsx:325
msgid "Privata"
msgstr "Privata"

#: src/features/connectors/wizards/calendarSpec.tsx:85
#: src/features/hive-flows/components/FlowShareControl.tsx:121
#: src/features/hive-flows/components/FlowShareControl.tsx:189
msgid "Privato"
msgstr "Privato"

#: src/features/connectors/wizards/crmSpec.tsx:114
#: src/features/connectors/wizards/projectManagementSpec.tsx:80
msgid "Privato e sicuro"
msgstr "Privato e sicuro"

#: src/features/admin/components/AdminOrgs.tsx:109
msgid "Pro"
msgstr "Pro"

#: src/routes/_authed/workspace/dashboard.tsx:1066
msgid "Probabile errore di rete o sessione. Riprova fra qualche secondo."
msgstr "Probabile errore di rete o sessione. Riprova fra qualche secondo."

#: src/features/console/docs/content.ts:1686
msgid "Probe di liveness pubblica (nessuna auth richiesta)."
msgstr "Probe di liveness pubblica (nessuna auth richiesta)."

#: src/features/console/docs/content.ts:236
msgid "Probe di liveness senza autenticazione."
msgstr "Probe di liveness senza autenticazione."

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:266
msgid "Problema temporaneo"
msgstr "Problema temporaneo"

#: src/features/connectors/wizards/openBankingSpec.tsx:185
msgid "Procedi al consenso"
msgstr "Procedi al consenso"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:58
msgid "Procedi alla firma"
msgstr "Procedi alla firma"

#: src/features/clean-control/components/EventQueue.tsx:278
msgid "Procedo…"
msgstr "Procedo…"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:291
msgid "Process codification"
msgstr "Process codification"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:999
msgid "Processi (separati da virgola)"
msgstr "Processi (separati da virgola)"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:259
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:266
msgid "Prodotti disponibili"
msgstr "Prodotti disponibili"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:759
msgid "production"
msgstr "production"

#: src/features/connectors/catalog.ts:222
#: src/features/onboarding/ConnectorsIntro.tsx:40
msgid "Produttività"
msgstr "Produttività"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:255
msgid "Profila con l'AI solo le tabelle non coperte dal dizionario"
msgstr "Profila con l'AI solo le tabelle non coperte dal dizionario"

#: src/features/admin/components/AdminCpqPriceBook.tsx:353
msgid "Profilazione per fonte (USD)"
msgstr "Profilazione per fonte (USD)"

#: src/features/agent-modes/components/AgentModesList.tsx:181
msgid "profili AI personalizzati"
msgstr "profili AI personalizzati"

#: src/features/agent-modes/components/AgentModesList.tsx:101
msgid "Profili AI personalizzati"
msgstr "Profili AI personalizzati"

#: src/routes/_authed/_modal/settings/help.tsx:74
msgid "Profili che definiscono come Ando risponde: focus (testo / dati strutturati / full), accesso al web, pensiero esteso. Puoi crearne di personalizzati o usare quelli condivisi dall'organizzazione. Si selezionano dal composer."
msgstr "Profili che definiscono come Ando risponde: focus (testo / dati strutturati / full), accesso al web, pensiero esteso. Puoi crearne di personalizzati o usare quelli condivisi dall'organizzazione. Si selezionano dal composer."

#: src/features/admin/components/orgs/OrgCostTab.tsx:65
msgid "Profiling"
msgstr "Profiling"

#: src/features/account/components/UserMenuButton.tsx:377
#: src/features/admin/components/UserDetailContent.tsx:374
#: src/features/settings/components/ProfileSettings.tsx:66
msgid "Profilo"
msgstr "Profilo"

#: src/features/console/pages/ModelsPage.tsx:195
msgid "Profilo attivo per le elaborazioni coperte"
msgstr "Profilo attivo per le elaborazioni coperte"

#: src/features/console/pages/ModelsPage.tsx:111
msgid "Profilo cliente da attivare"
msgstr "Profilo cliente da attivare"

#: src/features/console/pages/BillingPage.tsx:418
#: src/features/console/pages/BillingPage.tsx:421
msgid "Profilo contabile"
msgstr "Profilo contabile"

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:51
msgid "Profondità di ricerca"
msgstr "Profondità di ricerca"

#: src/features/chat/components/ConversationCommandPalette.tsx:316
#: src/features/chat/components/ConversationSidebar.tsx:331
#: src/features/projects/components/ProjectDetailPage.tsx:403
#: src/features/projects/components/ProjectDetailPage.tsx:434
#: src/features/settings/components/SelfProfileMemory.tsx:104
msgid "Progetti"
msgstr "Progetti"

#: src/features/console/pages/AccessOverviewPage.tsx:327
#: src/features/hive-flows/components/FlowShareControl.tsx:216
#: src/features/projects/components/ProjectDetailPage.tsx:567
#: src/features/projects/components/sections/MemorySection.tsx:56
#: src/routes/_authed/workspace/flows.index.tsx:385
msgid "Progetto"
msgstr "Progetto"

#. placeholder {0}: created.name
#: src/features/projects/components/TemplatesBrowserDialog.tsx:131
msgid "Progetto \"{0}\" creato"
msgstr "Progetto \"{0}\" creato"

#: src/features/hive-flows/components/FlowShareControl.tsx:91
msgid "Progetto assegnato, ma la condivisione non è riuscita: riprova da \"Progetto\"."
msgstr "Progetto assegnato, ma la condivisione non è riuscita: riprova da \"Progetto\"."

#: src/features/projects/components/ProjectDetailPage.tsx:448
msgid "Progetto inesistente"
msgstr "Progetto inesistente"

#: src/features/dxf/utils.ts:124
msgid "Progetto moda"
msgstr "Progetto moda"

#: src/features/projects/components/ProjectDetailPage.tsx:435
msgid "Progetto non trovato"
msgstr "Progetto non trovato"

#: src/features/projects/components/ProjectHub.tsx:544
#: src/features/projects/components/ProjectHub.tsx:586
msgid "Progetto vuoto"
msgstr "Progetto vuoto"

#: src/routes/_authed/workspace/flows.index.tsx:629
msgid "Progetto: {projectName}"
msgstr "Progetto: {projectName}"

#. placeholder {0}: currentProjectName ? `: ${currentProjectName}` : ""
#: src/features/hive-flows/components/FlowShareControl.tsx:125
msgid "Progetto{0}"
msgstr "Progetto{0}"

#: ../../packages/ui/src/ando/email/SendControl.tsx:109
#: src/features/sources/components/InboxDetailPane.tsx:1994
msgid "Programma"
msgstr "Programma"

#: ../../packages/ui/src/ando/email/SendControl.tsx:118
#: src/features/sources/components/InboxDetailPane.tsx:1110
#: src/features/sources/components/InboxDetailPane.tsx:1985
msgid "Programma invio"
msgstr "Programma invio"

#: src/features/admin/components/AdminCpqCanvas.tsx:156
msgid "Programma partner"
msgstr "Programma partner"

#: ../../packages/ui/src/ando/email/SendControl.tsx:168
msgid "Programma…"
msgstr "Programma…"

#: src/features/admin/components/MaintenanceControl.tsx:61
msgid "Programmata"
msgstr "Programmata"

#: src/features/automations/components/formatters.ts:89
msgid "Programmato (cron)"
msgstr "Programmato (cron)"

#: src/features/automations/components/AutomationDetailSection.tsx:163
msgid "Programmazione"
msgstr "Programmazione"

#: src/features/sources/components/InboxDetailPane.tsx:527
msgid "Programmazione annullata."
msgstr "Programmazione annullata."

#: src/features/automations/components/formatters.ts:22
msgid "Programmazione custom"
msgstr "Programmazione custom"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:229
msgid "Progresso dimensione campione"
msgstr "Progresso dimensione campione"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:299
msgid "Progresso provisioning"
msgstr "Progresso provisioning"

#: src/features/connectors/wizards/projectManagementSpec.tsx:33
#: src/features/console/connectors/meta.ts:84
msgid "Project management"
msgstr "Project management"

#. placeholder {0}: provision.gcp_project_id
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:279
msgid "Project: {0}"
msgstr "Project: {0}"

#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:33
msgid "Promemoria"
msgstr "Promemoria"

#: src/features/settings/components/NotificationPreferences.tsx:71
msgid "Promemoria scadenze"
msgstr "Promemoria scadenze"

#: src/features/projects/components/sections/MemorySection.tsx:59
msgid "Promessa"
msgstr "Promessa"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:157
msgid "Promosso"
msgstr "Promosso"

#: src/features/report/components/NpsPromoterDetractorGrid.tsx:78
msgid "Promotori"
msgstr "Promotori"

#: src/features/automations/components/AutomationDetailSection.tsx:162
#: src/features/automations/components/CreateAutomationDialog.tsx:219
msgid "Prompt"
msgstr "Prompt"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:386
msgid "Prompt (opzionale — override blueprint)"
msgstr "Prompt (opzionale — override blueprint)"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:254
msgid "Prompt immagine AI (opzionale)"
msgstr "Prompt immagine AI (opzionale)"

#: src/features/console/components/AssistPanel.tsx:283
msgid "Prompt per l'assistente"
msgstr "Prompt per l'assistente"

#: src/features/sources/components/ArtifactPane.tsx:259
msgid "Prompt pronto in chat — aggiungi le modifiche e invia"
msgstr "Prompt pronto in chat — aggiungi le modifiche e invia"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:305
msgid "Prompt versioni attive"
msgstr "Prompt versioni attive"

#: src/features/settings/components/OrgMembersPanel.tsx:345
msgid "Promuovere a Proprietario?"
msgstr "Promuovere a Proprietario?"

#: src/features/admin/components/userAdminActions.tsx:443
msgid "Promuovi"
msgstr "Promuovi"

#: src/features/settings/components/OrgMembersPanel.tsx:366
msgid "Promuovi a Proprietario"
msgstr "Promuovi a Proprietario"

#: src/features/admin/components/userAdminActions.tsx:423
msgid "Promuovi a Superadmin"
msgstr "Promuovi a Superadmin"

#: src/features/admin/components/userAdminActions.tsx:424
msgid "Promuovi ad Admin"
msgstr "Promuovi ad Admin"

#: src/routes/_authed/workspace/finance.tsx:935
msgid "pronta per invio"
msgstr "pronta per invio"

#: src/features/console/pages/SchemaPage.tsx:957
msgid "Pronte"
msgstr "Pronte"

#: src/features/projects/components/ProjectDetailPage.tsx:360
msgid "Pronti a riprendere — dimmi tu da dove cominciamo."
msgstr "Pronti a riprendere — dimmi tu da dove cominciamo."

#: src/features/canvases/components/CanvasStatusChip.tsx:29
#: src/features/console/components/StatusBadges.tsx:108
#: src/features/console/pages/EmbeddedIdentityPage.tsx:358
msgid "Pronto"
msgstr "Pronto"

#: src/features/billing/components/UsageInsightsCard.tsx:245
msgid "Pronto a partire: chat con la tua knowledge base per popolare la metrica."
msgstr "Pronto a partire: chat con la tua knowledge base per popolare la metrica."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:917
msgid "Pronto per il merge AI — il design del template è preservato, l'AI riempie solo il contenuto"
msgstr "Pronto per il merge AI — il design del template è preservato, l'AI riempie solo il contenuto"

#: src/features/sources/components/AISummaryPanel.tsx:910
msgid "Pronto per il salvataggio"
msgstr "Pronto per il salvataggio"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1327
msgid "Pronto per una nuova esecuzione"
msgstr "Pronto per una nuova esecuzione"

#: src/features/admin/components/AdminCpq.tsx:772
msgid "Proof of concept"
msgstr "Proof of concept"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2848
#: src/features/console/connectors/TestConnectorActionModal.tsx:179
msgid "Proponi"
msgstr "Proponi"

#: src/features/console/connectors/TestConnectorActionModal.tsx:202
msgid "Proponi l'azione, controlla l'anteprima, poi eseguila: Ando invia una richiesta firmata al webhook di «{connectorName}» e la tua app la esegue."
msgstr "Proponi l'azione, controlla l'anteprima, poi eseguila: Ando invia una richiesta firmata al webhook di «{connectorName}» e la tua app la esegue."

#: src/features/admin/components/AdminCpqAskAndo.tsx:364
#: src/features/admin/components/AdminDecksAskAndo.tsx:125
msgid "Proponi modifiche"
msgstr "Proponi modifiche"

#: src/features/console/docs/content.ts:1078
msgid "Proponi un'azione"
msgstr "Proponi un'azione"

#. placeholder {0}: event.proposal_id
#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:105
msgid "proposal: {0}"
msgstr "proposal: {0}"

#: ../../packages/ui/src/ando/action-card/ActionStatusBadge.tsx:17
#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:95
#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:117
#: src/features/actions/components/FocusedActionSurface.tsx:147
#: src/features/console/components/StatusBadges.tsx:164
#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1495
#: src/features/hive-flows/run/ProposalReview.tsx:763
msgid "Proposta"
msgstr "Proposta"

#: src/features/admin/components/AdminCpq.tsx:566
#: src/features/admin/components/AdminCpqCanvas.tsx:164
msgctxt "cpq editor tab"
msgid "Proposta"
msgstr "Proposta"

#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:94
#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:116
msgid "Proposta · {actionType}"
msgstr "Proposta · {actionType}"

#: src/features/admin/components/AdminCpqAskAndo.tsx:279
msgid "Proposta aggiornata."
msgstr "Proposta aggiornata."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:318
msgid "Proposta AI"
msgstr "Proposta AI"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:576
msgid "Proposta applicata alla bozza"
msgstr "Proposta applicata alla bozza"

#: src/features/hive-flows/run/ProposalReview.tsx:240
msgid "Proposta approvata"
msgstr "Proposta approvata"

#: src/features/share/components/ShareLinkDialog.tsx:417
msgid "Proposta da Ando · tocca il testo per modificarla"
msgstr "Proposta da Ando · tocca il testo per modificarla"

#: src/features/actions/components/ActionFormSurface.tsx:162
msgid "Proposta in attesa"
msgstr "Proposta in attesa"

#: src/features/actions/components/FocusedActionSurface.tsx:178
msgid "Proposta in dettaglio"
msgstr "Proposta in dettaglio"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2617
msgid "Proposta pronta."
msgstr "Proposta pronta."

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:65
msgid "Proposto da Ando"
msgstr "Proposto da Ando"

#: src/features/console/pages/SchemaPage.tsx:273
msgid "Proposto dall'AI"
msgstr "Proposto dall'AI"

#: src/features/console/components/StatusBadges.tsx:222
#: src/features/console/pages/AccessOverviewPage.tsx:300
#: src/features/console/pages/ResourceAccessPage.tsx:327
#: src/features/sales/components/CampaignSharing.tsx:212
#: src/features/sales/components/CampaignSharing.tsx:215
#: src/lib/roles.ts:16
msgid "Proprietario"
msgstr "Proprietario"

#: src/features/automations/components/AutomationDetailSection.tsx:61
msgid "prossima"
msgstr "prossima"

#: src/features/projects/components/ProjectDetailPage.tsx:211
msgid "prossima {at}"
msgstr "prossima {at}"

#: src/features/projects/components/sections/AutomationsSection.tsx:192
msgid "prossima {nextRun}"
msgstr "prossima {nextRun}"

#: src/features/console/pages/FlowDetailPage.tsx:213
msgid "Prossima esecuzione"
msgstr "Prossima esecuzione"

#: src/features/console/pages/BillingPage.tsx:268
msgid "Prossima fattura"
msgstr "Prossima fattura"

#: src/features/workspace/components/TaskSimpleRow.tsx:255
#: src/features/workspace/inbox/hooks/useSnoozeStore.ts:210
msgid "Prossima settimana"
msgstr "Prossima settimana"

#: src/features/automations/components/AutomationCard.tsx:68
msgid "Prossima:"
msgstr "Prossima:"

#: src/features/price-lists/components/PriceListsPage.tsx:357
msgid "Prossimamente"
msgstr "Prossimamente"

#: src/routes/_authed/workspace/finance.tsx:587
msgid "Prossime scadenze"
msgstr "Prossime scadenze"

#: src/routes/_authed/workspace/finance.tsx:1757
msgid "Prossime scadenze fiscali"
msgstr "Prossime scadenze fiscali"

#: src/routes/_authed/workspace/work.tsx:278
msgid "Prossimi"
msgstr "Prossimi"

#: src/features/chat/components/ChatEmptyState.tsx:177
msgid "Prossimi incassi"
msgstr "Prossimi incassi"

#: src/features/sales/components/FollowUpControl.tsx:86
msgid "Prossimo follow-up"
msgstr "Prossimo follow-up"

#: src/features/sales/components/crm/RecordDrawer.tsx:362
msgid "Prossimo passo:"
msgstr "Prossimo passo:"

#: src/features/console/connectors/CustomConnectorDetail.tsx:692
msgid "Prossimo sync"
msgstr "Prossimo sync"

#. placeholder {0}: formatDateTime(i18n.locale, delivery.next_attempt_at)
#: src/features/console/webhooks/WebhooksPanel.tsx:184
msgid "Prossimo tentativo: {0}"
msgstr "Prossimo tentativo: {0}"

#. placeholder {0}: formatTimeUntil(minutesToNext, i18n)
#: src/routes/_authed/workspace/calendar.tsx:642
msgid "prossimo tra <0>{0}</0>"
msgstr "prossimo tra <0>{0}</0>"

#: src/features/connectors/wizards/filesystemSpec.tsx:79
msgid "Protocollo"
msgstr "Protocollo"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:244
#: src/features/console/flows/ConsoleFlowEditor.tsx:254
#: src/features/console/pages/EmbeddedIdentityPage.tsx:350
#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:102
msgid "Prova"
msgstr "Prova"

#: src/features/console/pages/ConnectorsPage.tsx:326
#: src/features/console/pages/DocumentsPage.tsx:729
msgid "Prova a cambiare la ricerca o il filtro di stato."
msgstr "Prova a cambiare la ricerca o il filtro di stato."

#: src/features/agent-modes/components/AgentModesList.tsx:259
msgid "Prova a cambiare scope o termine di ricerca."
msgstr "Prova a cambiare scope o termine di ricerca."

#: src/features/report/components/ReportList.tsx:101
msgid "Prova a modificare il testo di ricerca o il periodo selezionato."
msgstr "Prova a modificare il testo di ricerca o il periodo selezionato."

#: src/features/console/pages/PlaygroundPage.tsx:853
msgid "Prova a precisare la domanda e controlla acquisizione e accessi delle fonti. Questo risultato non dimostra che l’informazione sia assente."
msgstr "Prova a precisare la domanda e controlla acquisizione e accessi delle fonti. Questo risultato non dimostra che l’informazione sia assente."

#: src/features/console/connectors/TestConnectorActionModal.tsx:195
msgid "Prova azione"
msgstr "Prova azione"

#: src/features/billing/components/UsageMeter.tsx:175
msgid "Prova gratuita"
msgstr "Prova gratuita"

#: src/features/console/pages/EngineSignupPage.tsx:256
msgid "Prova la prima chiamata"
msgstr "Prova la prima chiamata"

#: src/features/console/pages/OverviewPage.tsx:303
msgid "Prova nel Playground"
msgstr "Prova nel Playground"

#: src/features/console/lib/onboarding.ts:83
msgid "Prova una domanda"
msgstr "Prova una domanda"

#: src/features/console/pages/PlaygroundPage.tsx:1820
msgid "Prova una domanda sulle tue fonti e controlla la risposta insieme ai contenuti utilizzati."
msgstr "Prova una domanda sulle tue fonti e controlla la risposta insieme ai contenuti utilizzati."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:280
msgid "Provi le stesse risposte che riceverà chi usa il tuo chatbot pubblico, limitate alle fonti condivise."
msgstr "Provi le stesse risposte che riceverà chi usa il tuo chatbot pubblico, limitate alle fonti condivise."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:283
msgid "Provi le stesse risposte che vedono i tuoi ospiti, limitate alle fonti condivise."
msgstr "Provi le stesse risposte che vedono i tuoi ospiti, limitate alle fonti condivise."

#: src/features/console/components/ProviderAccounts.tsx:85
#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:63
#: src/features/workspace/components/searchFilters/ConversationsSearchFilters.tsx:60
msgid "Provider"
msgstr "Provider"

#: src/routes/_authed/_modal/integrations/$capability.tsx:1011
msgid "Provider del drive non riconosciuto — riconnetti l'account."
msgstr "Provider del drive non riconosciuto — riconnetti l'account."

#: src/features/auth/desktop/DesktopLoginForm.tsx:653
msgid "Provider di accesso non disponibili al momento."
msgstr "Provider di accesso non disponibili al momento."

#: src/features/sync/hooks/useFilePicker.tsx:117
msgid "Provider non disponibile — riconnetti l'account per gestire i file."
msgstr "Provider non disponibile — riconnetti l'account per gestire i file."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:371
#: src/features/console/pages/EmbeddedIdentityPage.tsx:401
#: src/features/console/pages/EmbeddedIdentityPage.tsx:597
msgid "Provider OIDC"
msgstr "Provider OIDC"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:397
msgid "Provider OIDC esistente"
msgstr "Provider OIDC esistente"

#: src/features/admin/components/CostTraceDetailSection.tsx:220
msgid "Provider/Model"
msgstr "Provider/Model"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:87
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:104
msgid "Provisioning"
msgstr "Provisioning"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:100
msgid "Provisioning avviato"
msgstr "Provisioning avviato"

#: src/features/admin/components/AdminBilling.tsx:85
msgid "Provisioning fallito"
msgstr "Provisioning fallito"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:83
msgid "Provisioning richiesto"
msgstr "Provisioning richiesto"

#: src/features/admin/components/AdminCpq.tsx:1238
#: src/features/hive-flows/components/FlowActivateControl.tsx:223
#: src/features/hive-flows/components/FlowFormPublish.tsx:215
msgid "Pubblica"
msgstr "Pubblica"

#: src/features/connect/components/ChatbotPanel.tsx:127
msgid "Pubblica chatbot"
msgstr "Pubblica chatbot"

#: src/features/hive-flows/components/FlowFormPublish.tsx:114
msgid "Pubblica come modulo"
msgstr "Pubblica come modulo"

#: src/features/hive-flows/components/FlowFormPublish.tsx:107
msgid "Pubblica form"
msgstr "Pubblica form"

#: src/features/admin/components/AdminCpq.tsx:1173
msgid "Pubblica il preventivo"
msgstr "Pubblica il preventivo"

#: src/features/admin/components/AdminCpq.tsx:524
msgid "Pubblica link"
msgstr "Pubblica link"

#: src/features/connect/components/ChatbotPanel.tsx:110
msgid "Pubblica questo spazio come chatbot: chiunque abbia il link potrà fare domande limitate alle fonti condivise, senza account."
msgstr "Pubblica questo spazio come chatbot: chiunque abbia il link potrà fare domande limitate alle fonti condivise, senza account."

#: src/features/admin/components/AdminCpq.tsx:469
#: src/features/admin/components/AdminCpqList.tsx:69
msgid "Pubblicato"
msgstr "Pubblicato"

#: src/features/report/lib/useReportLifecycle.ts:86
msgid "Pubblicato e congelato. Le modifiche creeranno una nuova versione."
msgstr "Pubblicato e congelato. Le modifiche creeranno una nuova versione."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:315
msgid "Pubblicazione"
msgstr "Pubblicazione"

#: src/features/admin/components/AdminCpq.tsx:424
#: src/features/hive-flows/components/FlowFormPublish.tsx:93
msgid "Pubblicazione non riuscita"
msgstr "Pubblicazione non riuscita"

#: src/features/settings/components/PresentationTemplates.tsx:95
msgid "Pubblico"
msgstr "Pubblico"

#: src/features/templates/components/TemplateCard.tsx:37
#: src/features/templates/components/TemplatesList.tsx:53
msgid "PUBBLICO"
msgstr "PUBBLICO"

#: src/features/hive-flows/components/FlowFormPublish.tsx:215
msgid "Pubblico…"
msgstr "Pubblico…"

#: src/routes/_authed/route.tsx:1131
msgid "pulisce la conversazione corrente"
msgstr "pulisce la conversazione corrente"

#: src/routes/_authed/route.tsx:1107
msgid "Pulisci la conversazione corrente"
msgstr "Pulisci la conversazione corrente"

#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:126
#: src/routes/_authed/workspace/conversations.tsx:1055
msgid "Pulisci ricerca"
msgstr "Pulisci ricerca"

#: src/features/admin/components/AdminOrgs.tsx:950
msgid "Pulisci selezione"
msgstr "Pulisci selezione"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:285
msgid "Punteggi di rilevanza calcolati dal consolidation"
msgstr "Punteggi di rilevanza calcolati dal consolidation"

#. placeholder {0}: r.score
#: src/features/report/components/NpsPromoterDetractorGrid.tsx:147
msgid "Punteggio {0} su 10"
msgstr "Punteggio {0} su 10"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:681
#: src/features/admin/components/deckEditor/DeckEditor.tsx:996
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:59
msgid "Punti"
msgstr "Punti"

#: src/features/sources/components/ArtifactPane.tsx:2318
msgid "Punti chiave"
msgstr "Punti chiave"

#: src/features/console/pages/FlowsPage.tsx:310
msgid "Punti di partenza pronti: crea un flow da un template e rifiniscilo subito nell'editor della console."
msgstr "Punti di partenza pronti: crea un flow da un template e rifiniscilo subito nell'editor della console."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:214
msgid "Punti elenco (uno per riga)"
msgstr "Punti elenco (uno per riga)"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:56
msgid "Punto di iniezione"
msgstr "Punto di iniezione"

#: src/features/connect/components/MemberManager.tsx:540
msgid "Può interrogare le fonti condivise, in sola lettura."
msgstr "Può interrogare le fonti condivise, in sola lettura."

#: src/features/sales/components/CampaignSharing.tsx:49
msgid "Può modificare"
msgstr "Può modificare"

#: src/features/sales/components/CampaignSharing.tsx:50
msgid "Può vedere"
msgstr "Può vedere"

#: src/features/sources/components/InboxDetailPane.tsx:521
msgid "Puoi annullarla qui sotto."
msgstr "Puoi annullarla qui sotto."

#: src/features/console/pages/BillingPage.tsx:206
msgid "Puoi cambiare modalità in qualsiasi momento. Vale per le nuove AppKey e ricariche; quelle esistenti mantengono il wallet originale. Nessun credito viene trasferito."
msgstr "Puoi cambiare modalità in qualsiasi momento. Vale per le nuove AppKey e ricariche; quelle esistenti mantengono il wallet originale. Nessun credito viene trasferito."

#: src/features/console/pages/ResourceAccessPage.tsx:400
msgid "Puoi leggere questo documento. Solo il proprietario o un gestore può cambiare chi ha accesso."
msgstr "Puoi leggere questo documento. Solo il proprietario o un gestore può cambiare chi ha accesso."

#: src/features/dashboard/components/ReceivedDashboardsList.tsx:92
msgid "Puoi modificare questa dashboard"
msgstr "Puoi modificare questa dashboard"

#: src/features/clean-control/components/ModeToggle.tsx:69
msgid "Puoi passare in automatico senza perdere i controlli."
msgstr "Puoi passare in automatico senza perdere i controlli."

#: src/features/sources/components/AISummaryPanel.tsx:903
msgid "Puoi salvare il documento per rendere le modifiche permanenti."
msgstr "Puoi salvare il documento per rendere le modifiche permanenti."

#: src/features/dashboard/components/ReceivedDashboardsList.tsx:93
msgid "Puoi solo visualizzarla"
msgstr "Puoi solo visualizzarla"

#: src/features/console/docs/content.ts:1979
msgid "Push su una run già abortita/completata."
msgstr "Push su una run già abortita/completata."

#: src/features/console/webhooks/WebhooksPanel.tsx:714
msgid "Python"
msgstr "Python"

#: src/features/console/connectors/CustomConnectorDetail.tsx:503
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:432
msgid "Python · AndoConnector"
msgstr "Python · AndoConnector"

#: src/features/console/docs/content.ts:1918
msgid "Python: usa lo stesso app_user_id verificato in start, conferma, stato e query. Dopo OAuth la sync procede automaticamente; per Drive e Teams scegli prima cartelle, file o chat. La sync manuale a pagine resta opzionale."
msgstr "Python: usa lo stesso app_user_id verificato in start, conferma, stato e query. Dopo OAuth la sync procede automaticamente; per Drive e Teams scegli prima cartelle, file o chat. La sync manuale a pagine resta opzionale."

#: src/features/connectors/wizards/driveSpec.tsx:111
msgid "Q&A sui file"
msgstr "Q&A sui file"

#: src/features/settings/components/OrganizationSettings.tsx:154
msgid "Q3 2026"
msgstr "Q3 2026"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:211
msgid "Qtà"
msgstr "Qtà"

#: src/features/chat/components/ChatEmptyState.tsx:492
msgid "Qual è il saldo e i movimenti del mese?"
msgstr "Qual è il saldo e i movimenti del mese?"

#: src/routes/_authed/workspace/finance.tsx:1796
msgid "Qual è la liquidazione IVA del trimestre corrente? Mostrami debito/credito e scadenze versamento."
msgstr "Qual è la liquidazione IVA del trimestre corrente? Mostrami debito/credito e scadenze versamento."

#: src/features/chat/components/ChatEmptyState.tsx:491
msgid "Qual è la policy ferie aziendale?"
msgstr "Qual è la policy ferie aziendale?"

#: src/routes/connect.chatbot.$publicToken.tsx:109
#: src/routes/connect.invite.$token.tsx:223
#: src/routes/public.voice-report.$token.tsx:352
msgid "Qualcosa è andato storto"
msgstr "Qualcosa è andato storto"

#: src/lib/RouteErrorFallback.tsx:17
msgid "Qualcosa è andato storto nel caricamento della pagina."
msgstr "Qualcosa è andato storto nel caricamento della pagina."

#: src/features/sources/components/SyncConflictDialog.tsx:74
msgid "qualcun altro"
msgstr "qualcun altro"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:379
msgid "Quale file vuoi usare come base?"
msgstr "Quale file vuoi usare come base?"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:413
msgid "Quale provider vuoi collegare?"
msgstr "Quale provider vuoi collegare?"

#: src/routes/_authed/workspace/finance.tsx:1802
msgid "Quali adempimenti di conservazione e quali LIPE devo presentare nei prossimi 60 giorni?"
msgstr "Quali adempimenti di conservazione e quali LIPE devo presentare nei prossimi 60 giorni?"

#: src/features/chat/components/ChatEmptyState.tsx:348
msgid "Quali automazioni sono attive in questo momento?"
msgstr "Quali automazioni sono attive in questo momento?"

#: src/features/chat/components/ChatEmptyState.tsx:244
msgid "Quali bug sono aperti questa settimana?"
msgstr "Quali bug sono aperti questa settimana?"

#: src/features/chat/components/ChatEmptyState.tsx:334
msgid "Quali canvas hanno condiviso con me?"
msgstr "Quali canvas hanno condiviso con me?"

#: src/routes/_authed/workspace/finance.tsx:1706
msgid "Quali clienti hanno fatture scadute da oltre 30 giorni? Mostrami nome, totale e ultima scadenza."
msgstr "Quali clienti hanno fatture scadute da oltre 30 giorni? Mostrami nome, totale e ultima scadenza."

#: src/features/chat/components/ChatEmptyState.tsx:426
msgid "Quali condivisioni aspettano una mia azione?"
msgstr "Quali condivisioni aspettano una mia azione?"

#: src/features/chat/components/ChatEmptyState.tsx:400
msgid "Quali conversazioni ho condiviso negli ultimi 30 giorni?"
msgstr ""

#: src/features/chat/components/ChatEmptyState.tsx:394
msgid "Quali conversazioni mi hanno condiviso di recente?"
msgstr ""

#: src/features/chat/components/ChatEmptyState.tsx:314
msgid "Quali dashboard hanno condiviso con me?"
msgstr "Quali dashboard hanno condiviso con me?"

#: src/features/chat/components/ChatEmptyState.tsx:230
msgid "Quali documenti aspettano la mia revisione?"
msgstr "Quali documenti aspettano la mia revisione?"

#: src/features/chat/components/ChatEmptyState.tsx:218
msgid "Quali documenti sono stati modificati questa settimana?"
msgstr "Quali documenti sono stati modificati questa settimana?"

#: src/features/chat/components/ChatEmptyState.tsx:132
msgid "Quali email posso archiviare senza rischio?"
msgstr "Quali email posso archiviare senza rischio?"

#: src/features/chat/components/ChatEmptyState.tsx:493
msgid "Quali fatture sono scadute?"
msgstr "Quali fatture sono scadute?"

#: src/features/chat/components/ChatEmptyState.tsx:380
msgid "Quali flow ho attivi in questo momento?"
msgstr "Quali flow ho attivi in questo momento?"

#: src/features/chat/components/ChatEmptyState.tsx:178
msgid "Quali incassi sono attesi nei prossimi 30 giorni?"
msgstr "Quali incassi sono attesi nei prossimi 30 giorni?"

#: src/features/chat/components/ChatEmptyState.tsx:198
msgid "Quali lead sono caldi e dovrei contattare oggi?"
msgstr "Quali lead sono caldi e dovrei contattare oggi?"

#: src/features/chat/components/ChatEmptyState.tsx:152
msgid "Quali meeting in conflitto posso riprogrammare?"
msgstr "Quali meeting in conflitto posso riprogrammare?"

#: src/features/chat/components/ChatEmptyState.tsx:210
msgid "Quali opportunità sono previste in chiusura questo mese?"
msgstr "Quali opportunità sono previste in chiusura questo mese?"

#: src/features/chat/components/ChatEmptyState.tsx:256
msgid "Quali pull request aspettano la mia review?"
msgstr "Quali pull request aspettano la mia review?"

#: src/features/chat/components/ChatEmptyState.tsx:288
msgid "Quali sono i miei blockers attivi e come posso sbloccarli?"
msgstr "Quali sono i miei blockers attivi e come posso sbloccarli?"

#: src/routes/_authed/workspace/finance.tsx:1596
msgid "Quali sono le 10 spese più alte di questo mese? Mostrami importo, data e causale."
msgstr "Quali sono le 10 spese più alte di questo mese? Mostrami importo, data e causale."

#: src/features/chat/components/ChatEmptyState.tsx:270
msgid "Quali task sono in ritardo?"
msgstr "Quali task sono in ritardo?"

#: src/features/chat/components/ChatEmptyState.tsx:360
msgid "Quali workflow hanno errori recenti?"
msgstr "Quali workflow hanno errori recenti?"

#: src/features/chat/components/ChatEmptyState.tsx:366
msgid "Quali workflow vale la pena testare?"
msgstr "Quali workflow vale la pena testare?"

#: src/features/sales/components/SalesOverview.tsx:183
msgid "Qualifica"
msgstr "Qualifica"

#: src/features/sales/components/LeadInlineControls.tsx:134
msgid "Qualifica lead"
msgstr "Qualifica lead"

#: src/features/sales/components/LeadInlineControls.tsx:122
msgid "Qualifica rimossa"
msgstr "Qualifica rimossa"

#: src/features/sales/components/SalesOverview.tsx:112
#: src/features/sales/components/SalesOverview.tsx:168
msgid "Qualificati"
msgstr "Qualificati"

#: src/features/sales/components/leadMeta.ts:58
msgid "Qualificato"
msgstr "Qualificato"

#: src/routes/_authed/_modal/admin/route.tsx:131
msgid "Qualità"
msgstr "Qualità"

#: src/features/clean-control/components/QualityScoreStat.tsx:110
#: src/features/clean-control/components/QualityScoreStat.tsx:113
msgid "Qualità del dato"
msgstr "Qualità del dato"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:232
msgid "Qualità: alta"
msgstr "Qualità: alta"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:236
msgid "Qualità: bassa"
msgstr "Qualità: bassa"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:234
msgid "Qualità: media"
msgstr "Qualità: media"

#: src/features/admin/components/AdminQuality.tsx:71
msgid "Quality dashboard"
msgstr "Quality dashboard"

#: src/features/connectors/wizards/databaseSpec.tsx:179
msgid "Qualsiasi DB via DSN"
msgstr "Qualsiasi DB via DSN"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:234
#: src/features/admin/components/orgs/AuditLogList.tsx:130
#: src/features/hive-flows/components/nodeVisuals.tsx:44
msgid "Quando"
msgstr "Quando"

#: src/routes/_authed/workspace/conversations.tsx:1106
msgid "Quando arriveranno nuove email o notifiche li vedrai qui."
msgstr "Quando arriveranno nuove email o notifiche li vedrai qui."

#: src/routes/_authed/_modal/settings/help.tsx:86
msgid "Quando attivi Focus, web search o pensiero esteso, Ando esegue più passi di ricerca e verifica prima di rispondere. Per risposte rapide disattiva queste opzioni dal pannello strumenti del composer."
msgstr "Quando attivi Focus, web search o pensiero esteso, Ando esegue più passi di ricerca e verifica prima di rispondere. Per risposte rapide disattiva queste opzioni dal pannello strumenti del composer."

#: src/features/settings/components/NotificationPreferences.tsx:78
msgid "Quando hai promesso qualcosa ma non l'hai ancora fatto."
msgstr "Quando hai promesso qualcosa ma non l'hai ancora fatto."

#: src/features/clean-control/components/policies/PoliciesEditor.tsx:63
msgid "Quando la modalità automatica è attiva, Ando applica queste policy sugli eventi eleggibili. Puoi simulare, chiedere approvazione o autorizzare l'applicazione autonoma."
msgstr "Quando la modalità automatica è attiva, Ando applica queste policy sugli eventi eleggibili. Puoi simulare, chiedere approvazione o autorizzare l'applicazione autonoma."

#: src/features/skills/components/TeamSkillsCatalog.tsx:89
msgid "Quando qualcuno del tuo team condivide una skill, la trovi qui e puoi attivarla per te."
msgstr "Quando qualcuno del tuo team condivide una skill, la trovi qui e puoi attivarla per te."

#: src/features/settings/components/NotificationPreferences.tsx:84
msgid "Quando salti un'azione che fai abitualmente."
msgstr "Quando salti un'azione che fai abitualmente."

#: src/features/settings/components/NotificationPreferences.tsx:102
msgid "Quando sembri bloccato, Ando ti chiede se ti serve aiuto."
msgstr "Quando sembri bloccato, Ando ti chiede se ti serve aiuto."

#: src/features/skills/components/SkillEditor.tsx:343
msgid "Quando si attiva"
msgstr "Quando si attiva"

#: src/features/skills/components/SkillsList.tsx:180
msgid "Quando spieghi ad Ando come fare una cosa, lui la salva come skill. Qui puoi attivarle, modificarle e condividerle col team dal menu «⋯». Le skill che il team condivide le trovi nel tab «Team»."
msgstr "Quando spieghi ad Ando come fare una cosa, lui la salva come skill. Qui puoi attivarle, modificarle e condividerle col team dal menu «⋯». Le skill che il team condivide le trovi nel tab «Team»."

#: src/routes/_authed/workspace/flows.index.tsx:573
msgid "Quando un collega condivide un flow col team lo trovi qui: puoi farne una tua copia e usarlo subito."
msgstr "Quando un collega condivide un flow col team lo trovi qui: puoi farne una tua copia e usarlo subito."

#: src/features/console/flows/ConsoleFlowApprovals.tsx:71
msgid "Quando un flow si ferma su un passaggio di approvazione, comparirà qui."
msgstr "Quando un flow si ferma su un passaggio di approvazione, comparirà qui."

#: src/features/admin/components/AdminEngagement.tsx:501
msgid "Quando usano il prodotto · giorno × ora"
msgstr "Quando usano il prodotto · giorno × ora"

#: src/features/admin/components/AdminCpq.tsx:1016
msgid "Quantità"
msgstr "Quantità"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:311
msgid "Quanto è delicata questa azione: guida la conferma richiesta all'esecuzione."
msgstr "Quanto è delicata questa azione: guida la conferma richiesta all'esecuzione."

#: src/features/admin/components/AdminEngagement.tsx:442
#: src/features/console/pages/PlaygroundPage.tsx:1875
msgid "Query"
msgstr "Query"

#: src/features/console/docs/content.ts:321
msgid "Query & Agentic answer"
msgstr "Query & Agentic answer"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:201
msgid "Query AI sui dati"
msgstr "Query AI sui dati"

#: src/features/connectors/wizards/erpSpec.tsx:192
msgid "Query AI sui dati ERP"
msgstr "Query AI sui dati ERP"

#: src/features/console/pages/PlaygroundPage.tsx:892
msgid "Query autonoma"
msgstr "Query autonoma"

#: src/features/hive-flows/components/DryRunPanel.tsx:72
#: src/features/hive-flows/components/DryRunPanel.tsx:144
msgid "Query freezata"
msgstr "Query freezata"

#. placeholder {0}: aiState.modelUsed || "Ando"
#: src/features/dashboard/components/wizard/WizardStepData.tsx:321
msgid "Query generata e già eseguita ({0}). Rivedila nella scheda <0>Scrivi SQL</0> o passa al passo successivo."
msgstr "Query generata e già eseguita ({0}). Rivedila nella scheda <0>Scrivi SQL</0> o passa al passo successivo."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:518
msgid "Query Gmail"
msgstr "Query Gmail"

#: src/features/connectors/wizards/databaseSpec.tsx:242
msgid "Query in linguaggio naturale"
msgstr "Query in linguaggio naturale"

#: src/features/price-lists/components/PriceListsPage.tsx:275
msgid "Query live su SAP B1"
msgstr "Query live su SAP B1"

#: src/features/price-lists/components/PriceListsPage.tsx:273
msgid "Query live sui prodotti del sistema collegato"
msgstr "Query live sui prodotti del sistema collegato"

#: src/features/price-lists/components/PriceListsPage.tsx:280
msgid "Query live sui Products di HubSpot"
msgstr "Query live sui Products di HubSpot"

#: src/features/price-lists/components/PriceListsPage.tsx:278
msgid "Query live sul Product2 di Salesforce"
msgstr "Query live sul Product2 di Salesforce"

#: src/features/dashboard/components/ChartSqlEditor.tsx:88
msgid "Query salvata. Aggiornamento del grafico in corso."
msgstr "Query salvata. Aggiornamento del grafico in corso."

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:88
#: src/features/dashboard/components/wizard/WizardStepData.tsx:356
msgid "Query SQL"
msgstr "Query SQL"

#: src/features/billing/components/UsageInsightsCard.tsx:235
msgid "Query totali"
msgstr "Query totali"

#: src/features/clean-control/utils/explainEvent.ts:68
msgid "Questa anagrafica compare con {count} schede diverse: potresti unificarle."
msgstr "Questa anagrafica compare con {count} schede diverse: potresti unificarle."

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:113
msgid "Questa app fa da ponte verso il database. Consigliato per database in rete locale o dietro firewall aziendale."
msgstr "Questa app fa da ponte verso il database. Consigliato per database in rete locale o dietro firewall aziendale."

#: src/features/console/pages/EngineSignupPage.tsx:234
msgid "Questa AppKey completa viene mostrata una sola volta. Copiala ora."
msgstr "Questa AppKey completa viene mostrata una sola volta. Copiala ora."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:217
msgid "Questa azione è a rischio «{riskName}» e richiede una conferma esplicita: senza spunta non verrà invocato nulla. Ando chiamerà subito il tuo endpoint."
msgstr "Questa azione è a rischio «{riskName}» e richiede una conferma esplicita: senza spunta non verrà invocato nulla. Ando chiamerà subito il tuo endpoint."

#: src/features/workspace/documents/components/FolderBrowserView.tsx:178
msgid "Questa cartella è vuota."
msgstr "Questa cartella è vuota."

#: src/features/console/components/CreateKeyWizard.tsx:424
msgid "Questa chiave legge solo i dati dell'utente verificato della app associata. Non legge le fonti del progetto né gli account degli altri utenti."
msgstr "Questa chiave legge solo i dati dell'utente verificato della app associata. Non legge le fonti del progetto né gli account degli altri utenti."

#: src/features/report/components/CitationDetail.tsx:153
msgid "Questa citazione non è stata ancorata al testo narrativo (l'estratto non corrisponde esattamente)."
msgstr "Questa citazione non è stata ancorata al testo narrativo (l'estratto non corrisponde esattamente)."

#: src/routes/_authed/workspace/shares.tsx:294
msgid "Questa condivisione non è più disponibile."
msgstr "Questa condivisione non è più disponibile."

#: src/features/console/pages/ResourceAccessPage.tsx:423
msgid "Questa connessione usa una regola precedente. Scegli una delle opzioni qui sotto per impostare l'accesso."
msgstr "Questa connessione usa una regola precedente. Scegli una delle opzioni qui sotto per impostare l'accesso."

#: src/features/dashboard/components/ChartNeedsConnectorState.tsx:71
msgid "Questa dashboard è stata condivisa con te. Per aggiornare il grafico contro i tuoi dati serve una connessione del tipo del proprietario."
msgstr "Questa dashboard è stata condivisa con te. Per aggiornare il grafico contro i tuoi dati serve una connessione del tipo del proprietario."

#: src/features/connect/components/GrantManager.tsx:575
msgid "Questa è l'UNICA conoscenza che l'ospite potrà interrogare."
msgstr "Questa è l'UNICA conoscenza che l'ospite potrà interrogare."

#: src/features/console/components/CreateKeyWizard.tsx:617
msgid "Questa è l'unica volta in cui la chiave completa viene mostrata: non sarà più visibile. Conservala subito in un secret manager."
msgstr "Questa è l'unica volta in cui la chiave completa viene mostrata: non sarà più visibile. Conservala subito in un secret manager."

#: src/features/console/pages/KeyDetailPage.tsx:745
msgid "Questa è la nuova chiave, mostrata UNA SOLA VOLTA: copiala ora."
msgstr "Questa è la nuova chiave, mostrata UNA SOLA VOLTA: copiala ora."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:411
msgid "Questa è un'alternativa avanzata alla modalità server sopra. L'URL di ritorno qui sotto appartiene all'issuer OIDC; quello registrato nella sezione principale appartiene all'app server. Usa il percorso della tua AppKey. Con OIDC, Ando verifica il token dell'utente a ogni richiesta e il backend della tua app conferma il callback OAuth."
msgstr "Questa è un'alternativa avanzata alla modalità server sopra. L'URL di ritorno qui sotto appartiene all'issuer OIDC; quello registrato nella sezione principale appartiene all'app server. Usa il percorso della tua AppKey. Con OIDC, Ando verifica il token dell'utente a ogni richiesta e il backend della tua app conferma il callback OAuth."

#: src/features/chat/components/ChatEmptyState.tsx:561
msgid "Questa è una demo live: stai esplorando Rossi Forniture, un'azienda fittizia con email, fatture, gestionale, banca e documenti già collegati. Ando li unisce in un solo Company Brain — chiedi in linguaggio naturale e trova, collega e ragiona sui dati tra i sistemi. I dati sono finti e le azioni simulate: esplora senza rischi. Tocca una domanda qui sotto per iniziare."
msgstr "Questa è una demo live: stai esplorando Rossi Forniture, un'azienda fittizia con email, fatture, gestionale, banca e documenti già collegati. Ando li unisce in un solo Company Brain — chiedi in linguaggio naturale e trova, collega e ragiona sui dati tra i sistemi. I dati sono finti e le azioni simulate: esplora senza rischi. Tocca una domanda qui sotto per iniziare."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:345
msgid "Questa integrazione non è più disponibile. Scegline un'altra per vedere i suoi utenti e le sue connessioni."
msgstr "Questa integrazione non è più disponibile. Scegline un'altra per vedere i suoi utenti e le sue connessioni."

#: src/features/console/pages/TracesPage.tsx:86
msgid "Questa intestazione contiene metadati registrati, non il corpo completo inviato al provider. Apri il payload della stessa chiamata quando è disponibile."
msgstr "Questa intestazione contiene metadati registrati, non il corpo completo inviato al provider. Apri il payload della stessa chiamata quando è disponibile."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:424
msgid "Questa organizzazione eredita la tariffa globale finché non salvi una percentuale specifica."
msgstr "Questa organizzazione eredita la tariffa globale finché non salvi una percentuale specifica."

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:106
msgid "Questa pagina non contiene più elementi. Torna alla pagina precedente."
msgstr "Questa pagina non contiene più elementi. Torna alla pagina precedente."

#: src/features/maintenance/MaintenanceScreen.tsx:250
msgid "Questa pagina si aggiorna da sola quando torniamo online."
msgstr "Questa pagina si aggiorna da sola quando torniamo online."

#: src/features/console/pages/PlaygroundPage.tsx:1973
msgid "Questa prova usa la tua sessione Console e cerca solo nei tuoi account. Lo snippet usa una AppKey live dello stesso proprietario; i permessi della chiave vanno verificati dalla tua app."
msgstr "Questa prova usa la tua sessione Console e cerca solo nei tuoi account. Lo snippet usa una AppKey live dello stesso proprietario; i permessi della chiave vanno verificati dalla tua app."

#: src/features/console/pages/PlaygroundPage.tsx:770
msgid "Questa risposta non espone riferimenti consultabili. Da questa vista non puoi verificarne il supporto nelle fonti."
msgstr "Questa risposta non espone riferimenti consultabili. Da questa vista non puoi verificarne il supporto nelle fonti."

#: src/routes/_authed/workspace/work.tsx:484
#: src/routes/_authed/workspace/work.tsx:486
msgid "Questa settimana"
msgstr "Questa settimana"

#: src/routes/_authed/_modal/admin/route.tsx:188
msgid "Questa sezione è riservata agli admin di piattaforma."
msgstr "Questa sezione è riservata agli admin di piattaforma."

#: src/routes/_authed/workspace/sales.tsx:154
msgid "Questa sezione non esiste più — usa Pipeline, Contatti o Aziende qui sopra."
msgstr "Questa sezione non esiste più — usa Pipeline, Contatti o Aziende qui sopra."

#: src/features/skills/components/SkillEditor.tsx:259
msgid "Questa skill l'ha scritta Ando da una tua spiegazione — puoi modificarla qui."
msgstr "Questa skill l'ha scritta Ando da una tua spiegazione — puoi modificarla qui."

#: src/features/dashboard/components/ChartNeedsConnectorState.tsx:43
msgid "questa sorgente"
msgstr "questa sorgente"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:463
msgid "Questi conteggi riguardano solo i membri Ando mappati manualmente. Gli utenti finali della tua app sono separati e si gestiscono nella sezione Utenti delle app."
msgstr "Questi conteggi riguardano solo i membri Ando mappati manualmente. Gli utenti finali della tua app sono separati e si gestiscono nella sezione Utenti delle app."

#: src/features/console/traces/TracePayloadReader.tsx:230
msgid "Questi riferimenti sono registrati nel trace. La console non esegue tool dell’agente né assume che siano stati riaperti."
msgstr "Questi riferimenti sono registrati nel trace. La console non esegue tool dell’agente né assume che siano stati riaperti."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:340
msgid "Questi utenti accedono alla tua app, non alla Console. Qui vedi identità, stato e connessioni; i contenuti dei loro account restano privati."
msgstr "Questi utenti accedono alla tua app, non alla Console. Qui vedi identità, stato e connessioni; i contenuti dei loro account restano privati."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:317
msgid "Questo account usa la sincronizzazione già configurata. Le impostazioni si gestiscono nella connessione originale."
msgstr "Questo account usa la sincronizzazione già configurata. Le impostazioni si gestiscono nella connessione originale."

#: src/features/sales/components/BatchSendModal.tsx:269
msgid "Questo account va riconnesso prima di poter inviare."
msgstr "Questo account va riconnesso prima di poter inviare."

#: src/routes/connect.chatbot.$publicToken.tsx:114
msgid "Questo assistente non è attivo o è stato disabilitato."
msgstr "Questo assistente non è attivo o è stato disabilitato."

#: src/features/clean-control/utils/explainEvent.ts:83
msgid "Questo collegamento non si sincronizza da un po': i dati potrebbero non essere aggiornati."
msgstr "Questo collegamento non si sincronizza da un po': i dati potrebbero non essere aggiornati."

#: src/features/connectors/components/management/EditConnectorDialog.tsx:378
msgid "Questo connettore non espone campi modificabili."
msgstr "Questo connettore non espone campi modificabili."

#: src/features/clean-control/utils/explainEvent.ts:40
msgid "Questo contenuto è identico a un altro già presente in memoria: puoi tenerne uno solo per evitare doppioni."
msgstr "Questo contenuto è identico a un altro già presente in memoria: puoi tenerne uno solo per evitare doppioni."

#: src/features/clean-control/utils/explainEvent.ts:48
msgid "Questo contenuto è molto simile (~{pct}%) a un altro: potrebbe essere una versione o una copia."
msgstr "Questo contenuto è molto simile (~{pct}%) a un altro: potrebbe essere una versione o una copia."

#: src/features/clean-control/utils/explainEvent.ts:49
msgid "Questo contenuto è molto simile a un altro già in memoria: potrebbe essere una versione o una copia."
msgstr "Questo contenuto è molto simile a un altro già in memoria: potrebbe essere una versione o una copia."

#: src/features/clean-control/utils/explainEvent.ts:87
msgid "Questo contenuto non ha utenti autorizzati: nessuno può trovarlo nelle ricerche."
msgstr "Questo contenuto non ha utenti autorizzati: nessuno può trovarlo nelle ricerche."

#: src/features/dxf/components/DxfBomButton.tsx:95
msgid "Questo disegno non contiene blocchi estraibili."
msgstr "Questo disegno non contiene blocchi estraibili."

#: src/features/clean-control/utils/explainEvent.ts:75
msgid "Questo documento non viene aggiornato da {days} giorni: valuta se archiviarlo."
msgstr "Questo documento non viene aggiornato da {days} giorni: valuta se archiviarlo."

#: src/features/clean-control/utils/explainEvent.ts:76
msgid "Questo documento non viene aggiornato da tempo: valuta se archiviarlo."
msgstr "Questo documento non viene aggiornato da tempo: valuta se archiviarlo."

#: src/features/console/pages/ResourceAccessPage.tsx:418
msgid "Questo documento usa una regola precedente. Scegli una delle opzioni qui sotto per sostituirla con un accesso esplicito."
msgstr "Questo documento usa una regola precedente. Scegli una delle opzioni qui sotto per sostituirla con un accesso esplicito."

#: src/features/onboarding/demoTourSteps.ts:38
msgid "Questo è il Company Brain di Rossi Forniture, un'azienda demo con email, gestionale, banca, documenti e calendario già collegati. Ti accompagno in un giro veloce — meno di un minuto."
msgstr "Questo è il Company Brain di Rossi Forniture, un'azienda demo con email, gestionale, banca, documenti e calendario già collegati. Ti accompagno in un giro veloce — meno di un minuto."

#: src/routes/_authed/workspace/calendar.tsx:1593
msgid "Questo evento non è disponibile"
msgstr "Questo evento non è disponibile"

#: src/features/hive-flows/run/PdfDropzone.tsx:128
msgid "Questo flow accetta solo documenti (PDF, Word, Excel, PowerPoint)"
msgstr "Questo flow accetta solo documenti (PDF, Word, Excel, PowerPoint)"

#: src/features/hive-flows/run/PdfDropzone.tsx:132
msgid "Questo flow accetta solo file audio"
msgstr "Questo flow accetta solo file audio"

#: src/features/hive-flows/run/PdfDropzone.tsx:130
msgid "Questo flow accetta solo file di testo"
msgstr "Questo flow accetta solo file di testo"

#: src/features/hive-flows/run/ProposalReview.tsx:247
msgid "Questo flow non ha un campo modificabile: rimuovi le modifiche e approva, oppure apri in chat."
msgstr "Questo flow non ha un campo modificabile: rimuovi le modifiche e approva, oppure apri in chat."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1330
msgid "Questo flow non richiede un documento: avvialo quando vuoi."
msgstr "Questo flow non richiede un documento: avvialo quando vuoi."

#: src/features/sources/components/ArtifactPane.tsx:1969
msgid "Questo formato non è renderizzabile direttamente. Scaricalo per aprirlo nel programma nativo."
msgstr "Questo formato non è renderizzabile direttamente. Scaricalo per aprirlo nel programma nativo."

#: src/features/console/components/DocumentAcquiredContent.tsx:72
msgid "Questo frammento non contiene testo."
msgstr "Questo frammento non contiene testo."

#: src/features/dashboard/components/ShareChartSheet.tsx:99
msgid "Questo grafico non è ancora in una dashboard. Per ora puoi solo inviarlo via email."
msgstr "Questo grafico non è ancora in una dashboard. Per ora puoi solo inviarlo via email."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:228
msgid "Questo indicatore usa saldi di chiusura: seleziona un esercizio completo disponibile. Gli esercizi non chiusi non sono confrontabili."
msgstr "Questo indicatore usa saldi di chiusura: seleziona un esercizio completo disponibile. Gli esercizi non chiusi non sono confrontabili."

#: src/routes/connect.invite.$token.tsx:140
msgid "Questo invito è scaduto."
msgstr "Questo invito è scaduto."

#: src/routes/connect.invite.$token.tsx:199
msgid "Questo invito è stato revocato o è già stato usato. Chiedi un nuovo link per accedere allo spazio."
msgstr "Questo invito è stato revocato o è già stato usato. Chiedi un nuovo link per accedere allo spazio."

#: src/routes/connect.invite.$token.tsx:142
msgid "Questo invito non è più valido."
msgstr "Questo invito non è più valido."

#: src/routes/connect.invite.$token.tsx:87
msgid "Questo invito non esiste più. Chiedi a chi te l'ha condiviso un nuovo link."
msgstr "Questo invito non esiste più. Chiedi a chi te l'ha condiviso un nuovo link."

#: src/routes/connect.invite.$token.tsx:228
msgid "Questo invito non esiste. Verifica il link o chiedine uno nuovo."
msgstr "Questo invito non esiste. Verifica il link o chiedine uno nuovo."

#: src/routes/public.voice-report.$token.tsx:285
msgid "Questo link di condivisione è scaduto. Chiedi a chi te l'ha inviato un nuovo collegamento."
msgstr "Questo link di condivisione è scaduto. Chiedi a chi te l'ha inviato un nuovo collegamento."

#: src/routes/public.voice-report.$token.tsx:93
msgid "Questo link di condivisione non esiste più. Chiedi a chi te l'ha inviato un nuovo collegamento."
msgstr "Questo link di condivisione non esiste più. Chiedi a chi te l'ha inviato un nuovo collegamento."

#: src/routes/public.voice-report.$token.tsx:341
msgid "Questo link di condivisione non esiste. Verifica il collegamento o chiedine uno nuovo."
msgstr "Questo link di condivisione non esiste. Verifica il collegamento o chiedine uno nuovo."

#: src/routes/connect.invite.$token.tsx:186
msgid "Questo link di invito è scaduto. Chiedi a chi te l'ha condiviso di inviartene uno nuovo."
msgstr "Questo link di invito è scaduto. Chiedi a chi te l'ha condiviso di inviartene uno nuovo."

#: src/routes/public.voice-report.$token.tsx:299
msgid "Questo link non è più valido. Chiedi a chi te l'ha inviato un nuovo collegamento."
msgstr "Questo link non è più valido. Chiedi a chi te l'ha inviato un nuovo collegamento."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:245
#: src/features/console/pages/MembersPage.tsx:326
#: src/features/console/pages/MembersPage.tsx:690
#: src/features/settings/components/OrgMembersPanel.tsx:624
msgid "questo membro"
msgstr "questo membro"

#: src/routes/_authed/workspace/conversations.tsx:1206
msgid "Questo messaggio non è più disponibile"
msgstr "Questo messaggio non è più disponibile"

#: src/routes/forms.$flowId.tsx:51
msgid "Questo modulo non esiste o non è più pubblicato."
msgstr "Questo modulo non esiste o non è più pubblicato."

#: src/features/hive-flows/components/NodeInspector.tsx:477
msgid "Questo nodo non ha impostazioni."
msgstr "Questo nodo non ha impostazioni."

#: src/features/hive-flows/components/NodeInspector.tsx:469
msgid "Questo nodo non richiede configurazione: la sua presenza nel flow è ciò che sblocca la pianificazione a orario nel pulsante «Pubblica», dove scegli quando far partire il flow."
msgstr "Questo nodo non richiede configurazione: la sua presenza nel flow è ciò che sblocca la pianificazione a orario nel pulsante «Pubblica», dove scegli quando far partire il flow."

#: src/features/console/pages/EngineSignupPage.tsx:264
msgid "Questo nome organizzazione è già in uso. Scegline un altro."
msgstr "Questo nome organizzazione è già in uso. Scegline un altro."

#: src/features/connect/components/MemberManager.tsx:157
msgid "Questo ospite non potrà più aprire lo spazio né interrogarne le fonti. Puoi annullare subito dopo."
msgstr "Questo ospite non potrà più aprire lo spazio né interrogarne le fonti. Puoi annullare subito dopo."

#: src/features/console/pages/PlaygroundPage.tsx:722
msgid "Questo passaggio non espone un titolo: mostriamo l'id del documento."
msgstr "Questo passaggio non espone un titolo: mostriamo l'id del documento."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:476
msgid "Questo passaggio serve solo per utenti già membri Ando: associa il valore sub stabile del loro token al membro attivo. Non aggiungere qui tutti i dipendenti della tua app."
msgstr "Questo passaggio serve solo per utenti già membri Ando: associa il valore sub stabile del loro token al membro attivo. Non aggiungere qui tutti i dipendenti della tua app."

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:418
msgid "Questo PDF è protetto da password. Inseriscila per aprirlo."
msgstr "Questo PDF è protetto da password. Inseriscila per aprirlo."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:349
msgid "Questo provider non espone ancora un flusso di collegamento."
msgstr "Questo provider non espone ancora un flusso di collegamento."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:278
msgid "Questo provider non ha ancora un flusso Console completo. Il collegamento richiede sincronizzazione e addebito Engine verificati."
msgstr "Questo provider non ha ancora un flusso Console completo. Il collegamento richiede sincronizzazione e addebito Engine verificati."

#: src/routes/_authed/_modal/integrations/$capability.tsx:609
msgid "Questo provider non supporta la riconnessione."
msgstr "Questo provider non supporta la riconnessione."

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:618
msgid "Questo risultato è ottimizzato per la vista tabellare."
msgstr "Questo risultato è ottimizzato per la vista tabellare."

#: src/features/console/webhooks/WebhooksPanel.tsx:317
msgid "Questo secret firma ogni consegna ed è mostrato UNA SOLA VOLTA: copialo ora in un secret manager. Con esso il tuo endpoint verifica la firma<0> webhook-signature</0> di ogni richiesta."
msgstr "Questo secret firma ogni consegna ed è mostrato UNA SOLA VOLTA: copialo ora in un secret manager. Con esso il tuo endpoint verifica la firma<0> webhook-signature</0> di ogni richiesta."

#: src/features/projects/components/ProjectDetailPage.tsx:304
msgid "Questo spazio è ancora silenzioso. Apri una chat e dimmi a cosa stai lavorando — comincio a ricordare da lì."
msgstr "Questo spazio è ancora silenzioso. Apri una chat e dimmi a cosa stai lavorando — comincio a ricordare da lì."

#: src/routes/_authed/workspace/connect.$spaceId.tsx:288
msgid "Questo spazio è archiviato: gli ospiti non possono più interrogarlo."
msgstr "Questo spazio è archiviato: gli ospiti non possono più interrogarlo."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:156
msgid "questo specialist"
msgstr "questo specialist"

#: src/features/templates/components/TemplateEditor.tsx:252
msgid "Questo template è built-in e in sola lettura. Usa \"Personalizza per modificare\" dalla griglia per crearne una copia modificabile."
msgstr "Questo template è built-in e in sola lettura. Usa \"Personalizza per modificare\" dalla griglia per crearne una copia modificabile."

#. placeholder {0}: i18n._(KIND_LABEL[detail.kind])
#. placeholder {1}: i18n._(KIND_LABEL[kind])
#: src/features/templates/components/TemplateEditor.tsx:308
msgid "Questo template è di tipo <0>{0}</0>. Per modificare le impostazioni {1}, apri un template di quella categoria dalla lista."
msgstr "Questo template è di tipo <0>{0}</0>. Per modificare le impostazioni {1}, apri un template di quella categoria dalla lista."

#: src/features/actions/hooks/useCreateManualAction.ts:90
msgid "Questo tipo di azione non è ancora creabile manualmente."
msgstr "Questo tipo di azione non è ancora creabile manualmente."

#: src/features/automations/components/ScheduleEditor.tsx:111
msgid "Questo tipo di pianificazione non è disponibile qui: scegli manualmente qui sotto."
msgstr "Questo tipo di pianificazione non è disponibile qui: scegli manualmente qui sotto."

#: src/features/hive-flows/components/TriggerTestDataDialog.tsx:62
msgid "Questo trigger non parte da un'azione manuale: inserisci dei valori di esempio cosi i nodi a valle hanno qualcosa da leggere."
msgstr "Questo trigger non parte da un'azione manuale: inserisci dei valori di esempio cosi i nodi a valle hanno qualcosa da leggere."

#: src/features/console/docs/content.ts:491
msgid "queued → processing → completed | failed (+ error_code stabile). L'SDK offre wait_for_job con polling e retry sui transienti."
msgstr "queued → processing → completed | failed (+ error_code stabile). L'SDK offre wait_for_job con polling e retry sui transienti."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:733
msgid "Qui non ci sono ancora opzioni: registra e abilita prima l'identità della tua app nel passaggio 1."
msgstr "Qui non ci sono ancora opzioni: registra e abilita prima l'identità della tua app nel passaggio 1."

#: src/features/onboarding/demoTourSteps.ts:61
msgid "Qui sopra ci sono le aree principali: conversazioni, calendario, documenti, amministrazione, vendite e altro. Le aree più avanzate — Canvas, Analisi, Automazioni, Flows, Connect — vivono negli «Spazi», nella barra a sinistra: te le mostro tra poco."
msgstr "Qui sopra ci sono le aree principali: conversazioni, calendario, documenti, amministrazione, vendite e altro. Le aree più avanzate — Canvas, Analisi, Automazioni, Flows, Connect — vivono negli «Spazi», nella barra a sinistra: te le mostro tra poco."

#: src/features/projects/components/sections/MemorySection.tsx:260
msgid "Qui vedi quello che l'agente ha imparato lavorando in questo progetto. Le preferenze generali del tuo workspace (nome, ruolo, gusti) restano valide anche qui, ma non vengono elencate per non confondere i due livelli. Gli altri progetti non si mescolano: la memoria di questo progetto resta isolata."
msgstr "Qui vedi quello che l'agente ha imparato lavorando in questo progetto. Le preferenze generali del tuo workspace (nome, ruolo, gusti) restano valide anche qui, ma non vengono elencate per non confondere i due livelli. Gli altri progetti non si mescolano: la memoria di questo progetto resta isolata."

#: src/features/console/pages/DocsPage.tsx:273
#: src/features/console/pages/DocsPage.tsx:479
#: src/features/console/pages/DocsPage.tsx:584
msgid "Quickstart"
msgstr "Quickstart"

#: src/features/admin/components/AdminRevenue.tsx:267
msgid "Quota"
msgstr "Quota"

#: src/features/console/docs/content.ts:1222
msgid "Quota (rate-limit + spend-cap)"
msgstr "Quota (rate-limit + spend-cap)"

#: src/features/console/pages/UsagePage.tsx:534
msgid "Quota periodo"
msgstr "Quota periodo"

#: src/features/sync/components/DocSyncManager.tsx:1400
msgid "Quota quasi piena — riduci la selezione o aumenta il piano."
msgstr "Quota quasi piena — riduci la selezione o aumenta il piano."

#: src/features/report/components/RespondentQuotesCarousel.tsx:125
msgid "Quote degli intervistati"
msgstr "Quote degli intervistati"

#: src/features/admin/components/AdminCpq.tsx:860
msgid "R&D Ando Lab (facoltativo)"
msgstr "R&D Ando Lab (facoltativo)"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:243
msgid "Raccogli i valori dei codici (senza AI)"
msgstr "Raccogli i valori dei codici (senza AI)"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:197
msgid "Raccogli i valori dei codici senza rigenerare le descrizioni"
msgstr "Raccogli i valori dei codici senza rigenerare le descrizioni"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:222
msgid "Raccolta valori avviata: compaiono nello schema entro pochi minuti."
msgstr "Raccolta valori avviata: compaiono nello schema entro pochi minuti."

#: src/features/integrations/parts/ConnectorDetailSection.tsx:220
msgid "Raccolta valori non avviata."
msgstr "Raccolta valori non avviata."

#. placeholder {0}: item.recommendation
#: src/features/report/hooks/useRecommendationActions.ts:78
msgid "Raccomandazione: {0}"
msgstr "Raccomandazione: {0}"

#: src/features/voice_report/components/RunDiffTimeline.tsx:354
msgid "Raccomandazioni"
msgstr "Raccomandazioni"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:100
#: src/features/dfm-rules/components/DfmRulesPage.tsx:53
msgid "Raccordo"
msgstr "Raccordo"

#: src/features/clean-control/components/DimensionRadar.tsx:165
msgid "Radar delle 7 dimensioni DAMA"
msgstr "Radar delle 7 dimensioni DAMA"

#. placeholder {0}: chi.toFixed(2)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:102
msgid "raggiunto (χ² {0})"
msgstr "raggiunto (χ² {0})"

#: src/features/projects/components/NewProjectDialog.tsx:107
msgid "Raggruppa le conversazioni per area di lavoro. Potrai cambiare icona, colore e impostazioni in qualsiasi momento."
msgstr "Raggruppa le conversazioni per area di lavoro. Potrai cambiare icona, colore e impostazioni in qualsiasi momento."

#: src/routes/_authed/workspace/documents.tsx:912
msgid "Raggruppa per"
msgstr "Raggruppa per"

#: src/features/console/pages/ModelsPage.tsx:322
msgid "Ragionamento agentico"
msgstr "Ragionamento agentico"

#: src/features/console/pages/ModelsPage.tsx:323
msgid "Ragionamento e strumenti dell’agente Engine."
msgstr "Ragionamento e strumenti dell’agente Engine."

#: src/features/connectors/wizards/sdiSpec.tsx:69
msgid "Ragione sociale"
msgstr "Ragione sociale"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:61
msgid "Ragione sociale, codice ATECO, sede legale — tutto in chat."
msgstr "Ragione sociale, codice ATECO, sede legale — tutto in chat."

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:383
msgid "Range diametro non valido (min ≤ max, ≥ 0)"
msgstr "Range diametro non valido (min ≤ max, ≥ 0)"

#: src/features/admin/components/AdminOverview.tsx:137
msgid "Ranking"
msgstr "Ranking"

#: src/features/structured-data/components/SimilarPartsSection.tsx:191
#: src/features/structured-data/components/SimilarPartsSection.tsx:194
msgid "Ranking verificato da Gemini Vision: i falsi positivi geometrici sono stati scartati."
msgstr "Ranking verificato da Gemini Vision: i falsi positivi geometrici sono stati scartati."

#: src/features/billing/components/UsageInsightsCard.tsx:168
msgid "rapide"
msgstr "rapide"

#: src/features/console/pages/ModelsPage.tsx:331
msgid "Rappresenta testi e domande per la ricerca."
msgstr "Rappresenta testi e domande per la ricerca."

#: src/features/connectors/wizards/vatVerifierSpec.tsx:70
msgid "Rate-limit gestito"
msgstr "Rate-limit gestito"

#: src/features/console/webhooks/WebhooksPanel.tsx:197
msgid "Re-invia"
msgstr "Re-invia"

#: src/features/sources/components/InboxDetailPane.tsx:1255
msgid "Re: (senza oggetto)"
msgstr "Re: (senza oggetto)"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1453
msgid "read-only"
msgstr "read-only"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:726
msgid "Realm Kerberos"
msgstr "Realm Kerberos"

#: src/features/admin/components/CostTraceDetailSection.tsx:176
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:378
msgid "Reasoning"
msgstr "Reasoning"

#: src/features/agent-modes/components/AgentModeEditor.tsx:427
msgid "Reasoning esteso, più fonti consultate, debate finale (~30–60s)."
msgstr "Reasoning esteso, più fonti consultate, debate finale (~30–60s)."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:163
msgid "Reasoning traces"
msgstr "Reasoning traces"

#: src/features/admin/components/AdminHypermem.tsx:96
msgid "Reasoning Traces"
msgstr "Reasoning Traces"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:456
msgid "Reasoning traces (per-turn)"
msgstr "Reasoning traces (per-turn)"

#: src/features/console/pages/FlowsPage.tsx:121
#: src/routes/_authed/workspace/flows.index.tsx:80
msgid "Reattivo"
msgstr "Reattivo"

#: src/features/automations/components/formatters.ts:92
msgid "Reattivo (evento)"
msgstr "Reattivo (evento)"

#: src/features/console/components/CommandPalette.tsx:171
msgid "Recenti"
msgstr "Recenti"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:268
msgid "Record"
msgstr "Record"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:513
msgid "record analizzati"
msgstr "record analizzati"

#: src/features/sales/hooks/useCrmQueries.ts:357
msgid "Record arricchito con AI"
msgstr "Record arricchito con AI"

#: src/features/console/connectors/CustomConnectorDetail.tsx:269
msgid "Record da validare (JSON)"
msgstr "Record da validare (JSON)"

#: src/features/hive-flows/run/ProposalReview.tsx:451
msgid "Record proposto"
msgstr "Record proposto"

#: src/features/console/connectors/CustomConnectorDetail.tsx:298
msgid "Record rifiutati"
msgstr "Record rifiutati"

#: src/features/admin/components/UserDetailContent.tsx:719
msgid "Recovery codes"
msgstr "Recovery codes"

#: src/features/admin/components/AdminEngagement.tsx:181
msgid "Recuperati · 7gg"
msgstr "Recuperati · 7gg"

#: src/features/console/pages/PlaygroundPage.tsx:871
msgid "Recupero documenti"
msgstr "Recupero documenti"

#: src/features/sources/SourceRailSurface.tsx:215
msgid "recupero fonti…"
msgstr "recupero fonti…"

#: src/features/clean-control/utils/labels.ts:119
msgid "Redigi automaticamente"
msgstr "Redigi automaticamente"

#: src/features/sales/components/CreateLeadDialog.tsx:166
#: src/features/sales/components/CreateLeadDialog.tsx:172
msgid "Referente"
msgstr "Referente"

#: src/features/voice_report/components/NewReportDialog.tsx:567
msgid "Refine failed"
msgstr "Refine failed"

#: src/features/admin/components/AdminCpqPriceBook.tsx:352
msgid "Refresh al mese"
msgstr "Refresh al mese"

#: src/features/auth/desktop/useDesktopOAuth.ts:198
msgid "Refresh fallito."
msgstr "Refresh fallito."

#: src/features/console/pages/BillingPage.tsx:460
msgid "Regime fiscale"
msgstr "Regime fiscale"

#. placeholder {0}: provision.region
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:280
msgid "Region: {0}"
msgstr "Region: {0}"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:197
msgid "Regione"
msgstr "Regione"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:201
msgid "Regione provisioning"
msgstr "Regione provisioning"

#: src/features/console/components/ModelPickerModal.tsx:362
#: src/features/console/components/ProviderAccounts.tsx:212
msgid "Regione Vertex AI"
msgstr "Regione Vertex AI"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:662
msgid "Registra connettore"
msgstr "Registra connettore"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:235
msgid "Registra il primo per spingere i dati del tuo applicativo verso Ando e renderli interrogabili."
msgstr "Registra il primo per spingere i dati del tuo applicativo verso Ando e renderli interrogabili."

#: src/features/console/pages/DevelopersPage.tsx:135
msgid "Registra il server nel file di configurazione MCP di Cursor."
msgstr "Registra il server nel file di configurazione MCP di Cursor."

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:184
msgid "Registra incasso"
msgstr "Registra incasso"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:429
msgid "Registra issuer"
msgstr "Registra issuer"

#: src/features/console/docs/content.ts:1504
msgid "Registra la tua app e l'URL di ritorno, poi crea una AppKey app_user_server con sources:manage e query:read. Dal tuo server invia l'ID stabile dell'utente autenticato: ogni persona autorizza il proprio account Gmail, Outlook, Drive, OneDrive o Teams (chat in sola lettura). La AppKey resta sul server e ogni dato in TRAMA resta isolato per app e utente. OIDC verificato è disponibile come modalità avanzata."
msgstr "Registra la tua app e l'URL di ritorno, poi crea una AppKey app_user_server con sources:manage e query:read. Dal tuo server invia l'ID stabile dell'utente autenticato: ogni persona autorizza il proprio account Gmail, Outlook, Drive, OneDrive o Teams (chat in sola lettura). La AppKey resta sul server e ogni dato in TRAMA resta isolato per app e utente. OIDC verificato è disponibile come modalità avanzata."

#: src/features/console/docs/content.ts:1867
msgid "Registra lo slug (POST /connectors)."
msgstr "Registra lo slug (POST /connectors)."

#: ../../packages/ui/src/ando/actions/FicPaymentPreview.tsx:183
msgid "Registra pagamento"
msgstr "Registra pagamento"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:401
msgid "Registra prima il tuo provider OIDC"
msgstr "Registra prima il tuo provider OIDC"

#: src/features/console/docs/content.ts:594
msgid "Registra un connettore"
msgstr "Registra un connettore"

#: src/features/console/docs/content.ts:586
msgid "Registra un connettore e spingi record: la piattaforma fa chunking, embeddings, ACL, versioning e fusion. Il dev emette solo record. mode=full attiva il mark-and-sweep al complete. GET /connectors/kinds indica disponibilità e contratto dei kind: push e manifest disponibili, code non ancora attivabile."
msgstr "Registra un connettore e spingi record: la piattaforma fa chunking, embeddings, ACL, versioning e fusion. Il dev emette solo record. mode=full attiva il mark-and-sweep al complete. GET /connectors/kinds indica disponibilità e contratto dei kind: push e manifest disponibili, code non ancora attivabile."

#: src/features/console/docs/content.ts:609
msgid "Registra un connettore manifest"
msgstr "Registra un connettore manifest"

#: src/features/console/docs/content.ts:856
msgid "Registra un endpoint"
msgstr "Registra un endpoint"

#: src/features/console/webhooks/WebhooksPanel.tsx:511
msgid "Registra un endpoint HTTPS del tuo applicativo per ricevere eventi firmati — incluso action.requested, necessario per eseguire le azioni."
msgstr "Registra un endpoint HTTPS del tuo applicativo per ricevere eventi firmati — incluso action.requested, necessario per eseguire le azioni."

#: src/features/console/webhooks/WebhooksPanel.tsx:285
msgid "Registra un endpoint HTTPS del tuo applicativo: Ando vi consegna eventi firmati (Standard Webhooks) con retry fino a 24 ore."
msgstr "Registra un endpoint HTTPS del tuo applicativo: Ando vi consegna eventi firmati (Standard Webhooks) con retry fino a 24 ore."

#: src/features/console/connectors/TestConnectorActionModal.tsx:223
msgid "Registra un webhook per action.requested"
msgstr "Registra un webhook per action.requested"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:380
#: src/features/console/pages/EmbeddedIdentityPage.tsx:451
msgid "Registra URL"
msgstr "Registra URL"

#: src/features/console/webhooks/WebhooksPanel.tsx:299
msgid "Registra webhook"
msgstr "Registra webhook"

#. placeholder {0}: formatInt(recorded)
#. placeholder {1}: formatInt(google)
#: src/features/admin/components/AdminCostTracking.tsx:84
msgid "registrati {0} / Google {1}"
msgstr "registrati {0} / Google {1}"

#: src/features/console/traces/TraceGraph.tsx:35
msgid "Registrato"
msgstr "Registrato"

#: src/features/chat/hooks/useAudioRecorder.ts:80
#: src/features/chat/hooks/useAudioRecorder.ts:145
msgid "Registrazione non supportata su questo browser."
msgstr "Registrazione non supportata su questo browser."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:464
msgid "Registrazione WhatsApp non riuscita"
msgstr "Registrazione WhatsApp non riuscita"

#: src/features/console/traces/TraceGraph.tsx:399
msgid "Registri tecnici, tempi e legenda"
msgstr "Registri tecnici, tempi e legenda"

#: src/features/console/traces/TraceGraph.tsx:55
msgid "Registro tecnico"
msgstr "Registro tecnico"

#: src/features/admin/components/AdminPlatformSettings.tsx:983
msgid "Registry modelli"
msgstr "Registry modelli"

#: src/features/console/pages/ResourceAccessPage.tsx:464
msgid "Regola"
msgstr "Regola"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:188
msgid "Regole di progettazione"
msgstr "Regole di progettazione"

#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:430
msgid "Regole di progettazione (Excel/PDF/Word)"
msgstr "Regole di progettazione (Excel/PDF/Word)"

#: src/features/workspace/config.ts:400
#: src/routes/_authed/workspace/technical.tsx:251
msgid "Regole progettazione"
msgstr "Regole progettazione"

#: src/routes/login.tsx:65
msgid "Reindirizzamento al login…"
msgstr "Reindirizzamento al login…"

#: src/features/console/pages/MembersPage.tsx:657
msgid "Reinvia"
msgstr "Reinvia"

#: src/features/auth/desktop/DesktopLoginForm.tsx:952
msgid "Reinvia codice"
msgstr "Reinvia codice"

#: src/features/admin/components/AdminDemoInviti.tsx:297
msgid "Reinvia email"
msgstr "Reinvia email"

#: src/features/admin/components/userAdminActions.tsx:184
#: src/features/admin/components/UserDetailContent.tsx:669
msgid "Reinvia email di verifica"
msgstr "Reinvia email di verifica"

#: src/features/admin/components/AdminUsers.tsx:358
msgid "Reinvia invito"
msgstr "Reinvia invito"

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:340
msgid "Reinvia invito a {0}"
msgstr "Reinvia invito a {0}"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:103
msgid "Reinvio fallito"
msgstr "Reinvio fallito"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:410
msgid "Relativo alla base del tuo sistema, deve iniziare con «/»."
msgstr "Relativo alla base del tuo sistema, deve iniziare con «/»."

#: src/features/projects/components/sections/MemorySection.tsx:57
msgid "Relazione"
msgstr "Relazione"

#: src/features/structured-data/components/SimilarPartsSection.tsx:104
msgid "Render isometrico singolo"
msgstr "Render isometrico singolo"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:818
msgid "Rendering deck…"
msgstr "Rendering deck…"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:61
msgid "Rendi il tono più formale e professionale."
msgstr "Rendi il tono più formale e professionale."

#: src/features/skills/components/SkillsList.tsx:449
msgid "Rendi predefinita del team"
msgstr "Rendi predefinita del team"

#: src/features/skills/components/SkillsList.tsx:458
msgid "Rendi privata"
msgstr "Rendi privata"

#: src/routes/_authed/workspace/flows.index.tsx:446
msgid "Rendi privato"
msgstr "Rendi privato"

#: src/features/report/components/ReportViewer.tsx:134
#: src/features/report/components/ReportViewer.tsx:138
#: src/features/voice_report/components/VoiceReportDetailPage.tsx:205
#: src/routes/_authed/workspace/dashboard.tsx:124
#: src/routes/_authed/workspace/dashboard.tsx:378
#: src/routes/_authed/workspace/dashboard.tsx:382
#: src/routes/_authed/workspace/dashboard.tsx:657
msgid "Report"
msgstr "Report"

#: src/features/connectors/wizards/crmSpec.tsx:109
msgid "Report al volo"
msgstr "Report al volo"

#: src/routes/_authed/workspace/reports/index.tsx:59
msgid "Report citation-grounded che sintetizzano l'opinione di clienti, prospect o utenti a partire dalla tua knowledge."
msgstr "Report citation-grounded che sintetizzano l'opinione di clienti, prospect o utenti a partire dalla tua knowledge."

#: src/routes/public.voice-report.$token.tsx:103
msgid "Report condiviso — Ando"
msgstr "Report condiviso — Ando"

#: src/features/voice_report/components/NewReportDialog.tsx:508
msgid "Report creato. Avvia la prima generazione dal pulsante Esegui."
msgstr "Report creato. Avvia la prima generazione dal pulsante Esegui."

#: src/routes/_authed/workspace/dashboard.tsx:611
msgid "Report importati"
msgstr "Report importati"

#: ../../packages/ui/src/ando/sources/db-row/DBActions.tsx:17
msgid "Rerun query"
msgstr "Rerun query"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:238
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:525
#: src/features/admin/components/orgs/OrgBrandingTab.tsx:198
#: src/features/admin/components/orgs/OrgBrandingTab.tsx:368
#: src/features/dashboard/components/ChartTimeRangePanel.tsx:430
msgid "Reset"
msgstr "Reset"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:363
msgid "Reset branding?"
msgstr "Reset branding?"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:155
msgid "Reset fallito"
msgstr "Reset fallito"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:379
msgid "Reset filtri"
msgstr "Reset filtri"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:368
msgid "Reset…"
msgstr "Reset…"

#: src/features/admin/components/userAdminActions.tsx:187
#: src/features/admin/components/UserDetailContent.tsx:651
msgid "Resetta sessioni"
msgstr "Resetta sessioni"

#: src/features/hive-flows/components/FlowShareControl.tsx:56
#: src/routes/_authed/workspace/flows.index.tsx:188
msgid "Reso privato"
msgstr "Reso privato"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:151
msgid "Respinto"
msgstr "Respinto"

#: src/features/connectors/wizards/filesystemSpec.tsx:122
msgid "Resta sincronizzata"
msgstr "Resta sincronizzata"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:137
msgid "Restano intatte solo le descrizioni modificate a mano da una persona"
msgstr "Restano intatte solo le descrizioni modificate a mano da una persona"

#: src/features/console/docs/content.ts:920
msgid "Restituisce 202 con generation_id e document_id."
msgstr "Restituisce 202 con generation_id e document_id."

#: src/features/console/docs/content.ts:1589
msgid "Restituisce al massimo cinque metadati dell'account dell'utente verificato. Non avvia la sincronizzazione né rende i contenuti cercabili."
msgstr "Restituisce al massimo cinque metadati dell'account dell'utente verificato. Non avvia la sincronizzazione né rende i contenuti cercabili."

#: src/features/console/docs/content.ts:1420
msgid "Restituisce il periodo di scansione di email o chat Teams: 30 giorni per impostazione iniziale. Per Drive il periodo non si applica."
msgstr "Restituisce il periodo di scansione di email o chat Teams: 30 giorni per impostazione iniziale. Per Drive il periodo non si applica."

#: src/features/console/docs/content.ts:1486
msgid "Restituisce risultati indicizzati solo dagli account privati del membro Console autenticato."
msgstr "Restituisce risultati indicizzati solo dagli account privati del membro Console autenticato."

#: src/features/console/pages/PlaygroundPage.tsx:2021
msgid "Restituisce solo i passaggi rilevanti."
msgstr "Restituisce solo i passaggi rilevanti."

#: src/features/console/docs/content.ts:1539
msgid "Restituisce solo le connessioni dell'utente corrente della tua app."
msgstr "Restituisce solo le connessioni dell'utente corrente della tua app."

#: src/features/console/docs/content.ts:1415
msgid "Restituisce un'anteprima limitata dell'account collegato, prima o dopo la sincronizzazione."
msgstr "Restituisce un'anteprima limitata dell'account collegato, prima o dopo la sincronizzazione."

#: src/features/dashboard/utils/calculatedFields.ts:71
msgid "Resto (%)"
msgstr "Resto (%)"

#: src/features/connectors/wizards/legalStorageSpec.tsx:60
msgid "Retention configurabile, esibizione in qualunque momento."
msgstr "Retention configurabile, esibizione in qualunque momento."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:89
msgid "Retention, QBR, upsell"
msgstr "Retention, QBR, upsell"

#: src/features/console/docs/content.ts:330
msgid "Retrieval / answer"
msgstr "Retrieval / answer"

#: src/features/admin/components/AdminPlatformSettings.tsx:918
msgid "Retrieval / RAG"
msgstr "Retrieval / RAG"

#: src/features/console/docs/content.ts:322
msgid "Retrieval sui chunk (/query) e il loop agentico completo con text-to-SQL sulle sources strutturate (/agentic/answer, PREVIEW)."
msgstr "Retrieval sui chunk (/query) e il loop agentico completo con text-to-SQL sulle sources strutturate (/agentic/answer, PREVIEW)."

#: src/features/admin/components/AdminCostTracking.tsx:387
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:118
#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:409
msgid "Retry"
msgstr "Retry"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:114
msgid "Retry avviato"
msgstr "Retry avviato"

#: src/features/console/webhooks/WebhooksPanel.tsx:132
msgid "Retry immediato verso il tuo endpoint, con una firma fresca."
msgstr "Retry immediato verso il tuo endpoint, con una firma fresca."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1979
msgid "Rettangolo"
msgstr "Rettangolo"

#: src/routes/_authed/_modal/admin/route.tsx:129
msgid "Revenue"
msgstr "Revenue"

#: src/features/admin/components/AdminRevenue.tsx:64
msgid "Revenue dashboard"
msgstr "Revenue dashboard"

#: src/features/admin/components/AdminRevenue.tsx:240
msgid "Revenue per tier"
msgstr "Revenue per tier"

#: src/features/report/lib/useReportLifecycle.ts:79
msgid "Revisionato"
msgstr "Revisionato"

#: src/features/sources/components/AISummaryPanel.tsx:859
#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:40
msgid "Revisione"
msgstr "Revisione"

#. placeholder {0}: v.version_number
#: src/routes/_authed/workspace/technical.tsx:660
msgid "Revisione #{0}"
msgstr "Revisione #{0}"

#: src/features/sources/components/ArtifactPane.tsx:2107
msgid "Revisione documento"
msgstr "Revisione documento"

#: src/features/actions/components/MessageActionChips.tsx:129
msgid "Revisione in corso"
msgstr "Revisione in corso"

#: src/features/admin/components/AdminCpq.tsx:437
msgid "Revisione non riuscita"
msgstr "Revisione non riuscita"

#: src/features/dxf/components/DxfEmptyHero.tsx:72
#: src/features/sources/components/AISummaryPanel.tsx:479
msgid "Revisioni"
msgstr "Revisioni"

#: src/features/admin/components/AdminDecks.tsx:787
#: src/features/admin/components/AdminDemoInviti.tsx:320
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:399
#: src/features/connect/components/MemberManager.tsx:162
#: src/features/console/pages/EmbeddedIdentityPage.tsx:488
#: src/features/console/pages/KeyDetailPage.tsx:610
#: src/features/console/pages/KeysPage.tsx:242
#: src/features/console/pages/MembersPage.tsx:664
#: src/features/console/pages/MembersPage.tsx:740
#: src/features/settings/components/SecuritySettings.tsx:358
#: src/features/settings/components/SecuritySettings.tsx:361
#: src/features/share/components/ShareLinkRow.tsx:201
#: src/features/voice_report/components/ShareReportDialog.tsx:414
msgid "Revoca"
msgstr "Revoca"

#: src/features/connect/components/MemberManager.tsx:229
msgid "Revoca accesso"
msgstr "Revoca accesso"

#: src/features/console/pages/KeyDetailPage.tsx:726
#: src/features/console/pages/KeysPage.tsx:284
msgid "Revoca definitivamente"
msgstr "Revoca definitivamente"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:121
msgid "Revoca fallita"
msgstr "Revoca fallita"

#: src/features/console/docs/content.ts:1566
msgid "Revoca il grant della tua app"
msgstr "Revoca il grant della tua app"

#: src/features/console/docs/content.ts:1567
msgid "Revoca il grant personale e cancella i token cifrati di questa connessione. Non modifica connessioni Console o Workspace."
msgstr "Revoca il grant personale e cancella i token cifrati di questa connessione. Non modifica connessioni Console o Workspace."

#: src/features/console/docs/content.ts:1840
msgid "Revoca immediata (scope keys:manage)."
msgstr "Revoca immediata (scope keys:manage)."

#: src/features/console/docs/content.ts:313
msgid "Revoca immediata; una chiave revocata risponde revoked_api_key."
msgstr "Revoca immediata; una chiave revocata risponde revoked_api_key."

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:361
msgid "Revoca invito a {0}"
msgstr "Revoca invito a {0}"

#: src/features/console/docs/content.ts:1495
msgid "Revoca la connessione privata e l'accesso ai suoi dati indicizzati."
msgstr "Revoca la connessione privata e l'accesso ai suoi dati indicizzati."

#: src/features/admin/components/AdminCpq.tsx:542
msgid "Revoca link"
msgstr "Revoca link"

#: src/features/admin/components/AdminCpq.tsx:448
msgid "Revoca non riuscita"
msgstr "Revoca non riuscita"

#: src/features/console/docs/content.ts:1362
msgid "Revoca permanente: blocca l'identità, invalida le credenziali e rimuove i chunk personali. Il medesimo ID non viene riattivato automaticamente."
msgstr "Revoca permanente: blocca l'identità, invalida le credenziali e rimuove i chunk personali. Il medesimo ID non viene riattivato automaticamente."

#: src/features/voice_report/components/ShareReportDialog.tsx:405
msgid "Revoca questo link"
msgstr "Revoca questo link"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:202
msgid "Revoca selezionati"
msgstr "Revoca selezionati"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:416
msgid "Revoca tutti"
msgstr "Revoca tutti"

#: src/features/console/docs/content.ts:1361
msgid "Revoca un utente dell'app"
msgstr "Revoca un utente dell'app"

#: src/features/console/docs/content.ts:312
msgid "Revoca una chiave"
msgstr "Revoca una chiave"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:399
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:416
msgid "Revoca…"
msgstr "Revoca…"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:408
msgid "Revocare gli inviti selezionati?"
msgstr "Revocare gli inviti selezionati?"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:388
msgid "Revocare invito?"
msgstr "Revocare invito?"

#: src/features/connect/components/MemberManager.tsx:155
msgid "Revocare l'accesso?"
msgstr "Revocare l'accesso?"

#: src/features/console/pages/MembersPage.tsx:719
msgid "Revocare l'invito?"
msgstr "Revocare l'invito?"

#. placeholder {0}: revokeTarget.email
#: src/features/console/pages/MembersPage.tsx:722
msgid "Revocare l'invito? Il link in {0} smetterà di funzionare."
msgstr "Revocare l'invito? Il link in {0} smetterà di funzionare."

#: src/features/console/pages/KeyDetailPage.tsx:707
#: src/features/console/pages/KeysPage.tsx:263
msgid "Revocare la chiave?"
msgstr "Revocare la chiave?"

#: src/features/console/components/KeyMeta.tsx:36
#: src/features/console/components/KeyMeta.tsx:177
msgid "Revocata"
msgstr "Revocata"

#: src/features/console/pages/KeyDetailPage.tsx:693
msgid "Revocata il"
msgstr "Revocata il"

#: src/features/admin/components/AdminGatedLinks.tsx:294
msgid "revocato"
msgstr "revocato"

#: src/features/admin/components/AdminCpq.tsx:470
#: src/features/admin/components/AdminCpqList.tsx:69
#: src/features/admin/components/AdminDemoInviti.tsx:45
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/share/components/ShareLinkRow.tsx:171
msgid "Revocato"
msgstr "Revocato"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:242
#: src/features/dashboard/components/ChartSqlEditor.tsx:163
msgid "Ri-esegui"
msgstr "Ri-esegui"

#: src/features/sync/components/DocSyncManager.tsx:875
msgid "Ri-sincronizza"
msgstr "Ri-sincronizza"

#: src/features/sync/components/DocSyncManager.tsx:552
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:259
msgid "Ri-sincronizzazione completa avviata"
msgstr "Ri-sincronizzazione completa avviata"

#. placeholder {0}: task.title
#: src/features/workspace/components/TaskSimpleRow.tsx:216
msgid "Riapri {0}"
msgstr "Riapri {0}"

#. placeholder {0}: task.title
#: src/features/projects/components/sections/TasksSection.tsx:123
msgid "Riapri attività: {0}"
msgstr "Riapri attività: {0}"

#: ../../packages/ui/src/ando/sources/pdf/PDFActions.tsx:36
msgid "Riassumi"
msgstr "Riassumi"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:210
msgid "Riassumi cosa rappresenta questa connessione perché l'agente possa interpretarla correttamente."
msgstr "Riassumi cosa rappresenta questa connessione perché l'agente possa interpretarla correttamente."

#: src/features/chat/components/ChatEmptyState.tsx:113
msgid "Riassumi email urgenti"
msgstr "Riassumi email urgenti"

#. placeholder {0}: item.subject
#: src/features/sources/components/InboxDetailPane.tsx:365
msgid "Riassumi il thread \"{0}\""
msgstr "Riassumi il thread \"{0}\""

#: src/routes/_authed/route.tsx:1064
msgid "Riassumi la mia settimana: meeting principali, decisioni e prossimi passi."
msgstr "Riassumi la mia settimana: meeting principali, decisioni e prossimi passi."

#: src/routes/_authed/route.tsx:1063
msgid "Riassumi la settimana"
msgstr "Riassumi la settimana"

#: src/features/chat/components/ChatEmptyState.tsx:490
msgid "Riassumi le email che richiedono risposta"
msgstr "Riassumi le email che richiedono risposta"

#: src/features/chat/components/ChatEmptyState.tsx:114
msgid "Riassumi le email non lette urgenti."
msgstr "Riassumi le email non lette urgenti."

#: src/features/chat/components/ChatEmptyState.tsx:262
msgid "Riassumi le note dell'ultimo standup tecnico."
msgstr "Riassumi le note dell'ultimo standup tecnico."

#: src/features/sources/components/CalendarEventPane.tsx:415
msgid "Riassumi le ultime conversazioni con {counterpart}"
msgstr "Riassumi le ultime conversazioni con {counterpart}"

#: ../../packages/ui/src/ando/sources/calendar/EventActions.tsx:25
msgid "Riassumi prep"
msgstr "Riassumi prep"

#: src/features/sources/components/InboxDetailPane.tsx:361
msgid "Riassumi questa email e suggerisci prossimi passi"
msgstr "Riassumi questa email e suggerisci prossimi passi"

#: src/routes/_authed/workspace/calendar.tsx:1450
msgid "Riassunto degli eventi della settimana"
msgstr "Riassunto degli eventi della settimana"

#: src/features/admin/components/AdminDemoInviti.tsx:308
#: src/features/admin/components/AdminOrgs.tsx:1588
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:131
#: src/features/admin/components/orgs/OrgDetailShell.tsx:366
#: src/features/automations/components/AutomationsHub.tsx:393
#: src/features/console/connectors/CustomConnectorDetail.tsx:1017
#: src/features/console/pages/EmbeddedIdentityPage.tsx:435
#: src/features/hive-flows/components/FlowActivateControl.tsx:223
msgid "Riattiva"
msgstr "Riattiva"

#. placeholder {0}: automation.name
#. placeholder {0}: m.email ?? m.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:546
#: src/features/automations/components/AutomationsHub.tsx:391
msgid "Riattiva {0}"
msgstr "Riattiva {0}"

#: src/features/onboarding/OnboardingSettings.tsx:42
msgid "Riattiva gli aiuti delle sezioni"
msgstr "Riattiva gli aiuti delle sezioni"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:547
msgid "Riattiva membro"
msgstr "Riattiva membro"

#: src/features/admin/components/userAdminActions.tsx:198
#: src/features/admin/components/userAdminActions.tsx:359
msgid "Riattiva utente"
msgstr "Riattiva utente"

#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:106
msgid "Riattivando l'organizzazione i membri tornano a poter accedere immediatamente. Nessun dato è stato cancellato durante la disattivazione."
msgstr "Riattivando l'organizzazione i membri tornano a poter accedere immediatamente. Nessun dato è stato cancellato durante la disattivazione."

#. placeholder {0}: org.name
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:98
msgid "Riattivare «{0}»?"
msgstr "Riattivare «{0}»?"

#: src/features/admin/components/AdminOrgs.tsx:485
#: src/features/admin/components/orgs/DeactivateOrgDialog.tsx:77
#: src/features/admin/components/orgs/OrgMembersTab.tsx:200
msgid "Riattivazione fallita"
msgstr "Riattivazione fallita"

#: src/features/settings/components/NotificationPreferences.tsx:296
msgid "Riautentica per gestire le notifiche."
msgstr "Riautentica per gestire le notifiche."

#: src/features/updates/components/UpdateBanner.tsx:212
msgid "Riavvia ora"
msgstr "Riavvia ora"

#: src/features/console/components/ConsoleShell.tsx:825
#: src/features/console/components/CustomTopup.tsx:41
#: src/features/console/pages/UsagePage.tsx:351
#: src/lib/RouteErrorFallback.tsx:31
msgid "Ricarica"
msgstr "Ricarica"

#: src/features/console/pages/BillingPage.tsx:544
msgid "Ricarica crediti"
msgstr "Ricarica crediti"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:299
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:302
msgid "Ricarica credito"
msgstr "Ricarica credito"

#: src/features/console/pages/BillingPage.tsx:508
msgid "Ricarica il saldo prepagato per non interrompere il servizio."
msgstr "Ricarica il saldo prepagato per non interrompere il servizio."

#: src/features/console/pages/UsagePage.tsx:340
msgid "Ricariche e consumi delle tue nuove AppKey incidono su questo saldo."
msgstr "Ricariche e consumi delle tue nuove AppKey incidono su questo saldo."

#: src/features/admin/components/AdminCpqPriceBook.tsx:219
msgid "Ricarico usage (x)"
msgstr "Ricarico usage (x)"

#: src/features/admin/components/AdminCpq.tsx:255
msgid "Ricavo netto nostro"
msgstr "Ricavo netto nostro"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:130
#: src/features/console/pages/PlaygroundPage.tsx:1852
msgid "Ricerca"
msgstr "Ricerca"

#: src/features/sales/components/LeadsPanel.tsx:294
#: src/features/sales/hooks/useProspectingWsBridge.ts:38
msgid "Ricerca approfondita"
msgstr "Ricerca approfondita"

#: src/features/sales/hooks/useSalesQueries.ts:138
msgid "Ricerca approfondita avviata… i lead arrivano fra qualche minuto."
msgstr "Ricerca approfondita avviata… i lead arrivano fra qualche minuto."

#: src/features/sales/hooks/useProspectingWsBridge.ts:62
msgid "Ricerca approfondita non disponibile: ho usato la ricerca veloce. {inserted} nuovi lead."
msgstr "Ricerca approfondita non disponibile: ho usato la ricerca veloce. {inserted} nuovi lead."

#: src/features/sales/components/LeadsPanel.tsx:286
msgid "Ricerca approfondita: più lenta e costosa, trova aziende difficili con contatti di alto livello"
msgstr "Ricerca approfondita: più lenta e costosa, trova aziende difficili con contatti di alto livello"

#: src/features/help/data/changelog.ts:47
msgid "Ricerca CAD spaziale e dati strutturati nel composer"
msgstr "Ricerca CAD spaziale e dati strutturati nel composer"

#: src/features/console/docs/content.ts:1006
msgid "Ricerca capi (fashion)"
msgstr "Ricerca capi (fashion)"

#: src/features/connectors/wizards/messagingSpec.tsx:78
msgid "Ricerca cross-canale"
msgstr "Ricerca cross-canale"

#: src/features/console/docs/content.ts:1007
msgid "Ricerca cross-modale testo→capo (FashionSigLIP) sul corpus CAD. resource_policy.cad_visibility=\"tenant\" allarga lo scope oltre i file della chiave."
msgstr "Ricerca cross-modale testo→capo (FashionSigLIP) sul corpus CAD. resource_policy.cad_visibility=\"tenant\" allarga lo scope oltre i file della chiave."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1504
msgid "Ricerca dei simili"
msgstr "Ricerca dei simili"

#: src/features/console/pages/DocumentsPage.tsx:713
msgid "Ricerca e filtri su tutti i documenti"
msgstr "Ricerca e filtri su tutti i documenti"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:67
msgid "Ricerca e importazione delle trascrizioni in corso."
msgstr "Ricerca e importazione delle trascrizioni in corso."

#: src/features/sales/hooks/useProspectingWsBridge.ts:42
msgid "Ricerca email"
msgstr "Ricerca email"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:137
msgid "Ricerca geometrica"
msgstr "Ricerca geometrica"

#: src/features/sales/components/LeadsPanel.tsx:659
msgid "Ricerca in corso…"
msgstr "Ricerca in corso…"

#: src/features/sales/hooks/useProspectingWsBridge.ts:36
msgid "Ricerca lead"
msgstr "Ricerca lead"

#: src/features/connectors/wizards/crmSpec.tsx:99
#: src/features/connectors/wizards/projectManagementSpec.tsx:65
msgid "Ricerca naturale"
msgstr "Ricerca naturale"

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1507
msgid "Ricerca nella knowledge base"
msgstr "Ricerca nella knowledge base"

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:57
msgid "Ricerca per similarità dal file caricato"
msgstr "Ricerca per similarità dal file caricato"

#: src/features/connectors/wizards/emailSpec.tsx:87
msgid "Ricerca semantica"
msgstr "Ricerca semantica"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:202
#: src/features/chat/hooks/useThinkingHops.ts:45
#: src/features/chat/hooks/useThinkingHops.ts:46
#: src/routes/_authed/route.tsx:1785
msgid "Ricerca web"
msgstr "Ricerca web"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1036
msgid "Ricerca…"
msgstr "Ricerca…"

#: src/features/console/connectors/SourceHealthSummary.tsx:21
msgid "Ricercabilità"
msgstr "Ricercabilità"

#: src/features/share/components/ShareLinkDialog.tsx:840
msgid "Riceve un'email con la scheda e il link. Per aprirlo conferma il suo indirizzo con un codice: se il link gira, non si apre. Revocabile da Condivisioni."
msgstr ""

#: src/features/settings/components/OtpEmailPanel.tsx:284
msgid "Riceverai un codice a 6 cifre a <0>{masked}</0> a ogni accesso."
msgstr "Riceverai un codice a 6 cifre a <0>{masked}</0> a ogni accesso."

#: src/features/settings/components/DataExport.tsx:148
msgid "Riceverai una email quando l'archivio sarà pronto."
msgstr "Riceverai una email quando l'archivio sarà pronto."

#: src/features/settings/components/NotificationPreferences.tsx:421
msgid "Ricevi anche via email i nudge urgenti (default: solo in-app)."
msgstr "Ricevi anche via email i nudge urgenti (default: solo in-app)."

#: src/features/console/webhooks/WebhooksPanel.tsx:491
msgid "Ricevi eventi firmati invece di fare polling — e chiudi il write-loop: le azioni dei connettori personalizzati arrivano al tuo applicativo via<0> action.requested</0>."
msgstr "Ricevi eventi firmati invece di fare polling — e chiudi il write-loop: le azioni dei connettori personalizzati arrivano al tuo applicativo via<0> action.requested</0>."

#: src/features/console/docs/content.ts:848
msgid "Ricevi eventi invece di fare polling: ingestion.completed, source.sync.completed, usage.threshold_reached e action.requested (il write-loop delle azioni dei connettori personalizzati). Payload firmati HMAC-SHA256 (Standard Webhooks), retry con backoff fino a 24h. Gestibili anche dalla console senza chiave: sezione Webhooks della pagina «Il tuo agente» (base sessione /platform/console/v1/webhooks)."
msgstr "Ricevi eventi invece di fare polling: ingestion.completed, source.sync.completed, usage.threshold_reached e action.requested (il write-loop delle azioni dei connettori personalizzati). Payload firmati HMAC-SHA256 (Standard Webhooks), retry con backoff fino a 24h. Gestibili anche dalla console senza chiave: sezione Webhooks della pagina «Il tuo agente» (base sessione /platform/console/v1/webhooks)."

#: src/features/settings/components/ProfileSettings.tsx:155
msgid "Ricevi notifiche via email"
msgstr "Ricevi notifiche via email"

#: src/features/settings/components/OtpEmailPanel.tsx:220
msgid "Ricevi un codice a 6 cifre via email a ogni accesso. Utile come secondo fattore alternativo all'app di autenticazione."
msgstr "Ricevi un codice a 6 cifre via email a ogni accesso. Utile come secondo fattore alternativo all'app di autenticazione."

#: src/features/share/components/ShareLinkDialog.tsx:771
msgid "Ricevono una notifica, la trovano in Condivisioni e possono continuare la conversazione nel loro workspace."
msgstr ""

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:176
msgid "Ricevuta"
msgstr "Ricevuta"

#: src/routes/_authed/workspace/shares.tsx:113
msgid "ricevute"
msgstr "ricevute"

#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:69
#: src/routes/_authed/workspace/shares.tsx:126
#: src/routes/_authed/workspace/shares.tsx:175
msgid "Ricevute"
msgstr "Ricevute"

#: src/features/chat/components/ChatEmptyState.tsx:393
msgid "Ricevute di recente"
msgstr ""

#: src/features/connectors/wizards/pecSpec.tsx:56
msgid "Ricevute valide"
msgstr "Ricevute valide"

#: src/features/connectors/wizards/pecSpec.tsx:52
msgid "Ricevute, originali e firmati pronti per ricerca naturale."
msgstr "Ricevute, originali e firmati pronti per ricerca naturale."

#: src/features/workspace/documents/components/SmartSourceChips.tsx:57
msgid "Ricevuti"
msgstr "Ricevuti"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:47
msgid "richiede conferma"
msgstr "richiede conferma"

#: src/routes/_authed/workspace/finance.tsx:424
#: src/routes/_authed/workspace/finance.tsx:437
msgid "richiede Fatture in Cloud"
msgstr "richiede Fatture in Cloud"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:91
#: src/features/connectors/wizards/spreadsheetSpec.tsx:151
msgid "Richiede Google Drive collegato"
msgstr "Richiede Google Drive collegato"

#: src/features/admin/components/AdminCostTracking.tsx:114
msgid "Richiede l'accesso a Cloud Monitoring (in produzione via Workload Identity)."
msgstr "Richiede l'accesso a Cloud Monitoring (in produzione via Workload Identity)."

#: src/features/connectors/wizards/messagingSpec.tsx:60
msgid "Richiede Meta Embedded Signup + opt-in business"
msgstr "Richiede Meta Embedded Signup + opt-in business"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:97
#: src/features/connectors/wizards/spreadsheetSpec.tsx:157
msgid "Richiede OneDrive collegato"
msgstr "Richiede OneDrive collegato"

#: src/routes/_authed/workspace/finance.tsx:492
msgid "richiede open banking"
msgstr "richiede open banking"

#: src/features/workspace/inbox/utils/inboxSmartViews.ts:66
msgid "Richiede risposta"
msgstr "Richiede risposta"

#: src/routes/_authed/workspace/finance.tsx:459
msgid "richiede Salesforce"
msgstr "richiede Salesforce"

#: src/features/admin/components/ZitadelPasswordActions.tsx:263
msgid "Richiedi cambio al prossimo accesso"
msgstr "Richiedi cambio al prossimo accesso"

#: src/features/admin/components/ZitadelPasswordActions.tsx:268
msgid "Richiedi cambio password al prossimo accesso"
msgstr "Richiedi cambio password al prossimo accesso"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:224
msgid "Richiedi provisioning"
msgstr "Richiedi provisioning"

#: src/features/console/pages/DocsPage.tsx:134
msgid "Richiesta"
msgstr "Richiesta"

#: src/features/console/pages/PlaygroundPage.tsx:1749
msgid "Richiesta annullata"
msgstr "Richiesta annullata"

#: src/features/console/pages/PlaygroundPage.tsx:2088
msgid "Richiesta eseguita"
msgstr "Richiesta eseguita"

#: src/features/settings/components/SelfProfileMemory.tsx:672
msgid "Richiesta inviata."
msgstr "Richiesta inviata."

#: src/features/admin/components/AdminCpqAskAndo.tsx:352
msgid "Richiesta per Ando"
msgstr "Richiesta per Ando"

#. placeholder {0}: new Date(job.requested_at).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", })
#: src/features/settings/components/DataExport.tsx:256
msgid "Richiesta: {0}"
msgstr "Richiesta: {0}"

#: src/features/console/pages/UsagePage.tsx:255
msgid "richieste"
msgstr "richieste"

#: src/features/admin/components/AdminHealth.tsx:142
#: src/features/console/pages/UsagePage.tsx:391
#: src/features/console/pages/UsagePage.tsx:528
msgid "Richieste"
msgstr "Richieste"

#: src/features/console/pages/UsagePage.tsx:401
msgid "Richieste ({windowDays}g)"
msgstr "Richieste ({windowDays}g)"

#: src/features/console/pages/UsagePage.tsx:386
msgid "Richieste al giorno"
msgstr "Richieste al giorno"

#: src/features/console/pages/LimitsPage.tsx:53
msgid "Richieste al minuto"
msgstr "Richieste al minuto"

#: src/features/console/components/ConsoleShell.tsx:247
#: src/features/console/pages/TracesPage.tsx:493
msgid "Richieste e trace"
msgstr "Richieste e trace"

#: src/features/console/pages/TracesPage.tsx:530
msgid "Richieste recenti"
msgstr "Richieste recenti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
msgid "Ricollega"
msgstr "Ricollega"

#: src/features/console/connectors/PersonalConnectionSync.tsx:387
msgid "Ricollega account"
msgstr "Ricollega account"

#: src/features/console/docs/content.ts:1178
msgid "Ricollega il principal manifest"
msgstr "Ricollega il principal manifest"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:371
msgid "Ricomincia da capo"
msgstr "Ricomincia da capo"

#. placeholder {0}: formatter.format(target)
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:553
msgid "Ricomparirà {0}"
msgstr "Ricomparirà {0}"

#: src/features/connectors/wizards/openBankingSpec.tsx:202
msgid "Riconciliazione automatica"
msgstr "Riconciliazione automatica"

#: src/features/admin/components/AdminCostTracking.tsx:101
msgid "Riconciliazione con Google"
msgstr "Riconciliazione con Google"

#: src/features/admin/components/AdminCostTracking.tsx:112
msgid "Riconciliazione non disponibile"
msgstr "Riconciliazione non disponibile"

#. placeholder {0}: humanizeError(err)
#: src/routes/_authed/_modal/integrations/$capability.tsx:613
msgid "Riconnessione fallita: {0}"
msgstr "Riconnessione fallita: {0}"

#: src/features/connectors/components/ConnectorStatus.tsx:117
#: src/features/connectors/components/ConnectorStatus.tsx:237
msgid "Riconnessione richiesta"
msgstr "Riconnessione richiesta"

#: src/features/connectors/components/ConnectedAccountRow.tsx:424
#: src/features/connectors/components/ConnectedAccountRow.tsx:485
#: src/features/connectors/components/ConnectedAccountRow.tsx:515
#: src/features/console/connectors/ConnectionCard.tsx:234
#: src/features/sales/components/BatchSendModal.tsx:276
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:144
#: src/routes/_authed/_modal/integrations/index.tsx:448
#: src/routes/_authed/_modal/integrations/index.tsx:530
msgid "Riconnetti"
msgstr "Riconnetti"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:277
msgid "Riconnetti {accountLabel}"
msgstr "Riconnetti {accountLabel}"

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:277
msgid "Riconnetti l'account"
msgstr "Riconnetti l'account"

#: src/features/console/components/CreateKeyWizard.tsx:276
msgid "Riconosci la chiave e scegli dove potrà essere utilizzata."
msgstr "Riconosci la chiave e scegli dove potrà essere utilizzata."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:257
msgid "Ricontrolla la modalità di connessione WhatsApp"
msgstr "Ricontrolla la modalità di connessione WhatsApp"

#: ../../packages/ui/src/ando/email/SendControl.tsx:184
msgid "Ricordami se non rispondono"
msgstr "Ricordami se non rispondono"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:125
msgid "Ricorrente"
msgstr "Ricorrente"

#: src/features/admin/components/AdminCpq.tsx:161
msgid "Ricorrente annuo a listino, a regime"
msgstr "Ricorrente annuo a listino, a regime"

#: src/features/chat/components/SplitDragHandle.tsx:141
msgid "Ridimensiona chat e workspace"
msgstr "Ridimensiona chat e workspace"

#: src/features/connectors/components/management/SchemaViewer.tsx:781
msgid "Ridimensiona colonna {c}"
msgstr "Ridimensiona colonna {c}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:390
msgid "Riduci"
msgstr "Riduci"

#: src/features/dxf/components/DxfPreviewStage.tsx:365
msgid "Riduci anteprima"
msgstr "Riduci anteprima"

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:119
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:343
msgid "Riduci zoom"
msgstr "Riduci zoom"

#: src/features/help/components/ShortcutsList.tsx:147
msgid "Riduci zoom nel viewer PDF"
msgstr "Riduci zoom nel viewer PDF"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1830
msgid "Riempimento"
msgstr "Riempimento"

#: src/features/chat/components/ChatEmptyState.tsx:184
msgid "Riepiloga le spese della settimana scorsa per categoria."
msgstr "Riepiloga le spese della settimana scorsa per categoria."

#: src/features/admin/components/AdminCpqCanvas.tsx:159
#: src/features/console/pages/BillingPage.tsx:232
msgid "Riepilogo"
msgstr "Riepilogo"

#: src/features/briefing/BriefAggregate.tsx:170
msgid "Riepilogo AI"
msgstr "Riepilogo AI"

#: src/features/chat/components/ChatEmptyState.tsx:165
msgid "Riepilogo cashflow"
msgstr "Riepilogo cashflow"

#: src/features/chat/components/ChatEmptyState.tsx:166
msgid "Riepilogo cashflow del trimestre corrente."
msgstr "Riepilogo cashflow del trimestre corrente."

#: src/features/connectors/wizards/messagingSpec.tsx:83
msgid "Riepilogo conversazioni"
msgstr "Riepilogo conversazioni"

#: src/features/settings/components/SelfProfileMemory.tsx:388
msgid "Riepilogo dei fatti estratti dalle tue conversazioni. Puoi cancellare tutto dal pannello sotto."
msgstr "Riepilogo dei fatti estratti dalle tue conversazioni. Puoi cancellare tutto dal pannello sotto."

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:258
msgid "Riepilogo IVA"
msgstr "Riepilogo IVA"

#: src/features/agent-modes/components/AgentModeEditor.tsx:495
msgid "Riepilogo modifica"
msgstr "Riepilogo modifica"

#: src/features/connectors/wizards/emailSpec.tsx:92
msgid "Riepilogo thread"
msgstr "Riepilogo thread"

#: src/features/console/pages/PlaygroundPage.tsx:1337
msgid "Riesegui questa richiesta"
msgstr "Riesegui questa richiesta"

#. placeholder {0}: item.source_row_ref
#. placeholder {0}: rule.source_row_ref
#: src/features/dfm-rules/components/DfmRulesPage.tsx:540
#: src/features/price-lists/components/PriceListsPage.tsx:679
msgid "Rif. {0}"
msgstr "Rif. {0}"

#: src/features/console/traces/TracePayloadReader.tsx:227
msgid "Riferimenti di navigazione conservati"
msgstr "Riferimenti di navigazione conservati"

#: ../../packages/ui/src/ando/DocumentReviewRenderer.tsx:140
msgid "Riferimenti nel disegno"
msgstr "Riferimenti nel disegno"

#: src/features/admin/components/AdminCpqList.tsx:141
msgid "Riferimento"
msgstr "Riferimento"

#: src/features/console/pages/DocsPage.tsx:484
#: src/features/console/pages/DocsPage.tsx:613
msgid "Riferimento API"
msgstr "Riferimento API"

#: src/features/console/pages/DocsPage.tsx:491
#: src/features/console/pages/DocsPage.tsx:673
msgid "Riferimento SDK"
msgstr "Riferimento SDK"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:96
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:78
#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:275
#: ../../packages/ui/src/editors/AiCellPopover.tsx:148
#: ../../packages/ui/src/editors/DraftActionBar.tsx:288
#: ../../packages/ui/src/editors/ReviewRail.tsx:320
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2722
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:298
#: src/features/sources/components/AISummaryPanel.tsx:637
msgid "Rifiuta"
msgstr "Rifiuta"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:285
msgid "Rifiuta la bozza AI"
msgstr "Rifiuta la bozza AI"

#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:272
msgid "Rifiuta la proposta"
msgstr "Rifiuta la proposta"

#: ../../packages/ui/src/ando/actions/InlineDiffPreview.tsx:261
#: ../../packages/ui/src/editors/ReviewRail.tsx:426
#: src/features/sources/components/AISummaryPanel.tsx:780
msgid "Rifiuta modifica"
msgstr "Rifiuta modifica"

#: src/features/actions/components/ActionFormSurface.tsx:178
msgid "Rifiuta proposta"
msgstr "Rifiuta proposta"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:216
#: ../../packages/ui/src/editors/ReviewRail.tsx:309
#: ../../packages/ui/src/editors/ReviewRail.tsx:310
#: src/features/sources/components/AISummaryPanel.tsx:559
msgid "Rifiuta tutte"
msgstr "Rifiuta tutte"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2731
msgid "Rifiuta tutto"
msgstr "Rifiuta tutto"

#: src/features/sources/components/AISummaryPanel.tsx:611
msgid "Rifiutare tutte le {count} modifiche?"
msgstr "Rifiutare tutte le {count} modifiche?"

#: ../../packages/ui/src/editors/ReviewRail.tsx:389
#: src/features/hive-flows/run/RunHistoryRail.tsx:59
msgid "Rifiutata"
msgstr "Rifiutata"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:67
#: src/features/console/connectors/CustomConnectorDetail.tsx:148
msgid "Rifiutati"
msgstr "Rifiutati"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:76
msgid "Rifiutato"
msgstr "Rifiutato"

#: src/features/console/flows/ConsoleFlowApprovals.tsx:43
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:51
msgid "Rifiutato: l'esecuzione non riprenderà"
msgstr "Rifiutato: l'esecuzione non riprenderà"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:317
msgid "Rifiuto della bozza in corso"
msgstr "Rifiuto della bozza in corso"

#. placeholder {0}: err.message
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:587
msgid "Rifiuto fallito: {0}"
msgstr "Rifiuto fallito: {0}"

#: src/features/sources/components/ArtifactPane.tsx:1242
msgid "Rifiuto fallito: {reason}"
msgstr "Rifiuto fallito: {reason}"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:588
msgid "Rifiuto fallito."
msgstr "Rifiuto fallito."

#: src/features/console/flows/ConsoleFlowApprovals.tsx:44
#: src/features/hive-flows/components/PendingApprovalsBanner.tsx:52
msgid "Rifiuto non riuscito"
msgstr "Rifiuto non riuscito"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:158
#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:173
msgid "Riformula con Ando"
msgstr "Riformula con Ando"

#. placeholder {0}: selectionEnd - selectionStart
#: ../../packages/ui/src/ando/actions/InlineAIRefiner.tsx:386
msgid "Riformula solo la selezione ({0} caratteri)."
msgstr "Riformula solo la selezione ({0} caratteri)."

#. placeholder {0}: value.length
#: ../../packages/ui/src/ando/actions/InlineAIRefiner.tsx:385
msgid "Riformula tutto il testo ({0} caratteri)."
msgstr "Riformula tutto il testo ({0} caratteri)."

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:173
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:194
msgid "riga"
msgstr "riga"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:853
#: src/features/connectors/components/management/BusinessContextEditor.tsx:214
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:295
msgid "Rigenera"
msgstr "Rigenera"

#: src/features/sources/components/CalendarEventPane.tsx:565
#: src/features/sources/components/CalendarEventPane.tsx:566
msgid "Rigenera briefing"
msgstr "Rigenera briefing"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:289
#: src/features/connectors/components/management/BusinessContextEditor.tsx:193
msgid "Rigenera con AI"
msgstr "Rigenera con AI"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:288
msgid "Rigenera il canvas"
msgstr "Rigenera il canvas"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:618
#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:626
msgid "Rigenera immagini"
msgstr "Rigenera immagini"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:630
msgid "Rigenera la prima illustrazione AI del deck"
msgstr "Rigenera la prima illustrazione AI del deck"

#: src/features/connectors/components/management/BusinessContextEditor.tsx:198
msgid "Rigenerare il contesto?"
msgstr "Rigenerare il contesto?"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:90
#: src/features/connectors/components/management/DiscoveryDialog.tsx:99
msgid "Rigenerare tutto lo schema?"
msgstr "Rigenerare tutto lo schema?"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:181
#: src/features/connectors/components/management/BusinessContextEditor.tsx:106
msgid "Rigenerazione non riuscita."
msgstr "Rigenerazione non riuscita."

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:853
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:295
msgid "Rigenero…"
msgstr "Rigenero…"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:426
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:479
msgid "Rigetta"
msgstr "Rigetta"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:143
#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:150
msgid "Rigetta DRAFT"
msgstr "Rigetta DRAFT"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:71
msgid "Rigettati"
msgstr "Rigettati"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:173
#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:194
#: src/features/console/connectors/ConnectionCard.tsx:335
#: src/features/structured-data/components/StructuredDataCard.tsx:75
msgid "righe"
msgstr "righe"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:200
#: src/features/console/connectors/ConnectionCard.tsx:256
#: src/features/console/pages/PlaygroundPage.tsx:888
msgid "Righe"
msgstr "Righe"

#: src/features/admin/components/orgs/_shared.tsx:204
msgid "Righe per pagina"
msgstr "Righe per pagina"

#. placeholder {0}: display.row_count
#. placeholder {1}: presentation.rows.length
#: src/features/structured-data/components/TemporalPresentationNotice.tsx:10
msgid "Righe restituite: {0}. Periodi visualizzati: {1}. I periodi senza righe restituite sono indicati con —, non con zero."
msgstr "Righe restituite: {0}. Periodi visualizzati: {1}. I periodi senza righe restituite sono indicati con —, non con zero."

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:432
msgid "righe validate"
msgstr "righe validate"

#: src/features/hive-flows/run/PdfDropzone.tsx:245
msgid "Rilascia il documento per avviare"
msgstr "Rilascia il documento per avviare"

#: src/features/price-lists/components/PriceListsPage.tsx:123
msgid "Rilascia il listino qui — Excel · PDF · Word"
msgstr "Rilascia il listino qui — Excel · PDF · Word"

#: src/features/hive-flows/run/PdfDropzone.tsx:244
msgid "Rilascia il PDF per avviare"
msgstr "Rilascia il PDF per avviare"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:143
msgid "Rilascia la checklist qui — Excel · PDF · Word"
msgstr "Rilascia la checklist qui — Excel · PDF · Word"

#: src/features/hive-flows/run/PdfDropzone.tsx:242
msgid "Rilascia per aggiungere alla coda"
msgstr "Rilascia per aggiungere alla coda"

#: src/features/chat/wsHandlers.ts:476
msgid "Rileggo la conversazione…"
msgstr "Rileggo la conversazione…"

#: src/features/console/connectors/ConnectionCard.tsx:378
msgid "Rileva di nuovo tabelle, viste e colonne della sorgente."
msgstr "Rileva di nuovo tabelle, viste e colonne della sorgente."

#: src/features/console/connectors/ConnectionCard.tsx:386
msgid "Rileva struttura"
msgstr "Rileva struttura"

#: src/features/console/connectors/ConnectionCard.tsx:379
msgid "Rileva tabelle, viste e colonne disponibili nella sorgente."
msgstr "Rileva tabelle, viste e colonne disponibili nella sorgente."

#: src/features/console/pages/ConnectorDetailPage.tsx:195
msgid "Rilevamento della struttura avviato"
msgstr "Rilevamento della struttura avviato"

#: src/features/console/connectors/meta.ts:185
#: src/features/console/connectors/meta.ts:202
msgid "Rilevamento periodico degli schemi e dei dati"
msgstr "Rilevamento periodico degli schemi e dei dati"

#: src/features/console/connectors/meta.ts:219
msgid "Rilevamento periodico dei dati"
msgstr "Rilevamento periodico dei dati"

#: src/features/clean-control/components/EventDetailSheet.tsx:280
msgid "Rilevato"
msgstr "Rilevato"

#: src/features/clean-control/components/EventRow.tsx:272
msgid "rilevato {relDetected} fa"
msgstr "rilevato {relDetected} fa"

#: src/features/workspace/components/TaskSimpleRow.tsx:103
msgid "Rilevato automaticamente da Ando"
msgstr "Rilevato automaticamente da Ando"

#: src/features/clean-control/components/EventDetailSheet.tsx:453
msgid "Rilevatore"
msgstr "Rilevatore"

#: src/features/clean-control/components/EventDetailSheet.tsx:450
msgid "Rilevatore & risorsa"
msgstr "Rilevatore & risorsa"

#: src/features/clean-control/components/EventRow.tsx:523
msgid "Rilevatore:"
msgstr "Rilevatore:"

#: src/features/clean-control/components/EventRow.tsx:307
msgid "Rimanda"
msgstr "Rimanda"

#: src/features/sales/components/leadMeta.ts:31
msgid "Rimbalzato"
msgstr "Rimbalzato"

#: src/features/admin/components/AdminDecksAskAndo.tsx:203
msgid "Rimossa"
msgstr "Rimossa"

#: src/features/console/connectors/CustomConnectorDetail.tsx:145
msgid "Rimossi"
msgstr "Rimossi"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:499
msgid "Rimosso"
msgstr "Rimosso"

#: src/routes/_authed/workspace/documents.tsx:584
msgid "Rimosso dall'indice, dal grafo e dallo storage."
msgstr "Rimosso dall'indice, dal grafo e dallo storage."

#: src/routes/_authed/workspace/documents.tsx:583
msgid "Rimosso dall'indice, dal grafo, dallo storage e dai file sincronizzati."
msgstr "Rimosso dall'indice, dal grafo, dallo storage e dai file sincronizzati."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:181
msgid "Rimozione fallita"
msgstr "Rimozione fallita"

#: src/features/sales/components/CampaignSharing.tsx:227
msgid "Rimozione non riuscita"
msgstr "Rimozione non riuscita"

#: src/features/sync/components/DocSyncManager.tsx:474
msgid "Rimozione non riuscita: {reason}"
msgstr "Rimozione non riuscita: {reason}"

#: src/features/settings/components/OtpEmailPanel.tsx:49
msgid "Rimozione non riuscita. Riprova."
msgstr "Rimozione non riuscita. Riprova."

#: src/features/admin/components/orgs/OrgMembersTab.tsx:600
#: src/features/admin/components/orgs/OrgSSOTab.tsx:369
#: src/features/settings/components/OrgMembersPanel.tsx:688
#: src/features/settings/components/OtpEmailPanel.tsx:352
#: src/features/settings/components/SecuritySettings.tsx:215
msgid "Rimozione…"
msgstr "Rimozione…"

#: src/features/console/docs/content.ts:1719
msgid "Rimuove indice + storage (scope ingest:write)."
msgstr "Rimuove indice + storage (scope ingest:write)."

#: src/features/console/docs/content.ts:482
msgid "Rimuove indice + storage. L'aggiornamento in-place oggi è DELETE + POST."
msgstr "Rimuove indice + storage. L'aggiornamento in-place oggi è DELETE + POST."

#: src/features/sources/components/ArtifactPane.tsx:1597
msgid "Rimuove la proposta pending dallo storage locale. Non modifica il documento."
msgstr "Rimuove la proposta pending dallo storage locale. Non modifica il documento."

#: src/features/sync/components/DocSyncManager.tsx:1460
msgid "Rimuovendo…"
msgstr "Rimuovendo…"

#. placeholder {0}: memberPrimary(removeTarget, i18n._(msg`questo membro`))
#: src/features/console/pages/MembersPage.tsx:689
msgid "Rimuovere «{0}»? Perde subito l'accesso all'organizzazione."
msgstr "Rimuovere «{0}»? Perde subito l'accesso all'organizzazione."

#: src/features/admin/components/orgs/OrgSSOTab.tsx:364
msgid "Rimuovere configurazione IdP?"
msgstr "Rimuovere configurazione IdP?"

#: src/features/sync/components/DocSyncManager.tsx:1436
msgid "Rimuovere dal sync?"
msgstr "Rimuovere dal sync?"

#: src/features/settings/components/OtpEmailPanel.tsx:320
msgid "Rimuovere il fattore <0>codice via email</0>? Non riceverai più i codici a {masked}. Se è il tuo unico secondo fattore, il tuo account resterà protetto dalla sola password."
msgstr "Rimuovere il fattore <0>codice via email</0>? Non riceverai più i codici a {masked}. Se è il tuo unico secondo fattore, il tuo account resterà protetto dalla sola password."

#: src/features/console/pages/MembersPage.tsx:686
#: src/features/projects/components/sections/MembersSection.tsx:138
msgid "Rimuovere il membro?"
msgstr "Rimuovere il membro?"

#: src/features/console/components/ProviderAccounts.tsx:233
msgid "Rimuovere il provider?"
msgstr "Rimuovere il provider?"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:590
msgid "Rimuovere membro?"
msgstr "Rimuovere membro?"

#: src/features/connect/components/GrantManager.tsx:188
msgid "Rimuovere questa risorsa?"
msgstr "Rimuovere questa risorsa?"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:931
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2386
#: src/features/admin/components/orgs/OrgMembersTab.tsx:600
#: src/features/admin/components/orgs/OrgSSOTab.tsx:369
#: src/features/connect/components/GrantManager.tsx:194
#: src/features/console/components/ProviderAccounts.tsx:150
#: src/features/console/components/ProviderAccounts.tsx:252
#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:116
#: src/features/console/pages/MembersPage.tsx:584
#: src/features/console/pages/MembersPage.tsx:708
#: src/features/console/pages/ResourceAccessPage.tsx:706
#: src/features/hive-flows/run/ProposalReview.tsx:637
#: src/features/projects/components/sections/MembersSection.tsx:148
#: src/features/projects/components/sections/MembersSection.tsx:272
#: src/features/sales/components/FollowUpControl.tsx:102
#: src/features/settings/components/OrgMembersPanel.tsx:688
#: src/features/settings/components/OtpEmailPanel.tsx:296
#: src/features/sync/components/DocSyncManager.tsx:1460
#: src/features/voice_report/components/NewReportDialog.tsx:970
#: src/features/workspace/components/NotificationPill.tsx:257
msgid "Rimuovi"
msgstr "Rimuovi"

#: src/features/skills/components/SkillEditor.tsx:371
msgid "Rimuovi «{kw}»"
msgstr "Rimuovi «{kw}»"

#. placeholder {0}: block.title
#. placeholder {0}: f.filename
#. placeholder {0}: field.name
#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:120
#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:366
#: src/features/admin/components/orgs/OrgMembersTab.tsx:562
#: src/features/admin/components/orgs/OrgSSOTab.tsx:233
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:255
#: src/features/hive-flows/run/ProposalReview.tsx:636
#: src/features/share/components/ShareLinkDialog.tsx:759
#: src/features/sync/components/DocSyncManager.tsx:1031
#: src/features/sync/components/DocSyncManager.tsx:1344
#: src/features/workspace/components/UploadModal.tsx:503
#: src/routes/_authed/route.tsx:2203
msgid "Rimuovi {0}"
msgstr "Rimuovi {0}"

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:314
msgid "Rimuovi {display}"
msgstr "Rimuovi {display}"

#: src/features/admin/components/AdminGatedLinks.tsx:91
msgid "Rimuovi {e}"
msgstr "Rimuovi {e}"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:288
msgid "Rimuovi {email}"
msgstr "Rimuovi {email}"

#: src/features/dashboard/components/ShareChartSheet.tsx:383
msgid "Rimuovi {memberName} dalla condivisione"
msgstr "Rimuovi {memberName} dalla condivisione"

#: src/features/dashboard/components/ShareDashboardSheet.tsx:370
msgid "Rimuovi {memberName} dalla dashboard"
msgstr "Rimuovi {memberName} dalla dashboard"

#: src/features/connect/components/connectShared.tsx:412
msgid "Rimuovi {t}"
msgstr "Rimuovi {t}"

#: src/features/settings/components/BrandKitSettings.tsx:685
msgid "Rimuovi {title}"
msgstr "Rimuovi {title}"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:836
msgid "Rimuovi {v}"
msgstr "Rimuovi {v}"

#: src/features/clean-control/utils/signalCatalog.ts:215
#: src/features/sales/components/CampaignSharing.tsx:305
msgid "Rimuovi accesso"
msgstr "Rimuovi accesso"

#. placeholder {0}: a.filename
#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:322
msgid "Rimuovi allegato {0}"
msgstr "Rimuovi allegato {0}"

#: src/features/admin/components/AdminCpq.tsx:707
msgid "Rimuovi applicazione"
msgstr "Rimuovi applicazione"

#: src/features/sales/components/AssigneePicker.tsx:128
msgid "Rimuovi assegnazione"
msgstr "Rimuovi assegnazione"

#: src/features/hive-flows/components/FlowFormPublish.tsx:185
msgid "Rimuovi campo"
msgstr "Rimuovi campo"

#: src/features/connectors/components/ConnectedAccountRow.tsx:502
#: src/features/connectors/components/ConnectedAccountRow.tsx:529
#: src/features/projects/components/sections/KnowledgeSection.tsx:198
msgid "Rimuovi cartella"
msgstr "Rimuovi cartella"

#: src/features/projects/components/sections/KnowledgeSection.tsx:197
msgid "Rimuovi cartella {p}"
msgstr "Rimuovi cartella {p}"

#: src/features/hive-flows/components/ConditionBuilder.tsx:236
#: src/features/hive-flows/components/NodeInspector.tsx:952
msgid "Rimuovi collegamento dato"
msgstr "Rimuovi collegamento dato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1139
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2289
msgid "Rimuovi colonna"
msgstr "Rimuovi colonna"

#. placeholder {0}: id.slice(0, 8)
#: src/features/projects/components/sections/KnowledgeSection.tsx:171
msgid "Rimuovi connettore {0}"
msgstr "Rimuovi connettore {0}"

#: src/features/chat/components/ConversationSidebar.tsx:1156
msgid "Rimuovi da progetto"
msgstr "Rimuovi da progetto"

#: src/features/settings/components/OrgMembersPanel.tsx:331
msgid "Rimuovi dall'organizzazione"
msgstr "Rimuovi dall'organizzazione"

#: src/features/clean-control/components/EventQueue.tsx:245
msgid "Rimuovi filtri"
msgstr "Rimuovi filtri"

#. placeholder {0}: chip.field
#. placeholder {1}: chip.value
#: src/features/dashboard/components/CrossFilterBar.tsx:112
msgid "Rimuovi filtro {0}: {1}"
msgstr "Rimuovi filtro {0}: {1}"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:181
msgid "Rimuovi filtro User ID"
msgstr "Rimuovi filtro User ID"

#: src/features/admin/components/AdminCpq.tsx:1053
#: src/features/admin/components/AdminCpqPriceBook.tsx:333
msgid "Rimuovi fonte"
msgstr "Rimuovi fonte"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:952
msgid "Rimuovi formattazione"
msgstr "Rimuovi formattazione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2477
msgid "Rimuovi immagine"
msgstr "Rimuovi immagine"

#. placeholder {0}: index + 1
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:170
msgid "Rimuovi la slide {0}"
msgstr "Rimuovi la slide {0}"

#: src/features/connect/components/GrantManager.tsx:729
msgid "Rimuovi la tabella {t}"
msgstr "Rimuovi la tabella {t}"

#: src/features/settings/components/OrgMembersPanel.tsx:638
msgid "Rimuovi membro"
msgstr "Rimuovi membro"

#. placeholder {0}: row.name || idx + 1
#: src/features/admin/components/AdminPlatformSettings.tsx:287
msgid "Rimuovi modello {0}"
msgstr "Rimuovi modello {0}"

#: src/features/hive-flows/components/NodeInspector.tsx:567
msgid "Rimuovi nodo"
msgstr "Rimuovi nodo"

#: src/features/dashboard/components/ChartTimeRangeSettings.tsx:56
msgid "Rimuovi periodo"
msgstr "Rimuovi periodo"

#: src/features/workspace/documents/components/DocumentCardV2.tsx:298
msgid "Rimuovi pin"
msgstr "Rimuovi pin"

#: src/features/admin/components/AdminCpqPriceBook.tsx:269
msgid "Rimuovi PoC"
msgstr "Rimuovi PoC"

#: src/features/hive-flows/components/ConditionBuilder.tsx:303
msgid "Rimuovi regola"
msgstr "Rimuovi regola"

#: ../../packages/ui/src/ando/EditableTable.tsx:491
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1087
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1173
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2227
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2326
msgid "Rimuovi riga"
msgstr "Rimuovi riga"

#: src/features/connect/components/GrantManager.tsx:258
msgid "Rimuovi risorsa"
msgstr "Rimuovi risorsa"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2187
msgid "Rimuovi serie"
msgstr "Rimuovi serie"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:182
msgid "Rimuovi sezione"
msgstr "Rimuovi sezione"

#: src/features/workspace/components/InboxItemRow.tsx:218
msgid "Rimuovi stella"
msgstr "Rimuovi stella"

#: src/features/admin/components/AdminCpqPriceBook.tsx:238
msgid "Rimuovi taglio"
msgstr "Rimuovi taglio"

#: src/features/settings/components/SecuritySettings.tsx:216
msgid "Rimuovi TOTP"
msgstr "Rimuovi TOTP"

#: src/features/billing/components/CurrentPlanCard.tsx:95
msgid "Rinnovo: {end}"
msgstr "Rinnovo: {end}"

#: src/features/chat/components/ConversationSidebar.tsx:821
#: src/features/chat/components/ConversationSidebar.tsx:1142
#: src/features/console/connectors/CustomConnectorDetail.tsx:985
#: src/features/console/pages/ResourceAccessPage.tsx:314
#: src/features/dashboard/components/DashboardListSidebar.tsx:339
#: src/routes/_authed/workspace/flows.index.tsx:427
msgid "Rinomina"
msgstr "Rinomina"

#. placeholder {0}: flow.name
#: src/routes/_authed/workspace/flows.index.tsx:487
msgid "Rinomina {0}"
msgstr "Rinomina {0}"

#: src/features/console/connectors/CustomConnectorDetail.tsx:742
msgid "Rinomina connettore"
msgstr "Rinomina connettore"

#: src/features/chat/components/ConversationCommandPalette.tsx:177
#: src/features/chat/components/ConversationSidebar.tsx:932
msgid "Rinomina conversazione"
msgstr "Rinomina conversazione"

#: src/features/chat/components/ConversationCommandPalette.tsx:168
msgid "Rinomina conversazione corrente"
msgstr "Rinomina conversazione corrente"

#: src/features/dashboard/components/DashboardListSidebar.tsx:535
msgid "Rinomina dashboard {dashboardName}"
msgstr "Rinomina dashboard {dashboardName}"

#: src/features/console/pages/SchemaPage.tsx:150
msgid "Rinomina la sorgente"
msgstr "Rinomina la sorgente"

#: src/features/chat/components/ConversationSidebar.tsx:945
#: src/routes/_authed/workspace/flows.index.tsx:101
msgid "Rinomina non riuscita"
msgstr "Rinomina non riuscita"

#: src/features/chat/components/ConversationSidebar.tsx:608
msgid "Rinomina progetto"
msgstr "Rinomina progetto"

#: src/features/console/pages/ModelsPage.tsx:326
msgid "Riordino dei risultati"
msgstr "Riordino dei risultati"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:380
msgid "Ripeti"
msgstr "Ripeti"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:381
msgid "Ripeti (Shift+Cmd+Z)"
msgstr "Ripeti (Shift+Cmd+Z)"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:283
msgid "Ripeti ogni"
msgstr "Ripeti ogni"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:240
#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:141
msgid "Ripetizione"
msgstr "Ripetizione"

#: src/features/admin/components/AdminDecks.tsx:251
msgid "Riporta tra le attive"
msgstr "Riporta tra le attive"

#: src/features/projects/components/ProjectDetailPage.tsx:602
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:360
msgid "Riprendi"
msgstr "Riprendi"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:243
msgid "Ripresa della sincronizzazione avviata"
msgstr "Ripresa della sincronizzazione avviata"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:115
msgid "Ripreso dall'ultimo checkpoint."
msgstr "Ripreso dall'ultimo checkpoint."

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:201
#: src/features/console/pages/ModelsPage.tsx:507
#: src/features/hive-flows/components/FlowVersionMenu.tsx:139
#: src/features/settings/components/NotificationPreferences.tsx:244
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:323
msgid "Ripristina"
msgstr "Ripristina"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:314
msgid "Ripristina dal cestino"
msgstr "Ripristina dal cestino"

#: src/features/settings/components/OrganizationSettings.tsx:294
msgid "Ripristina default"
msgstr "Ripristina default"

#. placeholder {0}: slot.label
#: src/features/admin/components/AdminPlatformSettings.tsx:1106
msgid "Ripristina default {0}"
msgstr "Ripristina default {0}"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:365
msgid "Ripristina i colori e i loghi ai default di ANDO. Questa operazione cancella i valori salvati."
msgstr "Ripristina i colori e i loghi ai default di ANDO. Questa operazione cancella i valori salvati."

#. placeholder {0}: config.label
#: src/features/console/pages/ModelsPage.tsx:149
msgid "Ripristina il predefinito per {0}"
msgstr "Ripristina il predefinito per {0}"

#: src/features/console/pages/ModelsPage.tsx:152
msgid "Ripristina predefinito"
msgstr "Ripristina predefinito"

#. placeholder {0}: v.version_number
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:198
msgid "Ripristina v{0}"
msgstr "Ripristina v{0}"

#: src/features/admin/components/AdminDecks.tsx:666
msgid "Ripristina versione"
msgstr "Ripristina versione"

#: src/features/console/pages/ModelsPage.tsx:485
msgid "Ripristinare il predefinito?"
msgstr "Ripristinare il predefinito?"

#. placeholder {0}: v.version
#: src/features/admin/components/AdminDecks.tsx:656
msgid "Ripristinare la v{0} come nuova versione attiva? I link già inviati non cambiano."
msgstr "Ripristinare la v{0} come nuova versione attiva? I link già inviati non cambiano."

#. placeholder {0}: v.version
#: src/features/admin/components/AdminDecks.tsx:655
msgid "Ripristinare la v{0}? Le modifiche non salvate nell'editor andranno perse."
msgstr "Ripristinare la v{0}? Le modifiche non salvate nell'editor andranno perse."

#. placeholder {0}: row.version
#: src/features/admin/components/AdminDecks.tsx:660
msgid "Ripristinata come versione {0}"
msgstr "Ripristinata come versione {0}"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:147
msgid "Ripristino — 3 passaggi, ~2 minuti"
msgstr "Ripristino — 3 passaggi, ~2 minuti"

#: src/features/admin/components/AdminDecks.tsx:662
#: src/features/hive-flows/components/FlowVersionMenu.tsx:64
msgid "Ripristino non riuscito"
msgstr "Ripristino non riuscito"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:201
msgid "Ripristino…"
msgstr "Ripristino…"

#: src/features/chat/components/AudioPlayer.tsx:95
msgid "Riproduci audio"
msgstr "Riproduci audio"

#: src/features/report/components/RespondentQuotesCarousel.tsx:242
msgid "Riproduzione automatica disattivata"
msgstr "Riproduzione automatica disattivata"

#: src/features/sources/components/CalendarEventPane.tsx:668
msgid "Riprogramma"
msgstr "Riprogramma"

#: src/features/chat/components/ChatEmptyState.tsx:151
msgid "Riprogramma meeting"
msgstr "Riprogramma meeting"

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:129
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:314
#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:321
#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:229
#: ../../packages/ui/src/ando/MessageToolbar.tsx:64
#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:235
#: ../../packages/ui/src/editors/AiTextPopover.tsx:373
#: src/features/admin/components/AdminPlatformSettings.tsx:169
#: src/features/admin/components/AdminPlatformSettings.tsx:530
#: src/features/admin/components/AdminPlatformSettings.tsx:1020
#: src/features/admin/components/AdminUsers.tsx:297
#: src/features/admin/components/hypermem/HmStates.tsx:25
#: src/features/admin/components/orgs/OrgCostTab.tsx:334
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:391
#: src/features/admin/components/widgets/EmptyChartState.tsx:70
#: src/features/auth/desktop/DesktopLoginForm.tsx:668
#: src/features/automations/components/AutomationsHub.tsx:342
#: src/features/chat/components/AudioPlayer.tsx:152
#: src/features/chat/components/InterruptedQueryNotice.tsx:46
#: src/features/clean-control/components/EventQueue.tsx:521
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:146
#: src/features/console/components/ConsoleSectionBoundary.tsx:81
#: src/features/console/components/CreateKeyWizard.tsx:374
#: src/features/console/components/DocumentAcquiredContent.tsx:39
#: src/features/console/pages/AccessOverviewPage.tsx:184
#: src/features/console/pages/EngineSignupPage.tsx:179
#: src/features/console/pages/OverviewPage.tsx:285
#: src/features/console/traces/TracePayloadReader.tsx:36
#: src/features/dxf/components/DxfPreviewStage.tsx:558
#: src/features/integrations/parts/StatusElements.tsx:143
#: src/features/onboarding/DemoBookCallModal.tsx:476
#: src/features/sales/components/SignaturesManager.tsx:153
#: src/features/sales/components/SignaturesManager.tsx:326
#: src/features/skills/components/SkillsList.tsx:219
#: src/features/skills/components/TeamSkillsCatalog.tsx:64
#: src/features/sources/components/ArtifactPane.tsx:2285
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:701
#: src/features/studio/components/StudioDrawerContent.tsx:433
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:479
#: src/features/templates/components/TemplatesList.tsx:158
#: src/features/updates/components/UpdateBanner.tsx:225
#: src/features/voice_report/components/VoiceReportsList.tsx:199
#: src/routes/_authed/workspace/canvases.$canvasId.tsx:171
#: src/routes/_authed/workspace/canvases.tsx:223
#: src/routes/_authed/workspace/connect.index.tsx:158
#: src/routes/_authed/workspace/connect.index.tsx:212
#: src/routes/_authed/workspace/dashboard.tsx:1073
#: src/routes/_authed/workspace/dashboard.tsx:1111
#: src/routes/_authed/workspace/finance.tsx:1485
#: src/routes/_authed/workspace/shares.tsx:152
#: src/routes/_authed/workspace/technical.tsx:366
#: src/routes/_authed/workspace/templates/$kind.tsx:130
#: src/routes/_authed/workspace/templates/$kind.tsx:294
msgid "Riprova"
msgstr "Riprova"

#: src/features/console/pages/ModelsPage.tsx:397
msgid "Riprova a caricare"
msgstr "Riprova a caricare"

#: ../../packages/ui/src/ando/actions/SlideDeckProposalSurface.tsx:235
msgid "Riprova anteprima"
msgstr "Riprova anteprima"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:367
msgid "Riprova configurazione"
msgstr "Riprova configurazione"

#: src/features/updates/components/UpdateBanner.tsx:221
msgid "Riprova controllo aggiornamento"
msgstr "Riprova controllo aggiornamento"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:369
msgid "Riprova disattivazione"
msgstr "Riprova disattivazione"

#: src/features/settings/components/NotificationPreferences.tsx:287
msgid "Riprova fra qualche istante."
msgstr "Riprova fra qualche istante."

#: src/routes/_authed/_modal/integrations/index.tsx:201
msgid "Riprova fra qualche minuto o riconnetti l'account."
msgstr "Riprova fra qualche minuto o riconnetti l'account."

#: src/routes/_authed/workspace/dashboard.tsx:1104
msgid "Riprova fra qualche secondo oppure seleziona un'altra dashboard dalla barra laterale."
msgstr "Riprova fra qualche secondo oppure seleziona un'altra dashboard dalla barra laterale."

#: src/features/admin/components/AdminAutomation.tsx:93
#: src/features/admin/components/AdminCanvas.tsx:88
#: src/features/admin/components/AdminCostTracking.tsx:218
#: src/features/admin/components/AdminEngagement.tsx:108
#: src/features/admin/components/AdminHealth.tsx:72
#: src/features/admin/components/AdminOverview.tsx:83
#: src/features/admin/components/AdminQuality.tsx:83
#: src/features/admin/components/AdminRevenue.tsx:76
#: src/features/automations/components/AutomationsHub.tsx:338
#: src/features/settings/components/ProfileSettings.tsx:94
#: src/features/sources/components/InboxDetailPane.tsx:325
#: src/features/sources/components/InboxDetailPane.tsx:578
#: src/features/sources/components/InboxDetailPane.tsx:1681
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:327
#: src/routes/_authed/workspace/canvases.tsx:216
#: src/routes/_authed/workspace/connect.index.tsx:155
#: src/routes/_authed/workspace/connect.index.tsx:209
#: src/routes/_authed/workspace/shares.tsx:145
msgid "Riprova fra qualche secondo."
msgstr "Riprova fra qualche secondo."

#: src/routes/_authed/workspace/conversations.tsx:857
msgid "Riprova fra qualche secondo. Se il problema persiste, verifica la connessione ai provider email/chat."
msgstr "Riprova fra qualche secondo. Se il problema persiste, verifica la connessione ai provider email/chat."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:97
msgid "Riprova fra un momento."
msgstr "Riprova fra un momento."

#: src/features/console/pages/ConnectorDetailPage.tsx:528
msgid "Riprova stima"
msgstr "Riprova stima"

#: src/features/admin/components/AdminCpq.tsx:369
#: src/features/admin/components/AdminCpqAskAndo.tsx:215
#: src/features/admin/components/AdminCpqList.tsx:121
#: src/features/admin/components/AdminCpqPriceBook.tsx:139
#: src/features/admin/components/AdminDecksAskAndo.tsx:65
#: src/features/admin/components/AdminDemoInviti.tsx:131
#: src/features/admin/components/AdminDemoInviti.tsx:144
#: src/features/admin/components/AdminDemoInviti.tsx:155
#: src/features/admin/components/AdminDemoInviti.tsx:206
msgid "Riprova."
msgstr "Riprova."

#: src/features/chat/components/InterruptedQueryNotice.tsx:46
msgid "Riprovo…"
msgstr "Riprovo…"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1308
msgid "Riquadro"
msgstr "Riquadro"

#: src/features/console/connectors/ConnectorActionsPanel.tsx:194
msgid "Rischio"
msgstr "Rischio"

#: src/features/console/components/StatusBadges.tsx:148
msgid "Rischio alto"
msgstr "Rischio alto"

#: src/features/console/components/StatusBadges.tsx:146
msgid "Rischio basso"
msgstr "Rischio basso"

#: src/features/console/components/StatusBadges.tsx:149
msgid "Rischio critico"
msgstr "Rischio critico"

#: src/features/console/components/StatusBadges.tsx:147
msgid "Rischio medio"
msgstr "Rischio medio"

#: src/features/console/pages/BillingPage.tsx:414
msgid "Riscossione"
msgstr "Riscossione"

#: src/features/console/pages/PlaygroundPage.tsx:891
msgid "Riscritta"
msgstr "Riscritta"

#. placeholder {0}: response.status
#: ../../packages/ui/src/editors/AiTextPopover.tsx:182
msgid "Riscrittura fallita (HTTP {0})."
msgstr "Riscrittura fallita (HTTP {0})."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:243
msgid "Riscrivi con AI"
msgstr "Riscrivi con AI"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:225
msgid "Riscrivi la selezione con AI"
msgstr "Riscrivi la selezione con AI"

#: src/features/hive-flows/run/RunHistoryRail.tsx:315
msgid "Risolto"
msgstr "Risolto"

#: src/features/clean-control/utils/signalCatalog.ts:227
msgid "Risolvi"
msgstr "Risolvi"

#: src/features/clean-control/components/EventDetailSheet.tsx:455
msgid "Risorsa"
msgstr "Risorsa"

#: src/features/connect/components/GrantManager.tsx:300
msgid "Risorsa condivisa"
msgstr "Risorsa condivisa"

#: src/features/console/docs/content.ts:2000
msgid "Risorsa inesistente nel tuo project."
msgstr "Risorsa inesistente nel tuo project."

#: src/features/connect/components/GrantManager.tsx:108
msgid "Risorsa rimossa"
msgstr "Risorsa rimossa"

#: src/features/console/components/CreateKeyWizard.tsx:118
#: src/features/console/pages/AccessOverviewPage.tsx:273
#: src/features/console/pages/KeysPage.tsx:125
#: src/routes/_authed/workspace/connect.$spaceId.tsx:305
msgid "Risorse"
msgstr "Risorse"

#: src/features/console/components/FirstRunTimeline.tsx:230
msgid "Risorse disponibili"
msgstr "Risorse disponibili"

#: src/features/console/components/CreateKeyWizard.tsx:442
msgid "Risorse selezionate"
msgstr "Risorse selezionate"

#: src/features/console/pages/DevelopersPage.tsx:41
msgid "Risponde a una domanda con una risposta sintetica basata solo sui contenuti, con citazioni."
msgstr "Risponde a una domanda con una risposta sintetica basata solo sui contenuti, con citazioni."

#: src/routes/connect.chatbot.$publicToken.tsx:167
msgid "Risponde solo dalle fonti di questo assistente"
msgstr "Risponde solo dalle fonti di questo assistente"

#: src/routes/connect.chatbot.$publicToken.tsx:162
#: src/routes/connect.chatbot.$publicToken.tsx:172
msgid "Risponde solo dalle fonti di questo assistente."
msgstr "Risponde solo dalle fonti di questo assistente."

#: src/routes/_authed/_modal/settings/help.tsx:160
msgid "Risponde una persona, non un bot. Includi una breve descrizione e — se possibile — uno screenshot o l'ID conversazione."
msgstr "Risponde una persona, non un bot. Includi una breve descrizione e — se possibile — uno screenshot o l'ID conversazione."

#: src/features/report/components/ReportList.tsx:38
#: src/features/report/components/ReportViewer.tsx:117
msgid "Rispondenti"
msgstr "Rispondenti"

#: ../../packages/ui/src/ando/sources/email/EmailActions.tsx:17
#: src/features/sources/components/InboxDetailPane.tsx:1833
#: src/features/sources/components/InboxDetailPane.tsx:2139
#: src/features/workspace/components/InboxItemRow.tsx:264
msgid "Rispondi"
msgstr "Rispondi"

#: src/features/sources/components/InboxDetailPane.tsx:1833
#: src/features/sources/components/InboxDetailPane.tsx:2146
msgid "Rispondi a tutti"
msgstr "Rispondi a tutti"

#: src/features/sources/components/InboxDetailPane.tsx:1829
msgid "Rispondi a tutti i partecipanti"
msgstr "Rispondi a tutti i partecipanti"

#: src/features/console/docs/content.ts:1636
msgid "Rispondi con i dati autorizzati dell'utente"
msgstr "Rispondi con i dati autorizzati dell'utente"

#: src/features/sources/components/InboxDetailPane.tsx:1828
msgid "Rispondi solo al mittente"
msgstr "Rispondi solo al mittente"

#: src/routes/_authed/_modal/settings/help.tsx:187
msgid "Rispondiamo entro 24 ore lavorative."
msgstr "Rispondiamo entro 24 ore lavorative."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:263
#: src/features/console/pages/DocsPage.tsx:142
#: src/features/console/pages/PlaygroundPage.tsx:793
#: src/features/console/pages/PlaygroundPage.tsx:1201
#: src/features/console/pages/PlaygroundPage.tsx:2084
msgid "Risposta"
msgstr "Risposta"

#: ../../packages/ui/src/editors/AiTextPopover.tsx:188
msgid "Risposta AI vuota."
msgstr "Risposta AI vuota."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:672
msgid "Risposta con fonti"
msgstr "Risposta con fonti"

#: src/features/share/components/ShareLinkRow.tsx:84
msgid "Risposta condivisa"
msgstr "Risposta condivisa"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:29
msgid "Risposta conversazionale"
msgstr "Risposta conversazionale"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:70
msgid "Risposta da migliorare"
msgstr "Risposta da migliorare"

#: src/features/console/components/AssistPanel.tsx:116
msgid "Risposta degradata."
msgstr "Risposta degradata."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:259
msgid "Risposta del tuo endpoint"
msgstr "Risposta del tuo endpoint"

#: ../../packages/ui/src/ando/MessageToolbar.tsx:71
msgid "Risposta eccellente"
msgstr "Risposta eccellente"

#: src/features/console/pages/ModelsPage.tsx:318
msgid "Risposta finale"
msgstr "Risposta finale"

#: src/features/console/pages/PlaygroundPage.tsx:1029
msgid "Risposta immediata dalla cache dei piani."
msgstr "Risposta immediata dalla cache dei piani."

#: src/features/chat/components/Messages.tsx:123
msgid "Risposta in"
msgstr "Risposta in"

#: src/features/templates/components/CreateTemplateDialog.tsx:112
msgid "Risposta inattesa dal server: slug mancante."
msgstr "Risposta inattesa dal server: slug mancante."

#. placeholder {0}: t.allowedDocCount
#: src/features/connect/components/ConnectChat.tsx:298
msgid "Risposta limitata alle <0>{0}</0> fonti condivise con te in questo spazio."
msgstr "Risposta limitata alle <0>{0}</0> fonti condivise con te in questo spazio."

#: src/features/connect/components/ConnectChat.tsx:304
msgid "Risposta limitata alle fonti condivise con te in questo spazio."
msgstr "Risposta limitata alle fonti condivise con te in questo spazio."

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:26
msgid "Risposta rapida, niente reasoning approfondito"
msgstr "Risposta rapida, niente reasoning approfondito"

#: src/features/agent-modes/components/AgentModeEditor.tsx:413
msgid "Risposta rapida, niente reasoning approfondito (~5s)."
msgstr "Risposta rapida, niente reasoning approfondito (~5s)."

#: ../../packages/ui/src/ando/MessageToolbar.tsx:69
msgid "Risposta utile"
msgstr "Risposta utile"

#: src/features/console/pages/ModelsPage.tsx:227
msgid "Risposte Engine e Playground"
msgstr "Risposte Engine e Playground"

#: src/features/sales/components/leadMeta.ts:30
msgid "Risposto"
msgstr "Risposto"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:332
#: src/features/console/pages/PlaygroundPage.tsx:885
msgid "Risultati"
msgstr "Risultati"

#: src/features/console/pages/PlaygroundPage.tsx:2029
msgid "Risultati (k)"
msgstr "Risultati (k)"

#: src/features/structured-data/components/DisplayResultChips.tsx:152
msgid "Risultati allegati"
msgstr "Risultati allegati"

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:53
msgid "Risultati per"
msgstr "Risultati per"

#: src/features/console/connectors/TestConnectorActionModal.tsx:372
#: src/features/console/pages/PlaygroundPage.tsx:2072
msgid "Risultato"
msgstr "Risultato"

#: src/features/structured-data/components/CadDataPanel.tsx:115
#: src/features/structured-data/components/CadDataPanel.tsx:125
#: src/features/structured-data/components/CadDataPanel.tsx:240
#: src/features/structured-data/components/CadDataPanel.tsx:262
#: src/features/structured-data/components/CadQueryCard.tsx:110
#: src/features/structured-data/components/CadQueryCard.tsx:114
#: src/features/structured-data/components/DisplayResultChips.tsx:92
msgid "Risultato CAD"
msgstr "Risultato CAD"

#: src/features/structured-data/components/StructuredDataCard.tsx:89
msgid "Risultato completo disponibile"
msgstr "Risultato completo disponibile"

#: src/features/structured-data/components/CadDataPanel.tsx:139
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:180
#: src/features/structured-data/components/InlineChartPanel.tsx:73
msgid "Risultato non disponibile"
msgstr "Risultato non disponibile"

#: src/features/dashboard/components/AddChartDialog.tsx:258
#: src/features/dashboard/components/AddChartDialog.tsx:278
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:159
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:166
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:409
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:427
#: src/features/structured-data/components/SaveToDashboardButton.tsx:86
#: src/features/structured-data/components/StructuredDataCard.tsx:64
#: src/routes/_authed/workspace/dashboard.tsx:967
msgid "Risultato query"
msgstr "Risultato query"

#: src/features/structured-data/components/DisplayResultChips.tsx:111
msgid "Risultato tabellare"
msgstr "Risultato tabellare"

#: src/routes/_authed/workspace/documents.tsx:1178
msgid "Risultato web"
msgstr "Risultato web"

#: src/features/console/pages/DocsPage.tsx:211
msgid "Ritorna"
msgstr "Ritorna"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:360
msgid "Ritorno dopo il login"
msgstr "Ritorno dopo il login"

#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:31
msgid "Riunioni"
msgstr "Riunioni"

#: src/features/onboarding/demoTourSteps.ts:78
msgid "Riunioni e impegni della settimana. Ando può prepararti un brief per il prossimo meeting o trovarti uno slot libero."
msgstr "Riunioni e impegni della settimana. Ando può prepararti un brief per il prossimo meeting o trovarti uno slot libero."

#: src/features/onboarding/sectionGuides.ts:36
msgid "Riunioni e impegni di tutti i calendari collegati. Ando può preparare un brief per il prossimo meeting o trovarti uno slot libero."
msgstr "Riunioni e impegni di tutti i calendari collegati. Ando può preparare un brief per il prossimo meeting o trovarti uno slot libero."

#: src/features/console/connectors/InvokeConnectorActionModal.tsx:243
msgid "Riuscita"
msgstr "Riuscita"

#: src/features/console/pages/FlowsPage.tsx:200
msgid "Riuscite"
msgstr "Riuscite"

#: src/features/sources/components/InboxDetailPane.tsx:1676
msgid "Rivedi e modifica prima di inviare."
msgstr "Rivedi e modifica prima di inviare."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:577
msgid "Rivedi e salva una nuova versione."
msgstr "Rivedi e salva una nuova versione."

#: src/features/onboarding/OnboardingSettings.tsx:30
msgid "Rivedi il giro guidato di Ando o riattiva i riquadri d'aiuto nelle sezioni se li avevi nascosti."
msgstr "Rivedi il giro guidato di Ando o riattiva i riquadri d'aiuto nelle sezioni se li avevi nascosti."

#: src/features/chat/components/ChatEmptyState.tsx:623
#: src/features/onboarding/DemoBetaBanner.tsx:60
#: src/features/onboarding/OnboardingSettings.tsx:38
msgid "Rivedi il tour guidato"
msgstr "Rivedi il tour guidato"

#: src/features/sources/components/AISummaryPanel.tsx:524
msgid "Rivedi le modifiche nel documento."
msgstr "Rivedi le modifiche nel documento."

#: src/features/actions/hooks/useActionRouter.ts:171
msgid "Rivedi le modifiche proposte nel documento e conferma per applicarle."
msgstr "Rivedi le modifiche proposte nel documento e conferma per applicarle."

#: src/features/actions/components/MessageActionChips.tsx:142
msgid "Rivedi modifiche"
msgstr "Rivedi modifiche"

#: src/features/actions/components/MessageActionChips.tsx:143
msgid "Rivedi proposta"
msgstr "Rivedi proposta"

#: src/features/report/lib/useReportLifecycle.ts:80
msgid "Rivisto editorialmente. Obblighi di disclosure ridotti (EU AI Act art. 50 §3)."
msgstr "Rivisto editorialmente. Obblighi di disclosure ridotti (EU AI Act art. 50 §3)."

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:133
msgid "Rollback"
msgstr "Rollback"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1983
msgid "Rombo"
msgstr "Rombo"

#: src/features/admin/components/CostTraceDetailSection.tsx:255
msgid "root"
msgstr "root"

#: src/features/projects/components/ProjectIcon.tsx:114
msgid "Rosa"
msgstr "Rosa"

#: src/features/projects/components/ProjectIcon.tsx:116
msgid "Rosso"
msgstr "Rosso"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1611
msgid "Rot. °"
msgstr "Rot. °"

#: src/features/console/docs/content.ts:1275
msgid "Rotazione & edit chiavi (session)"
msgstr "Rotazione & edit chiavi (session)"

#: src/features/admin/components/AdminHealth.tsx:136
msgid "Route"
msgstr "Route"

#: src/features/admin/components/AdminPlatformSettings.tsx:920
msgid "Router"
msgstr "Router"

#: src/features/connectors/wizards/openBankingSpec.tsx:147
msgid "Routing automatico in base al paese — gestito da Ando."
msgstr "Routing automatico in base al paese — gestito da Ando."

#: src/features/admin/components/AdminCostTracking.tsx:386
msgid "Routing modello"
msgstr "Routing modello"

#: src/features/structured-data/components/SimilarPartsSection.tsx:114
msgid "RRF dei 3 axes geometrici"
msgstr "RRF dei 3 axes geometrici"

#: src/features/admin/components/AdminAutomation.tsx:229
msgid "Run"
msgstr "Run"

#: src/features/admin/components/AdminAutomation.tsx:66
msgid "run · success rate · costi · suggerimenti in coda"
msgstr "run · success rate · costi · suggerimenti in coda"

#: src/features/admin/components/AdminAutomation.tsx:106
msgid "Run nel tempo · stacked area"
msgstr "Run nel tempo · stacked area"

#: src/features/console/docs/content.ts:772
msgid "Run più recenti prima, con stato, contatori, errori per record e durata."
msgstr "Run più recenti prima, con stato, contatori, errori per record e durata."

#: src/features/console/docs/content.ts:228
#: src/features/console/docs/content.ts:323
#: src/features/console/docs/content.ts:431
#: src/features/console/docs/content.ts:510
msgid "Runtime · Authorization: Bearer <api_key>"
msgstr "Runtime · Authorization: Bearer <api_key>"

#: src/features/console/docs/content.ts:1047
msgid "Runtime · Bearer <api_key> · scope actions:read / actions:write"
msgstr "Runtime · Bearer <api_key> · scope actions:read / actions:write"

#: src/features/console/docs/content.ts:960
msgid "Runtime · Bearer <api_key> · scope cad:read / cad:write"
msgstr "Runtime · Bearer <api_key> · scope cad:read / cad:write"

#: src/features/console/docs/content.ts:912
msgid "Runtime · Bearer <api_key> · scope generate:write"
msgstr "Runtime · Bearer <api_key> · scope generate:write"

#: src/features/console/docs/content.ts:849
msgid "Runtime · Bearer <api_key> · scope keys:manage"
msgstr "Runtime · Bearer <api_key> · scope keys:manage"

#: src/features/console/docs/content.ts:791
msgid "Runtime · Bearer <api_key> · scope sources:manage"
msgstr "Runtime · Bearer <api_key> · scope sources:manage"

#: src/features/console/docs/content.ts:587
msgid "Runtime · Bearer <api_key> · scope sources:manage + ingest:write"
msgstr "Runtime · Bearer <api_key> · scope sources:manage + ingest:write"

#: src/routes/_authed/workspace/finance.tsx:496
#: src/routes/_authed/workspace/finance.tsx:1440
msgid "Runway"
msgstr "Runway"

#: src/features/admin/components/AdminOrgs.tsx:1384
#: src/features/admin/components/AdminOrgs.tsx:1390
#: src/features/admin/components/AdminUsers.tsx:381
#: src/features/admin/components/deckEditor/DeckEditor.tsx:978
#: src/features/admin/components/orgs/AddMemberDialog.tsx:202
#: src/features/admin/components/orgs/AddMemberDialog.tsx:208
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:243
#: src/features/admin/components/orgs/OrgMembersTab.tsx:324
#: src/features/connect/components/MemberManager.tsx:528
#: src/features/connect/components/MemberManager.tsx:533
#: src/features/console/pages/MembersPage.tsx:356
#: src/features/console/pages/MembersPage.tsx:501
#: src/features/console/pages/MembersPage.tsx:612
#: src/features/projects/components/sections/MembersSection.tsx:554
#: src/features/projects/components/sections/PersonaSection.tsx:309
#: src/features/sales/components/CreateLeadDialog.tsx:178
#: src/features/sales/components/CreateLeadDialog.tsx:184
#: src/features/sales/components/crm/ContactsPanel.tsx:118
#: src/features/sales/components/crm/ContactsPanel.tsx:124
#: src/features/sales/components/crm/ContactsPanel.tsx:239
#: src/features/sales/components/crm/RecordDrawer.tsx:59
#: src/features/settings/components/OrgMembersPanel.tsx:546
msgid "Ruolo"
msgstr "Ruolo"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:151
#: src/features/console/pages/MembersPage.tsx:318
#: src/features/settings/components/OrgMembersPanel.tsx:230
msgid "Ruolo aggiornato"
msgstr "Ruolo aggiornato"

#: src/features/admin/components/userAdminActions.tsx:250
msgid "Ruolo aggiornato a {role}"
msgstr "Ruolo aggiornato a {role}"

#: src/features/projects/components/sections/PersonaSection.tsx:320
msgid "Ruolo del progetto"
msgstr "Ruolo del progetto"

#. placeholder {0}: m.email ?? m.user_id
#: src/features/admin/components/orgs/OrgMembersTab.tsx:452
msgid "Ruolo di {0}"
msgstr "Ruolo di {0}"

#: src/features/admin/components/orgs/OrgMembersTab.tsx:226
msgid "Ruolo impostato a Membro"
msgstr "Ruolo impostato a Membro"

#: src/features/console/pages/MembersPage.tsx:259
msgid "Ruolo nel Team Console"
msgstr "Ruolo nel Team Console"

#: src/features/settings/components/SelfProfileMemory.tsx:101
msgid "Ruolo professionale"
msgstr "Ruolo professionale"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:449
msgid "Ruolo:"
msgstr "Ruolo:"

#: src/features/console/components/OverlapRotationModal.tsx:111
#: src/features/console/pages/KeyDetailPage.tsx:607
msgid "Ruota"
msgstr "Ruota"

#: src/features/console/components/ByokModal.tsx:108
msgid "Ruota chiave"
msgstr "Ruota chiave"

#: src/features/console/connectors/CustomConnectorDetail.tsx:795
msgid "Ruota il secret"
msgstr "Ruota il secret"

#: src/features/console/components/ByokModal.tsx:94
msgid "Ruota la API key"
msgstr "Ruota la API key"

#: src/features/console/pages/KeyDetailPage.tsx:735
msgid "Ruota la chiave"
msgstr "Ruota la chiave"

#: src/features/console/connectors/CustomConnectorDetail.tsx:809
#: src/features/console/connectors/CustomConnectorDetail.tsx:995
#: src/features/console/webhooks/WebhooksPanel.tsx:627
#: src/features/console/webhooks/WebhooksPanel.tsx:764
msgid "Ruota secret"
msgstr "Ruota secret"

#: src/features/admin/components/AdminEngagement.tsx:36
msgid "Sab"
msgstr "Sab"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:81
msgid "sabato"
msgstr "sabato"

#: src/features/connectors/wizards/openBankingSpec.tsx:192
msgid "Saldi in tempo reale"
msgstr "Saldi in tempo reale"

#: src/features/connectors/wizards/openBankingSpec.tsx:137
msgid "Saldi, movimenti, riconciliazione — via PSD2 (consenso 90 giorni)"
msgstr "Saldi, movimenti, riconciliazione — via PSD2 (consenso 90 giorni)"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:250
#: src/features/console/pages/BillingPage.tsx:252
msgid "Saldo"
msgstr "Saldo"

#: src/features/console/pages/UsagePage.tsx:335
msgid "Saldo aziendale condiviso"
msgstr "Saldo aziendale condiviso"

#: src/features/settings/components/PlatformUsageCard.tsx:67
msgid "Saldo crediti"
msgstr "Saldo crediti"

#: src/features/settings/components/BillingSettings.tsx:162
msgid "Saldo crediti consumabili oltre i limiti del piano mensile."
msgstr "Saldo crediti consumabili oltre i limiti del piano mensile."

#: src/features/console/components/ConsoleShell.tsx:572
msgid "Saldo crediti. Apri la ricarica"
msgstr "Saldo crediti. Apri la ricarica"

#: src/features/console/pages/UsagePage.tsx:333
msgid "Saldo personale"
msgstr "Saldo personale"

#: src/features/console/pages/BillingPage.tsx:455
msgid "Saldo Stripe"
msgstr "Saldo Stripe"

#: src/routes/_authed/workspace/finance.tsx:1390
msgid "Saldo totale"
msgstr "Saldo totale"

#: src/features/console/pages/BillingPage.tsx:105
msgid "Saldo, metodo di pagamento e storico delle fatture."
msgstr "Saldo, metodo di pagamento e storico delle fatture."

#: src/features/projects/components/TemplatesBrowserDialog.tsx:86
#: src/features/workspace/config.ts:123
#: src/features/workspace/config.ts:125
msgid "Sales"
msgstr "Sales"

#: src/features/clean-control/components/EventQueue.tsx:100
msgid "Salesforce"
msgstr "Salesforce"

#: src/features/connectors/wizards/crmSpec.tsx:38
msgid "Salesforce o HubSpot — pipeline, account, opportunità in chat"
msgstr "Salesforce o HubSpot — pipeline, account, opportunità in chat"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:216
#: src/features/admin/components/hypermem/HmTenantsTab.tsx:52
msgid "Salience"
msgstr "Salience"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:283
msgid "Salience scores"
msgstr "Salience scores"

#: src/features/onboarding/DemoTour.tsx:270
msgid "Salta"
msgstr "Salta"

#: src/features/onboarding/DemoTour.tsx:237
msgid "Salta il tour"
msgstr "Salta il tour"

#: src/features/admin/components/AdminHealth.tsx:31
msgid "Salute del sistema"
msgstr "Salute del sistema"

#: src/features/admin/components/AdminEngagement.tsx:85
msgid "Salute della base utenti — DAU/MAU, time-to-first-value, segnale churn precoce, ampiezza d'uso e coorti settimana per settimana."
msgstr "Salute della base utenti — DAU/MAU, time-to-first-value, segnale churn precoce, ampiezza d'uso e coorti settimana per settimana."

#: src/routes/_authed/_modal/admin/route.tsx:140
msgid "Salute sistema"
msgstr "Salute sistema"

#: src/features/projects/components/ProjectHub.tsx:271
msgid "Saluto e attività progetti"
msgstr "Saluto e attività progetti"

#: src/features/chat/components/ChatEmptyState.tsx:631
msgid "Saluto e briefing"
msgstr "Saluto e briefing"

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:596
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:414
#: ../../packages/ui/src/editors/XlsxEditorInline.tsx:997
#: src/features/admin/components/AdminDemoInviti.tsx:442
#: src/features/admin/components/AdminPlatformSettings.tsx:209
#: src/features/admin/components/AdminPlatformSettings.tsx:998
#: src/features/admin/components/ModelMarkupCard.tsx:102
#: src/features/admin/components/orgs/OrgBrandingTab.tsx:211
#: src/features/agent-modes/components/AgentModeEditor.tsx:537
#: src/features/connectors/components/management/BusinessContextBanner.tsx:406
#: src/features/connectors/components/management/BusinessContextEditor.tsx:230
#: src/features/connectors/components/management/EditConnectorDialog.tsx:372
#: src/features/connectors/components/management/SchemaViewer.tsx:349
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:975
#: src/features/console/flows/ConsoleFlowEditor.tsx:305
#: src/features/console/pages/KeyDetailPage.tsx:165
#: src/features/console/pages/KeyDetailPage.tsx:286
#: src/features/console/pages/MembersPage.tsx:348
#: src/features/console/pages/ResourceAccessPage.tsx:289
#: src/features/console/pages/SchemaPage.tsx:137
#: src/features/console/pages/SchemaPage.tsx:301
#: src/features/dashboard/components/AddChartDialog.tsx:733
#: src/features/dashboard/components/AxisConfigurator.tsx:493
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:445
#: src/features/dxf/components/DxfActionsMenu.tsx:115
#: src/features/projects/components/sections/PersonaSection.tsx:373
#: src/features/sales/components/ActivityTimeline.tsx:255
#: src/features/settings/components/NotificationPreferences.tsx:255
#: src/features/settings/components/PresentationTemplates.tsx:885
#: src/features/settings/components/ProfileSettings.tsx:164
#: src/features/skills/components/SkillEditor.tsx:458
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:659
#: src/routes/_authed/workspace/finance.tsx:1182
#: src/routes/_authed/workspace/templates/$kind.tsx:365
msgid "Salva"
msgstr "Salva"

#: src/features/admin/components/AdminPlatformSettings.tsx:998
msgid "Salva ({dirtyCount})"
msgstr "Salva ({dirtyCount})"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:300
#: src/features/console/pages/ResourceAccessPage.tsx:954
msgid "Salva accesso"
msgstr "Salva accesso"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:125
msgid "Salva al massimo 200 aggiunte e 200 rimozioni per volta, poi continua con le altre."
msgstr "Salva al massimo 200 aggiunte e 200 rimozioni per volta, poi continua con le altre."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:355
msgid "Salva alla radice di {providerLabel}."
msgstr "Salva alla radice di {providerLabel}."

#: ../../packages/ui/src/ando/action-drawer/ActionDrawerFooter.tsx:106
#: src/features/admin/components/AdminCpq.tsx:521
msgid "Salva bozza"
msgstr "Salva bozza"

#: src/features/settings/components/BrandKitSettings.tsx:536
msgid "Salva Brand Kit"
msgstr "Salva Brand Kit"

#: src/features/console/components/ByokModal.tsx:108
msgid "Salva chiave"
msgstr "Salva chiave"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:629
msgid "Salva come preset"
msgstr "Salva come preset"

#: src/features/console/components/ProviderAccounts.tsx:200
msgid "Salva delega"
msgstr "Salva delega"

#: src/features/sources/marp/ManualDeckEditMount.tsx:149
msgid "Salva e rigenera"
msgstr "Salva e rigenera"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:207
msgid "Salva esempio"
msgstr "Salva esempio"

#: src/features/sales/components/SignatureSettings.tsx:123
#: src/features/sales/components/SignaturesManager.tsx:274
msgid "Salva firma"
msgstr "Salva firma"

#: src/features/dashboard/components/AddChartDialog.tsx:731
msgid "Salva grafico"
msgstr "Salva grafico"

#: src/features/dashboard/components/AddChartDialog.tsx:430
msgid "Salva il risultato di questa query come grafico in una dashboard."
msgstr "Salva il risultato di questa query come grafico in una dashboard."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:250
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:623
#: ../../packages/ui/src/editors/DraftActionBar.tsx:220
msgid "Salva in"
msgstr "Salva in"

#: src/features/structured-data/components/SaveToDashboardButton.tsx:126
msgid "Salva in dashboard"
msgstr "Salva in dashboard"

#: src/features/sources/components/GoogleChatMessageEditor.tsx:41
msgid "Salva in Google Chat"
msgstr "Salva in Google Chat"

#: src/features/console/docs/content.ts:1463
msgid "Salva la selezione chat"
msgstr "Salva la selezione chat"

#: src/features/console/docs/content.ts:1444
msgid "Salva la selezione Drive"
msgstr "Salva la selezione Drive"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:469
#: src/features/connect/components/ChatbotPanel.tsx:274
msgid "Salva limiti"
msgstr "Salva limiti"

#: src/features/console/connectors/CustomConnectorDetail.tsx:873
msgid "Salva manifest"
msgstr "Salva manifest"

#: src/features/admin/components/GlobalMarkupCard.tsx:138
msgid "Salva markup"
msgstr "Salva markup"

#: src/features/console/components/ModelPickerModal.tsx:238
#: src/features/sales/components/TemplateManager.tsx:354
msgid "Salva modello"
msgstr "Salva modello"

#: src/features/automations/components/CreateAutomationDialog.tsx:260
#: src/features/clean-control/components/policies/PolicyForm.tsx:391
#: src/features/dfm-rules/components/DfmRulesPage.tsx:1034
#: src/features/price-lists/components/PriceListsPage.tsx:1005
#: src/features/settings/components/OrganizationSettings.tsx:285
#: src/features/templates/components/TemplateEditor.tsx:410
#: src/features/voice_report/components/SettingsTab.tsx:218
msgid "Salva modifiche"
msgstr "Salva modifiche"

#: src/features/sales/components/TemplateManager.tsx:287
msgid "Salva nella libreria organizzazione"
msgstr "Salva nella libreria organizzazione"

#: src/features/console/connectors/CustomConnectorDetail.tsx:755
msgid "Salva nome"
msgstr "Salva nome"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:152
msgid "Salva nota"
msgstr "Salva nota"

#: src/features/admin/components/AdminCpqPriceBook.tsx:187
#: src/features/admin/components/PageEditor.tsx:459
msgid "Salva nuova versione"
msgstr "Salva nuova versione"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:215
msgid "Salva password policy"
msgstr "Salva password policy"

#: src/features/dashboard/components/ChartTimeRangeSettings.tsx:55
msgid "Salva periodo"
msgstr "Salva periodo"

#: src/features/admin/components/PageEditor.tsx:364
msgid "Salva prima di aprire l'anteprima"
msgstr "Salva prima di aprire l'anteprima"

#: src/features/console/pages/ResourceAccessPage.tsx:934
msgid "Salva prima la selezione dei contenuti qui sopra."
msgstr "Salva prima la selezione dei contenuti qui sopra."

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:122
msgid "Salva selezione"
msgstr "Salva selezione"

#: src/features/console/webhooks/WebhooksPanel.tsx:283
msgid "Salva subito il signing secret: non sarà più mostrato."
msgstr "Salva subito il signing secret: non sarà più mostrato."

#: src/features/settings/marp/CssUploadPanel.tsx:242
msgid "Salva template"
msgstr "Salva template"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:479
msgid "Salva versione"
msgstr "Salva versione"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:149
msgid "Salva widget"
msgstr "Salva widget"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:86
msgid "Salvare una nuova selezione revoca gli accessi attuali. Dovrai scegliere di nuovo le persone autorizzate."
msgstr "Salvare una nuova selezione revoca gli accessi attuali. Dovrai scegliere di nuovo le persone autorizzate."

#. placeholder {0}: row.version
#: src/features/admin/components/AdminDecks.tsx:532
msgid "Salvata la versione {0}"
msgstr "Salvata la versione {0}"

#: ../../packages/ui/src/editors/DraftActionBar.tsx:315
msgid "Salvataggio della bozza in corso"
msgstr "Salvataggio della bozza in corso"

#: src/features/admin/components/MaintenanceControl.tsx:109
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:189
msgid "Salvataggio fallito"
msgstr "Salvataggio fallito"

#. placeholder {0}: res.status
#: src/features/sources/components/ArtifactPane.tsx:377
#: src/features/sources/components/ArtifactPane.tsx:378
msgid "Salvataggio fallito ({0})"
msgstr "Salvataggio fallito ({0})"

#: src/features/settings/marp/CssUploadPanel.tsx:108
msgid "Salvataggio fallito: {reason}"
msgstr "Salvataggio fallito: {reason}"

#: src/features/sources/components/ArtifactPane.tsx:368
msgid "Salvataggio fallito: backend non raggiungibile."
msgstr "Salvataggio fallito: backend non raggiungibile."

#: src/features/sources/marp/ManualDeckEditMount.tsx:114
msgid "Salvataggio fallito. Riprova."
msgstr "Salvataggio fallito. Riprova."

#: src/features/actions/components/MessageActionChips.tsx:130
#: src/features/actions/components/MessageActionChips.tsx:131
msgid "Salvataggio in corso"
msgstr "Salvataggio in corso"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:222
msgid "Salvataggio in corso…"
msgstr "Salvataggio in corso…"

#: src/features/admin/components/GlobalMarkupCard.tsx:72
msgid "Salvataggio markup fallito"
msgstr "Salvataggio markup fallito"

#: src/features/admin/components/AdminCpq.tsx:384
#: src/features/admin/components/AdminCpqPriceBook.tsx:139
#: src/features/admin/components/AdminDecks.tsx:535
#: src/features/admin/components/AdminPlatformSettings.tsx:963
#: src/features/connectors/components/management/SchemaViewer.tsx:294
#: src/features/console/flows/ConsoleFlowEditor.tsx:129
#: src/features/dashboard/components/AxisConfigurator.tsx:204
#: src/features/dashboard/components/CalculatedFieldEditor.tsx:208
#: src/features/sales/components/SignatureSettings.tsx:53
#: src/features/sales/components/SignaturesManager.tsx:98
#: src/features/sales/components/TemplateManager.tsx:147
#: src/features/sales/hooks/useCrmQueries.ts:133
#: src/features/sales/hooks/useCrmQueries.ts:185
#: src/features/sales/hooks/useCrmQueries.ts:223
#: src/features/settings/components/BrandKitSettings.tsx:184
#: src/routes/_authed/workspace/flows.$flowId.tsx:311
msgid "Salvataggio non riuscito"
msgstr "Salvataggio non riuscito"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:159
#: src/features/connectors/components/management/BusinessContextEditor.tsx:89
#: src/features/connectors/components/management/EditConnectorDialog.tsx:188
msgid "Salvataggio non riuscito."
msgstr "Salvataggio non riuscito."

#: src/features/skills/components/SkillEditor.tsx:233
msgid "Salvataggio non riuscito. Riprova."
msgstr "Salvataggio non riuscito. Riprova."

#: src/features/admin/components/AdminPlatformSettings.tsx:139
msgid "Salvataggio prezzi fallito"
msgstr "Salvataggio prezzi fallito"

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:596
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:414
#: ../../packages/ui/src/editors/XlsxEditorInline.tsx:997
#: src/features/agent-modes/components/AgentModeEditor.tsx:537
#: src/features/automations/components/CreateAutomationDialog.tsx:257
#: src/features/clean-control/components/policies/PolicyForm.tsx:387
#: src/features/console/pages/BillingPage.tsx:160
#: src/features/dashboard/components/AddChartDialog.tsx:733
#: src/features/dxf/components/DxfActionsMenu.tsx:115
#: src/features/sales/components/SignatureSettings.tsx:123
#: src/features/sales/components/SignaturesManager.tsx:274
#: src/features/sales/components/TemplateManager.tsx:354
#: src/features/settings/components/BrandKitSettings.tsx:536
#: src/features/settings/components/NotificationPreferences.tsx:254
#: src/features/settings/components/OrganizationSettings.tsx:284
#: src/features/settings/components/PresentationTemplates.tsx:883
#: src/features/settings/components/ProfileSettings.tsx:164
#: src/features/settings/components/SecuritySettings.tsx:128
#: src/features/settings/marp/CssUploadPanel.tsx:241
#: src/features/skills/components/SkillEditor.tsx:455
#: src/features/sources/components/AISummaryPanel.tsx:548
#: src/features/sources/components/ArtifactPane.tsx:2137
#: src/features/templates/components/TemplateEditor.tsx:410
#: src/routes/_authed/workspace/finance.tsx:1182
#: src/routes/_authed/workspace/templates/$kind.tsx:362
msgid "Salvataggio…"
msgstr "Salvataggio…"

#: src/features/connectors/components/management/SchemaViewer.tsx:336
#: src/features/console/flows/ConsoleFlowEditor.tsx:305
#: src/features/sources/components/ArtifactPane.tsx:393
#: src/routes/_authed/workspace/templates/$kind.tsx:364
msgid "Salvato"
msgstr "Salvato"

#. placeholder {0}: savedAt.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", })
#: src/features/admin/components/AdminPlatformSettings.tsx:186
msgid "Salvato {0}"
msgstr "Salvato {0}"

#: src/features/sources/components/ArtifactPane.tsx:330
msgid "Salvato in Ando, ma non nella sorgente. Ricollega e reimporta il file per identificare l'account originale."
msgstr "Salvato in Ando, ma non nella sorgente. Ricollega e reimporta il file per identificare l'account originale."

#: src/features/admin/components/AdminPlatformSettings.tsx:209
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:972
msgid "Salvo…"
msgstr "Salvo…"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:260
msgid "same Gemini turn"
msgstr "same Gemini turn"

#. placeholder {0}: detail.sample_facts.length
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:313
msgid "Sample facts ({0})"
msgstr "Sample facts ({0})"

#: src/features/connectors/wizards/crmSpec.tsx:82
msgid "Sandbox (solo Salesforce)"
msgstr "Sandbox (solo Salesforce)"

#: src/features/connectors/wizards/crmSpec.tsx:47
msgid "Sandbox + Production, OAuth managed o BYOA"
msgstr "Sandbox + Production, OAuth managed o BYOA"

#: src/features/admin/components/AdminHealth.tsx:86
msgid "Saturazione worker"
msgstr "Saturazione worker"

#: src/features/admin/components/UserDetailContent.tsx:622
msgid "Sblocca"
msgstr "Sblocca"

#: src/features/admin/components/AdminDemoInviti.tsx:232
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:252
#: src/features/connect/components/GrantManager.tsx:245
#: src/features/console/pages/MembersPage.tsx:644
msgid "Scade"
msgstr "Scade"

#. placeholder {0}: formatExpiresAt(s.expires_at, locale)
#. placeholder {1}: s.view_count
#: src/features/voice_report/components/ShareReportDialog.tsx:380
msgid "Scade {0} · {1} aperture"
msgstr "Scade {0} · {1} aperture"

#. placeholder {0}: expiry.value
#: src/features/share/components/ShareLinkRow.tsx:93
msgid "Scade fra {0}g"
msgstr "Scade fra {0}g"

#. placeholder {0}: expiry.value
#: src/features/share/components/ShareLinkRow.tsx:95
msgid "Scade fra {0}h"
msgstr "Scade fra {0}h"

#. placeholder {0}: expiry.value
#: src/features/share/components/ShareLinkRow.tsx:96
msgid "Scade fra {0}m"
msgstr "Scade fra {0}m"

#. placeholder {0}: fmtDate(expiresAt)
#: src/features/admin/components/AdminGatedLinks.tsx:299
msgid "scade il {0}"
msgstr "scade il {0}"

#. placeholder {0}: new Date(job.expires_at).toLocaleString("it-IT", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", })
#: src/features/settings/components/DataExport.tsx:269
msgid "Scade: {0}"
msgstr "Scade: {0}"

#: src/features/console/pages/BillingPage.tsx:335
#: src/features/console/pages/KeyDetailPage.tsx:689
#: src/features/console/pages/KeysPage.tsx:131
#: src/features/console/pages/MembersPage.tsx:615
#: src/features/voice_report/components/ShareReportDialog.tsx:225
#: src/features/workspace/components/TaskComposer.tsx:187
msgid "Scadenza"
msgstr "Scadenza"

#: src/features/connect/components/GrantManager.tsx:599
#: src/features/connect/components/GrantManager.tsx:741
#: src/features/connect/components/GrantManager.tsx:806
#: src/features/console/components/CreateKeyWizard.tsx:291
msgid "Scadenza (opzionale)"
msgstr "Scadenza (opzionale)"

#: src/features/workspace/components/TaskComposer.tsx:196
msgid "Scadenza del task"
msgstr "Scadenza del task"

#: src/features/connect/components/GrantManager.tsx:607
#: src/features/connect/components/GrantManager.tsx:749
#: src/features/connect/components/GrantManager.tsx:814
msgid "Scadenza della condivisione"
msgstr "Scadenza della condivisione"

#: src/features/console/connectors/ConnectionCard.tsx:291
msgid "Scadenza token"
msgstr "Scadenza token"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:51
#: src/features/sources/components/ArtifactPane.tsx:2333
msgid "Scadenze"
msgstr "Scadenze"

#: src/features/connectors/wizards/projectManagementSpec.tsx:71
msgid "Scadenze, assegnatari e stato delle card riassunti al volo."
msgstr "Scadenze, assegnatari e stato delle card riassunti al volo."

#: src/features/connectors/wizards/accountingSpec.tsx:125
msgid "Scadenziario proattivo"
msgstr "Scadenziario proattivo"

#: src/routes/_authed/workspace/finance.tsx:934
msgid "scaduta"
msgstr "scaduta"

#: src/features/console/components/KeyMeta.tsx:35
msgid "Scaduta"
msgstr "Scaduta"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:68
msgid "Scaduti"
msgstr "Scaduti"

#: src/features/admin/components/AdminGatedLinks.tsx:295
msgid "scaduto"
msgstr "scaduto"

#: src/features/admin/components/AdminDemoInviti.tsx:44
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:77
#: src/features/console/pages/MembersPage.tsx:644
#: src/features/share/components/ShareLinkRow.tsx:91
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:50
msgid "Scaduto"
msgstr "Scaduto"

#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:104
msgid "scaduto da {expiredDays}g"
msgstr "scaduto da {expiredDays}g"

#: src/features/settings/components/SecuritySettings.tsx:245
msgid "Scansiona il QR-code (o copia il segreto) nella tua app di autenticazione, poi inserisci il codice a 6 cifre."
msgstr "Scansiona il QR-code (o copia il segreto) nella tua app di autenticazione, poi inserisci il codice a 6 cifre."

#: src/features/sales/hooks/useCrmQueries.ts:289
msgid "Scansione non riuscita"
msgstr "Scansione non riuscita"

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:363
#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:337
#: ../../packages/ui/src/editors/ImageViewerInline.tsx:143
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:367
#: src/features/hive-flows/run/RunDocumentViewer.tsx:171
#: src/features/settings/components/BrandKitSettings.tsx:381
#: src/features/sources/components/ArtifactPane.tsx:1102
#: src/features/sources/components/ArtifactPane.tsx:1954
#: src/features/sources/components/EmailAttachmentChip.tsx:190
msgid "Scarica"
msgstr "Scarica"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:716
msgid "Scarica .pptx (editabile)"
msgstr "Scarica .pptx (editabile)"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:699
msgid "Scarica .pptx (presentazione)"
msgstr "Scarica .pptx (presentazione)"

#. placeholder {0}: attachment.filename
#. placeholder {0}: filename ?? i18n._(msg`disegno`)
#. placeholder {0}: filename ?? i18n._(msg`modello`)
#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:356
#: ../../packages/ui/src/cad/parsers/StepViewer.tsx:330
#: src/features/sources/components/ArtifactPane.tsx:1950
#: src/features/sources/components/ArtifactPane.tsx:1981
#: src/features/sources/components/EmailAttachmentChip.tsx:186
msgid "Scarica {0}"
msgstr "Scarica {0}"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:436
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:441
msgid "Scarica anteprima"
msgstr "Scarica anteprima"

#: src/features/settings/components/DataExport.tsx:293
msgid "Scarica archivio"
msgstr "Scarica archivio"

#: src/features/hive-flows/run/ProposalReview.tsx:870
msgid "Scarica Excel"
msgstr "Scarica Excel"

#: src/features/settings/MarpTemplateSettings.tsx:205
msgid "Scarica il <0>.pptx</0> che preferisci, poi caricalo nella sezione sottostante per convertirlo nel tuo theme Ando personalizzato."
msgstr "Scarica il <0>.pptx</0> che preferisci, poi caricalo nella sezione sottostante per convertirlo nel tuo theme Ando personalizzato."

#: ../../packages/ui/src/editors/ImageViewerInline.tsx:142
msgid "Scarica immagine"
msgstr "Scarica immagine"

#: src/features/settings/components/DataExport.tsx:290
msgid "Scarica l'archivio dei tuoi dati"
msgstr "Scarica l'archivio dei tuoi dati"

#: src/features/dxf/components/DxfActionsMenu.tsx:135
#: src/features/sources/components/ArtifactPane.tsx:1890
msgid "Scarica originale"
msgstr "Scarica originale"

#: src/features/console/pages/TracesPage.tsx:163
msgid "Scarica payload completo"
msgstr "Scarica payload completo"

#: ../../packages/ui/src/editors/PDFViewerInline.tsx:366
#: src/features/console/pages/BillingPage.tsx:638
msgid "Scarica PDF"
msgstr "Scarica PDF"

#. placeholder {0}: inv.number ?? inv.id
#: src/features/admin/components/orgs/OrgBillingTab.tsx:642
msgid "Scarica PDF fattura {0}"
msgstr "Scarica PDF fattura {0}"

#: src/features/billing/components/InvoicesTable.tsx:160
msgid "Scarica PDF fattura {invoiceRef}"
msgstr "Scarica PDF fattura {invoiceRef}"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:435
msgid "Scarica PPTX"
msgstr "Scarica PPTX"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:440
msgid "Scarica PPTX (modificabile)"
msgstr "Scarica PPTX (modificabile)"

#: src/features/console/pages/TracesPage.tsx:522
msgid "Scarica trace completo"
msgstr "Scarica trace completo"

#: src/features/dxf/components/DxfBomButton.tsx:69
msgid "Scaricato"
msgstr "Scaricato"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:160
msgid "Scarico l'anteprima dal cloud…"
msgstr "Scarico l'anteprima dal cloud…"

#: src/features/admin/components/AdminCpqAskAndo.tsx:333
#: src/features/admin/components/AdminDecksAskAndo.tsx:214
#: src/features/sources/components/AISummaryPanel.tsx:636
#: src/features/sources/components/ArtifactPane.tsx:2131
#: src/features/workspace/components/NudgeClusterRow.tsx:280
#: src/features/workspace/components/TaskSimpleRow.tsx:344
msgid "Scarta"
msgstr "Scarta"

#: src/features/templates/components/TemplateEditor.tsx:440
msgid "Scarta e torna alla lista"
msgstr "Scarta e torna alla lista"

#: src/features/sources/components/ArtifactPane.tsx:1593
msgid "Scarta la proposta in sospeso su questo documento"
msgstr "Scarta la proposta in sospeso su questo documento"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:463
msgid "Scarta modifiche"
msgstr "Scarta modifiche"

#: src/features/sources/components/AISummaryPanel.tsx:559
#: src/features/sources/components/ArtifactPane.tsx:1626
#: src/features/sources/components/ArtifactPane.tsx:2114
#: src/features/workspace/components/TaskSimpleRow.tsx:336
msgid "Scarta proposta"
msgstr "Scarta proposta"

#: src/features/workspace/components/NudgeClusterRow.tsx:280
msgid "Scarta tutte ({size})"
msgstr "Scarta tutte ({size})"

#: src/features/sources/components/AISummaryPanel.tsx:610
#: src/features/sources/components/ArtifactPane.tsx:2109
#: src/features/sources/components/ArtifactPane.tsx:2110
msgid "Scartare l’intera proposta?"
msgstr "Scartare l’intera proposta?"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:123
msgid "Scatter"
msgstr "Scatter"

#: src/features/console/docs/content.ts:1425
msgid "Scegli 7, 30 o 90 giorni, oppure due date con intervallo massimo di 90 giorni. L'impostazione vale anche per le sincronizzazioni automatiche successive."
msgstr "Scegli 7, 30 o 90 giorni, oppure due date con intervallo massimo di 90 giorni. L'impostazione vale anche per le sincronizzazioni automatiche successive."

#: src/features/console/connectors/PersonalCalendarSelection.tsx:168
msgid "Scegli almeno un calendario e almeno un giorno. Ogni direzione può avere da 0 a 365 giorni."
msgstr "Scegli almeno un calendario e almeno un giorno. Ogni direzione può avere da 0 a 365 giorni."

#: src/features/console/pages/ResourceAccessPage.tsx:959
msgid "Scegli almeno una persona, oppure seleziona «Solo proprietario»."
msgstr "Scegli almeno una persona, oppure seleziona «Solo proprietario»."

#: src/features/console/pages/ResourceAccessPage.tsx:687
msgid "Scegli almeno una tabella."
msgstr "Scegli almeno una tabella."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:569
msgid "Scegli cartella"
msgstr "Scegli cartella"

#: src/features/console/docs/content.ts:1463
msgid "Scegli chat_ids; il valore all autorizza tutte le chat personali accessibili. Un array vuoto disattiva la scansione."
msgstr "Scegli chat_ids; il valore all autorizza tutte le chat personali accessibili. Un array vuoto disattiva la scansione."

#: src/features/console/pages/ResourceAccessPage.tsx:235
msgid "Scegli chi può trovare e leggere questo documento nelle risposte di Engine."
msgstr "Scegli chi può trovare e leggere questo documento nelle risposte di Engine."

#: src/features/console/pages/ResourceAccessPage.tsx:236
msgid "Scegli chi può usare questa connessione nelle risposte di Engine."
msgstr "Scegli chi può usare questa connessione nelle risposte di Engine."

#: src/features/connectors/enterprise-db-bridge/DeploymentModeChooser.tsx:87
msgid "Scegli come Ando raggiungerà il tuo database. Puoi cambiare in seguito dalla card del connettore."
msgstr "Scegli come Ando raggiungerà il tuo database. Puoi cambiare in seguito dalla card del connettore."

#: src/features/connectors/wizards/filesystemSpec.tsx:128
msgid "Scegli con chi condividere l'accesso ai documenti."
msgstr "Scegli con chi condividere l'accesso ai documenti."

#: src/features/connect/components/GrantManager.tsx:317
msgid "Scegli cosa condividere. Gli ospiti potranno interrogare solo le fonti che aggiungi qui, sempre in sola lettura."
msgstr "Scegli cosa condividere. Gli ospiti potranno interrogare solo le fonti che aggiungi qui, sempre in sola lettura."

#: src/features/console/pages/ResourceAccessPage.tsx:362
msgid "Scegli cosa possono trovare gli altri"
msgstr "Scegli cosa possono trovare gli altri"

#: src/features/console/pages/KeyDetailPage.tsx:153
msgid "Scegli cosa può fare questa chiave. La modifica non genera un nuovo segreto."
msgstr "Scegli cosa può fare questa chiave. La modifica non genera un nuovo segreto."

#: src/features/dashboard/components/AddWidgetWizard.tsx:278
msgid "Scegli da dove arrivano i dati del widget."
msgstr "Scegli da dove arrivano i dati del widget."

#: src/features/connectors/wizards/spreadsheetSpec.tsx:173
msgid "Scegli da dove importare il foglio di calcolo."
msgstr "Scegli da dove importare il foglio di calcolo."

#: src/features/connectors/wizards/cadLibrarySpec.tsx:120
msgid "Scegli da dove portare i file CAD."
msgstr "Scegli da dove portare i file CAD."

#: ../../packages/ui/src/ando/email/EmailAttachmentField.tsx:390
msgid "Scegli dai documenti Ando"
msgstr "Scegli dai documenti Ando"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:85
msgid "Scegli dalla knowledge già sincronizzata. I nuovi contenuti restano privati finché non li selezioni; gli aggiornamenti di quelli selezionati restano condivisi. La scelta non cambia il sync né dà accesso all'account originale."
msgstr "Scegli dalla knowledge già sincronizzata. I nuovi contenuti restano privati finché non li selezioni; gli aggiornamenti di quelli selezionati restano condivisi. La scelta non cambia il sync né dà accesso all'account originale."

#: src/features/console/pages/ConnectorsPage.tsx:456
msgid "Scegli file e cartelle"
msgstr "Scegli file e cartelle"

#: src/features/console/docs/content.ts:1444
msgid "Scegli folder_ids e file_ids. Il valore root in folder_ids autorizza la scansione dell'intero Drive accessibile. Due array vuoti disattivano la scansione."
msgstr "Scegli folder_ids e file_ids. Il valore root in folder_ids autorizza la scansione dell'intero Drive accessibile. Due array vuoti disattivano la scansione."

#: src/features/console/pages/ResourceAccessPage.tsx:375
msgid "Scegli gli utenti della tua app"
msgstr "Scegli gli utenti della tua app"

#: src/features/console/connectors/PersonalCalendarSelection.tsx:99
msgid "Scegli i calendari e il periodo. Salvare programma la sincronizzazione dei calendari selezionati."
msgstr "Scegli i calendari e il periodo. Salvare programma la sincronizzazione dei calendari selezionati."

#: src/features/dashboard/components/AxisConfigurator.tsx:224
msgid "Scegli i dati da mostrare e le opzioni disponibili per questa visualizzazione."
msgstr "Scegli i dati da mostrare e le opzioni disponibili per questa visualizzazione."

#: src/features/dashboard/components/ChartConfigurationMenu.tsx:69
msgid "Scegli i dati e il loro aspetto nel grafico"
msgstr "Scegli i dati e il loro aspetto nel grafico"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:690
msgid "Scegli il motore del database — il resto della procedura cambia in base al dialetto."
msgstr "Scegli il motore del database — il resto della procedura cambia in base al dialetto."

#: src/features/console/components/ModelPickerModal.tsx:218
msgid "Scegli il profilo AI"
msgstr "Scegli il profilo AI"

#: src/features/hive-flows/components/FlowShareControl.tsx:152
msgid "Scegli il progetto"
msgstr "Scegli il progetto"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:423
msgid "Scegli il servizio da collegare."
msgstr "Scegli il servizio da collegare."

#: src/features/console/connectors/StructuredConnectorSetup.tsx:421
msgid "Scegli il servizio email da collegare."
msgstr "Scegli il servizio email da collegare."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:270
msgid "Scegli il sito"
msgstr "Scegli il sito"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:644
msgid "Scegli il tipo di database"
msgstr "Scegli il tipo di database"

#: src/features/console/pages/ConnectorsPage.tsx:477
msgid "Scegli il tipo di dato. Puoi gestire sincronizzazione e stato dopo il collegamento."
msgstr "Scegli il tipo di dato. Puoi gestire sincronizzazione e stato dopo il collegamento."

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:266
msgid "Scegli l'accesso"
msgstr "Scegli l'accesso"

#: src/features/dashboard/components/ChartTimeRangeSettings.tsx:41
msgid "Scegli la colonna data e il periodo. Le modifiche vengono salvate sul grafico."
msgstr "Scegli la colonna data e il periodo. Le modifiche vengono salvate sul grafico."

#: ../../packages/ui/src/ando/email/EmailSignatureFooter.tsx:92
msgid "Scegli la firma"
msgstr "Scegli la firma"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:272
msgid "Scegli la raccolta"
msgstr "Scegli la raccolta"

#: src/features/connectors/wizards/openBankingSpec.tsx:177
msgid "Scegli la tua banca dall'elenco PSD2 supportato."
msgstr "Scegli la tua banca dall'elenco PSD2 supportato."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:273
msgid "Scegli le cartelle (sync ricorsivo)"
msgstr "Scegli le cartelle (sync ricorsivo)"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:334
msgid "Scegli mese"
msgstr "Scegli mese"

#: src/features/clean-control/components/ModeToggle.tsx:51
msgid "Scegli modalità"
msgstr "Scegli modalità"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:403
msgid "Scegli prima un account nel campo sopra per cercare tra i tuoi contatti. Per ora puoi digitare email libere e premere Invio."
msgstr "Scegli prima un account nel campo sopra per cercare tra i tuoi contatti. Per ora puoi digitare email libere e premere Invio."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:305
#: src/features/connectors/components/FilesystemConnectDialog.tsx:394
msgid "Scegli prima una cartella."
msgstr "Scegli prima una cartella."

#: src/features/sales/components/SignaturesManager.tsx:316
msgid "Scegli quale firma usare per ogni casella collegata. \"Predefinita globale\" segue la firma predefinita."
msgstr "Scegli quale firma usare per ogni casella collegata. \"Predefinita globale\" segue la firma predefinita."

#: src/features/connectors/wizards/spreadsheetSpec.tsx:192
msgid "Scegli quali fogli del workbook importare — tabelle separate per AI."
msgstr "Scegli quali fogli del workbook importare — tabelle separate per AI."

#: src/features/settings/components/NotificationPreferences.tsx:263
msgid "Scegli quali notifiche proattive vuoi ricevere da Ando e con quale frequenza. Le impostazioni si applicano alla prossima notifica."
msgstr "Scegli quali notifiche proattive vuoi ricevere da Ando e con quale frequenza. Le impostazioni si applicano alla prossima notifica."

#: src/features/hive-flows/components/FlowActivateControl.tsx:235
msgid "Scegli quando eseguire il flow in automatico. Potrai metterlo in pausa quando vuoi."
msgstr "Scegli quando eseguire il flow in automatico. Potrai metterlo in pausa quando vuoi."

#: src/features/voice_report/components/NewReportDialog.tsx:594
msgid "Scegli un dataset, descrivi cosa vuoi indagare e Ando lo trasformerà in un report citabile."
msgstr "Scegli un dataset, descrivi cosa vuoi indagare e Ando lo trasformerà in un report citabile."

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:115
msgid "Scegli un file sul tuo account {providerLabel} collegato. Ando legge solo i file che selezioni."
msgstr "Scegli un file sul tuo account {providerLabel} collegato. Ando legge solo i file che selezioni."

#: src/features/console/pages/ResourceAccessPage.tsx:738
msgid "Scegli un membro"
msgstr "Scegli un membro"

#: src/features/console/components/ModelPickerModal.tsx:223
msgid "Scegli un modello dei provider collegati per {purposeLabel}. Il profilo resta inattivo fino alla tua attivazione."
msgstr "Scegli un modello dei provider collegati per {purposeLabel}. Il profilo resta inattivo fino alla tua attivazione."

#: src/routes/_authed/workspace/templates/$kind.tsx:172
msgid "Scegli un template dalla lista per iniziare a modificarlo, oppure creane uno nuovo."
msgstr "Scegli un template dalla lista per iniziare a modificarlo, oppure creane uno nuovo."

#: src/features/console/pages/ResourceAccessPage.tsx:815
msgid "Scegli un utente"
msgstr "Scegli un utente"

#: src/features/console/pages/ResourceAccessPage.tsx:799
msgid "Scegli un'app"
msgstr "Scegli un'app"

#: src/features/sales/components/CreateLeadDialog.tsx:139
msgid "Scegli una campagna…"
msgstr "Scegli una campagna…"

#: src/features/connectors/wizards/filesystemSpec.tsx:118
msgid "Scegli una cartella del tuo computer o un'unità di rete montata."
msgstr "Scegli una cartella del tuo computer o un'unità di rete montata."

#: src/features/connectors/components/FilesystemConnectDialog.tsx:546
msgid "Scegli una cartella sul tuo computer. Ando indicizza i documenti che contiene (PDF, Word, Excel, PowerPoint, testo) senza spostarli."
msgstr "Scegli una cartella sul tuo computer. Ando indicizza i documenti che contiene (PDF, Word, Excel, PowerPoint, testo) senza spostarli."

#: src/features/console/pages/SchemaPage.tsx:1011
msgid "Scegli una sorgente"
msgstr "Scegli una sorgente"

#: src/features/sales/components/crm/RecordDrawer.tsx:326
msgid "Scegli…"
msgstr "Scegli…"

#: src/features/connectors/wizards/driveSpec.tsx:98
msgid "Sceglierai dopo quali cartelle / pagine indicizzare."
msgstr "Sceglierai dopo quali cartelle / pagine indicizzare."

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:282
msgid "Scelta registrata. Ando riprende l'analisi."
msgstr "Scelta registrata. Ando riprende l'analisi."

#: src/features/admin/components/AdminCpqAskAndo.tsx:183
msgid "Scelte del cliente"
msgstr "Scelte del cliente"

#: src/features/console/pages/SchemaPage.tsx:878
#: src/features/console/pages/SchemaPage.tsx:907
#: src/features/integrations/parts/ConnectorDetailSection.tsx:111
msgid "Schema"
msgstr "Schema"

#: src/features/console/components/ConsoleShell.tsx:216
msgid "Schema ({UKS})"
msgstr "Schema ({UKS})"

#: src/features/connectors/wizards/databaseSpec.tsx:247
#: src/features/connectors/wizards/erpSpec.tsx:187
msgid "Schema auto-discovery"
msgstr "Schema auto-discovery"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:320
msgid "Schema dei parametri (JSON Schema, opzionale)"
msgstr "Schema dei parametri (JSON Schema, opzionale)"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:71
msgid "Schema non valido: inserisci un oggetto JSON."
msgstr "Schema non valido: inserisci un oggetto JSON."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:177
msgid "Schema pronto"
msgstr "Schema pronto"

#: src/features/console/connectors/ConnectionCard.tsx:320
msgid "Schema rilevato"
msgstr "Schema rilevato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:428
#: src/features/admin/components/deckEditor/DeckEditor.tsx:429
#: src/features/admin/components/deckEditor/DeckEditor.tsx:432
#: src/features/chat/components/LayoutSwitcher.tsx:56
#: src/features/chat/components/SmartLayoutHint.tsx:152
msgid "Schermo intero"
msgstr "Schermo intero"

#: src/features/console/connectors/ConnectionCard.tsx:412
#: src/features/console/pages/ConnectorDetailPage.tsx:604
#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
msgid "Scollega"
msgstr "Scollega"

#: src/features/console/docs/content.ts:1495
msgid "Scollega un account"
msgstr "Scollega un account"

#: src/features/console/pages/ConnectorDetailPage.tsx:585
msgid "Scollegare questa connessione?"
msgstr "Scollegare questa connessione?"

#: src/features/chat/hooks/useThinkingHops.ts:58
msgid "Scompongo la richiesta"
msgstr "Scompongo la richiesta"

#: src/features/chat/wsHandlers.ts:489
msgid "Scompongo la richiesta…"
msgstr "Scompongo la richiesta…"

#: src/features/admin/components/AdminOrgs.tsx:670
#: src/features/admin/components/AdminOrgs.tsx:767
msgid "Sconosciuta"
msgstr "Sconosciuta"

#: src/features/workspace/components/UploadModal.tsx:147
msgid "sconosciuto"
msgstr "sconosciuto"

#: src/features/automations/components/AutomationStatusChip.tsx:42
msgid "Sconosciuto"
msgstr "Sconosciuto"

#: src/features/admin/components/AdminCpq.tsx:169
msgid "Sconto 3 anni"
msgstr "Sconto 3 anni"

#: src/features/admin/components/AdminCpqPriceBook.tsx:224
msgid "Sconto 3 anni %"
msgstr "Sconto 3 anni %"

#: src/features/admin/components/AdminCpq.tsx:894
#: src/features/admin/components/AdminCpqAskAndo.tsx:178
msgid "Sconto rivenditore %"
msgstr "Sconto rivenditore %"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:47
msgid "Sconto rivenditore impostato senza software house."
msgstr "Sconto rivenditore impostato senza software house."

#: src/features/admin/components/AdminCpqPriceBook.tsx:225
msgid "Sconto rivenditore predefinito %"
msgstr "Sconto rivenditore predefinito %"

#. placeholder {0}: recipient.reseller_discount_pct ?? 0
#: src/features/admin/components/AdminCpq.tsx:198
msgid "Sconto rivenditore sulle licenze ({0}%)"
msgstr "Sconto rivenditore sulle licenze ({0}%)"

#: src/features/agent-modes/components/AgentModeEditor.tsx:356
#: src/features/console/pages/DocsPage.tsx:123
#: src/features/console/pages/KeyDetailPage.tsx:674
#: src/features/console/pages/KeysPage.tsx:122
#: src/features/settings/marp/CssUploadPanel.tsx:196
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:206
msgid "Scope"
msgstr "Scope"

#: src/features/console/components/CreateKeyWizard.tsx:353
msgid "Scope — cosa può fare questa chiave"
msgstr "Scope — cosa può fare questa chiave"

#: src/features/voice_report/components/DatasetTab.tsx:80
msgid "Scope del dataset"
msgstr "Scope del dataset"

#: src/features/console/docs/content.ts:1993
msgid "Scope mancante (il message elenca quali)."
msgstr "Scope mancante (il message elenca quali)."

#: src/features/console/components/KeyMeta.tsx:176
msgid "Scope negato"
msgstr "Scope negato"

#: src/features/templates/components/TemplateEditor.tsx:377
msgid "Scope:"
msgstr "Scope:"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:172
msgid "Scoperta schema"
msgstr "Scoperta schema"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:179
msgid "Scoperta schema in corso"
msgstr "Scoperta schema in corso"

#: src/features/console/pages/PlaygroundPage.tsx:870
msgid "Scoperta sistemi"
msgstr "Scoperta sistemi"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:189
msgid "Scopri"
msgstr "Scopri"

#: src/features/settings/MarpTemplateSettings.tsx:156
msgid "Scopri template premium"
msgstr "Scopri template premium"

#: src/features/console/docs/content.ts:1753
msgid "Scorciatoia di query con mode=\"answer\": risposta sintetizzata + citazioni."
msgstr "Scorciatoia di query con mode=\"answer\": risposta sintetizzata + citazioni."

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:121
#: src/features/structured-data/components/SimilarPartsSection.tsx:487
msgid "Score visuale Gemini Vision"
msgstr "Score visuale Gemini Vision"

#: ../../packages/ui/src/ando/SourceDrawer.tsx:271
msgid "Scorri alla zona citata"
msgstr "Scorri alla zona citata"

#: src/features/workspace/components/WorkspaceTabs.tsx:466
msgid "Scorri le categorie verso destra"
msgstr "Scorri le categorie verso destra"

#: src/features/workspace/components/WorkspaceTabs.tsx:454
msgid "Scorri le categorie verso sinistra"
msgstr "Scorri le categorie verso sinistra"

#: src/features/console/pages/DevelopersPage.tsx:99
msgid "Scrittura"
msgstr "Scrittura"

#: src/features/console/pages/ModelsPage.tsx:319
msgid "Scrive la risposta a partire dalle fonti trovate."
msgstr "Scrive la risposta a partire dalle fonti trovate."

#: src/routes/_authed/_modal/settings/help.tsx:173
msgid "Scrivi a {SUPPORT_EMAIL}"
msgstr "Scrivi a {SUPPORT_EMAIL}"

#: src/features/sales/components/LeadDetailDrawer.tsx:239
#: src/features/sales/components/LeadsPanel.tsx:509
msgid "Scrivi a freddo"
msgstr "Scrivi a freddo"

#: src/features/sources/components/InboxDetailPane.tsx:2189
msgid "Scrivi con Ando"
msgstr "Scrivi con Ando"

#: ../../packages/ui/src/editors/RegionEditPill.tsx:129
msgid "Scrivi cosa modificare (es. 'rendi più formale')."
msgstr "Scrivi cosa modificare (es. 'rendi più formale')."

#: src/features/chat/components/ChatEmptyState.tsx:119
msgid "Scrivi follow-up"
msgstr "Scrivi follow-up"

#: ../../packages/ui/src/ando/email/EmailComposeSheet.tsx:245
msgid "Scrivi il messaggio…"
msgstr "Scrivi il messaggio…"

#: ../../packages/ui/src/editors/MarpDeckEditor.tsx:649
msgid "Scrivi il tuo deck in Marp markdown..."
msgstr "Scrivi il tuo deck in Marp markdown..."

#: src/features/sources/components/InboxDetailPane.tsx:1843
msgid "Scrivi la bozza con Ando"
msgstr "Scrivi la bozza con Ando"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:327
#: src/features/sources/components/InboxDetailPane.tsx:1902
msgid "Scrivi la tua risposta…"
msgstr "Scrivi la tua risposta…"

#: ../../packages/ui/src/ando/actions/EmailSendDraftPreview.tsx:554
msgid "Scrivi qui il corpo dell'email…"
msgstr "Scrivi qui il corpo dell'email…"

#: ../../packages/ui/src/ando/actions/PecSendPreview.tsx:386
msgid "Scrivi qui il corpo della PEC…"
msgstr "Scrivi qui il corpo della PEC…"

#: ../../packages/ui/src/ando/actions/SendMessagePreview.tsx:172
msgid "Scrivi qui il messaggio…"
msgstr "Scrivi qui il messaggio…"

#: ../../packages/ui/src/editors/DocxEditorInline.tsx:575
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:405
#: ../../packages/ui/src/editors/XlsxEditorInline.tsx:988
msgid "Scrivi qui o chiedi ad Ando"
msgstr "Scrivi qui o chiedi ad Ando"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:249
msgid "Scrivi SQL"
msgstr "Scrivi SQL"

#: src/features/chat/components/ChatEmptyState.tsx:120
msgid "Scrivi un follow-up alle email che aspettano una mia risposta."
msgstr "Scrivi un follow-up alle email che aspettano una mia risposta."

#: src/features/chat/components/ChatEmptyState.tsx:204
msgid "Scrivi un follow-up alle opportunità ferme da più di una settimana."
msgstr "Scrivi un follow-up alle opportunità ferme da più di una settimana."

#: src/features/connect/components/ConnectMessageThread.tsx:196
#: src/routes/connect.chatbot.$publicToken.tsx:177
msgid "Scrivi un messaggio…"
msgstr "Scrivi un messaggio…"

#: src/features/sales/components/LeadsPanel.tsx:211
msgid "Scrivi un'email a freddo a {who} per presentare i nostri servizi. Tono professionale, breve, una sola call to action."
msgstr "Scrivi un'email a freddo a {who} per presentare i nostri servizi. Tono professionale, breve, una sola call to action."

#: src/features/connect/components/ConnectChat.tsx:333
msgid "Scrivi una domanda…"
msgstr "Scrivi una domanda…"

#: src/features/skills/components/SkillEditor.tsx:395
msgid "Scrivi una frase e premi Invio"
msgstr "Scrivi una frase e premi Invio"

#: src/features/console/pages/PlaygroundPage.tsx:1787
msgid "Scrivi una query e premi Invio oppure Esegui per interrogare il runtime."
msgstr "Scrivi una query e premi Invio oppure Esegui per interrogare il runtime."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:217
#: src/features/settings/MarpTemplateSettings.tsx:230
msgid "Scuri"
msgstr "Scuri"

#: src/features/settings/components/ProfileSettings.tsx:145
#: src/features/settings/MarpTemplateSettings.tsx:297
msgid "Scuro"
msgstr "Scuro"

#: src/features/workspace/finance/components/FinanceConnectionRow.tsx:64
msgid "SDI"
msgstr "SDI"

#: src/features/connectors/components/vendorIcons.tsx:171
msgid "SDI Fatturazione"
msgstr "SDI Fatturazione"

#: src/features/connectors/components/vendorIcons.tsx:504
msgid "SDI Fatturazione Elettronica"
msgstr "SDI Fatturazione Elettronica"

#: src/features/console/pages/DocsPage.tsx:676
msgid "SDK Python ufficiale (<0>ando</0>, solo httpx). I nomi dei metodi sono quelli spediti."
msgstr "SDK Python ufficiale (<0>ando</0>, solo httpx). I nomi dei metodi sono quelli spediti."

#: src/features/dashboard/utils/calculatedFields.ts:102
msgid "Se (IF)"
msgstr "Se (IF)"

#: src/features/clean-control/components/EventDetailSheet.tsx:378
#: src/features/clean-control/components/EventRow.tsx:455
msgid "Se Ando fosse in automatico"
msgstr "Se Ando fosse in automatico"

#: src/features/connect/components/MemberManager.tsx:464
msgid "Se è già su Ando, ottiene l'accesso subito e riceve una notifica. Altrimenti gli arriva un link magico via email."
msgstr "Se è già su Ando, ottiene l'accesso subito e riceve una notifica. Altrimenti gli arriva un link magico via email."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:522
msgid "Se hai un account aziendale, ricollegalo dalla pagina Integrazioni. Se invece serve OneDrive, scegli il connettore dedicato."
msgstr "Se hai un account aziendale, ricollegalo dalla pagina Integrazioni. Se invece serve OneDrive, scegli il connettore dedicato."

#: src/features/settings/components/OrgMembersPanel.tsx:520
msgid "Se l'indirizzo email è già associato a un account Ando il membro sarà aggiunto subito. Altrimenti creiamo un invito in sospeso."
msgstr "Se l'indirizzo email è già associato a un account Ando il membro sarà aggiunto subito. Altrimenti creiamo un invito in sospeso."

#: src/features/connectors/wizards/sdiSpec.tsx:83
msgid "Se non hai un codice SDI dedicato lascia 0000000: il SDI userà la PEC che hai collegato come canale di consegna."
msgstr "Se non hai un codice SDI dedicato lascia 0000000: il SDI userà la PEC che hai collegato come canale di consegna."

#: src/features/admin/components/AdminPlatformSettings.tsx:916
msgid "Search power"
msgstr "Search power"

#: src/features/settings/components/SecuritySettings.tsx:162
msgid "Secondo fattore (TOTP)"
msgstr "Secondo fattore (TOTP)"

#: src/features/console/connectors/ManifestConfigForm.tsx:142
msgid "Secret"
msgstr "Secret"

#: src/features/console/connectors/CustomConnectorDetail.tsx:645
msgid "Secret mancante"
msgstr "Secret mancante"

#: src/features/console/connectors/CustomConnectorDetail.tsx:641
msgid "Secret sigillato"
msgstr "Secret sigillato"

#: src/features/workspace/components/NotificationPill.tsx:258
#: src/features/workspace/components/NudgeClusterRow.tsx:272
msgid "Segna come letta"
msgstr "Segna come letta"

#: src/features/workspace/components/InboxItemRow.tsx:232
msgid "Segna come letto"
msgstr "Segna come letto"

#: src/features/workspace/components/InboxItemRow.tsx:232
msgid "Segna come non letto"
msgstr "Segna come non letto"

#: src/features/workspace/inbox/components/InboxBulkActionBar.tsx:54
msgid "Segna letta"
msgstr "Segna letta"

#: src/features/workspace/components/NudgeClusterRow.tsx:271
msgid "Segna tutte come lette ({size})"
msgstr "Segna tutte come lette ({size})"

#: src/features/clean-control/utils/signalCatalog.ts:152
#: src/features/clean-control/utils/signalCatalog.ts:165
#: src/features/clean-control/utils/signalCatalog.ts:178
msgid "Segnala emittente"
msgstr "Segnala emittente"

#: src/features/clean-control/utils/labels.ts:120
msgid "Segnala per revisione"
msgstr "Segnala per revisione"

#: src/features/clean-control/components/EventRow.tsx:585
msgid "Segnala questo evento come falso positivo"
msgstr "Segnala questo evento come falso positivo"

#: src/features/clean-control/components/EventRow.tsx:569
msgid "Segnala questo evento come utile"
msgstr "Segnala questo evento come utile"

#: src/routes/_authed/_modal/settings/help.tsx:183
msgid "Segnala un bug critico"
msgstr "Segnala un bug critico"

#: src/features/clean-control/components/policies/PolicyForm.tsx:220
msgid "Segnale"
msgstr "Segnale"

#: src/features/admin/components/AdminEngagement.tsx:172
msgid "Segnale churn precoce — WAU vs WAU precedente"
msgstr "Segnale churn precoce — WAU vs WAU precedente"

#: src/features/settings/components/SecuritySettings.tsx:258
msgid "Segreto (fallback manuale)"
msgstr "Segreto (fallback manuale)"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:516
msgid "Segui le run dallo storico"
msgstr "Segui le run dallo storico"

#: src/features/workspace/components/NotificationPill.tsx:213
msgid "Sei in pari ✨"
msgstr "Sei in pari ✨"

#: src/routes/connect.invite.$token.tsx:119
msgid "Sei stato invitato a collaborare in"
msgstr "Sei stato invitato a collaborare in"

#: src/features/console/pages/DevelopersPage.tsx:215
msgid "Sei strumenti: quattro letture sul tuo {UKS}, una per scoprire le azioni consentite e una per eseguire un'azione verso i tuoi connettori, con guardrail di rischio."
msgstr "Sei strumenti: quattro letture sul tuo {UKS}, una per scoprire le azioni consentite e una per eseguire un'azione verso i tuoi connettori, con guardrail di rischio."

#: src/features/agent-modes/components/AgentModeEditor.tsx:485
msgid "Sei un assistente specializzato in…"
msgstr "Sei un assistente specializzato in…"

#: src/features/connectors/wizards/driveSpec.tsx:106
msgid "Selective sync"
msgstr "Selective sync"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:273
msgid "Selettore colore accent"
msgstr "Selettore colore accent"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:245
msgid "Selettore colore primario"
msgstr "Selettore colore primario"

#. placeholder {0}: doc.title || doc.filename
#. placeholder {0}: item.subject || item.sender_display || t`messaggio`
#. placeholder {0}: m.email ?? m.user_id
#: src/features/admin/components/AdminOrgs.tsx:1498
#: src/features/admin/components/orgs/OrgMembersTab.tsx:405
#: src/features/sales/components/LeadsPanel.tsx:433
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:726
#: src/features/workspace/components/InboxItemRow.tsx:292
#: src/features/workspace/documents/components/DocumentCardV2.tsx:354
msgid "Seleziona {0}"
msgstr "Seleziona {0}"

#. placeholder {0}: node.name
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:725
msgid "Seleziona {0} (~{fileCount} file)"
msgstr "Seleziona {0} (~{fileCount} file)"

#: src/routes/_authed/workspace/conversations.tsx:835
msgid "Seleziona account conversazioni"
msgstr "Seleziona account conversazioni"

#: src/features/sync/components/DocSyncManager.tsx:295
msgid "Seleziona almeno un elemento da sincronizzare."
msgstr "Seleziona almeno un elemento da sincronizzare."

#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:380
msgid "Seleziona almeno un foglio da importare."
msgstr "Seleziona almeno un foglio da importare."

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:412
msgid "Seleziona almeno una cartella"
msgstr "Seleziona almeno una cartella"

#: src/features/sync/components/DocSyncManager.tsx:885
msgid "Seleziona almeno una cartella o un file da sincronizzare."
msgstr "Seleziona almeno una cartella o un file da sincronizzare."

#: src/features/dashboard/components/AxisConfigurator.tsx:184
msgid "Seleziona almeno una colonna."
msgstr "Seleziona almeno una colonna."

#: src/features/sync/components/picker/NotionPickerModal.tsx:197
msgid "Seleziona almeno una pagina"
msgstr "Seleziona almeno una pagina"

#: src/features/console/components/CreateKeyWizard.tsx:504
msgid "Seleziona almeno una sorgente o una connessione per continuare."
msgstr "Seleziona almeno una sorgente o una connessione per continuare."

#: src/features/console/pages/KeyDetailPage.tsx:218
msgid "Seleziona almeno uno scope."
msgstr "Seleziona almeno uno scope."

#: ../../packages/ui/src/cad/parsers/DxfViewer.tsx:284
msgid "Seleziona area"
msgstr "Seleziona area"

#: src/routes/_authed/workspace/calendar.tsx:774
msgid "Seleziona calendari attivi"
msgstr "Seleziona calendari attivi"

#: src/routes/_authed/workspace/finance.tsx:353
msgid "Seleziona collegamenti finanziari"
msgstr "Seleziona collegamenti finanziari"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:347
msgid "Seleziona colonna…"
msgstr "Seleziona colonna…"

#: src/features/structured-data/components/CadDataPanel.tsx:306
#: src/features/structured-data/components/CadQueryCard.tsx:131
msgid "Seleziona disegno"
msgstr "Seleziona disegno"

#: src/features/console/pages/ResourceAccessPage.tsx:405
msgid "Seleziona e salva almeno un contenuto indicizzato prima di autorizzare gli utenti della tua app."
msgstr "Seleziona e salva almeno un contenuto indicizzato prima di autorizzare gli utenti della tua app."

#: src/features/sync/components/DocSyncManager.tsx:807
msgid "Seleziona elementi da sincronizzare"
msgstr "Seleziona elementi da sincronizzare"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:276
msgid "Seleziona esercizio"
msgstr "Seleziona esercizio"

#: src/features/console/docs/content.ts:1179
msgid "Seleziona esplicitamente una nuova AppKey di servizio live per il sync periodico di un connettore manifest. La chiave deve appartenere al project e risolvere allo stesso utente di servizio; i contenuti già indicizzati conservano i propri ACL."
msgstr "Seleziona esplicitamente una nuova AppKey di servizio live per il sync periodico di un connettore manifest. La chiave deve appartenere al project e risolvere allo stesso utente di servizio; i contenuti già indicizzati conservano i propri ACL."

#: src/features/clean-control/components/EventRow.tsx:188
#: src/features/clean-control/components/EventRow.tsx:194
msgid "Seleziona evento"
msgstr "Seleziona evento"

#: src/features/console/pages/DocumentsPage.tsx:210
msgid "Seleziona i file da caricare"
msgstr "Seleziona i file da caricare"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:179
msgid "Seleziona i fogli da importare (Excel multi-sheet)."
msgstr "Seleziona i fogli da importare (Excel multi-sheet)."

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:201
msgid "Seleziona il dizionario dati"
msgstr "Seleziona il dizionario dati"

#: src/features/connectors/wizards/openBankingSpec.tsx:156
msgid "Seleziona il paese della tua banca."
msgstr "Seleziona il paese della tua banca."

#. placeholder {0}: inv.email
#: src/features/admin/components/orgs/OrgInvitesTab.tsx:303
msgid "Seleziona invito {0}"
msgstr "Seleziona invito {0}"

#: src/features/account/components/OrgSwitcherDialog.tsx:167
msgid "Seleziona l'organizzazione attiva."
msgstr "Seleziona l'organizzazione attiva."

#: src/features/connectors/wizards/cadLibrarySpec.tsx:130
msgid "Seleziona la cartella che contiene i disegni."
msgstr "Seleziona la cartella che contiene i disegni."

#: src/features/sync/components/picker/NotionPickerModal.tsx:104
msgid "Seleziona pagine e database del workspace"
msgstr "Seleziona pagine e database del workspace"

#. placeholder {0}: SOURCE_PROVIDER_LABEL[cloudProvider]
#: src/features/connectors/components/_spreadsheet/useSpreadsheetConnectState.ts:262
msgid "Seleziona prima un account {0}."
msgstr "Seleziona prima un account {0}."

#: src/features/voice_report/components/NewReportDialog.tsx:525
msgid "Seleziona prima un dataset"
msgstr "Seleziona prima un dataset"

#: src/routes/_authed/_modal/integrations/$capability.tsx:384
msgid "Seleziona prima un provider dal menu."
msgstr "Seleziona prima un provider dal menu."

#: src/features/console/components/CreateKeyWizard.tsx:349
msgid "Seleziona soltanto ciò che questa integrazione deve poter fare."
msgstr "Seleziona soltanto ciò che questa integrazione deve poter fare."

#: src/features/voice_report/components/NewReportDialog.tsx:859
msgid "Seleziona testo per migliorare con AI"
msgstr "Seleziona testo per migliorare con AI"

#: src/features/admin/components/AdminOrgs.tsx:996
msgid "Seleziona tutte le organizzazioni"
msgstr "Seleziona tutte le organizzazioni"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:144
msgid "Seleziona tutti"
msgstr "Seleziona tutti"

#: src/features/admin/components/AdminUsers.tsx:317
msgid "Seleziona tutti gli utenti della pagina"
msgstr "Seleziona tutti gli utenti della pagina"

#: src/features/sales/components/LeadsPanel.tsx:382
msgid "Seleziona tutti i contattabili"
msgstr "Seleziona tutti i contattabili"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:217
#: src/features/admin/components/orgs/OrgMembersTab.tsx:308
msgid "Seleziona tutto"
msgstr "Seleziona tutto"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:63
msgid "Seleziona un account Google prima di importare."
msgstr "Seleziona un account Google prima di importare."

#: src/features/sales/components/BatchSendModal.tsx:258
msgid "Seleziona un account…"
msgstr "Seleziona un account…"

#: src/features/dashboard/components/ShareChartSheet.tsx:253
#: src/features/dashboard/components/ShareDashboardSheet.tsx:240
msgid "Seleziona un collega dalla lista."
msgstr "Seleziona un collega dalla lista."

#: src/features/console/pages/ActionsPage.tsx:101
msgid "Seleziona un connettore per gestirne le azioni."
msgstr "Seleziona un connettore per gestirne le azioni."

#: src/features/voice_report/components/NewReportDialog.tsx:147
#: src/features/voice_report/components/NewReportDialog.tsx:731
msgid "Seleziona un dataset"
msgstr "Seleziona un dataset"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:332
msgid "Seleziona un disegno dalla lista"
msgstr "Seleziona un disegno dalla lista"

#: src/features/dxf/components/DxfPreview.tsx:32
msgid "Seleziona un disegno per vedere l’anteprima"
msgstr "Seleziona un disegno per vedere l’anteprima"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:238
msgid "Seleziona un disegno, attiva la selezione e trascina un'area da analizzare."
msgstr "Seleziona un disegno, attiva la selezione e trascina un'area da analizzare."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:230
msgid "Seleziona un esercizio chiuso per ricalcolare correttamente questo indicatore."
msgstr "Seleziona un esercizio chiuso per ricalcolare correttamente questo indicatore."

#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:51
msgid "Seleziona un file Excel o CSV"
msgstr "Seleziona un file Excel o CSV"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:729
msgid "Seleziona un issuer"
msgstr "Seleziona un issuer"

#: src/features/console/components/CreateKeyWizard.tsx:338
msgid "Seleziona un issuer attivo"
msgstr "Seleziona un issuer attivo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:484
msgid "Seleziona un membro"
msgstr "Seleziona un membro"

#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:114
msgid "Seleziona un modo per vedere la cronologia."
msgstr "Seleziona un modo per vedere la cronologia."

#: src/features/console/pages/SchemaPage.tsx:1013
msgid "Seleziona un nodo nella mappa per esplorarla o curarne le descrizioni."
msgstr "Seleziona un nodo nella mappa per esplorarla o curarne le descrizioni."

#: src/features/hive-flows/components/NodeInspector.tsx:250
msgid "Seleziona un nodo per configurarlo."
msgstr "Seleziona un nodo per configurarlo."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:401
msgid "Seleziona un provider attivo"
msgstr "Seleziona un provider attivo"

#: src/routes/_authed/workspace/templates/$kind.tsx:170
msgid "Seleziona un template"
msgstr "Seleziona un template"

#: src/features/voice_report/components/TemplatesGallery.tsx:469
msgid "Seleziona un template per visualizzarne l'anteprima."
msgstr "Seleziona un template per visualizzarne l'anteprima."

#: src/features/admin/components/AdminHypermem.tsx:104
msgid "Seleziona un tenant in alto per visualizzare questa sezione."
msgstr "Seleziona un tenant in alto per visualizzare questa sezione."

#: src/features/console/components/CreateKeyWizard.tsx:329
#: src/features/console/pages/EmbeddedIdentityPage.tsx:346
msgid "Seleziona un'app"
msgstr "Seleziona un'app"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:177
msgid "Seleziona un'organizzazione"
msgstr "Seleziona un'organizzazione"

#: src/features/console/connectors/CustomConnectorDetail.tsx:592
msgid "Seleziona una AppKey server attiva"
msgstr "Seleziona una AppKey server attiva"

#: src/features/hive-flows/run/EmailSupportMonitor.tsx:55
msgid "Seleziona una conversazione nello storico per leggere gli scambi e gestire lo stato del problema."
msgstr "Seleziona una conversazione nello storico per leggere gli scambi e gestire lo stato del problema."

#: src/routes/_authed/workspace/dashboard.tsx:1096
msgid "Seleziona una dashboard dalla barra laterale."
msgstr "Seleziona una dashboard dalla barra laterale."

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:230
msgid "Seleziona una data di riferimento."
msgstr "Seleziona una data di riferimento."

#: src/features/console/pages/TracesPage.tsx:619
msgid "Seleziona una richiesta"
msgstr "Seleziona una richiesta"

#: src/features/console/pages/AccessOverviewPage.tsx:139
msgid "Seleziona una risorsa"
msgstr "Seleziona una risorsa"

#: src/features/connectors/components/management/SchemaViewer.tsx:201
msgid "Seleziona una tabella per modificarne la descrizione."
msgstr "Seleziona una tabella per modificarne la descrizione."

#. placeholder {0}: user.email
#: src/features/admin/components/AdminUsers.tsx:486
msgid "Seleziona utente {0}"
msgstr "Seleziona utente {0}"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:268
msgid "selezionata"
msgstr "selezionata"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:262
msgid "Selezionato: la piattaforma sincronizzerà da sola l'API che descrivi sotto."
msgstr "Selezionato: la piattaforma sincronizzerà da sola l'API che descrivi sotto."

#: ../../packages/ui/src/editors/AiTextPopover.tsx:260
#: src/features/connect/components/GrantManager.tsx:876
msgid "Selezione"
msgstr "Selezione"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:264
msgid "Selezione cartella non riuscita."
msgstr "Selezione cartella non riuscita."

#: src/features/connect/components/GrantManager.tsx:876
msgid "Selezione multipla"
msgstr "Selezione multipla"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:285
msgid "Selezione periodo"
msgstr "Selezione periodo"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:193
msgid "self-confidence"
msgstr "self-confidence"

#: src/features/console/docs/content.ts:1257
msgid "Self-service teammate: GET /members = roster + inviti pendenti + posti (usati vs cap). /members/roles è il catalogo ruoli. POST /members/invites invita per email; .../resend re-invia, DELETE .../invites/<id> revoca. PATCH /members/<id> cambia ruolo (solo owner), DELETE /members/<id> rimuove (admin/owner). Invariante: sempre ≥ 1 owner."
msgstr "Self-service teammate: GET /members = roster + inviti pendenti + posti (usati vs cap). /members/roles è il catalogo ruoli. POST /members/invites invita per email; .../resend re-invia, DELETE .../invites/<id> revoca. PATCH /members/<id> cambia ruolo (solo owner), DELETE /members/<id> rimuove (admin/owner). Invariante: sempre ≥ 1 owner."

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:46
msgid "Semantic"
msgstr "Semantic"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:276
msgid "Semantic facts (totali)"
msgstr "Semantic facts (totali)"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:278
msgid "Semantic facts (validi)"
msgstr "Semantic facts (validi)"

#: src/features/settings/components/NotificationPreferences.tsx:405
msgid "Sempre attivo. Visualizzato nel campanello in alto a destra."
msgstr "Sempre attivo. Visualizzato nel campanello in alto a destra."

#: src/features/report/components/charts.tsx:45
#: src/features/report/components/QuestionView.tsx:93
msgid "Sentimento per categoria"
msgstr "Sentimento per categoria"

#: src/features/report/components/charts.tsx:84
msgid "Sentimento per segmento"
msgstr "Sentimento per segmento"

#: src/features/sales/components/crm/PipelineBoard.tsx:117
msgid "Senza collegamenti"
msgstr "Senza collegamenti"

#: src/features/sales/components/SalesOverview.tsx:121
#: src/features/sales/components/SalesOverview.tsx:174
msgid "Senza email"
msgstr "Senza email"

#: ../../packages/ui/src/ando/OrganizationMemberPicker.tsx:67
#: src/features/settings/components/OrgMembersPanel.tsx:216
msgid "Senza nome"
msgstr "Senza nome"

#: src/features/hive-flows/run/RunHistoryRail.tsx:111
msgid "Senza oggetto"
msgstr "Senza oggetto"

#: src/features/connect/components/GrantManager.tsx:249
#: src/features/connect/components/GrantManager.tsx:606
#: src/features/connect/components/GrantManager.tsx:748
#: src/features/connect/components/GrantManager.tsx:813
msgid "Senza scadenza"
msgstr "Senza scadenza"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:230
#: src/features/chat/components/ConversationCommandPalette.tsx:254
#: src/features/chat/components/ConversationSidebar.tsx:921
#: src/routes/_authed/route.tsx:1172
#: src/routes/_authed/workspace/calendar.tsx:600
#: src/routes/_authed/workspace/calendar.tsx:1534
#: src/routes/_authed/workspace/work.tsx:576
msgid "Senza titolo"
msgstr "Senza titolo"

#: src/features/console/traces/TraceGraph.tsx:376
msgid "seq del turno"
msgstr "seq del turno"

#. placeholder {0}: detail?.total_call_count ?? "…"
#. placeholder {1}: detail ? formatUsd(detail.total_cost_usd, 4) : "…"
#: src/features/admin/components/CostTraceDetailSection.tsx:183
msgid "Sequenza chiamate LLM ({0} totali · costo aggregato {1})"
msgstr "Sequenza chiamate LLM ({0} totali · costo aggregato {1})"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2093
msgid "Serie"
msgstr "Serie"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:234
msgid "Serie (opz.)"
msgstr "Serie (opz.)"

#: src/features/console/docs/content.ts:1208
msgid "Serie per giorno (7d/30d/90d): query, pagine ingerite, storage. /usage/breakdown per il consumo LLM proprio (richieste/token e %, MAI valuta). /usage/by-key ordina le chiavi per consumo; /keys/<id>/usage è il breakdown di UNA chiave (vista billing, costo incluso)."
msgstr "Serie per giorno (7d/30d/90d): query, pagine ingerite, storage. /usage/breakdown per il consumo LLM proprio (richieste/token e %, MAI valuta). /usage/by-key ordina le chiavi per consumo; /keys/<id>/usage è il breakdown di UNA chiave (vista billing, costo incluso)."

#: src/features/admin/components/AdminOverview.tsx:110
msgid "Serie temporale aggregata sull'intervallo selezionato"
msgstr "Serie temporale aggregata sull'intervallo selezionato"

#: src/features/sales/components/CreateLeadDialog.tsx:109
msgid "Serve prima una campagna a cui aggiungere il lead. Creane una con \"+ Nuovo → Nuova campagna\"."
msgstr "Serve prima una campagna a cui aggiungere il lead. Creane una con \"+ Nuovo → Nuova campagna\"."

#: src/features/admin/components/AdminBilling.tsx:97
msgid "Serve solo se un giorno vuoi rate card a tier/per-modello o crediti prepagati. Non necessario col markup nativo."
msgstr "Serve solo se un giorno vuoi rate card a tier/per-modello o crediti prepagati. Non necessario col markup nativo."

#: src/features/console/connectors/CustomConnectorDetail.tsx:249
msgid "Serve un oggetto record o un array di oggetti record."
msgstr "Serve un oggetto record o un array di oggetti record."

#: src/features/onboarding/DemoBookCallModal.tsx:175
msgid "Serve un'email aziendale — grazie!"
msgstr "Serve un'email aziendale — grazie!"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:174
msgid "Serve una precisazione"
msgstr "Serve una precisazione"

#: src/features/console/pages/DevelopersPage.tsx:190
msgid "Server MCP ospitato"
msgstr "Server MCP ospitato"

#: src/features/connectors/wizards/accountingSpec.tsx:91
msgid "Service Layer OData v4 — mid-market + enterprise"
msgstr "Service Layer OData v4 — mid-market + enterprise"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1336
msgid "Service name"
msgstr "Service name"

#: src/features/admin/components/AdminCpq.tsx:563
#: src/features/admin/components/AdminCpqCanvas.tsx:163
msgid "Servizi e prezzi"
msgstr "Servizi e prezzi"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:285
msgid "Servizi non ancora collegati. Per aggiungere un secondo account a un servizio già presente, usa la sua riga qui sopra."
msgstr "Servizi non ancora collegati. Per aggiungere un secondo account a un servizio già presente, usa la sua riga qui sopra."

#: src/features/console/pages/AccessOverviewPage.tsx:164
#: src/features/console/pages/AccessOverviewPage.tsx:229
#: src/features/price-lists/utils/formatItem.ts:39
msgid "Servizio"
msgstr "Servizio"

#: src/features/console/pages/ConnectorDetailPage.tsx:63
#: src/features/console/pages/ConnectorDetailPage.tsx:378
msgid "Servizio cloud"
msgstr "Servizio cloud"

#: src/features/voice_report/components/RunDiffTimeline.tsx:404
msgid "Servono almeno due run completati con successo per mostrare il confronto semantico."
msgstr "Servono almeno due run completati con successo per mostrare il confronto semantico."

#: src/features/console/pages/PlaygroundPage.tsx:1805
msgid "Sessione corrente (nessuna chiave)"
msgstr "Sessione corrente (nessuna chiave)"

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:218
msgid "Sessione desktop assente. Riconnetti l'app."
msgstr "Sessione desktop assente. Riconnetti l'app."

#: src/features/connectors/filesystem-desktop/syncFilesystem.ts:220
msgid "Sessione desktop scaduta. Riconnetti l'app."
msgstr "Sessione desktop scaduta. Riconnetti l'app."

#: src/features/settings/components/NotificationPreferences.tsx:295
msgid "Sessione non disponibile"
msgstr "Sessione non disponibile"

#: src/features/settings/components/AccountDeletion.tsx:188
msgid "Sessione non rilevata. Esegui di nuovo l'accesso per completare la richiesta."
msgstr "Sessione non rilevata. Esegui di nuovo l'accesso per completare la richiesta."

#: src/features/chat/wsHandlers.ts:320
msgid "Sessione scaduta"
msgstr "Sessione scaduta"

#: src/features/sync/hooks/useChatSync.ts:114
#: src/features/sync/hooks/useChatSync.ts:145
#: src/features/sync/hooks/useChatSync.ts:169
#: src/features/sync/hooks/useChatSync.ts:187
#: src/features/sync/hooks/useDriveSync.ts:280
msgid "Sessione utente assente"
msgstr "Sessione utente assente"

#: src/features/admin/components/UserDetailContent.tsx:268
msgid "Sessioni"
msgstr "Sessioni"

#: src/features/settings/components/SecuritySettings.tsx:311
msgid "Sessioni attive"
msgstr "Sessioni attive"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:294
msgid "Set di regole"
msgstr "Set di regole"

#: src/routes/_authed/workspace/calendar.tsx:409
msgid "Sett."
msgstr "Sett."

#: src/features/briefing/BriefCard.tsx:130
#: src/features/workspace/config.ts:341
#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:173
msgid "Settimana"
msgstr "Settimana"

#: src/routes/_authed/workspace/calendar.tsx:847
msgid "Settimana precedente"
msgstr "Settimana precedente"

#: src/routes/_authed/workspace/calendar.tsx:853
msgid "Settimana successiva"
msgstr "Settimana successiva"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:104
msgid "Settimanale ({day})"
msgstr "Settimanale ({day})"

#: ../../packages/ui/src/ando/actions/RecurrenceField.tsx:231
msgid "settimane"
msgstr "settimane"

#: src/features/sales/components/crm/CompaniesPanel.tsx:115
#: src/features/sales/components/crm/CompaniesPanel.tsx:121
#: src/features/sales/components/crm/CompaniesPanel.tsx:230
#: src/features/sales/components/crm/RecordDrawer.tsx:65
#: src/features/settings/components/SelfProfileMemory.tsx:109
msgid "Settore"
msgstr "Settore"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1043
msgid "Setup"
msgstr "Setup"

#: src/features/admin/components/AdminCpqPriceBook.tsx:301
msgid "Setup (EUR)"
msgstr "Setup (EUR)"

#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:108
msgid "Setup del tenant"
msgstr "Setup del tenant"

#: src/features/admin/components/AdminCpq.tsx:202
msgid "Setup una tantum"
msgstr "Setup una tantum"

#: src/features/clean-control/components/EventDetailSheet.tsx:268
msgid "Severità"
msgstr "Severità"

#. placeholder {0}: severityLabel.toLowerCase()
#: src/features/clean-control/components/EventRow.tsx:219
msgid "Severità {0}"
msgstr "Severità {0}"

#. placeholder {0}: item.severity
#: src/features/report/hooks/useRecommendationActions.ts:79
msgid "Severità: {0}."
msgstr "Severità: {0}."

#: src/features/templates/components/TemplateEditor.tsx:282
msgid "Sez. non applicabile"
msgstr "Sez. non applicabile"

#: src/routes/public.voice-report.$token.tsx:244
msgid "Sezione {sectionNumber}"
msgstr "Sezione {sectionNumber}"

#: src/routes/_authed/workspace/sales.tsx:152
msgid "Sezione non disponibile"
msgstr "Sezione non disponibile"

#: src/features/actions/components/FocusedActionView.tsx:1134
msgid "Sezione rigenerata"
msgstr "Sezione rigenerata"

#: src/features/admin/components/AdminCpq.tsx:1276
msgid "Sezioni"
msgstr "Sezioni"

#: src/features/clean-control/components/CleanControlHub.tsx:116
msgid "Sezioni Clean & Control"
msgstr "Sezioni Clean & Control"

#: src/features/console/components/ConsoleShell.tsx:645
#: src/features/console/components/ConsoleShell.tsx:710
#: src/features/console/components/ConsoleShell.tsx:717
msgid "Sezioni console"
msgstr "Sezioni console"

#: src/features/console/pages/FlowsPage.tsx:758
msgid "Sezioni dei flow"
msgstr "Sezioni dei flow"

#: src/features/connectors/components/ConnectorDetailPanel.tsx:94
#: src/features/console/connectors/CustomConnectorDetail.tsx:1035
msgid "Sezioni del connettore"
msgstr "Sezioni del connettore"

#. placeholder {0}: project.name
#: src/features/projects/components/ProjectDetailPage.tsx:541
msgid "Sezioni del progetto {0}"
msgstr "Sezioni del progetto {0}"

#: src/features/report/components/ReportViewer.tsx:353
msgid "Sezioni del report"
msgstr "Sezioni del report"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:348
msgid "Sezioni della app"
msgstr "Sezioni della app"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:457
msgid "Sezioni dettaglio organizzazione"
msgstr "Sezioni dettaglio organizzazione"

#: src/features/admin/components/AdminCpqAskAndo.tsx:186
#: src/features/admin/components/AdminCpqProposalCopy.tsx:128
msgid "Sezioni extra"
msgstr "Sezioni extra"

#: src/features/chat/components/ConversationSidebar.tsx:1166
msgid "Sfissa"
msgstr "Sfissa"

#: src/features/voice_report/components/NewReportDialog.tsx:954
msgid "Sfoglia gallery"
msgstr "Sfoglia gallery"

#: src/features/connectors/components/_spreadsheet/SpreadsheetSourceStep.tsx:199
msgid "Sfoglia OneDrive"
msgstr "Sfoglia OneDrive"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:802
#: src/features/settings/components/BrandKitSettings.tsx:83
msgid "Sfondo"
msgstr "Sfondo"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:51
msgid "Sformo"
msgstr "Sformo"

#: src/features/connectors/wizards/driveSpec.tsx:122
msgid "Sganci → indice eliminato entro la finestra di compliance."
msgstr "Sganci → indice eliminato entro la finestra di compliance."

#: ../../packages/ui/src/ando/actions/DestinationPicker.tsx:113
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:99
#: src/features/workspace/config.ts:378
#: src/features/workspace/documents/components/FolderBrowserView.tsx:51
msgid "SharePoint"
msgstr "SharePoint"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:516
msgid "SharePoint richiede un account Microsoft 365 / Azure AD (work o school). Gli account Microsoft personali (outlook.com / hotmail.com / live.com) non hanno SharePoint."
msgstr "SharePoint richiede un account Microsoft 365 / Azure AD (work o school). Gli account Microsoft personali (outlook.com / hotmail.com / live.com) non hanno SharePoint."

#: ../../packages/ui/src/ando/DataPagedTable.tsx:103
#: ../../packages/ui/src/cad/CadBlockAccordion.tsx:57
#: src/features/console/pages/PlaygroundPage.tsx:948
#: src/features/dashboard/components/wizard/WizardStepData.tsx:529
msgid "sì"
msgstr "sì"

#: ../../packages/ui/src/ando/ActionAuditDiff.tsx:21
#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1246
#: ../../packages/ui/src/ando/actions/GenericProposalPreview.tsx:45
#: src/features/admin/components/AdminCpqAskAndo.tsx:189
#: src/features/automations/components/AutomationDetailSection.tsx:170
#: src/features/connectors/components/_spreadsheet/types.tsx:151
#: src/features/console/connectors/CustomConnectorDetail.tsx:416
#: src/features/console/pages/FlowDetailPage.tsx:223
#: src/features/hive-flows/components/FlowNodeCard.tsx:79
msgid "Sì"
msgstr "Sì"

#: src/routes/_authed/_modal/settings/help.tsx:78
msgid "Sì — apri Impostazioni → Organizzazione e usa Invita membri. Servono i ruoli appropriati (admin per inviti). Ogni membro vede solo i dati a cui ha accesso secondo le policy condivise dall'organizzazione."
msgstr "Sì — apri Impostazioni → Organizzazione e usa Invita membri. Servono i ruoli appropriati (admin per inviti). Ogni membro vede solo i dati a cui ha accesso secondo le policy condivise dall'organizzazione."

#. placeholder {0}: share.recipient_email
#: src/features/share/components/ShareLinkDialog.tsx:929
msgid "Si apre solo confermando l'indirizzo con un codice inviato a {0}."
msgstr "Si apre solo confermando l'indirizzo con un codice inviato a {0}."

#: src/features/sales/components/crm/RecordDrawer.tsx:335
msgid "Si apre una proposta modificabile — nulla parte senza conferma."
msgstr "Si apre una proposta modificabile — nulla parte senza conferma."

#: src/features/skills/components/SkillCardParts.tsx:71
msgid "Si attiva quando:"
msgstr "Si attiva quando:"

#: ../../packages/ui/src/ando/ShareEmailForm.tsx:193
msgid "si avvicina al limite"
msgstr "si avvicina al limite"

#: src/features/connect/components/ConnectChat.tsx:182
msgid "Si è verificato un errore. Riprova."
msgstr "Si è verificato un errore. Riprova."

#: src/features/settings/components/DataExport.tsx:302
msgid "Si è verificato un problema durante la generazione. Riprova o contatta il supporto."
msgstr "Si è verificato un problema durante la generazione. Riprova o contatta il supporto."

#. placeholder {0}: tabLabel[ZONE_TAB[zone]]
#: src/features/admin/components/AdminCpqCanvas.tsx:263
msgid "si modifica nella scheda {0}."
msgstr "si modifica nella scheda {0}."

#: src/features/connectors/components/management/DiscoveryDialog.tsx:115
msgid "Si perde tutto quello che l'AI aveva prodotto:"
msgstr "Si perde tutto quello che l'AI aveva prodotto:"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:161
msgid "Sì, rigenera tutto"
msgstr "Sì, rigenera tutto"

#: src/features/account/components/UserMenuButton.tsx:382
#: src/features/admin/components/orgs/OrgDetailShell.tsx:179
#: src/features/admin/components/orgs/OrgDetailShell.tsx:182
#: src/features/settings/components/SecuritySettings.tsx:41
msgid "Sicurezza"
msgstr "Sicurezza"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:120
msgid "Sidebar"
msgstr "Sidebar"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:268
msgid "Significatività attesa"
msgstr "Significatività attesa"

#. placeholder {0}: chi.toFixed(2)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:109
msgid "significativo, effect <5% (χ² {0})"
msgstr "significativo, effect <5% (χ² {0})"

#: src/features/console/webhooks/WebhooksPanel.tsx:325
msgid "Signing secret"
msgstr "Signing secret"

#: src/features/admin/components/AdminEngagement.tsx:156
msgid "Signup → Prima query"
msgstr "Signup → Prima query"

#: src/features/admin/components/AdminEngagement.tsx:161
msgid "Signup → Primo canvas"
msgstr "Signup → Primo canvas"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:302
msgid "Signup not completed. Close the popup only via \"Done\"/\"Finish\" — clicking the X cancels the setup."
msgstr "Signup not completed. Close the popup only via \"Done\"/\"Finish\" — clicking the X cancels the setup."

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:41
msgid "Simboli (!@#$)"
msgstr "Simboli (!@#$)"

#: src/features/structured-data/components/CadSimilarSearchModal.tsx:122
msgid "Similarità coseno"
msgstr "Similarità coseno"

#: src/features/structured-data/components/SimilarPartsSection.tsx:488
msgid "Similarità coseno bi-encoder"
msgstr "Similarità coseno bi-encoder"

#: src/features/clean-control/components/policies/enforcement.ts:27
msgid "Simula soltanto"
msgstr "Simula soltanto"

#: src/features/connectors/components/ConnectedAccountRow.tsx:435
#: src/features/console/connectors/ConnectionCard.tsx:398
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:661
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:625
msgid "Sincronizza"
msgstr "Sincronizza"

#. placeholder {0}: folder.name
#: src/features/sync/components/DocSyncManager.tsx:993
msgid "Sincronizza {0}"
msgstr "Sincronizza {0}"

#. placeholder {0}: matchingCount.toLocaleString("it-IT")
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:659
msgid "Sincronizza {0} conversazioni"
msgstr "Sincronizza {0} conversazioni"

#. placeholder {0}: matchingCount.toLocaleString("it-IT")
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:624
msgid "Sincronizza {0} email"
msgstr "Sincronizza {0} email"

#: src/features/console/pages/ConnectorsPage.tsx:420
msgid "Sincronizza {label}"
msgstr "Sincronizza {label}"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:285
msgid "Sincronizza conversazioni"
msgstr "Sincronizza conversazioni"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:310
#: src/features/workspace/components/QuickAddMenu/useQuickAddItems.tsx:271
msgid "Sincronizza email"
msgstr "Sincronizza email"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:304
msgid "Sincronizza ora"
msgstr "Sincronizza ora"

#. placeholder {0}: connection.connection_key
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:285
msgid "Sincronizza ora {0}"
msgstr "Sincronizza ora {0}"

#: src/features/connectors/components/AutoSyncBadge.tsx:176
msgid "Sincronizza per attivare l'auto-sync"
msgstr "Sincronizza per attivare l'auto-sync"

#: src/features/console/pages/ConnectorDetailPage.tsx:316
msgid "Sincronizza tutto"
msgstr "Sincronizza tutto"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:656
#: src/features/sync/components/DocSyncManager.tsx:805
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:622
msgid "Sincronizzando…"
msgstr "Sincronizzando…"

#: src/features/sync/components/DocSyncManager.tsx:1189
#: src/features/sync/components/DocSyncManager.tsx:1272
msgid "sincronizzato"
msgstr "sincronizzato"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:284
msgid "Sincronizzato"
msgstr "Sincronizzato"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:283
msgid "Sincronizzato · {count} movimenti caricati"
msgstr "Sincronizzato · {count} movimenti caricati"

#: src/features/console/connectors/ConnectionCard.tsx:47
#: src/features/sync/components/UniversalSyncToast.tsx:279
#: src/features/workspace/components/QuickAddMenu/types.ts:92
msgid "Sincronizzazione"
msgstr "Sincronizzazione"

#. placeholder {0}: connection.connection_key
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:261
msgid "Sincronizzazione {0} al {progressPct} percento"
msgstr "Sincronizzazione {0} al {progressPct} percento"

#: src/features/connectors/components/CancelSyncButton.tsx:58
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:153
msgid "Sincronizzazione annullata"
msgstr "Sincronizzazione annullata"

#: src/features/sync/components/DocSyncManager.tsx:434
msgid "Sincronizzazione annullata — puoi riprovare"
msgstr "Sincronizzazione annullata — puoi riprovare"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:317
msgid "Sincronizzazione automatica"
msgstr "Sincronizzazione automatica"

#: src/features/console/pages/ConnectorDetailPage.tsx:146
#: src/features/console/pages/ConnectorDetailPage.tsx:162
#: src/features/console/pages/ConnectorsPage.tsx:189
#: src/features/sync/components/DocSyncManager.tsx:306
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:216
msgid "Sincronizzazione avviata"
msgstr "Sincronizzazione avviata"

#: src/routes/_authed/_modal/integrations/$capability.tsx:1044
msgid "Sincronizzazione avviata…"
msgstr "Sincronizzazione avviata…"

#: src/features/sync/components/UniversalSyncToast.tsx:278
msgid "Sincronizzazione cartella"
msgstr "Sincronizzazione cartella"

#: src/features/sync/components/UniversalSyncToast.tsx:276
msgid "Sincronizzazione chat"
msgstr "Sincronizzazione chat"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:235
msgid "Sincronizzazione chat avviata"
msgstr "Sincronizzazione chat avviata"

#: src/features/connectors/wizards/databaseSpec.tsx:258
msgid "Sincronizzazione delta a basso impatto sul tuo database."
msgstr "Sincronizzazione delta a basso impatto sul tuo database."

#: src/features/sync/components/UniversalSyncToast.tsx:277
msgid "Sincronizzazione documenti"
msgstr "Sincronizzazione documenti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:294
msgid "Sincronizzazione e accesso ai dati di questa fonte."
msgstr "Sincronizzazione e accesso ai dati di questa fonte."

#: src/features/sync/components/UniversalSyncToast.tsx:275
msgid "Sincronizzazione email"
msgstr "Sincronizzazione email"

#: src/features/sync/components/SyncStatusPill.tsx:78
#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:151
msgid "Sincronizzazione fallita"
msgstr "Sincronizzazione fallita"

#: src/features/connectors/components/ConnectedAccountRow.tsx:162
msgid "Sincronizzazione fallita · riprova"
msgstr "Sincronizzazione fallita · riprova"

#: ../../packages/ui/src/ando/ActiveSyncJobBanner.tsx:171
msgid "Sincronizzazione già in corso"
msgstr "Sincronizzazione già in corso"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:299
msgid "Sincronizzazione già in corso — i filtri sono bloccati finché non completa."
msgstr "Sincronizzazione già in corso — i filtri sono bloccati finché non completa."

#: src/features/sync/components/SyncStatusPill.tsx:83
#: src/features/workspace/documents/components/DocumentsEmptyStates.tsx:97
#: src/features/workspace/documents/components/SmartSourceChips.tsx:72
msgid "Sincronizzazione in corso"
msgstr "Sincronizzazione in corso"

#. placeholder {0}: job.completedItems.toLocaleString("it-IT")
#. placeholder {1}: job.totalItems.toLocaleString("it-IT")
#. placeholder {2}: job.progress
#: src/features/sync/components/SyncStatusPill.tsx:82
msgid "Sincronizzazione in corso, {0} di {1} elementi, {2}%"
msgstr "Sincronizzazione in corso, {0} di {1} elementi, {2}%"

#: src/features/connectors/components/ConnectedAccountRow.tsx:377
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:261
msgid "Sincronizzazione in corso…"
msgstr "Sincronizzazione in corso…"

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:341
msgid "Sincronizzazione interrotta"
msgstr "Sincronizzazione interrotta"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:251
msgid "Sincronizzazione mai eseguita"
msgstr "Sincronizzazione mai eseguita"

#: src/routes/_authed/_modal/integrations/$capability.tsx:1076
msgid "Sincronizzazione non riuscita."
msgstr "Sincronizzazione non riuscita."

#: src/features/workspace/documents/components/SmartSourceChips.tsx:71
msgid "Sincronizzazione OK"
msgstr "Sincronizzazione OK"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:310
msgid "Sincronizzazione PEC dalla pagina connettori."
msgstr "Sincronizzazione PEC dalla pagina connettori."

#: src/features/console/connectors/meta.ts:57
msgid "Sincronizzazione periodica automatica dopo il collegamento"
msgstr "Sincronizzazione periodica automatica dopo il collegamento"

#: src/features/connectors/components/management/SchemaViewer.tsx:901
msgid "Sincronizzazione schema in corso…"
msgstr "Sincronizzazione schema in corso…"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:313
msgid "Sincronizzazione sospesa"
msgstr "Sincronizzazione sospesa"

#: src/features/connectors/components/ConnectorStatus.tsx:115
#: src/features/connectors/components/ConnectorStatus.tsx:235
#: src/routes/_authed/_modal/integrations/index.tsx:521
msgid "Sincronizzazione…"
msgstr "Sincronizzazione…"

#: src/features/settings/components/OrganizationSettings.tsx:144
msgid "Single Sign-On — disponibile in Q3 2026"
msgstr "Single Sign-On — disponibile in Q3 2026"

#: src/features/templates/components/TemplateFieldSpecs.ts:100
msgid "Singola colonna"
msgstr "Singola colonna"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1587
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1944
msgid "Sinistra"
msgstr "Sinistra"

#: src/features/connectors/components/management/SchemaViewer.tsx:471
msgid "Sinonimi"
msgstr "Sinonimi"

#: src/features/price-lists/components/PriceListsPage.tsx:970
msgid "Sinonimi / codici alias (separati da virgola)"
msgstr "Sinonimi / codici alias (separati da virgola)"

#: src/features/price-lists/components/PriceListsPage.tsx:698
msgid "Sinonimi:"
msgstr "Sinonimi:"

#: src/features/console/pages/PlaygroundPage.tsx:874
#: src/features/dashboard/components/DashboardViewControls.tsx:33
#: src/features/sources/components/AISummaryPanel.tsx:487
#: src/features/sources/components/ArtifactPane.tsx:2129
#: src/routes/public.voice-report.$token.tsx:233
msgid "Sintesi"
msgstr "Sintesi"

#: src/features/share/components/ShareLinkDialog.tsx:406
msgid "Sintesi della condivisione"
msgstr "Sintesi della condivisione"

#: src/features/sources/components/ArtifactPane.tsx:2206
msgid "Sintesi di Ando"
msgstr "Sintesi di Ando"

#: src/features/voice_report/components/VoiceReportsList.tsx:158
msgid "Sintetizza l'opinione di tutti i tuoi clienti, prospect o utenti in un report citation-grounded. I report restano consultabili nel tempo e si aggiornano on-demand."
msgstr "Sintetizza l'opinione di tutti i tuoi clienti, prospect o utenti in un report citation-grounded. I report restano consultabili nel tempo e si aggiornano on-demand."

#: src/features/settings/components/ProfileSettings.tsx:146
#: src/routes/_authed/_modal/admin/route.tsx:135
msgid "Sistema"
msgstr "Sistema"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:55
#: src/features/connectors/wizards/sdiSpec.tsx:56
msgid "Sistema di Interscambio"
msgstr "Sistema di Interscambio"

#: src/features/console/pages/PlaygroundPage.tsx:894
msgid "Sistemi interrogati"
msgstr "Sistemi interrogati"

#: src/features/console/pages/PlaygroundPage.tsx:893
msgid "Sistemi visti"
msgstr "Sistemi visti"

#: src/features/sales/components/CreateLeadDialog.tsx:206
#: src/features/sales/components/CreateLeadDialog.tsx:212
msgid "Sito web"
msgstr "Sito web"

#: src/features/admin/components/AdminEngagement.tsx:570
msgid "Size"
msgstr "Size"

#: src/features/account/components/UserMenuButton.tsx:424
msgid "Skill"
msgstr "Skill"

#: src/features/skills/components/SkillEditor.tsx:229
msgid "Skill aggiornata"
msgstr "Skill aggiornata"

#: src/features/skills/components/SkillsList.tsx:129
msgid "Skill attivata"
msgstr "Skill attivata"

#: src/features/skills/components/SkillsList.tsx:109
msgid "Skill condivisa col team"
msgstr "Skill condivisa col team"

#: src/features/skills/components/SkillEditor.tsx:209
msgid "Skill creata"
msgstr "Skill creata"

#: src/features/skills/components/TeamSkillsCatalog.tsx:43
msgid "Skill del team attivata"
msgstr "Skill del team attivata"

#: src/features/skills/components/TeamSkillsCatalog.tsx:44
msgid "Skill del team disattivata"
msgstr "Skill del team disattivata"

#: src/features/skills/components/SkillsList.tsx:129
msgid "Skill disattivata"
msgstr "Skill disattivata"

#: src/features/skills/components/SkillsList.tsx:144
msgid "Skill eliminata"
msgstr "Skill eliminata"

#: src/features/skills/components/SkillsList.tsx:108
msgid "Skill resa predefinita del team"
msgstr "Skill resa predefinita del team"

#: src/features/skills/components/SkillsList.tsx:106
msgid "Skill resa privata"
msgstr "Skill resa privata"

#: src/features/workspace/config.ts:335
#: src/routes/_authed/workspace/conversations.tsx:578
#: src/routes/_authed/workspace/conversations.tsx:1118
msgid "Slack"
msgstr "Slack"

#: src/features/connectors/wizards/messagingSpec.tsx:40
msgid "Slack, Teams, Google Chat, WhatsApp — conversazioni e trascrizioni delle riunioni indicizzate"
msgstr "Slack, Teams, Google Chat, WhatsApp — conversazioni e trascrizioni delle riunioni indicizzate"

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:393
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:394
msgid "slide"
msgstr "slide"

#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:566
#: src/features/admin/components/AdminDecks.tsx:351
msgid "Slide"
msgstr "Slide"

#. placeholder {0}: c.preview.slide
#. placeholder {0}: preview.slide
#. placeholder {0}: s.index
#: ../../packages/ui/src/ando/actions/DocumentCreatePreview.tsx:685
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:488
#: ../../packages/ui/src/editors/PptxEditorInline.tsx:534
#: ../../packages/ui/src/editors/ReviewRail.tsx:461
#: src/features/sources/components/AISummaryPanel.tsx:421
msgid "Slide {0}"
msgstr "Slide {0}"

#. placeholder {0}: index + 1
#: src/features/report/components/RespondentQuotesCarousel.tsx:174
msgid "Slide {0} di {total}"
msgstr "Slide {0} di {total}"

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:447
msgid "Slide {activeSlide}"
msgstr "Slide {activeSlide}"

#. placeholder {0}: doc.numPages
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:376
msgid "Slide {currentSlide} / {0}"
msgstr "Slide {currentSlide} / {0}"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:564
#: ../../packages/ui/src/editors/PptxViewerInline.tsx:726
msgid "Slide {n}"
msgstr "Slide {n}"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:725
msgid "Slide {n} — ha modifiche"
msgstr "Slide {n} — ha modifiche"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:563
msgid "Slide {n} (con modifiche)"
msgstr "Slide {n} (con modifiche)"

#: src/features/sources/marp/DeckOutlineEditorMount.tsx:178
msgid "Slide aggiornata dall'AI"
msgstr "Slide aggiornata dall'AI"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2695
msgid "Slide cambiate"
msgstr "Slide cambiate"

#: src/features/settings/components/PresentationTemplates.tsx:86
msgid "Slide design"
msgstr "Slide design"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:371
#: src/features/report/components/RespondentQuotesCarousel.tsx:188
msgid "Slide precedente"
msgstr "Slide precedente"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:504
msgid "Slide selezionata"
msgstr "Slide selezionata"

#: ../../packages/ui/src/editors/PptxViewerInline.tsx:383
#: src/features/report/components/RespondentQuotesCarousel.tsx:200
msgid "Slide successiva"
msgstr "Slide successiva"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1452
msgid "Slide vuota: inserisci un elemento."
msgstr "Slide vuota: inserisci un elemento."

#: src/features/connectors/wizards/calendarSpec.tsx:75
msgid "Slot proposti"
msgstr "Slot proposti"

#: src/features/console/connectors/CustomConnectorsPanel.tsx:259
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:281
#: src/features/settings/marp/CssUploadPanel.tsx:152
msgid "Slug"
msgstr "Slug"

#: src/features/settings/marp/CssUploadPanel.tsx:47
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:42
msgid "Slug obbligatorio"
msgstr "Slug obbligatorio"

#: src/features/admin/components/AdminOrgs.tsx:205
msgid "Slug obbligatorio."
msgstr "Slug obbligatorio."

#: src/features/templates/components/TemplateEditor.tsx:381
msgid "Slug:"
msgstr "Slug:"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:101
msgid "Smusso"
msgstr "Smusso"

#: src/features/admin/components/AdminOverview.tsx:97
msgid "Snapshot live vs periodo precedente"
msgstr "Snapshot live vs periodo precedente"

#: src/features/console/pages/PlaygroundPage.tsx:1261
msgid "Snippet copia-e-incolla, aggiornato sui parametri correnti."
msgstr "Snippet copia-e-incolla, aggiornato sui parametri correnti."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:65
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:74
#: src/features/workspace/components/InboxItemRow.tsx:246
#: src/features/workspace/inbox/components/InboxBulkActionBar.tsx:61
msgid "Snooze"
msgstr "Snooze"

#: src/features/workspace/inbox/hooks/useInboxMutations.ts:469
#: src/features/workspace/inbox/hooks/useInboxMutations.ts:482
msgid "Snooze attivato"
msgstr "Snooze attivato"

#: src/features/briefing/briefingActions.ts:91
msgid "Snooze bulk in arrivo"
msgstr "Snooze bulk in arrivo"

#: src/features/workspace/inbox/components/SnoozePopover.tsx:75
msgid "Snooze fino a…"
msgstr "Snooze fino a…"

#. placeholder {0}: hard.email_hard
#: src/features/settings/components/NotificationPreferences.tsx:472
msgid "Soft {emailSoft} · hard {0}"
msgstr "Soft {emailSoft} · hard {0}"

#. placeholder {0}: hard.in_app_hard
#: src/features/settings/components/NotificationPreferences.tsx:460
msgid "Soft {inAppSoft} · hard {0}"
msgstr "Soft {inAppSoft} · hard {0}"

#: src/features/admin/components/AdminCpq.tsx:599
#: src/features/admin/components/AdminCpq.tsx:1075
#: src/features/admin/components/AdminCpq.tsx:1097
#: src/features/admin/components/AdminCpq.tsx:1130
#: src/features/admin/components/AdminCpqCanvas.tsx:197
#: src/features/admin/components/AdminCpqList.tsx:147
msgid "Software house"
msgstr "Software house"

#: src/features/admin/components/AdminCpq.tsx:877
msgid "Software house e condizioni"
msgstr "Software house e condizioni"

#. placeholder {0}: formatPct(EFFECT_THRESHOLD * 100, 0)
#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:279
msgid "Soglia: α=0.05 (χ² ≥ {CHI_SQ_CRITICAL_005}), effect ≥ {0}. Auto-promozione al raggiungimento di entrambe."
msgstr "Soglia: α=0.05 (χ² ≥ {CHI_SQ_CRITICAL_005}), effect ≥ {0}. Auto-promozione al raggiungimento di entrambe."

#: src/features/connect/components/ConnectPublicShell.tsx:146
#: src/features/connect/components/GrantManager.tsx:238
#: src/features/connect/components/GrantManager.tsx:241
#: src/features/connect/components/GrantManager.tsx:676
#: src/features/connect/components/GrantManager.tsx:679
#: src/features/connect/components/SpaceScopeBanner.tsx:167
#: src/features/dashboard/components/DashboardChartCard.tsx:764
#: src/routes/_authed/workspace/connect.$spaceId.tsx:423
msgid "Sola lettura"
msgstr "Sola lettura"

#: src/features/console/docs/content.ts:1223
msgid "Sola lettura delle soglie che il runtime GIÀ enforce per-chiave: per ogni AppKey il rate-limit (limit/min, window_seconds, current_usage LIVE e remaining — null se Redis giù) e lo spend-cap mensile (monthly_limit_cents, month_to_date_cents, remaining_cents). Cifre RAW pre-markup; il markup % non è mai esposto."
msgstr "Sola lettura delle soglie che il runtime GIÀ enforce per-chiave: per ogni AppKey il rate-limit (limit/min, window_seconds, current_usage LIVE e remaining — null se Redis giù) e lo spend-cap mensile (monthly_limit_cents, month_to_date_cents, remaining_cents). Cifre RAW pre-markup; il markup % non è mai esposto."

#: src/routes/_authed/workspace/finance.tsx:473
msgid "Solido"
msgstr "Solido"

#: src/features/admin/components/AdminOrgs.tsx:206
msgid "Solo a-z, 0-9, trattino — 2-60 char."
msgstr "Solo a-z, 0-9, trattino — 2-60 char."

#: src/features/connectors/wizards/openBankingSpec.tsx:208
msgid "Solo accesso in lettura, consenso revocabile in ogni momento."
msgstr "Solo accesso in lettura, consenso revocabile in ogni momento."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:516
msgid "Solo bassa qualità (≤ 40%)"
msgstr "Solo bassa qualità (≤ 40%)"

#: src/features/hive-flows/components/FlowShareControl.tsx:219
msgid "Solo chi è nel progetto"
msgstr "Solo chi è nel progetto"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:220
msgid "Solo cloud (mobile disconnesso)"
msgstr "Solo cloud (mobile disconnesso)"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:34
msgid "Solo dati tabellari + grafici"
msgstr "Solo dati tabellari + grafici"

#: src/features/admin/components/AdminDecksAskAndo.tsx:72
msgid "Solo EN"
msgstr "Solo EN"

#: src/features/admin/components/AdminOrgs.tsx:1411
#: src/features/admin/components/orgs/AddMemberDialog.tsx:235
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:269
#: src/features/admin/components/orgs/OrgMembersTab.tsx:439
msgid "Solo Engine"
msgstr "Solo Engine"

#: src/features/console/pages/ResourceAccessPage.tsx:868
msgid "Solo gli utenti già registrati in Ando."
msgstr "Solo gli utenti già registrati in Ando."

#: src/features/console/connectors/ManifestConfigForm.tsx:102
msgid "Solo HTTPS e raggiungibile pubblicamente: Ando lo chiama dai suoi server."
msgstr "Solo HTTPS e raggiungibile pubblicamente: Ando lo chiama dai suoi server."

#: src/features/console/webhooks/WebhooksPanel.tsx:364
msgid "Solo HTTPS: le consegne sono firmate e riprovate con backoff."
msgstr "Solo HTTPS: le consegne sono firmate e riprovate con backoff."

#: src/features/voice_report/components/ShareReportDialog.tsx:281
msgid "Solo i destinatari indicati possono aprire il link"
msgstr "Solo i destinatari indicati possono aprire il link"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:40
#: src/features/console/pages/ResourceAccessPage.tsx:222
msgid "Solo il proprietario"
msgstr "Solo il proprietario"

#: src/features/connectors/wizards/sdiSpec.tsx:113
msgid "Solo in lettura senza conferma"
msgstr "Solo in lettura senza conferma"

#: src/features/admin/components/AdminCpq.tsx:254
msgid "Solo interno"
msgstr "Solo interno"

#: src/features/connectors/components/ConnectedAccountRow.tsx:224
#: src/features/connectors/components/GmailAccessModeDialog.tsx:28
msgid "Solo invio"
msgstr "Solo invio"

#: src/features/console/connectors/StructuredConnectorSetup.tsx:221
msgid "Solo io"
msgstr "Solo io"

#: src/features/admin/components/AdminDecksAskAndo.tsx:71
msgid "Solo IT"
msgstr "Solo IT"

#: src/features/chat/components/LayoutSwitcher.tsx:57
msgid "Solo la chat, a tutta larghezza"
msgstr "Solo la chat, a tutta larghezza"

#: src/features/admin/components/AdminDecksAskAndo.tsx:119
msgid "Solo la slide selezionata"
msgstr "Solo la slide selezionata"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:258
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:302
msgid "Solo lettere minuscole, cifre, punto, trattino o underscore (max 64 caratteri)."
msgstr "Solo lettere minuscole, cifre, punto, trattino o underscore (max 64 caratteri)."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:491
msgid "Solo non letti"
msgstr "Solo non letti"

#: src/features/settings/marp/CssUploadPanel.tsx:204
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:214
msgid "Solo per me"
msgstr "Solo per me"

#: src/features/console/pages/DocumentsPage.tsx:828
#: src/features/console/pages/DocumentsPage.tsx:830
#: src/features/console/pages/ResourceAccessPage.tsx:220
#: src/features/console/pages/ResourceAccessPage.tsx:491
msgid "Solo proprietario"
msgstr "Solo proprietario"

#: src/features/admin/components/AdminDecksAskAndo.tsx:73
msgid "Solo PT"
msgstr "Solo PT"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2831
msgid "Solo questa slide"
msgstr "Solo questa slide"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:372
msgid "Solo SELECT — limit auto a 50 righe nell'anteprima."
msgstr "Solo SELECT — limit auto a 50 righe nell'anteprima."

#: ../../packages/ui/src/ando/composer-parts/FileChipList.tsx:53
msgid "Solo storage"
msgstr "Solo storage"

#: src/features/console/pages/ResourceAccessPage.tsx:651
msgid "Solo tabelle selezionate"
msgstr "Solo tabelle selezionate"

#: src/features/sales/components/CampaignSharing.tsx:149
msgid "Solo tu e i collaboratori scelti potete accedere."
msgstr "Solo tu e i collaboratori scelti potete accedere."

#: src/features/hive-flows/components/FlowShareControl.tsx:192
msgid "Solo tu puoi vederlo e usarlo"
msgstr "Solo tu puoi vederlo e usarlo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:417
msgid "Solo un gestore dell'organizzazione può modificare queste impostazioni."
msgstr "Solo un gestore dell'organizzazione può modificare queste impostazioni."

#: src/features/console/pages/EngineSignupPage.tsx:153
msgid "Solo un owner o admin può attivare Engine per questa organizzazione."
msgstr "Solo un owner o admin può attivare Engine per questa organizzazione."

#: src/features/dashboard/components/AxisConfigurator.tsx:255
msgid "Solo valore della query"
msgstr "Solo valore della query"

#: src/features/dashboard/components/DashboardToolbar.tsx:78
msgid "Solo visualizzazione"
msgstr "Solo visualizzazione"

#: src/features/admin/components/AdminOrgs.tsx:1410
#: src/features/admin/components/orgs/AddMemberDialog.tsx:234
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:268
#: src/features/admin/components/orgs/OrgMembersTab.tsx:440
msgid "Solo Workspace"
msgstr "Solo Workspace"

#: src/features/dashboard/utils/calculatedFields.ts:67
msgid "Somma (+)"
msgstr "Somma (+)"

#: src/features/dashboard/utils/calculatedFields.ts:114
msgid "Somma totale"
msgstr "Somma totale"

#: src/features/sales/components/leadMeta.ts:32
msgid "Soppresso"
msgstr "Soppresso"

#. placeholder {0}: pct(target)
#: src/features/admin/components/AdminCpq.tsx:184
msgid "Sopra il target del {0}"
msgstr "Sopra il target del {0}"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:711
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1319
msgid "Sopratitolo"
msgstr "Sopratitolo"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:147
#: src/features/admin/components/AdminCostTracking.tsx:252
#: src/features/clean-control/components/EventDetailSheet.tsx:278
#: src/features/connectors/wizards/cadLibrarySpec.tsx:119
#: src/features/connectors/wizards/spreadsheetSpec.tsx:172
#: src/features/console/pages/DocumentsPage.tsx:319
#: src/features/console/pages/DocumentsPage.tsx:758
#: src/features/dashboard/components/AddWidgetWizard.tsx:72
msgid "Sorgente"
msgstr "Sorgente"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:148
msgid "Sorgente del documento"
msgstr "Sorgente del documento"

#: src/features/console/pages/PlaygroundPage.tsx:597
msgid "Sorgente non ancora interrogabile"
msgstr "Sorgente non ancora interrogabile"

#: src/features/sources/components/CalendarEventPane.tsx:384
msgid "Sorgente non navigabile"
msgstr "Sorgente non navigabile"

#: src/features/dashboard/components/AddWidgetWizard.tsx:180
msgid "Sorgente non valida. Torna al passo Sorgente e scegli una connessione."
msgstr "Sorgente non valida. Torna al passo Sorgente e scegli una connessione."

#: src/features/console/pages/SchemaPage.tsx:390
msgid "Sorgente rinominata"
msgstr "Sorgente rinominata"

#: src/features/console/pages/PlaygroundPage.tsx:882
msgid "Sorgenti"
msgstr "Sorgenti"

#: src/features/console/pages/PlaygroundPage.tsx:555
msgid "Sorgenti (scope)"
msgstr "Sorgenti (scope)"

#: src/features/console/pages/OverviewPage.tsx:230
msgid "Sorgenti collegate"
msgstr "Sorgenti collegate"

#: src/routes/_authed/workspace/finance.tsx:687
msgid "Sorgenti dati"
msgstr "Sorgenti dati"

#: src/features/admin/components/AdminUsers.tsx:356
#: src/features/admin/components/userAdminActions.tsx:203
msgid "Sospendi"
msgstr "Sospendi"

#: src/features/admin/components/userAdminActions.tsx:359
msgid "Sospendi utente"
msgstr "Sospendi utente"

#: src/features/admin/components/AdminUsers.tsx:264
msgid "Sospesi"
msgstr "Sospesi"

#: src/features/admin/components/UserDetailContent.tsx:509
#: src/features/console/components/StatusBadges.tsx:241
msgid "Sospeso"
msgstr "Sospeso"

#: src/features/sales/components/SignatureSettings.tsx:95
msgid "Sostituisce la firma dell'organizzazione nelle tue email. Lascia vuoto per usare quella predefinita."
msgstr "Sostituisce la firma dell'organizzazione nelle tue email. Lascia vuoto per usare quella predefinita."

#: src/features/settings/components/BrandKitSettings.tsx:678
msgid "Sostituisci"
msgstr "Sostituisci"

#: src/features/settings/components/BrandKitSettings.tsx:675
msgid "Sostituisci {title}"
msgstr "Sostituisci {title}"

#: ../../packages/ui/src/ando/actions/DocumentForkPreview.tsx:92
msgid "Sostituzione testo"
msgstr "Sostituzione testo"

#. placeholder {0}: pct(target)
#: src/features/admin/components/AdminCpq.tsx:184
msgid "Sotto il target del {0}"
msgstr "Sotto il target del {0}"

#: src/routes/_authed/workspace/finance.tsx:1447
msgid "sotto l'anno"
msgstr "sotto l'anno"

#: src/routes/_authed/workspace/finance.tsx:506
msgid "Sotto l'anno"
msgstr "Sotto l'anno"

#: src/routes/_authed/workspace/finance.tsx:476
msgid "Sotto stress"
msgstr "Sotto stress"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:707
msgid "Sottocartella (opzionale)"
msgstr "Sottocartella (opzionale)"

#: src/features/console/pages/SchemaPage.tsx:654
msgid "Sottocartelle"
msgstr "Sottocartelle"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:726
#: src/features/sales/components/SignatureRichEditor.tsx:207
msgid "Sottolineato"
msgstr "Sottolineato"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:52
msgid "Sottosquadro"
msgstr "Sottosquadro"

#: src/features/dashboard/utils/calculatedFields.ts:83
msgid "Sottostringa"
msgstr "Sottostringa"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:554
msgid "Sottotipo / filettatura"
msgstr "Sottotipo / filettatura"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:689
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:699
#: src/features/admin/components/AdminCpqAskAndo.tsx:185
#: src/features/admin/components/AdminCpqProposalCopy.tsx:72
#: src/features/admin/components/deckEditor/DeckEditor.tsx:713
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1316
msgid "Sottotitolo"
msgstr "Sottotitolo"

#: src/features/dashboard/utils/calculatedFields.ts:68
msgid "Sottrazione (−)"
msgstr "Sottrazione (−)"

#: src/features/admin/components/CostTraceDetailSection.tsx:217
msgid "Source"
msgstr "Source"

#: src/features/templates/components/TemplateFieldSpecs.ts:77
#: src/features/templates/components/TemplateFieldSpecs.ts:89
msgid "Source Serif Pro"
msgstr "Source Serif Pro"

#: src/features/console/docs/content.ts:789
msgid "Sources strutturate"
msgstr "Sources strutturate"

#: src/features/sources/components/SyncConflictDialog.tsx:92
msgid "Sovrascrivi"
msgstr "Sovrascrivi"

#: src/features/connectors/wizards/openBankingSpec.tsx:167
msgid "Spagna"
msgstr "Spagna"

#: src/features/help/data/changelog.ts:35
msgid "Spalla impostazioni ridisegnata · novità · tasti rapidi"
msgstr "Spalla impostazioni ridisegnata · novità · tasti rapidi"

#: src/routes/_authed/workspace/connect.index.tsx:108
msgid "spazi"
msgstr "spazi"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:467
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:493
msgid "Spazi"
msgstr "Spazi"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:141
#: src/routes/_authed/workspace/connect.index.tsx:134
#: src/routes/_authed/workspace/connect.index.tsx:145
msgid "Spazi Connect"
msgstr "Spazi Connect"

#: src/routes/_authed/workspace/connect.index.tsx:108
msgid "spazio"
msgstr "spazio"

#: src/routes/connect.space.$spaceId.tsx:108
msgid "Spazio condiviso"
msgstr "Spazio condiviso"

#: src/routes/connect.space.$spaceId.tsx:92
msgid "Spazio condiviso Ando Connect"
msgstr "Spazio condiviso Ando Connect"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:411
msgid "Spazio condiviso con te"
msgstr "Spazio condiviso con te"

#: src/features/active-context/components/ActiveContextOverrideBanner.tsx:42
msgid "spazio Connect"
msgstr "spazio Connect"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:409
msgid "Spazio di {ownerOrg}"
msgstr "Spazio di {ownerOrg}"

#: src/features/console/pages/OverviewPage.tsx:223
msgid "Spazio indicizzato"
msgstr "Spazio indicizzato"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:157
msgid "Spazio non disponibile"
msgstr "Spazio non disponibile"

#: src/features/templates/components/TemplateEditor.tsx:353
msgid "Spec JSON"
msgstr "Spec JSON"

#: src/features/templates/components/SchemaFormEditor.tsx:71
msgid "Spec JSON · ispettore avanzato"
msgstr "Spec JSON · ispettore avanzato"

#: src/features/templates/components/TemplateEditor.tsx:325
msgid "Spec JSON avanzato"
msgstr "Spec JSON avanzato"

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:372
msgid "Specialist"
msgstr "Specialist"

#: src/features/settings/components/PresentationTemplates.tsx:808
msgid "Specifica JSON"
msgstr "Specifica JSON"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:758
msgid "Specifica la feature"
msgstr "Specifica la feature"

#: src/features/console/pages/BillingPage.tsx:264
msgid "Spesa in corso"
msgstr "Spesa in corso"

#: src/features/console/pages/LimitsPage.tsx:67
msgid "Spesa mensile"
msgstr "Spesa mensile"

#: src/features/admin/components/AdminCostTracking.tsx:244
msgid "Spesa per provider/sorgente con breakdown token"
msgstr "Spesa per provider/sorgente con breakdown token"

#: src/features/workspace/finance/components/CategorySpendBreakdown.tsx:82
msgid "Spese per categoria"
msgstr "Spese per categoria"

#: src/features/chat/components/ChatEmptyState.tsx:183
msgid "Spese settimana scorsa"
msgstr "Spese settimana scorsa"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1852
msgid "Spessore"
msgstr "Spessore"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:50
msgid "Spessore parete"
msgstr "Spessore parete"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:418
msgid "Spiega perché rifiuti questo suggerimento — l'audit trail registrerà la motivazione."
msgstr "Spiega perché rifiuti questo suggerimento — l'audit trail registrerà la motivazione."

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:105
msgid "Sporgenza"
msgstr "Sporgenza"

#: ../../packages/ui/src/ando/sources/calendar/EventActions.tsx:32
#: src/features/admin/components/orgs/MigrateUserDialog.tsx:150
msgid "Sposta"
msgstr "Sposta"

#: src/features/dashboard/components/AxisConfigurator.tsx:301
msgid "Sposta {column} giù"
msgstr "Sposta {column} giù"

#: src/features/dashboard/components/AxisConfigurator.tsx:284
msgid "Sposta {column} su"
msgstr "Sposta {column} su"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1146
msgid "Sposta a destra"
msgstr "Sposta a destra"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1132
msgid "Sposta a sinistra"
msgstr "Sposta a sinistra"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:735
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2383
msgid "Sposta giù"
msgstr "Sposta giù"

#: src/features/workspace/documents/components/DocumentCardV2.tsx:316
#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:113
msgid "Sposta in cartella"
msgstr "Sposta in cartella"

#: src/features/chat/components/ConversationSidebar.tsx:1151
msgid "Sposta in progetto"
msgstr "Sposta in progetto"

#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:175
msgid "Sposta in Root"
msgstr "Sposta in Root"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:731
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2380
msgid "Sposta su"
msgstr "Sposta su"

#: src/features/voice_report/components/RunDiffTimeline.tsx:264
msgid "Spostamenti di sentiment"
msgstr "Spostamenti di sentiment"

#: src/features/sales/hooks/useCrmQueries.ts:102
msgid "Spostamento non riuscito"
msgstr "Spostamento non riuscito"

#: src/features/workspace/documents/components/MoveToFolderDialog.tsx:192
msgid "Spostando…"
msgstr "Spostando…"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:276
msgid "Spunta = sync ricorsivo di tutti i file dentro"
msgstr "Spunta = sync ricorsivo di tutti i file dentro"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:414
msgid "Spunta sopra per procedere"
msgstr "Spunta sopra per procedere"

#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:160
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:211
#: ../../packages/ui/src/ando/SqlPreviewBlock.tsx:289
#: src/features/dashboard/components/AddChartDialog.tsx:196
msgid "SQL copiato"
msgstr "SQL copiato"

#: src/features/sales/components/SalesOverview.tsx:169
msgid "Squalificati"
msgstr "Squalificati"

#: src/features/sales/components/leadMeta.ts:59
msgid "Squalificato"
msgstr "Squalificato"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:181
#: src/features/settings/components/OrganizationSettings.tsx:118
msgid "SSO"
msgstr "SSO"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:210
msgid "SSO Provider"
msgstr "SSO Provider"

#: src/features/actions/components/FocusedActionView.tsx:1078
msgid "Sta impiegando più del previsto. Il documento potrebbe essere comunque pronto in <0>Documenti</0> — ricarica la pagina se non si apre da solo a breve."
msgstr "Sta impiegando più del previsto. Il documento potrebbe essere comunque pronto in <0>Documenti</0> — ricarica la pagina se non si apre da solo a breve."

#: src/routes/connect.space.$spaceId.tsx:105
msgid "Stai collaborando con"
msgstr "Stai collaborando con"

#. placeholder {0}: selected.size
#. placeholder {1}: i18n._(plural(selected.size, { one: "membro", other: "membri" }))
#: src/features/admin/components/orgs/OrgMembersTab.tsx:617
msgid "Stai per applicare l'operazione a <0>{0}</0> {1}. Le mutazioni vengono inviate in parallelo e i fallimenti vengono raccolti senza interrompere le altre."
msgstr "Stai per applicare l'operazione a <0>{0}</0> {1}. Le mutazioni vengono inviate in parallelo e i fallimenti vengono raccolti senza interrompere le altre."

#: src/features/share/components/ShareLinkDialog.tsx:517
msgid "Stai per condividere"
msgstr "Stai per condividere"

#. placeholder {0}: pendingDelete?.dashboard.name
#: src/features/dashboard/components/DashboardListSidebar.tsx:461
msgid "Stai per eliminare <0>{0}</0>."
msgstr "Stai per eliminare <0>{0}</0>."

#: src/features/dashboard/components/ChartActionsMenu.tsx:280
msgid "Stai per eliminare definitivamente il grafico \"{chartTitle}\". L'azione non può essere annullata."
msgstr "Stai per eliminare definitivamente il grafico \"{chartTitle}\". L'azione non può essere annullata."

#: src/features/onboarding/DemoWelcomeModal.tsx:170
msgid "Stai per esplorare un ambiente interamente simulato, pensato per farti vivere Ando nel modo più vicino possibile alla realtà. È una beta, quindi può capitare qualche piccolo intoppo — ma riguarda solo la demo, non il prodotto: l'esperienza reale di Ando è solida e già stabile. Per qualunque cosa siamo a tua disposizione. Buona esplorazione!"
msgstr "Stai per esplorare un ambiente interamente simulato, pensato per farti vivere Ando nel modo più vicino possibile alla realtà. È una beta, quindi può capitare qualche piccolo intoppo — ma riguarda solo la demo, non il prodotto: l'esperienza reale di Ando è solida e già stabile. Per qualunque cosa siamo a tua disposizione. Buona esplorazione!"

#: src/features/admin/components/orgs/OrgInvitesTab.tsx:411
msgid "Stai per revocare"
msgstr "Stai per revocare"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:539
msgid "Stai per revocare l'accesso a"
msgstr "Stai per revocare l'accesso a"

#: src/features/settings/components/OrgMembersPanel.tsx:641
msgid "Stai per rimuovere <0>{displayName}</0> dall'organizzazione. Perderà subito l'accesso a chat, connettori e documenti condivisi. L'azione è irreversibile."
msgstr "Stai per rimuovere <0>{displayName}</0> dall'organizzazione. Perderà subito l'accesso a chat, connettori e documenti condivisi. L'azione è irreversibile."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:210
msgid "Stai per spostare denaro."
msgstr "Stai per spostare denaro."

#: src/features/sync/components/DocSyncManager.tsx:1402
msgid "Stai per superare l'80% — considera di ridurre la selezione."
msgstr "Stai per superare l'80% — considera di ridurre la selezione."

#. placeholder {0}: capability === "email" ? "Email" : capability === "drive" ? "Drive" : capability === "calendar" ? "Calendari" : "Chat"
#: src/features/console/pages/EmbeddedIdentityPage.tsx:286
msgid "Stai visualizzando i provider per {0}."
msgstr "Stai visualizzando i provider per {0}."

#: src/routes/public.voice-report.$token.tsx:133
msgid "Stai visualizzando una versione di sola lettura del report. Le modifiche non sono possibili e le fonti restano dentro al workspace originale."
msgstr "Stai visualizzando una versione di sola lettura del report. Le modifiche non sono possibili e le fonti restano dentro al workspace originale."

#: src/features/report/components/tables.tsx:152
msgid "Stakeholder"
msgstr "Stakeholder"

#. placeholder {0}: item.stakeholders.join(", ")
#: src/features/report/hooks/useRecommendationActions.ts:75
msgid "Stakeholder: {0}."
msgstr "Stakeholder: {0}."

#: src/features/billing/components/UsageInsightsCard.tsx:174
msgid "standard"
msgstr "standard"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:28
#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:27
#: src/features/admin/components/AdminOrgs.tsx:108
#: src/features/sales/components/TemplateManager.tsx:33
#: src/features/sales/components/TemplateManager.tsx:39
msgid "Standard"
msgstr "Standard"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:318
msgid "Standard (eredita — {orgTierLabel})"
msgstr "Standard (eredita — {orgTierLabel})"

#: src/features/workspace/inbox/hooks/useSnoozeStore.ts:181
msgid "Stasera (18:00)"
msgstr "Stasera (18:00)"

#: src/features/auth/desktop/useDesktopOAuth.ts:195
msgid "State mismatch nel callback OAuth. Possibile CSRF — riprova."
msgstr "State mismatch nel callback OAuth. Possibile CSRF — riprova."

#: src/features/admin/components/AdminAutomation.tsx:117
msgid "Stati run"
msgstr "Stati run"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:529
#: src/features/console/pages/FlowDetailPage.tsx:247
#: src/features/console/pages/FlowsPage.tsx:600
msgid "Statistiche"
msgstr "Statistiche"

#: src/features/admin/components/AdminCanvas.tsx:230
#: src/features/admin/components/AdminCpqList.tsx:156
#: src/features/admin/components/AdminDemoInviti.tsx:223
#: src/features/admin/components/AdminOrgs.tsx:1036
#: src/features/admin/components/AdminUsers.tsx:384
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:222
#: src/features/admin/components/orgs/OrgBillingTab.tsx:609
#: src/features/admin/components/orgs/OrgMembersTab.tsx:364
#: src/features/billing/components/InvoicesTable.tsx:113
#: src/features/clean-control/components/EventDetailSheet.tsx:277
#: src/features/console/components/ProviderAccounts.tsx:91
#: src/features/console/connectors/CustomConnectorDetail.tsx:136
#: src/features/console/connectors/CustomConnectorsPanel.tsx:265
#: src/features/console/pages/BillingPage.tsx:599
#: src/features/console/pages/DocumentsPage.tsx:334
#: src/features/console/pages/DocumentsPage.tsx:771
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/FlowsPage.tsx:817
#: src/features/console/pages/KeyDetailPage.tsx:650
#: src/features/console/pages/KeysPage.tsx:134
#: src/features/console/pages/MembersPage.tsx:504
#: src/features/console/pages/ResourceAccessPage.tsx:573
#: src/features/sales/components/CampaignsPanel.tsx:191
#: src/features/sales/components/LeadsPanel.tsx:398
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:91
#: src/features/workspace/components/searchFilters/WorkSearchFilters.tsx:56
msgid "Stato"
msgstr "Stato"

#: src/features/console/docs/content.ts:943
msgid "Stato & download"
msgstr "Stato & download"

#: src/features/console/docs/content.ts:473
msgid "Stato + metadati del documento ingerito."
msgstr "Stato + metadati del documento ingerito."

#: src/features/console/docs/content.ts:1712
msgid "Stato + metadati di un documento (scope query:read)."
msgstr "Stato + metadati di un documento (scope query:read)."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:358
msgid "Stato accesso"
msgstr "Stato accesso"

#: src/features/console/connectors/ConnectionAccessSummary.tsx:30
msgid "Stato accesso non disponibile"
msgstr "Stato accesso non disponibile"

#: src/features/sales/components/crm/ActivityNotesPane.tsx:26
#: src/features/sales/components/LeadInlineControls.tsx:65
msgid "Stato aggiornato"
msgstr "Stato aggiornato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:359
msgid "Stato app"
msgstr "Stato app"

#: src/features/console/connectors/CustomConnectorDetail.tsx:582
msgid "Stato AppKey non disponibile."
msgstr "Stato AppKey non disponibile."

#: src/features/connectors/wizards/sdiSpec.tsx:108
msgid "Stato chiaro"
msgstr "Stato chiaro"

#: src/features/admin/components/AdminCanvas.tsx:101
msgid "Stato compilation"
msgstr "Stato compilation"

#: src/features/console/docs/content.ts:509
msgid "Stato conversazionale per gli agentic turn: la seconda domanda ricorda la prima. È la STESSA entità che usa la chat del prodotto."
msgstr "Stato conversazionale per gli agentic turn: la seconda domanda ricorda la prima. È la STESSA entità che usa la chat del prodotto."

#: src/features/console/connectors/ConnectionCard.tsx:211
msgid "Stato dei contenuti"
msgstr "Stato dei contenuti"

#: src/features/console/docs/content.ts:472
msgid "Stato del documento"
msgstr "Stato del documento"

#: src/features/console/docs/content.ts:490
msgid "Stato del job"
msgstr "Stato del job"

#: src/features/console/docs/content.ts:1726
msgid "Stato del job di ingestion (scope query:read)."
msgstr "Stato del job di ingestion (scope query:read)."

#: src/features/maintenance/MaintenanceScreen.tsx:234
msgid "Stato del servizio"
msgstr "Stato del servizio"

#: src/features/console/pages/OverviewPage.tsx:157
msgid "Stato dell'indice, delle fonti e delle attività di acquisizione recenti."
msgstr "Stato dell'indice, delle fonti e delle attività di acquisizione recenti."

#: src/features/console/pages/OverviewPage.tsx:171
msgid "Stato della conoscenza"
msgstr "Stato della conoscenza"

#: src/features/console/connectors/SourceHealthSummary.tsx:25
msgid "Stato della fonte"
msgstr "Stato della fonte"

#: src/features/chat/components/ChatEmptyState.tsx:191
msgid "Stato della pipeline"
msgstr "Stato della pipeline"

#: src/features/console/docs/content.ts:1481
msgid "Stato della sincronizzazione"
msgstr "Stato della sincronizzazione"

#: src/features/console/docs/content.ts:1612
msgid "Stato della sincronizzazione automatica"
msgstr "Stato della sincronizzazione automatica"

#: src/features/admin/components/AdminCanvas.tsx:67
msgid "Stato delle compile dei knowledge canvas: distribuzione status, tempi medi, entità più menzionate, costo nel tempo."
msgstr "Stato delle compile dei knowledge canvas: distribuzione status, tempi medi, entità più menzionate, costo nel tempo."

#: src/features/console/pages/OverviewPage.tsx:186
msgid "Stato delle fonti"
msgstr "Stato delle fonti"

#: src/features/console/pages/OverviewPage.tsx:356
msgid "Stato delle sincronizzazioni"
msgstr "Stato delle sincronizzazioni"

#: src/features/console/docs/content.ts:1126
msgid "Stato di un'invocazione diretta"
msgstr "Stato di un'invocazione diretta"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:243
msgid "Stato HyperMem"
msgstr "Stato HyperMem"

#: src/features/admin/components/MaintenanceControl.tsx:152
msgid "Stato manutenzione"
msgstr "Stato manutenzione"

#: src/features/admin/components/UserDetailContent.tsx:695
msgid "Stato MFA"
msgstr "Stato MFA"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:141
msgid "Stato non disponibile"
msgstr "Stato non disponibile"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:66
msgid "Stato pagamenti, cartelle, avvisi bonari direttamente in chat."
msgstr "Stato pagamenti, cartelle, avvisi bonari direttamente in chat."

#: ../../packages/ui/src/ando/EditableTable.tsx:224
msgid "Stato riga"
msgstr "Stato riga"

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:357
msgid "Stato sincronizzazione email"
msgstr "Stato sincronizzazione email"

#: src/features/dashboard/components/AddWidgetWizard.tsx:414
msgid "Stato wizard"
msgstr "Stato wizard"

#: src/features/admin/components/UserDetailContent.tsx:597
msgid "Stato Zitadel non disponibile"
msgstr "Stato Zitadel non disponibile"

#: src/features/settings/components/OtpEmailPanel.tsx:277
msgid "Stato: attivo"
msgstr "Stato: attivo"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:350
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:422
msgid "Status"
msgstr "Status"

#: src/features/workspace/inbox/components/InboxBulkActionBar.tsx:70
msgid "Stella"
msgstr "Stella"

#: src/features/workspace/components/InboxItemRow.tsx:167
msgid "Stellata"
msgstr "Stellata"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:268
msgid "Step {sharePointStep}/3"
msgstr "Step {sharePointStep}/3"

#: src/features/clean-control/utils/signalCatalog.ts:121
msgid "Stessa entità con nomi canonici diversi."
msgstr "Stessa entità con nomi canonici diversi."

#: src/features/connectors/wizards/erpSpec.tsx:198
msgid "Stessa esperienza tra SAP, Zucchetti e TeamSystem — vista normalizzata."
msgstr "Stessa esperienza tra SAP, Zucchetti e TeamSystem — vista normalizzata."

#: src/features/console/pages/DocsPage.tsx:634
msgid "Stessa forma ovunque; usa il code (stabile) per la logica."
msgstr "Stessa forma ovunque; usa il code (stabile) per la logica."

#: src/features/connect/components/MemberManager.tsx:549
msgid "Stesso accesso in sola lettura. Riservato a future funzioni di collaborazione."
msgstr "Stesso accesso in sola lettura. Riservato a future funzioni di collaborazione."

#: src/features/console/components/ModelPickerModal.tsx:333
msgid "Stesso modello, fatturato dal tuo progetto Google Cloud. Richiede una delega approvata."
msgstr "Stesso modello, fatturato dal tuo progetto Google Cloud. Richiede una delega approvata."

#: src/features/structured-data/components/SimilarPartsSection.tsx:313
msgid "Stesso pezzo, formato diverso"
msgstr "Stesso pezzo, formato diverso"

#: src/features/maintenance/MaintenanceScreen.tsx:215
msgid "Stiamo aggiornando Ando per renderlo più veloce e sicuro. Il tuo lavoro è al sicuro: nessun dato viene toccato."
msgstr "Stiamo aggiornando Ando per renderlo più veloce e sicuro. Il tuo lavoro è al sicuro: nessun dato viene toccato."

#: src/features/connectors/components/management/SchemaViewer.tsx:904
msgid "Stiamo analizzando le tabelle. Lo schema apparirà qui appena pronto, senza bisogno di ricaricare la pagina."
msgstr "Stiamo analizzando le tabelle. Lo schema apparirà qui appena pronto, senza bisogno di ricaricare la pagina."

#: src/routes/_authed/_modal/integrations/index.tsx:195
msgid "Stiamo ancora aspettando il provider. Riprova fra 1-2 minuti — niente di rotto."
msgstr "Stiamo ancora aspettando il provider. Riprova fra 1-2 minuti — niente di rotto."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:196
msgid "Stiamo aprendo il canvas…"
msgstr "Stiamo aprendo il canvas…"

#: src/routes/_authed/workspace/canvases.tsx:352
msgid "Stiamo cercando entità ricorrenti nelle tue conversazioni…"
msgstr "Stiamo cercando entità ricorrenti nelle tue conversazioni…"

#: src/features/briefing/briefingActions.ts:85
msgid "Stiamo preparando questa azione. Per ora archivia dalla lista email."
msgstr "Stiamo preparando questa azione. Per ora archivia dalla lista email."

#: src/features/briefing/briefingActions.ts:93
msgid "Stiamo preparando questa azione. Per ora puoi snoozare dal singolo messaggio."
msgstr "Stiamo preparando questa azione. Per ora puoi snoozare dal singolo messaggio."

#: src/features/dxf/components/DxfPreviewStage.tsx:503
msgid "Stiamo renderizzando il PNG del disegno. Aggiorna fra qualche secondo o passa al viewer 3D per esplorare subito."
msgstr "Stiamo renderizzando il PNG del disegno. Aggiorna fra qualche secondo o passa al viewer 3D per esplorare subito."

#: src/features/connectors/components/management/BusinessContextBanner.tsx:168
msgid "Stiamo rigenerando il contesto con l'AI…"
msgstr "Stiamo rigenerando il contesto con l'AI…"

#: src/features/admin/components/AdminEngagement.tsx:81
msgid "stickiness · TTFV · funnel · coorti retention"
msgstr "stickiness · TTFV · funnel · coorti retention"

#: src/features/admin/components/AdminEngagement.tsx:118
msgid "Stickiness DAU/MAU"
msgstr "Stickiness DAU/MAU"

#: src/features/admin/components/AdminEngagement.tsx:134
msgid "Sticky"
msgstr "Sticky"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1335
#: ../../packages/ui/src/editors/DraftActionBar.tsx:116
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1827
msgid "Stile"
msgstr "Stile"

#. placeholder {0}: style.name
#: src/features/settings/MarpTemplateSettings.tsx:252
msgid "Stile \"{0}\" appreso"
msgstr "Stile \"{0}\" appreso"

#. placeholder {0}: s.name
#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:523
msgid "Stile {0}"
msgstr "Stile {0}"

#. placeholder {0}: brandKit?.name ?? "Ando"
#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:621
msgid "Stile {0} (predefinito)"
msgstr "Stile {0} (predefinito)"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:590
msgid "Stile del documento"
msgstr "Stile del documento"

#: src/features/settings/components/SelfProfileMemory.tsx:110
msgid "Stile di comunicazione"
msgstr "Stile di comunicazione"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:619
msgid "Stile predefinito · ottimizzato dall'AI"
msgstr "Stile predefinito · ottimizzato dall'AI"

#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:682
msgid "Stile testo"
msgstr "Stile testo"

#: src/features/settings/MarpTemplateSettings.tsx:315
msgid "Stili"
msgstr "Stili"

#: src/features/workspace/components/TaskComposer.tsx:201
msgid "Stima (min)"
msgstr "Stima (min)"

#. placeholder {0}: totalMonthly.toFixed(0)
#: src/features/admin/components/AdminCostTracking.tsx:405
msgid "Stima ~${0}/mese recuperabili — indicativa, dai dati di utilizzo."
msgstr "Stima ~${0}/mese recuperabili — indicativa, dai dati di utilizzo."

#: src/features/billing/components/UsageInsightsCard.tsx:214
msgid "Stima conservativa: quick 1,5 min · standard 4 min · expert 12 min."
msgstr "Stima conservativa: quick 1,5 min · standard 4 min · expert 12 min."

#: src/features/console/pages/ConnectorDetailPage.tsx:543
msgid "Stima del costo di indicizzazione"
msgstr "Stima del costo di indicizzazione"

#: src/features/console/pages/ConnectorDetailPage.tsx:553
msgid "Stima del profiling della struttura. Le elaborazioni semantiche successive sono escluse; il costo finale può variare."
msgstr "Stima del profiling della struttura. Le elaborazioni semantiche successive sono escluse; il costo finale può variare."

#: src/features/admin/components/AdminCpq.tsx:963
msgid "Stima in crediti di usage (1 credito = 1 € a listino). Costruzione e profilazione delle fonti sono consumo a carico del cliente."
msgstr "Stima in crediti di usage (1 credito = 1 € a listino). Costruzione e profilazione delle fonti sono consumo a carico del cliente."

#: src/features/workspace/components/TaskComposer.tsx:213
msgid "Stima in minuti"
msgstr "Stima in minuti"

#: src/features/maintenance/MaintenanceScreen.tsx:139
msgid "Stimato"
msgstr "Stimato"

#: src/features/console/components/TopupReturnStatus.tsx:93
msgid "Sto aspettando l’aggiornamento del saldo. Controlla la transazione in Stripe prima di ripetere la ricarica."
msgstr "Sto aspettando l’aggiornamento del saldo. Controlla la transazione in Stripe prima di ripetere la ricarica."

#: src/features/chat/wsHandlers.ts:477
msgid "Sto cercando sul web…"
msgstr "Sto cercando sul web…"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:379
msgid "Sto componendo il canvas — di solito ci vogliono 30-60 secondi."
msgstr "Sto componendo il canvas — di solito ci vogliono 30-60 secondi."

#: src/features/actions/components/FocusedActionView.tsx:1075
msgid "Sto creando il documento…"
msgstr "Sto creando il documento…"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:759
msgid "Sto imparando lo stile…"
msgstr "Sto imparando lo stile…"

#: src/features/chat/wsHandlers.ts:475
msgid "Sto leggendo le email…"
msgstr "Sto leggendo le email…"

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:406
msgid "Sto per"
msgstr "Sto per"

#: src/features/chat/components/ChatEmptyState.tsx:647
msgid "Sto preparando il tuo briefing…"
msgstr "Sto preparando il tuo briefing…"

#. placeholder {0}: selected.filename
#: src/features/source-confirmation/components/SourceConfirmationSurface.tsx:151
msgid "Sto preparando la versione di \"{0}\"…"
msgstr "Sto preparando la versione di \"{0}\"…"

#: src/features/console/components/AssistPanel.tsx:123
#: src/features/console/components/AssistPanel.tsx:270
msgid "Sto ragionando…"
msgstr "Sto ragionando…"

#: src/features/workspace/components/QuickAddMenu/DriveFolderPicker.tsx:209
msgid "Sto registrando la selezione per la sincronizzazione…"
msgstr "Sto registrando la selezione per la sincronizzazione…"

#: src/features/updates/components/UpdateBanner.tsx:132
msgid "Sto scaricando l'aggiornamento…"
msgstr "Sto scaricando l'aggiornamento…"

#: src/features/projects/components/ProjectHub.tsx:451
msgid "Sto sfogliando i tuoi progetti…"
msgstr "Sto sfogliando i tuoi progetti…"

#: src/features/console/components/TopupReturnStatus.tsx:77
msgid "Sto verificando il pagamento e aggiornando il saldo…"
msgstr "Sto verificando il pagamento e aggiornando il saldo…"

#: src/features/admin/components/orgs/OrgBillingTab.tsx:490
#: src/features/admin/components/orgs/OrgBillingTab.tsx:547
#: src/features/billing/components/UsageMeter.tsx:243
#: src/features/console/components/UsageCharts.tsx:136
#: src/features/console/pages/OverviewPage.tsx:220
msgid "Storage"
msgstr "Storage"

#: src/features/admin/components/AdminPlatformSettings.tsx:583
#: src/features/admin/components/AdminPlatformSettings.tsx:868
msgid "Storage (GB)"
msgstr "Storage (GB)"

#: src/features/console/pages/UsagePage.tsx:431
msgid "Storage attuale"
msgstr "Storage attuale"

#: src/features/billing/components/UsageMeter.tsx:248
msgid "Storage illimitato"
msgstr "Storage illimitato"

#: src/features/admin/components/AdminPlatformSettings.tsx:653
msgid "Storage in GB"
msgstr "Storage in GB"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:361
msgid "Storage limit (GB)"
msgstr "Storage limit (GB)"

#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:375
msgid "Storage limit override"
msgstr "Storage limit override"

#: src/features/console/pages/UsagePage.tsx:506
msgid "Storage occupato"
msgstr "Storage occupato"

#: src/features/voice_report/components/VoiceReportDetailPage.tsx:223
msgid "Storia run"
msgstr "Storia run"

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:70
msgid "Storico completo"
msgstr "Storico completo"

#: src/features/console/webhooks/WebhooksPanel.tsx:155
msgid "Storico consegne"
msgstr "Storico consegne"

#: src/features/console/pages/BillingPage.tsx:592
msgid "Storico delle fatture"
msgstr "Storico delle fatture"

#: src/features/console/pages/BillingPage.tsx:573
msgid "Storico delle fatture di consumo (documento di incasso)."
msgstr "Storico delle fatture di consumo (documento di incasso)."

#: src/features/console/docs/content.ts:771
msgid "Storico delle run"
msgstr "Storico delle run"

#: src/features/console/docs/content.ts:1896
msgid "Storico delle run (GET /connectors/<slug>/syncs)."
msgstr "Storico delle run (GET /connectors/<slug>/syncs)."

#: src/features/settings/components/BillingSettings.tsx:169
msgid "Storico fatture"
msgstr "Storico fatture"

#: src/features/console/connectors/CustomConnectorDetail.tsx:132
msgid "Storico sincronizzazioni"
msgstr "Storico sincronizzazioni"

#: src/features/console/connectors/CustomConnectorDetail.tsx:1040
msgid "Storico sync"
msgstr "Storico sync"

#: src/features/console/connectors/CustomConnectorDetail.tsx:658
msgid "Strategia di sync"
msgstr "Strategia di sync"

#: src/features/connectors/wizards/databaseSpec.tsx:117
msgid "Stringa di connessione"
msgstr "Stringa di connessione"

#: src/features/connectors/wizards/databaseSpec.tsx:121
msgid "Stringa ODBC completa, alternativa al DSN."
msgstr "Stringa ODBC completa, alternativa al DSN."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:56
msgid "Stripe addebita automaticamente il metodo di pagamento salvato."
msgstr "Stripe addebita automaticamente il metodo di pagamento salvato."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:62
msgid "Stripe invia una fattura pagabile con link. Funziona senza carta salvata."
msgstr "Stripe invia una fattura pagabile con link. Funziona senza carta salvata."

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:177
#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:185
#: src/features/settings/components/SelfProfileMemory.tsx:107
msgid "Strumenti"
msgstr "Strumenti"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:177
msgid "Strumenti ({count} attivi)"
msgstr "Strumenti ({count} attivi)"

#: src/features/console/pages/DevelopersPage.tsx:213
msgid "Strumenti esposti"
msgstr "Strumenti esposti"

#: src/routes/_authed/_modal/settings/privacy.tsx:43
msgid "Strumenti GDPR self-service: esporta tutti i tuoi dati oppure richiedi la cancellazione definitiva dell'account."
msgstr "Strumenti GDPR self-service: esporta tutti i tuoi dati oppure richiedi la cancellazione definitiva dell'account."

#: src/features/voice_report/components/TemplatesGallery.tsx:301
msgid "Struttura"
msgstr "Struttura"

#: src/features/console/connectors/ConnectionCard.tsx:208
msgid "Struttura da rilevare"
msgstr "Struttura da rilevare"

#: src/features/console/connectors/ConnectionCard.tsx:206
msgid "Struttura rilevata"
msgstr "Struttura rilevata"

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:33
#: src/features/agent-modes/components/AgentModeEditor.tsx:104
msgid "Strutturati"
msgstr "Strutturati"

#: src/features/settings/components/BrandKitSettings.tsx:247
#: src/features/settings/components/PresentationTemplates.tsx:201
#: src/features/studio/components/StudioDrawerContent.tsx:99
#: src/features/studio/components/StudioPillTrigger.tsx:51
#: src/features/studio/components/StudioPillTrigger.tsx:61
#: src/features/studio/components/StudioPillTrigger.tsx:94
msgid "Studio"
msgstr "Studio"

#: src/features/settings/MarpTemplateSettings.tsx:61
msgid "Studio · Workspace"
msgstr "Studio · Workspace"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:82
msgid "Studio Legale"
msgstr "Studio Legale"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:83
msgid "Studio Notarile"
msgstr "Studio Notarile"

#: src/features/clean-control/components/SignalHealthCard.tsx:153
msgid "Su {total} feedback ultimi {lookback} giorni"
msgstr "Su {total} feedback ultimi {lookback} giorni"

#: src/routes/_authed/route.tsx:2222
msgid "Su che banca / conto / scadenza lavoriamo?"
msgstr "Su che banca / conto / scadenza lavoriamo?"

#: src/routes/_authed/route.tsx:2224
msgid "Su cosa lavoriamo, {composerFirstName}?"
msgstr "Su cosa lavoriamo, {composerFirstName}?"

#: ../../packages/ui/src/ando/composer-parts/RichTextEditor.tsx:315
#: src/routes/_authed/route.tsx:2225
msgid "Su cosa lavoriamo?"
msgstr "Su cosa lavoriamo?"

#: src/features/automations/components/formatters.ts:39
msgid "Su evento"
msgstr "Su evento"

#: src/features/automations/components/formatters.ts:37
msgid "Su webhook"
msgstr "Su webhook"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:117
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:197
msgid "success"
msgstr "success"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:254
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:465
#: src/features/console/components/DocumentAcquiredContent.tsx:106
#: src/features/console/pages/AccessOverviewPage.tsx:415
#: src/features/console/pages/DocumentsPage.tsx:901
#: src/features/console/pages/FlowsPage.tsx:957
#: src/features/console/traces/TraceJsonTree.tsx:38
#: src/features/console/traces/TraceJsonTree.tsx:121
#: src/features/console/traces/TracePayloadReader.tsx:180
msgid "Successiva"
msgstr "Successiva"

#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:108
#: src/features/console/connectors/IndexedKnowledgeSelection.tsx:119
#: src/features/console/pages/EmbeddedIdentityPage.tsx:616
#: src/features/console/pages/ResourceAccessPage.tsx:911
msgid "Successivi"
msgstr "Successivi"

#: src/features/admin/components/AdminAutomation.tsx:235
#: src/features/admin/components/AdminQuality.tsx:189
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:98
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:183
#: src/features/hive-flows/components/FlowVersionMenu.tsx:97
msgid "Successo"
msgstr "Successo"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:425
msgid "Suggerimenti"
msgstr "Suggerimenti"

#: ../../packages/ui/src/ando/RecipientsInput.tsx:415
msgid "Suggerimenti contatti"
msgstr "Suggerimenti contatti"

#: ../../packages/ui/src/ando/email/RecipientChips.tsx:397
msgid "Suggerimenti destinatari"
msgstr "Suggerimenti destinatari"

#: src/features/onboarding/SectionGuide.tsx:82
msgid "Suggerimenti e azioni rapide"
msgstr "Suggerimenti e azioni rapide"

#: ../../packages/ui/src/ando/composer-parts/MentionSuggestionList.tsx:160
msgid "Suggerimenti menzione"
msgstr "Suggerimenti menzione"

#: src/features/sources/components/CalendarEventPane.tsx:674
msgid "Suggerimenti slot"
msgstr "Suggerimenti slot"

#: src/features/admin/components/AdminAutomation.tsx:143
msgid "Suggerimenti workflow in coda"
msgstr "Suggerimenti workflow in coda"

#: src/features/chat/wsHandlers.ts:399
msgid "Suggerimento"
msgstr "Suggerimento"

#: src/routes/_authed/workspace/dashboard.tsx:408
msgid "Suggerimento Voice of X"
msgstr "Suggerimento Voice of X"

#: src/features/console/components/FirstRunTimeline.tsx:264
msgid "Suggerimento: apri i comandi rapidi con"
msgstr "Suggerimento: apri i comandi rapidi con"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:160
msgid "Suggerimento: per la Coesistenza (il tuo numero resta utilizzabile sull'app WhatsApp Business), il numero deve essere già attivo sull'app mobile da almeno 7 giorni, con versione dell'app 2.24.17 o successiva."
msgstr "Suggerimento: per la Coesistenza (il tuo numero resta utilizzabile sull'app WhatsApp Business), il numero deve essere già attivo sull'app mobile da almeno 7 giorni, con versione dell'app 2.24.17 o successiva."

#. placeholder {0}: item.sender_display
#: src/features/sources/components/InboxDetailPane.tsx:366
msgid "Suggerisci una risposta per {0}"
msgstr "Suggerisci una risposta per {0}"

#: src/features/chat/components/ChatEmptyState.tsx:386
msgid "Suggeriscimi automazioni utili in base ai miei strumenti collegati."
msgstr "Suggeriscimi automazioni utili in base ai miei strumenti collegati."

#: src/features/sales/components/crm/SuggestionsStrip.tsx:63
#: src/features/sales/components/crm/SuggestionsStrip.tsx:71
#: src/routes/_authed/workspace/work.tsx:546
msgid "Suggeriti da Ando"
msgstr "Suggeriti da Ando"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:367
msgid "Suggested automation"
msgstr "Suggested automation"

#: src/features/chat/components/ConversationCommandPalette.tsx:332
msgid "sui documenti per modificare via chat"
msgstr "sui documenti per modificare via chat"

#: src/features/dashboard/components/ChartTimeRangePanel.tsx:370
msgid "Sui risultati"
msgstr "Sui risultati"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:837
msgid "Sulla copertina l'immagine prende il posto del grafico."
msgstr "Sulla copertina l'immagine prende il posto del grafico."

#: src/features/admin/components/AdminCpqProposalCopy.tsx:98
msgid "Sulla pagina il cliente prova queste opzioni e vede i prezzi ricalcolati. Il preventivo non cambia: ci arriva una richiesta da confermare con una revisione."
msgstr "Sulla pagina il cliente prova queste opzioni e vede i prezzi ricalcolati. Il preventivo non cambia: ci arriva una richiesta da confermare con una revisione."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1416
msgid "Sulla slide: trascina per spostare, maniglie per ridimensionare, doppio clic per scrivere. Frecce sposta (Maiusc = 5%), Canc elimina, Cmd+D duplica, Cmd+C / Cmd+V copia e incolla (anche su un'altra slide), Alt disattiva le guide."
msgstr "Sulla slide: trascina per spostare, maniglie per ridimensionare, doppio clic per scrivere. Frecce sposta (Maiusc = 5%), Canc elimina, Cmd+D duplica, Cmd+C / Cmd+V copia e incolla (anche su un'altra slide), Alt disattiva le guide."

#: src/features/connectors/wizards/messagingSpec.tsx:84
msgid "Summary del thread + action items in un colpo."
msgstr "Summary del thread + action items in un colpo."

#: src/features/admin/components/AdminUsers.tsx:254
msgid "Super Admin"
msgstr "Super Admin"

#. placeholder {0}: formatBytes(i18n.locale, file.size)
#: src/features/console/pages/DocumentsPage.tsx:137
msgid "Supera il limite di 25 MB ({0})."
msgstr "Supera il limite di 25 MB ({0})."

#: src/features/admin/components/userAdminActions.tsx:84
msgid "Superadmin"
msgstr "Superadmin"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:72
msgid "Superati"
msgstr "Superati"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1682
msgid "Superficie"
msgstr "Superficie"

#: src/features/console/pages/DocsPage.tsx:616
msgid "Superficie <0>/platform/v1</0> (Bearer API key) più la Console API di sessione. Il code degli errori è stabile; il message può cambiare."
msgstr "Superficie <0>/platform/v1</0> (Bearer API key) più la Console API di sessione. Il code degli errori è stabile; il message può cambiare."

#: src/features/admin/components/AdminCpqAskAndo.tsx:175
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:56
#: src/features/settings/components/NotificationPreferences.tsx:101
msgid "Supporto"
msgstr "Supporto"

#: src/features/admin/components/AdminCpq.tsx:842
msgid "Supporto e R&D"
msgstr "Supporto e R&D"

#: src/features/admin/components/AdminCpq.tsx:195
#: src/features/admin/components/AdminCpqCanvas.tsx:153
msgid "Supporto e SLA"
msgstr "Supporto e SLA"

#: src/features/chat/components/MessagePreviewEmbed.tsx:254
msgid "SVG generato"
msgstr "SVG generato"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:153
msgid "SVG renderizzato server-side, nessun download lato client."
msgstr "SVG renderizzato server-side, nessun download lato client."

#: src/features/console/components/StatusBadges.tsx:224
msgid "Sviluppatore"
msgstr "Sviluppatore"

#: src/features/console/pages/PlaygroundPage.tsx:1319
msgid "Svuota"
msgstr "Svuota"

#: src/features/sync/components/SyncStatusPill.tsx:72
#: src/features/sync/components/SyncStatusPill.tsx:108
msgid "Sync"
msgstr "Sync"

#. placeholder {0}: formatRelativeTime(row.lastUsedAt)
#: src/routes/_authed/_modal/integrations/index.tsx:506
msgid "sync {0}"
msgstr "sync {0}"

#. placeholder {0}: job.completedItems.toLocaleString("it-IT")
#. placeholder {1}: job.totalItems.toLocaleString("it-IT")
#. placeholder {2}: job.progress
#: src/features/sync/components/SyncStatusPill.tsx:69
msgid "Sync {0}/{1} · {2}%"
msgstr "Sync {0}/{1} · {2}%"

#. placeholder {0}: job.progress
#: src/features/sync/components/SyncStatusPill.tsx:71
msgid "Sync {0}%"
msgstr "Sync {0}%"

#: src/features/connectors/components/ConnectedAccountRow.tsx:357
msgid "sync {relative} fa"
msgstr "sync {relative} fa"

#: src/features/connectors/components/_spreadsheet/SpreadsheetPreviewStep.tsx:106
msgid "Sync automatico ogni 60 min"
msgstr "Sync automatico ogni 60 min"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:271
msgid "Sync completata · 0 movimenti restituiti"
msgstr "Sync completata · 0 movimenti restituiti"

#: src/features/sync/components/DocSyncManager.tsx:803
msgid "Sync in corso · annulla sopra"
msgstr "Sync in corso · annulla sopra"

#: src/features/console/connectors/CustomConnectorDetail.tsx:576
msgid "Sync in pausa: la AppKey associata al manifest è assente, revocata o scaduta."
msgstr "Sync in pausa: la AppKey associata al manifest è assente, revocata o scaduta."

#: src/features/workspace/finance/components/BankAccountsList.tsx:161
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:191
msgid "Sync ora"
msgstr "Sync ora"

#: src/features/workspace/finance/components/BankAccountsList.tsx:161
#: src/features/workspace/finance/components/SyncStatusPanel.tsx:191
msgid "Sync…"
msgstr "Sync…"

#: src/features/admin/components/AdminHealth.tsx:47
msgid "System health"
msgstr "System health"

#: src/features/agent-modes/components/AgentModeEditor.tsx:464
msgid "System prompt"
msgstr "System prompt"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:685
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1116
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1312
#: src/features/dashboard/components/AddChartDialog.tsx:111
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:60
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:44
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:124
msgid "Tabella"
msgstr "Tabella"

#: src/features/admin/components/UserDetailContent.tsx:678
msgid "Tabella device / IP / geo / started_at — endpoint /admin/users/{id}/sessions in roadmap."
msgstr "Tabella device / IP / geo / started_at — endpoint /admin/users/{id}/sessions in roadmap."

#: src/features/chat/components/MessagePreviewEmbed.tsx:292
msgid "Tabella generata"
msgstr "Tabella generata"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:349
msgid "tabelle"
msgstr "tabelle"

#: src/features/console/pages/ResourceAccessPage.tsx:632
msgid "Tabelle accessibili"
msgstr "Tabelle accessibili"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:434
msgid "Tabelle con più colonne senza descrizione"
msgstr "Tabelle con più colonne senza descrizione"

#: src/features/connect/components/GrantManager.tsx:728
msgid "Tabelle consentite"
msgstr "Tabelle consentite"

#: src/features/connect/components/GrantManager.tsx:721
msgid "Tabelle consentite (opzionale)"
msgstr "Tabelle consentite (opzionale)"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:395
msgid "Tabelle coperte"
msgstr "Tabelle coperte"

#: src/features/connectors/wizards/erpSpec.tsx:188
msgid "Tabelle e relazioni profilate al primo collegamento — nessuna mappatura manuale."
msgstr "Tabelle e relazioni profilate al primo collegamento — nessuna mappatura manuale."

#: src/features/console/connectors/meta.ts:179
msgid "Tabelle e viste degli schemi selezionati"
msgstr "Tabelle e viste degli schemi selezionati"

#: src/features/connectors/components/management/ImportDictionaryDialog.tsx:365
msgid "Tabelle nel dizionario"
msgstr "Tabelle nel dizionario"

#: ../../packages/ui/src/ando/sources/banking-tx/BankingActions.tsx:25
msgid "Tag"
msgstr "Tag"

#: src/features/connectors/wizards/cadLibrarySpec.tsx:148
msgid "Tag automatici dal nome cartella, nessuna curation manuale."
msgstr "Tag automatici dal nome cartella, nessuna curation manuale."

#: src/features/admin/components/AdminCpqPriceBook.tsx:232
msgid "Tagli di licenza (per applicazione)"
msgstr "Tagli di licenza (per applicazione)"

#: src/features/admin/components/AdminCpq.tsx:669
msgid "Taglio"
msgstr "Taglio"

#: src/features/admin/components/orgs/AuditLogList.tsx:157
msgid "Target"
msgstr "Target"

#: src/features/console/pages/ModelsPage.tsx:210
msgid "Tariffa Ando da configurare prima dell'attivazione."
msgstr "Tariffa Ando da configurare prima dell'attivazione."

#: src/features/admin/components/AdminPricingMarkup.tsx:58
msgid "Tariffa dei consumi Engine precedenti, separata dai modelli Console."
msgstr "Tariffa dei consumi Engine precedenti, separata dai modelli Console."

#: src/features/admin/components/AdminBilling.tsx:242
msgid "Tariffa dei consumi Engine precedenti. Non modifica la commissione dei modelli Console."
msgstr "Tariffa dei consumi Engine precedenti. Non modifica la commissione dei modelli Console."

#: src/features/admin/components/orgs/OrgBillingTab.tsx:434
msgid "Tariffa dei consumi Engine precedenti. Separata dalla commissione dei modelli Console."
msgstr "Tariffa dei consumi Engine precedenti. Separata dalla commissione dei modelli Console."

#: src/features/admin/components/ModelMarkupCard.tsx:82
msgid "Tariffa globale ereditata"
msgstr "Tariffa globale ereditata"

#: src/features/admin/components/ModelMarkupCard.tsx:83
msgid "Tariffa globale predefinita"
msgstr "Tariffa globale predefinita"

#: src/features/admin/components/ModelMarkupCard.tsx:52
msgid "Tariffa globale ripristinata"
msgstr "Tariffa globale ripristinata"

#: src/features/admin/components/ModelMarkupCard.tsx:40
msgid "Tariffa modelli salvata"
msgstr "Tariffa modelli salvata"

#: src/features/admin/components/ModelMarkupCard.tsx:81
msgid "Tariffa specifica di questa organizzazione"
msgstr "Tariffa specifica di questa organizzazione"

#: src/features/admin/components/AdminPricingMarkup.tsx:43
msgid "Tariffe dei modelli"
msgstr "Tariffe dei modelli"

#: src/features/admin/components/AdminPricingMarkup.tsx:25
msgid "Tariffe modelli"
msgstr "Tariffe modelli"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:103
msgid "Tasca"
msgstr "Tasca"

#: src/features/briefing/BriefCard.tsx:123
#: src/features/workspace/components/TaskSimpleRow.tsx:87
msgid "Task"
msgstr "Task"

#: src/features/workspace/components/TaskSimpleRow.tsx:85
msgid "Task · alta priorità"
msgstr "Task · alta priorità"

#: src/features/workspace/components/TaskSimpleRow.tsx:86
msgid "Task · bassa priorità"
msgstr "Task · bassa priorità"

#: src/features/report/components/tables.tsx:209
#: src/features/workspace/components/TaskComposer.tsx:88
msgid "Task creato"
msgstr "Task creato"

#: src/features/sources/components/InboxDetailPane.tsx:321
msgid "Task creato dalla email."
msgstr "Task creato dalla email."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:52
#: src/features/settings/components/NotificationPreferences.tsx:77
msgid "Task dimenticati"
msgstr "Task dimenticati"

#: src/features/chat/components/ChatEmptyState.tsx:269
msgid "Task in ritardo"
msgstr "Task in ritardo"

#: src/features/onboarding/sectionGuides.ts:53
msgid "Task, attività e azioni proposte da Ando. Ogni azione è una proposta che vedi, modifichi e approvi prima dell'esecuzione (in demo è simulata)."
msgstr "Task, attività e azioni proposte da Ando. Ogni azione è una proposta che vedi, modifichi e approvi prima dell'esecuzione (in demo è simulata)."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:154
msgid "Tasso di conferma"
msgstr "Tasso di conferma"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:151
msgid "Tasso di consegna"
msgstr "Tasso di consegna"

#: src/features/report/components/ReportList.tsx:43
#: src/features/report/components/ReportViewer.tsx:120
msgid "Tasso di risposta"
msgstr "Tasso di risposta"

#: src/features/console/pages/FlowsPage.tsx:208
msgid "Tasso di successo"
msgstr "Tasso di successo"

#: src/features/automations/components/AutomationsHub.tsx:263
msgid "Tasso successo"
msgstr "Tasso successo"

#: src/features/account/components/UserMenuButton.tsx:458
#: src/features/help/components/KeyboardShortcutsOverlay.tsx:34
#: src/features/help/components/KeyboardShortcutsOverlay.tsx:38
#: src/routes/_authed/_modal/settings/shortcuts.tsx:27
msgid "Tasti rapidi"
msgstr "Tasti rapidi"

#: src/features/help/data/changelog.ts:71
msgid "Tauri 2 auto-updater + banner aggiornamenti"
msgstr "Tauri 2 auto-updater + banner aggiornamenti"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:686
#: src/features/hive-flows/components/FlowShareControl.tsx:123
#: src/features/hive-flows/components/FlowShareControl.tsx:202
#: src/features/sales/components/TemplateManager.tsx:197
#: src/features/settings/components/SelfProfileMemory.tsx:108
#: src/features/share/components/ShareLinkDialog.tsx:278
#: src/features/skills/components/SkillsList.tsx:202
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:401
#: src/routes/_authed/workspace/flows.index.tsx:259
#: src/routes/_authed/workspace/flows.index.tsx:385
#: src/routes/_authed/workspace/flows.index.tsx:629
msgid "Team"
msgstr "Team"

#: src/features/console/docs/content.ts:1256
msgid "Team (membri & inviti)"
msgstr "Team (membri & inviti)"

#: src/features/console/components/ConsoleShell.tsx:241
#: src/features/console/pages/MembersPage.tsx:460
msgid "Team Console"
msgstr "Team Console"

#: src/features/workspace/config.ts:336
#: src/routes/_authed/workspace/conversations.tsx:581
#: src/routes/_authed/workspace/conversations.tsx:1119
msgid "Teams"
msgstr "Teams"

#: src/features/projects/components/ProjectIcon.tsx:71
#: src/features/projects/components/sections/PersonaSection.tsx:356
#: src/features/templates/components/TemplateFieldSpecs.ts:172
msgid "Tecnico"
msgstr "Tecnico"

#: src/features/admin/components/UserDetailContent.tsx:829
msgid "Telefono"
msgstr "Telefono"

#: src/features/onboarding/DemoBookCallModal.tsx:424
msgid "Telefono (opzionale)"
msgstr "Telefono (opzionale)"

#: src/features/settings/components/ProfileSettings.tsx:137
msgid "Tema"
msgstr "Tema"

#: src/features/console/theme/ConsoleTheme.tsx:123
msgid "Tema chiaro"
msgstr "Tema chiaro"

#: src/features/console/theme/ConsoleTheme.tsx:130
msgid "Tema della console"
msgstr "Tema della console"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:418
msgid "Tema della tela"
msgstr "Tema della tela"

#: src/features/console/theme/ConsoleTheme.tsx:125
msgid "Tema di sistema"
msgstr "Tema di sistema"

#: src/features/console/theme/ConsoleTheme.tsx:124
msgid "Tema scuro"
msgstr "Tema scuro"

#: src/features/agent-modes/components/AgentModeEditor.tsx:436
msgid "Temperature"
msgstr "Temperature"

#: src/features/clean-control/utils/labels.ts:91
msgid "Tempes."
msgstr "Tempes."

#: src/features/clean-control/utils/labels.ts:77
msgid "Tempestività"
msgstr "Tempestività"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1338
#: ../../packages/ui/src/editors/DraftActionBar.tsx:114
#: src/features/automations/components/AutomationsHub.tsx:323
#: src/features/console/pages/FlowsPage.tsx:308
#: src/features/hive-flows/run/WorkbenchSurface.tsx:97
#: src/features/voice_report/components/NewReportDialog.tsx:917
#: src/routes/_authed/workspace/templates/$kind.tsx:105
msgid "Template"
msgstr "Template"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:169
msgid "Template (opzionale)"
msgstr "Template (opzionale)"

#. placeholder {0}: res.slug
#. placeholder {1}: res.mode
#. placeholder {2}: res.placeholders.length
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:112
msgid "Template {0} caricato ({1}, {2} segnaposto)"
msgstr "Template {0} caricato ({1}, {2} segnaposto)"

#. placeholder {0}: res.slug
#: src/features/settings/marp/CssUploadPanel.tsx:100
msgid "Template {0} salvato"
msgstr "Template {0} salvato"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:849
msgid "Template {label}{statusLabel}{mergeLabel}"
msgstr "Template {label}{statusLabel}{mergeLabel}"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1181
msgid "Template Ando"
msgstr "Template Ando"

#: src/features/chat/components/ChatEmptyState.tsx:339
msgid "Template canvas"
msgstr "Template canvas"

#: src/features/settings/components/BrandKitSettings.tsx:198
msgid "Template caricato"
msgstr "Template caricato"

#: src/features/settings/components/BrandKitSettings.tsx:500
msgid "Template caricato — la generazione parte da questo file."
msgstr "Template caricato — la generazione parte da questo file."

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:1123
msgid "Template del documento"
msgstr "Template del documento"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:977
msgid "Template del tuo Brand Kit"
msgstr "Template del tuo Brand Kit"

#: src/features/settings/marp/CssUploadPanel.tsx:248
msgid "Template esistenti"
msgstr "Template esistenti"

#: src/features/settings/components/BrandKitSettings.tsx:491
msgid "Template Excel"
msgstr "Template Excel"

#: src/features/settings/MarpTemplateSettings.tsx:62
msgid "Template Marp personalizzati"
msgstr "Template Marp personalizzati"

#: src/routes/_authed/workspace/templates/edit.$slug.tsx:61
msgid "Template non trovato"
msgstr "Template non trovato"

#: src/features/settings/components/BrandKitSettings.tsx:490
msgid "Template PowerPoint"
msgstr "Template PowerPoint"

#: src/features/hive-flows/components/DocTemplatesField.tsx:40
msgid "Template predefinito"
msgstr "Template predefinito"

#: src/features/settings/components/PresentationTemplates.tsx:202
msgid "Template presentazioni"
msgstr "Template presentazioni"

#: src/features/settings/components/BrandKitSettings.tsx:489
msgid "Template Word"
msgstr "Template Word"

#: src/features/admin/components/AdminCanvas.tsx:124
msgid "Tempo di compilation · distribuzione"
msgstr "Tempo di compilation · distribuzione"

#: src/features/billing/components/UsageInsightsCard.tsx:229
msgid "Tempo risparmiato"
msgstr "Tempo risparmiato"

#: src/features/settings/components/BillingSettings.tsx:123
msgid "Tempo risparmiato, volume di lavoro e knowledge base accumulata — stima conservativa basata sui tuoi consumi."
msgstr "Tempo risparmiato, volume di lavoro e knowledge base accumulata — stima conservativa basata sui tuoi consumi."

#: src/features/clean-control/components/EventQueue.tsx:102
msgid "Temporal"
msgstr "Temporal"

#: src/features/admin/components/AdminHypermem.tsx:184
#: src/features/admin/components/hypermem/HmTenantsTab.tsx:37
#: src/features/connectors/wizards/legalStorageSpec.tsx:79
msgid "Tenant"
msgstr "Tenant"

#: src/features/connectors/wizards/legalStorageSpec.tsx:40
msgid "Tenant conservazione"
msgstr "Tenant conservazione"

#: src/features/admin/components/AdminCpqPriceBook.tsx:222
msgid "Tenant sul cluster SaaS"
msgstr "Tenant sul cluster SaaS"

#: src/features/console/docs/content.ts:252
msgid "Tenant, scope e rate-limit tier della chiave corrente."
msgstr "Tenant, scope e rate-limit tier della chiave corrente."

#: src/features/admin/components/hypermem/HmApprovalQueueTab.tsx:339
msgid "Tenant: {tenantId}."
msgstr "Tenant: {tenantId}."

#. placeholder {0}: delivery.attempts
#: src/features/console/webhooks/WebhooksPanel.tsx:172
msgid "Tentativi: {0}"
msgstr "Tentativi: {0}"

#: src/features/dashboard/components/DashboardToolbar.tsx:104
msgid "Termina modifica"
msgstr "Termina modifica"

#: src/features/dashboard/components/DashboardToolbar.tsx:87
msgid "Termina modifica layout"
msgstr "Termina modifica layout"

#: src/features/admin/components/UserDetailContent.tsx:218
#: src/features/admin/components/UserDetailContent.tsx:844
msgid "Termina ora"
msgstr "Termina ora"

#: src/features/billing/components/CurrentPlanCard.tsx:93
msgid "Termine: {end}"
msgstr "Termine: {end}"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:264
msgid "TERRA β"
msgstr "TERRA β"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:912
msgid "test"
msgstr "test"

#: src/features/console/flows/hooks.ts:65
#: src/features/console/pages/FlowsPage.tsx:690
msgid "Test completato"
msgstr "Test completato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:314
msgid "Testa accesso"
msgstr "Testa accesso"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:429
msgid "Testa configurazione"
msgstr "Testa configurazione"

#: src/features/console/docs/content.ts:1579
msgid "Testa l'accesso al provider"
msgstr "Testa l'accesso al provider"

#: src/features/console/docs/content.ts:1410
msgid "Testa un account"
msgstr "Testa un account"

#: src/features/chat/components/ChatEmptyState.tsx:365
msgid "Testa workflow"
msgstr "Testa workflow"

#: src/features/admin/components/orgs/OrgSecurityTab.tsx:230
msgid "Tester forza password"
msgstr "Tester forza password"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:842
msgid "Testi"
msgstr "Testi"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:204
#: src/features/admin/components/deckEditor/DeckEditor.tsx:714
#: src/features/admin/components/deckEditor/DeckEditor.tsx:973
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1301
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1317
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1510
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1678
#: src/features/dashboard/utils/calculatedFields.ts:78
#: src/features/sales/components/BatchSendModal.tsx:340
#: src/features/sales/components/TemplateManager.tsx:321
msgid "Testo"
msgstr "Testo"

#: src/features/settings/components/BrandKitSettings.tsx:81
msgid "Testo (ink)"
msgstr "Testo (ink)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2459
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2460
msgid "Testo alternativo"
msgstr "Testo alternativo"

#: src/features/connectors/components/management/BusinessContextBanner.tsx:378
#: src/features/connectors/components/management/BusinessContextEditor.tsx:149
msgid "Testo del contesto di business"
msgstr "Testo del contesto di business"

#: src/features/templates/components/TemplateFieldSpecs.ts:147
msgid "Testo del footer"
msgstr "Testo del footer"

#: src/features/console/components/DocumentAcquiredContent.tsx:25
msgid "Testo già acquisito da Ando per questo documento. Puoi confrontarlo con l'originale; questa vista è in sola lettura."
msgstr "Testo già acquisito da Ando per questo documento. Puoi confrontarlo con l'originale; questa vista è in sola lettura."

#: src/features/admin/components/AdminCpq.tsx:619
msgid "Testo precedente: {legacyValidUntil}. Scegli una data per mostrarla in ogni lingua."
msgstr "Testo precedente: {legacyValidUntil}. Scegli una data per mostrarla in ogni lingua."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:832
msgid "Testo regola"
msgstr "Testo regola"

#: src/features/settings/components/BrandKitSettings.tsx:82
msgid "Testo secondario"
msgstr "Testo secondario"

#: src/features/admin/components/AdminCpqCanvas.tsx:258
msgid "testo standard del listino: per una variante aggiungi una sezione nella scheda Proposta."
msgstr "testo standard del listino: per una variante aggiungi una sezione nella scheda Proposta."

#: src/features/console/components/CreateKeyWizard.tsx:586
msgid "Tetto applicato al runtime: superata la soglia la chiave riceve un errore 402. Lascia vuoto per nessun limite."
msgstr "Tetto applicato al runtime: superata la soglia la chiave riceve un errore 402. Lascia vuoto per nessun limite."

#: src/features/admin/components/AdminCpqPriceBook.tsx:305
msgid "Tetto manutenzione per ambiente (EUR, vuoto = nessuno)"
msgstr "Tetto manutenzione per ambiente (EUR, vuoto = nessuno)"

#: src/features/console/pages/KeyDetailPage.tsx:275
#: src/features/console/pages/KeyDetailPage.tsx:441
msgid "Tetto mensile applicato al runtime per questa chiave."
msgstr "Tetto mensile applicato al runtime per questa chiave."

#: src/features/admin/components/CostTraceDetailSection.tsx:268
msgid "Thinking + reasoning tokens"
msgstr "Thinking + reasoning tokens"

#: src/features/workspace/components/InboxItemRow.tsx:151
msgid "Thread con {threadCount} messaggi"
msgstr "Thread con {threadCount} messaggi"

#: src/features/sources/components/InboxDetailPane.tsx:693
msgid "Thread non ancora indicizzato. Mostro l'anteprima salvata."
msgstr "Thread non ancora indicizzato. Mostro l'anteprima salvata."

#: src/features/connectors/wizards/emailSpec.tsx:35
msgid "Thread, allegati e CC indicizzati per ricerca naturale"
msgstr "Thread, allegati e CC indicizzati per ricerca naturale"

#: src/features/console/pages/UsagePage.tsx:397
msgid "Throughput del periodo"
msgstr "Throughput del periodo"

#: src/features/onboarding/DemoBookCallModal.tsx:538
msgid "Ti abbiamo aggiunto in coda. Vuoi prenotare direttamente ora?"
msgstr "Ti abbiamo aggiunto in coda. Vuoi prenotare direttamente ora?"

#: src/features/auth/desktop/DesktopLoginForm.tsx:913
msgid "Ti abbiamo inviato un codice a 6 cifre."
msgstr "Ti abbiamo inviato un codice a 6 cifre."

#: src/features/onboarding/DemoBookCallModal.tsx:365
msgid "Ti mostriamo Ando sui tuoi dati reali. Lascia due dettagli e ti scriviamo entro il giorno."
msgstr "Ti mostriamo Ando sui tuoi dati reali. Lascia due dettagli e ti scriviamo entro il giorno."

#: src/features/onboarding/DemoBookCallBanner.tsx:46
msgid "Ti piace Ando? <0>Provalo sui tuoi dati reali</0> — prenota 15 min col team."
msgstr "Ti piace Ando? <0>Provalo sui tuoi dati reali</0> — prenota 15 min col team."

#: src/features/sources/components/InboxDetailPane.tsx:572
msgid "Ti ricorderò il follow-up."
msgstr "Ti ricorderò il follow-up."

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:283
msgid "Tieni aperta l'app WhatsApp Business sul telefono per una sincronizzazione più rapida."
msgstr "Tieni aperta l'app WhatsApp Business sul telefono per una sincronizzazione più rapida."

#: src/features/clean-control/utils/signalCatalog.ts:100
#: src/features/clean-control/utils/signalCatalog.ts:113
msgid "Tieni entrambi"
msgstr "Tieni entrambi"

#: src/features/admin/components/AdminUsers.tsx:378
#: src/features/admin/components/orgs/OrgDetailShell.tsx:406
#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:181
#: src/features/admin/components/orgs/OrgMembersTab.tsx:359
#: src/features/admin/components/UserDetailContent.tsx:383
#: src/features/console/pages/PlaygroundPage.tsx:883
msgid "Tier"
msgstr "Tier"

#: src/features/settings/components/BillingSettings.tsx:131
msgid "Tier attivo, stato sottoscrizione e periodo di fatturazione."
msgstr "Tier attivo, stato sottoscrizione e periodo di fatturazione."

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:185
msgid "Tier provisioning"
msgstr "Tier provisioning"

#: src/features/admin/components/AdminOrgs.tsx:1179
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:310
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:316
msgid "Tier usage"
msgstr "Tier usage"

#. placeholder {0}: member?.name ?? member?.email ?? i18n._(msg`questo membro`)
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:245
msgid "Tier usage e accesso connector per {0}."
msgstr "Tier usage e accesso connector per {0}."

#: src/features/admin/components/AdminEngagement.tsx:153
msgid "Time-to-First-Value (TTFV)"
msgstr "Time-to-First-Value (TTFV)"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:410
msgid "Timeline cronologica delle decisioni MetaPrompt sui prompt. Ogni evento è auditato e immutabile."
msgstr "Timeline cronologica delle decisioni MetaPrompt sui prompt. Ogni evento è auditato e immutabile."

#: src/features/report/components/CategoryEmergenceTimeline.tsx:129
msgid "Timeline di emergenza delle categorie"
msgstr "Timeline di emergenza delle categorie"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1301
msgid "Timeout connessione (ms)"
msgstr "Timeout connessione (ms)"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1184
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1248
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:1351
msgid "Timeout connessione (s)"
msgstr "Timeout connessione (s)"

#: src/features/chat/wsHandlers.ts:314
msgid "Timeout della query"
msgstr "Timeout della query"

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:481
msgid "Timeout in secondi (opzionale)"
msgstr "Timeout in secondi (opzionale)"

#: src/features/chat/wsHandlers.ts:316
msgid "Timeout utente"
msgstr "Timeout utente"

#: src/features/automations/components/AutomationDetailSection.tsx:164
msgid "Timezone"
msgstr "Timezone"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:373
msgid "Tipi di chat"
msgstr "Tipi di chat"

#: src/features/settings/components/NotificationPreferences.tsx:355
msgid "Tipi di nudge"
msgstr "Tipi di nudge"

#: src/features/console/components/CreateKeyWizard.tsx:451
#: src/features/console/pages/KeyDetailPage.tsx:389
msgid "Tipi di sorgente"
msgstr "Tipi di sorgente"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:459
msgid "Tipi di spazio"
msgstr "Tipi di spazio"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:184
#: src/features/admin/components/AdminCanvas.tsx:215
#: src/features/admin/components/AdminCpqPriceBook.tsx:341
#: src/features/admin/components/AdminDecks.tsx:338
#: src/features/admin/components/AdminDecks.tsx:502
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:329
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:413
#: src/features/admin/components/orgs/OrgSSOTab.tsx:268
#: src/features/console/connectors/CustomConnectorDetail.tsx:334
#: src/features/console/connectors/CustomConnectorDetail.tsx:390
#: src/features/console/connectors/CustomConnectorsPanel.tsx:262
#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:238
#: src/features/console/pages/AccessOverviewPage.tsx:162
#: src/features/console/pages/SchemaPage.tsx:323
#: src/features/dfm-rules/components/DfmRulesPage.tsx:884
#: src/features/sales/components/TemplateManager.tsx:265
#: src/features/settings/components/PresentationTemplates.tsx:782
#: src/features/workspace/components/searchFilters/CalendarSearchFilters.tsx:57
#: src/features/workspace/components/searchFilters/DocumentsSearchFilters.tsx:47
#: src/features/workspace/components/searchFilters/FinanceSearchFilters.tsx:85
#: src/features/workspace/components/searchFilters/TechnicalSearchFilters.tsx:63
msgid "Tipo"
msgstr "Tipo"

#: src/features/console/pages/PlaygroundPage.tsx:887
msgid "Tipo connettore"
msgstr "Tipo connettore"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:247
#: src/features/console/pages/ConnectorsPage.tsx:247
msgid "Tipo di connettore"
msgstr "Tipo di connettore"

#: src/features/console/pages/TracesPage.tsx:301
msgid "Tipo di evento"
msgstr "Tipo di evento"

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:527
msgid "Tipo di feature"
msgstr "Tipo di feature"

#. placeholder {0}: flow.flow_type
#: src/routes/_authed/_modal/integrations/$capability.tsx:465
msgid "Tipo di flusso non supportato ({0}). Aggiorna l'app."
msgstr "Tipo di flusso non supportato ({0}). Aggiorna l'app."

#: src/features/admin/components/AdminCpq.tsx:1003
#: src/features/admin/components/AdminCpqPriceBook.tsx:342
#: src/features/console/pages/PlaygroundPage.tsx:1979
msgid "Tipo di fonte"
msgstr "Tipo di fonte"

#: src/features/dashboard/components/AddChartDialog.tsx:481
#: src/features/dashboard/components/ChartConfigurationMenu.tsx:82
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:88
#: src/features/dashboard/components/DashboardChartCard.tsx:857
#: src/features/dashboard/components/DashboardChartCard.tsx:860
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:67
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:205
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:527
msgid "Tipo di grafico"
msgstr "Tipo di grafico"

#: src/features/console/components/CreateKeyWizard.tsx:314
msgid "Tipo di identità"
msgstr "Tipo di identità"

#: src/features/connect/components/MemberManager.tsx:367
msgid "Tipo di invito"
msgstr "Tipo di invito"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:507
msgid "Tipo di origine"
msgstr "Tipo di origine"

#: src/features/automations/components/ScheduleEditor.tsx:184
msgid "Tipo di programmazione"
msgstr "Tipo di programmazione"

#: src/features/console/pages/AccessOverviewPage.tsx:195
msgid "Tipo di risorsa"
msgstr "Tipo di risorsa"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:757
msgid "Tipo di slide"
msgstr "Tipo di slide"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:175
msgid "Tipo di sorgente"
msgstr "Tipo di sorgente"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:192
msgid "Tipo evento"
msgstr "Tipo evento"

#: src/features/console/pages/TracesPage.tsx:108
msgid "tipo non determinato"
msgstr "tipo non determinato"

#. placeholder {0}: file.type || i18n._(msg`sconosciuto`)
#: src/features/workspace/components/UploadModal.tsx:147
msgid "Tipo non supportato ({0})"
msgstr "Tipo non supportato ({0})"

#: src/features/templates/components/TemplateEditor.tsx:373
msgid "Tipo:"
msgstr "Tipo:"

#. placeholder {0}: idp.type
#: src/features/admin/components/orgs/OrgSSOTab.tsx:222
msgid "Tipo: {0}"
msgstr "Tipo: {0}"

#: src/features/settings/components/BrandKitSettings.tsx:307
msgid "Tipografia"
msgstr "Tipografia"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:425
msgid "Title / preview"
msgstr "Title / preview"

#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:165
#: ../../packages/ui/src/ando/actions/ActionProposalSurface.tsx:166
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:265
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:182
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:687
#: ../../packages/ui/src/ando/email/RichEmailBody.tsx:698
#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:165
#: src/features/admin/components/AdminCanvas.tsx:212
#: src/features/admin/components/AdminCpqAskAndo.tsx:165
#: src/features/admin/components/AdminCpqProposalCopy.tsx:195
#: src/features/admin/components/deckEditor/DeckEditor.tsx:712
#: src/features/admin/components/deckEditor/DeckEditor.tsx:972
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1315
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1343
#: src/features/admin/components/PageEditor.tsx:417
#: src/features/dashboard/components/AddChartDialog.tsx:451
#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:254
#: src/features/share/components/ShareLinkDialog.tsx:397
#: src/features/voice_report/components/NewReportDialog.tsx:825
#: src/features/voice_report/components/SettingsTab.tsx:123
msgid "Titolo"
msgstr "Titolo"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1501
msgid "Titolo (facoltativo)"
msgstr "Titolo (facoltativo)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1053
msgid "Titolo colonna"
msgstr "Titolo colonna"

#: src/features/admin/components/AdminDecksAskAndo.tsx:182
msgid "titolo del deck"
msgstr "titolo del deck"

#: src/features/hive-flows/components/FlowFormPublish.tsx:145
msgid "Titolo del modulo"
msgstr "Titolo del modulo"

#: src/features/workspace/components/TaskComposer.tsx:141
msgid "Titolo del task"
msgstr "Titolo del task"

#: src/features/share/components/ShareLinkDialog.tsx:396
msgid "Titolo della condivisione"
msgstr "Titolo della condivisione"

#: src/features/projects/components/sections/TasksSection.tsx:232
msgid "Titolo della nuova attività"
msgstr "Titolo della nuova attività"

#: src/features/admin/components/AdminCpqAskAndo.tsx:184
#: src/features/admin/components/AdminCpqProposalCopy.tsx:62
msgid "Titolo della proposta"
msgstr "Titolo della proposta"

#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:189
msgid "Titolo della slide"
msgstr "Titolo della slide"

#: src/features/admin/components/AdminCpqProposalCopy.tsx:59
msgid "Titolo e apertura"
msgstr "Titolo e apertura"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:264
msgid "Titolo evento"
msgstr "Titolo evento"

#: src/features/admin/components/AdminCpq.tsx:607
msgid "Titolo interno"
msgstr "Titolo interno"

#: src/features/workspace/config.ts:148
#: src/features/workspace/config.ts:150
msgid "To Do"
msgstr "To Do"

#: src/features/share/components/ShareLinkDialog.tsx:422
msgid "Tocca il testo per modificarlo"
msgstr "Tocca il testo per modificarlo"

#. placeholder {0}: d.name
#. placeholder {0}: html.name
#: src/features/admin/components/AdminDecks.tsx:364
#: src/features/admin/components/AdminDecks.tsx:421
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2760
#: src/features/admin/components/PageEditor.tsx:200
msgid "Togli {0}"
msgstr "Togli {0}"

#. placeholder {0}: lang.toUpperCase()
#: src/features/admin/components/PageEditor.tsx:338
msgid "Togli la lingua {0}"
msgstr "Togli la lingua {0}"

#: src/features/console/pages/UsagePage.tsx:254
msgid "token"
msgstr "token"

#: src/features/admin/components/CostTraceDetailSection.tsx:229
#: src/features/console/pages/UsagePage.tsx:466
#: src/features/console/pages/UsagePage.tsx:531
#: src/features/settings/components/PlatformUsageCard.tsx:64
msgid "Token"
msgstr "Token"

#: src/features/console/pages/UsagePage.tsx:407
msgid "Token ({windowDays}g)"
msgstr "Token ({windowDays}g)"

#: src/features/console/pages/UsagePage.tsx:458
msgid "Token al giorno"
msgstr "Token al giorno"

#: src/features/admin/components/orgs/OrgCostTab.tsx:362
msgid "Token cached"
msgstr "Token cached"

#: src/features/connectors/wizards/crmSpec.tsx:115
#: src/features/connectors/wizards/projectManagementSpec.tsx:81
msgid "Token criptati at-rest, scope minimo, cancellazione GDPR garantita."
msgstr "Token criptati at-rest, scope minimo, cancellazione GDPR garantita."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:338
msgid "Token in / out"
msgstr "Token in / out"

#: src/features/admin/components/orgs/OrgCostTab.tsx:350
msgid "Token input"
msgstr "Token input"

#: src/features/admin/components/orgs/OrgCostTab.tsx:356
msgid "Token output"
msgstr "Token output"

#: src/features/admin/components/AdminCostTracking.tsx:102
msgid "Token registrati (llm_usage) vs Google Cloud Monitoring — project-level"
msgstr "Token registrati (llm_usage) vs Google Cloud Monitoring — project-level"

#: src/features/settings/marp/PptxExtractPanel.tsx:191
msgid "Token rilevati"
msgstr "Token rilevati"

#: src/routes/_authed/_modal/integrations/index.tsx:514
msgid "token scaduto"
msgstr "token scaduto"

#: src/features/connectors/components/ConnectedAccountRow.tsx:371
msgid "Token scaduto"
msgstr "Token scaduto"

#: src/routes/_authed/_modal/integrations/index.tsx:440
msgid "Token scaduto · richiede riconnessione"
msgstr "Token scaduto · richiede riconnessione"

#: src/features/admin/components/CostTraceDetailSection.tsx:157
msgid "Token totali"
msgstr "Token totali"

#: src/features/connectors/wizards/messagingSpec.tsx:98
msgid "Tokens criptati"
msgstr "Tokens criptati"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:61
msgid "Tolleranza"
msgstr "Tolleranza"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:660
msgid "Tolleranza (±)"
msgstr "Tolleranza (±)"

#: src/features/projects/components/sections/PersonaSection.tsx:334
#: src/features/templates/components/TemplateFieldSpecs.ts:165
msgid "Tono"
msgstr "Tono"

#: src/features/projects/components/sections/PersonaSection.tsx:342
msgid "Tono del progetto"
msgstr "Tono del progetto"

#: src/features/settings/components/BrandKitSettings.tsx:443
msgid "Tono di voce attivo"
msgstr "Tono di voce attivo"

#: src/features/settings/components/BrandKitSettings.tsx:440
msgid "Tono di voce per i testi generati. La lingua resta sempre quella del thread."
msgstr "Tono di voce per i testi generati. La lingua resta sempre quella del thread."

#: src/features/projects/components/ProjectDetailPage.tsx:103
msgid "Tono: {tone}"
msgstr "Tono: {tone}"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:129
msgid "tool"
msgstr "tool"

#: src/features/admin/components/AdminQuality.tsx:96
msgid "Tool × esito · heatmap"
msgstr "Tool × esito · heatmap"

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:233
msgid "Tool chiamati"
msgstr "Tool chiamati"

#: src/features/admin/components/AdminOrgs.tsx:807
msgid "Toolbar · multi-select · bulk actions · KPI tier · hard-delete con conferma slug. Dettaglio per-org disponibile cliccando sulla riga."
msgstr "Toolbar · multi-select · bulk actions · KPI tier · hard-delete con conferma slug. Dettaglio per-org disponibile cliccando sulla riga."

#: src/features/help/data/changelog.ts:48
msgid "Tools menu del composer: \"Analisi CAD\" con selezione rettangolare sul DXF, Focus selector Standard / Strutturati / Full, navigazione automatica alla dashboard quando l'agente risponde con risultati strutturati."
msgstr "Tools menu del composer: \"Analisi CAD\" con selezione rettangolare sul DXF, Focus selector Standard / Strutturati / Full, navigazione automatica alla dashboard quando l'agente risponde con risultati strutturati."

#: src/routes/_authed/workspace/finance.tsx:1594
msgid "Top 10 spese del mese con causale"
msgstr "Top 10 spese del mese con causale"

#: src/features/admin/components/AdminAutomation.tsx:214
msgid "Top automazioni"
msgstr "Top automazioni"

#: src/features/admin/components/AdminCanvas.tsx:200
msgid "Top entità · per menzione"
msgstr "Top entità · per menzione"

#: src/features/admin/components/AdminOverview.tsx:138
msgid "Top organizzazioni per costo"
msgstr "Top organizzazioni per costo"

#: src/features/agent-modes/components/AgentModeEditor.tsx:446
msgid "Top P"
msgstr "Top P"

#: src/features/admin/components/AdminQuality.tsx:161
#: src/features/admin/components/AdminQuality.tsx:173
msgid "Top tool per chiamate"
msgstr "Top tool per chiamate"

#: src/features/admin/components/AdminCostTracking.tsx:308
msgid "Top trace costosi"
msgstr "Top trace costosi"

#: src/features/admin/components/AdminEngagement.tsx:423
msgid "Top utenti attivi"
msgstr "Top utenti attivi"

#: src/features/actions/components/ActionFormSurface.tsx:173
msgid "Torna →"
msgstr "Torna →"

#: src/features/console/components/ConsoleShell.tsx:603
msgid "Torna ad Ando"
msgstr "Torna ad Ando"

#: src/features/console/pages/ResourceAccessPage.tsx:249
msgid "Torna agli accessi"
msgstr "Torna agli accessi"

#: src/routes/_authed/workspace/connect.$spaceId.tsx:173
msgid "Torna agli spazi"
msgstr "Torna agli spazi"

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:177
msgid "Torna ai canvas"
msgstr "Torna ai canvas"

#: src/features/console/pages/ConnectorDetailPage.tsx:483
msgid "Torna ai connettori"
msgstr "Torna ai connettori"

#: src/features/admin/components/AdminCpq.tsx:480
msgid "Torna ai preventivi"
msgstr "Torna ai preventivi"

#: src/features/projects/components/ProjectDetailPage.tsx:443
msgid "Torna ai progetti"
msgstr "Torna ai progetti"

#: src/routes/_authed/workspace/flows.$flowId.tsx:376
msgid "Torna ai tuoi flow"
msgstr "Torna ai tuoi flow"

#: src/routes/_authed/workspace/calendar.tsx:1478
#: src/routes/_authed/workspace/calendar.tsx:1600
msgid "Torna al calendario"
msgstr "Torna al calendario"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:169
msgid "Torna al catalogo"
msgstr "Torna al catalogo"

#: src/routes/_authed/_modal/admin/route.tsx:191
#: src/routes/_authed/_modal/integrations/route.tsx:61
#: src/routes/_authed/_modal/integrations/route.tsx:69
#: src/routes/_authed/_modal/route.tsx:161
#: src/routes/_authed/_modal/settings/route.tsx:56
#: src/routes/_authed/_modal/settings/route.tsx:64
msgid "Torna al workspace"
msgstr "Torna al workspace"

#: src/features/actions/components/FocusedActionView.tsx:1052
#: src/features/console/pages/FlowDetailPage.tsx:166
#: src/features/console/pages/KeyDetailPage.tsx:636
msgid "Torna all'elenco"
msgstr "Torna all'elenco"

#: src/routes/_authed/workspace/conversations.tsx:1114
#: src/routes/_authed/workspace/conversations.tsx:1213
msgid "Torna all'inbox"
msgstr "Torna all'inbox"

#: src/features/structured-data/components/InlineChartPanel.tsx:86
msgid "Torna alla chat"
msgstr "Torna alla chat"

#: src/features/onboarding/DemoBookCallModal.tsx:559
#: src/features/onboarding/DemoBookCallModal.tsx:564
msgid "Torna alla demo"
msgstr "Torna alla demo"

#: src/routes/_authed/workspace/templates/edit.$slug.tsx:67
msgid "Torna alla lista"
msgstr "Torna alla lista"

#: src/routes/_authed/workspace/documents.tsx:1114
msgid "Torna alla lista documenti"
msgstr "Torna alla lista documenti"

#: src/features/admin/components/orgs/OrgDetailShell.tsx:282
msgid "Torna alla lista organizzazioni"
msgstr "Torna alla lista organizzazioni"

#. placeholder {0}: action.title
#: src/features/actions/components/ActionFormSurface.tsx:145
msgid "Torna alla proposta: {0}"
msgstr "Torna alla proposta: {0}"

#. placeholder {0}: action.title
#. placeholder {1}: destDef.label
#: src/features/actions/components/ActionFormSurface.tsx:144
msgid "Torna alla proposta: {0} su {1}"
msgstr "Torna alla proposta: {0} su {1}"

#: src/features/automations/components/AutomationsHub.tsx:136
msgid "Torna alle automazioni"
msgstr "Torna alle automazioni"

#: src/features/onboarding/demoTourSteps.ts:118
msgid "Torna in chat e fai la tua prima domanda, oppure collega un nuovo strumento dai Connettori. Puoi rivedere questo giro quando vuoi dalla schermata iniziale."
msgstr "Torna in chat e fai la tua prima domanda, oppure collega un nuovo strumento dai Connettori. Puoi rivedere questo giro quando vuoi dalla schermata iniziale."

#: src/features/onboarding/demoTourSteps.ts:117
msgid "Torna in chat e fai la tua prima domanda. Un buon inizio: «Riassumi le email che richiedono risposta» oppure «Qual è la policy ferie aziendale?». Puoi rivedere questo giro dalla schermata iniziale."
msgstr "Torna in chat e fai la tua prima domanda. Un buon inizio: «Riassumi le email che richiedono risposta» oppure «Qual è la policy ferie aziendale?». Puoi rivedere questo giro dalla schermata iniziale."

#: src/features/hive-flows/run/FlowRunWorkspace.tsx:1657
msgid "Torna indietro"
msgstr "Torna indietro"

#: src/features/maintenance/MaintenanceScreen.tsx:205
msgid "Torniamo tra pochissimo"
msgstr "Torniamo tra pochissimo"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2064
#: src/features/dashboard/components/AddChartDialog.tsx:109
#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:58
#: src/features/dashboard/components/wizard/WizardChartTypePicker.tsx:42
#: src/features/structured-data/components/EnterpriseDataPanel.tsx:122
msgid "Torta"
msgstr "Torta"

#: ../../packages/ui/src/ando/actions/FicCreateInvoicePreview.tsx:159
#: src/features/admin/components/AdminOrgs.tsx:829
msgid "Totale"
msgstr "Totale"

#: src/features/admin/components/AdminCpq.tsx:208
#: src/features/admin/components/AdminCpqList.tsx:153
msgid "Totale anno 1"
msgstr "Totale anno 1"

#: ../../packages/ui/src/ando/actions/SdiInvoicePreview.tsx:57
msgid "Totale documento"
msgstr "Totale documento"

#: src/features/sales/components/SalesOverview.tsx:111
msgid "Totale lead"
msgstr "Totale lead"

#: ../../packages/ui/src/ando/actions/QuotationDraftPreview.tsx:136
msgid "Totale stimato · {matched} voci"
msgstr "Totale stimato · {matched} voci"

#: src/features/settings/components/SecuritySettings.tsx:233
msgid "TOTP attivato."
msgstr "TOTP attivato."

#: src/features/admin/components/UserDetailContent.tsx:701
msgid "TOTP authenticator"
msgstr "TOTP authenticator"

#: src/features/settings/components/SecuritySettings.tsx:224
msgid "TOTP rimosso."
msgstr "TOTP rimosso."

#: ../../packages/ui/src/ando/actions/action-lifecycle.tsx:116
#: src/features/maintenance/MaintenanceBanner.tsx:117
msgid "tra"
msgstr "tra"

#. placeholder {0}: Math.floor(delta / MS_DAY)
#: src/routes/_authed/workspace/calendar.tsx:1517
msgid "Tra {0} giorni"
msgstr "Tra {0} giorni"

#. placeholder {0}: Math.floor(delta / MS_MIN)
#: src/routes/_authed/workspace/calendar.tsx:1514
msgid "Tra {0} minuti"
msgstr "Tra {0} minuti"

#. placeholder {0}: Math.floor(delta / MS_HOUR)
#: src/routes/_authed/workspace/calendar.tsx:1515
msgid "Tra {0} ore"
msgstr "Tra {0} ore"

#: src/features/automations/components/formatters.ts:80
msgid "tra {days}d"
msgstr "tra {days}d"

#: src/features/automations/components/formatters.ts:78
msgid "tra {hrs}h"
msgstr "tra {hrs}h"

#: src/features/automations/components/formatters.ts:76
msgid "tra {mins}m"
msgstr "tra {mins}m"

#: src/features/sources/components/InboxDetailPane.tsx:1048
#: src/features/workspace/components/TaskSimpleRow.tsx:253
#: src/features/workspace/inbox/hooks/useSnoozeStore.ts:176
msgid "Tra 1 ora"
msgstr "Tra 1 ora"

#: src/features/workspace/inbox/__tests__/SnoozePopover.test.tsx:63
msgid "Tra 30 minuti"
msgstr "Tra 30 minuti"

#: src/features/console/components/AssistPanel.tsx:87
#: src/features/console/pages/PlaygroundPage.tsx:1015
msgid "Traccia di esecuzione"
msgstr "Traccia di esecuzione"

#: src/features/sync/components/picker/GraphTreePickerModal.tsx:775
#: src/features/sync/components/picker/GraphTreePickerModal.tsx:797
msgid "tracciata"
msgstr "tracciata"

#: src/features/console/traces/TracePayloadReader.tsx:25
msgid "Trace non disponibile per il tuo accesso. Verifica la richiesta selezionata."
msgstr "Trace non disponibile per il tuo accesso. Verifica la richiesta selezionata."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:179
msgid "Trace non trovato o errore di rete."
msgstr "Trace non trovato o errore di rete."

#: src/features/admin/components/UserDetailContent.tsx:274
msgid "Trace recenti"
msgstr "Trace recenti"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:858
msgid "traduzione mancante"
msgstr "traduzione mancante"

#: src/features/console/pages/UsagePage.tsx:387
msgid "Traffico Engine negli ultimi {windowDays} giorni."
msgstr "Traffico Engine negli ultimi {windowDays} giorni."

#: src/features/settings/components/NotificationPreferences.tsx:95
msgid "Traguardi"
msgstr "Traguardi"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:783
msgid "Trama"
msgstr "Trama"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:246
msgid "TRAMA attuale"
msgstr "TRAMA attuale"

#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:241
#: ../../packages/ui/src/ando/composer-parts/ToolsMenu.tsx:255
msgid "TRAMA Lakehouse"
msgstr "TRAMA Lakehouse"

#: src/features/chat/components/Messages.tsx:126
#: src/routes/_authed/route.tsx:1831
msgid "TRAMA β"
msgstr "TRAMA β"

#: src/features/dashboard/components/DashboardViewControls.tsx:52
msgid "Trascina e ridimensiona i widget per modificare il layout."
msgstr "Trascina e ridimensiona i widget per modificare il layout."

#: src/features/workspace/components/UploadModal.tsx:349
msgid "Trascina i file oppure clicca per selezionare"
msgstr "Trascina i file oppure clicca per selezionare"

#: src/features/console/pages/DocumentsPage.tsx:198
msgid "Trascina i file qui o fai clic per caricarli"
msgstr "Trascina i file qui o fai clic per caricarli"

#. placeholder {0}: formatSize(MAX_BYTES)
#: src/features/workspace/components/UploadModal.tsx:323
msgid "Trascina i file qui sotto o seleziona dal computer. Massimo {0} per file."
msgstr "Trascina i file qui sotto o seleziona dal computer. Massimo {0} per file."

#: src/features/console/flows/ConsoleFlowEditor.tsx:235
msgid "Trascina i nodi dalla palette, collegali e configurali; «Prova» esegue un test senza effetti collaterali."
msgstr "Trascina i nodi dalla palette, collegali e configurali; «Prova» esegue un test senza effetti collaterali."

#: src/features/connectors/components/management/SchemaViewer.tsx:835
msgid "Trascina il bordo di una colonna per allargarla · doppio clic per adattarla · clic su una cella per copiare"
msgstr "Trascina il bordo di una colonna per allargarla · doppio clic per adattarla · clic su una cella per copiare"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:166
msgid "Trascina o seleziona .docx / .xlsx / .pptx"
msgstr "Trascina o seleziona .docx / .xlsx / .pptx"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:762
msgid "Trascina o seleziona un .pptx / .docx / .xlsx — Ando ne impara il look."
msgstr "Trascina o seleziona un .pptx / .docx / .xlsx — Ando ne impara il look."

#: src/features/settings/marp/PptxExtractPanel.tsx:149
msgid "Trascina o seleziona un file .pptx"
msgstr "Trascina o seleziona un file .pptx"

#. placeholder {0}: Math.round(currentRatio)
#. placeholder {1}: Math.round(100 - currentRatio)
#: src/features/chat/components/SplitDragHandle.tsx:150
msgid "Trascina per ridimensionare ({0}% / {1}%) · doppio-clic per reset · {DEFAULT_SPLIT_RATIO}% default"
msgstr "Trascina per ridimensionare ({0}% / {1}%) · doppio-clic per reset · {DEFAULT_SPLIT_RATIO}% default"

#: ../../packages/ui/src/ando/EditableTable.tsx:327
msgid "Trascina per riordinare"
msgstr "Trascina per riordinare"

#. placeholder {0}: index + 1
#: ../../packages/ui/src/ando/actions/SlideOutlineEditor.tsx:143
msgid "Trascina per riordinare la slide {0}"
msgstr "Trascina per riordinare la slide {0}"

#: src/features/console/traces/TraceGraph.tsx:542
msgid "Trascina per spostarti, usa +/− per lo zoom o il comando di inquadratura per vedere l’intero grafo."
msgstr "Trascina per spostarti, usa +/− per lo zoom o il comando di inquadratura per vedere l’intero grafo."

#: src/features/sales/components/crm/PipelineBoard.tsx:223
msgid "Trascina qui"
msgstr "Trascina qui"

#: src/features/hive-flows/run/PdfDropzone.tsx:214
msgid "Trascina qui un documento, o clicca per caricarlo"
msgstr "Trascina qui un documento, o clicca per caricarlo"

#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:152
msgid "Trascina qui un file o seleziona"
msgstr "Trascina qui un file o seleziona"

#: src/features/connectors/components/_spreadsheet/SpreadsheetFileDropzone.tsx:55
msgid "Trascina qui un file o seleziona dal disco"
msgstr "Trascina qui un file o seleziona dal disco"

#: src/features/hive-flows/run/PdfDropzone.tsx:212
msgid "Trascina qui un PDF, o clicca per caricarlo"
msgstr "Trascina qui un PDF, o clicca per caricarlo"

#: src/features/dxf/components/DxfEmptyHero.tsx:137
msgid "Trascina un file CAD o una tavola PDF — supportati <0>DXF · DWG · STEP · IGES · STL · PDF</0>. Ando estrae blocchi, quote, fori, cartiglio e geometria 3D — la distinta è pronta per Excel in un click."
msgstr "Trascina un file CAD o una tavola PDF — supportati <0>DXF · DWG · STEP · IGES · STL · PDF</0>. Ando estrae blocchi, quote, fori, cartiglio e geometria 3D — la distinta è pronta per Excel in un click."

#: src/features/dashboard/components/DashboardChartCard.tsx:657
msgid "Trascina widget"
msgstr "Trascina widget"

#: src/features/hive-flows/components/FlowCanvas.tsx:101
msgid "Trascinalo dalla palette o cliccalo per aggiungerlo."
msgstr "Trascinalo dalla palette o cliccalo per aggiungerlo."

#: src/features/console/docs/content.ts:540
msgid "Trascrizione"
msgstr "Trascrizione"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:52
msgid "Trascrizioni Google Meet"
msgstr "Trascrizioni Google Meet"

#: src/features/connectors/wizards/messagingSpec.tsx:88
msgid "Trascrizioni riunioni"
msgstr "Trascrizioni riunioni"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:119
msgid "Trasferisci la ownership dell'org sorgente prima di migrare l'utente."
msgstr "Trasferisci la ownership dell'org sorgente prima di migrare l'utente."

#. placeholder {0}: primary.title
#: src/features/workspace/components/NudgeClusterRow.tsx:261
msgid "Trasforma in task: {0}"
msgstr "Trasforma in task: {0}"

#: src/features/connectors/wizards/sdiSpec.tsx:43
msgid "Trasmissione fatture al Sistema di Interscambio"
msgstr "Trasmissione fatture al Sistema di Interscambio"

#: src/features/admin/components/hypermem/HmExperimentsTab.tsx:247
msgid "Treatment"
msgstr "Treatment"

#: src/features/admin/components/AdminCostTracking.tsx:295
#: src/features/admin/components/AdminOverview.tsx:108
msgid "Trend"
msgstr "Trend"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1982
msgid "Triangolo"
msgstr "Triangolo"

#: src/features/console/pages/FlowDetailPage.tsx:197
#: src/features/console/pages/FlowsPage.tsx:814
msgid "Trigger"
msgstr "Trigger"

#: src/features/projects/components/sections/AutomationsSection.tsx:80
msgid "trigger reattivo"
msgstr "trigger reattivo"

#: src/features/projects/components/sections/AutomationsSection.tsx:79
msgid "trigger via webhook"
msgstr "trigger via webhook"

#: src/routes/connect.chatbot.$publicToken.tsx:92
#: src/routes/public.voice-report.$token.tsx:325
msgid "Troppe richieste"
msgstr "Troppe richieste"

#: src/routes/connect.invite.$token.tsx:211
msgid "Troppi tentativi"
msgstr "Troppi tentativi"

#: src/features/sales/components/LeadsPanel.tsx:308
msgid "Trova email mancanti"
msgstr "Trova email mancanti"

#: src/features/chat/components/ChatEmptyState.tsx:224
msgid "Trova i contratti firmati negli ultimi 30 giorni."
msgstr "Trova i contratti firmati negli ultimi 30 giorni."

#: src/features/sales/components/LeadsPanel.tsx:301
msgid "Trova le email pubbliche dei lead che ancora non ne hanno"
msgstr "Trova le email pubbliche dei lead che ancora non ne hanno"

#: src/features/chat/components/ChatEmptyState.tsx:126
msgid "Trova le fatture in arrivo nelle email di questa settimana."
msgstr "Trova le fatture in arrivo nelle email di questa settimana."

#: src/features/console/pages/PlaygroundPage.tsx:1869
msgid "Trova passaggi indicizzati o genera una risposta sintetica."
msgstr "Trova passaggi indicizzati o genera una risposta sintetica."

#: src/features/settings/MarpTemplateSettings.tsx:160
msgid "Trova template pitch-deck di qualità da convertire automaticamente"
msgstr "Trova template pitch-deck di qualità da convertire automaticamente"

#: src/features/sales/hooks/useProspectingWsBridge.ts:77
msgid "Trovate {filled} email mancanti."
msgstr "Trovate {filled} email mancanti."

#. placeholder {0}: summary.found ?? "…"
#. placeholder {1}: summary.ingested
#. placeholder {2}: summary.skipped
#. placeholder {3}: summary.errors.length
#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:72
msgid "Trovate: {0}. Importate: {1}. Saltate: {2}. Errori: {3}."
msgstr "Trovate: {0}. Importate: {1}. Saltate: {2}. Errori: {3}."

#: src/features/sales/hooks/useProspectingWsBridge.ts:68
msgid "Trovati {inserted} nuovi lead."
msgstr "Trovati {inserted} nuovi lead."

#: src/features/sales/components/crm/SuggestionsStrip.tsx:104
msgid "Trovati nelle tue email (solo persone a cui hai risposto). Restano qui finché non li approvi — le tue liste non vengono toccate."
msgstr "Trovati nelle tue email (solo persone a cui hai risposto). Restano qui finché non li approvi — le tue liste non vengono toccate."

#: ../../packages/ui/src/ando/SourceConfirmationCard.tsx:131
msgid "Trovato nella ricerca semantica"
msgstr "Trovato nella ricerca semantica"

#: src/routes/_authed/_modal/settings/help.tsx:70
msgid "Trovi piano, utilizzo e ricevute in Impostazioni → Fatturazione. Le risorse (messaggi, ingestion, archiviazione) si rinnovano ad inizio mese. Se ti avvicini al limite riceverai un nudge in chat prima del blocco."
msgstr "Trovi piano, utilizzo e ricevute in Impostazioni → Fatturazione. Le risorse (messaggi, ingestion, archiviazione) si rinnovano ad inizio mese. Se ti avvicini al limite riceverai un nudge in chat prima del blocco."

#: src/features/connect/components/ConnectMessageThread.tsx:167
#: src/features/console/pages/AccessOverviewPage.tsx:347
#: src/features/console/pages/MembersPage.tsx:543
#: src/features/console/pages/ResourceAccessPage.tsx:206
#: src/features/projects/components/sections/MembersSection.tsx:186
#: src/features/settings/components/OrgMembersPanel.tsx:261
#: src/features/sources/components/EmailThreadMessages.tsx:254
msgid "Tu"
msgstr "Tu"

#: src/features/auth/desktop/DesktopLoginForm.tsx:573
msgid "tu@esempio.it"
msgstr "tu@esempio.it"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:541
#: src/features/settings/MarpTemplateSettings.tsx:302
msgid "Tuo"
msgstr "Tuo"

#: src/features/projects/components/ProjectIcon.tsx:113
msgid "Turchese"
msgstr "Turchese"

#: src/features/console/pages/PlaygroundPage.tsx:890
msgid "Turni caricati"
msgstr "Turni caricati"

#: src/features/settings/marp/CssUploadPanel.tsx:211
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:221
msgid "Tutta l'organizzazione"
msgstr "Tutta l'organizzazione"

#: src/features/voice_report/components/VoiceReportsList.tsx:109
msgid "Tutta la knowledge"
msgstr "Tutta la knowledge"

#: ../../packages/ui/src/editors/ReviewRail.tsx:515
msgid "Tutta revisionata"
msgstr "Tutta revisionata"

#: src/features/admin/components/AdminDecksAskAndo.tsx:70
#: src/features/admin/components/AdminOrgs.tsx:889
#: src/features/console/pages/SchemaPage.tsx:949
#: src/features/workspace/documents/components/FolderBrowserView.tsx:111
#: src/routes/_authed/_modal/integrations/index.tsx:402
#: src/routes/_authed/workspace/sales.tsx:111
msgid "Tutte"
msgstr "Tutte"

#: src/features/sales/components/SalesOverview.tsx:286
msgid "Tutte le campagne"
msgstr "Tutte le campagne"

#: src/features/chat/components/ConversationSidebar.tsx:587
msgid "Tutte le chat di \"{label}\" verranno rimosse. L'azione non è reversibile."
msgstr "Tutte le chat di \"{label}\" verranno rimosse. L'azione non è reversibile."

#: src/features/report/components/ReportDateFilter.tsx:60
#: src/features/report/components/ReportDateFilter.tsx:80
msgid "Tutte le date"
msgstr "Tutte le date"

#: src/features/clean-control/components/EventQueue.tsx:204
msgid "Tutte le dimensioni"
msgstr "Tutte le dimensioni"

#: src/features/console/pages/PlaygroundPage.tsx:1985
msgid "Tutte le fonti personali"
msgstr "Tutte le fonti personali"

#: src/features/integrations/parts/CapabilityHeader.tsx:49
msgid "Tutte le integrazioni"
msgstr "Tutte le integrazioni"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2835
msgid "Tutte le lingue"
msgstr "Tutte le lingue"

#: ../../packages/ui/src/editors/ReviewRail.tsx:516
#: src/features/sources/components/AISummaryPanel.tsx:897
msgid "Tutte le modifiche revisionate"
msgstr "Tutte le modifiche revisionate"

#: src/features/admin/components/AdminDecks.tsx:488
msgid "Tutte le presentazioni"
msgstr "Tutte le presentazioni"

#: src/features/console/components/CreateKeyWizard.tsx:435
#: src/features/console/components/KeyMeta.tsx:132
#: src/features/console/components/KeyMeta.tsx:140
msgid "Tutte le risorse"
msgstr "Tutte le risorse"

#: src/features/help/components/KeyboardShortcutsOverlay.tsx:40
msgid "Tutte le scorciatoie attive nell'app. Cerca per azione o tasto."
msgstr "Tutte le scorciatoie attive nell'app. Cerca per azione o tasto."

#: src/features/clean-control/components/EventQueue.tsx:216
msgid "Tutte le severità"
msgstr "Tutte le severità"

#: src/features/clean-control/components/EventQueue.tsx:228
msgid "Tutte le sorgenti"
msgstr "Tutte le sorgenti"

#: ../../packages/ui/src/editors/ReviewRail.tsx:278
msgid "Tutte revisionate"
msgstr "Tutte revisionate"

#: ../../packages/ui/src/ando/connections/ConnectionPicker.tsx:296
#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:200
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:479
#: src/features/agent-modes/components/AgentModesList.tsx:150
#: src/features/connect/components/GrantManager.tsx:710
#: src/features/console/pages/ConnectorsPage.tsx:73
#: src/features/console/pages/DocumentsPage.tsx:92
#: src/features/dxf/components/DxfLeftRail.tsx:99
#: src/features/projects/components/TemplatesBrowserDialog.tsx:79
#: src/features/sales/components/LeadsPanel.tsx:88
#: src/features/templates/components/TemplatesList.tsx:40
#: src/features/workspace/components/ProjectPill.tsx:79
#: src/features/workspace/components/searchFilters/types.ts:31
#: src/features/workspace/config.ts:333
#: src/features/workspace/config.ts:343
#: src/features/workspace/config.ts:375
#: src/features/workspace/config.ts:419
#: src/features/workspace/config.ts:428
#: src/features/workspace/config.ts:439
#: src/features/workspace/documents/components/SmartSourceChips.tsx:56
#: src/features/workspace/inbox/utils/inboxSmartViews.ts:64
#: src/routes/_authed/workspace/conversations.tsx:573
msgid "Tutti"
msgstr "Tutti"

#. placeholder {0}: suggestions.length
#: src/routes/_authed/workspace/canvases.tsx:273
msgid "Tutti · {0}"
msgstr "Tutti · {0}"

#: src/features/admin/components/AdminHypermem.tsx:191
msgid "Tutti (platform-wide)"
msgstr "Tutti (platform-wide)"

#: src/features/console/pages/PlaygroundPage.tsx:1999
msgid "Tutti gli account del tipo scelto"
msgstr "Tutti gli account del tipo scelto"

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:77
msgid "Tutti gli spazi"
msgstr "Tutti gli spazi"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:423
msgid "Tutti gli specialist"
msgstr "Tutti gli specialist"

#: src/features/admin/components/AdminCpqList.tsx:98
#: src/features/admin/components/AdminUsers.tsx:262
#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:436
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:361
msgid "Tutti gli stati"
msgstr "Tutti gli stati"

#: src/features/admin/components/MaintenanceControl.tsx:275
msgid "Tutti gli utenti verranno bloccati immediatamente con una schermata di manutenzione. Tu e gli altri platform-admin continuerete ad accedere per verificare prima di riaprire."
msgstr "Tutti gli utenti verranno bloccati immediatamente con una schermata di manutenzione. Tu e gli altri platform-admin continuerete ad accedere per verificare prima di riaprire."

#: src/routes/_authed/workspace/canvases.$canvasId.tsx:406
msgid "Tutti i canvas"
msgstr "Tutti i canvas"

#: src/features/console/docs/content.ts:1808
msgid "Tutti i connettori del project (scope sources:manage)."
msgstr "Tutti i connettori del project (scope sources:manage)."

#: src/features/console/docs/content.ts:708
msgid "Tutti i connettori del project; GET /connectors/<slug> per il dettaglio."
msgstr "Tutti i connettori del project; GET /connectors/<slug> per il dettaglio."

#: src/features/console/connectors/CustomConnectorsPanel.tsx:246
msgid "Tutti i connettori sono disabilitati e il filtro li nasconde: riattiva «Mostra disabilitati» per vederli."
msgstr "Tutti i connettori sono disabilitati e il filtro li nasconde: riattiva «Mostra disabilitati» per vederli."

#: ../../packages/ui/src/ando/composer-parts/FocusSelector.tsx:39
msgid "Tutti i dati disponibili"
msgstr "Tutti i dati disponibili"

#: src/features/dxf/components/DxfCategorySidebar.tsx:32
#: src/features/dxf/components/DxfLeftRail.tsx:157
msgid "Tutti i disegni"
msgstr "Tutti i disegni"

#: src/features/console/pages/DocumentsPage.tsx:651
msgid "Tutti i documenti indicizzati, dai connettori e dagli upload."
msgstr "Tutti i documenti indicizzati, dai connettori e dagli upload."

#: ../../packages/ui/src/ando/composer-parts/CadAnalysisModal.tsx:501
msgid "Tutti i file del corpus"
msgstr "Tutti i file del corpus"

#: src/features/automations/components/ScheduleEditor.tsx:54
msgid "Tutti i giorni alle 18:00"
msgstr "Tutti i giorni alle 18:00"

#: src/features/automations/components/ScheduleEditor.tsx:53
msgid "Tutti i giorni alle 9:00"
msgstr "Tutti i giorni alle 9:00"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:374
msgid "Tutti i membri"
msgstr "Tutti i membri"

#: src/features/projects/components/sections/MembersSection.tsx:497
msgid "Tutti i membri dell'org sono già nel progetto."
msgstr "Tutti i membri dell'org sono già nel progetto."

#: src/features/sales/components/CampaignSharing.tsx:147
msgid "Tutti i membri possono vedere e modificare questa campagna."
msgstr "Tutti i membri possono vedere e modificare questa campagna."

#: src/features/admin/components/orgs/HardDeleteOrgDialog.tsx:124
msgid "Tutti i membri vengono migrati al Default Tenant e i dati org-owned vengono eliminati."
msgstr "Tutti i membri vengono migrati al Default Tenant e i dati org-owned vengono eliminati."

#: src/features/chat/components/ConversationSidebar.tsx:345
#: src/features/chat/components/ConversationSidebar.tsx:359
#: src/features/projects/components/ProjectDetailPage.tsx:555
msgid "Tutti i progetti"
msgstr "Tutti i progetti"

#: src/features/voice_report/components/VoiceReportDetailPage.tsx:152
#: src/routes/_authed/workspace/dashboard.tsx:669
msgid "Tutti i report"
msgstr "Tutti i report"

#: src/features/admin/components/AdminUsers.tsx:250
msgid "Tutti i ruoli"
msgstr "Tutti i ruoli"

#: src/features/projects/components/TemplatesBrowserDialog.tsx:79
#: src/features/templates/components/TemplateEditor.tsx:203
msgid "Tutti i template"
msgstr "Tutti i template"

#: src/features/admin/components/AdminOrgs.tsx:871
msgid "Tutti i tier"
msgstr "Tutti i tier"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:340
#: src/features/console/pages/TracesPage.tsx:305
msgid "Tutti i tipi"
msgstr "Tutti i tipi"

#: src/features/console/pages/DocsPage.tsx:509
msgid "Tutto ciò che serve per costruire su Ando: quali endpoint chiamare e quali funzioni dell'SDK usare. Quickstart, riferimento API e riferimento SDK, con esempi curl e Python copia-incolla."
msgstr "Tutto ciò che serve per costruire su Ando: quali endpoint chiamare e quali funzioni dell'SDK usare. Quickstart, riferimento API e riferimento SDK, con esempi curl e Python copia-incolla."

#: src/features/admin/components/AdminCostTracking.tsx:413
msgid "Tutto ottimizzato per questo periodo."
msgstr "Tutto ottimizzato per questo periodo."

#: src/routes/_authed/_modal/settings/changelog.tsx:57
msgid "Tutto quello che è cambiato di recente. Le novità più rilevanti appaiono anche come <0>nudge proattivi</0> in chat."
msgstr "Tutto quello che è cambiato di recente. Le novità più rilevanti appaiono anche come <0>nudge proattivi</0> in chat."

#: src/features/onboarding/demoTourSteps.ts:116
msgid "Tutto qui. Tocca a te."
msgstr "Tutto qui. Tocca a te."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:450
msgid "Tutto salvato"
msgstr "Tutto salvato"

#: src/features/sync/components/DocSyncManager.tsx:863
msgid "Tutto sincronizzato."
msgstr "Tutto sincronizzato."

#: src/routes/_authed/workspace/work.tsx:440
msgid "Tutto sotto controllo"
msgstr "Tutto sotto controllo"

#: src/routes/_authed/workspace/conversations.tsx:1088
msgid "Tutto tranquillo"
msgstr "Tutto tranquillo"

#: src/routes/_authed/route.tsx:1248
msgid "Tutto-fare"
msgstr "Tutto-fare"

#: src/features/console/docs/content.ts:1940
msgid "TypeScript: passa { appUserId } a ogni metodo; dopo OAuth controlla la sync automatica e scegli l'ambito Drive o Teams prima dell'indicizzazione. La sync manuale a pagine è opzionale. In alternativa OIDC avanzato usa { endUserToken }, mai entrambi. AppKey sempre sul server."
msgstr "TypeScript: passa { appUserId } a ogni metodo; dopo OAuth controlla la sync automatica e scegli l'ambito Drive o Teams prima dell'indicizzazione. La sync manuale a pagine è opzionale. In alternativa OIDC avanzato usa { endUserToken }, mai entrambi. AppKey sempre sul server."

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:161
msgid "Ultima acquisizione completata"
msgstr "Ultima acquisizione completata"

#: src/features/admin/components/AdminEngagement.tsx:447
#: src/features/admin/components/hypermem/HmTenantsTab.tsx:68
#: src/features/console/pages/EmbeddedIdentityPage.tsx:615
#: src/features/console/pages/MembersPage.tsx:507
#: src/features/sales/components/crm/ContactsPanel.tsx:245
msgid "Ultima attività"
msgstr "Ultima attività"

#. placeholder {0}: project.name
#: src/features/chat/components/ConversationSidebar.tsx:682
msgid "Ultima attività su {0}"
msgstr "Ultima attività su {0}"

#: src/features/automations/components/AutomationDetailSection.tsx:60
msgid "ultima esec."
msgstr "ultima esec."

#: src/features/automations/components/AutomationCard.tsx:64
msgid "Ultima esec.:"
msgstr "Ultima esec.:"

#: src/features/console/pages/FlowsPage.tsx:220
#: src/features/console/pages/FlowsPage.tsx:820
#: src/routes/_authed/workspace/flows.index.tsx:277
msgid "Ultima esecuzione"
msgstr "Ultima esecuzione"

#: src/features/structured-data/components/TemporalQueryControl.tsx:139
msgid "Ultima ora"
msgstr "Ultima ora"

#: src/features/console/traces/TraceGraph.tsx:428
msgid "Ultima registrazione"
msgstr "Ultima registrazione"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:489
msgid "Ultima ricarica fallita: {errorMessage}"
msgstr "Ultima ricarica fallita: {errorMessage}"

#: src/features/structured-data/components/TemporalQueryControl.tsx:141
msgid "Ultima settimana"
msgstr "Ultima settimana"

#: src/features/console/pages/ConnectorsPage.tsx:393
#: src/features/console/pages/EmbeddedIdentityPage.tsx:317
#: src/features/console/pages/OverviewPage.tsx:352
msgid "Ultima sincronizzazione"
msgstr "Ultima sincronizzazione"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:274
msgid "Ultima sincronizzazione {lastSync}."
msgstr "Ultima sincronizzazione {lastSync}."

#: src/features/workspace/components/QuickAddMenu/EmailSyncSummary.tsx:244
msgid "Ultima sync"
msgstr "Ultima sync"

#. placeholder {0}: formatTimestamp(item.last_seen)
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:274
msgid "Ultima vista {0}"
msgstr "Ultima vista {0}"

#: src/features/admin/components/hypermem/HmEvolutionLogTab.tsx:451
msgid "Ultime {n}"
msgstr "Ultime {n}"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:107
msgid "Ultime 24 h"
msgstr "Ultime 24 h"

#: src/features/admin/components/AdminEngagement.tsx:137
msgid "ultime 24h"
msgstr "ultime 24h"

#. placeholder {0}: recentTx.transactions.length
#: src/routes/_authed/workspace/finance.tsx:1524
msgid "Ultimi {0}"
msgstr "Ultimi {0}"

#: src/features/console/pages/UsagePage.tsx:281
msgid "Ultimi {days} giorni"
msgstr "Ultimi {days} giorni"

#: src/features/console/pages/UsagePage.tsx:461
msgid "Ultimi {windowDays} giorni."
msgstr "Ultimi {windowDays} giorni."

#: src/features/settings/components/BillingSettings.tsx:171
msgid "Ultimi 10 documenti fiscali emessi — PDF e link Stripe disponibili."
msgstr "Ultimi 10 documenti fiscali emessi — PDF e link Stripe disponibili."

#: src/features/sync/components/ChatSyncFiltersSheet.tsx:333
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:435
msgid "Ultimi 3 mesi"
msgstr "Ultimi 3 mesi"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:109
msgid "Ultimi 30 g"
msgstr "Ultimi 30 g"

#: src/features/automations/components/AutomationsHub.tsx:272
msgid "ultimi 30 giorni"
msgstr "ultimi 30 giorni"

#: src/features/report/components/ReportDateFilter.tsx:57
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:327
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:429
#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:57
#: src/features/workspace/components/searchFilters/types.ts:30
msgid "Ultimi 30 giorni"
msgstr "Ultimi 30 giorni"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:108
msgid "Ultimi 7 g"
msgstr "Ultimi 7 g"

#: src/features/report/components/ReportDateFilter.tsx:54
#: src/features/sync/components/ChatSyncFiltersSheet.tsx:321
#: src/features/sync/components/EmailSyncFiltersSheet.tsx:423
#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:57
#: src/features/workspace/components/searchFilters/types.ts:29
msgid "Ultimi 7 giorni"
msgstr "Ultimi 7 giorni"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:110
msgid "Ultimi 90 g"
msgstr "Ultimi 90 g"

#: src/features/sync/components/GoogleMeetTranscriptImport.tsx:57
msgid "Ultimi 90 giorni"
msgstr "Ultimi 90 giorni"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:320
msgid "Ultimi elementi disponibili"
msgstr "Ultimi elementi disponibili"

#: src/features/projects/components/ProjectDetailPage.tsx:129
msgid "Ultimo"
msgstr "Ultimo"

#: src/features/projects/components/ProjectDetailPage.tsx:189
msgid "ultimo {at}"
msgstr "ultimo {at}"

#: src/features/admin/components/AdminUsers.tsx:390
#: src/features/settings/components/OrgMembersPanel.tsx:268
msgid "Ultimo accesso"
msgstr "Ultimo accesso"

#: src/features/admin/components/UserDetailShell.tsx:145
msgid "Ultimo accesso {lastLoginRelative}"
msgstr "Ultimo accesso {lastLoginRelative}"

#. placeholder {0}: formatTimestamp(savedAt) ?? i18n._(msg`Mai aggiornato`)
#: src/features/connectors/components/management/BusinessContextEditor.tsx:136
msgid "Ultimo aggiornamento {0}"
msgstr "Ultimo aggiornamento {0}"

#: src/features/settings/components/SelfProfileMemory.tsx:438
msgid "Ultimo aggiornamento: {lastExtractedFormatted}"
msgstr "Ultimo aggiornamento: {lastExtractedFormatted}"

#: src/features/structured-data/components/TemporalQueryControl.tsx:144
msgid "Ultimo anno"
msgstr "Ultimo anno"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:256
msgid "Ultimo consolidation job"
msgstr "Ultimo consolidation job"

#: src/features/console/pages/OverviewPage.tsx:359
msgid "Ultimo esito registrato per fonte. Un errore di sincronizzazione non significa che l'account sia scollegato; apri Fonti per lo stato attuale."
msgstr "Ultimo esito registrato per fonte. Un errore di sincronizzazione non significa che l'account sia scollegato; apri Fonti per lo stato attuale."

#: src/features/structured-data/components/TemporalQueryControl.tsx:140
msgid "Ultimo giorno"
msgstr "Ultimo giorno"

#: src/features/admin/components/UserDetailContent.tsx:386
msgid "Ultimo login"
msgstr "Ultimo login"

#: src/features/structured-data/components/TemporalQueryControl.tsx:142
msgid "Ultimo mese"
msgstr "Ultimo mese"

#: src/features/structured-data/components/TemporalQueryControl.tsx:138
msgid "Ultimo minuto"
msgstr "Ultimo minuto"

#: src/features/dashboard/components/KpiCard.tsx:220
msgid "Ultimo periodo"
msgstr "Ultimo periodo"

#: src/features/console/connectors/ConnectionCard.tsx:248
#: src/features/console/connectors/CustomConnectorsPanel.tsx:271
#: src/features/console/pages/ConnectorDetailPage.tsx:101
msgid "Ultimo sync"
msgstr "Ultimo sync"

#: src/features/structured-data/components/TemporalQueryControl.tsx:143
msgid "Ultimo trimestre"
msgstr "Ultimo trimestre"

#: src/features/console/pages/KeyDetailPage.tsx:686
#: src/features/console/pages/KeysPage.tsx:128
msgid "Ultimo uso"
msgstr "Ultimo uso"

#: src/features/sales/components/crm/CompaniesPanel.tsx:77
msgid "Un account nel tuo CRM — il dominio evita i duplicati."
msgstr "Un account nel tuo CRM — il dominio evita i duplicati."

#: src/features/console/components/ProviderAccounts.tsx:69
msgid "Un account per provider, condiviso tra risposta finale e ragionamento. I modelli si scelgono dopo."
msgstr "Un account per provider, condiviso tra risposta finale e ragionamento. I modelli si scelgono dopo."

#: src/features/console/docs/content.ts:1815
msgid "Un AndoConnector legato a questo slug (batching, retry, idempotency)."
msgstr "Un AndoConnector legato a questo slug (batching, retry, idempotency)."

#: src/features/admin/components/AdminDecks.tsx:388
msgid "Un artifact HTML completo (stili, script, grafici): chi legge lo naviga per sezioni, con Chiedi ad Ando e stampa in PDF. Senza file parti da una pagina vuota da modificare nell'editor."
msgstr "Un artifact HTML completo (stili, script, grafici): chi legge lo naviga per sezioni, con Chiedi ad Ando e stampa in PDF. Senza file parti da una pagina vuota da modificare nell'editor."

#: src/features/connect/components/CreateSpaceDialog.tsx:101
msgid "Un assistente pubblico, incorporabile, sulle stesse fonti."
msgstr "Un assistente pubblico, incorporabile, sulle stesse fonti."

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:211
msgid "Un bonifico disposto"
msgstr "Un bonifico disposto"

#: src/features/console/pages/PlaygroundPage.tsx:617
msgid "Un bucket accende la sua metà; un id la accende e la restringe a quella sorgente."
msgstr "Un bucket accende la sua metà; un id la accende e la restringe a quella sorgente."

#: src/features/connect/components/GrantManager.tsx:361
msgid "Un Canvas o un insieme di documenti come unica conoscenza interrogabile."
msgstr "Un Canvas o un insieme di documenti come unica conoscenza interrogabile."

#: src/features/connect/components/GrantManager.tsx:368
msgid "Un connettore a dati strutturati collegato, in sola lettura, limitabile alle tabelle scelte."
msgstr "Un connettore a dati strutturati collegato, in sola lettura, limitabile alle tabelle scelte."

#: src/features/console/connectors/CustomConnectorsPanel.tsx:183
msgid "Un connettore personalizzato collega il TUO applicativo per rendere i suoi dati interrogabili da Ando: li spingi tu con una AppKey (push) oppure descrivi la tua API e la piattaforma la interroga da sola (manifest). Ando fa chunking, embedding, ACL e versioning."
msgstr "Un connettore personalizzato collega il TUO applicativo per rendere i suoi dati interrogabili da Ando: li spingi tu con una AppKey (push) oppure descrivi la tua API e la piattaforma la interroga da sola (manifest). Ando fa chunking, embedding, ACL e versioning."

#: src/features/admin/components/AdminDecks.tsx:398
msgid "Un documento"
msgstr "Un documento"

#: src/features/console/webhooks/WebhooksPanel.tsx:88
msgid "Un documento è stato ingerito e indicizzato"
msgstr "Un documento è stato ingerito e indicizzato"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:385
msgid "Un gestore dell'organizzazione può configurare le app e le AppKeys."
msgstr "Un gestore dell'organizzazione può configurare le app e le AppKeys."

#: src/features/sales/components/SignaturesManager.tsx:135
msgid "Un insieme di firme con nome: scegline una come predefinita e assegnala alle tue caselle."
msgstr "Un insieme di firme con nome: scegline una come predefinita e assegnala alle tue caselle."

#: src/features/console/docs/content.ts:1977
msgid "Un job di ingestion è finito failed (porta error_code)."
msgstr "Un job di ingestion è finito failed (porta error_code)."

#: src/features/sales/components/CampaignSharing.tsx:96
msgid "un membro del team"
msgstr "un membro del team"

#: src/features/connectors/components/WhatsAppHistorySyncStatus.tsx:185
msgid "Un problema imprevisto ha interrotto l'importazione dei 180 giorni di cronologia. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca. Contatta l'assistenza se hai bisogno di ripristinare le chat più vecchie."
msgstr "Un problema imprevisto ha interrotto l'importazione dei 180 giorni di cronologia. I nuovi messaggi ricevuti d'ora in avanti vengono comunque indicizzati per la ricerca. Contatta l'assistenza se hai bisogno di ripristinare le chat più vecchie."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:459
msgid "Un record per ogni turn dell'agente. ``success_confidence`` consolida thumbs, action accept/reject, response evaluator e correction patterns in un'unica metrica leggibile da MetaPrompt. Filtra \"Solo bassa qualità\" per il workflow di QA."
msgstr "Un record per ogni turn dell'agente. ``success_confidence`` consolida thumbs, action accept/reject, response evaluator e correction patterns in un'unica metrica leggibile da MetaPrompt. Filtra \"Solo bassa qualità\" per il workflow di QA."

#: src/features/connect/components/GrantManager.tsx:378
msgid "Un singolo file dei tuoi documenti."
msgstr "Un singolo file dei tuoi documenti."

#: src/features/console/pages/DevelopersPage.tsx:192
msgid "Un unico endpoint, autenticato con la tua AppKey. Nessun processo da gestire."
msgstr "Un unico endpoint, autenticato con la tua AppKey. Nessun processo da gestire."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:347
msgid "Un'app identifica la tua integrazione e tiene separati i suoi utenti. Si registrano alla prima richiesta autenticata; non ricevono accesso alla Console."
msgstr "Un'app identifica la tua integrazione e tiene separati i suoi utenti. Si registrano alla prima richiesta autenticata; non ricevono accesso alla Console."

#: src/features/console/connectors/DeclareConnectorActionModal.tsx:220
msgid "Un'azione fa fare qualcosa al tuo applicativo (es. crea un ticket). Qui ne dichiari il nome, i parametri e il rischio: quando Ando la esegue, invia una richiesta firmata al tuo webhook e la tua app la esegue."
msgstr "Un'azione fa fare qualcosa al tuo applicativo (es. crea un ticket). Qui ne dichiari il nome, i parametri e il rischio: quando Ando la esegue, invia una richiesta firmata al tuo webhook e la tua app la esegue."

#: src/features/console/components/ProviderAccounts.tsx:162
msgid "Una credenziale salvata non verifica una chiamata. Vertex richiede una delega approvata; non è un accesso OAuth Google."
msgstr "Una credenziale salvata non verifica una chiamata. Vertex richiede una delega approvata; non è un accesso OAuth Google."

#: src/features/console/traces/TraceGraph.tsx:461
msgid "Una cronologia unica ordina i gruppi visibili per prima registrazione, anche tra registri tecnici. A parità di tempo conserva l’ordine della risposta API. Le registrazioni senza tempo sono mostrate in fondo, nel loro ordine API. Il tratteggio di ordine non indica dipendenze o passaggi di contesto. L’intervallo di registrazione non descrive parallelismo o durata del provider. «seq del turno» conserva invece l’ordine registrato dentro un turno. Le altre linee mostrano soltanto relazioni esplicite."
msgstr "Una cronologia unica ordina i gruppi visibili per prima registrazione, anche tra registri tecnici. A parità di tempo conserva l’ordine della risposta API. Le registrazioni senza tempo sono mostrate in fondo, nel loro ordine API. Il tratteggio di ordine non indica dipendenze o passaggi di contesto. L’intervallo di registrazione non descrive parallelismo o durata del provider. «seq del turno» conserva invece l’ordine registrato dentro un turno. Le altre linee mostrano soltanto relazioni esplicite."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:76
msgid "Una delega per ogni P.IVA che gestisci."
msgstr "Una delega per ogni P.IVA che gestisci."

#: src/features/admin/components/MaintenanceControl.tsx:242
msgid "Una manutenzione programmata si attiva da sola all'ora di inizio e si chiude alla fine. La fine alimenta anche l'header Retry-After."
msgstr "Una manutenzione programmata si attiva da sola all'ora di inizio e si chiude alla fine. La fine alimenta anche l'header Retry-After."

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:288
msgid "Una nota per ricordare cosa rappresenta"
msgstr "Una nota per ricordare cosa rappresenta"

#: src/features/dashboard/components/AddChartDialog.tsx:535
msgid "Una nota per ricordare cosa rappresenta il grafico."
msgstr "Una nota per ricordare cosa rappresenta il grafico."

#: src/features/console/docs/content.ts:1458
msgid "Una nuova connessione Teams parte senza chat selezionate."
msgstr "Una nuova connessione Teams parte senza chat selezionate."

#: src/features/console/pages/ConnectorDetailPage.tsx:394
msgid "Una o più connessioni richiedono una nuova autorizzazione. Riconnettile qui sotto per riprendere la sincronizzazione."
msgstr "Una o più connessioni richiedono una nuova autorizzazione. Riconnettile qui sotto per riprendere la sincronizzazione."

#: src/features/admin/components/PageEditor.tsx:435
msgid "Una pagina HTML completa: stili, script, font e grafici propri. Le sezioni con id (section id=\"…\") diventano il menu di navigazione per chi legge."
msgstr "Una pagina HTML completa: stili, script, font e grafici propri. Le sezioni con id (section id=\"…\") diventano il menu di navigazione per chi legge."

#: src/features/sales/components/crm/ContactsPanel.tsx:79
msgid "Una persona nel tuo CRM — collegala a un'azienda se vuoi."
msgstr "Una persona nel tuo CRM — collegala a un'azienda se vuoi."

#. placeholder {0}: graph.nodes.length
#. placeholder {1}: registries.length
#: src/features/console/traces/TraceGraph.tsx:389
msgid "Una richiesta · {0} eventi · {1} registri tecnici"
msgstr "Una richiesta · {0} eventi · {1} registri tecnici"

#: src/features/admin/components/orgs/OrgConnectorsTab.tsx:417
msgid "Una riga per membro, una colonna per ogni connector «Per utente». Clicca l'intestazione di una colonna per attivare o disattivare in blocco."
msgstr "Una riga per membro, una colonna per ogni connector «Per utente». Clicca l'intestazione di una colonna per attivare o disattivare in blocco."

#: src/features/sync/components/EmailSyncFiltersSheet.tsx:346
msgid "Una sessione precedente non è stata completata."
msgstr "Una sessione precedente non è stata completata."

#: src/features/console/traces/TraceGraph.tsx:454
msgid "Una sola richiesta, registrazioni tecniche separate: il collegamento chiamante fra questi registri non è presente nei metadati visualizzati."
msgstr "Una sola richiesta, registrazioni tecniche separate: il collegamento chiamante fra questi registri non è presente nei metadati visualizzati."

#: src/features/automations/components/formatters.ts:35
#: src/features/automations/components/formatters.ts:90
msgid "Una sola volta"
msgstr "Una sola volta"

#: src/features/console/pages/FlowsPage.tsx:119
#: src/routes/_authed/workspace/flows.index.tsx:78
msgid "Una volta"
msgstr "Una volta"

#: src/features/projects/components/sections/AutomationsSection.tsx:90
msgid "una volta · {when}"
msgstr "una volta · {when}"

#: src/features/console/docs/content.ts:1637
msgid "Unisce contenuti indicizzati personali o condivisi e fonti strutturate con grant attivo in una risposta con citazioni. Usa la stessa identità verificata delle altre route end-user; include_rows mostra righe SQL solo al chiamante autorizzato."
msgstr "Unisce contenuti indicizzati personali o condivisi e fonti strutturate con grant attivo in una risposta con citazioni. Usa la stessa identità verificata delle altre route end-user; include_rows mostra righe SQL solo al chiamante autorizzato."

#: src/features/clean-control/utils/signalCatalog.ts:98
#: src/features/clean-control/utils/signalCatalog.ts:111
msgid "Unisci"
msgstr "Unisci"

#: src/features/clean-control/utils/labels.ts:116
msgid "Unisci automaticamente"
msgstr "Unisci automaticamente"

#: src/features/clean-control/utils/signalCatalog.ts:124
msgid "Unisci contatti"
msgstr "Unisci contatti"

#: src/features/admin/components/AdminCpqPriceBook.tsx:339
#: src/features/admin/components/deckEditor/DeckEditor.tsx:2155
#: src/features/dashboard/components/AxisConfigurator.tsx:262
#: src/features/dashboard/components/AxisConfigurator.tsx:262
#: src/features/price-lists/components/PriceListsPage.tsx:926
msgid "Unità"
msgstr "Unità"

#: src/features/clean-control/utils/labels.ts:92
msgid "Univ."
msgstr "Univ."

#: src/features/clean-control/utils/labels.ts:78
msgid "Univocità"
msgstr "Univocità"

#: src/features/connectors/components/WhatsAppEmbeddedSignupButton.tsx:202
msgid "Unknown error while completing WhatsApp setup"
msgstr "Unknown error while completing WhatsApp setup"

#: src/features/workspace/finance/components/SyncStatusPanel.tsx:299
msgid "Uno o più conti riportano errore di sync. Riprova ora oppure verifica il consenso PSD2."
msgstr "Uno o più conti riportano errore di sync. Riprova ora oppure verifica il consenso PSD2."

#: src/routes/connect.invite.$token.tsx:93
msgid "uno spazio condiviso"
msgstr "uno spazio condiviso"

#: src/features/console/docs/content.ts:430
msgid "Upload (multipart o source_url), stato del documento e polling del job. Ingestion sempre asincrona: 202 + job_id."
msgstr "Upload (multipart o source_url), stato del documento e polling del job. Ingestion sempre asincrona: 202 + job_id."

#: src/features/connectors/hooks/useChunkedSpreadsheetUpload.ts:221
msgid "Upload annullato."
msgstr "Upload annullato."

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:353
msgid "Upload diretto del logo non ancora portato — solo URL HTTPS. TODO Stream Branding: portare il dropzone di v1"
msgstr "Upload diretto del logo non ancora portato — solo URL HTTPS. TODO Stream Branding: portare il dropzone di v1"

#: src/features/settings/marp/OoxmlTemplatePanel.tsx:122
msgid "Upload fallito: {reason}"
msgstr "Upload fallito: {reason}"

#: src/features/connectors/wizards/spreadsheetSpec.tsx:216
msgid "Upload locale"
msgstr "Upload locale"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:93
msgid "Urgente"
msgstr "Urgente"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:416
msgid "Urgenza"
msgstr "Urgenza"

#: src/features/settings/components/SecuritySettings.tsx:252
msgid "URI otpauth"
msgstr "URI otpauth"

#: src/features/connectors/wizards/erpSpec.tsx:61
msgid "URL completo dell'endpoint OData v4 (Business Suite, S/4HANA)."
msgstr "URL completo dell'endpoint OData v4 (Business Suite, S/4HANA)."

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:490
msgid "URL dell'app non configurato"
msgstr "URL dell'app non configurato"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2488
msgid "URL dell'immagine"
msgstr "URL dell'immagine"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:375
msgid "URL di ritorno"
msgstr "URL di ritorno"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:400
msgid "URL di ritorno dopo il login"
msgstr "URL di ritorno dopo il login"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:379
msgid "URL di ritorno HTTPS"
msgstr "URL di ritorno HTTPS"

#: src/features/console/webhooks/WebhooksPanel.tsx:345
msgid "URL endpoint"
msgstr "URL endpoint"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:351
#: src/routes/_authed/_modal/integrations/$capability.tsx:438
msgid "URL non valido"
msgstr "URL non valido"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:356
msgid "URL non valido (includi https://)"
msgstr "URL non valido (includi https://)"

#: src/features/admin/components/orgs/OrgBrandingTab.tsx:52
#: src/features/admin/components/orgs/OrgSSOTab.tsx:45
msgid "URL non valido."
msgstr "URL non valido."

#: src/features/voice_report/components/ShareReportDialog.tsx:315
msgid "URL pubblico del report"
msgstr "URL pubblico del report"

#: src/features/hive-flows/components/FlowActivateControl.tsx:196
msgid "URL webhook"
msgstr "URL webhook"

#: src/features/hive-flows/components/FlowActivateControl.tsx:133
msgid "URL webhook copiato"
msgstr "URL webhook copiato"

#. placeholder {0}: payload.url
#: ../../packages/ui/src/ando/sources/web/WebPreview.tsx:265
msgid "URL: {0}"
msgstr "URL: {0}"

#: src/features/admin/components/orgs/OrgInfrastructureTab.tsx:60
msgid "US Central 1 (Iowa)"
msgstr "US Central 1 (Iowa)"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2497
#: src/routes/_authed/workspace/flows.index.tsx:647
msgid "Usa"
msgstr "Usa"

#. placeholder {0}: payload.measured_value_label
#. placeholder {0}: skill.name
#: src/features/chat/components/MessageBusinessDefinition.tsx:74
#: src/features/skills/components/TeamSkillsCatalog.tsx:156
msgid "Usa «{0}»"
msgstr "Usa «{0}»"

#: src/features/sales/components/TemplateManager.tsx:330
msgid "Usa {{campo}} per i segnaposto compilati per destinatario."
msgstr "Usa {{campo}} per i segnaposto compilati per destinatario."

#. placeholder {0}: flow.name
#: src/routes/_authed/workspace/flows.index.tsx:658
msgid "Usa {0}"
msgstr "Usa {0}"

#: src/features/auth/desktop/DesktopLoginForm.tsx:819
msgid "Usa app di autenticazione"
msgstr "Usa app di autenticazione"

#: src/features/settings/components/PresentationTemplates.tsx:534
msgid "Usa come default"
msgstr "Usa come default"

#: src/features/console/pages/TracesPage.tsx:116
msgid "Usa come riferimento per il confronto"
msgstr "Usa come riferimento per il confronto"

#: src/routes/_authed/workspace/shares.tsx:166
msgid "Usa Condividi su una risposta di Ando o dal menu ⋯ di una chat."
msgstr "Usa Condividi su una risposta di Ando o dal menu ⋯ di una chat."

#: src/features/console/components/ModelPickerModal.tsx:238
msgid "Usa il profilo Ando"
msgstr "Usa il profilo Ando"

#: src/features/dashboard/components/ChartSqlEditor.tsx:114
msgid "Usa la colonna data della sorgente prima di GROUP BY. La data finale è inclusa."
msgstr "Usa la colonna data della sorgente prima di GROUP BY. La data finale è inclusa."

#: src/features/console/pages/EngineSignupPage.tsx:117
msgid "Usa la tua organizzazione, aggiungi crediti e ricevi la prima AppKey."
msgstr "Usa la tua organizzazione, aggiungi crediti e ricevi la prima AppKey."

#: src/features/chat/components/MessageBusinessDefinition.tsx:100
msgid "Usa questa definizione"
msgstr "Usa questa definizione"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:410
msgid "Usa questa modalità se preferisci che Ando verifichi direttamente i token OIDC degli utenti della tua app. Issuer, audience e JWKS appartengono al sistema di login della tua app: non sono parametri di Google Drive o OneDrive."
msgstr "Usa questa modalità se preferisci che Ando verifichi direttamente i token OIDC degli utenti della tua app. Issuer, audience e JWKS appartengono al sistema di login della tua app: non sono parametri di Google Drive o OneDrive."

#: src/features/admin/components/deckEditor/DeckEditor.tsx:2256
msgid "Usa questi dati"
msgstr "Usa questi dati"

#: src/features/settings/marp/CssUploadPanel.tsx:54
#: src/features/settings/marp/OoxmlTemplatePanel.tsx:49
msgid "Usa solo lettere minuscole, numeri e trattini (es. ``my-blue-deck``)"
msgstr "Usa solo lettere minuscole, numeri e trattini (es. ``my-blue-deck``)"

#: src/features/admin/components/ModelMarkupCard.tsx:106
msgid "Usa tariffa globale"
msgstr "Usa tariffa globale"

#: src/features/automations/components/AutomationsHub.tsx:463
#: src/features/voice_report/components/TemplatesGallery.tsx:331
msgid "Usa template"
msgstr "Usa template"

#. placeholder {0}: t.name
#: src/features/projects/components/TemplatesBrowserDialog.tsx:326
msgid "Usa template: {0}"
msgstr "Usa template: {0}"

#: src/features/voice_report/components/NewReportDialog.tsx:677
#: src/features/voice_report/components/NewReportDialog.tsx:754
msgid "Usa tutta la mia knowledge Ando"
msgstr "Usa tutta la mia knowledge Ando"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:1808
msgid "Usa un link https:// o un indirizzo e-mail"
msgstr "Usa un link https:// o un indirizzo e-mail"

#: src/features/console/docs/content.ts:1913
msgid "Usa una AppKey app_user_server solo dal backend della tua app e ricava l'ID stabile dal login verificato. Dopo OAuth scegli l'ambito da indicizzare e controlla lo stato della sync automatica; query e risposte applicano gli ACL ai contenuti propri e a quelli esplicitamente condivisi. Per una nuova app OIDC usa app_user_oidc vincolata all'app; end_user_only è legacy."
msgstr "Usa una AppKey app_user_server solo dal backend della tua app e ricava l'ID stabile dal login verificato. Dopo OAuth scegli l'ambito da indicizzare e controlla lo stato della sync automatica; query e risposte applicano gli ACL ai contenuti propri e a quelli esplicitamente condivisi. Per una nuova app OIDC usa app_user_oidc vincolata all'app; end_user_only è legacy."

#: src/features/console/components/ConsoleShell.tsx:248
#: src/features/console/pages/UsagePage.tsx:318
#: src/features/console/pages/UsagePage.tsx:357
msgid "Usage"
msgstr "Usage"

#: src/features/console/docs/content.ts:1207
msgid "Usage & breakdown"
msgstr "Usage & breakdown"

#. placeholder {0}: cat?.unlimited_on_prem_pct ?? 0
#: src/features/admin/components/AdminCpq.tsx:767
msgid "Usage illimitato, solo on-prem (+{0}% sulle licenze)"
msgstr "Usage illimitato, solo on-prem (+{0}% sulle licenze)"

#: src/features/admin/components/AdminCpqPriceBook.tsx:245
#: src/features/admin/components/AdminCpqPriceBook.tsx:277
msgid "Usage incluso (crediti)"
msgstr "Usage incluso (crediti)"

#: src/features/admin/components/AdminCpq.tsx:236
msgid "Usage incluso nelle licenze"
msgstr "Usage incluso nelle licenze"

#: src/features/projects/components/sections/MembersSection.tsx:137
msgid "Uscire dal progetto?"
msgstr "Uscire dal progetto?"

#: src/features/workspace/finance/components/RecentTransactionsList.tsx:95
msgid "Uscita"
msgstr "Uscita"

#: src/features/console/components/ModelPickerModal.tsx:304
msgid "Uscita {outPrice} / 1M token"
msgstr "Uscita {outPrice} / 1M token"

#: src/features/console/pages/ModelsPage.tsx:138
msgid "Uscita {outputPrice} / 1M token"
msgstr "Uscita {outputPrice} / 1M token"

#: src/features/workspace/finance/components/CashFlowWeekTable.tsx:175
msgid "Uscite"
msgstr "Uscite"

#: src/routes/_authed/workspace/finance.tsx:1414
msgid "Uscite mese"
msgstr "Uscite mese"

#: src/features/console/components/CreateKeyWizard.tsx:581
#: src/features/console/pages/KeyDetailPage.tsx:327
msgid "USD / mese"
msgstr "USD / mese"

#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:207
#: src/features/admin/components/hypermem/HmNudgesTab.tsx:410
msgid "User"
msgstr "User"

#: src/features/templates/components/TemplateCard.tsx:29
#: src/features/templates/components/TemplatesList.tsx:51
msgid "USER"
msgstr "USER"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:211
#: src/features/admin/components/hypermem/HmFactsBrowserTab.tsx:169
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:490
msgid "User ID (opzionale)"
msgstr "User ID (opzionale)"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:93
msgid "User:"
msgstr "User:"

#: src/features/connectors/wizards/accountingSpec.tsx:56
msgid "Username Service Layer"
msgstr "Username Service Layer"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:386
msgid "Usi già token OIDC? Apri la configurazione avanzata"
msgstr "Usi già token OIDC? Apri la configurazione avanzata"

#: src/features/connectors/components/management/SchemaViewer.tsx:476
msgid "Uso"
msgstr "Uso"

#: src/features/admin/components/AdminCpqAskAndo.tsx:180
msgid "Uso illimitato"
msgstr "Uso illimitato"

#: src/features/console/pages/LimitsPage.tsx:60
msgid "Uso in tempo reale non disponibile"
msgstr "Uso in tempo reale non disponibile"

#: src/features/projects/components/sections/MembersSection.tsx:345
msgid "utente"
msgstr "utente"

#: ../../packages/ui/src/ando/UserMenu.tsx:78
#: src/features/account/components/UserMenuButton.tsx:208
#: src/features/admin/components/AdminEngagement.tsx:430
#: src/features/admin/components/AdminUsers.tsx:372
#: src/features/admin/components/userAdminActions.tsx:81
#: src/features/connectors/components/FilesystemConnectDialog.tsx:659
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:768
#: src/features/connectors/wizards/databaseSpec.tsx:79
#: src/features/connectors/wizards/databaseSpec.tsx:125
#: src/features/connectors/wizards/erpSpec.tsx:65
#: src/features/connectors/wizards/erpSpec.tsx:102
#: src/features/connectors/wizards/filesystemSpec.tsx:87
#: src/features/connectors/wizards/legalStorageSpec.tsx:44
msgid "Utente"
msgstr "Utente"

#: src/features/admin/components/orgs/OrgCostTab.tsx:171
msgid "Utente {shortId}"
msgstr "Utente {shortId}"

#: src/features/console/pages/ResourceAccessPage.tsx:808
msgid "Utente da autorizzare"
msgstr "Utente da autorizzare"

#: src/features/console/pages/ResourceAccessPage.tsx:623
msgid "Utente di un'app"
msgstr "Utente di un'app"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:100
msgid "Utente migrato"
msgstr "Utente migrato"

#: src/features/admin/components/UserDetailShell.tsx:88
msgid "Utente non trovato"
msgstr "Utente non trovato"

#: src/features/admin/components/userAdminActions.tsx:288
msgid "Utente riattivato"
msgstr "Utente riattivato"

#: src/features/admin/components/userAdminActions.tsx:285
msgid "Utente sospeso"
msgstr "Utente sospeso"

#: src/features/admin/components/orgs/MigrateUserDialog.tsx:103
msgid "Utente spostato (dati lasciati nell'org sorgente)."
msgstr "Utente spostato (dati lasciati nell'org sorgente)."

#: src/features/admin/components/AdminUsers.tsx:188
#: src/features/admin/components/orgs/OrgSetupChecklist.tsx:138
#: src/features/admin/components/UserDetailShell.tsx:123
#: src/routes/_authed/_modal/admin/route.tsx:149
msgid "Utenti"
msgstr "Utenti"

#: src/features/connectors/components/FilesystemConnectDialog.tsx:897
#: src/features/connectors/wizards/filesystemSpec.tsx:105
msgid "Utenti autorizzati"
msgstr "Utenti autorizzati"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:468
msgid "Utenti connessi"
msgstr "Utenti connessi"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:351
msgid "Utenti dell'app →"
msgstr "Utenti dell'app →"

#: src/features/console/docs/content.ts:1912
msgid "Utenti della tua app — Python e TypeScript"
msgstr "Utenti della tua app — Python e TypeScript"

#: src/features/console/components/ConsoleShell.tsx:232
#: src/features/console/pages/EmbeddedIdentityPage.tsx:292
msgid "Utenti delle app"
msgstr "Utenti delle app"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:341
msgid "Utenti di"
msgstr "Utenti di"

#: src/features/console/docs/content.ts:1352
msgid "Utenti di un'app"
msgstr "Utenti di un'app"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:467
msgid "Utenti mappati"
msgstr "Utenti mappati"

#: src/features/console/docs/content.ts:1370
msgid "Utenti OIDC verificati"
msgstr "Utenti OIDC verificati"

#: src/features/clean-control/components/EventDetailSheet.tsx:202
#: src/features/clean-control/components/EventRow.tsx:572
#: src/features/clean-control/components/SignalHealthCard.tsx:134
msgid "Utile"
msgstr "Utile"

#: src/features/account/components/UserMenuButton.tsx:455
msgid "Utilità"
msgstr "Utilità"

#: src/features/console/pages/FlowDetailPage.tsx:181
#: src/routes/_authed/workspace/flows.$flowId.tsx:388
msgid "Utilizza"
msgstr "Utilizza"

#: src/features/console/components/KeyMeta.tsx:174
msgid "Utilizzata"
msgstr "Utilizzata"

#: src/features/settings/components/BillingSettings.tsx:88
msgid "utilizzo · fatture · metodi di pagamento"
msgstr "utilizzo · fatture · metodi di pagamento"

#: src/features/settings/components/BillingSettings.tsx:144
msgid "Utilizzo del mese"
msgstr "Utilizzo del mese"

#: src/features/admin/components/hypermem/HmAuditTrailTab.tsx:221
#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:500
msgid "UUID o vuoto"
msgstr "UUID o vuoto"

#: ../../packages/ui/src/ando/actions/AIEditBubble.tsx:306
#: ../../packages/ui/src/editors/ReviewRail.tsx:405
#: src/features/console/pages/EmbeddedIdentityPage.tsx:616
msgid "Vai"
msgstr "Vai"

#: src/features/console/components/CommandPalette.tsx:184
msgid "Vai a"
msgstr "Vai a"

#: src/features/workspace/documents/components/FolderBrowserView.tsx:197
msgid "Vai a tutte le cartelle"
msgstr "Vai a tutte le cartelle"

#: src/features/console/pages/ActionsPage.tsx:77
msgid "Vai ai connettori"
msgstr "Vai ai connettori"

#: src/features/chat/components/ConversationCommandPalette.tsx:293
msgid "Vai ai contatti"
msgstr "Vai ai contatti"

#: src/features/projects/components/ProjectDetailPage.tsx:465
msgid "Vai ai progetti"
msgstr "Vai ai progetti"

#: src/features/admin/components/AdminCpqPublishChecks.tsx:101
msgid "Vai al campo"
msgstr "Vai al campo"

#: src/features/console/pages/PlaygroundPage.tsx:825
msgid "Vai al passaggio citato"
msgstr "Vai al passaggio citato"

#: src/features/dashboard/components/wizard/WizardStepSource.tsx:262
msgid "Vai al passo Dati"
msgstr "Vai al passo Dati"

#: src/features/dashboard/components/wizard/WizardStepData.tsx:414
msgid "Vai al passo Visualizza"
msgstr "Vai al passo Visualizza"

#. placeholder {0}: current.name
#: src/features/workspace/components/ProjectPill.tsx:84
msgid "Vai al progetto {0}"
msgstr "Vai al progetto {0}"

#: src/features/workspace/components/ProjectPill.tsx:85
msgid "Vai all'hub progetti"
msgstr "Vai all'hub progetti"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:733
msgid "Vai all'identità dell'app"
msgstr "Vai all'identità dell'app"

#: ../../packages/ui/src/editors/ReviewRail.tsx:401
msgid "Vai alla modifica"
msgstr "Vai alla modifica"

#: src/features/chat/components/ConversationCommandPalette.tsx:292
msgid "Vai alla pipeline"
msgstr "Vai alla pipeline"

#: src/features/help/components/ShortcutsList.tsx:162
msgid "Vai alla prima o ultima voce del menu"
msgstr "Vai alla prima o ultima voce del menu"

#. placeholder {0}: i + 1
#: src/features/report/components/RespondentQuotesCarousel.tsx:221
msgid "Vai alla slide {0}"
msgstr "Vai alla slide {0}"

#: src/features/console/pages/LimitsPage.tsx:137
msgid "Vai alle AppKey"
msgstr "Vai alle AppKey"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:416
msgid "Vai alle AppKeys per crearne una"
msgstr "Vai alle AppKeys per crearne una"

#: src/features/chat/components/ConversationCommandPalette.tsx:294
msgid "Vai alle aziende"
msgstr "Vai alle aziende"

#: src/features/chat/components/ConversationCommandPalette.tsx:295
msgid "Vai alle campagne"
msgstr "Vai alle campagne"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:282
msgid "Vai allo schema"
msgstr "Vai allo schema"

#: src/features/admin/components/GlobalMarkupCard.tsx:125
msgid "Vale per tutti i tenant salvo override per-tenant."
msgstr "Vale per tutti i tenant salvo override per-tenant."

#: src/features/clean-control/utils/labels.ts:93
msgid "Valid."
msgstr "Valid."

#: src/features/console/connectors/CustomConnectorDetail.tsx:1041
msgid "Valida"
msgstr "Valida"

#: src/features/console/connectors/CustomConnectorDetail.tsx:282
msgid "Valida (dry-run)"
msgstr "Valida (dry-run)"

#: src/features/console/docs/content.ts:832
msgid "Valida e pubblica"
msgstr "Valida e pubblica"

#: src/features/console/docs/content.ts:1079
msgid "Valida i params e crea una proposta 'proposed' con preview — nessun effetto collaterale. Idempotency-Key supportato."
msgstr "Valida i params e crea una proposta 'proposed' con preview — nessun effetto collaterale. Idempotency-Key supportato."

#: src/features/console/docs/content.ts:683
msgid "Valida record (dry-run)"
msgstr "Valida record (dry-run)"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:25
msgid "Validazione anagrafiche, VIES, controllo soggetti"
msgstr "Validazione anagrafiche, VIES, controllo soggetti"

#: src/features/clean-control/utils/labels.ts:79
msgid "Validità"
msgstr "Validità"

#: src/features/admin/components/AdminCpq.tsx:1206
msgid "Validità del link (giorni)"
msgstr "Validità del link (giorni)"

#: src/features/admin/components/AdminDecks.tsx:723
msgid "Valido"
msgstr "Valido"

#: src/features/admin/components/AdminCpq.tsx:616
#: src/features/admin/components/AdminCpqAskAndo.tsx:168
msgid "Valido fino al"
msgstr "Valido fino al"

#: ../../packages/ui/src/ando/chat/ClarificationNote.tsx:98
#: src/features/admin/components/deckEditor/DeckEditor.tsx:975
#: src/features/admin/components/deckEditor/DeckEditor.tsx:1519
#: src/features/connect/components/connectShared.tsx:265
#: src/features/dfm-rules/components/DfmRulesPage.tsx:926
#: src/features/sales/components/crm/CreateDealDialog.tsx:144
#: src/features/sales/components/crm/DealDetailDrawer.tsx:130
#: src/features/sales/components/crm/DealDetailDrawer.tsx:139
msgid "Valore"
msgstr "Valore"

#: src/features/sales/components/crm/CreateDealDialog.tsx:137
msgid "Valore (€)"
msgstr "Valore (€)"

#: src/features/dashboard/components/AxisConfigurator.tsx:371
msgid "Valore {column}"
msgstr "Valore {column}"

#: src/features/dashboard/utils/calculatedFields.ts:73
msgid "Valore assoluto"
msgstr "Valore assoluto"

#: src/features/admin/components/AdminPlatformSettings.tsx:1096
msgid "Valore attivo"
msgstr "Valore attivo"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:427
msgid "Valore aud atteso nei token degli utenti."
msgstr "Valore aud atteso nei token degli utenti."

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:511
msgid "Valore certificato"
msgstr "Valore certificato"

#: src/features/dashboard/components/CalculatedFieldEditor.tsx:365
msgid "Valore costante"
msgstr "Valore costante"

#: src/features/dashboard/utils/calculatedFields.ts:333
msgid "Valore costante obbligatorio"
msgstr "Valore costante obbligatorio"

#: src/features/hive-flows/components/ConditionBuilder.tsx:247
#: src/features/hive-flows/components/ConditionBuilder.tsx:248
msgid "Valore da controllare"
msgstr "Valore da controllare"

#: src/features/dashboard/components/AxisConfigurator.tsx:117
#: src/features/dashboard/components/DashboardChartCard.tsx:749
msgid "Valore del KPI"
msgstr "Valore del KPI"

#: src/features/dashboard/components/wizard/WizardStepVisualize.tsx:215
msgid "Valore della metrica"
msgstr "Valore della metrica"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:661
msgid "Valore esatto"
msgstr "Valore esatto"

#: src/features/console/pages/EmbeddedIdentityPage.tsx:426
msgid "Valore iss nei token OIDC della tua app."
msgstr "Valore iss nei token OIDC della tua app."

#: src/features/connectors/wizards/pecSpec.tsx:61
msgid "Valore legale"
msgstr "Valore legale"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:732
msgid "Valore non valido"
msgstr "Valore non valido"

#: ../../packages/ui/src/ando/chat/ConflictNote.tsx:100
msgid "Valore scelto"
msgstr "Valore scelto"

#: src/features/integrations/parts/ConnectorDetailSection.tsx:207
msgid "Valori"
msgstr "Valori"

#: src/features/connectors/components/management/DiscoveryDialog.tsx:119
msgid "valori campione, mappature semantiche e relazioni rilevate"
msgstr "valori campione, mappature semantiche e relazioni rilevate"

#: src/features/connectors/components/management/SchemaViewer.tsx:544
msgid "Valori di esempio"
msgstr "Valori di esempio"

#: ../../packages/ui/src/ando/actions/SepaPaymentPreview.tsx:258
#: src/features/console/pages/BillingPage.tsx:453
#: src/features/price-lists/components/PriceListsPage.tsx:915
msgid "Valuta"
msgstr "Valuta"

#: src/features/integrations/parts/StatusElements.tsx:70
msgid "Vantaggi"
msgstr "Vantaggi"

#: src/features/admin/components/AdminCpq.tsx:1029
msgid "Variazione mensile %"
msgstr "Variazione mensile %"

#: src/features/report/components/ComparisonGrid.tsx:143
msgid "Variazione non disponibile"
msgstr "Variazione non disponibile"

#: src/features/hive-flows/run/WorkbenchSurface.tsx:127
msgid "Vedi disegno"
msgstr "Vedi disegno"

#: src/features/report/components/CitationDetail.tsx:174
msgid "Vedi nel contesto"
msgstr "Vedi nel contesto"

#. placeholder {0}: field.label
#: ../../packages/ui/src/ando/DocumentReviewRenderer.tsx:145
msgid "Vedi nel disegno: {0}"
msgstr "Vedi nel disegno: {0}"

#. placeholder {0}: v.system_prompt_overlay.length.toLocaleString()
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:216
msgid "Vedi prompt ({0} car.)"
msgstr "Vedi prompt ({0} car.)"

#: src/features/chat/components/ChatEmptyState.tsx:708
msgid "Vediamo tutto"
msgstr "Vediamo tutto"

#: ../../packages/ui/src/ando/composer-parts/SearchPowerSelector.tsx:26
#: src/features/agent-modes/components/AgentModeEditor.tsx:410
msgid "Veloce"
msgstr "Veloce"

#: src/features/admin/components/AdminEngagement.tsx:35
msgid "Ven"
msgstr "Ven"

#: src/features/projects/components/ProjectIcon.tsx:70
msgid "Vendite"
msgstr "Vendite"

#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:80
msgid "venerdì"
msgstr "venerdì"

#: src/features/projects/components/sections/PersonaSection.tsx:290
msgid "Vengono aggiunte al prompt di sistema solo per questo progetto."
msgstr "Vengono aggiunte al prompt di sistema solo per questo progetto."

#: src/features/projects/components/ProjectIcon.tsx:115
msgid "Verde"
msgstr "Verde"

#: src/features/auth/desktop/DesktopLoginForm.tsx:891
#: src/features/auth/desktop/DesktopLoginForm.tsx:943
#: src/features/console/connectors/ConnectionCard.tsx:367
#: src/features/integrations/parts/ConnectorDetailSection.tsx:179
msgid "Verifica"
msgstr "Verifica"

#: src/features/console/connectors/CustomConnectorDetail.tsx:694
msgid "verifica AppKey in corso…"
msgstr "verifica AppKey in corso…"

#: src/features/console/docs/content.ts:1410
msgid "Verifica che l'autorizzazione del provider sia ancora valida."
msgstr "Verifica che l'autorizzazione del provider sia ancora valida."

#: src/features/console/traces/TraceGraph.tsx:54
msgid "Verifica citazioni (citation_verifier)"
msgstr "Verifica citazioni (citation_verifier)"

#: src/features/settings/components/SecuritySettings.tsx:288
msgid "Verifica codice"
msgstr "Verifica codice"

#: src/features/connectors/components/management/EditConnectorDialog.tsx:263
#: src/features/integrations/parts/ConnectorDetailSection.tsx:176
msgid "Verifica connessione"
msgstr "Verifica connessione"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:662
msgid "Verifica del risultato"
msgstr "Verifica del risultato"

#: src/features/console/webhooks/WebhooksPanel.tsx:703
msgid "Verifica della firma (Standard Webhooks)"
msgstr "Verifica della firma (Standard Webhooks)"

#: src/features/console/connectors/RegisterCustomConnectorModal.tsx:475
msgid "Verifica delle AppKey in corso…"
msgstr "Verifica delle AppKey in corso…"

#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:934
msgid "Verifica e continua"
msgstr "Verifica e continua"

#: src/features/auth/desktop/DesktopLoginForm.tsx:474
#: src/features/auth/desktop/DesktopLoginForm.tsx:488
#: src/features/console/components/KeyMeta.tsx:175
msgid "Verifica fallita"
msgstr "Verifica fallita"

#. placeholder {0}: data.error ?? i18n._(msg`errore sconosciuto`)
#: src/routes/_authed/_modal/integrations/$capability.tsx:184
msgid "Verifica fallita: {0}"
msgstr "Verifica fallita: {0}"

#: src/features/connectors/components/management/EditConnectorDialog.tsx:165
msgid "Verifica fallita."
msgstr "Verifica fallita."

#: src/features/connectors/wizards/sdiSpec.tsx:91
msgid "Verifica i dati. Ando trasmetterà le fatture al SDI solo dopo la tua conferma su ogni proposta (HITL)."
msgstr "Verifica i dati. Ando trasmetterà le fatture al SDI solo dopo la tua conferma su ogni proposta (HITL)."

#: src/features/connectors/wizards/legalStorageSpec.tsx:64
msgid "Verifica integrità"
msgstr "Verifica integrità"

#: src/features/console/docs/content.ts:1580
msgid "Verifica l'account collegato con il token dell'utente corrente; segnala quando serve una nuova autorizzazione."
msgstr "Verifica l'account collegato con il token dell'utente corrente; segnala quando serve una nuova autorizzazione."

#: src/features/admin/components/orgs/OrgDetailShell.tsx:259
#: src/features/admin/components/UserDetailShell.tsx:92
msgid "Verifica l'ID e riprova."
msgstr "Verifica l'ID e riprova."

#: src/routes/_authed/workspace/documents.tsx:958
#: src/routes/_authed/workspace/technical.tsx:359
#: src/routes/_authed/workspace/work.tsx:543
msgid "Verifica la connessione e riprova fra qualche secondo."
msgstr "Verifica la connessione e riprova fra qualche secondo."

#: src/routes/_authed/workspace/calendar.tsx:1417
msgid "Verifica la connessione e riprova. Oppure collega un calendario per attivare la vista."
msgstr "Verifica la connessione e riprova. Oppure collega un calendario per attivare la vista."

#: src/features/dfm-rules/components/DfmRulesPage.tsx:664
msgid "Verifica manuale"
msgstr "Verifica manuale"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:226
msgid "Verifica modalità…"
msgstr "Verifica modalità…"

#. placeholder {0}: err instanceof Error ? err.message : i18n._(msg`errore`)
#: src/routes/_authed/_modal/integrations/$capability.tsx:191
msgid "Verifica non riuscita: {0}"
msgstr "Verifica non riuscita: {0}"

#: src/features/connectors/components/management/EditConnectorDialog.tsx:169
msgid "Verifica non riuscita."
msgstr "Verifica non riuscita."

#: src/features/console/pages/EmbeddedIdentityPage.tsx:699
msgid "Verifica OAuth, sincronizzazione e ricerca con un'identità di prova separata dai tuoi account Engine e dagli utenti reali dell'app."
msgstr "Verifica OAuth, sincronizzazione e ricerca con un'identità di prova separata dai tuoi account Engine e dagli utenti reali dell'app."

#: src/features/connectors/components/vendorIcons.tsx:172
#: src/features/connectors/components/vendorIcons.tsx:513
#: src/features/connectors/wizards/vatVerifierSpec.tsx:24
msgid "Verifica P.IVA"
msgstr "Verifica P.IVA"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:56
msgid "Verifica P.IVA UE in tempo reale dentro al flusso fatturazione."
msgstr "Verifica P.IVA UE in tempo reale dentro al flusso fatturazione."

#: src/features/console/components/TopupReturnStatus.tsx:104
msgid "Verifica pagamento"
msgstr "Verifica pagamento"

#: ../../packages/ui/src/ando/ActionFieldEditor.tsx:1604
msgid "Verifica questi campi"
msgstr "Verifica questi campi"

#: src/features/console/pages/OverviewPage.tsx:303
msgid "Verifica risposte e fonti con una domanda"
msgstr "Verifica risposte e fonti con una domanda"

#: src/features/console/docs/content.ts:684
msgid "Verifica un batch contro il Record contract SENZA scrivere: per ogni record torna l'anteprima di cosa verrebbe indicizzato oppure il rifiuto con index, field e reason. accepted + rejected = record inviati."
msgstr "Verifica un batch contro il Record contract SENZA scrivere: per ogni record torna l'anteprima di cosa verrebbe indicizzato oppure il rifiuto con index, field e reason. accepted + rejected = record inviati."

#: src/features/structured-data/components/SimilarPartsSection.tsx:203
msgid "Verifica visuale"
msgstr "Verifica visuale"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:551
msgid "Verifica:"
msgstr "Verifica:"

#: src/features/auth/desktop/DesktopLoginForm.tsx:888
#: src/features/auth/desktop/DesktopLoginForm.tsx:940
#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:270
#: src/features/connectors/enterprise-db-bridge/SetupWizard.tsx:931
#: src/features/settings/components/SecuritySettings.tsx:287
msgid "Verifica…"
msgstr "Verifica…"

#: src/features/report/components/CitationDetail.tsx:42
msgid "Verificata"
msgstr "Verificata"

#: src/features/console/pages/EngineSignupPage.tsx:217
msgid "Verifico il saldo e preparo il progetto…"
msgstr "Verifico il saldo e preparo il progetto…"

#: src/features/admin/components/AdminCostTracking.tsx:100
msgid "Verità"
msgstr "Verità"

#: ../../packages/ui/src/editors/AiCellPopover.tsx:68
msgid "VERO"
msgstr "VERO"

#: src/features/connectors/components/management/ChatExamplesManager.tsx:185
msgid "Verrà usato come few-shot per migliorare la generazione SQL."
msgstr "Verrà usato come few-shot per migliorare la generazione SQL."

#: src/features/connectors/wizards/cassettoFiscaleSpec.tsx:57
msgid "Verrai reindirizzato al portale AdE per la firma SPID/CIE."
msgstr "Verrai reindirizzato al portale AdE per la firma SPID/CIE."

#: src/features/connectors/wizards/openBankingSpec.tsx:184
msgid "Verrai reindirizzato al portale della tua banca per il consenso."
msgstr "Verrai reindirizzato al portale della tua banca per il consenso."

#: src/features/connectors/wizards/crmSpec.tsx:91
#: src/features/connectors/wizards/projectManagementSpec.tsx:57
msgid "Verrai reindirizzato al provider per l'autorizzazione OAuth."
msgstr "Verrai reindirizzato al provider per l'autorizzazione OAuth."

#. placeholder {0}: v.version_number
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:161
msgid "version {0}"
msgstr "version {0}"

#: src/features/admin/components/AdminDecks.tsx:625
msgid "Versione"
msgstr "Versione"

#: src/features/price-lists/components/PriceListsPage.tsx:506
msgid "versione {listVersion}"
msgstr "versione {listVersion}"

#: src/features/hive-flows/components/FlowVersionMenu.tsx:62
msgid "Versione {version} ripristinata"
msgstr "Versione {version} ripristinata"

#. placeholder {0}: book.data.version
#: src/features/admin/components/AdminCpqPriceBook.tsx:175
msgid "Versione attiva {0}"
msgstr "Versione attiva {0}"

#: src/features/admin/components/AdminDecks.tsx:586
#: src/features/admin/components/AdminDecks.tsx:601
#: src/features/hive-flows/components/FlowVersionMenu.tsx:106
#: src/features/sources/components/ArtifactPane.tsx:2355
msgid "Versioni"
msgstr "Versioni"

#. placeholder {0}: mode.name
#. placeholder {1}: mode.current_version.version_number
#: src/features/agent-modes/components/ModeVersionHistoryDialog.tsx:113
msgid "Versioni di \"{0}\". v{1} è quella attiva."
msgstr "Versioni di \"{0}\". v{1} è quella attiva."

#: ../../packages/ui/src/ando/sources/pdf/PDFActions.tsx:50
msgid "Versioning"
msgstr "Versioning"

#: src/features/share/components/ShareLinkRow.tsx:44
msgid "Via email"
msgstr "Via email"

#: src/features/projects/components/sections/MembersSection.tsx:486
msgid "Via email, se ha già un account Ando nella tua organizzazione"
msgstr "Via email, se ha già un account Ando nella tua organizzazione"

#: src/features/console/components/LimitBar.tsx:76
msgid "Vicino al limite"
msgstr "Vicino al limite"

#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:190
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:244
#: ../../packages/ui/src/ando/actions/CalendarCreateEventPreview.tsx:389
#: src/features/sources/components/CalendarEventPane.tsx:208
#: src/features/sources/components/CalendarEventPane.tsx:464
msgid "Videochiamata"
msgstr "Videochiamata"

#: src/features/connectors/wizards/vatVerifierSpec.tsx:55
msgid "VIES integrato"
msgstr "VIES integrato"

#: src/features/dfm-rules/components/DfmRulesPage.tsx:662
msgid "Vietato"
msgstr "Vietato"

#: src/features/projects/components/sections/MembersSection.tsx:72
#: src/features/projects/components/sections/MembersSection.tsx:563
msgid "Viewer"
msgstr "Viewer"

#. placeholder {0}: session.filename
#: ../../packages/ui/src/editors/PDFViewerInline.tsx:387
msgid "Viewer PDF — {0}. Scorri per navigare, pinch o ⌘+ / ⌘− per zoom."
msgstr "Viewer PDF — {0}. Scorri per navigare, pinch o ⌘+ / ⌘− per zoom."

#: src/features/sales/components/crm/DealDetailDrawer.tsx:106
#: src/features/sales/components/crm/RecordDrawer.tsx:258
msgid "Vinta"
msgstr "Vinta"

#: src/features/projects/components/ProjectIcon.tsx:111
msgid "Viola"
msgstr "Viola"

#: src/features/hive-flows/components/FlowShareControl.tsx:205
msgid "Visibile a tutta l'organizzazione"
msgstr "Visibile a tutta l'organizzazione"

#: src/features/admin/components/deckEditor/DeckEditor.tsx:918
msgid "Visibili solo a chi presenta (tasto N)"
msgstr "Visibili solo a chi presenta (tasto N)"

#: src/features/admin/components/AdminPlatformSettings.tsx:917
msgid "Vision"
msgstr "Vision"

#: src/features/admin/components/AdminCpq.tsx:1125
#: src/features/dashboard/components/DashboardViewControls.tsx:23
#: src/features/dashboard/components/ReceivedDashboardsList.tsx:99
#: src/features/workspace/inbox/components/ConversationsFiltersPopover.tsx:60
msgid "Vista"
msgstr "Vista"

#: src/features/canvases/components/SuggestedCanvasCard.tsx:89
msgid "vista {seen}"
msgstr "vista {seen}"

#: src/routes/_authed/workspace/dashboard.tsx:119
msgid "Vista analisi"
msgstr "Vista analisi"

#: src/routes/_authed/workspace/calendar.tsx:718
msgid "Vista calendario"
msgstr "Vista calendario"

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:128
msgid "Vista comparativa per tenant"
msgstr "Vista comparativa per tenant"

#: src/features/dashboard/components/DashboardViewControls.tsx:25
msgid "Vista dashboard"
msgstr "Vista dashboard"

#: src/features/console/pages/DocumentsPage.tsx:377
msgid "Vista del documento"
msgstr "Vista del documento"

#: src/features/console/pages/TracesPage.tsx:279
msgid "Vista del grafo"
msgstr "Vista del grafo"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:474
msgid "Vista del risultato"
msgstr "Vista del risultato"

#: src/features/workspace/inbox/components/InboxSmartViewChips.tsx:77
msgid "Vista intelligente conversazioni"
msgstr "Vista intelligente conversazioni"

#: src/features/console/traces/TraceGraph.tsx:497
msgid "Vista metadati: le relazioni interne ai payload possono non essere mostrate; apri i payload originali."
msgstr "Vista metadati: le relazioni interne ai payload possono non essere mostrate; apri i payload originali."

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:504
msgid "Vista nudge"
msgstr "Vista nudge"

#: src/features/admin/components/AdminHealth.tsx:38
msgid "Vista operativa real-time — anomalie su saturazione, p95 per route, error rate. Refresh ogni 30 secondi."
msgstr "Vista operativa real-time — anomalie su saturazione, p95 per route, error rate. Refresh ogni 30 secondi."

#: src/features/sources/components/AISummaryPanel.tsx:463
msgid "Vista pannello"
msgstr "Vista pannello"

#: src/features/workspace/documents/components/SmartSourceChips.tsx:108
msgid "Viste documenti"
msgstr "Viste documenti"

#: src/features/structured-data/components/SimilarPartsSection.tsx:103
msgid "Visuale"
msgstr "Visuale"

#: src/features/dashboard/components/AddWidgetWizard.tsx:74
#: src/features/dashboard/components/ShareChartSheet.tsx:304
#: src/features/dashboard/components/ShareChartSheet.tsx:378
#: src/features/dashboard/components/ShareDashboardSheet.tsx:291
#: src/features/dashboard/components/ShareDashboardSheet.tsx:365
msgid "Visualizza"
msgstr "Visualizza"

#: src/features/dashboard/components/ChartTypeOverrideRow.tsx:100
msgid "Visualizza come {labelText}"
msgstr "Visualizza come {labelText}"

#: src/features/structured-data/components/EnterpriseDataPanel.tsx:538
msgid "Visualizza come {resolvedLabel}"
msgstr "Visualizza come {resolvedLabel}"

#: ../../packages/ui/src/charts/Chart.tsx:299
msgid "Visualizza come grafico"
msgstr "Visualizza come grafico"

#: ../../packages/ui/src/charts/Chart.tsx:299
msgid "Visualizza come tabella"
msgstr "Visualizza come tabella"

#: src/features/chat/components/ConversationSidebar.tsx:443
msgid "Visualizza tutto"
msgstr "Visualizza tutto"

#: src/features/connect/components/connectShared.tsx:69
#: src/routes/connect.invite.$token.tsx:98
msgid "Visualizzatore"
msgstr "Visualizzatore"

#: src/features/price-lists/utils/formatItem.ts:31
msgid "Viteria"
msgstr "Viteria"

#: ../../packages/ui/src/ando/actions/StyleTemplatePicker.tsx:220
#: src/features/settings/MarpTemplateSettings.tsx:231
msgid "Vivaci"
msgstr "Vivaci"

#: src/features/console/components/KeyMeta.tsx:61
#: src/features/settings/components/BrandKitSettings.tsx:440
msgid "Voce"
msgstr "Voce"

#: src/features/settings/components/BrandKitSettings.tsx:763
msgid "Voce creata"
msgstr "Voce creata"

#: src/features/settings/components/BrandKitSettings.tsx:773
msgid "Voce eliminata"
msgstr "Voce eliminata"

#: src/features/hive-flows/run/ReferencePane.tsx:196
msgid "Voci"
msgstr "Voci"

#: src/features/settings/components/BrandKitSettings.tsx:783
msgid "Voci personalizzate"
msgstr "Voci personalizzate"

#: src/features/studio/components/StudioDrawerContent.tsx:72
#: src/features/templates/components/TemplatesList.tsx:43
#: src/features/templates/components/TemplatesList.tsx:59
msgid "Voice"
msgstr "Voice"

#: src/features/templates/components/CreateTemplateDialog.tsx:53
#: src/features/templates/components/TemplateEditor.tsx:60
msgid "Voice · stile di scrittura"
msgstr "Voice · stile di scrittura"

#: src/features/studio/components/StudioDrawerContent.tsx:553
msgid "Voice · stili di scrittura"
msgstr "Voice · stili di scrittura"

#: src/features/settings/components/PresentationTemplates.tsx:88
msgid "Voice & tone"
msgstr "Voice & tone"

#: src/features/chat/components/MessagePreviewEmbed.tsx:200
#: src/features/voice_report/components/VoiceReportsList.tsx:235
#: src/routes/_authed/workspace/dashboard.tsx:460
#: src/routes/_authed/workspace/reports/index.tsx:56
msgid "Voice of X"
msgstr "Voice of X"

#: src/features/actions/components/voice_report_generate/VoiceReportGenerateCard.tsx:166
msgid "Voice of X — clienti Q2"
msgstr "Voice of X — clienti Q2"

#: src/features/clean-control/components/QualityScoreStat.tsx:146
msgid "vs 30 giorni fa"
msgstr "vs 30 giorni fa"

#: src/features/console/pages/UsagePage.tsx:116
msgid "vs periodo prec."
msgstr "vs periodo prec."

#: src/features/admin/components/AdminGatedLinks.tsx:336
msgid "vuole essere richiamato"
msgstr "vuole essere richiamato"

#: ../../packages/ui/src/editors/PptxEditorInline.tsx:516
#: src/features/admin/components/AdminDecks.tsx:396
msgid "Vuota"
msgstr "Vuota"

#: src/features/connectors/components/_spreadsheet/types.tsx:149
msgid "vuoto"
msgstr "vuoto"

#: src/features/structured-data/components/DisplayResultChips.tsx:78
msgid "Vuoto"
msgstr "Vuoto"

#: src/features/console/connectors/ManifestConfigForm.tsx:199
msgid "Vuoto = il corpo della risposta È già l'array di record."
msgstr "Vuoto = il corpo della risposta È già l'array di record."

#: src/features/admin/components/AdminCpq.tsx:895
msgid "Vuoto = quello del livello partner o del listino."
msgstr "Vuoto = quello del livello partner o del listino."

#: src/features/admin/components/AdminCpq.tsx:599
msgid "Vuoto per una vendita diretta."
msgstr "Vuoto per una vendita diretta."

#: src/features/admin/components/orgs/OrgBillingConfigCard.tsx:267
msgid "Vuoto usa il prezzo del tier. Un valore qui vale solo per questa organizzazione e si applica ai nuovi abbonamenti: quelli già attivi mantengono il prezzo con cui sono partiti."
msgstr "Vuoto usa il prezzo del tier. Un valore qui vale solo per questa organizzazione e si applica ai nuovi abbonamenti: quelli già attivi mantengono il prezzo con cui sono partiti."

#: src/features/console/docs/content.ts:1978
msgid "wait_for_job ha superato il deadline senza stato terminale."
msgstr "wait_for_job ha superato il deadline senza stato terminale."

#: src/features/admin/components/hypermem/HmReasoningTracesTab.tsx:348
msgid "Wall-clock"
msgstr "Wall-clock"

#: src/features/console/pages/GetStartedPage.tsx:54
msgid "Wallet"
msgstr "Wallet"

#: src/features/console/pages/BillingPage.tsx:145
msgid "Wallet Engine"
msgstr "Wallet Engine"

#: src/features/admin/components/AdminEngagement.tsx:139
msgid "WAU · 7gg"
msgstr "WAU · 7gg"

#: src/features/admin/components/AdminEngagement.tsx:191
msgid "WAU corrente"
msgstr "WAU corrente"

#: src/features/admin/components/AdminEngagement.tsx:187
msgid "WAU precedente"
msgstr "WAU precedente"

#: src/features/console/pages/PlaygroundPage.tsx:550
#: src/routes/_authed/workspace/documents.tsx:1200
msgid "Web"
msgstr "Web"

#: src/features/agent-modes/components/AgentModeEditor.tsx:103
msgid "Web search"
msgstr "Web search"

#: src/features/automations/components/formatters.ts:91
#: src/features/console/pages/FlowsPage.tsx:120
#: src/routes/_authed/workspace/flows.index.tsx:79
msgid "Webhook"
msgstr "Webhook"

#: src/features/console/webhooks/WebhooksPanel.tsx:465
msgid "Webhook attivato"
msgstr "Webhook attivato"

#: src/features/console/webhooks/WebhooksPanel.tsx:465
msgid "Webhook disattivato"
msgstr "Webhook disattivato"

#: src/features/console/webhooks/WebhooksPanel.tsx:280
msgid "Webhook registrato"
msgstr "Webhook registrato"

#: src/features/console/docs/content.ts:847
#: src/features/console/webhooks/WebhooksPanel.tsx:487
#: src/features/console/webhooks/WebhooksPanel.tsx:503
msgid "Webhooks"
msgstr "Webhooks"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:204
#: src/features/console/connectors/StructuredConnectorSetup.tsx:472
msgid "WhatsApp Business"
msgstr "WhatsApp Business"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:461
msgid "WhatsApp Business connesso"
msgstr "WhatsApp Business connesso"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:115
msgid "WhatsApp Business disconnesso"
msgstr "WhatsApp Business disconnesso"

#: src/features/connectors/components/WhatsAppConnectorPanel.tsx:421
msgid "WhatsApp Embedded Signup non è configurato"
msgstr "WhatsApp Embedded Signup non è configurato"

#: src/features/dashboard/components/AddWidgetWizard.tsx:243
msgid "Widget aggiunto a {dashName}"
msgstr "Widget aggiunto a {dashName}"

#: src/features/dashboard/components/AddWidgetWizard.tsx:242
msgid "Widget salvato"
msgstr "Widget salvato"

#: src/features/sources/components/InboxDetailPane.tsx:982
msgid "Wiring /actions/propose backlog Phase 2."
msgstr "Wiring /actions/propose backlog Phase 2."

#: src/routes/_authed/workspace/documents.tsx:1118
#: src/routes/_authed/workspace/documents.tsx:1119
msgid "Word"
msgstr "Word"

#: src/features/settings/components/PresentationTemplates.tsx:87
msgid "Word document"
msgstr "Word document"

#: src/features/automations/components/AutomationsHub.tsx:320
msgid "Worker"
msgstr "Worker"

#: src/features/admin/components/AdminHealth.tsx:35
msgid "worker · latenza · errori · ultime 24h"
msgstr "worker · latenza · errori · ultime 24h"

#: src/features/automations/components/AutomationsHub.tsx:152
msgid "worker AI · schedulati · reattivi"
msgstr "worker AI · schedulati · reattivi"

#: src/features/automations/components/AutomationsHub.tsx:256
msgid "Worker attivi"
msgstr "Worker attivi"

#: src/features/automations/components/AutomationsHub.tsx:279
msgid "worker sospesi"
msgstr "worker sospesi"

#: src/features/admin/components/hypermem/HmTenantsTab.tsx:58
msgid "Workflow sugg."
msgstr "Workflow sugg."

#: src/features/admin/components/AdminHypermem.tsx:91
#: src/features/admin/components/hypermem/HmWorkflowSuggestionsTab.tsx:603
msgid "Workflow Suggestions"
msgstr "Workflow Suggestions"

#: src/features/admin/components/hypermem/HmOverviewTab.tsx:294
msgid "Workflow suggestions in attesa"
msgstr "Workflow suggestions in attesa"

#: src/features/account/components/UserMenuButton.tsx:391
#: src/features/chat/components/ChatEmptyState.tsx:469
#: src/features/connectors/wizards/messagingSpec.tsx:106
#: src/features/console/connectors/StructuredConnectorSetup.tsx:251
#: src/features/help/components/ShortcutsList.tsx:45
msgid "Workspace"
msgstr "Workspace"

#: src/features/workspace/components/WorkspaceTabs.tsx:409
msgid "Workspace · trascina o usa Ctrl+frecce per riordinare"
msgstr "Workspace · trascina o usa Ctrl+frecce per riordinare"

#: src/features/chat/components/LayoutSwitcher.tsx:70
msgid "Workspace ampio"
msgstr "Workspace ampio"

#: src/features/admin/components/AdminOrgs.tsx:1412
#: src/features/admin/components/orgs/AddMemberDialog.tsx:236
#: src/features/admin/components/orgs/MemberSettingsDialog.tsx:270
#: src/features/admin/components/orgs/OrgMembersTab.tsx:437
msgid "Workspace ed Engine"
msgstr "Workspace ed Engine"

#: src/features/admin/components/AdminEngagement.tsx:132
msgid "World-class"
msgstr "World-class"

#: src/features/admin/components/orgs/OrgSSOTab.tsx:292
msgid "your-client-id"
msgstr "your-client-id"

#: src/features/report/components/ComparisonGrid.tsx:104
msgid "Δ Variazione"
msgstr "Δ Variazione"

#. placeholder {0}: formatCurrencyDelta(burnRate?.trend_delta_30d, currency)
#. placeholder {0}: formatCurrencyDelta(data.burn_rate.trend_delta_30d, currency)
#: src/routes/_authed/workspace/finance.tsx:490
#: src/routes/_authed/workspace/finance.tsx:1423
msgid "Δ30g {0}"
msgstr "Δ30g {0}"

#: src/features/admin/components/hypermem/HmNudgesTab.tsx:158
msgid "μ {avgConf}"
msgstr "μ {avgConf}"
